(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire75b9"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire75b9"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("fYuER", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $ba143da7933fe1b6$export$6503ec6e8aabbaf; }, function (v) { return $ba143da7933fe1b6$export$6503ec6e8aabbaf = v; });
var $ba143da7933fe1b6$export$6503ec6e8aabbaf;
var $ba143da7933fe1b6$export$f7ad0328861e2f03;
"use strict";
var $ba143da7933fe1b6$var$mapping = new Map();
function $ba143da7933fe1b6$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$ba143da7933fe1b6$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $ba143da7933fe1b6$var$resolve(id) {
    var resolved = $ba143da7933fe1b6$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$ba143da7933fe1b6$export$6503ec6e8aabbaf = $ba143da7933fe1b6$var$register;
$ba143da7933fe1b6$export$f7ad0328861e2f03 = $ba143da7933fe1b6$var$resolve;

});

parcelRegister("3uQPI", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $28bd2803df698a7a$export$bdfd709ae4826697; }, function (v) { return $28bd2803df698a7a$export$bdfd709ae4826697 = v; });
var $28bd2803df698a7a$export$bdfd709ae4826697;
var $28bd2803df698a7a$export$c9e73fbda7da57b6;
var $28bd2803df698a7a$export$5a759dc7a1cfb72a;
"use strict";
var $28bd2803df698a7a$var$bundleURL = {};
function $28bd2803df698a7a$var$getBundleURLCached(id) {
    var value = $28bd2803df698a7a$var$bundleURL[id];
    if (!value) {
        value = $28bd2803df698a7a$var$getBundleURL();
        $28bd2803df698a7a$var$bundleURL[id] = value;
    }
    return value;
}
function $28bd2803df698a7a$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $28bd2803df698a7a$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $28bd2803df698a7a$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $28bd2803df698a7a$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$28bd2803df698a7a$export$bdfd709ae4826697 = $28bd2803df698a7a$var$getBundleURLCached;
$28bd2803df698a7a$export$c9e73fbda7da57b6 = $28bd2803df698a7a$var$getBaseURL;
$28bd2803df698a7a$export$5a759dc7a1cfb72a = $28bd2803df698a7a$var$getOrigin;

});

parcelRegister("9Wwts", function(module, exports) {

var $jzTO1 = parcelRequire("jzTO1");
(function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined1;
    /** Used as the semantic version number. */ var VERSION = "4.17.21";
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", FUNC_ERROR_TEXT = "Expected a function", INVALID_TEMPL_VAR_ERROR_TEXT = "Invalid `variable` option passed into `_.template`";
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = "__lodash_placeholder__";
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = "...";
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            "ary",
            WRAP_ARY_FLAG
        ],
        [
            "bind",
            WRAP_BIND_FLAG
        ],
        [
            "bindKey",
            WRAP_BIND_KEY_FLAG
        ],
        [
            "curry",
            WRAP_CURRY_FLAG
        ],
        [
            "curryRight",
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            "flip",
            WRAP_FLIP_FLAG
        ],
        [
            "partial",
            WRAP_PARTIAL_FLAG
        ],
        [
            "partialRight",
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            "rearg",
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", domExcTag = "[object DOMException]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", promiseTag = "[object Promise]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]", weakSetTag = "[object WeakSet]";
    var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = "\ud800-\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = "\\u2700-\\u27bf", rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", rsPunctuationRange = "\\u2000-\\u206f", rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", rsVarRange = "\\ufe0e\\ufe0f", rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsAstral = "[" + rsAstralRange + "]", rsBreak = "[" + rsBreakRange + "]", rsCombo = "[" + rsComboRange + "]", rsDigits = "\\d+", rsDingbat = "[" + rsDingbatRange + "]", rsLower = "[" + rsLowerRange + "]", rsMisc = "[^" + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + "]", rsFitz = "\ud83c[\udffb-\udfff]", rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")", rsNonAstral = "[^" + rsAstralRange + "]", rsRegional = "(?:\ud83c[\udde6-\uddff]){2}", rsSurrPair = "[\ud800-\udbff][\udc00-\udfff]", rsUpper = "[" + rsUpperRange + "]", rsZWJ = "\\u200d";
    /** Used to compose unicode regexes. */ var rsMiscLower = "(?:" + rsLower + "|" + rsMisc + ")", rsMiscUpper = "(?:" + rsUpper + "|" + rsMisc + ")", rsOptContrLower = "(?:" + rsApos + "(?:d|ll|m|re|s|t|ve))?", rsOptContrUpper = "(?:" + rsApos + "(?:D|LL|M|RE|S|T|VE))?", reOptMod = rsModifier + "?", rsOptVar = "[" + rsVarRange + "]?", rsOptJoin = "(?:" + rsZWJ + "(?:" + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsOptVar + reOptMod + ")*", rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = "(?:" + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsSeq, rsSymbol = "(?:" + [
        rsNonAstral + rsCombo + "?",
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join("|") + ")";
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, "g");
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, "g");
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + "?" + rsLower + "+" + rsOptContrLower + "(?=" + [
            rsBreak,
            rsUpper,
            "$"
        ].join("|") + ")",
        rsMiscUpper + "+" + rsOptContrUpper + "(?=" + [
            rsBreak,
            rsUpper + rsMiscLower,
            "$"
        ].join("|") + ")",
        rsUpper + "?" + rsMiscLower + "+" + rsOptContrLower,
        rsUpper + "+" + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join("|"), "g");
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp("[" + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + "]");
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        "\xc0": "A",
        "\xc1": "A",
        "\xc2": "A",
        "\xc3": "A",
        "\xc4": "A",
        "\xc5": "A",
        "\xe0": "a",
        "\xe1": "a",
        "\xe2": "a",
        "\xe3": "a",
        "\xe4": "a",
        "\xe5": "a",
        "\xc7": "C",
        "\xe7": "c",
        "\xd0": "D",
        "\xf0": "d",
        "\xc8": "E",
        "\xc9": "E",
        "\xca": "E",
        "\xcb": "E",
        "\xe8": "e",
        "\xe9": "e",
        "\xea": "e",
        "\xeb": "e",
        "\xcc": "I",
        "\xcd": "I",
        "\xce": "I",
        "\xcf": "I",
        "\xec": "i",
        "\xed": "i",
        "\xee": "i",
        "\xef": "i",
        "\xd1": "N",
        "\xf1": "n",
        "\xd2": "O",
        "\xd3": "O",
        "\xd4": "O",
        "\xd5": "O",
        "\xd6": "O",
        "\xd8": "O",
        "\xf2": "o",
        "\xf3": "o",
        "\xf4": "o",
        "\xf5": "o",
        "\xf6": "o",
        "\xf8": "o",
        "\xd9": "U",
        "\xda": "U",
        "\xdb": "U",
        "\xdc": "U",
        "\xf9": "u",
        "\xfa": "u",
        "\xfb": "u",
        "\xfc": "u",
        "\xdd": "Y",
        "\xfd": "y",
        "\xff": "y",
        "\xc6": "Ae",
        "\xe6": "ae",
        "\xde": "Th",
        "\xfe": "th",
        "\xdf": "ss",
        // Latin Extended-A block.
        "\u0100": "A",
        "\u0102": "A",
        "\u0104": "A",
        "\u0101": "a",
        "\u0103": "a",
        "\u0105": "a",
        "\u0106": "C",
        "\u0108": "C",
        "\u010A": "C",
        "\u010C": "C",
        "\u0107": "c",
        "\u0109": "c",
        "\u010B": "c",
        "\u010D": "c",
        "\u010E": "D",
        "\u0110": "D",
        "\u010F": "d",
        "\u0111": "d",
        "\u0112": "E",
        "\u0114": "E",
        "\u0116": "E",
        "\u0118": "E",
        "\u011A": "E",
        "\u0113": "e",
        "\u0115": "e",
        "\u0117": "e",
        "\u0119": "e",
        "\u011B": "e",
        "\u011C": "G",
        "\u011E": "G",
        "\u0120": "G",
        "\u0122": "G",
        "\u011D": "g",
        "\u011F": "g",
        "\u0121": "g",
        "\u0123": "g",
        "\u0124": "H",
        "\u0126": "H",
        "\u0125": "h",
        "\u0127": "h",
        "\u0128": "I",
        "\u012A": "I",
        "\u012C": "I",
        "\u012E": "I",
        "\u0130": "I",
        "\u0129": "i",
        "\u012B": "i",
        "\u012D": "i",
        "\u012F": "i",
        "\u0131": "i",
        "\u0134": "J",
        "\u0135": "j",
        "\u0136": "K",
        "\u0137": "k",
        "\u0138": "k",
        "\u0139": "L",
        "\u013B": "L",
        "\u013D": "L",
        "\u013F": "L",
        "\u0141": "L",
        "\u013A": "l",
        "\u013C": "l",
        "\u013E": "l",
        "\u0140": "l",
        "\u0142": "l",
        "\u0143": "N",
        "\u0145": "N",
        "\u0147": "N",
        "\u014A": "N",
        "\u0144": "n",
        "\u0146": "n",
        "\u0148": "n",
        "\u014B": "n",
        "\u014C": "O",
        "\u014E": "O",
        "\u0150": "O",
        "\u014D": "o",
        "\u014F": "o",
        "\u0151": "o",
        "\u0154": "R",
        "\u0156": "R",
        "\u0158": "R",
        "\u0155": "r",
        "\u0157": "r",
        "\u0159": "r",
        "\u015A": "S",
        "\u015C": "S",
        "\u015E": "S",
        "\u0160": "S",
        "\u015B": "s",
        "\u015D": "s",
        "\u015F": "s",
        "\u0161": "s",
        "\u0162": "T",
        "\u0164": "T",
        "\u0166": "T",
        "\u0163": "t",
        "\u0165": "t",
        "\u0167": "t",
        "\u0168": "U",
        "\u016A": "U",
        "\u016C": "U",
        "\u016E": "U",
        "\u0170": "U",
        "\u0172": "U",
        "\u0169": "u",
        "\u016B": "u",
        "\u016D": "u",
        "\u016F": "u",
        "\u0171": "u",
        "\u0173": "u",
        "\u0174": "W",
        "\u0175": "w",
        "\u0176": "Y",
        "\u0177": "y",
        "\u0178": "Y",
        "\u0179": "Z",
        "\u017B": "Z",
        "\u017D": "Z",
        "\u017A": "z",
        "\u017C": "z",
        "\u017E": "z",
        "\u0132": "IJ",
        "\u0133": "ij",
        "\u0152": "Oe",
        "\u0153": "oe",
        "\u0149": "'n",
        "\u017F": "s"
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require("util").types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding("util");
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty("length");
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split("");
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined1 : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined1 : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined1) result = result === undefined1 ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, "") : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return "\\" + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined1 : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, _$Function = context.Function, Math = context.Math, _$Object = context.Object, _$RegExp = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = _$Function.prototype, objectProto = _$Object.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context["__core-js_shared__"];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
            return uid ? "Symbol(src)_1." + uid : "";
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(_$Object);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = _$RegExp("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined1, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined1, getPrototype = overArg(_$Object.getPrototypeOf, _$Object), objectCreate = _$Object.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined1, symIterator = Symbol ? Symbol.iterator : undefined1, symToStringTag = Symbol ? Symbol.toStringTag : undefined1;
        var defineProperty = function() {
            try {
                var func = getNative(_$Object, "defineProperty");
                func({}, "", {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = _$Object.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined1, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(_$Object.keys, _$Object), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, "DataView"), Map = getNative(context, "Map"), Promise = getNative(context, "Promise"), Set = getNative(context, "Set"), WeakMap = getNative(context, "WeakMap"), nativeCreate = getNative(_$Object, "create");
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined1, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined1, symbolToString = symbolProto ? symbolProto.toString : undefined1;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, "__wrapped__")) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var _$result = new object;
                object.prototype = undefined1;
                return _$result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined1;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "escape": reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "evaluate": reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "interpolate": reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ "variable": "",
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ "imports": {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ "_": lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var _$result = new LazyWrapper(this.__wrapped__);
            _$result.__actions__ = copyArray(this.__actions__);
            _$result.__dir__ = this.__dir__;
            _$result.__filtered__ = this.__filtered__;
            _$result.__iteratees__ = copyArray(this.__iteratees__);
            _$result.__takeCount__ = this.__takeCount__;
            _$result.__views__ = copyArray(this.__views__);
            return _$result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var _$result = new LazyWrapper(this);
                _$result.__dir__ = -1;
                _$result.__filtered__ = true;
            } else {
                _$result = this.clone();
                _$result.__dir__ *= -1;
            }
            return _$result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var _$result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], _$iteratee = data.iteratee, type = data.type, computed = _$iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                _$result[resIndex++] = value;
            }
            return _$result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var _$result = this.has(key) && delete this.__data__[key];
            this.size -= _$result ? 1 : 0;
            return _$result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var _$result = data[key];
                return _$result === HASH_UNDEFINED ? undefined1 : _$result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined1;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined1 : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined1 ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype["delete"] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined1 : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype["delete"] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                "hash": new Hash,
                "map": new (Map || ListCache),
                "string": new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var _$result = getMapData(this, key)["delete"](key);
            this.size -= _$result ? 1 : 0;
            return _$result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), _$size = data.size;
            data.set(key, value);
            this.size += data.size == _$size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype["delete"] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, _$result = data["delete"](key);
            this.size = data.size;
            return _$result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype["delete"] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, _$result = skipIndexes ? baseTimes(value.length, String) : [], length = _$result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
            isIndex(key, length)))) _$result.push(key);
            return _$result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined1;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined1 && !eq(object[key], value) || value === undefined1 && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined1 && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == "__proto__" && defineProperty) defineProperty(object, key, {
                "configurable": true,
                "enumerable": true,
                "value": value,
                "writable": true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, _$result = Array1(length), skip = object == null;
            while(++index < length)_$result[index] = skip ? undefined1 : get(object, paths[index]);
            return _$result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined1) number = number <= upper ? number : upper;
                if (lower !== undefined1) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var _$result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) _$result = object ? customizer(value, key, object, stack) : customizer(value);
            if (_$result !== undefined1) return _$result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                _$result = initCloneArray(value);
                if (!isDeep) return copyArray(value, _$result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    _$result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(_$result, value)) : copySymbols(value, baseAssign(_$result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    _$result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, _$result);
            if (isSet(value)) value.forEach(function(subValue) {
                _$result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                _$result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined1 : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(_$result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return _$result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = _$Object(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined1 && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined1, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, _$includes = arrayIncludes, isCommon = true, length = array.length, _$result = [], valuesLength = values.length;
            if (!length) return _$result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                _$includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                _$includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    _$result.push(value);
                } else if (!_$includes(values, computed, comparator)) _$result.push(value);
            }
            return _$result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var _$result = true;
            baseEach(collection, function(value, index, collection) {
                _$result = !!predicate(value, index, collection);
                return _$result;
            });
            return _$result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined1 ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, _$result = value;
            }
            return _$result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined1 || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var _$result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) _$result.push(value);
            });
            return _$result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined1;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var _$result = keysFunc(object);
            return isArray(object) ? _$result : arrayPush(_$result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined1 ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in _$Object(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in _$Object(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var _$includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, _$result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined1;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && _$result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : _$includes(_$result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : _$includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    _$result.push(value);
                }
            }
            return _$result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined1 : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = _$Object(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined1 && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var _$result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(_$result === undefined1 ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : _$result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == "function") return value;
            if (value == null) return identity;
            if (typeof value == "object") return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var _$result = [];
            for(var key in _$Object(object))if (hasOwnProperty.call(object, key) && key != "constructor") _$result.push(key);
            return _$result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), _$result = [];
            for(var key in object)if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) _$result.push(key);
            return _$result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, _$result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                _$result[++index] = iteratee(value, key, collection);
            });
            return _$result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined1 && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : undefined1;
                    if (newValue === undefined1) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined1;
            var isCommon = newValue === undefined1;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack["delete"](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined1;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var _$result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    "criteria": criteria,
                    "index": ++index,
                    "value": value
                };
            });
            return baseSortBy(_$result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, _$result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(_$result, castPath(path, object), value);
            }
            return _$result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var _$indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = _$indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), _$result = Array1(length);
            while(length--){
                _$result[fromRight ? length : ++index] = start;
                start += step;
            }
            return _$result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var _$result = "";
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return _$result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) _$result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return _$result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + "");
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === "__proto__" || key === "constructor" || key === "prototype") return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined1;
                    if (newValue === undefined1) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function baseSetData(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function baseSetToString(func, string) {
            return defineProperty(func, "toString", {
                "configurable": true,
                "enumerable": false,
                "value": constant(string),
                "writable": true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var _$result = Array1(length);
            while(++index < length)_$result[index] = array[index + start];
            return _$result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var _$result;
            baseEach(collection, function(value, index, collection) {
                _$result = predicate(value, index, collection);
                return !_$result;
            });
            return !!_$result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == "number" && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined1;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined1, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, _$result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    _$result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return _$result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == "string") return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + "";
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : "";
            var _$result = value + "";
            return _$result == "0" && 1 / value == -INFINITY ? "-0" : _$result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, _$includes = arrayIncludes, length = array.length, isCommon = true, _$result = [], seen = _$result;
            if (comparator) {
                isCommon = false;
                _$includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var _$set = iteratee ? null : createSet(array);
                if (_$set) return setToArray(_$set);
                isCommon = false;
                _$includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : _$result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    _$result.push(value);
                } else if (!_$includes(seen, computed, comparator)) {
                    if (seen !== _$result) seen.push(computed);
                    _$result.push(value);
                }
            }
            return _$result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            object = parent(object, path);
            return object == null || delete object[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var _$result = value;
            if (_$result instanceof LazyWrapper) _$result = _$result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, _$result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, _$result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) _$result[index] = baseDifference(_$result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(_$result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, _$result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined1;
                assignFunc(_$result, props[index], value);
            }
            return _$result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == "function" ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined1 ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, _$result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(_$result);
            return _$result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var _$result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(_$result).set(new Uint8Array(arrayBuffer));
            return _$result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var _$result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            _$result.lastIndex = regexp.lastIndex;
            return _$result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? _$Object(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined1, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined1, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var _$result = compareAscending(objCriteria[index], othCriteria[index]);
                if (_$result) {
                    if (index >= ordersLength) return _$result;
                    var order = orders[index];
                    return _$result * (order == "desc" ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), _$result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)_$result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) _$result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)_$result[leftIndex++] = args[argsIndex++];
            return _$result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), _$result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)_$result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)_$result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) _$result[offset + holders[holdersIndex]] = args[argsIndex++];
            return _$result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined1;
                if (newValue === undefined1) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined1, guard = length > 2 ? sources[2] : undefined1;
                customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined1;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined1 : customizer;
                    length = 1;
                }
                object = _$Object(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = _$Object(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = _$Object(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined1;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join("") : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, "")), callback, "");
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), _$result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(_$result) ? _$result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined1, args, holders, undefined1, undefined1, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = _$Object(collection);
                if (!isArrayLike(collection)) {
                    var _$iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function predicate(key) {
                        return _$iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[_$iteratee ? collection[index] : index] : undefined1;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == "wrapper") var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == "wrapper" ? getData(func) : undefined1;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, _$result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)_$result = funcs[index].call(this, _$result);
                    return _$result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined1 : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var _$result;
                if (value === undefined1 && other === undefined1) return defaultValue;
                if (value !== undefined1) _$result = value;
                if (other !== undefined1) {
                    if (_$result === undefined1) return other;
                    if (typeof value == "string" || typeof other == "string") {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    _$result = operator(value, other);
                }
                return _$result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined1 ? " " : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var _$result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(_$result), 0, length).join("") : _$result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != "number" && isIterateeCall(start, end, step)) end = step = undefined1;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined1) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined1 ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == "string" && typeof other == "string")) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined1, newHoldersRight = isCurry ? undefined1 : holders, newPartials = isCurry ? partials : undefined1, newPartialsRight = isCurry ? undefined1 : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var _$result = wrapFunc.apply(undefined1, newData);
            if (isLaziable(func)) setData(_$result, newData);
            _$result.placeholder = placeholder;
            return setWrapToString(_$result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + "e").split("e"), value = func(pair[0] + "e" + (+pair[1] + precision));
                    pair = (toString(value) + "e").split("e");
                    return +(pair[0] + "e" + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function createSet(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined1;
            }
            ary = ary === undefined1 ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined1 ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined1;
            }
            var data = isBindKey ? undefined1 : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined1 ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var _$result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) _$result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) _$result = createPartial(func, bitmask, thisArg, partials);
            else _$result = createHybrid.apply(undefined1, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(_$result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined1 || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined1, customDefaultsMerge, stack);
                stack["delete"](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined1 : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, _$result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined1;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined1) {
                    if (compared) continue;
                    _$result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        _$result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    _$result = false;
                    break;
                }
            }
            stack["delete"](array);
            stack["delete"](other);
            return _$result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + "";
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var _$result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack["delete"](object);
                    return _$result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var _$result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined1 ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    _$result = false;
                    break;
                }
                skipCtor || (skipCtor = key == "constructor");
            }
            if (_$result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) _$result = false;
            }
            stack["delete"](object);
            stack["delete"](other);
            return _$result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined1, flatten), func + "");
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function getData(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var _$result = func.name + "", array = realNames[_$result], length = hasOwnProperty.call(realNames, _$result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return _$result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, "placeholder") ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var _$result = lodash.iteratee || iteratee;
            _$result = _$result === iteratee ? baseIteratee : _$result;
            return arguments.length ? _$result(arguments[0], arguments[1]) : _$result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var _$result = keys(object), length = _$result.length;
            while(length--){
                var key = _$result[length], value = object[key];
                _$result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return _$result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined1;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined1;
                var unmasked = true;
            } catch (e) {}
            var _$result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return _$result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function getSymbols(object) {
            if (object == null) return [];
            object = _$Object(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function getSymbolsIn(object) {
            var _$result = [];
            while(object){
                arrayPush(_$result, getSymbols(object));
                object = getPrototype(object);
            }
            return _$result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function getTag(value) {
            var _$result = baseGetTag(value), Ctor = _$result == objectTag ? value.constructor : undefined1, ctorString = Ctor ? toSource(Ctor) : "";
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return _$result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], _$size = data.size;
                switch(data.type){
                    case "drop":
                        start += _$size;
                        break;
                    case "dropRight":
                        end -= _$size;
                        break;
                    case "take":
                        end = nativeMin(end, start + _$size);
                        break;
                    case "takeRight":
                        start = nativeMax(start, end - _$size);
                        break;
                }
            }
            return {
                "start": start,
                "end": end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, _$result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(_$result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (_$result || ++index != length) return _$result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, _$result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == "string" && hasOwnProperty.call(array, "index")) {
                _$result.index = array.index;
                _$result.input = array.input;
            }
            return _$result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? "& " : "") + details[lastIndex];
            details = details.join(length > 2 ? ", " : " ");
            return source.replace(reWrapComment, "{\n/* [wrapped with " + details + "] */\n");
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value === "undefined" ? "undefined" : (0, $jzTO1._)(value);
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index === "undefined" ? "undefined" : (0, $jzTO1._)(index);
            if (type == "number" ? isArrayLike(object) && isIndex(index, object.length) : type == "string" && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value === "undefined" ? "undefined" : (0, $jzTO1._)(value);
            if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in _$Object(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value === "undefined" ? "undefined" : (0, $jzTO1._)(value);
            return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != "function" || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined1 || key in _$Object(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var _$result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = _$result.cache;
            return _$result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var _$result = [];
            if (object != null) for(var key in _$Object(object))_$result.push(key);
            return _$result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined1 ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined1;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === "constructor" && typeof object[key] === "function") return;
            if (key == "__proto__") return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + "";
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined1, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined1 ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var _$result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) _$result.push("");
            string.replace(rePropName, function(match, number, quote, subString) {
                _$result.push(quote ? subString.replace(reEscapeChar, "$1") : number || match);
            });
            return _$result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == "string" || isSymbol(value)) return value;
            var _$result = value + "";
            return _$result == "0" && 1 / value == -INFINITY ? "-0" : _$result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + "";
                } catch (e) {}
            }
            return "";
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = "_." + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var _$result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            _$result.__actions__ = copyArray(wrapper.__actions__);
            _$result.__index__ = wrapper.__index__;
            _$result.__values__ = wrapper.__values__;
            return _$result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined1) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, _$result = Array1(nativeCeil(length / size));
            while(index < length)_$result[resIndex++] = baseSlice(array, index, index += size);
            return _$result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, _$result = [];
            while(++index < length){
                var value = array[index];
                if (value) _$result[resIndex++] = value;
            }
            return _$result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var _$iteratee = last(values);
            if (isArrayLikeObject(_$iteratee)) _$iteratee = undefined1;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(_$iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined1;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined1, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined1 ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined1 ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != "number" && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined1) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined1 ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, _$result = {};
            while(++index < length){
                var pair = pairs[index];
                _$result[pair[0]] = pair[1];
            }
            return _$result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined1;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var _$iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (_$iteratee === last(mapped)) _$iteratee = undefined1;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(_$iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == "function" ? comparator : undefined1;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined1, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? "" : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined1;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined1) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined1;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined1, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, _$result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return _$result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var _$result = [];
            if (!(array && array.length)) return _$result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    _$result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return _$result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != "number" && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined1 ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined1 ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined1 ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var _$iteratee = last(arrays);
            if (isArrayLikeObject(_$iteratee)) _$iteratee = undefined1;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(_$iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined1;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined1, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == "function" ? comparator : undefined1;
            return array && array.length ? baseUniq(array, undefined1, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var _$result = unzip(array);
            if (iteratee == null) return _$result;
            return arrayMap(_$result, function(group) {
                return apply(iteratee, undefined1, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var _$iteratee = last(arrays);
            if (isArrayLikeObject(_$iteratee)) _$iteratee = undefined1;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(_$iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined1;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined1, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, _$iteratee = length > 1 ? arrays[length - 1] : undefined1;
            _$iteratee = typeof _$iteratee == "function" ? (arrays.pop(), _$iteratee) : undefined1;
            return unzipWith(arrays, _$iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var _$result = lodash(value);
            _$result.__chain__ = true;
            return _$result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function interceptor(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                "func": thru,
                "args": [
                    interceptor
                ],
                "thisArg": undefined1
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined1);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined1) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined1 : this.__values__[this.__index__++];
            return {
                "done": done,
                "value": value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var _$result, parent = this;
            while(parent instanceof baseLodash){
                var _$clone = wrapperClone(parent);
                _$clone.__index__ = 0;
                _$clone.__values__ = undefined1;
                if (_$result) previous.__wrapped__ = _$clone;
                else _$result = _$clone;
                var previous = _$clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return _$result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    "func": thru,
                    "args": [
                        reverse
                    ],
                    "thisArg": undefined1
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined1;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined1 ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == "function", _$result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                _$result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return _$result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined1 : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined1) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined1;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined1 : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined1, undefined1, undefined1, undefined1, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var _$result;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) _$result = func.apply(this, arguments);
                if (n <= 1) func = undefined1;
                return _$result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined1 : arity;
            var _$result = createWrap(func, WRAP_CURRY_FLAG, undefined1, undefined1, undefined1, undefined1, undefined1, arity);
            _$result.placeholder = curry.placeholder;
            return _$result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined1 : arity;
            var _$result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined1, undefined1, undefined1, undefined1, undefined1, arity);
            _$result.placeholder = curryRight.placeholder;
            return _$result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, _$result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = "maxWait" in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined1;
                lastInvokeTime = time;
                _$result = func.apply(thisArg, args);
                return _$result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : _$result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined1 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined1;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined1;
                return _$result;
            }
            function cancel() {
                if (timerId !== undefined1) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined1;
            }
            function flush() {
                return timerId === undefined1 ? _$result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined1) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined1) timerId = setTimeout(timerExpired, wait);
                return _$result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function memoized1() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var _$result = func.apply(this, args);
                memoized.cache = cache.set(key, _$result) || cache;
                return _$result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined1, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined1, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined1, undefined1, undefined1, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined1 ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = "leading" in options ? !!options.leading : leading;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                "leading": leading,
                "maxWait": wait,
                "trailing": trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined1;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined1;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function isArguments(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined1;
            var _$result = customizer ? customizer(value, other) : undefined1;
            return _$result === undefined1 ? baseIsEqual(value, other, undefined1, customizer) : !!_$result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == "string" && typeof value.name == "string" && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == "number" && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == "number" && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value === "undefined" ? "undefined" : (0, $jzTO1._)(value);
            return value != null && (type == "object" || type == "function");
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == "object";
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined1;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == "number" || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
            return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == "string" || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return (typeof value === "undefined" ? "undefined" : (0, $jzTO1._)(value)) == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined1;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var _$result = toFinite(value), remainder = _$result % 1;
            return _$result === _$result ? remainder ? _$result - remainder : _$result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == "function" ? value.valueOf() : value;
                value = isObject(other) ? other + "" : other;
            }
            if (typeof value != "string") return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? "" : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var _$result = baseCreate(prototype);
            return properties == null ? _$result : baseAssign(_$result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = _$Object(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined1;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined1 || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined1, customDefaultsMerge);
            return apply(mergeWith, undefined1, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var _$result = object == null ? undefined1 : baseGet(object, path);
            return _$result === undefined1 ? defaultValue : _$result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var _$result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(_$result, iteratee(value, key, object), value);
            });
            return _$result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var _$result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(_$result, key, iteratee(value, key, object));
            });
            return _$result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var _$result = {};
            if (object == null) return _$result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), _$result);
            if (isDeep) _$result = baseClone(_$result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(_$result, paths[length]);
            return _$result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined1;
            }
            while(++index < length){
                var value = object == null ? undefined1 : object[toKey(path[index])];
                if (value === undefined1) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined1;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined1;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined1) {
                upper = lower;
                lower = undefined1;
            }
            if (upper !== undefined1) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined1) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined1) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != "boolean" && isIterateeCall(lower, upper, floating)) upper = floating = undefined1;
            if (floating === undefined1) {
                if (typeof upper == "boolean") {
                    floating = upper;
                    upper = undefined1;
                } else if (typeof lower == "boolean") {
                    floating = lower;
                    lower = undefined1;
                }
            }
            if (lower === undefined1 && upper === undefined1) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined1) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat("1e-" + ((rand + "").length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, "");
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined1 ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, "\\$&") : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? "-" : "") + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst("toLowerCase");
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ""), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined1) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? "_" : "") + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != "number" && isIterateeCall(string, separator, limit)) separator = limit = undefined1;
            limit = limit === undefined1 ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == "string" || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined1;
            string = toString(string);
            options = assignInWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = _$RegExp((options.escape || reNoMatch).source + "|" + interpolate.source + "|" + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + "|" + (options.evaluate || reNoMatch).source + "|$", "g");
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = "//# sourceURL=" + (hasOwnProperty.call(options, "sourceURL") ? (options.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++templateCounter + "]") + "\n";
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, "variable") && options.variable;
            if (!variable) source = "with (obj) {\n" + source + "\n}\n";
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, "") : source).replace(reEmptyStringMiddle, "$1").replace(reEmptyStringTrailing, "$1;");
            // Frame code as the function body.
            source = "function(" + (variable || "obj") + ") {\n" + (variable ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (isEscaping ? ", __e = _.escape" : "") + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + source + "return __p\n}";
            var _$result = attempt(function() {
                return _$Function(importsKeys, sourceURL + "return " + source).apply(undefined1, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            _$result.source = source;
            if (isError(_$result)) throw _$result;
            return _$result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined1)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join("");
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined1)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join("");
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined1)) return string.replace(reTrimStart, "");
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join("");
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = "separator" in options ? options.separator : separator;
                length = "length" in options ? toInteger(options.length) : length;
                omission = "omission" in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var _$result = strSymbols ? castSlice(strSymbols, 0, end).join("") : string.slice(0, end);
            if (separator === undefined1) return _$result + omission;
            if (strSymbols) end += _$result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = _$result;
                    if (!separator.global) separator = _$RegExp(separator.source, toString(reFlags.exec(separator)) + "g");
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    _$result = _$result.slice(0, newEnd === undefined1 ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = _$result.lastIndexOf(separator);
                if (index > -1) _$result = _$result.slice(0, index);
            }
            return _$result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst("toUpperCase");
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined1 : pattern;
            if (pattern === undefined1) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined1, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != "function") throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == "function" ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var _$chain = !(isObject(options) && "chain" in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (_$chain || chainAll) {
                        var _$result = object(this.__wrapped__), actions = _$result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            "func": func,
                            "args": arguments,
                            "thisArg": object
                        });
                        _$result.__chain__ = chainAll;
                        return _$result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined1 : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return "";
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var _$result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return _$result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound("ceil");
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound("floor");
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined1;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined1;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined1;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined1;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound("round");
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            "chain": false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            "bind",
            "bindKey",
            "curry",
            "curryRight",
            "partial",
            "partialRight"
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            "drop",
            "take"
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined1 ? 1 : nativeMax(toInteger(n), 0);
                var _$result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (_$result.__filtered__) _$result.__takeCount__ = nativeMin(n, _$result.__takeCount__);
                else _$result.__views__.push({
                    "size": nativeMin(n, MAX_ARRAY_LENGTH),
                    "type": methodName + (_$result.__dir__ < 0 ? "Right" : "")
                });
                return _$result;
            };
            LazyWrapper.prototype[methodName + "Right"] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            "filter",
            "map",
            "takeWhile"
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var _$result = this.clone();
                _$result.__iteratees__.push({
                    "iteratee": getIteratee(iteratee, 3),
                    "type": type
                });
                _$result.__filtered__ = _$result.__filtered__ || isFilter;
                return _$result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            "head",
            "last"
        ], function(methodName, index) {
            var takeName = "take" + (index ? "Right" : "");
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            "initial",
            "tail"
        ], function(methodName, index) {
            var dropName = "drop" + (index ? "" : "Right");
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == "function") return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var _$result = this;
            if (_$result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(_$result);
            if (start < 0) _$result = _$result.takeRight(-start);
            else if (start) _$result = _$result.drop(start);
            if (end !== undefined1) {
                end = toInteger(end);
                _$result = end < 0 ? _$result.dropRight(-end) : _$result.take(end - start);
            }
            return _$result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? "take" + (methodName == "last" ? "Right" : "") : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, _$iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function interceptor(value) {
                    var _$result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? _$result[0] : _$result;
                };
                if (useLazy && checkIteratee && typeof _$iteratee == "function" && _$iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var _$result = func.apply(value, args);
                    _$result.__actions__.push({
                        "func": thru,
                        "args": [
                            interceptor
                        ],
                        "thisArg": undefined1
                    });
                    return new LodashWrapper(_$result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                _$result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? _$result.value()[0] : _$result.value() : _$result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            "pop",
            "push",
            "shift",
            "sort",
            "splice",
            "unshift"
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? "tap" : "thru", retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + "";
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    "name": methodName,
                    "func": lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined1, WRAP_BIND_KEY_FLAG).name] = [
            {
                "name": "wrapper",
                "func": undefined1
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == "function" && typeof define.amd == "object" && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(undefined);

});
parcelRegister("jzTO1", function(module, exports) {

$parcel$export(module.exports, "_type_of", function () { return $e40c931179dab0a5$export$5f0017c582d45a2d; });
$parcel$export(module.exports, "_", function () { return $e40c931179dab0a5$export$5f0017c582d45a2d; });
function $e40c931179dab0a5$export$5f0017c582d45a2d(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}

});


parcelRegister("eA5uq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a9d8afa584430ddd$var$assign;
function $a9d8afa584430ddd$var$assign(target, object) {
    if (target == null) throw new TypeError("assign requires that input parameter not be null or undefined");
    for(var property in object)if (Object.prototype.hasOwnProperty.call(object, property)) target[property] = object[property];
    return target;
}
module.exports = module.exports.default;

});

parcelRegister("jW8xq", function(module, exports) {

$parcel$export(module.exports, "date", function () { return Rx; });
/*!
 * Quasar Framework v2.15.4
 * (c) 2015-present Razvan Stoenescu
 * Released under the MIT License.
 */ 
var $luoZD = parcelRequire("luoZD");

var $fYUO3 = parcelRequire("fYUO3");

var $8pZMQ = parcelRequire("8pZMQ");

var $8typN = parcelRequire("8typN");

var $lhEla = parcelRequire("lhEla");

var $4f96i = parcelRequire("4f96i");

var $79xu7 = parcelRequire("79xu7");

var $jzTO1 = parcelRequire("jzTO1");
parcelRequire("5eKWL");
var $aAzpa = parcelRequire("aAzpa");
var $iMtOP = parcelRequire("iMtOP");
var $aD8ZA = parcelRequire("aD8ZA");
var p0 = Object.create;
var Qs = Object.defineProperty;
var b0 = Object.getOwnPropertyDescriptor;
var y0 = Object.getOwnPropertyNames;
var S0 = Object.getPrototypeOf, x0 = Object.prototype.hasOwnProperty;
var Dd = function(e, t) {
    return function() {
        return t || e((t = {
            exports: {}
        }).exports, t), t.exports;
    };
}, Vd = function(e, t) {
    for(var o in t)Qs(e, o, {
        get: t[o],
        enumerable: !0
    });
}, _0 = function(e, t, o, r) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if (t && typeof t == "object" || typeof t == "function") try {
        var _loop = function() {
            var n = _step.value;
            !x0.call(e, n) && n !== o && Qs(e, n, {
                get: function() {
                    return t[n];
                },
                enumerable: !(r = b0(t, n)) || r.enumerable
            });
        };
        for(var _iterator = y0(t)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return e;
};
var zd = function(e, t, o) {
    return o = e != null ? p0(S0(e)) : {}, _0(t || !e || !e.__esModule ? Qs(o, "default", {
        value: e,
        enumerable: !0
    }) : o, e);
};
var Xd = Dd(function(t2, Yd) {
    Yd.exports = {
        isoName: "en-US",
        nativeName: "English (US)",
        label: {
            clear: "Clear",
            ok: "OK",
            cancel: "Cancel",
            close: "Close",
            set: "Set",
            select: "Select",
            reset: "Reset",
            remove: "Remove",
            update: "Update",
            create: "Create",
            search: "Search",
            filter: "Filter",
            refresh: "Refresh",
            expand: function(e) {
                return e ? 'Expand "'.concat(e, '"') : "Expand";
            },
            collapse: function(e) {
                return e ? 'Collapse "'.concat(e, '"') : "Collapse";
            }
        },
        date: {
            days: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
            daysShort: "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),
            months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
            monthsShort: "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),
            firstDayOfWeek: 0,
            format24h: !1,
            pluralDay: "days"
        },
        table: {
            noData: "No data available",
            noResults: "No matching records found",
            loading: "Loading...",
            selectedRecords: function(e) {
                return e === 1 ? "1 record selected." : (e === 0 ? "No" : e) + " records selected.";
            },
            recordsPerPage: "Records per page:",
            allRows: "All",
            pagination: function(e, t, o) {
                return e + "-" + t + " of " + o;
            },
            columns: "Columns"
        },
        editor: {
            url: "URL",
            bold: "Bold",
            italic: "Italic",
            strikethrough: "Strikethrough",
            underline: "Underline",
            unorderedList: "Unordered List",
            orderedList: "Ordered List",
            subscript: "Subscript",
            superscript: "Superscript",
            hyperlink: "Hyperlink",
            toggleFullscreen: "Toggle Fullscreen",
            quote: "Quote",
            left: "Left align",
            center: "Center align",
            right: "Right align",
            justify: "Justify align",
            print: "Print",
            outdent: "Decrease indentation",
            indent: "Increase indentation",
            removeFormat: "Remove formatting",
            formatting: "Formatting",
            fontSize: "Font Size",
            align: "Align",
            hr: "Insert Horizontal Rule",
            undo: "Undo",
            redo: "Redo",
            heading1: "Heading 1",
            heading2: "Heading 2",
            heading3: "Heading 3",
            heading4: "Heading 4",
            heading5: "Heading 5",
            heading6: "Heading 6",
            paragraph: "Paragraph",
            code: "Code",
            size1: "Very small",
            size2: "A bit small",
            size3: "Normal",
            size4: "Medium-large",
            size5: "Big",
            size6: "Very big",
            size7: "Maximum",
            defaultFont: "Default Font",
            viewSource: "View Source"
        },
        tree: {
            noNodes: "No nodes available",
            noResults: "No matching nodes found"
        }
    };
});
var Jd = Dd(function(r2, Zd) {
    Zd.exports = {
        name: "material-icons",
        type: {
            positive: "check_circle",
            negative: "warning",
            info: "info",
            warning: "priority_high"
        },
        arrow: {
            up: "arrow_upward",
            right: "arrow_forward",
            down: "arrow_downward",
            left: "arrow_back",
            dropdown: "arrow_drop_down"
        },
        chevron: {
            left: "chevron_left",
            right: "chevron_right"
        },
        colorPicker: {
            spectrum: "gradient",
            tune: "tune",
            palette: "style"
        },
        pullToRefresh: {
            icon: "refresh"
        },
        carousel: {
            left: "chevron_left",
            right: "chevron_right",
            up: "keyboard_arrow_up",
            down: "keyboard_arrow_down",
            navigationIcon: "lens"
        },
        chip: {
            remove: "cancel",
            selected: "check"
        },
        datetime: {
            arrowLeft: "chevron_left",
            arrowRight: "chevron_right",
            now: "access_time",
            today: "today"
        },
        editor: {
            bold: "format_bold",
            italic: "format_italic",
            strikethrough: "strikethrough_s",
            underline: "format_underlined",
            unorderedList: "format_list_bulleted",
            orderedList: "format_list_numbered",
            subscript: "vertical_align_bottom",
            superscript: "vertical_align_top",
            hyperlink: "link",
            toggleFullscreen: "fullscreen",
            quote: "format_quote",
            left: "format_align_left",
            center: "format_align_center",
            right: "format_align_right",
            justify: "format_align_justify",
            print: "print",
            outdent: "format_indent_decrease",
            indent: "format_indent_increase",
            removeFormat: "format_clear",
            formatting: "text_format",
            fontSize: "format_size",
            align: "format_align_left",
            hr: "remove",
            undo: "undo",
            redo: "redo",
            heading: "format_size",
            code: "code",
            size: "format_size",
            font: "font_download",
            viewSource: "code"
        },
        expansionItem: {
            icon: "keyboard_arrow_down",
            denseIcon: "arrow_drop_down"
        },
        fab: {
            icon: "add",
            activeIcon: "close"
        },
        field: {
            clear: "cancel",
            error: "error"
        },
        pagination: {
            first: "first_page",
            prev: "keyboard_arrow_left",
            next: "keyboard_arrow_right",
            last: "last_page"
        },
        rating: {
            icon: "grade"
        },
        stepper: {
            done: "check",
            active: "edit",
            error: "warning"
        },
        tabs: {
            left: "chevron_left",
            right: "chevron_right",
            up: "keyboard_arrow_up",
            down: "keyboard_arrow_down"
        },
        table: {
            arrowUp: "arrow_upward",
            warning: "warning",
            firstPage: "first_page",
            prevPage: "chevron_left",
            nextPage: "chevron_right",
            lastPage: "last_page"
        },
        tree: {
            icon: "play_arrow"
        },
        uploader: {
            done: "done",
            clear: "clear",
            add: "add_box",
            upload: "cloud_upload",
            removeQueue: "clear_all",
            removeUploaded: "done_all"
        }
    };
});
function it(e, t, o, r) {
    return Object.defineProperty(e, t, {
        get: o,
        set: r,
        enumerable: !0
    }), e;
}
function Sl(e, t) {
    for(var o in t)it(e, o, t[o]);
    return e;
}
var bt = (0, $aAzpa.ref)(!1), js;
function k0(e, t) {
    var o = /(edg|edge|edga|edgios)\/([\w.]+)/.exec(e) || /(opr)[\/]([\w.]+)/.exec(e) || /(vivaldi)[\/]([\w.]+)/.exec(e) || /(chrome|crios)[\/]([\w.]+)/.exec(e) || /(version)(applewebkit)[\/]([\w.]+).*(safari)[\/]([\w.]+)/.exec(e) || /(webkit)[\/]([\w.]+).*(version)[\/]([\w.]+).*(safari)[\/]([\w.]+)/.exec(e) || /(firefox|fxios)[\/]([\w.]+)/.exec(e) || /(webkit)[\/]([\w.]+)/.exec(e) || /(opera)(?:.*version|)[\/]([\w.]+)/.exec(e) || [];
    return {
        browser: o[5] || o[3] || o[1] || "",
        version: o[4] || o[2] || "0",
        platform: t[0] || ""
    };
}
function q0(e) {
    return /(ipad)/.exec(e) || /(ipod)/.exec(e) || /(windows phone)/.exec(e) || /(iphone)/.exec(e) || /(kindle)/.exec(e) || /(silk)/.exec(e) || /(android)/.exec(e) || /(win)/.exec(e) || /(mac)/.exec(e) || /(linux)/.exec(e) || /(cros)/.exec(e) || /(playbook)/.exec(e) || /(bb)/.exec(e) || /(blackberry)/.exec(e) || [];
}
var Id = "ontouchstart" in window || window.navigator.maxTouchPoints > 0;
function T0(e) {
    var t = e.toLowerCase(), o = q0(t), r = k0(t, o), n = {};
    r.browser && (n[r.browser] = !0, n.version = r.version, n.versionNumber = parseInt(r.version, 10)), r.platform && (n[r.platform] = !0);
    var i = n.android || n.ios || n.bb || n.blackberry || n.ipad || n.iphone || n.ipod || n.kindle || n.playbook || n.silk || n["windows phone"];
    if (i === !0 || t.indexOf("mobile") !== -1 ? n.mobile = !0 : n.desktop = !0, n["windows phone"] && (n.winphone = !0, delete n["windows phone"]), n.edga || n.edgios || n.edg ? (n.edge = !0, r.browser = "edge") : n.crios ? (n.chrome = !0, r.browser = "chrome") : n.fxios && (n.firefox = !0, r.browser = "firefox"), (n.ipod || n.ipad || n.iphone) && (n.ios = !0), n.vivaldi && (r.browser = "vivaldi", n.vivaldi = !0), (n.chrome || n.opr || n.safari || n.vivaldi || n.mobile === !0 && n.ios !== !0 && i !== !0) && (n.webkit = !0), n.opr && (r.browser = "opera", n.opera = !0), n.safari && (n.blackberry || n.bb ? (r.browser = "blackberry", n.blackberry = !0) : n.playbook ? (r.browser = "playbook", n.playbook = !0) : n.android ? (r.browser = "android", n.android = !0) : n.kindle ? (r.browser = "kindle", n.kindle = !0) : n.silk && (r.browser = "silk", n.silk = !0)), n.name = r.browser, n.platform = r.platform, t.indexOf("electron") !== -1) n.electron = !0;
    else if (document.location.href.indexOf("-extension://") !== -1) n.bex = !0;
    else {
        if (window.Capacitor !== void 0 ? (n.capacitor = !0, n.nativeMobile = !0, n.nativeMobileWrapper = "capacitor") : (window._cordovaNative !== void 0 || window.cordova !== void 0) && (n.cordova = !0, n.nativeMobile = !0, n.nativeMobileWrapper = "cordova"), bt.value === !0 && (js = {
            is: (0, $8pZMQ._)({}, n)
        }), Id === !0 && n.mac === !0 && (n.desktop === !0 && n.safari === !0 || n.nativeMobile === !0 && n.android !== !0 && n.ios !== !0 && n.ipad !== !0)) {
            delete n.mac, delete n.desktop;
            var a = Math.min(window.innerHeight, window.innerWidth) > 414 ? "ipad" : "iphone";
            Object.assign(n, {
                mobile: !0,
                ios: !0,
                platform: a,
                [a]: !0
            });
        }
        n.mobile !== !0 && window.navigator.userAgentData && window.navigator.userAgentData.mobile && (delete n.desktop, n.mobile = !0);
    }
    return n;
}
var Od = navigator.userAgent || navigator.vendor || window.opera, M0 = {
    has: {
        touch: !1,
        webStorage: !1
    },
    within: {
        iframe: !1
    }
}, Ce = {
    userAgent: Od,
    is: T0(Od),
    has: {
        touch: Id
    },
    within: {
        iframe: window.self !== window.top
    }
}, Us = {
    install: function(e) {
        var t = e.$q;
        bt.value === !0 ? (e.onSSRHydrated.push(function() {
            Object.assign(t.platform, Ce), bt.value = !1;
        }), t.platform = (0, $aAzpa.reactive)(this)) : t.platform = this;
    }
};
{
    var e;
    it(Ce.has, "webStorage", function() {
        if (e !== void 0) return e;
        try {
            if (window.localStorage) return e = !0, !0;
        } catch (e) {}
        return e = !1, !1;
    }), Object.assign(Us, Ce), bt.value === !0 && (Object.assign(Us, js, M0), js = null);
}var qn = Us;
function R(e) {
    return (0, $aAzpa.markRaw)((0, $aD8ZA.defineComponent)(e));
}
function Mt(e) {
    return (0, $aAzpa.markRaw)(e);
}
var Xt = function(e, t) {
    var _loop = function(r) {
        it(t, r, function() {
            return o[r];
        }, function(n) {
            o[r] = n;
        });
    };
    var o = (0, $aAzpa.reactive)(e);
    for(var r in e)_loop(r);
    return t;
};
var Xe = {
    hasPassive: !1,
    passiveCapture: !0,
    notPassiveCapture: !0
};
try {
    var e1 = Object.defineProperty({}, "passive", {
        get: function() {
            Object.assign(Xe, {
                hasPassive: !0,
                passive: {
                    passive: !0
                },
                notPassive: {
                    passive: !1
                },
                passiveCapture: {
                    passive: !0,
                    capture: !0
                },
                notPassiveCapture: {
                    passive: !1,
                    capture: !0
                }
            });
        }
    });
    window.addEventListener("qtest", null, e1), window.removeEventListener("qtest", null, e1);
} catch (e) {}
function Qe() {}
function Tn(e) {
    return e.button === 0;
}
function A0(e) {
    return e.button === 1;
}
function $0(e) {
    return e.button === 2;
}
function yt(e) {
    return e.touches && e.touches[0] ? e = e.touches[0] : e.changedTouches && e.changedTouches[0] ? e = e.changedTouches[0] : e.targetTouches && e.targetTouches[0] && (e = e.targetTouches[0]), {
        top: e.clientY,
        left: e.clientX
    };
}
function Ks(e) {
    if (e.path) return e.path;
    if (e.composedPath) return e.composedPath();
    var t = [], o = e.target;
    for(; o;){
        if (t.push(o), o.tagName === "HTML") return t.push(document), t.push(window), t;
        o = o.parentElement;
    }
}
var E0 = 40, B0 = 800;
function L0(e) {
    var t = e.deltaX, o = e.deltaY;
    if ((t || o) && e.deltaMode) {
        var r = e.deltaMode === 1 ? E0 : B0;
        t *= r, o *= r;
    }
    var ref;
    return e.shiftKey && !t && (ref = [
        t,
        o
    ], o = ref[0], t = ref[1], ref), {
        x: t,
        y: o
    };
}
function tt(e) {
    e.stopPropagation();
}
function ut(e) {
    e.cancelable !== !1 && e.preventDefault();
}
function Se(e) {
    e.cancelable !== !1 && e.preventDefault(), e.stopPropagation();
}
function Mn(e, t) {
    if (e === void 0 || t === !0 && e.__dragPrevented === !0) return;
    var o = t === !0 ? function(r) {
        r.__dragPrevented = !0, r.addEventListener("dragstart", ut, Xe.notPassiveCapture);
    } : function(r) {
        delete r.__dragPrevented, r.removeEventListener("dragstart", ut, Xe.notPassiveCapture);
    };
    e.querySelectorAll("a, img").forEach(o);
}
function lt(e, t, o) {
    var r = "__q_".concat(t, "_evt");
    e[r] = e[r] !== void 0 ? e[r].concat(o) : o, o.forEach(function(n) {
        n[0].addEventListener(n[1], e[n[2]], Xe[n[3]]);
    });
}
function Ct(e, t) {
    var o = "__q_".concat(t, "_evt");
    e[o] !== void 0 && (e[o].forEach(function(r) {
        r[0].removeEventListener(r[1], e[r[2]], Xe[r[3]]);
    }), e[o] = void 0);
}
var F0 = {
    listenOpts: Xe,
    leftClick: Tn,
    middleClick: A0,
    rightClick: $0,
    position: yt,
    getEventPath: Ks,
    getMouseWheelDistance: L0,
    stop: tt,
    prevent: ut,
    stopAndPrevent: Se,
    preventDraggable: Mn
};
function So(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 250, o = arguments.length > 2 ? arguments[2] : void 0;
    var r = null;
    function n() {
        var _this = this;
        var i = arguments, a = function() {
            r = null, o !== !0 && e.apply(_this, i);
        };
        r !== null ? clearTimeout(r) : o === !0 && e.apply(this, i), r = setTimeout(a, t);
    }
    return n.cancel = function() {
        r !== null && clearTimeout(r);
    }, n;
}
var Ws = [
    "sm",
    "md",
    "lg",
    "xl"
], Nd = Xe.passive, Ys = Xt({
    width: 0,
    height: 0,
    name: "xs",
    sizes: {
        sm: 600,
        md: 1024,
        lg: 1440,
        xl: 1920
    },
    lt: {
        sm: !0,
        md: !0,
        lg: !0,
        xl: !0
    },
    gt: {
        xs: !1,
        sm: !1,
        md: !1,
        lg: !1
    },
    xs: !0,
    sm: !1,
    md: !1,
    lg: !1,
    xl: !1
}, {
    setSizes: Qe,
    setDebounce: Qe,
    install: function(param) {
        var _this = this;
        var e = param.$q, t = param.onSSRHydrated;
        if (e.screen = this, this.__installed === !0) {
            e.config.screen !== void 0 && (e.config.screen.bodyClasses === !1 ? document.body.classList.remove("screen--".concat(this.name)) : this.__update(!0));
            return;
        }
        var o = window.visualViewport, r = o || window, n = document.scrollingElement || document.documentElement, i = o === void 0 || Ce.is.mobile === !0 ? function() {
            return [
                Math.max(window.innerWidth, n.clientWidth),
                Math.max(window.innerHeight, n.clientHeight)
            ];
        } : function() {
            return [
                o.width * o.scale + window.innerWidth - n.clientWidth,
                o.height * o.scale + window.innerHeight - n.clientHeight
            ];
        }, a = e.config.screen !== void 0 && e.config.screen.bodyClasses === !0;
        this.__update = function(v) {
            var _i = (0, $4f96i._)(i(), 2), f = _i[0], d = _i[1];
            if (d !== _this.height && (_this.height = d), f !== _this.width) _this.width = f;
            else if (v !== !0) return;
            var m = _this.sizes;
            _this.gt.xs = f >= m.sm, _this.gt.sm = f >= m.md, _this.gt.md = f >= m.lg, _this.gt.lg = f >= m.xl, _this.lt.sm = f < m.sm, _this.lt.md = f < m.md, _this.lt.lg = f < m.lg, _this.lt.xl = f < m.xl, _this.xs = _this.lt.sm, _this.sm = _this.gt.xs === !0 && _this.lt.md === !0, _this.md = _this.gt.sm === !0 && _this.lt.lg === !0, _this.lg = _this.gt.md === !0 && _this.lt.xl === !0, _this.xl = _this.gt.lg, m = _this.xs === !0 && "xs" || _this.sm === !0 && "sm" || _this.md === !0 && "md" || _this.lg === !0 && "lg" || "xl", m !== _this.name && (a === !0 && (document.body.classList.remove("screen--".concat(_this.name)), document.body.classList.add("screen--".concat(m))), _this.name = m);
        };
        var l, s = {}, c = 16;
        this.setSizes = function(v) {
            Ws.forEach(function(f) {
                v[f] !== void 0 && (s[f] = v[f]);
            });
        }, this.setDebounce = function(v) {
            c = v;
        };
        var u = function() {
            var v = getComputedStyle(document.body);
            v.getPropertyValue("--q-size-sm") && Ws.forEach(function(f) {
                _this.sizes[f] = parseInt(v.getPropertyValue("--q-size-".concat(f)), 10);
            }), _this.setSizes = function(f) {
                Ws.forEach(function(d) {
                    f[d] && (_this.sizes[d] = f[d]);
                }), _this.__update(!0);
            }, _this.setDebounce = function(f) {
                l !== void 0 && r.removeEventListener("resize", l, Nd), l = f > 0 ? So(_this.__update, f) : _this.__update, r.addEventListener("resize", l, Nd);
            }, _this.setDebounce(c), Object.keys(s).length !== 0 ? (_this.setSizes(s), s = void 0) : _this.__update(), a === !0 && _this.name === "xs" && document.body.classList.add("screen--xs");
        };
        bt.value === !0 ? t.push(u) : u();
    }
});
var Gt = Xt({
    isActive: !1,
    mode: !1
}, {
    __media: void 0,
    set: function(e) {
        Gt.mode = e, e === "auto" ? (Gt.__media === void 0 && (Gt.__media = window.matchMedia("(prefers-color-scheme: dark)"), Gt.__updateMedia = function() {
            Gt.set("auto");
        }, Gt.__media.addListener(Gt.__updateMedia)), e = Gt.__media.matches) : Gt.__media !== void 0 && (Gt.__media.removeListener(Gt.__updateMedia), Gt.__media = void 0), Gt.isActive = e === !0, document.body.classList.remove("body--".concat(e === !0 ? "light" : "dark")), document.body.classList.add("body--".concat(e === !0 ? "dark" : "light"));
    },
    toggle: function() {
        Gt.set(Gt.isActive === !1);
    },
    install: function(param) {
        var e = param.$q, t = param.ssrContext;
        var _e_config = e.config, o = _e_config.dark;
        e.dark = this, this.__installed !== !0 && this.set(o !== void 0 ? o : !1);
    }
}), Xs = Gt;
function xl(e, t) {
    var o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : document.body;
    if (typeof e != "string") throw new TypeError("Expected a string as propName");
    if (typeof t != "string") throw new TypeError("Expected a string as value");
    if (!(o instanceof Element)) throw new TypeError("Expected a DOM element");
    o.style.setProperty("--q-".concat(e), t);
}
var Qd = !1;
function jd(e) {
    Qd = e.isComposing === !0;
}
function xo(e) {
    return Qd === !0 || e !== Object(e) || e.isComposing === !0 || e.qKeyEvent === !0;
}
function wt(e, t) {
    return xo(e) === !0 ? !1 : [].concat(t).includes(e.keyCode);
}
function Ud(e) {
    if (e.ios === !0) return "ios";
    if (e.android === !0) return "android";
}
function D0(param, r) {
    var e = param.is, t = param.has, o = param.within;
    var n = [
        e.desktop === !0 ? "desktop" : "mobile",
        "".concat(t.touch === !1 ? "no-" : "", "touch")
    ];
    if (e.mobile === !0) {
        var i = Ud(e);
        i !== void 0 && n.push("platform-" + i);
    }
    if (e.nativeMobile === !0) {
        var i1 = e.nativeMobileWrapper;
        n.push(i1), n.push("native-mobile"), e.ios === !0 && (r[i1] === void 0 || r[i1].iosStatusBarPadding !== !1) && n.push("q-ios-padding");
    } else e.electron === !0 ? n.push("electron") : e.bex === !0 && n.push("bex");
    return o.iframe === !0 && n.push("within-iframe"), n;
}
function V0() {
    var e = Ce.is, t = document.body.className, o = new Set(t.replace(/ {2}/g, " ").split(" "));
    if (e.nativeMobile !== !0 && e.electron !== !0 && e.bex !== !0) {
        if (e.desktop === !0) o.delete("mobile"), o.delete("platform-ios"), o.delete("platform-android"), o.add("desktop");
        else if (e.mobile === !0) {
            o.delete("desktop"), o.add("mobile"), o.delete("platform-ios"), o.delete("platform-android");
            var n = Ud(e);
            n !== void 0 && o.add("platform-".concat(n));
        }
    }
    Ce.has.touch === !0 && (o.delete("no-touch"), o.add("touch")), Ce.within.iframe === !0 && o.add("within-iframe");
    var r = Array.from(o).join(" ");
    t !== r && (document.body.className = r);
}
function z0(e) {
    for(var t in e)xl(t, e[t]);
}
var Kd = {
    install: function(e) {
        if (this.__installed !== !0) {
            if (bt.value === !0) V0();
            else {
                var t = e.$q;
                t.config.brand !== void 0 && z0(t.config.brand);
                var o = D0(Ce, t.config);
                document.body.classList.add.apply(document.body.classList, o);
            }
            Ce.is.ios === !0 && document.body.addEventListener("touchstart", Qe), window.addEventListener("keydown", jd, !0);
        }
    }
};
var Wd = function() {
    return !0;
};
function O0(e) {
    return typeof e == "string" && e !== "" && e !== "/" && e !== "#/";
}
function I0(e) {
    return e.startsWith("#") === !0 && (e = e.substring(1)), e.startsWith("/") === !1 && (e = "/" + e), e.endsWith("/") === !0 && (e = e.substring(0, e.length - 1)), "#" + e;
}
function H0(e) {
    var _t;
    if (e.backButtonExit === !1) return function() {
        return !1;
    };
    if (e.backButtonExit === "*") return Wd;
    var t = [
        "#/"
    ];
    return Array.isArray(e.backButtonExit) === !0 && (_t = t).push.apply(_t, (0, $79xu7._)(e.backButtonExit.filter(O0).map(I0))), function() {
        return t.includes(window.location.hash);
    };
}
var Un = {
    __history: [],
    add: Qe,
    remove: Qe,
    install: function(param) {
        var _this = this;
        var e = param.$q;
        if (this.__installed === !0) return;
        var _Ce_is = Ce.is, t = _Ce_is.cordova, o = _Ce_is.capacitor;
        if (t !== !0 && o !== !0) return;
        var r = e.config[t === !0 ? "cordova" : "capacitor"];
        if (r !== void 0 && r.backButton === !1 || o === !0 && (window.Capacitor === void 0 || window.Capacitor.Plugins.App === void 0)) return;
        this.add = function(a) {
            a.condition === void 0 && (a.condition = Wd), _this.__history.push(a);
        }, this.remove = function(a) {
            var l = _this.__history.indexOf(a);
            l >= 0 && _this.__history.splice(l, 1);
        };
        var n = H0(Object.assign({
            backButtonExit: !0
        }, r)), i = function() {
            if (_this.__history.length) {
                var a = _this.__history[_this.__history.length - 1];
                a.condition() === !0 && (_this.__history.pop(), a.handler());
            } else n() === !0 ? navigator.app.exitApp() : window.history.back();
        };
        t === !0 ? document.addEventListener("deviceready", function() {
            document.addEventListener("backbutton", i, !1);
        }) : window.Capacitor.Plugins.App.addListener("backButton", i);
    }
};
var qa = zd(Xd());
function Gd() {
    var e = Array.isArray(navigator.languages) === !0 && navigator.languages.length !== 0 ? navigator.languages[0] : navigator.language;
    if (typeof e == "string") return e.split(/[-_]/).map(function(t, o) {
        return o === 0 ? t.toLowerCase() : o > 1 || t.length < 4 ? t.toUpperCase() : t[0].toUpperCase() + t.slice(1).toLowerCase();
    }).join("-");
}
var kr = Xt({
    __qLang: {}
}, {
    getLocale: Gd,
    set: function() {
        var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : qa.default, t = arguments.length > 1 ? arguments[1] : void 0;
        var o = (0, $8typN._)((0, $8pZMQ._)({}, e), {
            rtl: e.rtl === !0,
            getLocale: Gd
        });
        if (o.set = kr.set, kr.__langConfig === void 0 || kr.__langConfig.noHtmlAttrs !== !0) {
            var r = document.documentElement;
            r.setAttribute("dir", o.rtl === !0 ? "rtl" : "ltr"), r.setAttribute("lang", o.isoName);
        }
        Object.assign(kr.__qLang, o);
    },
    install: function(param) {
        var e = param.$q, t = param.lang, o = param.ssrContext;
        e.lang = kr.__qLang, kr.__langConfig = e.config.lang, this.__installed === !0 ? t !== void 0 && this.set(t) : (this.props = new Proxy(this.__qLang, {
            get: function() {
                var _Reflect;
                return (_Reflect = Reflect).get.apply(_Reflect, arguments);
            },
            ownKeys: function(r) {
                return Reflect.ownKeys(r).filter(function(n) {
                    return n !== "set" && n !== "getLocale";
                });
            }
        }), this.set(t || qa.default));
    }
}), Kn = kr;
var ef = zd(Jd()), Gs = Xt({
    iconMapFn: null,
    __qIconSet: {}
}, {
    set: function(e, t) {
        var o = (0, $8pZMQ._)({}, e);
        o.set = Gs.set, Object.assign(Gs.__qIconSet, o);
    },
    install: function(param) {
        var _this = this;
        var e = param.$q, t = param.iconSet, o = param.ssrContext;
        e.config.iconMapFn !== void 0 && (this.iconMapFn = e.config.iconMapFn), e.iconSet = this.__qIconSet, it(e, "iconMapFn", function() {
            return _this.iconMapFn;
        }, function(r) {
            _this.iconMapFn = r;
        }), this.__installed === !0 ? t !== void 0 && this.set(t) : (this.props = new Proxy(this.__qIconSet, {
            get: function() {
                var _Reflect;
                return (_Reflect = Reflect).get.apply(_Reflect, arguments);
            },
            ownKeys: function(r) {
                return Reflect.ownKeys(r).filter(function(n) {
                    return n !== "set";
                });
            }
        }), this.set(t || ef.default));
    }
}), Ta = Gs;
var _l = "_q_", Cl = "_q_t_", wl = "_q_s_", co = "_q_l_", kl = "_q_pc_", ql = "_q_f_", Rn = "_q_fo_", Tl = "_q_tabs_", Ml = "_q_u_";
function Ye() {}
var ni = {}, Zs = !1;
function tf() {
    Zs = !0;
}
function Zt(e, t) {
    if (e === t) return !0;
    if (e !== null && t !== null && typeof e == "object" && typeof t == "object") {
        if (e.constructor !== t.constructor) return !1;
        var o, r;
        if (e.constructor === Array) {
            if (o = e.length, o !== t.length) return !1;
            for(r = o; r-- !== 0;)if (Zt(e[r], t[r]) !== !0) return !1;
            return !0;
        }
        if (e.constructor === Map) {
            if (e.size !== t.size) return !1;
            var i = e.entries();
            for(r = i.next(); r.done !== !0;){
                if (t.has(r.value[0]) !== !0) return !1;
                r = i.next();
            }
            for(i = e.entries(), r = i.next(); r.done !== !0;){
                if (Zt(r.value[1], t.get(r.value[0])) !== !0) return !1;
                r = i.next();
            }
            return !0;
        }
        if (e.constructor === Set) {
            if (e.size !== t.size) return !1;
            var i1 = e.entries();
            for(r = i1.next(); r.done !== !0;){
                if (t.has(r.value[0]) !== !0) return !1;
                r = i1.next();
            }
            return !0;
        }
        if (e.buffer != null && e.buffer.constructor === ArrayBuffer) {
            if (o = e.length, o !== t.length) return !1;
            for(r = o; r-- !== 0;)if (e[r] !== t[r]) return !1;
            return !0;
        }
        if (e.constructor === RegExp) return e.source === t.source && e.flags === t.flags;
        if (e.valueOf !== Object.prototype.valueOf) return e.valueOf() === t.valueOf();
        if (e.toString !== Object.prototype.toString) return e.toString() === t.toString();
        var n = Object.keys(e).filter(function(i) {
            return e[i] !== void 0;
        });
        if (o = n.length, o !== Object.keys(t).filter(function(i) {
            return t[i] !== void 0;
        }).length) return !1;
        for(r = o; r-- !== 0;){
            var i2 = n[r];
            if (Zt(e[i2], t[i2]) !== !0) return !1;
        }
        return !0;
    }
    return e !== e && t !== t;
}
function at(e) {
    return e !== null && typeof e == "object" && Array.isArray(e) !== !0;
}
function Pn(e) {
    return Object.prototype.toString.call(e) === "[object Date]";
}
function Js(e) {
    return Object.prototype.toString.call(e) === "[object RegExp]";
}
function Mo(e) {
    return typeof e == "number" && isFinite(e);
}
var N0 = {
    deepEqual: Zt,
    object: at,
    date: Pn,
    regexp: Js,
    number: Mo
};
var of = [
    qn,
    Kd,
    Xs,
    Ys,
    Un,
    Kn,
    Ta
];
function Wn(e, t) {
    var o = (0, $iMtOP.createApp)(e);
    o.config.globalProperties = t.config.globalProperties;
    var _t__context = t._context, r = _t__context.reload, n = (0, $lhEla._)(_t__context, [
        "reload"
    ]);
    return Object.assign(o._context, n), o;
}
function nf(e, t) {
    t.forEach(function(o) {
        o.install(e), o.__installed = !0;
    });
}
function j0(e, t, o) {
    e.config.globalProperties.$q = o.$q, e.provide(_l, o.$q), nf(o, of), t.components !== void 0 && Object.values(t.components).forEach(function(r) {
        at(r) === !0 && r.name !== void 0 && e.component(r.name, r);
    }), t.directives !== void 0 && Object.values(t.directives).forEach(function(r) {
        at(r) === !0 && r.name !== void 0 && e.directive(r.name, r);
    }), t.plugins !== void 0 && nf(o, Object.values(t.plugins).filter(function(r) {
        return typeof r.install == "function" && of.includes(r) === !1;
    })), bt.value === !0 && (o.$q.onSSRHydrated = function() {
        o.onSSRHydrated.forEach(function(r) {
            r();
        }), o.$q.onSSRHydrated = function() {};
    });
}
var rf = function rf(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var o = {
        version: "2.15.4"
    };
    Zs === !1 ? (t.config !== void 0 && Object.assign(ni, t.config), o.config = (0, $8pZMQ._)({}, ni), tf()) : o.config = t.config || {}, j0(e, t, {
        parentApp: e,
        $q: o,
        lang: t.lang,
        iconSet: t.iconSet,
        onSSRHydrated: []
    });
};
var Td = {};
Vd(Td, {
    QAjaxBar: function() {
        return Pl;
    },
    QAvatar: function() {
        return $l;
    },
    QBadge: function() {
        return pf;
    },
    QBanner: function() {
        return yf;
    },
    QBar: function() {
        return Sf;
    },
    QBreadcrumbs: function() {
        return Cf;
    },
    QBreadcrumbsEl: function() {
        return Rf;
    },
    QBtn: function() {
        return Le;
    },
    QBtnDropdown: function() {
        return Kl;
    },
    QBtnGroup: function() {
        return gi;
    },
    QBtnToggle: function() {
        return um;
    },
    QCard: function() {
        return $i;
    },
    QCardActions: function() {
        return Wl;
    },
    QCardSection: function() {
        return Ho;
    },
    QCarousel: function() {
        return fm;
    },
    QCarouselControl: function() {
        return gm;
    },
    QCarouselSlide: function() {
        return mm;
    },
    QChatMessage: function() {
        return hm;
    },
    QCheckbox: function() {
        return fn;
    },
    QChip: function() {
        return Ki;
    },
    QCircularProgress: function() {
        return Yi;
    },
    QColor: function() {
        return Am;
    },
    QDate: function() {
        return jm;
    },
    QDialog: function() {
        return gn;
    },
    QDrawer: function() {
        return ov;
    },
    QEditor: function() {
        return Sv;
    },
    QExpansionItem: function() {
        return _v;
    },
    QFab: function() {
        return wv;
    },
    QFabAction: function() {
        return Tv;
    },
    QField: function() {
        return Au;
    },
    QFile: function() {
        return Ev;
    },
    QFooter: function() {
        return Bv;
    },
    QForm: function() {
        return Lv;
    },
    QFormChildMixin: function() {
        return Fv;
    },
    QHeader: function() {
        return Vv;
    },
    QIcon: function() {
        return we;
    },
    QImg: function() {
        return zv;
    },
    QInfiniteScroll: function() {
        return Nv;
    },
    QInnerLoading: function() {
        return jv;
    },
    QInput: function() {
        return da;
    },
    QIntersection: function() {
        return tg;
    },
    QItem: function() {
        return hn;
    },
    QItemLabel: function() {
        return Hr;
    },
    QItemSection: function() {
        return ho;
    },
    QKnob: function() {
        return rg;
    },
    QLayout: function() {
        return lg;
    },
    QLinearProgress: function() {
        return is;
    },
    QList: function() {
        return Uu;
    },
    QMarkupTable: function() {
        return Wu;
    },
    QMenu: function() {
        return sn;
    },
    QNoSsr: function() {
        return sg;
    },
    QOptionGroup: function() {
        return Gu;
    },
    QPage: function() {
        return gg;
    },
    QPageContainer: function() {
        return hg;
    },
    QPageScroller: function() {
        return Sg;
    },
    QPageSticky: function() {
        return xg;
    },
    QPagination: function() {
        return _g;
    },
    QParallax: function() {
        return wg;
    },
    QPopupEdit: function() {
        return kg;
    },
    QPopupProxy: function() {
        return Tg;
    },
    QPullToRefresh: function() {
        return Rg;
    },
    QRadio: function() {
        return Yu;
    },
    QRange: function() {
        return Pg;
    },
    QRating: function() {
        return Ag;
    },
    QResizeObserver: function() {
        return go;
    },
    QResponsive: function() {
        return $g;
    },
    QRouteTab: function() {
        return Gh;
    },
    QScrollArea: function() {
        return Dg;
    },
    QScrollObserver: function() {
        return fa;
    },
    QSelect: function() {
        return fs;
    },
    QSeparator: function() {
        return Co;
    },
    QSkeleton: function() {
        return Qg;
    },
    QSlideItem: function() {
        return Kg;
    },
    QSlideTransition: function() {
        return sr;
    },
    QSlider: function() {
        return Bn;
    },
    QSpace: function() {
        return Wg;
    },
    QSpinner: function() {
        return xt;
    },
    QSpinnerAudio: function() {
        return Yg;
    },
    QSpinnerBall: function() {
        return Xg;
    },
    QSpinnerBars: function() {
        return Gg;
    },
    QSpinnerBox: function() {
        return Zg;
    },
    QSpinnerClock: function() {
        return Jg;
    },
    QSpinnerComment: function() {
        return eh;
    },
    QSpinnerCube: function() {
        return th;
    },
    QSpinnerDots: function() {
        return oh;
    },
    QSpinnerFacebook: function() {
        return nh;
    },
    QSpinnerGears: function() {
        return rh;
    },
    QSpinnerGrid: function() {
        return ih;
    },
    QSpinnerHearts: function() {
        return ah;
    },
    QSpinnerHourglass: function() {
        return lh;
    },
    QSpinnerInfinity: function() {
        return uh;
    },
    QSpinnerIos: function() {
        return sh;
    },
    QSpinnerOrbit: function() {
        return ch;
    },
    QSpinnerOval: function() {
        return dh;
    },
    QSpinnerPie: function() {
        return fh;
    },
    QSpinnerPuff: function() {
        return mh;
    },
    QSpinnerRadio: function() {
        return vh;
    },
    QSpinnerRings: function() {
        return gh;
    },
    QSpinnerTail: function() {
        return hh;
    },
    QSplitter: function() {
        return bh;
    },
    QStep: function() {
        return xh;
    },
    QStepper: function() {
        return _h;
    },
    QStepperNavigation: function() {
        return Ch;
    },
    QTab: function() {
        return ir;
    },
    QTabPanel: function() {
        return Gi;
    },
    QTabPanels: function() {
        return su;
    },
    QTable: function() {
        return Kh;
    },
    QTabs: function() {
        return Qa;
    },
    QTd: function() {
        return Xh;
    },
    QTh: function() {
        return bs;
    },
    QTime: function() {
        return Jh;
    },
    QTimeline: function() {
        return ep;
    },
    QTimelineEntry: function() {
        return tp;
    },
    QToggle: function() {
        return Xu;
    },
    QToolbar: function() {
        return op;
    },
    QToolbarTitle: function() {
        return np;
    },
    QTooltip: function() {
        return ku;
    },
    QTr: function() {
        return Wh;
    },
    QTree: function() {
        return ip;
    },
    QUploader: function() {
        return cp;
    },
    QUploaderAddTrigger: function() {
        return dp;
    },
    QVideo: function() {
        return mp;
    },
    QVirtualScroll: function() {
        return xs;
    }
});
var af = [
    "B",
    "KB",
    "MB",
    "GB",
    "TB",
    "PB"
];
function ri(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
    var o = 0;
    for(; parseInt(e, 10) >= 1024 && o < af.length - 1;)e /= 1024, ++o;
    return "".concat(e.toFixed(t)).concat(af[o]);
}
function ec(e) {
    return e.charAt(0).toUpperCase() + e.slice(1);
}
function Ze(e, t, o) {
    return o <= t ? t : Math.min(o, Math.max(t, e));
}
function qr(e, t, o) {
    if (o <= t) return t;
    var r = o - t + 1, n = t + (e - t) % r;
    return n < t && (n = r + n), n === 0 ? 0 : n;
}
function Je(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2, o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "0";
    if (e == null) return e;
    var r = "" + e;
    return r.length >= t ? r : new Array(t - r.length + 1).join(o) + r;
}
var U0 = {
    humanStorageSize: ri,
    capitalize: ec,
    between: Ze,
    normalizeToInterval: qr,
    pad: Je
};
var oc = XMLHttpRequest, lf = oc.prototype.open, G0 = [
    "top",
    "right",
    "bottom",
    "left"
], Rl = [], Ma = 0;
function Z0(param) {
    var e = param.p, t = param.pos, o = param.active, r = param.horiz, n = param.reverse, i = param.dir;
    var a = 1, l = 1;
    return r === !0 ? (n === !0 && (a = -1), t === "bottom" && (l = -1), {
        transform: "translate3d(".concat(a * (e - 100), "%,").concat(o ? 0 : l * -200, "%,0)")
    }) : (n === !0 && (l = -1), t === "right" && (a = -1), {
        transform: "translate3d(".concat(o ? 0 : i * a * -200, "%,").concat(l * (e - 100), "%,0)")
    });
}
function J0(e, t) {
    return typeof t != "number" && (e < 25 ? t = Math.random() * 3 + 3 : e < 65 ? t = Math.random() * 3 : e < 85 ? t = Math.random() * 2 : e < 99 ? t = .6 : t = 0), Ze(e + t, 0, 100);
}
function eb(e) {
    Ma++, Rl.push(e), !(Ma > 1) && (oc.prototype.open = function(t, o) {
        var r = [], n = function() {
            Rl.forEach(function(a) {
                (a.hijackFilter.value === null || a.hijackFilter.value(o) === !0) && (a.start(), r.push(a.stop));
            });
        }, i = function() {
            r.forEach(function(a) {
                a();
            });
        };
        this.addEventListener("loadstart", n, {
            once: !0
        }), this.addEventListener("loadend", i, {
            once: !0
        }), lf.apply(this, arguments);
    });
}
function tb(e) {
    Rl = Rl.filter(function(t) {
        return t.start !== e;
    }), Ma = Math.max(0, Ma - 1), Ma === 0 && (oc.prototype.open = lf);
}
var Pl = R({
    name: "QAjaxBar",
    props: {
        position: {
            type: String,
            default: "top",
            validator: function(e) {
                return G0.includes(e);
            }
        },
        size: {
            type: String,
            default: "2px"
        },
        color: String,
        skipHijack: Boolean,
        reverse: Boolean,
        hijackFilter: Function
    },
    emits: [
        "start",
        "stop"
    ],
    setup: function(e, param) {
        var t = param.emit;
        var _X0 = (0, $aD8ZA.getCurrentInstance)(), o = _X0.proxy, r = (0, $aAzpa.ref)(0), n = (0, $aAzpa.ref)(!1), i = (0, $aAzpa.ref)(!0), a = 0, l = null, s, c = (0, $aAzpa.computed)(function() {
            return "q-loading-bar q-loading-bar--".concat(e.position) + (e.color !== void 0 ? " bg-".concat(e.color) : "") + (i.value === !0 ? "" : " no-transition");
        }), u = (0, $aAzpa.computed)(function() {
            return e.position === "top" || e.position === "bottom";
        }), v = (0, $aAzpa.computed)(function() {
            return u.value === !0 ? "height" : "width";
        }), f = (0, $aAzpa.computed)(function() {
            var h = n.value, g = Z0({
                p: r.value,
                pos: e.position,
                active: h,
                horiz: u.value,
                reverse: o.$q.lang.rtl === !0 && [
                    "top",
                    "bottom"
                ].includes(e.position) ? e.reverse === !1 : e.reverse,
                dir: o.$q.lang.rtl === !0 ? -1 : 1
            });
            return g[v.value] = e.size, g.opacity = h ? 1 : 0, g;
        }), d = (0, $aAzpa.computed)(function() {
            return n.value === !0 ? {
                role: "progressbar",
                "aria-valuemin": 0,
                "aria-valuemax": 100,
                "aria-valuenow": r.value
            } : {
                "aria-hidden": "true"
            };
        });
        function m() {
            var h = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 300;
            var g = s;
            return s = Math.max(0, h) || 0, a++, a > 1 ? (g === 0 && h > 0 ? C() : l !== null && g > 0 && h <= 0 && (clearTimeout(l), l = null), a) : (l !== null && clearTimeout(l), t("start"), r.value = 0, l = setTimeout(function() {
                l = null, i.value = !0, h > 0 && C();
            }, n._value === !0 ? 500 : 1), n._value !== !0 && (n.value = !0, i.value = !1), a);
        }
        function y(h) {
            return a > 0 && (r.value = J0(r.value, h)), a;
        }
        function p() {
            if (a = Math.max(0, a - 1), a > 0) return a;
            l !== null && (clearTimeout(l), l = null), t("stop");
            var h = function() {
                i.value = !0, r.value = 100, l = setTimeout(function() {
                    l = null, n.value = !1;
                }, 1e3);
            };
            return r.value === 0 ? l = setTimeout(h, 1) : h(), a;
        }
        function C() {
            r.value < 100 && (l = setTimeout(function() {
                l = null, y(), C();
            }, s));
        }
        var b;
        return (0, $aD8ZA.onMounted)(function() {
            e.skipHijack !== !0 && (b = !0, eb({
                start: m,
                stop: p,
                hijackFilter: (0, $aAzpa.computed)(function() {
                    return e.hijackFilter || null;
                })
            }));
        }), (0, $aD8ZA.onBeforeUnmount)(function() {
            l !== null && clearTimeout(l), b === !0 && tb(m);
        }), Object.assign(o, {
            start: m,
            stop: p,
            increment: y
        }), function() {
            return (0, $aD8ZA.h)("div", (0, $8pZMQ._)({
                class: c.value,
                style: f.value
            }, d.value));
        };
    }
});
var Al = {
    xs: 18,
    sm: 24,
    md: 32,
    lg: 38,
    xl: 46
}, Ot = {
    size: String
};
function It(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Al;
    return (0, $aAzpa.computed)(function() {
        return e.size !== void 0 ? {
            fontSize: e.size in t ? "".concat(t[e.size], "px") : e.size
        } : null;
    });
}
function J(e, t) {
    return e !== void 0 && e() || t;
}
function tn(e, t) {
    if (e !== void 0) {
        var o = e();
        if (o != null) return o.slice();
    }
    return t;
}
function Ke(e, t) {
    return e !== void 0 ? t.concat(e()) : t;
}
function ai(e, t) {
    return e === void 0 ? t : t !== void 0 ? t.concat(e()) : e();
}
function kt(e, t, o, r, n, i) {
    t.key = r + n;
    var a = (0, $aD8ZA.h)(e, t, o);
    return n === !0 ? (0, $aD8ZA.withDirectives)(a, i()) : a;
}
var sf = "0 0 24 24", cf = function(e) {
    return e;
}, nc = function(e) {
    return "ionicons ".concat(e);
}, ff = {
    "mdi-": function(e) {
        return "mdi ".concat(e);
    },
    "icon-": cf,
    "bt-": function(e) {
        return "bt ".concat(e);
    },
    "eva-": function(e) {
        return "eva ".concat(e);
    },
    "ion-md": nc,
    "ion-ios": nc,
    "ion-logo": nc,
    "iconfont ": cf,
    "ti-": function(e) {
        return "themify-icon ".concat(e);
    },
    "bi-": function(e) {
        return "bootstrap-icons ".concat(e);
    }
}, mf = {
    o_: "-outlined",
    r_: "-round",
    s_: "-sharp"
}, vf = {
    sym_o_: "-outlined",
    sym_r_: "-rounded",
    sym_s_: "-sharp"
}, ab = new RegExp("^(" + Object.keys(ff).join("|") + ")"), lb = new RegExp("^(" + Object.keys(mf).join("|") + ")"), df = new RegExp("^(" + Object.keys(vf).join("|") + ")"), ub = /^[Mm]\s?[-+]?\.?\d/, sb = /^img:/, cb = /^svguse:/, db = /^ion-/, fb = /^(fa-(sharp|solid|regular|light|brands|duotone|thin)|[lf]a[srlbdk]?) /, we = R({
    name: "QIcon",
    props: (0, $8typN._)((0, $8pZMQ._)({}, Ot), {
        tag: {
            type: String,
            default: "i"
        },
        name: String,
        color: String,
        left: Boolean,
        right: Boolean
    }),
    setup: function(e, param) {
        var t = param.slots;
        var _ib = (0, $aD8ZA.getCurrentInstance)(), _ib_proxy = _ib.proxy, o = _ib_proxy.$q, r = It(e), n = (0, $aAzpa.computed)(function() {
            return "q-icon" + (e.left === !0 ? " on-left" : "") + (e.right === !0 ? " on-right" : "") + (e.color !== void 0 ? " text-".concat(e.color) : "");
        }), i = (0, $aAzpa.computed)(function() {
            var a, l = e.name;
            if (l === "none" || !l) return {
                none: !0
            };
            if (o.iconMapFn !== null) {
                var u = o.iconMapFn(l);
                if (u !== void 0) {
                    if (u.icon !== void 0) {
                        if (l = u.icon, l === "none" || !l) return {
                            none: !0
                        };
                    } else return {
                        cls: u.cls,
                        content: u.content !== void 0 ? u.content : " "
                    };
                }
            }
            if (ub.test(l) === !0) {
                var _l_split = (0, $4f96i._)(l.split("|"), 2), u1 = _l_split[0], tmp = _l_split[1], v = tmp === void 0 ? sf : tmp;
                return {
                    svg: !0,
                    viewBox: v,
                    nodes: u1.split("&&").map(function(f) {
                        var _f_split = (0, $4f96i._)(f.split("@@"), 3), d = _f_split[0], m = _f_split[1], y = _f_split[2];
                        return (0, $aD8ZA.h)("path", {
                            style: m,
                            d: d,
                            transform: y
                        });
                    })
                };
            }
            if (sb.test(l) === !0) return {
                img: !0,
                src: l.substring(4)
            };
            if (cb.test(l) === !0) {
                var _l_split1 = (0, $4f96i._)(l.split("|"), 2), u2 = _l_split1[0], tmp1 = _l_split1[1], v1 = tmp1 === void 0 ? sf : tmp1;
                return {
                    svguse: !0,
                    src: u2.substring(7),
                    viewBox: v1
                };
            }
            var s = " ", c = l.match(ab);
            if (c !== null) a = ff[c[1]](l);
            else if (fb.test(l) === !0) a = l;
            else if (db.test(l) === !0) a = "ionicons ion-".concat(o.platform.is.ios === !0 ? "ios" : "md").concat(l.substring(3));
            else if (df.test(l) === !0) {
                a = "notranslate material-symbols";
                var u3 = l.match(df);
                u3 !== null && (l = l.substring(6), a += vf[u3[1]]), s = l;
            } else {
                a = "notranslate material-icons";
                var u4 = l.match(lb);
                u4 !== null && (l = l.substring(2), a += mf[u4[1]]), s = l;
            }
            return {
                cls: a,
                content: s
            };
        });
        return function() {
            var a = {
                class: n.value,
                style: r.value,
                "aria-hidden": "true",
                role: "presentation"
            };
            return i.value.none === !0 ? (0, $aD8ZA.h)(e.tag, a, J(t.default)) : i.value.img === !0 ? (0, $aD8ZA.h)(e.tag, a, Ke(t.default, [
                (0, $aD8ZA.h)("img", {
                    src: i.value.src
                })
            ])) : i.value.svg === !0 ? (0, $aD8ZA.h)(e.tag, a, Ke(t.default, [
                (0, $aD8ZA.h)("svg", {
                    viewBox: i.value.viewBox || "0 0 24 24"
                }, i.value.nodes)
            ])) : i.value.svguse === !0 ? (0, $aD8ZA.h)(e.tag, a, Ke(t.default, [
                (0, $aD8ZA.h)("svg", {
                    viewBox: i.value.viewBox
                }, [
                    (0, $aD8ZA.h)("use", {
                        "xlink:href": i.value.src
                    })
                ])
            ])) : (i.value.cls !== void 0 && (a.class += " " + i.value.cls), (0, $aD8ZA.h)(e.tag, a, Ke(t.default, [
                i.value.content
            ])));
        };
    }
});
var $l = R({
    name: "QAvatar",
    props: (0, $8typN._)((0, $8pZMQ._)({}, Ot), {
        fontSize: String,
        color: String,
        textColor: String,
        icon: String,
        square: Boolean,
        rounded: Boolean
    }),
    setup: function(e, param) {
        var t = param.slots;
        var o = It(e), r = (0, $aAzpa.computed)(function() {
            return "q-avatar" + (e.color ? " bg-".concat(e.color) : "") + (e.textColor ? " text-".concat(e.textColor, " q-chip--colored") : "") + (e.square === !0 ? " q-avatar--square" : e.rounded === !0 ? " rounded-borders" : "");
        }), n = (0, $aAzpa.computed)(function() {
            return e.fontSize ? {
                fontSize: e.fontSize
            } : null;
        });
        return function() {
            var i = e.icon !== void 0 ? [
                (0, $aD8ZA.h)(we, {
                    name: e.icon
                })
            ] : void 0;
            return (0, $aD8ZA.h)("div", {
                class: r.value,
                style: o.value
            }, [
                (0, $aD8ZA.h)("div", {
                    class: "q-avatar__content row flex-center overflow-hidden",
                    style: n.value
                }, ai(t.default, i))
            ]);
        };
    }
});
var vb = [
    "top",
    "middle",
    "bottom"
], pf = R({
    name: "QBadge",
    props: {
        color: String,
        textColor: String,
        floating: Boolean,
        transparent: Boolean,
        multiLine: Boolean,
        outline: Boolean,
        rounded: Boolean,
        label: [
            Number,
            String
        ],
        align: {
            type: String,
            validator: function(e) {
                return vb.includes(e);
            }
        }
    },
    setup: function(e, param) {
        var t = param.slots;
        var o = (0, $aAzpa.computed)(function() {
            return e.align !== void 0 ? {
                verticalAlign: e.align
            } : null;
        }), r = (0, $aAzpa.computed)(function() {
            var n = e.outline === !0 && e.color || e.textColor;
            return "q-badge flex inline items-center no-wrap q-badge--".concat(e.multiLine === !0 ? "multi" : "single", "-line") + (e.outline === !0 ? " q-badge--outline" : e.color !== void 0 ? " bg-".concat(e.color) : "") + (n !== void 0 ? " text-".concat(n) : "") + (e.floating === !0 ? " q-badge--floating" : "") + (e.rounded === !0 ? " q-badge--rounded" : "") + (e.transparent === !0 ? " q-badge--transparent" : "");
        });
        return function() {
            return (0, $aD8ZA.h)("div", {
                class: r.value,
                style: o.value,
                role: "status",
                "aria-label": e.label
            }, Ke(t.default, e.label !== void 0 ? [
                e.label
            ] : []));
        };
    }
});
var he = {
    dark: {
        type: Boolean,
        default: null
    }
};
function pe(e, t) {
    return (0, $aAzpa.computed)(function() {
        return e.dark === null ? t.dark.isActive : e.dark;
    });
}
var yf = R({
    name: "QBanner",
    props: (0, $8typN._)((0, $8pZMQ._)({}, he), {
        inlineActions: Boolean,
        dense: Boolean,
        rounded: Boolean
    }),
    setup: function(e, param) {
        var t = param.slots;
        var _hb = (0, $aD8ZA.getCurrentInstance)(), _hb_proxy = _hb.proxy, o = _hb_proxy.$q, r = pe(e, o), n = (0, $aAzpa.computed)(function() {
            return "q-banner row items-center" + (e.dense === !0 ? " q-banner--dense" : "") + (r.value === !0 ? " q-banner--dark q-dark" : "") + (e.rounded === !0 ? " rounded-borders" : "");
        }), i = (0, $aAzpa.computed)(function() {
            return "q-banner__actions row items-center justify-end col-".concat(e.inlineActions === !0 ? "auto" : "all");
        });
        return function() {
            var a = [
                (0, $aD8ZA.h)("div", {
                    class: "q-banner__avatar col-auto row items-center self-start"
                }, J(t.avatar)),
                (0, $aD8ZA.h)("div", {
                    class: "q-banner__content col text-body2"
                }, J(t.default))
            ], l = J(t.action);
            return l !== void 0 && a.push((0, $aD8ZA.h)("div", {
                class: i.value
            }, l)), (0, $aD8ZA.h)("div", {
                class: n.value + (e.inlineActions === !1 && l !== void 0 ? " q-banner--top-padding" : ""),
                role: "alert"
            }, a);
        };
    }
});
var Sf = R({
    name: "QBar",
    props: (0, $8typN._)((0, $8pZMQ._)({}, he), {
        dense: Boolean
    }),
    setup: function(e, param) {
        var t = param.slots;
        var _yb = (0, $aD8ZA.getCurrentInstance)(), _yb_proxy = _yb.proxy, o = _yb_proxy.$q, r = pe(e, o), n = (0, $aAzpa.computed)(function() {
            return "q-bar row no-wrap items-center q-bar--".concat(e.dense === !0 ? "dense" : "standard", "  q-bar--").concat(r.value === !0 ? "dark" : "light");
        });
        return function() {
            return (0, $aD8ZA.h)("div", {
                class: n.value,
                role: "toolbar"
            }, J(t.default));
        };
    }
});
var xf = {
    left: "start",
    center: "center",
    right: "end",
    between: "between",
    around: "around",
    evenly: "evenly",
    stretch: "stretch"
}, xb = Object.keys(xf), li = {
    align: {
        type: String,
        validator: function(e) {
            return xb.includes(e);
        }
    }
};
function ui(e) {
    return (0, $aAzpa.computed)(function() {
        var t = e.align === void 0 ? e.vertical === !0 ? "stretch" : "left" : e.align;
        return "".concat(e.vertical === !0 ? "items" : "justify", "-").concat(xf[t]);
    });
}
function Ra(e) {
    if (Object(e.$parent) === e.$parent) return e.$parent;
    var _e_$ = e.$, t = _e_$.parent;
    for(; Object(t) === t;){
        if (Object(t.proxy) === t.proxy) return t.proxy;
        t = t.parent;
    }
}
function _f(e, t) {
    (0, $jzTO1._)(t.type) == "symbol" ? Array.isArray(t.children) === !0 && t.children.forEach(function(o) {
        _f(e, o);
    }) : e.add(t);
}
function si(e) {
    var t = new Set;
    return e.forEach(function(o) {
        _f(t, o);
    }), Array.from(t);
}
function ci(e) {
    return e.appContext.config.globalProperties.$router !== void 0;
}
function Jt(e) {
    return e.isUnmounted === !0 || e.isDeactivated === !0;
}
var _b = [
    "",
    !0
], Cf = R({
    name: "QBreadcrumbs",
    props: (0, $8typN._)((0, $8pZMQ._)({}, li), {
        separator: {
            type: String,
            default: "/"
        },
        separatorColor: String,
        activeColor: {
            type: String,
            default: "primary"
        },
        gutter: {
            type: String,
            validator: function(e) {
                return [
                    "none",
                    "xs",
                    "sm",
                    "md",
                    "lg",
                    "xl"
                ].includes(e);
            },
            default: "sm"
        }
    }),
    setup: function(e, param) {
        var t = param.slots;
        var o = ui(e), r = (0, $aAzpa.computed)(function() {
            return "flex items-center ".concat(o.value).concat(e.gutter === "none" ? "" : " q-gutter-".concat(e.gutter));
        }), n = (0, $aAzpa.computed)(function() {
            return e.separatorColor ? " text-".concat(e.separatorColor) : "";
        }), i = (0, $aAzpa.computed)(function() {
            return " text-".concat(e.activeColor);
        });
        return function() {
            if (t.default === void 0) return;
            var a = si(J(t.default));
            if (a.length === 0) return;
            var l = 1, s = [], c = a.filter(function(v) {
                return v.type !== void 0 && v.type.name === "QBreadcrumbsEl";
            }).length, u = t.separator !== void 0 ? t.separator : function() {
                return e.separator;
            };
            return a.forEach(function(v) {
                if (v.type !== void 0 && v.type.name === "QBreadcrumbsEl") {
                    var f = l < c, d = v.props !== null && _b.includes(v.props.disable), m = (f === !0 ? "" : " q-breadcrumbs--last") + (d !== !0 && f === !0 ? i.value : "");
                    l++, s.push((0, $aD8ZA.h)("div", {
                        class: "flex items-center".concat(m)
                    }, [
                        v
                    ])), f === !0 && s.push((0, $aD8ZA.h)("div", {
                        class: "q-breadcrumbs__separator" + n.value
                    }, u()));
                } else s.push(v);
            }), (0, $aD8ZA.h)("div", {
                class: "q-breadcrumbs"
            }, [
                (0, $aD8ZA.h)("div", {
                    class: r.value
                }, s)
            ]);
        };
    }
});
function wf(e) {
    return e ? e.aliasOf ? e.aliasOf.path : e.path : "";
}
function kf(e, t) {
    return (e.aliasOf || e) === (t.aliasOf || t);
}
function wb(e, t) {
    var _loop = function(o) {
        var r = t[o], n = e[o];
        if (typeof r == "string") {
            if (r !== n) return {
                v: !1
            };
        } else if (Array.isArray(n) === !1 || n.length !== r.length || r.some(function(i, a) {
            return i !== n[a];
        })) return {
            v: !1
        };
    };
    for(var o in t){
        var _ret = _loop(o);
        if ((0, $jzTO1._)(_ret) === "object") return _ret.v;
    }
    return !0;
}
function qf(e, t) {
    return Array.isArray(t) === !0 ? e.length === t.length && e.every(function(o, r) {
        return o === t[r];
    }) : e.length === 1 && e[0] === t;
}
function kb(e, t) {
    return Array.isArray(e) === !0 ? qf(e, t) : Array.isArray(t) === !0 ? qf(t, e) : e === t;
}
function qb(e, t) {
    if (Object.keys(e).length !== Object.keys(t).length) return !1;
    for(var o in e)if (kb(e[o], t[o]) === !1) return !1;
    return !0;
}
var zo = {
    to: [
        String,
        Object
    ],
    replace: Boolean,
    exact: Boolean,
    activeClass: {
        type: String,
        default: "q-router-link--active"
    },
    exactActiveClass: {
        type: String,
        default: "q-router-link--exact-active"
    },
    href: String,
    target: String,
    disable: Boolean
};
function Yn() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, e = _ref.fallbackTag, tmp = _ref.useDisableForRouterLinkProps, t = tmp === void 0 ? !0 : tmp;
    var o = (0, $aD8ZA.getCurrentInstance)(), r = o.props, n = o.proxy, i = o.emit, a = ci(o), l = (0, $aAzpa.computed)(function() {
        return r.disable !== !0 && r.href !== void 0;
    }), s = t === !0 ? (0, $aAzpa.computed)(function() {
        return a === !0 && r.disable !== !0 && l.value !== !0 && r.to !== void 0 && r.to !== null && r.to !== "";
    }) : (0, $aAzpa.computed)(function() {
        return a === !0 && l.value !== !0 && r.to !== void 0 && r.to !== null && r.to !== "";
    }), c = (0, $aAzpa.computed)(function() {
        return s.value === !0 ? b(r.to) : null;
    }), u = (0, $aAzpa.computed)(function() {
        return c.value !== null;
    }), v = (0, $aAzpa.computed)(function() {
        return l.value === !0 || u.value === !0;
    }), f = (0, $aAzpa.computed)(function() {
        return r.type === "a" || v.value === !0 ? "a" : r.tag || e || "div";
    }), d = (0, $aAzpa.computed)(function() {
        return l.value === !0 ? {
            href: r.href,
            target: r.target
        } : u.value === !0 ? {
            href: c.value.href,
            target: r.target
        } : {};
    }), m = (0, $aAzpa.computed)(function() {
        if (u.value === !1) return -1;
        var _c_value = c.value, S = _c_value.matched, P = S.length, $ = S[P - 1];
        if ($ === void 0) return -1;
        var L = n.$route.matched;
        if (L.length === 0) return -1;
        var E = L.findIndex(kf.bind(null, $));
        if (E !== -1) return E;
        var A = wf(S[P - 2]);
        return P > 1 && wf($) === A && L[L.length - 1].path !== A ? L.findIndex(kf.bind(null, S[P - 2])) : E;
    }), y = (0, $aAzpa.computed)(function() {
        return u.value === !0 && m.value !== -1 && wb(n.$route.params, c.value.params);
    }), p = (0, $aAzpa.computed)(function() {
        return y.value === !0 && m.value === n.$route.matched.length - 1 && qb(n.$route.params, c.value.params);
    }), C = (0, $aAzpa.computed)(function() {
        return u.value === !0 ? p.value === !0 ? " ".concat(r.exactActiveClass, " ").concat(r.activeClass) : r.exact === !0 ? "" : y.value === !0 ? " ".concat(r.activeClass) : "" : "";
    });
    function b(S) {
        try {
            return n.$router.resolve(S);
        } catch (e) {}
        return null;
    }
    function h(S) {
        var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, P = _ref.returnRouterError, tmp = _ref.to, $ = tmp === void 0 ? r.to : tmp, tmp1 = _ref.replace, L = tmp1 === void 0 ? r.replace : tmp1;
        if (r.disable === !0) return S.preventDefault(), Promise.resolve(!1);
        if (S.metaKey || S.altKey || S.ctrlKey || S.shiftKey || S.button !== void 0 && S.button !== 0 || r.target === "_blank") return Promise.resolve(!1);
        S.preventDefault();
        var E = n.$router[L === !0 ? "replace" : "push"]($);
        return P === !0 ? E : E.then(function() {}).catch(function() {});
    }
    function g(S) {
        if (u.value === !0) {
            var P = function($) {
                return h(S, $);
            };
            i("click", S, P), S.defaultPrevented !== !0 && P();
        } else i("click", S);
    }
    return {
        hasRouterLink: u,
        hasHrefLink: l,
        hasLink: v,
        linkTag: f,
        resolvedLink: c,
        linkIsActive: y,
        linkIsExactActive: p,
        linkClass: C,
        linkAttrs: d,
        getLink: b,
        navigateToRouterLink: h,
        navigateOnClick: g
    };
}
var Rf = R({
    name: "QBreadcrumbsEl",
    props: (0, $8typN._)((0, $8pZMQ._)({}, zo), {
        label: String,
        icon: String,
        tag: {
            type: String,
            default: "span"
        }
    }),
    emits: [
        "click"
    ],
    setup: function(e, param) {
        var t = param.slots;
        var _Yn = Yn(), o = _Yn.linkTag, r = _Yn.linkAttrs, n = _Yn.linkClass, i = _Yn.navigateOnClick, a = (0, $aAzpa.computed)(function() {
            return (0, $8typN._)((0, $8pZMQ._)({
                class: "q-breadcrumbs__el q-link flex inline items-center relative-position " + (e.disable !== !0 ? "q-link--focusable" + n.value : "q-breadcrumbs__el--disable")
            }, r.value), {
                onClick: i
            });
        }), l = (0, $aAzpa.computed)(function() {
            return "q-breadcrumbs__el-icon" + (e.label !== void 0 ? " q-breadcrumbs__el-icon--with-label" : "");
        });
        return function() {
            var s = [];
            return e.icon !== void 0 && s.push((0, $aD8ZA.h)(we, {
                class: l.value,
                name: e.icon
            })), e.label !== void 0 && s.push(e.label), (0, $aD8ZA.h)(o.value, (0, $8pZMQ._)({}, a.value), Ke(t.default, s));
        };
    }
});
var Oe = {
    size: {
        type: [
            Number,
            String
        ],
        default: "1em"
    },
    color: String
};
function Ve(e) {
    return {
        cSize: (0, $aAzpa.computed)(function() {
            return e.size in Al ? "".concat(Al[e.size], "px") : e.size;
        }),
        classes: (0, $aAzpa.computed)(function() {
            return "q-spinner" + (e.color ? " text-".concat(e.color) : "");
        })
    };
}
var xt = R({
    name: "QSpinner",
    props: (0, $8typN._)((0, $8pZMQ._)({}, Oe), {
        thickness: {
            type: Number,
            default: 5
        }
    }),
    setup: function(e) {
        var _Ve = Ve(e), t = _Ve.cSize, o = _Ve.classes;
        return function() {
            return (0, $aD8ZA.h)("svg", {
                class: o.value + " q-spinner-mat",
                width: t.value,
                height: t.value,
                viewBox: "25 25 50 50"
            }, [
                (0, $aD8ZA.h)("circle", {
                    class: "path",
                    cx: "50",
                    cy: "50",
                    r: "20",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": e.thickness,
                    "stroke-miterlimit": "10"
                })
            ]);
        };
    }
});
function Tr(e) {
    if (e === window) return {
        top: 0,
        left: 0
    };
    var _e_getBoundingClientRect = e.getBoundingClientRect(), t = _e_getBoundingClientRect.top, o = _e_getBoundingClientRect.left;
    return {
        top: t,
        left: o
    };
}
function Mb(e, t) {
    return window.getComputedStyle(e).getPropertyValue(t);
}
function nn(e) {
    return e === window ? window.innerHeight : e.getBoundingClientRect().height;
}
function Rb(e) {
    return e === window ? window.innerWidth : e.getBoundingClientRect().width;
}
function Mr(e, t) {
    var o = e.style;
    for(var r in t)o[r] = t[r];
}
function Pb(e, t) {
    e.forEach(function(o) {
        return Mr(o, t);
    });
}
function Ab(e) {
    if (typeof e == "function") {
        if (document.readyState !== "loading") return e();
        document.addEventListener("DOMContentLoaded", e, !1);
    }
}
function $f(e) {
    if (e == null) return;
    if (typeof e == "string") try {
        return document.querySelector(e) || void 0;
    } catch (e) {
        return;
    }
    var t = (0, $aAzpa.unref)(e);
    if (t) return t.$el || t;
}
function Ll(e, t) {
    if (e == null || e.contains(t) === !0) return !0;
    for(var o = e.nextElementSibling; o !== null; o = o.nextElementSibling)if (o.contains(t)) return !0;
    return !1;
}
var $b = {
    offset: Tr,
    style: Mb,
    height: nn,
    width: Rb,
    css: Mr,
    cssBatch: Pb,
    ready: Ab
};
function Pa(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 250;
    var o = !1, r;
    return function() {
        return o === !1 && (o = !0, setTimeout(function() {
            o = !1;
        }, t), r = e.apply(this, arguments)), r;
    };
}
function Ef(e, t, o, r) {
    o.modifiers.stop === !0 && tt(e);
    var n = o.modifiers.color, i = o.modifiers.center;
    i = i === !0 || r === !0;
    var a = document.createElement("span"), l = document.createElement("span"), s = yt(e), _t_getBoundingClientRect = t.getBoundingClientRect(), c = _t_getBoundingClientRect.left, u = _t_getBoundingClientRect.top, v = _t_getBoundingClientRect.width, f = _t_getBoundingClientRect.height, d = Math.sqrt(v * v + f * f), m = d / 2, y = "".concat((v - d) / 2, "px"), p = i ? y : "".concat(s.left - c - m, "px"), C = "".concat((f - d) / 2, "px"), b = i ? C : "".concat(s.top - u - m, "px");
    l.className = "q-ripple__inner", Mr(l, {
        height: "".concat(d, "px"),
        width: "".concat(d, "px"),
        transform: "translate3d(".concat(p, ",").concat(b, ",0) scale3d(.2,.2,1)"),
        opacity: 0
    }), a.className = "q-ripple".concat(n ? " text-" + n : ""), a.setAttribute("dir", "ltr"), a.appendChild(l), t.appendChild(a);
    var h = function() {
        a.remove(), clearTimeout(g);
    };
    o.abort.push(h);
    var g = setTimeout(function() {
        l.classList.add("q-ripple__inner--enter"), l.style.transform = "translate3d(".concat(y, ",").concat(C, ",0) scale3d(1,1,1)"), l.style.opacity = .2, g = setTimeout(function() {
            l.classList.remove("q-ripple__inner--enter"), l.classList.add("q-ripple__inner--leave"), l.style.opacity = 0, g = setTimeout(function() {
                a.remove(), o.abort.splice(o.abort.indexOf(h), 1);
            }, 275);
        }, 250);
    }, 50);
}
function Bf(e, param) {
    var t = param.modifiers, o = param.value, r = param.arg;
    var n = Object.assign({}, e.cfg.ripple, t, o);
    e.modifiers = {
        early: n.early === !0,
        stop: n.stop === !0,
        center: n.center === !0,
        color: n.color || r,
        keyCodes: [].concat(n.keyCodes || 13)
    };
}
var rn = Mt({
    name: "ripple",
    beforeMount: function(e, t) {
        var o = t.instance.$.appContext.config.globalProperties.$q.config || {};
        if (o.ripple === !1) return;
        var r = {
            cfg: o,
            enabled: t.value !== !1,
            modifiers: {},
            abort: [],
            start: function(n) {
                r.enabled === !0 && n.qSkipRipple !== !0 && n.type === (r.modifiers.early === !0 ? "pointerdown" : "click") && Ef(n, e, r, n.qKeyEvent === !0);
            },
            keystart: Pa(function(n) {
                r.enabled === !0 && n.qSkipRipple !== !0 && wt(n, r.modifiers.keyCodes) === !0 && n.type === "key".concat(r.modifiers.early === !0 ? "down" : "up") && Ef(n, e, r, !0);
            }, 300)
        };
        Bf(r, t), e.__qripple = r, lt(r, "main", [
            [
                e,
                "pointerdown",
                "start",
                "passive"
            ],
            [
                e,
                "click",
                "start",
                "passive"
            ],
            [
                e,
                "keydown",
                "keystart",
                "passive"
            ],
            [
                e,
                "keyup",
                "keystart",
                "passive"
            ]
        ]);
    },
    updated: function(e, t) {
        if (t.oldValue !== t.value) {
            var o = e.__qripple;
            o !== void 0 && (o.enabled = t.value !== !1, o.enabled === !0 && Object(t.value) === t.value && Bf(o, t));
        }
    },
    beforeUnmount: function(e) {
        var t = e.__qripple;
        t !== void 0 && (t.abort.forEach(function(o) {
            o();
        }), Ct(t, "main"), delete e._qripple);
    }
});
var Aa = {
    none: 0,
    xs: 4,
    sm: 8,
    md: 16,
    lg: 24,
    xl: 32
}, Eb = {
    xs: 8,
    sm: 10,
    md: 14,
    lg: 20,
    xl: 24
}, Bb = [
    "button",
    "submit",
    "reset"
], Lb = /[^\s]\/[^\s]/, ac = [
    "flat",
    "outline",
    "push",
    "unelevated"
];
function Fl(e, t) {
    return e.flat === !0 ? "flat" : e.outline === !0 ? "outline" : e.push === !0 ? "push" : e.unelevated === !0 ? "unelevated" : t;
}
function Dl(e) {
    var t = Fl(e);
    return t !== void 0 ? {
        [t]: !0
    } : {};
}
var $a = (0, $8typN._)((0, $8pZMQ._)((0, $8typN._)((0, $8pZMQ._)({}, Ot, zo), {
    type: {
        type: String,
        default: "button"
    },
    label: [
        Number,
        String
    ],
    icon: String,
    iconRight: String
}), ac.reduce(function(e, t) {
    return (e[t] = Boolean) && e;
}, {})), {
    square: Boolean,
    round: Boolean,
    rounded: Boolean,
    glossy: Boolean,
    size: String,
    fab: Boolean,
    fabMini: Boolean,
    padding: String,
    color: String,
    textColor: String,
    noCaps: Boolean,
    noWrap: Boolean,
    dense: Boolean,
    tabindex: [
        Number,
        String
    ],
    ripple: {
        type: [
            Boolean,
            Object
        ],
        default: !0
    },
    align: (0, $8typN._)((0, $8pZMQ._)({}, li.align), {
        default: "center"
    }),
    stack: Boolean,
    stretch: Boolean,
    loading: {
        type: Boolean,
        default: null
    },
    disable: Boolean
});
function Lf(e) {
    var t = It(e, Eb), o = ui(e), _Yn = Yn({
        fallbackTag: "button"
    }), r = _Yn.hasRouterLink, n = _Yn.hasLink, i = _Yn.linkTag, a = _Yn.linkAttrs, l = _Yn.navigateOnClick, s = (0, $aAzpa.computed)(function() {
        var p = e.fab === !1 && e.fabMini === !1 ? t.value : {};
        return e.padding !== void 0 ? Object.assign({}, p, {
            padding: e.padding.split(/\s+/).map(function(C) {
                return C in Aa ? Aa[C] + "px" : C;
            }).join(" "),
            minWidth: "0",
            minHeight: "0"
        }) : p;
    }), c = (0, $aAzpa.computed)(function() {
        return e.rounded === !0 || e.fab === !0 || e.fabMini === !0;
    }), u = (0, $aAzpa.computed)(function() {
        return e.disable !== !0 && e.loading !== !0;
    }), v = (0, $aAzpa.computed)(function() {
        return u.value === !0 ? e.tabindex || 0 : -1;
    }), f = (0, $aAzpa.computed)(function() {
        return Fl(e, "standard");
    }), d = (0, $aAzpa.computed)(function() {
        var p = {
            tabindex: v.value
        };
        return n.value === !0 ? Object.assign(p, a.value) : Bb.includes(e.type) === !0 && (p.type = e.type), i.value === "a" ? (e.disable === !0 ? p["aria-disabled"] = "true" : p.href === void 0 && (p.role = "button"), r.value !== !0 && Lb.test(e.type) === !0 && (p.type = e.type)) : e.disable === !0 && (p.disabled = "", p["aria-disabled"] = "true"), e.loading === !0 && e.percentage !== void 0 && Object.assign(p, {
            role: "progressbar",
            "aria-valuemin": 0,
            "aria-valuemax": 100,
            "aria-valuenow": e.percentage
        }), p;
    }), m = (0, $aAzpa.computed)(function() {
        var p;
        e.color !== void 0 ? e.flat === !0 || e.outline === !0 ? p = "text-".concat(e.textColor || e.color) : p = "bg-".concat(e.color, " text-").concat(e.textColor || "white") : e.textColor && (p = "text-".concat(e.textColor));
        var C = e.round === !0 ? "round" : "rectangle".concat(c.value === !0 ? " q-btn--rounded" : e.square === !0 ? " q-btn--square" : "");
        return "q-btn--".concat(f.value, " q-btn--").concat(C) + (p !== void 0 ? " " + p : "") + (u.value === !0 ? " q-btn--actionable q-focusable q-hoverable" : e.disable === !0 ? " disabled" : "") + (e.fab === !0 ? " q-btn--fab" : e.fabMini === !0 ? " q-btn--fab-mini" : "") + (e.noCaps === !0 ? " q-btn--no-uppercase" : "") + (e.dense === !0 ? " q-btn--dense" : "") + (e.stretch === !0 ? " no-border-radius self-stretch" : "") + (e.glossy === !0 ? " glossy" : "") + (e.square ? " q-btn--square" : "");
    }), y = (0, $aAzpa.computed)(function() {
        return o.value + (e.stack === !0 ? " column" : " row") + (e.noWrap === !0 ? " no-wrap text-no-wrap" : "") + (e.loading === !0 ? " q-btn__content--hidden" : "");
    });
    return {
        classes: m,
        style: s,
        innerClasses: y,
        attributes: d,
        hasLink: n,
        linkTag: i,
        navigateOnClick: l,
        isActionable: u
    };
}
var Po = Xe.passiveCapture, fi = null, mi = null, vi = null, Le = R({
    name: "QBtn",
    props: (0, $8typN._)((0, $8pZMQ._)({}, $a), {
        percentage: Number,
        darkPercentage: Boolean,
        onTouchstart: [
            Function,
            Array
        ]
    }),
    emits: [
        "click",
        "keydown",
        "mousedown",
        "keyup"
    ],
    setup: function(e, param) {
        var t = param.slots, o = param.emit;
        var _zb = (0, $aD8ZA.getCurrentInstance)(), r = _zb.proxy, _Lf = Lf(e), n = _Lf.classes, i = _Lf.style, a = _Lf.innerClasses, l = _Lf.attributes, s = _Lf.hasLink, c = _Lf.linkTag, u = _Lf.navigateOnClick, v = _Lf.isActionable, f = (0, $aAzpa.ref)(null), d = (0, $aAzpa.ref)(null), m = null, y, p = null, C = (0, $aAzpa.computed)(function() {
            return e.label !== void 0 && e.label !== null && e.label !== "";
        }), b = (0, $aAzpa.computed)(function() {
            return e.disable === !0 || e.ripple === !1 ? !1 : (0, $8pZMQ._)({
                keyCodes: s.value === !0 ? [
                    13,
                    32
                ] : [
                    13
                ]
            }, e.ripple === !0 ? {} : e.ripple);
        }), h = (0, $aAzpa.computed)(function() {
            return {
                center: e.round
            };
        }), g = (0, $aAzpa.computed)(function() {
            var k = Math.max(0, Math.min(100, e.percentage));
            return k > 0 ? {
                transition: "transform 0.6s",
                transform: "translateX(".concat(k - 100, "%)")
            } : {};
        }), S = (0, $aAzpa.computed)(function() {
            if (e.loading === !0) return {
                onMousedown: x,
                onTouchstart: x,
                onClick: x,
                onKeydown: x,
                onKeyup: x
            };
            if (v.value === !0) {
                var k = {
                    onClick: $,
                    onKeydown: L,
                    onMousedown: A
                };
                if (r.$q.platform.has.touch === !0) {
                    var j = e.onTouchstart !== void 0 ? "" : "Passive";
                    k["onTouchstart".concat(j)] = E;
                }
                return k;
            }
            return {
                onClick: Se
            };
        }), P = (0, $aAzpa.computed)(function() {
            return (0, $8pZMQ._)({
                ref: f,
                class: "q-btn q-btn-item non-selectable no-outline " + n.value,
                style: i.value
            }, l.value, S.value);
        });
        function $(k) {
            if (f.value !== null) {
                if (k !== void 0) {
                    if (k.defaultPrevented === !0) return;
                    var j = document.activeElement;
                    if (e.type === "submit" && j !== document.body && f.value.contains(j) === !1 && j.contains(f.value) === !1) {
                        f.value.focus();
                        var Q = function() {
                            document.removeEventListener("keydown", Se, !0), document.removeEventListener("keyup", Q, Po), f.value !== null && f.value.removeEventListener("blur", Q, Po);
                        };
                        document.addEventListener("keydown", Se, !0), document.addEventListener("keyup", Q, Po), f.value.addEventListener("blur", Q, Po);
                    }
                }
                u(k);
            }
        }
        function L(k) {
            f.value !== null && (o("keydown", k), wt(k, [
                13,
                32
            ]) === !0 && mi !== f.value && (mi !== null && q(), k.defaultPrevented !== !0 && (f.value.focus(), mi = f.value, f.value.classList.add("q-btn--active"), document.addEventListener("keyup", B, !0), f.value.addEventListener("blur", B, Po)), Se(k)));
        }
        function E(k) {
            f.value !== null && (o("touchstart", k), k.defaultPrevented !== !0 && (fi !== f.value && (fi !== null && q(), fi = f.value, m = k.target, m.addEventListener("touchcancel", B, Po), m.addEventListener("touchend", B, Po)), y = !0, p !== null && clearTimeout(p), p = setTimeout(function() {
                p = null, y = !1;
            }, 200)));
        }
        function A(k) {
            f.value !== null && (k.qSkipRipple = y === !0, o("mousedown", k), k.defaultPrevented !== !0 && vi !== f.value && (vi !== null && q(), vi = f.value, f.value.classList.add("q-btn--active"), document.addEventListener("mouseup", B, Po)));
        }
        function B(k) {
            if (f.value !== null && !(k !== void 0 && k.type === "blur" && document.activeElement === f.value)) {
                if (k !== void 0 && k.type === "keyup") {
                    if (mi === f.value && wt(k, [
                        13,
                        32
                    ]) === !0) {
                        var j = new MouseEvent("click", k);
                        j.qKeyEvent = !0, k.defaultPrevented === !0 && ut(j), k.cancelBubble === !0 && tt(j), f.value.dispatchEvent(j), Se(k), k.qKeyEvent = !0;
                    }
                    o("keyup", k);
                }
                q();
            }
        }
        function q(k) {
            var j = d.value;
            k !== !0 && (fi === f.value || vi === f.value) && j !== null && j !== document.activeElement && (j.setAttribute("tabindex", -1), j.focus()), fi === f.value && (m !== null && (m.removeEventListener("touchcancel", B, Po), m.removeEventListener("touchend", B, Po)), fi = m = null), vi === f.value && (document.removeEventListener("mouseup", B, Po), vi = null), mi === f.value && (document.removeEventListener("keyup", B, !0), f.value !== null && f.value.removeEventListener("blur", B, Po), mi = null), f.value !== null && f.value.classList.remove("q-btn--active");
        }
        function x(k) {
            Se(k), k.qSkipRipple = !0;
        }
        return (0, $aD8ZA.onBeforeUnmount)(function() {
            q(!0);
        }), Object.assign(r, {
            click: function(k) {
                v.value === !0 && $(k);
            }
        }), function() {
            var k = [];
            e.icon !== void 0 && k.push((0, $aD8ZA.h)(we, {
                name: e.icon,
                left: e.stack !== !0 && C.value === !0,
                role: "img",
                "aria-hidden": "true"
            })), C.value === !0 && k.push((0, $aD8ZA.h)("span", {
                class: "block"
            }, [
                e.label
            ])), k = Ke(t.default, k), e.iconRight !== void 0 && e.round === !1 && k.push((0, $aD8ZA.h)(we, {
                name: e.iconRight,
                right: e.stack !== !0 && C.value === !0,
                role: "img",
                "aria-hidden": "true"
            }));
            var j = [
                (0, $aD8ZA.h)("span", {
                    class: "q-focus-helper",
                    ref: d
                })
            ];
            return e.loading === !0 && e.percentage !== void 0 && j.push((0, $aD8ZA.h)("span", {
                class: "q-btn__progress absolute-full overflow-hidden" + (e.darkPercentage === !0 ? " q-btn__progress--dark" : "")
            }, [
                (0, $aD8ZA.h)("span", {
                    class: "q-btn__progress-indicator fit block",
                    style: g.value
                })
            ])), j.push((0, $aD8ZA.h)("span", {
                class: "q-btn__content text-center col items-center q-anchor--skip " + a.value
            }, k)), e.loading !== null && j.push((0, $aD8ZA.h)((0, $iMtOP.Transition), {
                name: "q-transition--fade"
            }, function() {
                return e.loading === !0 ? [
                    (0, $aD8ZA.h)("span", {
                        key: "loading",
                        class: "absolute-full flex flex-center"
                    }, t.loading !== void 0 ? t.loading() : [
                        (0, $aD8ZA.h)(xt)
                    ])
                ] : null;
            })), (0, $aD8ZA.withDirectives)((0, $aD8ZA.h)(c.value, P.value, j), [
                [
                    rn,
                    b.value,
                    void 0,
                    h.value
                ]
            ]);
        };
    }
});
var gi = R({
    name: "QBtnGroup",
    props: {
        unelevated: Boolean,
        outline: Boolean,
        flat: Boolean,
        rounded: Boolean,
        square: Boolean,
        push: Boolean,
        stretch: Boolean,
        glossy: Boolean,
        spread: Boolean
    },
    setup: function(e, param) {
        var t = param.slots;
        var o = (0, $aAzpa.computed)(function() {
            var r = [
                "unelevated",
                "outline",
                "flat",
                "rounded",
                "square",
                "push",
                "stretch",
                "glossy"
            ].filter(function(n) {
                return e[n] === !0;
            }).map(function(n) {
                return "q-btn-group--".concat(n);
            }).join(" ");
            return "q-btn-group row no-wrap".concat(r.length !== 0 ? " " + r : "") + (e.spread === !0 ? " q-btn-group--spread" : " inline");
        });
        return function() {
            return (0, $aD8ZA.h)("div", {
                class: o.value
            }, J(t.default));
        };
    }
});
function Ut() {
    if (window.getSelection !== void 0) {
        var e = window.getSelection();
        e.empty !== void 0 ? e.empty() : e.removeAllRanges !== void 0 && (e.removeAllRanges(), qn.is.mobile !== !0 && e.addRange(document.createRange()));
    } else document.selection !== void 0 && document.selection.empty();
}
var hi = {
    target: {
        default: !0
    },
    noParentEvent: Boolean,
    contextMenu: Boolean
};
function pi(param) {
    var e = param.showing, t = param.avoidEmit, o = param.configureAnchorEl;
    var _Ub = (0, $aD8ZA.getCurrentInstance)(), r = _Ub.props, n = _Ub.proxy, i = _Ub.emit, a = (0, $aAzpa.ref)(null), l = null;
    function s(d) {
        return a.value === null ? !1 : d === void 0 || d.touches === void 0 || d.touches.length <= 1;
    }
    var c = {};
    o === void 0 && (Object.assign(c, {
        hide: function(d) {
            n.hide(d);
        },
        toggle: function(d) {
            n.toggle(d), d.qAnchorHandled = !0;
        },
        toggleKey: function(d) {
            wt(d, 13) === !0 && c.toggle(d);
        },
        contextClick: function(d) {
            n.hide(d), ut(d), (0, $aD8ZA.nextTick)(function() {
                n.show(d), d.qAnchorHandled = !0;
            });
        },
        prevent: ut,
        mobileTouch: function(d) {
            if (c.mobileCleanup(d), s(d) !== !0) return;
            n.hide(d), a.value.classList.add("non-selectable");
            var m = d.target;
            lt(c, "anchor", [
                [
                    m,
                    "touchmove",
                    "mobileCleanup",
                    "passive"
                ],
                [
                    m,
                    "touchend",
                    "mobileCleanup",
                    "passive"
                ],
                [
                    m,
                    "touchcancel",
                    "mobileCleanup",
                    "passive"
                ],
                [
                    a.value,
                    "contextmenu",
                    "prevent",
                    "notPassive"
                ]
            ]), l = setTimeout(function() {
                l = null, n.show(d), d.qAnchorHandled = !0;
            }, 300);
        },
        mobileCleanup: function(d) {
            a.value.classList.remove("non-selectable"), l !== null && (clearTimeout(l), l = null), e.value === !0 && d !== void 0 && Ut();
        }
    }), o = function o() {
        var d = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : r.contextMenu;
        if (r.noParentEvent === !0 || a.value === null) return;
        var m;
        d === !0 ? n.$q.platform.is.mobile === !0 ? m = [
            [
                a.value,
                "touchstart",
                "mobileTouch",
                "passive"
            ]
        ] : m = [
            [
                a.value,
                "mousedown",
                "hide",
                "passive"
            ],
            [
                a.value,
                "contextmenu",
                "contextClick",
                "notPassive"
            ]
        ] : m = [
            [
                a.value,
                "click",
                "toggle",
                "passive"
            ],
            [
                a.value,
                "keyup",
                "toggleKey",
                "passive"
            ]
        ], lt(c, "anchor", m);
    });
    function u() {
        Ct(c, "anchor");
    }
    function v(d) {
        for(a.value = d; a.value.classList.contains("q-anchor--skip");)a.value = a.value.parentNode;
        o();
    }
    function f() {
        if (r.target === !1 || r.target === "" || n.$el.parentNode === null) a.value = null;
        else if (r.target === !0) v(n.$el.parentNode);
        else {
            var d = r.target;
            if (typeof r.target == "string") try {
                d = document.querySelector(r.target);
            } catch (e) {
                d = void 0;
            }
            d != null ? (a.value = d.$el || d, o()) : (a.value = null, console.error('Anchor: target "'.concat(r.target, '" not found')));
        }
    }
    return (0, $aD8ZA.watch)(function() {
        return r.contextMenu;
    }, function(d) {
        a.value !== null && (u(), o(d));
    }), (0, $aD8ZA.watch)(function() {
        return r.target;
    }, function() {
        a.value !== null && u(), f();
    }), (0, $aD8ZA.watch)(function() {
        return r.noParentEvent;
    }, function(d) {
        a.value !== null && (d === !0 ? u() : o());
    }), (0, $aD8ZA.onMounted)(function() {
        f(), t !== !0 && r.modelValue === !0 && a.value === null && i("update:modelValue", !1);
    }), (0, $aD8ZA.onBeforeUnmount)(function() {
        l !== null && clearTimeout(l), u();
    }), {
        anchorEl: a,
        canShow: s,
        anchorEvents: c
    };
}
function Vl(e, t) {
    var o = (0, $aAzpa.ref)(null), r;
    function n(l, s) {
        var c = "".concat(s !== void 0 ? "add" : "remove", "EventListener"), u = s !== void 0 ? s : r;
        l !== window && l[c]("scroll", u, Xe.passive), window[c]("scroll", u, Xe.passive), r = s;
    }
    function i() {
        o.value !== null && (n(o.value), o.value = null);
    }
    var a = (0, $aD8ZA.watch)(function() {
        return e.noParentEvent;
    }, function() {
        o.value !== null && (i(), t());
    });
    return (0, $aD8ZA.onBeforeUnmount)(a), {
        localScrollTarget: o,
        unconfigureScrollTarget: i,
        changeScrollEvent: n
    };
}
var Ao = {
    modelValue: {
        type: Boolean,
        default: null
    },
    "onUpdate:modelValue": [
        Function,
        Array
    ]
}, $o = [
    "beforeShow",
    "show",
    "beforeHide",
    "hide"
];
function Eo(param) {
    var e = param.showing, t = param.canShow, o = param.hideOnRouteChange, r = param.handleShow, n = param.handleHide, i = param.processOnMount;
    var a = (0, $aD8ZA.getCurrentInstance)(), l = a.props, s = a.emit, c = a.proxy, u;
    function v(b) {
        e.value === !0 ? m(b) : f(b);
    }
    function f(b) {
        if (l.disable === !0 || b !== void 0 && b.qAnchorHandled === !0 || t !== void 0 && t(b) !== !0) return;
        var h = l["onUpdate:modelValue"] !== void 0;
        h === !0 && (s("update:modelValue", !0), u = b, (0, $aD8ZA.nextTick)(function() {
            u === b && (u = void 0);
        })), (l.modelValue === null || h === !1) && d(b);
    }
    function d(b) {
        e.value !== !0 && (e.value = !0, s("beforeShow", b), r !== void 0 ? r(b) : s("show", b));
    }
    function m(b) {
        if (l.disable === !0) return;
        var h = l["onUpdate:modelValue"] !== void 0;
        h === !0 && (s("update:modelValue", !1), u = b, (0, $aD8ZA.nextTick)(function() {
            u === b && (u = void 0);
        })), (l.modelValue === null || h === !1) && y(b);
    }
    function y(b) {
        e.value !== !1 && (e.value = !1, s("beforeHide", b), n !== void 0 ? n(b) : s("hide", b));
    }
    function p(b) {
        l.disable === !0 && b === !0 ? l["onUpdate:modelValue"] !== void 0 && s("update:modelValue", !1) : b === !0 !== e.value && (b === !0 ? d : y)(u);
    }
    (0, $aD8ZA.watch)(function() {
        return l.modelValue;
    }, p), o !== void 0 && ci(a) === !0 && (0, $aD8ZA.watch)(function() {
        return c.$route.fullPath;
    }, function() {
        o.value === !0 && e.value === !0 && m();
    }), i === !0 && (0, $aD8ZA.onMounted)(function() {
        p(l.modelValue);
    });
    var C = {
        show: f,
        hide: m,
        toggle: v
    };
    return Object.assign(c, C), C;
}
var Rr = [], Ea = [];
function zf(e) {
    Ea = Ea.filter(function(t) {
        return t !== e;
    });
}
function Of(e) {
    zf(e), Ea.push(e);
}
function uc(e) {
    zf(e), Ea.length === 0 && Rr.length !== 0 && (Rr[Rr.length - 1](), Rr = []);
}
function Bo(e) {
    Ea.length === 0 ? e() : Rr.push(e);
}
function If(e) {
    Rr = Rr.filter(function(t) {
        return t !== e;
    });
}
var bi = [], Ba = [], Zb = 1, Gn = document.body;
function an(e, t) {
    var o = document.createElement("div");
    if (o.id = t !== void 0 ? "q-portal--".concat(t, "--").concat(Zb++) : e, ni.globalNodes !== void 0) {
        var r = ni.globalNodes.class;
        r !== void 0 && (o.className = r);
    }
    return Gn.appendChild(o), bi.push(o), Ba.push(t), o;
}
function yi(e) {
    var t = bi.indexOf(e);
    bi.splice(t, 1), Ba.splice(t, 1), e.remove();
}
function Hf(e) {
    if (e === Gn) return;
    if (Gn = e, Gn === document.body || Ba.reduce(function(o, r) {
        return r === "dialog" ? o + 1 : o;
    }, 0) < 2) {
        bi.forEach(function(o) {
            o.contains(Gn) === !1 && Gn.appendChild(o);
        });
        return;
    }
    var t = Ba.lastIndexOf("dialog");
    for(var o = 0; o < bi.length; o++){
        var r = bi[o];
        (o === t || Ba[o] !== "dialog") && r.contains(Gn) === !1 && Gn.appendChild(r);
    }
}
var Zn = [];
function Nf(e) {
    return Zn.find(function(t) {
        return t.contentEl !== null && t.contentEl.contains(e);
    });
}
function sc(e, t) {
    do {
        if (e.$options.name === "QMenu") {
            if (e.hide(t), e.$props.separateClosePopup === !0) return Ra(e);
        } else if (e.__qPortal === !0) {
            var o = Ra(e);
            return o !== void 0 && o.$options.name === "QPopupProxy" ? (e.hide(t), o) : e;
        }
        e = Ra(e);
    }while (e != null);
}
function Qf(e, t, o) {
    for(; o !== 0 && e !== void 0 && e !== null;){
        if (e.__qPortal === !0) {
            if (o--, e.$options.name === "QMenu") {
                e = sc(e, t);
                continue;
            }
            e.hide(t);
        }
        e = Ra(e);
    }
}
var ty = R({
    name: "QPortal",
    setup: function(e, param) {
        var t = param.slots;
        return function() {
            return t.default();
        };
    }
});
function oy(e) {
    for(e = e.parent; e != null;){
        if (e.type.name === "QGlobalDialog") return !0;
        if (e.type.name === "QDialog" || e.type.name === "QMenu") return !1;
        e = e.parent;
    }
    return !1;
}
function Si(e, t, o, r) {
    var n = (0, $aAzpa.ref)(!1), i = (0, $aAzpa.ref)(!1), a = null, l = {}, s = r === "dialog" && oy(e);
    function c(v) {
        if (v === !0) {
            uc(l), i.value = !0;
            return;
        }
        i.value = !1, n.value === !1 && (s === !1 && a === null && (a = an(!1, r)), n.value = !0, Zn.push(e.proxy), Of(l));
    }
    function u(v) {
        if (i.value = !1, v !== !0) return;
        uc(l), n.value = !1;
        var f = Zn.indexOf(e.proxy);
        f !== -1 && Zn.splice(f, 1), a !== null && (yi(a), a = null);
    }
    return (0, $aD8ZA.onUnmounted)(function() {
        u(!0);
    }), e.proxy.__qPortal = !0, it(e.proxy, "contentEl", function() {
        return t.value;
    }), {
        showPortal: c,
        hidePortal: u,
        portalIsActive: n,
        portalIsAccessible: i,
        renderPortal: function() {
            return s === !0 ? o() : n.value === !0 ? [
                (0, $aD8ZA.h)((0, $aD8ZA.Teleport), {
                    to: a
                }, (0, $aD8ZA.h)(ty, o))
            ] : void 0;
        }
    };
}
var ln = {
    transitionShow: {
        type: String,
        default: "fade"
    },
    transitionHide: {
        type: String,
        default: "fade"
    },
    transitionDuration: {
        type: [
            String,
            Number
        ],
        default: 300
    }
};
function Jn(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : function() {}, o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : function() {};
    return {
        transitionProps: (0, $aAzpa.computed)(function() {
            var r = "q-transition--".concat(e.transitionShow || t()), n = "q-transition--".concat(e.transitionHide || o());
            return {
                appear: !0,
                enterFromClass: "".concat(r, "-enter-from"),
                enterActiveClass: "".concat(r, "-enter-active"),
                enterToClass: "".concat(r, "-enter-to"),
                leaveFromClass: "".concat(n, "-leave-from"),
                leaveActiveClass: "".concat(n, "-leave-active"),
                leaveToClass: "".concat(n, "-leave-to")
            };
        }),
        transitionStyle: (0, $aAzpa.computed)(function() {
            return "--q-transition-duration: ".concat(e.transitionDuration, "ms");
        })
    };
}
function Io() {
    var e, t = (0, $aD8ZA.getCurrentInstance)();
    function o() {
        e = void 0;
    }
    return (0, $aD8ZA.onDeactivated)(o), (0, $aD8ZA.onBeforeUnmount)(o), {
        removeTick: o,
        registerTick: function(r) {
            e = r, (0, $aD8ZA.nextTick)(function() {
                e === r && (Jt(t) === !1 && e(), e = void 0);
            });
        }
    };
}
function io() {
    var e = null, t = (0, $aD8ZA.getCurrentInstance)();
    function o() {
        e !== null && (clearTimeout(e), e = null);
    }
    return (0, $aD8ZA.onDeactivated)(o), (0, $aD8ZA.onBeforeUnmount)(o), {
        removeTimeout: o,
        registerTimeout: function(r, n) {
            o(e), Jt(t) === !1 && (e = setTimeout(function() {
                e = null, r();
            }, n));
        }
    };
}
var cy = [
    null,
    document,
    document.body,
    document.scrollingElement,
    document.documentElement
];
function At(e, t) {
    var o = $f(t);
    if (o === void 0) {
        if (e == null) return window;
        o = e.closest(".scroll,.scroll-y,.overflow-auto");
    }
    return cy.includes(o) ? window : o;
}
function xi(e) {
    return (e === window ? document.body : e).scrollHeight;
}
function dy(e) {
    return (e === window ? document.body : e).scrollWidth;
}
function fo(e) {
    return e === window ? window.pageYOffset || window.scrollY || document.body.scrollTop || 0 : e.scrollTop;
}
function er(e) {
    return e === window ? window.pageXOffset || window.scrollX || document.body.scrollLeft || 0 : e.scrollLeft;
}
function fc(e, t) {
    var o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    var r = arguments[3] === void 0 ? performance.now() : arguments[3], n = fo(e);
    if (o <= 0) {
        n !== t && cc(e, t);
        return;
    }
    requestAnimationFrame(function(i) {
        var a = i - r, l = n + (t - n) / Math.max(a, o) * a;
        cc(e, l), l !== t && fc(e, t, o - a, i);
    });
}
function mc(e, t) {
    var o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    var r = arguments[3] === void 0 ? performance.now() : arguments[3], n = er(e);
    if (o <= 0) {
        n !== t && dc(e, t);
        return;
    }
    requestAnimationFrame(function(i) {
        var a = i - r, l = n + (t - n) / Math.max(a, o) * a;
        dc(e, l), l !== t && mc(e, t, o - a, i);
    });
}
function cc(e, t) {
    if (e === window) {
        window.scrollTo(window.pageXOffset || window.scrollX || document.body.scrollLeft || 0, t);
        return;
    }
    e.scrollTop = t;
}
function dc(e, t) {
    if (e === window) {
        window.scrollTo(t, window.pageYOffset || window.scrollY || document.body.scrollTop || 0);
        return;
    }
    e.scrollLeft = t;
}
function un(e, t, o) {
    if (o) {
        fc(e, t, o);
        return;
    }
    cc(e, t);
}
function La(e, t, o) {
    if (o) {
        mc(e, t, o);
        return;
    }
    dc(e, t);
}
var zl;
function Pr() {
    if (zl !== void 0) return zl;
    var e = document.createElement("p"), t = document.createElement("div");
    Mr(e, {
        width: "100%",
        height: "200px"
    }), Mr(t, {
        position: "absolute",
        top: "0px",
        left: "0px",
        visibility: "hidden",
        width: "200px",
        height: "150px",
        overflow: "hidden"
    }), t.appendChild(e), document.body.appendChild(t);
    var o = e.offsetWidth;
    t.style.overflow = "scroll";
    var r = e.offsetWidth;
    return o === r && (r = t.clientWidth), t.remove(), zl = o - r, zl;
}
function vc(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
    return !e || e.nodeType !== Node.ELEMENT_NODE ? !1 : t ? e.scrollHeight > e.clientHeight && (e.classList.contains("scroll") || e.classList.contains("overflow-auto") || [
        "auto",
        "scroll"
    ].includes(window.getComputedStyle(e)["overflow-y"])) : e.scrollWidth > e.clientWidth && (e.classList.contains("scroll") || e.classList.contains("overflow-auto") || [
        "auto",
        "scroll"
    ].includes(window.getComputedStyle(e)["overflow-x"]));
}
var fy = {
    getScrollTarget: At,
    getScrollHeight: xi,
    getScrollWidth: dy,
    getVerticalScrollPosition: fo,
    getHorizontalScrollPosition: er,
    animVerticalScrollTo: fc,
    animHorizontalScrollTo: mc,
    setVerticalScrollPosition: un,
    setHorizontalScrollPosition: La,
    getScrollbarWidth: Pr,
    hasScrollbar: vc
};
var Ar = [], _i;
function my(e) {
    _i = e.keyCode === 27;
}
function vy() {
    _i === !0 && (_i = !1);
}
function gy(e) {
    _i === !0 && (_i = !1, wt(e, 27) === !0 && Ar[Ar.length - 1](e));
}
function Wf(e) {
    window[e]("keydown", my), window[e]("blur", vy), window[e]("keyup", gy), _i = !1;
}
function Ol(e) {
    Ce.is.desktop === !0 && (Ar.push(e), Ar.length === 1 && Wf("addEventListener"));
}
function Ci(e) {
    var t = Ar.indexOf(e);
    t !== -1 && (Ar.splice(t, 1), Ar.length === 0 && Wf("removeEventListener"));
}
var $r = [];
function Yf(e) {
    $r[$r.length - 1](e);
}
function wi(e) {
    Ce.is.desktop === !0 && ($r.push(e), $r.length === 1 && document.body.addEventListener("focusin", Yf));
}
function Er(e) {
    var t = $r.indexOf(e);
    t !== -1 && ($r.splice(t, 1), $r.length === 0 && document.body.removeEventListener("focusin", Yf));
}
var ki = null, Il = Xe.notPassiveCapture, Br = [];
function Hl(e) {
    ki !== null && (clearTimeout(ki), ki = null);
    var t = e.target;
    if (t === void 0 || t.nodeType === 8 || t.classList.contains("no-pointer-events") === !0) return;
    var o = Zn.length - 1;
    for(; o >= 0;){
        var r = Zn[o].$;
        if (r.type.name === "QTooltip") {
            o--;
            continue;
        }
        if (r.type.name !== "QDialog") break;
        if (r.props.seamless !== !0) return;
        o--;
    }
    for(var r1 = Br.length - 1; r1 >= 0; r1--){
        var n = Br[r1];
        if ((n.anchorEl.value === null || n.anchorEl.value.contains(t) === !1) && (t === document.body || n.innerRef.value !== null && n.innerRef.value.contains(t) === !1)) e.qClickOutside = !0, n.onClickOutside(e);
        else return;
    }
}
function Nl(e) {
    Br.push(e), Br.length === 1 && (document.addEventListener("mousedown", Hl, Il), document.addEventListener("touchstart", Hl, Il));
}
function qi(e) {
    var t = Br.findIndex(function(o) {
        return o === e;
    });
    t !== -1 && (Br.splice(t, 1), Br.length === 0 && (ki !== null && (clearTimeout(ki), ki = null), document.removeEventListener("mousedown", Hl, Il), document.removeEventListener("touchstart", Hl, Il)));
}
var Xf, Gf;
function Ti(e) {
    var t = e.split(" ");
    return t.length !== 2 ? !1 : [
        "top",
        "center",
        "bottom"
    ].includes(t[0]) !== !0 ? (console.error("Anchor/Self position must start with one of top/center/bottom"), !1) : [
        "left",
        "middle",
        "right",
        "start",
        "end"
    ].includes(t[1]) !== !0 ? (console.error("Anchor/Self position must end with one of left/middle/right/start/end"), !1) : !0;
}
function Ql(e) {
    return e ? !(e.length !== 2 || typeof e[0] != "number" || typeof e[1] != "number") : !0;
}
var hc = {
    "start#ltr": "left",
    "start#rtl": "right",
    "end#ltr": "right",
    "end#rtl": "left"
};
[
    "left",
    "middle",
    "right"
].forEach(function(e) {
    hc["".concat(e, "#ltr")] = e, hc["".concat(e, "#rtl")] = e;
});
function Mi(e, t) {
    var o = e.split(" ");
    return {
        vertical: o[0],
        horizontal: hc["".concat(o[1], "#").concat(t === !0 ? "rtl" : "ltr")]
    };
}
function hy(e, t) {
    var _e_getBoundingClientRect = e.getBoundingClientRect(), o = _e_getBoundingClientRect.top, r = _e_getBoundingClientRect.left, n = _e_getBoundingClientRect.right, i = _e_getBoundingClientRect.bottom, a = _e_getBoundingClientRect.width, l = _e_getBoundingClientRect.height;
    return t !== void 0 && (o -= t[1], r -= t[0], i += t[1], n += t[0], a += t[0], l += t[1]), {
        top: o,
        bottom: i,
        height: l,
        left: r,
        right: n,
        width: a,
        middle: r + (n - r) / 2,
        center: o + (i - o) / 2
    };
}
function py(e, t, o) {
    var _e_getBoundingClientRect = e.getBoundingClientRect(), r = _e_getBoundingClientRect.top, n = _e_getBoundingClientRect.left;
    return r += t.top, n += t.left, o !== void 0 && (r += o[1], n += o[0]), {
        top: r,
        bottom: r + 1,
        height: 1,
        left: n,
        right: n + 1,
        width: 1,
        middle: n,
        center: r
    };
}
function by(e, t) {
    return {
        top: 0,
        center: t / 2,
        bottom: t,
        left: 0,
        middle: e / 2,
        right: e
    };
}
function Zf(e, t, o, r) {
    return {
        top: e[o.vertical] - t[r.vertical],
        left: e[o.horizontal] - t[r.horizontal]
    };
}
function Fa(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    if (e.targetEl === null || e.anchorEl === null || t > 5) return;
    if (e.targetEl.offsetHeight === 0 || e.targetEl.offsetWidth === 0) {
        setTimeout(function() {
            Fa(e, t + 1);
        }, 10);
        return;
    }
    var o = e.targetEl, r = e.offset, n = e.anchorEl, i = e.anchorOrigin, a = e.selfOrigin, l = e.absoluteOffset, s = e.fit, c = e.cover, u = e.maxHeight, v = e.maxWidth;
    if (Ce.is.ios === !0 && window.visualViewport !== void 0) {
        var P = document.body.style, _window_visualViewport = window.visualViewport, $ = _window_visualViewport.offsetLeft, L = _window_visualViewport.offsetTop;
        $ !== Xf && (P.setProperty("--q-pe-left", $ + "px"), Xf = $), L !== Gf && (P.setProperty("--q-pe-top", L + "px"), Gf = L);
    }
    var f = o.scrollLeft, d = o.scrollTop, m = l === void 0 ? hy(n, c === !0 ? [
        0,
        0
    ] : r) : py(n, l, r);
    Object.assign(o.style, {
        top: 0,
        left: 0,
        minWidth: null,
        minHeight: null,
        maxWidth: v || "100vw",
        maxHeight: u || "100vh",
        visibility: "visible"
    });
    var y = o.offsetWidth, p = o.offsetHeight, _ref = s === !0 || c === !0 ? {
        elWidth: Math.max(m.width, y),
        elHeight: c === !0 ? Math.max(m.height, p) : p
    } : {
        elWidth: y,
        elHeight: p
    }, C = _ref.elWidth, b = _ref.elHeight, h = {
        maxWidth: v,
        maxHeight: u
    };
    (s === !0 || c === !0) && (h.minWidth = m.width + "px", c === !0 && (h.minHeight = m.height + "px")), Object.assign(o.style, h);
    var g = by(C, b), S = Zf(m, g, i, a);
    if (l === void 0 || r === void 0) gc(S, m, g, i, a);
    else {
        var P1 = S.top, $1 = S.left;
        gc(S, m, g, i, a);
        var L1 = !1;
        if (S.top !== P1) {
            L1 = !0;
            var E = 2 * r[1];
            m.center = m.top -= E, m.bottom -= E + 2;
        }
        if (S.left !== $1) {
            L1 = !0;
            var E1 = 2 * r[0];
            m.middle = m.left -= E1, m.right -= E1 + 2;
        }
        L1 === !0 && (S = Zf(m, g, i, a), gc(S, m, g, i, a));
    }
    h = {
        top: S.top + "px",
        left: S.left + "px"
    }, S.maxHeight !== void 0 && (h.maxHeight = S.maxHeight + "px", m.height > S.maxHeight && (h.minHeight = h.maxHeight)), S.maxWidth !== void 0 && (h.maxWidth = S.maxWidth + "px", m.width > S.maxWidth && (h.minWidth = h.maxWidth)), Object.assign(o.style, h), o.scrollTop !== d && (o.scrollTop = d), o.scrollLeft !== f && (o.scrollLeft = f);
}
function gc(e, t, o, r, n) {
    var i = o.bottom, a = o.right, l = Pr(), s = window.innerHeight - l, c = document.body.clientWidth;
    if (e.top < 0 || e.top + i > s) {
        if (n.vertical === "center") e.top = t[r.vertical] > s / 2 ? Math.max(0, s - i) : 0, e.maxHeight = Math.min(i, s);
        else if (t[r.vertical] > s / 2) {
            var u = Math.min(s, r.vertical === "center" ? t.center : r.vertical === n.vertical ? t.bottom : t.top);
            e.maxHeight = Math.min(i, u), e.top = Math.max(0, u - i);
        } else e.top = Math.max(0, r.vertical === "center" ? t.center : r.vertical === n.vertical ? t.top : t.bottom), e.maxHeight = Math.min(i, s - e.top);
    }
    if (e.left < 0 || e.left + a > c) {
        if (e.maxWidth = Math.min(a, c), n.horizontal === "middle") e.left = t[r.horizontal] > c / 2 ? Math.max(0, c - a) : 0;
        else if (t[r.horizontal] > c / 2) {
            var u1 = Math.min(c, r.horizontal === "middle" ? t.middle : r.horizontal === n.horizontal ? t.right : t.left);
            e.maxWidth = Math.min(a, u1), e.left = Math.max(0, u1 - e.maxWidth);
        } else e.left = Math.max(0, r.horizontal === "middle" ? t.middle : r.horizontal === n.horizontal ? t.left : t.right), e.maxWidth = Math.min(a, c - e.left);
    }
}
var sn = R({
    name: "QMenu",
    inheritAttrs: !1,
    props: (0, $8typN._)((0, $8pZMQ._)({}, hi, Ao, he, ln), {
        persistent: Boolean,
        autoClose: Boolean,
        separateClosePopup: Boolean,
        noRouteDismiss: Boolean,
        noRefocus: Boolean,
        noFocus: Boolean,
        fit: Boolean,
        cover: Boolean,
        square: Boolean,
        anchor: {
            type: String,
            validator: Ti
        },
        self: {
            type: String,
            validator: Ti
        },
        offset: {
            type: Array,
            validator: Ql
        },
        scrollTarget: {
            default: void 0
        },
        touchPosition: Boolean,
        maxHeight: {
            type: String,
            default: null
        },
        maxWidth: {
            type: String,
            default: null
        }
    }),
    emits: (0, $79xu7._)($o).concat([
        "click",
        "escapeKey"
    ]),
    setup: function(e, param) {
        var t = param.slots, o = param.emit, r = param.attrs;
        var n = null, i, a, l, s = (0, $aD8ZA.getCurrentInstance)(), c = s.proxy, u = c.$q, v = (0, $aAzpa.ref)(null), f = (0, $aAzpa.ref)(!1), d = (0, $aAzpa.computed)(function() {
            return e.persistent !== !0 && e.noRouteDismiss !== !0;
        }), m = pe(e, u), _Io = Io(), y = _Io.registerTick, p = _Io.removeTick, _io = io(), C = _io.registerTimeout, _Jn = Jn(e), b = _Jn.transitionProps, h = _Jn.transitionStyle, _Vl = Vl(e, N), g = _Vl.localScrollTarget, S = _Vl.changeScrollEvent, P = _Vl.unconfigureScrollTarget, _pi = pi({
            showing: f
        }), $ = _pi.anchorEl, L = _pi.canShow, _Eo = Eo({
            showing: f,
            canShow: L,
            handleShow: ie,
            handleHide: V,
            hideOnRouteChange: d,
            processOnMount: !0
        }), E = _Eo.hide, _Si = Si(s, v, te, "menu"), A = _Si.showPortal, B = _Si.hidePortal, q = _Si.renderPortal, x = {
            anchorEl: $,
            innerRef: v,
            onClickOutside: function(z) {
                if (e.persistent !== !0 && f.value === !0) return E(z), (z.type === "touchstart" || z.target.classList.contains("q-dialog__backdrop")) && Se(z), !0;
            }
        }, k = (0, $aAzpa.computed)(function() {
            return Mi(e.anchor || (e.cover === !0 ? "center middle" : "bottom start"), u.lang.rtl);
        }), j = (0, $aAzpa.computed)(function() {
            return e.cover === !0 ? k.value : Mi(e.self || "top start", u.lang.rtl);
        }), Q = (0, $aAzpa.computed)(function() {
            return (e.square === !0 ? " q-menu--square" : "") + (m.value === !0 ? " q-menu--dark q-dark" : "");
        }), w = (0, $aAzpa.computed)(function() {
            return e.autoClose === !0 ? {
                onClick: I
            } : {};
        }), H = (0, $aAzpa.computed)(function() {
            return f.value === !0 && e.persistent !== !0;
        });
        (0, $aD8ZA.watch)(H, function(z) {
            z === !0 ? (Ol(T), Nl(x)) : (Ci(T), qi(x));
        });
        function W() {
            Bo(function() {
                var z = v.value;
                z && z.contains(document.activeElement) !== !0 && (z = z.querySelector("[autofocus][tabindex], [data-autofocus][tabindex]") || z.querySelector("[autofocus] [tabindex], [data-autofocus] [tabindex]") || z.querySelector("[autofocus], [data-autofocus]") || z, z.focus({
                    preventScroll: !0
                }));
            });
        }
        function ie(z) {
            if (n = e.noRefocus === !1 ? document.activeElement : null, wi(oe), A(), N(), i = void 0, z !== void 0 && (e.touchPosition || e.contextMenu)) {
                var ue = yt(z);
                if (ue.left !== void 0) {
                    var _$_value_getBoundingClientRect = $.value.getBoundingClientRect(), _e = _$_value_getBoundingClientRect.top, U = _$_value_getBoundingClientRect.left;
                    i = {
                        left: ue.left - U,
                        top: ue.top - _e
                    };
                }
            }
            a === void 0 && (a = (0, $aD8ZA.watch)(function() {
                return u.screen.width + "|" + u.screen.height + "|" + e.self + "|" + e.anchor + "|" + u.lang.rtl;
            }, D)), e.noFocus !== !0 && document.activeElement.blur(), y(function() {
                D(), e.noFocus !== !0 && W();
            }), C(function() {
                u.platform.is.ios === !0 && (l = e.autoClose, v.value.click()), D(), A(!0), o("show", z);
            }, e.transitionDuration);
        }
        function V(z) {
            p(), B(), _(!0), n !== null && (z === void 0 || z.qClickOutside !== !0) && (((z && z.type.indexOf("key") === 0 ? n.closest('[tabindex]:not([tabindex^="-"])') : void 0) || n).focus(), n = null), C(function() {
                B(!0), o("hide", z);
            }, e.transitionDuration);
        }
        function _(z) {
            i = void 0, a !== void 0 && (a(), a = void 0), (z === !0 || f.value === !0) && (Er(oe), P(), qi(x), Ci(T)), z !== !0 && (n = null);
        }
        function N() {
            ($.value !== null || e.scrollTarget !== void 0) && (g.value = At($.value, e.scrollTarget), S(g.value, D));
        }
        function I(z) {
            l !== !0 ? (sc(c, z), o("click", z)) : l = !1;
        }
        function oe(z) {
            H.value === !0 && e.noFocus !== !0 && Ll(v.value, z.target) !== !0 && W();
        }
        function T(z) {
            o("escapeKey"), E(z);
        }
        function D() {
            Fa({
                targetEl: v.value,
                offset: e.offset,
                anchorEl: $.value,
                anchorOrigin: k.value,
                selfOrigin: j.value,
                absoluteOffset: i,
                fit: e.fit,
                cover: e.cover,
                maxHeight: e.maxHeight,
                maxWidth: e.maxWidth
            });
        }
        function te() {
            return (0, $aD8ZA.h)((0, $iMtOP.Transition), b.value, function() {
                return f.value === !0 ? (0, $aD8ZA.h)("div", (0, $8pZMQ._)((0, $8typN._)((0, $8pZMQ._)({
                    role: "menu"
                }, r), {
                    ref: v,
                    tabindex: -1,
                    class: [
                        "q-menu q-position-engine scroll" + Q.value,
                        r.class
                    ],
                    style: [
                        r.style,
                        h.value
                    ]
                }), w.value), J(t.default)) : null;
            });
        }
        return (0, $aD8ZA.onBeforeUnmount)(_), Object.assign(c, {
            focus: W,
            updatePosition: D
        }), q;
    }
});
var pc, jl = 0, Kt = new Array(256);
for(var e2 = 0; e2 < 256; e2++)Kt[e2] = (e2 + 256).toString(16).substring(1);
var _y = function() {
    var e = (typeof crypto === "undefined" ? "undefined" : (0, $jzTO1._)(crypto)) < "u" ? crypto : (typeof window === "undefined" ? "undefined" : (0, $jzTO1._)(window)) < "u" ? window.crypto || window.msCrypto : void 0;
    if (e !== void 0) {
        if (e.randomBytes !== void 0) return e.randomBytes;
        if (e.getRandomValues !== void 0) return function(t) {
            var o = new Uint8Array(t);
            return e.getRandomValues(o), o;
        };
    }
    return function(t) {
        var o = [];
        for(var r = t; r > 0; r--)o.push(Math.floor(Math.random() * 256));
        return o;
    };
}(), om = 4096;
function An() {
    (pc === void 0 || jl + 16 > om) && (jl = 0, pc = _y(om));
    var e = Array.prototype.slice.call(pc, jl, jl += 16);
    return e[6] = e[6] & 15 | 64, e[8] = e[8] & 63 | 128, Kt[e[0]] + Kt[e[1]] + Kt[e[2]] + Kt[e[3]] + "-" + Kt[e[4]] + Kt[e[5]] + "-" + Kt[e[6]] + Kt[e[7]] + "-" + Kt[e[8]] + Kt[e[9]] + "-" + Kt[e[10]] + Kt[e[11]] + Kt[e[12]] + Kt[e[13]] + Kt[e[14]] + Kt[e[15]];
}
function qy(e) {
    return e !== null && e !== void 0 ? e : null;
}
function nm(e, t) {
    return e !== null && e !== void 0 ? e : t === !0 ? "f_".concat(An()) : null;
}
function $n() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, e = _ref.getValue, tmp = _ref.required, t = tmp === void 0 ? !0 : tmp;
    if (bt.value === !0) {
        var o = e !== void 0 ? (0, $aAzpa.ref)(qy(e())) : (0, $aAzpa.ref)(null);
        return t === !0 && o.value === null && (0, $aD8ZA.onMounted)(function() {
            o.value = "f_".concat(An());
        }), e !== void 0 && (0, $aD8ZA.watch)(e, function(r) {
            o.value = nm(r, t);
        }), o;
    }
    return e !== void 0 ? (0, $aAzpa.computed)(function() {
        return nm(e(), t);
    }) : (0, $aAzpa.ref)("f_".concat(An()));
}
var Ry = Object.keys($a);
function Py(e) {
    return Ry.reduce(function(t, o) {
        var r = e[o];
        return r !== void 0 && (t[o] = r), t;
    }, {});
}
var Kl = R({
    name: "QBtnDropdown",
    props: (0, $8typN._)((0, $8pZMQ._)({}, $a, ln), {
        modelValue: Boolean,
        split: Boolean,
        dropdownIcon: String,
        contentClass: [
            Array,
            String,
            Object
        ],
        contentStyle: [
            Array,
            String,
            Object
        ],
        cover: Boolean,
        persistent: Boolean,
        noRouteDismiss: Boolean,
        autoClose: Boolean,
        menuAnchor: {
            type: String,
            default: "bottom end"
        },
        menuSelf: {
            type: String,
            default: "top end"
        },
        menuOffset: Array,
        disableMainBtn: Boolean,
        disableDropdown: Boolean,
        noIconAnimation: Boolean,
        toggleAriaLabel: String
    }),
    emits: [
        "update:modelValue",
        "click",
        "beforeShow",
        "show",
        "beforeHide",
        "hide"
    ],
    setup: function(e, param) {
        var t = param.slots, o = param.emit;
        var _My = (0, $aD8ZA.getCurrentInstance)(), r = _My.proxy, n = (0, $aAzpa.ref)(e.modelValue), i = (0, $aAzpa.ref)(null), a = $n(), l = (0, $aAzpa.computed)(function() {
            var g = {
                "aria-expanded": n.value === !0 ? "true" : "false",
                "aria-haspopup": "true",
                "aria-controls": a.value,
                "aria-label": e.toggleAriaLabel || r.$q.lang.label[n.value === !0 ? "collapse" : "expand"](e.label)
            };
            return (e.disable === !0 || e.split === !1 && e.disableMainBtn === !0 || e.disableDropdown === !0) && (g["aria-disabled"] = "true"), g;
        }), s = (0, $aAzpa.computed)(function() {
            return "q-btn-dropdown__arrow" + (n.value === !0 && e.noIconAnimation === !1 ? " rotate-180" : "") + (e.split === !1 ? " q-btn-dropdown__arrow-container" : "");
        }), c = (0, $aAzpa.computed)(function() {
            return Dl(e);
        }), u = (0, $aAzpa.computed)(function() {
            return Py(e);
        });
        (0, $aD8ZA.watch)(function() {
            return e.modelValue;
        }, function(g) {
            i.value !== null && i.value[g ? "show" : "hide"]();
        }), (0, $aD8ZA.watch)(function() {
            return e.split;
        }, h);
        function v(g) {
            n.value = !0, o("beforeShow", g);
        }
        function f(g) {
            o("show", g), o("update:modelValue", !0);
        }
        function d(g) {
            n.value = !1, o("beforeHide", g);
        }
        function m(g) {
            o("hide", g), o("update:modelValue", !1);
        }
        function y(g) {
            o("click", g);
        }
        function p(g) {
            tt(g), h(), o("click", g);
        }
        function C(g) {
            i.value !== null && i.value.toggle(g);
        }
        function b(g) {
            i.value !== null && i.value.show(g);
        }
        function h(g) {
            i.value !== null && i.value.hide(g);
        }
        return Object.assign(r, {
            show: b,
            hide: h,
            toggle: C
        }), (0, $aD8ZA.onMounted)(function() {
            e.modelValue === !0 && b();
        }), function() {
            var g = [
                (0, $aD8ZA.h)(we, {
                    class: s.value,
                    name: e.dropdownIcon || r.$q.iconSet.arrow.dropdown
                })
            ];
            return e.disableDropdown !== !0 && g.push((0, $aD8ZA.h)(sn, {
                ref: i,
                id: a.value,
                class: e.contentClass,
                style: e.contentStyle,
                cover: e.cover,
                fit: !0,
                persistent: e.persistent,
                noRouteDismiss: e.noRouteDismiss,
                autoClose: e.autoClose,
                anchor: e.menuAnchor,
                self: e.menuSelf,
                offset: e.menuOffset,
                separateClosePopup: !0,
                transitionShow: e.transitionShow,
                transitionHide: e.transitionHide,
                transitionDuration: e.transitionDuration,
                onBeforeShow: v,
                onShow: f,
                onBeforeHide: d,
                onHide: m
            }, t.default)), e.split === !1 ? (0, $aD8ZA.h)(Le, (0, $8typN._)((0, $8pZMQ._)({
                class: "q-btn-dropdown q-btn-dropdown--simple"
            }, u.value, l.value), {
                disable: e.disable === !0 || e.disableMainBtn === !0,
                noWrap: !0,
                round: !1,
                onClick: y
            }), {
                default: function() {
                    return J(t.label, []).concat(g);
                },
                loading: t.loading
            }) : (0, $aD8ZA.h)(gi, (0, $8typN._)((0, $8pZMQ._)({
                class: "q-btn-dropdown q-btn-dropdown--split no-wrap q-btn-item",
                rounded: e.rounded,
                square: e.square
            }, c.value), {
                glossy: e.glossy,
                stretch: e.stretch
            }), function() {
                return [
                    (0, $aD8ZA.h)(Le, (0, $8typN._)((0, $8pZMQ._)({
                        class: "q-btn-dropdown--current"
                    }, u.value), {
                        disable: e.disable === !0 || e.disableMainBtn === !0,
                        noWrap: !0,
                        round: !1,
                        onClick: p
                    }), {
                        default: t.label,
                        loading: t.loading
                    }),
                    (0, $aD8ZA.h)(Le, (0, $8typN._)((0, $8pZMQ._)({
                        class: "q-btn-dropdown__arrow-container q-anchor--skip"
                    }, l.value, c.value), {
                        disable: e.disable === !0 || e.disableDropdown === !0,
                        rounded: e.rounded,
                        color: e.color,
                        textColor: e.textColor,
                        dense: e.dense,
                        size: e.size,
                        padding: e.padding,
                        ripple: e.ripple
                    }), function() {
                        return g;
                    })
                ];
            });
        };
    }
});
var _t = {
    name: String
};
function cn(e) {
    return (0, $aAzpa.computed)(function() {
        return {
            type: "hidden",
            name: e.name,
            value: e.modelValue
        };
    });
}
function eo() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return function(t, o, r) {
        t[o]((0, $aD8ZA.h)("input", (0, $8pZMQ._)({
            class: "hidden" + (r || "")
        }, e.value)));
    };
}
function Ai(e) {
    return (0, $aAzpa.computed)(function() {
        return e.name || e.for;
    });
}
var um = R({
    name: "QBtnToggle",
    props: (0, $8typN._)((0, $8pZMQ._)({}, _t), {
        modelValue: {
            required: !0
        },
        options: {
            type: Array,
            required: !0,
            validator: function(e) {
                return e.every(function(t) {
                    return ("label" in t || "icon" in t || "slot" in t) && "value" in t;
                });
            }
        },
        color: String,
        textColor: String,
        toggleColor: {
            type: String,
            default: "primary"
        },
        toggleTextColor: String,
        outline: Boolean,
        flat: Boolean,
        unelevated: Boolean,
        rounded: Boolean,
        push: Boolean,
        glossy: Boolean,
        size: String,
        padding: String,
        noCaps: Boolean,
        noWrap: Boolean,
        dense: Boolean,
        readonly: Boolean,
        disable: Boolean,
        stack: Boolean,
        stretch: Boolean,
        spread: Boolean,
        clearable: Boolean,
        ripple: {
            type: [
                Boolean,
                Object
            ],
            default: !0
        }
    }),
    emits: [
        "update:modelValue",
        "clear",
        "click"
    ],
    setup: function(e, param) {
        var t = param.slots, o = param.emit;
        var r = (0, $aAzpa.computed)(function() {
            return e.options.find(function(f) {
                return f.value === e.modelValue;
            }) !== void 0;
        }), n = (0, $aAzpa.computed)(function() {
            return {
                type: "hidden",
                name: e.name,
                value: e.modelValue
            };
        }), i = eo(n), a = (0, $aAzpa.computed)(function() {
            return Dl(e);
        }), l = (0, $aAzpa.computed)(function() {
            return (0, $8pZMQ._)({
                rounded: e.rounded,
                dense: e.dense
            }, a.value);
        }), s = (0, $aAzpa.computed)(function() {
            return e.options.map(function(f, d) {
                var m = f.attrs, y = f.value, p = f.slot, C = (0, $lhEla._)(f, [
                    "attrs",
                    "value",
                    "slot"
                ]);
                return {
                    slot: p,
                    props: (0, $8typN._)((0, $8pZMQ._)({
                        key: d,
                        "aria-pressed": y === e.modelValue ? "true" : "false"
                    }, m, C, l.value), {
                        disable: e.disable === !0 || C.disable === !0,
                        color: y === e.modelValue ? u(C, "toggleColor") : u(C, "color"),
                        textColor: y === e.modelValue ? u(C, "toggleTextColor") : u(C, "textColor"),
                        noCaps: u(C, "noCaps") === !0,
                        noWrap: u(C, "noWrap") === !0,
                        size: u(C, "size"),
                        padding: u(C, "padding"),
                        ripple: u(C, "ripple"),
                        stack: u(C, "stack") === !0,
                        stretch: u(C, "stretch") === !0,
                        onClick: function(b) {
                            c(y, f, b);
                        }
                    })
                };
            });
        });
        function c(f, d, m) {
            e.readonly !== !0 && (e.modelValue === f ? e.clearable === !0 && (o("update:modelValue", null, null), o("clear")) : o("update:modelValue", f, d), o("click", m));
        }
        function u(f, d) {
            return f[d] === void 0 ? e[d] : f[d];
        }
        function v() {
            var f = s.value.map(function(d) {
                return (0, $aD8ZA.h)(Le, d.props, d.slot !== void 0 ? t[d.slot] : void 0);
            });
            return e.name !== void 0 && e.disable !== !0 && r.value === !0 && i(f, "push"), Ke(t.default, f);
        }
        return function() {
            return (0, $aD8ZA.h)(gi, (0, $8typN._)((0, $8pZMQ._)({
                class: "q-btn-toggle"
            }, a.value), {
                rounded: e.rounded,
                stretch: e.stretch,
                glossy: e.glossy,
                spread: e.spread
            }), v);
        };
    }
});
var $i = R({
    name: "QCard",
    props: (0, $8typN._)((0, $8pZMQ._)({}, he), {
        tag: {
            type: String,
            default: "div"
        },
        square: Boolean,
        flat: Boolean,
        bordered: Boolean
    }),
    setup: function(e, param) {
        var t = param.slots;
        var _By = (0, $aD8ZA.getCurrentInstance)(), _By_proxy = _By.proxy, o = _By_proxy.$q, r = pe(e, o), n = (0, $aAzpa.computed)(function() {
            return "q-card" + (r.value === !0 ? " q-card--dark q-dark" : "") + (e.bordered === !0 ? " q-card--bordered" : "") + (e.square === !0 ? " q-card--square no-border-radius" : "") + (e.flat === !0 ? " q-card--flat no-shadow" : "");
        });
        return function() {
            return (0, $aD8ZA.h)(e.tag, {
                class: n.value
            }, J(t.default));
        };
    }
});
var Ho = R({
    name: "QCardSection",
    props: {
        tag: {
            type: String,
            default: "div"
        },
        horizontal: Boolean
    },
    setup: function(e, param) {
        var t = param.slots;
        var o = (0, $aAzpa.computed)(function() {
            return "q-card__section q-card__section--".concat(e.horizontal === !0 ? "horiz row no-wrap" : "vert");
        });
        return function() {
            return (0, $aD8ZA.h)(e.tag, {
                class: o.value
            }, J(t.default));
        };
    }
});
var Wl = R({
    name: "QCardActions",
    props: (0, $8typN._)((0, $8pZMQ._)({}, li), {
        vertical: Boolean
    }),
    setup: function(e, param) {
        var t = param.slots;
        var o = ui(e), r = (0, $aAzpa.computed)(function() {
            return "q-card__actions ".concat(o.value, " q-card__actions--").concat(e.vertical === !0 ? "vert column" : "horiz row");
        });
        return function() {
            return (0, $aD8ZA.h)("div", {
                class: r.value
            }, J(t.default));
        };
    }
});
var yc = {
    left: !0,
    right: !0,
    up: !0,
    down: !0,
    horizontal: !0,
    vertical: !0
}, zy = Object.keys(yc);
yc.all = !0;
function Ei(e) {
    var t = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = zy[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var o = _step.value;
            e[o] === !0 && (t[o] = !0);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return Object.keys(t).length === 0 ? yc : (t.horizontal === !0 ? t.left = t.right = !0 : t.left === !0 && t.right === !0 && (t.horizontal = !0), t.vertical === !0 ? t.up = t.down = !0 : t.up === !0 && t.down === !0 && (t.vertical = !0), t.horizontal === !0 && t.vertical === !0 && (t.all = !0), t);
}
var Oy = [
    "INPUT",
    "TEXTAREA"
];
function Bi(e, t) {
    return t.event === void 0 && e.target !== void 0 && e.target.draggable !== !0 && typeof t.handler == "function" && Oy.includes(e.target.nodeName.toUpperCase()) === !1 && (e.qClonedBy === void 0 || e.qClonedBy.indexOf(t.uid) === -1);
}
function Iy(e) {
    var t = [
        .06,
        6,
        50
    ];
    return typeof e == "string" && e.length && e.split(":").forEach(function(o, r) {
        var n = parseFloat(o);
        n && (t[r] = n);
    }), t;
}
var Yl = Mt({
    name: "touch-swipe",
    beforeMount: function(e, param) {
        var t = param.value, o = param.arg, r = param.modifiers;
        if (r.mouse !== !0 && Ce.has.touch !== !0) return;
        var n = r.mouseCapture === !0 ? "Capture" : "", i = {
            handler: t,
            sensitivity: Iy(o),
            direction: Ei(r),
            noop: Qe,
            mouseStart: function(a) {
                Bi(a, i) && Tn(a) && (lt(i, "temp", [
                    [
                        document,
                        "mousemove",
                        "move",
                        "notPassive".concat(n)
                    ],
                    [
                        document,
                        "mouseup",
                        "end",
                        "notPassiveCapture"
                    ]
                ]), i.start(a, !0));
            },
            touchStart: function(a) {
                if (Bi(a, i)) {
                    var l = a.target;
                    lt(i, "temp", [
                        [
                            l,
                            "touchmove",
                            "move",
                            "notPassiveCapture"
                        ],
                        [
                            l,
                            "touchcancel",
                            "end",
                            "notPassiveCapture"
                        ],
                        [
                            l,
                            "touchend",
                            "end",
                            "notPassiveCapture"
                        ]
                    ]), i.start(a);
                }
            },
            start: function(a, l) {
                Ce.is.firefox === !0 && Mn(e, !0);
                var s = yt(a);
                i.event = {
                    x: s.left,
                    y: s.top,
                    time: Date.now(),
                    mouse: l === !0,
                    dir: !1
                };
            },
            move: function(a) {
                if (i.event === void 0) return;
                if (i.event.dir !== !1) {
                    Se(a);
                    return;
                }
                var l = Date.now() - i.event.time;
                if (l === 0) return;
                var s = yt(a), c = s.left - i.event.x, u = Math.abs(c), v = s.top - i.event.y, f = Math.abs(v);
                if (i.event.mouse !== !0) {
                    if (u < i.sensitivity[1] && f < i.sensitivity[1]) {
                        i.end(a);
                        return;
                    }
                } else if (window.getSelection().toString() !== "") {
                    i.end(a);
                    return;
                } else if (u < i.sensitivity[2] && f < i.sensitivity[2]) return;
                var d = u / l, m = f / l;
                i.direction.vertical === !0 && u < f && u < 100 && m > i.sensitivity[0] && (i.event.dir = v < 0 ? "up" : "down"), i.direction.horizontal === !0 && u > f && f < 100 && d > i.sensitivity[0] && (i.event.dir = c < 0 ? "left" : "right"), i.direction.up === !0 && u < f && v < 0 && u < 100 && m > i.sensitivity[0] && (i.event.dir = "up"), i.direction.down === !0 && u < f && v > 0 && u < 100 && m > i.sensitivity[0] && (i.event.dir = "down"), i.direction.left === !0 && u > f && c < 0 && f < 100 && d > i.sensitivity[0] && (i.event.dir = "left"), i.direction.right === !0 && u > f && c > 0 && f < 100 && d > i.sensitivity[0] && (i.event.dir = "right"), i.event.dir !== !1 ? (Se(a), i.event.mouse === !0 && (document.body.classList.add("no-pointer-events--children"), document.body.classList.add("non-selectable"), Ut(), i.styleCleanup = function(y) {
                    i.styleCleanup = void 0, document.body.classList.remove("non-selectable");
                    var p = function() {
                        document.body.classList.remove("no-pointer-events--children");
                    };
                    y === !0 ? setTimeout(p, 50) : p();
                }), i.handler({
                    evt: a,
                    touch: i.event.mouse !== !0,
                    mouse: i.event.mouse,
                    direction: i.event.dir,
                    duration: l,
                    distance: {
                        x: u,
                        y: f
                    }
                })) : i.end(a);
            },
            end: function(a) {
                i.event !== void 0 && (Ct(i, "temp"), Ce.is.firefox === !0 && Mn(e, !1), i.styleCleanup !== void 0 && i.styleCleanup(!0), a !== void 0 && i.event.dir !== !1 && Se(a), i.event = void 0);
            }
        };
        if (e.__qtouchswipe = i, r.mouse === !0) {
            var a = r.mouseCapture === !0 || r.mousecapture === !0 ? "Capture" : "";
            lt(i, "main", [
                [
                    e,
                    "mousedown",
                    "mouseStart",
                    "passive".concat(a)
                ]
            ]);
        }
        Ce.has.touch === !0 && lt(i, "main", [
            [
                e,
                "touchstart",
                "touchStart",
                "passive".concat(r.capture === !0 ? "Capture" : "")
            ],
            [
                e,
                "touchmove",
                "noop",
                "notPassiveCapture"
            ]
        ]);
    },
    updated: function(e, t) {
        var o = e.__qtouchswipe;
        o !== void 0 && (t.oldValue !== t.value && (typeof t.value != "function" && o.end(), o.handler = t.value), o.direction = Ei(t.modifiers));
    },
    beforeUnmount: function(e) {
        var t = e.__qtouchswipe;
        t !== void 0 && (Ct(t, "main"), Ct(t, "temp"), Ce.is.firefox === !0 && Mn(e, !1), t.styleCleanup !== void 0 && t.styleCleanup(), delete e.__qtouchswipe);
    }
});
function No() {
    var e = Object.create(null);
    return {
        getCache: function(t, o) {
            return e[t] === void 0 ? e[t] = typeof o == "function" ? o() : o : e[t];
        },
        setCache: function(t, o) {
            e[t] = o;
        },
        hasCache: function(t) {
            return Object.hasOwnProperty.call(e, t);
        },
        clearCache: function(t) {
            t !== void 0 ? delete e[t] : e = Object.create(null);
        }
    };
}
var Li = {
    name: {
        required: !0
    },
    disable: Boolean
}, cm = {
    setup: function(e, param) {
        var t = param.slots;
        return function() {
            return (0, $aD8ZA.h)("div", {
                class: "q-panel scroll",
                role: "tabpanel"
            }, J(t.default));
        };
    }
}, Fi = {
    modelValue: {
        required: !0
    },
    animated: Boolean,
    infinite: Boolean,
    swipeable: Boolean,
    vertical: Boolean,
    transitionPrev: String,
    transitionNext: String,
    transitionDuration: {
        type: [
            String,
            Number
        ],
        default: 300
    },
    keepAlive: Boolean,
    keepAliveInclude: [
        String,
        Array,
        RegExp
    ],
    keepAliveExclude: [
        String,
        Array,
        RegExp
    ],
    keepAliveMax: Number
}, Di = [
    "update:modelValue",
    "beforeTransition",
    "transition"
];
function Vi() {
    var _Qy = (0, $aD8ZA.getCurrentInstance)(), e = _Qy.props, t = _Qy.emit, o = _Qy.proxy, _No = No(), r = _No.getCache, n, i, a = (0, $aAzpa.ref)(null), l = (0, $aAzpa.ref)(null);
    function s(x) {
        var k = e.vertical === !0 ? "up" : "left";
        $((o.$q.lang.rtl === !0 ? -1 : 1) * (x.direction === k ? 1 : -1));
    }
    var c = (0, $aAzpa.computed)(function() {
        return [
            [
                Yl,
                s,
                void 0,
                {
                    horizontal: e.vertical !== !0,
                    vertical: e.vertical,
                    mouse: !0
                }
            ]
        ];
    }), u = (0, $aAzpa.computed)(function() {
        return e.transitionPrev || "slide-".concat(e.vertical === !0 ? "down" : "right");
    }), v = (0, $aAzpa.computed)(function() {
        return e.transitionNext || "slide-".concat(e.vertical === !0 ? "up" : "left");
    }), f = (0, $aAzpa.computed)(function() {
        return "--q-transition-duration: ".concat(e.transitionDuration, "ms");
    }), d = (0, $aAzpa.computed)(function() {
        return typeof e.modelValue == "string" || typeof e.modelValue == "number" ? e.modelValue : String(e.modelValue);
    }), m = (0, $aAzpa.computed)(function() {
        return {
            include: e.keepAliveInclude,
            exclude: e.keepAliveExclude,
            max: e.keepAliveMax
        };
    }), y = (0, $aAzpa.computed)(function() {
        return e.keepAliveInclude !== void 0 || e.keepAliveExclude !== void 0;
    });
    (0, $aD8ZA.watch)(function() {
        return e.modelValue;
    }, function(x, k) {
        var j = h(x) === !0 ? g(x) : -1;
        i !== !0 && P(j === -1 ? 0 : j < g(k) ? -1 : 1), a.value !== j && (a.value = j, t("beforeTransition", x, k), (0, $aD8ZA.nextTick)(function() {
            t("transition", x, k);
        }));
    });
    function p() {
        $(1);
    }
    function C() {
        $(-1);
    }
    function b(x) {
        t("update:modelValue", x);
    }
    function h(x) {
        return x != null && x !== "";
    }
    function g(x) {
        return n.findIndex(function(k) {
            return k.props.name === x && k.props.disable !== "" && k.props.disable !== !0;
        });
    }
    function S() {
        return n.filter(function(x) {
            return x.props.disable !== "" && x.props.disable !== !0;
        });
    }
    function P(x) {
        var k = x !== 0 && e.animated === !0 && a.value !== -1 ? "q-transition--" + (x === -1 ? u.value : v.value) : null;
        l.value !== k && (l.value = k);
    }
    function $(x) {
        var k = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : a.value;
        var j = k + x;
        for(; j !== -1 && j < n.length;){
            var Q = n[j];
            if (Q !== void 0 && Q.props.disable !== "" && Q.props.disable !== !0) {
                P(x), i = !0, t("update:modelValue", Q.props.name), setTimeout(function() {
                    i = !1;
                });
                return;
            }
            j += x;
        }
        e.infinite === !0 && n.length !== 0 && k !== -1 && k !== n.length && $(x, x === -1 ? n.length : -1);
    }
    function L() {
        var x = g(e.modelValue);
        return a.value !== x && (a.value = x), !0;
    }
    function E() {
        var x = h(e.modelValue) === !0 && L() && n[a.value];
        return e.keepAlive === !0 ? [
            (0, $aD8ZA.h)((0, $aD8ZA.KeepAlive), m.value, [
                (0, $aD8ZA.h)(y.value === !0 ? r(d.value, function() {
                    return (0, $8typN._)((0, $8pZMQ._)({}, cm), {
                        name: d.value
                    });
                }) : cm, {
                    key: d.value,
                    style: f.value
                }, function() {
                    return x;
                })
            ])
        ] : [
            (0, $aD8ZA.h)("div", {
                class: "q-panel scroll",
                style: f.value,
                key: d.value,
                role: "tabpanel"
            }, [
                x
            ])
        ];
    }
    function A() {
        if (n.length !== 0) return e.animated === !0 ? [
            (0, $aD8ZA.h)((0, $iMtOP.Transition), {
                name: l.value
            }, E)
        ] : E();
    }
    function B(x) {
        return n = si(J(x.default, [])).filter(function(k) {
            return k.props !== null && k.props.slot === void 0 && h(k.props.name) === !0;
        }), n.length;
    }
    function q() {
        return n;
    }
    return Object.assign(o, {
        next: p,
        previous: C,
        goTo: b
    }), {
        panelIndex: a,
        panelDirectives: c,
        updatePanelsList: B,
        updatePanelIndex: L,
        getPanelContent: A,
        getEnabledPanels: S,
        getPanels: q,
        isValidPanelName: h,
        keepAliveProps: m,
        needsUniqueKeepAliveWrapper: y,
        goToPanelByOffset: $,
        goToPanel: b,
        nextPanel: p,
        previousPanel: C
    };
}
var za = 0, zi = {
    fullscreen: Boolean,
    noRouteFullscreenExit: Boolean
}, Oi = [
    "update:fullscreen",
    "fullscreen"
];
function Ii() {
    var e = (0, $aD8ZA.getCurrentInstance)(), t = e.props, o = e.emit, r = e.proxy, n, i, a, l = (0, $aAzpa.ref)(!1);
    ci(e) === !0 && (0, $aD8ZA.watch)(function() {
        return r.$route.fullPath;
    }, function() {
        t.noRouteFullscreenExit !== !0 && u();
    }), (0, $aD8ZA.watch)(function() {
        return t.fullscreen;
    }, function(v) {
        l.value !== v && s();
    }), (0, $aD8ZA.watch)(l, function(v) {
        o("update:fullscreen", v), o("fullscreen", v);
    });
    function s() {
        l.value === !0 ? u() : c();
    }
    function c() {
        l.value !== !0 && (l.value = !0, a = r.$el.parentNode, a.replaceChild(i, r.$el), document.body.appendChild(r.$el), za++, za === 1 && document.body.classList.add("q-body--fullscreen-mixin"), n = {
            handler: u
        }, Un.add(n));
    }
    function u() {
        l.value === !0 && (n !== void 0 && (Un.remove(n), n = void 0), a.replaceChild(r.$el, i), l.value = !1, za = Math.max(0, za - 1), za === 0 && (document.body.classList.remove("q-body--fullscreen-mixin"), r.$el.scrollIntoView !== void 0 && setTimeout(function() {
            r.$el.scrollIntoView();
        })));
    }
    return (0, $aD8ZA.onBeforeMount)(function() {
        i = document.createElement("span");
    }), (0, $aD8ZA.onMounted)(function() {
        t.fullscreen === !0 && c();
    }), (0, $aD8ZA.onBeforeUnmount)(u), Object.assign(r, {
        toggleFullscreen: s,
        setFullscreen: c,
        exitFullscreen: u
    }), {
        inFullscreen: l,
        toggleFullscreen: s
    };
}
var tS = [
    "top",
    "right",
    "bottom",
    "left"
], oS = [
    "regular",
    "flat",
    "outline",
    "push",
    "unelevated"
], fm = R({
    name: "QCarousel",
    props: (0, $8typN._)((0, $8pZMQ._)({}, he, Fi, zi), {
        transitionPrev: {
            type: String,
            default: "fade"
        },
        transitionNext: {
            type: String,
            default: "fade"
        },
        height: String,
        padding: Boolean,
        controlColor: String,
        controlTextColor: String,
        controlType: {
            type: String,
            validator: function(e) {
                return oS.includes(e);
            },
            default: "flat"
        },
        autoplay: [
            Number,
            Boolean
        ],
        arrows: Boolean,
        prevIcon: String,
        nextIcon: String,
        navigation: Boolean,
        navigationPosition: {
            type: String,
            validator: function(e) {
                return tS.includes(e);
            }
        },
        navigationIcon: String,
        navigationActiveIcon: String,
        thumbnails: Boolean
    }),
    emits: (0, $79xu7._)(Oi).concat((0, $79xu7._)(Di)),
    setup: function(e, param) {
        var t = param.slots;
        var _eS = (0, $aD8ZA.getCurrentInstance)(), _eS_proxy = _eS.proxy, o = _eS_proxy.$q, r = pe(e, o), n = null, i, _Vi = Vi(), a = _Vi.updatePanelsList, l = _Vi.getPanelContent, s = _Vi.panelDirectives, c = _Vi.goToPanel, u = _Vi.previousPanel, v = _Vi.nextPanel, f = _Vi.getEnabledPanels, d = _Vi.panelIndex, _Ii = Ii(), m = _Ii.inFullscreen, y = (0, $aAzpa.computed)(function() {
            return m.value !== !0 && e.height !== void 0 ? {
                height: e.height
            } : {};
        }), p = (0, $aAzpa.computed)(function() {
            return e.vertical === !0 ? "vertical" : "horizontal";
        }), C = (0, $aAzpa.computed)(function() {
            return "q-carousel q-panel-parent q-carousel--with".concat(e.padding === !0 ? "" : "out", "-padding") + (m.value === !0 ? " fullscreen" : "") + (r.value === !0 ? " q-carousel--dark q-dark" : "") + (e.arrows === !0 ? " q-carousel--arrows-".concat(p.value) : "") + (e.navigation === !0 ? " q-carousel--navigation-".concat(S.value) : "");
        }), b = (0, $aAzpa.computed)(function() {
            var A = [
                e.prevIcon || o.iconSet.carousel[e.vertical === !0 ? "up" : "left"],
                e.nextIcon || o.iconSet.carousel[e.vertical === !0 ? "down" : "right"]
            ];
            return e.vertical === !1 && o.lang.rtl === !0 ? A.reverse() : A;
        }), h = (0, $aAzpa.computed)(function() {
            return e.navigationIcon || o.iconSet.carousel.navigationIcon;
        }), g = (0, $aAzpa.computed)(function() {
            return e.navigationActiveIcon || h.value;
        }), S = (0, $aAzpa.computed)(function() {
            return e.navigationPosition || (e.vertical === !0 ? "right" : "bottom");
        }), P = (0, $aAzpa.computed)(function() {
            return {
                color: e.controlColor,
                textColor: e.controlTextColor,
                round: !0,
                [e.controlType]: !0,
                dense: !0
            };
        });
        (0, $aD8ZA.watch)(function() {
            return e.modelValue;
        }, function() {
            e.autoplay && $();
        }), (0, $aD8ZA.watch)(function() {
            return e.autoplay;
        }, function(A) {
            A ? $() : n !== null && (clearTimeout(n), n = null);
        });
        function $() {
            var A = Mo(e.autoplay) === !0 ? Math.abs(e.autoplay) : 5e3;
            n !== null && clearTimeout(n), n = setTimeout(function() {
                n = null, A >= 0 ? v() : u();
            }, A);
        }
        (0, $aD8ZA.onMounted)(function() {
            e.autoplay && $();
        }), (0, $aD8ZA.onBeforeUnmount)(function() {
            n !== null && clearTimeout(n);
        });
        function L(A, B) {
            return (0, $aD8ZA.h)("div", {
                class: "q-carousel__control q-carousel__navigation no-wrap absolute flex q-carousel__navigation--".concat(A, " q-carousel__navigation--").concat(S.value) + (e.controlColor !== void 0 ? " text-".concat(e.controlColor) : "")
            }, [
                (0, $aD8ZA.h)("div", {
                    class: "q-carousel__navigation-inner flex flex-center no-wrap"
                }, f().map(B))
            ]);
        }
        function E() {
            var A = [];
            if (e.navigation === !0) {
                var B = t["navigation-icon"] !== void 0 ? t["navigation-icon"] : function(x) {
                    return (0, $aD8ZA.h)(Le, (0, $8typN._)((0, $8pZMQ._)({
                        key: "nav" + x.name,
                        class: "q-carousel__navigation-icon q-carousel__navigation-icon--".concat(x.active === !0 ? "" : "in", "active")
                    }, x.btnProps), {
                        onClick: x.onClick
                    }));
                }, q = i - 1;
                A.push(L("buttons", function(x, k) {
                    var j = x.props.name, Q = d.value === k;
                    return B({
                        index: k,
                        maxIndex: q,
                        name: j,
                        active: Q,
                        btnProps: (0, $8pZMQ._)({
                            icon: Q === !0 ? g.value : h.value,
                            size: "sm"
                        }, P.value),
                        onClick: function() {
                            c(j);
                        }
                    });
                }));
            } else if (e.thumbnails === !0) {
                var B1 = e.controlColor !== void 0 ? " text-".concat(e.controlColor) : "";
                A.push(L("thumbnails", function(q) {
                    var x = q.props;
                    return (0, $aD8ZA.h)("img", {
                        key: "tmb#" + x.name,
                        class: "q-carousel__thumbnail q-carousel__thumbnail--".concat(x.name === e.modelValue ? "" : "in", "active") + B1,
                        src: x.imgSrc || x["img-src"],
                        onClick: function() {
                            c(x.name);
                        }
                    });
                }));
            }
            return e.arrows === !0 && d.value >= 0 && ((e.infinite === !0 || d.value > 0) && A.push((0, $aD8ZA.h)("div", {
                key: "prev",
                class: "q-carousel__control q-carousel__arrow q-carousel__prev-arrow q-carousel__prev-arrow--".concat(p.value, " absolute flex flex-center")
            }, [
                (0, $aD8ZA.h)(Le, (0, $8typN._)((0, $8pZMQ._)({
                    icon: b.value[0]
                }, P.value), {
                    onClick: u
                }))
            ])), (e.infinite === !0 || d.value < i - 1) && A.push((0, $aD8ZA.h)("div", {
                key: "next",
                class: "q-carousel__control q-carousel__arrow q-carousel__next-arrow q-carousel__next-arrow--".concat(p.value, " absolute flex flex-center")
            }, [
                (0, $aD8ZA.h)(Le, (0, $8typN._)((0, $8pZMQ._)({
                    icon: b.value[1]
                }, P.value), {
                    onClick: v
                }))
            ]))), Ke(t.control, A);
        }
        return function() {
            return i = a(t), (0, $aD8ZA.h)("div", {
                class: C.value,
                style: y.value
            }, [
                kt("div", {
                    class: "q-carousel__slides-container"
                }, l(), "sl-cont", e.swipeable, function() {
                    return s.value;
                })
            ].concat(E()));
        };
    }
});
var mm = R({
    name: "QCarouselSlide",
    props: (0, $8typN._)((0, $8pZMQ._)({}, Li), {
        imgSrc: String
    }),
    setup: function(e, param) {
        var t = param.slots;
        var o = (0, $aAzpa.computed)(function() {
            return e.imgSrc ? {
                backgroundImage: 'url("'.concat(e.imgSrc, '")')
            } : {};
        });
        return function() {
            return (0, $aD8ZA.h)("div", {
                class: "q-carousel__slide",
                style: o.value
            }, J(t.default));
        };
    }
});
var gm = R({
    name: "QCarouselControl",
    props: {
        position: {
            type: String,
            default: "bottom-right",
            validator: function(e) {
                return [
                    "top-right",
                    "top-left",
                    "bottom-right",
                    "bottom-left",
                    "top",
                    "right",
                    "bottom",
                    "left"
                ].includes(e);
            }
        },
        offset: {
            type: Array,
            default: function() {
                return [
                    18,
                    18
                ];
            },
            validator: function(e) {
                return e.length === 2;
            }
        }
    },
    setup: function(e, param) {
        var t = param.slots;
        var o = (0, $aAzpa.computed)(function() {
            return "q-carousel__control absolute absolute-".concat(e.position);
        }), r = (0, $aAzpa.computed)(function() {
            return {
                margin: "".concat(e.offset[1], "px ").concat(e.offset[0], "px")
            };
        });
        return function() {
            return (0, $aD8ZA.h)("div", {
                class: o.value,
                style: r.value
            }, J(t.default));
        };
    }
});
var hm = R({
    name: "QChatMessage",
    props: {
        sent: Boolean,
        label: String,
        bgColor: String,
        textColor: String,
        name: String,
        avatar: String,
        text: Array,
        stamp: String,
        size: String,
        labelHtml: Boolean,
        nameHtml: Boolean,
        textHtml: Boolean,
        stampHtml: Boolean
    },
    setup: function(e, param) {
        var t = param.slots;
        var o = (0, $aAzpa.computed)(function() {
            return e.sent === !0 ? "sent" : "received";
        }), r = (0, $aAzpa.computed)(function() {
            return "q-message-text-content q-message-text-content--".concat(o.value) + (e.textColor !== void 0 ? " text-".concat(e.textColor) : "");
        }), n = (0, $aAzpa.computed)(function() {
            return "q-message-text q-message-text--".concat(o.value) + (e.bgColor !== void 0 ? " text-".concat(e.bgColor) : "");
        }), i = (0, $aAzpa.computed)(function() {
            return "q-message-container row items-end no-wrap" + (e.sent === !0 ? " reverse" : "");
        }), a = (0, $aAzpa.computed)(function() {
            return e.size !== void 0 ? "col-".concat(e.size) : "";
        }), l = (0, $aAzpa.computed)(function() {
            return {
                msg: e.textHtml === !0 ? "innerHTML" : "textContent",
                stamp: e.stampHtml === !0 ? "innerHTML" : "textContent",
                name: e.nameHtml === !0 ? "innerHTML" : "textContent",
                label: e.labelHtml === !0 ? "innerHTML" : "textContent"
            };
        });
        function s(u) {
            return t.stamp !== void 0 ? [
                u,
                (0, $aD8ZA.h)("div", {
                    class: "q-message-stamp"
                }, t.stamp())
            ] : e.stamp ? [
                u,
                (0, $aD8ZA.h)("div", {
                    class: "q-message-stamp",
                    [l.value.stamp]: e.stamp
                })
            ] : [
                u
            ];
        }
        function c(u, v) {
            var f = v === !0 ? u.length > 1 ? function(d) {
                return d;
            } : function(d) {
                return (0, $aD8ZA.h)("div", [
                    d
                ]);
            } : function(d) {
                return (0, $aD8ZA.h)("div", {
                    [l.value.msg]: d
                });
            };
            return u.map(function(d, m) {
                return (0, $aD8ZA.h)("div", {
                    key: m,
                    class: n.value
                }, [
                    (0, $aD8ZA.h)("div", {
                        class: r.value
                    }, s(f(d)))
                ]);
            });
        }
        return function() {
            var u = [];
            t.avatar !== void 0 ? u.push(t.avatar()) : e.avatar !== void 0 && u.push((0, $aD8ZA.h)("img", {
                class: "q-message-avatar q-message-avatar--".concat(o.value),
                src: e.avatar,
                "aria-hidden": "true"
            }));
            var v = [];
            t.name !== void 0 ? v.push((0, $aD8ZA.h)("div", {
                class: "q-message-name q-message-name--".concat(o.value)
            }, t.name())) : e.name !== void 0 && v.push((0, $aD8ZA.h)("div", {
                class: "q-message-name q-message-name--".concat(o.value),
                [l.value.name]: e.name
            })), t.default !== void 0 ? v.push(c(si(t.default()), !0)) : e.text !== void 0 && v.push(c(e.text)), u.push((0, $aD8ZA.h)("div", {
                class: a.value
            }, v));
            var f = [];
            return t.label !== void 0 ? f.push((0, $aD8ZA.h)("div", {
                class: "q-message-label"
            }, t.label())) : e.label !== void 0 && f.push((0, $aD8ZA.h)("div", {
                class: "q-message-label",
                [l.value.label]: e.label
            })), f.push((0, $aD8ZA.h)("div", {
                class: i.value
            }, u)), (0, $aD8ZA.h)("div", {
                class: "q-message q-message-".concat(o.value)
            }, f);
        };
    }
});
function Xl(e, t) {
    var o = (0, $aAzpa.ref)(null), r = (0, $aAzpa.computed)(function() {
        return e.disable === !0 ? null : (0, $aD8ZA.h)("span", {
            ref: o,
            class: "no-outline",
            tabindex: -1
        });
    });
    function n(i) {
        var a = t.value;
        i !== void 0 && i.type.indexOf("key") === 0 ? a !== null && document.activeElement !== a && a.contains(document.activeElement) === !0 && a.focus() : o.value !== null && (i === void 0 || a !== null && a.contains(i.target) === !0) && o.value.focus();
    }
    return {
        refocusTargetEl: r,
        refocusTarget: n
    };
}
var Gl = {
    xs: 30,
    sm: 35,
    md: 40,
    lg: 50,
    xl: 60
};
var Zl = (0, $8typN._)((0, $8pZMQ._)({}, he, Ot, _t), {
    modelValue: {
        required: !0,
        default: null
    },
    val: {},
    trueValue: {
        default: !0
    },
    falseValue: {
        default: !1
    },
    indeterminateValue: {
        default: null
    },
    checkedIcon: String,
    uncheckedIcon: String,
    indeterminateIcon: String,
    toggleOrder: {
        type: String,
        validator: function(e) {
            return e === "tf" || e === "ft";
        }
    },
    toggleIndeterminate: Boolean,
    label: String,
    leftLabel: Boolean,
    color: String,
    keepColor: Boolean,
    dense: Boolean,
    disable: Boolean,
    tabindex: [
        String,
        Number
    ]
}), Jl = [
    "update:modelValue"
];
function eu(e, t) {
    var _cS = (0, $aD8ZA.getCurrentInstance)(), o = _cS.props, r = _cS.slots, n = _cS.emit, i = _cS.proxy, a = i.$q, l = pe(o, a), s = (0, $aAzpa.ref)(null), _Xl = Xl(o, s), c = _Xl.refocusTargetEl, u = _Xl.refocusTarget, v = It(o, Gl), f = (0, $aAzpa.computed)(function() {
        return o.val !== void 0 && Array.isArray(o.modelValue);
    }), d = (0, $aAzpa.computed)(function() {
        var q = (0, $aAzpa.toRaw)(o.val);
        return f.value === !0 ? o.modelValue.findIndex(function(x) {
            return (0, $aAzpa.toRaw)(x) === q;
        }) : -1;
    }), m = (0, $aAzpa.computed)(function() {
        return f.value === !0 ? d.value !== -1 : (0, $aAzpa.toRaw)(o.modelValue) === (0, $aAzpa.toRaw)(o.trueValue);
    }), y = (0, $aAzpa.computed)(function() {
        return f.value === !0 ? d.value === -1 : (0, $aAzpa.toRaw)(o.modelValue) === (0, $aAzpa.toRaw)(o.falseValue);
    }), p = (0, $aAzpa.computed)(function() {
        return m.value === !1 && y.value === !1;
    }), C = (0, $aAzpa.computed)(function() {
        return o.disable === !0 ? -1 : o.tabindex || 0;
    }), b = (0, $aAzpa.computed)(function() {
        return "q-".concat(e, " cursor-pointer no-outline row inline no-wrap items-center") + (o.disable === !0 ? " disabled" : "") + (l.value === !0 ? " q-".concat(e, "--dark") : "") + (o.dense === !0 ? " q-".concat(e, "--dense") : "") + (o.leftLabel === !0 ? " reverse" : "");
    }), h = (0, $aAzpa.computed)(function() {
        var q = m.value === !0 ? "truthy" : y.value === !0 ? "falsy" : "indet", x = o.color !== void 0 && (o.keepColor === !0 || (e === "toggle" ? m.value === !0 : y.value !== !0)) ? " text-".concat(o.color) : "";
        return "q-".concat(e, "__inner relative-position non-selectable q-").concat(e, "__inner--").concat(q).concat(x);
    }), g = (0, $aAzpa.computed)(function() {
        var q = {
            type: "checkbox"
        };
        return o.name !== void 0 && Object.assign(q, {
            ".checked": m.value,
            "^checked": m.value === !0 ? "checked" : void 0,
            name: o.name,
            value: f.value === !0 ? o.val : o.trueValue
        }), q;
    }), S = eo(g), P = (0, $aAzpa.computed)(function() {
        var q = {
            tabindex: C.value,
            role: e === "toggle" ? "switch" : "checkbox",
            "aria-label": o.label,
            "aria-checked": p.value === !0 ? "mixed" : m.value === !0 ? "true" : "false"
        };
        return o.disable === !0 && (q["aria-disabled"] = "true"), q;
    });
    function $(q) {
        q !== void 0 && (Se(q), u(q)), o.disable !== !0 && n("update:modelValue", L(), q);
    }
    function L() {
        if (f.value === !0) {
            if (m.value === !0) {
                var q = o.modelValue.slice();
                return q.splice(d.value, 1), q;
            }
            return o.modelValue.concat([
                o.val
            ]);
        }
        if (m.value === !0) {
            if (o.toggleOrder !== "ft" || o.toggleIndeterminate === !1) return o.falseValue;
        } else if (y.value === !0) {
            if (o.toggleOrder === "ft" || o.toggleIndeterminate === !1) return o.trueValue;
        } else return o.toggleOrder !== "ft" ? o.trueValue : o.falseValue;
        return o.indeterminateValue;
    }
    function E(q) {
        (q.keyCode === 13 || q.keyCode === 32) && Se(q);
    }
    function A(q) {
        (q.keyCode === 13 || q.keyCode === 32) && $(q);
    }
    var B = t(m, p);
    return Object.assign(i, {
        toggle: $
    }), function() {
        var q = B();
        o.disable !== !0 && S(q, "unshift", " q-".concat(e, "__native absolute q-ma-none q-pa-none"));
        var x = [
            (0, $aD8ZA.h)("div", {
                class: h.value,
                style: v.value,
                "aria-hidden": "true"
            }, q)
        ];
        c.value !== null && x.push(c.value);
        var k = o.label !== void 0 ? Ke(r.default, [
            o.label
        ]) : J(r.default);
        return k !== void 0 && x.push((0, $aD8ZA.h)("div", {
            class: "q-".concat(e, "__label q-anchor--skip")
        }, k)), (0, $aD8ZA.h)("div", (0, $8typN._)((0, $8pZMQ._)({
            ref: s,
            class: b.value
        }, P.value), {
            onClick: $,
            onKeydown: E,
            onKeyup: A
        }), x);
    };
}
var fS = (0, $aD8ZA.h)("div", {
    key: "svg",
    class: "q-checkbox__bg absolute"
}, [
    (0, $aD8ZA.h)("svg", {
        class: "q-checkbox__svg fit absolute-full",
        viewBox: "0 0 24 24"
    }, [
        (0, $aD8ZA.h)("path", {
            class: "q-checkbox__truthy",
            fill: "none",
            d: "M1.73,12.91 8.1,19.28 22.79,4.59"
        }),
        (0, $aD8ZA.h)("path", {
            class: "q-checkbox__indet",
            d: "M4,14H20V10H4"
        })
    ])
]), fn = R({
    name: "QCheckbox",
    props: Zl,
    emits: Jl,
    setup: function(e) {
        function t(o, r) {
            var n = (0, $aAzpa.computed)(function() {
                return (o.value === !0 ? e.checkedIcon : r.value === !0 ? e.indeterminateIcon : e.uncheckedIcon) || null;
            });
            return function() {
                return n.value !== null ? [
                    (0, $aD8ZA.h)("div", {
                        key: "icon",
                        class: "q-checkbox__icon-container absolute-full flex flex-center no-wrap"
                    }, [
                        (0, $aD8ZA.h)(we, {
                            class: "q-checkbox__icon",
                            name: n.value
                        })
                    ])
                ] : [
                    fS
                ];
            };
        }
        return eu("checkbox", t);
    }
});
var vS = {
    xs: 8,
    sm: 10,
    md: 14,
    lg: 20,
    xl: 24
}, Ki = R({
    name: "QChip",
    props: (0, $8typN._)((0, $8pZMQ._)({}, he, Ot), {
        dense: Boolean,
        icon: String,
        iconRight: String,
        iconRemove: String,
        iconSelected: String,
        label: [
            String,
            Number
        ],
        color: String,
        textColor: String,
        modelValue: {
            type: Boolean,
            default: !0
        },
        selected: {
            type: Boolean,
            default: null
        },
        square: Boolean,
        outline: Boolean,
        clickable: Boolean,
        removable: Boolean,
        removeAriaLabel: String,
        tabindex: [
            String,
            Number
        ],
        disable: Boolean,
        ripple: {
            type: [
                Boolean,
                Object
            ],
            default: !0
        }
    }),
    emits: [
        "update:modelValue",
        "update:selected",
        "remove",
        "click"
    ],
    setup: function(e, param) {
        var t = param.slots, o = param.emit;
        var _mS = (0, $aD8ZA.getCurrentInstance)(), _mS_proxy = _mS.proxy, r = _mS_proxy.$q, n = pe(e, r), i = It(e, vS), a = (0, $aAzpa.computed)(function() {
            return e.selected === !0 || e.icon !== void 0;
        }), l = (0, $aAzpa.computed)(function() {
            return e.selected === !0 ? e.iconSelected || r.iconSet.chip.selected : e.icon;
        }), s = (0, $aAzpa.computed)(function() {
            return e.iconRemove || r.iconSet.chip.remove;
        }), c = (0, $aAzpa.computed)(function() {
            return e.disable === !1 && (e.clickable === !0 || e.selected !== null);
        }), u = (0, $aAzpa.computed)(function() {
            var p = e.outline === !0 && e.color || e.textColor;
            return "q-chip row inline no-wrap items-center" + (e.outline === !1 && e.color !== void 0 ? " bg-".concat(e.color) : "") + (p ? " text-".concat(p, " q-chip--colored") : "") + (e.disable === !0 ? " disabled" : "") + (e.dense === !0 ? " q-chip--dense" : "") + (e.outline === !0 ? " q-chip--outline" : "") + (e.selected === !0 ? " q-chip--selected" : "") + (c.value === !0 ? " q-chip--clickable cursor-pointer non-selectable q-hoverable" : "") + (e.square === !0 ? " q-chip--square" : "") + (n.value === !0 ? " q-chip--dark q-dark" : "");
        }), v = (0, $aAzpa.computed)(function() {
            var p = e.disable === !0 ? {
                tabindex: -1,
                "aria-disabled": "true"
            } : {
                tabindex: e.tabindex || 0
            }, C = (0, $8typN._)((0, $8pZMQ._)({}, p), {
                role: "button",
                "aria-hidden": "false",
                "aria-label": e.removeAriaLabel || r.lang.label.remove
            });
            return {
                chip: p,
                remove: C
            };
        });
        function f(p) {
            p.keyCode === 13 && d(p);
        }
        function d(p) {
            e.disable || (o("update:selected", !e.selected), o("click", p));
        }
        function m(p) {
            (p.keyCode === void 0 || p.keyCode === 13) && (Se(p), e.disable === !1 && (o("update:modelValue", !1), o("remove")));
        }
        function y() {
            var p = [];
            c.value === !0 && p.push((0, $aD8ZA.h)("div", {
                class: "q-focus-helper"
            })), a.value === !0 && p.push((0, $aD8ZA.h)(we, {
                class: "q-chip__icon q-chip__icon--left",
                name: l.value
            }));
            var C = e.label !== void 0 ? [
                (0, $aD8ZA.h)("div", {
                    class: "ellipsis"
                }, [
                    e.label
                ])
            ] : void 0;
            return p.push((0, $aD8ZA.h)("div", {
                class: "q-chip__content col row no-wrap items-center q-anchor--skip"
            }, ai(t.default, C))), e.iconRight && p.push((0, $aD8ZA.h)(we, {
                class: "q-chip__icon q-chip__icon--right",
                name: e.iconRight
            })), e.removable === !0 && p.push((0, $aD8ZA.h)(we, (0, $8typN._)((0, $8pZMQ._)({
                class: "q-chip__icon q-chip__icon--remove cursor-pointer",
                name: s.value
            }, v.value.remove), {
                onClick: m,
                onKeyup: m
            }))), p;
        }
        return function() {
            if (e.modelValue === !1) return;
            var p = {
                class: u.value,
                style: i.value
            };
            return c.value === !0 && Object.assign(p, v.value.chip, {
                onClick: d,
                onKeyup: f
            }), kt("div", p, y(), "ripple", e.ripple !== !1 && e.disable !== !0, function() {
                return [
                    [
                        rn,
                        e.ripple
                    ]
                ];
            });
        };
    }
});
var Oa = (0, $8typN._)((0, $8pZMQ._)({}, Ot), {
    min: {
        type: Number,
        default: 0
    },
    max: {
        type: Number,
        default: 100
    },
    color: String,
    centerColor: String,
    trackColor: String,
    fontSize: String,
    rounded: Boolean,
    thickness: {
        type: Number,
        default: .2,
        validator: function(e) {
            return e >= 0 && e <= 1;
        }
    },
    angle: {
        type: Number,
        default: 0
    },
    showValue: Boolean,
    reverse: Boolean,
    instantFeedback: Boolean
});
var _c = 50, pm = 2 * _c, bm = pm * Math.PI, hS = Math.round(bm * 1e3) / 1e3, Yi = R({
    name: "QCircularProgress",
    props: (0, $8typN._)((0, $8pZMQ._)({}, Oa), {
        value: {
            type: Number,
            default: 0
        },
        animationSpeed: {
            type: [
                String,
                Number
            ],
            default: 600
        },
        indeterminate: Boolean
    }),
    setup: function(e, param) {
        var t = param.slots;
        var _gS = (0, $aD8ZA.getCurrentInstance)(), _gS_proxy = _gS.proxy, o = _gS_proxy.$q, r = It(e), n = (0, $aAzpa.computed)(function() {
            var d = (o.lang.rtl === !0 ? -1 : 1) * e.angle;
            return {
                transform: e.reverse !== (o.lang.rtl === !0) ? "scale3d(-1, 1, 1) rotate3d(0, 0, 1, ".concat(-90 - d, "deg)") : "rotate3d(0, 0, 1, ".concat(d - 90, "deg)")
            };
        }), i = (0, $aAzpa.computed)(function() {
            return e.instantFeedback !== !0 && e.indeterminate !== !0 ? {
                transition: "stroke-dashoffset ".concat(e.animationSpeed, "ms ease 0s, stroke ").concat(e.animationSpeed, "ms ease")
            } : "";
        }), a = (0, $aAzpa.computed)(function() {
            return pm / (1 - e.thickness / 2);
        }), l = (0, $aAzpa.computed)(function() {
            return "".concat(a.value / 2, " ").concat(a.value / 2, " ").concat(a.value, " ").concat(a.value);
        }), s = (0, $aAzpa.computed)(function() {
            return Ze(e.value, e.min, e.max);
        }), c = (0, $aAzpa.computed)(function() {
            return e.max - e.min;
        }), u = (0, $aAzpa.computed)(function() {
            return e.thickness / 2 * a.value;
        }), v = (0, $aAzpa.computed)(function() {
            var d = (e.max - s.value) / c.value, m = e.rounded === !0 && s.value < e.max && d < .25 ? u.value / 2 * (1 - d / .25) : 0;
            return bm * d + m;
        });
        function f(param) {
            var d = param.thickness, m = param.offset, y = param.color, p = param.cls, C = param.rounded;
            return (0, $aD8ZA.h)("circle", {
                class: "q-circular-progress__" + p + (y !== void 0 ? " text-".concat(y) : ""),
                style: i.value,
                fill: "transparent",
                stroke: "currentColor",
                "stroke-width": d,
                "stroke-dasharray": hS,
                "stroke-dashoffset": m,
                "stroke-linecap": C,
                cx: a.value,
                cy: a.value,
                r: _c
            });
        }
        return function() {
            var d = [];
            e.centerColor !== void 0 && e.centerColor !== "transparent" && d.push((0, $aD8ZA.h)("circle", {
                class: "q-circular-progress__center text-".concat(e.centerColor),
                fill: "currentColor",
                r: _c - u.value / 2,
                cx: a.value,
                cy: a.value
            })), e.trackColor !== void 0 && e.trackColor !== "transparent" && d.push(f({
                cls: "track",
                thickness: u.value,
                offset: 0,
                color: e.trackColor
            })), d.push(f({
                cls: "circle",
                thickness: u.value,
                offset: v.value,
                color: e.color,
                rounded: e.rounded === !0 ? "round" : void 0
            }));
            var m = [
                (0, $aD8ZA.h)("svg", {
                    class: "q-circular-progress__svg",
                    style: n.value,
                    viewBox: l.value,
                    "aria-hidden": "true"
                }, d)
            ];
            return e.showValue === !0 && m.push((0, $aD8ZA.h)("div", {
                class: "q-circular-progress__text absolute-full row flex-center content-center",
                style: {
                    fontSize: e.fontSize
                }
            }, t.default !== void 0 ? t.default() : [
                (0, $aD8ZA.h)("div", s.value)
            ])), (0, $aD8ZA.h)("div", {
                class: "q-circular-progress q-circular-progress--".concat(e.indeterminate === !0 ? "in" : "", "determinate"),
                style: r.value,
                role: "progressbar",
                "aria-valuemin": e.min,
                "aria-valuemax": e.max,
                "aria-valuenow": e.indeterminate === !0 ? void 0 : s.value
            }, ai(t.internal, m));
        };
    }
});
function Cc(e, t, o) {
    var r = yt(e), n, i = r.left - t.event.x, a = r.top - t.event.y, l = Math.abs(i), s = Math.abs(a), c = t.direction;
    c.horizontal === !0 && c.vertical !== !0 ? n = i < 0 ? "left" : "right" : c.horizontal !== !0 && c.vertical === !0 ? n = a < 0 ? "up" : "down" : c.up === !0 && a < 0 ? (n = "up", l > s && (c.left === !0 && i < 0 ? n = "left" : c.right === !0 && i > 0 && (n = "right"))) : c.down === !0 && a > 0 ? (n = "down", l > s && (c.left === !0 && i < 0 ? n = "left" : c.right === !0 && i > 0 && (n = "right"))) : c.left === !0 && i < 0 ? (n = "left", l < s && (c.up === !0 && a < 0 ? n = "up" : c.down === !0 && a > 0 && (n = "down"))) : c.right === !0 && i > 0 && (n = "right", l < s && (c.up === !0 && a < 0 ? n = "up" : c.down === !0 && a > 0 && (n = "down")));
    var u = !1;
    if (n === void 0 && o === !1) {
        if (t.event.isFirst === !0 || t.event.lastDir === void 0) return {};
        n = t.event.lastDir, u = !0, n === "left" || n === "right" ? (r.left -= i, l = 0, i = 0) : (r.top -= a, s = 0, a = 0);
    }
    return {
        synthetic: u,
        payload: {
            evt: e,
            touch: t.event.mouse !== !0,
            mouse: t.event.mouse === !0,
            position: r,
            direction: n,
            isFirst: t.event.isFirst,
            isFinal: o === !0,
            duration: Date.now() - t.event.time,
            distance: {
                x: l,
                y: s
            },
            offset: {
                x: i,
                y: a
            },
            delta: {
                x: r.left - t.event.lastX,
                y: r.top - t.event.lastY
            }
        }
    };
}
var pS = 0, qt = Mt({
    name: "touch-pan",
    beforeMount: function(e, param) {
        var t = param.value, o = param.modifiers;
        if (o.mouse !== !0 && Ce.has.touch !== !0) return;
        function r(i, a) {
            o.mouse === !0 && a === !0 ? Se(i) : (o.stop === !0 && tt(i), o.prevent === !0 && ut(i));
        }
        var n = {
            uid: "qvtp_" + pS++,
            handler: t,
            modifiers: o,
            direction: Ei(o),
            noop: Qe,
            mouseStart: function(i) {
                Bi(i, n) && Tn(i) && (lt(n, "temp", [
                    [
                        document,
                        "mousemove",
                        "move",
                        "notPassiveCapture"
                    ],
                    [
                        document,
                        "mouseup",
                        "end",
                        "passiveCapture"
                    ]
                ]), n.start(i, !0));
            },
            touchStart: function(i) {
                if (Bi(i, n)) {
                    var a = i.target;
                    lt(n, "temp", [
                        [
                            a,
                            "touchmove",
                            "move",
                            "notPassiveCapture"
                        ],
                        [
                            a,
                            "touchcancel",
                            "end",
                            "passiveCapture"
                        ],
                        [
                            a,
                            "touchend",
                            "end",
                            "passiveCapture"
                        ]
                    ]), n.start(i);
                }
            },
            start: function(i, a) {
                if (Ce.is.firefox === !0 && Mn(e, !0), n.lastEvt = i, a === !0 || o.stop === !0) {
                    if (n.direction.all !== !0 && (a !== !0 || n.modifiers.mouseAllDir !== !0 && n.modifiers.mousealldir !== !0)) {
                        var c = i.type.indexOf("mouse") !== -1 ? new MouseEvent(i.type, i) : new TouchEvent(i.type, i);
                        i.defaultPrevented === !0 && ut(c), i.cancelBubble === !0 && tt(c), Object.assign(c, {
                            qKeyEvent: i.qKeyEvent,
                            qClickOutside: i.qClickOutside,
                            qAnchorHandled: i.qAnchorHandled,
                            qClonedBy: i.qClonedBy === void 0 ? [
                                n.uid
                            ] : i.qClonedBy.concat(n.uid)
                        }), n.initialEvent = {
                            target: i.target,
                            event: c
                        };
                    }
                    tt(i);
                }
                var _yt = yt(i), l = _yt.left, s = _yt.top;
                n.event = {
                    x: l,
                    y: s,
                    time: Date.now(),
                    mouse: a === !0,
                    detected: !1,
                    isFirst: !0,
                    isFinal: !1,
                    lastX: l,
                    lastY: s
                };
            },
            move: function(i) {
                if (n.event === void 0) return;
                var a = yt(i), l = a.left - n.event.x, s = a.top - n.event.y;
                if (l === 0 && s === 0) return;
                n.lastEvt = i;
                var c = n.event.mouse === !0, u = function() {
                    r(i, c);
                    var d;
                    o.preserveCursor !== !0 && o.preservecursor !== !0 && (d = document.documentElement.style.cursor || "", document.documentElement.style.cursor = "grabbing"), c === !0 && document.body.classList.add("no-pointer-events--children"), document.body.classList.add("non-selectable"), Ut(), n.styleCleanup = function(m) {
                        if (n.styleCleanup = void 0, d !== void 0 && (document.documentElement.style.cursor = d), document.body.classList.remove("non-selectable"), c === !0) {
                            var y = function() {
                                document.body.classList.remove("no-pointer-events--children");
                            };
                            m !== void 0 ? setTimeout(function() {
                                y(), m();
                            }, 50) : y();
                        } else m !== void 0 && m();
                    };
                };
                if (n.event.detected === !0) {
                    n.event.isFirst !== !0 && r(i, n.event.mouse);
                    var _Cc = Cc(i, n, !1), d = _Cc.payload, m = _Cc.synthetic;
                    d !== void 0 && (n.handler(d) === !1 ? n.end(i) : (n.styleCleanup === void 0 && n.event.isFirst === !0 && u(), n.event.lastX = d.position.left, n.event.lastY = d.position.top, n.event.lastDir = m === !0 ? void 0 : d.direction, n.event.isFirst = !1));
                    return;
                }
                if (n.direction.all === !0 || c === !0 && (n.modifiers.mouseAllDir === !0 || n.modifiers.mousealldir === !0)) {
                    u(), n.event.detected = !0, n.move(i);
                    return;
                }
                var v = Math.abs(l), f = Math.abs(s);
                v !== f && (n.direction.horizontal === !0 && v > f || n.direction.vertical === !0 && v < f || n.direction.up === !0 && v < f && s < 0 || n.direction.down === !0 && v < f && s > 0 || n.direction.left === !0 && v > f && l < 0 || n.direction.right === !0 && v > f && l > 0 ? (n.event.detected = !0, n.move(i)) : n.end(i, !0));
            },
            end: function(i, a) {
                if (n.event !== void 0) {
                    if (Ct(n, "temp"), Ce.is.firefox === !0 && Mn(e, !1), a === !0) n.styleCleanup !== void 0 && n.styleCleanup(), n.event.detected !== !0 && n.initialEvent !== void 0 && n.initialEvent.target.dispatchEvent(n.initialEvent.event);
                    else if (n.event.detected === !0) {
                        n.event.isFirst === !0 && n.handler(Cc(i === void 0 ? n.lastEvt : i, n).payload);
                        var _Cc = Cc(i === void 0 ? n.lastEvt : i, n, !0), l = _Cc.payload, s = function() {
                            n.handler(l);
                        };
                        n.styleCleanup !== void 0 ? n.styleCleanup(s) : s();
                    }
                    n.event = void 0, n.initialEvent = void 0, n.lastEvt = void 0;
                }
            }
        };
        if (e.__qtouchpan = n, o.mouse === !0) {
            var i = o.mouseCapture === !0 || o.mousecapture === !0 ? "Capture" : "";
            lt(n, "main", [
                [
                    e,
                    "mousedown",
                    "mouseStart",
                    "passive".concat(i)
                ]
            ]);
        }
        Ce.has.touch === !0 && lt(n, "main", [
            [
                e,
                "touchstart",
                "touchStart",
                "passive".concat(o.capture === !0 ? "Capture" : "")
            ],
            [
                e,
                "touchmove",
                "noop",
                "notPassiveCapture"
            ]
        ]);
    },
    updated: function(e, t) {
        var o = e.__qtouchpan;
        o !== void 0 && (t.oldValue !== t.value && (typeof value != "function" && o.end(), o.handler = t.value), o.direction = Ei(t.modifiers));
    },
    beforeUnmount: function(e) {
        var t = e.__qtouchpan;
        t !== void 0 && (t.event !== void 0 && t.end(), Ct(t, "main"), Ct(t, "temp"), Ce.is.firefox === !0 && Mn(e, !1), t.styleCleanup !== void 0 && t.styleCleanup(), delete e.__qtouchpan);
    }
});
var ym = "q-slider__marker-labels", SS = function(e) {
    return {
        value: e
    };
}, xS = function(param) {
    var e = param.marker;
    return (0, $aD8ZA.h)("div", {
        key: e.value,
        style: e.style,
        class: e.classes
    }, e.label);
}, Ia = [
    34,
    37,
    40,
    33,
    39,
    38
], ou = (0, $8typN._)((0, $8pZMQ._)({}, he, _t), {
    min: {
        type: Number,
        default: 0
    },
    max: {
        type: Number,
        default: 100
    },
    innerMin: Number,
    innerMax: Number,
    step: {
        type: Number,
        default: 1,
        validator: function(e) {
            return e >= 0;
        }
    },
    snap: Boolean,
    vertical: Boolean,
    reverse: Boolean,
    hideSelection: Boolean,
    color: String,
    markerLabelsClass: String,
    label: Boolean,
    labelColor: String,
    labelTextColor: String,
    labelAlways: Boolean,
    switchLabelSide: Boolean,
    markers: [
        Boolean,
        Number
    ],
    markerLabels: [
        Boolean,
        Array,
        Object,
        Function
    ],
    switchMarkerLabelsSide: Boolean,
    trackImg: String,
    trackColor: String,
    innerTrackImg: String,
    innerTrackColor: String,
    selectionColor: String,
    selectionImg: String,
    thumbSize: {
        type: String,
        default: "20px"
    },
    trackSize: {
        type: String,
        default: "4px"
    },
    disable: Boolean,
    readonly: Boolean,
    dense: Boolean,
    tabindex: [
        String,
        Number
    ],
    thumbColor: String,
    thumbPath: {
        type: String,
        default: "M 4, 10 a 6,6 0 1,0 12,0 a 6,6 0 1,0 -12,0"
    }
}), nu = [
    "pan",
    "update:modelValue",
    "change"
];
function ru(param) {
    var e = param.updateValue, t = param.updatePosition, o = param.getDragging, r = param.formAttrs;
    var _yS = (0, $aD8ZA.getCurrentInstance)(), n = _yS.props, i = _yS.emit, a = _yS.slots, _yS_proxy = _yS.proxy, l = _yS_proxy.$q, s = pe(n, l), c = eo(r), u = (0, $aAzpa.ref)(!1), v = (0, $aAzpa.ref)(!1), f = (0, $aAzpa.ref)(!1), d = (0, $aAzpa.ref)(!1), m = (0, $aAzpa.computed)(function() {
        return n.vertical === !0 ? "--v" : "--h";
    }), y = (0, $aAzpa.computed)(function() {
        return "-" + (n.switchLabelSide === !0 ? "switched" : "standard");
    }), p = (0, $aAzpa.computed)(function() {
        return n.vertical === !0 ? n.reverse === !0 : n.reverse !== (l.lang.rtl === !0);
    }), C = (0, $aAzpa.computed)(function() {
        return isNaN(n.innerMin) === !0 || n.innerMin < n.min ? n.min : n.innerMin;
    }), b = (0, $aAzpa.computed)(function() {
        return isNaN(n.innerMax) === !0 || n.innerMax > n.max ? n.max : n.innerMax;
    }), h = (0, $aAzpa.computed)(function() {
        return n.disable !== !0 && n.readonly !== !0 && C.value < b.value;
    }), g = (0, $aAzpa.computed)(function() {
        if (n.step === 0) return function(ee) {
            return ee;
        };
        var K = (String(n.step).trim().split(".")[1] || "").length;
        return function(ee) {
            return parseFloat(ee.toFixed(K));
        };
    }), S = (0, $aAzpa.computed)(function() {
        return n.step === 0 ? 1 : n.step;
    }), P = (0, $aAzpa.computed)(function() {
        return h.value === !0 ? n.tabindex || 0 : -1;
    }), $ = (0, $aAzpa.computed)(function() {
        return n.max - n.min;
    }), L = (0, $aAzpa.computed)(function() {
        return b.value - C.value;
    }), E = (0, $aAzpa.computed)(function() {
        return _e(C.value);
    }), A = (0, $aAzpa.computed)(function() {
        return _e(b.value);
    }), B = (0, $aAzpa.computed)(function() {
        return n.vertical === !0 ? p.value === !0 ? "bottom" : "top" : p.value === !0 ? "right" : "left";
    }), q = (0, $aAzpa.computed)(function() {
        return n.vertical === !0 ? "height" : "width";
    }), x = (0, $aAzpa.computed)(function() {
        return n.vertical === !0 ? "width" : "height";
    }), k = (0, $aAzpa.computed)(function() {
        return n.vertical === !0 ? "vertical" : "horizontal";
    }), j = (0, $aAzpa.computed)(function() {
        var K = {
            role: "slider",
            "aria-valuemin": C.value,
            "aria-valuemax": b.value,
            "aria-orientation": k.value,
            "data-step": n.step
        };
        return n.disable === !0 ? K["aria-disabled"] = "true" : n.readonly === !0 && (K["aria-readonly"] = "true"), K;
    }), Q = (0, $aAzpa.computed)(function() {
        return "q-slider q-slider".concat(m.value, " q-slider--").concat(u.value === !0 ? "" : "in", "active inline no-wrap ") + (n.vertical === !0 ? "row" : "column") + (n.disable === !0 ? " disabled" : " q-slider--enabled" + (h.value === !0 ? " q-slider--editable" : "")) + (f.value === "both" ? " q-slider--focus" : "") + (n.label || n.labelAlways === !0 ? " q-slider--label" : "") + (n.labelAlways === !0 ? " q-slider--label-always" : "") + (s.value === !0 ? " q-slider--dark" : "") + (n.dense === !0 ? " q-slider--dense q-slider--dense" + m.value : "");
    });
    function w(K) {
        var ee = "q-slider__" + K;
        return "".concat(ee, " ").concat(ee).concat(m.value, " ").concat(ee).concat(m.value).concat(y.value);
    }
    function H(K) {
        var ee = "q-slider__" + K;
        return "".concat(ee, " ").concat(ee).concat(m.value);
    }
    var W = (0, $aAzpa.computed)(function() {
        var K = n.selectionColor || n.color;
        return "q-slider__selection absolute" + (K !== void 0 ? " text-".concat(K) : "");
    }), ie = (0, $aAzpa.computed)(function() {
        return H("markers") + " absolute overflow-hidden";
    }), V = (0, $aAzpa.computed)(function() {
        return H("track-container");
    }), _ = (0, $aAzpa.computed)(function() {
        return w("pin");
    }), N = (0, $aAzpa.computed)(function() {
        return w("label");
    }), I = (0, $aAzpa.computed)(function() {
        return w("text-container");
    }), oe = (0, $aAzpa.computed)(function() {
        return w("marker-labels-container") + (n.markerLabelsClass !== void 0 ? " ".concat(n.markerLabelsClass) : "");
    }), T = (0, $aAzpa.computed)(function() {
        return "q-slider__track relative-position no-outline" + (n.trackColor !== void 0 ? " bg-".concat(n.trackColor) : "");
    }), D = (0, $aAzpa.computed)(function() {
        var K = {
            [x.value]: n.trackSize
        };
        return n.trackImg !== void 0 && (K.backgroundImage = "url(".concat(n.trackImg, ") !important")), K;
    }), te = (0, $aAzpa.computed)(function() {
        return "q-slider__inner absolute" + (n.innerTrackColor !== void 0 ? " bg-".concat(n.innerTrackColor) : "");
    }), z = (0, $aAzpa.computed)(function() {
        var K = A.value - E.value, ee = {
            [B.value]: "".concat(100 * E.value, "%"),
            [q.value]: K === 0 ? "2px" : "".concat(100 * K, "%")
        };
        return n.innerTrackImg !== void 0 && (ee.backgroundImage = "url(".concat(n.innerTrackImg, ") !important")), ee;
    });
    function ue(K) {
        var ee = n.min, ke = n.max, ze = n.step, ye = ee + K * (ke - ee);
        if (ze > 0) {
            var Ge = (ye - C.value) % ze;
            ye += (Math.abs(Ge) >= ze / 2 ? (Ge < 0 ? -1 : 1) * ze : 0) - Ge;
        }
        return ye = g.value(ye), Ze(ye, C.value, b.value);
    }
    function _e(K) {
        return $.value === 0 ? 0 : (K - n.min) / $.value;
    }
    function U(K, ee) {
        var ke = yt(K), ze = n.vertical === !0 ? Ze((ke.top - ee.top) / ee.height, 0, 1) : Ze((ke.left - ee.left) / ee.width, 0, 1);
        return Ze(p.value === !0 ? 1 - ze : ze, E.value, A.value);
    }
    var ae = (0, $aAzpa.computed)(function() {
        return Mo(n.markers) === !0 ? n.markers : S.value;
    }), ce = (0, $aAzpa.computed)(function() {
        var K = [], ee = ae.value, ke = n.max, ze = n.min;
        do K.push(ze), ze += ee;
        while (ze < ke);
        return K.push(ke), K;
    }), be = (0, $aAzpa.computed)(function() {
        var K = " ".concat(ym).concat(m.value, "-");
        return ym + "".concat(K).concat(n.switchMarkerLabelsSide === !0 ? "switched" : "standard").concat(K).concat(p.value === !0 ? "rtl" : "ltr");
    }), Me = (0, $aAzpa.computed)(function() {
        return n.markerLabels === !1 ? null : Fe(n.markerLabels).map(function(K, ee) {
            return {
                index: ee,
                value: K.value,
                label: K.label || K.value,
                classes: be.value + (K.classes !== void 0 ? " " + K.classes : ""),
                style: (0, $8pZMQ._)({}, De(K.value), K.style || {})
            };
        });
    }), le = (0, $aAzpa.computed)(function() {
        return {
            markerList: Me.value,
            markerMap: ne.value,
            classes: be.value,
            getStyle: De
        };
    }), Re = (0, $aAzpa.computed)(function() {
        var K = L.value === 0 ? "2px" : 100 * ae.value / L.value;
        return (0, $8typN._)((0, $8pZMQ._)({}, z.value), {
            backgroundSize: n.vertical === !0 ? "2px ".concat(K, "%") : "".concat(K, "% 2px")
        });
    });
    function Fe(K) {
        if (K === !1) return null;
        if (K === !0) return ce.value.map(SS);
        if (typeof K == "function") return ce.value.map(function(ke) {
            var ze = K(ke);
            return at(ze) === !0 ? (0, $8typN._)((0, $8pZMQ._)({}, ze), {
                value: ke
            }) : {
                value: ke,
                label: ze
            };
        });
        var ee = function(param) {
            var ke = param.value;
            return ke >= n.min && ke <= n.max;
        };
        return Array.isArray(K) === !0 ? K.map(function(ke) {
            return at(ke) === !0 ? ke : {
                value: ke
            };
        }).filter(ee) : Object.keys(K).map(function(ke) {
            var ze = K[ke], ye = Number(ke);
            return at(ze) === !0 ? (0, $8typN._)((0, $8pZMQ._)({}, ze), {
                value: ye
            }) : {
                value: ye,
                label: ze
            };
        }).filter(ee);
    }
    function De(K) {
        return {
            [B.value]: "".concat(100 * (K - n.min) / $.value, "%")
        };
    }
    var ne = (0, $aAzpa.computed)(function() {
        if (n.markerLabels === !1) return null;
        var K = {};
        return Me.value.forEach(function(ee) {
            K[ee.value] = ee;
        }), K;
    });
    function se() {
        if (a["marker-label-group"] !== void 0) return a["marker-label-group"](le.value);
        var K = a["marker-label"] || xS;
        return Me.value.map(function(ee) {
            return K((0, $8pZMQ._)({
                marker: ee
            }, le.value));
        });
    }
    var Y = (0, $aAzpa.computed)(function() {
        return [
            [
                qt,
                me,
                void 0,
                {
                    [k.value]: !0,
                    prevent: !0,
                    stop: !0,
                    mouse: !0,
                    mouseAllDir: !0
                }
            ]
        ];
    });
    function me(K) {
        K.isFinal === !0 ? (d.value !== void 0 && (t(K.evt), K.touch === !0 && e(!0), d.value = void 0, i("pan", "end")), u.value = !1, f.value = !1) : K.isFirst === !0 ? (d.value = o(K.evt), t(K.evt), e(), u.value = !0, i("pan", "start")) : (t(K.evt), e());
    }
    function Pe() {
        f.value = !1;
    }
    function Ee(K) {
        t(K, o(K)), e(), v.value = !0, u.value = !0, document.addEventListener("mouseup", Ae, !0);
    }
    function Ae() {
        v.value = !1, u.value = !1, e(!0), Pe(), document.removeEventListener("mouseup", Ae, !0);
    }
    function nt(K) {
        t(K, o(K)), e(!0);
    }
    function ct(K) {
        Ia.includes(K.keyCode) && e(!0);
    }
    function dt(K) {
        if (n.vertical === !0) return null;
        var ee = l.lang.rtl !== n.reverse ? 1 - K : K;
        return {
            transform: "translateX(calc(".concat(2 * ee - 1, " * ").concat(n.thumbSize, " / 2 + ").concat(50 - 100 * ee, "%))")
        };
    }
    function G(K) {
        var ee = (0, $aAzpa.computed)(function() {
            return v.value === !1 && (f.value === K.focusValue || f.value === "both") ? " q-slider--focus" : "";
        }), ke = (0, $aAzpa.computed)(function() {
            return "q-slider__thumb q-slider__thumb".concat(m.value, " q-slider__thumb").concat(m.value, "-").concat(p.value === !0 ? "rtl" : "ltr", " absolute non-selectable") + ee.value + (K.thumbColor.value !== void 0 ? " text-".concat(K.thumbColor.value) : "");
        }), ze = (0, $aAzpa.computed)(function() {
            return {
                width: n.thumbSize,
                height: n.thumbSize,
                [B.value]: "".concat(100 * K.ratio.value, "%"),
                zIndex: f.value === K.focusValue ? 2 : void 0
            };
        }), ye = (0, $aAzpa.computed)(function() {
            return K.labelColor.value !== void 0 ? " text-".concat(K.labelColor.value) : "";
        }), Ge = (0, $aAzpa.computed)(function() {
            return dt(K.ratio.value);
        }), mt = (0, $aAzpa.computed)(function() {
            return "q-slider__text" + (K.labelTextColor.value !== void 0 ? " text-".concat(K.labelTextColor.value) : "");
        });
        return function() {
            var ht = [
                (0, $aD8ZA.h)("svg", {
                    class: "q-slider__thumb-shape absolute-full",
                    viewBox: "0 0 20 20",
                    "aria-hidden": "true"
                }, [
                    (0, $aD8ZA.h)("path", {
                        d: n.thumbPath
                    })
                ]),
                (0, $aD8ZA.h)("div", {
                    class: "q-slider__focus-ring fit"
                })
            ];
            return (n.label === !0 || n.labelAlways === !0) && (ht.push((0, $aD8ZA.h)("div", {
                class: _.value + " absolute fit no-pointer-events" + ye.value
            }, [
                (0, $aD8ZA.h)("div", {
                    class: N.value,
                    style: {
                        minWidth: n.thumbSize
                    }
                }, [
                    (0, $aD8ZA.h)("div", {
                        class: I.value,
                        style: Ge.value
                    }, [
                        (0, $aD8ZA.h)("span", {
                            class: mt.value
                        }, K.label.value)
                    ])
                ])
            ])), n.name !== void 0 && n.disable !== !0 && c(ht, "push")), (0, $aD8ZA.h)("div", (0, $8pZMQ._)({
                class: ke.value,
                style: ze.value
            }, K.getNodeData()), ht);
        };
    }
    function re(K, ee, ke, ze) {
        var ye = [];
        n.innerTrackColor !== "transparent" && ye.push((0, $aD8ZA.h)("div", {
            key: "inner",
            class: te.value,
            style: z.value
        })), n.selectionColor !== "transparent" && ye.push((0, $aD8ZA.h)("div", {
            key: "selection",
            class: W.value,
            style: K.value
        })), n.markers !== !1 && ye.push((0, $aD8ZA.h)("div", {
            key: "marker",
            class: ie.value,
            style: Re.value
        })), ze(ye);
        var Ge = [
            kt("div", (0, $8pZMQ._)({
                key: "trackC",
                class: V.value,
                tabindex: ee.value
            }, ke.value), [
                (0, $aD8ZA.h)("div", {
                    class: T.value,
                    style: D.value
                }, ye)
            ], "slide", h.value, function() {
                return Y.value;
            })
        ];
        if (n.markerLabels !== !1) {
            var mt = n.switchMarkerLabelsSide === !0 ? "unshift" : "push";
            Ge[mt]((0, $aD8ZA.h)("div", {
                key: "markerL",
                class: oe.value
            }, se()));
        }
        return Ge;
    }
    return (0, $aD8ZA.onBeforeUnmount)(function() {
        document.removeEventListener("mouseup", Ae, !0);
    }), {
        state: {
            active: u,
            focus: f,
            preventFocus: v,
            dragging: d,
            editable: h,
            classes: Q,
            tabindex: P,
            attributes: j,
            roundValueFn: g,
            keyStep: S,
            trackLen: $,
            innerMin: C,
            innerMinRatio: E,
            innerMax: b,
            innerMaxRatio: A,
            positionProp: B,
            sizeProp: q,
            isReversed: p
        },
        methods: {
            onActivate: Ee,
            onMobileClick: nt,
            onBlur: Pe,
            onKeyup: ct,
            getContent: re,
            getThumbRenderFn: G,
            convertRatioToModel: ue,
            convertModelToRatio: _e,
            getDraggingRatio: U
        }
    };
}
var kS = function() {
    return {};
}, Bn = R({
    name: "QSlider",
    props: (0, $8typN._)((0, $8pZMQ._)({}, ou), {
        modelValue: {
            required: !0,
            default: null,
            validator: function(e) {
                return typeof e == "number" || e === null;
            }
        },
        labelValue: [
            String,
            Number
        ]
    }),
    emits: nu,
    setup: function(e, param) {
        var t = param.emit;
        var _wS = (0, $aD8ZA.getCurrentInstance)(), _wS_proxy = _wS.proxy, o = _wS_proxy.$q, _ru = ru({
            updateValue: m,
            updatePosition: p,
            getDragging: y,
            formAttrs: cn(e)
        }), r = _ru.state, n = _ru.methods, i = (0, $aAzpa.ref)(null), a = (0, $aAzpa.ref)(0), l = (0, $aAzpa.ref)(0);
        function s() {
            l.value = e.modelValue === null ? r.innerMin.value : Ze(e.modelValue, r.innerMin.value, r.innerMax.value);
        }
        (0, $aD8ZA.watch)(function() {
            return "".concat(e.modelValue, "|").concat(r.innerMin.value, "|").concat(r.innerMax.value);
        }, s), s();
        var c = (0, $aAzpa.computed)(function() {
            return n.convertModelToRatio(l.value);
        }), u = (0, $aAzpa.computed)(function() {
            return r.active.value === !0 ? a.value : c.value;
        }), v = (0, $aAzpa.computed)(function() {
            var h = {
                [r.positionProp.value]: "".concat(100 * r.innerMinRatio.value, "%"),
                [r.sizeProp.value]: "".concat(100 * (u.value - r.innerMinRatio.value), "%")
            };
            return e.selectionImg !== void 0 && (h.backgroundImage = "url(".concat(e.selectionImg, ") !important")), h;
        }), f = n.getThumbRenderFn({
            focusValue: !0,
            getNodeData: kS,
            ratio: u,
            label: (0, $aAzpa.computed)(function() {
                return e.labelValue !== void 0 ? e.labelValue : l.value;
            }),
            thumbColor: (0, $aAzpa.computed)(function() {
                return e.thumbColor || e.color;
            }),
            labelColor: (0, $aAzpa.computed)(function() {
                return e.labelColor;
            }),
            labelTextColor: (0, $aAzpa.computed)(function() {
                return e.labelTextColor;
            })
        }), d = (0, $aAzpa.computed)(function() {
            return r.editable.value !== !0 ? {} : o.platform.is.mobile === !0 ? {
                onClick: n.onMobileClick
            } : {
                onMousedown: n.onActivate,
                onFocus: C,
                onBlur: n.onBlur,
                onKeydown: b,
                onKeyup: n.onKeyup
            };
        });
        function m(h) {
            l.value !== e.modelValue && t("update:modelValue", l.value), h === !0 && t("change", l.value);
        }
        function y() {
            return i.value.getBoundingClientRect();
        }
        function p(h) {
            var g = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : r.dragging.value;
            var S = n.getDraggingRatio(h, g);
            l.value = n.convertRatioToModel(S), a.value = e.snap !== !0 || e.step === 0 ? S : n.convertModelToRatio(l.value);
        }
        function C() {
            r.focus.value = !0;
        }
        function b(h) {
            if (!Ia.includes(h.keyCode)) return;
            Se(h);
            var g = ([
                34,
                33
            ].includes(h.keyCode) ? 10 : 1) * r.keyStep.value, S = ([
                34,
                37,
                40
            ].includes(h.keyCode) ? -1 : 1) * (r.isReversed.value === !0 ? -1 : 1) * (e.vertical === !0 ? -1 : 1) * g;
            l.value = Ze(r.roundValueFn.value(l.value + S), r.innerMin.value, r.innerMax.value), m();
        }
        return function() {
            var h = n.getContent(v, r.tabindex, d, function(g) {
                g.push(f());
            });
            return (0, $aD8ZA.h)("div", (0, $8typN._)((0, $8pZMQ._)({
                ref: i,
                class: r.classes.value + (e.modelValue === null ? " q-slider--no-value" : "")
            }, r.attributes.value), {
                "aria-valuenow": e.modelValue
            }), h);
        };
    }
});
function Ha() {
    var e = (0, $aAzpa.ref)(!bt.value);
    return e.value === !1 && (0, $aD8ZA.onMounted)(function() {
        e.value = !0;
    }), {
        isHydrated: e
    };
}
var wm = (typeof ResizeObserver === "undefined" ? "undefined" : (0, $jzTO1._)(ResizeObserver)) < "u", Cm = wm === !0 ? {} : {
    style: "display:block;position:absolute;top:0;left:0;right:0;bottom:0;height:100%;width:100%;overflow:hidden;pointer-events:none;z-index:-1;",
    url: "about:blank"
}, go = R({
    name: "QResizeObserver",
    props: {
        debounce: {
            type: [
                String,
                Number
            ],
            default: 100
        }
    },
    emits: [
        "resize"
    ],
    setup: function(e, param) {
        var t = param.emit;
        var o = null, r, n = {
            width: -1,
            height: -1
        };
        function i(s) {
            s === !0 || e.debounce === 0 || e.debounce === "0" ? a() : o === null && (o = setTimeout(a, e.debounce));
        }
        function a() {
            if (o !== null && (clearTimeout(o), o = null), r) {
                var s = r.offsetWidth, c = r.offsetHeight;
                (s !== n.width || c !== n.height) && (n = {
                    width: s,
                    height: c
                }, t("resize", n));
            }
        }
        var _RS = (0, $aD8ZA.getCurrentInstance)(), l = _RS.proxy;
        if (l.trigger = i, wm === !0) {
            var s, c = function(u) {
                r = l.$el.parentNode, r ? (s = new ResizeObserver(i), s.observe(r), a()) : u !== !0 && (0, $aD8ZA.nextTick)(function() {
                    c(!0);
                });
            };
            return (0, $aD8ZA.onMounted)(function() {
                c();
            }), (0, $aD8ZA.onBeforeUnmount)(function() {
                o !== null && clearTimeout(o), s !== void 0 && (s.disconnect !== void 0 ? s.disconnect() : r && s.unobserve(r));
            }), Qe;
        } else {
            var u = function u() {
                o !== null && (clearTimeout(o), o = null), c1 !== void 0 && (c1.removeEventListener !== void 0 && c1.removeEventListener("resize", i, Xe.passive), c1 = void 0);
            }, v = function v() {
                u(), r && r.contentDocument && (c1 = r.contentDocument.defaultView, c1.addEventListener("resize", i, Xe.passive), a());
            }, _Ha = Ha(), s1 = _Ha.isHydrated, c1;
            return (0, $aD8ZA.onMounted)(function() {
                (0, $aD8ZA.nextTick)(function() {
                    r = l.$el, r && v();
                });
            }), (0, $aD8ZA.onBeforeUnmount)(u), function() {
                if (s1.value === !0) return (0, $aD8ZA.h)("object", {
                    class: "q--avoid-card-border",
                    style: Cm.style,
                    tabindex: -1,
                    type: "text/html",
                    data: Cm.url,
                    "aria-hidden": "true",
                    onLoad: v
                });
            };
        }
    }
});
var Fr = !1;
{
    var e3 = document.createElement("div");
    e3.setAttribute("dir", "rtl"), Object.assign(e3.style, {
        width: "1px",
        height: "1px",
        overflow: "auto"
    });
    var t = document.createElement("div");
    Object.assign(t.style, {
        width: "1000px",
        height: "1px"
    }), document.body.appendChild(e3), e3.appendChild(t), e3.scrollLeft = -1000, Fr = e3.scrollLeft >= 0, e3.remove();
}function LS(e, t, o) {
    var r = o === !0 ? [
        "left",
        "right"
    ] : [
        "top",
        "bottom"
    ];
    return "absolute-".concat(t === !0 ? r[0] : r[1]).concat(e ? " text-".concat(e) : "");
}
var FS = [
    "left",
    "center",
    "right",
    "justify"
], Qa = R({
    name: "QTabs",
    props: {
        modelValue: [
            Number,
            String
        ],
        align: {
            type: String,
            default: "center",
            validator: function(e) {
                return FS.includes(e);
            }
        },
        breakpoint: {
            type: [
                String,
                Number
            ],
            default: 600
        },
        vertical: Boolean,
        shrink: Boolean,
        stretch: Boolean,
        activeClass: String,
        activeColor: String,
        activeBgColor: String,
        indicatorColor: String,
        leftIcon: String,
        rightIcon: String,
        outsideArrows: Boolean,
        mobileArrows: Boolean,
        switchIndicator: Boolean,
        narrowIndicator: Boolean,
        inlineLabel: Boolean,
        noCaps: Boolean,
        dense: Boolean,
        contentClass: String,
        "onUpdate:modelValue": [
            Function,
            Array
        ]
    },
    setup: function(e, param) {
        var t = param.slots, o = param.emit;
        var _ES = (0, $aD8ZA.getCurrentInstance)(), r = _ES.proxy, n = r.$q, _Io = Io(), i = _Io.registerTick, _Io1 = Io(), a = _Io1.registerTick, _Io2 = Io(), l = _Io2.registerTick, _io = io(), s = _io.registerTimeout, c = _io.removeTimeout, _io1 = io(), u = _io1.registerTimeout, v = _io1.removeTimeout, f = (0, $aAzpa.ref)(null), d = (0, $aAzpa.ref)(null), m = (0, $aAzpa.ref)(e.modelValue), y = (0, $aAzpa.ref)(!1), p = (0, $aAzpa.ref)(!0), C = (0, $aAzpa.ref)(!1), b = (0, $aAzpa.ref)(!1), h = [], g = (0, $aAzpa.ref)(0), S = (0, $aAzpa.ref)(!1), P = null, $ = null, L, E = (0, $aAzpa.computed)(function() {
            return {
                activeClass: e.activeClass,
                activeColor: e.activeColor,
                activeBgColor: e.activeBgColor,
                indicatorClass: LS(e.indicatorColor, e.switchIndicator, e.vertical),
                narrowIndicator: e.narrowIndicator,
                inlineLabel: e.inlineLabel,
                noCaps: e.noCaps
            };
        }), A = (0, $aAzpa.computed)(function() {
            var ne = g.value, se = m.value;
            for(var Y = 0; Y < ne; Y++)if (h[Y].name.value === se) return !0;
            return !1;
        }), B = (0, $aAzpa.computed)(function() {
            return "q-tabs__content--align-".concat(y.value === !0 ? "left" : b.value === !0 ? "justify" : e.align);
        }), q = (0, $aAzpa.computed)(function() {
            return "q-tabs row no-wrap items-center q-tabs--".concat(y.value === !0 ? "" : "not-", "scrollable q-tabs--").concat(e.vertical === !0 ? "vertical" : "horizontal", " q-tabs__arrows--").concat(e.outsideArrows === !0 ? "outside" : "inside", " q-tabs--mobile-with").concat(e.mobileArrows === !0 ? "" : "out", "-arrows") + (e.dense === !0 ? " q-tabs--dense" : "") + (e.shrink === !0 ? " col-shrink" : "") + (e.stretch === !0 ? " self-stretch" : "");
        }), x = (0, $aAzpa.computed)(function() {
            return "q-tabs__content scroll--mobile row no-wrap items-center self-stretch hide-scrollbar relative-position " + B.value + (e.contentClass !== void 0 ? " ".concat(e.contentClass) : "");
        }), k = (0, $aAzpa.computed)(function() {
            return e.vertical === !0 ? {
                container: "height",
                content: "offsetHeight",
                scroll: "scrollHeight"
            } : {
                container: "width",
                content: "offsetWidth",
                scroll: "scrollWidth"
            };
        }), j = (0, $aAzpa.computed)(function() {
            return e.vertical !== !0 && n.lang.rtl === !0;
        }), Q = (0, $aAzpa.computed)(function() {
            return Fr === !1 && j.value === !0;
        });
        (0, $aD8ZA.watch)(j, _), (0, $aD8ZA.watch)(function() {
            return e.modelValue;
        }, function(ne) {
            w({
                name: ne,
                setCurrent: !0,
                skipEmit: !0
            });
        }), (0, $aD8ZA.watch)(function() {
            return e.outsideArrows;
        }, H);
        function w(param) {
            var ne = param.name, se = param.setCurrent, Y = param.skipEmit;
            m.value !== ne && (Y !== !0 && e["onUpdate:modelValue"] !== void 0 && o("update:modelValue", ne), (se === !0 || e["onUpdate:modelValue"] === void 0) && (ie(m.value, ne), m.value = ne));
        }
        function H() {
            i(function() {
                W({
                    width: f.value.offsetWidth,
                    height: f.value.offsetHeight
                });
            });
        }
        function W(ne) {
            if (k.value === void 0 || d.value === null) return;
            var se = ne[k.value.container], Y = Math.min(d.value[k.value.scroll], Array.prototype.reduce.call(d.value.children, function(Pe, Ee) {
                return Pe + (Ee[k.value.content] || 0);
            }, 0)), me = se > 0 && Y > se;
            y.value = me, me === !0 && a(_), b.value = se < parseInt(e.breakpoint, 10);
        }
        function ie(ne, se) {
            var Y = ne != null && ne !== "" ? h.find(function(Pe) {
                return Pe.name.value === ne;
            }) : null, me = se != null && se !== "" ? h.find(function(Pe) {
                return Pe.name.value === se;
            }) : null;
            if (Y && me) {
                var Pe = Y.tabIndicatorRef.value, Ee = me.tabIndicatorRef.value;
                P !== null && (clearTimeout(P), P = null), Pe.style.transition = "none", Pe.style.transform = "none", Ee.style.transition = "none", Ee.style.transform = "none";
                var Ae = Pe.getBoundingClientRect(), nt = Ee.getBoundingClientRect();
                Ee.style.transform = e.vertical === !0 ? "translate3d(0,".concat(Ae.top - nt.top, "px,0) scale3d(1,").concat(nt.height ? Ae.height / nt.height : 1, ",1)") : "translate3d(".concat(Ae.left - nt.left, "px,0,0) scale3d(").concat(nt.width ? Ae.width / nt.width : 1, ",1,1)"), l(function() {
                    P = setTimeout(function() {
                        P = null, Ee.style.transition = "transform .25s cubic-bezier(.4, 0, .2, 1)", Ee.style.transform = "none";
                    }, 70);
                });
            }
            me && y.value === !0 && V(me.rootRef.value);
        }
        function V(ne) {
            var _d_value_getBoundingClientRect = d.value.getBoundingClientRect(), se = _d_value_getBoundingClientRect.left, Y = _d_value_getBoundingClientRect.width, me = _d_value_getBoundingClientRect.top, Pe = _d_value_getBoundingClientRect.height, Ee = ne.getBoundingClientRect(), Ae = e.vertical === !0 ? Ee.top - me : Ee.left - se;
            if (Ae < 0) {
                d.value[e.vertical === !0 ? "scrollTop" : "scrollLeft"] += Math.floor(Ae), _();
                return;
            }
            Ae += e.vertical === !0 ? Ee.height - Pe : Ee.width - Y, Ae > 0 && (d.value[e.vertical === !0 ? "scrollTop" : "scrollLeft"] += Math.ceil(Ae), _());
        }
        function _() {
            var ne = d.value;
            if (ne === null) return;
            var se = ne.getBoundingClientRect(), Y = e.vertical === !0 ? ne.scrollTop : Math.abs(ne.scrollLeft);
            j.value === !0 ? (p.value = Math.ceil(Y + se.width) < ne.scrollWidth - 1, C.value = Y > 0) : (p.value = Y > 0, C.value = e.vertical === !0 ? Math.ceil(Y + se.height) < ne.scrollHeight : Math.ceil(Y + se.width) < ne.scrollWidth);
        }
        function N(ne) {
            $ !== null && clearInterval($), $ = setInterval(function() {
                z(ne) === !0 && T();
            }, 5);
        }
        function I() {
            N(Q.value === !0 ? Number.MAX_SAFE_INTEGER : 0);
        }
        function oe() {
            N(Q.value === !0 ? 0 : Number.MAX_SAFE_INTEGER);
        }
        function T() {
            $ !== null && (clearInterval($), $ = null);
        }
        function D(ne, se) {
            var Y = Array.prototype.filter.call(d.value.children, function(nt) {
                return nt === se || nt.matches && nt.matches(".q-tab.q-focusable") === !0;
            }), me = Y.length;
            if (me === 0) return;
            if (ne === 36) return V(Y[0]), Y[0].focus(), !0;
            if (ne === 35) return V(Y[me - 1]), Y[me - 1].focus(), !0;
            var Pe = ne === (e.vertical === !0 ? 38 : 37), Ee = ne === (e.vertical === !0 ? 40 : 39), Ae = Pe === !0 ? -1 : Ee === !0 ? 1 : void 0;
            if (Ae !== void 0) {
                var nt = j.value === !0 ? -1 : 1, ct = Y.indexOf(se) + Ae * nt;
                return ct >= 0 && ct < me && (V(Y[ct]), Y[ct].focus({
                    preventScroll: !0
                })), !0;
            }
        }
        var te = (0, $aAzpa.computed)(function() {
            return Q.value === !0 ? {
                get: function(ne) {
                    return Math.abs(ne.scrollLeft);
                },
                set: function(ne, se) {
                    ne.scrollLeft = -se;
                }
            } : e.vertical === !0 ? {
                get: function(ne) {
                    return ne.scrollTop;
                },
                set: function(ne, se) {
                    ne.scrollTop = se;
                }
            } : {
                get: function(ne) {
                    return ne.scrollLeft;
                },
                set: function(ne, se) {
                    ne.scrollLeft = se;
                }
            };
        });
        function z(ne) {
            var se = d.value, _te_value = te.value, Y = _te_value.get, me = _te_value.set, Pe = !1, Ee = Y(se), Ae = ne < Ee ? -1 : 1;
            return Ee += Ae * 5, Ee < 0 ? (Pe = !0, Ee = 0) : (Ae === -1 && Ee <= ne || Ae === 1 && Ee >= ne) && (Pe = !0, Ee = ne), me(se, Ee), _(), Pe;
        }
        function ue(ne, se) {
            for(var Y in ne)if (ne[Y] !== se[Y]) return !1;
            return !0;
        }
        function _e() {
            var ne = null, se = {
                matchedLen: 0,
                queryDiff: 9999,
                hrefLen: 0
            }, Y = h.filter(function(Ae) {
                return Ae.routeData !== void 0 && Ae.routeData.hasRouterLink.value === !0;
            }), _r_$route = r.$route, me = _r_$route.hash, Pe = _r_$route.query, Ee = Object.keys(Pe).length;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = Y[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var Ae = _step.value;
                    var nt = Ae.routeData.exact.value === !0;
                    if (Ae.routeData[nt === !0 ? "linkIsExactActive" : "linkIsActive"].value !== !0) continue;
                    var _Ae_routeData_resolvedLink_value = Ae.routeData.resolvedLink.value, ct = _Ae_routeData_resolvedLink_value.hash, dt = _Ae_routeData_resolvedLink_value.query, G = _Ae_routeData_resolvedLink_value.matched, re = _Ae_routeData_resolvedLink_value.href, K = Object.keys(dt).length;
                    if (nt === !0) {
                        if (ct !== me || K !== Ee || ue(Pe, dt) === !1) continue;
                        ne = Ae.name.value;
                        break;
                    }
                    if (ct !== "" && ct !== me || K !== 0 && ue(dt, Pe) === !1) continue;
                    var ee = {
                        matchedLen: G.length,
                        queryDiff: Ee - K,
                        hrefLen: re.length - ct.length
                    };
                    if (ee.matchedLen > se.matchedLen) {
                        ne = Ae.name.value, se = ee;
                        continue;
                    } else if (ee.matchedLen !== se.matchedLen) continue;
                    if (ee.queryDiff < se.queryDiff) ne = Ae.name.value, se = ee;
                    else if (ee.queryDiff !== se.queryDiff) continue;
                    ee.hrefLen > se.hrefLen && (ne = Ae.name.value, se = ee);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            ne === null && h.some(function(Ae) {
                return Ae.routeData === void 0 && Ae.name.value === m.value;
            }) === !0 || w({
                name: ne,
                setCurrent: !0
            });
        }
        function U(ne) {
            if (c(), S.value !== !0 && f.value !== null && ne.target && typeof ne.target.closest == "function") {
                var se = ne.target.closest(".q-tab");
                se && f.value.contains(se) === !0 && (S.value = !0, y.value === !0 && V(se));
            }
        }
        function ae() {
            s(function() {
                S.value = !1;
            }, 30);
        }
        function ce() {
            Re.avoidRouteWatcher === !1 ? u(_e) : v();
        }
        function be() {
            if (L === void 0) {
                var ne = (0, $aD8ZA.watch)(function() {
                    return r.$route.fullPath;
                }, ce);
                L = function() {
                    ne(), L = void 0;
                };
            }
        }
        function Me(ne) {
            h.push(ne), g.value++, H(), ne.routeData === void 0 || r.$route === void 0 ? u(function() {
                if (y.value === !0) {
                    var se = m.value, Y = se != null && se !== "" ? h.find(function(me) {
                        return me.name.value === se;
                    }) : null;
                    Y && V(Y.rootRef.value);
                }
            }) : (be(), ne.routeData.hasRouterLink.value === !0 && ce());
        }
        function le(ne) {
            h.splice(h.indexOf(ne), 1), g.value--, H(), L !== void 0 && ne.routeData !== void 0 && (h.every(function(se) {
                return se.routeData === void 0;
            }) === !0 && L(), ce());
        }
        var Re = {
            currentModel: m,
            tabProps: E,
            hasFocus: S,
            hasActiveTab: A,
            registerTab: Me,
            unregisterTab: le,
            verifyRouteModel: ce,
            updateModel: w,
            onKbdNavigate: D,
            avoidRouteWatcher: !1
        };
        (0, $aD8ZA.provide)(Tl, Re);
        function Fe() {
            P !== null && clearTimeout(P), T(), L !== void 0 && L();
        }
        var De;
        return (0, $aD8ZA.onBeforeUnmount)(Fe), (0, $aD8ZA.onDeactivated)(function() {
            De = L !== void 0, Fe();
        }), (0, $aD8ZA.onActivated)(function() {
            De === !0 && be(), H();
        }), function() {
            return (0, $aD8ZA.h)("div", {
                ref: f,
                class: q.value,
                role: "tablist",
                onFocusin: U,
                onFocusout: ae
            }, [
                (0, $aD8ZA.h)(go, {
                    onResize: W
                }),
                (0, $aD8ZA.h)("div", {
                    ref: d,
                    class: x.value,
                    onScroll: _
                }, J(t.default)),
                (0, $aD8ZA.h)(we, {
                    class: "q-tabs__arrow q-tabs__arrow--left absolute q-tab__icon" + (p.value === !0 ? "" : " q-tabs__arrow--faded"),
                    name: e.leftIcon || n.iconSet.tabs[e.vertical === !0 ? "up" : "left"],
                    onMousedownPassive: I,
                    onTouchstartPassive: I,
                    onMouseupPassive: T,
                    onMouseleavePassive: T,
                    onTouchendPassive: T
                }),
                (0, $aD8ZA.h)(we, {
                    class: "q-tabs__arrow q-tabs__arrow--right absolute q-tab__icon" + (C.value === !0 ? "" : " q-tabs__arrow--faded"),
                    name: e.rightIcon || n.iconSet.tabs[e.vertical === !0 ? "down" : "right"],
                    onMousedownPassive: oe,
                    onTouchstartPassive: oe,
                    onMouseupPassive: T,
                    onMouseleavePassive: T,
                    onTouchendPassive: T
                })
            ]);
        };
    }
});
var HS = 0, au = [
    "click",
    "keydown"
], lu = {
    icon: String,
    label: [
        Number,
        String
    ],
    alert: [
        Boolean,
        String
    ],
    alertIcon: String,
    name: {
        type: [
            Number,
            String
        ],
        default: function() {
            return "t_".concat(HS++);
        }
    },
    noCaps: Boolean,
    tabindex: [
        String,
        Number
    ],
    disable: Boolean,
    contentClass: String,
    ripple: {
        type: [
            Boolean,
            Object
        ],
        default: !0
    }
};
function uu(e, t, o, r) {
    var n = (0, $aD8ZA.inject)(Tl, Ye);
    if (n === Ye) return console.error("QTab/QRouteTab component needs to be child of QTabs"), Ye;
    var _IS = (0, $aD8ZA.getCurrentInstance)(), i = _IS.proxy, a = (0, $aAzpa.ref)(null), l = (0, $aAzpa.ref)(null), s = (0, $aAzpa.ref)(null), c = (0, $aAzpa.computed)(function() {
        return e.disable === !0 || e.ripple === !1 ? !1 : Object.assign({
            keyCodes: [
                13,
                32
            ],
            early: !0
        }, e.ripple === !0 ? {} : e.ripple);
    }), u = (0, $aAzpa.computed)(function() {
        return n.currentModel.value === e.name;
    }), v = (0, $aAzpa.computed)(function() {
        return "q-tab relative-position self-stretch flex flex-center text-center" + (u.value === !0 ? " q-tab--active" + (n.tabProps.value.activeClass ? " " + n.tabProps.value.activeClass : "") + (n.tabProps.value.activeColor ? " text-".concat(n.tabProps.value.activeColor) : "") + (n.tabProps.value.activeBgColor ? " bg-".concat(n.tabProps.value.activeBgColor) : "") : " q-tab--inactive") + (e.icon && e.label && n.tabProps.value.inlineLabel === !1 ? " q-tab--full" : "") + (e.noCaps === !0 || n.tabProps.value.noCaps === !0 ? " q-tab--no-caps" : "") + (e.disable === !0 ? " disabled" : " q-focusable q-hoverable cursor-pointer") + (r !== void 0 ? r.linkClass.value : "");
    }), f = (0, $aAzpa.computed)(function() {
        return "q-tab__content self-stretch flex-center relative-position q-anchor--skip non-selectable " + (n.tabProps.value.inlineLabel === !0 ? "row no-wrap q-tab__content--inline" : "column") + (e.contentClass !== void 0 ? " ".concat(e.contentClass) : "");
    }), d = (0, $aAzpa.computed)(function() {
        return e.disable === !0 || n.hasFocus.value === !0 || u.value === !1 && n.hasActiveTab.value === !0 ? -1 : e.tabindex || 0;
    });
    function m(h, g) {
        if (g !== !0 && a.value !== null && a.value.focus(), e.disable === !0) {
            r !== void 0 && r.hasRouterLink.value === !0 && Se(h);
            return;
        }
        if (r === void 0) {
            n.updateModel({
                name: e.name
            }), o("click", h);
            return;
        }
        if (r.hasRouterLink.value === !0) {
            var S = function() {
                var P = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var $, L = P.to === void 0 || Zt(P.to, e.to) === !0 ? n.avoidRouteWatcher = An() : null;
                return r.navigateToRouterLink(h, (0, $8typN._)((0, $8pZMQ._)({}, P), {
                    returnRouterError: !0
                })).catch(function(E) {
                    $ = E;
                }).then(function(E) {
                    if (L === n.avoidRouteWatcher && (n.avoidRouteWatcher = !1, $ === void 0 && (E === void 0 || E.message !== void 0 && E.message.startsWith("Avoided redundant navigation") === !0) && n.updateModel({
                        name: e.name
                    })), P.returnRouterError === !0) return $ !== void 0 ? Promise.reject($) : E;
                });
            };
            o("click", h, S), h.defaultPrevented !== !0 && S();
            return;
        }
        o("click", h);
    }
    function y(h) {
        wt(h, [
            13,
            32
        ]) ? m(h, !0) : xo(h) !== !0 && h.keyCode >= 35 && h.keyCode <= 40 && h.altKey !== !0 && h.metaKey !== !0 && n.onKbdNavigate(h.keyCode, i.$el) === !0 && Se(h), o("keydown", h);
    }
    function p() {
        var h = n.tabProps.value.narrowIndicator, g = [], S = (0, $aD8ZA.h)("div", {
            ref: s,
            class: [
                "q-tab__indicator",
                n.tabProps.value.indicatorClass
            ]
        });
        e.icon !== void 0 && g.push((0, $aD8ZA.h)(we, {
            class: "q-tab__icon",
            name: e.icon
        })), e.label !== void 0 && g.push((0, $aD8ZA.h)("div", {
            class: "q-tab__label"
        }, e.label)), e.alert !== !1 && g.push(e.alertIcon !== void 0 ? (0, $aD8ZA.h)(we, {
            class: "q-tab__alert-icon",
            color: e.alert !== !0 ? e.alert : void 0,
            name: e.alertIcon
        }) : (0, $aD8ZA.h)("div", {
            class: "q-tab__alert" + (e.alert !== !0 ? " text-".concat(e.alert) : "")
        })), h === !0 && g.push(S);
        var P = [
            (0, $aD8ZA.h)("div", {
                class: "q-focus-helper",
                tabindex: -1,
                ref: a
            }),
            (0, $aD8ZA.h)("div", {
                class: f.value
            }, Ke(t.default, g))
        ];
        return h === !1 && P.push(S), P;
    }
    var C = {
        name: (0, $aAzpa.computed)(function() {
            return e.name;
        }),
        rootRef: l,
        tabIndicatorRef: s,
        routeData: r
    };
    (0, $aD8ZA.onBeforeUnmount)(function() {
        n.unregisterTab(C);
    }), (0, $aD8ZA.onMounted)(function() {
        n.registerTab(C);
    });
    function b(h, g) {
        var S = (0, $8pZMQ._)({
            ref: l,
            class: v.value,
            tabindex: d.value,
            role: "tab",
            "aria-selected": u.value === !0 ? "true" : "false",
            "aria-disabled": e.disable === !0 ? "true" : void 0,
            onClick: m,
            onKeydown: y
        }, g);
        return (0, $aD8ZA.withDirectives)((0, $aD8ZA.h)(h, S, p()), [
            [
                rn,
                c.value
            ]
        ]);
    }
    return {
        renderTab: b,
        $tabs: n
    };
}
var ir = R({
    name: "QTab",
    props: lu,
    emits: au,
    setup: function(e, param) {
        var t = param.slots, o = param.emit;
        var _uu = uu(e, t, o), r = _uu.renderTab;
        return function() {
            return r("div");
        };
    }
});
var su = R({
    name: "QTabPanels",
    props: (0, $8pZMQ._)({}, Fi, he),
    emits: Di,
    setup: function(e, param) {
        var t = param.slots;
        var o = (0, $aD8ZA.getCurrentInstance)(), r = pe(e, o.proxy.$q), _Vi = Vi(), n = _Vi.updatePanelsList, i = _Vi.getPanelContent, a = _Vi.panelDirectives, l = (0, $aAzpa.computed)(function() {
            return "q-tab-panels q-panel-parent" + (r.value === !0 ? " q-tab-panels--dark q-dark" : "");
        });
        return function() {
            return n(t), kt("div", {
                class: l.value
            }, i(), "pan", e.swipeable, function() {
                return a.value;
            });
        };
    }
});
var Gi = R({
    name: "QTabPanel",
    props: Li,
    setup: function(e, param) {
        var t = param.slots;
        return function() {
            return (0, $aD8ZA.h)("div", {
                class: "q-tab-panel",
                role: "tabpanel"
            }, J(t.default));
        };
    }
});
var km = /^#[0-9a-fA-F]{3}([0-9a-fA-F]{3})?$/, qm = /^#[0-9a-fA-F]{4}([0-9a-fA-F]{4})?$/, Tm = /^#([0-9a-fA-F]{3}|[0-9a-fA-F]{4}|[0-9a-fA-F]{6}|[0-9a-fA-F]{8})$/, cu = /^rgb\(((0|[1-9][\d]?|1[\d]{0,2}|2[\d]?|2[0-4][\d]|25[0-5]),){2}(0|[1-9][\d]?|1[\d]{0,2}|2[\d]?|2[0-4][\d]|25[0-5])\)$/, du = /^rgba\(((0|[1-9][\d]?|1[\d]{0,2}|2[\d]?|2[0-4][\d]|25[0-5]),){2}(0|[1-9][\d]?|1[\d]{0,2}|2[\d]?|2[0-4][\d]|25[0-5]),(0|0\.[0-9]+[1-9]|0\.[1-9]+|1)\)$/, Dr = {
    date: function(e) {
        return /^-?[\d]+\/[0-1]\d\/[0-3]\d$/.test(e);
    },
    time: function(e) {
        return /^([0-1]?\d|2[0-3]):[0-5]\d$/.test(e);
    },
    fulltime: function(e) {
        return /^([0-1]?\d|2[0-3]):[0-5]\d:[0-5]\d$/.test(e);
    },
    timeOrFulltime: function(e) {
        return /^([0-1]?\d|2[0-3]):[0-5]\d(:[0-5]\d)?$/.test(e);
    },
    email: function(e) {
        return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(e);
    },
    hexColor: function(e) {
        return km.test(e);
    },
    hexaColor: function(e) {
        return qm.test(e);
    },
    hexOrHexaColor: function(e) {
        return Tm.test(e);
    },
    rgbColor: function(e) {
        return cu.test(e);
    },
    rgbaColor: function(e) {
        return du.test(e);
    },
    rgbOrRgbaColor: function(e) {
        return cu.test(e) || du.test(e);
    },
    hexOrRgbColor: function(e) {
        return km.test(e) || cu.test(e);
    },
    hexaOrRgbaColor: function(e) {
        return qm.test(e) || du.test(e);
    },
    anyColor: function(e) {
        return Tm.test(e) || cu.test(e) || du.test(e);
    }
}, US = {
    testPattern: Dr
};
var KS = /^rgb(a)?\((\d{1,3}),(\d{1,3}),(\d{1,3}),?([01]?\.?\d*?)?\)$/;
function Vr(param) {
    var e = param.r, t = param.g, o = param.b, r = param.a;
    var n = r !== void 0;
    if (e = Math.round(e), t = Math.round(t), o = Math.round(o), e > 255 || t > 255 || o > 255 || n && r > 100) throw new TypeError("Expected 3 numbers below 256 (and optionally one below 100)");
    return r = n ? (Math.round(255 * r / 100) | 256).toString(16).slice(1) : "", "#" + (o | t << 8 | e << 16 | 16777216).toString(16).slice(1) + r;
}
function qc(param) {
    var e = param.r, t = param.g, o = param.b, r = param.a;
    return "rgb".concat(r !== void 0 ? "a" : "", "(").concat(e, ",").concat(t, ",").concat(o).concat(r !== void 0 ? "," + r / 100 : "", ")");
}
function fu(e) {
    if (typeof e != "string") throw new TypeError("Expected a string");
    e = e.replace(/^#/, ""), e.length === 3 ? e = e[0] + e[0] + e[1] + e[1] + e[2] + e[2] : e.length === 4 && (e = e[0] + e[0] + e[1] + e[1] + e[2] + e[2] + e[3] + e[3]);
    var t = parseInt(e, 16);
    return e.length > 6 ? {
        r: t >> 24 & 255,
        g: t >> 16 & 255,
        b: t >> 8 & 255,
        a: Math.round((t & 255) / 2.55)
    } : {
        r: t >> 16,
        g: t >> 8 & 255,
        b: t & 255
    };
}
function mu(param) {
    var e = param.h, t = param.s, o = param.v, r = param.a;
    var n, i, a;
    t = t / 100, o = o / 100, e = e / 360;
    var l = Math.floor(e * 6), s = e * 6 - l, c = o * (1 - t), u = o * (1 - s * t), v = o * (1 - (1 - s) * t);
    switch(l % 6){
        case 0:
            n = o, i = v, a = c;
            break;
        case 1:
            n = u, i = o, a = c;
            break;
        case 2:
            n = c, i = o, a = v;
            break;
        case 3:
            n = c, i = u, a = o;
            break;
        case 4:
            n = v, i = c, a = o;
            break;
        case 5:
            n = o, i = c, a = u;
            break;
    }
    return {
        r: Math.round(n * 255),
        g: Math.round(i * 255),
        b: Math.round(a * 255),
        a: r
    };
}
function ja(param) {
    var e = param.r, t = param.g, o = param.b, r = param.a;
    var n = Math.max(e, t, o), i = Math.min(e, t, o), a = n - i, l = n === 0 ? 0 : a / n, s = n / 255, c;
    switch(n){
        case i:
            c = 0;
            break;
        case e:
            c = t - o + a * (t < o ? 6 : 0), c /= 6 * a;
            break;
        case t:
            c = o - e + a * 2, c /= 6 * a;
            break;
        case o:
            c = e - t + a * 4, c /= 6 * a;
            break;
    }
    return {
        h: Math.round(c * 360),
        s: Math.round(l * 100),
        v: Math.round(s * 100),
        a: r
    };
}
function mn(e) {
    if (typeof e != "string") throw new TypeError("Expected a string");
    var t = e.replace(/ /g, ""), o = KS.exec(t);
    if (o === null) return fu(t);
    var r = {
        r: Math.min(255, parseInt(o[2], 10)),
        g: Math.min(255, parseInt(o[3], 10)),
        b: Math.min(255, parseInt(o[4], 10))
    };
    if (o[1]) {
        var n = parseFloat(o[5]);
        r.a = Math.min(1, isNaN(n) === !0 ? 1 : n) * 100;
    }
    return r;
}
function WS(e, t) {
    if (typeof e != "string") throw new TypeError("Expected a string as color");
    if (typeof t != "number") throw new TypeError("Expected a numeric percent");
    var o = mn(e), r = t < 0 ? 0 : 255, n = Math.abs(t) / 100, i = o.r, a = o.g, l = o.b;
    return "#" + (16777216 + (Math.round((r - i) * n) + i) * 65536 + (Math.round((r - a) * n) + a) * 256 + (Math.round((r - l) * n) + l)).toString(16).slice(1);
}
function Tc(e) {
    if (typeof e != "string" && (!e || e.r === void 0)) throw new TypeError("Expected a string or a {r, g, b} object as color");
    var t = typeof e == "string" ? mn(e) : e, o = t.r / 255, r = t.g / 255, n = t.b / 255, i = o <= .03928 ? o / 12.92 : Math.pow((o + .055) / 1.055, 2.4), a = r <= .03928 ? r / 12.92 : Math.pow((r + .055) / 1.055, 2.4), l = n <= .03928 ? n / 12.92 : Math.pow((n + .055) / 1.055, 2.4);
    return .2126 * i + .7152 * a + .0722 * l;
}
function YS(e) {
    if (typeof e != "string" && (!e || e.r === void 0)) throw new TypeError("Expected a string or a {r, g, b} object as color");
    var t = typeof e == "string" ? mn(e) : e;
    return (t.r * 299 + t.g * 587 + t.b * 114) / 1e3;
}
function XS(e, t) {
    if (typeof e != "string" && (!e || e.r === void 0)) throw new TypeError("Expected a string or a {r, g, b[, a]} object as fgColor");
    if (typeof t != "string" && (!t || t.r === void 0)) throw new TypeError("Expected a string or a {r, g, b[, a]} object as bgColor");
    var o = typeof e == "string" ? mn(e) : e, r = o.r / 255, n = o.g / 255, i = o.b / 255, a = o.a !== void 0 ? o.a / 100 : 1, l = typeof t == "string" ? mn(t) : t, s = l.r / 255, c = l.g / 255, u = l.b / 255, v = l.a !== void 0 ? l.a / 100 : 1, f = a + v * (1 - a), d = Math.round((r * a + s * v * (1 - a)) / f * 255), m = Math.round((n * a + c * v * (1 - a)) / f * 255), y = Math.round((i * a + u * v * (1 - a)) / f * 255), p = {
        r: d,
        g: m,
        b: y,
        a: Math.round(f * 100)
    };
    return typeof e == "string" ? Vr(p) : p;
}
function GS(e, t) {
    if (typeof e != "string") throw new TypeError("Expected a string as color");
    if (t === void 0 || t < -1 || t > 1) throw new TypeError("Expected offset to be between -1 and 1");
    var _mn = mn(e), o = _mn.r, r = _mn.g, n = _mn.b, i = _mn.a, a = i !== void 0 ? i / 100 : 0;
    return Vr({
        r: o,
        g: r,
        b: n,
        a: Math.round(Math.min(1, Math.max(0, a + t)) * 100)
    });
}
function ZS(e) {
    if (typeof e != "string") throw new TypeError("Expected a string as color");
    var t = document.createElement("div");
    t.className = "text-".concat(e, " invisible fixed no-pointer-events"), document.body.appendChild(t);
    var o = getComputedStyle(t).getPropertyValue("color");
    return t.remove(), Vr(mn(o));
}
var JS = {
    rgbToHex: Vr,
    hexToRgb: fu,
    hsvToRgb: mu,
    rgbToHsv: ja,
    textToRgb: mn,
    lighten: WS,
    luminosity: Tc,
    brightness: YS,
    blend: XS,
    changeAlpha: GS,
    getPaletteColor: ZS
};
var tx = [
    "rgb(255,204,204)",
    "rgb(255,230,204)",
    "rgb(255,255,204)",
    "rgb(204,255,204)",
    "rgb(204,255,230)",
    "rgb(204,255,255)",
    "rgb(204,230,255)",
    "rgb(204,204,255)",
    "rgb(230,204,255)",
    "rgb(255,204,255)",
    "rgb(255,153,153)",
    "rgb(255,204,153)",
    "rgb(255,255,153)",
    "rgb(153,255,153)",
    "rgb(153,255,204)",
    "rgb(153,255,255)",
    "rgb(153,204,255)",
    "rgb(153,153,255)",
    "rgb(204,153,255)",
    "rgb(255,153,255)",
    "rgb(255,102,102)",
    "rgb(255,179,102)",
    "rgb(255,255,102)",
    "rgb(102,255,102)",
    "rgb(102,255,179)",
    "rgb(102,255,255)",
    "rgb(102,179,255)",
    "rgb(102,102,255)",
    "rgb(179,102,255)",
    "rgb(255,102,255)",
    "rgb(255,51,51)",
    "rgb(255,153,51)",
    "rgb(255,255,51)",
    "rgb(51,255,51)",
    "rgb(51,255,153)",
    "rgb(51,255,255)",
    "rgb(51,153,255)",
    "rgb(51,51,255)",
    "rgb(153,51,255)",
    "rgb(255,51,255)",
    "rgb(255,0,0)",
    "rgb(255,128,0)",
    "rgb(255,255,0)",
    "rgb(0,255,0)",
    "rgb(0,255,128)",
    "rgb(0,255,255)",
    "rgb(0,128,255)",
    "rgb(0,0,255)",
    "rgb(128,0,255)",
    "rgb(255,0,255)",
    "rgb(245,0,0)",
    "rgb(245,123,0)",
    "rgb(245,245,0)",
    "rgb(0,245,0)",
    "rgb(0,245,123)",
    "rgb(0,245,245)",
    "rgb(0,123,245)",
    "rgb(0,0,245)",
    "rgb(123,0,245)",
    "rgb(245,0,245)",
    "rgb(214,0,0)",
    "rgb(214,108,0)",
    "rgb(214,214,0)",
    "rgb(0,214,0)",
    "rgb(0,214,108)",
    "rgb(0,214,214)",
    "rgb(0,108,214)",
    "rgb(0,0,214)",
    "rgb(108,0,214)",
    "rgb(214,0,214)",
    "rgb(163,0,0)",
    "rgb(163,82,0)",
    "rgb(163,163,0)",
    "rgb(0,163,0)",
    "rgb(0,163,82)",
    "rgb(0,163,163)",
    "rgb(0,82,163)",
    "rgb(0,0,163)",
    "rgb(82,0,163)",
    "rgb(163,0,163)",
    "rgb(92,0,0)",
    "rgb(92,46,0)",
    "rgb(92,92,0)",
    "rgb(0,92,0)",
    "rgb(0,92,46)",
    "rgb(0,92,92)",
    "rgb(0,46,92)",
    "rgb(0,0,92)",
    "rgb(46,0,92)",
    "rgb(92,0,92)",
    "rgb(255,255,255)",
    "rgb(205,205,205)",
    "rgb(178,178,178)",
    "rgb(153,153,153)",
    "rgb(127,127,127)",
    "rgb(102,102,102)",
    "rgb(76,76,76)",
    "rgb(51,51,51)",
    "rgb(25,25,25)",
    "rgb(0,0,0)"
], Pm = "M5 5 h10 v10 h-10 v-10 z", ox = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAH0lEQVQoU2NkYGAwZkAFZ5G5jPRRgOYEVDeB3EBjBQBOZwTVugIGyAAAAABJRU5ErkJggg==", Am = R({
    name: "QColor",
    props: (0, $8typN._)((0, $8pZMQ._)({}, he, _t), {
        modelValue: String,
        defaultValue: String,
        defaultView: {
            type: String,
            default: "spectrum",
            validator: function(e) {
                return [
                    "spectrum",
                    "tune",
                    "palette"
                ].includes(e);
            }
        },
        formatModel: {
            type: String,
            default: "auto",
            validator: function(e) {
                return [
                    "auto",
                    "hex",
                    "rgb",
                    "hexa",
                    "rgba"
                ].includes(e);
            }
        },
        palette: Array,
        noHeader: Boolean,
        noHeaderTabs: Boolean,
        noFooter: Boolean,
        square: Boolean,
        flat: Boolean,
        bordered: Boolean,
        disable: Boolean,
        readonly: Boolean
    }),
    emits: [
        "update:modelValue",
        "change"
    ],
    setup: function(e, param) {
        var t = param.emit;
        var _ex = (0, $aD8ZA.getCurrentInstance)(), o = _ex.proxy, r = o.$q, n = pe(e, r), _No = No(), i = _No.getCache, a = (0, $aAzpa.ref)(null), l = (0, $aAzpa.ref)(null), s = (0, $aAzpa.computed)(function() {
            return e.formatModel === "auto" ? null : e.formatModel.indexOf("hex") !== -1;
        }), c = (0, $aAzpa.computed)(function() {
            return e.formatModel === "auto" ? null : e.formatModel.indexOf("a") !== -1;
        }), u = (0, $aAzpa.ref)(e.formatModel === "auto" ? e.modelValue === void 0 || e.modelValue === null || e.modelValue === "" || e.modelValue.startsWith("#") ? "hex" : "rgb" : e.formatModel.startsWith("hex") ? "hex" : "rgb"), v = (0, $aAzpa.ref)(e.defaultView), f = (0, $aAzpa.ref)(q(e.modelValue || e.defaultValue)), d = (0, $aAzpa.computed)(function() {
            return e.disable !== !0 && e.readonly !== !0;
        }), m = (0, $aAzpa.computed)(function() {
            return e.modelValue === void 0 || e.modelValue === null || e.modelValue === "" || e.modelValue.startsWith("#");
        }), y = (0, $aAzpa.computed)(function() {
            return s.value !== null ? s.value : m.value;
        }), p = (0, $aAzpa.computed)(function() {
            return {
                type: "hidden",
                name: e.name,
                value: f.value[y.value === !0 ? "hex" : "rgb"]
            };
        }), C = eo(p), b = (0, $aAzpa.computed)(function() {
            return c.value !== null ? c.value : f.value.a !== void 0;
        }), h = (0, $aAzpa.computed)(function() {
            return {
                backgroundColor: f.value.rgb || "#000"
            };
        }), g = (0, $aAzpa.computed)(function() {
            return "q-color-picker__header-content q-color-picker__header-content--".concat((f.value.a !== void 0 && f.value.a < 65 ? !0 : Tc(f.value) > .4) ? "light" : "dark");
        }), S = (0, $aAzpa.computed)(function() {
            return {
                background: "hsl(".concat(f.value.h, ",100%,50%)")
            };
        }), P = (0, $aAzpa.computed)(function() {
            return {
                top: "".concat(100 - f.value.v, "%"),
                [r.lang.rtl === !0 ? "right" : "left"]: "".concat(f.value.s, "%")
            };
        }), $ = (0, $aAzpa.computed)(function() {
            return e.palette !== void 0 && e.palette.length !== 0 ? e.palette : tx;
        }), L = (0, $aAzpa.computed)(function() {
            return "q-color-picker" + (e.bordered === !0 ? " q-color-picker--bordered" : "") + (e.square === !0 ? " q-color-picker--square no-border-radius" : "") + (e.flat === !0 ? " q-color-picker--flat no-shadow" : "") + (e.disable === !0 ? " disabled" : "") + (n.value === !0 ? " q-color-picker--dark q-dark" : "");
        }), E = (0, $aAzpa.computed)(function() {
            return e.disable === !0 ? {
                "aria-disabled": "true"
            } : {};
        }), A = (0, $aAzpa.computed)(function() {
            return [
                [
                    qt,
                    W,
                    void 0,
                    {
                        prevent: !0,
                        stop: !0,
                        mouse: !0
                    }
                ]
            ];
        });
        (0, $aD8ZA.watch)(function() {
            return e.modelValue;
        }, function(U) {
            var ae = q(U || e.defaultValue);
            ae.hex !== f.value.hex && (f.value = ae);
        }), (0, $aD8ZA.watch)(function() {
            return e.defaultValue;
        }, function(U) {
            if (!e.modelValue && U) {
                var ae = q(U);
                ae.hex !== f.value.hex && (f.value = ae);
            }
        });
        function B(U, ae) {
            f.value.hex = Vr(U), f.value.rgb = qc(U), f.value.r = U.r, f.value.g = U.g, f.value.b = U.b, f.value.a = U.a;
            var ce = f.value[y.value === !0 ? "hex" : "rgb"];
            t("update:modelValue", ce), ae === !0 && t("change", ce);
        }
        function q(U) {
            var ae = c.value !== void 0 ? c.value : e.formatModel === "auto" ? null : e.formatModel.indexOf("a") !== -1;
            if (typeof U != "string" || U.length === 0 || Dr.anyColor(U.replace(/ /g, "")) !== !0) return {
                h: 0,
                s: 0,
                v: 0,
                r: 0,
                g: 0,
                b: 0,
                a: ae === !0 ? 100 : void 0,
                hex: void 0,
                rgb: void 0
            };
            var ce = mn(U);
            return ae === !0 && ce.a === void 0 && (ce.a = 100), ce.hex = Vr(ce), ce.rgb = qc(ce), Object.assign(ce, ja(ce));
        }
        function x(U, ae, ce) {
            var be = a.value;
            if (be === null) return;
            var Me = be.clientWidth, le = be.clientHeight, Re = be.getBoundingClientRect(), Fe = Math.min(Me, Math.max(0, U - Re.left));
            r.lang.rtl === !0 && (Fe = Me - Fe);
            var De = Math.min(le, Math.max(0, ae - Re.top)), ne = Math.round(100 * Fe / Me), se = Math.round(100 * Math.max(0, Math.min(1, -(De / le) + 1))), Y = mu({
                h: f.value.h,
                s: ne,
                v: se,
                a: b.value === !0 ? f.value.a : void 0
            });
            f.value.s = ne, f.value.v = se, B(Y, ce);
        }
        function k(U, ae) {
            var ce = Math.round(U), be = mu({
                h: ce,
                s: f.value.s,
                v: f.value.v,
                a: b.value === !0 ? f.value.a : void 0
            });
            f.value.h = ce, B(be, ae);
        }
        function j(U) {
            k(U, !0);
        }
        function Q(U, ae, ce, be, Me) {
            if (be !== void 0 && tt(be), !/^[0-9]+$/.test(U)) {
                Me === !0 && o.$forceUpdate();
                return;
            }
            var le = Math.floor(Number(U));
            if (le < 0 || le > ce) {
                Me === !0 && o.$forceUpdate();
                return;
            }
            var Re = {
                r: ae === "r" ? le : f.value.r,
                g: ae === "g" ? le : f.value.g,
                b: ae === "b" ? le : f.value.b,
                a: b.value === !0 ? ae === "a" ? le : f.value.a : void 0
            };
            if (ae !== "a") {
                var Fe = ja(Re);
                f.value.h = Fe.h, f.value.s = Fe.s, f.value.v = Fe.v;
            }
            if (B(Re, Me), be !== void 0 && Me !== !0 && be.target.selectionEnd !== void 0) {
                var Fe1 = be.target.selectionEnd;
                (0, $aD8ZA.nextTick)(function() {
                    be.target.setSelectionRange(Fe1, Fe1);
                });
            }
        }
        function w(U, ae) {
            var ce, be = U.target.value;
            if (tt(U), u.value === "hex") {
                if (be.length !== (b.value === !0 ? 9 : 7) || !/^#[0-9A-Fa-f]+$/.test(be)) return !0;
                ce = fu(be);
            } else {
                var le;
                if (be.endsWith(")")) {
                    if (b.value !== !0 && be.startsWith("rgb(")) {
                        if (le = be.substring(4, be.length - 1).split(",").map(function(Re) {
                            return parseInt(Re, 10);
                        }), le.length !== 3 || !/^rgb\([0-9]{1,3},[0-9]{1,3},[0-9]{1,3}\)$/.test(be)) return !0;
                    } else if (b.value === !0 && be.startsWith("rgba(")) {
                        if (le = be.substring(5, be.length - 1).split(","), le.length !== 4 || !/^rgba\([0-9]{1,3},[0-9]{1,3},[0-9]{1,3},(0|0\.[0-9]+[1-9]|0\.[1-9]+|1)\)$/.test(be)) return !0;
                        for(var Fe = 0; Fe < 3; Fe++){
                            var De = parseInt(le[Fe], 10);
                            if (De < 0 || De > 255) return !0;
                            le[Fe] = De;
                        }
                        var Re = parseFloat(le[3]);
                        if (Re < 0 || Re > 1) return !0;
                        le[3] = Re;
                    } else return !0;
                } else return !0;
                if (le[0] < 0 || le[0] > 255 || le[1] < 0 || le[1] > 255 || le[2] < 0 || le[2] > 255 || b.value === !0 && (le[3] < 0 || le[3] > 1)) return !0;
                ce = {
                    r: le[0],
                    g: le[1],
                    b: le[2],
                    a: b.value === !0 ? le[3] * 100 : void 0
                };
            }
            var Me = ja(ce);
            if (f.value.h = Me.h, f.value.s = Me.s, f.value.v = Me.v, B(ce, ae), ae !== !0) {
                var le1 = U.target.selectionEnd;
                (0, $aD8ZA.nextTick)(function() {
                    U.target.setSelectionRange(le1, le1);
                });
            }
        }
        function H(U) {
            var ae = q(U), ce = {
                r: ae.r,
                g: ae.g,
                b: ae.b,
                a: ae.a
            };
            ce.a === void 0 && (ce.a = f.value.a), f.value.h = ae.h, f.value.s = ae.s, f.value.v = ae.v, B(ce, !0);
        }
        function W(U) {
            U.isFinal ? x(U.position.left, U.position.top, !0) : ie(U);
        }
        var ie = Pa(function(U) {
            x(U.position.left, U.position.top);
        }, 20);
        function V(U) {
            x(U.pageX - window.pageXOffset, U.pageY - window.pageYOffset, !0);
        }
        function _(U) {
            x(U.pageX - window.pageXOffset, U.pageY - window.pageYOffset);
        }
        function N(U) {
            l.value !== null && (l.value.$el.style.opacity = U ? 1 : 0);
        }
        function I(U) {
            u.value = U;
        }
        function oe() {
            var U = [];
            return e.noHeaderTabs !== !0 && U.push((0, $aD8ZA.h)(Qa, {
                class: "q-color-picker__header-tabs",
                modelValue: u.value,
                dense: !0,
                align: "justify",
                "onUpdate:modelValue": I
            }, function() {
                return [
                    (0, $aD8ZA.h)(ir, {
                        label: "HEX" + (b.value === !0 ? "A" : ""),
                        name: "hex",
                        ripple: !1
                    }),
                    (0, $aD8ZA.h)(ir, {
                        label: "RGB" + (b.value === !0 ? "A" : ""),
                        name: "rgb",
                        ripple: !1
                    })
                ];
            })), U.push((0, $aD8ZA.h)("div", {
                class: "q-color-picker__header-banner row flex-center no-wrap"
            }, [
                (0, $aD8ZA.h)("input", (0, $8pZMQ._)({
                    class: "fit",
                    value: f.value[u.value]
                }, d.value !== !0 ? {
                    readonly: !0
                } : {}, i("topIn", {
                    onInput: function(ae) {
                        N(w(ae) === !0);
                    },
                    onChange: tt,
                    onBlur: function(ae) {
                        w(ae, !0) === !0 && o.$forceUpdate(), N(!1);
                    }
                }))),
                (0, $aD8ZA.h)(we, {
                    ref: l,
                    class: "q-color-picker__error-icon absolute no-pointer-events",
                    name: r.iconSet.type.negative
                })
            ])), (0, $aD8ZA.h)("div", {
                class: "q-color-picker__header relative-position overflow-hidden"
            }, [
                (0, $aD8ZA.h)("div", {
                    class: "q-color-picker__header-bg absolute-full"
                }),
                (0, $aD8ZA.h)("div", {
                    class: g.value,
                    style: h.value
                }, U)
            ]);
        }
        function T() {
            return (0, $aD8ZA.h)(su, {
                modelValue: v.value,
                animated: !0
            }, function() {
                return [
                    (0, $aD8ZA.h)(Gi, {
                        class: "q-color-picker__spectrum-tab overflow-hidden",
                        name: "spectrum"
                    }, z),
                    (0, $aD8ZA.h)(Gi, {
                        class: "q-pa-md q-color-picker__tune-tab",
                        name: "tune"
                    }, ue),
                    (0, $aD8ZA.h)(Gi, {
                        class: "q-color-picker__palette-tab",
                        name: "palette"
                    }, _e)
                ];
            });
        }
        function D(U) {
            v.value = U;
        }
        function te() {
            return (0, $aD8ZA.h)("div", {
                class: "q-color-picker__footer relative-position overflow-hidden"
            }, [
                (0, $aD8ZA.h)(Qa, {
                    class: "absolute-full",
                    modelValue: v.value,
                    dense: !0,
                    align: "justify",
                    "onUpdate:modelValue": D
                }, function() {
                    return [
                        (0, $aD8ZA.h)(ir, {
                            icon: r.iconSet.colorPicker.spectrum,
                            name: "spectrum",
                            ripple: !1
                        }),
                        (0, $aD8ZA.h)(ir, {
                            icon: r.iconSet.colorPicker.tune,
                            name: "tune",
                            ripple: !1
                        }),
                        (0, $aD8ZA.h)(ir, {
                            icon: r.iconSet.colorPicker.palette,
                            name: "palette",
                            ripple: !1
                        })
                    ];
                })
            ]);
        }
        function z() {
            var U = (0, $8pZMQ._)({
                ref: a,
                class: "q-color-picker__spectrum non-selectable relative-position cursor-pointer" + (d.value !== !0 ? " readonly" : ""),
                style: S.value
            }, d.value === !0 ? {
                onClick: V,
                onMousedown: _
            } : {}), ae = [
                (0, $aD8ZA.h)("div", {
                    style: {
                        paddingBottom: "100%"
                    }
                }),
                (0, $aD8ZA.h)("div", {
                    class: "q-color-picker__spectrum-white absolute-full"
                }),
                (0, $aD8ZA.h)("div", {
                    class: "q-color-picker__spectrum-black absolute-full"
                }),
                (0, $aD8ZA.h)("div", {
                    class: "absolute",
                    style: P.value
                }, [
                    f.value.hex !== void 0 ? (0, $aD8ZA.h)("div", {
                        class: "q-color-picker__spectrum-circle"
                    }) : null
                ])
            ], ce = [
                (0, $aD8ZA.h)(Bn, {
                    class: "q-color-picker__hue non-selectable",
                    modelValue: f.value.h,
                    min: 0,
                    max: 360,
                    trackSize: "8px",
                    innerTrackColor: "transparent",
                    selectionColor: "transparent",
                    readonly: d.value !== !0,
                    thumbPath: Pm,
                    "onUpdate:modelValue": k,
                    onChange: j
                })
            ];
            return b.value === !0 && ce.push((0, $aD8ZA.h)(Bn, (0, $8pZMQ._)({
                class: "q-color-picker__alpha non-selectable",
                modelValue: f.value.a,
                min: 0,
                max: 100,
                trackSize: "8px",
                trackColor: "white",
                innerTrackColor: "transparent",
                selectionColor: "transparent",
                trackImg: ox,
                readonly: d.value !== !0,
                hideSelection: !0,
                thumbPath: Pm
            }, i("alphaSlide", {
                "onUpdate:modelValue": function(be) {
                    return Q(be, "a", 100);
                },
                onChange: function(be) {
                    return Q(be, "a", 100, void 0, !0);
                }
            })))), [
                kt("div", U, ae, "spec", d.value, function() {
                    return A.value;
                }),
                (0, $aD8ZA.h)("div", {
                    class: "q-color-picker__sliders"
                }, ce)
            ];
        }
        function ue() {
            return [
                (0, $aD8ZA.h)("div", {
                    class: "row items-center no-wrap"
                }, [
                    (0, $aD8ZA.h)("div", "R"),
                    (0, $aD8ZA.h)(Bn, (0, $8pZMQ._)({
                        modelValue: f.value.r,
                        min: 0,
                        max: 255,
                        color: "red",
                        dark: n.value,
                        readonly: d.value !== !0
                    }, i("rSlide", {
                        "onUpdate:modelValue": function(U) {
                            return Q(U, "r", 255);
                        },
                        onChange: function(U) {
                            return Q(U, "r", 255, void 0, !0);
                        }
                    }))),
                    (0, $aD8ZA.h)("input", (0, $8pZMQ._)({
                        value: f.value.r,
                        maxlength: 3,
                        readonly: d.value !== !0,
                        onChange: tt
                    }, i("rIn", {
                        onInput: function(U) {
                            return Q(U.target.value, "r", 255, U);
                        },
                        onBlur: function(U) {
                            return Q(U.target.value, "r", 255, U, !0);
                        }
                    })))
                ]),
                (0, $aD8ZA.h)("div", {
                    class: "row items-center no-wrap"
                }, [
                    (0, $aD8ZA.h)("div", "G"),
                    (0, $aD8ZA.h)(Bn, (0, $8pZMQ._)({
                        modelValue: f.value.g,
                        min: 0,
                        max: 255,
                        color: "green",
                        dark: n.value,
                        readonly: d.value !== !0
                    }, i("gSlide", {
                        "onUpdate:modelValue": function(U) {
                            return Q(U, "g", 255);
                        },
                        onChange: function(U) {
                            return Q(U, "g", 255, void 0, !0);
                        }
                    }))),
                    (0, $aD8ZA.h)("input", (0, $8pZMQ._)({
                        value: f.value.g,
                        maxlength: 3,
                        readonly: d.value !== !0,
                        onChange: tt
                    }, i("gIn", {
                        onInput: function(U) {
                            return Q(U.target.value, "g", 255, U);
                        },
                        onBlur: function(U) {
                            return Q(U.target.value, "g", 255, U, !0);
                        }
                    })))
                ]),
                (0, $aD8ZA.h)("div", {
                    class: "row items-center no-wrap"
                }, [
                    (0, $aD8ZA.h)("div", "B"),
                    (0, $aD8ZA.h)(Bn, (0, $8pZMQ._)({
                        modelValue: f.value.b,
                        min: 0,
                        max: 255,
                        color: "blue",
                        readonly: d.value !== !0,
                        dark: n.value
                    }, i("bSlide", {
                        "onUpdate:modelValue": function(U) {
                            return Q(U, "b", 255);
                        },
                        onChange: function(U) {
                            return Q(U, "b", 255, void 0, !0);
                        }
                    }))),
                    (0, $aD8ZA.h)("input", (0, $8pZMQ._)({
                        value: f.value.b,
                        maxlength: 3,
                        readonly: d.value !== !0,
                        onChange: tt
                    }, i("bIn", {
                        onInput: function(U) {
                            return Q(U.target.value, "b", 255, U);
                        },
                        onBlur: function(U) {
                            return Q(U.target.value, "b", 255, U, !0);
                        }
                    })))
                ]),
                b.value === !0 ? (0, $aD8ZA.h)("div", {
                    class: "row items-center no-wrap"
                }, [
                    (0, $aD8ZA.h)("div", "A"),
                    (0, $aD8ZA.h)(Bn, (0, $8pZMQ._)({
                        modelValue: f.value.a,
                        color: "grey",
                        readonly: d.value !== !0,
                        dark: n.value
                    }, i("aSlide", {
                        "onUpdate:modelValue": function(U) {
                            return Q(U, "a", 100);
                        },
                        onChange: function(U) {
                            return Q(U, "a", 100, void 0, !0);
                        }
                    }))),
                    (0, $aD8ZA.h)("input", (0, $8pZMQ._)({
                        value: f.value.a,
                        maxlength: 3,
                        readonly: d.value !== !0,
                        onChange: tt
                    }, i("aIn", {
                        onInput: function(U) {
                            return Q(U.target.value, "a", 100, U);
                        },
                        onBlur: function(U) {
                            return Q(U.target.value, "a", 100, U, !0);
                        }
                    })))
                ]) : null
            ];
        }
        function _e() {
            var U = function(ae) {
                return (0, $aD8ZA.h)("div", (0, $8pZMQ._)({
                    class: "q-color-picker__cube col-auto",
                    style: {
                        backgroundColor: ae
                    }
                }, d.value === !0 ? i("palette#" + ae, {
                    onClick: function() {
                        H(ae);
                    }
                }) : {}));
            };
            return [
                (0, $aD8ZA.h)("div", {
                    class: "row items-center q-color-picker__palette-rows" + (d.value === !0 ? " q-color-picker__palette-rows--editable" : "")
                }, $.value.map(U))
            ];
        }
        return function() {
            var U = [
                T()
            ];
            return e.name !== void 0 && e.disable !== !0 && C(U, "push"), e.noHeader !== !0 && U.unshift(oe()), e.noFooter !== !0 && U.push(te()), (0, $aD8ZA.h)("div", (0, $8pZMQ._)({
                class: L.value
            }, E.value), U);
        };
    }
});
var ar = [
    -61,
    9,
    38,
    199,
    426,
    686,
    756,
    818,
    1111,
    1181,
    1210,
    1635,
    2060,
    2097,
    2192,
    2262,
    2324,
    2394,
    2456,
    3178
];
function $m(e, t, o) {
    return Object.prototype.toString.call(e) === "[object Date]" && (o = e.getDate(), t = e.getMonth() + 1, e = e.getFullYear()), ax(Rc(e, t, o));
}
function Mc(e, t, o) {
    return Bm(ix(e, t, o));
}
function nx(e) {
    return rx(e) === 0;
}
function Zi(e, t) {
    return t <= 6 ? 31 : t <= 11 || nx(e) ? 30 : 29;
}
function rx(e) {
    var t = ar.length, o = ar[0], r, n, i, a, l;
    if (e < o || e >= ar[t - 1]) throw new Error("Invalid Jalaali year " + e);
    for(l = 1; l < t && (r = ar[l], n = r - o, !(e < r)); l += 1)o = r;
    return a = e - o, n - a < 6 && (a = a - n + St(n + 4, 33) * 33), i = _o(_o(a + 1, 33) - 1, 4), i === -1 && (i = 4), i;
}
function Em(e, t) {
    var o = ar.length, r = e + 621, n = -14, i = ar[0], a, l, s, c, u;
    if (e < i || e >= ar[o - 1]) throw new Error("Invalid Jalaali year " + e);
    for(u = 1; u < o && (a = ar[u], l = a - i, !(e < a)); u += 1)n = n + St(l, 33) * 8 + St(_o(l, 33), 4), i = a;
    c = e - i, n = n + St(c, 33) * 8 + St(_o(c, 33) + 3, 4), _o(l, 33) === 4 && l - c === 4 && (n += 1);
    var v = St(r, 4) - St((St(r, 100) + 1) * 3, 4) - 150, f = 20 + n - v;
    return t || (l - c < 6 && (c = c - l + St(l + 4, 33) * 33), s = _o(_o(c + 1, 33) - 1, 4), s === -1 && (s = 4)), {
        leap: s,
        gy: r,
        march: f
    };
}
function ix(e, t, o) {
    var r = Em(e, !0);
    return Rc(r.gy, 3, r.march) + (t - 1) * 31 - St(t, 7) * (t - 7) + o - 1;
}
function ax(e) {
    var t = Bm(e).gy, o = t - 621, r, n, i, a = Em(o, !1), l = Rc(t, 3, a.march);
    if (i = e - l, i >= 0) {
        if (i <= 185) return n = 1 + St(i, 31), r = _o(i, 31) + 1, {
            jy: o,
            jm: n,
            jd: r
        };
        i -= 186;
    } else o -= 1, i += 179, a.leap === 1 && (i += 1);
    return n = 7 + St(i, 30), r = _o(i, 30) + 1, {
        jy: o,
        jm: n,
        jd: r
    };
}
function Rc(e, t, o) {
    var r = St((e + St(t - 8, 6) + 100100) * 1461, 4) + St(153 * _o(t + 9, 12) + 2, 5) + o - 34840408;
    return r = r - St(St(e + 100100 + St(t - 8, 6), 100) * 3, 4) + 752, r;
}
function Bm(e) {
    var t = 4 * e + 139361631;
    t = t + St(St(4 * e + 183187720, 146097) * 3, 4) * 4 - 3908;
    var o = St(_o(t, 1461), 4) * 5 + 308, r = St(_o(o, 153), 5) + 1, n = _o(St(o, 153), 12) + 1;
    return {
        gy: St(t, 1461) - 100100 + St(8 - n, 6),
        gm: n,
        gd: r
    };
}
function St(e, t) {
    return ~~(e / t);
}
function _o(e, t) {
    return e - ~~(e / t) * t;
}
var lx = [
    "gregorian",
    "persian"
], vu = {
    modelValue: {
        required: !0
    },
    mask: {
        type: String
    },
    locale: Object,
    calendar: {
        type: String,
        validator: function(e) {
            return lx.includes(e);
        },
        default: "gregorian"
    },
    landscape: Boolean,
    color: String,
    textColor: String,
    square: Boolean,
    flat: Boolean,
    bordered: Boolean,
    readonly: Boolean,
    disable: Boolean
}, gu = [
    "update:modelValue"
];
function Qo(e) {
    return e.year + "/" + Je(e.month) + "/" + Je(e.day);
}
function hu(e, t) {
    var o = (0, $aAzpa.computed)(function() {
        return e.disable !== !0 && e.readonly !== !0;
    }), r = (0, $aAzpa.computed)(function() {
        return o.value === !0 ? 0 : -1;
    }), n = (0, $aAzpa.computed)(function() {
        var l = [];
        return e.color !== void 0 && l.push("bg-".concat(e.color)), e.textColor !== void 0 && l.push("text-".concat(e.textColor)), l.join(" ");
    });
    function i() {
        return e.locale !== void 0 ? (0, $8pZMQ._)({}, t.lang.date, e.locale) : t.lang.date;
    }
    function a(l) {
        var s = new Date, c = l === !0 ? null : 0;
        if (e.calendar === "persian") {
            var u = $m(s);
            return {
                year: u.jy,
                month: u.jm,
                day: u.jd
            };
        }
        return {
            year: s.getFullYear(),
            month: s.getMonth() + 1,
            day: s.getDate(),
            hour: c,
            minute: c,
            second: c,
            millisecond: c
        };
    }
    return {
        editable: o,
        tabindex: r,
        headerClass: n,
        getLocale: i,
        getCurrentDate: a
    };
}
var Vm = 864e5, ux = 36e5, Ec = 6e4, zm = "YYYY-MM-DDTHH:mm:ss.SSSZ", sx = /\[((?:[^\]\\]|\\]|\\)*)\]|d{1,4}|M{1,4}|m{1,2}|w{1,2}|Qo|Do|D{1,4}|YY(?:YY)?|H{1,2}|h{1,2}|s{1,2}|S{1,3}|Z{1,2}|a{1,2}|[AQExX]/g, cx = /(\[[^\]]*\])|d{1,4}|M{1,4}|m{1,2}|w{1,2}|Qo|Do|D{1,4}|YY(?:YY)?|H{1,2}|h{1,2}|s{1,2}|S{1,3}|Z{1,2}|a{1,2}|[AQExX]|([.*+:?^,\s${}()|\\]+)/g, Ac = {};
function dx(e, t) {
    var o = "(" + t.days.join("|") + ")", r = e + o;
    if (Ac[r] !== void 0) return Ac[r];
    var n = "(" + t.daysShort.join("|") + ")", i = "(" + t.months.join("|") + ")", a = "(" + t.monthsShort.join("|") + ")", l = {}, s = 0, c = e.replace(cx, function(v) {
        switch(s++, v){
            case "YY":
                return l.YY = s, "(-?\\d{1,2})";
            case "YYYY":
                return l.YYYY = s, "(-?\\d{1,4})";
            case "M":
                return l.M = s, "(\\d{1,2})";
            case "MM":
                return l.M = s, "(\\d{2})";
            case "MMM":
                return l.MMM = s, a;
            case "MMMM":
                return l.MMMM = s, i;
            case "D":
                return l.D = s, "(\\d{1,2})";
            case "Do":
                return l.D = s++, "(\\d{1,2}(st|nd|rd|th))";
            case "DD":
                return l.D = s, "(\\d{2})";
            case "H":
                return l.H = s, "(\\d{1,2})";
            case "HH":
                return l.H = s, "(\\d{2})";
            case "h":
                return l.h = s, "(\\d{1,2})";
            case "hh":
                return l.h = s, "(\\d{2})";
            case "m":
                return l.m = s, "(\\d{1,2})";
            case "mm":
                return l.m = s, "(\\d{2})";
            case "s":
                return l.s = s, "(\\d{1,2})";
            case "ss":
                return l.s = s, "(\\d{2})";
            case "S":
                return l.S = s, "(\\d{1})";
            case "SS":
                return l.S = s, "(\\d{2})";
            case "SSS":
                return l.S = s, "(\\d{3})";
            case "A":
                return l.A = s, "(AM|PM)";
            case "a":
                return l.a = s, "(am|pm)";
            case "aa":
                return l.aa = s, "(a\\.m\\.|p\\.m\\.)";
            case "ddd":
                return n;
            case "dddd":
                return o;
            case "Q":
            case "d":
            case "E":
                return "(\\d{1})";
            case "Qo":
                return "(1st|2nd|3rd|4th)";
            case "DDD":
            case "DDDD":
                return "(\\d{1,3})";
            case "w":
                return "(\\d{1,2})";
            case "ww":
                return "(\\d{2})";
            case "Z":
                return l.Z = s, "(Z|[+-]\\d{2}:\\d{2})";
            case "ZZ":
                return l.ZZ = s, "(Z|[+-]\\d{2}\\d{2})";
            case "X":
                return l.X = s, "(-?\\d+)";
            case "x":
                return l.x = s, "(-?\\d{4,})";
            default:
                return s--, v[0] === "[" && (v = v.substring(1, v.length - 1)), v.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
        }
    }), u = {
        map: l,
        regex: new RegExp("^" + c)
    };
    return Ac[r] = u, u;
}
function Om(e, t) {
    return e !== void 0 ? e : t !== void 0 ? t.date : qa.default.date;
}
function Lm(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    var o = e > 0 ? "-" : "+", r = Math.abs(e), n = Math.floor(r / 60), i = r % 60;
    return o + Je(n) + t + Je(i);
}
function fx(e, t, o) {
    var r = e.getFullYear(), n = e.getMonth(), i = e.getDate();
    return t.year !== void 0 && (r += o * t.year, delete t.year), t.month !== void 0 && (n += o * t.month, delete t.month), e.setDate(1), e.setMonth(2), e.setFullYear(r), e.setMonth(n), e.setDate(Math.min(i, Dc(e))), t.date !== void 0 && (e.setDate(e.getDate() + o * t.date), delete t.date), e;
}
function mx(e, t, o) {
    var r = t.year !== void 0 ? t.year : e["get".concat(o, "FullYear")](), n = t.month !== void 0 ? t.month - 1 : e["get".concat(o, "Month")](), i = new Date(r, n + 1, 0).getDate(), a = Math.min(i, t.date !== void 0 ? t.date : e["get".concat(o, "Date")]());
    return e["set".concat(o, "Date")](1), e["set".concat(o, "Month")](2), e["set".concat(o, "FullYear")](r), e["set".concat(o, "Month")](n), e["set".concat(o, "Date")](a), delete t.year, delete t.month, delete t.date, e;
}
function Fc(e, t, o) {
    var r = Im(t), n = new Date(e), i = r.year !== void 0 || r.month !== void 0 || r.date !== void 0 ? fx(n, r, o) : n;
    for(var a in r){
        var l = ec(a);
        i["set".concat(l)](i["get".concat(l)]() + o * r[a]);
    }
    return i;
}
function Im(e) {
    var t = (0, $8pZMQ._)({}, e);
    return e.years !== void 0 && (t.year = e.years, delete t.years), e.months !== void 0 && (t.month = e.months, delete t.months), e.days !== void 0 && (t.date = e.days, delete t.days), e.day !== void 0 && (t.date = e.day, delete t.day), e.hour !== void 0 && (t.hours = e.hour, delete t.hour), e.minute !== void 0 && (t.minutes = e.minute, delete t.minute), e.second !== void 0 && (t.seconds = e.second, delete t.second), e.millisecond !== void 0 && (t.milliseconds = e.millisecond, delete t.millisecond), t;
}
function Hm(e, t, o) {
    var r = Im(t), n = o === !0 ? "UTC" : "", i = new Date(e), a = r.year !== void 0 || r.month !== void 0 || r.date !== void 0 ? mx(i, r, n) : i;
    for(var l in r){
        var s = l.charAt(0).toUpperCase() + l.slice(1);
        a["set".concat(n).concat(s)](r[l]);
    }
    return a;
}
function vx(e, t, o) {
    var r = lr(e, t, o), n = new Date(r.year, r.month === null ? null : r.month - 1, r.day === null ? 1 : r.day, r.hour, r.minute, r.second, r.millisecond), i = n.getTimezoneOffset();
    return r.timezoneOffset === null || r.timezoneOffset === i ? n : Fc(n, {
        minutes: r.timezoneOffset - i
    }, 1);
}
function lr(e, t, o, r, n) {
    var i = {
        year: null,
        month: null,
        day: null,
        hour: null,
        minute: null,
        second: null,
        millisecond: null,
        timezoneOffset: null,
        dateHash: null,
        timeHash: null
    };
    if (n !== void 0 && Object.assign(i, n), e == null || e === "" || typeof e != "string") return i;
    t === void 0 && (t = zm);
    var a = Om(o, Kn.props), l = a.months, s = a.monthsShort, _dx = dx(t, a), c = _dx.regex, u = _dx.map, v = e.match(c);
    if (v === null) return i;
    var f = "";
    if (u.X !== void 0 || u.x !== void 0) {
        var d = parseInt(v[u.X !== void 0 ? u.X : u.x], 10);
        if (isNaN(d) === !0 || d < 0) return i;
        var m = new Date(d * (u.X !== void 0 ? 1e3 : 1));
        i.year = m.getFullYear(), i.month = m.getMonth() + 1, i.day = m.getDate(), i.hour = m.getHours(), i.minute = m.getMinutes(), i.second = m.getSeconds(), i.millisecond = m.getMilliseconds();
    } else {
        if (u.YYYY !== void 0) i.year = parseInt(v[u.YYYY], 10);
        else if (u.YY !== void 0) {
            var d1 = parseInt(v[u.YY], 10);
            i.year = d1 < 0 ? d1 : 2e3 + d1;
        }
        if (u.M !== void 0) {
            if (i.month = parseInt(v[u.M], 10), i.month < 1 || i.month > 12) return i;
        } else u.MMM !== void 0 ? i.month = s.indexOf(v[u.MMM]) + 1 : u.MMMM !== void 0 && (i.month = l.indexOf(v[u.MMMM]) + 1);
        if (u.D !== void 0) {
            if (i.day = parseInt(v[u.D], 10), i.year === null || i.month === null || i.day < 1) return i;
            var d2 = r !== "persian" ? new Date(i.year, i.month, 0).getDate() : Zi(i.year, i.month);
            if (i.day > d2) return i;
        }
        u.H !== void 0 ? i.hour = parseInt(v[u.H], 10) % 24 : u.h !== void 0 && (i.hour = parseInt(v[u.h], 10) % 12, (u.A && v[u.A] === "PM" || u.a && v[u.a] === "pm" || u.aa && v[u.aa] === "p.m.") && (i.hour += 12), i.hour = i.hour % 24), u.m !== void 0 && (i.minute = parseInt(v[u.m], 10) % 60), u.s !== void 0 && (i.second = parseInt(v[u.s], 10) % 60), u.S !== void 0 && (i.millisecond = parseInt(v[u.S], 10) * Math.pow(10, 3 - v[u.S].length)), (u.Z !== void 0 || u.ZZ !== void 0) && (f = u.Z !== void 0 ? v[u.Z].replace(":", "") : v[u.ZZ], i.timezoneOffset = (f[0] === "+" ? -1 : 1) * (60 * f.slice(1, 3) + 1 * f.slice(3, 5)));
    }
    return i.dateHash = Je(i.year, 6) + "/" + Je(i.month) + "/" + Je(i.day), i.timeHash = Je(i.hour) + ":" + Je(i.minute) + ":" + Je(i.second) + f, i;
}
function gx(e) {
    return typeof e == "number" ? !0 : isNaN(Date.parse(e)) === !1;
}
function hx(e, t) {
    return Hm(new Date, e, t);
}
function px(e) {
    var t = new Date(e).getDay();
    return t === 0 ? 7 : t;
}
function Bc(e) {
    var t = new Date(e.getFullYear(), e.getMonth(), e.getDate());
    t.setDate(t.getDate() - (t.getDay() + 6) % 7 + 3);
    var o = new Date(t.getFullYear(), 0, 4);
    o.setDate(o.getDate() - (o.getDay() + 6) % 7 + 3);
    var r = t.getTimezoneOffset() - o.getTimezoneOffset();
    t.setHours(t.getHours() - r);
    var n = (t - o) / (Vm * 7);
    return 1 + Math.floor(n);
}
function bx(e) {
    return e.getFullYear() * 1e4 + e.getMonth() * 100 + e.getDate();
}
function $c(e, t) {
    var o = new Date(e);
    return t === !0 ? bx(o) : o.getTime();
}
function yx(e, t, o) {
    var r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    var n = $c(t, r.onlyDate), i = $c(o, r.onlyDate), a = $c(e, r.onlyDate);
    return (a > n || r.inclusiveFrom === !0 && a === n) && (a < i || r.inclusiveTo === !0 && a === i);
}
function Sx(e, t) {
    return Fc(e, t, 1);
}
function xx(e, t) {
    return Fc(e, t, -1);
}
function vn(e, t, o) {
    var r = new Date(e), n = "set".concat(o === !0 ? "UTC" : "");
    switch(t){
        case "year":
        case "years":
            r["".concat(n, "Month")](0);
        case "month":
        case "months":
            r["".concat(n, "Date")](1);
        case "day":
        case "days":
        case "date":
            r["".concat(n, "Hours")](0);
        case "hour":
        case "hours":
            r["".concat(n, "Minutes")](0);
        case "minute":
        case "minutes":
            r["".concat(n, "Seconds")](0);
        case "second":
        case "seconds":
            r["".concat(n, "Milliseconds")](0);
    }
    return r;
}
function _x(e, t, o) {
    var r = new Date(e), n = "set".concat(o === !0 ? "UTC" : "");
    switch(t){
        case "year":
        case "years":
            r["".concat(n, "Month")](11);
        case "month":
        case "months":
            r["".concat(n, "Date")](Dc(r));
        case "day":
        case "days":
        case "date":
            r["".concat(n, "Hours")](23);
        case "hour":
        case "hours":
            r["".concat(n, "Minutes")](59);
        case "minute":
        case "minutes":
            r["".concat(n, "Seconds")](59);
        case "second":
        case "seconds":
            r["".concat(n, "Milliseconds")](999);
    }
    return r;
}
function Cx(e) {
    var t = new Date(e);
    return Array.prototype.slice.call(arguments, 1).forEach(function(o) {
        t = Math.max(t, new Date(o));
    }), t;
}
function wx(e) {
    var t = new Date(e);
    return Array.prototype.slice.call(arguments, 1).forEach(function(o) {
        t = Math.min(t, new Date(o));
    }), t;
}
function pu(e, t, o) {
    return (e.getTime() - e.getTimezoneOffset() * Ec - (t.getTime() - t.getTimezoneOffset() * Ec)) / o;
}
function bu(e, t) {
    var o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "days";
    var r = new Date(e), n = new Date(t);
    switch(o){
        case "years":
        case "year":
            return r.getFullYear() - n.getFullYear();
        case "months":
        case "month":
            return (r.getFullYear() - n.getFullYear()) * 12 + r.getMonth() - n.getMonth();
        case "days":
        case "day":
        case "date":
            return pu(vn(r, "day"), vn(n, "day"), Vm);
        case "hours":
        case "hour":
            return pu(vn(r, "hour"), vn(n, "hour"), ux);
        case "minutes":
        case "minute":
            return pu(vn(r, "minute"), vn(n, "minute"), Ec);
        case "seconds":
        case "second":
            return pu(vn(r, "second"), vn(n, "second"), 1e3);
    }
}
function Lc(e) {
    return bu(e, vn(e, "year"), "days") + 1;
}
function kx(e) {
    return Pn(e) === !0 ? "date" : typeof e == "number" ? "number" : "string";
}
function qx(e, t, o) {
    var r = new Date(e);
    if (t) {
        var n = new Date(t);
        if (r < n) return n;
    }
    if (o) {
        var n1 = new Date(o);
        if (r > n1) return n1;
    }
    return r;
}
function Tx(e, t, o) {
    var r = new Date(e), n = new Date(t);
    if (o === void 0) return r.getTime() === n.getTime();
    switch(o){
        case "second":
        case "seconds":
            if (r.getSeconds() !== n.getSeconds()) return !1;
        case "minute":
        case "minutes":
            if (r.getMinutes() !== n.getMinutes()) return !1;
        case "hour":
        case "hours":
            if (r.getHours() !== n.getHours()) return !1;
        case "day":
        case "days":
        case "date":
            if (r.getDate() !== n.getDate()) return !1;
        case "month":
        case "months":
            if (r.getMonth() !== n.getMonth()) return !1;
        case "year":
        case "years":
            if (r.getFullYear() !== n.getFullYear()) return !1;
            break;
        default:
            throw new Error("date isSameDate unknown unit ".concat(o));
    }
    return !0;
}
function Dc(e) {
    return new Date(e.getFullYear(), e.getMonth() + 1, 0).getDate();
}
function Fm(e) {
    if (e >= 11 && e <= 13) return "".concat(e, "th");
    switch(e % 10){
        case 1:
            return "".concat(e, "st");
        case 2:
            return "".concat(e, "nd");
        case 3:
            return "".concat(e, "rd");
    }
    return "".concat(e, "th");
}
var Dm = {
    YY: function(e, t, o) {
        var r = this.YYYY(e, t, o) % 100;
        return r >= 0 ? Je(r) : "-" + Je(Math.abs(r));
    },
    YYYY: function(e, t, o) {
        return o !== null && o !== void 0 ? o : e.getFullYear();
    },
    M: function(e) {
        return e.getMonth() + 1;
    },
    MM: function(e) {
        return Je(e.getMonth() + 1);
    },
    MMM: function(e, t) {
        return t.monthsShort[e.getMonth()];
    },
    MMMM: function(e, t) {
        return t.months[e.getMonth()];
    },
    Q: function(e) {
        return Math.ceil((e.getMonth() + 1) / 3);
    },
    Qo: function(e) {
        return Fm(this.Q(e));
    },
    D: function(e) {
        return e.getDate();
    },
    Do: function(e) {
        return Fm(e.getDate());
    },
    DD: function(e) {
        return Je(e.getDate());
    },
    DDD: function(e) {
        return Lc(e);
    },
    DDDD: function(e) {
        return Je(Lc(e), 3);
    },
    d: function(e) {
        return e.getDay();
    },
    dd: function(e, t) {
        return this.dddd(e, t).slice(0, 2);
    },
    ddd: function(e, t) {
        return t.daysShort[e.getDay()];
    },
    dddd: function(e, t) {
        return t.days[e.getDay()];
    },
    E: function(e) {
        return e.getDay() || 7;
    },
    w: function(e) {
        return Bc(e);
    },
    ww: function(e) {
        return Je(Bc(e));
    },
    H: function(e) {
        return e.getHours();
    },
    HH: function(e) {
        return Je(e.getHours());
    },
    h: function(e) {
        var t = e.getHours();
        return t === 0 ? 12 : t > 12 ? t % 12 : t;
    },
    hh: function(e) {
        return Je(this.h(e));
    },
    m: function(e) {
        return e.getMinutes();
    },
    mm: function(e) {
        return Je(e.getMinutes());
    },
    s: function(e) {
        return e.getSeconds();
    },
    ss: function(e) {
        return Je(e.getSeconds());
    },
    S: function(e) {
        return Math.floor(e.getMilliseconds() / 100);
    },
    SS: function(e) {
        return Je(Math.floor(e.getMilliseconds() / 10));
    },
    SSS: function(e) {
        return Je(e.getMilliseconds(), 3);
    },
    A: function(e) {
        return this.H(e) < 12 ? "AM" : "PM";
    },
    a: function(e) {
        return this.H(e) < 12 ? "am" : "pm";
    },
    aa: function(e) {
        return this.H(e) < 12 ? "a.m." : "p.m.";
    },
    Z: function(e, t, o, r) {
        var n = r !== null && r !== void 0 ? r : e.getTimezoneOffset();
        return Lm(n, ":");
    },
    ZZ: function(e, t, o, r) {
        var n = r !== null && r !== void 0 ? r : e.getTimezoneOffset();
        return Lm(n);
    },
    X: function(e) {
        return Math.floor(e.getTime() / 1e3);
    },
    x: function(e) {
        return e.getTime();
    }
};
function Ka(e, t, o, r, n) {
    if (e !== 0 && !e || e === 1 / 0 || e === -1 / 0) return;
    var i = new Date(e);
    if (isNaN(i)) return;
    t === void 0 && (t = zm);
    var a = Om(o, Kn.props);
    return t.replace(sx, function(l, s) {
        return l in Dm ? Dm[l](i, a, r, n) : s === void 0 ? l : s.split("\\]").join("]");
    });
}
function Mx(e) {
    return Pn(e) === !0 ? new Date(e.getTime()) : e;
}
var Rx = {
    isValid: gx,
    extractDate: vx,
    buildDate: hx,
    getDayOfWeek: px,
    getWeekOfYear: Bc,
    isBetweenDates: yx,
    addToDate: Sx,
    subtractFromDate: xx,
    adjustDate: Hm,
    startOfDate: vn,
    endOfDate: _x,
    getMaxDate: Cx,
    getMinDate: wx,
    getDateDiff: bu,
    getDayOfYear: Lc,
    inferDateFormat: kx,
    getDateBetween: qx,
    isSameDate: Tx,
    daysInMonth: Dc,
    formatDate: Ka,
    clone: Mx
};
var zr = 20, Ax = [
    "Calendar",
    "Years",
    "Months"
], Qm = function(e) {
    return Ax.includes(e);
}, Vc = function(e) {
    return /^-?[\d]+\/[0-1]\d$/.test(e);
}, Ji = " \u2014 ";
function ur(e) {
    return e.year + "/" + Je(e.month);
}
var jm = R({
    name: "QDate",
    props: (0, $8typN._)((0, $8pZMQ._)({}, vu, _t, he), {
        multiple: Boolean,
        range: Boolean,
        title: String,
        subtitle: String,
        mask: {
            default: "YYYY/MM/DD"
        },
        defaultYearMonth: {
            type: String,
            validator: Vc
        },
        yearsInMonthView: Boolean,
        events: [
            Array,
            Function
        ],
        eventColor: [
            String,
            Function
        ],
        emitImmediately: Boolean,
        options: [
            Array,
            Function
        ],
        navigationMinYearMonth: {
            type: String,
            validator: Vc
        },
        navigationMaxYearMonth: {
            type: String,
            validator: Vc
        },
        noUnset: Boolean,
        firstDayOfWeek: [
            String,
            Number
        ],
        todayBtn: Boolean,
        minimal: Boolean,
        defaultView: {
            type: String,
            default: "Calendar",
            validator: Qm
        }
    }),
    emits: (0, $79xu7._)(gu).concat([
        "rangeStart",
        "rangeEnd",
        "navigation"
    ]),
    setup: function(e, param) {
        var t = param.slots, o = param.emit;
        var _Px = (0, $aD8ZA.getCurrentInstance)(), r = _Px.proxy, n = r.$q, i = pe(e, n), _No = No(), a = _No.getCache, _hu = hu(e, n), l = _hu.tabindex, s = _hu.headerClass, c = _hu.getLocale, u = _hu.getCurrentDate, v, f = cn(e), d = eo(f), m = (0, $aAzpa.ref)(null), y = (0, $aAzpa.ref)(nt()), p = (0, $aAzpa.ref)(c()), C = (0, $aAzpa.computed)(function() {
            return nt();
        }), b = (0, $aAzpa.computed)(function() {
            return c();
        }), h = (0, $aAzpa.computed)(function() {
            return u();
        }), g = (0, $aAzpa.ref)(dt(y.value, p.value)), S = (0, $aAzpa.ref)(e.defaultView), P = n.lang.rtl === !0 ? "right" : "left", $ = (0, $aAzpa.ref)(P.value), L = (0, $aAzpa.ref)(P.value), E = g.value.year, A = (0, $aAzpa.ref)(E - E % zr - (E < 0 ? zr : 0)), B = (0, $aAzpa.ref)(null), q = (0, $aAzpa.computed)(function() {
            var M = e.landscape === !0 ? "landscape" : "portrait";
            return "q-date q-date--".concat(M, " q-date--").concat(M, "-").concat(e.minimal === !0 ? "minimal" : "standard") + (i.value === !0 ? " q-date--dark q-dark" : "") + (e.bordered === !0 ? " q-date--bordered" : "") + (e.square === !0 ? " q-date--square no-border-radius" : "") + (e.flat === !0 ? " q-date--flat no-shadow" : "") + (e.disable === !0 ? " disabled" : e.readonly === !0 ? " q-date--readonly" : "");
        }), x = (0, $aAzpa.computed)(function() {
            return e.color || "primary";
        }), k = (0, $aAzpa.computed)(function() {
            return e.textColor || "white";
        }), j = (0, $aAzpa.computed)(function() {
            return e.emitImmediately === !0 && e.multiple !== !0 && e.range !== !0;
        }), Q = (0, $aAzpa.computed)(function() {
            return Array.isArray(e.modelValue) === !0 ? e.modelValue : e.modelValue !== null && e.modelValue !== void 0 ? [
                e.modelValue
            ] : [];
        }), w = (0, $aAzpa.computed)(function() {
            return Q.value.filter(function(M) {
                return typeof M == "string";
            }).map(function(M) {
                return ct(M, y.value, p.value);
            }).filter(function(M) {
                return M.dateHash !== null && M.day !== null && M.month !== null && M.year !== null;
            });
        }), H = (0, $aAzpa.computed)(function() {
            var M = function(O) {
                return ct(O, y.value, p.value);
            };
            return Q.value.filter(function(O) {
                return at(O) === !0 && O.from !== void 0 && O.to !== void 0;
            }).map(function(O) {
                return {
                    from: M(O.from),
                    to: M(O.to)
                };
            }).filter(function(O) {
                return O.from.dateHash !== null && O.to.dateHash !== null && O.from.dateHash < O.to.dateHash;
            });
        }), W = (0, $aAzpa.computed)(function() {
            return e.calendar !== "persian" ? function(M) {
                return new Date(M.year, M.month - 1, M.day);
            } : function(M) {
                var O = Mc(M.year, M.month, M.day);
                return new Date(O.gy, O.gm - 1, O.gd);
            };
        }), ie = (0, $aAzpa.computed)(function() {
            return e.calendar === "persian" ? Qo : function(M, O, X) {
                return Ka(new Date(M.year, M.month - 1, M.day, M.hour, M.minute, M.second, M.millisecond), O === void 0 ? y.value : O, X === void 0 ? p.value : X, M.year, M.timezoneOffset);
            };
        }), V = (0, $aAzpa.computed)(function() {
            return w.value.length + H.value.reduce(function(M, O) {
                return M + 1 + bu(W.value(O.to), W.value(O.from));
            }, 0);
        }), _ = (0, $aAzpa.computed)(function() {
            if (e.title !== void 0 && e.title !== null && e.title.length !== 0) return e.title;
            if (B.value !== null) {
                var X = B.value.init, de = W.value(X);
                return p.value.daysShort[de.getDay()] + ", " + p.value.monthsShort[X.month - 1] + " " + X.day + Ji + "?";
            }
            if (V.value === 0) return Ji;
            if (V.value > 1) return "".concat(V.value, " ").concat(p.value.pluralDay);
            var M = w.value[0], O = W.value(M);
            return isNaN(O.valueOf()) === !0 ? Ji : p.value.headerTitle !== void 0 ? p.value.headerTitle(O, M) : p.value.daysShort[O.getDay()] + ", " + p.value.monthsShort[M.month - 1] + " " + M.day;
        }), N = (0, $aAzpa.computed)(function() {
            return w.value.concat(H.value.map(function(O) {
                return O.from;
            })).sort(function(O, X) {
                return O.year - X.year || O.month - X.month;
            })[0];
        }), I = (0, $aAzpa.computed)(function() {
            return w.value.concat(H.value.map(function(O) {
                return O.to;
            })).sort(function(O, X) {
                return X.year - O.year || X.month - O.month;
            })[0];
        }), oe = (0, $aAzpa.computed)(function() {
            if (e.subtitle !== void 0 && e.subtitle !== null && e.subtitle.length !== 0) return e.subtitle;
            if (V.value === 0) return Ji;
            if (V.value > 1) {
                var M = N.value, O = I.value, X = p.value.monthsShort;
                return X[M.month - 1] + (M.year !== O.year ? " " + M.year + Ji + X[O.month - 1] + " " : M.month !== O.month ? Ji + X[O.month - 1] : "") + " " + O.year;
            }
            return w.value[0].year;
        }), T = (0, $aAzpa.computed)(function() {
            var M = [
                n.iconSet.datetime.arrowLeft,
                n.iconSet.datetime.arrowRight
            ];
            return n.lang.rtl === !0 ? M.reverse() : M;
        }), D = (0, $aAzpa.computed)(function() {
            return e.firstDayOfWeek !== void 0 ? Number(e.firstDayOfWeek) : p.value.firstDayOfWeek;
        }), te = (0, $aAzpa.computed)(function() {
            var M = p.value.daysShort, O = D.value;
            return O > 0 ? M.slice(O, 7).concat(M.slice(0, O)) : M;
        }), z = (0, $aAzpa.computed)(function() {
            var M = g.value;
            return e.calendar !== "persian" ? new Date(M.year, M.month, 0).getDate() : Zi(M.year, M.month);
        }), ue = (0, $aAzpa.computed)(function() {
            return typeof e.eventColor == "function" ? e.eventColor : function() {
                return e.eventColor;
            };
        }), _e = (0, $aAzpa.computed)(function() {
            if (e.navigationMinYearMonth === void 0) return null;
            var M = e.navigationMinYearMonth.split("/");
            return {
                year: parseInt(M[0], 10),
                month: parseInt(M[1], 10)
            };
        }), U = (0, $aAzpa.computed)(function() {
            if (e.navigationMaxYearMonth === void 0) return null;
            var M = e.navigationMaxYearMonth.split("/");
            return {
                year: parseInt(M[0], 10),
                month: parseInt(M[1], 10)
            };
        }), ae = (0, $aAzpa.computed)(function() {
            var M = {
                month: {
                    prev: !0,
                    next: !0
                },
                year: {
                    prev: !0,
                    next: !0
                }
            };
            return _e.value !== null && _e.value.year >= g.value.year && (M.year.prev = !1, _e.value.year === g.value.year && _e.value.month >= g.value.month && (M.month.prev = !1)), U.value !== null && U.value.year <= g.value.year && (M.year.next = !1, U.value.year === g.value.year && U.value.month <= g.value.month && (M.month.next = !1)), M;
        }), ce = (0, $aAzpa.computed)(function() {
            var M = {};
            return w.value.forEach(function(O) {
                var X = ur(O);
                M[X] === void 0 && (M[X] = []), M[X].push(O.day);
            }), M;
        }), be = (0, $aAzpa.computed)(function() {
            var M = {};
            return H.value.forEach(function(O) {
                var X = ur(O.from), de = ur(O.to);
                if (M[X] === void 0 && (M[X] = []), M[X].push({
                    from: O.from.day,
                    to: X === de ? O.to.day : void 0,
                    range: O
                }), X < de) {
                    var fe, _O_from = O.from, et = _O_from.year, Te = _O_from.month, We = Te < 12 ? {
                        year: et,
                        month: Te + 1
                    } : {
                        year: et + 1,
                        month: 1
                    };
                    for(; (fe = ur(We)) <= de;)M[fe] === void 0 && (M[fe] = []), M[fe].push({
                        from: void 0,
                        to: fe === de ? O.to.day : void 0,
                        range: O
                    }), We.month++, We.month > 12 && (We.year++, We.month = 1);
                }
            }), M;
        }), Me = (0, $aAzpa.computed)(function() {
            if (B.value === null) return;
            var _B_value = B.value, M = _B_value.init, O = _B_value.initHash, X = _B_value.final, de = _B_value.finalHash, _ref = (0, $4f96i._)(O <= de ? [
                M,
                X
            ] : [
                X,
                M
            ], 2), fe = _ref[0], et = _ref[1], Te = ur(fe), We = ur(et);
            if (Te !== le.value && We !== le.value) return;
            var rt = {};
            return Te === le.value ? (rt.from = fe.day, rt.includeFrom = !0) : rt.from = 1, We === le.value ? (rt.to = et.day, rt.includeTo = !0) : rt.to = z.value, rt;
        }), le = (0, $aAzpa.computed)(function() {
            return ur(g.value);
        }), Re = (0, $aAzpa.computed)(function() {
            var M = {};
            if (e.options === void 0) {
                for(var X = 1; X <= z.value; X++)M[X] = !0;
                return M;
            }
            var O = typeof e.options == "function" ? e.options : function(X) {
                return e.options.includes(X);
            };
            for(var X1 = 1; X1 <= z.value; X1++){
                var de = le.value + "/" + Je(X1);
                M[X1] = O(de);
            }
            return M;
        }), Fe = (0, $aAzpa.computed)(function() {
            var M = {};
            if (e.events === void 0) for(var O = 1; O <= z.value; O++)M[O] = !1;
            else {
                var O1 = typeof e.events == "function" ? e.events : function(X) {
                    return e.events.includes(X);
                };
                for(var X = 1; X <= z.value; X++){
                    var de = le.value + "/" + Je(X);
                    M[X] = O1(de) === !0 && ue.value(de);
                }
            }
            return M;
        }), De = (0, $aAzpa.computed)(function() {
            var M, O, _g_value = g.value, X = _g_value.year, de = _g_value.month;
            if (e.calendar !== "persian") M = new Date(X, de - 1, 1), O = new Date(X, de - 1, 0).getDate();
            else {
                var fe = Mc(X, de, 1);
                M = new Date(fe.gy, fe.gm - 1, fe.gd);
                var et = de - 1, Te = X;
                et === 0 && (et = 12, Te--), O = Zi(Te, et);
            }
            return {
                days: M.getDay() - D.value - 1,
                endDay: O
            };
        }), ne = (0, $aAzpa.computed)(function() {
            var M = [], _De_value = De.value, O = _De_value.days, X = _De_value.endDay, de = O < 0 ? O + 7 : O;
            if (de < 6) for(var Te = X - de; Te <= X; Te++)M.push({
                i: Te,
                fill: !0
            });
            var fe = M.length;
            for(var Te1 = 1; Te1 <= z.value; Te1++){
                var We = {
                    i: Te1,
                    event: Fe.value[Te1],
                    classes: []
                };
                Re.value[Te1] === !0 && (We.in = !0, We.flat = !0), M.push(We);
            }
            if (ce.value[le.value] !== void 0 && ce.value[le.value].forEach(function(Te) {
                var We = fe + Te - 1;
                Object.assign(M[We], {
                    selected: !0,
                    unelevated: !0,
                    flat: !1,
                    color: x.value,
                    textColor: k.value
                });
            }), be.value[le.value] !== void 0 && be.value[le.value].forEach(function(Te) {
                if (Te.from !== void 0) {
                    var We = fe + Te.from - 1, rt = fe + (Te.to || z.value) - 1;
                    for(var To = We; To <= rt; To++)Object.assign(M[To], {
                        range: Te.range,
                        unelevated: !0,
                        color: x.value,
                        textColor: k.value
                    });
                    Object.assign(M[We], {
                        rangeFrom: !0,
                        flat: !1
                    }), Te.to !== void 0 && Object.assign(M[rt], {
                        rangeTo: !0,
                        flat: !1
                    });
                } else if (Te.to !== void 0) {
                    var We1 = fe + Te.to - 1;
                    for(var rt1 = fe; rt1 <= We1; rt1++)Object.assign(M[rt1], {
                        range: Te.range,
                        unelevated: !0,
                        color: x.value,
                        textColor: k.value
                    });
                    Object.assign(M[We1], {
                        flat: !1,
                        rangeTo: !0
                    });
                } else {
                    var We2 = fe + z.value - 1;
                    for(var rt2 = fe; rt2 <= We2; rt2++)Object.assign(M[rt2], {
                        range: Te.range,
                        unelevated: !0,
                        color: x.value,
                        textColor: k.value
                    });
                }
            }), Me.value !== void 0) {
                var Te2 = fe + Me.value.from - 1, We1 = fe + Me.value.to - 1;
                for(var rt = Te2; rt <= We1; rt++)M[rt].color = x.value, M[rt].editRange = !0;
                Me.value.includeFrom === !0 && (M[Te2].editRangeFrom = !0), Me.value.includeTo === !0 && (M[We1].editRangeTo = !0);
            }
            g.value.year === h.value.year && g.value.month === h.value.month && (M[fe + h.value.day - 1].today = !0);
            var et = M.length % 7;
            if (et > 0) {
                var Te3 = 7 - et;
                for(var We2 = 1; We2 <= Te3; We2++)M.push({
                    i: We2,
                    fill: !0
                });
            }
            return M.forEach(function(Te) {
                var We = "q-date__calendar-item ";
                Te.fill === !0 ? We += "q-date__calendar-item--fill" : (We += "q-date__calendar-item--".concat(Te.in === !0 ? "in" : "out"), Te.range !== void 0 && (We += " q-date__range".concat(Te.rangeTo === !0 ? "-to" : Te.rangeFrom === !0 ? "-from" : "")), Te.editRange === !0 && (We += " q-date__edit-range".concat(Te.editRangeFrom === !0 ? "-from" : "").concat(Te.editRangeTo === !0 ? "-to" : "")), (Te.range !== void 0 || Te.editRange === !0) && (We += " text-".concat(Te.color))), Te.classes = We;
            }), M;
        }), se = (0, $aAzpa.computed)(function() {
            return e.disable === !0 ? {
                "aria-disabled": "true"
            } : {};
        });
        (0, $aD8ZA.watch)(function() {
            return e.modelValue;
        }, function(M) {
            if (v === M) v = 0;
            else {
                var O = dt(y.value, p.value);
                Ge(O.year, O.month, O);
            }
        }), (0, $aD8ZA.watch)(S, function() {
            m.value !== null && r.$el.contains(document.activeElement) === !0 && m.value.focus();
        }), (0, $aD8ZA.watch)(function() {
            return g.value.year + "|" + g.value.month;
        }, function() {
            o("navigation", {
                year: g.value.year,
                month: g.value.month
            });
        }), (0, $aD8ZA.watch)(C, function(M) {
            Z(M, p.value, "mask"), y.value = M;
        }), (0, $aD8ZA.watch)(b, function(M) {
            Z(y.value, M, "locale"), p.value = M;
        });
        function Y() {
            var _h_value = h.value, M = _h_value.year, O = _h_value.month, X = _h_value.day, de = (0, $8typN._)((0, $8pZMQ._)({}, g.value), {
                year: M,
                month: O,
                day: X
            }), fe = ce.value[ur(de)];
            (fe === void 0 || fe.includes(de.day) === !1) && kn(de), Ee(de.year, de.month);
        }
        function me(M) {
            Qm(M) === !0 && (S.value = M);
        }
        function Pe(M, O) {
            [
                "month",
                "year"
            ].includes(M) && (M === "month" ? re : K)(O === !0 ? -1 : 1);
        }
        function Ee(M, O) {
            S.value = "Calendar", Ge(M, O);
        }
        function Ae(M, O) {
            if (e.range === !1 || !M) {
                B.value = null;
                return;
            }
            var X = Object.assign((0, $8pZMQ._)({}, g.value), M), de = O !== void 0 ? Object.assign((0, $8pZMQ._)({}, g.value), O) : X;
            B.value = {
                init: X,
                initHash: Qo(X),
                final: de,
                finalHash: Qo(de)
            }, Ee(X.year, X.month);
        }
        function nt() {
            return e.calendar === "persian" ? "YYYY/MM/DD" : e.mask;
        }
        function ct(M, O, X) {
            return lr(M, O, X, e.calendar, {
                hour: 0,
                minute: 0,
                second: 0,
                millisecond: 0
            });
        }
        function dt(M, O) {
            var X = Array.isArray(e.modelValue) === !0 ? e.modelValue : e.modelValue ? [
                e.modelValue
            ] : [];
            if (X.length === 0) return G();
            var de = X[X.length - 1], fe = ct(de.from !== void 0 ? de.from : de, M, O);
            return fe.dateHash === null ? G() : fe;
        }
        function G() {
            var M, O;
            if (e.defaultYearMonth !== void 0) {
                var X = e.defaultYearMonth.split("/");
                M = parseInt(X[0], 10), O = parseInt(X[1], 10);
            } else {
                var X1 = h.value !== void 0 ? h.value : u();
                M = X1.year, O = X1.month;
            }
            return {
                year: M,
                month: O,
                day: 1,
                hour: 0,
                minute: 0,
                second: 0,
                millisecond: 0,
                dateHash: M + "/" + Je(O) + "/01"
            };
        }
        function re(M) {
            var O = g.value.year, X = Number(g.value.month) + M;
            X === 13 ? (X = 1, O++) : X === 0 && (X = 12, O--), Ge(O, X), j.value === !0 && ht("month");
        }
        function K(M) {
            var O = Number(g.value.year) + M;
            Ge(O, g.value.month), j.value === !0 && ht("year");
        }
        function ee(M) {
            Ge(M, g.value.month), S.value = e.defaultView === "Years" ? "Months" : "Calendar", j.value === !0 && ht("year");
        }
        function ke(M) {
            Ge(g.value.year, M), S.value = "Calendar", j.value === !0 && ht("month");
        }
        function ze(M, O) {
            var X = ce.value[O];
            (X !== void 0 && X.includes(M.day) === !0 ? en : kn)(M);
        }
        function ye(M) {
            return {
                year: M.year,
                month: M.month,
                day: M.day
            };
        }
        function Ge(M, O, X) {
            if (_e.value !== null && M <= _e.value.year && ((O < _e.value.month || M < _e.value.year) && (O = _e.value.month), M = _e.value.year), U.value !== null && M >= U.value.year && ((O > U.value.month || M > U.value.year) && (O = U.value.month), M = U.value.year), X !== void 0) {
                var fe = X.hour, et = X.minute, Te = X.second, We = X.millisecond, rt = X.timezoneOffset, To = X.timeHash;
                Object.assign(g.value, {
                    hour: fe,
                    minute: et,
                    second: Te,
                    millisecond: We,
                    timezoneOffset: rt,
                    timeHash: To
                });
            }
            var de = M + "/" + Je(O) + "/01";
            de !== g.value.dateHash && ($.value = g.value.dateHash < de == (n.lang.rtl !== !0) ? "left" : "right", M !== g.value.year && (L.value = $.value), (0, $aD8ZA.nextTick)(function() {
                A.value = M - M % zr - (M < 0 ? zr : 0), Object.assign(g.value, {
                    year: M,
                    month: O,
                    day: 1,
                    dateHash: de
                });
            }));
        }
        function mt(M, O, X) {
            var de = M !== null && M.length === 1 && e.multiple === !1 ? M[0] : M;
            v = de;
            var _ro = ro(O, X), fe = _ro.reason, et = _ro.details;
            o("update:modelValue", de, fe, et);
        }
        function ht(M) {
            var O = w.value[0] !== void 0 && w.value[0].dateHash !== null ? (0, $8pZMQ._)({}, w.value[0]) : (0, $8pZMQ._)({}, g.value);
            (0, $aD8ZA.nextTick)(function() {
                O.year = g.value.year, O.month = g.value.month;
                var X = e.calendar !== "persian" ? new Date(O.year, O.month, 0).getDate() : Zi(O.year, O.month);
                O.day = Math.min(Math.max(1, O.day), X);
                var de = qo(O);
                v = de;
                var _ro = ro("", O), fe = _ro.details;
                o("update:modelValue", de, M, fe);
            });
        }
        function ro(M, O) {
            return O.from !== void 0 ? {
                reason: "".concat(M, "-range"),
                details: (0, $8typN._)((0, $8pZMQ._)({}, ye(O.target)), {
                    from: ye(O.from),
                    to: ye(O.to)
                })
            } : {
                reason: "".concat(M, "-day"),
                details: ye(O)
            };
        }
        function qo(M, O, X) {
            return M.from !== void 0 ? {
                from: ie.value(M.from, O, X),
                to: ie.value(M.to, O, X)
            } : ie.value(M, O, X);
        }
        function kn(M) {
            var O;
            if (e.multiple === !0) {
                if (M.from !== void 0) {
                    var X = Qo(M.from), de = Qo(M.to), fe = w.value.filter(function(Te) {
                        return Te.dateHash < X || Te.dateHash > de;
                    }), et = H.value.filter(function(param) {
                        var Te = param.from, We = param.to;
                        return We.dateHash < X || Te.dateHash > de;
                    });
                    O = fe.concat(et).concat(M).map(function(Te) {
                        return qo(Te);
                    });
                } else {
                    var X1 = Q.value.slice();
                    X1.push(qo(M)), O = X1;
                }
            } else O = qo(M);
            mt(O, "add", M);
        }
        function en(M) {
            if (e.noUnset === !0) return;
            var O = null;
            if (e.multiple === !0 && Array.isArray(e.modelValue) === !0) {
                var X = qo(M);
                M.from !== void 0 ? O = e.modelValue.filter(function(de) {
                    return de.from !== void 0 ? de.from !== X.from && de.to !== X.to : !0;
                }) : O = e.modelValue.filter(function(de) {
                    return de !== X;
                }), O.length === 0 && (O = null);
            }
            mt(O, "remove", M);
        }
        function Z(M, O, X) {
            var de = w.value.concat(H.value).map(function(fe) {
                return qo(fe, M, O);
            }).filter(function(fe) {
                return fe.from !== void 0 ? fe.from.dateHash !== null && fe.to.dateHash !== null : fe.dateHash !== null;
            });
            o("update:modelValue", (e.multiple === !0 ? de : de[0]) || null, X);
        }
        function ve() {
            if (e.minimal !== !0) return (0, $aD8ZA.h)("div", {
                class: "q-date__header " + s.value
            }, [
                (0, $aD8ZA.h)("div", {
                    class: "relative-position"
                }, [
                    (0, $aD8ZA.h)((0, $iMtOP.Transition), {
                        name: "q-transition--fade"
                    }, function() {
                        return (0, $aD8ZA.h)("div", (0, $8pZMQ._)({
                            key: "h-yr-" + oe.value,
                            class: "q-date__header-subtitle q-date__header-link " + (S.value === "Years" ? "q-date__header-link--active" : "cursor-pointer"),
                            tabindex: l.value
                        }, a("vY", {
                            onClick: function() {
                                S.value = "Years";
                            },
                            onKeyup: function(M) {
                                M.keyCode === 13 && (S.value = "Years");
                            }
                        })), [
                            oe.value
                        ]);
                    })
                ]),
                (0, $aD8ZA.h)("div", {
                    class: "q-date__header-title relative-position flex no-wrap"
                }, [
                    (0, $aD8ZA.h)("div", {
                        class: "relative-position col"
                    }, [
                        (0, $aD8ZA.h)((0, $iMtOP.Transition), {
                            name: "q-transition--fade"
                        }, function() {
                            return (0, $aD8ZA.h)("div", (0, $8pZMQ._)({
                                key: "h-sub" + _.value,
                                class: "q-date__header-title-label q-date__header-link " + (S.value === "Calendar" ? "q-date__header-link--active" : "cursor-pointer"),
                                tabindex: l.value
                            }, a("vC", {
                                onClick: function() {
                                    S.value = "Calendar";
                                },
                                onKeyup: function(M) {
                                    M.keyCode === 13 && (S.value = "Calendar");
                                }
                            })), [
                                _.value
                            ]);
                        })
                    ]),
                    e.todayBtn === !0 ? (0, $aD8ZA.h)(Le, {
                        class: "q-date__header-today self-start",
                        icon: n.iconSet.datetime.today,
                        flat: !0,
                        size: "sm",
                        round: !0,
                        tabindex: l.value,
                        onClick: Y
                    }) : null
                ])
            ]);
        }
        function qe(param) {
            var M = param.label, O = param.type, X = param.key, de = param.dir, fe = param.goTo, et = param.boundaries, Te = param.cls;
            return [
                (0, $aD8ZA.h)("div", {
                    class: "row items-center q-date__arrow"
                }, [
                    (0, $aD8ZA.h)(Le, (0, $8pZMQ._)({
                        round: !0,
                        dense: !0,
                        size: "sm",
                        flat: !0,
                        icon: T.value[0],
                        tabindex: l.value,
                        disable: et.prev === !1
                    }, a("go-#" + O, {
                        onClick: function() {
                            fe(-1);
                        }
                    })))
                ]),
                (0, $aD8ZA.h)("div", {
                    class: "relative-position overflow-hidden flex flex-center" + Te
                }, [
                    (0, $aD8ZA.h)((0, $iMtOP.Transition), {
                        name: "q-transition--jump-" + de
                    }, function() {
                        return (0, $aD8ZA.h)("div", {
                            key: X
                        }, [
                            (0, $aD8ZA.h)(Le, (0, $8pZMQ._)({
                                flat: !0,
                                dense: !0,
                                noCaps: !0,
                                label: M,
                                tabindex: l.value
                            }, a("view#" + O, {
                                onClick: function() {
                                    S.value = O;
                                }
                            })))
                        ]);
                    })
                ]),
                (0, $aD8ZA.h)("div", {
                    class: "row items-center q-date__arrow"
                }, [
                    (0, $aD8ZA.h)(Le, (0, $8pZMQ._)({
                        round: !0,
                        dense: !0,
                        size: "sm",
                        flat: !0,
                        icon: T.value[1],
                        tabindex: l.value,
                        disable: et.next === !1
                    }, a("go+#" + O, {
                        onClick: function() {
                            fe(1);
                        }
                    })))
                ])
            ];
        }
        var Be = {
            Calendar: function() {
                return [
                    (0, $aD8ZA.h)("div", {
                        key: "calendar-view",
                        class: "q-date__view q-date__calendar"
                    }, [
                        (0, $aD8ZA.h)("div", {
                            class: "q-date__navigation row items-center no-wrap"
                        }, qe({
                            label: p.value.months[g.value.month - 1],
                            type: "Months",
                            key: g.value.month,
                            dir: $.value,
                            goTo: re,
                            boundaries: ae.value.month,
                            cls: " col"
                        }).concat(qe({
                            label: g.value.year,
                            type: "Years",
                            key: g.value.year,
                            dir: L.value,
                            goTo: K,
                            boundaries: ae.value.year,
                            cls: ""
                        }))),
                        (0, $aD8ZA.h)("div", {
                            class: "q-date__calendar-weekdays row items-center no-wrap"
                        }, te.value.map(function(M) {
                            return (0, $aD8ZA.h)("div", {
                                class: "q-date__calendar-item"
                            }, [
                                (0, $aD8ZA.h)("div", M)
                            ]);
                        })),
                        (0, $aD8ZA.h)("div", {
                            class: "q-date__calendar-days-container relative-position overflow-hidden"
                        }, [
                            (0, $aD8ZA.h)((0, $iMtOP.Transition), {
                                name: "q-transition--slide-" + $.value
                            }, function() {
                                return (0, $aD8ZA.h)("div", {
                                    key: le.value,
                                    class: "q-date__calendar-days fit"
                                }, ne.value.map(function(M) {
                                    return (0, $aD8ZA.h)("div", {
                                        class: M.classes
                                    }, [
                                        M.in === !0 ? (0, $aD8ZA.h)(Le, (0, $8pZMQ._)({
                                            class: M.today === !0 ? "q-date__today" : "",
                                            dense: !0,
                                            flat: M.flat,
                                            unelevated: M.unelevated,
                                            color: M.color,
                                            textColor: M.textColor,
                                            label: M.i,
                                            tabindex: l.value
                                        }, a("day#" + M.i, {
                                            onClick: function() {
                                                Ne(M.i);
                                            },
                                            onMouseover: function() {
                                                pt(M.i);
                                            }
                                        })), M.event !== !1 ? function() {
                                            return (0, $aD8ZA.h)("div", {
                                                class: "q-date__event bg-" + M.event
                                            });
                                        } : null) : (0, $aD8ZA.h)("div", "" + M.i)
                                    ]);
                                }));
                            })
                        ])
                    ])
                ];
            },
            Months: function() {
                var M = g.value.year === h.value.year, O = function(de) {
                    return _e.value !== null && g.value.year === _e.value.year && _e.value.month > de || U.value !== null && g.value.year === U.value.year && U.value.month < de;
                }, X = p.value.monthsShort.map(function(de, fe) {
                    var et = g.value.month === fe + 1;
                    return (0, $aD8ZA.h)("div", {
                        class: "q-date__months-item flex flex-center"
                    }, [
                        (0, $aD8ZA.h)(Le, (0, $8pZMQ._)({
                            class: M === !0 && h.value.month === fe + 1 ? "q-date__today" : null,
                            flat: et !== !0,
                            label: de,
                            unelevated: et,
                            color: et === !0 ? x.value : null,
                            textColor: et === !0 ? k.value : null,
                            tabindex: l.value,
                            disable: O(fe + 1)
                        }, a("month#" + fe, {
                            onClick: function() {
                                ke(fe + 1);
                            }
                        })))
                    ]);
                });
                return e.yearsInMonthView === !0 && X.unshift((0, $aD8ZA.h)("div", {
                    class: "row no-wrap full-width"
                }, [
                    qe({
                        label: g.value.year,
                        type: "Years",
                        key: g.value.year,
                        dir: L.value,
                        goTo: K,
                        boundaries: ae.value.year,
                        cls: " col"
                    })
                ])), (0, $aD8ZA.h)("div", {
                    key: "months-view",
                    class: "q-date__view q-date__months flex flex-center"
                }, X);
            },
            Years: function() {
                var _loop = function(fe) {
                    var et = g.value.year === fe;
                    X.push((0, $aD8ZA.h)("div", {
                        class: "q-date__years-item flex flex-center"
                    }, [
                        (0, $aD8ZA.h)(Le, (0, $8pZMQ._)({
                            key: "yr" + fe,
                            class: h.value.year === fe ? "q-date__today" : null,
                            flat: !et,
                            label: fe,
                            dense: !0,
                            unelevated: et,
                            color: et === !0 ? x.value : null,
                            textColor: et === !0 ? k.value : null,
                            tabindex: l.value,
                            disable: de(fe)
                        }, a("yr#" + fe, {
                            onClick: function() {
                                ee(fe);
                            }
                        })))
                    ]));
                };
                var M = A.value, O = M + zr, X = [], de = function(fe) {
                    return _e.value !== null && _e.value.year > fe || U.value !== null && U.value.year < fe;
                };
                for(var fe = M; fe <= O; fe++)_loop(fe);
                return (0, $aD8ZA.h)("div", {
                    class: "q-date__view q-date__years flex flex-center"
                }, [
                    (0, $aD8ZA.h)("div", {
                        class: "col-auto"
                    }, [
                        (0, $aD8ZA.h)(Le, (0, $8pZMQ._)({
                            round: !0,
                            dense: !0,
                            flat: !0,
                            icon: T.value[0],
                            tabindex: l.value,
                            disable: de(M)
                        }, a("y-", {
                            onClick: function() {
                                A.value -= zr;
                            }
                        })))
                    ]),
                    (0, $aD8ZA.h)("div", {
                        class: "q-date__years-content col self-stretch row items-center"
                    }, X),
                    (0, $aD8ZA.h)("div", {
                        class: "col-auto"
                    }, [
                        (0, $aD8ZA.h)(Le, (0, $8pZMQ._)({
                            round: !0,
                            dense: !0,
                            flat: !0,
                            icon: T.value[1],
                            tabindex: l.value,
                            disable: de(O)
                        }, a("y+", {
                            onClick: function() {
                                A.value += zr;
                            }
                        })))
                    ])
                ]);
            }
        };
        function Ne(M) {
            var O = (0, $8typN._)((0, $8pZMQ._)({}, g.value), {
                day: M
            });
            if (e.range === !1) {
                ze(O, le.value);
                return;
            }
            if (B.value === null) {
                var X = ne.value.find(function(fe) {
                    return fe.fill !== !0 && fe.i === M;
                });
                if (e.noUnset !== !0 && X.range !== void 0) {
                    en({
                        target: O,
                        from: X.range.from,
                        to: X.range.to
                    });
                    return;
                }
                if (X.selected === !0) {
                    en(O);
                    return;
                }
                var de = Qo(O);
                B.value = {
                    init: O,
                    initHash: de,
                    final: O,
                    finalHash: de
                }, o("rangeStart", ye(O));
            } else {
                var X1 = B.value.initHash, de1 = Qo(O), fe = X1 <= de1 ? {
                    from: B.value.init,
                    to: O
                } : {
                    from: O,
                    to: B.value.init
                };
                B.value = null, kn(X1 === de1 ? O : (0, $8pZMQ._)({
                    target: O
                }, fe)), o("rangeEnd", {
                    from: ye(fe.from),
                    to: ye(fe.to)
                });
            }
        }
        function pt(M) {
            if (B.value !== null) {
                var O = (0, $8typN._)((0, $8pZMQ._)({}, g.value), {
                    day: M
                });
                Object.assign(B.value, {
                    final: O,
                    finalHash: Qo(O)
                });
            }
        }
        return Object.assign(r, {
            setToday: Y,
            setView: me,
            offsetCalendar: Pe,
            setCalendarTo: Ee,
            setEditingRange: Ae
        }), function() {
            var M = [
                (0, $aD8ZA.h)("div", {
                    class: "q-date__content col relative-position"
                }, [
                    (0, $aD8ZA.h)((0, $iMtOP.Transition), {
                        name: "q-transition--fade"
                    }, Be[S.value])
                ])
            ], O = J(t.default);
            return O !== void 0 && M.push((0, $aD8ZA.h)("div", {
                class: "q-date__actions"
            }, O)), e.name !== void 0 && e.disable !== !0 && d(M, "push"), (0, $aD8ZA.h)("div", (0, $8pZMQ._)({
                class: q.value
            }, se.value), [
                ve(),
                (0, $aD8ZA.h)("div", {
                    ref: m,
                    class: "q-date__main col column",
                    tabindex: -1
                }, M)
            ]);
        };
    }
});
function yu(e, t, o) {
    var r;
    function n() {
        r !== void 0 && (Un.remove(r), r = void 0);
    }
    return (0, $aD8ZA.onBeforeUnmount)(function() {
        e.value === !0 && n();
    }), {
        removeFromHistory: n,
        addToHistory: function() {
            r = {
                condition: function() {
                    return o.value === !0;
                },
                handler: t
            }, Un.add(r);
        }
    };
}
var Xa = 0, zc, Oc, Ga, Ic = !1, Um, Km, Wm, Or = null;
function Ex(e) {
    Bx(e) && Se(e);
}
function Bx(e) {
    if (e.target === document.body || e.target.classList.contains("q-layout__backdrop")) return !0;
    var t = Ks(e), o = e.shiftKey && !e.deltaX, r = !o && Math.abs(e.deltaX) <= Math.abs(e.deltaY), n = o || r ? e.deltaY : e.deltaX;
    for(var i = 0; i < t.length; i++){
        var a = t[i];
        if (vc(a, r)) return r ? n < 0 && a.scrollTop === 0 ? !0 : n > 0 && a.scrollTop + a.clientHeight === a.scrollHeight : n < 0 && a.scrollLeft === 0 ? !0 : n > 0 && a.scrollLeft + a.clientWidth === a.scrollWidth;
    }
    return !0;
}
function Ym(e) {
    e.target === document && (document.scrollingElement.scrollTop = document.scrollingElement.scrollTop);
}
function Su(e) {
    Ic !== !0 && (Ic = !0, requestAnimationFrame(function() {
        Ic = !1;
        var _e_target = e.target, t = _e_target.height, _document_scrollingElement = document.scrollingElement, o = _document_scrollingElement.clientHeight, r = _document_scrollingElement.scrollTop;
        (Ga === void 0 || t !== window.innerHeight) && (Ga = o - t, document.scrollingElement.scrollTop = r), r > Ga && (document.scrollingElement.scrollTop -= Math.ceil((r - Ga) / 8));
    }));
}
function Xm(e) {
    var t = document.body, o = window.visualViewport !== void 0;
    if (e === "add") {
        var _window_getComputedStyle = window.getComputedStyle(t), r = _window_getComputedStyle.overflowY, n = _window_getComputedStyle.overflowX;
        zc = er(window), Oc = fo(window), Um = t.style.left, Km = t.style.top, Wm = window.location.href, t.style.left = "-".concat(zc, "px"), t.style.top = "-".concat(Oc, "px"), n !== "hidden" && (n === "scroll" || t.scrollWidth > window.innerWidth) && t.classList.add("q-body--force-scrollbar-x"), r !== "hidden" && (r === "scroll" || t.scrollHeight > window.innerHeight) && t.classList.add("q-body--force-scrollbar-y"), t.classList.add("q-body--prevent-scroll"), document.qScrollPrevented = !0, Ce.is.ios === !0 && (o === !0 ? (window.scrollTo(0, 0), window.visualViewport.addEventListener("resize", Su, Xe.passiveCapture), window.visualViewport.addEventListener("scroll", Su, Xe.passiveCapture), window.scrollTo(0, 0)) : window.addEventListener("scroll", Ym, Xe.passiveCapture));
    }
    Ce.is.desktop === !0 && Ce.is.mac === !0 && window["".concat(e, "EventListener")]("wheel", Ex, Xe.notPassive), e === "remove" && (Ce.is.ios === !0 && (o === !0 ? (window.visualViewport.removeEventListener("resize", Su, Xe.passiveCapture), window.visualViewport.removeEventListener("scroll", Su, Xe.passiveCapture)) : window.removeEventListener("scroll", Ym, Xe.passiveCapture)), t.classList.remove("q-body--prevent-scroll"), t.classList.remove("q-body--force-scrollbar-x"), t.classList.remove("q-body--force-scrollbar-y"), document.qScrollPrevented = !1, t.style.left = Um, t.style.top = Km, window.location.href === Wm && window.scrollTo(zc, Oc), Ga = void 0);
}
function Za(e) {
    var t = "add";
    if (e === !0) {
        if (Xa++, Or !== null) {
            clearTimeout(Or), Or = null;
            return;
        }
        if (Xa > 1) return;
    } else {
        if (Xa === 0 || (Xa--, Xa > 0)) return;
        if (t = "remove", Ce.is.ios === !0 && Ce.is.nativeMobile === !0) {
            Or !== null && clearTimeout(Or), Or = setTimeout(function() {
                Xm(t), Or = null;
            }, 100);
            return;
        }
    }
    Xm(t);
}
function xu() {
    var e;
    return {
        preventBodyScroll: function(t) {
            t !== e && (e !== void 0 || t === !0) && (e = t, Za(t));
        }
    };
}
var _u = 0, Dx = {
    standard: "fixed-full flex-center",
    top: "fixed-top justify-center",
    bottom: "fixed-bottom justify-center",
    right: "fixed-right items-center",
    left: "fixed-left items-center"
}, Jm = {
    standard: [
        "scale",
        "scale"
    ],
    top: [
        "slide-down",
        "slide-up"
    ],
    bottom: [
        "slide-up",
        "slide-down"
    ],
    right: [
        "slide-left",
        "slide-right"
    ],
    left: [
        "slide-right",
        "slide-left"
    ]
}, gn = R({
    name: "QDialog",
    inheritAttrs: !1,
    props: (0, $8typN._)((0, $8pZMQ._)({}, Ao, ln), {
        transitionShow: String,
        transitionHide: String,
        persistent: Boolean,
        autoClose: Boolean,
        allowFocusOutside: Boolean,
        noEscDismiss: Boolean,
        noBackdropDismiss: Boolean,
        noRouteDismiss: Boolean,
        noRefocus: Boolean,
        noFocus: Boolean,
        noShake: Boolean,
        seamless: Boolean,
        maximized: Boolean,
        fullWidth: Boolean,
        fullHeight: Boolean,
        square: Boolean,
        backdropFilter: String,
        position: {
            type: String,
            default: "standard",
            validator: function(e) {
                return e === "standard" || [
                    "top",
                    "bottom",
                    "left",
                    "right"
                ].includes(e);
            }
        }
    }),
    emits: (0, $79xu7._)($o).concat([
        "shake",
        "click",
        "escapeKey"
    ]),
    setup: function(e, param) {
        var t = param.slots, o = param.emit, r = param.attrs;
        var n = (0, $aD8ZA.getCurrentInstance)(), i = (0, $aAzpa.ref)(null), a = (0, $aAzpa.ref)(!1), l = (0, $aAzpa.ref)(!1), s = null, c = null, u, v, f = (0, $aAzpa.computed)(function() {
            return e.persistent !== !0 && e.noRouteDismiss !== !0 && e.seamless !== !0;
        }), _xu = xu(), d = _xu.preventBodyScroll, _io = io(), m = _io.registerTimeout, _Io = Io(), y = _Io.registerTick, p = _Io.removeTick, _Jn = Jn(e, function() {
            return Jm[e.position][0];
        }, function() {
            return Jm[e.position][1];
        }), C = _Jn.transitionProps, b = _Jn.transitionStyle, h = (0, $aAzpa.computed)(function() {
            return b.value + (e.backdropFilter !== void 0 ? ";backdrop-filter:".concat(e.backdropFilter, ";-webkit-backdrop-filter:").concat(e.backdropFilter) : "");
        }), _Si = Si(n, i, oe, "dialog"), g = _Si.showPortal, S = _Si.hidePortal, P = _Si.portalIsAccessible, $ = _Si.renderPortal, _Eo = Eo({
            showing: a,
            hideOnRouteChange: f,
            handleShow: j,
            handleHide: Q,
            processOnMount: !0
        }), L = _Eo.hide, _yu = yu(a, L, f), E = _yu.addToHistory, A = _yu.removeFromHistory, B = (0, $aAzpa.computed)(function() {
            return "q-dialog__inner flex no-pointer-events q-dialog__inner--".concat(e.maximized === !0 ? "maximized" : "minimized", " q-dialog__inner--").concat(e.position, " ").concat(Dx[e.position]) + (l.value === !0 ? " q-dialog__inner--animating" : "") + (e.fullWidth === !0 ? " q-dialog__inner--fullwidth" : "") + (e.fullHeight === !0 ? " q-dialog__inner--fullheight" : "") + (e.square === !0 ? " q-dialog__inner--square" : "");
        }), q = (0, $aAzpa.computed)(function() {
            return a.value === !0 && e.seamless !== !0;
        }), x = (0, $aAzpa.computed)(function() {
            return e.autoClose === !0 ? {
                onClick: _
            } : {};
        }), k = (0, $aAzpa.computed)(function() {
            return [
                "q-dialog fullscreen no-pointer-events q-dialog--".concat(q.value === !0 ? "modal" : "seamless"),
                r.class
            ];
        });
        (0, $aD8ZA.watch)(function() {
            return e.maximized;
        }, function(T) {
            a.value === !0 && V(T);
        }), (0, $aD8ZA.watch)(q, function(T) {
            d(T), T === !0 ? (wi(I), Ol(W)) : (Er(I), Ci(W));
        });
        function j(T) {
            E(), c = e.noRefocus === !1 && document.activeElement !== null ? document.activeElement : null, V(e.maximized), g(), l.value = !0, e.noFocus !== !0 ? (document.activeElement !== null && document.activeElement.blur(), y(w)) : p(), m(function() {
                if (n.proxy.$q.platform.is.ios === !0) {
                    if (e.seamless !== !0 && document.activeElement) {
                        var _document_activeElement_getBoundingClientRect = document.activeElement.getBoundingClientRect(), D = _document_activeElement_getBoundingClientRect.top, te = _document_activeElement_getBoundingClientRect.bottom, z = window.innerHeight, ue = window.visualViewport !== void 0 ? window.visualViewport.height : z;
                        D > 0 && te > ue / 2 && (document.scrollingElement.scrollTop = Math.min(document.scrollingElement.scrollHeight - ue, te >= z ? 1 / 0 : Math.ceil(document.scrollingElement.scrollTop + te - ue / 2))), document.activeElement.scrollIntoView();
                    }
                    v = !0, i.value.click(), v = !1;
                }
                g(!0), l.value = !1, o("show", T);
            }, e.transitionDuration);
        }
        function Q(T) {
            p(), A(), ie(!0), l.value = !0, S(), c !== null && (((T && T.type.indexOf("key") === 0 ? c.closest('[tabindex]:not([tabindex^="-"])') : void 0) || c).focus(), c = null), m(function() {
                S(!0), l.value = !1, o("hide", T);
            }, e.transitionDuration);
        }
        function w(T) {
            Bo(function() {
                var D = i.value;
                if (D !== null) {
                    if (T !== void 0) {
                        var te = D.querySelector(T);
                        if (te !== null) {
                            te.focus({
                                preventScroll: !0
                            });
                            return;
                        }
                    }
                    D.contains(document.activeElement) !== !0 && (D = D.querySelector("[autofocus][tabindex], [data-autofocus][tabindex]") || D.querySelector("[autofocus] [tabindex], [data-autofocus] [tabindex]") || D.querySelector("[autofocus], [data-autofocus]") || D, D.focus({
                        preventScroll: !0
                    }));
                }
            });
        }
        function H(T) {
            T && typeof T.focus == "function" ? T.focus({
                preventScroll: !0
            }) : w(), o("shake");
            var D = i.value;
            D !== null && (D.classList.remove("q-animate--scale"), D.classList.add("q-animate--scale"), s !== null && clearTimeout(s), s = setTimeout(function() {
                s = null, i.value !== null && (D.classList.remove("q-animate--scale"), w());
            }, 170));
        }
        function W() {
            e.seamless !== !0 && (e.persistent === !0 || e.noEscDismiss === !0 ? e.maximized !== !0 && e.noShake !== !0 && H() : (o("escapeKey"), L()));
        }
        function ie(T) {
            s !== null && (clearTimeout(s), s = null), (T === !0 || a.value === !0) && (V(!1), e.seamless !== !0 && (d(!1), Er(I), Ci(W))), T !== !0 && (c = null);
        }
        function V(T) {
            T === !0 ? u !== !0 && (_u < 1 && document.body.classList.add("q-body--dialog"), _u++, u = !0) : u === !0 && (_u < 2 && document.body.classList.remove("q-body--dialog"), _u--, u = !1);
        }
        function _(T) {
            v !== !0 && (L(T), o("click", T));
        }
        function N(T) {
            e.persistent !== !0 && e.noBackdropDismiss !== !0 ? L(T) : e.noShake !== !0 && H();
        }
        function I(T) {
            e.allowFocusOutside !== !0 && P.value === !0 && Ll(i.value, T.target) !== !0 && w('[tabindex]:not([tabindex="-1"])');
        }
        Object.assign(n.proxy, {
            focus: w,
            shake: H,
            __updateRefocusTarget: function(T) {
                c = T || null;
            }
        }), (0, $aD8ZA.onBeforeUnmount)(ie);
        function oe() {
            return (0, $aD8ZA.h)("div", (0, $8typN._)((0, $8pZMQ._)({
                role: "dialog",
                "aria-modal": q.value === !0 ? "true" : "false"
            }, r), {
                class: k.value
            }), [
                (0, $aD8ZA.h)((0, $iMtOP.Transition), {
                    name: "q-transition--fade",
                    appear: !0
                }, function() {
                    return q.value === !0 ? (0, $aD8ZA.h)("div", {
                        class: "q-dialog__backdrop fixed-full",
                        style: h.value,
                        "aria-hidden": "true",
                        tabindex: -1,
                        onClick: N
                    }) : null;
                }),
                (0, $aD8ZA.h)((0, $iMtOP.Transition), C.value, function() {
                    return a.value === !0 ? (0, $aD8ZA.h)("div", (0, $8pZMQ._)({
                        ref: i,
                        class: B.value,
                        style: b.value,
                        tabindex: -1
                    }, x.value), J(t.default)) : null;
                })
            ]);
        }
        return $;
    }
});
var tv = 150, ov = R({
    name: "QDrawer",
    inheritAttrs: !1,
    props: (0, $8typN._)((0, $8pZMQ._)({}, Ao, he), {
        side: {
            type: String,
            default: "left",
            validator: function(e) {
                return [
                    "left",
                    "right"
                ].includes(e);
            }
        },
        width: {
            type: Number,
            default: 300
        },
        mini: Boolean,
        miniToOverlay: Boolean,
        miniWidth: {
            type: Number,
            default: 57
        },
        noMiniAnimation: Boolean,
        breakpoint: {
            type: Number,
            default: 1023
        },
        showIfAbove: Boolean,
        behavior: {
            type: String,
            validator: function(e) {
                return [
                    "default",
                    "desktop",
                    "mobile"
                ].includes(e);
            },
            default: "default"
        },
        bordered: Boolean,
        elevated: Boolean,
        overlay: Boolean,
        persistent: Boolean,
        noSwipeOpen: Boolean,
        noSwipeClose: Boolean,
        noSwipeBackdrop: Boolean
    }),
    emits: (0, $79xu7._)($o).concat([
        "onLayout",
        "miniState"
    ]),
    setup: function(e, param) {
        var t = param.slots, o = param.emit, r = param.attrs;
        var n = (0, $aD8ZA.getCurrentInstance)(), _n_proxy = n.proxy, i = _n_proxy.$q, a = pe(e, i), _xu = xu(), l = _xu.preventBodyScroll, _io = io(), s = _io.registerTimeout, c = _io.removeTimeout, u = (0, $aD8ZA.inject)(co, Ye);
        if (u === Ye) return console.error("QDrawer needs to be child of QLayout"), Ye;
        var v, f = null, d, m = (0, $aAzpa.ref)(e.behavior === "mobile" || e.behavior !== "desktop" && u.totalWidth.value <= e.breakpoint), y = (0, $aAzpa.computed)(function() {
            return e.mini === !0 && m.value !== !0;
        }), p = (0, $aAzpa.computed)(function() {
            return y.value === !0 ? e.miniWidth : e.width;
        }), C = (0, $aAzpa.ref)(e.showIfAbove === !0 && m.value === !1 ? !0 : e.modelValue === !0), b = (0, $aAzpa.computed)(function() {
            return e.persistent !== !0 && (m.value === !0 || ie.value === !0);
        });
        function h(Y, me) {
            if ($(), Y !== !1 && u.animate(), ae(0), m.value === !0) {
                var Pe = u.instances[Q.value];
                Pe !== void 0 && Pe.belowBreakpoint === !0 && Pe.hide(!1), ce(1), u.isContainer.value !== !0 && l(!0);
            } else ce(0), Y !== !1 && be(!1);
            s(function() {
                Y !== !1 && be(!0), me !== !0 && o("show", Y);
            }, tv);
        }
        function g(Y, me) {
            L(), Y !== !1 && u.animate(), ce(0), ae(B.value * p.value), Fe(), me !== !0 ? s(function() {
                o("hide", Y);
            }, tv) : c();
        }
        var _Eo = Eo({
            showing: C,
            hideOnRouteChange: b,
            handleShow: h,
            handleHide: g
        }), S = _Eo.show, P = _Eo.hide, _yu = yu(C, P, b), $ = _yu.addToHistory, L = _yu.removeFromHistory, E = {
            belowBreakpoint: m,
            hide: P
        }, A = (0, $aAzpa.computed)(function() {
            return e.side === "right";
        }), B = (0, $aAzpa.computed)(function() {
            return (i.lang.rtl === !0 ? -1 : 1) * (A.value === !0 ? 1 : -1);
        }), q = (0, $aAzpa.ref)(0), x = (0, $aAzpa.ref)(!1), k = (0, $aAzpa.ref)(!1), j = (0, $aAzpa.ref)(p.value * B.value), Q = (0, $aAzpa.computed)(function() {
            return A.value === !0 ? "left" : "right";
        }), w = (0, $aAzpa.computed)(function() {
            return C.value === !0 && m.value === !1 && e.overlay === !1 ? e.miniToOverlay === !0 ? e.miniWidth : p.value : 0;
        }), H = (0, $aAzpa.computed)(function() {
            return e.overlay === !0 || e.miniToOverlay === !0 || u.view.value.indexOf(A.value ? "R" : "L") !== -1 || i.platform.is.ios === !0 && u.isContainer.value === !0;
        }), W = (0, $aAzpa.computed)(function() {
            return e.overlay === !1 && C.value === !0 && m.value === !1;
        }), ie = (0, $aAzpa.computed)(function() {
            return e.overlay === !0 && C.value === !0 && m.value === !1;
        }), V = (0, $aAzpa.computed)(function() {
            return "fullscreen q-drawer__backdrop" + (C.value === !1 && x.value === !1 ? " hidden" : "");
        }), _ = (0, $aAzpa.computed)(function() {
            return {
                backgroundColor: "rgba(0,0,0,".concat(q.value * .4, ")")
            };
        }), N = (0, $aAzpa.computed)(function() {
            return A.value === !0 ? u.rows.value.top[2] === "r" : u.rows.value.top[0] === "l";
        }), I = (0, $aAzpa.computed)(function() {
            return A.value === !0 ? u.rows.value.bottom[2] === "r" : u.rows.value.bottom[0] === "l";
        }), oe = (0, $aAzpa.computed)(function() {
            var Y = {};
            return u.header.space === !0 && N.value === !1 && (H.value === !0 ? Y.top = "".concat(u.header.offset, "px") : u.header.space === !0 && (Y.top = "".concat(u.header.size, "px"))), u.footer.space === !0 && I.value === !1 && (H.value === !0 ? Y.bottom = "".concat(u.footer.offset, "px") : u.footer.space === !0 && (Y.bottom = "".concat(u.footer.size, "px"))), Y;
        }), T = (0, $aAzpa.computed)(function() {
            var Y = {
                width: "".concat(p.value, "px"),
                transform: "translateX(".concat(j.value, "px)")
            };
            return m.value === !0 ? Y : Object.assign(Y, oe.value);
        }), D = (0, $aAzpa.computed)(function() {
            return "q-drawer__content fit " + (u.isContainer.value !== !0 ? "scroll" : "overflow-auto");
        }), te = (0, $aAzpa.computed)(function() {
            return "q-drawer q-drawer--".concat(e.side) + (k.value === !0 ? " q-drawer--mini-animate" : "") + (e.bordered === !0 ? " q-drawer--bordered" : "") + (a.value === !0 ? " q-drawer--dark q-dark" : "") + (x.value === !0 ? " no-transition" : C.value === !0 ? "" : " q-layout--prevent-focus") + (m.value === !0 ? " fixed q-drawer--on-top q-drawer--mobile q-drawer--top-padding" : " q-drawer--".concat(y.value === !0 ? "mini" : "standard") + (H.value === !0 || W.value !== !0 ? " fixed" : "") + (e.overlay === !0 || e.miniToOverlay === !0 ? " q-drawer--on-top" : "") + (N.value === !0 ? " q-drawer--top-padding" : ""));
        }), z = (0, $aAzpa.computed)(function() {
            var Y = i.lang.rtl === !0 ? e.side : Q.value;
            return [
                [
                    qt,
                    le,
                    void 0,
                    {
                        [Y]: !0,
                        mouse: !0
                    }
                ]
            ];
        }), ue = (0, $aAzpa.computed)(function() {
            var Y = i.lang.rtl === !0 ? Q.value : e.side;
            return [
                [
                    qt,
                    Re,
                    void 0,
                    {
                        [Y]: !0,
                        mouse: !0
                    }
                ]
            ];
        }), _e = (0, $aAzpa.computed)(function() {
            var Y = i.lang.rtl === !0 ? Q.value : e.side;
            return [
                [
                    qt,
                    Re,
                    void 0,
                    {
                        [Y]: !0,
                        mouse: !0,
                        mouseAllDir: !0
                    }
                ]
            ];
        });
        function U() {
            ne(m, e.behavior === "mobile" || e.behavior !== "desktop" && u.totalWidth.value <= e.breakpoint);
        }
        (0, $aD8ZA.watch)(m, function(Y) {
            Y === !0 ? (v = C.value, C.value === !0 && P(!1)) : e.overlay === !1 && e.behavior !== "mobile" && v !== !1 && (C.value === !0 ? (ae(0), ce(0), Fe()) : S(!1));
        }), (0, $aD8ZA.watch)(function() {
            return e.side;
        }, function(Y, me) {
            u.instances[me] === E && (u.instances[me] = void 0, u[me].space = !1, u[me].offset = 0), u.instances[Y] = E, u[Y].size = p.value, u[Y].space = W.value, u[Y].offset = w.value;
        }), (0, $aD8ZA.watch)(u.totalWidth, function() {
            (u.isContainer.value === !0 || document.qScrollPrevented !== !0) && U();
        }), (0, $aD8ZA.watch)(function() {
            return e.behavior + e.breakpoint;
        }, U), (0, $aD8ZA.watch)(u.isContainer, function(Y) {
            C.value === !0 && l(Y !== !0), Y === !0 && U();
        }), (0, $aD8ZA.watch)(u.scrollbarWidth, function() {
            ae(C.value === !0 ? 0 : void 0);
        }), (0, $aD8ZA.watch)(w, function(Y) {
            De("offset", Y);
        }), (0, $aD8ZA.watch)(W, function(Y) {
            o("onLayout", Y), De("space", Y);
        }), (0, $aD8ZA.watch)(A, function() {
            ae();
        }), (0, $aD8ZA.watch)(p, function(Y) {
            ae(), se(e.miniToOverlay, Y);
        }), (0, $aD8ZA.watch)(function() {
            return e.miniToOverlay;
        }, function(Y) {
            se(Y, p.value);
        }), (0, $aD8ZA.watch)(function() {
            return i.lang.rtl;
        }, function() {
            ae();
        }), (0, $aD8ZA.watch)(function() {
            return e.mini;
        }, function() {
            e.noMiniAnimation || e.modelValue === !0 && (Me(), u.animate());
        }), (0, $aD8ZA.watch)(y, function(Y) {
            o("miniState", Y);
        });
        function ae(Y) {
            Y === void 0 ? (0, $aD8ZA.nextTick)(function() {
                Y = C.value === !0 ? 0 : p.value, ae(B.value * Y);
            }) : (u.isContainer.value === !0 && A.value === !0 && (m.value === !0 || Math.abs(Y) === p.value) && (Y += B.value * u.scrollbarWidth.value), j.value = Y);
        }
        function ce(Y) {
            q.value = Y;
        }
        function be(Y) {
            var me = Y === !0 ? "remove" : u.isContainer.value !== !0 ? "add" : "";
            me !== "" && document.body.classList[me]("q-body--drawer-toggle");
        }
        function Me() {
            f !== null && clearTimeout(f), n.proxy && n.proxy.$el && n.proxy.$el.classList.add("q-drawer--mini-animate"), k.value = !0, f = setTimeout(function() {
                f = null, k.value = !1, n && n.proxy && n.proxy.$el && n.proxy.$el.classList.remove("q-drawer--mini-animate");
            }, 150);
        }
        function le(Y) {
            if (C.value !== !1) return;
            var me = p.value, Pe = Ze(Y.distance.x, 0, me);
            if (Y.isFinal === !0) {
                Pe >= Math.min(75, me) === !0 ? S() : (u.animate(), ce(0), ae(B.value * me)), x.value = !1;
                return;
            }
            ae((i.lang.rtl === !0 ? A.value !== !0 : A.value) ? Math.max(me - Pe, 0) : Math.min(0, Pe - me)), ce(Ze(Pe / me, 0, 1)), Y.isFirst === !0 && (x.value = !0);
        }
        function Re(Y) {
            if (C.value !== !0) return;
            var me = p.value, Pe = Y.direction === e.side, Ee = (i.lang.rtl === !0 ? Pe !== !0 : Pe) ? Ze(Y.distance.x, 0, me) : 0;
            if (Y.isFinal === !0) {
                Math.abs(Ee) < Math.min(75, me) === !0 ? (u.animate(), ce(1), ae(0)) : P(), x.value = !1;
                return;
            }
            ae(B.value * Ee), ce(Ze(1 - Ee / me, 0, 1)), Y.isFirst === !0 && (x.value = !0);
        }
        function Fe() {
            l(!1), be(!0);
        }
        function De(Y, me) {
            u.update(e.side, Y, me);
        }
        function ne(Y, me) {
            Y.value !== me && (Y.value = me);
        }
        function se(Y, me) {
            De("size", Y === !0 ? e.miniWidth : me);
        }
        return u.instances[e.side] = E, se(e.miniToOverlay, p.value), De("space", W.value), De("offset", w.value), e.showIfAbove === !0 && e.modelValue !== !0 && C.value === !0 && e["onUpdate:modelValue"] !== void 0 && o("update:modelValue", !0), (0, $aD8ZA.onMounted)(function() {
            o("onLayout", W.value), o("miniState", y.value), v = e.showIfAbove === !0;
            var Y = function() {
                (C.value === !0 ? h : g)(!1, !0);
            };
            if (u.totalWidth.value !== 0) {
                (0, $aD8ZA.nextTick)(Y);
                return;
            }
            d = (0, $aD8ZA.watch)(u.totalWidth, function() {
                d(), d = void 0, C.value === !1 && e.showIfAbove === !0 && m.value === !1 ? S(!1) : Y();
            });
        }), (0, $aD8ZA.onBeforeUnmount)(function() {
            d !== void 0 && d(), f !== null && (clearTimeout(f), f = null), C.value === !0 && Fe(), u.instances[e.side] === E && (u.instances[e.side] = void 0, De("size", 0), De("offset", 0), De("space", !1));
        }), function() {
            var Y = [];
            m.value === !0 && (e.noSwipeOpen === !1 && Y.push((0, $aD8ZA.withDirectives)((0, $aD8ZA.h)("div", {
                key: "open",
                class: "q-drawer__opener fixed-".concat(e.side),
                "aria-hidden": "true"
            }), z.value)), Y.push(kt("div", {
                ref: "backdrop",
                class: V.value,
                style: _.value,
                "aria-hidden": "true",
                onClick: P
            }, void 0, "backdrop", e.noSwipeBackdrop !== !0 && C.value === !0, function() {
                return _e.value;
            })));
            var me = y.value === !0 && t.mini !== void 0, Pe = [
                (0, $aD8ZA.h)("div", (0, $8typN._)((0, $8pZMQ._)({}, r), {
                    key: "" + me,
                    class: [
                        D.value,
                        r.class
                    ]
                }), me === !0 ? t.mini() : J(t.default))
            ];
            return e.elevated === !0 && C.value === !0 && Pe.push((0, $aD8ZA.h)("div", {
                class: "q-layout__shadow absolute-full overflow-hidden no-pointer-events"
            })), Y.push(kt("aside", {
                ref: "content",
                class: te.value,
                style: T.value
            }, Pe, "contentclose", e.noSwipeClose !== !0 && m.value === !0, function() {
                return ue.value;
            })), (0, $aD8ZA.h)("div", {
                class: "q-drawer-container"
            }, Y);
        };
    }
});
function nv(e, t) {
    if (t && e === t) return null;
    var o = e.nodeName.toLowerCase();
    if ([
        "div",
        "li",
        "ul",
        "ol",
        "blockquote"
    ].includes(o) === !0) return e;
    var r = window.getComputedStyle ? window.getComputedStyle(e) : e.currentStyle, n = r.display;
    return n === "block" || n === "table" ? e : nv(e.parentNode);
}
function Nc(e, t, o) {
    return !e || e === document.body ? !1 : o === !0 && e === t || (t === document ? document.body : t).contains(e.parentNode);
}
function rv(e, t, o) {
    if (o || (o = document.createRange(), o.selectNode(e), o.setStart(e, 0)), t.count === 0) o.setEnd(e, t.count);
    else if (t.count > 0) {
        if (e.nodeType === Node.TEXT_NODE) e.textContent.length < t.count ? t.count -= e.textContent.length : (o.setEnd(e, t.count), t.count = 0);
        else for(var r = 0; t.count !== 0 && r < e.childNodes.length; r++)o = rv(e.childNodes[r], t, o);
    }
    return o;
}
var Nx = /^https?:\/\//, el = /*#__PURE__*/ function() {
    "use strict";
    function el(t, o) {
        (0, $luoZD._)(this, el);
        this.el = t, this.eVm = o, this._range = null;
    }
    (0, $fYUO3._)(el, [
        {
            key: "selection",
            get: function get() {
                if (this.el) {
                    var t = document.getSelection();
                    if (Nc(t.anchorNode, this.el, !0) && Nc(t.focusNode, this.el, !0)) return t;
                }
                return null;
            }
        },
        {
            key: "hasSelection",
            get: function get() {
                return this.selection !== null ? this.selection.toString().length !== 0 : !1;
            }
        },
        {
            key: "range",
            get: function get() {
                var t = this.selection;
                return t !== null && t.rangeCount ? t.getRangeAt(0) : this._range;
            }
        },
        {
            key: "parent",
            get: function get() {
                var t = this.range;
                if (t !== null) {
                    var o = t.startContainer;
                    return o.nodeType === document.ELEMENT_NODE ? o : o.parentNode;
                }
                return null;
            }
        },
        {
            key: "blockParent",
            get: function get() {
                var t = this.parent;
                return t !== null ? nv(t, this.el) : null;
            }
        },
        {
            key: "save",
            value: function save() {
                var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.range;
                t !== null && (this._range = t);
            }
        },
        {
            key: "restore",
            value: function restore() {
                var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this._range;
                var o = document.createRange(), r = document.getSelection();
                t !== null ? (o.setStart(t.startContainer, t.startOffset), o.setEnd(t.endContainer, t.endOffset), r.removeAllRanges(), r.addRange(o)) : (r.selectAllChildren(this.el), r.collapseToEnd());
            }
        },
        {
            key: "savePosition",
            value: function savePosition() {
                var t = -1, o, r = document.getSelection(), n = this.el.parentNode;
                if (r.focusNode && Nc(r.focusNode, n)) for(o = r.focusNode, t = r.focusOffset; o && o !== n;)o !== this.el && o.previousSibling ? (o = o.previousSibling, t += o.textContent.length) : o = o.parentNode;
                this.savedPos = t;
            }
        },
        {
            key: "restorePosition",
            value: function restorePosition() {
                var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
                if (this.savedPos > 0 && this.savedPos < t) {
                    var o = window.getSelection(), r = rv(this.el, {
                        count: this.savedPos
                    });
                    r && (r.collapse(!1), o.removeAllRanges(), o.addRange(r));
                }
            }
        },
        {
            key: "hasParent",
            value: function hasParent(t, o) {
                var r = o ? this.parent : this.blockParent;
                return r !== null ? r.nodeName.toLowerCase() === t.toLowerCase() : !1;
            }
        },
        {
            key: "hasParents",
            value: function hasParents(t, o) {
                var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : this.parent;
                return r === null ? !1 : t.includes(r.nodeName.toLowerCase()) === !0 ? !0 : o === !0 ? this.hasParents(t, o, r.parentNode) : !1;
            }
        },
        {
            key: "is",
            value: function is(t, o) {
                if (this.selection === null) return !1;
                switch(t){
                    case "formatBlock":
                        return o === "DIV" && this.parent === this.el || this.hasParent(o, o === "PRE");
                    case "link":
                        return this.hasParent("A", !0);
                    case "fontSize":
                        return document.queryCommandValue(t) === o;
                    case "fontName":
                        var r = document.queryCommandValue(t);
                        return r === '"'.concat(o, '"') || r === o;
                    case "fullscreen":
                        return this.eVm.inFullscreen.value;
                    case "viewsource":
                        return this.eVm.isViewingSource.value;
                    case void 0:
                        return !1;
                    default:
                        var n = document.queryCommandState(t);
                        return o !== void 0 ? n === o : n;
                }
            }
        },
        {
            key: "getParentAttribute",
            value: function getParentAttribute(t) {
                return this.parent !== null ? this.parent.getAttribute(t) : null;
            }
        },
        {
            key: "can",
            value: function can(t) {
                if (t === "outdent") return this.hasParents([
                    "blockquote",
                    "li"
                ], !0);
                if (t === "indent") return this.hasParents([
                    "li"
                ], !0);
                if (t === "link") return this.selection !== null || this.is("link");
            }
        },
        {
            key: "apply",
            value: function apply(t, o) {
                var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Qe;
                if (t === "formatBlock") [
                    "BLOCKQUOTE",
                    "H1",
                    "H2",
                    "H3",
                    "H4",
                    "H5",
                    "H6"
                ].includes(o) && this.is(t, o) && (t = "outdent", o = null), o === "PRE" && this.is(t, "PRE") && (o = "P");
                else if (t === "print") {
                    r();
                    var n = window.open();
                    n.document.write("\n        <!doctype html>\n        <html>\n          <head>\n            <title>Print - ".concat(document.title, "</title>\n          </head>\n          <body>\n            <div>").concat(this.el.innerHTML, "</div>\n          </body>\n        </html>\n      ")), n.print(), n.close();
                    return;
                } else if (t === "link") {
                    var n1 = this.getParentAttribute("href");
                    if (n1 === null) {
                        var i = this.selectWord(this.selection), a = i ? i.toString() : "";
                        if (!a.length && (!this.range || !this.range.cloneContents().querySelector("img"))) return;
                        this.eVm.editLinkUrl.value = Nx.test(a) ? a : "https://", document.execCommand("createLink", !1, this.eVm.editLinkUrl.value), this.save(i.getRangeAt(0));
                    } else this.eVm.editLinkUrl.value = n1, this.range.selectNodeContents(this.parent), this.save();
                    return;
                } else if (t === "fullscreen") {
                    this.eVm.toggleFullscreen(), r();
                    return;
                } else if (t === "viewsource") {
                    this.eVm.isViewingSource.value = this.eVm.isViewingSource.value === !1, this.eVm.setContent(this.eVm.props.modelValue), r();
                    return;
                }
                document.execCommand(t, !1, o), r();
            }
        },
        {
            key: "selectWord",
            value: function selectWord(t) {
                if (t === null || t.isCollapsed !== !0 || t.modify === void 0) return t;
                var o = document.createRange();
                o.setStart(t.anchorNode, t.anchorOffset), o.setEnd(t.focusNode, t.focusOffset);
                var r = o.collapsed ? [
                    "backward",
                    "forward"
                ] : [
                    "forward",
                    "backward"
                ];
                o.detach();
                var n = t.focusNode, i = t.focusOffset;
                return t.collapse(t.anchorNode, t.anchorOffset), t.modify("move", r[0], "character"), t.modify("move", r[1], "word"), t.extend(n, i), t.modify("extend", r[1], "character"), t.modify("extend", r[0], "word"), t;
            }
        }
    ]);
    return el;
}();
var ku = R({
    name: "QTooltip",
    inheritAttrs: !1,
    props: (0, $8typN._)((0, $8pZMQ._)({}, hi, Ao, ln), {
        maxHeight: {
            type: String,
            default: null
        },
        maxWidth: {
            type: String,
            default: null
        },
        transitionShow: {
            default: "jump-down"
        },
        transitionHide: {
            default: "jump-up"
        },
        anchor: {
            type: String,
            default: "bottom middle",
            validator: Ti
        },
        self: {
            type: String,
            default: "top middle",
            validator: Ti
        },
        offset: {
            type: Array,
            default: function() {
                return [
                    14,
                    14
                ];
            },
            validator: Ql
        },
        scrollTarget: {
            default: void 0
        },
        delay: {
            type: Number,
            default: 0
        },
        hideDelay: {
            type: Number,
            default: 0
        },
        persistent: Boolean
    }),
    emits: (0, $79xu7._)($o),
    setup: function(e, param) {
        var t = param.slots, o = param.emit, r = param.attrs;
        var n, i, a = (0, $aD8ZA.getCurrentInstance)(), _a_proxy = a.proxy, l = _a_proxy.$q, s = (0, $aAzpa.ref)(null), c = (0, $aAzpa.ref)(!1), u = (0, $aAzpa.computed)(function() {
            return Mi(e.anchor, l.lang.rtl);
        }), v = (0, $aAzpa.computed)(function() {
            return Mi(e.self, l.lang.rtl);
        }), f = (0, $aAzpa.computed)(function() {
            return e.persistent !== !0;
        }), _Io = Io(), d = _Io.registerTick, m = _Io.removeTick, _io = io(), y = _io.registerTimeout, _Jn = Jn(e), p = _Jn.transitionProps, C = _Jn.transitionStyle, _Vl = Vl(e, ie), b = _Vl.localScrollTarget, h = _Vl.changeScrollEvent, g = _Vl.unconfigureScrollTarget, _pi = pi({
            showing: c,
            configureAnchorEl: W
        }), S = _pi.anchorEl, P = _pi.canShow, $ = _pi.anchorEvents, _Eo = Eo({
            showing: c,
            canShow: P,
            handleShow: x,
            handleHide: k,
            hideOnRouteChange: f,
            processOnMount: !0
        }), L = _Eo.show, E = _Eo.hide;
        Object.assign($, {
            delayShow: w,
            delayHide: H
        });
        var _Si = Si(a, s, _, "tooltip"), A = _Si.showPortal, B = _Si.hidePortal, q = _Si.renderPortal;
        if (l.platform.is.mobile === !0) {
            var N = {
                anchorEl: S,
                innerRef: s,
                onClickOutside: function(oe) {
                    return E(oe), oe.target.classList.contains("q-dialog__backdrop") && Se(oe), !0;
                }
            }, I = (0, $aAzpa.computed)(function() {
                return e.modelValue === null && e.persistent !== !0 && c.value === !0;
            });
            (0, $aD8ZA.watch)(I, function(oe) {
                (oe === !0 ? Nl : qi)(N);
            }), (0, $aD8ZA.onBeforeUnmount)(function() {
                qi(N);
            });
        }
        function x(N) {
            A(), d(function() {
                i = new MutationObserver(function() {
                    return Q();
                }), i.observe(s.value, {
                    attributes: !1,
                    childList: !0,
                    characterData: !0,
                    subtree: !0
                }), Q(), ie();
            }), n === void 0 && (n = (0, $aD8ZA.watch)(function() {
                return l.screen.width + "|" + l.screen.height + "|" + e.self + "|" + e.anchor + "|" + l.lang.rtl;
            }, Q)), y(function() {
                A(!0), o("show", N);
            }, e.transitionDuration);
        }
        function k(N) {
            m(), B(), j(), y(function() {
                B(!0), o("hide", N);
            }, e.transitionDuration);
        }
        function j() {
            i !== void 0 && (i.disconnect(), i = void 0), n !== void 0 && (n(), n = void 0), g(), Ct($, "tooltipTemp");
        }
        function Q() {
            Fa({
                targetEl: s.value,
                offset: e.offset,
                anchorEl: S.value,
                anchorOrigin: u.value,
                selfOrigin: v.value,
                maxHeight: e.maxHeight,
                maxWidth: e.maxWidth
            });
        }
        function w(N) {
            if (l.platform.is.mobile === !0) {
                Ut(), document.body.classList.add("non-selectable");
                var I = S.value, oe = [
                    "touchmove",
                    "touchcancel",
                    "touchend",
                    "click"
                ].map(function(T) {
                    return [
                        I,
                        T,
                        "delayHide",
                        "passiveCapture"
                    ];
                });
                lt($, "tooltipTemp", oe);
            }
            y(function() {
                L(N);
            }, e.delay);
        }
        function H(N) {
            l.platform.is.mobile === !0 && (Ct($, "tooltipTemp"), Ut(), setTimeout(function() {
                document.body.classList.remove("non-selectable");
            }, 10)), y(function() {
                E(N);
            }, e.hideDelay);
        }
        function W() {
            if (e.noParentEvent === !0 || S.value === null) return;
            var N = l.platform.is.mobile === !0 ? [
                [
                    S.value,
                    "touchstart",
                    "delayShow",
                    "passive"
                ]
            ] : [
                [
                    S.value,
                    "mouseenter",
                    "delayShow",
                    "passive"
                ],
                [
                    S.value,
                    "mouseleave",
                    "delayHide",
                    "passive"
                ]
            ];
            lt($, "anchor", N);
        }
        function ie() {
            if (S.value !== null || e.scrollTarget !== void 0) {
                b.value = At(S.value, e.scrollTarget);
                var N = e.noParentEvent === !0 ? Q : E;
                h(b.value, N);
            }
        }
        function V() {
            return c.value === !0 ? (0, $aD8ZA.h)("div", (0, $8typN._)((0, $8pZMQ._)({}, r), {
                ref: s,
                class: [
                    "q-tooltip q-tooltip--style q-position-engine no-pointer-events",
                    r.class
                ],
                style: [
                    r.style,
                    C.value
                ],
                role: "tooltip"
            }), J(t.default)) : null;
        }
        function _() {
            return (0, $aD8ZA.h)((0, $iMtOP.Transition), p.value, V);
        }
        return (0, $aD8ZA.onBeforeUnmount)(j), Object.assign(a.proxy, {
            updatePosition: Q
        }), q;
    }
});
var hn = R({
    name: "QItem",
    props: (0, $8typN._)((0, $8pZMQ._)({}, he, zo), {
        tag: {
            type: String,
            default: "div"
        },
        active: {
            type: Boolean,
            default: null
        },
        clickable: Boolean,
        dense: Boolean,
        insetLevel: Number,
        tabindex: [
            String,
            Number
        ],
        focused: Boolean,
        manualFocus: Boolean
    }),
    emits: [
        "click",
        "keyup"
    ],
    setup: function(e, param) {
        var t = param.slots, o = param.emit;
        var _Ux = (0, $aD8ZA.getCurrentInstance)(), _Ux_proxy = _Ux.proxy, r = _Ux_proxy.$q, n = pe(e, r), _Yn = Yn(), i = _Yn.hasLink, a = _Yn.linkAttrs, l = _Yn.linkClass, s = _Yn.linkTag, c = _Yn.navigateOnClick, u = (0, $aAzpa.ref)(null), v = (0, $aAzpa.ref)(null), f = (0, $aAzpa.computed)(function() {
            return e.clickable === !0 || i.value === !0 || e.tag === "label";
        }), d = (0, $aAzpa.computed)(function() {
            return e.disable !== !0 && f.value === !0;
        }), m = (0, $aAzpa.computed)(function() {
            return "q-item q-item-type row no-wrap" + (e.dense === !0 ? " q-item--dense" : "") + (n.value === !0 ? " q-item--dark" : "") + (i.value === !0 && e.active === null ? l.value : e.active === !0 ? " q-item--active".concat(e.activeClass !== void 0 ? " ".concat(e.activeClass) : "") : "") + (e.disable === !0 ? " disabled" : "") + (d.value === !0 ? " q-item--clickable q-link cursor-pointer " + (e.manualFocus === !0 ? "q-manual-focusable" : "q-focusable q-hoverable") + (e.focused === !0 ? " q-manual-focusable--focused" : "") : "");
        }), y = (0, $aAzpa.computed)(function() {
            return e.insetLevel === void 0 ? null : {
                ["padding" + (r.lang.rtl === !0 ? "Right" : "Left")]: 16 + e.insetLevel * 56 + "px"
            };
        });
        function p(h) {
            d.value === !0 && (v.value !== null && (h.qKeyEvent !== !0 && document.activeElement === u.value ? v.value.focus() : document.activeElement === v.value && u.value.focus()), c(h));
        }
        function C(h) {
            if (d.value === !0 && wt(h, [
                13,
                32
            ]) === !0) {
                Se(h), h.qKeyEvent = !0;
                var g = new MouseEvent("click", h);
                g.qKeyEvent = !0, u.value.dispatchEvent(g);
            }
            o("keyup", h);
        }
        function b() {
            var h = tn(t.default, []);
            return d.value === !0 && h.unshift((0, $aD8ZA.h)("div", {
                class: "q-focus-helper",
                tabindex: -1,
                ref: v
            })), h;
        }
        return function() {
            var h = {
                ref: u,
                class: m.value,
                style: y.value,
                role: "listitem",
                onClick: p,
                onKeyup: C
            };
            return d.value === !0 ? (h.tabindex = e.tabindex || "0", Object.assign(h, a.value)) : f.value === !0 && (h["aria-disabled"] = "true"), (0, $aD8ZA.h)(s.value, h, b());
        };
    }
});
var ho = R({
    name: "QItemSection",
    props: {
        avatar: Boolean,
        thumbnail: Boolean,
        side: Boolean,
        top: Boolean,
        noWrap: Boolean
    },
    setup: function(e, param) {
        var t = param.slots;
        var o = (0, $aAzpa.computed)(function() {
            return "q-item__section column q-item__section--".concat(e.avatar === !0 || e.side === !0 || e.thumbnail === !0 ? "side" : "main") + (e.top === !0 ? " q-item__section--top justify-start" : " justify-center") + (e.avatar === !0 ? " q-item__section--avatar" : "") + (e.thumbnail === !0 ? " q-item__section--thumbnail" : "") + (e.noWrap === !0 ? " q-item__section--nowrap" : "");
        });
        return function() {
            return (0, $aD8ZA.h)("div", {
                class: o.value
            }, J(t.default));
        };
    }
});
function dv(e, t, o) {
    t.handler ? t.handler(e, o, o.caret) : o.runCmd(t.cmd, t.param);
}
function Qc(e) {
    return (0, $aD8ZA.h)("div", {
        class: "q-editor__toolbar-group"
    }, e);
}
function fv(e, t, o) {
    var r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
    var n = r || (t.type === "toggle" ? t.toggled ? t.toggled(e) : t.cmd && e.caret.is(t.cmd, t.param) : !1), i = [];
    if (t.tip && e.$q.platform.is.desktop) {
        var a = t.key ? (0, $aD8ZA.h)("div", [
            (0, $aD8ZA.h)("small", "(CTRL + ".concat(String.fromCharCode(t.key), ")"))
        ]) : null;
        i.push((0, $aD8ZA.h)(ku, {
            delay: 1e3
        }, function() {
            return [
                (0, $aD8ZA.h)("div", {
                    innerHTML: t.tip
                }),
                a
            ];
        }));
    }
    return (0, $aD8ZA.h)(Le, (0, $8typN._)((0, $8pZMQ._)({}, e.buttonProps.value), {
        icon: t.icon !== null ? t.icon : void 0,
        color: n ? t.toggleColor || e.props.toolbarToggleColor : t.color || e.props.toolbarColor,
        textColor: n && !e.props.toolbarPush ? null : t.textColor || e.props.toolbarTextColor,
        label: t.label,
        disable: t.disable ? typeof t.disable == "function" ? t.disable(e) : !0 : !1,
        size: "sm",
        onClick: function(a) {
            o && o(), dv(a, t, e);
        }
    }), function() {
        return i;
    });
}
function Yx(e, t) {
    var o = t.list === "only-icons", r = t.label, n = t.icon !== null ? t.icon : void 0, i, a;
    function l() {
        c.component.proxy.hide();
    }
    if (o) a = t.options.map(function(u) {
        var v = u.type === void 0 ? e.caret.is(u.cmd, u.param) : !1;
        return v && (r = u.tip, n = u.icon !== null ? u.icon : void 0), fv(e, u, l, v);
    }), i = e.toolbarBackgroundClass.value, a = [
        Qc(a)
    ];
    else {
        var u = e.props.toolbarToggleColor !== void 0 ? "text-".concat(e.props.toolbarToggleColor) : null, v = e.props.toolbarTextColor !== void 0 ? "text-".concat(e.props.toolbarTextColor) : null, f = t.list === "no-icons";
        a = t.options.map(function(d) {
            var m = d.disable ? d.disable(e) : !1, y = d.type === void 0 ? e.caret.is(d.cmd, d.param) : !1;
            y && (r = d.tip, n = d.icon !== null ? d.icon : void 0);
            var p = d.htmlTip;
            return (0, $aD8ZA.h)(hn, {
                active: y,
                activeClass: u,
                clickable: !0,
                disable: m,
                dense: !0,
                onClick: function(C) {
                    l(), e.contentRef.value !== null && e.contentRef.value.focus(), e.caret.restore(), dv(C, d, e);
                }
            }, function() {
                return [
                    f === !0 ? null : (0, $aD8ZA.h)(ho, {
                        class: y ? u : v,
                        side: !0
                    }, function() {
                        return (0, $aD8ZA.h)(we, {
                            name: d.icon !== null ? d.icon : void 0
                        });
                    }),
                    (0, $aD8ZA.h)(ho, p ? function() {
                        return (0, $aD8ZA.h)("div", {
                            class: "text-no-wrap",
                            innerHTML: d.htmlTip
                        });
                    } : d.tip ? function() {
                        return (0, $aD8ZA.h)("div", {
                            class: "text-no-wrap"
                        }, d.tip);
                    } : void 0)
                ];
            });
        }), i = [
            e.toolbarBackgroundClass.value,
            v
        ];
    }
    var s = t.highlight && r !== t.label, c = (0, $aD8ZA.h)(Kl, (0, $8typN._)((0, $8pZMQ._)({}, e.buttonProps.value), {
        noCaps: !0,
        noWrap: !0,
        color: s ? e.props.toolbarToggleColor : e.props.toolbarColor,
        textColor: s && !e.props.toolbarPush ? null : e.props.toolbarTextColor,
        label: t.fixedLabel ? t.label : r,
        icon: t.fixedIcon ? t.icon !== null ? t.icon : void 0 : n,
        contentClass: i,
        onShow: function(u) {
            return e.emit("dropdownShow", u);
        },
        onHide: function(u) {
            return e.emit("dropdownHide", u);
        },
        onBeforeShow: function(u) {
            return e.emit("dropdownBeforeShow", u);
        },
        onBeforeHide: function(u) {
            return e.emit("dropdownBeforeHide", u);
        }
    }), function() {
        return a;
    });
    return c;
}
function mv(e) {
    if (e.caret) return e.buttons.value.filter(function(t) {
        return !e.isViewingSource.value || t.find(function(o) {
            return o.cmd === "viewsource";
        });
    }).map(function(t) {
        return Qc(t.map(function(o) {
            return e.isViewingSource.value && o.cmd !== "viewsource" ? !1 : o.type === "slot" ? J(e.slots[o.slot]) : o.type === "dropdown" ? Yx(e, o) : fv(e, o);
        }));
    });
}
function vv(e, t, o) {
    var r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    var n = Object.keys(r);
    if (n.length === 0) return {};
    var i = {
        default_font: {
            cmd: "fontName",
            param: e,
            icon: o,
            tip: t
        }
    };
    return n.forEach(function(a) {
        var l = r[a];
        i[a] = {
            cmd: "fontName",
            param: l,
            icon: o,
            tip: l,
            htmlTip: '<font face="'.concat(l, '">').concat(l, "</font>")
        };
    }), i;
}
function gv(e) {
    if (e.caret) {
        var t = e.props.toolbarColor || e.props.toolbarTextColor, o = e.editLinkUrl.value, r = function() {
            e.caret.restore(), o !== e.editLinkUrl.value && document.execCommand("createLink", !1, o === "" ? " " : o), e.editLinkUrl.value = null;
        };
        return [
            (0, $aD8ZA.h)("div", {
                class: "q-mx-xs text-".concat(t)
            }, "".concat(e.$q.lang.editor.url, ": ")),
            (0, $aD8ZA.h)("input", {
                key: "qedt_btm_input",
                class: "col q-editor__link-input",
                value: o,
                onInput: function(n) {
                    tt(n), o = n.target.value;
                },
                onKeydown: function(n) {
                    if (xo(n) !== !0) switch(n.keyCode){
                        case 13:
                            return ut(n), r();
                        case 27:
                            ut(n), e.caret.restore(), (!e.editLinkUrl.value || e.editLinkUrl.value === "https://") && document.execCommand("unlink"), e.editLinkUrl.value = null;
                            break;
                    }
                }
            }),
            Qc([
                (0, $aD8ZA.h)(Le, (0, $8typN._)((0, $8pZMQ._)({
                    key: "qedt_btm_rem",
                    tabindex: -1
                }, e.buttonProps.value), {
                    label: e.$q.lang.label.remove,
                    noCaps: !0,
                    onClick: function() {
                        e.caret.restore(), document.execCommand("unlink"), e.editLinkUrl.value = null;
                    }
                })),
                (0, $aD8ZA.h)(Le, (0, $8typN._)((0, $8pZMQ._)({
                    key: "qedt_btm_upd"
                }, e.buttonProps.value), {
                    label: e.$q.lang.label.update,
                    noCaps: !0,
                    onClick: r
                }))
            ])
        ];
    }
}
var pv = /^on[A-Z]/;
function tl() {
    var _Gx = (0, $aD8ZA.getCurrentInstance)(), e = _Gx.attrs, t = _Gx.vnode, o = {
        listeners: (0, $aAzpa.ref)({}),
        attributes: (0, $aAzpa.ref)({})
    };
    function r() {
        var n = {}, i = {};
        for(var a in e)a !== "class" && a !== "style" && pv.test(a) === !1 && (n[a] = e[a]);
        for(var a1 in t.props)pv.test(a1) === !0 && (i[a1] = t.props[a1]);
        o.attributes.value = n, o.listeners.value = i;
    }
    return (0, $aD8ZA.onBeforeUpdate)(r), r(), o;
}
var Zx = Object.prototype.toString, jc = Object.prototype.hasOwnProperty, Jx = new Set([
    "Boolean",
    "Number",
    "String",
    "Function",
    "Array",
    "Date",
    "RegExp"
].map(function(e) {
    return "[object " + e + "]";
}));
function bv(e) {
    if (e !== Object(e) || Jx.has(Zx.call(e)) === !0 || e.constructor && jc.call(e, "constructor") === !1 && jc.call(e.constructor.prototype, "isPrototypeOf") === !1) return !1;
    var t;
    for(t in e);
    return t === void 0 || jc.call(e, t);
}
function Ir() {
    var e, t, o, r, n, i, a = arguments[0] || {}, l = 1, s = !1, c = arguments.length;
    for(typeof a == "boolean" && (s = a, a = arguments[1] || {}, l = 2), Object(a) !== a && typeof a != "function" && (a = {}), c === l && (a = this, l--); l < c; l++)if ((e = arguments[l]) !== null) for(t in e)o = a[t], r = e[t], a !== r && (s === !0 && r && ((n = Array.isArray(r)) || bv(r) === !0) ? (n === !0 ? i = Array.isArray(o) === !0 ? o : [] : i = bv(o) === !0 ? o : {}, a[t] = Ir(s, i, r)) : r !== void 0 && (a[t] = r));
    return a;
}
var Sv = R({
    name: "QEditor",
    props: (0, $8typN._)((0, $8pZMQ._)({}, he, zi), {
        modelValue: {
            type: String,
            required: !0
        },
        readonly: Boolean,
        disable: Boolean,
        minHeight: {
            type: String,
            default: "10rem"
        },
        maxHeight: String,
        height: String,
        definitions: Object,
        fonts: Object,
        placeholder: String,
        toolbar: {
            type: Array,
            validator: function(e) {
                return e.length === 0 || e.every(function(t) {
                    return t.length;
                });
            },
            default: function() {
                return [
                    [
                        "left",
                        "center",
                        "right",
                        "justify"
                    ],
                    [
                        "bold",
                        "italic",
                        "underline",
                        "strike"
                    ],
                    [
                        "undo",
                        "redo"
                    ]
                ];
            }
        },
        toolbarColor: String,
        toolbarBg: String,
        toolbarTextColor: String,
        toolbarToggleColor: {
            type: String,
            default: "primary"
        },
        toolbarOutline: Boolean,
        toolbarPush: Boolean,
        toolbarRounded: Boolean,
        paragraphTag: {
            type: String,
            validator: function(e) {
                return [
                    "div",
                    "p"
                ].includes(e);
            },
            default: "div"
        },
        contentStyle: Object,
        contentClass: [
            Object,
            Array,
            String
        ],
        square: Boolean,
        flat: Boolean,
        dense: Boolean
    }),
    emits: (0, $79xu7._)(Oi).concat([
        "update:modelValue",
        "keydown",
        "click",
        "mouseup",
        "keyup",
        "touchend",
        "focus",
        "blur",
        "dropdownShow",
        "dropdownHide",
        "dropdownBeforeShow",
        "dropdownBeforeHide",
        "linkShow",
        "linkHide"
    ]),
    setup: function(e, param) {
        var t = param.slots, o = param.emit;
        var _n_ = (0, $aD8ZA.getCurrentInstance)(), r = _n_.proxy, n = r.$q, i = pe(e, n), _Ii = Ii(), a = _Ii.inFullscreen, l = _Ii.toggleFullscreen, s = tl(), c = (0, $aAzpa.ref)(null), u = (0, $aAzpa.ref)(null), v = (0, $aAzpa.ref)(null), f = (0, $aAzpa.ref)(!1), d = (0, $aAzpa.computed)(function() {
            return !e.readonly && !e.disable;
        }), m, y, p = e.modelValue;
        document.execCommand("defaultParagraphSeparator", !1, e.paragraphTag), m = window.getComputedStyle(document.body).fontFamily;
        var C = (0, $aAzpa.computed)(function() {
            return e.toolbarBg ? " bg-".concat(e.toolbarBg) : "";
        }), b = (0, $aAzpa.computed)(function() {
            return {
                type: "a",
                flat: e.toolbarOutline !== !0 && e.toolbarPush !== !0,
                noWrap: !0,
                outline: e.toolbarOutline,
                push: e.toolbarPush,
                rounded: e.toolbarRounded,
                dense: !0,
                color: e.toolbarColor,
                disable: !d.value,
                size: "sm"
            };
        }), h = (0, $aAzpa.computed)(function() {
            var T = n.lang.editor, D = n.iconSet.editor;
            return {
                bold: {
                    cmd: "bold",
                    icon: D.bold,
                    tip: T.bold,
                    key: 66
                },
                italic: {
                    cmd: "italic",
                    icon: D.italic,
                    tip: T.italic,
                    key: 73
                },
                strike: {
                    cmd: "strikeThrough",
                    icon: D.strikethrough,
                    tip: T.strikethrough,
                    key: 83
                },
                underline: {
                    cmd: "underline",
                    icon: D.underline,
                    tip: T.underline,
                    key: 85
                },
                unordered: {
                    cmd: "insertUnorderedList",
                    icon: D.unorderedList,
                    tip: T.unorderedList
                },
                ordered: {
                    cmd: "insertOrderedList",
                    icon: D.orderedList,
                    tip: T.orderedList
                },
                subscript: {
                    cmd: "subscript",
                    icon: D.subscript,
                    tip: T.subscript,
                    htmlTip: "x<subscript>2</subscript>"
                },
                superscript: {
                    cmd: "superscript",
                    icon: D.superscript,
                    tip: T.superscript,
                    htmlTip: "x<superscript>2</superscript>"
                },
                link: {
                    cmd: "link",
                    disable: function(te) {
                        return te.caret && !te.caret.can("link");
                    },
                    icon: D.hyperlink,
                    tip: T.hyperlink,
                    key: 76
                },
                fullscreen: {
                    cmd: "fullscreen",
                    icon: D.toggleFullscreen,
                    tip: T.toggleFullscreen,
                    key: 70
                },
                viewsource: {
                    cmd: "viewsource",
                    icon: D.viewSource,
                    tip: T.viewSource
                },
                quote: {
                    cmd: "formatBlock",
                    param: "BLOCKQUOTE",
                    icon: D.quote,
                    tip: T.quote,
                    key: 81
                },
                left: {
                    cmd: "justifyLeft",
                    icon: D.left,
                    tip: T.left
                },
                center: {
                    cmd: "justifyCenter",
                    icon: D.center,
                    tip: T.center
                },
                right: {
                    cmd: "justifyRight",
                    icon: D.right,
                    tip: T.right
                },
                justify: {
                    cmd: "justifyFull",
                    icon: D.justify,
                    tip: T.justify
                },
                print: {
                    type: "no-state",
                    cmd: "print",
                    icon: D.print,
                    tip: T.print,
                    key: 80
                },
                outdent: {
                    type: "no-state",
                    disable: function(te) {
                        return te.caret && !te.caret.can("outdent");
                    },
                    cmd: "outdent",
                    icon: D.outdent,
                    tip: T.outdent
                },
                indent: {
                    type: "no-state",
                    disable: function(te) {
                        return te.caret && !te.caret.can("indent");
                    },
                    cmd: "indent",
                    icon: D.indent,
                    tip: T.indent
                },
                removeFormat: {
                    type: "no-state",
                    cmd: "removeFormat",
                    icon: D.removeFormat,
                    tip: T.removeFormat
                },
                hr: {
                    type: "no-state",
                    cmd: "insertHorizontalRule",
                    icon: D.hr,
                    tip: T.hr
                },
                undo: {
                    type: "no-state",
                    cmd: "undo",
                    icon: D.undo,
                    tip: T.undo,
                    key: 90
                },
                redo: {
                    type: "no-state",
                    cmd: "redo",
                    icon: D.redo,
                    tip: T.redo,
                    key: 89
                },
                h1: {
                    cmd: "formatBlock",
                    param: "H1",
                    icon: D.heading1 || D.heading,
                    tip: T.heading1,
                    htmlTip: '<h1 class="q-ma-none">'.concat(T.heading1, "</h1>")
                },
                h2: {
                    cmd: "formatBlock",
                    param: "H2",
                    icon: D.heading2 || D.heading,
                    tip: T.heading2,
                    htmlTip: '<h2 class="q-ma-none">'.concat(T.heading2, "</h2>")
                },
                h3: {
                    cmd: "formatBlock",
                    param: "H3",
                    icon: D.heading3 || D.heading,
                    tip: T.heading3,
                    htmlTip: '<h3 class="q-ma-none">'.concat(T.heading3, "</h3>")
                },
                h4: {
                    cmd: "formatBlock",
                    param: "H4",
                    icon: D.heading4 || D.heading,
                    tip: T.heading4,
                    htmlTip: '<h4 class="q-ma-none">'.concat(T.heading4, "</h4>")
                },
                h5: {
                    cmd: "formatBlock",
                    param: "H5",
                    icon: D.heading5 || D.heading,
                    tip: T.heading5,
                    htmlTip: '<h5 class="q-ma-none">'.concat(T.heading5, "</h5>")
                },
                h6: {
                    cmd: "formatBlock",
                    param: "H6",
                    icon: D.heading6 || D.heading,
                    tip: T.heading6,
                    htmlTip: '<h6 class="q-ma-none">'.concat(T.heading6, "</h6>")
                },
                p: {
                    cmd: "formatBlock",
                    param: e.paragraphTag,
                    icon: D.heading,
                    tip: T.paragraph
                },
                code: {
                    cmd: "formatBlock",
                    param: "PRE",
                    icon: D.code,
                    htmlTip: "<code>".concat(T.code, "</code>")
                },
                "size-1": {
                    cmd: "fontSize",
                    param: "1",
                    icon: D.size1 || D.size,
                    tip: T.size1,
                    htmlTip: '<font size="1">'.concat(T.size1, "</font>")
                },
                "size-2": {
                    cmd: "fontSize",
                    param: "2",
                    icon: D.size2 || D.size,
                    tip: T.size2,
                    htmlTip: '<font size="2">'.concat(T.size2, "</font>")
                },
                "size-3": {
                    cmd: "fontSize",
                    param: "3",
                    icon: D.size3 || D.size,
                    tip: T.size3,
                    htmlTip: '<font size="3">'.concat(T.size3, "</font>")
                },
                "size-4": {
                    cmd: "fontSize",
                    param: "4",
                    icon: D.size4 || D.size,
                    tip: T.size4,
                    htmlTip: '<font size="4">'.concat(T.size4, "</font>")
                },
                "size-5": {
                    cmd: "fontSize",
                    param: "5",
                    icon: D.size5 || D.size,
                    tip: T.size5,
                    htmlTip: '<font size="5">'.concat(T.size5, "</font>")
                },
                "size-6": {
                    cmd: "fontSize",
                    param: "6",
                    icon: D.size6 || D.size,
                    tip: T.size6,
                    htmlTip: '<font size="6">'.concat(T.size6, "</font>")
                },
                "size-7": {
                    cmd: "fontSize",
                    param: "7",
                    icon: D.size7 || D.size,
                    tip: T.size7,
                    htmlTip: '<font size="7">'.concat(T.size7, "</font>")
                }
            };
        }), g = (0, $aAzpa.computed)(function() {
            var T = e.definitions || {}, D = e.definitions || e.fonts ? Ir(!0, {}, h.value, T, vv(m, n.lang.editor.defaultFont, n.iconSet.editor.font, e.fonts)) : h.value;
            return e.toolbar.map(function(te) {
                return te.map(function(z) {
                    if (z.options) return {
                        type: "dropdown",
                        icon: z.icon,
                        label: z.label,
                        size: "sm",
                        dense: !0,
                        fixedLabel: z.fixedLabel,
                        fixedIcon: z.fixedIcon,
                        highlight: z.highlight,
                        list: z.list,
                        options: z.options.map(function(_e) {
                            return D[_e];
                        })
                    };
                    var ue = D[z];
                    return ue ? ue.type === "no-state" || T[z] && (ue.cmd === void 0 || h.value[ue.cmd] && h.value[ue.cmd].type === "no-state") ? ue : Object.assign({
                        type: "toggle"
                    }, ue) : {
                        type: "slot",
                        slot: z
                    };
                });
            });
        }), S = {
            $q: n,
            props: e,
            slots: t,
            emit: o,
            inFullscreen: a,
            toggleFullscreen: l,
            runCmd: _,
            isViewingSource: f,
            editLinkUrl: v,
            toolbarBackgroundClass: C,
            buttonProps: b,
            contentRef: u,
            buttons: g,
            setContent: V
        };
        (0, $aD8ZA.watch)(function() {
            return e.modelValue;
        }, function(T) {
            p !== T && (p = T, V(T, !0));
        }), (0, $aD8ZA.watch)(v, function(T) {
            o("link".concat(T ? "Show" : "Hide"));
        });
        var P = (0, $aAzpa.computed)(function() {
            return e.toolbar && e.toolbar.length !== 0;
        }), $ = (0, $aAzpa.computed)(function() {
            var T = {}, D = function(te) {
                te.key && (T[te.key] = {
                    cmd: te.cmd,
                    param: te.param
                });
            };
            return g.value.forEach(function(te) {
                te.forEach(function(z) {
                    z.options ? z.options.forEach(D) : D(z);
                });
            }), T;
        }), L = (0, $aAzpa.computed)(function() {
            return a.value ? e.contentStyle : [
                {
                    minHeight: e.minHeight,
                    height: e.height,
                    maxHeight: e.maxHeight
                },
                e.contentStyle
            ];
        }), E = (0, $aAzpa.computed)(function() {
            return "q-editor q-editor--".concat(f.value === !0 ? "source" : "default") + (e.disable === !0 ? " disabled" : "") + (a.value === !0 ? " fullscreen column" : "") + (e.square === !0 ? " q-editor--square no-border-radius" : "") + (e.flat === !0 ? " q-editor--flat" : "") + (e.dense === !0 ? " q-editor--dense" : "") + (i.value === !0 ? " q-editor--dark q-dark" : "");
        }), A = (0, $aAzpa.computed)(function() {
            return [
                e.contentClass,
                "q-editor__content",
                {
                    col: a.value,
                    "overflow-auto": a.value || e.maxHeight
                }
            ];
        }), B = (0, $aAzpa.computed)(function() {
            return e.disable === !0 ? {
                "aria-disabled": "true"
            } : {};
        });
        function q() {
            if (u.value !== null) {
                var T = "inner".concat(f.value === !0 ? "Text" : "HTML"), D = u.value[T];
                D !== e.modelValue && (p = D, o("update:modelValue", D));
            }
        }
        function x(T) {
            if (o("keydown", T), T.ctrlKey !== !0 || xo(T) === !0) {
                N();
                return;
            }
            var D = T.keyCode, te = $.value[D];
            if (te !== void 0) {
                var z = te.cmd, ue = te.param;
                Se(T), _(z, ue, !1);
            }
        }
        function k(T) {
            N(), o("click", T);
        }
        function j(T) {
            if (u.value !== null) {
                var _u_value = u.value, D = _u_value.scrollTop, te = _u_value.scrollHeight;
                y = te - D;
            }
            S.caret.save(), o("blur", T);
        }
        function Q(T) {
            (0, $aD8ZA.nextTick)(function() {
                u.value !== null && y !== void 0 && (u.value.scrollTop = u.value.scrollHeight - y);
            }), o("focus", T);
        }
        function w(T) {
            var D = c.value;
            if (D !== null && D.contains(T.target) === !0 && (T.relatedTarget === null || D.contains(T.relatedTarget) !== !0)) {
                var te = "inner".concat(f.value === !0 ? "Text" : "HTML");
                S.caret.restorePosition(u.value[te].length), N();
            }
        }
        function H(T) {
            var D = c.value;
            D !== null && D.contains(T.target) === !0 && (T.relatedTarget === null || D.contains(T.relatedTarget) !== !0) && (S.caret.savePosition(), N());
        }
        function W() {
            y = void 0;
        }
        function ie(T) {
            S.caret.save();
        }
        function V(T, D) {
            if (u.value !== null) {
                D === !0 && S.caret.savePosition();
                var te = "inner".concat(f.value === !0 ? "Text" : "HTML");
                u.value[te] = T, D === !0 && (S.caret.restorePosition(u.value[te].length), N());
            }
        }
        function _(T, D) {
            var te = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0;
            I(), S.caret.restore(), S.caret.apply(T, D, function() {
                I(), S.caret.save(), te && N();
            });
        }
        function N() {
            setTimeout(function() {
                v.value = null, r.$forceUpdate();
            }, 1);
        }
        function I() {
            Bo(function() {
                u.value !== null && u.value.focus({
                    preventScroll: !0
                });
            });
        }
        function oe() {
            return u.value;
        }
        return (0, $aD8ZA.onMounted)(function() {
            S.caret = r.caret = new el(u.value, S), V(e.modelValue), N(), document.addEventListener("selectionchange", ie);
        }), (0, $aD8ZA.onBeforeUnmount)(function() {
            document.removeEventListener("selectionchange", ie);
        }), Object.assign(r, {
            runCmd: _,
            refreshToolbar: N,
            focus: I,
            getContentEl: oe
        }), function() {
            var T;
            if (P.value) {
                var D = [
                    (0, $aD8ZA.h)("div", {
                        key: "qedt_top",
                        class: "q-editor__toolbar row no-wrap scroll-x" + C.value
                    }, mv(S))
                ];
                v.value !== null && D.push((0, $aD8ZA.h)("div", {
                    key: "qedt_btm",
                    class: "q-editor__toolbar row no-wrap items-center scroll-x" + C.value
                }, gv(S))), T = (0, $aD8ZA.h)("div", {
                    key: "toolbar_ctainer",
                    class: "q-editor__toolbars-container"
                }, D);
            }
            return (0, $aD8ZA.h)("div", (0, $8typN._)((0, $8pZMQ._)({
                ref: c,
                class: E.value,
                style: {
                    height: a.value === !0 ? "100%" : null
                }
            }, B.value), {
                onFocusin: w,
                onFocusout: H
            }), [
                T,
                (0, $aD8ZA.h)("div", (0, $8typN._)((0, $8pZMQ._)({
                    ref: u,
                    style: L.value,
                    class: A.value,
                    contenteditable: d.value,
                    placeholder: e.placeholder
                }, s.listeners.value), {
                    onInput: q,
                    onKeydown: x,
                    onClick: k,
                    onBlur: j,
                    onFocus: Q,
                    onMousedown: W,
                    onTouchstartPassive: W
                }))
            ]);
        };
    }
});
var Hr = R({
    name: "QItemLabel",
    props: {
        overline: Boolean,
        caption: Boolean,
        header: Boolean,
        lines: [
            Number,
            String
        ]
    },
    setup: function(e, param) {
        var t = param.slots;
        var o = (0, $aAzpa.computed)(function() {
            return parseInt(e.lines, 10);
        }), r = (0, $aAzpa.computed)(function() {
            return "q-item__label" + (e.overline === !0 ? " q-item__label--overline text-overline" : "") + (e.caption === !0 ? " q-item__label--caption text-caption" : "") + (e.header === !0 ? " q-item__label--header" : "") + (o.value === 1 ? " ellipsis" : "");
        }), n = (0, $aAzpa.computed)(function() {
            return e.lines !== void 0 && o.value > 1 ? {
                overflow: "hidden",
                display: "-webkit-box",
                "-webkit-box-orient": "vertical",
                "-webkit-line-clamp": o.value
            } : null;
        });
        return function() {
            return (0, $aD8ZA.h)("div", {
                style: n.value,
                class: r.value
            }, J(t.default));
        };
    }
});
var sr = R({
    name: "QSlideTransition",
    props: {
        appear: Boolean,
        duration: {
            type: Number,
            default: 300
        }
    },
    emits: [
        "show",
        "hide"
    ],
    setup: function(e, param) {
        var t = param.slots, o = param.emit;
        var r = !1, n, i, a = null, l = null, s, c;
        function u() {
            n && n(), n = null, r = !1, a !== null && (clearTimeout(a), a = null), l !== null && (clearTimeout(l), l = null), i !== void 0 && i.removeEventListener("transitionend", s), s = null;
        }
        function v(y, p, C) {
            p !== void 0 && (y.style.height = "".concat(p, "px")), y.style.transition = "height ".concat(e.duration, "ms cubic-bezier(.25, .8, .50, 1)"), r = !0, n = C;
        }
        function f(y, p) {
            y.style.overflowY = null, y.style.height = null, y.style.transition = null, u(), p !== c && o(p);
        }
        function d(y, p) {
            var C = 0;
            i = y, r === !0 ? (u(), C = y.offsetHeight === y.scrollHeight ? 0 : void 0) : (c = "hide", y.style.overflowY = "hidden"), v(y, C, p), a = setTimeout(function() {
                a = null, y.style.height = "".concat(y.scrollHeight, "px"), s = function(b) {
                    l = null, (Object(b) !== b || b.target === y) && f(y, "show");
                }, y.addEventListener("transitionend", s), l = setTimeout(s, e.duration * 1.1);
            }, 100);
        }
        function m(y, p) {
            var C;
            i = y, r === !0 ? u() : (c = "show", y.style.overflowY = "hidden", C = y.scrollHeight), v(y, C, p), a = setTimeout(function() {
                a = null, y.style.height = 0, s = function(b) {
                    l = null, (Object(b) !== b || b.target === y) && f(y, "hide");
                }, y.addEventListener("transitionend", s), l = setTimeout(s, e.duration * 1.1);
            }, 100);
        }
        return (0, $aD8ZA.onBeforeUnmount)(function() {
            r === !0 && u();
        }), function() {
            return (0, $aD8ZA.h)((0, $iMtOP.Transition), {
                css: !1,
                appear: e.appear,
                onEnter: d,
                onLeave: m
            }, t.default);
        };
    }
});
var c_ = {
    true: "inset",
    item: "item-inset",
    "item-thumbnail": "item-thumbnail-inset"
}, Kc = {
    xs: 2,
    sm: 4,
    md: 8,
    lg: 16,
    xl: 24
}, Co = R({
    name: "QSeparator",
    props: (0, $8typN._)((0, $8pZMQ._)({}, he), {
        spaced: [
            Boolean,
            String
        ],
        inset: [
            Boolean,
            String
        ],
        vertical: Boolean,
        color: String,
        size: String
    }),
    setup: function(e) {
        var t = (0, $aD8ZA.getCurrentInstance)(), o = pe(e, t.proxy.$q), r = (0, $aAzpa.computed)(function() {
            return e.vertical === !0 ? "vertical" : "horizontal";
        }), n = (0, $aAzpa.computed)(function() {
            return " q-separator--".concat(r.value);
        }), i = (0, $aAzpa.computed)(function() {
            return e.inset !== !1 ? "".concat(n.value, "-").concat(c_[e.inset]) : "";
        }), a = (0, $aAzpa.computed)(function() {
            return "q-separator".concat(n.value).concat(i.value) + (e.color !== void 0 ? " bg-".concat(e.color) : "") + (o.value === !0 ? " q-separator--dark" : "");
        }), l = (0, $aAzpa.computed)(function() {
            var s = {};
            if (e.size !== void 0 && (s[e.vertical === !0 ? "width" : "height"] = e.size), e.spaced !== !1) {
                var c = e.spaced === !0 ? "".concat(Kc.md, "px") : e.spaced in Kc ? "".concat(Kc[e.spaced], "px") : e.spaced, u = e.vertical === !0 ? [
                    "Left",
                    "Right"
                ] : [
                    "Top",
                    "Bottom"
                ];
                s["margin".concat(u[0])] = s["margin".concat(u[1])] = c;
            }
            return s;
        });
        return function() {
            return (0, $aD8ZA.h)("hr", {
                class: a.value,
                style: l.value,
                "aria-orientation": r.value
            });
        };
    }
});
var Nr = (0, $aAzpa.shallowReactive)({}), h_ = Object.keys(zo), _v = R({
    name: "QExpansionItem",
    props: (0, $8typN._)((0, $8pZMQ._)({}, zo, Ao, he), {
        icon: String,
        label: String,
        labelLines: [
            Number,
            String
        ],
        caption: String,
        captionLines: [
            Number,
            String
        ],
        dense: Boolean,
        toggleAriaLabel: String,
        expandIcon: String,
        expandedIcon: String,
        expandIconClass: [
            Array,
            String,
            Object
        ],
        duration: Number,
        headerInsetLevel: Number,
        contentInsetLevel: Number,
        expandSeparator: Boolean,
        defaultOpened: Boolean,
        hideExpandIcon: Boolean,
        expandIconToggle: Boolean,
        switchToggleSide: Boolean,
        denseToggle: Boolean,
        group: String,
        popup: Boolean,
        headerStyle: [
            Array,
            String,
            Object
        ],
        headerClass: [
            Array,
            String,
            Object
        ]
    }),
    emits: (0, $79xu7._)($o).concat([
        "click",
        "afterShow",
        "afterHide"
    ]),
    setup: function(e, param) {
        var t = param.slots, o = param.emit;
        var _m_ = (0, $aD8ZA.getCurrentInstance)(), _m__proxy = _m_.proxy, r = _m__proxy.$q, n = pe(e, r), i = (0, $aAzpa.ref)(e.modelValue !== null ? e.modelValue : e.defaultOpened), a = (0, $aAzpa.ref)(null), l = $n(), _Eo = Eo({
            showing: i
        }), s = _Eo.show, c = _Eo.hide, u = _Eo.toggle, v, f, d = (0, $aAzpa.computed)(function() {
            return "q-expansion-item q-item-type q-expansion-item--".concat(i.value === !0 ? "expanded" : "collapsed", " q-expansion-item--").concat(e.popup === !0 ? "popup" : "standard");
        }), m = (0, $aAzpa.computed)(function() {
            return e.contentInsetLevel === void 0 ? null : {
                ["padding" + (r.lang.rtl === !0 ? "Right" : "Left")]: e.contentInsetLevel * 56 + "px"
            };
        }), y = (0, $aAzpa.computed)(function() {
            return e.disable !== !0 && (e.href !== void 0 || e.to !== void 0 && e.to !== null && e.to !== "");
        }), p = (0, $aAzpa.computed)(function() {
            var w = {};
            return h_.forEach(function(H) {
                w[H] = e[H];
            }), w;
        }), C = (0, $aAzpa.computed)(function() {
            return y.value === !0 || e.expandIconToggle !== !0;
        }), b = (0, $aAzpa.computed)(function() {
            return e.expandedIcon !== void 0 && i.value === !0 ? e.expandedIcon : e.expandIcon || r.iconSet.expansionItem[e.denseToggle === !0 ? "denseIcon" : "icon"];
        }), h = (0, $aAzpa.computed)(function() {
            return e.disable !== !0 && (y.value === !0 || e.expandIconToggle === !0);
        }), g = (0, $aAzpa.computed)(function() {
            return {
                expanded: i.value === !0,
                detailsId: l.value,
                toggle: u,
                show: s,
                hide: c
            };
        }), S = (0, $aAzpa.computed)(function() {
            var w = e.toggleAriaLabel !== void 0 ? e.toggleAriaLabel : r.lang.label[i.value === !0 ? "collapse" : "expand"](e.label);
            return {
                role: "button",
                "aria-expanded": i.value === !0 ? "true" : "false",
                "aria-controls": l.value,
                "aria-label": w
            };
        });
        (0, $aD8ZA.watch)(function() {
            return e.group;
        }, function(w) {
            f !== void 0 && f(), w !== void 0 && B();
        });
        function P(w) {
            y.value !== !0 && u(w), o("click", w);
        }
        function $(w) {
            w.keyCode === 13 && L(w, !0);
        }
        function L(w, H) {
            H !== !0 && a.value !== null && a.value.focus(), u(w), Se(w);
        }
        function E() {
            o("afterShow");
        }
        function A() {
            o("afterHide");
        }
        function B() {
            v === void 0 && (v = An()), i.value === !0 && (Nr[e.group] = v);
            var w = (0, $aD8ZA.watch)(i, function(W) {
                W === !0 ? Nr[e.group] = v : Nr[e.group] === v && delete Nr[e.group];
            }), H = (0, $aD8ZA.watch)(function() {
                return Nr[e.group];
            }, function(W, ie) {
                ie === v && W !== void 0 && W !== v && c();
            });
            f = function() {
                w(), H(), Nr[e.group] === v && delete Nr[e.group], f = void 0;
            };
        }
        function q() {
            var w = {
                class: [
                    "q-focusable relative-position cursor-pointer".concat(e.denseToggle === !0 && e.switchToggleSide === !0 ? " items-end" : ""),
                    e.expandIconClass
                ],
                side: e.switchToggleSide !== !0,
                avatar: e.switchToggleSide
            }, H = [
                (0, $aD8ZA.h)(we, {
                    class: "q-expansion-item__toggle-icon" + (e.expandedIcon === void 0 && i.value === !0 ? " q-expansion-item__toggle-icon--rotated" : ""),
                    name: b.value
                })
            ];
            return h.value === !0 && (Object.assign(w, (0, $8typN._)((0, $8pZMQ._)({
                tabindex: 0
            }, S.value), {
                onClick: L,
                onKeyup: $
            })), H.unshift((0, $aD8ZA.h)("div", {
                ref: a,
                class: "q-expansion-item__toggle-focus q-icon q-focus-helper q-focus-helper--rounded",
                tabindex: -1
            }))), (0, $aD8ZA.h)(ho, w, function() {
                return H;
            });
        }
        function x() {
            var w;
            return t.header !== void 0 ? w = [].concat(t.header(g.value)) : (w = [
                (0, $aD8ZA.h)(ho, function() {
                    return [
                        (0, $aD8ZA.h)(Hr, {
                            lines: e.labelLines
                        }, function() {
                            return e.label || "";
                        }),
                        e.caption ? (0, $aD8ZA.h)(Hr, {
                            lines: e.captionLines,
                            caption: !0
                        }, function() {
                            return e.caption;
                        }) : null
                    ];
                })
            ], e.icon && w[e.switchToggleSide === !0 ? "push" : "unshift"]((0, $aD8ZA.h)(ho, {
                side: e.switchToggleSide === !0,
                avatar: e.switchToggleSide !== !0
            }, function() {
                return (0, $aD8ZA.h)(we, {
                    name: e.icon
                });
            }))), e.disable !== !0 && e.hideExpandIcon !== !0 && w[e.switchToggleSide === !0 ? "unshift" : "push"](q()), w;
        }
        function k() {
            var w = {
                ref: "item",
                style: e.headerStyle,
                class: e.headerClass,
                dark: n.value,
                disable: e.disable,
                dense: e.dense,
                insetLevel: e.headerInsetLevel
            };
            return C.value === !0 && (w.clickable = !0, w.onClick = P, Object.assign(w, y.value === !0 ? p.value : S.value)), (0, $aD8ZA.h)(hn, w, x);
        }
        function j() {
            return (0, $aD8ZA.withDirectives)((0, $aD8ZA.h)("div", {
                key: "e-content",
                class: "q-expansion-item__content relative-position",
                style: m.value,
                id: l.value
            }, J(t.default)), [
                [
                    (0, $iMtOP.vShow),
                    i.value
                ]
            ]);
        }
        function Q() {
            var w = [
                k(),
                (0, $aD8ZA.h)(sr, {
                    duration: e.duration,
                    onShow: E,
                    onHide: A
                }, j)
            ];
            return e.expandSeparator === !0 && w.push((0, $aD8ZA.h)(Co, {
                class: "q-expansion-item__border q-expansion-item__border--top absolute-top",
                dark: n.value
            }), (0, $aD8ZA.h)(Co, {
                class: "q-expansion-item__border q-expansion-item__border--bottom absolute-bottom",
                dark: n.value
            })), w;
        }
        return e.group !== void 0 && B(), (0, $aD8ZA.onBeforeUnmount)(function() {
            f !== void 0 && f();
        }), function() {
            return (0, $aD8ZA.h)("div", {
                class: d.value
            }, [
                (0, $aD8ZA.h)("div", {
                    class: "q-expansion-item__container relative-position"
                }, Q())
            ]);
        };
    }
});
var p_ = [
    "top",
    "right",
    "bottom",
    "left"
], Mu = {
    type: {
        type: String,
        default: "a"
    },
    outline: Boolean,
    push: Boolean,
    flat: Boolean,
    unelevated: Boolean,
    color: String,
    textColor: String,
    glossy: Boolean,
    square: Boolean,
    padding: String,
    label: {
        type: [
            String,
            Number
        ],
        default: ""
    },
    labelPosition: {
        type: String,
        default: "right",
        validator: function(e) {
            return p_.includes(e);
        }
    },
    externalLabel: Boolean,
    hideLabel: {
        type: Boolean
    },
    labelClass: [
        Array,
        String,
        Object
    ],
    labelStyle: [
        Array,
        String,
        Object
    ],
    disable: Boolean,
    tabindex: [
        Number,
        String
    ]
};
function Ru(e, t) {
    return {
        formClass: (0, $aAzpa.computed)(function() {
            return "q-fab--form-".concat(e.square === !0 ? "square" : "rounded");
        }),
        stacked: (0, $aAzpa.computed)(function() {
            return e.externalLabel === !1 && [
                "top",
                "bottom"
            ].includes(e.labelPosition);
        }),
        labelProps: (0, $aAzpa.computed)(function() {
            if (e.externalLabel === !0) {
                var o = e.hideLabel === null ? t.value === !1 : e.hideLabel;
                return {
                    action: "push",
                    data: {
                        class: [
                            e.labelClass,
                            "q-fab__label q-tooltip--style q-fab__label--external q-fab__label--external-".concat(e.labelPosition) + (o === !0 ? " q-fab__label--external-hidden" : "")
                        ],
                        style: e.labelStyle
                    }
                };
            }
            return {
                action: [
                    "left",
                    "top"
                ].includes(e.labelPosition) ? "unshift" : "push",
                data: {
                    class: [
                        e.labelClass,
                        "q-fab__label q-fab__label--internal q-fab__label--internal-".concat(e.labelPosition) + (e.hideLabel === !0 ? " q-fab__label--internal-hidden" : "")
                    ],
                    style: e.labelStyle
                }
            };
        })
    };
}
var S_ = [
    "up",
    "right",
    "down",
    "left"
], x_ = [
    "left",
    "center",
    "right"
], wv = R({
    name: "QFab",
    props: (0, $8typN._)((0, $8pZMQ._)({}, Mu, Ao), {
        icon: String,
        activeIcon: String,
        hideIcon: Boolean,
        hideLabel: {
            default: null
        },
        direction: {
            type: String,
            default: "right",
            validator: function(e) {
                return S_.includes(e);
            }
        },
        persistent: Boolean,
        verticalActionsAlign: {
            type: String,
            default: "center",
            validator: function(e) {
                return x_.includes(e);
            }
        }
    }),
    emits: $o,
    setup: function(e, param) {
        var t = param.slots;
        var o = (0, $aAzpa.ref)(null), r = (0, $aAzpa.ref)(e.modelValue === !0), n = $n(), _y_ = (0, $aD8ZA.getCurrentInstance)(), _y__proxy = _y_.proxy, i = _y__proxy.$q, _Ru = Ru(e, r), a = _Ru.formClass, l = _Ru.labelProps, s = (0, $aAzpa.computed)(function() {
            return e.persistent !== !0;
        }), _Eo = Eo({
            showing: r,
            hideOnRouteChange: s
        }), c = _Eo.hide, u = _Eo.toggle, v = (0, $aAzpa.computed)(function() {
            return {
                opened: r.value
            };
        }), f = (0, $aAzpa.computed)(function() {
            return "q-fab z-fab row inline justify-center q-fab--align-".concat(e.verticalActionsAlign, " ").concat(a.value) + (r.value === !0 ? " q-fab--opened" : " q-fab--closed");
        }), d = (0, $aAzpa.computed)(function() {
            return "q-fab__actions flex no-wrap inline q-fab__actions--".concat(e.direction, " q-fab__actions--").concat(r.value === !0 ? "opened" : "closed");
        }), m = (0, $aAzpa.computed)(function() {
            var b = {
                id: n.value,
                role: "menu"
            };
            return r.value !== !0 && (b["aria-hidden"] = "true"), b;
        }), y = (0, $aAzpa.computed)(function() {
            return "q-fab__icon-holder  q-fab__icon-holder--".concat(r.value === !0 ? "opened" : "closed");
        });
        function p(b, h) {
            var g = t[b], S = "q-fab__".concat(b, " absolute-full");
            return g === void 0 ? (0, $aD8ZA.h)(we, {
                class: S,
                name: e[h] || i.iconSet.fab[h]
            }) : (0, $aD8ZA.h)("div", {
                class: S
            }, g(v.value));
        }
        function C() {
            var b = [];
            return e.hideIcon !== !0 && b.push((0, $aD8ZA.h)("div", {
                class: y.value
            }, [
                p("icon", "icon"),
                p("active-icon", "activeIcon")
            ])), (e.label !== "" || t.label !== void 0) && b[l.value.action]((0, $aD8ZA.h)("div", l.value.data, t.label !== void 0 ? t.label(v.value) : [
                e.label
            ])), Ke(t.tooltip, b);
        }
        return (0, $aD8ZA.provide)(ql, {
            showing: r,
            onChildClick: function(b) {
                c(b), o.value !== null && o.value.$el.focus();
            }
        }), function() {
            return (0, $aD8ZA.h)("div", {
                class: f.value
            }, [
                (0, $aD8ZA.h)(Le, (0, $8typN._)((0, $8pZMQ._)({
                    ref: o,
                    class: a.value
                }, e), {
                    noWrap: !0,
                    stack: e.stacked,
                    align: void 0,
                    icon: void 0,
                    label: void 0,
                    noCaps: !0,
                    fab: !0,
                    "aria-expanded": r.value === !0 ? "true" : "false",
                    "aria-haspopup": "true",
                    "aria-controls": n.value,
                    onClick: u
                }), C),
                (0, $aD8ZA.h)("div", (0, $8pZMQ._)({
                    class: d.value
                }, m.value), J(t.default))
            ]);
        };
    }
});
var qv = {
    start: "self-end",
    center: "self-center",
    end: "self-start"
}, w_ = Object.keys(qv), Tv = R({
    name: "QFabAction",
    props: (0, $8typN._)((0, $8pZMQ._)({}, Mu), {
        icon: {
            type: String,
            default: ""
        },
        anchor: {
            type: String,
            validator: function(e) {
                return w_.includes(e);
            }
        },
        to: [
            String,
            Object
        ],
        replace: Boolean
    }),
    emits: [
        "click"
    ],
    setup: function(e, param) {
        var t = param.slots, o = param.emit;
        var r = (0, $aD8ZA.inject)(ql, function() {
            return {
                showing: {
                    value: !0
                },
                onChildClick: Qe
            };
        }), _Ru = Ru(e, r.showing), n = _Ru.formClass, i = _Ru.labelProps, a = (0, $aAzpa.computed)(function() {
            var v = qv[e.anchor];
            return n.value + (v !== void 0 ? " ".concat(v) : "");
        }), l = (0, $aAzpa.computed)(function() {
            return e.disable === !0 || r.showing.value !== !0;
        });
        function s(v) {
            r.onChildClick(v), o("click", v);
        }
        function c() {
            var v = [];
            return t.icon !== void 0 ? v.push(t.icon()) : e.icon !== "" && v.push((0, $aD8ZA.h)(we, {
                name: e.icon
            })), (e.label !== "" || t.label !== void 0) && v[i.value.action]((0, $aD8ZA.h)("div", i.value.data, t.label !== void 0 ? t.label() : [
                e.label
            ])), Ke(t.default, v);
        }
        var u = (0, $aD8ZA.getCurrentInstance)();
        return Object.assign(u.proxy, {
            click: s
        }), function() {
            return (0, $aD8ZA.h)(Le, (0, $8typN._)((0, $8pZMQ._)({
                class: a.value
            }, e), {
                noWrap: !0,
                stack: e.stacked,
                icon: void 0,
                label: void 0,
                noCaps: !0,
                fabMini: !0,
                disable: l.value,
                onClick: s
            }), c);
        };
    }
});
function Gc(param) {
    var e = param.validate, t = param.resetValidation, o = param.requiresQForm;
    var r = (0, $aD8ZA.inject)(Rn, !1);
    if (r !== !1) {
        var _T_ = (0, $aD8ZA.getCurrentInstance)(), n = _T_.props, i = _T_.proxy;
        Object.assign(i, {
            validate: e,
            resetValidation: t
        }), (0, $aD8ZA.watch)(function() {
            return n.disable;
        }, function(a) {
            a === !0 ? (typeof t == "function" && t(), r.unbindComponent(i)) : r.bindComponent(i);
        }), (0, $aD8ZA.onMounted)(function() {
            n.disable !== !0 && r.bindComponent(i);
        }), (0, $aD8ZA.onBeforeUnmount)(function() {
            n.disable !== !0 && r.unbindComponent(i);
        });
    } else o === !0 && console.error("Parent QForm not found on useFormChild()!");
}
var $_ = [
    !0,
    !1,
    "ondemand"
], Mv = {
    modelValue: {},
    error: {
        type: Boolean,
        default: null
    },
    errorMessage: String,
    noErrorIcon: Boolean,
    rules: Array,
    reactiveRules: Boolean,
    lazyRules: {
        type: [
            Boolean,
            String
        ],
        default: !1,
        validator: function(e) {
            return $_.includes(e);
        }
    }
};
function Rv(e, t) {
    var _A_ = (0, $aD8ZA.getCurrentInstance)(), o = _A_.props, r = _A_.proxy, n = (0, $aAzpa.ref)(!1), i = (0, $aAzpa.ref)(null), a = (0, $aAzpa.ref)(!1);
    Gc({
        validate: y,
        resetValidation: m
    });
    var l = 0, s, c = (0, $aAzpa.computed)(function() {
        return o.rules !== void 0 && o.rules !== null && o.rules.length !== 0;
    }), u = (0, $aAzpa.computed)(function() {
        return o.disable !== !0 && c.value === !0 && t.value === !1;
    }), v = (0, $aAzpa.computed)(function() {
        return o.error === !0 || n.value === !0;
    }), f = (0, $aAzpa.computed)(function() {
        return typeof o.errorMessage == "string" && o.errorMessage.length !== 0 ? o.errorMessage : i.value;
    });
    (0, $aD8ZA.watch)(function() {
        return o.modelValue;
    }, function() {
        a.value = !0, u.value === !0 && o.lazyRules === !1 && p();
    });
    function d() {
        o.lazyRules !== "ondemand" && u.value === !0 && a.value === !0 && p();
    }
    (0, $aD8ZA.watch)(function() {
        return o.reactiveRules;
    }, function(C) {
        C === !0 ? s === void 0 && (s = (0, $aD8ZA.watch)(function() {
            return o.rules;
        }, d, {
            immediate: !0,
            deep: !0
        })) : s !== void 0 && (s(), s = void 0);
    }, {
        immediate: !0
    }), (0, $aD8ZA.watch)(function() {
        return o.lazyRules;
    }, d), (0, $aD8ZA.watch)(e, function(C) {
        C === !0 ? a.value = !0 : u.value === !0 && o.lazyRules !== "ondemand" && p();
    });
    function m() {
        l++, t.value = !1, a.value = !1, n.value = !1, i.value = null, p.cancel();
    }
    function y() {
        var C = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : o.modelValue;
        if (o.disable === !0 || c.value === !1) return !0;
        var b = ++l, h = t.value !== !0 ? function() {
            a.value = !0;
        } : function() {}, g = function(P, $) {
            P === !0 && h(), n.value = P, i.value = $ || null, t.value = !1;
        }, S = [];
        for(var P = 0; P < o.rules.length; P++){
            var $ = o.rules[P], L = void 0;
            if (typeof $ == "function" ? L = $(C, Dr) : typeof $ == "string" && Dr[$] !== void 0 && (L = Dr[$](C)), L === !1 || typeof L == "string") return g(!0, L), !1;
            L !== !0 && L !== void 0 && S.push(L);
        }
        return S.length === 0 ? (g(!1), !0) : (t.value = !0, Promise.all(S).then(function(P) {
            if (P === void 0 || Array.isArray(P) === !1 || P.length === 0) return b === l && g(!1), !0;
            var $ = P.find(function(L) {
                return L === !1 || typeof L == "string";
            });
            return b === l && g($ !== void 0, $), $ === void 0;
        }, function(P) {
            return b === l && (console.error(P), g(!0)), !1;
        }));
    }
    var p = So(y, 0);
    return (0, $aD8ZA.onBeforeUnmount)(function() {
        s !== void 0 && s(), p.cancel();
    }), Object.assign(r, {
        resetValidation: m,
        validate: y
    }), it(r, "hasError", function() {
        return v.value;
    }), {
        isDirtyModel: a,
        hasRules: c,
        hasError: v,
        errorMessage: f,
        validate: y,
        resetValidation: m
    };
}
function pn(e) {
    return e != null && ("" + e).length !== 0;
}
var zn = (0, $8typN._)((0, $8pZMQ._)({}, he, Mv), {
    label: String,
    stackLabel: Boolean,
    hint: String,
    hideHint: Boolean,
    prefix: String,
    suffix: String,
    labelColor: String,
    color: String,
    bgColor: String,
    filled: Boolean,
    outlined: Boolean,
    borderless: Boolean,
    standout: [
        Boolean,
        String
    ],
    square: Boolean,
    loading: Boolean,
    labelSlot: Boolean,
    bottomSlots: Boolean,
    hideBottomSpace: Boolean,
    rounded: Boolean,
    dense: Boolean,
    itemAligned: Boolean,
    counter: Boolean,
    clearable: Boolean,
    clearIcon: String,
    disable: Boolean,
    readonly: Boolean,
    autofocus: Boolean,
    for: String,
    maxlength: [
        Number,
        String
    ]
}), cr = [
    "update:modelValue",
    "clear",
    "focus",
    "blur",
    "popupShow",
    "popupHide"
];
function dr() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, tmp = _ref.requiredForAttr, e = tmp === void 0 ? !0 : tmp, t = _ref.tagProp;
    var _Pv = (0, $aD8ZA.getCurrentInstance)(), o = _Pv.props, r = _Pv.proxy, n = pe(o, r.$q), i = $n({
        required: e,
        getValue: function() {
            return o.for;
        }
    });
    return {
        requiredForAttr: e,
        tag: t === !0 ? (0, $aAzpa.computed)(function() {
            return o.tag;
        }) : {
            value: "label"
        },
        isDark: n,
        editable: (0, $aAzpa.computed)(function() {
            return o.disable !== !0 && o.readonly !== !0;
        }),
        innerLoading: (0, $aAzpa.ref)(!1),
        focused: (0, $aAzpa.ref)(!1),
        hasPopupOpen: !1,
        splitAttrs: tl(),
        targetUid: i,
        rootRef: (0, $aAzpa.ref)(null),
        targetRef: (0, $aAzpa.ref)(null),
        controlRef: (0, $aAzpa.ref)(null)
    };
}
function fr(e) {
    var _Pv = (0, $aD8ZA.getCurrentInstance)(), t = _Pv.props, o = _Pv.emit, r = _Pv.slots, n = _Pv.attrs, i = _Pv.proxy, a = i.$q, l = null;
    e.hasValue === void 0 && (e.hasValue = (0, $aAzpa.computed)(function() {
        return pn(t.modelValue);
    })), e.emitValue === void 0 && (e.emitValue = function(w) {
        o("update:modelValue", w);
    }), e.controlEvents === void 0 && (e.controlEvents = {
        onFocusin: E,
        onFocusout: A
    }), Object.assign(e, {
        clearValue: B,
        onControlFocusin: E,
        onControlFocusout: A,
        focus: $
    }), e.computedCounter === void 0 && (e.computedCounter = (0, $aAzpa.computed)(function() {
        if (t.counter !== !1) {
            var w = typeof t.modelValue == "string" || typeof t.modelValue == "number" ? ("" + t.modelValue).length : Array.isArray(t.modelValue) === !0 ? t.modelValue.length : 0, H = t.maxlength !== void 0 ? t.maxlength : t.maxValues;
            return w + (H !== void 0 ? " / " + H : "");
        }
    }));
    var _Rv = Rv(e.focused, e.innerLoading), s = _Rv.isDirtyModel, c = _Rv.hasRules, u = _Rv.hasError, v = _Rv.errorMessage, f = _Rv.resetValidation, d = e.floatingLabel !== void 0 ? (0, $aAzpa.computed)(function() {
        return t.stackLabel === !0 || e.focused.value === !0 || e.floatingLabel.value === !0;
    }) : (0, $aAzpa.computed)(function() {
        return t.stackLabel === !0 || e.focused.value === !0 || e.hasValue.value === !0;
    }), m = (0, $aAzpa.computed)(function() {
        return t.bottomSlots === !0 || t.hint !== void 0 || c.value === !0 || t.counter === !0 || t.error !== null;
    }), y = (0, $aAzpa.computed)(function() {
        return t.filled === !0 ? "filled" : t.outlined === !0 ? "outlined" : t.borderless === !0 ? "borderless" : t.standout ? "standout" : "standard";
    }), p = (0, $aAzpa.computed)(function() {
        return "q-field row no-wrap items-start q-field--".concat(y.value) + (e.fieldClass !== void 0 ? " ".concat(e.fieldClass.value) : "") + (t.rounded === !0 ? " q-field--rounded" : "") + (t.square === !0 ? " q-field--square" : "") + (d.value === !0 ? " q-field--float" : "") + (b.value === !0 ? " q-field--labeled" : "") + (t.dense === !0 ? " q-field--dense" : "") + (t.itemAligned === !0 ? " q-field--item-aligned q-item-type" : "") + (e.isDark.value === !0 ? " q-field--dark" : "") + (e.getControl === void 0 ? " q-field--auto-height" : "") + (e.focused.value === !0 ? " q-field--focused" : "") + (u.value === !0 ? " q-field--error" : "") + (u.value === !0 || e.focused.value === !0 ? " q-field--highlighted" : "") + (t.hideBottomSpace !== !0 && m.value === !0 ? " q-field--with-bottom" : "") + (t.disable === !0 ? " q-field--disabled" : t.readonly === !0 ? " q-field--readonly" : "");
    }), C = (0, $aAzpa.computed)(function() {
        return "q-field__control relative-position row no-wrap" + (t.bgColor !== void 0 ? " bg-".concat(t.bgColor) : "") + (u.value === !0 ? " text-negative" : typeof t.standout == "string" && t.standout.length !== 0 && e.focused.value === !0 ? " ".concat(t.standout) : t.color !== void 0 ? " text-".concat(t.color) : "");
    }), b = (0, $aAzpa.computed)(function() {
        return t.labelSlot === !0 || t.label !== void 0;
    }), h = (0, $aAzpa.computed)(function() {
        return "q-field__label no-pointer-events absolute ellipsis" + (t.labelColor !== void 0 && u.value !== !0 ? " text-".concat(t.labelColor) : "");
    }), g = (0, $aAzpa.computed)(function() {
        return {
            id: e.targetUid.value,
            editable: e.editable.value,
            focused: e.focused.value,
            floatingLabel: d.value,
            modelValue: t.modelValue,
            emitValue: e.emitValue
        };
    }), S = (0, $aAzpa.computed)(function() {
        var w = {};
        return e.targetUid.value && (w.for = e.targetUid.value), t.disable === !0 && (w["aria-disabled"] = "true"), w;
    });
    function P() {
        var w = document.activeElement, H = e.targetRef !== void 0 && e.targetRef.value;
        H && (w === null || w.id !== e.targetUid.value) && (H.hasAttribute("tabindex") === !0 || (H = H.querySelector("[tabindex]")), H && H !== w && H.focus({
            preventScroll: !0
        }));
    }
    function $() {
        Bo(P);
    }
    function L() {
        If(P);
        var w = document.activeElement;
        w !== null && e.rootRef.value.contains(w) && w.blur();
    }
    function E(w) {
        l !== null && (clearTimeout(l), l = null), e.editable.value === !0 && e.focused.value === !1 && (e.focused.value = !0, o("focus", w));
    }
    function A(w, H) {
        l !== null && clearTimeout(l), l = setTimeout(function() {
            l = null, !(document.hasFocus() === !0 && (e.hasPopupOpen === !0 || e.controlRef === void 0 || e.controlRef.value === null || e.controlRef.value.contains(document.activeElement) !== !1)) && (e.focused.value === !0 && (e.focused.value = !1, o("blur", w)), H !== void 0 && H());
        });
    }
    function B(w) {
        Se(w), a.platform.is.mobile !== !0 ? (e.targetRef !== void 0 && e.targetRef.value || e.rootRef.value).focus() : e.rootRef.value.contains(document.activeElement) === !0 && document.activeElement.blur(), t.type === "file" && (e.inputRef.value.value = null), o("update:modelValue", null), o("clear", t.modelValue), (0, $aD8ZA.nextTick)(function() {
            var H = s.value;
            f(), s.value = H;
        });
    }
    function q() {
        var w = [];
        return r.prepend !== void 0 && w.push((0, $aD8ZA.h)("div", {
            class: "q-field__prepend q-field__marginal row no-wrap items-center",
            key: "prepend",
            onClick: ut
        }, r.prepend())), w.push((0, $aD8ZA.h)("div", {
            class: "q-field__control-container col relative-position row no-wrap q-anchor--skip"
        }, x())), u.value === !0 && t.noErrorIcon === !1 && w.push(j("error", [
            (0, $aD8ZA.h)(we, {
                name: a.iconSet.field.error,
                color: "negative"
            })
        ])), t.loading === !0 || e.innerLoading.value === !0 ? w.push(j("inner-loading-append", r.loading !== void 0 ? r.loading() : [
            (0, $aD8ZA.h)(xt, {
                color: t.color
            })
        ])) : t.clearable === !0 && e.hasValue.value === !0 && e.editable.value === !0 && w.push(j("inner-clearable-append", [
            (0, $aD8ZA.h)(we, {
                class: "q-field__focusable-action",
                tag: "button",
                name: t.clearIcon || a.iconSet.field.clear,
                tabindex: 0,
                type: "button",
                "aria-hidden": null,
                role: null,
                onClick: B
            })
        ])), r.append !== void 0 && w.push((0, $aD8ZA.h)("div", {
            class: "q-field__append q-field__marginal row no-wrap items-center",
            key: "append",
            onClick: ut
        }, r.append())), e.getInnerAppend !== void 0 && w.push(j("inner-append", e.getInnerAppend())), e.getControlChild !== void 0 && w.push(e.getControlChild()), w;
    }
    function x() {
        var w = [];
        return t.prefix !== void 0 && t.prefix !== null && w.push((0, $aD8ZA.h)("div", {
            class: "q-field__prefix no-pointer-events row items-center"
        }, t.prefix)), e.getShadowControl !== void 0 && e.hasShadow.value === !0 && w.push(e.getShadowControl()), e.getControl !== void 0 ? w.push(e.getControl()) : r.rawControl !== void 0 ? w.push(r.rawControl()) : r.control !== void 0 && w.push((0, $aD8ZA.h)("div", (0, $8typN._)((0, $8pZMQ._)({
            ref: e.targetRef,
            class: "q-field__native row",
            tabindex: -1
        }, e.splitAttrs.attributes.value), {
            "data-autofocus": t.autofocus === !0 || void 0
        }), r.control(g.value))), b.value === !0 && w.push((0, $aD8ZA.h)("div", {
            class: h.value
        }, J(r.label, t.label))), t.suffix !== void 0 && t.suffix !== null && w.push((0, $aD8ZA.h)("div", {
            class: "q-field__suffix no-pointer-events row items-center"
        }, t.suffix)), w.concat(J(r.default));
    }
    function k() {
        var w, H;
        u.value === !0 ? v.value !== null ? (w = [
            (0, $aD8ZA.h)("div", {
                role: "alert"
            }, v.value)
        ], H = "q--slot-error-".concat(v.value)) : (w = J(r.error), H = "q--slot-error") : (t.hideHint !== !0 || e.focused.value === !0) && (t.hint !== void 0 ? (w = [
            (0, $aD8ZA.h)("div", t.hint)
        ], H = "q--slot-hint-".concat(t.hint)) : (w = J(r.hint), H = "q--slot-hint"));
        var W = t.counter === !0 || r.counter !== void 0;
        if (t.hideBottomSpace === !0 && W === !1 && w === void 0) return;
        var ie = (0, $aD8ZA.h)("div", {
            key: H,
            class: "q-field__messages col"
        }, w);
        return (0, $aD8ZA.h)("div", {
            class: "q-field__bottom row items-start q-field__bottom--" + (t.hideBottomSpace !== !0 ? "animated" : "stale"),
            onClick: ut
        }, [
            t.hideBottomSpace === !0 ? ie : (0, $aD8ZA.h)((0, $iMtOP.Transition), {
                name: "q-transition--field-message"
            }, function() {
                return ie;
            }),
            W === !0 ? (0, $aD8ZA.h)("div", {
                class: "q-field__counter"
            }, r.counter !== void 0 ? r.counter() : e.computedCounter.value) : null
        ]);
    }
    function j(w, H) {
        return H === null ? null : (0, $aD8ZA.h)("div", {
            key: w,
            class: "q-field__append q-field__marginal row no-wrap items-center q-anchor--skip"
        }, H);
    }
    var Q = !1;
    return (0, $aD8ZA.onDeactivated)(function() {
        Q = !0;
    }), (0, $aD8ZA.onActivated)(function() {
        Q === !0 && t.autofocus === !0 && i.focus();
    }), t.autofocus === !0 && (0, $aD8ZA.onMounted)(function() {
        i.focus();
    }), (0, $aD8ZA.onBeforeUnmount)(function() {
        l !== null && clearTimeout(l);
    }), Object.assign(i, {
        focus: $,
        blur: L
    }), function() {
        var H = e.getControl === void 0 && r.control === void 0 ? (0, $8pZMQ._)((0, $8typN._)((0, $8pZMQ._)({}, e.splitAttrs.attributes.value), {
            "data-autofocus": t.autofocus === !0 || void 0
        }), S.value) : S.value;
        return (0, $aD8ZA.h)(e.tag.value, (0, $8pZMQ._)({
            ref: e.rootRef,
            class: [
                p.value,
                n.class
            ],
            style: n.style
        }, H), [
            r.before !== void 0 ? (0, $aD8ZA.h)("div", {
                class: "q-field__before q-field__marginal row no-wrap items-center",
                onClick: ut
            }, r.before()) : null,
            (0, $aD8ZA.h)("div", {
                class: "q-field__inner relative-position col self-stretch"
            }, [
                (0, $aD8ZA.h)("div", (0, $8pZMQ._)({
                    ref: e.controlRef,
                    class: C.value,
                    tabindex: -1
                }, e.controlEvents), q()),
                m.value === !0 ? k() : null
            ]),
            r.after !== void 0 ? (0, $aD8ZA.h)("div", {
                class: "q-field__after q-field__marginal row no-wrap items-center",
                onClick: ut
            }, r.after()) : null
        ]);
    };
}
var Au = R({
    name: "QField",
    inheritAttrs: !1,
    props: (0, $8typN._)((0, $8pZMQ._)({}, zn), {
        tag: {
            type: String,
            default: "label"
        }
    }),
    emits: cr,
    setup: function() {
        return fr(dr({
            requiredForAttr: !1,
            tagProp: !0
        }));
    }
});
function na(e, t, o, r) {
    var n = [];
    return e.forEach(function(i) {
        r(i) === !0 ? n.push(i) : t.push({
            failedPropValidation: o,
            file: i
        });
    }), n;
}
function $u(e) {
    e && e.dataTransfer && (e.dataTransfer.dropEffect = "copy"), Se(e);
}
var Eu = {
    multiple: Boolean,
    accept: String,
    capture: String,
    maxFileSize: [
        Number,
        String
    ],
    maxTotalSize: [
        Number,
        String
    ],
    maxFiles: [
        Number,
        String
    ],
    filter: Function
}, Bu = [
    "rejected"
];
function Lu(param) {
    var e = param.editable, t = param.dnd, o = param.getFileInput, r = param.addFilesToQueue;
    var _I_ = (0, $aD8ZA.getCurrentInstance)(), n = _I_.props, i = _I_.emit, a = _I_.proxy, l = (0, $aAzpa.ref)(null), s = (0, $aAzpa.computed)(function() {
        return n.accept !== void 0 ? n.accept.split(",").map(function(b) {
            return b = b.trim(), b === "*" ? "*/" : (b.endsWith("/*") && (b = b.slice(0, b.length - 1)), b.toUpperCase());
        }) : null;
    }), c = (0, $aAzpa.computed)(function() {
        return parseInt(n.maxFiles, 10);
    }), u = (0, $aAzpa.computed)(function() {
        return parseInt(n.maxTotalSize, 10);
    });
    function v(b) {
        if (e.value) {
            if (b !== Object(b) && (b = {
                target: null
            }), b.target !== null && b.target.matches('input[type="file"]') === !0) b.clientX === 0 && b.clientY === 0 && tt(b);
            else {
                var h = o();
                h && h !== b.target && h.click(b);
            }
        }
    }
    function f(b) {
        e.value && b && r(null, b);
    }
    function d(b, h, g, S) {
        var P = Array.from(h || b.target.files), $ = [], L = function() {
            $.length !== 0 && i("rejected", $);
        };
        if (n.accept !== void 0 && s.value.indexOf("*/") === -1 && (P = na(P, $, "accept", function(E) {
            return s.value.some(function(A) {
                return E.type.toUpperCase().startsWith(A) || E.name.toUpperCase().endsWith(A);
            });
        }), P.length === 0)) return L();
        if (n.maxFileSize !== void 0) {
            var E = parseInt(n.maxFileSize, 10);
            if (P = na(P, $, "max-file-size", function(A) {
                return A.size <= E;
            }), P.length === 0) return L();
        }
        if (n.multiple !== !0 && P.length !== 0 && (P = [
            P[0]
        ]), P.forEach(function(E) {
            E.__key = E.webkitRelativePath + E.lastModified + E.name + E.size;
        }), S === !0) {
            var E1 = g.map(function(A) {
                return A.__key;
            });
            P = na(P, $, "duplicate", function(A) {
                return E1.includes(A.__key) === !1;
            });
        }
        if (P.length === 0) return L();
        if (n.maxTotalSize !== void 0) {
            var E2 = S === !0 ? g.reduce(function(A, B) {
                return A + B.size;
            }, 0) : 0;
            if (P = na(P, $, "max-total-size", function(A) {
                return E2 += A.size, E2 <= u.value;
            }), P.length === 0) return L();
        }
        if (typeof n.filter == "function") {
            var E3 = n.filter(P);
            P = na(P, $, "filter", function(A) {
                return E3.includes(A);
            });
        }
        if (n.maxFiles !== void 0) {
            var E4 = S === !0 ? g.length : 0;
            if (P = na(P, $, "max-files", function() {
                return E4++, E4 <= c.value;
            }), P.length === 0) return L();
        }
        if (L(), P.length !== 0) return P;
    }
    function m(b) {
        $u(b), t.value !== !0 && (t.value = !0);
    }
    function y(b) {
        Se(b), (b.relatedTarget !== null || Ce.is.safari !== !0 ? b.relatedTarget !== l.value : document.elementsFromPoint(b.clientX, b.clientY).includes(l.value) === !1) === !0 && (t.value = !1);
    }
    function p(b) {
        $u(b);
        var h = b.dataTransfer.files;
        h.length !== 0 && r(null, h), t.value = !1;
    }
    function C(b) {
        if (t.value === !0) return (0, $aD8ZA.h)("div", {
            ref: l,
            class: "q-".concat(b, "__dnd absolute-full"),
            onDragenter: $u,
            onDragover: $u,
            onDragleave: y,
            onDrop: p
        });
    }
    return Object.assign(a, {
        pickFiles: v,
        addFiles: f
    }), {
        pickFiles: v,
        addFiles: f,
        onDragover: m,
        onDragleave: y,
        processFiles: d,
        getDndNode: C,
        maxFilesNumber: c,
        maxTotalSizeNumber: u
    };
}
function Fu(e, t) {
    function o() {
        var r = e.modelValue;
        try {
            var n = "DataTransfer" in window ? new DataTransfer : "ClipboardEvent" in window ? new ClipboardEvent("").clipboardData : void 0;
            return Object(r) === r && ("length" in r ? Array.from(r) : [
                r
            ]).forEach(function(i) {
                n.items.add(i);
            }), {
                files: n.files
            };
        } catch (e) {
            return {
                files: void 0
            };
        }
    }
    return t === !0 ? (0, $aAzpa.computed)(function() {
        if (e.type === "file") return o();
    }) : (0, $aAzpa.computed)(o);
}
var Ev = R({
    name: "QFile",
    inheritAttrs: !1,
    props: (0, $8typN._)((0, $8pZMQ._)({}, zn, _t, Eu), {
        modelValue: [
            File,
            FileList,
            Array
        ],
        append: Boolean,
        useChips: Boolean,
        displayValue: [
            String,
            Number
        ],
        tabindex: {
            type: [
                String,
                Number
            ],
            default: 0
        },
        counterLabel: Function,
        inputClass: [
            Array,
            String,
            Object
        ],
        inputStyle: [
            Array,
            String,
            Object
        ]
    }),
    emits: (0, $79xu7._)(cr).concat((0, $79xu7._)(Bu)),
    setup: function(e, param) {
        var t = param.slots, o = param.emit, r = param.attrs;
        var _H_ = (0, $aD8ZA.getCurrentInstance)(), n = _H_.proxy, i = dr(), a = (0, $aAzpa.ref)(null), l = (0, $aAzpa.ref)(!1), s = Ai(e), _Lu = Lu({
            editable: i.editable,
            dnd: l,
            getFileInput: q,
            addFilesToQueue: x
        }), c = _Lu.pickFiles, u = _Lu.onDragover, v = _Lu.onDragleave, f = _Lu.processFiles, d = _Lu.getDndNode, m = Fu(e), y = (0, $aAzpa.computed)(function() {
            return Object(e.modelValue) === e.modelValue ? "length" in e.modelValue ? Array.from(e.modelValue) : [
                e.modelValue
            ] : [];
        }), p = (0, $aAzpa.computed)(function() {
            return pn(y.value);
        }), C = (0, $aAzpa.computed)(function() {
            return y.value.map(function(w) {
                return w.name;
            }).join(", ");
        }), b = (0, $aAzpa.computed)(function() {
            return ri(y.value.reduce(function(w, H) {
                return w + H.size;
            }, 0));
        }), h = (0, $aAzpa.computed)(function() {
            return {
                totalSize: b.value,
                filesNumber: y.value.length,
                maxFiles: e.maxFiles
            };
        }), g = (0, $aAzpa.computed)(function() {
            return (0, $8typN._)((0, $8pZMQ._)({
                tabindex: -1,
                type: "file",
                title: "",
                accept: e.accept,
                capture: e.capture,
                name: s.value
            }, r), {
                id: i.targetUid.value,
                disabled: i.editable.value !== !0
            });
        }), S = (0, $aAzpa.computed)(function() {
            return "q-file q-field--auto-height" + (l.value === !0 ? " q-file--dnd" : "");
        }), P = (0, $aAzpa.computed)(function() {
            return e.multiple === !0 && e.append === !0;
        });
        function $(w) {
            var H = y.value.slice();
            H.splice(w, 1), E(H);
        }
        function L(w) {
            var H = y.value.indexOf(w);
            H !== -1 && $(H);
        }
        function E(w) {
            o("update:modelValue", e.multiple === !0 ? w : w[0]);
        }
        function A(w) {
            w.keyCode === 13 && ut(w);
        }
        function B(w) {
            (w.keyCode === 13 || w.keyCode === 32) && c(w);
        }
        function q() {
            return a.value;
        }
        function x(w, H) {
            var W = f(w, H, y.value, P.value), ie = q();
            ie != null && (ie.value = ""), W !== void 0 && ((e.multiple === !0 ? e.modelValue && W.every(function(V) {
                return y.value.includes(V);
            }) : e.modelValue === W[0]) || E(P.value === !0 ? y.value.concat(W) : W));
        }
        function k() {
            return [
                (0, $aD8ZA.h)("input", {
                    class: [
                        e.inputClass,
                        "q-file__filler"
                    ],
                    style: e.inputStyle
                })
            ];
        }
        function j() {
            var _this = this;
            if (t.file !== void 0) return y.value.length === 0 ? k() : y.value.map(function(H, W) {
                return t.file({
                    index: W,
                    file: H,
                    ref: _this
                });
            });
            if (t.selected !== void 0) return y.value.length === 0 ? k() : t.selected({
                files: y.value,
                ref: this
            });
            if (e.useChips === !0) return y.value.length === 0 ? k() : y.value.map(function(H, W) {
                return (0, $aD8ZA.h)(Ki, {
                    key: "file-" + W,
                    removable: i.editable.value,
                    dense: !0,
                    textColor: e.color,
                    tabindex: e.tabindex,
                    onRemove: function() {
                        $(W);
                    }
                }, function() {
                    return (0, $aD8ZA.h)("span", {
                        class: "ellipsis",
                        textContent: H.name
                    });
                });
            });
            var w = e.displayValue !== void 0 ? e.displayValue : C.value;
            return w.length !== 0 ? [
                (0, $aD8ZA.h)("div", {
                    class: e.inputClass,
                    style: e.inputStyle,
                    textContent: w
                })
            ] : k();
        }
        function Q() {
            var w = (0, $8typN._)((0, $8pZMQ._)({
                ref: a
            }, g.value, m.value), {
                class: "q-field__input fit absolute-full cursor-pointer",
                onChange: x
            });
            return e.multiple === !0 && (w.multiple = !0), (0, $aD8ZA.h)("input", w);
        }
        return Object.assign(i, {
            fieldClass: S,
            emitValue: E,
            hasValue: p,
            inputRef: a,
            innerValue: y,
            floatingLabel: (0, $aAzpa.computed)(function() {
                return p.value === !0 || pn(e.displayValue);
            }),
            computedCounter: (0, $aAzpa.computed)(function() {
                if (e.counterLabel !== void 0) return e.counterLabel(h.value);
                var w = e.maxFiles;
                return "".concat(y.value.length).concat(w !== void 0 ? " / " + w : "", " (").concat(b.value, ")");
            }),
            getControlChild: function() {
                return d("file");
            },
            getControl: function() {
                var w = {
                    ref: i.targetRef,
                    class: "q-field__native row items-center cursor-pointer",
                    tabindex: e.tabindex
                };
                return i.editable.value === !0 && Object.assign(w, {
                    onDragover: u,
                    onDragleave: v,
                    onKeydown: A,
                    onKeyup: B
                }), (0, $aD8ZA.h)("div", w, [
                    Q()
                ].concat(j()));
            }
        }), Object.assign(n, {
            removeAtIndex: $,
            removeFile: L,
            getNativeElement: function() {
                return a.value;
            }
        }), it(n, "nativeEl", function() {
            return a.value;
        }), fr(i);
    }
});
var Bv = R({
    name: "QFooter",
    props: {
        modelValue: {
            type: Boolean,
            default: !0
        },
        reveal: Boolean,
        bordered: Boolean,
        elevated: Boolean,
        heightHint: {
            type: [
                String,
                Number
            ],
            default: 50
        }
    },
    emits: [
        "reveal",
        "focusin"
    ],
    setup: function(e, param) {
        var t = param.slots, o = param.emit;
        var _j_ = (0, $aD8ZA.getCurrentInstance)(), _j__proxy = _j_.proxy, r = _j__proxy.$q, n = (0, $aD8ZA.inject)(co, Ye);
        if (n === Ye) return console.error("QFooter needs to be child of QLayout"), Ye;
        var i = (0, $aAzpa.ref)(parseInt(e.heightHint, 10)), a = (0, $aAzpa.ref)(!0), l = (0, $aAzpa.ref)(bt.value === !0 || n.isContainer.value === !0 ? 0 : window.innerHeight), s = (0, $aAzpa.computed)(function() {
            return e.reveal === !0 || n.view.value.indexOf("F") !== -1 || r.platform.is.ios && n.isContainer.value === !0;
        }), c = (0, $aAzpa.computed)(function() {
            return n.isContainer.value === !0 ? n.containerHeight.value : l.value;
        }), u = (0, $aAzpa.computed)(function() {
            if (e.modelValue !== !0) return 0;
            if (s.value === !0) return a.value === !0 ? i.value : 0;
            var S = n.scroll.value.position + c.value + i.value - n.height.value;
            return S > 0 ? S : 0;
        }), v = (0, $aAzpa.computed)(function() {
            return e.modelValue !== !0 || s.value === !0 && a.value !== !0;
        }), f = (0, $aAzpa.computed)(function() {
            return e.modelValue === !0 && v.value === !0 && e.reveal === !0;
        }), d = (0, $aAzpa.computed)(function() {
            return "q-footer q-layout__section--marginal " + (s.value === !0 ? "fixed" : "absolute") + "-bottom" + (e.bordered === !0 ? " q-footer--bordered" : "") + (v.value === !0 ? " q-footer--hidden" : "") + (e.modelValue !== !0 ? " q-layout--prevent-focus" + (s.value !== !0 ? " hidden" : "") : "");
        }), m = (0, $aAzpa.computed)(function() {
            var S = n.rows.value.bottom, P = {};
            return S[0] === "l" && n.left.space === !0 && (P[r.lang.rtl === !0 ? "right" : "left"] = "".concat(n.left.size, "px")), S[2] === "r" && n.right.space === !0 && (P[r.lang.rtl === !0 ? "left" : "right"] = "".concat(n.right.size, "px")), P;
        });
        function y(S, P) {
            n.update("footer", S, P);
        }
        function p(S, P) {
            S.value !== P && (S.value = P);
        }
        function C(param) {
            var S = param.height;
            p(i, S), y("size", S);
        }
        function b() {
            if (e.reveal !== !0) return;
            var _n_scroll_value = n.scroll.value, S = _n_scroll_value.direction, P = _n_scroll_value.position, $ = _n_scroll_value.inflectionPoint;
            p(a, S === "up" || P - $ < 100 || n.height.value - c.value - P - i.value < 300);
        }
        function h(S) {
            f.value === !0 && p(a, !0), o("focusin", S);
        }
        (0, $aD8ZA.watch)(function() {
            return e.modelValue;
        }, function(S) {
            y("space", S), p(a, !0), n.animate();
        }), (0, $aD8ZA.watch)(u, function(S) {
            y("offset", S);
        }), (0, $aD8ZA.watch)(function() {
            return e.reveal;
        }, function(S) {
            S === !1 && p(a, e.modelValue);
        }), (0, $aD8ZA.watch)(a, function(S) {
            n.animate(), o("reveal", S);
        }), (0, $aD8ZA.watch)([
            i,
            n.scroll,
            n.height
        ], b), (0, $aD8ZA.watch)(function() {
            return r.screen.height;
        }, function(S) {
            n.isContainer.value !== !0 && p(l, S);
        });
        var g = {};
        return n.instances.footer = g, e.modelValue === !0 && y("size", i.value), y("space", e.modelValue), y("offset", u.value), (0, $aD8ZA.onBeforeUnmount)(function() {
            n.instances.footer === g && (n.instances.footer = void 0, y("size", 0), y("offset", 0), y("space", !1));
        }), function() {
            var S = Ke(t.default, [
                (0, $aD8ZA.h)(go, {
                    debounce: 0,
                    onResize: C
                })
            ]);
            return e.elevated === !0 && S.push((0, $aD8ZA.h)("div", {
                class: "q-layout__shadow absolute-full overflow-hidden no-pointer-events"
            })), (0, $aD8ZA.h)("footer", {
                class: d.value,
                style: m.value,
                onFocusin: h
            }, S);
        };
    }
});
var Lv = R({
    name: "QForm",
    props: {
        autofocus: Boolean,
        noErrorFocus: Boolean,
        noResetFocus: Boolean,
        greedy: Boolean,
        onSubmit: Function
    },
    emits: [
        "reset",
        "validationSuccess",
        "validationError"
    ],
    setup: function(e, param) {
        var t = param.slots, o = param.emit;
        var r = (0, $aD8ZA.getCurrentInstance)(), n = (0, $aAzpa.ref)(null), i = 0, a = [];
        function l(d) {
            var m = typeof d == "boolean" ? d : e.noErrorFocus !== !0, y = ++i, p = function(h, g) {
                o("validation" + (h === !0 ? "Success" : "Error"), g);
            }, C = function(h) {
                var g = h.validate();
                return typeof g.then == "function" ? g.then(function(S) {
                    return {
                        valid: S,
                        comp: h
                    };
                }, function(S) {
                    return {
                        valid: !1,
                        comp: h,
                        err: S
                    };
                }) : Promise.resolve({
                    valid: g,
                    comp: h
                });
            };
            return (e.greedy === !0 ? Promise.all(a.map(C)).then(function(h) {
                return h.filter(function(g) {
                    return g.valid !== !0;
                });
            }) : a.reduce(function(h, g) {
                return h.then(function() {
                    return C(g).then(function(S) {
                        if (S.valid === !1) return Promise.reject(S);
                    });
                });
            }, Promise.resolve()).catch(function(h) {
                return [
                    h
                ];
            })).then(function(h) {
                if (h === void 0 || h.length === 0) return y === i && p(!0), !0;
                if (y === i) {
                    var _h_ = h[0], g = _h_.comp, S = _h_.err;
                    if (S !== void 0 && console.error(S), p(!1, g), m === !0) {
                        var P = h.find(function(param) {
                            var $ = param.comp;
                            return typeof $.focus == "function" && Jt($.$) === !1;
                        });
                        P !== void 0 && P.comp.focus();
                    }
                }
                return !1;
            });
        }
        function s() {
            i++, a.forEach(function(d) {
                typeof d.resetValidation == "function" && d.resetValidation();
            });
        }
        function c(d) {
            d !== void 0 && Se(d);
            var m = i + 1;
            l().then(function(y) {
                m === i && y === !0 && (e.onSubmit !== void 0 ? o("submit", d) : d !== void 0 && d.target !== void 0 && typeof d.target.submit == "function" && d.target.submit());
            });
        }
        function u(d) {
            d !== void 0 && Se(d), o("reset"), (0, $aD8ZA.nextTick)(function() {
                s(), e.autofocus === !0 && e.noResetFocus !== !0 && v();
            });
        }
        function v() {
            Bo(function() {
                if (n.value === null) return;
                var d = n.value.querySelector("[autofocus][tabindex], [data-autofocus][tabindex]") || n.value.querySelector("[autofocus] [tabindex], [data-autofocus] [tabindex]") || n.value.querySelector("[autofocus], [data-autofocus]") || Array.prototype.find.call(n.value.querySelectorAll("[tabindex]"), function(m) {
                    return m.tabIndex !== -1;
                });
                d === null || d === void 0 ? void 0 : d.focus({
                    preventScroll: !0
                });
            });
        }
        (0, $aD8ZA.provide)(Rn, {
            bindComponent: function(d) {
                a.push(d);
            },
            unbindComponent: function(d) {
                var m = a.indexOf(d);
                m !== -1 && a.splice(m, 1);
            }
        });
        var f = !1;
        return (0, $aD8ZA.onDeactivated)(function() {
            f = !0;
        }), (0, $aD8ZA.onActivated)(function() {
            f === !0 && e.autofocus === !0 && v();
        }), (0, $aD8ZA.onMounted)(function() {
            e.autofocus === !0 && v();
        }), Object.assign(r.proxy, {
            validate: l,
            resetValidation: s,
            submit: c,
            reset: u,
            focus: v,
            getValidationComponents: function() {
                return a;
            }
        }), function() {
            return (0, $aD8ZA.h)("form", {
                class: "q-form",
                ref: n,
                onSubmit: c,
                onReset: u
            }, J(t.default));
        };
    }
});
var Fv = {
    inject: {
        [Rn]: {
            default: Qe
        }
    },
    watch: {
        disable: function(e) {
            var t = this.$.provides[Rn];
            t !== void 0 && (e === !0 ? (this.resetValidation(), t.unbindComponent(this)) : t.bindComponent(this));
        }
    },
    methods: {
        validate: function() {},
        resetValidation: function() {}
    },
    mounted: function() {
        var e = this.$.provides[Rn];
        e !== void 0 && this.disable !== !0 && e.bindComponent(this);
    },
    beforeUnmount: function() {
        var e = this.$.provides[Rn];
        e !== void 0 && this.disable !== !0 && e.unbindComponent(this);
    }
};
var Vv = R({
    name: "QHeader",
    props: {
        modelValue: {
            type: Boolean,
            default: !0
        },
        reveal: Boolean,
        revealOffset: {
            type: Number,
            default: 250
        },
        bordered: Boolean,
        elevated: Boolean,
        heightHint: {
            type: [
                String,
                Number
            ],
            default: 50
        }
    },
    emits: [
        "reveal",
        "focusin"
    ],
    setup: function(e, param) {
        var t = param.slots, o = param.emit;
        var _o1 = (0, $aD8ZA.getCurrentInstance)(), _o1_proxy = _o1.proxy, r = _o1_proxy.$q, n = (0, $aD8ZA.inject)(co, Ye);
        if (n === Ye) return console.error("QHeader needs to be child of QLayout"), Ye;
        var i = (0, $aAzpa.ref)(parseInt(e.heightHint, 10)), a = (0, $aAzpa.ref)(!0), l = (0, $aAzpa.computed)(function() {
            return e.reveal === !0 || n.view.value.indexOf("H") !== -1 || r.platform.is.ios && n.isContainer.value === !0;
        }), s = (0, $aAzpa.computed)(function() {
            if (e.modelValue !== !0) return 0;
            if (l.value === !0) return a.value === !0 ? i.value : 0;
            var b = i.value - n.scroll.value.position;
            return b > 0 ? b : 0;
        }), c = (0, $aAzpa.computed)(function() {
            return e.modelValue !== !0 || l.value === !0 && a.value !== !0;
        }), u = (0, $aAzpa.computed)(function() {
            return e.modelValue === !0 && c.value === !0 && e.reveal === !0;
        }), v = (0, $aAzpa.computed)(function() {
            return "q-header q-layout__section--marginal " + (l.value === !0 ? "fixed" : "absolute") + "-top" + (e.bordered === !0 ? " q-header--bordered" : "") + (c.value === !0 ? " q-header--hidden" : "") + (e.modelValue !== !0 ? " q-layout--prevent-focus" : "");
        }), f = (0, $aAzpa.computed)(function() {
            var b = n.rows.value.top, h = {};
            return b[0] === "l" && n.left.space === !0 && (h[r.lang.rtl === !0 ? "right" : "left"] = "".concat(n.left.size, "px")), b[2] === "r" && n.right.space === !0 && (h[r.lang.rtl === !0 ? "left" : "right"] = "".concat(n.right.size, "px")), h;
        });
        function d(b, h) {
            n.update("header", b, h);
        }
        function m(b, h) {
            b.value !== h && (b.value = h);
        }
        function y(param) {
            var b = param.height;
            m(i, b), d("size", b);
        }
        function p(b) {
            u.value === !0 && m(a, !0), o("focusin", b);
        }
        (0, $aD8ZA.watch)(function() {
            return e.modelValue;
        }, function(b) {
            d("space", b), m(a, !0), n.animate();
        }), (0, $aD8ZA.watch)(s, function(b) {
            d("offset", b);
        }), (0, $aD8ZA.watch)(function() {
            return e.reveal;
        }, function(b) {
            b === !1 && m(a, e.modelValue);
        }), (0, $aD8ZA.watch)(a, function(b) {
            n.animate(), o("reveal", b);
        }), (0, $aD8ZA.watch)(n.scroll, function(b) {
            e.reveal === !0 && m(a, b.direction === "up" || b.position <= e.revealOffset || b.position - b.inflectionPoint < 100);
        });
        var C = {};
        return n.instances.header = C, e.modelValue === !0 && d("size", i.value), d("space", e.modelValue), d("offset", s.value), (0, $aD8ZA.onBeforeUnmount)(function() {
            n.instances.header === C && (n.instances.header = void 0, d("size", 0), d("offset", 0), d("space", !1));
        }), function() {
            var b = tn(t.default, []);
            return e.elevated === !0 && b.push((0, $aD8ZA.h)("div", {
                class: "q-layout__shadow absolute-full overflow-hidden no-pointer-events"
            })), b.push((0, $aD8ZA.h)(go, {
                debounce: 0,
                onResize: y
            })), (0, $aD8ZA.h)("header", {
                class: v.value,
                style: f.value,
                onFocusin: p
            }, b);
        };
    }
});
var la = {
    ratio: [
        String,
        Number
    ]
};
function ua(e, t) {
    return (0, $aAzpa.computed)(function() {
        var o = Number(e.ratio || (t !== void 0 ? t.value : void 0));
        return isNaN(o) !== !0 && o > 0 ? {
            paddingBottom: "".concat(100 / o, "%")
        } : null;
    });
}
var u1 = 1.7778, zv = R({
    name: "QImg",
    props: (0, $8typN._)((0, $8pZMQ._)({}, la), {
        src: String,
        srcset: String,
        sizes: String,
        alt: String,
        crossorigin: String,
        decoding: String,
        referrerpolicy: String,
        draggable: Boolean,
        loading: {
            type: String,
            default: "lazy"
        },
        loadingShowDelay: {
            type: [
                Number,
                String
            ],
            default: 0
        },
        fetchpriority: {
            type: String,
            default: "auto"
        },
        width: String,
        height: String,
        initialRatio: {
            type: [
                Number,
                String
            ],
            default: u1
        },
        placeholderSrc: String,
        errorSrc: String,
        fit: {
            type: String,
            default: "cover"
        },
        position: {
            type: String,
            default: "50% 50%"
        },
        imgClass: String,
        imgStyle: Object,
        noSpinner: Boolean,
        noNativeMenu: Boolean,
        noTransition: Boolean,
        spinnerColor: String,
        spinnerSize: String
    }),
    emits: [
        "load",
        "error"
    ],
    setup: function(e, param) {
        var t = param.slots, o = param.emit;
        var r = (0, $aAzpa.ref)(e.initialRatio), n = ua(e, r), i = (0, $aD8ZA.getCurrentInstance)(), _io = io(), a = _io.registerTimeout, l = _io.removeTimeout, _io1 = io(), s = _io1.registerTimeout, c = _io1.removeTimeout, u = (0, $aAzpa.computed)(function() {
            return e.placeholderSrc !== void 0 ? {
                src: e.placeholderSrc
            } : null;
        }), v = (0, $aAzpa.computed)(function() {
            return e.errorSrc !== void 0 ? {
                src: e.errorSrc,
                __qerror: !0
            } : null;
        }), f = [
            (0, $aAzpa.ref)(null),
            (0, $aAzpa.ref)(u.value)
        ], d = (0, $aAzpa.ref)(0), m = (0, $aAzpa.ref)(!1), y = (0, $aAzpa.ref)(!1), p = (0, $aAzpa.computed)(function() {
            return "q-img q-img--".concat(e.noNativeMenu === !0 ? "no-" : "", "menu");
        }), C = (0, $aAzpa.computed)(function() {
            return {
                width: e.width,
                height: e.height
            };
        }), b = (0, $aAzpa.computed)(function() {
            return "q-img__image ".concat(e.imgClass !== void 0 ? e.imgClass + " " : "", "q-img__image--with").concat(e.noTransition === !0 ? "out" : "", "-transition q-img__image--");
        }), h = (0, $aAzpa.computed)(function() {
            return (0, $8typN._)((0, $8pZMQ._)({}, e.imgStyle), {
                objectFit: e.fit,
                objectPosition: e.position
            });
        });
        function g() {
            if (c(), e.loadingShowDelay === 0) {
                m.value = !0;
                return;
            }
            s(function() {
                m.value = !0;
            }, e.loadingShowDelay);
        }
        function S() {
            c(), m.value = !1;
        }
        function P(param) {
            var q = param.target;
            Jt(i) === !1 && (l(), r.value = q.naturalHeight === 0 ? .5 : q.naturalWidth / q.naturalHeight, $(q, 1));
        }
        function $(q, x) {
            x === 1e3 || Jt(i) === !0 || (q.complete === !0 ? L(q) : a(function() {
                $(q, x + 1);
            }, 50));
        }
        function L(q) {
            Jt(i) !== !0 && (d.value = d.value ^ 1, f[d.value].value = null, S(), q.getAttribute("__qerror") !== "true" && (y.value = !1), o("load", q.currentSrc || q.src));
        }
        function E(q) {
            l(), S(), y.value = !0, f[d.value].value = v.value, f[d.value ^ 1].value = u.value, o("error", q);
        }
        function A(q) {
            var x = f[q].value, k = (0, $8pZMQ._)({
                key: "img_" + q,
                class: b.value,
                style: h.value,
                alt: e.alt,
                crossorigin: e.crossorigin,
                decoding: e.decoding,
                referrerpolicy: e.referrerpolicy,
                height: e.height,
                width: e.width,
                loading: e.loading,
                fetchpriority: e.fetchpriority,
                "aria-hidden": "true",
                draggable: e.draggable
            }, x);
            return d.value === q ? Object.assign(k, {
                class: k.class + "current",
                onLoad: P,
                onError: E
            }) : k.class += "loaded", (0, $aD8ZA.h)("div", {
                class: "q-img__container absolute-full",
                key: "img" + q
            }, (0, $aD8ZA.h)("img", k));
        }
        function B() {
            return m.value === !1 ? (0, $aD8ZA.h)("div", {
                key: "content",
                class: "q-img__content absolute-full q-anchor--skip"
            }, J(t[y.value === !0 ? "error" : "default"])) : (0, $aD8ZA.h)("div", {
                key: "loading",
                class: "q-img__loading absolute-full flex flex-center"
            }, t.loading !== void 0 ? t.loading() : e.noSpinner === !0 ? void 0 : [
                (0, $aD8ZA.h)(xt, {
                    color: e.spinnerColor,
                    size: e.spinnerSize
                })
            ]);
        }
        {
            var q = function q() {
                (0, $aD8ZA.watch)(function() {
                    return e.src || e.srcset || e.sizes ? {
                        src: e.src,
                        srcset: e.srcset,
                        sizes: e.sizes
                    } : null;
                }, function(x) {
                    l(), y.value = !1, x === null ? (S(), f[d.value ^ 1].value = u.value) : g(), f[d.value].value = x;
                }, {
                    immediate: !0
                });
            };
            bt.value === !0 ? (0, $aD8ZA.onMounted)(q) : q();
        }
        return function() {
            var q = [];
            return n.value !== null && q.push((0, $aD8ZA.h)("div", {
                key: "filler",
                style: n.value
            })), f[0].value !== null && q.push(A(0)), f[1].value !== null && q.push(A(1)), q.push((0, $aD8ZA.h)((0, $iMtOP.Transition), {
                name: "q-transition--fade"
            }, B)), (0, $aD8ZA.h)("div", {
                key: "main",
                class: p.value,
                style: C.value,
                role: "img",
                "aria-label": e.alt
            }, q);
        };
    }
});
var Ur = Xe.passive, Nv = R({
    name: "QInfiniteScroll",
    props: {
        offset: {
            type: Number,
            default: 500
        },
        debounce: {
            type: [
                String,
                Number
            ],
            default: 100
        },
        scrollTarget: {
            default: void 0
        },
        initialIndex: Number,
        disable: Boolean,
        reverse: Boolean
    },
    emits: [
        "load"
    ],
    setup: function(e, param) {
        var t = param.slots, o = param.emit;
        var r = (0, $aAzpa.ref)(!1), n = (0, $aAzpa.ref)(!0), i = (0, $aAzpa.ref)(null), a = (0, $aAzpa.ref)(null), l = e.initialIndex || 0, s, c, u = (0, $aAzpa.computed)(function() {
            return "q-infinite-scroll__loading" + (r.value === !0 ? "" : " invisible");
        });
        function v() {
            if (e.disable === !0 || r.value === !0 || n.value === !1) return;
            var $ = xi(s), L = fo(s), E = nn(s);
            e.reverse === !1 ? Math.round(L + E + e.offset) >= Math.round($) && f() : Math.round(L) <= e.offset && f();
        }
        function f() {
            if (e.disable === !0 || r.value === !0 || n.value === !1) return;
            l++, r.value = !0;
            var $ = xi(s);
            o("load", l, function(L) {
                n.value === !0 && (r.value = !1, (0, $aD8ZA.nextTick)(function() {
                    if (e.reverse === !0) {
                        var E = xi(s), A = fo(s), B = E - $;
                        un(s, A + B);
                    }
                    L === !0 ? y() : i.value && i.value.closest("body") && c();
                }));
            });
        }
        function d() {
            l = 0;
        }
        function m() {
            n.value === !1 && (n.value = !0, s.addEventListener("scroll", c, Ur)), v();
        }
        function y() {
            n.value === !0 && (n.value = !1, r.value = !1, s.removeEventListener("scroll", c, Ur), c !== void 0 && c.cancel !== void 0 && c.cancel());
        }
        function p() {
            if (s && n.value === !0 && s.removeEventListener("scroll", c, Ur), s = At(i.value, e.scrollTarget), n.value === !0) {
                if (s.addEventListener("scroll", c, Ur), e.reverse === !0) {
                    var $ = xi(s), L = nn(s);
                    un(s, $ - L);
                }
                v();
            }
        }
        function C($) {
            l = $;
        }
        function b($) {
            $ = parseInt($, 10);
            var L = c;
            c = $ <= 0 ? v : So(v, isNaN($) === !0 ? 100 : $), s && n.value === !0 && (L !== void 0 && s.removeEventListener("scroll", L, Ur), s.addEventListener("scroll", c, Ur));
        }
        function h($) {
            if (g.value === !0) {
                if (a.value === null) {
                    $ !== !0 && (0, $aD8ZA.nextTick)(function() {
                        h(!0);
                    });
                    return;
                }
                var L = "".concat(r.value === !0 ? "un" : "", "pauseAnimations");
                Array.from(a.value.getElementsByTagName("svg")).forEach(function(E) {
                    E[L]();
                });
            }
        }
        var g = (0, $aAzpa.computed)(function() {
            return e.disable !== !0 && n.value === !0;
        });
        (0, $aD8ZA.watch)([
            r,
            g
        ], function() {
            h();
        }), (0, $aD8ZA.watch)(function() {
            return e.disable;
        }, function($) {
            $ === !0 ? y() : m();
        }), (0, $aD8ZA.watch)(function() {
            return e.reverse;
        }, function() {
            r.value === !1 && n.value === !0 && v();
        }), (0, $aD8ZA.watch)(function() {
            return e.scrollTarget;
        }, p), (0, $aD8ZA.watch)(function() {
            return e.debounce;
        }, b);
        var S = !1;
        (0, $aD8ZA.onActivated)(function() {
            S !== !1 && s && un(s, S);
        }), (0, $aD8ZA.onDeactivated)(function() {
            S = s ? fo(s) : !1;
        }), (0, $aD8ZA.onBeforeUnmount)(function() {
            n.value === !0 && s.removeEventListener("scroll", c, Ur);
        }), (0, $aD8ZA.onMounted)(function() {
            b(e.debounce), p(), r.value === !1 && h();
        });
        var P = (0, $aD8ZA.getCurrentInstance)();
        return Object.assign(P.proxy, {
            poll: function() {
                c !== void 0 && c();
            },
            trigger: f,
            stop: y,
            reset: d,
            resume: m,
            setIndex: C,
            updateScrollTarget: p
        }), function() {
            var $ = tn(t.default, []);
            return g.value === !0 && $[e.reverse === !1 ? "push" : "unshift"]((0, $aD8ZA.h)("div", {
                ref: a,
                class: u.value
            }, J(t.loading))), (0, $aD8ZA.h)("div", {
                class: "q-infinite-scroll",
                ref: i
            }, $);
        };
    }
});
var jv = R({
    name: "QInnerLoading",
    props: (0, $8typN._)((0, $8pZMQ._)({}, he, ln), {
        showing: Boolean,
        color: String,
        size: {
            type: [
                String,
                Number
            ],
            default: 42
        },
        label: String,
        labelClass: String,
        labelStyle: [
            String,
            Array,
            Object
        ]
    }),
    setup: function(e, param) {
        var t = param.slots;
        var o = (0, $aD8ZA.getCurrentInstance)(), r = pe(e, o.proxy.$q), _Jn = Jn(e), n = _Jn.transitionProps, i = _Jn.transitionStyle, a = (0, $aAzpa.computed)(function() {
            return "q-inner-loading q--avoid-card-border absolute-full column flex-center" + (r.value === !0 ? " q-inner-loading--dark" : "");
        }), l = (0, $aAzpa.computed)(function() {
            return "q-inner-loading__label" + (e.labelClass !== void 0 ? " ".concat(e.labelClass) : "");
        });
        function s() {
            var u = [
                (0, $aD8ZA.h)(xt, {
                    size: e.size,
                    color: e.color
                })
            ];
            return e.label !== void 0 && u.push((0, $aD8ZA.h)("div", {
                class: l.value,
                style: e.labelStyle
            }, [
                e.label
            ])), u;
        }
        function c() {
            return e.showing === !0 ? (0, $aD8ZA.h)("div", {
                class: a.value,
                style: i.value
            }, t.default !== void 0 ? t.default() : s()) : null;
        }
        return function() {
            return (0, $aD8ZA.h)((0, $iMtOP.Transition), n.value, c);
        };
    }
});
var Kv = {
    date: "####/##/##",
    datetime: "####/##/## ##:##",
    time: "##:##",
    fulltime: "##:##:##",
    phone: "(###) ### - ####",
    card: "#### #### #### ####"
}, Ou = {
    "#": {
        pattern: "[\\d]",
        negate: "[^\\d]"
    },
    S: {
        pattern: "[a-zA-Z]",
        negate: "[^a-zA-Z]"
    },
    N: {
        pattern: "[0-9a-zA-Z]",
        negate: "[^0-9a-zA-Z]"
    },
    A: {
        pattern: "[a-zA-Z]",
        negate: "[^a-zA-Z]",
        transform: function(e) {
            return e.toLocaleUpperCase();
        }
    },
    a: {
        pattern: "[a-zA-Z]",
        negate: "[^a-zA-Z]",
        transform: function(e) {
            return e.toLocaleLowerCase();
        }
    },
    X: {
        pattern: "[0-9a-zA-Z]",
        negate: "[^0-9a-zA-Z]",
        transform: function(e) {
            return e.toLocaleUpperCase();
        }
    },
    x: {
        pattern: "[0-9a-zA-Z]",
        negate: "[^0-9a-zA-Z]",
        transform: function(e) {
            return e.toLocaleLowerCase();
        }
    }
}, Yv = Object.keys(Ou);
Yv.forEach(function(e) {
    Ou[e].regex = new RegExp(Ou[e].pattern);
});
var p1 = new RegExp("\\\\([^.*+?^${}()|([\\]])|([.*+?^${}()|[\\]])|([" + Yv.join("") + "])|(.)", "g"), Wv = /[.*+?^${}()|[\]\\]/g, Bt = "\x01", Xv = {
    mask: String,
    reverseFillMask: Boolean,
    fillMask: [
        Boolean,
        String
    ],
    unmaskedValue: Boolean
};
function Gv(e, t, o, r) {
    var n, i, a, l, s, c, u = (0, $aAzpa.ref)(null), v = (0, $aAzpa.ref)(d());
    function f() {
        return e.autogrow === !0 || [
            "textarea",
            "text",
            "search",
            "url",
            "tel",
            "password"
        ].includes(e.type);
    }
    (0, $aD8ZA.watch)(function() {
        return e.type + e.autogrow;
    }, y), (0, $aD8ZA.watch)(function() {
        return e.mask;
    }, function(E) {
        if (E !== void 0) p(v.value, !0);
        else {
            var A = $(v.value);
            y(), e.modelValue !== A && t("update:modelValue", A);
        }
    }), (0, $aD8ZA.watch)(function() {
        return e.fillMask + e.reverseFillMask;
    }, function() {
        u.value === !0 && p(v.value, !0);
    }), (0, $aD8ZA.watch)(function() {
        return e.unmaskedValue;
    }, function() {
        u.value === !0 && p(v.value);
    });
    function d() {
        if (y(), u.value === !0) {
            var E = S($(e.modelValue));
            return e.fillMask !== !1 ? L(E) : E;
        }
        return e.modelValue;
    }
    function m(E) {
        if (E < n.length) return n.slice(-E);
        var A = "", B = n, q = B.indexOf(Bt);
        if (q !== -1) {
            for(var x = E - B.length; x > 0; x--)A += Bt;
            B = B.slice(0, q) + A + B.slice(q);
        }
        return B;
    }
    function y() {
        if (u.value = e.mask !== void 0 && e.mask.length !== 0 && f(), u.value === !1) {
            l = void 0, n = "", i = "";
            return;
        }
        var E = Kv[e.mask] === void 0 ? e.mask : Kv[e.mask], A = typeof e.fillMask == "string" && e.fillMask.length !== 0 ? e.fillMask.slice(0, 1) : "_", B = A.replace(Wv, "\\$&"), q = [], x = [], k = [], j = e.reverseFillMask === !0, Q = "", w = "";
        E.replace(p1, function(V, _, N, I, oe) {
            if (I !== void 0) {
                var T = Ou[I];
                k.push(T), w = T.negate, j === !0 && (x.push("(?:" + w + "+)?(" + T.pattern + "+)?(?:" + w + "+)?(" + T.pattern + "+)?"), j = !1), x.push("(?:" + w + "+)?(" + T.pattern + ")?");
            } else if (N !== void 0) Q = "\\" + (N === "\\" ? "" : N), k.push(N), q.push("([^" + Q + "]+)?" + Q + "?");
            else {
                var T1 = _ !== void 0 ? _ : oe;
                Q = T1 === "\\" ? "\\\\\\\\" : T1.replace(Wv, "\\\\$&"), k.push(T1), q.push("([^" + Q + "]+)?" + Q + "?");
            }
        });
        var H = new RegExp("^" + q.join("") + "(" + (Q === "" ? "." : "[^" + Q + "]") + "+)?" + (Q === "" ? "" : "[" + Q + "]*") + "$"), W = x.length - 1, ie = x.map(function(V, _) {
            return _ === 0 && e.reverseFillMask === !0 ? new RegExp("^" + B + "*" + V) : _ === W ? new RegExp("^" + V + "(" + (w === "" ? "." : w) + "+)?" + (e.reverseFillMask === !0 ? "$" : B + "*")) : new RegExp("^" + V);
        });
        a = k, l = function(V) {
            var _ = H.exec(e.reverseFillMask === !0 ? V : V.slice(0, k.length + 1));
            _ !== null && (V = _.slice(1).join(""));
            var N = [], I = ie.length;
            for(var oe = 0, T = V; oe < I; oe++){
                var _N;
                var D = ie[oe].exec(T);
                if (D === null) break;
                T = T.slice(D.shift().length), (_N = N).push.apply(_N, (0, $79xu7._)(D));
            }
            return N.length !== 0 ? N.join("") : V;
        }, n = k.map(function(V) {
            return typeof V == "string" ? V : Bt;
        }).join(""), i = n.split(Bt).join(A);
    }
    function p(E, A, B) {
        var q = r.value, x = q.selectionEnd, k = q.value.length - x, j = $(E);
        A === !0 && y();
        var Q = S(j), w = e.fillMask !== !1 ? L(Q) : Q, H = v.value !== w;
        q.value !== w && (q.value = w), H === !0 && (v.value = w), document.activeElement === q && (0, $aD8ZA.nextTick)(function() {
            if (w === i) {
                var ie = e.reverseFillMask === !0 ? i.length : 0;
                q.setSelectionRange(ie, ie, "forward");
                return;
            }
            if (B === "insertFromPaste" && e.reverseFillMask !== !0) {
                var ie1 = q.selectionEnd, V = x - 1;
                for(var _ = s; _ <= V && _ < ie1; _++)n[_] !== Bt && V++;
                b.right(q, V);
                return;
            }
            if ([
                "deleteContentBackward",
                "deleteContentForward"
            ].indexOf(B) !== -1) {
                var ie2 = e.reverseFillMask === !0 ? x === 0 ? w.length > Q.length ? 1 : 0 : Math.max(0, w.length - (w === i ? 0 : Math.min(Q.length, k) + 1)) + 1 : x;
                q.setSelectionRange(ie2, ie2, "forward");
                return;
            }
            if (e.reverseFillMask === !0) {
                if (H === !0) {
                    var ie3 = Math.max(0, w.length - (w === i ? 0 : Math.min(Q.length, k + 1)));
                    ie3 === 1 && x === 1 ? q.setSelectionRange(ie3, ie3, "forward") : b.rightReverse(q, ie3);
                } else {
                    var ie4 = w.length - k;
                    q.setSelectionRange(ie4, ie4, "backward");
                }
            } else if (H === !0) {
                var ie5 = Math.max(0, n.indexOf(Bt), Math.min(Q.length, x) - 1);
                b.right(q, ie5);
            } else {
                var ie6 = x - 1;
                b.right(q, ie6);
            }
        });
        var W = e.unmaskedValue === !0 ? $(w) : w;
        String(e.modelValue) !== W && (e.modelValue !== null || W !== "") && o(W, !0);
    }
    function C(E, A, B) {
        var q = S($(E.value));
        A = Math.max(0, n.indexOf(Bt), Math.min(q.length, A)), s = A, E.setSelectionRange(A, B, "forward");
    }
    var b = {
        left: function(E, A) {
            var B = n.slice(A - 1).indexOf(Bt) === -1, q = Math.max(0, A - 1);
            for(; q >= 0; q--)if (n[q] === Bt) {
                A = q, B === !0 && A++;
                break;
            }
            if (q < 0 && n[A] !== void 0 && n[A] !== Bt) return b.right(E, 0);
            A >= 0 && E.setSelectionRange(A, A, "backward");
        },
        right: function(E, A) {
            var B = E.value.length, q = Math.min(B, A + 1);
            for(; q <= B; q++)if (n[q] === Bt) {
                A = q;
                break;
            } else n[q - 1] === Bt && (A = q);
            if (q > B && n[A - 1] !== void 0 && n[A - 1] !== Bt) return b.left(E, B);
            E.setSelectionRange(A, A, "forward");
        },
        leftReverse: function(E, A) {
            var B = m(E.value.length), q = Math.max(0, A - 1);
            for(; q >= 0; q--)if (B[q - 1] === Bt) {
                A = q;
                break;
            } else if (B[q] === Bt && (A = q, q === 0)) break;
            if (q < 0 && B[A] !== void 0 && B[A] !== Bt) return b.rightReverse(E, 0);
            A >= 0 && E.setSelectionRange(A, A, "backward");
        },
        rightReverse: function(E, A) {
            var B = E.value.length, q = m(B), x = q.slice(0, A + 1).indexOf(Bt) === -1, k = Math.min(B, A + 1);
            for(; k <= B; k++)if (q[k - 1] === Bt) {
                A = k, A > 0 && x === !0 && A--;
                break;
            }
            if (k > B && q[A - 1] !== void 0 && q[A - 1] !== Bt) return b.leftReverse(E, B);
            E.setSelectionRange(A, A, "forward");
        }
    };
    function h(E) {
        t("click", E), c = void 0;
    }
    function g(E) {
        if (t("keydown", E), xo(E) === !0 || E.altKey === !0) return;
        var A = r.value, B = A.selectionStart, q = A.selectionEnd;
        if (E.shiftKey || (c = void 0), E.keyCode === 37 || E.keyCode === 39) {
            E.shiftKey && c === void 0 && (c = A.selectionDirection === "forward" ? B : q);
            var x = b[(E.keyCode === 39 ? "right" : "left") + (e.reverseFillMask === !0 ? "Reverse" : "")];
            if (E.preventDefault(), x(A, c === B ? q : B), E.shiftKey) {
                var k = A.selectionStart;
                A.setSelectionRange(Math.min(c, k), Math.max(c, k), "forward");
            }
        } else E.keyCode === 8 && e.reverseFillMask !== !0 && B === q ? (b.left(A, B), A.setSelectionRange(A.selectionStart, q, "backward")) : E.keyCode === 46 && e.reverseFillMask === !0 && B === q && (b.rightReverse(A, q), A.setSelectionRange(B, A.selectionEnd, "forward"));
    }
    function S(E) {
        if (E == null || E === "") return "";
        if (e.reverseFillMask === !0) return P(E);
        var A = a, B = 0, q = "";
        for(var x = 0; x < A.length; x++){
            var k = E[B], j = A[x];
            if (typeof j == "string") q += j, k === j && B++;
            else if (k !== void 0 && j.regex.test(k)) q += j.transform !== void 0 ? j.transform(k) : k, B++;
            else return q;
        }
        return q;
    }
    function P(E) {
        var A = a, B = n.indexOf(Bt), q = E.length - 1, x = "";
        for(var k = A.length - 1; k >= 0 && q !== -1; k--){
            var j = A[k], Q = E[q];
            if (typeof j == "string") x = j + x, Q === j && q--;
            else if (Q !== void 0 && j.regex.test(Q)) do x = (j.transform !== void 0 ? j.transform(Q) : Q) + x, q--, Q = E[q];
            while (B === k && Q !== void 0 && j.regex.test(Q));
            else return x;
        }
        return x;
    }
    function $(E) {
        return typeof E != "string" || l === void 0 ? typeof E == "number" ? l("" + E) : E : l(E);
    }
    function L(E) {
        return i.length - E.length <= 0 ? E : e.reverseFillMask === !0 && E.length !== 0 ? i.slice(0, -E.length) + E : E + i.slice(E.length);
    }
    return {
        innerValue: v,
        hasMask: u,
        moveCursorForPaste: C,
        updateMaskValue: p,
        onMaskedKeydown: g,
        onMaskedClick: h
    };
}
var b1 = /[\u3000-\u303f\u3040-\u309f\u30a0-\u30ff\uff00-\uff9f\u4e00-\u9faf\u3400-\u4dbf]/, y1 = RegExp("[\\u4e00-\\u9fff\\u3400-\\u4dbf\\u{20000}-\\u{2a6df}\\u{2a700}-\\u{2b73f}\\u{2b740}-\\u{2b81f}\\u{2b820}-\\u{2ceaf}\\uf900-\\ufaff\\u3300-\\u33ff\\ufe30-\\ufe4f\\uf900-\\ufaff\\u{2f800}-\\u{2fa1f}]", "u"), S1 = /[\u3131-\u314e\u314f-\u3163\uac00-\ud7a3]/, x1 = /[a-z0-9_ -]$/i;
function Iu(e) {
    return function(o) {
        if (o.type === "compositionend" || o.type === "change") {
            if (o.target.qComposing !== !0) return;
            o.target.qComposing = !1, e(o);
        } else o.type === "compositionupdate" && o.target.qComposing !== !0 && typeof o.data == "string" && (Ce.is.firefox === !0 ? x1.test(o.data) === !1 : b1.test(o.data) === !0 || y1.test(o.data) === !0 || S1.test(o.data) === !0) === !0 && (o.target.qComposing = !0);
    };
}
var da = R({
    name: "QInput",
    inheritAttrs: !1,
    props: (0, $8typN._)((0, $8pZMQ._)({}, zn, Xv, _t), {
        modelValue: {
            required: !1
        },
        shadowText: String,
        type: {
            type: String,
            default: "text"
        },
        debounce: [
            String,
            Number
        ],
        autogrow: Boolean,
        inputClass: [
            Array,
            String,
            Object
        ],
        inputStyle: [
            Array,
            String,
            Object
        ]
    }),
    emits: (0, $79xu7._)(cr).concat([
        "paste",
        "change",
        "keydown",
        "click",
        "animationend"
    ]),
    setup: function(e, param) {
        var t = param.emit, o = param.attrs;
        var _k1 = (0, $aD8ZA.getCurrentInstance)(), r = _k1.proxy, n = r.$q, i = {}, a = NaN, l, s, c = null, u, v = (0, $aAzpa.ref)(null), f = Ai(e), _Gv = Gv(e, t, Q, v), d = _Gv.innerValue, m = _Gv.hasMask, y = _Gv.moveCursorForPaste, p = _Gv.updateMaskValue, C = _Gv.onMaskedKeydown, b = _Gv.onMaskedClick, h = Fu(e, !0), g = (0, $aAzpa.computed)(function() {
            return pn(d.value);
        }), S = Iu(k), P = dr(), $ = (0, $aAzpa.computed)(function() {
            return e.type === "textarea" || e.autogrow === !0;
        }), L = (0, $aAzpa.computed)(function() {
            return $.value === !0 || [
                "text",
                "search",
                "url",
                "tel",
                "password"
            ].includes(e.type);
        }), E = (0, $aAzpa.computed)(function() {
            var _ = (0, $8typN._)((0, $8pZMQ._)({}, P.splitAttrs.listeners.value), {
                onInput: k,
                onPaste: x,
                onChange: H,
                onBlur: W,
                onFocus: tt
            });
            return _.onCompositionstart = _.onCompositionupdate = _.onCompositionend = S, m.value === !0 && (_.onKeydown = C, _.onClick = b), e.autogrow === !0 && (_.onAnimationend = j), _;
        }), A = (0, $aAzpa.computed)(function() {
            var _ = (0, $8typN._)((0, $8pZMQ._)({
                tabindex: 0,
                "data-autofocus": e.autofocus === !0 || void 0,
                rows: e.type === "textarea" ? 6 : void 0,
                "aria-label": e.label,
                name: f.value
            }, P.splitAttrs.attributes.value), {
                id: P.targetUid.value,
                maxlength: e.maxlength,
                disabled: e.disable === !0,
                readonly: e.readonly === !0
            });
            return $.value === !1 && (_.type = e.type), e.autogrow === !0 && (_.rows = 1), _;
        });
        (0, $aD8ZA.watch)(function() {
            return e.type;
        }, function() {
            v.value && (v.value.value = e.modelValue);
        }), (0, $aD8ZA.watch)(function() {
            return e.modelValue;
        }, function(_) {
            if (m.value === !0) {
                if (s === !0 && (s = !1, String(_) === a)) return;
                p(_);
            } else d.value !== _ && (d.value = _, e.type === "number" && i.hasOwnProperty("value") === !0 && (l === !0 ? l = !1 : delete i.value));
            e.autogrow === !0 && (0, $aD8ZA.nextTick)(w);
        }), (0, $aD8ZA.watch)(function() {
            return e.autogrow;
        }, function(_) {
            _ === !0 ? (0, $aD8ZA.nextTick)(w) : v.value !== null && o.rows > 0 && (v.value.style.height = "auto");
        }), (0, $aD8ZA.watch)(function() {
            return e.dense;
        }, function() {
            e.autogrow === !0 && (0, $aD8ZA.nextTick)(w);
        });
        function B() {
            Bo(function() {
                var _ = document.activeElement;
                v.value !== null && v.value !== _ && (_ === null || _.id !== P.targetUid.value) && v.value.focus({
                    preventScroll: !0
                });
            });
        }
        function q() {
            v.value !== null && v.value.select();
        }
        function x(_) {
            if (m.value === !0 && e.reverseFillMask !== !0) {
                var N = _.target;
                y(N, N.selectionStart, N.selectionEnd);
            }
            t("paste", _);
        }
        function k(_) {
            if (!_ || !_.target) return;
            if (e.type === "file") {
                t("update:modelValue", _.target.files);
                return;
            }
            var N = _.target.value;
            if (_.target.qComposing === !0) {
                i.value = N;
                return;
            }
            if (m.value === !0) p(N, !1, _.inputType);
            else if (Q(N), L.value === !0 && _.target === document.activeElement) {
                var __target = _.target, I = __target.selectionStart, oe = __target.selectionEnd;
                I !== void 0 && oe !== void 0 && (0, $aD8ZA.nextTick)(function() {
                    _.target === document.activeElement && N.indexOf(_.target.value) === 0 && _.target.setSelectionRange(I, oe);
                });
            }
            e.autogrow === !0 && w();
        }
        function j(_) {
            t("animationend", _), w();
        }
        function Q(_, N) {
            u = function() {
                c = null, e.type !== "number" && i.hasOwnProperty("value") === !0 && delete i.value, e.modelValue !== _ && a !== _ && (a = _, N === !0 && (s = !0), t("update:modelValue", _), (0, $aD8ZA.nextTick)(function() {
                    a === _ && (a = NaN);
                })), u = void 0;
            }, e.type === "number" && (l = !0, i.value = _), e.debounce !== void 0 ? (c !== null && clearTimeout(c), i.value = _, c = setTimeout(u, e.debounce)) : u();
        }
        function w() {
            requestAnimationFrame(function() {
                var _ = v.value;
                if (_ !== null) {
                    var N = _.parentNode.style, I = _.scrollTop, _ref = n.platform.is.firefox === !0 ? {} : window.getComputedStyle(_), oe = _ref.overflowY, T = _ref.maxHeight, D = oe !== void 0 && oe !== "scroll";
                    D === !0 && (_.style.overflowY = "hidden"), N.marginBottom = _.scrollHeight - 1 + "px", _.style.height = "1px", _.style.height = _.scrollHeight + "px", D === !0 && (_.style.overflowY = parseInt(T, 10) < _.scrollHeight ? "auto" : "hidden"), N.marginBottom = "", _.scrollTop = I;
                }
            });
        }
        function H(_) {
            S(_), c !== null && (clearTimeout(c), c = null), u !== void 0 && u(), t("change", _.target.value);
        }
        function W(_) {
            _ !== void 0 && tt(_), c !== null && (clearTimeout(c), c = null), u !== void 0 && u(), l = !1, s = !1, delete i.value, e.type !== "file" && setTimeout(function() {
                v.value !== null && (v.value.value = d.value !== void 0 ? d.value : "");
            });
        }
        function ie() {
            return i.hasOwnProperty("value") === !0 ? i.value : d.value !== void 0 ? d.value : "";
        }
        (0, $aD8ZA.onBeforeUnmount)(function() {
            W();
        }), (0, $aD8ZA.onMounted)(function() {
            e.autogrow === !0 && w();
        }), Object.assign(P, {
            innerValue: d,
            fieldClass: (0, $aAzpa.computed)(function() {
                return "q-".concat($.value === !0 ? "textarea" : "input") + (e.autogrow === !0 ? " q-textarea--autogrow" : "");
            }),
            hasShadow: (0, $aAzpa.computed)(function() {
                return e.type !== "file" && typeof e.shadowText == "string" && e.shadowText.length !== 0;
            }),
            inputRef: v,
            emitValue: Q,
            hasValue: g,
            floatingLabel: (0, $aAzpa.computed)(function() {
                return g.value === !0 && (e.type !== "number" || isNaN(d.value) === !1) || pn(e.displayValue);
            }),
            getControl: function() {
                return (0, $aD8ZA.h)($.value === !0 ? "textarea" : "input", (0, $8pZMQ._)({
                    ref: v,
                    class: [
                        "q-field__native q-placeholder",
                        e.inputClass
                    ],
                    style: e.inputStyle
                }, A.value, E.value, e.type !== "file" ? {
                    value: ie()
                } : h.value));
            },
            getShadowControl: function() {
                return (0, $aD8ZA.h)("div", {
                    class: "q-field__native q-field__shadow absolute-bottom no-pointer-events" + ($.value === !0 ? "" : " text-no-wrap")
                }, [
                    (0, $aD8ZA.h)("span", {
                        class: "invisible"
                    }, ie()),
                    (0, $aD8ZA.h)("span", e.shadowText)
                ]);
            }
        });
        var V = fr(P);
        return Object.assign(r, {
            focus: B,
            select: q,
            getNativeElement: function() {
                return v.value;
            }
        }), it(r, "nativeEl", function() {
            return v.value;
        }), V;
    }
});
var Zv = {
    threshold: 0,
    root: null,
    rootMargin: "0px"
};
function Jv(e, t, o) {
    var r, n, i;
    typeof o == "function" ? (r = o, n = Zv, i = t.cfg === void 0) : (r = o.handler, n = Object.assign({}, Zv, o.cfg), i = t.cfg === void 0 || Zt(t.cfg, n) === !1), t.handler !== r && (t.handler = r), i === !0 && (t.cfg = n, t.observer !== void 0 && t.observer.unobserve(e), t.observer = new IntersectionObserver(function(param) {
        var _param = (0, $4f96i._)(param, 1), a = _param[0];
        if (typeof t.handler == "function") {
            if (a.rootBounds === null && document.body.contains(e) === !0) {
                t.observer.unobserve(e), t.observer.observe(e);
                return;
            }
            (t.handler(a, t.observer) === !1 || t.once === !0 && a.isIntersecting === !0) && eg(e);
        }
    }, n), t.observer.observe(e));
}
function eg(e) {
    var t = e.__qvisible;
    t !== void 0 && (t.observer !== void 0 && t.observer.unobserve(e), delete e.__qvisible);
}
var Qu = Mt({
    name: "intersection",
    mounted: function(e, param) {
        var t = param.modifiers, o = param.value;
        var r = {
            once: t.once === !0
        };
        Jv(e, r, o), e.__qvisible = r;
    },
    updated: function(e, t) {
        var o = e.__qvisible;
        o !== void 0 && Jv(e, o, t.value);
    },
    beforeUnmount: eg
});
var tg = R({
    name: "QIntersection",
    props: {
        tag: {
            type: String,
            default: "div"
        },
        once: Boolean,
        transition: String,
        transitionDuration: {
            type: [
                String,
                Number
            ],
            default: 300
        },
        ssrPrerender: Boolean,
        margin: String,
        threshold: [
            Number,
            Array
        ],
        root: {
            default: null
        },
        disable: Boolean,
        onVisibility: Function
    },
    setup: function(e, param) {
        var t = param.slots, o = param.emit;
        var r = (0, $aAzpa.ref)(bt.value === !0 ? e.ssrPrerender : !1), n = (0, $aAzpa.computed)(function() {
            return e.root !== void 0 || e.margin !== void 0 || e.threshold !== void 0 ? {
                handler: s,
                cfg: {
                    root: e.root,
                    rootMargin: e.margin,
                    threshold: e.threshold
                }
            } : s;
        }), i = (0, $aAzpa.computed)(function() {
            return e.disable !== !0 && (bt.value !== !0 || e.once !== !0 || e.ssrPrerender !== !0);
        }), a = (0, $aAzpa.computed)(function() {
            return [
                [
                    Qu,
                    n.value,
                    void 0,
                    {
                        once: e.once
                    }
                ]
            ];
        }), l = (0, $aAzpa.computed)(function() {
            return "--q-transition-duration: ".concat(e.transitionDuration, "ms");
        });
        function s(u) {
            r.value !== u.isIntersecting && (r.value = u.isIntersecting, e.onVisibility !== void 0 && o("visibility", r.value));
        }
        function c() {
            if (r.value === !0) return [
                (0, $aD8ZA.h)("div", {
                    key: "content",
                    style: l.value
                }, J(t.default))
            ];
            if (t.hidden !== void 0) return [
                (0, $aD8ZA.h)("div", {
                    key: "hidden",
                    style: l.value
                }, t.hidden())
            ];
        }
        return function() {
            var u = e.transition ? [
                (0, $aD8ZA.h)((0, $iMtOP.Transition), {
                    name: "q-transition--" + e.transition
                }, c)
            ] : c();
            return kt(e.tag, {
                class: "q-intersection"
            }, u, "main", i.value, function() {
                return a.value;
            });
        };
    }
});
var Uu = R({
    name: "QList",
    props: (0, $8typN._)((0, $8pZMQ._)({}, he), {
        bordered: Boolean,
        dense: Boolean,
        separator: Boolean,
        padding: Boolean,
        tag: {
            type: String,
            default: "div"
        }
    }),
    setup: function(e, param) {
        var t = param.slots;
        var o = (0, $aD8ZA.getCurrentInstance)(), r = pe(e, o.proxy.$q), n = (0, $aAzpa.computed)(function() {
            return "q-list" + (e.bordered === !0 ? " q-list--bordered" : "") + (e.dense === !0 ? " q-list--dense" : "") + (e.separator === !0 ? " q-list--separator" : "") + (r.value === !0 ? " q-list--dark" : "") + (e.padding === !0 ? " q-list--padding" : "");
        });
        return function() {
            return (0, $aD8ZA.h)(e.tag, {
                class: n.value
            }, J(t.default));
        };
    }
});
var ng = [
    34,
    37,
    40,
    33,
    39,
    38
], B1 = Object.keys(Oa), rg = R({
    name: "QKnob",
    props: (0, $8typN._)((0, $8pZMQ._)({}, _t, Oa), {
        modelValue: {
            type: Number,
            required: !0
        },
        innerMin: Number,
        innerMax: Number,
        step: {
            type: Number,
            default: 1,
            validator: function(e) {
                return e >= 0;
            }
        },
        tabindex: {
            type: [
                Number,
                String
            ],
            default: 0
        },
        disable: Boolean,
        readonly: Boolean
    }),
    emits: [
        "update:modelValue",
        "change",
        "dragValue"
    ],
    setup: function(e, param) {
        var t = param.slots, o = param.emit;
        var _E1 = (0, $aD8ZA.getCurrentInstance)(), r = _E1.proxy, n = r.$q, i = (0, $aAzpa.ref)(e.modelValue), a = (0, $aAzpa.ref)(!1), l = (0, $aAzpa.computed)(function() {
            return isNaN(e.innerMin) === !0 || e.innerMin < e.min ? e.min : e.innerMin;
        }), s = (0, $aAzpa.computed)(function() {
            return isNaN(e.innerMax) === !0 || e.innerMax > e.max ? e.max : e.innerMax;
        }), c;
        function u() {
            i.value = e.modelValue === null ? l.value : Ze(e.modelValue, l.value, s.value), B(!0);
        }
        (0, $aD8ZA.watch)(function() {
            return "".concat(e.modelValue, "|").concat(l.value, "|").concat(s.value);
        }, u), u();
        var v = (0, $aAzpa.computed)(function() {
            return e.disable === !1 && e.readonly === !1;
        }), f = (0, $aAzpa.computed)(function() {
            return "q-knob non-selectable" + (v.value === !0 ? " q-knob--editable" : e.disable === !0 ? " disabled" : "");
        }), d = (0, $aAzpa.computed)(function() {
            return (String(e.step).trim().split(".")[1] || "").length;
        }), m = (0, $aAzpa.computed)(function() {
            return e.step === 0 ? 1 : e.step;
        }), y = (0, $aAzpa.computed)(function() {
            return e.instantFeedback === !0 || a.value === !0;
        }), p = n.platform.is.mobile === !0 ? (0, $aAzpa.computed)(function() {
            return v.value === !0 ? {
                onClick: $
            } : {};
        }) : (0, $aAzpa.computed)(function() {
            return v.value === !0 ? {
                onMousedown: P,
                onClick: $,
                onKeydown: L,
                onKeyup: A
            } : {};
        }), C = (0, $aAzpa.computed)(function() {
            return v.value === !0 ? {
                tabindex: e.tabindex
            } : {
                ["aria-".concat(e.disable === !0 ? "disabled" : "readonly")]: "true"
            };
        }), b = (0, $aAzpa.computed)(function() {
            var k = {};
            return B1.forEach(function(j) {
                k[j] = e[j];
            }), k;
        });
        function h(k) {
            k.isFinal ? (E(k.evt, !0), a.value = !1) : (k.isFirst && (S(), a.value = !0), E(k.evt));
        }
        var g = (0, $aAzpa.computed)(function() {
            return [
                [
                    qt,
                    h,
                    void 0,
                    {
                        prevent: !0,
                        stop: !0,
                        mouse: !0
                    }
                ]
            ];
        });
        function S() {
            var _r_$el_getBoundingClientRect = r.$el.getBoundingClientRect(), k = _r_$el_getBoundingClientRect.top, j = _r_$el_getBoundingClientRect.left, Q = _r_$el_getBoundingClientRect.width, w = _r_$el_getBoundingClientRect.height;
            c = {
                top: k + w / 2,
                left: j + Q / 2
            };
        }
        function P(k) {
            S(), E(k);
        }
        function $(k) {
            S(), E(k, !0);
        }
        function L(k) {
            if (!ng.includes(k.keyCode)) return;
            Se(k);
            var j = ([
                34,
                33
            ].includes(k.keyCode) ? 10 : 1) * m.value, Q = [
                34,
                37,
                40
            ].includes(k.keyCode) ? -j : j;
            i.value = Ze(parseFloat((i.value + Q).toFixed(d.value)), l.value, s.value), B();
        }
        function E(k, j) {
            var Q = yt(k), w = Math.abs(Q.top - c.top), H = Math.sqrt(Math.pow(w, 2) + Math.pow(Math.abs(Q.left - c.left), 2)), W = Math.asin(w / H) * (180 / Math.PI);
            Q.top < c.top ? W = c.left < Q.left ? 90 - W : 270 + W : W = c.left < Q.left ? W + 90 : 270 - W, n.lang.rtl === !0 ? W = qr(-W - e.angle, 0, 360) : e.angle && (W = qr(W - e.angle, 0, 360)), e.reverse === !0 && (W = 360 - W);
            var ie = e.min + W / 360 * (e.max - e.min);
            if (m.value !== 0) {
                var V = ie % m.value;
                ie = ie - V + (Math.abs(V) >= m.value / 2 ? (V < 0 ? -1 : 1) * m.value : 0), ie = parseFloat(ie.toFixed(d.value));
            }
            ie = Ze(ie, l.value, s.value), o("dragValue", ie), i.value !== ie && (i.value = ie), B(j);
        }
        function A(k) {
            ng.includes(k.keyCode) && B(!0);
        }
        function B(k) {
            e.modelValue !== i.value && o("update:modelValue", i.value), k === !0 && o("change", i.value);
        }
        var q = cn(e);
        function x() {
            return (0, $aD8ZA.h)("input", q.value);
        }
        return function() {
            var k = (0, $8pZMQ._)((0, $8typN._)((0, $8pZMQ._)({
                class: f.value,
                role: "slider",
                "aria-valuemin": l.value,
                "aria-valuemax": s.value,
                "aria-valuenow": e.modelValue
            }, C.value, b.value), {
                value: i.value,
                instantFeedback: y.value
            }), p.value), j = {
                default: t.default
            };
            return v.value === !0 && e.name !== void 0 && (j.internal = x), kt(Yi, k, j, "knob", v.value, function() {
                return g.value;
            });
        };
    }
});
var ag = Xe.passive, V1 = [
    "both",
    "horizontal",
    "vertical"
], fa = R({
    name: "QScrollObserver",
    props: {
        axis: {
            type: String,
            validator: function(e) {
                return V1.includes(e);
            },
            default: "vertical"
        },
        debounce: [
            String,
            Number
        ],
        scrollTarget: {
            default: void 0
        }
    },
    emits: [
        "scroll"
    ],
    setup: function(e, param) {
        var t = param.emit;
        var o = {
            position: {
                top: 0,
                left: 0
            },
            direction: "down",
            directionChanged: !1,
            delta: {
                top: 0,
                left: 0
            },
            inflectionPoint: {
                top: 0,
                left: 0
            }
        }, r = null, n, i;
        (0, $aD8ZA.watch)(function() {
            return e.scrollTarget;
        }, function() {
            s(), l();
        });
        function a() {
            r !== null && r();
            var v = Math.max(0, fo(n)), f = er(n), d = {
                top: v - o.position.top,
                left: f - o.position.left
            };
            if (e.axis === "vertical" && d.top === 0 || e.axis === "horizontal" && d.left === 0) return;
            var m = Math.abs(d.top) >= Math.abs(d.left) ? d.top < 0 ? "up" : "down" : d.left < 0 ? "left" : "right";
            o.position = {
                top: v,
                left: f
            }, o.directionChanged = o.direction !== m, o.delta = d, o.directionChanged === !0 && (o.direction = m, o.inflectionPoint = o.position), t("scroll", (0, $8pZMQ._)({}, o));
        }
        function l() {
            n = At(i, e.scrollTarget), n.addEventListener("scroll", c, ag), c(!0);
        }
        function s() {
            n !== void 0 && (n.removeEventListener("scroll", c, ag), n = void 0);
        }
        function c(v) {
            if (v === !0 || e.debounce === 0 || e.debounce === "0") a();
            else if (r === null) {
                var _ref = (0, $4f96i._)(e.debounce ? [
                    setTimeout(a, e.debounce),
                    clearTimeout
                ] : [
                    requestAnimationFrame(a),
                    cancelAnimationFrame
                ], 2), f = _ref[0], d = _ref[1];
                r = function() {
                    d(f), r = null;
                };
            }
        }
        var _D1 = (0, $aD8ZA.getCurrentInstance)(), u = _D1.proxy;
        return (0, $aD8ZA.watch)(function() {
            return u.$q.lang.rtl;
        }, a), (0, $aD8ZA.onMounted)(function() {
            i = u.$el.parentNode, l();
        }), (0, $aD8ZA.onBeforeUnmount)(function() {
            r !== null && r(), s();
        }), Object.assign(u, {
            trigger: c,
            getPosition: function() {
                return o;
            }
        }), Qe;
    }
});
var lg = R({
    name: "QLayout",
    props: {
        container: Boolean,
        view: {
            type: String,
            default: "hhh lpr fff",
            validator: function(e) {
                return /^(h|l)h(h|r) lpr (f|l)f(f|r)$/.test(e.toLowerCase());
            }
        },
        onScroll: Function,
        onScrollHeight: Function,
        onResize: Function
    },
    setup: function(e, param) {
        var t = param.slots, o = param.emit;
        var _H1 = (0, $aD8ZA.getCurrentInstance)(), _H1_proxy = _H1.proxy, r = _H1_proxy.$q, n = (0, $aAzpa.ref)(null), i = (0, $aAzpa.ref)(r.screen.height), a = (0, $aAzpa.ref)(e.container === !0 ? 0 : r.screen.width), l = (0, $aAzpa.ref)({
            position: 0,
            direction: "down",
            inflectionPoint: 0
        }), s = (0, $aAzpa.ref)(0), c = (0, $aAzpa.ref)(bt.value === !0 ? 0 : Pr()), u = (0, $aAzpa.computed)(function() {
            return "q-layout q-layout--" + (e.container === !0 ? "containerized" : "standard");
        }), v = (0, $aAzpa.computed)(function() {
            return e.container === !1 ? {
                minHeight: r.screen.height + "px"
            } : null;
        }), f = (0, $aAzpa.computed)(function() {
            return c.value !== 0 ? {
                [r.lang.rtl === !0 ? "left" : "right"]: "".concat(c.value, "px")
            } : null;
        }), d = (0, $aAzpa.computed)(function() {
            return c.value !== 0 ? {
                [r.lang.rtl === !0 ? "right" : "left"]: 0,
                [r.lang.rtl === !0 ? "left" : "right"]: "-".concat(c.value, "px"),
                width: "calc(100% + ".concat(c.value, "px)")
            } : null;
        });
        function m(g) {
            if (e.container === !0 || document.qScrollPrevented !== !0) {
                var S = {
                    position: g.position.top,
                    direction: g.direction,
                    directionChanged: g.directionChanged,
                    inflectionPoint: g.inflectionPoint.top,
                    delta: g.delta.top
                };
                l.value = S, e.onScroll !== void 0 && o("scroll", S);
            }
        }
        function y(g) {
            var S = g.height, P = g.width, $ = !1;
            i.value !== S && ($ = !0, i.value = S, e.onScrollHeight !== void 0 && o("scrollHeight", S), C()), a.value !== P && ($ = !0, a.value = P), $ === !0 && e.onResize !== void 0 && o("resize", g);
        }
        function p(param) {
            var g = param.height;
            s.value !== g && (s.value = g, C());
        }
        function C() {
            if (e.container === !0) {
                var g = i.value > s.value ? Pr() : 0;
                c.value !== g && (c.value = g);
            }
        }
        var b = null, h = {
            instances: {},
            view: (0, $aAzpa.computed)(function() {
                return e.view;
            }),
            isContainer: (0, $aAzpa.computed)(function() {
                return e.container;
            }),
            rootRef: n,
            height: i,
            containerHeight: s,
            scrollbarWidth: c,
            totalWidth: (0, $aAzpa.computed)(function() {
                return a.value + c.value;
            }),
            rows: (0, $aAzpa.computed)(function() {
                var g = e.view.toLowerCase().split(" ");
                return {
                    top: g[0].split(""),
                    middle: g[1].split(""),
                    bottom: g[2].split("")
                };
            }),
            header: (0, $aAzpa.reactive)({
                size: 0,
                offset: 0,
                space: !1
            }),
            right: (0, $aAzpa.reactive)({
                size: 300,
                offset: 0,
                space: !1
            }),
            footer: (0, $aAzpa.reactive)({
                size: 0,
                offset: 0,
                space: !1
            }),
            left: (0, $aAzpa.reactive)({
                size: 300,
                offset: 0,
                space: !1
            }),
            scroll: l,
            animate: function() {
                b !== null ? clearTimeout(b) : document.body.classList.add("q-body--layout-animate"), b = setTimeout(function() {
                    b = null, document.body.classList.remove("q-body--layout-animate");
                }, 155);
            },
            update: function(g, S, P) {
                h[g][S] = P;
            }
        };
        if ((0, $aD8ZA.provide)(co, h), Pr() > 0) {
            var P = function P() {
                g = null, S.classList.remove("hide-scrollbar");
            }, $ = function $() {
                if (g === null) {
                    if (S.scrollHeight > r.screen.height) return;
                    S.classList.add("hide-scrollbar");
                } else clearTimeout(g);
                g = setTimeout(P, 300);
            }, L = function L(E) {
                g !== null && E === "remove" && (clearTimeout(g), P()), window["".concat(E, "EventListener")]("resize", $);
            }, g = null, S = document.body;
            (0, $aD8ZA.watch)(function() {
                return e.container !== !0 ? "add" : "remove";
            }, L), e.container !== !0 && L("add"), (0, $aD8ZA.onUnmounted)(function() {
                L("remove");
            });
        }
        return function() {
            var g = Ke(t.default, [
                (0, $aD8ZA.h)(fa, {
                    onScroll: m
                }),
                (0, $aD8ZA.h)(go, {
                    onResize: y
                })
            ]), S = (0, $aD8ZA.h)("div", {
                class: u.value,
                style: v.value,
                ref: e.container === !0 ? void 0 : n,
                tabindex: -1
            }, g);
            return e.container === !0 ? (0, $aD8ZA.h)("div", {
                class: "q-layout-container overflow-hidden",
                ref: n
            }, [
                (0, $aD8ZA.h)(go, {
                    onResize: p
                }),
                (0, $aD8ZA.h)("div", {
                    class: "absolute-full",
                    style: f.value
                }, [
                    (0, $aD8ZA.h)("div", {
                        class: "scroll",
                        style: d.value
                    }, [
                        S
                    ])
                ])
            ]) : S;
        };
    }
});
var j1 = [
    "horizontal",
    "vertical",
    "cell",
    "none"
], Wu = R({
    name: "QMarkupTable",
    props: (0, $8typN._)((0, $8pZMQ._)({}, he), {
        dense: Boolean,
        flat: Boolean,
        bordered: Boolean,
        square: Boolean,
        wrapCells: Boolean,
        separator: {
            type: String,
            default: "horizontal",
            validator: function(e) {
                return j1.includes(e);
            }
        }
    }),
    setup: function(e, param) {
        var t = param.slots;
        var o = (0, $aD8ZA.getCurrentInstance)(), r = pe(e, o.proxy.$q), n = (0, $aAzpa.computed)(function() {
            return "q-markup-table q-table__container q-table__card q-table--".concat(e.separator, "-separator") + (r.value === !0 ? " q-table--dark q-table__card--dark q-dark" : "") + (e.dense === !0 ? " q-table--dense" : "") + (e.flat === !0 ? " q-table--flat" : "") + (e.bordered === !0 ? " q-table--bordered" : "") + (e.square === !0 ? " q-table--square" : "") + (e.wrapCells === !1 ? " q-table--no-wrap" : "");
        });
        return function() {
            return (0, $aD8ZA.h)("div", {
                class: n.value
            }, [
                (0, $aD8ZA.h)("table", {
                    class: "q-table"
                }, J(t.default))
            ]);
        };
    }
});
var sg = R({
    name: "QNoSsr",
    props: {
        tag: {
            type: String,
            default: "div"
        },
        placeholder: String
    },
    setup: function(e, param) {
        var t = param.slots;
        var _Ha = Ha(), o = _Ha.isHydrated;
        return function() {
            if (o.value === !0) {
                var i = J(t.default);
                return i === void 0 ? i : i.length > 1 ? (0, $aD8ZA.h)(e.tag, {}, i) : i[0];
            }
            var r = {
                class: "q-no-ssr-placeholder"
            }, n = J(t.placeholder);
            if (n !== void 0) return n.length > 1 ? (0, $aD8ZA.h)(e.tag, r, n) : n[0];
            if (e.placeholder !== void 0) return (0, $aD8ZA.h)(e.tag, r, e.placeholder);
        };
    }
});
var W1 = (0, $aD8ZA.h)("svg", {
    key: "svg",
    class: "q-radio__bg absolute non-selectable",
    viewBox: "0 0 24 24"
}, [
    (0, $aD8ZA.h)("path", {
        d: "M12,22a10,10 0 0 1 -10,-10a10,10 0 0 1 10,-10a10,10 0 0 1 10,10a10,10 0 0 1 -10,10m0,-22a12,12 0 0 0 -12,12a12,12 0 0 0 12,12a12,12 0 0 0 12,-12a12,12 0 0 0 -12,-12"
    }),
    (0, $aD8ZA.h)("path", {
        class: "q-radio__check",
        d: "M12,6a6,6 0 0 0 -6,6a6,6 0 0 0 6,6a6,6 0 0 0 6,-6a6,6 0 0 0 -6,-6"
    })
]), Yu = R({
    name: "QRadio",
    props: (0, $8typN._)((0, $8pZMQ._)({}, he, Ot, _t), {
        modelValue: {
            required: !0
        },
        val: {
            required: !0
        },
        label: String,
        leftLabel: Boolean,
        checkedIcon: String,
        uncheckedIcon: String,
        color: String,
        keepColor: Boolean,
        dense: Boolean,
        disable: Boolean,
        tabindex: [
            String,
            Number
        ]
    }),
    emits: [
        "update:modelValue"
    ],
    setup: function(e, param) {
        var t = param.slots, o = param.emit;
        var _K1 = (0, $aD8ZA.getCurrentInstance)(), r = _K1.proxy, n = pe(e, r.$q), i = It(e, Gl), a = (0, $aAzpa.ref)(null), _Xl = Xl(e, a), l = _Xl.refocusTargetEl, s = _Xl.refocusTarget, c = (0, $aAzpa.computed)(function() {
            return (0, $aAzpa.toRaw)(e.modelValue) === (0, $aAzpa.toRaw)(e.val);
        }), u = (0, $aAzpa.computed)(function() {
            return "q-radio cursor-pointer no-outline row inline no-wrap items-center" + (e.disable === !0 ? " disabled" : "") + (n.value === !0 ? " q-radio--dark" : "") + (e.dense === !0 ? " q-radio--dense" : "") + (e.leftLabel === !0 ? " reverse" : "");
        }), v = (0, $aAzpa.computed)(function() {
            var h = e.color !== void 0 && (e.keepColor === !0 || c.value === !0) ? " text-".concat(e.color) : "";
            return "q-radio__inner relative-position q-radio__inner--".concat(c.value === !0 ? "truthy" : "falsy").concat(h);
        }), f = (0, $aAzpa.computed)(function() {
            return (c.value === !0 ? e.checkedIcon : e.uncheckedIcon) || null;
        }), d = (0, $aAzpa.computed)(function() {
            return e.disable === !0 ? -1 : e.tabindex || 0;
        }), m = (0, $aAzpa.computed)(function() {
            var h = {
                type: "radio"
            };
            return e.name !== void 0 && Object.assign(h, {
                ".checked": c.value === !0,
                "^checked": c.value === !0 ? "checked" : void 0,
                name: e.name,
                value: e.val
            }), h;
        }), y = eo(m);
        function p(h) {
            h !== void 0 && (Se(h), s(h)), e.disable !== !0 && c.value !== !0 && o("update:modelValue", e.val, h);
        }
        function C(h) {
            (h.keyCode === 13 || h.keyCode === 32) && Se(h);
        }
        function b(h) {
            (h.keyCode === 13 || h.keyCode === 32) && p(h);
        }
        return Object.assign(r, {
            set: p
        }), function() {
            var h = f.value !== null ? [
                (0, $aD8ZA.h)("div", {
                    key: "icon",
                    class: "q-radio__icon-container absolute-full flex flex-center no-wrap"
                }, [
                    (0, $aD8ZA.h)(we, {
                        class: "q-radio__icon",
                        name: f.value
                    })
                ])
            ] : [
                W1
            ];
            e.disable !== !0 && y(h, "unshift", " q-radio__native q-ma-none q-pa-none");
            var g = [
                (0, $aD8ZA.h)("div", {
                    class: v.value,
                    style: i.value,
                    "aria-hidden": "true"
                }, h)
            ];
            l.value !== null && g.push(l.value);
            var S = e.label !== void 0 ? Ke(t.default, [
                e.label
            ]) : J(t.default);
            return S !== void 0 && g.push((0, $aD8ZA.h)("div", {
                class: "q-radio__label q-anchor--skip"
            }, S)), (0, $aD8ZA.h)("div", {
                ref: a,
                class: u.value,
                tabindex: d.value,
                role: "radio",
                "aria-label": e.label,
                "aria-checked": c.value === !0 ? "true" : "false",
                "aria-disabled": e.disable === !0 ? "true" : void 0,
                onClick: p,
                onKeydown: C,
                onKeyup: b
            }, g);
        };
    }
});
var Xu = R({
    name: "QToggle",
    props: (0, $8typN._)((0, $8pZMQ._)({}, Zl), {
        icon: String,
        iconColor: String
    }),
    emits: Jl,
    setup: function(e) {
        function t(o, r) {
            var n = (0, $aAzpa.computed)(function() {
                return (o.value === !0 ? e.checkedIcon : r.value === !0 ? e.indeterminateIcon : e.uncheckedIcon) || e.icon;
            }), i = (0, $aAzpa.computed)(function() {
                return o.value === !0 ? e.iconColor : null;
            });
            return function() {
                return [
                    (0, $aD8ZA.h)("div", {
                        class: "q-toggle__track"
                    }),
                    (0, $aD8ZA.h)("div", {
                        class: "q-toggle__thumb absolute flex flex-center no-wrap"
                    }, n.value !== void 0 ? [
                        (0, $aD8ZA.h)(we, {
                            name: n.value,
                            color: i.value
                        })
                    ] : void 0)
                ];
            };
        }
        return eu("toggle", t);
    }
});
var fg = {
    radio: Yu,
    checkbox: fn,
    toggle: Xu
}, X1 = Object.keys(fg), Gu = R({
    name: "QOptionGroup",
    props: (0, $8typN._)((0, $8pZMQ._)({}, he), {
        modelValue: {
            required: !0
        },
        options: {
            type: Array,
            validator: function(e) {
                return e.every(function(t) {
                    return "value" in t && "label" in t;
                });
            }
        },
        name: String,
        type: {
            default: "radio",
            validator: function(e) {
                return X1.includes(e);
            }
        },
        color: String,
        keepColor: Boolean,
        dense: Boolean,
        size: String,
        leftLabel: Boolean,
        inline: Boolean,
        disable: Boolean
    }),
    emits: [
        "update:modelValue"
    ],
    setup: function(e, param) {
        var t = param.emit, o = param.slots;
        var _Y1 = (0, $aD8ZA.getCurrentInstance)(), _Y1_proxy = _Y1.proxy, r = _Y1_proxy.$q, n = Array.isArray(e.modelValue);
        e.type === "radio" ? n === !0 && console.error("q-option-group: model should not be array") : n === !1 && console.error("q-option-group: model should be array in your case");
        var i = pe(e, r), a = (0, $aAzpa.computed)(function() {
            return fg[e.type];
        }), l = (0, $aAzpa.computed)(function() {
            return "q-option-group q-gutter-x-sm" + (e.inline === !0 ? " q-option-group--inline" : "");
        }), s = (0, $aAzpa.computed)(function() {
            var u = {
                role: "group"
            };
            return e.type === "radio" && (u.role = "radiogroup", e.disable === !0 && (u["aria-disabled"] = "true")), u;
        });
        function c(u) {
            t("update:modelValue", u);
        }
        return function() {
            return (0, $aD8ZA.h)("div", (0, $8pZMQ._)({
                class: l.value
            }, s.value), e.options.map(function(u, v) {
                var f = o["label-" + v] !== void 0 ? function() {
                    return o["label-" + v](u);
                } : o.label !== void 0 ? function() {
                    return o.label(u);
                } : void 0;
                return (0, $aD8ZA.h)("div", [
                    (0, $aD8ZA.h)(a.value, {
                        modelValue: e.modelValue,
                        val: u.value,
                        name: u.name === void 0 ? e.name : u.name,
                        disable: e.disable || u.disable,
                        label: f === void 0 ? u.label : null,
                        leftLabel: u.leftLabel === void 0 ? e.leftLabel : u.leftLabel,
                        color: u.color === void 0 ? e.color : u.color,
                        checkedIcon: u.checkedIcon,
                        uncheckedIcon: u.uncheckedIcon,
                        dark: u.dark || i.value,
                        size: u.size === void 0 ? e.size : u.size,
                        dense: e.dense,
                        keepColor: u.keepColor === void 0 ? e.keepColor : u.keepColor,
                        "onUpdate:modelValue": c
                    }, f)
                ]);
            }));
        };
    }
});
var gg = R({
    name: "QPage",
    props: {
        padding: Boolean,
        styleFn: Function
    },
    setup: function(e, param) {
        var t = param.slots;
        var _Z1 = (0, $aD8ZA.getCurrentInstance)(), _Z1_proxy = _Z1.proxy, o = _Z1_proxy.$q, r = (0, $aD8ZA.inject)(co, Ye);
        if (r === Ye) return console.error("QPage needs to be a deep child of QLayout"), Ye;
        if ((0, $aD8ZA.inject)(kl, Ye) === Ye) return console.error("QPage needs to be child of QPageContainer"), Ye;
        var i = (0, $aAzpa.computed)(function() {
            var l = (r.header.space === !0 ? r.header.size : 0) + (r.footer.space === !0 ? r.footer.size : 0);
            if (typeof e.styleFn == "function") {
                var s = r.isContainer.value === !0 ? r.containerHeight.value : o.screen.height;
                return e.styleFn(l, s);
            }
            return {
                minHeight: r.isContainer.value === !0 ? r.containerHeight.value - l + "px" : o.screen.height === 0 ? l !== 0 ? "calc(100vh - ".concat(l, "px)") : "100vh" : o.screen.height - l + "px"
            };
        }), a = (0, $aAzpa.computed)(function() {
            return "q-page".concat(e.padding === !0 ? " q-layout-padding" : "");
        });
        return function() {
            return (0, $aD8ZA.h)("main", {
                class: a.value,
                style: i.value
            }, J(t.default));
        };
    }
});
var hg = R({
    name: "QPageContainer",
    setup: function(e, param) {
        var t = param.slots;
        var _nC = (0, $aD8ZA.getCurrentInstance)(), _nC_proxy = _nC.proxy, o = _nC_proxy.$q, r = (0, $aD8ZA.inject)(co, Ye);
        if (r === Ye) return console.error("QPageContainer needs to be child of QLayout"), Ye;
        (0, $aD8ZA.provide)(kl, !0);
        var n = (0, $aAzpa.computed)(function() {
            var i = {};
            return r.header.space === !0 && (i.paddingTop = "".concat(r.header.size, "px")), r.right.space === !0 && (i["padding".concat(o.lang.rtl === !0 ? "Left" : "Right")] = "".concat(r.right.size, "px")), r.footer.space === !0 && (i.paddingBottom = "".concat(r.footer.size, "px")), r.left.space === !0 && (i["padding".concat(o.lang.rtl === !0 ? "Right" : "Left")] = "".concat(r.left.size, "px")), i;
        });
        return function() {
            return (0, $aD8ZA.h)("div", {
                class: "q-page-container",
                style: n.value
            }, J(t.default));
        };
    }
});
var Zu = {
    position: {
        type: String,
        default: "bottom-right",
        validator: function(e) {
            return [
                "top-right",
                "top-left",
                "bottom-right",
                "bottom-left",
                "top",
                "right",
                "bottom",
                "left"
            ].includes(e);
        }
    },
    offset: {
        type: Array,
        validator: function(e) {
            return e.length === 2;
        }
    },
    expand: Boolean
};
function Ju() {
    var _iC = (0, $aD8ZA.getCurrentInstance)(), e = _iC.props, _iC_proxy = _iC.proxy, t = _iC_proxy.$q, o = (0, $aD8ZA.inject)(co, Ye);
    if (o === Ye) return console.error("QPageSticky needs to be child of QLayout"), Ye;
    var r = (0, $aAzpa.computed)(function() {
        var v = e.position;
        return {
            top: v.indexOf("top") !== -1,
            right: v.indexOf("right") !== -1,
            bottom: v.indexOf("bottom") !== -1,
            left: v.indexOf("left") !== -1,
            vertical: v === "top" || v === "bottom",
            horizontal: v === "left" || v === "right"
        };
    }), n = (0, $aAzpa.computed)(function() {
        return o.header.offset;
    }), i = (0, $aAzpa.computed)(function() {
        return o.right.offset;
    }), a = (0, $aAzpa.computed)(function() {
        return o.footer.offset;
    }), l = (0, $aAzpa.computed)(function() {
        return o.left.offset;
    }), s = (0, $aAzpa.computed)(function() {
        var v = 0, f = 0, d = r.value, m = t.lang.rtl === !0 ? -1 : 1;
        d.top === !0 && n.value !== 0 ? f = "".concat(n.value, "px") : d.bottom === !0 && a.value !== 0 && (f = "".concat(-a.value, "px")), d.left === !0 && l.value !== 0 ? v = "".concat(m * l.value, "px") : d.right === !0 && i.value !== 0 && (v = "".concat(-m * i.value, "px"));
        var y = {
            transform: "translate(".concat(v, ", ").concat(f, ")")
        };
        return e.offset && (y.margin = "".concat(e.offset[1], "px ").concat(e.offset[0], "px")), d.vertical === !0 ? (l.value !== 0 && (y[t.lang.rtl === !0 ? "right" : "left"] = "".concat(l.value, "px")), i.value !== 0 && (y[t.lang.rtl === !0 ? "left" : "right"] = "".concat(i.value, "px"))) : d.horizontal === !0 && (n.value !== 0 && (y.top = "".concat(n.value, "px")), a.value !== 0 && (y.bottom = "".concat(a.value, "px"))), y;
    }), c = (0, $aAzpa.computed)(function() {
        return "q-page-sticky row flex-center fixed-".concat(e.position, " q-page-sticky--").concat(e.expand === !0 ? "expand" : "shrink");
    });
    function u(v) {
        var f = J(v.default);
        return (0, $aD8ZA.h)("div", {
            class: c.value,
            style: s.value
        }, e.expand === !0 ? f : [
            (0, $aD8ZA.h)("div", f)
        ]);
    }
    return {
        $layout: o,
        getStickyContent: u
    };
}
var Sg = R({
    name: "QPageScroller",
    props: (0, $8typN._)((0, $8pZMQ._)({}, Zu), {
        scrollOffset: {
            type: Number,
            default: 1e3
        },
        reverse: Boolean,
        duration: {
            type: Number,
            default: 300
        },
        offset: {
            default: function() {
                return [
                    18,
                    18
                ];
            }
        }
    }),
    emits: [
        "click"
    ],
    setup: function(e, param) {
        var t = param.slots, o = param.emit;
        var _uC = (0, $aD8ZA.getCurrentInstance)(), _uC_proxy = _uC.proxy, r = _uC_proxy.$q, _Ju = Ju(), n = _Ju.$layout, i = _Ju.getStickyContent, a = (0, $aAzpa.ref)(null), l, s = (0, $aAzpa.computed)(function() {
            return n.height.value - (n.isContainer.value === !0 ? n.containerHeight.value : r.screen.height);
        });
        function c() {
            return e.reverse === !0 ? s.value - n.scroll.value.position > e.scrollOffset : n.scroll.value.position > e.scrollOffset;
        }
        var u = (0, $aAzpa.ref)(c());
        function v() {
            var p = c();
            u.value !== p && (u.value = p);
        }
        function f() {
            e.reverse === !0 ? l === void 0 && (l = (0, $aD8ZA.watch)(s, v)) : d();
        }
        (0, $aD8ZA.watch)(n.scroll, v), (0, $aD8ZA.watch)(function() {
            return e.reverse;
        }, f);
        function d() {
            l !== void 0 && (l(), l = void 0);
        }
        function m(p) {
            var C = At(n.isContainer.value === !0 ? a.value : n.rootRef.value);
            un(C, e.reverse === !0 ? n.height.value : 0, e.duration), o("click", p);
        }
        function y() {
            return u.value === !0 ? (0, $aD8ZA.h)("div", {
                ref: a,
                class: "q-page-scroller",
                onClick: m
            }, i(t)) : null;
        }
        return f(), (0, $aD8ZA.onBeforeUnmount)(d), function() {
            return (0, $aD8ZA.h)((0, $iMtOP.Transition), {
                name: "q-transition--fade"
            }, y);
        };
    }
});
var xg = R({
    name: "QPageSticky",
    props: Zu,
    setup: function(e, param) {
        var t = param.slots;
        var _Ju = Ju(), o = _Ju.getStickyContent;
        return function() {
            return o(t);
        };
    }
});
function es(e, t) {
    return [
        !0,
        !1
    ].includes(e) ? e : t;
}
var _g = R({
    name: "QPagination",
    props: (0, $8typN._)((0, $8pZMQ._)({}, he), {
        modelValue: {
            type: Number,
            required: !0
        },
        min: {
            type: [
                Number,
                String
            ],
            default: 1
        },
        max: {
            type: [
                Number,
                String
            ],
            required: !0
        },
        maxPages: {
            type: [
                Number,
                String
            ],
            default: 0,
            validator: function(e) {
                return (typeof e == "string" ? parseInt(e, 10) : e) >= 0;
            }
        },
        inputStyle: [
            Array,
            String,
            Object
        ],
        inputClass: [
            Array,
            String,
            Object
        ],
        size: String,
        disable: Boolean,
        input: Boolean,
        iconPrev: String,
        iconNext: String,
        iconFirst: String,
        iconLast: String,
        toFn: Function,
        boundaryLinks: {
            type: Boolean,
            default: null
        },
        boundaryNumbers: {
            type: Boolean,
            default: null
        },
        directionLinks: {
            type: Boolean,
            default: null
        },
        ellipses: {
            type: Boolean,
            default: null
        },
        ripple: {
            type: [
                Boolean,
                Object
            ],
            default: null
        },
        round: Boolean,
        rounded: Boolean,
        flat: Boolean,
        outline: Boolean,
        unelevated: Boolean,
        push: Boolean,
        glossy: Boolean,
        color: {
            type: String,
            default: "primary"
        },
        textColor: String,
        activeDesign: {
            type: String,
            default: "",
            values: function(e) {
                return e === "" || ac.includes(e);
            }
        },
        activeColor: String,
        activeTextColor: String,
        gutter: String,
        padding: {
            type: String,
            default: "3px 2px"
        }
    }),
    emits: [
        "update:modelValue"
    ],
    setup: function(e, param) {
        var t = param.emit;
        var _fC = (0, $aD8ZA.getCurrentInstance)(), o = _fC.proxy, r = o.$q, n = pe(e, r), i = (0, $aAzpa.computed)(function() {
            return parseInt(e.min, 10);
        }), a = (0, $aAzpa.computed)(function() {
            return parseInt(e.max, 10);
        }), l = (0, $aAzpa.computed)(function() {
            return parseInt(e.maxPages, 10);
        }), s = (0, $aAzpa.computed)(function() {
            return m.value + " / " + a.value;
        }), c = (0, $aAzpa.computed)(function() {
            return es(e.boundaryLinks, e.input);
        }), u = (0, $aAzpa.computed)(function() {
            return es(e.boundaryNumbers, !e.input);
        }), v = (0, $aAzpa.computed)(function() {
            return es(e.directionLinks, e.input);
        }), f = (0, $aAzpa.computed)(function() {
            return es(e.ellipses, !e.input);
        }), d = (0, $aAzpa.ref)(null), m = (0, $aAzpa.computed)({
            get: function() {
                return e.modelValue;
            },
            set: function(x) {
                if (x = parseInt(x, 10), e.disable || isNaN(x)) return;
                var k = Ze(x, i.value, a.value);
                e.modelValue !== k && t("update:modelValue", k);
            }
        });
        (0, $aD8ZA.watch)(function() {
            return "".concat(i.value, "|").concat(a.value);
        }, function() {
            m.value = e.modelValue;
        });
        var y = (0, $aAzpa.computed)(function() {
            return "q-pagination row no-wrap items-center" + (e.disable === !0 ? " disabled" : "");
        }), p = (0, $aAzpa.computed)(function() {
            return e.gutter in Aa ? "".concat(Aa[e.gutter], "px") : e.gutter || null;
        }), C = (0, $aAzpa.computed)(function() {
            return p.value !== null ? "--q-pagination-gutter-parent:-".concat(p.value, ";--q-pagination-gutter-child:").concat(p.value) : null;
        }), b = (0, $aAzpa.computed)(function() {
            var x = [
                e.iconFirst || r.iconSet.pagination.first,
                e.iconPrev || r.iconSet.pagination.prev,
                e.iconNext || r.iconSet.pagination.next,
                e.iconLast || r.iconSet.pagination.last
            ];
            return r.lang.rtl === !0 ? x.reverse() : x;
        }), h = (0, $aAzpa.computed)(function() {
            return {
                "aria-disabled": e.disable === !0 ? "true" : "false",
                role: "navigation"
            };
        }), g = (0, $aAzpa.computed)(function() {
            return Fl(e, "flat");
        }), S = (0, $aAzpa.computed)(function() {
            return {
                [g.value]: !0,
                round: e.round,
                rounded: e.rounded,
                padding: e.padding,
                color: e.color,
                textColor: e.textColor,
                size: e.size,
                ripple: e.ripple !== null ? e.ripple : !0
            };
        }), P = (0, $aAzpa.computed)(function() {
            var x = {
                [g.value]: !1
            };
            return e.activeDesign !== "" && (x[e.activeDesign] = !0), x;
        }), $ = (0, $aAzpa.computed)(function() {
            return (0, $8typN._)((0, $8pZMQ._)({}, P.value), {
                color: e.activeColor || e.color,
                textColor: e.activeTextColor || e.textColor
            });
        }), L = (0, $aAzpa.computed)(function() {
            var x = Math.max(l.value, 1 + (f.value ? 2 : 0) + (u.value ? 2 : 0)), k = {
                pgFrom: i.value,
                pgTo: a.value,
                ellipsesStart: !1,
                ellipsesEnd: !1,
                boundaryStart: !1,
                boundaryEnd: !1,
                marginalStyle: {
                    minWidth: "".concat(Math.max(2, String(a.value).length), "em")
                }
            };
            return l.value && x < a.value - i.value + 1 && (x = 1 + Math.floor(x / 2) * 2, k.pgFrom = Math.max(i.value, Math.min(a.value - x + 1, e.modelValue - Math.floor(x / 2))), k.pgTo = Math.min(a.value, k.pgFrom + x - 1), u.value && (k.boundaryStart = !0, k.pgFrom++), f.value && k.pgFrom > i.value + (u.value ? 1 : 0) && (k.ellipsesStart = !0, k.pgFrom++), u.value && (k.boundaryEnd = !0, k.pgTo--), f.value && k.pgTo < a.value - (u.value ? 1 : 0) && (k.ellipsesEnd = !0, k.pgTo--)), k;
        });
        function E(x) {
            m.value = x;
        }
        function A(x) {
            m.value = m.value + x;
        }
        var B = (0, $aAzpa.computed)(function() {
            var x = function x() {
                m.value = d.value, d.value = null;
            };
            return {
                "onUpdate:modelValue": function(k) {
                    d.value = k;
                },
                onKeyup: function(k) {
                    wt(k, 13) === !0 && x();
                },
                onBlur: x
            };
        });
        function q(x, k, j) {
            var Q = (0, $8pZMQ._)({
                "aria-label": k,
                "aria-current": "false"
            }, S.value, x);
            return j === !0 && Object.assign(Q, (0, $8pZMQ._)({
                "aria-current": "true"
            }, $.value)), k !== void 0 && (e.toFn !== void 0 ? Q.to = e.toFn(k) : Q.onClick = function() {
                E(k);
            }), (0, $aD8ZA.h)(Le, Q);
        }
        return Object.assign(o, {
            set: E,
            setByOffset: A
        }), function() {
            var x = [], k = [], j;
            if (c.value === !0 && (x.push(q({
                key: "bls",
                disable: e.disable || e.modelValue <= i.value,
                icon: b.value[0]
            }, i.value)), k.unshift(q({
                key: "ble",
                disable: e.disable || e.modelValue >= a.value,
                icon: b.value[3]
            }, a.value))), v.value === !0 && (x.push(q({
                key: "bdp",
                disable: e.disable || e.modelValue <= i.value,
                icon: b.value[1]
            }, e.modelValue - 1)), k.unshift(q({
                key: "bdn",
                disable: e.disable || e.modelValue >= a.value,
                icon: b.value[2]
            }, e.modelValue + 1))), e.input !== !0) {
                j = [];
                var _L_value = L.value, Q = _L_value.pgFrom, w = _L_value.pgTo, H = _L_value.marginalStyle;
                if (L.value.boundaryStart === !0) {
                    var W = i.value === e.modelValue;
                    x.push(q({
                        key: "bns",
                        style: H,
                        disable: e.disable,
                        label: i.value
                    }, i.value, W));
                }
                if (L.value.boundaryEnd === !0) {
                    var W1 = a.value === e.modelValue;
                    k.unshift(q({
                        key: "bne",
                        style: H,
                        disable: e.disable,
                        label: a.value
                    }, a.value, W1));
                }
                L.value.ellipsesStart === !0 && x.push(q({
                    key: "bes",
                    style: H,
                    disable: e.disable,
                    label: "\u2026",
                    ripple: !1
                }, Q - 1)), L.value.ellipsesEnd === !0 && k.unshift(q({
                    key: "bee",
                    style: H,
                    disable: e.disable,
                    label: "\u2026",
                    ripple: !1
                }, w + 1));
                for(var W2 = Q; W2 <= w; W2++)j.push(q({
                    key: "bpg".concat(W2),
                    style: H,
                    disable: e.disable,
                    label: W2
                }, W2, W2 === e.modelValue));
            }
            return (0, $aD8ZA.h)("div", (0, $8pZMQ._)({
                class: y.value
            }, h.value), [
                (0, $aD8ZA.h)("div", {
                    class: "q-pagination__content row no-wrap items-center",
                    style: C.value
                }, (0, $79xu7._)(x).concat([
                    e.input === !0 ? (0, $aD8ZA.h)(da, (0, $8pZMQ._)({
                        class: "inline",
                        style: {
                            width: "".concat(s.value.length / 1.5, "em")
                        },
                        type: "number",
                        dense: !0,
                        value: d.value,
                        disable: e.disable,
                        dark: n.value,
                        borderless: !0,
                        inputClass: e.inputClass,
                        inputStyle: e.inputStyle,
                        placeholder: s.value,
                        min: i.value,
                        max: a.value
                    }, B.value)) : (0, $aD8ZA.h)("div", {
                        class: "q-pagination__middle row justify-center"
                    }, j)
                ], (0, $79xu7._)(k)))
            ]);
        };
    }
});
function cl(e) {
    var t = !1, o, r;
    function n() {
        var _this = this;
        r = arguments, t !== !0 && (t = !0, o = window.requestAnimationFrame(function() {
            e.apply(_this, r), r = void 0, t = !1;
        }));
    }
    return n.cancel = function() {
        window.cancelAnimationFrame(o), t = !1;
    }, n;
}
var ns = Xe.passive, wg = R({
    name: "QParallax",
    props: {
        src: String,
        height: {
            type: Number,
            default: 500
        },
        speed: {
            type: Number,
            default: 1,
            validator: function(e) {
                return e >= 0 && e <= 1;
            }
        },
        scrollTarget: {
            default: void 0
        },
        onScroll: Function
    },
    setup: function(e, param) {
        var t = param.slots, o = param.emit;
        var r = (0, $aAzpa.ref)(0), n = (0, $aAzpa.ref)(null), i = (0, $aAzpa.ref)(null), a = (0, $aAzpa.ref)(null), l, s, c, u, v, f;
        (0, $aD8ZA.watch)(function() {
            return e.height;
        }, function() {
            l === !0 && m();
        }), (0, $aD8ZA.watch)(function() {
            return e.scrollTarget;
        }, function() {
            l === !0 && (b(), C());
        });
        var d = function(h) {
            r.value = h, e.onScroll !== void 0 && o("scroll", h);
        };
        function m() {
            var h, g, S;
            f === window ? (h = 0, S = g = window.innerHeight) : (h = Tr(f).top, g = nn(f), S = h + g);
            var P = Tr(n.value).top, $ = P + e.height;
            if (v !== void 0 || $ > h && P < S) {
                var L = (S - P) / (e.height + g);
                y((c - e.height) * L * e.speed), d(L);
            }
        }
        var y = function(h) {
            s.style.transform = "translate3d(-50%,".concat(Math.round(h), "px,0)");
        };
        function p() {
            c = s.naturalHeight || s.videoHeight || nn(s), l === !0 && m();
        }
        function C() {
            l = !0, f = At(n.value, e.scrollTarget), f.addEventListener("scroll", m, ns), window.addEventListener("resize", u, ns), m();
        }
        function b() {
            l === !0 && (l = !1, f.removeEventListener("scroll", m, ns), window.removeEventListener("resize", u, ns), f = void 0, y.cancel(), d.cancel(), u.cancel());
        }
        return (0, $aD8ZA.onMounted)(function() {
            y = cl(y), d = cl(d), u = cl(p), s = t.media !== void 0 ? i.value.children[0] : a.value, s.onload = s.onloadstart = s.loadedmetadata = p, p(), s.style.display = "initial", window.IntersectionObserver !== void 0 ? (v = new IntersectionObserver(function(h) {
                (h[0].isIntersecting === !0 ? C : b)();
            }), v.observe(n.value)) : C();
        }), (0, $aD8ZA.onBeforeUnmount)(function() {
            b(), v !== void 0 && v.disconnect(), s.onload = s.onloadstart = s.loadedmetadata = null;
        }), function() {
            return (0, $aD8ZA.h)("div", {
                ref: n,
                class: "q-parallax",
                style: {
                    height: "".concat(e.height, "px")
                }
            }, [
                (0, $aD8ZA.h)("div", {
                    ref: i,
                    class: "q-parallax__media absolute-full"
                }, t.media !== void 0 ? t.media() : [
                    (0, $aD8ZA.h)("img", {
                        ref: a,
                        src: e.src
                    })
                ]),
                (0, $aD8ZA.h)("div", {
                    class: "q-parallax__content absolute-full column flex-center"
                }, t.content !== void 0 ? t.content({
                    percentScrolled: r.value
                }) : J(t.default))
            ]);
        };
    }
});
function pr(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new WeakMap;
    var _Object;
    if (Object(e) !== e) return e;
    if (t.has(e)) return t.get(e);
    var o = e instanceof Date ? new Date(e) : e instanceof RegExp ? new RegExp(e.source, e.flags) : e instanceof Set ? new Set : e instanceof Map ? new Map : typeof e.constructor != "function" ? Object.create(null) : e.prototype !== void 0 && typeof e.prototype.constructor == "function" ? e : new e.constructor;
    if (typeof e.constructor == "function" && typeof e.valueOf == "function") {
        var r = e.valueOf();
        if (Object(r) !== r) {
            var n = new e.constructor(r);
            return t.set(e, n), n;
        }
    }
    return t.set(e, o), e instanceof Set ? e.forEach(function(r) {
        o.add(pr(r, t));
    }) : e instanceof Map && e.forEach(function(r, n) {
        o.set(n, pr(r, t));
    }), (_Object = Object).assign.apply(_Object, [
        o
    ].concat((0, $79xu7._)(Object.keys(e).map(function(r) {
        return {
            [r]: pr(e[r], t)
        };
    }))));
}
var kg = R({
    name: "QPopupEdit",
    props: {
        modelValue: {
            required: !0
        },
        title: String,
        buttons: Boolean,
        labelSet: String,
        labelCancel: String,
        color: {
            type: String,
            default: "primary"
        },
        validate: {
            type: Function,
            default: function() {
                return !0;
            }
        },
        autoSave: Boolean,
        cover: {
            type: Boolean,
            default: !0
        },
        disable: Boolean
    },
    emits: [
        "update:modelValue",
        "save",
        "cancel",
        "beforeShow",
        "show",
        "beforeHide",
        "hide"
    ],
    setup: function(e, param) {
        var t = param.slots, o = param.emit;
        var _pC = (0, $aD8ZA.getCurrentInstance)(), r = _pC.proxy, n = r.$q, i = (0, $aAzpa.ref)(null), a = (0, $aAzpa.ref)(""), l = (0, $aAzpa.ref)(""), s = !1, c = (0, $aAzpa.computed)(function() {
            return it({
                initialValue: a.value,
                validate: e.validate,
                set: u,
                cancel: v,
                updatePosition: f
            }, "value", function() {
                return l.value;
            }, function(g) {
                l.value = g;
            });
        });
        function u() {
            e.validate(l.value) !== !1 && (d() === !0 && (o("save", l.value, a.value), o("update:modelValue", l.value)), m());
        }
        function v() {
            d() === !0 && o("cancel", l.value, a.value), m();
        }
        function f() {
            (0, $aD8ZA.nextTick)(function() {
                i.value.updatePosition();
            });
        }
        function d() {
            return Zt(l.value, a.value) === !1;
        }
        function m() {
            s = !0, i.value.hide();
        }
        function y() {
            s = !1, a.value = pr(e.modelValue), l.value = pr(e.modelValue), o("beforeShow");
        }
        function p() {
            o("show");
        }
        function C() {
            s === !1 && d() === !0 && (e.autoSave === !0 && e.validate(l.value) === !0 ? (o("save", l.value, a.value), o("update:modelValue", l.value)) : o("cancel", l.value, a.value)), o("beforeHide");
        }
        function b() {
            o("hide");
        }
        function h() {
            var g = t.default !== void 0 ? [].concat(t.default(c.value)) : [];
            return e.title && g.unshift((0, $aD8ZA.h)("div", {
                class: "q-dialog__title q-mt-sm q-mb-sm"
            }, e.title)), e.buttons === !0 && g.push((0, $aD8ZA.h)("div", {
                class: "q-popup-edit__buttons row justify-center no-wrap"
            }, [
                (0, $aD8ZA.h)(Le, {
                    flat: !0,
                    color: e.color,
                    label: e.labelCancel || n.lang.label.cancel,
                    onClick: v
                }),
                (0, $aD8ZA.h)(Le, {
                    flat: !0,
                    color: e.color,
                    label: e.labelSet || n.lang.label.set,
                    onClick: u
                })
            ])), g;
        }
        return Object.assign(r, {
            set: u,
            cancel: v,
            show: function(g) {
                i.value !== null && i.value.show(g);
            },
            hide: function(g) {
                i.value !== null && i.value.hide(g);
            },
            updatePosition: f
        }), function() {
            if (e.disable !== !0) return (0, $aD8ZA.h)(sn, {
                ref: i,
                class: "q-popup-edit",
                cover: e.cover,
                onBeforeShow: y,
                onShow: p,
                onBeforeHide: C,
                onHide: b,
                onEscapeKey: v
            }, h);
        };
    }
});
var Tg = R({
    name: "QPopupProxy",
    props: (0, $8typN._)((0, $8pZMQ._)({}, hi), {
        breakpoint: {
            type: [
                String,
                Number
            ],
            default: 450
        }
    }),
    emits: [
        "show",
        "hide"
    ],
    setup: function(e, param) {
        var t = param.slots, o = param.emit, r = param.attrs;
        var _SC = (0, $aD8ZA.getCurrentInstance)(), n = _SC.proxy, i = n.$q, a = (0, $aAzpa.ref)(!1), l = (0, $aAzpa.ref)(null), s = (0, $aAzpa.computed)(function() {
            return parseInt(e.breakpoint, 10);
        }), _pi = pi({
            showing: a
        }), c = _pi.canShow;
        function u() {
            return i.screen.width < s.value || i.screen.height < s.value ? "dialog" : "menu";
        }
        var v = (0, $aAzpa.ref)(u()), f = (0, $aAzpa.computed)(function() {
            return v.value === "menu" ? {
                maxHeight: "99vh"
            } : {};
        });
        (0, $aD8ZA.watch)(function() {
            return u();
        }, function(y) {
            a.value !== !0 && (v.value = y);
        });
        function d(y) {
            a.value = !0, o("show", y);
        }
        function m(y) {
            a.value = !1, v.value = u(), o("hide", y);
        }
        return Object.assign(n, {
            show: function(y) {
                c(y) === !0 && l.value.show(y);
            },
            hide: function(y) {
                l.value.hide(y);
            },
            toggle: function(y) {
                l.value.toggle(y);
            }
        }), it(n, "currentComponent", function() {
            return {
                type: v.value,
                ref: l.value
            };
        }), function() {
            var y = (0, $8typN._)((0, $8pZMQ._)({
                ref: l
            }, f.value, r), {
                onShow: d,
                onHide: m
            }), p;
            return v.value === "dialog" ? p = gn : (p = sn, Object.assign(y, {
                target: e.target,
                contextMenu: e.contextMenu,
                noParentEvent: !0,
                separateClosePopup: !0
            })), (0, $aD8ZA.h)(p, y, t.default);
        };
    }
});
var _C = {
    xs: 2,
    sm: 4,
    md: 6,
    lg: 10,
    xl: 14
};
function Mg(e, t, o) {
    return {
        transform: t === !0 ? "translateX(".concat(o.lang.rtl === !0 ? "-" : "", "100%) scale3d(").concat(-e, ",1,1)") : "scale3d(".concat(e, ",1,1)")
    };
}
var is = R({
    name: "QLinearProgress",
    props: (0, $8typN._)((0, $8pZMQ._)({}, he, Ot), {
        value: {
            type: Number,
            default: 0
        },
        buffer: Number,
        color: String,
        trackColor: String,
        reverse: Boolean,
        stripe: Boolean,
        indeterminate: Boolean,
        query: Boolean,
        rounded: Boolean,
        animationSpeed: {
            type: [
                String,
                Number
            ],
            default: 2100
        },
        instantFeedback: Boolean
    }),
    setup: function(e, param) {
        var t = param.slots;
        var _xC = (0, $aD8ZA.getCurrentInstance)(), o = _xC.proxy, r = pe(e, o.$q), n = It(e, _C), i = (0, $aAzpa.computed)(function() {
            return e.indeterminate === !0 || e.query === !0;
        }), a = (0, $aAzpa.computed)(function() {
            return e.reverse !== e.query;
        }), l = (0, $aAzpa.computed)(function() {
            return (0, $8typN._)((0, $8pZMQ._)({}, n.value !== null ? n.value : {}), {
                "--q-linear-progress-speed": "".concat(e.animationSpeed, "ms")
            });
        }), s = (0, $aAzpa.computed)(function() {
            return "q-linear-progress" + (e.color !== void 0 ? " text-".concat(e.color) : "") + (e.reverse === !0 || e.query === !0 ? " q-linear-progress--reverse" : "") + (e.rounded === !0 ? " rounded-borders" : "");
        }), c = (0, $aAzpa.computed)(function() {
            return Mg(e.buffer !== void 0 ? e.buffer : 1, a.value, o.$q);
        }), u = (0, $aAzpa.computed)(function() {
            return "with".concat(e.instantFeedback === !0 ? "out" : "", "-transition");
        }), v = (0, $aAzpa.computed)(function() {
            return "q-linear-progress__track absolute-full q-linear-progress__track--".concat(u.value, " q-linear-progress__track--").concat(r.value === !0 ? "dark" : "light") + (e.trackColor !== void 0 ? " bg-".concat(e.trackColor) : "");
        }), f = (0, $aAzpa.computed)(function() {
            return Mg(i.value === !0 ? 1 : e.value, a.value, o.$q);
        }), d = (0, $aAzpa.computed)(function() {
            return "q-linear-progress__model absolute-full q-linear-progress__model--".concat(u.value, " q-linear-progress__model--").concat(i.value === !0 ? "in" : "", "determinate");
        }), m = (0, $aAzpa.computed)(function() {
            return {
                width: "".concat(e.value * 100, "%")
            };
        }), y = (0, $aAzpa.computed)(function() {
            return "q-linear-progress__stripe absolute-".concat(e.reverse === !0 ? "right" : "left", " q-linear-progress__stripe--").concat(u.value);
        });
        return function() {
            var p = [
                (0, $aD8ZA.h)("div", {
                    class: v.value,
                    style: c.value
                }),
                (0, $aD8ZA.h)("div", {
                    class: d.value,
                    style: f.value
                })
            ];
            return e.stripe === !0 && i.value === !1 && p.push((0, $aD8ZA.h)("div", {
                class: y.value,
                style: m.value
            })), (0, $aD8ZA.h)("div", {
                class: s.value,
                style: l.value,
                role: "progressbar",
                "aria-valuemin": 0,
                "aria-valuemax": 1,
                "aria-valuenow": e.indeterminate === !0 ? void 0 : e.value
            }, Ke(t.default, p));
        };
    }
});
var ha = 40, dd = 20, Rg = R({
    name: "QPullToRefresh",
    props: {
        color: String,
        bgColor: String,
        icon: String,
        noMouse: Boolean,
        disable: Boolean,
        scrollTarget: {
            default: void 0
        }
    },
    emits: [
        "refresh"
    ],
    setup: function(e, param) {
        var t = param.slots, o = param.emit;
        var _qC = (0, $aD8ZA.getCurrentInstance)(), r = _qC.proxy, n = r.$q, i = (0, $aAzpa.ref)("pull"), a = (0, $aAzpa.ref)(0), l = (0, $aAzpa.ref)(!1), s = (0, $aAzpa.ref)(-ha), c = (0, $aAzpa.ref)(!1), u = (0, $aAzpa.ref)({}), v = (0, $aAzpa.computed)(function() {
            return {
                opacity: a.value,
                transform: "translateY(".concat(s.value, "px) rotate(").concat(a.value * 360, "deg)")
            };
        }), f = (0, $aAzpa.computed)(function() {
            return "q-pull-to-refresh__puller row flex-center" + (c.value === !0 ? " q-pull-to-refresh__puller--animating" : "") + (e.bgColor !== void 0 ? " bg-".concat(e.bgColor) : "");
        });
        function d(P) {
            if (P.isFinal === !0) {
                l.value === !0 && (l.value = !1, i.value === "pulled" ? (i.value = "refreshing", g({
                    pos: dd
                }), p()) : i.value === "pull" && g({
                    pos: -ha,
                    ratio: 0
                }));
                return;
            }
            if (c.value === !0 || i.value === "refreshing") return !1;
            if (P.isFirst === !0) {
                if (fo(b) !== 0 || P.direction !== "down") return l.value === !0 && (l.value = !1, i.value = "pull", g({
                    pos: -ha,
                    ratio: 0
                })), !1;
                l.value = !0;
                var _C_getBoundingClientRect = C.getBoundingClientRect(), E = _C_getBoundingClientRect.top, A = _C_getBoundingClientRect.left;
                u.value = {
                    top: E + "px",
                    left: A + "px",
                    width: window.getComputedStyle(C).getPropertyValue("width")
                };
            }
            ut(P.evt);
            var $ = Math.min(140, Math.max(0, P.distance.y));
            s.value = $ - ha, a.value = Ze($ / (dd + ha), 0, 1);
            var L = s.value > dd ? "pulled" : "pull";
            i.value !== L && (i.value = L);
        }
        var m = (0, $aAzpa.computed)(function() {
            var P = {
                down: !0
            };
            return e.noMouse !== !0 && (P.mouse = !0), [
                [
                    qt,
                    d,
                    void 0,
                    P
                ]
            ];
        }), y = (0, $aAzpa.computed)(function() {
            return "q-pull-to-refresh__content".concat(l.value === !0 ? " no-pointer-events" : "");
        });
        function p() {
            o("refresh", function() {
                g({
                    pos: -ha,
                    ratio: 0
                }, function() {
                    i.value = "pull";
                });
            });
        }
        var C, b, h = null;
        function g(param, L) {
            var P = param.pos, $ = param.ratio;
            c.value = !0, s.value = P, $ !== void 0 && (a.value = $), h !== null && clearTimeout(h), h = setTimeout(function() {
                h = null, c.value = !1, L && L();
            }, 300);
        }
        function S() {
            b = At(C, e.scrollTarget);
        }
        return (0, $aD8ZA.watch)(function() {
            return e.scrollTarget;
        }, S), (0, $aD8ZA.onMounted)(function() {
            C = r.$el, S();
        }), (0, $aD8ZA.onBeforeUnmount)(function() {
            h !== null && clearTimeout(h);
        }), Object.assign(r, {
            trigger: p,
            updateScrollTarget: S
        }), function() {
            var P = [
                (0, $aD8ZA.h)("div", {
                    class: y.value
                }, J(t.default)),
                (0, $aD8ZA.h)("div", {
                    class: "q-pull-to-refresh__puller-container fixed row flex-center no-pointer-events z-top",
                    style: u.value
                }, [
                    (0, $aD8ZA.h)("div", {
                        class: f.value,
                        style: v.value
                    }, [
                        i.value !== "refreshing" ? (0, $aD8ZA.h)(we, {
                            name: e.icon || n.iconSet.pullToRefresh.icon,
                            color: e.color,
                            size: "32px"
                        }) : (0, $aD8ZA.h)(xt, {
                            size: "24px",
                            color: e.color
                        })
                    ])
                ])
            ];
            return kt("div", {
                class: "q-pull-to-refresh"
            }, P, "main", e.disable === !1, function() {
                return m.value;
            });
        };
    }
});
var br = {
    MIN: 0,
    RANGE: 1,
    MAX: 2
}, Pg = R({
    name: "QRange",
    props: (0, $8typN._)((0, $8pZMQ._)({}, ou), {
        modelValue: {
            type: Object,
            default: function() {
                return {
                    min: null,
                    max: null
                };
            },
            validator: function(e) {
                return "min" in e && "max" in e;
            }
        },
        dragRange: Boolean,
        dragOnlyRange: Boolean,
        leftLabelColor: String,
        leftLabelTextColor: String,
        rightLabelColor: String,
        rightLabelTextColor: String,
        leftLabelValue: [
            String,
            Number
        ],
        rightLabelValue: [
            String,
            Number
        ],
        leftThumbColor: String,
        rightThumbColor: String
    }),
    emits: nu,
    setup: function(e, param) {
        var t = param.emit;
        var _RC = (0, $aD8ZA.getCurrentInstance)(), _RC_proxy = _RC.proxy, o = _RC_proxy.$q, _ru = ru({
            updateValue: L,
            updatePosition: A,
            getDragging: E,
            formAttrs: (0, $aAzpa.computed)(function() {
                return {
                    type: "hidden",
                    name: e.name,
                    value: "".concat(e.modelValue.min, "|").concat(e.modelValue.max)
                };
            })
        }), r = _ru.state, n = _ru.methods, i = (0, $aAzpa.ref)(null), a = (0, $aAzpa.ref)(0), l = (0, $aAzpa.ref)(0), s = (0, $aAzpa.ref)({
            min: 0,
            max: 0
        });
        function c() {
            s.value.min = e.modelValue.min === null ? r.innerMin.value : Ze(e.modelValue.min, r.innerMin.value, r.innerMax.value), s.value.max = e.modelValue.max === null ? r.innerMax.value : Ze(e.modelValue.max, r.innerMin.value, r.innerMax.value);
        }
        (0, $aD8ZA.watch)(function() {
            return "".concat(e.modelValue.min, "|").concat(e.modelValue.max, "|").concat(r.innerMin.value, "|").concat(r.innerMax.value);
        }, c), c();
        var u = (0, $aAzpa.computed)(function() {
            return n.convertModelToRatio(s.value.min);
        }), v = (0, $aAzpa.computed)(function() {
            return n.convertModelToRatio(s.value.max);
        }), f = (0, $aAzpa.computed)(function() {
            return r.active.value === !0 ? a.value : u.value;
        }), d = (0, $aAzpa.computed)(function() {
            return r.active.value === !0 ? l.value : v.value;
        }), m = (0, $aAzpa.computed)(function() {
            var q = {
                [r.positionProp.value]: "".concat(100 * f.value, "%"),
                [r.sizeProp.value]: "".concat(100 * (d.value - f.value), "%")
            };
            return e.selectionImg !== void 0 && (q.backgroundImage = "url(".concat(e.selectionImg, ") !important")), q;
        }), y = (0, $aAzpa.computed)(function() {
            if (r.editable.value !== !0) return {};
            if (o.platform.is.mobile === !0) return {
                onClick: n.onMobileClick
            };
            var q = {
                onMousedown: n.onActivate
            };
            return (e.dragRange === !0 || e.dragOnlyRange === !0) && Object.assign(q, {
                onFocus: function() {
                    r.focus.value = "both";
                },
                onBlur: n.onBlur,
                onKeydown: B,
                onKeyup: n.onKeyup
            }), q;
        });
        function p(q) {
            return o.platform.is.mobile !== !0 && r.editable.value === !0 && e.dragOnlyRange !== !0 ? {
                onFocus: function() {
                    r.focus.value = q;
                },
                onBlur: n.onBlur,
                onKeydown: B,
                onKeyup: n.onKeyup
            } : {};
        }
        var C = (0, $aAzpa.computed)(function() {
            return e.dragOnlyRange !== !0 ? r.tabindex.value : null;
        }), b = (0, $aAzpa.computed)(function() {
            return o.platform.is.mobile !== !0 && (e.dragRange || e.dragOnlyRange === !0) ? r.tabindex.value : null;
        }), h = (0, $aAzpa.ref)(null), g = (0, $aAzpa.computed)(function() {
            return p("min");
        }), S = n.getThumbRenderFn({
            focusValue: "min",
            getNodeData: function() {
                return (0, $8typN._)((0, $8pZMQ._)({
                    ref: h,
                    key: "tmin"
                }, g.value), {
                    tabindex: C.value
                });
            },
            ratio: f,
            label: (0, $aAzpa.computed)(function() {
                return e.leftLabelValue !== void 0 ? e.leftLabelValue : s.value.min;
            }),
            thumbColor: (0, $aAzpa.computed)(function() {
                return e.leftThumbColor || e.thumbColor || e.color;
            }),
            labelColor: (0, $aAzpa.computed)(function() {
                return e.leftLabelColor || e.labelColor;
            }),
            labelTextColor: (0, $aAzpa.computed)(function() {
                return e.leftLabelTextColor || e.labelTextColor;
            })
        }), P = (0, $aAzpa.computed)(function() {
            return p("max");
        }), $ = n.getThumbRenderFn({
            focusValue: "max",
            getNodeData: function() {
                return (0, $8typN._)((0, $8pZMQ._)({}, P.value), {
                    key: "tmax",
                    tabindex: C.value
                });
            },
            ratio: d,
            label: (0, $aAzpa.computed)(function() {
                return e.rightLabelValue !== void 0 ? e.rightLabelValue : s.value.max;
            }),
            thumbColor: (0, $aAzpa.computed)(function() {
                return e.rightThumbColor || e.thumbColor || e.color;
            }),
            labelColor: (0, $aAzpa.computed)(function() {
                return e.rightLabelColor || e.labelColor;
            }),
            labelTextColor: (0, $aAzpa.computed)(function() {
                return e.rightLabelTextColor || e.labelTextColor;
            })
        });
        function L(q) {
            (s.value.min !== e.modelValue.min || s.value.max !== e.modelValue.max) && t("update:modelValue", (0, $8pZMQ._)({}, s.value)), q === !0 && t("change", (0, $8pZMQ._)({}, s.value));
        }
        function E(q) {
            var _i_value_getBoundingClientRect = i.value.getBoundingClientRect(), x = _i_value_getBoundingClientRect.left, k = _i_value_getBoundingClientRect.top, j = _i_value_getBoundingClientRect.width, Q = _i_value_getBoundingClientRect.height, w = e.dragOnlyRange === !0 ? 0 : e.vertical === !0 ? h.value.offsetHeight / (2 * Q) : h.value.offsetWidth / (2 * j), H = {
                left: x,
                top: k,
                width: j,
                height: Q,
                valueMin: s.value.min,
                valueMax: s.value.max,
                ratioMin: u.value,
                ratioMax: v.value
            }, W = n.getDraggingRatio(q, H);
            return e.dragOnlyRange !== !0 && W < H.ratioMin + w ? H.type = br.MIN : e.dragOnlyRange === !0 || W < H.ratioMax - w ? e.dragRange === !0 || e.dragOnlyRange === !0 ? (H.type = br.RANGE, Object.assign(H, {
                offsetRatio: W,
                offsetModel: n.convertRatioToModel(W),
                rangeValue: H.valueMax - H.valueMin,
                rangeRatio: H.ratioMax - H.ratioMin
            })) : H.type = H.ratioMax - W < W - H.ratioMin ? br.MAX : br.MIN : H.type = br.MAX, H;
        }
        function A(q) {
            var x = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : r.dragging.value;
            var k, j = n.getDraggingRatio(q, x), Q = n.convertRatioToModel(j);
            switch(x.type){
                case br.MIN:
                    j <= x.ratioMax ? (k = {
                        minR: j,
                        maxR: x.ratioMax,
                        min: Q,
                        max: x.valueMax
                    }, r.focus.value = "min") : (k = {
                        minR: x.ratioMax,
                        maxR: j,
                        min: x.valueMax,
                        max: Q
                    }, r.focus.value = "max");
                    break;
                case br.MAX:
                    j >= x.ratioMin ? (k = {
                        minR: x.ratioMin,
                        maxR: j,
                        min: x.valueMin,
                        max: Q
                    }, r.focus.value = "max") : (k = {
                        minR: j,
                        maxR: x.ratioMin,
                        min: Q,
                        max: x.valueMin
                    }, r.focus.value = "min");
                    break;
                case br.RANGE:
                    var w = j - x.offsetRatio, H = Ze(x.ratioMin + w, r.innerMinRatio.value, r.innerMaxRatio.value - x.rangeRatio), W = Q - x.offsetModel, ie = Ze(x.valueMin + W, r.innerMin.value, r.innerMax.value - x.rangeValue);
                    k = {
                        minR: H,
                        maxR: H + x.rangeRatio,
                        min: r.roundValueFn.value(ie),
                        max: r.roundValueFn.value(ie + x.rangeValue)
                    }, r.focus.value = "both";
                    break;
            }
            s.value = s.value.min === null || s.value.max === null ? {
                min: k.min || e.min,
                max: k.max || e.max
            } : {
                min: k.min,
                max: k.max
            }, e.snap !== !0 || e.step === 0 ? (a.value = k.minR, l.value = k.maxR) : (a.value = n.convertModelToRatio(s.value.min), l.value = n.convertModelToRatio(s.value.max));
        }
        function B(q) {
            if (!Ia.includes(q.keyCode)) return;
            Se(q);
            var x = ([
                34,
                33
            ].includes(q.keyCode) ? 10 : 1) * r.keyStep.value, k = ([
                34,
                37,
                40
            ].includes(q.keyCode) ? -1 : 1) * (r.isReversed.value === !0 ? -1 : 1) * (e.vertical === !0 ? -1 : 1) * x;
            if (r.focus.value === "both") {
                var j = s.value.max - s.value.min, Q = Ze(r.roundValueFn.value(s.value.min + k), r.innerMin.value, r.innerMax.value - j);
                s.value = {
                    min: Q,
                    max: r.roundValueFn.value(Q + j)
                };
            } else {
                if (r.focus.value === !1) return;
                {
                    var j1 = r.focus.value;
                    s.value = (0, $8typN._)((0, $8pZMQ._)({}, s.value), {
                        [j1]: Ze(r.roundValueFn.value(s.value[j1] + k), j1 === "min" ? r.innerMin.value : s.value.min, j1 === "max" ? r.innerMax.value : s.value.max)
                    });
                }
            }
            L();
        }
        return function() {
            var q = n.getContent(m, b, y, function(x) {
                x.push(S(), $());
            });
            return (0, $aD8ZA.h)("div", (0, $8typN._)((0, $8pZMQ._)({
                ref: i,
                class: "q-range " + r.classes.value + (e.modelValue.min === null || e.modelValue.max === null ? " q-slider--no-value" : "")
            }, r.attributes.value), {
                "aria-valuenow": e.modelValue.min + "|" + e.modelValue.max
            }), q);
        };
    }
});
var Ag = R({
    name: "QRating",
    props: (0, $8typN._)((0, $8pZMQ._)({}, Ot, _t), {
        modelValue: {
            type: Number,
            required: !0
        },
        max: {
            type: [
                String,
                Number
            ],
            default: 5
        },
        icon: [
            String,
            Array
        ],
        iconHalf: [
            String,
            Array
        ],
        iconSelected: [
            String,
            Array
        ],
        iconAriaLabel: [
            String,
            Array
        ],
        color: [
            String,
            Array
        ],
        colorHalf: [
            String,
            Array
        ],
        colorSelected: [
            String,
            Array
        ],
        noReset: Boolean,
        noDimming: Boolean,
        readonly: Boolean,
        disable: Boolean
    }),
    emits: [
        "update:modelValue"
    ],
    setup: function(e, param) {
        var t = param.slots, o = param.emit;
        var _$C = (0, $aD8ZA.getCurrentInstance)(), _$C_proxy = _$C.proxy, r = _$C_proxy.$q, n = It(e), i = cn(e), a = eo(i), l = (0, $aAzpa.ref)(0), s = {}, c = (0, $aAzpa.computed)(function() {
            return e.readonly !== !0 && e.disable !== !0;
        }), u = (0, $aAzpa.computed)(function() {
            return "q-rating row inline items-center q-rating--".concat(c.value === !0 ? "" : "non-", "editable") + (e.noDimming === !0 ? " q-rating--no-dimming" : "") + (e.disable === !0 ? " disabled" : "") + (e.color !== void 0 && Array.isArray(e.color) === !1 ? " text-".concat(e.color) : "");
        }), v = (0, $aAzpa.computed)(function() {
            var h = Array.isArray(e.icon) === !0 ? e.icon.length : 0, g = Array.isArray(e.iconSelected) === !0 ? e.iconSelected.length : 0, S = Array.isArray(e.iconHalf) === !0 ? e.iconHalf.length : 0, P = Array.isArray(e.color) === !0 ? e.color.length : 0, $ = Array.isArray(e.colorSelected) === !0 ? e.colorSelected.length : 0, L = Array.isArray(e.colorHalf) === !0 ? e.colorHalf.length : 0;
            return {
                iconLen: h,
                icon: h > 0 ? e.icon[h - 1] : e.icon,
                selIconLen: g,
                selIcon: g > 0 ? e.iconSelected[g - 1] : e.iconSelected,
                halfIconLen: S,
                halfIcon: S > 0 ? e.iconHalf[g - 1] : e.iconHalf,
                colorLen: P,
                color: P > 0 ? e.color[P - 1] : e.color,
                selColorLen: $,
                selColor: $ > 0 ? e.colorSelected[$ - 1] : e.colorSelected,
                halfColorLen: L,
                halfColor: L > 0 ? e.colorHalf[L - 1] : e.colorHalf
            };
        }), f = (0, $aAzpa.computed)(function() {
            if (typeof e.iconAriaLabel == "string") {
                var h = e.iconAriaLabel.length !== 0 ? "".concat(e.iconAriaLabel, " ") : "";
                return function(g) {
                    return "".concat(h).concat(g);
                };
            }
            if (Array.isArray(e.iconAriaLabel) === !0) {
                var h1 = e.iconAriaLabel.length;
                if (h1 > 0) return function(g) {
                    return e.iconAriaLabel[Math.min(g, h1) - 1];
                };
            }
            return function(h, g) {
                return "".concat(g, " ").concat(h);
            };
        }), d = (0, $aAzpa.computed)(function() {
            var h = [], g = v.value, S = Math.ceil(e.modelValue), P = c.value === !0 ? 0 : null, $ = e.iconHalf === void 0 || S === e.modelValue ? -1 : S;
            for(var L = 1; L <= e.max; L++){
                var E = l.value === 0 && e.modelValue >= L || l.value > 0 && l.value >= L, A = $ === L && l.value < L, B = l.value > 0 && (A === !0 ? S : e.modelValue) >= L && l.value < L, q = A === !0 ? L <= g.halfColorLen ? e.colorHalf[L - 1] : g.halfColor : g.selColor !== void 0 && E === !0 ? L <= g.selColorLen ? e.colorSelected[L - 1] : g.selColor : L <= g.colorLen ? e.color[L - 1] : g.color, x = (A === !0 ? L <= g.halfIconLen ? e.iconHalf[L - 1] : g.halfIcon : g.selIcon !== void 0 && (E === !0 || B === !0) ? L <= g.selIconLen ? e.iconSelected[L - 1] : g.selIcon : L <= g.iconLen ? e.icon[L - 1] : g.icon) || r.iconSet.rating.icon;
                h.push({
                    name: (A === !0 ? L <= g.halfIconLen ? e.iconHalf[L - 1] : g.halfIcon : g.selIcon !== void 0 && (E === !0 || B === !0) ? L <= g.selIconLen ? e.iconSelected[L - 1] : g.selIcon : L <= g.iconLen ? e.icon[L - 1] : g.icon) || r.iconSet.rating.icon,
                    attrs: {
                        tabindex: P,
                        role: "radio",
                        "aria-checked": e.modelValue === L ? "true" : "false",
                        "aria-label": f.value(L, x)
                    },
                    iconClass: "q-rating__icon" + (E === !0 || A === !0 ? " q-rating__icon--active" : "") + (B === !0 ? " q-rating__icon--exselected" : "") + (l.value === L ? " q-rating__icon--hovered" : "") + (q !== void 0 ? " text-".concat(q) : "")
                });
            }
            return h;
        }), m = (0, $aAzpa.computed)(function() {
            var h = {
                role: "radiogroup"
            };
            return e.disable === !0 && (h["aria-disabled"] = "true"), e.readonly === !0 && (h["aria-readonly"] = "true"), h;
        });
        function y(h) {
            if (c.value === !0) {
                var g = Ze(parseInt(h, 10), 1, parseInt(e.max, 10)), S = e.noReset !== !0 && e.modelValue === g ? 0 : g;
                S !== e.modelValue && o("update:modelValue", S), l.value = 0;
            }
        }
        function p(h) {
            c.value === !0 && (l.value = h);
        }
        function C(h, g) {
            switch(h.keyCode){
                case 13:
                case 32:
                    return y(g), Se(h);
                case 37:
                case 40:
                    return s["rt".concat(g - 1)] && s["rt".concat(g - 1)].focus(), Se(h);
                case 39:
                case 38:
                    return s["rt".concat(g + 1)] && s["rt".concat(g + 1)].focus(), Se(h);
            }
        }
        function b() {
            l.value = 0;
        }
        return (0, $aD8ZA.onBeforeUpdate)(function() {
            s = {};
        }), function() {
            var h = [];
            return d.value.forEach(function(param, $) {
                var g = param.iconClass, S = param.name, P = param.attrs;
                var L = $ + 1;
                h.push((0, $aD8ZA.h)("div", (0, $8typN._)((0, $8pZMQ._)({
                    key: L,
                    ref: function(E) {
                        s["rt".concat(L)] = E;
                    },
                    class: "q-rating__icon-container flex flex-center"
                }, P), {
                    onClick: function() {
                        y(L);
                    },
                    onMouseover: function() {
                        p(L);
                    },
                    onMouseout: b,
                    onFocus: function() {
                        p(L);
                    },
                    onBlur: b,
                    onKeyup: function(E) {
                        C(E, L);
                    }
                }), Ke(t["tip-".concat(L)], [
                    (0, $aD8ZA.h)(we, {
                        class: g,
                        name: S
                    })
                ])));
            }), e.name !== void 0 && e.disable !== !0 && a(h, "push"), (0, $aD8ZA.h)("div", (0, $8pZMQ._)({
                class: u.value,
                style: n.value
            }, m.value), h);
        };
    }
});
var $g = R({
    name: "QResponsive",
    props: la,
    setup: function(e, param) {
        var t = param.slots;
        var o = ua(e);
        return function() {
            return (0, $aD8ZA.h)("div", {
                class: "q-responsive"
            }, [
                (0, $aD8ZA.h)("div", {
                    class: "q-responsive__filler overflow-hidden"
                }, [
                    (0, $aD8ZA.h)("div", {
                        style: o.value
                    })
                ]),
                (0, $aD8ZA.h)("div", {
                    class: "q-responsive__content absolute-full fit"
                }, J(t.default))
            ]);
        };
    }
});
var Bg = [
    "vertical",
    "horizontal"
], md = {
    vertical: {
        offset: "offsetY",
        scroll: "scrollTop",
        dir: "down",
        dist: "y"
    },
    horizontal: {
        offset: "offsetX",
        scroll: "scrollLeft",
        dir: "right",
        dist: "x"
    }
}, Lg = {
    prevent: !0,
    mouse: !0,
    mouseAllDir: !0
}, Fg = function(e) {
    return e >= 250 ? 50 : Math.ceil(e / 5);
}, Dg = R({
    name: "QScrollArea",
    props: (0, $8typN._)((0, $8pZMQ._)({}, he), {
        thumbStyle: Object,
        verticalThumbStyle: Object,
        horizontalThumbStyle: Object,
        barStyle: [
            Array,
            String,
            Object
        ],
        verticalBarStyle: [
            Array,
            String,
            Object
        ],
        horizontalBarStyle: [
            Array,
            String,
            Object
        ],
        contentStyle: [
            Array,
            String,
            Object
        ],
        contentActiveStyle: [
            Array,
            String,
            Object
        ],
        delay: {
            type: [
                String,
                Number
            ],
            default: 1e3
        },
        visible: {
            type: Boolean,
            default: null
        },
        tabindex: [
            String,
            Number
        ],
        onScroll: Function
    }),
    setup: function(e, param) {
        var t = param.slots, o = param.emit;
        var r = (0, $aAzpa.ref)(!1), n = (0, $aAzpa.ref)(!1), i = (0, $aAzpa.ref)(!1), a = {
            vertical: (0, $aAzpa.ref)(0),
            horizontal: (0, $aAzpa.ref)(0)
        }, l = {
            vertical: {
                ref: (0, $aAzpa.ref)(null),
                position: (0, $aAzpa.ref)(0),
                size: (0, $aAzpa.ref)(0)
            },
            horizontal: {
                ref: (0, $aAzpa.ref)(null),
                position: (0, $aAzpa.ref)(0),
                size: (0, $aAzpa.ref)(0)
            }
        }, _DC = (0, $aD8ZA.getCurrentInstance)(), s = _DC.proxy, c = pe(e, s.$q), u = null, v, f = (0, $aAzpa.ref)(null), d = (0, $aAzpa.computed)(function() {
            return "q-scrollarea" + (c.value === !0 ? " q-scrollarea--dark" : "");
        });
        l.vertical.percentage = (0, $aAzpa.computed)(function() {
            var w = l.vertical.size.value - a.vertical.value;
            if (w <= 0) return 0;
            var H = Ze(l.vertical.position.value / w, 0, 1);
            return Math.round(H * 1e4) / 1e4;
        }), l.vertical.thumbHidden = (0, $aAzpa.computed)(function() {
            return (e.visible === null ? i.value : e.visible) !== !0 && r.value === !1 && n.value === !1 || l.vertical.size.value <= a.vertical.value + 1;
        }), l.vertical.thumbStart = (0, $aAzpa.computed)(function() {
            return l.vertical.percentage.value * (a.vertical.value - l.vertical.thumbSize.value);
        }), l.vertical.thumbSize = (0, $aAzpa.computed)(function() {
            return Math.round(Ze(a.vertical.value * a.vertical.value / l.vertical.size.value, Fg(a.vertical.value), a.vertical.value));
        }), l.vertical.style = (0, $aAzpa.computed)(function() {
            return (0, $8typN._)((0, $8pZMQ._)({}, e.thumbStyle, e.verticalThumbStyle), {
                top: "".concat(l.vertical.thumbStart.value, "px"),
                height: "".concat(l.vertical.thumbSize.value, "px")
            });
        }), l.vertical.thumbClass = (0, $aAzpa.computed)(function() {
            return "q-scrollarea__thumb q-scrollarea__thumb--v absolute-right" + (l.vertical.thumbHidden.value === !0 ? " q-scrollarea__thumb--invisible" : "");
        }), l.vertical.barClass = (0, $aAzpa.computed)(function() {
            return "q-scrollarea__bar q-scrollarea__bar--v absolute-right" + (l.vertical.thumbHidden.value === !0 ? " q-scrollarea__bar--invisible" : "");
        }), l.horizontal.percentage = (0, $aAzpa.computed)(function() {
            var w = l.horizontal.size.value - a.horizontal.value;
            if (w <= 0) return 0;
            var H = Ze(Math.abs(l.horizontal.position.value) / w, 0, 1);
            return Math.round(H * 1e4) / 1e4;
        }), l.horizontal.thumbHidden = (0, $aAzpa.computed)(function() {
            return (e.visible === null ? i.value : e.visible) !== !0 && r.value === !1 && n.value === !1 || l.horizontal.size.value <= a.horizontal.value + 1;
        }), l.horizontal.thumbStart = (0, $aAzpa.computed)(function() {
            return l.horizontal.percentage.value * (a.horizontal.value - l.horizontal.thumbSize.value);
        }), l.horizontal.thumbSize = (0, $aAzpa.computed)(function() {
            return Math.round(Ze(a.horizontal.value * a.horizontal.value / l.horizontal.size.value, Fg(a.horizontal.value), a.horizontal.value));
        }), l.horizontal.style = (0, $aAzpa.computed)(function() {
            return (0, $8typN._)((0, $8pZMQ._)({}, e.thumbStyle, e.horizontalThumbStyle), {
                [s.$q.lang.rtl === !0 ? "right" : "left"]: "".concat(l.horizontal.thumbStart.value, "px"),
                width: "".concat(l.horizontal.thumbSize.value, "px")
            });
        }), l.horizontal.thumbClass = (0, $aAzpa.computed)(function() {
            return "q-scrollarea__thumb q-scrollarea__thumb--h absolute-bottom" + (l.horizontal.thumbHidden.value === !0 ? " q-scrollarea__thumb--invisible" : "");
        }), l.horizontal.barClass = (0, $aAzpa.computed)(function() {
            return "q-scrollarea__bar q-scrollarea__bar--h absolute-bottom" + (l.horizontal.thumbHidden.value === !0 ? " q-scrollarea__bar--invisible" : "");
        });
        var m = (0, $aAzpa.computed)(function() {
            return l.vertical.thumbHidden.value === !0 && l.horizontal.thumbHidden.value === !0 ? e.contentStyle : e.contentActiveStyle;
        }), y = [
            [
                qt,
                function(w) {
                    $(w, "vertical");
                },
                void 0,
                (0, $8pZMQ._)({
                    vertical: !0
                }, Lg)
            ]
        ], p = [
            [
                qt,
                function(w) {
                    $(w, "horizontal");
                },
                void 0,
                (0, $8pZMQ._)({
                    horizontal: !0
                }, Lg)
            ]
        ];
        function C() {
            var w = {};
            return Bg.forEach(function(H) {
                var W = l[H];
                w[H + "Position"] = W.position.value, w[H + "Percentage"] = W.percentage.value, w[H + "Size"] = W.size.value, w[H + "ContainerSize"] = a[H].value;
            }), w;
        }
        var b = So(function() {
            var w = C();
            w.ref = s, o("scroll", w);
        }, 0);
        function h(w, H, W) {
            if (Bg.includes(w) === !1) {
                console.error("[QScrollArea]: wrong first param of setScrollPosition (vertical/horizontal)");
                return;
            }
            (w === "vertical" ? un : La)(f.value, H, W);
        }
        function g(param) {
            var w = param.height, H = param.width;
            var W = !1;
            a.vertical.value !== w && (a.vertical.value = w, W = !0), a.horizontal.value !== H && (a.horizontal.value = H, W = !0), W === !0 && B();
        }
        function S(param) {
            var w = param.position;
            var H = !1;
            l.vertical.position.value !== w.top && (l.vertical.position.value = w.top, H = !0), l.horizontal.position.value !== w.left && (l.horizontal.position.value = w.left, H = !0), H === !0 && B();
        }
        function P(param) {
            var w = param.height, H = param.width;
            l.horizontal.size.value !== H && (l.horizontal.size.value = H, B()), l.vertical.size.value !== w && (l.vertical.size.value = w, B());
        }
        function $(w, H) {
            var W = l[H];
            if (w.isFirst === !0) {
                if (W.thumbHidden.value === !0) return;
                v = W.position.value, n.value = !0;
            } else if (n.value !== !0) return;
            w.isFinal === !0 && (n.value = !1);
            var ie = md[H], V = a[H].value, _ = (W.size.value - V) / (V - W.thumbSize.value), N = w.distance[ie.dist], I = v + (w.direction === ie.dir ? 1 : -1) * N * _;
            q(I, H);
        }
        function L(w, H) {
            var W = l[H];
            if (W.thumbHidden.value !== !0) {
                var ie = w[md[H].offset];
                if (ie < W.thumbStart.value || ie > W.thumbStart.value + W.thumbSize.value) {
                    var V = ie - W.thumbSize.value / 2;
                    q(V / a[H].value * W.size.value, H);
                }
                W.ref.value !== null && W.ref.value.dispatchEvent(new MouseEvent(w.type, w));
            }
        }
        function E(w) {
            L(w, "vertical");
        }
        function A(w) {
            L(w, "horizontal");
        }
        function B() {
            r.value = !0, u !== null && clearTimeout(u), u = setTimeout(function() {
                u = null, r.value = !1;
            }, e.delay), e.onScroll !== void 0 && b();
        }
        function q(w, H) {
            f.value[md[H].scroll] = w;
        }
        var x = null;
        function k() {
            x !== null && clearTimeout(x), x = setTimeout(function() {
                x = null, i.value = !0;
            }, s.$q.platform.is.ios ? 50 : 0);
        }
        function j() {
            x !== null && (clearTimeout(x), x = null), i.value = !1;
        }
        var Q = null;
        return (0, $aD8ZA.watch)(function() {
            return s.$q.lang.rtl;
        }, function(w) {
            f.value !== null && La(f.value, Math.abs(l.horizontal.position.value) * (w === !0 ? -1 : 1));
        }), (0, $aD8ZA.onDeactivated)(function() {
            Q = {
                top: l.vertical.position.value,
                left: l.horizontal.position.value
            };
        }), (0, $aD8ZA.onActivated)(function() {
            if (Q === null) return;
            var w = f.value;
            w !== null && (La(w, Q.left), un(w, Q.top));
        }), (0, $aD8ZA.onBeforeUnmount)(b.cancel), Object.assign(s, {
            getScrollTarget: function() {
                return f.value;
            },
            getScroll: C,
            getScrollPosition: function() {
                return {
                    top: l.vertical.position.value,
                    left: l.horizontal.position.value
                };
            },
            getScrollPercentage: function() {
                return {
                    top: l.vertical.percentage.value,
                    left: l.horizontal.percentage.value
                };
            },
            setScrollPosition: h,
            setScrollPercentage: function(w, H, W) {
                h(w, H * (l[w].size.value - a[w].value) * (w === "horizontal" && s.$q.lang.rtl === !0 ? -1 : 1), W);
            }
        }), function() {
            return (0, $aD8ZA.h)("div", {
                class: d.value,
                onMouseenter: k,
                onMouseleave: j
            }, [
                (0, $aD8ZA.h)("div", {
                    ref: f,
                    class: "q-scrollarea__container scroll relative-position fit hide-scrollbar",
                    tabindex: e.tabindex !== void 0 ? e.tabindex : void 0
                }, [
                    (0, $aD8ZA.h)("div", {
                        class: "q-scrollarea__content absolute",
                        style: m.value
                    }, Ke(t.default, [
                        (0, $aD8ZA.h)(go, {
                            debounce: 0,
                            onResize: P
                        })
                    ])),
                    (0, $aD8ZA.h)(fa, {
                        axis: "both",
                        onScroll: S
                    })
                ]),
                (0, $aD8ZA.h)(go, {
                    debounce: 0,
                    onResize: g
                }),
                (0, $aD8ZA.h)("div", {
                    class: l.vertical.barClass.value,
                    style: [
                        e.barStyle,
                        e.verticalBarStyle
                    ],
                    "aria-hidden": "true",
                    onMousedown: E
                }),
                (0, $aD8ZA.h)("div", {
                    class: l.horizontal.barClass.value,
                    style: [
                        e.barStyle,
                        e.horizontalBarStyle
                    ],
                    "aria-hidden": "true",
                    onMousedown: A
                }),
                (0, $aD8ZA.withDirectives)((0, $aD8ZA.h)("div", {
                    ref: l.vertical.ref,
                    class: l.vertical.thumbClass.value,
                    style: l.vertical.style.value,
                    "aria-hidden": "true"
                }), y),
                (0, $aD8ZA.withDirectives)((0, $aD8ZA.h)("div", {
                    ref: l.horizontal.ref,
                    class: l.horizontal.thumbClass.value,
                    style: l.horizontal.style.value,
                    "aria-hidden": "true"
                }), p)
            ]);
        };
    }
});
var Ko = 1e3, QC = [
    "start",
    "center",
    "end",
    "start-force",
    "center-force",
    "end-force"
], Og = Array.prototype.filter, jC = window.getComputedStyle(document.body).overflowAnchor === void 0 ? Qe : function jC(e, t) {
    e !== null && (e._qOverflowAnimationFrame !== void 0 && cancelAnimationFrame(e._qOverflowAnimationFrame), e._qOverflowAnimationFrame = requestAnimationFrame(function() {
        if (e === null) return;
        e._qOverflowAnimationFrame = void 0;
        var o = e.children || [];
        Og.call(o, function(n) {
            return n.dataset && n.dataset.qVsAnchor !== void 0;
        }).forEach(function(n) {
            delete n.dataset.qVsAnchor;
        });
        var r = o[t];
        r && r.dataset && (r.dataset.qVsAnchor = "");
    }));
};
function ba(e, t) {
    return e + t;
}
function vd(e, t, o, r, n, i, a, l) {
    var s = e === window ? document.scrollingElement || document.documentElement : e, c = n === !0 ? "offsetWidth" : "offsetHeight", u = {
        scrollStart: 0,
        scrollViewSize: -a - l,
        scrollMaxSize: 0,
        offsetStart: -a,
        offsetEnd: -l
    };
    if (n === !0 ? (e === window ? (u.scrollStart = window.pageXOffset || window.scrollX || document.body.scrollLeft || 0, u.scrollViewSize += document.documentElement.clientWidth) : (u.scrollStart = s.scrollLeft, u.scrollViewSize += s.clientWidth), u.scrollMaxSize = s.scrollWidth, i === !0 && (u.scrollStart = (Fr === !0 ? u.scrollMaxSize - u.scrollViewSize : 0) - u.scrollStart)) : (e === window ? (u.scrollStart = window.pageYOffset || window.scrollY || document.body.scrollTop || 0, u.scrollViewSize += document.documentElement.clientHeight) : (u.scrollStart = s.scrollTop, u.scrollViewSize += s.clientHeight), u.scrollMaxSize = s.scrollHeight), o !== null) for(var v = o.previousElementSibling; v !== null; v = v.previousElementSibling)v.classList.contains("q-virtual-scroll--skip") === !1 && (u.offsetStart += v[c]);
    if (r !== null) for(var v1 = r.nextElementSibling; v1 !== null; v1 = v1.nextElementSibling)v1.classList.contains("q-virtual-scroll--skip") === !1 && (u.offsetEnd += v1[c]);
    if (t !== e) {
        var v2 = s.getBoundingClientRect(), f = t.getBoundingClientRect();
        n === !0 ? (u.offsetStart += f.left - v2.left, u.offsetEnd -= f.width) : (u.offsetStart += f.top - v2.top, u.offsetEnd -= f.height), e !== window && (u.offsetStart += u.scrollStart), u.offsetEnd += u.scrollMaxSize - u.offsetStart;
    }
    return u;
}
function zg(e, t, o, r) {
    t === "end" && (t = (e === window ? document.body : e)[o === !0 ? "scrollWidth" : "scrollHeight"]), e === window ? o === !0 ? (r === !0 && (t = (Fr === !0 ? document.body.scrollWidth - document.documentElement.clientWidth : 0) - t), window.scrollTo(t, window.pageYOffset || window.scrollY || document.body.scrollTop || 0)) : window.scrollTo(window.pageXOffset || window.scrollX || document.body.scrollLeft || 0, t) : o === !0 ? (r === !0 && (t = (Fr === !0 ? e.scrollWidth - e.offsetWidth : 0) - t), e.scrollLeft = t) : e.scrollTop = t;
}
function vl(e, t, o, r) {
    if (o >= r) return 0;
    var n = t.length, i = Math.floor(o / Ko), a = Math.floor((r - 1) / Ko) + 1, l = e.slice(i, a).reduce(ba, 0);
    return o % Ko !== 0 && (l -= t.slice(i * Ko, o).reduce(ba, 0)), r % Ko !== 0 && r !== n && (l -= t.slice(r, a * Ko).reduce(ba, 0)), l;
}
var Ig = {
    virtualScrollSliceSize: {
        type: [
            Number,
            String
        ],
        default: null
    },
    virtualScrollSliceRatioBefore: {
        type: [
            Number,
            String
        ],
        default: 1
    },
    virtualScrollSliceRatioAfter: {
        type: [
            Number,
            String
        ],
        default: 1
    },
    virtualScrollItemSize: {
        type: [
            Number,
            String
        ],
        default: 24
    },
    virtualScrollStickySizeStart: {
        type: [
            Number,
            String
        ],
        default: 0
    },
    virtualScrollStickySizeEnd: {
        type: [
            Number,
            String
        ],
        default: 0
    },
    tableColspan: [
        Number,
        String
    ]
}, gd = Object.keys(Ig), ss = (0, $8pZMQ._)({
    virtualScrollHorizontal: Boolean,
    onVirtualScroll: Function
}, Ig);
function cs(param) {
    var e = param.virtualScrollLength, t = param.getVirtualScrollTarget, o = param.getVirtualScrollEl, r = param.virtualScrollItemSizeComputed;
    var n = (0, $aD8ZA.getCurrentInstance)(), i = n.props, a = n.emit, l = n.proxy, s = l.$q, c, u, v, f = [], d, m = (0, $aAzpa.ref)(0), y = (0, $aAzpa.ref)(0), p = (0, $aAzpa.ref)({}), C = (0, $aAzpa.ref)(null), b = (0, $aAzpa.ref)(null), h = (0, $aAzpa.ref)(null), g = (0, $aAzpa.ref)({
        from: 0,
        to: 0
    }), S = (0, $aAzpa.computed)(function() {
        return i.tableColspan !== void 0 ? i.tableColspan : 100;
    });
    r === void 0 && (r = (0, $aAzpa.computed)(function() {
        return i.virtualScrollItemSize;
    }));
    var P = (0, $aAzpa.computed)(function() {
        return r.value + ";" + i.virtualScrollHorizontal;
    }), $ = (0, $aAzpa.computed)(function() {
        return P.value + ";" + i.virtualScrollSliceRatioBefore + ";" + i.virtualScrollSliceRatioAfter;
    });
    (0, $aD8ZA.watch)($, function() {
        Q();
    }), (0, $aD8ZA.watch)(P, L);
    function L() {
        j(u, !0);
    }
    function E(V) {
        j(V === void 0 ? u : V);
    }
    function A(V, _) {
        var N = t();
        if (N == null || N.nodeType === 8) return;
        var I = vd(N, o(), C.value, b.value, i.virtualScrollHorizontal, s.lang.rtl, i.virtualScrollStickySizeStart, i.virtualScrollStickySizeEnd);
        v !== I.scrollViewSize && Q(I.scrollViewSize), q(N, I, Math.min(e.value - 1, Math.max(0, parseInt(V, 10) || 0)), 0, QC.indexOf(_) !== -1 ? _ : u !== -1 && V > u ? "end" : "start");
    }
    function B() {
        var V = t();
        if (V == null || V.nodeType === 8) return;
        var _ = vd(V, o(), C.value, b.value, i.virtualScrollHorizontal, s.lang.rtl, i.virtualScrollStickySizeStart, i.virtualScrollStickySizeEnd), N = e.value - 1, I = _.scrollMaxSize - _.offsetStart - _.offsetEnd - y.value;
        if (c === _.scrollStart) return;
        if (_.scrollMaxSize <= 0) {
            q(V, _, 0, 0);
            return;
        }
        v !== _.scrollViewSize && Q(_.scrollViewSize), x(g.value.from);
        var oe = Math.floor(_.scrollMaxSize - Math.max(_.scrollViewSize, _.offsetEnd) - Math.min(d[N], _.scrollViewSize / 2));
        if (oe > 0 && Math.ceil(_.scrollStart) >= oe) {
            q(V, _, N, _.scrollMaxSize - _.offsetEnd - f.reduce(ba, 0));
            return;
        }
        var T = 0, D = _.scrollStart - _.offsetStart, te = D;
        if (D <= I && D + _.scrollViewSize >= m.value) D -= m.value, T = g.value.from, te = D;
        else for(var z = 0; D >= f[z] && T < N; z++)D -= f[z], T += Ko;
        for(; D > 0 && T < N;)D -= d[T], D > -_.scrollViewSize ? (T++, te = D) : te = d[T] + D;
        q(V, _, T, te);
    }
    function q(V, _, N, I, oe) {
        var T = typeof oe == "string" && oe.indexOf("-force") !== -1, D = T === !0 ? oe.replace("-force", "") : oe, te = D !== void 0 ? D : "start", z = Math.max(0, N - p.value[te]), ue = z + p.value.total;
        ue > e.value && (ue = e.value, z = Math.max(0, ue - p.value.total)), c = _.scrollStart;
        var _e = z !== g.value.from || ue !== g.value.to;
        if (_e === !1 && D === void 0) {
            H(N);
            return;
        }
        var U = document.activeElement, ae = h.value;
        _e === !0 && ae !== null && ae !== U && ae.contains(U) === !0 && (ae.addEventListener("focusout", k), setTimeout(function() {
            ae !== null && ae.removeEventListener("focusout", k);
        })), jC(ae, N - z);
        var ce = D !== void 0 ? d.slice(z, N).reduce(ba, 0) : 0;
        if (_e === !0) {
            var be = ue >= g.value.from && z <= g.value.to ? g.value.to : ue;
            g.value = {
                from: z,
                to: be
            }, m.value = vl(f, d, 0, z), y.value = vl(f, d, ue, e.value), requestAnimationFrame(function() {
                g.value.to !== ue && c === _.scrollStart && (g.value = {
                    from: g.value.from,
                    to: ue
                }, y.value = vl(f, d, ue, e.value));
            });
        }
        requestAnimationFrame(function() {
            if (c !== _.scrollStart) return;
            _e === !0 && x(z);
            var be = d.slice(z, N).reduce(ba, 0), Me = be + _.offsetStart + m.value, le = Me + d[N], Re = Me + I;
            if (D !== void 0) {
                var Fe = be - ce, De = _.scrollStart + Fe;
                Re = T !== !0 && De < Me && le < De + _.scrollViewSize ? De : D === "end" ? le - _.scrollViewSize : Me - (D === "start" ? 0 : Math.round((_.scrollViewSize - d[N]) / 2));
            }
            c = Re, zg(V, Re, i.virtualScrollHorizontal, s.lang.rtl), H(N);
        });
    }
    function x(V) {
        var _ = h.value;
        if (_) {
            var N = Og.call(_.children, function(z) {
                return z.classList && z.classList.contains("q-virtual-scroll--skip") === !1;
            }), I = N.length, oe = i.virtualScrollHorizontal === !0 ? function(z) {
                return z.getBoundingClientRect().width;
            } : function(z) {
                return z.offsetHeight;
            }, T = V, D, te;
            for(var z = 0; z < I;){
                for(D = oe(N[z]), z++; z < I && N[z].classList.contains("q-virtual-scroll--with-prev") === !0;)D += oe(N[z]), z++;
                te = D - d[T], te !== 0 && (d[T] += te, f[Math.floor(T / Ko)] += te), T++;
            }
        }
    }
    function k() {
        h.value !== null && h.value !== void 0 && h.value.focus();
    }
    function j(V, _) {
        var N = 1 * r.value;
        (_ === !0 || Array.isArray(d) === !1) && (d = []);
        var I = d.length;
        d.length = e.value;
        for(var T = e.value - 1; T >= I; T--)d[T] = N;
        var oe = Math.floor((e.value - 1) / Ko);
        f = [];
        for(var T1 = 0; T1 <= oe; T1++){
            var D = 0, te = Math.min((T1 + 1) * Ko, e.value);
            for(var z = T1 * Ko; z < te; z++)D += d[z];
            f.push(D);
        }
        u = -1, c = void 0, m.value = vl(f, d, 0, g.value.from), y.value = vl(f, d, g.value.to, e.value), V >= 0 ? (x(g.value.from), (0, $aD8ZA.nextTick)(function() {
            A(V);
        })) : W();
    }
    function Q(V) {
        if (V === void 0 && (typeof window === "undefined" ? "undefined" : (0, $jzTO1._)(window)) < "u") {
            var D = t();
            D != null && D.nodeType !== 8 && (V = vd(D, o(), C.value, b.value, i.virtualScrollHorizontal, s.lang.rtl, i.virtualScrollStickySizeStart, i.virtualScrollStickySizeEnd).scrollViewSize);
        }
        v = V;
        var _ = parseFloat(i.virtualScrollSliceRatioBefore) || 0, N = parseFloat(i.virtualScrollSliceRatioAfter) || 0, I = 1 + _ + N, oe = V === void 0 || V <= 0 ? 1 : Math.ceil(V / r.value), T = Math.max(1, oe, Math.ceil((i.virtualScrollSliceSize > 0 ? i.virtualScrollSliceSize : 10) / I));
        p.value = {
            total: Math.ceil(T * I),
            start: Math.ceil(T * _),
            center: Math.ceil(T * (.5 + _)),
            end: Math.ceil(T * (1 + _)),
            view: oe
        };
    }
    function w(V, _) {
        var N = i.virtualScrollHorizontal === !0 ? "width" : "height", I = {
            ["--q-virtual-scroll-item-" + N]: r.value + "px"
        };
        return [
            V === "tbody" ? (0, $aD8ZA.h)(V, {
                class: "q-virtual-scroll__padding",
                key: "before",
                ref: C
            }, [
                (0, $aD8ZA.h)("tr", [
                    (0, $aD8ZA.h)("td", {
                        style: (0, $8pZMQ._)({
                            [N]: "".concat(m.value, "px")
                        }, I),
                        colspan: S.value
                    })
                ])
            ]) : (0, $aD8ZA.h)(V, {
                class: "q-virtual-scroll__padding",
                key: "before",
                ref: C,
                style: (0, $8pZMQ._)({
                    [N]: "".concat(m.value, "px")
                }, I)
            }),
            (0, $aD8ZA.h)(V, {
                class: "q-virtual-scroll__content",
                key: "content",
                ref: h,
                tabindex: -1
            }, _.flat()),
            V === "tbody" ? (0, $aD8ZA.h)(V, {
                class: "q-virtual-scroll__padding",
                key: "after",
                ref: b
            }, [
                (0, $aD8ZA.h)("tr", [
                    (0, $aD8ZA.h)("td", {
                        style: (0, $8pZMQ._)({
                            [N]: "".concat(y.value, "px")
                        }, I),
                        colspan: S.value
                    })
                ])
            ]) : (0, $aD8ZA.h)(V, {
                class: "q-virtual-scroll__padding",
                key: "after",
                ref: b,
                style: (0, $8pZMQ._)({
                    [N]: "".concat(y.value, "px")
                }, I)
            })
        ];
    }
    function H(V) {
        u !== V && (i.onVirtualScroll !== void 0 && a("virtualScroll", {
            index: V,
            from: g.value.from,
            to: g.value.to - 1,
            direction: V < u ? "decrease" : "increase",
            ref: l
        }), u = V);
    }
    Q();
    var W = So(B, s.platform.is.ios === !0 ? 120 : 35);
    (0, $aD8ZA.onBeforeMount)(function() {
        Q();
    });
    var ie = !1;
    return (0, $aD8ZA.onDeactivated)(function() {
        ie = !0;
    }), (0, $aD8ZA.onActivated)(function() {
        if (ie !== !0) return;
        var V = t();
        c !== void 0 && V !== void 0 && V !== null && V.nodeType !== 8 ? zg(V, c, i.virtualScrollHorizontal, s.lang.rtl) : A(u);
    }), (0, $aD8ZA.onBeforeUnmount)(function() {
        W.cancel();
    }), Object.assign(l, {
        scrollTo: A,
        reset: L,
        refresh: E
    }), {
        virtualScrollSliceRange: g,
        virtualScrollSliceSizeComputed: p,
        setVirtualScrollSize: Q,
        onVirtualScrollEvt: W,
        localResetVirtualScroll: j,
        padVirtualScroll: w,
        scrollTo: A,
        reset: L,
        refresh: E
    };
}
var Hg = function(e) {
    return [
        "add",
        "add-unique",
        "toggle"
    ].includes(e);
}, XC = ".*+?^${}()|[]\\", GC = Object.keys(zn), fs = R({
    name: "QSelect",
    inheritAttrs: !1,
    props: (0, $8typN._)((0, $8pZMQ._)({}, ss, _t, zn), {
        modelValue: {
            required: !0
        },
        multiple: Boolean,
        displayValue: [
            String,
            Number
        ],
        displayValueHtml: Boolean,
        dropdownIcon: String,
        options: {
            type: Array,
            default: function() {
                return [];
            }
        },
        optionValue: [
            Function,
            String
        ],
        optionLabel: [
            Function,
            String
        ],
        optionDisable: [
            Function,
            String
        ],
        hideSelected: Boolean,
        hideDropdownIcon: Boolean,
        fillInput: Boolean,
        maxValues: [
            Number,
            String
        ],
        optionsDense: Boolean,
        optionsDark: {
            type: Boolean,
            default: null
        },
        optionsSelectedClass: String,
        optionsHtml: Boolean,
        optionsCover: Boolean,
        menuShrink: Boolean,
        menuAnchor: String,
        menuSelf: String,
        menuOffset: Array,
        popupContentClass: String,
        popupContentStyle: [
            String,
            Array,
            Object
        ],
        popupNoRouteDismiss: Boolean,
        useInput: Boolean,
        useChips: Boolean,
        newValueMode: {
            type: String,
            validator: Hg
        },
        mapOptions: Boolean,
        emitValue: Boolean,
        inputDebounce: {
            type: [
                Number,
                String
            ],
            default: 500
        },
        inputClass: [
            Array,
            String,
            Object
        ],
        inputStyle: [
            Array,
            String,
            Object
        ],
        tabindex: {
            type: [
                String,
                Number
            ],
            default: 0
        },
        autocomplete: String,
        transitionShow: String,
        transitionHide: String,
        transitionDuration: [
            String,
            Number
        ],
        behavior: {
            type: String,
            validator: function(e) {
                return [
                    "default",
                    "menu",
                    "dialog"
                ].includes(e);
            },
            default: "default"
        },
        virtualScrollItemSize: {
            type: [
                Number,
                String
            ],
            default: void 0
        },
        onNewValue: Function,
        onFilter: Function
    }),
    emits: (0, $79xu7._)(cr).concat([
        "add",
        "remove",
        "inputValue",
        "keyup",
        "keypress",
        "keydown",
        "filterAbort"
    ]),
    setup: function(e, param) {
        var t = param.slots, o = param.emit;
        var _YC = (0, $aD8ZA.getCurrentInstance)(), r = _YC.proxy, n = r.$q, i = (0, $aAzpa.ref)(!1), a = (0, $aAzpa.ref)(!1), l = (0, $aAzpa.ref)(-1), s = (0, $aAzpa.ref)(""), c = (0, $aAzpa.ref)(!1), u = (0, $aAzpa.ref)(!1), v = null, f = null, d, m, y, p = null, C, b, h, g, S = (0, $aAzpa.ref)(null), P = (0, $aAzpa.ref)(null), $ = (0, $aAzpa.ref)(null), L = (0, $aAzpa.ref)(null), E = (0, $aAzpa.ref)(null), A = Ai(e), B = Iu(ve), q = (0, $aAzpa.computed)(function() {
            return Array.isArray(e.options) ? e.options.length : 0;
        }), x = (0, $aAzpa.computed)(function() {
            return e.virtualScrollItemSize === void 0 ? e.optionsDense === !0 ? 24 : 48 : e.virtualScrollItemSize;
        }), _cs = cs({
            virtualScrollLength: q,
            getVirtualScrollTarget: qo,
            getVirtualScrollEl: ro,
            virtualScrollItemSizeComputed: x
        }), k = _cs.virtualScrollSliceRange, j = _cs.virtualScrollSliceSizeComputed, Q = _cs.localResetVirtualScroll, w = _cs.padVirtualScroll, H = _cs.onVirtualScrollEvt, W = _cs.scrollTo, ie = _cs.setVirtualScrollSize, V = dr(), _ = (0, $aAzpa.computed)(function() {
            var F = e.mapOptions === !0 && e.multiple !== !0, xe = e.modelValue !== void 0 && (e.modelValue !== null || F === !0) ? e.multiple === !0 && Array.isArray(e.modelValue) ? e.modelValue : [
                e.modelValue
            ] : [];
            if (e.mapOptions === !0 && Array.isArray(e.options) === !0) {
                var ge = e.mapOptions === !0 && d !== void 0 ? d : [], Ue = xe.map(function(vt) {
                    return K(vt, ge);
                });
                return e.modelValue === null && F === !0 ? Ue.filter(function(vt) {
                    return vt !== null;
                }) : Ue;
            }
            return xe;
        }), N = (0, $aAzpa.computed)(function() {
            var F = {};
            return GC.forEach(function(xe) {
                var ge = e[xe];
                ge !== void 0 && (F[xe] = ge);
            }), F;
        }), I = (0, $aAzpa.computed)(function() {
            return e.optionsDark === null ? V.isDark.value : e.optionsDark;
        }), oe = (0, $aAzpa.computed)(function() {
            return pn(_.value);
        }), T = (0, $aAzpa.computed)(function() {
            var F = "q-field__input q-placeholder col";
            return e.hideSelected === !0 || _.value.length === 0 ? [
                F,
                e.inputClass
            ] : (F += " q-field__input--padding", e.inputClass === void 0 ? F : [
                F,
                e.inputClass
            ]);
        }), D = (0, $aAzpa.computed)(function() {
            return (e.virtualScrollHorizontal === !0 ? "q-virtual-scroll--horizontal" : "") + (e.popupContentClass ? " " + e.popupContentClass : "");
        }), te = (0, $aAzpa.computed)(function() {
            return q.value === 0;
        }), z = (0, $aAzpa.computed)(function() {
            return _.value.map(function(F) {
                return se.value(F);
            }).join(", ");
        }), ue = (0, $aAzpa.computed)(function() {
            return e.displayValue !== void 0 ? e.displayValue : z.value;
        }), _e = (0, $aAzpa.computed)(function() {
            return e.optionsHtml === !0 ? function() {
                return !0;
            } : function(F) {
                return F != null && F.html === !0;
            };
        }), U = (0, $aAzpa.computed)(function() {
            return e.displayValueHtml === !0 || e.displayValue === void 0 && (e.optionsHtml === !0 || _.value.some(_e.value));
        }), ae = (0, $aAzpa.computed)(function() {
            return V.focused.value === !0 ? e.tabindex : -1;
        }), ce = (0, $aAzpa.computed)(function() {
            var F = {
                tabindex: e.tabindex,
                role: "combobox",
                "aria-label": e.label,
                "aria-readonly": e.readonly === !0 ? "true" : "false",
                "aria-autocomplete": e.useInput === !0 ? "list" : "none",
                "aria-expanded": i.value === !0 ? "true" : "false",
                "aria-controls": "".concat(V.targetUid.value, "_lb")
            };
            return l.value >= 0 && (F["aria-activedescendant"] = "".concat(V.targetUid.value, "_").concat(l.value)), F;
        }), be = (0, $aAzpa.computed)(function() {
            return {
                id: "".concat(V.targetUid.value, "_lb"),
                role: "listbox",
                "aria-multiselectable": e.multiple === !0 ? "true" : "false"
            };
        }), Me = (0, $aAzpa.computed)(function() {
            return _.value.map(function(F, xe) {
                return {
                    index: xe,
                    opt: F,
                    html: _e.value(F),
                    selected: !0,
                    removeAtIndex: nt,
                    toggleOption: dt,
                    tabindex: ae.value
                };
            });
        }), le = (0, $aAzpa.computed)(function() {
            if (q.value === 0) return [];
            var _k_value = k.value, F = _k_value.from, xe = _k_value.to;
            return e.options.slice(F, xe).map(function(ge, Ue) {
                var vt = Y.value(ge) === !0, ft = ke(ge) === !0, jt = F + Ue, Pt = {
                    clickable: !0,
                    active: ft,
                    activeClass: De.value,
                    manualFocus: !0,
                    focused: !1,
                    disable: vt,
                    tabindex: -1,
                    dense: e.optionsDense,
                    dark: I.value,
                    role: "option",
                    "aria-selected": ft === !0 ? "true" : "false",
                    id: "".concat(V.targetUid.value, "_").concat(jt),
                    onClick: function() {
                        dt(ge);
                    }
                };
                return vt !== !0 && (l.value === jt && (Pt.focused = !0), n.platform.is.desktop === !0 && (Pt.onMousemove = function() {
                    i.value === !0 && G(jt);
                })), {
                    index: jt,
                    opt: ge,
                    html: _e.value(ge),
                    label: se.value(ge),
                    selected: Pt.active,
                    focused: Pt.focused,
                    toggleOption: dt,
                    setOptionIndex: G,
                    itemProps: Pt
                };
            });
        }), Re = (0, $aAzpa.computed)(function() {
            return e.dropdownIcon !== void 0 ? e.dropdownIcon : n.iconSet.arrow.dropdown;
        }), Fe = (0, $aAzpa.computed)(function() {
            return e.optionsCover === !1 && e.outlined !== !0 && e.standout !== !0 && e.borderless !== !0 && e.rounded !== !0;
        }), De = (0, $aAzpa.computed)(function() {
            return e.optionsSelectedClass !== void 0 ? e.optionsSelectedClass : e.color !== void 0 ? "text-".concat(e.color) : "";
        }), ne = (0, $aAzpa.computed)(function() {
            return ee(e.optionValue, "value");
        }), se = (0, $aAzpa.computed)(function() {
            return ee(e.optionLabel, "label");
        }), Y = (0, $aAzpa.computed)(function() {
            return ee(e.optionDisable, "disable");
        }), me = (0, $aAzpa.computed)(function() {
            return _.value.map(function(F) {
                return ne.value(F);
            });
        }), Pe = (0, $aAzpa.computed)(function() {
            var F = {
                onInput: ve,
                onChange: B,
                onKeydown: ht,
                onKeyup: Ge,
                onKeypress: mt,
                onFocus: ze,
                onClick: function(xe) {
                    m === !0 && tt(xe);
                }
            };
            return F.onCompositionstart = F.onCompositionupdate = F.onCompositionend = B, F;
        });
        (0, $aD8ZA.watch)(_, function(F) {
            d = F, e.useInput === !0 && e.fillInput === !0 && e.multiple !== !0 && V.innerLoading.value !== !0 && (a.value !== !0 && i.value !== !0 || oe.value !== !0) && (y !== !0 && oi(), (a.value === !0 || i.value === !0) && Ne(""));
        }, {
            immediate: !0
        }), (0, $aD8ZA.watch)(function() {
            return e.fillInput;
        }, oi), (0, $aD8ZA.watch)(i, Hs), (0, $aD8ZA.watch)(q, h0);
        function Ee(F) {
            return e.emitValue === !0 ? ne.value(F) : F;
        }
        function Ae(F) {
            if (F !== -1 && F < _.value.length) {
                if (e.multiple === !0) {
                    var xe = e.modelValue.slice();
                    o("remove", {
                        index: F,
                        value: xe.splice(F, 1)[0]
                    }), o("update:modelValue", xe);
                } else o("update:modelValue", null);
            }
        }
        function nt(F) {
            Ae(F), V.focus();
        }
        function ct(F, xe) {
            var ge = Ee(F);
            if (e.multiple !== !0) {
                e.fillInput === !0 && Be(se.value(F), !0, !0), o("update:modelValue", ge);
                return;
            }
            if (_.value.length === 0) {
                o("add", {
                    index: 0,
                    value: ge
                }), o("update:modelValue", e.multiple === !0 ? [
                    ge
                ] : ge);
                return;
            }
            if (xe === !0 && ke(F) === !0 || e.maxValues !== void 0 && e.modelValue.length >= e.maxValues) return;
            var Ue = e.modelValue.slice();
            o("add", {
                index: Ue.length,
                value: ge
            }), Ue.push(ge), o("update:modelValue", Ue);
        }
        function dt(F, xe) {
            if (V.editable.value !== !0 || F === void 0 || Y.value(F) === !0) return;
            var ge = ne.value(F);
            if (e.multiple !== !0) {
                xe !== !0 && (Be(e.fillInput === !0 ? se.value(F) : "", !0, !0), wr()), P.value !== null && P.value.focus(), (_.value.length === 0 || Zt(ne.value(_.value[0]), ge) !== !0) && o("update:modelValue", e.emitValue === !0 ? ge : F);
                return;
            }
            if ((m !== !0 || c.value === !0) && V.focus(), ze(), _.value.length === 0) {
                var ft = e.emitValue === !0 ? ge : F;
                o("add", {
                    index: 0,
                    value: ft
                }), o("update:modelValue", e.multiple === !0 ? [
                    ft
                ] : ft);
                return;
            }
            var Ue = e.modelValue.slice(), vt = me.value.findIndex(function(ft) {
                return Zt(ft, ge);
            });
            if (vt !== -1) o("remove", {
                index: vt,
                value: Ue.splice(vt, 1)[0]
            });
            else {
                if (e.maxValues !== void 0 && Ue.length >= e.maxValues) return;
                var ft1 = e.emitValue === !0 ? ge : F;
                o("add", {
                    index: Ue.length,
                    value: ft1
                }), Ue.push(ft1);
            }
            o("update:modelValue", Ue);
        }
        function G(F) {
            if (n.platform.is.desktop !== !0) return;
            var xe = F !== -1 && F < q.value ? F : -1;
            l.value !== xe && (l.value = xe);
        }
        function re() {
            var F = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1, xe = arguments.length > 1 ? arguments[1] : void 0;
            if (i.value === !0) {
                var ge = l.value;
                do ge = qr(ge + F, -1, q.value - 1);
                while (ge !== -1 && ge !== l.value && Y.value(e.options[ge]) === !0);
                l.value !== ge && (G(ge), W(ge), xe !== !0 && e.useInput === !0 && e.fillInput === !0 && qe(ge >= 0 ? se.value(e.options[ge]) : C, !0));
            }
        }
        function K(F, xe) {
            var ge = function(Ue) {
                return Zt(ne.value(Ue), F);
            };
            return e.options.find(ge) || xe.find(ge) || F;
        }
        function ee(F, xe) {
            var ge = F !== void 0 ? F : xe;
            return typeof ge == "function" ? ge : function(Ue) {
                return Ue !== null && typeof Ue == "object" && ge in Ue ? Ue[ge] : Ue;
            };
        }
        function ke(F) {
            var xe = ne.value(F);
            return me.value.find(function(ge) {
                return Zt(ge, xe);
            }) !== void 0;
        }
        function ze(F) {
            e.useInput === !0 && P.value !== null && (F === void 0 || P.value === F.target && F.target.value === z.value) && P.value.select();
        }
        function ye(F) {
            wt(F, 27) === !0 && i.value === !0 && (tt(F), wr(), oi()), o("keyup", F);
        }
        function Ge(F) {
            var _F_target = F.target, xe = _F_target.value;
            if (F.keyCode !== void 0) {
                ye(F);
                return;
            }
            if (F.target.value = "", v !== null && (clearTimeout(v), v = null), f !== null && (clearTimeout(f), f = null), oi(), typeof xe == "string" && xe.length !== 0) {
                var ge = xe.toLocaleLowerCase(), Ue = function(ft) {
                    var jt = e.options.find(function(Pt) {
                        return ft.value(Pt).toLocaleLowerCase() === ge;
                    });
                    return jt === void 0 ? !1 : (_.value.indexOf(jt) === -1 ? dt(jt) : wr(), !0);
                }, vt = function(ft) {
                    Ue(ne) !== !0 && (Ue(se) === !0 || ft === !0 || Ne(xe, !0, function() {
                        return vt(!0);
                    }));
                };
                vt();
            } else V.clearValue(F);
        }
        function mt(F) {
            o("keypress", F);
        }
        function ht(F) {
            if (o("keydown", F), xo(F) === !0) return;
            var xe = s.value.length !== 0 && (e.newValueMode !== void 0 || e.onNewValue !== void 0), ge = F.shiftKey !== !0 && e.multiple !== !0 && (l.value !== -1 || xe === !0);
            if (F.keyCode === 27) {
                ut(F);
                return;
            }
            if (F.keyCode === 9 && ge === !1) {
                rt();
                return;
            }
            if (F.target === void 0 || F.target.id !== V.targetUid.value || V.editable.value !== !0) return;
            if (F.keyCode === 40 && V.innerLoading.value !== !0 && i.value === !1) {
                Se(F), To();
                return;
            }
            if (F.keyCode === 8 && (e.useChips === !0 || e.clearable === !0) && e.hideSelected !== !0 && s.value.length === 0) {
                e.multiple === !0 && Array.isArray(e.modelValue) === !0 ? Ae(e.modelValue.length - 1) : e.multiple !== !0 && e.modelValue !== null && o("update:modelValue", null);
                return;
            }
            (F.keyCode === 35 || F.keyCode === 36) && (typeof s.value != "string" || s.value.length === 0) && (Se(F), l.value = -1, re(F.keyCode === 36 ? 1 : -1, e.multiple)), (F.keyCode === 33 || F.keyCode === 34) && j.value !== void 0 && (Se(F), l.value = Math.max(-1, Math.min(q.value, l.value + (F.keyCode === 33 ? -1 : 1) * j.value.view)), re(F.keyCode === 33 ? 1 : -1, e.multiple)), (F.keyCode === 38 || F.keyCode === 40) && (Se(F), re(F.keyCode === 38 ? -1 : 1, e.multiple));
            var Ue = q.value;
            if ((h === void 0 || g < Date.now()) && (h = ""), Ue > 0 && e.useInput !== !0 && F.key !== void 0 && F.key.length === 1 && F.altKey === !1 && F.ctrlKey === !1 && F.metaKey === !1 && (F.keyCode !== 32 || h.length !== 0)) {
                i.value !== !0 && To(F);
                var vt = F.key.toLocaleLowerCase(), ft = h.length === 1 && h[0] === vt;
                g = Date.now() + 1500, ft === !1 && (Se(F), h += vt);
                var jt = new RegExp("^" + h.split("").map(function(Ns) {
                    return XC.indexOf(Ns) !== -1 ? "\\" + Ns : Ns;
                }).join(".*"), "i"), Pt = l.value;
                if (ft === !0 || Pt < 0 || jt.test(se.value(e.options[Pt])) !== !0) do Pt = qr(Pt + 1, -1, Ue - 1);
                while (Pt !== l.value && (Y.value(e.options[Pt]) === !0 || jt.test(se.value(e.options[Pt])) !== !0));
                l.value !== Pt && (0, $aD8ZA.nextTick)(function() {
                    G(Pt), W(Pt), Pt >= 0 && e.useInput === !0 && e.fillInput === !0 && qe(se.value(e.options[Pt]), !0);
                });
                return;
            }
            if (!(F.keyCode !== 13 && (F.keyCode !== 32 || e.useInput === !0 || h !== "") && (F.keyCode !== 9 || ge === !1))) {
                if (F.keyCode !== 9 && Se(F), l.value !== -1 && l.value < Ue) {
                    dt(e.options[l.value]);
                    return;
                }
                if (xe === !0) {
                    var vt1 = function(ft, jt) {
                        if (jt) {
                            if (Hg(jt) !== !0) return;
                        } else jt = e.newValueMode;
                        if (Be("", e.multiple !== !0, !0), ft == null) return;
                        (jt === "toggle" ? dt : ct)(ft, jt === "add-unique"), e.multiple !== !0 && (P.value !== null && P.value.focus(), wr());
                    };
                    if (e.onNewValue !== void 0 ? o("newValue", s.value, vt1) : vt1(s.value), e.multiple !== !0) return;
                }
                i.value === !0 ? rt() : V.innerLoading.value !== !0 && To();
            }
        }
        function ro() {
            return m === !0 ? E.value : $.value !== null && $.value.contentEl !== null ? $.value.contentEl : void 0;
        }
        function qo() {
            return ro();
        }
        function kn() {
            return e.hideSelected === !0 ? [] : t["selected-item"] !== void 0 ? Me.value.map(function(F) {
                return t["selected-item"](F);
            }).slice() : t.selected !== void 0 ? [].concat(t.selected()) : e.useChips === !0 ? Me.value.map(function(F, xe) {
                return (0, $aD8ZA.h)(Ki, {
                    key: "option-" + xe,
                    removable: V.editable.value === !0 && Y.value(F.opt) !== !0,
                    dense: !0,
                    textColor: e.color,
                    tabindex: ae.value,
                    onRemove: function() {
                        F.removeAtIndex(xe);
                    }
                }, function() {
                    return (0, $aD8ZA.h)("span", {
                        class: "ellipsis",
                        [F.html === !0 ? "innerHTML" : "textContent"]: se.value(F.opt)
                    });
                });
            }) : [
                (0, $aD8ZA.h)("span", {
                    [U.value === !0 ? "innerHTML" : "textContent"]: ue.value
                })
            ];
        }
        function en() {
            if (te.value === !0) return t["no-option"] !== void 0 ? t["no-option"]({
                inputValue: s.value
            }) : void 0;
            var F = t.option !== void 0 ? t.option : function(ge) {
                return (0, $aD8ZA.h)(hn, (0, $8pZMQ._)({
                    key: ge.index
                }, ge.itemProps), function() {
                    return (0, $aD8ZA.h)(ho, function() {
                        return (0, $aD8ZA.h)(Hr, function() {
                            return (0, $aD8ZA.h)("span", {
                                [ge.html === !0 ? "innerHTML" : "textContent"]: ge.label
                            });
                        });
                    });
                });
            }, xe = w("div", le.value.map(F));
            return t["before-options"] !== void 0 && (xe = t["before-options"]().concat(xe)), Ke(t["after-options"], xe);
        }
        function Z(F, xe) {
            var ge = xe === !0 ? (0, $8pZMQ._)({}, ce.value, V.splitAttrs.attributes.value) : void 0, Ue = (0, $8pZMQ._)((0, $8typN._)((0, $8pZMQ._)({
                ref: xe === !0 ? P : void 0,
                key: "i_t",
                class: T.value,
                style: e.inputStyle,
                value: s.value !== void 0 ? s.value : "",
                type: "search"
            }, ge), {
                id: xe === !0 ? V.targetUid.value : void 0,
                maxlength: e.maxlength,
                autocomplete: e.autocomplete,
                "data-autofocus": F === !0 || e.autofocus === !0 || void 0,
                disabled: e.disable === !0,
                readonly: e.readonly === !0
            }), Pe.value);
            return F !== !0 && m === !0 && (Array.isArray(Ue.class) === !0 ? Ue.class = (0, $79xu7._)(Ue.class).concat([
                "no-pointer-events"
            ]) : Ue.class += " no-pointer-events"), (0, $aD8ZA.h)("input", Ue);
        }
        function ve(F) {
            v !== null && (clearTimeout(v), v = null), f !== null && (clearTimeout(f), f = null), !(F && F.target && F.target.qComposing === !0) && (qe(F.target.value || ""), y = !0, C = s.value, V.focused.value !== !0 && (m !== !0 || c.value === !0) && V.focus(), e.onFilter !== void 0 && (v = setTimeout(function() {
                v = null, Ne(s.value);
            }, e.inputDebounce)));
        }
        function qe(F, xe) {
            s.value !== F && (s.value = F, xe === !0 || e.inputDebounce === 0 || e.inputDebounce === "0" ? o("inputValue", F) : f = setTimeout(function() {
                f = null, o("inputValue", F);
            }, e.inputDebounce));
        }
        function Be(F, xe, ge) {
            y = ge !== !0, e.useInput === !0 && (qe(F, !0), (xe === !0 || ge !== !0) && (C = F), xe !== !0 && Ne(F));
        }
        function Ne(F, xe, ge) {
            if (e.onFilter === void 0 || xe !== !0 && V.focused.value !== !0) return;
            V.innerLoading.value === !0 ? o("filterAbort") : (V.innerLoading.value = !0, u.value = !0), F !== "" && e.multiple !== !0 && _.value.length !== 0 && y !== !0 && F === se.value(_.value[0]) && (F = "");
            var Ue = setTimeout(function() {
                i.value === !0 && (i.value = !1);
            }, 10);
            p !== null && clearTimeout(p), p = Ue, o("filter", F, function(vt, ft) {
                (xe === !0 || V.focused.value === !0) && p === Ue && (clearTimeout(p), typeof vt == "function" && vt(), u.value = !1, (0, $aD8ZA.nextTick)(function() {
                    V.innerLoading.value = !1, V.editable.value === !0 && (xe === !0 ? i.value === !0 && wr() : i.value === !0 ? Hs(!0) : i.value = !0), typeof ft == "function" && (0, $aD8ZA.nextTick)(function() {
                        ft(r);
                    }), typeof ge == "function" && (0, $aD8ZA.nextTick)(function() {
                        ge(r);
                    });
                }));
            }, function() {
                V.focused.value === !0 && p === Ue && (clearTimeout(p), V.innerLoading.value = !1, u.value = !1), i.value === !0 && (i.value = !1);
            });
        }
        function pt() {
            return (0, $aD8ZA.h)(sn, (0, $8typN._)((0, $8pZMQ._)({
                ref: $,
                class: D.value,
                style: e.popupContentStyle,
                modelValue: i.value,
                fit: e.menuShrink !== !0,
                cover: e.optionsCover === !0 && te.value !== !0 && e.useInput !== !0,
                anchor: e.menuAnchor,
                self: e.menuSelf,
                offset: e.menuOffset,
                dark: I.value,
                noParentEvent: !0,
                noRefocus: !0,
                noFocus: !0,
                noRouteDismiss: e.popupNoRouteDismiss,
                square: Fe.value,
                transitionShow: e.transitionShow,
                transitionHide: e.transitionHide,
                transitionDuration: e.transitionDuration,
                separateClosePopup: !0
            }, be.value), {
                onScrollPassive: H,
                onBeforeShow: Bd,
                onBeforeHide: M,
                onShow: O
            }), en);
        }
        function M(F) {
            Ld(F), rt();
        }
        function O() {
            ie();
        }
        function X(F) {
            tt(F), P.value !== null && P.value.focus(), c.value = !0, window.scrollTo(window.pageXOffset || window.scrollX || document.body.scrollLeft || 0, 0);
        }
        function de(F) {
            tt(F), (0, $aD8ZA.nextTick)(function() {
                c.value = !1;
            });
        }
        function fe() {
            var F = [
                (0, $aD8ZA.h)(Au, (0, $8typN._)((0, $8pZMQ._)((0, $8typN._)((0, $8pZMQ._)({
                    class: "col-auto ".concat(V.fieldClass.value)
                }, N.value), {
                    for: V.targetUid.value,
                    dark: I.value,
                    square: !0,
                    loading: u.value,
                    itemAligned: !1,
                    filled: !0,
                    stackLabel: s.value.length !== 0
                }), V.splitAttrs.listeners.value), {
                    onFocus: X,
                    onBlur: de
                }), (0, $8typN._)((0, $8pZMQ._)({}, t), {
                    rawControl: function() {
                        return V.getControl(!0);
                    },
                    before: void 0,
                    after: void 0
                }))
            ];
            return i.value === !0 && F.push((0, $aD8ZA.h)("div", (0, $8typN._)((0, $8pZMQ._)({
                ref: E,
                class: D.value + " scroll",
                style: e.popupContentStyle
            }, be.value), {
                onClick: ut,
                onScrollPassive: H
            }), en())), (0, $aD8ZA.h)(gn, {
                ref: L,
                modelValue: a.value,
                position: e.useInput === !0 ? "top" : void 0,
                transitionShow: b,
                transitionHide: e.transitionHide,
                transitionDuration: e.transitionDuration,
                noRouteDismiss: e.popupNoRouteDismiss,
                onBeforeShow: Bd,
                onBeforeHide: et,
                onHide: Te,
                onShow: We
            }, function() {
                return (0, $aD8ZA.h)("div", {
                    class: "q-select__dialog" + (I.value === !0 ? " q-select__dialog--dark q-dark" : "") + (c.value === !0 ? " q-select__dialog--focused" : "")
                }, F);
            });
        }
        function et(F) {
            Ld(F), L.value !== null && L.value.__updateRefocusTarget(V.rootRef.value.querySelector(".q-field__native > [tabindex]:last-child")), V.focused.value = !1;
        }
        function Te(F) {
            wr(), V.focused.value === !1 && o("blur", F), oi();
        }
        function We() {
            var F = document.activeElement;
            (F === null || F.id !== V.targetUid.value) && P.value !== null && P.value !== F && P.value.focus(), ie();
        }
        function rt() {
            a.value !== !0 && (l.value = -1, i.value === !0 && (i.value = !1), V.focused.value === !1 && (p !== null && (clearTimeout(p), p = null), V.innerLoading.value === !0 && (o("filterAbort"), V.innerLoading.value = !1, u.value = !1)));
        }
        function To(F) {
            V.editable.value === !0 && (m === !0 ? (V.onControlFocusin(F), a.value = !0, (0, $aD8ZA.nextTick)(function() {
                V.focus();
            })) : V.focus(), e.onFilter !== void 0 ? Ne(s.value) : (te.value !== !0 || t["no-option"] !== void 0) && (i.value = !0));
        }
        function wr() {
            a.value = !1, rt();
        }
        function oi() {
            e.useInput === !0 && Be(e.multiple !== !0 && e.fillInput === !0 && _.value.length !== 0 && se.value(_.value[0]) || "", !0, !0);
        }
        function Hs(F) {
            var xe = -1;
            if (F === !0) {
                if (_.value.length !== 0) {
                    var ge = ne.value(_.value[0]);
                    xe = e.options.findIndex(function(Ue) {
                        return Zt(ne.value(Ue), ge);
                    });
                }
                Q(xe);
            }
            G(xe);
        }
        function h0(F, xe) {
            i.value === !0 && V.innerLoading.value === !1 && (Q(-1, !0), (0, $aD8ZA.nextTick)(function() {
                i.value === !0 && V.innerLoading.value === !1 && (F > xe ? Q() : Hs(!0));
            }));
        }
        function Ed() {
            a.value === !1 && $.value !== null && $.value.updatePosition();
        }
        function Bd(F) {
            F !== void 0 && tt(F), o("popupShow", F), V.hasPopupOpen = !0, V.onControlFocusin(F);
        }
        function Ld(F) {
            F !== void 0 && tt(F), o("popupHide", F), V.hasPopupOpen = !1, V.onControlFocusout(F);
        }
        function Fd() {
            m = n.platform.is.mobile !== !0 && e.behavior !== "dialog" ? !1 : e.behavior !== "menu" && (e.useInput === !0 ? t["no-option"] !== void 0 || e.onFilter !== void 0 || te.value === !1 : !0), b = n.platform.is.ios === !0 && m === !0 && e.useInput === !0 ? "fade" : e.transitionShow;
        }
        return (0, $aD8ZA.onBeforeUpdate)(Fd), (0, $aD8ZA.onUpdated)(Ed), Fd(), (0, $aD8ZA.onBeforeUnmount)(function() {
            v !== null && clearTimeout(v), f !== null && clearTimeout(f);
        }), Object.assign(r, {
            showPopup: To,
            hidePopup: wr,
            removeAtIndex: Ae,
            add: ct,
            toggleOption: dt,
            getOptionIndex: function() {
                return l.value;
            },
            setOptionIndex: G,
            moveOptionSelection: re,
            filter: Ne,
            updateMenuPosition: Ed,
            updateInputValue: Be,
            isOptionSelected: ke,
            getEmittingOptionValue: Ee,
            isOptionDisabled: function() {
                for(var _len = arguments.length, F = new Array(_len), _key = 0; _key < _len; _key++){
                    F[_key] = arguments[_key];
                }
                return Y.value.apply(null, F) === !0;
            },
            getOptionValue: function() {
                for(var _len = arguments.length, F = new Array(_len), _key = 0; _key < _len; _key++){
                    F[_key] = arguments[_key];
                }
                return ne.value.apply(null, F);
            },
            getOptionLabel: function() {
                for(var _len = arguments.length, F = new Array(_len), _key = 0; _key < _len; _key++){
                    F[_key] = arguments[_key];
                }
                return se.value.apply(null, F);
            }
        }), Object.assign(V, {
            innerValue: _,
            fieldClass: (0, $aAzpa.computed)(function() {
                return "q-select q-field--auto-height q-select--with".concat(e.useInput !== !0 ? "out" : "", "-input q-select--with").concat(e.useChips !== !0 ? "out" : "", "-chips q-select--").concat(e.multiple === !0 ? "multiple" : "single");
            }),
            inputRef: S,
            targetRef: P,
            hasValue: oe,
            showPopup: To,
            floatingLabel: (0, $aAzpa.computed)(function() {
                return e.hideSelected !== !0 && oe.value === !0 || typeof s.value == "number" || s.value.length !== 0 || pn(e.displayValue);
            }),
            getControlChild: function() {
                if (V.editable.value !== !1 && (a.value === !0 || te.value !== !0 || t["no-option"] !== void 0)) return m === !0 ? fe() : pt();
                V.hasPopupOpen === !0 && (V.hasPopupOpen = !1);
            },
            controlEvents: {
                onFocusin: function(F) {
                    V.onControlFocusin(F);
                },
                onFocusout: function(F) {
                    V.onControlFocusout(F, function() {
                        oi(), rt();
                    });
                },
                onClick: function(F) {
                    if (ut(F), m !== !0 && i.value === !0) {
                        rt(), P.value !== null && P.value.focus();
                        return;
                    }
                    To(F);
                }
            },
            getControl: function(F) {
                var xe = kn(), ge = F === !0 || a.value !== !0 || m !== !0;
                if (e.useInput === !0) xe.push(Z(F, ge));
                else if (V.editable.value === !0) {
                    var vt = ge === !0 ? ce.value : void 0;
                    xe.push((0, $aD8ZA.h)("input", (0, $8typN._)((0, $8pZMQ._)({
                        ref: ge === !0 ? P : void 0,
                        key: "d_t",
                        class: "q-select__focus-target",
                        id: ge === !0 ? V.targetUid.value : void 0,
                        value: ue.value,
                        readonly: !0,
                        "data-autofocus": F === !0 || e.autofocus === !0 || void 0
                    }, vt), {
                        onKeydown: ht,
                        onKeyup: ye,
                        onKeypress: mt
                    }))), ge === !0 && typeof e.autocomplete == "string" && e.autocomplete.length !== 0 && xe.push((0, $aD8ZA.h)("input", {
                        class: "q-select__autocomplete-input",
                        autocomplete: e.autocomplete,
                        tabindex: -1,
                        onKeyup: Ge
                    }));
                }
                if (A.value !== void 0 && e.disable !== !0 && me.value.length !== 0) {
                    var vt1 = me.value.map(function(ft) {
                        return (0, $aD8ZA.h)("option", {
                            value: ft,
                            selected: !0
                        });
                    });
                    xe.push((0, $aD8ZA.h)("select", {
                        class: "hidden",
                        name: A.value,
                        multiple: e.multiple
                    }, vt1));
                }
                var Ue = e.useInput === !0 || ge !== !0 ? void 0 : V.splitAttrs.attributes.value;
                return (0, $aD8ZA.h)("div", (0, $8pZMQ._)({
                    class: "q-field__native row items-center"
                }, Ue, V.splitAttrs.listeners.value), xe);
            },
            getInnerAppend: function() {
                return e.loading !== !0 && u.value !== !0 && e.hideDropdownIcon !== !0 ? [
                    (0, $aD8ZA.h)(we, {
                        class: "q-select__dropdown-icon" + (i.value === !0 ? " rotate-180" : ""),
                        name: Re.value
                    })
                ] : null;
            }
        }), fr(V);
    }
});
var ew = [
    "text",
    "rect",
    "circle",
    "QBtn",
    "QBadge",
    "QChip",
    "QToolbar",
    "QCheckbox",
    "QRadio",
    "QToggle",
    "QSlider",
    "QRange",
    "QInput",
    "QAvatar"
], tw = [
    "wave",
    "pulse",
    "pulse-x",
    "pulse-y",
    "fade",
    "blink",
    "none"
], Qg = R({
    name: "QSkeleton",
    props: (0, $8typN._)((0, $8pZMQ._)({}, he), {
        tag: {
            type: String,
            default: "div"
        },
        type: {
            type: String,
            validator: function(e) {
                return ew.includes(e);
            },
            default: "rect"
        },
        animation: {
            type: String,
            validator: function(e) {
                return tw.includes(e);
            },
            default: "wave"
        },
        animationSpeed: {
            type: [
                String,
                Number
            ],
            default: 1500
        },
        square: Boolean,
        bordered: Boolean,
        size: String,
        width: String,
        height: String
    }),
    setup: function(e, param) {
        var t = param.slots;
        var o = (0, $aD8ZA.getCurrentInstance)(), r = pe(e, o.proxy.$q), n = (0, $aAzpa.computed)(function() {
            var a = e.size !== void 0 ? [
                e.size,
                e.size
            ] : [
                e.width,
                e.height
            ];
            return {
                "--q-skeleton-speed": "".concat(e.animationSpeed, "ms"),
                width: a[0],
                height: a[1]
            };
        }), i = (0, $aAzpa.computed)(function() {
            return "q-skeleton q-skeleton--".concat(r.value === !0 ? "dark" : "light", " q-skeleton--type-").concat(e.type) + (e.animation !== "none" ? " q-skeleton--anim q-skeleton--anim-".concat(e.animation) : "") + (e.square === !0 ? " q-skeleton--square" : "") + (e.bordered === !0 ? " q-skeleton--bordered" : "");
        });
        return function() {
            return (0, $aD8ZA.h)(e.tag, {
                class: i.value,
                style: n.value
            }, J(t.default));
        };
    }
});
var Ug = [
    [
        "left",
        "center",
        "start",
        "width"
    ],
    [
        "right",
        "center",
        "end",
        "width"
    ],
    [
        "top",
        "start",
        "center",
        "height"
    ],
    [
        "bottom",
        "end",
        "center",
        "height"
    ]
], Kg = R({
    name: "QSlideItem",
    props: (0, $8typN._)((0, $8pZMQ._)({}, he), {
        leftColor: String,
        rightColor: String,
        topColor: String,
        bottomColor: String,
        onSlide: Function
    }),
    emits: [
        "action",
        "top",
        "right",
        "bottom",
        "left"
    ],
    setup: function(e, param) {
        var t = param.slots, o = param.emit;
        var _aw = (0, $aD8ZA.getCurrentInstance)(), r = _aw.proxy, n = r.$q, i = pe(e, n), _No = No(), a = _No.getCache, l = (0, $aAzpa.ref)(null), s = null, c = {}, u = {}, v = {}, f = (0, $aAzpa.computed)(function() {
            return n.lang.rtl === !0 ? {
                left: "right",
                right: "left"
            } : {
                left: "left",
                right: "right"
            };
        }), d = (0, $aAzpa.computed)(function() {
            return "q-slide-item q-item-type overflow-hidden" + (i.value === !0 ? " q-slide-item--dark q-dark" : "");
        });
        function m() {
            l.value.style.transform = "translate(0,0)";
        }
        function y(C, b, h) {
            e.onSlide !== void 0 && o("slide", {
                side: C,
                ratio: b,
                isReset: h
            });
        }
        function p(C) {
            var b = l.value;
            if (C.isFirst) c = {
                dir: null,
                size: {
                    left: 0,
                    right: 0,
                    top: 0,
                    bottom: 0
                },
                scale: 0
            }, b.classList.add("no-transition"), Ug.forEach(function(P) {
                if (t[P[0]] !== void 0) {
                    var $ = v[P[0]];
                    $.style.transform = "scale(1)", c.size[P[0]] = $.getBoundingClientRect()[P[3]];
                }
            }), c.axis = C.direction === "up" || C.direction === "down" ? "Y" : "X";
            else if (C.isFinal) {
                b.classList.remove("no-transition"), c.scale === 1 ? (b.style.transform = "translate".concat(c.axis, "(").concat(c.dir * 100, "%)"), s !== null && clearTimeout(s), s = setTimeout(function() {
                    s = null, o(c.showing, {
                        reset: m
                    }), o("action", {
                        side: c.showing,
                        reset: m
                    });
                }, 230)) : (b.style.transform = "translate(0,0)", y(c.showing, 0, !0));
                return;
            } else C.direction = c.axis === "X" ? C.offset.x < 0 ? "left" : "right" : C.offset.y < 0 ? "up" : "down";
            if (t.left === void 0 && C.direction === f.value.right || t.right === void 0 && C.direction === f.value.left || t.top === void 0 && C.direction === "down" || t.bottom === void 0 && C.direction === "up") {
                b.style.transform = "translate(0,0)";
                return;
            }
            var h, g, S;
            c.axis === "X" ? (g = C.direction === "left" ? -1 : 1, h = g === 1 ? f.value.left : f.value.right, S = C.distance.x) : (g = C.direction === "up" ? -2 : 2, h = g === 2 ? "top" : "bottom", S = C.distance.y), !(c.dir !== null && Math.abs(g) !== Math.abs(c.dir)) && (c.dir !== g && ([
                "left",
                "right",
                "top",
                "bottom"
            ].forEach(function(P) {
                u[P] && (u[P].style.visibility = h === P ? "visible" : "hidden");
            }), c.showing = h, c.dir = g), c.scale = Math.max(0, Math.min(1, (S - 40) / c.size[h])), b.style.transform = "translate".concat(c.axis, "(").concat(S * g / Math.abs(g), "px)"), v[h].style.transform = "scale(".concat(c.scale, ")"), y(h, c.scale, !1));
        }
        return (0, $aD8ZA.onBeforeUpdate)(function() {
            u = {}, v = {};
        }), (0, $aD8ZA.onBeforeUnmount)(function() {
            s !== null && clearTimeout(s);
        }), Object.assign(r, {
            reset: m
        }), function() {
            var C = [], b = {
                left: t[f.value.right] !== void 0,
                right: t[f.value.left] !== void 0,
                up: t.bottom !== void 0,
                down: t.top !== void 0
            }, h = Object.keys(b).filter(function(S) {
                return b[S] === !0;
            });
            Ug.forEach(function(S) {
                var P = S[0];
                t[P] !== void 0 && C.push((0, $aD8ZA.h)("div", {
                    key: P,
                    ref: function($) {
                        u[P] = $;
                    },
                    class: "q-slide-item__".concat(P, " absolute-full row no-wrap items-").concat(S[1], " justify-").concat(S[2]) + (e[P + "Color"] !== void 0 ? " bg-".concat(e[P + "Color"]) : "")
                }, [
                    (0, $aD8ZA.h)("div", {
                        ref: function($) {
                            v[P] = $;
                        }
                    }, t[P]())
                ]));
            });
            var g = (0, $aD8ZA.h)("div", {
                key: "".concat(h.length === 0 ? "only-" : "", " content"),
                ref: l,
                class: "q-slide-item__content"
            }, J(t.default));
            return h.length === 0 ? C.push(g) : C.push((0, $aD8ZA.withDirectives)(g, a("dir#" + h.join(""), function() {
                var S = {
                    prevent: !0,
                    stop: !0,
                    mouse: !0
                };
                return h.forEach(function(P) {
                    S[P] = !0;
                }), [
                    [
                        qt,
                        p,
                        void 0,
                        S
                    ]
                ];
            }))), (0, $aD8ZA.h)("div", {
                class: d.value
            }, C);
        };
    }
});
var uw = (0, $aD8ZA.h)("div", {
    class: "q-space"
}), Wg = R({
    name: "QSpace",
    setup: function() {
        return function() {
            return uw;
        };
    }
});
var sw = [
    (0, $aD8ZA.h)("g", {
        transform: "matrix(1 0 0 -1 0 80)"
    }, [
        (0, $aD8ZA.h)("rect", {
            width: "10",
            height: "20",
            rx: "3"
        }, [
            (0, $aD8ZA.h)("animate", {
                attributeName: "height",
                begin: "0s",
                dur: "4.3s",
                values: "20;45;57;80;64;32;66;45;64;23;66;13;64;56;34;34;2;23;76;79;20",
                calcMode: "linear",
                repeatCount: "indefinite"
            })
        ]),
        (0, $aD8ZA.h)("rect", {
            x: "15",
            width: "10",
            height: "80",
            rx: "3"
        }, [
            (0, $aD8ZA.h)("animate", {
                attributeName: "height",
                begin: "0s",
                dur: "2s",
                values: "80;55;33;5;75;23;73;33;12;14;60;80",
                calcMode: "linear",
                repeatCount: "indefinite"
            })
        ]),
        (0, $aD8ZA.h)("rect", {
            x: "30",
            width: "10",
            height: "50",
            rx: "3"
        }, [
            (0, $aD8ZA.h)("animate", {
                attributeName: "height",
                begin: "0s",
                dur: "1.4s",
                values: "50;34;78;23;56;23;34;76;80;54;21;50",
                calcMode: "linear",
                repeatCount: "indefinite"
            })
        ]),
        (0, $aD8ZA.h)("rect", {
            x: "45",
            width: "10",
            height: "30",
            rx: "3"
        }, [
            (0, $aD8ZA.h)("animate", {
                attributeName: "height",
                begin: "0s",
                dur: "2s",
                values: "30;45;13;80;56;72;45;76;34;23;67;30",
                calcMode: "linear",
                repeatCount: "indefinite"
            })
        ])
    ])
], Yg = R({
    name: "QSpinnerAudio",
    props: Oe,
    setup: function(e) {
        var _Ve = Ve(e), t = _Ve.cSize, o = _Ve.classes;
        return function() {
            return (0, $aD8ZA.h)("svg", {
                class: o.value,
                fill: "currentColor",
                width: t.value,
                height: t.value,
                viewBox: "0 0 55 80",
                xmlns: "http://www.w3.org/2000/svg"
            }, sw);
        };
    }
});
var cw = [
    (0, $aD8ZA.h)("g", {
        transform: "translate(1 1)",
        "stroke-width": "2",
        fill: "none",
        "fill-rule": "evenodd"
    }, [
        (0, $aD8ZA.h)("circle", {
            cx: "5",
            cy: "50",
            r: "5"
        }, [
            (0, $aD8ZA.h)("animate", {
                attributeName: "cy",
                begin: "0s",
                dur: "2.2s",
                values: "50;5;50;50",
                calcMode: "linear",
                repeatCount: "indefinite"
            }),
            (0, $aD8ZA.h)("animate", {
                attributeName: "cx",
                begin: "0s",
                dur: "2.2s",
                values: "5;27;49;5",
                calcMode: "linear",
                repeatCount: "indefinite"
            })
        ]),
        (0, $aD8ZA.h)("circle", {
            cx: "27",
            cy: "5",
            r: "5"
        }, [
            (0, $aD8ZA.h)("animate", {
                attributeName: "cy",
                begin: "0s",
                dur: "2.2s",
                from: "5",
                to: "5",
                values: "5;50;50;5",
                calcMode: "linear",
                repeatCount: "indefinite"
            }),
            (0, $aD8ZA.h)("animate", {
                attributeName: "cx",
                begin: "0s",
                dur: "2.2s",
                from: "27",
                to: "27",
                values: "27;49;5;27",
                calcMode: "linear",
                repeatCount: "indefinite"
            })
        ]),
        (0, $aD8ZA.h)("circle", {
            cx: "49",
            cy: "50",
            r: "5"
        }, [
            (0, $aD8ZA.h)("animate", {
                attributeName: "cy",
                begin: "0s",
                dur: "2.2s",
                values: "50;50;5;50",
                calcMode: "linear",
                repeatCount: "indefinite"
            }),
            (0, $aD8ZA.h)("animate", {
                attributeName: "cx",
                from: "49",
                to: "49",
                begin: "0s",
                dur: "2.2s",
                values: "49;5;27;49",
                calcMode: "linear",
                repeatCount: "indefinite"
            })
        ])
    ])
], Xg = R({
    name: "QSpinnerBall",
    props: Oe,
    setup: function(e) {
        var _Ve = Ve(e), t = _Ve.cSize, o = _Ve.classes;
        return function() {
            return (0, $aD8ZA.h)("svg", {
                class: o.value,
                stroke: "currentColor",
                width: t.value,
                height: t.value,
                viewBox: "0 0 57 57",
                xmlns: "http://www.w3.org/2000/svg"
            }, cw);
        };
    }
});
var dw = [
    (0, $aD8ZA.h)("rect", {
        y: "10",
        width: "15",
        height: "120",
        rx: "6"
    }, [
        (0, $aD8ZA.h)("animate", {
            attributeName: "height",
            begin: "0.5s",
            dur: "1s",
            values: "120;110;100;90;80;70;60;50;40;140;120",
            calcMode: "linear",
            repeatCount: "indefinite"
        }),
        (0, $aD8ZA.h)("animate", {
            attributeName: "y",
            begin: "0.5s",
            dur: "1s",
            values: "10;15;20;25;30;35;40;45;50;0;10",
            calcMode: "linear",
            repeatCount: "indefinite"
        })
    ]),
    (0, $aD8ZA.h)("rect", {
        x: "30",
        y: "10",
        width: "15",
        height: "120",
        rx: "6"
    }, [
        (0, $aD8ZA.h)("animate", {
            attributeName: "height",
            begin: "0.25s",
            dur: "1s",
            values: "120;110;100;90;80;70;60;50;40;140;120",
            calcMode: "linear",
            repeatCount: "indefinite"
        }),
        (0, $aD8ZA.h)("animate", {
            attributeName: "y",
            begin: "0.25s",
            dur: "1s",
            values: "10;15;20;25;30;35;40;45;50;0;10",
            calcMode: "linear",
            repeatCount: "indefinite"
        })
    ]),
    (0, $aD8ZA.h)("rect", {
        x: "60",
        width: "15",
        height: "140",
        rx: "6"
    }, [
        (0, $aD8ZA.h)("animate", {
            attributeName: "height",
            begin: "0s",
            dur: "1s",
            values: "120;110;100;90;80;70;60;50;40;140;120",
            calcMode: "linear",
            repeatCount: "indefinite"
        }),
        (0, $aD8ZA.h)("animate", {
            attributeName: "y",
            begin: "0s",
            dur: "1s",
            values: "10;15;20;25;30;35;40;45;50;0;10",
            calcMode: "linear",
            repeatCount: "indefinite"
        })
    ]),
    (0, $aD8ZA.h)("rect", {
        x: "90",
        y: "10",
        width: "15",
        height: "120",
        rx: "6"
    }, [
        (0, $aD8ZA.h)("animate", {
            attributeName: "height",
            begin: "0.25s",
            dur: "1s",
            values: "120;110;100;90;80;70;60;50;40;140;120",
            calcMode: "linear",
            repeatCount: "indefinite"
        }),
        (0, $aD8ZA.h)("animate", {
            attributeName: "y",
            begin: "0.25s",
            dur: "1s",
            values: "10;15;20;25;30;35;40;45;50;0;10",
            calcMode: "linear",
            repeatCount: "indefinite"
        })
    ]),
    (0, $aD8ZA.h)("rect", {
        x: "120",
        y: "10",
        width: "15",
        height: "120",
        rx: "6"
    }, [
        (0, $aD8ZA.h)("animate", {
            attributeName: "height",
            begin: "0.5s",
            dur: "1s",
            values: "120;110;100;90;80;70;60;50;40;140;120",
            calcMode: "linear",
            repeatCount: "indefinite"
        }),
        (0, $aD8ZA.h)("animate", {
            attributeName: "y",
            begin: "0.5s",
            dur: "1s",
            values: "10;15;20;25;30;35;40;45;50;0;10",
            calcMode: "linear",
            repeatCount: "indefinite"
        })
    ])
], Gg = R({
    name: "QSpinnerBars",
    props: Oe,
    setup: function(e) {
        var _Ve = Ve(e), t = _Ve.cSize, o = _Ve.classes;
        return function() {
            return (0, $aD8ZA.h)("svg", {
                class: o.value,
                fill: "currentColor",
                width: t.value,
                height: t.value,
                viewBox: "0 0 135 140",
                xmlns: "http://www.w3.org/2000/svg"
            }, dw);
        };
    }
});
var fw = [
    (0, $aD8ZA.h)("rect", {
        x: "25",
        y: "25",
        width: "50",
        height: "50",
        fill: "none",
        "stroke-width": "4",
        stroke: "currentColor"
    }, [
        (0, $aD8ZA.h)("animateTransform", {
            id: "spinnerBox",
            attributeName: "transform",
            type: "rotate",
            from: "0 50 50",
            to: "180 50 50",
            dur: "0.5s",
            begin: "rectBox.end"
        })
    ]),
    (0, $aD8ZA.h)("rect", {
        x: "27",
        y: "27",
        width: "46",
        height: "50",
        fill: "currentColor"
    }, [
        (0, $aD8ZA.h)("animate", {
            id: "rectBox",
            attributeName: "height",
            begin: "0s;spinnerBox.end",
            dur: "1.3s",
            from: "50",
            to: "0",
            fill: "freeze"
        })
    ])
], Zg = R({
    name: "QSpinnerBox",
    props: Oe,
    setup: function(e) {
        var _Ve = Ve(e), t = _Ve.cSize, o = _Ve.classes;
        return function() {
            return (0, $aD8ZA.h)("svg", {
                class: o.value,
                width: t.value,
                height: t.value,
                viewBox: "0 0 100 100",
                preserveAspectRatio: "xMidYMid",
                xmlns: "http://www.w3.org/2000/svg"
            }, fw);
        };
    }
});
var mw = [
    (0, $aD8ZA.h)("circle", {
        cx: "50",
        cy: "50",
        r: "48",
        fill: "none",
        "stroke-width": "4",
        "stroke-miterlimit": "10",
        stroke: "currentColor"
    }),
    (0, $aD8ZA.h)("line", {
        "stroke-linecap": "round",
        "stroke-width": "4",
        "stroke-miterlimit": "10",
        stroke: "currentColor",
        x1: "50",
        y1: "50",
        x2: "85",
        y2: "50.5"
    }, [
        (0, $aD8ZA.h)("animateTransform", {
            attributeName: "transform",
            type: "rotate",
            from: "0 50 50",
            to: "360 50 50",
            dur: "2s",
            repeatCount: "indefinite"
        })
    ]),
    (0, $aD8ZA.h)("line", {
        "stroke-linecap": "round",
        "stroke-width": "4",
        "stroke-miterlimit": "10",
        stroke: "currentColor",
        x1: "50",
        y1: "50",
        x2: "49.5",
        y2: "74"
    }, [
        (0, $aD8ZA.h)("animateTransform", {
            attributeName: "transform",
            type: "rotate",
            from: "0 50 50",
            to: "360 50 50",
            dur: "15s",
            repeatCount: "indefinite"
        })
    ])
], Jg = R({
    name: "QSpinnerClock",
    props: Oe,
    setup: function(e) {
        var _Ve = Ve(e), t = _Ve.cSize, o = _Ve.classes;
        return function() {
            return (0, $aD8ZA.h)("svg", {
                class: o.value,
                width: t.value,
                height: t.value,
                viewBox: "0 0 100 100",
                preserveAspectRatio: "xMidYMid",
                xmlns: "http://www.w3.org/2000/svg"
            }, mw);
        };
    }
});
var vw = [
    (0, $aD8ZA.h)("rect", {
        x: "0",
        y: "0",
        width: "100",
        height: "100",
        fill: "none"
    }),
    (0, $aD8ZA.h)("path", {
        d: "M78,19H22c-6.6,0-12,5.4-12,12v31c0,6.6,5.4,12,12,12h37.2c0.4,3,1.8,5.6,3.7,7.6c2.4,2.5,5.1,4.1,9.1,4 c-1.4-2.1-2-7.2-2-10.3c0-0.4,0-0.8,0-1.3h8c6.6,0,12-5.4,12-12V31C90,24.4,84.6,19,78,19z",
        fill: "currentColor"
    }),
    (0, $aD8ZA.h)("circle", {
        cx: "30",
        cy: "47",
        r: "5",
        fill: "#fff"
    }, [
        (0, $aD8ZA.h)("animate", {
            attributeName: "opacity",
            from: "0",
            to: "1",
            values: "0;1;1",
            keyTimes: "0;0.2;1",
            dur: "1s",
            repeatCount: "indefinite"
        })
    ]),
    (0, $aD8ZA.h)("circle", {
        cx: "50",
        cy: "47",
        r: "5",
        fill: "#fff"
    }, [
        (0, $aD8ZA.h)("animate", {
            attributeName: "opacity",
            from: "0",
            to: "1",
            values: "0;0;1;1",
            keyTimes: "0;0.2;0.4;1",
            dur: "1s",
            repeatCount: "indefinite"
        })
    ]),
    (0, $aD8ZA.h)("circle", {
        cx: "70",
        cy: "47",
        r: "5",
        fill: "#fff"
    }, [
        (0, $aD8ZA.h)("animate", {
            attributeName: "opacity",
            from: "0",
            to: "1",
            values: "0;0;1;1",
            keyTimes: "0;0.4;0.6;1",
            dur: "1s",
            repeatCount: "indefinite"
        })
    ])
], eh = R({
    name: "QSpinnerComment",
    props: Oe,
    setup: function(e) {
        var _Ve = Ve(e), t = _Ve.cSize, o = _Ve.classes;
        return function() {
            return (0, $aD8ZA.h)("svg", {
                class: o.value,
                width: t.value,
                height: t.value,
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 100 100",
                preserveAspectRatio: "xMidYMid"
            }, vw);
        };
    }
});
var gw = [
    (0, $aD8ZA.h)("rect", {
        x: "0",
        y: "0",
        width: "100",
        height: "100",
        fill: "none"
    }),
    (0, $aD8ZA.h)("g", {
        transform: "translate(25 25)"
    }, [
        (0, $aD8ZA.h)("rect", {
            x: "-20",
            y: "-20",
            width: "40",
            height: "40",
            fill: "currentColor",
            opacity: "0.9"
        }, [
            (0, $aD8ZA.h)("animateTransform", {
                attributeName: "transform",
                type: "scale",
                from: "1.5",
                to: "1",
                repeatCount: "indefinite",
                begin: "0s",
                dur: "1s",
                calcMode: "spline",
                keySplines: "0.2 0.8 0.2 0.8",
                keyTimes: "0;1"
            })
        ])
    ]),
    (0, $aD8ZA.h)("g", {
        transform: "translate(75 25)"
    }, [
        (0, $aD8ZA.h)("rect", {
            x: "-20",
            y: "-20",
            width: "40",
            height: "40",
            fill: "currentColor",
            opacity: "0.8"
        }, [
            (0, $aD8ZA.h)("animateTransform", {
                attributeName: "transform",
                type: "scale",
                from: "1.5",
                to: "1",
                repeatCount: "indefinite",
                begin: "0.1s",
                dur: "1s",
                calcMode: "spline",
                keySplines: "0.2 0.8 0.2 0.8",
                keyTimes: "0;1"
            })
        ])
    ]),
    (0, $aD8ZA.h)("g", {
        transform: "translate(25 75)"
    }, [
        (0, $aD8ZA.h)("rect", {
            x: "-20",
            y: "-20",
            width: "40",
            height: "40",
            fill: "currentColor",
            opacity: "0.7"
        }, [
            (0, $aD8ZA.h)("animateTransform", {
                attributeName: "transform",
                type: "scale",
                from: "1.5",
                to: "1",
                repeatCount: "indefinite",
                begin: "0.3s",
                dur: "1s",
                calcMode: "spline",
                keySplines: "0.2 0.8 0.2 0.8",
                keyTimes: "0;1"
            })
        ])
    ]),
    (0, $aD8ZA.h)("g", {
        transform: "translate(75 75)"
    }, [
        (0, $aD8ZA.h)("rect", {
            x: "-20",
            y: "-20",
            width: "40",
            height: "40",
            fill: "currentColor",
            opacity: "0.6"
        }, [
            (0, $aD8ZA.h)("animateTransform", {
                attributeName: "transform",
                type: "scale",
                from: "1.5",
                to: "1",
                repeatCount: "indefinite",
                begin: "0.2s",
                dur: "1s",
                calcMode: "spline",
                keySplines: "0.2 0.8 0.2 0.8",
                keyTimes: "0;1"
            })
        ])
    ])
], th = R({
    name: "QSpinnerCube",
    props: Oe,
    setup: function(e) {
        var _Ve = Ve(e), t = _Ve.cSize, o = _Ve.classes;
        return function() {
            return (0, $aD8ZA.h)("svg", {
                class: o.value,
                width: t.value,
                height: t.value,
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 100 100",
                preserveAspectRatio: "xMidYMid"
            }, gw);
        };
    }
});
var hw = [
    (0, $aD8ZA.h)("circle", {
        cx: "15",
        cy: "15",
        r: "15"
    }, [
        (0, $aD8ZA.h)("animate", {
            attributeName: "r",
            from: "15",
            to: "15",
            begin: "0s",
            dur: "0.8s",
            values: "15;9;15",
            calcMode: "linear",
            repeatCount: "indefinite"
        }),
        (0, $aD8ZA.h)("animate", {
            attributeName: "fill-opacity",
            from: "1",
            to: "1",
            begin: "0s",
            dur: "0.8s",
            values: "1;.5;1",
            calcMode: "linear",
            repeatCount: "indefinite"
        })
    ]),
    (0, $aD8ZA.h)("circle", {
        cx: "60",
        cy: "15",
        r: "9",
        "fill-opacity": ".3"
    }, [
        (0, $aD8ZA.h)("animate", {
            attributeName: "r",
            from: "9",
            to: "9",
            begin: "0s",
            dur: "0.8s",
            values: "9;15;9",
            calcMode: "linear",
            repeatCount: "indefinite"
        }),
        (0, $aD8ZA.h)("animate", {
            attributeName: "fill-opacity",
            from: ".5",
            to: ".5",
            begin: "0s",
            dur: "0.8s",
            values: ".5;1;.5",
            calcMode: "linear",
            repeatCount: "indefinite"
        })
    ]),
    (0, $aD8ZA.h)("circle", {
        cx: "105",
        cy: "15",
        r: "15"
    }, [
        (0, $aD8ZA.h)("animate", {
            attributeName: "r",
            from: "15",
            to: "15",
            begin: "0s",
            dur: "0.8s",
            values: "15;9;15",
            calcMode: "linear",
            repeatCount: "indefinite"
        }),
        (0, $aD8ZA.h)("animate", {
            attributeName: "fill-opacity",
            from: "1",
            to: "1",
            begin: "0s",
            dur: "0.8s",
            values: "1;.5;1",
            calcMode: "linear",
            repeatCount: "indefinite"
        })
    ])
], oh = R({
    name: "QSpinnerDots",
    props: Oe,
    setup: function(e) {
        var _Ve = Ve(e), t = _Ve.cSize, o = _Ve.classes;
        return function() {
            return (0, $aD8ZA.h)("svg", {
                class: o.value,
                fill: "currentColor",
                width: t.value,
                height: t.value,
                viewBox: "0 0 120 30",
                xmlns: "http://www.w3.org/2000/svg"
            }, hw);
        };
    }
});
var pw = [
    (0, $aD8ZA.h)("g", {
        transform: "translate(20 50)"
    }, [
        (0, $aD8ZA.h)("rect", {
            x: "-10",
            y: "-30",
            width: "20",
            height: "60",
            fill: "currentColor",
            opacity: "0.6"
        }, [
            (0, $aD8ZA.h)("animateTransform", {
                attributeName: "transform",
                type: "scale",
                from: "2",
                to: "1",
                begin: "0s",
                repeatCount: "indefinite",
                dur: "1s",
                calcMode: "spline",
                keySplines: "0.1 0.9 0.4 1",
                keyTimes: "0;1",
                values: "2;1"
            })
        ])
    ]),
    (0, $aD8ZA.h)("g", {
        transform: "translate(50 50)"
    }, [
        (0, $aD8ZA.h)("rect", {
            x: "-10",
            y: "-30",
            width: "20",
            height: "60",
            fill: "currentColor",
            opacity: "0.8"
        }, [
            (0, $aD8ZA.h)("animateTransform", {
                attributeName: "transform",
                type: "scale",
                from: "2",
                to: "1",
                begin: "0.1s",
                repeatCount: "indefinite",
                dur: "1s",
                calcMode: "spline",
                keySplines: "0.1 0.9 0.4 1",
                keyTimes: "0;1",
                values: "2;1"
            })
        ])
    ]),
    (0, $aD8ZA.h)("g", {
        transform: "translate(80 50)"
    }, [
        (0, $aD8ZA.h)("rect", {
            x: "-10",
            y: "-30",
            width: "20",
            height: "60",
            fill: "currentColor",
            opacity: "0.9"
        }, [
            (0, $aD8ZA.h)("animateTransform", {
                attributeName: "transform",
                type: "scale",
                from: "2",
                to: "1",
                begin: "0.2s",
                repeatCount: "indefinite",
                dur: "1s",
                calcMode: "spline",
                keySplines: "0.1 0.9 0.4 1",
                keyTimes: "0;1",
                values: "2;1"
            })
        ])
    ])
], nh = R({
    name: "QSpinnerFacebook",
    props: Oe,
    setup: function(e) {
        var _Ve = Ve(e), t = _Ve.cSize, o = _Ve.classes;
        return function() {
            return (0, $aD8ZA.h)("svg", {
                class: o.value,
                width: t.value,
                height: t.value,
                viewBox: "0 0 100 100",
                xmlns: "http://www.w3.org/2000/svg",
                preserveAspectRatio: "xMidYMid"
            }, pw);
        };
    }
});
var bw = [
    (0, $aD8ZA.h)("g", {
        transform: "translate(-20,-20)"
    }, [
        (0, $aD8ZA.h)("path", {
            d: "M79.9,52.6C80,51.8,80,50.9,80,50s0-1.8-0.1-2.6l-5.1-0.4c-0.3-2.4-0.9-4.6-1.8-6.7l4.2-2.9c-0.7-1.6-1.6-3.1-2.6-4.5 L70,35c-1.4-1.9-3.1-3.5-4.9-4.9l2.2-4.6c-1.4-1-2.9-1.9-4.5-2.6L59.8,27c-2.1-0.9-4.4-1.5-6.7-1.8l-0.4-5.1C51.8,20,50.9,20,50,20 s-1.8,0-2.6,0.1l-0.4,5.1c-2.4,0.3-4.6,0.9-6.7,1.8l-2.9-4.1c-1.6,0.7-3.1,1.6-4.5,2.6l2.1,4.6c-1.9,1.4-3.5,3.1-5,4.9l-4.5-2.1 c-1,1.4-1.9,2.9-2.6,4.5l4.1,2.9c-0.9,2.1-1.5,4.4-1.8,6.8l-5,0.4C20,48.2,20,49.1,20,50s0,1.8,0.1,2.6l5,0.4 c0.3,2.4,0.9,4.7,1.8,6.8l-4.1,2.9c0.7,1.6,1.6,3.1,2.6,4.5l4.5-2.1c1.4,1.9,3.1,3.5,5,4.9l-2.1,4.6c1.4,1,2.9,1.9,4.5,2.6l2.9-4.1 c2.1,0.9,4.4,1.5,6.7,1.8l0.4,5.1C48.2,80,49.1,80,50,80s1.8,0,2.6-0.1l0.4-5.1c2.3-0.3,4.6-0.9,6.7-1.8l2.9,4.2 c1.6-0.7,3.1-1.6,4.5-2.6L65,69.9c1.9-1.4,3.5-3,4.9-4.9l4.6,2.2c1-1.4,1.9-2.9,2.6-4.5L73,59.8c0.9-2.1,1.5-4.4,1.8-6.7L79.9,52.6 z M50,65c-8.3,0-15-6.7-15-15c0-8.3,6.7-15,15-15s15,6.7,15,15C65,58.3,58.3,65,50,65z",
            fill: "currentColor"
        }, [
            (0, $aD8ZA.h)("animateTransform", {
                attributeName: "transform",
                type: "rotate",
                from: "90 50 50",
                to: "0 50 50",
                dur: "1s",
                repeatCount: "indefinite"
            })
        ])
    ]),
    (0, $aD8ZA.h)("g", {
        transform: "translate(20,20) rotate(15 50 50)"
    }, [
        (0, $aD8ZA.h)("path", {
            d: "M79.9,52.6C80,51.8,80,50.9,80,50s0-1.8-0.1-2.6l-5.1-0.4c-0.3-2.4-0.9-4.6-1.8-6.7l4.2-2.9c-0.7-1.6-1.6-3.1-2.6-4.5 L70,35c-1.4-1.9-3.1-3.5-4.9-4.9l2.2-4.6c-1.4-1-2.9-1.9-4.5-2.6L59.8,27c-2.1-0.9-4.4-1.5-6.7-1.8l-0.4-5.1C51.8,20,50.9,20,50,20 s-1.8,0-2.6,0.1l-0.4,5.1c-2.4,0.3-4.6,0.9-6.7,1.8l-2.9-4.1c-1.6,0.7-3.1,1.6-4.5,2.6l2.1,4.6c-1.9,1.4-3.5,3.1-5,4.9l-4.5-2.1 c-1,1.4-1.9,2.9-2.6,4.5l4.1,2.9c-0.9,2.1-1.5,4.4-1.8,6.8l-5,0.4C20,48.2,20,49.1,20,50s0,1.8,0.1,2.6l5,0.4 c0.3,2.4,0.9,4.7,1.8,6.8l-4.1,2.9c0.7,1.6,1.6,3.1,2.6,4.5l4.5-2.1c1.4,1.9,3.1,3.5,5,4.9l-2.1,4.6c1.4,1,2.9,1.9,4.5,2.6l2.9-4.1 c2.1,0.9,4.4,1.5,6.7,1.8l0.4,5.1C48.2,80,49.1,80,50,80s1.8,0,2.6-0.1l0.4-5.1c2.3-0.3,4.6-0.9,6.7-1.8l2.9,4.2 c1.6-0.7,3.1-1.6,4.5-2.6L65,69.9c1.9-1.4,3.5-3,4.9-4.9l4.6,2.2c1-1.4,1.9-2.9,2.6-4.5L73,59.8c0.9-2.1,1.5-4.4,1.8-6.7L79.9,52.6 z M50,65c-8.3,0-15-6.7-15-15c0-8.3,6.7-15,15-15s15,6.7,15,15C65,58.3,58.3,65,50,65z",
            fill: "currentColor"
        }, [
            (0, $aD8ZA.h)("animateTransform", {
                attributeName: "transform",
                type: "rotate",
                from: "0 50 50",
                to: "90 50 50",
                dur: "1s",
                repeatCount: "indefinite"
            })
        ])
    ])
], rh = R({
    name: "QSpinnerGears",
    props: Oe,
    setup: function(e) {
        var _Ve = Ve(e), t = _Ve.cSize, o = _Ve.classes;
        return function() {
            return (0, $aD8ZA.h)("svg", {
                class: o.value,
                width: t.value,
                height: t.value,
                viewBox: "0 0 100 100",
                preserveAspectRatio: "xMidYMid",
                xmlns: "http://www.w3.org/2000/svg"
            }, bw);
        };
    }
});
var yw = [
    (0, $aD8ZA.h)("circle", {
        cx: "12.5",
        cy: "12.5",
        r: "12.5"
    }, [
        (0, $aD8ZA.h)("animate", {
            attributeName: "fill-opacity",
            begin: "0s",
            dur: "1s",
            values: "1;.2;1",
            calcMode: "linear",
            repeatCount: "indefinite"
        })
    ]),
    (0, $aD8ZA.h)("circle", {
        cx: "12.5",
        cy: "52.5",
        r: "12.5",
        "fill-opacity": ".5"
    }, [
        (0, $aD8ZA.h)("animate", {
            attributeName: "fill-opacity",
            begin: "100ms",
            dur: "1s",
            values: "1;.2;1",
            calcMode: "linear",
            repeatCount: "indefinite"
        })
    ]),
    (0, $aD8ZA.h)("circle", {
        cx: "52.5",
        cy: "12.5",
        r: "12.5"
    }, [
        (0, $aD8ZA.h)("animate", {
            attributeName: "fill-opacity",
            begin: "300ms",
            dur: "1s",
            values: "1;.2;1",
            calcMode: "linear",
            repeatCount: "indefinite"
        })
    ]),
    (0, $aD8ZA.h)("circle", {
        cx: "52.5",
        cy: "52.5",
        r: "12.5"
    }, [
        (0, $aD8ZA.h)("animate", {
            attributeName: "fill-opacity",
            begin: "600ms",
            dur: "1s",
            values: "1;.2;1",
            calcMode: "linear",
            repeatCount: "indefinite"
        })
    ]),
    (0, $aD8ZA.h)("circle", {
        cx: "92.5",
        cy: "12.5",
        r: "12.5"
    }, [
        (0, $aD8ZA.h)("animate", {
            attributeName: "fill-opacity",
            begin: "800ms",
            dur: "1s",
            values: "1;.2;1",
            calcMode: "linear",
            repeatCount: "indefinite"
        })
    ]),
    (0, $aD8ZA.h)("circle", {
        cx: "92.5",
        cy: "52.5",
        r: "12.5"
    }, [
        (0, $aD8ZA.h)("animate", {
            attributeName: "fill-opacity",
            begin: "400ms",
            dur: "1s",
            values: "1;.2;1",
            calcMode: "linear",
            repeatCount: "indefinite"
        })
    ]),
    (0, $aD8ZA.h)("circle", {
        cx: "12.5",
        cy: "92.5",
        r: "12.5"
    }, [
        (0, $aD8ZA.h)("animate", {
            attributeName: "fill-opacity",
            begin: "700ms",
            dur: "1s",
            values: "1;.2;1",
            calcMode: "linear",
            repeatCount: "indefinite"
        })
    ]),
    (0, $aD8ZA.h)("circle", {
        cx: "52.5",
        cy: "92.5",
        r: "12.5"
    }, [
        (0, $aD8ZA.h)("animate", {
            attributeName: "fill-opacity",
            begin: "500ms",
            dur: "1s",
            values: "1;.2;1",
            calcMode: "linear",
            repeatCount: "indefinite"
        })
    ]),
    (0, $aD8ZA.h)("circle", {
        cx: "92.5",
        cy: "92.5",
        r: "12.5"
    }, [
        (0, $aD8ZA.h)("animate", {
            attributeName: "fill-opacity",
            begin: "200ms",
            dur: "1s",
            values: "1;.2;1",
            calcMode: "linear",
            repeatCount: "indefinite"
        })
    ])
], ih = R({
    name: "QSpinnerGrid",
    props: Oe,
    setup: function(e) {
        var _Ve = Ve(e), t = _Ve.cSize, o = _Ve.classes;
        return function() {
            return (0, $aD8ZA.h)("svg", {
                class: o.value,
                fill: "currentColor",
                width: t.value,
                height: t.value,
                viewBox: "0 0 105 105",
                xmlns: "http://www.w3.org/2000/svg"
            }, yw);
        };
    }
});
var Sw = [
    (0, $aD8ZA.h)("path", {
        d: "M30.262 57.02L7.195 40.723c-5.84-3.976-7.56-12.06-3.842-18.063 3.715-6 11.467-7.65 17.306-3.68l4.52 3.76 2.6-5.274c3.716-6.002 11.47-7.65 17.304-3.68 5.84 3.97 7.56 12.054 3.842 18.062L34.49 56.118c-.897 1.512-2.793 1.915-4.228.9z",
        "fill-opacity": ".5"
    }, [
        (0, $aD8ZA.h)("animate", {
            attributeName: "fill-opacity",
            begin: "0s",
            dur: "1.4s",
            values: "0.5;1;0.5",
            calcMode: "linear",
            repeatCount: "indefinite"
        })
    ]),
    (0, $aD8ZA.h)("path", {
        d: "M105.512 56.12l-14.44-24.272c-3.716-6.008-1.996-14.093 3.843-18.062 5.835-3.97 13.588-2.322 17.306 3.68l2.6 5.274 4.52-3.76c5.84-3.97 13.593-2.32 17.308 3.68 3.718 6.003 1.998 14.088-3.842 18.064L109.74 57.02c-1.434 1.014-3.33.61-4.228-.9z",
        "fill-opacity": ".5"
    }, [
        (0, $aD8ZA.h)("animate", {
            attributeName: "fill-opacity",
            begin: "0.7s",
            dur: "1.4s",
            values: "0.5;1;0.5",
            calcMode: "linear",
            repeatCount: "indefinite"
        })
    ]),
    (0, $aD8ZA.h)("path", {
        d: "M67.408 57.834l-23.01-24.98c-5.864-6.15-5.864-16.108 0-22.248 5.86-6.14 15.37-6.14 21.234 0L70 16.168l4.368-5.562c5.863-6.14 15.375-6.14 21.235 0 5.863 6.14 5.863 16.098 0 22.247l-23.007 24.98c-1.43 1.556-3.757 1.556-5.188 0z"
    })
], ah = R({
    name: "QSpinnerHearts",
    props: Oe,
    setup: function(e) {
        var _Ve = Ve(e), t = _Ve.cSize, o = _Ve.classes;
        return function() {
            return (0, $aD8ZA.h)("svg", {
                class: o.value,
                fill: "currentColor",
                width: t.value,
                height: t.value,
                viewBox: "0 0 140 64",
                xmlns: "http://www.w3.org/2000/svg"
            }, Sw);
        };
    }
});
var xw = [
    (0, $aD8ZA.h)("g", [
        (0, $aD8ZA.h)("path", {
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "5",
            "stroke-miterlimit": "10",
            d: "M58.4,51.7c-0.9-0.9-1.4-2-1.4-2.3s0.5-0.4,1.4-1.4 C70.8,43.8,79.8,30.5,80,15.5H70H30H20c0.2,15,9.2,28.1,21.6,32.3c0.9,0.9,1.4,1.2,1.4,1.5s-0.5,1.6-1.4,2.5 C29.2,56.1,20.2,69.5,20,85.5h10h40h10C79.8,69.5,70.8,55.9,58.4,51.7z"
        }),
        (0, $aD8ZA.h)("clipPath", {
            id: "uil-hourglass-clip1"
        }, [
            (0, $aD8ZA.h)("rect", {
                x: "15",
                y: "20",
                width: "70",
                height: "25"
            }, [
                (0, $aD8ZA.h)("animate", {
                    attributeName: "height",
                    from: "25",
                    to: "0",
                    dur: "1s",
                    repeatCount: "indefinite",
                    values: "25;0;0",
                    keyTimes: "0;0.5;1"
                }),
                (0, $aD8ZA.h)("animate", {
                    attributeName: "y",
                    from: "20",
                    to: "45",
                    dur: "1s",
                    repeatCount: "indefinite",
                    values: "20;45;45",
                    keyTimes: "0;0.5;1"
                })
            ])
        ]),
        (0, $aD8ZA.h)("clipPath", {
            id: "uil-hourglass-clip2"
        }, [
            (0, $aD8ZA.h)("rect", {
                x: "15",
                y: "55",
                width: "70",
                height: "25"
            }, [
                (0, $aD8ZA.h)("animate", {
                    attributeName: "height",
                    from: "0",
                    to: "25",
                    dur: "1s",
                    repeatCount: "indefinite",
                    values: "0;25;25",
                    keyTimes: "0;0.5;1"
                }),
                (0, $aD8ZA.h)("animate", {
                    attributeName: "y",
                    from: "80",
                    to: "55",
                    dur: "1s",
                    repeatCount: "indefinite",
                    values: "80;55;55",
                    keyTimes: "0;0.5;1"
                })
            ])
        ]),
        (0, $aD8ZA.h)("path", {
            d: "M29,23c3.1,11.4,11.3,19.5,21,19.5S67.9,34.4,71,23H29z",
            "clip-path": "url(#uil-hourglass-clip1)",
            fill: "currentColor"
        }),
        (0, $aD8ZA.h)("path", {
            d: "M71.6,78c-3-11.6-11.5-20-21.5-20s-18.5,8.4-21.5,20H71.6z",
            "clip-path": "url(#uil-hourglass-clip2)",
            fill: "currentColor"
        }),
        (0, $aD8ZA.h)("animateTransform", {
            attributeName: "transform",
            type: "rotate",
            from: "0 50 50",
            to: "180 50 50",
            repeatCount: "indefinite",
            dur: "1s",
            values: "0 50 50;0 50 50;180 50 50",
            keyTimes: "0;0.7;1"
        })
    ])
], lh = R({
    name: "QSpinnerHourglass",
    props: Oe,
    setup: function(e) {
        var _Ve = Ve(e), t = _Ve.cSize, o = _Ve.classes;
        return function() {
            return (0, $aD8ZA.h)("svg", {
                class: o.value,
                width: t.value,
                height: t.value,
                viewBox: "0 0 100 100",
                preserveAspectRatio: "xMidYMid",
                xmlns: "http://www.w3.org/2000/svg"
            }, xw);
        };
    }
});
var _w = [
    (0, $aD8ZA.h)("path", {
        d: "M24.3,30C11.4,30,5,43.3,5,50s6.4,20,19.3,20c19.3,0,32.1-40,51.4-40C88.6,30,95,43.3,95,50s-6.4,20-19.3,20C56.4,70,43.6,30,24.3,30z",
        fill: "none",
        stroke: "currentColor",
        "stroke-width": "8",
        "stroke-dasharray": "10.691205342610678 10.691205342610678",
        "stroke-dashoffset": "0"
    }, [
        (0, $aD8ZA.h)("animate", {
            attributeName: "stroke-dashoffset",
            from: "0",
            to: "21.382410685221355",
            begin: "0",
            dur: "2s",
            repeatCount: "indefinite",
            fill: "freeze"
        })
    ])
], uh = R({
    name: "QSpinnerInfinity",
    props: Oe,
    setup: function(e) {
        var _Ve = Ve(e), t = _Ve.cSize, o = _Ve.classes;
        return function() {
            return (0, $aD8ZA.h)("svg", {
                class: o.value,
                width: t.value,
                height: t.value,
                viewBox: "0 0 100 100",
                preserveAspectRatio: "xMidYMid"
            }, _w);
        };
    }
});
var Cw = [
    (0, $aD8ZA.h)("g", {
        "stroke-width": "4",
        "stroke-linecap": "round"
    }, [
        (0, $aD8ZA.h)("line", {
            y1: "17",
            y2: "29",
            transform: "translate(32,32) rotate(180)"
        }, [
            (0, $aD8ZA.h)("animate", {
                attributeName: "stroke-opacity",
                dur: "750ms",
                values: "1;.85;.7;.65;.55;.45;.35;.25;.15;.1;0;1",
                repeatCount: "indefinite"
            })
        ]),
        (0, $aD8ZA.h)("line", {
            y1: "17",
            y2: "29",
            transform: "translate(32,32) rotate(210)"
        }, [
            (0, $aD8ZA.h)("animate", {
                attributeName: "stroke-opacity",
                dur: "750ms",
                values: "0;1;.85;.7;.65;.55;.45;.35;.25;.15;.1;0",
                repeatCount: "indefinite"
            })
        ]),
        (0, $aD8ZA.h)("line", {
            y1: "17",
            y2: "29",
            transform: "translate(32,32) rotate(240)"
        }, [
            (0, $aD8ZA.h)("animate", {
                attributeName: "stroke-opacity",
                dur: "750ms",
                values: ".1;0;1;.85;.7;.65;.55;.45;.35;.25;.15;.1",
                repeatCount: "indefinite"
            })
        ]),
        (0, $aD8ZA.h)("line", {
            y1: "17",
            y2: "29",
            transform: "translate(32,32) rotate(270)"
        }, [
            (0, $aD8ZA.h)("animate", {
                attributeName: "stroke-opacity",
                dur: "750ms",
                values: ".15;.1;0;1;.85;.7;.65;.55;.45;.35;.25;.15",
                repeatCount: "indefinite"
            })
        ]),
        (0, $aD8ZA.h)("line", {
            y1: "17",
            y2: "29",
            transform: "translate(32,32) rotate(300)"
        }, [
            (0, $aD8ZA.h)("animate", {
                attributeName: "stroke-opacity",
                dur: "750ms",
                values: ".25;.15;.1;0;1;.85;.7;.65;.55;.45;.35;.25",
                repeatCount: "indefinite"
            })
        ]),
        (0, $aD8ZA.h)("line", {
            y1: "17",
            y2: "29",
            transform: "translate(32,32) rotate(330)"
        }, [
            (0, $aD8ZA.h)("animate", {
                attributeName: "stroke-opacity",
                dur: "750ms",
                values: ".35;.25;.15;.1;0;1;.85;.7;.65;.55;.45;.35",
                repeatCount: "indefinite"
            })
        ]),
        (0, $aD8ZA.h)("line", {
            y1: "17",
            y2: "29",
            transform: "translate(32,32) rotate(0)"
        }, [
            (0, $aD8ZA.h)("animate", {
                attributeName: "stroke-opacity",
                dur: "750ms",
                values: ".45;.35;.25;.15;.1;0;1;.85;.7;.65;.55;.45",
                repeatCount: "indefinite"
            })
        ]),
        (0, $aD8ZA.h)("line", {
            y1: "17",
            y2: "29",
            transform: "translate(32,32) rotate(30)"
        }, [
            (0, $aD8ZA.h)("animate", {
                attributeName: "stroke-opacity",
                dur: "750ms",
                values: ".55;.45;.35;.25;.15;.1;0;1;.85;.7;.65;.55",
                repeatCount: "indefinite"
            })
        ]),
        (0, $aD8ZA.h)("line", {
            y1: "17",
            y2: "29",
            transform: "translate(32,32) rotate(60)"
        }, [
            (0, $aD8ZA.h)("animate", {
                attributeName: "stroke-opacity",
                dur: "750ms",
                values: ".65;.55;.45;.35;.25;.15;.1;0;1;.85;.7;.65",
                repeatCount: "indefinite"
            })
        ]),
        (0, $aD8ZA.h)("line", {
            y1: "17",
            y2: "29",
            transform: "translate(32,32) rotate(90)"
        }, [
            (0, $aD8ZA.h)("animate", {
                attributeName: "stroke-opacity",
                dur: "750ms",
                values: ".7;.65;.55;.45;.35;.25;.15;.1;0;1;.85;.7",
                repeatCount: "indefinite"
            })
        ]),
        (0, $aD8ZA.h)("line", {
            y1: "17",
            y2: "29",
            transform: "translate(32,32) rotate(120)"
        }, [
            (0, $aD8ZA.h)("animate", {
                attributeName: "stroke-opacity",
                dur: "750ms",
                values: ".85;.7;.65;.55;.45;.35;.25;.15;.1;0;1;.85",
                repeatCount: "indefinite"
            })
        ]),
        (0, $aD8ZA.h)("line", {
            y1: "17",
            y2: "29",
            transform: "translate(32,32) rotate(150)"
        }, [
            (0, $aD8ZA.h)("animate", {
                attributeName: "stroke-opacity",
                dur: "750ms",
                values: "1;.85;.7;.65;.55;.45;.35;.25;.15;.1;0;1",
                repeatCount: "indefinite"
            })
        ])
    ])
], sh = R({
    name: "QSpinnerIos",
    props: Oe,
    setup: function(e) {
        var _Ve = Ve(e), t = _Ve.cSize, o = _Ve.classes;
        return function() {
            return (0, $aD8ZA.h)("svg", {
                class: o.value,
                width: t.value,
                height: t.value,
                stroke: "currentColor",
                fill: "currentColor",
                viewBox: "0 0 64 64"
            }, Cw);
        };
    }
});
var ww = [
    (0, $aD8ZA.h)("circle", {
        cx: "50",
        cy: "50",
        r: "44",
        fill: "none",
        "stroke-width": "4",
        "stroke-opacity": ".5",
        stroke: "currentColor"
    }),
    (0, $aD8ZA.h)("circle", {
        cx: "8",
        cy: "54",
        r: "6",
        fill: "currentColor",
        "stroke-width": "3",
        stroke: "currentColor"
    }, [
        (0, $aD8ZA.h)("animateTransform", {
            attributeName: "transform",
            type: "rotate",
            from: "0 50 48",
            to: "360 50 52",
            dur: "2s",
            repeatCount: "indefinite"
        })
    ])
], ch = R({
    name: "QSpinnerOrbit",
    props: Oe,
    setup: function(e) {
        var _Ve = Ve(e), t = _Ve.cSize, o = _Ve.classes;
        return function() {
            return (0, $aD8ZA.h)("svg", {
                class: o.value,
                width: t.value,
                height: t.value,
                viewBox: "0 0 100 100",
                preserveAspectRatio: "xMidYMid",
                xmlns: "http://www.w3.org/2000/svg"
            }, ww);
        };
    }
});
var kw = [
    (0, $aD8ZA.h)("g", {
        transform: "translate(1 1)",
        "stroke-width": "2",
        fill: "none",
        "fill-rule": "evenodd"
    }, [
        (0, $aD8ZA.h)("circle", {
            "stroke-opacity": ".5",
            cx: "18",
            cy: "18",
            r: "18"
        }),
        (0, $aD8ZA.h)("path", {
            d: "M36 18c0-9.94-8.06-18-18-18"
        }, [
            (0, $aD8ZA.h)("animateTransform", {
                attributeName: "transform",
                type: "rotate",
                from: "0 18 18",
                to: "360 18 18",
                dur: "1s",
                repeatCount: "indefinite"
            })
        ])
    ])
], dh = R({
    name: "QSpinnerOval",
    props: Oe,
    setup: function(e) {
        var _Ve = Ve(e), t = _Ve.cSize, o = _Ve.classes;
        return function() {
            return (0, $aD8ZA.h)("svg", {
                class: o.value,
                stroke: "currentColor",
                width: t.value,
                height: t.value,
                viewBox: "0 0 38 38",
                xmlns: "http://www.w3.org/2000/svg"
            }, kw);
        };
    }
});
var qw = [
    (0, $aD8ZA.h)("path", {
        d: "M0 50A50 50 0 0 1 50 0L50 50L0 50",
        fill: "currentColor",
        opacity: "0.5"
    }, [
        (0, $aD8ZA.h)("animateTransform", {
            attributeName: "transform",
            type: "rotate",
            from: "0 50 50",
            to: "360 50 50",
            dur: "0.8s",
            repeatCount: "indefinite"
        })
    ]),
    (0, $aD8ZA.h)("path", {
        d: "M50 0A50 50 0 0 1 100 50L50 50L50 0",
        fill: "currentColor",
        opacity: "0.5"
    }, [
        (0, $aD8ZA.h)("animateTransform", {
            attributeName: "transform",
            type: "rotate",
            from: "0 50 50",
            to: "360 50 50",
            dur: "1.6s",
            repeatCount: "indefinite"
        })
    ]),
    (0, $aD8ZA.h)("path", {
        d: "M100 50A50 50 0 0 1 50 100L50 50L100 50",
        fill: "currentColor",
        opacity: "0.5"
    }, [
        (0, $aD8ZA.h)("animateTransform", {
            attributeName: "transform",
            type: "rotate",
            from: "0 50 50",
            to: "360 50 50",
            dur: "2.4s",
            repeatCount: "indefinite"
        })
    ]),
    (0, $aD8ZA.h)("path", {
        d: "M50 100A50 50 0 0 1 0 50L50 50L50 100",
        fill: "currentColor",
        opacity: "0.5"
    }, [
        (0, $aD8ZA.h)("animateTransform", {
            attributeName: "transform",
            type: "rotate",
            from: "0 50 50",
            to: "360 50 50",
            dur: "3.2s",
            repeatCount: "indefinite"
        })
    ])
], fh = R({
    name: "QSpinnerPie",
    props: Oe,
    setup: function(e) {
        var _Ve = Ve(e), t = _Ve.cSize, o = _Ve.classes;
        return function() {
            return (0, $aD8ZA.h)("svg", {
                class: o.value,
                width: t.value,
                height: t.value,
                viewBox: "0 0 100 100",
                preserveAspectRatio: "xMidYMid",
                xmlns: "http://www.w3.org/2000/svg"
            }, qw);
        };
    }
});
var Tw = [
    (0, $aD8ZA.h)("g", {
        fill: "none",
        "fill-rule": "evenodd",
        "stroke-width": "2"
    }, [
        (0, $aD8ZA.h)("circle", {
            cx: "22",
            cy: "22",
            r: "1"
        }, [
            (0, $aD8ZA.h)("animate", {
                attributeName: "r",
                begin: "0s",
                dur: "1.8s",
                values: "1; 20",
                calcMode: "spline",
                keyTimes: "0; 1",
                keySplines: "0.165, 0.84, 0.44, 1",
                repeatCount: "indefinite"
            }),
            (0, $aD8ZA.h)("animate", {
                attributeName: "stroke-opacity",
                begin: "0s",
                dur: "1.8s",
                values: "1; 0",
                calcMode: "spline",
                keyTimes: "0; 1",
                keySplines: "0.3, 0.61, 0.355, 1",
                repeatCount: "indefinite"
            })
        ]),
        (0, $aD8ZA.h)("circle", {
            cx: "22",
            cy: "22",
            r: "1"
        }, [
            (0, $aD8ZA.h)("animate", {
                attributeName: "r",
                begin: "-0.9s",
                dur: "1.8s",
                values: "1; 20",
                calcMode: "spline",
                keyTimes: "0; 1",
                keySplines: "0.165, 0.84, 0.44, 1",
                repeatCount: "indefinite"
            }),
            (0, $aD8ZA.h)("animate", {
                attributeName: "stroke-opacity",
                begin: "-0.9s",
                dur: "1.8s",
                values: "1; 0",
                calcMode: "spline",
                keyTimes: "0; 1",
                keySplines: "0.3, 0.61, 0.355, 1",
                repeatCount: "indefinite"
            })
        ])
    ])
], mh = R({
    name: "QSpinnerPuff",
    props: Oe,
    setup: function(e) {
        var _Ve = Ve(e), t = _Ve.cSize, o = _Ve.classes;
        return function() {
            return (0, $aD8ZA.h)("svg", {
                class: o.value,
                stroke: "currentColor",
                width: t.value,
                height: t.value,
                viewBox: "0 0 44 44",
                xmlns: "http://www.w3.org/2000/svg"
            }, Tw);
        };
    }
});
var Mw = [
    (0, $aD8ZA.h)("g", {
        transform: "scale(0.55)"
    }, [
        (0, $aD8ZA.h)("circle", {
            cx: "30",
            cy: "150",
            r: "30",
            fill: "currentColor"
        }, [
            (0, $aD8ZA.h)("animate", {
                attributeName: "opacity",
                from: "0",
                to: "1",
                dur: "1s",
                begin: "0",
                repeatCount: "indefinite",
                keyTimes: "0;0.5;1",
                values: "0;1;1"
            })
        ]),
        (0, $aD8ZA.h)("path", {
            d: "M90,150h30c0-49.7-40.3-90-90-90v30C63.1,90,90,116.9,90,150z",
            fill: "currentColor"
        }, [
            (0, $aD8ZA.h)("animate", {
                attributeName: "opacity",
                from: "0",
                to: "1",
                dur: "1s",
                begin: "0.1",
                repeatCount: "indefinite",
                keyTimes: "0;0.5;1",
                values: "0;1;1"
            })
        ]),
        (0, $aD8ZA.h)("path", {
            d: "M150,150h30C180,67.2,112.8,0,30,0v30C96.3,30,150,83.7,150,150z",
            fill: "currentColor"
        }, [
            (0, $aD8ZA.h)("animate", {
                attributeName: "opacity",
                from: "0",
                to: "1",
                dur: "1s",
                begin: "0.2",
                repeatCount: "indefinite",
                keyTimes: "0;0.5;1",
                values: "0;1;1"
            })
        ])
    ])
], vh = R({
    name: "QSpinnerRadio",
    props: Oe,
    setup: function(e) {
        var _Ve = Ve(e), t = _Ve.cSize, o = _Ve.classes;
        return function() {
            return (0, $aD8ZA.h)("svg", {
                class: o.value,
                width: t.value,
                height: t.value,
                viewBox: "0 0 100 100",
                preserveAspectRatio: "xMidYMid",
                xmlns: "http://www.w3.org/2000/svg"
            }, Mw);
        };
    }
});
var Rw = [
    (0, $aD8ZA.h)("g", {
        fill: "none",
        "fill-rule": "evenodd",
        transform: "translate(1 1)",
        "stroke-width": "2"
    }, [
        (0, $aD8ZA.h)("circle", {
            cx: "22",
            cy: "22",
            r: "6"
        }, [
            (0, $aD8ZA.h)("animate", {
                attributeName: "r",
                begin: "1.5s",
                dur: "3s",
                values: "6;22",
                calcMode: "linear",
                repeatCount: "indefinite"
            }),
            (0, $aD8ZA.h)("animate", {
                attributeName: "stroke-opacity",
                begin: "1.5s",
                dur: "3s",
                values: "1;0",
                calcMode: "linear",
                repeatCount: "indefinite"
            }),
            (0, $aD8ZA.h)("animate", {
                attributeName: "stroke-width",
                begin: "1.5s",
                dur: "3s",
                values: "2;0",
                calcMode: "linear",
                repeatCount: "indefinite"
            })
        ]),
        (0, $aD8ZA.h)("circle", {
            cx: "22",
            cy: "22",
            r: "6"
        }, [
            (0, $aD8ZA.h)("animate", {
                attributeName: "r",
                begin: "3s",
                dur: "3s",
                values: "6;22",
                calcMode: "linear",
                repeatCount: "indefinite"
            }),
            (0, $aD8ZA.h)("animate", {
                attributeName: "stroke-opacity",
                begin: "3s",
                dur: "3s",
                values: "1;0",
                calcMode: "linear",
                repeatCount: "indefinite"
            }),
            (0, $aD8ZA.h)("animate", {
                attributeName: "stroke-width",
                begin: "3s",
                dur: "3s",
                values: "2;0",
                calcMode: "linear",
                repeatCount: "indefinite"
            })
        ]),
        (0, $aD8ZA.h)("circle", {
            cx: "22",
            cy: "22",
            r: "8"
        }, [
            (0, $aD8ZA.h)("animate", {
                attributeName: "r",
                begin: "0s",
                dur: "1.5s",
                values: "6;1;2;3;4;5;6",
                calcMode: "linear",
                repeatCount: "indefinite"
            })
        ])
    ])
], gh = R({
    name: "QSpinnerRings",
    props: Oe,
    setup: function(e) {
        var _Ve = Ve(e), t = _Ve.cSize, o = _Ve.classes;
        return function() {
            return (0, $aD8ZA.h)("svg", {
                class: o.value,
                stroke: "currentColor",
                width: t.value,
                height: t.value,
                viewBox: "0 0 45 45",
                xmlns: "http://www.w3.org/2000/svg"
            }, Rw);
        };
    }
});
var Pw = [
    (0, $aD8ZA.h)("defs", [
        (0, $aD8ZA.h)("linearGradient", {
            x1: "8.042%",
            y1: "0%",
            x2: "65.682%",
            y2: "23.865%",
            id: "a"
        }, [
            (0, $aD8ZA.h)("stop", {
                "stop-color": "currentColor",
                "stop-opacity": "0",
                offset: "0%"
            }),
            (0, $aD8ZA.h)("stop", {
                "stop-color": "currentColor",
                "stop-opacity": ".631",
                offset: "63.146%"
            }),
            (0, $aD8ZA.h)("stop", {
                "stop-color": "currentColor",
                offset: "100%"
            })
        ])
    ]),
    (0, $aD8ZA.h)("g", {
        transform: "translate(1 1)",
        fill: "none",
        "fill-rule": "evenodd"
    }, [
        (0, $aD8ZA.h)("path", {
            d: "M36 18c0-9.94-8.06-18-18-18",
            stroke: "url(#a)",
            "stroke-width": "2"
        }, [
            (0, $aD8ZA.h)("animateTransform", {
                attributeName: "transform",
                type: "rotate",
                from: "0 18 18",
                to: "360 18 18",
                dur: "0.9s",
                repeatCount: "indefinite"
            })
        ]),
        (0, $aD8ZA.h)("circle", {
            fill: "currentColor",
            cx: "36",
            cy: "18",
            r: "1"
        }, [
            (0, $aD8ZA.h)("animateTransform", {
                attributeName: "transform",
                type: "rotate",
                from: "0 18 18",
                to: "360 18 18",
                dur: "0.9s",
                repeatCount: "indefinite"
            })
        ])
    ])
], hh = R({
    name: "QSpinnerTail",
    props: Oe,
    setup: function(e) {
        var _Ve = Ve(e), t = _Ve.cSize, o = _Ve.classes;
        return function() {
            return (0, $aD8ZA.h)("svg", {
                class: o.value,
                width: t.value,
                height: t.value,
                viewBox: "0 0 38 38",
                xmlns: "http://www.w3.org/2000/svg"
            }, Pw);
        };
    }
});
var bh = R({
    name: "QSplitter",
    props: (0, $8typN._)((0, $8pZMQ._)({}, he), {
        modelValue: {
            type: Number,
            required: !0
        },
        reverse: Boolean,
        unit: {
            type: String,
            default: "%",
            validator: function(e) {
                return [
                    "%",
                    "px"
                ].includes(e);
            }
        },
        limits: {
            type: Array,
            validator: function(e) {
                return e.length !== 2 || typeof e[0] != "number" || typeof e[1] != "number" ? !1 : e[0] >= 0 && e[0] <= e[1];
            }
        },
        emitImmediately: Boolean,
        horizontal: Boolean,
        disable: Boolean,
        beforeClass: [
            Array,
            String,
            Object
        ],
        afterClass: [
            Array,
            String,
            Object
        ],
        separatorClass: [
            Array,
            String,
            Object
        ],
        separatorStyle: [
            Array,
            String,
            Object
        ]
    }),
    emits: [
        "update:modelValue"
    ],
    setup: function(e, param) {
        var t = param.slots, o = param.emit;
        var _$w = (0, $aD8ZA.getCurrentInstance)(), _$w_proxy = _$w.proxy, r = _$w_proxy.$q, n = pe(e, r), i = (0, $aAzpa.ref)(null), a = {
            before: (0, $aAzpa.ref)(null),
            after: (0, $aAzpa.ref)(null)
        }, l = (0, $aAzpa.computed)(function() {
            return "q-splitter no-wrap ".concat(e.horizontal === !0 ? "q-splitter--horizontal column" : "q-splitter--vertical row", " q-splitter--").concat(e.disable === !0 ? "disabled" : "workable") + (n.value === !0 ? " q-splitter--dark" : "");
        }), s = (0, $aAzpa.computed)(function() {
            return e.horizontal === !0 ? "height" : "width";
        }), c = (0, $aAzpa.computed)(function() {
            return e.reverse !== !0 ? "before" : "after";
        }), u = (0, $aAzpa.computed)(function() {
            return e.limits !== void 0 ? e.limits : e.unit === "%" ? [
                10,
                90
            ] : [
                50,
                1 / 0
            ];
        });
        function v(S) {
            return (e.unit === "%" ? S : Math.round(S)) + e.unit;
        }
        var f = (0, $aAzpa.computed)(function() {
            return {
                [c.value]: {
                    [s.value]: v(e.modelValue)
                }
            };
        }), d, m, y, p, C;
        function b(S) {
            if (S.isFirst === !0) {
                var $ = i.value.getBoundingClientRect()[s.value];
                d = e.horizontal === !0 ? "up" : "left", m = e.unit === "%" ? 100 : $, y = Math.min(m, u.value[1], Math.max(u.value[0], e.modelValue)), p = (e.reverse !== !0 ? 1 : -1) * (e.horizontal === !0 ? 1 : r.lang.rtl === !0 ? -1 : 1) * (e.unit === "%" ? $ === 0 ? 0 : 100 / $ : 1), i.value.classList.add("q-splitter--active");
                return;
            }
            if (S.isFinal === !0) {
                C !== e.modelValue && o("update:modelValue", C), i.value.classList.remove("q-splitter--active");
                return;
            }
            var P = y + p * (S.direction === d ? -1 : 1) * S.distance[e.horizontal === !0 ? "y" : "x"];
            C = Math.min(m, u.value[1], Math.max(u.value[0], P)), a[c.value].value.style[s.value] = v(C), e.emitImmediately === !0 && e.modelValue !== C && o("update:modelValue", C);
        }
        var h = (0, $aAzpa.computed)(function() {
            return [
                [
                    qt,
                    b,
                    void 0,
                    {
                        [e.horizontal === !0 ? "vertical" : "horizontal"]: !0,
                        prevent: !0,
                        stop: !0,
                        mouse: !0,
                        mouseAllDir: !0
                    }
                ]
            ];
        });
        function g(S, P) {
            S < P[0] ? o("update:modelValue", P[0]) : S > P[1] && o("update:modelValue", P[1]);
        }
        return (0, $aD8ZA.watch)(function() {
            return e.modelValue;
        }, function(S) {
            g(S, u.value);
        }), (0, $aD8ZA.watch)(function() {
            return e.limits;
        }, function() {
            (0, $aD8ZA.nextTick)(function() {
                g(e.modelValue, u.value);
            });
        }), function() {
            var S = [
                (0, $aD8ZA.h)("div", {
                    ref: a.before,
                    class: [
                        "q-splitter__panel q-splitter__before" + (e.reverse === !0 ? " col" : ""),
                        e.beforeClass
                    ],
                    style: f.value.before
                }, J(t.before)),
                (0, $aD8ZA.h)("div", {
                    class: [
                        "q-splitter__separator",
                        e.separatorClass
                    ],
                    style: e.separatorStyle,
                    "aria-disabled": e.disable === !0 ? "true" : void 0
                }, [
                    kt("div", {
                        class: "q-splitter__separator-area absolute-full"
                    }, J(t.separator), "sep", e.disable !== !0, function() {
                        return h.value;
                    })
                ]),
                (0, $aD8ZA.h)("div", {
                    ref: a.after,
                    class: [
                        "q-splitter__panel q-splitter__after" + (e.reverse === !0 ? "" : " col"),
                        e.afterClass
                    ],
                    style: f.value.after
                }, J(t.after))
            ];
            return (0, $aD8ZA.h)("div", {
                class: l.value,
                ref: i
            }, Ke(t.default, S));
        };
    }
});
var hs = R({
    name: "StepHeader",
    props: {
        stepper: {},
        step: {},
        goToPanel: Function
    },
    setup: function(e, param) {
        var t = param.attrs;
        var _Lw = (0, $aD8ZA.getCurrentInstance)(), _Lw_proxy = _Lw.proxy, o = _Lw_proxy.$q, r = (0, $aAzpa.ref)(null), n = (0, $aAzpa.computed)(function() {
            return e.stepper.modelValue === e.step.name;
        }), i = (0, $aAzpa.computed)(function() {
            var p = e.step.disable;
            return p === !0 || p === "";
        }), a = (0, $aAzpa.computed)(function() {
            var p = e.step.error;
            return p === !0 || p === "";
        }), l = (0, $aAzpa.computed)(function() {
            var p = e.step.done;
            return i.value === !1 && (p === !0 || p === "");
        }), s = (0, $aAzpa.computed)(function() {
            var p = e.step.headerNav, C = p === !0 || p === "" || p === void 0;
            return i.value === !1 && e.stepper.headerNav && C;
        }), c = (0, $aAzpa.computed)(function() {
            return e.step.prefix && (n.value === !1 || e.stepper.activeIcon === "none") && (a.value === !1 || e.stepper.errorIcon === "none") && (l.value === !1 || e.stepper.doneIcon === "none");
        }), u = (0, $aAzpa.computed)(function() {
            var p = e.step.icon || e.stepper.inactiveIcon;
            if (n.value === !0) {
                var C = e.step.activeIcon || e.stepper.activeIcon;
                return C === "none" ? p : C || o.iconSet.stepper.active;
            }
            if (a.value === !0) {
                var C1 = e.step.errorIcon || e.stepper.errorIcon;
                return C1 === "none" ? p : C1 || o.iconSet.stepper.error;
            }
            if (i.value === !1 && l.value === !0) {
                var C2 = e.step.doneIcon || e.stepper.doneIcon;
                return C2 === "none" ? p : C2 || o.iconSet.stepper.done;
            }
            return p;
        }), v = (0, $aAzpa.computed)(function() {
            var p = a.value === !0 ? e.step.errorColor || e.stepper.errorColor : void 0;
            if (n.value === !0) {
                var C = e.step.activeColor || e.stepper.activeColor || e.step.color;
                return C !== void 0 ? C : p;
            }
            return p !== void 0 ? p : i.value === !1 && l.value === !0 ? e.step.doneColor || e.stepper.doneColor || e.step.color || e.stepper.inactiveColor : e.step.color || e.stepper.inactiveColor;
        }), f = (0, $aAzpa.computed)(function() {
            return "q-stepper__tab col-grow flex items-center no-wrap relative-position" + (v.value !== void 0 ? " text-".concat(v.value) : "") + (a.value === !0 ? " q-stepper__tab--error q-stepper__tab--error-with-" + (c.value === !0 ? "prefix" : "icon") : "") + (n.value === !0 ? " q-stepper__tab--active" : "") + (l.value === !0 ? " q-stepper__tab--done" : "") + (s.value === !0 ? " q-stepper__tab--navigation q-focusable q-hoverable" : "") + (i.value === !0 ? " q-stepper__tab--disabled" : "");
        }), d = (0, $aAzpa.computed)(function() {
            return e.stepper.headerNav !== !0 ? !1 : s.value;
        });
        function m() {
            r.value !== null && r.value.focus(), n.value === !1 && e.goToPanel(e.step.name);
        }
        function y(p) {
            p.keyCode === 13 && n.value === !1 && e.goToPanel(e.step.name);
        }
        return function() {
            var p = {
                class: f.value
            };
            s.value === !0 && (p.onClick = m, p.onKeyup = y, Object.assign(p, i.value === !0 ? {
                tabindex: -1,
                "aria-disabled": "true"
            } : {
                tabindex: t.tabindex || 0
            }));
            var C = [
                (0, $aD8ZA.h)("div", {
                    class: "q-focus-helper",
                    tabindex: -1,
                    ref: r
                }),
                (0, $aD8ZA.h)("div", {
                    class: "q-stepper__dot row flex-center q-stepper__line relative-position"
                }, [
                    (0, $aD8ZA.h)("span", {
                        class: "row flex-center"
                    }, [
                        c.value === !0 ? e.step.prefix : (0, $aD8ZA.h)(we, {
                            name: u.value
                        })
                    ])
                ])
            ];
            if (e.step.title !== void 0 && e.step.title !== null) {
                var b = [
                    (0, $aD8ZA.h)("div", {
                        class: "q-stepper__title"
                    }, e.step.title)
                ];
                e.step.caption !== void 0 && e.step.caption !== null && b.push((0, $aD8ZA.h)("div", {
                    class: "q-stepper__caption"
                }, e.step.caption)), C.push((0, $aD8ZA.h)("div", {
                    class: "q-stepper__label q-stepper__line relative-position"
                }, b));
            }
            return (0, $aD8ZA.withDirectives)((0, $aD8ZA.h)("div", p, C), [
                [
                    rn,
                    d.value
                ]
            ]);
        };
    }
});
function Sh(e) {
    return (0, $aD8ZA.h)("div", {
        class: "q-stepper__step-content"
    }, [
        (0, $aD8ZA.h)("div", {
            class: "q-stepper__step-inner"
        }, J(e.default))
    ]);
}
var yh = {
    setup: function(e, param) {
        var t = param.slots;
        return function() {
            return Sh(t);
        };
    }
}, xh = R({
    name: "QStep",
    props: (0, $8typN._)((0, $8pZMQ._)({}, Li), {
        icon: String,
        color: String,
        title: {
            type: String,
            required: !0
        },
        caption: String,
        prefix: [
            String,
            Number
        ],
        doneIcon: String,
        doneColor: String,
        activeIcon: String,
        activeColor: String,
        errorIcon: String,
        errorColor: String,
        headerNav: {
            type: Boolean,
            default: !0
        },
        done: Boolean,
        error: Boolean,
        onScroll: [
            Function,
            Array
        ]
    }),
    setup: function(e, param) {
        var t = param.slots, o = param.emit;
        var _Vw = (0, $aD8ZA.getCurrentInstance)(), _Vw_proxy = _Vw.proxy, r = _Vw_proxy.$q, n = (0, $aD8ZA.inject)(wl, Ye);
        if (n === Ye) return console.error("QStep needs to be a child of QStepper"), Ye;
        var _No = No(), i = _No.getCache, a = (0, $aAzpa.ref)(null), l = (0, $aAzpa.computed)(function() {
            return n.value.modelValue === e.name;
        }), s = (0, $aAzpa.computed)(function() {
            return r.platform.is.ios !== !0 && r.platform.is.chrome === !0 || l.value !== !0 || n.value.vertical !== !0 ? {} : {
                onScroll: function(v) {
                    var f = v.target;
                    f.scrollTop > 0 && (f.scrollTop = 0), e.onScroll !== void 0 && o("scroll", v);
                }
            };
        }), c = (0, $aAzpa.computed)(function() {
            return typeof e.name == "string" || typeof e.name == "number" ? e.name : String(e.name);
        });
        function u() {
            var v = n.value.vertical;
            return v === !0 && n.value.keepAlive === !0 ? (0, $aD8ZA.h)((0, $aD8ZA.KeepAlive), n.value.keepAliveProps.value, l.value === !0 ? [
                (0, $aD8ZA.h)(n.value.needsUniqueKeepAliveWrapper.value === !0 ? i(c.value, function() {
                    return (0, $8typN._)((0, $8pZMQ._)({}, yh), {
                        name: c.value
                    });
                }) : yh, {
                    key: c.value
                }, t.default)
            ] : void 0) : v !== !0 || l.value === !0 ? Sh(t) : void 0;
        }
        return function() {
            return (0, $aD8ZA.h)("div", (0, $8pZMQ._)({
                ref: a,
                class: "q-stepper__step",
                role: "tabpanel"
            }, s.value), n.value.vertical === !0 ? [
                (0, $aD8ZA.h)(hs, {
                    stepper: n.value,
                    step: e,
                    goToPanel: n.value.goToPanel
                }),
                n.value.animated === !0 ? (0, $aD8ZA.h)(sr, u) : u()
            ] : [
                u()
            ]);
        };
    }
});
var Hw = /(-\w)/g;
function Nw(e) {
    var t = {};
    for(var o in e){
        var r = o.replace(Hw, function(n) {
            return n[1].toUpperCase();
        });
        t[r] = e[o];
    }
    return t;
}
var _h = R({
    name: "QStepper",
    props: (0, $8typN._)((0, $8pZMQ._)({}, he, Fi), {
        flat: Boolean,
        bordered: Boolean,
        alternativeLabels: Boolean,
        headerNav: Boolean,
        contracted: Boolean,
        headerClass: String,
        inactiveColor: String,
        inactiveIcon: String,
        doneIcon: String,
        doneColor: String,
        activeIcon: String,
        activeColor: String,
        errorIcon: String,
        errorColor: String
    }),
    emits: Di,
    setup: function(e, param) {
        var t = param.slots;
        var o = (0, $aD8ZA.getCurrentInstance)(), r = pe(e, o.proxy.$q), _Vi = Vi(), n = _Vi.updatePanelsList, i = _Vi.isValidPanelName, a = _Vi.updatePanelIndex, l = _Vi.getPanelContent, s = _Vi.getPanels, c = _Vi.panelDirectives, u = _Vi.goToPanel, v = _Vi.keepAliveProps, f = _Vi.needsUniqueKeepAliveWrapper;
        (0, $aD8ZA.provide)(wl, (0, $aAzpa.computed)(function() {
            return (0, $8pZMQ._)({
                goToPanel: u,
                keepAliveProps: v,
                needsUniqueKeepAliveWrapper: f
            }, e);
        }));
        var d = (0, $aAzpa.computed)(function() {
            return "q-stepper q-stepper--".concat(e.vertical === !0 ? "vertical" : "horizontal") + (e.flat === !0 ? " q-stepper--flat" : "") + (e.bordered === !0 ? " q-stepper--bordered" : "") + (r.value === !0 ? " q-stepper--dark q-dark" : "");
        }), m = (0, $aAzpa.computed)(function() {
            return "q-stepper__header row items-stretch justify-between q-stepper__header--".concat(e.alternativeLabels === !0 ? "alternative" : "standard", "-labels") + (e.flat === !1 || e.bordered === !0 ? " q-stepper__header--border" : "") + (e.contracted === !0 ? " q-stepper__header--contracted" : "") + (e.headerClass !== void 0 ? " ".concat(e.headerClass) : "");
        });
        function y() {
            var p = J(t.message, []);
            if (e.vertical === !0) {
                i(e.modelValue) && a();
                var C = (0, $aD8ZA.h)("div", {
                    class: "q-stepper__content"
                }, J(t.default));
                return p === void 0 ? [
                    C
                ] : p.concat(C);
            }
            return [
                (0, $aD8ZA.h)("div", {
                    class: m.value
                }, s().map(function(C) {
                    var b = Nw(C.props);
                    return (0, $aD8ZA.h)(hs, {
                        key: b.name,
                        stepper: e,
                        step: b,
                        goToPanel: u
                    });
                })),
                p,
                kt("div", {
                    class: "q-stepper__content q-panel-parent"
                }, l(), "cont", e.swipeable, function() {
                    return c.value;
                })
            ];
        }
        return function() {
            return n(t), (0, $aD8ZA.h)("div", {
                class: d.value
            }, Ke(t.navigation, y()));
        };
    }
});
var Ch = R({
    name: "QStepperNavigation",
    setup: function(e, param) {
        var t = param.slots;
        return function() {
            return (0, $aD8ZA.h)("div", {
                class: "q-stepper__nav"
            }, J(t.default));
        };
    }
});
var bs = R({
    name: "QTh",
    props: {
        props: Object,
        autoWidth: Boolean
    },
    emits: [
        "click"
    ],
    setup: function(e, param) {
        var t = param.slots, o = param.emit;
        var r = (0, $aD8ZA.getCurrentInstance)(), _r_proxy = r.proxy, n = _r_proxy.$q, i = function(a) {
            o("click", a);
        };
        return function() {
            if (e.props === void 0) return (0, $aD8ZA.h)("th", {
                class: e.autoWidth === !0 ? "q-table--col-auto-width" : "",
                onClick: i
            }, J(t.default));
            var a, l, s = r.vnode.key;
            if (s) {
                if (a = e.props.colsMap[s], a === void 0) return;
            } else a = e.props.col;
            if (a.sortable === !0) {
                var u = a.align === "right" ? "unshift" : "push";
                l = tn(t.default, []), l[u]((0, $aD8ZA.h)(we, {
                    class: a.__iconClass,
                    name: n.iconSet.table.arrowUp
                }));
            } else l = J(t.default);
            var c = {
                class: a.__thClass + (e.autoWidth === !0 ? " q-table--col-auto-width" : ""),
                style: a.headerStyle,
                onClick: function(u) {
                    a.sortable === !0 && e.props.sort(a), i(u);
                }
            };
            return (0, $aD8ZA.h)("th", c, l);
        };
    }
});
function ys(e, t) {
    return (0, $aD8ZA.h)("div", e, [
        (0, $aD8ZA.h)("table", {
            class: "q-table"
        }, t)
    ]);
}
var Jw = {
    list: Uu,
    table: Wu
}, ek = [
    "list",
    "table",
    "__qtable"
], xs = R({
    name: "QVirtualScroll",
    props: (0, $8typN._)((0, $8pZMQ._)({}, ss), {
        type: {
            type: String,
            default: "list",
            validator: function(e) {
                return ek.includes(e);
            }
        },
        items: {
            type: Array,
            default: function() {
                return [];
            }
        },
        itemsFn: Function,
        itemsSize: Number,
        scrollTarget: {
            default: void 0
        }
    }),
    setup: function(e, param) {
        var t = param.slots, o = param.attrs;
        var r, n = (0, $aAzpa.ref)(null), i = (0, $aAzpa.computed)(function() {
            return e.itemsSize >= 0 && e.itemsFn !== void 0 ? parseInt(e.itemsSize, 10) : Array.isArray(e.items) ? e.items.length : 0;
        }), _cs = cs({
            virtualScrollLength: i,
            getVirtualScrollTarget: m,
            getVirtualScrollEl: d
        }), a = _cs.virtualScrollSliceRange, l = _cs.localResetVirtualScroll, s = _cs.padVirtualScroll, c = _cs.onVirtualScrollEvt, u = (0, $aAzpa.computed)(function() {
            if (i.value === 0) return [];
            var b = function(h, g) {
                return {
                    index: a.value.from + g,
                    item: h
                };
            };
            return e.itemsFn === void 0 ? e.items.slice(a.value.from, a.value.to).map(b) : e.itemsFn(a.value.from, a.value.to - a.value.from).map(b);
        }), v = (0, $aAzpa.computed)(function() {
            return "q-virtual-scroll q-virtual-scroll" + (e.virtualScrollHorizontal === !0 ? "--horizontal" : "--vertical") + (e.scrollTarget !== void 0 ? "" : " scroll");
        }), f = (0, $aAzpa.computed)(function() {
            return e.scrollTarget !== void 0 ? {} : {
                tabindex: 0
            };
        });
        (0, $aD8ZA.watch)(i, function() {
            l();
        }), (0, $aD8ZA.watch)(function() {
            return e.scrollTarget;
        }, function() {
            p(), y();
        });
        function d() {
            return n.value.$el || n.value;
        }
        function m() {
            return r;
        }
        function y() {
            r = At(d(), e.scrollTarget), r.addEventListener("scroll", c, Xe.passive);
        }
        function p() {
            r !== void 0 && (r.removeEventListener("scroll", c, Xe.passive), r = void 0);
        }
        function C() {
            var b = s(e.type === "list" ? "div" : "tbody", u.value.map(t.default));
            return t.before !== void 0 && (b = t.before().concat(b)), Ke(t.after, b);
        }
        return (0, $aD8ZA.onBeforeMount)(function() {
            l();
        }), (0, $aD8ZA.onMounted)(function() {
            y();
        }), (0, $aD8ZA.onActivated)(function() {
            y();
        }), (0, $aD8ZA.onDeactivated)(function() {
            p();
        }), (0, $aD8ZA.onBeforeUnmount)(function() {
            p();
        }), function() {
            if (t.default === void 0) {
                console.error("QVirtualScroll: default scoped slot is required for rendering");
                return;
            }
            return e.type === "__qtable" ? ys({
                ref: n,
                class: "q-table__middle " + v.value
            }, C()) : (0, $aD8ZA.h)(Jw[e.type], (0, $8pZMQ._)((0, $8typN._)((0, $8pZMQ._)({}, o), {
                ref: n,
                class: [
                    o.class,
                    v.value
                ]
            }), f.value), C);
        };
    }
});
function qh(e, t) {
    return new Date(e) - new Date(t);
}
var Mh = {
    sortMethod: Function,
    binaryStateSort: Boolean,
    columnSortOrder: {
        type: String,
        validator: function(e) {
            return e === "ad" || e === "da";
        },
        default: "ad"
    }
};
function Rh(e, t, o, r) {
    var n = (0, $aAzpa.computed)(function() {
        var _t_value = t.value, l = _t_value.sortBy;
        return l && o.value.find(function(s) {
            return s.name === l;
        }) || null;
    }), i = (0, $aAzpa.computed)(function() {
        return e.sortMethod !== void 0 ? e.sortMethod : function(l, s, c) {
            var u = o.value.find(function(d) {
                return d.name === s;
            });
            if (u === void 0 || u.field === void 0) return l;
            var v = c === !0 ? -1 : 1, f = typeof u.field == "function" ? function(d) {
                return u.field(d);
            } : function(d) {
                return d[u.field];
            };
            return l.sort(function(d, m) {
                var y = f(d), p = f(m);
                var ref;
                return u.rawSort !== void 0 ? u.rawSort(y, p, d, m) * v : y == null ? -1 * v : p == null ? 1 * v : u.sort !== void 0 ? u.sort(y, p, d, m) * v : Mo(y) === !0 && Mo(p) === !0 ? (y - p) * v : Pn(y) === !0 && Pn(p) === !0 ? qh(y, p) * v : typeof y == "boolean" && typeof p == "boolean" ? (y - p) * v : (ref = (0, $4f96i._)([
                    y,
                    p
                ].map(function(C) {
                    return (C + "").toLocaleString().toLowerCase();
                }), 2), y = ref[0], p = ref[1], ref, y < p ? -1 * v : y === p ? 0 : v);
            });
        };
    });
    function a(l) {
        var s = e.columnSortOrder;
        if (at(l) === !0) l.sortOrder && (s = l.sortOrder), l = l.name;
        else {
            var v = o.value.find(function(f) {
                return f.name === l;
            });
            v !== void 0 && v.sortOrder && (s = v.sortOrder);
        }
        var _t_value = t.value, c = _t_value.sortBy, u = _t_value.descending;
        c !== l ? (c = l, u = s === "da") : e.binaryStateSort === !0 ? u = !u : u === !0 ? s === "ad" ? c = null : u = !1 : s === "ad" ? u = !0 : c = null, r({
            sortBy: c,
            descending: u,
            page: 1
        });
    }
    return {
        columnToSort: n,
        computedSortMethod: i,
        sort: a
    };
}
var Ph = {
    filter: [
        String,
        Object
    ],
    filterMethod: Function
};
function Ah(e, t) {
    var o = (0, $aAzpa.computed)(function() {
        return e.filterMethod !== void 0 ? e.filterMethod : function(r, n, i, a) {
            var l = n ? n.toLowerCase() : "";
            return r.filter(function(s) {
                return i.some(function(c) {
                    var u = a(c, s) + "";
                    return (u === "undefined" || u === "null" ? "" : u.toLowerCase()).indexOf(l) !== -1;
                });
            });
        };
    });
    return (0, $aD8ZA.watch)(function() {
        return e.filter;
    }, function() {
        (0, $aD8ZA.nextTick)(function() {
            t({
                page: 1
            }, !0);
        });
    }, {
        deep: !0
    }), {
        computedFilterMethod: o
    };
}
function lk(e, t) {
    for(var o in t)if (t[o] !== e[o]) return !1;
    return !0;
}
function $h(e) {
    return e.page < 1 && (e.page = 1), e.rowsPerPage !== void 0 && e.rowsPerPage < 1 && (e.rowsPerPage = 0), e;
}
var Eh = {
    pagination: Object,
    rowsPerPageOptions: {
        type: Array,
        default: function() {
            return [
                5,
                7,
                10,
                15,
                20,
                25,
                50,
                0
            ];
        }
    },
    "onUpdate:pagination": [
        Function,
        Array
    ]
};
function Bh(e, t) {
    var o = e.props, r = e.emit, n = (0, $aAzpa.ref)(Object.assign({
        sortBy: null,
        descending: !1,
        page: 1,
        rowsPerPage: o.rowsPerPageOptions.length !== 0 ? o.rowsPerPageOptions[0] : 5
    }, o.pagination)), i = (0, $aAzpa.computed)(function() {
        var u = o["onUpdate:pagination"] !== void 0 ? (0, $8pZMQ._)({}, n.value, o.pagination) : n.value;
        return $h(u);
    }), a = (0, $aAzpa.computed)(function() {
        return i.value.rowsNumber !== void 0;
    });
    function l(u) {
        s({
            pagination: u,
            filter: o.filter
        });
    }
    function s() {
        var u = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        (0, $aD8ZA.nextTick)(function() {
            r("request", {
                pagination: u.pagination || i.value,
                filter: u.filter || o.filter,
                getCellValue: t
            });
        });
    }
    function c(u, v) {
        var f = $h((0, $8pZMQ._)({}, i.value, u));
        if (lk(i.value, f) === !0) {
            a.value === !0 && v === !0 && l(f);
            return;
        }
        if (a.value === !0) {
            l(f);
            return;
        }
        o.pagination !== void 0 && o["onUpdate:pagination"] !== void 0 ? r("update:pagination", f) : n.value = f;
    }
    return {
        innerPagination: n,
        computedPagination: i,
        isServerSide: a,
        requestServerInteraction: s,
        setPagination: c
    };
}
function Lh(e, t, o, r, n, i) {
    var a = e.props, l = e.emit, _e_proxy = e.proxy, s = _e_proxy.$q, c = (0, $aAzpa.computed)(function() {
        return r.value === !0 ? o.value.rowsNumber || 0 : i.value;
    }), u = (0, $aAzpa.computed)(function() {
        var _o_value = o.value, g = _o_value.page, S = _o_value.rowsPerPage;
        return (g - 1) * S;
    }), v = (0, $aAzpa.computed)(function() {
        var _o_value = o.value, g = _o_value.page, S = _o_value.rowsPerPage;
        return g * S;
    }), f = (0, $aAzpa.computed)(function() {
        return o.value.page === 1;
    }), d = (0, $aAzpa.computed)(function() {
        return o.value.rowsPerPage === 0 ? 1 : Math.max(1, Math.ceil(c.value / o.value.rowsPerPage));
    }), m = (0, $aAzpa.computed)(function() {
        return v.value === 0 ? !0 : o.value.page >= d.value;
    }), y = (0, $aAzpa.computed)(function() {
        return (a.rowsPerPageOptions.includes(t.value.rowsPerPage) ? a.rowsPerPageOptions : [
            t.value.rowsPerPage
        ].concat(a.rowsPerPageOptions)).map(function(S) {
            return {
                label: S === 0 ? s.lang.table.allRows : "" + S,
                value: S
            };
        });
    });
    (0, $aD8ZA.watch)(d, function(g, S) {
        if (g === S) return;
        var P = o.value.page;
        g && !P ? n({
            page: 1
        }) : g < P && n({
            page: g
        });
    });
    function p() {
        n({
            page: 1
        });
    }
    function C() {
        var _o_value = o.value, g = _o_value.page;
        g > 1 && n({
            page: g - 1
        });
    }
    function b() {
        var _o_value = o.value, g = _o_value.page, S = _o_value.rowsPerPage;
        v.value > 0 && g * S < c.value && n({
            page: g + 1
        });
    }
    function h() {
        n({
            page: d.value
        });
    }
    return a["onUpdate:pagination"] !== void 0 && l("update:pagination", (0, $8pZMQ._)({}, o.value)), {
        firstRowIndex: u,
        lastRowIndex: v,
        isFirstPage: f,
        isLastPage: m,
        pagesNumber: d,
        computedRowsPerPageOptions: y,
        computedRowsNumber: c,
        firstPage: p,
        prevPage: C,
        nextPage: b,
        lastPage: h
    };
}
var Fh = {
    selection: {
        type: String,
        default: "none",
        validator: function(e) {
            return [
                "single",
                "multiple",
                "none"
            ].includes(e);
        }
    },
    selected: {
        type: Array,
        default: function() {
            return [];
        }
    }
}, Dh = [
    "update:selected",
    "selection"
];
function Vh(e, t, o, r) {
    var n = (0, $aAzpa.computed)(function() {
        var m = {};
        return e.selected.map(r.value).forEach(function(y) {
            m[y] = !0;
        }), m;
    }), i = (0, $aAzpa.computed)(function() {
        return e.selection !== "none";
    }), a = (0, $aAzpa.computed)(function() {
        return e.selection === "single";
    }), l = (0, $aAzpa.computed)(function() {
        return e.selection === "multiple";
    }), s = (0, $aAzpa.computed)(function() {
        return o.value.length !== 0 && o.value.every(function(m) {
            return n.value[r.value(m)] === !0;
        });
    }), c = (0, $aAzpa.computed)(function() {
        return s.value !== !0 && o.value.some(function(m) {
            return n.value[r.value(m)] === !0;
        });
    }), u = (0, $aAzpa.computed)(function() {
        return e.selected.length;
    });
    function v(m) {
        return n.value[m] === !0;
    }
    function f() {
        t("update:selected", []);
    }
    function d(m, y, p, C) {
        t("selection", {
            rows: y,
            added: p,
            keys: m,
            evt: C
        });
        var b = a.value === !0 ? p === !0 ? y : [] : p === !0 ? e.selected.concat(y) : e.selected.filter(function(h) {
            return m.includes(r.value(h)) === !1;
        });
        t("update:selected", b);
    }
    return {
        hasSelectionMode: i,
        singleSelection: a,
        multipleSelection: l,
        allRowsSelected: s,
        someRowsSelected: c,
        rowsSelectedNumber: u,
        isRowSelected: v,
        clearSelection: f,
        updateSelection: d
    };
}
function zh(e) {
    return Array.isArray(e) ? e.slice() : [];
}
var Oh = {
    expanded: Array
}, Ih = [
    "update:expanded"
];
function Hh(e, t) {
    var o = (0, $aAzpa.ref)(zh(e.expanded));
    (0, $aD8ZA.watch)(function() {
        return e.expanded;
    }, function(a) {
        o.value = zh(a);
    });
    function r(a) {
        return o.value.includes(a);
    }
    function n(a) {
        e.expanded !== void 0 ? t("update:expanded", a) : o.value = a;
    }
    function i(a, l) {
        var s = o.value.slice(), c = s.indexOf(a);
        l === !0 ? c === -1 && (s.push(a), n(s)) : c !== -1 && (s.splice(c, 1), n(s));
    }
    return {
        isRowExpanded: r,
        setExpanded: n,
        updateExpanded: i
    };
}
var Nh = {
    visibleColumns: Array
};
function Qh(e, t, o) {
    var r = (0, $aAzpa.computed)(function() {
        if (e.columns !== void 0) return e.columns;
        var l = e.rows[0];
        return l !== void 0 ? Object.keys(l).map(function(s) {
            return {
                name: s,
                label: s.toUpperCase(),
                field: s,
                align: Mo(l[s]) ? "right" : "left",
                sortable: !0
            };
        }) : [];
    }), n = (0, $aAzpa.computed)(function() {
        var _t_value = t.value, l = _t_value.sortBy, s = _t_value.descending;
        return (e.visibleColumns !== void 0 ? r.value.filter(function(u) {
            return u.required === !0 || e.visibleColumns.includes(u.name) === !0;
        }) : r.value).map(function(u) {
            var v = u.align || "right", f = "text-".concat(v);
            return (0, $8typN._)((0, $8pZMQ._)({}, u), {
                align: v,
                __iconClass: "q-table__sort-icon q-table__sort-icon--".concat(v),
                __thClass: f + (u.headerClasses !== void 0 ? " " + u.headerClasses : "") + (u.sortable === !0 ? " sortable" : "") + (u.name === l ? " sorted ".concat(s === !0 ? "sort-desc" : "") : ""),
                __tdStyle: u.style !== void 0 ? typeof u.style != "function" ? function() {
                    return u.style;
                } : u.style : function() {
                    return null;
                },
                __tdClass: u.classes !== void 0 ? typeof u.classes != "function" ? function() {
                    return f + " " + u.classes;
                } : function(d) {
                    return f + " " + u.classes(d);
                } : function() {
                    return f;
                }
            });
        });
    }), i = (0, $aAzpa.computed)(function() {
        var l = {};
        return n.value.forEach(function(s) {
            l[s.name] = s;
        }), l;
    }), a = (0, $aAzpa.computed)(function() {
        return e.tableColspan !== void 0 ? e.tableColspan : n.value.length + (o.value === !0 ? 1 : 0);
    });
    return {
        colList: r,
        computedCols: n,
        computedColsMap: i,
        computedColspan: a
    };
}
var Cs = "q-table__bottom row items-center", Uh = {};
gd.forEach(function(e) {
    Uh[e] = {};
});
var Kh = R({
    name: "QTable",
    props: (0, $8pZMQ._)((0, $8typN._)((0, $8pZMQ._)({
        rows: {
            type: Array,
            required: !0
        },
        rowKey: {
            type: [
                String,
                Function
            ],
            default: "id"
        },
        columns: Array,
        loading: Boolean,
        iconFirstPage: String,
        iconPrevPage: String,
        iconNextPage: String,
        iconLastPage: String,
        title: String,
        hideHeader: Boolean,
        grid: Boolean,
        gridHeader: Boolean,
        dense: Boolean,
        flat: Boolean,
        bordered: Boolean,
        square: Boolean,
        separator: {
            type: String,
            default: "horizontal",
            validator: function(e) {
                return [
                    "horizontal",
                    "vertical",
                    "cell",
                    "none"
                ].includes(e);
            }
        },
        wrapCells: Boolean,
        virtualScroll: Boolean,
        virtualScrollTarget: {
            default: void 0
        }
    }, Uh), {
        noDataLabel: String,
        noResultsLabel: String,
        loadingLabel: String,
        selectedRowsLabel: Function,
        rowsPerPageLabel: String,
        paginationLabel: Function,
        color: {
            type: String,
            default: "grey-8"
        },
        titleClass: [
            String,
            Array,
            Object
        ],
        tableStyle: [
            String,
            Array,
            Object
        ],
        tableClass: [
            String,
            Array,
            Object
        ],
        tableHeaderStyle: [
            String,
            Array,
            Object
        ],
        tableHeaderClass: [
            String,
            Array,
            Object
        ],
        cardContainerClass: [
            String,
            Array,
            Object
        ],
        cardContainerStyle: [
            String,
            Array,
            Object
        ],
        cardStyle: [
            String,
            Array,
            Object
        ],
        cardClass: [
            String,
            Array,
            Object
        ],
        hideBottom: Boolean,
        hideSelectedBanner: Boolean,
        hideNoData: Boolean,
        hidePagination: Boolean,
        onRowClick: Function,
        onRowDblclick: Function,
        onRowContextmenu: Function
    }), he, zi, Nh, Ph, Eh, Oh, Fh, Mh),
    emits: [
        "request",
        "virtualScroll"
    ].concat((0, $79xu7._)(Oi), (0, $79xu7._)(Ih), (0, $79xu7._)(Dh)),
    setup: function(e, param) {
        var t = param.slots, o = param.emit;
        var r = (0, $aD8ZA.getCurrentInstance)(), _r_proxy = r.proxy, n = _r_proxy.$q, i = pe(e, n), _Ii = Ii(), a = _Ii.inFullscreen, l = _Ii.toggleFullscreen, s = (0, $aAzpa.computed)(function() {
            return typeof e.rowKey == "function" ? e.rowKey : function(Z) {
                return Z[e.rowKey];
            };
        }), c = (0, $aAzpa.ref)(null), u = (0, $aAzpa.ref)(null), v = (0, $aAzpa.computed)(function() {
            return e.grid !== !0 && e.virtualScroll === !0;
        }), f = (0, $aAzpa.computed)(function() {
            return " q-table__card" + (i.value === !0 ? " q-table__card--dark q-dark" : "") + (e.square === !0 ? " q-table--square" : "") + (e.flat === !0 ? " q-table--flat" : "") + (e.bordered === !0 ? " q-table--bordered" : "");
        }), d = (0, $aAzpa.computed)(function() {
            return "q-table__container q-table--".concat(e.separator, "-separator column no-wrap") + (e.grid === !0 ? " q-table--grid" : f.value) + (i.value === !0 ? " q-table--dark" : "") + (e.dense === !0 ? " q-table--dense" : "") + (e.wrapCells === !1 ? " q-table--no-wrap" : "") + (a.value === !0 ? " fullscreen scroll" : "");
        }), m = (0, $aAzpa.computed)(function() {
            return d.value + (e.loading === !0 ? " q-table--loading" : "");
        });
        (0, $aD8ZA.watch)(function() {
            return e.tableStyle + e.tableClass + e.tableHeaderStyle + e.tableHeaderClass + d.value;
        }, function() {
            v.value === !0 && u.value !== null && u.value.reset();
        });
        var _Bh = Bh(r, G), y = _Bh.innerPagination, p = _Bh.computedPagination, C = _Bh.isServerSide, b = _Bh.requestServerInteraction, h = _Bh.setPagination, _Ah = Ah(e, h), g = _Ah.computedFilterMethod, _Hh = Hh(e, o), S = _Hh.isRowExpanded, P = _Hh.setExpanded, $ = _Hh.updateExpanded, L = (0, $aAzpa.computed)(function() {
            var Z = e.rows;
            if (C.value === !0 || Z.length === 0) return Z;
            var _p_value = p.value, ve = _p_value.sortBy, qe = _p_value.descending;
            return e.filter && (Z = g.value(Z, e.filter, V.value, G)), I.value !== null && (Z = oe.value(e.rows === Z ? Z.slice() : Z, ve, qe)), Z;
        }), E = (0, $aAzpa.computed)(function() {
            return L.value.length;
        }), A = (0, $aAzpa.computed)(function() {
            var Z = L.value;
            if (C.value === !0) return Z;
            var _p_value = p.value, ve = _p_value.rowsPerPage;
            return ve !== 0 && (D.value === 0 && e.rows !== Z ? Z.length > te.value && (Z = Z.slice(0, te.value)) : Z = Z.slice(D.value, te.value)), Z;
        }), _Vh = Vh(e, o, A, s), B = _Vh.hasSelectionMode, q = _Vh.singleSelection, x = _Vh.multipleSelection, k = _Vh.allRowsSelected, j = _Vh.someRowsSelected, Q = _Vh.rowsSelectedNumber, w = _Vh.isRowSelected, H = _Vh.clearSelection, W = _Vh.updateSelection, _Qh = Qh(e, p, B), ie = _Qh.colList, V = _Qh.computedCols, _ = _Qh.computedColsMap, N = _Qh.computedColspan, _Rh = Rh(e, p, ie, h), I = _Rh.columnToSort, oe = _Rh.computedSortMethod, T = _Rh.sort, _Lh = Lh(r, y, p, C, h, E), D = _Lh.firstRowIndex, te = _Lh.lastRowIndex, z = _Lh.isFirstPage, ue = _Lh.isLastPage, _e = _Lh.pagesNumber, U = _Lh.computedRowsPerPageOptions, ae = _Lh.computedRowsNumber, ce = _Lh.firstPage, be = _Lh.prevPage, Me = _Lh.nextPage, le = _Lh.lastPage, Re = (0, $aAzpa.computed)(function() {
            return A.value.length === 0;
        }), Fe = (0, $aAzpa.computed)(function() {
            var Z = {};
            return gd.forEach(function(ve) {
                Z[ve] = e[ve];
            }), Z.virtualScrollItemSize === void 0 && (Z.virtualScrollItemSize = e.dense === !0 ? 28 : 48), Z;
        });
        function De() {
            v.value === !0 && u.value.reset();
        }
        function ne() {
            if (e.grid === !0) return en();
            var Z = e.hideHeader !== !0 ? ke : null;
            if (v.value === !0) {
                var qe = t["top-row"], Be = t["bottom-row"], Ne = {
                    default: function(pt) {
                        return Pe(pt.item, t.body, pt.index);
                    }
                };
                if (qe !== void 0) {
                    var pt = (0, $aD8ZA.h)("tbody", qe({
                        cols: V.value
                    }));
                    Ne.before = Z === null ? function() {
                        return pt;
                    } : function() {
                        return [
                            Z()
                        ].concat(pt);
                    };
                } else Z !== null && (Ne.before = Z);
                return Be !== void 0 && (Ne.after = function() {
                    return (0, $aD8ZA.h)("tbody", Be({
                        cols: V.value
                    }));
                }), (0, $aD8ZA.h)(xs, (0, $8typN._)((0, $8pZMQ._)({
                    ref: u,
                    class: e.tableClass,
                    style: e.tableStyle
                }, Fe.value), {
                    scrollTarget: e.virtualScrollTarget,
                    items: A.value,
                    type: "__qtable",
                    tableColspan: N.value,
                    onVirtualScroll: Y
                }), Ne);
            }
            var ve = [
                Ee()
            ];
            return Z !== null && ve.unshift(Z()), ys({
                class: [
                    "q-table__middle scroll",
                    e.tableClass
                ],
                style: e.tableStyle
            }, ve);
        }
        function se(Z, ve) {
            if (u.value !== null) {
                u.value.scrollTo(Z, ve);
                return;
            }
            Z = parseInt(Z, 10);
            var qe = c.value.querySelector("tbody tr:nth-of-type(".concat(Z + 1, ")"));
            if (qe !== null) {
                var Be = c.value.querySelector(".q-table__middle.scroll"), Ne = qe.offsetTop - e.virtualScrollStickySizeStart, pt = Ne < Be.scrollTop ? "decrease" : "increase";
                Be.scrollTop = Ne, o("virtualScroll", {
                    index: Z,
                    from: 0,
                    to: y.value.rowsPerPage - 1,
                    direction: pt
                });
            }
        }
        function Y(Z) {
            o("virtualScroll", Z);
        }
        function me() {
            return [
                (0, $aD8ZA.h)(is, {
                    class: "q-table__linear-progress",
                    color: e.color,
                    dark: i.value,
                    indeterminate: !0,
                    trackColor: "transparent"
                })
            ];
        }
        function Pe(Z, ve, qe) {
            var Be = s.value(Z), Ne = w(Be);
            if (ve !== void 0) return ve(Ae({
                key: Be,
                row: Z,
                pageIndex: qe,
                __trClass: Ne ? "selected" : ""
            }));
            var pt = t["body-cell"], M = V.value.map(function(X) {
                var de = t["body-cell-".concat(X.name)], fe = de !== void 0 ? de : pt;
                return fe !== void 0 ? fe(nt({
                    key: Be,
                    row: Z,
                    pageIndex: qe,
                    col: X
                })) : (0, $aD8ZA.h)("td", {
                    class: X.__tdClass(Z),
                    style: X.__tdStyle(Z)
                }, G(X, Z));
            });
            if (B.value === !0) {
                var X = t["body-selection"], de = X !== void 0 ? X(ct({
                    key: Be,
                    row: Z,
                    pageIndex: qe
                })) : [
                    (0, $aD8ZA.h)(fn, {
                        modelValue: Ne,
                        color: e.color,
                        dark: i.value,
                        dense: e.dense,
                        "onUpdate:modelValue": function(fe, et) {
                            W([
                                Be
                            ], [
                                Z
                            ], fe, et);
                        }
                    })
                ];
                M.unshift((0, $aD8ZA.h)("td", {
                    class: "q-table--col-auto-width"
                }, de));
            }
            var O = {
                key: Be,
                class: {
                    selected: Ne
                }
            };
            return e.onRowClick !== void 0 && (O.class["cursor-pointer"] = !0, O.onClick = function(X) {
                o("rowClick", X, Z, qe);
            }), e.onRowDblclick !== void 0 && (O.class["cursor-pointer"] = !0, O.onDblclick = function(X) {
                o("rowDblclick", X, Z, qe);
            }), e.onRowContextmenu !== void 0 && (O.class["cursor-pointer"] = !0, O.onContextmenu = function(X) {
                o("rowContextmenu", X, Z, qe);
            }), (0, $aD8ZA.h)("tr", O, M);
        }
        function Ee() {
            var Z = t.body, ve = t["top-row"], qe = t["bottom-row"], Be = A.value.map(function(Ne, pt) {
                return Pe(Ne, Z, pt);
            });
            return ve !== void 0 && (Be = ve({
                cols: V.value
            }).concat(Be)), qe !== void 0 && (Be = Be.concat(qe({
                cols: V.value
            }))), (0, $aD8ZA.h)("tbody", Be);
        }
        function Ae(Z) {
            return dt(Z), Z.cols = Z.cols.map(function(ve) {
                return it((0, $8pZMQ._)({}, ve), "value", function() {
                    return G(ve, Z.row);
                });
            }), Z;
        }
        function nt(Z) {
            return dt(Z), it(Z, "value", function() {
                return G(Z.col, Z.row);
            }), Z;
        }
        function ct(Z) {
            return dt(Z), Z;
        }
        function dt(Z) {
            Object.assign(Z, {
                cols: V.value,
                colsMap: _.value,
                sort: T,
                rowIndex: D.value + Z.pageIndex,
                color: e.color,
                dark: i.value,
                dense: e.dense
            }), B.value === !0 && it(Z, "selected", function() {
                return w(Z.key);
            }, function(ve, qe) {
                W([
                    Z.key
                ], [
                    Z.row
                ], ve, qe);
            }), it(Z, "expand", function() {
                return S(Z.key);
            }, function(ve) {
                $(Z.key, ve);
            });
        }
        function G(Z, ve) {
            var qe = typeof Z.field == "function" ? Z.field(ve) : ve[Z.field];
            return Z.format !== void 0 ? Z.format(qe, ve) : qe;
        }
        var re = (0, $aAzpa.computed)(function() {
            return {
                pagination: p.value,
                pagesNumber: _e.value,
                isFirstPage: z.value,
                isLastPage: ue.value,
                firstPage: ce,
                prevPage: be,
                nextPage: Me,
                lastPage: le,
                inFullscreen: a.value,
                toggleFullscreen: l
            };
        });
        function K() {
            var Z = t.top, ve = t["top-left"], qe = t["top-right"], Be = t["top-selection"], Ne = B.value === !0 && Be !== void 0 && Q.value > 0, pt = "q-table__top relative-position row items-center";
            if (Z !== void 0) return (0, $aD8ZA.h)("div", {
                class: pt
            }, [
                Z(re.value)
            ]);
            var M;
            if (Ne === !0 ? M = Be(re.value).slice() : (M = [], ve !== void 0 ? M.push((0, $aD8ZA.h)("div", {
                class: "q-table__control"
            }, [
                ve(re.value)
            ])) : e.title && M.push((0, $aD8ZA.h)("div", {
                class: "q-table__control"
            }, [
                (0, $aD8ZA.h)("div", {
                    class: [
                        "q-table__title",
                        e.titleClass
                    ]
                }, e.title)
            ]))), qe !== void 0 && (M.push((0, $aD8ZA.h)("div", {
                class: "q-table__separator col"
            })), M.push((0, $aD8ZA.h)("div", {
                class: "q-table__control"
            }, [
                qe(re.value)
            ]))), M.length !== 0) return (0, $aD8ZA.h)("div", {
                class: pt
            }, M);
        }
        var ee = (0, $aAzpa.computed)(function() {
            return j.value === !0 ? null : k.value;
        });
        function ke() {
            var Z = ze();
            return e.loading === !0 && t.loading === void 0 && Z.push((0, $aD8ZA.h)("tr", {
                class: "q-table__progress"
            }, [
                (0, $aD8ZA.h)("th", {
                    class: "relative-position",
                    colspan: N.value
                }, me())
            ])), (0, $aD8ZA.h)("thead", Z);
        }
        function ze() {
            var Z = t.header, ve = t["header-cell"];
            if (Z !== void 0) return Z(ye({
                header: !0
            })).slice();
            var qe = V.value.map(function(Be) {
                var Ne = t["header-cell-".concat(Be.name)], pt = Ne !== void 0 ? Ne : ve, M = ye({
                    col: Be
                });
                return pt !== void 0 ? pt(M) : (0, $aD8ZA.h)(bs, {
                    key: Be.name,
                    props: M
                }, function() {
                    return Be.label;
                });
            });
            if (q.value === !0 && e.grid !== !0) qe.unshift((0, $aD8ZA.h)("th", {
                class: "q-table--col-auto-width"
            }, " "));
            else if (x.value === !0) {
                var Be = t["header-selection"], Ne = Be !== void 0 ? Be(ye({})) : [
                    (0, $aD8ZA.h)(fn, {
                        color: e.color,
                        modelValue: ee.value,
                        dark: i.value,
                        dense: e.dense,
                        "onUpdate:modelValue": Ge
                    })
                ];
                qe.unshift((0, $aD8ZA.h)("th", {
                    class: "q-table--col-auto-width"
                }, Ne));
            }
            return [
                (0, $aD8ZA.h)("tr", {
                    class: e.tableHeaderClass,
                    style: e.tableHeaderStyle
                }, qe)
            ];
        }
        function ye(Z) {
            return Object.assign(Z, {
                cols: V.value,
                sort: T,
                colsMap: _.value,
                color: e.color,
                dark: i.value,
                dense: e.dense
            }), x.value === !0 && it(Z, "selected", function() {
                return ee.value;
            }, Ge), Z;
        }
        function Ge(Z) {
            j.value === !0 && (Z = !1), W(A.value.map(s.value), A.value, Z);
        }
        var mt = (0, $aAzpa.computed)(function() {
            var Z = [
                e.iconFirstPage || n.iconSet.table.firstPage,
                e.iconPrevPage || n.iconSet.table.prevPage,
                e.iconNextPage || n.iconSet.table.nextPage,
                e.iconLastPage || n.iconSet.table.lastPage
            ];
            return n.lang.rtl === !0 ? Z.reverse() : Z;
        });
        function ht() {
            if (e.hideBottom === !0) return;
            if (Re.value === !0) {
                if (e.hideNoData === !0) return;
                var qe = e.loading === !0 ? e.loadingLabel || n.lang.table.loading : e.filter ? e.noResultsLabel || n.lang.table.noResults : e.noDataLabel || n.lang.table.noData, Be = t["no-data"], Ne = Be !== void 0 ? [
                    Be({
                        message: qe,
                        icon: n.iconSet.table.warning,
                        filter: e.filter
                    })
                ] : [
                    (0, $aD8ZA.h)(we, {
                        class: "q-table__bottom-nodata-icon",
                        name: n.iconSet.table.warning
                    }),
                    qe
                ];
                return (0, $aD8ZA.h)("div", {
                    class: Cs + " q-table__bottom--nodata"
                }, Ne);
            }
            var Z = t.bottom;
            if (Z !== void 0) return (0, $aD8ZA.h)("div", {
                class: Cs
            }, [
                Z(re.value)
            ]);
            var ve = e.hideSelectedBanner !== !0 && B.value === !0 && Q.value > 0 ? [
                (0, $aD8ZA.h)("div", {
                    class: "q-table__control"
                }, [
                    (0, $aD8ZA.h)("div", [
                        (e.selectedRowsLabel || n.lang.table.selectedRecords)(Q.value)
                    ])
                ])
            ] : [];
            if (e.hidePagination !== !0) return (0, $aD8ZA.h)("div", {
                class: Cs + " justify-end"
            }, qo(ve));
            if (ve.length !== 0) return (0, $aD8ZA.h)("div", {
                class: Cs
            }, ve);
        }
        function ro(Z) {
            h({
                page: 1,
                rowsPerPage: Z.value
            });
        }
        function qo(Z) {
            var ve, _p_value = p.value, qe = _p_value.rowsPerPage, Be = e.paginationLabel || n.lang.table.pagination, Ne = t.pagination, pt = e.rowsPerPageOptions.length > 1;
            if (Z.push((0, $aD8ZA.h)("div", {
                class: "q-table__separator col"
            })), pt === !0 && Z.push((0, $aD8ZA.h)("div", {
                class: "q-table__control"
            }, [
                (0, $aD8ZA.h)("span", {
                    class: "q-table__bottom-item"
                }, [
                    e.rowsPerPageLabel || n.lang.table.recordsPerPage
                ]),
                (0, $aD8ZA.h)(fs, {
                    class: "q-table__select inline q-table__bottom-item",
                    color: e.color,
                    modelValue: qe,
                    options: U.value,
                    displayValue: qe === 0 ? n.lang.table.allRows : qe,
                    dark: i.value,
                    borderless: !0,
                    dense: !0,
                    optionsDense: !0,
                    optionsCover: !0,
                    "onUpdate:modelValue": ro
                })
            ])), Ne !== void 0) ve = Ne(re.value);
            else if (ve = [
                (0, $aD8ZA.h)("span", qe !== 0 ? {
                    class: "q-table__bottom-item"
                } : {}, [
                    qe ? Be(D.value + 1, Math.min(te.value, ae.value), ae.value) : Be(1, E.value, ae.value)
                ])
            ], qe !== 0 && _e.value > 1) {
                var M = {
                    color: e.color,
                    round: !0,
                    dense: !0,
                    flat: !0
                };
                e.dense === !0 && (M.size = "sm"), _e.value > 2 && ve.push((0, $aD8ZA.h)(Le, (0, $8typN._)((0, $8pZMQ._)({
                    key: "pgFirst"
                }, M), {
                    icon: mt.value[0],
                    disable: z.value,
                    onClick: ce
                }))), ve.push((0, $aD8ZA.h)(Le, (0, $8typN._)((0, $8pZMQ._)({
                    key: "pgPrev"
                }, M), {
                    icon: mt.value[1],
                    disable: z.value,
                    onClick: be
                })), (0, $aD8ZA.h)(Le, (0, $8typN._)((0, $8pZMQ._)({
                    key: "pgNext"
                }, M), {
                    icon: mt.value[2],
                    disable: ue.value,
                    onClick: Me
                }))), _e.value > 2 && ve.push((0, $aD8ZA.h)(Le, (0, $8typN._)((0, $8pZMQ._)({
                    key: "pgLast"
                }, M), {
                    icon: mt.value[3],
                    disable: ue.value,
                    onClick: le
                })));
            }
            return Z.push((0, $aD8ZA.h)("div", {
                class: "q-table__control"
            }, ve)), Z;
        }
        function kn() {
            var Z = e.gridHeader === !0 ? [
                (0, $aD8ZA.h)("table", {
                    class: "q-table"
                }, [
                    ke((0, $aD8ZA.h))
                ])
            ] : e.loading === !0 && t.loading === void 0 ? me((0, $aD8ZA.h)) : void 0;
            return (0, $aD8ZA.h)("div", {
                class: "q-table__middle"
            }, Z);
        }
        function en() {
            var Z = t.item !== void 0 ? t.item : function(ve) {
                var qe = ve.cols.map(function(Ne) {
                    return (0, $aD8ZA.h)("div", {
                        class: "q-table__grid-item-row"
                    }, [
                        (0, $aD8ZA.h)("div", {
                            class: "q-table__grid-item-title"
                        }, [
                            Ne.label
                        ]),
                        (0, $aD8ZA.h)("div", {
                            class: "q-table__grid-item-value"
                        }, [
                            Ne.value
                        ])
                    ]);
                });
                if (B.value === !0) {
                    var Ne = t["body-selection"], pt = Ne !== void 0 ? Ne(ve) : [
                        (0, $aD8ZA.h)(fn, {
                            modelValue: ve.selected,
                            color: e.color,
                            dark: i.value,
                            dense: e.dense,
                            "onUpdate:modelValue": function(M, O) {
                                W([
                                    ve.key
                                ], [
                                    ve.row
                                ], M, O);
                            }
                        })
                    ];
                    qe.unshift((0, $aD8ZA.h)("div", {
                        class: "q-table__grid-item-row"
                    }, pt), (0, $aD8ZA.h)(Co, {
                        dark: i.value
                    }));
                }
                var Be = {
                    class: [
                        "q-table__grid-item-card" + f.value,
                        e.cardClass
                    ],
                    style: e.cardStyle
                };
                return (e.onRowClick !== void 0 || e.onRowDblclick !== void 0) && (Be.class[0] += " cursor-pointer", e.onRowClick !== void 0 && (Be.onClick = function(Ne) {
                    o("RowClick", Ne, ve.row, ve.pageIndex);
                }), e.onRowDblclick !== void 0 && (Be.onDblclick = function(Ne) {
                    o("RowDblclick", Ne, ve.row, ve.pageIndex);
                })), (0, $aD8ZA.h)("div", {
                    class: "q-table__grid-item col-xs-12 col-sm-6 col-md-4 col-lg-3" + (ve.selected === !0 ? " q-table__grid-item--selected" : "")
                }, [
                    (0, $aD8ZA.h)("div", Be, qe)
                ]);
            };
            return (0, $aD8ZA.h)("div", {
                class: [
                    "q-table__grid-content row",
                    e.cardContainerClass
                ],
                style: e.cardContainerStyle
            }, A.value.map(function(ve, qe) {
                return Z(Ae({
                    key: s.value(ve),
                    row: ve,
                    pageIndex: qe
                }));
            }));
        }
        return Object.assign(r.proxy, {
            requestServerInteraction: b,
            setPagination: h,
            firstPage: ce,
            prevPage: be,
            nextPage: Me,
            lastPage: le,
            isRowSelected: w,
            clearSelection: H,
            isRowExpanded: S,
            setExpanded: P,
            sort: T,
            resetVirtualScroll: De,
            scrollTo: se,
            getCellValue: G
        }), Sl(r.proxy, {
            filteredSortedRows: function() {
                return L.value;
            },
            computedRows: function() {
                return A.value;
            },
            computedRowsNumber: function() {
                return ae.value;
            }
        }), function() {
            var Z = [
                K()
            ], ve = {
                ref: c,
                class: m.value
            };
            return e.grid === !0 ? Z.push(kn()) : Object.assign(ve, {
                class: [
                    ve.class,
                    e.cardClass
                ],
                style: e.cardStyle
            }), Z.push(ne(), ht()), e.loading === !0 && t.loading !== void 0 && Z.push(t.loading()), (0, $aD8ZA.h)("div", ve, Z);
        };
    }
});
var Wh = R({
    name: "QTr",
    props: {
        props: Object,
        noHover: Boolean
    },
    setup: function(e, param) {
        var t = param.slots;
        var o = (0, $aAzpa.computed)(function() {
            return "q-tr" + (e.props === void 0 || e.props.header === !0 ? "" : " " + e.props.__trClass) + (e.noHover === !0 ? " q-tr--no-hover" : "");
        });
        return function() {
            return (0, $aD8ZA.h)("tr", {
                class: o.value
            }, J(t.default));
        };
    }
});
var Xh = R({
    name: "QTd",
    props: {
        props: Object,
        autoWidth: Boolean,
        noHover: Boolean
    },
    setup: function(e, param) {
        var t = param.slots;
        var o = (0, $aD8ZA.getCurrentInstance)(), r = (0, $aAzpa.computed)(function() {
            return "q-td" + (e.autoWidth === !0 ? " q-table--col-auto-width" : "") + (e.noHover === !0 ? " q-td--no-hover" : "") + " ";
        });
        return function() {
            if (e.props === void 0) return (0, $aD8ZA.h)("td", {
                class: r.value
            }, J(t.default));
            var n = o.vnode.key, i = (e.props.colsMap !== void 0 ? e.props.colsMap[n] : null) || e.props.col;
            if (i === void 0) return;
            var _e_props = e.props, a = _e_props.row;
            return (0, $aD8ZA.h)("td", {
                class: r.value + i.__tdClass(a),
                style: i.__tdStyle(a)
            }, J(t.default));
        };
    }
});
var Gh = R({
    name: "QRouteTab",
    props: (0, $8pZMQ._)({}, zo, lu),
    emits: au,
    setup: function(e, param) {
        var t = param.slots, o = param.emit;
        var r = Yn({
            useDisableForRouterLinkProps: !1
        }), _uu = uu(e, t, o, (0, $8pZMQ._)({
            exact: (0, $aAzpa.computed)(function() {
                return e.exact;
            })
        }, r)), n = _uu.renderTab, i = _uu.$tabs;
        return (0, $aD8ZA.watch)(function() {
            return "".concat(e.name, " | ").concat(e.exact, " | ").concat((r.resolvedLink.value || {}).href);
        }, function() {
            i.verifyRouteModel();
        }), function() {
            return n(r.linkTag.value, r.linkAttrs.value);
        };
    }
});
function _k(e, t) {
    if (e.hour !== null) {
        if (e.minute === null) return "minute";
        if (t === !0 && e.second === null) return "second";
    }
    return "hour";
}
function Ck() {
    var e = new Date;
    return {
        hour: e.getHours(),
        minute: e.getMinutes(),
        second: e.getSeconds(),
        millisecond: e.getMilliseconds()
    };
}
var Jh = R({
    name: "QTime",
    props: (0, $8typN._)((0, $8pZMQ._)({}, he, _t, vu), {
        mask: {
            default: null
        },
        format24h: {
            type: Boolean,
            default: null
        },
        defaultDate: {
            type: String,
            validator: function(e) {
                return /^-?[\d]+\/[0-1]\d\/[0-3]\d$/.test(e);
            }
        },
        options: Function,
        hourOptions: Array,
        minuteOptions: Array,
        secondOptions: Array,
        withSeconds: Boolean,
        nowBtn: Boolean
    }),
    emits: gu,
    setup: function(e, param) {
        var t = param.slots, o = param.emit;
        var r = (0, $aD8ZA.getCurrentInstance)(), _r_proxy = r.proxy, n = _r_proxy.$q, i = pe(e, n), _hu = hu(e, n), a = _hu.tabindex, l = _hu.headerClass, s = _hu.getLocale, c = _hu.getCurrentDate, u = cn(e), v = eo(u), f, d, m = (0, $aAzpa.ref)(null), y = (0, $aAzpa.computed)(function() {
            return oe();
        }), p = (0, $aAzpa.computed)(function() {
            return s();
        }), C = (0, $aAzpa.computed)(function() {
            return T();
        }), b = lr(e.modelValue, y.value, p.value, e.calendar, C.value), h = (0, $aAzpa.ref)(_k(b)), g = (0, $aAzpa.ref)(b), S = (0, $aAzpa.ref)(b.hour === null || b.hour < 12), P = (0, $aAzpa.computed)(function() {
            return "q-time q-time--".concat(e.landscape === !0 ? "landscape" : "portrait") + (i.value === !0 ? " q-time--dark q-dark" : "") + (e.disable === !0 ? " disabled" : e.readonly === !0 ? " q-time--readonly" : "") + (e.bordered === !0 ? " q-time--bordered" : "") + (e.square === !0 ? " q-time--square no-border-radius" : "") + (e.flat === !0 ? " q-time--flat no-shadow" : "");
        }), $ = (0, $aAzpa.computed)(function() {
            var G = g.value;
            return {
                hour: G.hour === null ? "--" : L.value === !0 ? Je(G.hour) : String(S.value === !0 ? G.hour === 0 ? 12 : G.hour : G.hour > 12 ? G.hour - 12 : G.hour),
                minute: G.minute === null ? "--" : Je(G.minute),
                second: G.second === null ? "--" : Je(G.second)
            };
        }), L = (0, $aAzpa.computed)(function() {
            return e.format24h !== null ? e.format24h : n.lang.date.format24h;
        }), E = (0, $aAzpa.computed)(function() {
            var G = h.value === "hour", re = G === !0 ? 12 : 60, K = g.value[h.value], ke = "rotate(".concat(Math.round(K * (360 / re)) - 180, "deg) translateX(-50%)");
            return G === !0 && L.value === !0 && g.value.hour >= 12 && (ke += " scale(.7)"), {
                transform: ke
            };
        }), A = (0, $aAzpa.computed)(function() {
            return g.value.hour !== null;
        }), B = (0, $aAzpa.computed)(function() {
            return A.value === !0 && g.value.minute !== null;
        }), q = (0, $aAzpa.computed)(function() {
            return e.hourOptions !== void 0 ? function(G) {
                return e.hourOptions.includes(G);
            } : e.options !== void 0 ? function(G) {
                return e.options(G, null, null);
            } : null;
        }), x = (0, $aAzpa.computed)(function() {
            return e.minuteOptions !== void 0 ? function(G) {
                return e.minuteOptions.includes(G);
            } : e.options !== void 0 ? function(G) {
                return e.options(g.value.hour, G, null);
            } : null;
        }), k = (0, $aAzpa.computed)(function() {
            return e.secondOptions !== void 0 ? function(G) {
                return e.secondOptions.includes(G);
            } : e.options !== void 0 ? function(G) {
                return e.options(g.value.hour, g.value.minute, G);
            } : null;
        }), j = (0, $aAzpa.computed)(function() {
            if (q.value === null) return null;
            var G = _(0, 11, q.value), re = _(12, 11, q.value);
            return {
                am: G,
                pm: re,
                values: G.values.concat(re.values)
            };
        }), Q = (0, $aAzpa.computed)(function() {
            return x.value !== null ? _(0, 59, x.value) : null;
        }), w = (0, $aAzpa.computed)(function() {
            return k.value !== null ? _(0, 59, k.value) : null;
        }), H = (0, $aAzpa.computed)(function() {
            switch(h.value){
                case "hour":
                    return j.value;
                case "minute":
                    return Q.value;
                case "second":
                    return w.value;
            }
        }), W = (0, $aAzpa.computed)(function() {
            var G, re, K = 0, ee = 1, ke = H.value !== null ? H.value.values : void 0;
            h.value === "hour" ? L.value === !0 ? (G = 0, re = 23) : (G = 0, re = 11, S.value === !1 && (K = 12)) : (G = 0, re = 55, ee = 5);
            var ze = [];
            for(var ye = G, Ge = G; ye <= re; ye += ee, Ge++){
                var mt = ye + K, ht = ke !== void 0 && ke.includes(mt) === !1, ro = h.value === "hour" && ye === 0 ? L.value === !0 ? "00" : "12" : ye;
                ze.push({
                    val: mt,
                    index: Ge,
                    disable: ht,
                    label: ro
                });
            }
            return ze;
        }), ie = (0, $aAzpa.computed)(function() {
            return [
                [
                    qt,
                    z,
                    void 0,
                    {
                        stop: !0,
                        prevent: !0,
                        mouse: !0
                    }
                ]
            ];
        });
        (0, $aD8ZA.watch)(function() {
            return e.modelValue;
        }, function(G) {
            var re = lr(G, y.value, p.value, e.calendar, C.value);
            (re.dateHash !== g.value.dateHash || re.timeHash !== g.value.timeHash) && (g.value = re, re.hour === null ? h.value = "hour" : S.value = re.hour < 12);
        }), (0, $aD8ZA.watch)([
            y,
            p
        ], function() {
            (0, $aD8ZA.nextTick)(function() {
                nt();
            });
        });
        function V() {
            var G = (0, $8pZMQ._)({}, c(), Ck());
            nt(G), Object.assign(g.value, G), h.value = "hour";
        }
        function _(G, re, K) {
            var ee = Array.apply(null, {
                length: re + 1
            }).map(function(ke, ze) {
                var ye = ze + G;
                return {
                    index: ye,
                    val: K(ye) === !0
                };
            }).filter(function(ke) {
                return ke.val === !0;
            }).map(function(ke) {
                return ke.index;
            });
            return {
                min: ee[0],
                max: ee[ee.length - 1],
                values: ee,
                threshold: re + 1
            };
        }
        function N(G, re, K) {
            var ee = Math.abs(G - re);
            return Math.min(ee, K - ee);
        }
        function I(G, param) {
            var re = param.min, K = param.max, ee = param.values, ke = param.threshold;
            if (G === re) return re;
            if (G < re || G > K) return N(G, re, ke) <= N(G, K, ke) ? re : K;
            var ze = ee.findIndex(function(mt) {
                return G <= mt;
            }), ye = ee[ze - 1], Ge = ee[ze];
            return G - ye <= Ge - G ? ye : Ge;
        }
        function oe() {
            return e.calendar !== "persian" && e.mask !== null ? e.mask : "HH:mm".concat(e.withSeconds === !0 ? ":ss" : "");
        }
        function T() {
            if (typeof e.defaultDate != "string") {
                var G = c(!0);
                return G.dateHash = Qo(G), G;
            }
            return lr(e.defaultDate, "YYYY/MM/DD", void 0, e.calendar);
        }
        function D() {
            return Jt(r) === !0 || H.value !== null && (H.value.values.length === 0 || h.value === "hour" && L.value !== !0 && j.value[S.value === !0 ? "am" : "pm"].values.length === 0);
        }
        function te() {
            var G = m.value, _G_getBoundingClientRect = G.getBoundingClientRect(), re = _G_getBoundingClientRect.top, K = _G_getBoundingClientRect.left, ee = _G_getBoundingClientRect.width, ke = ee / 2;
            return {
                top: re + ke,
                left: K + ke,
                dist: ke * .7
            };
        }
        function z(G) {
            if (D() !== !0) {
                if (G.isFirst === !0) {
                    f = te(), d = _e(G.evt, f);
                    return;
                }
                d = _e(G.evt, f, d), G.isFinal === !0 && (f = !1, d = null, ue());
            }
        }
        function ue() {
            h.value === "hour" ? h.value = "minute" : e.withSeconds && h.value === "minute" && (h.value = "second");
        }
        function _e(G, re, K) {
            var ee = yt(G), ke = Math.abs(ee.top - re.top), ze = Math.sqrt(Math.pow(Math.abs(ee.top - re.top), 2) + Math.pow(Math.abs(ee.left - re.left), 2)), ye, Ge = Math.asin(ke / ze) * (180 / Math.PI);
            if (ee.top < re.top ? Ge = re.left < ee.left ? 90 - Ge : 270 + Ge : Ge = re.left < ee.left ? Ge + 90 : 270 - Ge, h.value === "hour") {
                if (ye = Ge / 30, j.value !== null) {
                    var mt = L.value !== !0 ? S.value === !0 : j.value.am.values.length !== 0 && j.value.pm.values.length !== 0 ? ze >= re.dist : j.value.am.values.length !== 0;
                    ye = I(ye + (mt === !0 ? 0 : 12), j.value[mt === !0 ? "am" : "pm"]);
                } else ye = Math.round(ye), L.value === !0 ? ze < re.dist ? ye < 12 && (ye += 12) : ye === 12 && (ye = 0) : S.value === !0 && ye === 12 ? ye = 0 : S.value === !1 && ye !== 12 && (ye += 12);
                L.value === !0 && (S.value = ye < 12);
            } else ye = Math.round(Ge / 6) % 60, h.value === "minute" && Q.value !== null ? ye = I(ye, Q.value) : h.value === "second" && w.value !== null && (ye = I(ye, w.value));
            return K !== ye && Y[h.value](ye), ye;
        }
        var U = {
            hour: function() {
                h.value = "hour";
            },
            minute: function() {
                h.value = "minute";
            },
            second: function() {
                h.value = "second";
            }
        };
        function ae(G) {
            G.keyCode === 13 && me();
        }
        function ce(G) {
            G.keyCode === 13 && Pe();
        }
        function be(G) {
            D() !== !0 && (n.platform.is.desktop !== !0 && _e(G, te()), ue());
        }
        function Me(G) {
            D() !== !0 && _e(G, te());
        }
        function le(G) {
            if (G.keyCode === 13) h.value = "hour";
            else if ([
                37,
                39
            ].includes(G.keyCode)) {
                var re = G.keyCode === 37 ? -1 : 1;
                if (j.value !== null) {
                    var K = L.value === !0 ? j.value.values : j.value[S.value === !0 ? "am" : "pm"].values;
                    if (K.length === 0) return;
                    if (g.value.hour === null) De(K[0]);
                    else {
                        var ee = (K.length + K.indexOf(g.value.hour) + re) % K.length;
                        De(K[ee]);
                    }
                } else {
                    var K1 = L.value === !0 ? 24 : 12, ee1 = L.value !== !0 && S.value === !1 ? 12 : 0, ke = g.value.hour === null ? -re : g.value.hour;
                    De(ee1 + (24 + ke + re) % K1);
                }
            }
        }
        function Re(G) {
            if (G.keyCode === 13) h.value = "minute";
            else if ([
                37,
                39
            ].includes(G.keyCode)) {
                var re = G.keyCode === 37 ? -1 : 1;
                if (Q.value !== null) {
                    var K = Q.value.values;
                    if (K.length === 0) return;
                    if (g.value.minute === null) ne(K[0]);
                    else {
                        var ee = (K.length + K.indexOf(g.value.minute) + re) % K.length;
                        ne(K[ee]);
                    }
                } else {
                    var K1 = g.value.minute === null ? -re : g.value.minute;
                    ne((60 + K1 + re) % 60);
                }
            }
        }
        function Fe(G) {
            if (G.keyCode === 13) h.value = "second";
            else if ([
                37,
                39
            ].includes(G.keyCode)) {
                var re = G.keyCode === 37 ? -1 : 1;
                if (w.value !== null) {
                    var K = w.value.values;
                    if (K.length === 0) return;
                    if (g.value.seconds === null) se(K[0]);
                    else {
                        var ee = (K.length + K.indexOf(g.value.second) + re) % K.length;
                        se(K[ee]);
                    }
                } else {
                    var K1 = g.value.second === null ? -re : g.value.second;
                    se((60 + K1 + re) % 60);
                }
            }
        }
        function De(G) {
            g.value.hour !== G && (g.value.hour = G, Ae());
        }
        function ne(G) {
            g.value.minute !== G && (g.value.minute = G, Ae());
        }
        function se(G) {
            g.value.second !== G && (g.value.second = G, Ae());
        }
        var Y = {
            hour: De,
            minute: ne,
            second: se
        };
        function me() {
            S.value === !1 && (S.value = !0, g.value.hour !== null && (g.value.hour -= 12, Ae()));
        }
        function Pe() {
            S.value === !0 && (S.value = !1, g.value.hour !== null && (g.value.hour += 12, Ae()));
        }
        function Ee(G) {
            var re = e.modelValue;
            h.value !== G && re !== void 0 && re !== null && re !== "" && typeof re != "string" && (h.value = G);
        }
        function Ae() {
            if (q.value !== null && q.value(g.value.hour) !== !0) {
                g.value = lr(), Ee("hour");
                return;
            }
            if (x.value !== null && x.value(g.value.minute) !== !0) {
                g.value.minute = null, g.value.second = null, Ee("minute");
                return;
            }
            if (e.withSeconds === !0 && k.value !== null && k.value(g.value.second) !== !0) {
                g.value.second = null, Ee("second");
                return;
            }
            g.value.hour === null || g.value.minute === null || e.withSeconds === !0 && g.value.second === null || nt();
        }
        function nt(G) {
            var re = Object.assign((0, $8pZMQ._)({}, g.value), G), K = e.calendar === "persian" ? Je(re.hour) + ":" + Je(re.minute) + (e.withSeconds === !0 ? ":" + Je(re.second) : "") : Ka(new Date(re.year, re.month === null ? null : re.month - 1, re.day, re.hour, re.minute, re.second, re.millisecond), y.value, p.value, re.year, re.timezoneOffset);
            re.changed = K !== e.modelValue, o("update:modelValue", K, re);
        }
        function ct() {
            var G = [
                (0, $aD8ZA.h)("div", {
                    class: "q-time__link " + (h.value === "hour" ? "q-time__link--active" : "cursor-pointer"),
                    tabindex: a.value,
                    onClick: U.hour,
                    onKeyup: le
                }, $.value.hour),
                (0, $aD8ZA.h)("div", ":"),
                (0, $aD8ZA.h)("div", A.value === !0 ? {
                    class: "q-time__link " + (h.value === "minute" ? "q-time__link--active" : "cursor-pointer"),
                    tabindex: a.value,
                    onKeyup: Re,
                    onClick: U.minute
                } : {
                    class: "q-time__link"
                }, $.value.minute)
            ];
            e.withSeconds === !0 && G.push((0, $aD8ZA.h)("div", ":"), (0, $aD8ZA.h)("div", B.value === !0 ? {
                class: "q-time__link " + (h.value === "second" ? "q-time__link--active" : "cursor-pointer"),
                tabindex: a.value,
                onKeyup: Fe,
                onClick: U.second
            } : {
                class: "q-time__link"
            }, $.value.second));
            var re = [
                (0, $aD8ZA.h)("div", {
                    class: "q-time__header-label row items-center no-wrap",
                    dir: "ltr"
                }, G)
            ];
            return L.value === !1 && re.push((0, $aD8ZA.h)("div", {
                class: "q-time__header-ampm column items-between no-wrap"
            }, [
                (0, $aD8ZA.h)("div", {
                    class: "q-time__link " + (S.value === !0 ? "q-time__link--active" : "cursor-pointer"),
                    tabindex: a.value,
                    onClick: me,
                    onKeyup: ae
                }, "AM"),
                (0, $aD8ZA.h)("div", {
                    class: "q-time__link " + (S.value !== !0 ? "q-time__link--active" : "cursor-pointer"),
                    tabindex: a.value,
                    onClick: Pe,
                    onKeyup: ce
                }, "PM")
            ])), (0, $aD8ZA.h)("div", {
                class: "q-time__header flex flex-center no-wrap " + l.value
            }, re);
        }
        function dt() {
            var G = g.value[h.value];
            return (0, $aD8ZA.h)("div", {
                class: "q-time__content col relative-position"
            }, [
                (0, $aD8ZA.h)((0, $iMtOP.Transition), {
                    name: "q-transition--scale"
                }, function() {
                    return (0, $aD8ZA.h)("div", {
                        key: "clock" + h.value,
                        class: "q-time__container-parent absolute-full"
                    }, [
                        (0, $aD8ZA.h)("div", {
                            ref: m,
                            class: "q-time__container-child fit overflow-hidden"
                        }, [
                            (0, $aD8ZA.withDirectives)((0, $aD8ZA.h)("div", {
                                class: "q-time__clock cursor-pointer non-selectable",
                                onClick: be,
                                onMousedown: Me
                            }, [
                                (0, $aD8ZA.h)("div", {
                                    class: "q-time__clock-circle fit"
                                }, [
                                    (0, $aD8ZA.h)("div", {
                                        class: "q-time__clock-pointer" + (g.value[h.value] === null ? " hidden" : e.color !== void 0 ? " text-".concat(e.color) : ""),
                                        style: E.value
                                    }),
                                    W.value.map(function(re) {
                                        return (0, $aD8ZA.h)("div", {
                                            class: "q-time__clock-position row flex-center q-time__clock-pos-".concat(re.index) + (re.val === G ? " q-time__clock-position--active " + l.value : re.disable === !0 ? " q-time__clock-position--disable" : "")
                                        }, [
                                            (0, $aD8ZA.h)("span", re.label)
                                        ]);
                                    })
                                ])
                            ]), ie.value)
                        ])
                    ]);
                }),
                e.nowBtn === !0 ? (0, $aD8ZA.h)(Le, {
                    class: "q-time__now-button absolute",
                    icon: n.iconSet.datetime.now,
                    unelevated: !0,
                    size: "sm",
                    round: !0,
                    color: e.color,
                    textColor: e.textColor,
                    tabindex: a.value,
                    onClick: V
                }) : null
            ]);
        }
        return r.proxy.setNow = V, function() {
            var G = [
                dt()
            ], re = J(t.default);
            return re !== void 0 && G.push((0, $aD8ZA.h)("div", {
                class: "q-time__actions"
            }, re)), e.name !== void 0 && e.disable !== !0 && v(G, "push"), (0, $aD8ZA.h)("div", {
                class: P.value,
                tabindex: -1
            }, [
                ct(),
                (0, $aD8ZA.h)("div", {
                    class: "q-time__main col overflow-auto"
                }, G)
            ]);
        };
    }
});
var ep = R({
    name: "QTimeline",
    props: (0, $8typN._)((0, $8pZMQ._)({}, he), {
        color: {
            type: String,
            default: "primary"
        },
        side: {
            type: String,
            default: "right",
            validator: function(e) {
                return [
                    "left",
                    "right"
                ].includes(e);
            }
        },
        layout: {
            type: String,
            default: "dense",
            validator: function(e) {
                return [
                    "dense",
                    "comfortable",
                    "loose"
                ].includes(e);
            }
        }
    }),
    setup: function(e, param) {
        var t = param.slots;
        var o = (0, $aD8ZA.getCurrentInstance)(), r = pe(e, o.proxy.$q);
        (0, $aD8ZA.provide)(Cl, e);
        var n = (0, $aAzpa.computed)(function() {
            return "q-timeline q-timeline--".concat(e.layout, " q-timeline--").concat(e.layout, "--").concat(e.side) + (r.value === !0 ? " q-timeline--dark" : "");
        });
        return function() {
            return (0, $aD8ZA.h)("ul", {
                class: n.value
            }, J(t.default));
        };
    }
});
var tp = R({
    name: "QTimelineEntry",
    props: {
        heading: Boolean,
        tag: {
            type: String,
            default: "h3"
        },
        side: {
            type: String,
            default: "right",
            validator: function(e) {
                return [
                    "left",
                    "right"
                ].includes(e);
            }
        },
        icon: String,
        avatar: String,
        color: String,
        title: String,
        subtitle: String,
        body: String
    },
    setup: function(e, param) {
        var t = param.slots;
        var o = (0, $aD8ZA.inject)(Cl, Ye);
        if (o === Ye) return console.error("QTimelineEntry needs to be child of QTimeline"), Ye;
        var r = (0, $aAzpa.computed)(function() {
            return "q-timeline__entry q-timeline__entry--".concat(e.side) + (e.icon !== void 0 || e.avatar !== void 0 ? " q-timeline__entry--icon" : "");
        }), n = (0, $aAzpa.computed)(function() {
            return "q-timeline__dot text-".concat(e.color || o.color);
        }), i = (0, $aAzpa.computed)(function() {
            return o.layout === "comfortable" && o.side === "left";
        });
        return function() {
            var a = tn(t.default, []);
            if (e.body !== void 0 && a.unshift(e.body), e.heading === !0) {
                var c = [
                    (0, $aD8ZA.h)("div"),
                    (0, $aD8ZA.h)("div"),
                    (0, $aD8ZA.h)(e.tag, {
                        class: "q-timeline__heading-title"
                    }, a)
                ];
                return (0, $aD8ZA.h)("div", {
                    class: "q-timeline__heading"
                }, i.value === !0 ? c.reverse() : c);
            }
            var l;
            e.icon !== void 0 ? l = [
                (0, $aD8ZA.h)(we, {
                    class: "row items-center justify-center",
                    name: e.icon
                })
            ] : e.avatar !== void 0 && (l = [
                (0, $aD8ZA.h)("img", {
                    class: "q-timeline__dot-img",
                    src: e.avatar
                })
            ]);
            var s = [
                (0, $aD8ZA.h)("div", {
                    class: "q-timeline__subtitle"
                }, [
                    (0, $aD8ZA.h)("span", {}, J(t.subtitle, [
                        e.subtitle
                    ]))
                ]),
                (0, $aD8ZA.h)("div", {
                    class: n.value
                }, l),
                (0, $aD8ZA.h)("div", {
                    class: "q-timeline__content"
                }, [
                    (0, $aD8ZA.h)("h6", {
                        class: "q-timeline__title"
                    }, J(t.title, [
                        e.title
                    ]))
                ].concat(a))
            ];
            return (0, $aD8ZA.h)("li", {
                class: r.value
            }, i.value === !0 ? s.reverse() : s);
        };
    }
});
var op = R({
    name: "QToolbar",
    props: {
        inset: Boolean
    },
    setup: function(e, param) {
        var t = param.slots;
        var o = (0, $aAzpa.computed)(function() {
            return "q-toolbar row no-wrap items-center" + (e.inset === !0 ? " q-toolbar--inset" : "");
        });
        return function() {
            return (0, $aD8ZA.h)("div", {
                class: o.value,
                role: "toolbar"
            }, J(t.default));
        };
    }
});
var np = R({
    name: "QToolbarTitle",
    props: {
        shrink: Boolean
    },
    setup: function(e, param) {
        var t = param.slots;
        var o = (0, $aAzpa.computed)(function() {
            return "q-toolbar__title ellipsis" + (e.shrink === !0 ? " col-shrink" : "");
        });
        return function() {
            return (0, $aD8ZA.h)("div", {
                class: o.value
            }, J(t.default));
        };
    }
});
var Vk = [
    "none",
    "strict",
    "leaf",
    "leaf-filtered"
], ip = R({
    name: "QTree",
    props: (0, $8typN._)((0, $8pZMQ._)({}, he), {
        nodes: {
            type: Array,
            required: !0
        },
        nodeKey: {
            type: String,
            required: !0
        },
        labelKey: {
            type: String,
            default: "label"
        },
        childrenKey: {
            type: String,
            default: "children"
        },
        dense: Boolean,
        color: String,
        controlColor: String,
        textColor: String,
        selectedColor: String,
        icon: String,
        tickStrategy: {
            type: String,
            default: "none",
            validator: function(e) {
                return Vk.includes(e);
            }
        },
        ticked: Array,
        expanded: Array,
        selected: {},
        noSelectionUnset: Boolean,
        defaultExpandAll: Boolean,
        accordion: Boolean,
        filter: String,
        filterMethod: Function,
        duration: Number,
        noConnectors: Boolean,
        noTransition: Boolean,
        noNodesLabel: String,
        noResultsLabel: String
    }),
    emits: [
        "update:expanded",
        "update:ticked",
        "update:selected",
        "lazyLoad",
        "afterShow",
        "afterHide"
    ],
    setup: function(e, param) {
        var t = param.slots, o = param.emit;
        var _Fk = (0, $aD8ZA.getCurrentInstance)(), r = _Fk.proxy, n = r.$q, i = pe(e, n), a = (0, $aAzpa.ref)({}), l = (0, $aAzpa.ref)(e.ticked || []), s = (0, $aAzpa.ref)(e.expanded || []), c = {};
        (0, $aD8ZA.onBeforeUpdate)(function() {
            c = {};
        });
        var u = (0, $aAzpa.computed)(function() {
            return "q-tree q-tree--".concat(e.dense === !0 ? "dense" : "standard") + (e.noConnectors === !0 ? " q-tree--no-connectors" : "") + (i.value === !0 ? " q-tree--dark" : "") + (e.color !== void 0 ? " text-".concat(e.color) : "");
        }), v = (0, $aAzpa.computed)(function() {
            return e.selected !== void 0;
        }), f = (0, $aAzpa.computed)(function() {
            return e.icon || n.iconSet.tree.icon;
        }), d = (0, $aAzpa.computed)(function() {
            return e.controlColor || e.color;
        }), m = (0, $aAzpa.computed)(function() {
            return e.textColor !== void 0 ? " text-".concat(e.textColor) : "";
        }), y = (0, $aAzpa.computed)(function() {
            var _ = e.selectedColor || e.color;
            return _ ? " text-".concat(_) : "";
        }), p = (0, $aAzpa.computed)(function() {
            return e.filterMethod !== void 0 ? e.filterMethod : function(_, N) {
                var I = N.toLowerCase();
                return _[e.labelKey] && _[e.labelKey].toLowerCase().indexOf(I) !== -1;
            };
        }), C = (0, $aAzpa.computed)(function() {
            var _ = {}, N = function(I, oe) {
                var T = I.tickStrategy || (oe ? oe.tickStrategy : e.tickStrategy), D = I[e.nodeKey], te = I[e.childrenKey] && Array.isArray(I[e.childrenKey]) && I[e.childrenKey].length !== 0, z = I.disabled !== !0 && v.value === !0 && I.selectable !== !1, ue = I.disabled !== !0 && I.expandable !== !1, _e = T !== "none", U = T === "strict", ae = T === "leaf-filtered", ce = T === "leaf" || T === "leaf-filtered", be = I.disabled !== !0 && I.tickable !== !1;
                ce === !0 && be === !0 && oe && oe.tickable !== !0 && (be = !1);
                var Me = I.lazy;
                Me === !0 && a.value[D] !== void 0 && Array.isArray(I[e.childrenKey]) === !0 && (Me = a.value[D]);
                var le = {
                    key: D,
                    parent: oe,
                    isParent: te,
                    lazy: Me,
                    disabled: I.disabled,
                    link: I.disabled !== !0 && (z === !0 || ue === !0 && (te === !0 || Me === !0)),
                    children: [],
                    matchesFilter: e.filter ? p.value(I, e.filter) : !0,
                    selected: D === e.selected && z === !0,
                    selectable: z,
                    expanded: te === !0 ? s.value.includes(D) : !1,
                    expandable: ue,
                    noTick: I.noTick === !0 || U !== !0 && Me && Me !== "loaded",
                    tickable: be,
                    tickStrategy: T,
                    hasTicking: _e,
                    strictTicking: U,
                    leafFilteredTicking: ae,
                    leafTicking: ce,
                    ticked: U === !0 ? l.value.includes(D) : te === !0 ? !1 : l.value.includes(D)
                };
                if (_[D] = le, te === !0 && (le.children = I[e.childrenKey].map(function(Re) {
                    return N(Re, le);
                }), e.filter && (le.matchesFilter !== !0 ? le.matchesFilter = le.children.some(function(Re) {
                    return Re.matchesFilter;
                }) : le.noTick !== !0 && le.disabled !== !0 && le.tickable === !0 && ae === !0 && le.children.every(function(Re) {
                    return Re.matchesFilter !== !0 || Re.noTick === !0 || Re.tickable !== !0;
                }) === !0 && (le.tickable = !1)), le.matchesFilter === !0 && (le.noTick !== !0 && U !== !0 && le.children.every(function(Re) {
                    return Re.noTick;
                }) === !0 && (le.noTick = !0), ce))) {
                    if (le.ticked = !1, le.indeterminate = le.children.some(function(Re) {
                        return Re.indeterminate === !0;
                    }), le.tickable = le.tickable === !0 && le.children.some(function(Re) {
                        return Re.tickable;
                    }), le.indeterminate !== !0) {
                        var Re = le.children.reduce(function(Fe, De) {
                            return De.ticked === !0 ? Fe + 1 : Fe;
                        }, 0);
                        Re === le.children.length ? le.ticked = !0 : Re > 0 && (le.indeterminate = !0);
                    }
                    le.indeterminate === !0 && (le.indeterminateNextState = le.children.every(function(Re) {
                        return Re.tickable !== !0 || Re.ticked !== !0;
                    }));
                }
                return le;
            };
            return e.nodes.forEach(function(I) {
                return N(I, null);
            }), _;
        });
        (0, $aD8ZA.watch)(function() {
            return e.ticked;
        }, function(_) {
            l.value = _;
        }), (0, $aD8ZA.watch)(function() {
            return e.expanded;
        }, function(_) {
            s.value = _;
        });
        function b(_) {
            var N = [].reduce, I = function(oe, T) {
                if (oe || !T) return oe;
                if (Array.isArray(T) === !0) return N.call(Object(T), I, oe);
                if (T[e.nodeKey] === _) return T;
                if (T[e.childrenKey]) return I(null, T[e.childrenKey]);
            };
            return I(null, e.nodes);
        }
        function h() {
            return l.value.map(function(_) {
                return b(_);
            });
        }
        function g() {
            return s.value.map(function(_) {
                return b(_);
            });
        }
        function S(_) {
            return _ && C.value[_] ? C.value[_].expanded : !1;
        }
        function P() {
            e.expanded !== void 0 ? o("update:expanded", []) : s.value = [];
        }
        function $() {
            var _ = [], N = function(I) {
                I[e.childrenKey] && I[e.childrenKey].length !== 0 && I.expandable !== !1 && I.disabled !== !0 && (_.push(I[e.nodeKey]), I[e.childrenKey].forEach(N));
            };
            e.nodes.forEach(N), e.expanded !== void 0 ? o("update:expanded", _) : s.value = _;
        }
        function L(_, N) {
            var I = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : b(_), oe = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : C.value[_];
            if (oe.lazy && oe.lazy !== "loaded") {
                if (oe.lazy === "loading") return;
                a.value[_] = "loading", Array.isArray(I[e.childrenKey]) !== !0 && (I[e.childrenKey] = []), o("lazyLoad", {
                    node: I,
                    key: _,
                    done: function(T) {
                        a.value[_] = "loaded", I[e.childrenKey] = Array.isArray(T) === !0 ? T : [], (0, $aD8ZA.nextTick)(function() {
                            var D = C.value[_];
                            D && D.isParent === !0 && E(_, !0);
                        });
                    },
                    fail: function() {
                        delete a.value[_], I[e.childrenKey].length === 0 && delete I[e.childrenKey];
                    }
                });
            } else oe.isParent === !0 && oe.expandable === !0 && E(_, N);
        }
        function E(_, N) {
            var I = s.value, oe = e.expanded !== void 0;
            if (oe === !0 && (I = I.slice()), N) {
                if (e.accordion && C.value[_]) {
                    var T = [];
                    C.value[_].parent ? C.value[_].parent.children.forEach(function(D) {
                        D.key !== _ && D.expandable === !0 && T.push(D.key);
                    }) : e.nodes.forEach(function(D) {
                        var te = D[e.nodeKey];
                        te !== _ && T.push(te);
                    }), T.length !== 0 && (I = I.filter(function(D) {
                        return T.includes(D) === !1;
                    }));
                }
                I = I.concat([
                    _
                ]).filter(function(T, D, te) {
                    return te.indexOf(T) === D;
                });
            } else I = I.filter(function(T) {
                return T !== _;
            });
            oe === !0 ? o("update:expanded", I) : s.value = I;
        }
        function A(_) {
            return _ && C.value[_] ? C.value[_].ticked : !1;
        }
        function B(_, N) {
            var I = l.value, oe = e.ticked !== void 0;
            oe === !0 && (I = I.slice()), N ? I = I.concat(_).filter(function(T, D, te) {
                return te.indexOf(T) === D;
            }) : I = I.filter(function(T) {
                return _.includes(T) === !1;
            }), oe === !0 && o("update:ticked", I);
        }
        function q(_, N, I) {
            var oe = {
                tree: r,
                node: _,
                key: I,
                color: e.color,
                dark: i.value
            };
            return it(oe, "expanded", function() {
                return N.expanded;
            }, function(T) {
                T !== N.expanded && L(I, T);
            }), it(oe, "ticked", function() {
                return N.ticked;
            }, function(T) {
                T !== N.ticked && B([
                    I
                ], T);
            }), oe;
        }
        function x(_) {
            return (e.filter ? _.filter(function(N) {
                return C.value[N[e.nodeKey]].matchesFilter;
            }) : _).map(function(N) {
                return w(N);
            });
        }
        function k(_) {
            if (_.icon !== void 0) return (0, $aD8ZA.h)(we, {
                class: "q-tree__icon q-mr-sm",
                name: _.icon,
                color: _.iconColor
            });
            var N = _.img || _.avatar;
            if (N) return (0, $aD8ZA.h)("img", {
                class: "q-tree__".concat(_.img ? "img" : "avatar", " q-mr-sm"),
                src: N
            });
        }
        function j() {
            o("afterShow");
        }
        function Q() {
            o("afterHide");
        }
        function w(_) {
            var N = _[e.nodeKey], I = C.value[N], oe = _.header && t["header-".concat(_.header)] || t["default-header"], T = I.isParent === !0 ? x(_[e.childrenKey]) : [], D = T.length !== 0 || I.lazy && I.lazy !== "loaded", te = _.body && t["body-".concat(_.body)] || t["default-body"], z = oe !== void 0 || te !== void 0 ? q(_, I, N) : null;
            return te !== void 0 && (te = (0, $aD8ZA.h)("div", {
                class: "q-tree__node-body relative-position"
            }, [
                (0, $aD8ZA.h)("div", {
                    class: m.value
                }, [
                    te(z)
                ])
            ])), (0, $aD8ZA.h)("div", {
                key: N,
                class: "q-tree__node relative-position q-tree__node--".concat(D === !0 ? "parent" : "child")
            }, [
                (0, $aD8ZA.h)("div", {
                    class: "q-tree__node-header relative-position row no-wrap items-center" + (I.link === !0 ? " q-tree__node--link q-hoverable q-focusable" : "") + (I.selected === !0 ? " q-tree__node--selected" : "") + (I.disabled === !0 ? " q-tree__node--disabled" : ""),
                    tabindex: I.link === !0 ? 0 : -1,
                    ariaExpanded: T.length > 0 ? I.expanded : null,
                    role: "treeitem",
                    onClick: function(ue) {
                        W(_, I, ue);
                    },
                    onKeypress: function(ue) {
                        xo(ue) !== !0 && (ue.keyCode === 13 ? W(_, I, ue, !0) : ue.keyCode === 32 && ie(_, I, ue, !0));
                    }
                }, [
                    (0, $aD8ZA.h)("div", {
                        class: "q-focus-helper",
                        tabindex: -1,
                        ref: function(ue) {
                            c[I.key] = ue;
                        }
                    }),
                    I.lazy === "loading" ? (0, $aD8ZA.h)(xt, {
                        class: "q-tree__spinner",
                        color: d.value
                    }) : D === !0 ? (0, $aD8ZA.h)(we, {
                        class: "q-tree__arrow" + (I.expanded === !0 ? " q-tree__arrow--rotate" : ""),
                        name: f.value,
                        onClick: function(ue) {
                            ie(_, I, ue);
                        }
                    }) : null,
                    I.hasTicking === !0 && I.noTick !== !0 ? (0, $aD8ZA.h)(fn, {
                        class: "q-tree__tickbox",
                        modelValue: I.indeterminate === !0 ? null : I.ticked,
                        color: d.value,
                        dark: i.value,
                        dense: !0,
                        keepColor: !0,
                        disable: I.tickable !== !0,
                        onKeydown: Se,
                        "onUpdate:modelValue": function(ue) {
                            V(I, ue);
                        }
                    }) : null,
                    (0, $aD8ZA.h)("div", {
                        class: "q-tree__node-header-content col row no-wrap items-center" + (I.selected === !0 ? y.value : m.value)
                    }, [
                        oe ? oe(z) : [
                            k(_),
                            (0, $aD8ZA.h)("div", _[e.labelKey])
                        ]
                    ])
                ]),
                D === !0 ? e.noTransition === !0 ? I.expanded === !0 ? (0, $aD8ZA.h)("div", {
                    class: "q-tree__node-collapsible" + m.value,
                    key: "".concat(N, "__q")
                }, [
                    te,
                    (0, $aD8ZA.h)("div", {
                        class: "q-tree__children" + (I.disabled === !0 ? " q-tree__node--disabled" : ""),
                        role: "group"
                    }, T)
                ]) : null : (0, $aD8ZA.h)(sr, {
                    duration: e.duration,
                    onShow: j,
                    onHide: Q
                }, function() {
                    return (0, $aD8ZA.withDirectives)((0, $aD8ZA.h)("div", {
                        class: "q-tree__node-collapsible" + m.value,
                        key: "".concat(N, "__q")
                    }, [
                        te,
                        (0, $aD8ZA.h)("div", {
                            class: "q-tree__children" + (I.disabled === !0 ? " q-tree__node--disabled" : ""),
                            role: "group"
                        }, T)
                    ]), [
                        [
                            (0, $iMtOP.vShow),
                            I.expanded
                        ]
                    ]);
                }) : te
            ]);
        }
        function H(_) {
            var N = c[_];
            N && N.focus();
        }
        function W(_, N, I, oe) {
            oe !== !0 && N.selectable !== !1 && H(N.key), v.value && N.selectable ? e.noSelectionUnset === !1 ? o("update:selected", N.key !== e.selected ? N.key : null) : N.key !== e.selected && o("update:selected", N.key === void 0 ? null : N.key) : ie(_, N, I, oe), typeof _.handler == "function" && _.handler(_);
        }
        function ie(_, N, I, oe) {
            I !== void 0 && Se(I), oe !== !0 && N.selectable !== !1 && H(N.key), L(N.key, !N.expanded, _, N);
        }
        function V(_, N) {
            if (_.indeterminate === !0 && (N = _.indeterminateNextState), _.strictTicking) B([
                _.key
            ], N);
            else if (_.leafTicking) {
                var I = [], oe = function(T) {
                    T.isParent ? (N !== !0 && T.noTick !== !0 && T.tickable === !0 && I.push(T.key), T.leafTicking === !0 && T.children.forEach(oe)) : T.noTick !== !0 && T.tickable === !0 && (T.leafFilteredTicking !== !0 || T.matchesFilter === !0) && I.push(T.key);
                };
                oe(_), B(I, N);
            }
        }
        return e.defaultExpandAll === !0 && $(), Object.assign(r, {
            getNodeByKey: b,
            getTickedNodes: h,
            getExpandedNodes: g,
            isExpanded: S,
            collapseAll: P,
            expandAll: $,
            setExpanded: L,
            isTicked: A,
            setTicked: B
        }), function() {
            var _ = x(e.nodes);
            return (0, $aD8ZA.h)("div", {
                class: u.value,
                role: "tree"
            }, _.length === 0 ? e.filter ? e.noResultsLabel || n.lang.tree.noResults : e.noNodesLabel || n.lang.tree.noNodes : _);
        };
    }
});
function ap(e) {
    return (e * 100).toFixed(2) + "%";
}
var lp = (0, $8typN._)((0, $8pZMQ._)({}, he, Eu), {
    label: String,
    color: String,
    textColor: String,
    square: Boolean,
    flat: Boolean,
    bordered: Boolean,
    noThumbnails: Boolean,
    autoUpload: Boolean,
    hideUploadBtn: Boolean,
    disable: Boolean,
    readonly: Boolean
}), Cd = (0, $79xu7._)(Bu).concat([
    "start",
    "finish",
    "added",
    "removed"
]);
function up(e, t) {
    var _loop = function(z) {
        (0, $aAzpa.isRef)(m[z]) === !0 ? it(te, z, function() {
            return m[z].value;
        }) : te[z] = m[z];
    };
    var o = (0, $aD8ZA.getCurrentInstance)(), r = o.props, n = o.slots, i = o.emit, a = o.proxy, l = a.$q, s = pe(r, l);
    function c(z, ue, _e) {
        if (z.__status = ue, ue === "idle") {
            z.__uploaded = 0, z.__progress = 0, z.__sizeLabel = ri(z.size), z.__progressLabel = "0.00%";
            return;
        }
        if (ue === "failed") {
            a.$forceUpdate();
            return;
        }
        z.__uploaded = ue === "uploaded" ? z.size : _e, z.__progress = ue === "uploaded" ? 1 : Math.min(.9999, z.__uploaded / z.size), z.__progressLabel = ap(z.__progress), a.$forceUpdate();
    }
    var u = (0, $aAzpa.computed)(function() {
        return r.disable !== !0 && r.readonly !== !0;
    }), v = (0, $aAzpa.ref)(!1), f = (0, $aAzpa.ref)(null), d = (0, $aAzpa.ref)(null), m = {
        files: (0, $aAzpa.ref)([]),
        queuedFiles: (0, $aAzpa.ref)([]),
        uploadedFiles: (0, $aAzpa.ref)([]),
        uploadedSize: (0, $aAzpa.ref)(0),
        updateFileStatus: c,
        isAlive: function() {
            return Jt(o) === !1;
        }
    }, _Lu = Lu({
        editable: u,
        dnd: v,
        getFileInput: V,
        addFilesToQueue: _
    }), y = _Lu.pickFiles, p = _Lu.addFiles, C = _Lu.onDragover, b = _Lu.onDragleave, h = _Lu.processFiles, g = _Lu.getDndNode, S = _Lu.maxFilesNumber, P = _Lu.maxTotalSizeNumber;
    Object.assign(m, e({
        props: r,
        slots: n,
        emit: i,
        helpers: m,
        exposeApi: function(z) {
            Object.assign(m, z);
        }
    })), m.isBusy === void 0 && (m.isBusy = (0, $aAzpa.ref)(!1));
    var $ = (0, $aAzpa.ref)(0), L = (0, $aAzpa.computed)(function() {
        return $.value === 0 ? 0 : m.uploadedSize.value / $.value;
    }), E = (0, $aAzpa.computed)(function() {
        return ap(L.value);
    }), A = (0, $aAzpa.computed)(function() {
        return ri($.value);
    }), B = (0, $aAzpa.computed)(function() {
        return u.value === !0 && m.isUploading.value !== !0 && (r.multiple === !0 || m.queuedFiles.value.length === 0) && (r.maxFiles === void 0 || m.files.value.length < S.value) && (r.maxTotalSize === void 0 || $.value < P.value);
    }), q = (0, $aAzpa.computed)(function() {
        return u.value === !0 && m.isBusy.value !== !0 && m.isUploading.value !== !0 && m.queuedFiles.value.length !== 0;
    });
    (0, $aD8ZA.provide)(Ml, oe);
    var x = (0, $aAzpa.computed)(function() {
        return "q-uploader column no-wrap" + (s.value === !0 ? " q-uploader--dark q-dark" : "") + (r.bordered === !0 ? " q-uploader--bordered" : "") + (r.square === !0 ? " q-uploader--square no-border-radius" : "") + (r.flat === !0 ? " q-uploader--flat no-shadow" : "") + (r.disable === !0 ? " disabled q-uploader--disable" : "") + (v.value === !0 ? " q-uploader--dnd" : "");
    }), k = (0, $aAzpa.computed)(function() {
        return "q-uploader__header" + (r.color !== void 0 ? " bg-".concat(r.color) : "") + (r.textColor !== void 0 ? " text-".concat(r.textColor) : "");
    });
    (0, $aD8ZA.watch)(m.isUploading, function(z, ue) {
        ue === !1 && z === !0 ? i("start") : ue === !0 && z === !1 && i("finish");
    });
    function j() {
        r.disable === !1 && (m.abort(), m.uploadedSize.value = 0, $.value = 0, ie(), m.files.value = [], m.queuedFiles.value = [], m.uploadedFiles.value = []);
    }
    function Q() {
        r.disable === !1 && H([
            "uploaded"
        ], function() {
            m.uploadedFiles.value = [];
        });
    }
    function w() {
        H([
            "idle",
            "failed"
        ], function(param) {
            var z = param.size;
            $.value -= z, m.queuedFiles.value = [];
        });
    }
    function H(z, ue) {
        if (r.disable === !0) return;
        var _e = {
            files: [],
            size: 0
        }, U = m.files.value.filter(function(ae) {
            return z.indexOf(ae.__status) === -1 ? !0 : (_e.size += ae.size, _e.files.push(ae), ae.__img !== void 0 && window.URL.revokeObjectURL(ae.__img.src), !1);
        });
        _e.files.length !== 0 && (m.files.value = U, ue(_e), i("removed", _e.files));
    }
    function W(z) {
        r.disable || (z.__status === "uploaded" ? m.uploadedFiles.value = m.uploadedFiles.value.filter(function(ue) {
            return ue.__key !== z.__key;
        }) : z.__status === "uploading" ? z.__abort() : $.value -= z.size, m.files.value = m.files.value.filter(function(ue) {
            return ue.__key !== z.__key ? !0 : (ue.__img !== void 0 && window.URL.revokeObjectURL(ue.__img.src), !1);
        }), m.queuedFiles.value = m.queuedFiles.value.filter(function(ue) {
            return ue.__key !== z.__key;
        }), i("removed", [
            z
        ]));
    }
    function ie() {
        m.files.value.forEach(function(z) {
            z.__img !== void 0 && window.URL.revokeObjectURL(z.__img.src);
        });
    }
    function V() {
        return d.value || f.value.getElementsByClassName("q-uploader__input")[0];
    }
    function _(z, ue) {
        var _e = h(z, ue, m.files.value, !0), U = V();
        U != null && (U.value = ""), _e !== void 0 && (_e.forEach(function(ae) {
            if (m.updateFileStatus(ae, "idle"), $.value += ae.size, r.noThumbnails !== !0 && ae.type.toUpperCase().startsWith("IMAGE")) {
                var ce = new Image;
                ce.src = window.URL.createObjectURL(ae), ae.__img = ce;
            }
        }), m.files.value = m.files.value.concat(_e), m.queuedFiles.value = m.queuedFiles.value.concat(_e), i("added", _e), r.autoUpload === !0 && m.upload());
    }
    function N() {
        q.value === !0 && m.upload();
    }
    function I(z, ue, _e) {
        if (z === !0) {
            var U = {
                type: "a",
                key: ue,
                icon: l.iconSet.uploader[ue],
                flat: !0,
                dense: !0
            }, ae;
            return ue === "add" ? (U.onClick = y, ae = oe) : U.onClick = _e, (0, $aD8ZA.h)(Le, U, ae);
        }
    }
    function oe() {
        return (0, $aD8ZA.h)("input", {
            ref: d,
            class: "q-uploader__input overflow-hidden absolute-full",
            tabindex: -1,
            type: "file",
            title: "",
            accept: r.accept,
            multiple: r.multiple === !0 ? "multiple" : void 0,
            capture: r.capture,
            onMousedown: tt,
            onClick: y,
            onChange: _
        });
    }
    function T() {
        return n.header !== void 0 ? n.header(te) : [
            (0, $aD8ZA.h)("div", {
                class: "q-uploader__header-content column"
            }, [
                (0, $aD8ZA.h)("div", {
                    class: "flex flex-center no-wrap q-gutter-xs"
                }, [
                    I(m.queuedFiles.value.length !== 0, "removeQueue", w),
                    I(m.uploadedFiles.value.length !== 0, "removeUploaded", Q),
                    m.isUploading.value === !0 ? (0, $aD8ZA.h)(xt, {
                        class: "q-uploader__spinner"
                    }) : null,
                    (0, $aD8ZA.h)("div", {
                        class: "col column justify-center"
                    }, [
                        r.label !== void 0 ? (0, $aD8ZA.h)("div", {
                            class: "q-uploader__title"
                        }, [
                            r.label
                        ]) : null,
                        (0, $aD8ZA.h)("div", {
                            class: "q-uploader__subtitle"
                        }, [
                            A.value + " / " + E.value
                        ])
                    ]),
                    I(B.value, "add"),
                    I(r.hideUploadBtn === !1 && q.value === !0, "upload", m.upload),
                    I(m.isUploading.value, "clear", m.abort)
                ])
            ])
        ];
    }
    function D() {
        return n.list !== void 0 ? n.list(te) : m.files.value.map(function(z) {
            return (0, $aD8ZA.h)("div", {
                key: z.__key,
                class: "q-uploader__file relative-position" + (r.noThumbnails !== !0 && z.__img !== void 0 ? " q-uploader__file--img" : "") + (z.__status === "failed" ? " q-uploader__file--failed" : z.__status === "uploaded" ? " q-uploader__file--uploaded" : ""),
                style: r.noThumbnails !== !0 && z.__img !== void 0 ? {
                    backgroundImage: 'url("' + z.__img.src + '")'
                } : null
            }, [
                (0, $aD8ZA.h)("div", {
                    class: "q-uploader__file-header row flex-center no-wrap"
                }, [
                    z.__status === "failed" ? (0, $aD8ZA.h)(we, {
                        class: "q-uploader__file-status",
                        name: l.iconSet.type.negative,
                        color: "negative"
                    }) : null,
                    (0, $aD8ZA.h)("div", {
                        class: "q-uploader__file-header-content col"
                    }, [
                        (0, $aD8ZA.h)("div", {
                            class: "q-uploader__title"
                        }, [
                            z.name
                        ]),
                        (0, $aD8ZA.h)("div", {
                            class: "q-uploader__subtitle row items-center no-wrap"
                        }, [
                            z.__sizeLabel + " / " + z.__progressLabel
                        ])
                    ]),
                    z.__status === "uploading" ? (0, $aD8ZA.h)(Yi, {
                        value: z.__progress,
                        min: 0,
                        max: 1,
                        indeterminate: z.__progress === 0
                    }) : (0, $aD8ZA.h)(Le, {
                        round: !0,
                        dense: !0,
                        flat: !0,
                        icon: l.iconSet.uploader[z.__status === "uploaded" ? "done" : "clear"],
                        onClick: function() {
                            W(z);
                        }
                    })
                ])
            ]);
        });
    }
    (0, $aD8ZA.onBeforeUnmount)(function() {
        m.isUploading.value === !0 && m.abort(), m.files.value.length !== 0 && ie();
    });
    var te = {};
    for(var z in m)_loop(z);
    return Object.assign(te, {
        upload: N,
        reset: j,
        removeUploadedFiles: Q,
        removeQueuedFiles: w,
        removeFile: W,
        pickFiles: y,
        addFiles: p
    }), Sl(te, {
        canAddFiles: function() {
            return B.value;
        },
        canUpload: function() {
            return q.value;
        },
        uploadSizeLabel: function() {
            return A.value;
        },
        uploadProgressLabel: function() {
            return E.value;
        }
    }), t((0, $8typN._)((0, $8pZMQ._)({}, m), {
        upload: N,
        reset: j,
        removeUploadedFiles: Q,
        removeQueuedFiles: w,
        removeFile: W,
        pickFiles: y,
        addFiles: p,
        canAddFiles: B,
        canUpload: q,
        uploadSizeLabel: A,
        uploadProgressLabel: E
    })), function() {
        var z = [
            (0, $aD8ZA.h)("div", {
                class: k.value
            }, T()),
            (0, $aD8ZA.h)("div", {
                class: "q-uploader__list scroll"
            }, D()),
            g("uploader")
        ];
        m.isBusy.value === !0 && z.push((0, $aD8ZA.h)("div", {
            class: "q-uploader__overlay absolute-full flex flex-center"
        }, [
            (0, $aD8ZA.h)(xt)
        ]));
        var ue = {
            ref: f,
            class: x.value
        };
        return B.value === !0 && Object.assign(ue, {
            onDragover: C,
            onDragleave: b
        }), (0, $aD8ZA.h)("div", ue, z);
    };
}
var Qk = function() {
    return !0;
};
function ks(e) {
    var t = {};
    return e.forEach(function(o) {
        t[o] = Qk;
    }), t;
}
var jk = ks(Cd), wd = function(param) {
    var e = param.name, t = param.props, o = param.emits, r = param.injectPlugin;
    return R({
        name: e,
        props: (0, $8pZMQ._)({}, lp, t),
        emits: at(o) === !0 ? (0, $8pZMQ._)({}, jk, o) : (0, $79xu7._)(Cd).concat((0, $79xu7._)(o)),
        setup: function(n, param) {
            var i = param.expose;
            return up(r, i);
        }
    });
};
function jn(e) {
    return typeof e == "function" ? e : function() {
        return e;
    };
}
var Uk = "QUploader", Kk = {
    url: [
        Function,
        String
    ],
    method: {
        type: [
            Function,
            String
        ],
        default: "POST"
    },
    fieldName: {
        type: [
            Function,
            String
        ],
        default: function() {
            return function(e) {
                return e.name;
            };
        }
    },
    headers: [
        Function,
        Array
    ],
    formFields: [
        Function,
        Array
    ],
    withCredentials: [
        Function,
        Boolean
    ],
    sendRaw: [
        Function,
        Boolean
    ],
    batch: [
        Function,
        Boolean
    ],
    factory: Function
}, Wk = [
    "factoryFailed",
    "uploaded",
    "failed",
    "uploading"
];
function Yk(param) {
    var e = param.props, t = param.emit, o = param.helpers;
    var r = (0, $aAzpa.ref)([]), n = (0, $aAzpa.ref)([]), i = (0, $aAzpa.ref)(0), a = (0, $aAzpa.computed)(function() {
        return {
            url: jn(e.url),
            method: jn(e.method),
            headers: jn(e.headers),
            formFields: jn(e.formFields),
            fieldName: jn(e.fieldName),
            withCredentials: jn(e.withCredentials),
            sendRaw: jn(e.sendRaw),
            batch: jn(e.batch)
        };
    }), l = (0, $aAzpa.computed)(function() {
        return i.value > 0;
    }), s = (0, $aAzpa.computed)(function() {
        return n.value.length !== 0;
    }), c;
    function u() {
        r.value.forEach(function(m) {
            m.abort();
        }), n.value.length !== 0 && (c = !0);
    }
    function v() {
        var m = o.queuedFiles.value.slice(0);
        o.queuedFiles.value = [], a.value.batch(m) ? f(m) : m.forEach(function(y) {
            f([
                y
            ]);
        });
    }
    function f(m) {
        if (i.value++, typeof e.factory != "function") {
            d(m, {});
            return;
        }
        var y = e.factory(m);
        if (!y) t("factoryFailed", new Error("QUploader: factory() does not return properly"), m), i.value--;
        else if (typeof y.catch == "function" && typeof y.then == "function") {
            n.value.push(y);
            var p = function(C) {
                o.isAlive() === !0 && (n.value = n.value.filter(function(b) {
                    return b !== y;
                }), n.value.length === 0 && (c = !1), o.queuedFiles.value = o.queuedFiles.value.concat(m), m.forEach(function(b) {
                    o.updateFileStatus(b, "failed");
                }), t("factoryFailed", C, m), i.value--);
            };
            y.then(function(C) {
                c === !0 ? p(new Error("Aborted")) : o.isAlive() === !0 && (n.value = n.value.filter(function(b) {
                    return b !== y;
                }), d(m, C));
            }).catch(p);
        } else d(m, y || {});
    }
    function d(m, y) {
        var p = new FormData, C = new XMLHttpRequest, b = function(q, x) {
            return y[q] !== void 0 ? jn(y[q])(x) : a.value[q](x);
        }, h = b("url", m);
        if (!h) {
            console.error("q-uploader: invalid or no URL specified"), i.value--;
            return;
        }
        var g = b("formFields", m);
        g !== void 0 && g.forEach(function(q) {
            p.append(q.name, q.value);
        });
        var S = 0, P = 0, $ = 0, L = 0, E;
        C.upload.addEventListener("progress", function(q) {
            if (E === !0) return;
            var x = Math.min(L, q.loaded);
            o.uploadedSize.value += x - $, $ = x;
            var k = $ - P;
            for(var j = S; k > 0 && j < m.length; j++){
                var Q = m[j];
                if (k > Q.size) k -= Q.size, S++, P += Q.size, o.updateFileStatus(Q, "uploading", Q.size);
                else {
                    o.updateFileStatus(Q, "uploading", k);
                    return;
                }
            }
        }, !1), C.onreadystatechange = function() {
            C.readyState < 4 || (C.status && C.status < 400 ? (o.uploadedFiles.value = o.uploadedFiles.value.concat(m), m.forEach(function(q) {
                o.updateFileStatus(q, "uploaded");
            }), t("uploaded", {
                files: m,
                xhr: C
            })) : (E = !0, o.uploadedSize.value -= $, o.queuedFiles.value = o.queuedFiles.value.concat(m), m.forEach(function(q) {
                o.updateFileStatus(q, "failed");
            }), t("failed", {
                files: m,
                xhr: C
            })), i.value--, r.value = r.value.filter(function(q) {
                return q !== C;
            }));
        }, C.open(b("method", m), h), b("withCredentials", m) === !0 && (C.withCredentials = !0);
        var A = b("headers", m);
        A !== void 0 && A.forEach(function(q) {
            C.setRequestHeader(q.name, q.value);
        });
        var B = b("sendRaw", m);
        m.forEach(function(q) {
            o.updateFileStatus(q, "uploading", 0), B !== !0 && p.append(b("fieldName", q), q, q.name), q.xhr = C, q.__abort = function() {
                C.abort();
            }, L += q.size;
        }), t("uploading", {
            files: m,
            xhr: C
        }), r.value.push(C), B === !0 ? C.send(new Blob(m)) : C.send(p);
    }
    return {
        isUploading: l,
        isBusy: s,
        abort: u,
        upload: v
    };
}
var sp = {
    name: Uk,
    props: Kk,
    emits: Wk,
    injectPlugin: Yk
};
var cp = wd(sp);
var dp = R({
    name: "QUploaderAddTrigger",
    setup: function() {
        var e = (0, $aD8ZA.inject)(Ml, Ye);
        return e === Ye && console.error("QUploaderAddTrigger needs to be child of QUploader"), e;
    }
});
var mp = R({
    name: "QVideo",
    props: (0, $8typN._)((0, $8pZMQ._)({}, la), {
        src: {
            type: String,
            required: !0
        },
        title: String,
        fetchpriority: {
            type: String,
            default: "auto"
        },
        loading: {
            type: String,
            default: "eager"
        },
        referrerpolicy: {
            type: String,
            default: "strict-origin-when-cross-origin"
        }
    }),
    setup: function(e) {
        var t = ua(e), o = (0, $aAzpa.computed)(function() {
            return "q-video" + (e.ratio !== void 0 ? " q-video--responsive" : "");
        });
        return function() {
            return (0, $aD8ZA.h)("div", {
                class: o.value,
                style: t.value
            }, [
                (0, $aD8ZA.h)("iframe", {
                    src: e.src,
                    title: e.title,
                    fetchpriority: e.fetchpriority,
                    loading: e.loading,
                    referrerpolicy: e.referrerpolicy,
                    frameborder: "0",
                    allowfullscreen: !0
                })
            ]);
        };
    }
});
var Md = {};
Vd(Md, {
    ClosePopup: function() {
        return gp;
    },
    Intersection: function() {
        return Qu;
    },
    Morph: function() {
        return qp;
    },
    Mutation: function() {
        return Rp;
    },
    Ripple: function() {
        return rn;
    },
    Scroll: function() {
        return Ep;
    },
    ScrollFire: function() {
        return Ap;
    },
    TouchHold: function() {
        return Bp;
    },
    TouchPan: function() {
        return qt;
    },
    TouchRepeat: function() {
        return Fp;
    },
    TouchSwipe: function() {
        return Yl;
    }
});
function vp(e) {
    if (e === !1) return 0;
    if (e === !0 || e === void 0) return 1;
    var t = parseInt(e, 10);
    return isNaN(t) ? 0 : t;
}
var gp = Mt({
    name: "close-popup",
    beforeMount: function(e, param) {
        var t = param.value;
        var o = {
            depth: vp(t),
            handler: function(r) {
                o.depth !== 0 && setTimeout(function() {
                    var n = Nf(e);
                    n !== void 0 && Qf(n, r, o.depth);
                });
            },
            handlerKey: function(r) {
                wt(r, 13) === !0 && o.handler(r);
            }
        };
        e.__qclosepopup = o, e.addEventListener("click", o.handler), e.addEventListener("keyup", o.handlerKey);
    },
    updated: function(e, param) {
        var t = param.value, o = param.oldValue;
        t !== o && (e.__qclosepopup.depth = vp(t));
    },
    beforeUnmount: function(e) {
        var t = e.__qclosepopup;
        e.removeEventListener("click", t.handler), e.removeEventListener("keyup", t.handlerKey), delete e.__qclosepopup;
    }
});
var Zk = 0, pl;
function hp(e, t) {
    pl === void 0 && (pl = document.createElement("div"), pl.style.cssText = "position: absolute; left: 0; top: 0", document.body.appendChild(pl));
    var o = e.getBoundingClientRect(), r = pl.getBoundingClientRect(), _window_getComputedStyle = window.getComputedStyle(e), n = _window_getComputedStyle.marginLeft, i = _window_getComputedStyle.marginRight, a = _window_getComputedStyle.marginTop, l = _window_getComputedStyle.marginBottom, s = parseInt(n, 10) + parseInt(i, 10), c = parseInt(a, 10) + parseInt(l, 10);
    return {
        left: o.left - r.left,
        top: o.top - r.top,
        width: o.right - o.left,
        height: o.bottom - o.top,
        widthM: o.right - o.left + (t === !0 ? 0 : s),
        heightM: o.bottom - o.top + (t === !0 ? 0 : c),
        marginH: t === !0 ? s : 0,
        marginV: t === !0 ? c : 0
    };
}
function qs(e) {
    return {
        width: e.scrollWidth,
        height: e.scrollHeight
    };
}
var pp = [
    "Top",
    "Right",
    "Bottom",
    "Left"
], bp = [
    "borderTopLeftRadius",
    "borderTopRightRadius",
    "borderBottomRightRadius",
    "borderBottomLeftRadius"
], Jk = /-block|-inline|block-|inline-/, eq = /(-block|-inline|block-|inline-).*:/;
function yp(e, t) {
    var _loop = function(n) {
        var i = t[n];
        if (o[i] === "") {
            if (i === "cssText") {
                var a = o.length, l = "";
                for(var s = 0; s < a; s++)Jk.test(o[s]) !== !0 && (l += o[s] + ": " + o[o[s]] + "; ");
                r[i] = l;
            } else if ([
                "borderWidth",
                "borderStyle",
                "borderColor"
            ].indexOf(i) !== -1) {
                var a1 = i.replace("border", ""), l1 = "";
                for(var s1 = 0; s1 < pp.length; s1++){
                    var c = "border" + pp[s1] + a1;
                    l1 += o[c] + " ";
                }
                r[i] = l1;
            } else if (i === "borderRadius") {
                var a2 = "", l2 = "";
                for(var s2 = 0; s2 < bp.length; s2++){
                    var c1 = o[bp[s2]].split(" ");
                    a2 += c1[0] + " ", l2 += (c1[1] === void 0 ? c1[0] : c1[1]) + " ";
                }
                r[i] = a2 + "/ " + l2;
            } else r[i] = o[i];
        } else i === "cssText" ? r[i] = o[i].split(";").filter(function(a) {
            return eq.test(a) !== !0;
        }).join(";") : r[i] = o[i];
    };
    var o = window.getComputedStyle(e), r = {};
    for(var n = 0; n < t.length; n++)_loop(n);
    return r;
}
var tq = [
    "absolute",
    "fixed",
    "relative",
    "sticky"
];
function Sp(e) {
    var t = e, o = 0;
    for(; t !== null && t !== document;){
        var _window_getComputedStyle = window.getComputedStyle(t), r = _window_getComputedStyle.position, n = _window_getComputedStyle.zIndex, i = Number(n);
        i > o && (t === e || tq.includes(r) === !0) && (o = i), t = t.parentNode;
    }
    return o;
}
function oq(e) {
    return {
        from: e.from,
        to: e.to !== void 0 ? e.to : e.from
    };
}
function nq(e) {
    return typeof e == "number" ? e = {
        duration: e
    } : typeof e == "function" && (e = {
        onEnd: e
    }), (0, $8typN._)((0, $8pZMQ._)({}, e), {
        waitFor: e.waitFor === void 0 ? 0 : e.waitFor,
        duration: isNaN(e.duration) === !0 ? 300 : parseInt(e.duration, 10),
        easing: typeof e.easing == "string" && e.easing.length !== 0 ? e.easing : "ease-in-out",
        delay: isNaN(e.delay) === !0 ? 0 : parseInt(e.delay, 10),
        fill: typeof e.fill == "string" && e.fill.length !== 0 ? e.fill : "none",
        resize: e.resize === !0,
        useCSS: e.useCSS === !0 || e.usecss === !0,
        hideFromClone: e.hideFromClone === !0 || e.hidefromclone === !0,
        keepToClone: e.keepToClone === !0 || e.keeptoclone === !0,
        tween: e.tween === !0,
        tweenFromOpacity: isNaN(e.tweenFromOpacity) === !0 ? .6 : parseFloat(e.tweenFromOpacity),
        tweenToOpacity: isNaN(e.tweenToOpacity) === !0 ? .5 : parseFloat(e.tweenToOpacity)
    });
}
function xp(e) {
    var t = typeof e === "undefined" ? "undefined" : (0, $jzTO1._)(e);
    return t === "function" ? e() : t === "string" ? document.querySelector(e) : e;
}
function _p(e) {
    return e && e.ownerDocument === document && e.parentNode !== null;
}
function Ts(e) {
    var t = function() {
        return !1;
    }, o = !1, r = !0, n = oq(e), i = nq(e), a = xp(n.from);
    if (_p(a) !== !0) return t;
    typeof a.qMorphCancel == "function" && a.qMorphCancel();
    var l, s, c, u, v = a.parentNode, f = a.nextElementSibling, d = hp(a, i.resize), _qs = qs(v), m = _qs.width, y = _qs.height, _yp = yp(a, [
        "borderWidth",
        "borderStyle",
        "borderColor",
        "borderRadius",
        "backgroundColor",
        "transform",
        "position",
        "cssText"
    ]), p = _yp.borderWidth, C = _yp.borderStyle, b = _yp.borderColor, h = _yp.borderRadius, g = _yp.backgroundColor, S = _yp.transform, P = _yp.position, $ = _yp.cssText, L = a.classList.toString(), E = a.style.cssText, A = a.cloneNode(!0), B = i.tween === !0 ? a.cloneNode(!0) : void 0;
    B !== void 0 && (B.className = B.classList.toString().split(" ").filter(function(x) {
        return /^bg-/.test(x) === !1;
    }).join(" ")), i.hideFromClone === !0 && A.classList.add("q-morph--internal"), A.setAttribute("aria-hidden", "true"), A.style.transition = "none", A.style.animation = "none", A.style.pointerEvents = "none", v.insertBefore(A, f), a.qMorphCancel = function() {
        o = !0, A.remove(), B !== void 0 && B.remove(), i.hideFromClone === !0 && A.classList.remove("q-morph--internal"), a.qMorphCancel = void 0;
    };
    var q = function() {
        var x = xp(n.to);
        if (o === !0 || _p(x) !== !0) {
            typeof a.qMorphCancel == "function" && a.qMorphCancel();
            return;
        }
        a !== x && typeof x.qMorphCancel == "function" && x.qMorphCancel(), i.keepToClone !== !0 && x.classList.add("q-morph--internal"), A.classList.add("q-morph--internal");
        var _qs = qs(v), k = _qs.width, j = _qs.height, _qs1 = qs(x.parentNode), Q = _qs1.width, w = _qs1.height;
        i.hideFromClone !== !0 && A.classList.remove("q-morph--internal"), x.qMorphCancel = function() {
            o = !0, A.remove(), B !== void 0 && B.remove(), i.hideFromClone === !0 && A.classList.remove("q-morph--internal"), i.keepToClone !== !0 && x.classList.remove("q-morph--internal"), a.qMorphCancel = void 0, x.qMorphCancel = void 0;
        };
        var H = function() {
            if (o === !0) {
                typeof x.qMorphCancel == "function" && x.qMorphCancel();
                return;
            }
            i.hideFromClone !== !0 && (A.classList.add("q-morph--internal"), A.innerHTML = "", A.style.left = 0, A.style.right = "unset", A.style.top = 0, A.style.bottom = "unset", A.style.transform = "none"), i.keepToClone !== !0 && x.classList.remove("q-morph--internal");
            var W = x.parentNode, _qs = qs(W), ie = _qs.width, V = _qs.height, _ = x.cloneNode(i.keepToClone);
            _.setAttribute("aria-hidden", "true"), i.keepToClone !== !0 && (_.style.left = 0, _.style.right = "unset", _.style.top = 0, _.style.bottom = "unset", _.style.transform = "none", _.style.pointerEvents = "none"), _.classList.add("q-morph--internal");
            var N = x === a && v === W ? A : x.nextElementSibling;
            W.insertBefore(_, N);
            var _yp = yp(x, [
                "borderWidth",
                "borderStyle",
                "borderColor",
                "borderRadius",
                "backgroundColor",
                "transform",
                "position",
                "cssText"
            ]), I = _yp.borderWidth, oe = _yp.borderStyle, T = _yp.borderColor, D = _yp.borderRadius, te = _yp.backgroundColor, z = _yp.transform, ue = _yp.position, _e = _yp.cssText, U = x.classList.toString(), ae = x.style.cssText;
            x.style.cssText = _e, x.style.transform = "none", x.style.animation = "none", x.style.transition = "none", x.className = U.split(" ").filter(function(ee) {
                return /^bg-/.test(ee) === !1;
            }).join(" ");
            var ce = hp(x, i.resize), be = d.left - ce.left, Me = d.top - ce.top, le = d.width / (ce.width > 0 ? ce.width : 10), Re = d.height / (ce.height > 0 ? ce.height : 100), Fe = m - k, De = y - j, ne = ie - Q, se = V - w, Y = Math.max(d.widthM, Fe), me = Math.max(d.heightM, De), Pe = Math.max(ce.widthM, ne), Ee = Math.max(ce.heightM, se), Ae = a === x && [
                "absolute",
                "fixed"
            ].includes(ue) === !1 && [
                "absolute",
                "fixed"
            ].includes(P) === !1, nt = ue === "fixed", ct = W;
            for(; nt !== !0 && ct !== document;)nt = window.getComputedStyle(ct).position === "fixed", ct = ct.parentNode;
            if (i.hideFromClone !== !0 && (A.style.display = "block", A.style.flex = "0 0 auto", A.style.opacity = 0, A.style.minWidth = "unset", A.style.maxWidth = "unset", A.style.minHeight = "unset", A.style.maxHeight = "unset", A.classList.remove("q-morph--internal")), i.keepToClone !== !0 && (_.style.display = "block", _.style.flex = "0 0 auto", _.style.opacity = 0, _.style.minWidth = "unset", _.style.maxWidth = "unset", _.style.minHeight = "unset", _.style.maxHeight = "unset"), _.classList.remove("q-morph--internal"), typeof i.classes == "string" && (x.className += " " + i.classes), typeof i.style == "string") x.style.cssText += " " + i.style;
            else if (at(i.style) === !0) for(var ee in i.style)x.style[ee] = i.style[ee];
            var dt = Sp(A), G = Sp(x), re = nt === !0 ? document.documentElement : {
                scrollLeft: 0,
                scrollTop: 0
            };
            x.style.position = nt === !0 ? "fixed" : "absolute", x.style.left = "".concat(ce.left - re.scrollLeft, "px"), x.style.right = "unset", x.style.top = "".concat(ce.top - re.scrollTop, "px"), x.style.margin = 0, i.resize === !0 && (x.style.minWidth = "unset", x.style.maxWidth = "unset", x.style.minHeight = "unset", x.style.maxHeight = "unset", x.style.overflow = "hidden", x.style.overflowX = "hidden", x.style.overflowY = "hidden"), document.body.appendChild(x), B !== void 0 && (B.style.cssText = $, B.style.transform = "none", B.style.animation = "none", B.style.transition = "none", B.style.position = x.style.position, B.style.left = "".concat(d.left - re.scrollLeft, "px"), B.style.right = "unset", B.style.top = "".concat(d.top - re.scrollTop, "px"), B.style.margin = 0, B.style.pointerEvents = "none", i.resize === !0 && (B.style.minWidth = "unset", B.style.maxWidth = "unset", B.style.minHeight = "unset", B.style.maxHeight = "unset", B.style.overflow = "hidden", B.style.overflowX = "hidden", B.style.overflowY = "hidden"), document.body.appendChild(B));
            var K = function(ee) {
                a === x && r !== !0 ? (x.style.cssText = E, x.className = L) : (x.style.cssText = ae, x.className = U), _.parentNode === W && W.insertBefore(x, _), A.remove(), _.remove(), B !== void 0 && B.remove(), t = function() {
                    return !1;
                }, a.qMorphCancel = void 0, x.qMorphCancel = void 0, typeof i.onEnd == "function" && i.onEnd(r === !0 ? "to" : "from", ee === !0);
            };
            if (i.useCSS !== !0 && typeof x.animate == "function") {
                var ee1 = i.resize === !0 ? {
                    transform: "translate(".concat(be, "px, ").concat(Me, "px)"),
                    width: "".concat(Y, "px"),
                    height: "".concat(me, "px")
                } : {
                    transform: "translate(".concat(be, "px, ").concat(Me, "px) scale(").concat(le, ", ").concat(Re, ")")
                }, ke = i.resize === !0 ? {
                    width: "".concat(Pe, "px"),
                    height: "".concat(Ee, "px")
                } : {}, ze = i.resize === !0 ? {
                    width: "".concat(Y, "px"),
                    height: "".concat(me, "px")
                } : {}, ye = i.resize === !0 ? {
                    transform: "translate(".concat(-1 * be, "px, ").concat(-1 * Me, "px)"),
                    width: "".concat(Pe, "px"),
                    height: "".concat(Ee, "px")
                } : {
                    transform: "translate(".concat(-1 * be, "px, ").concat(-1 * Me, "px) scale(").concat(1 / le, ", ").concat(1 / Re, ")")
                }, Ge = B !== void 0 ? {
                    opacity: i.tweenToOpacity
                } : {
                    backgroundColor: g
                }, mt = B !== void 0 ? {
                    opacity: 1
                } : {
                    backgroundColor: te
                };
                u = x.animate([
                    (0, $8pZMQ._)({
                        margin: 0,
                        borderWidth: p,
                        borderStyle: C,
                        borderColor: b,
                        borderRadius: h,
                        zIndex: dt,
                        transformOrigin: "0 0"
                    }, ee1, Ge),
                    (0, $8pZMQ._)({
                        margin: 0,
                        borderWidth: I,
                        borderStyle: oe,
                        borderColor: T,
                        borderRadius: D,
                        zIndex: G,
                        transformOrigin: "0 0",
                        transform: z
                    }, ke, mt)
                ], {
                    duration: i.duration,
                    easing: i.easing,
                    fill: i.fill,
                    delay: i.delay
                }), s = B === void 0 ? void 0 : B.animate([
                    (0, $8pZMQ._)({
                        opacity: i.tweenFromOpacity,
                        margin: 0,
                        borderWidth: p,
                        borderStyle: C,
                        borderColor: b,
                        borderRadius: h,
                        zIndex: dt,
                        transformOrigin: "0 0",
                        transform: S
                    }, ze),
                    (0, $8pZMQ._)({
                        opacity: 0,
                        margin: 0,
                        borderWidth: I,
                        borderStyle: oe,
                        borderColor: T,
                        borderRadius: D,
                        zIndex: G,
                        transformOrigin: "0 0"
                    }, ye)
                ], {
                    duration: i.duration,
                    easing: i.easing,
                    fill: i.fill,
                    delay: i.delay
                }), l = i.hideFromClone === !0 || Ae === !0 ? void 0 : A.animate([
                    {
                        margin: "".concat(De < 0 ? De / 2 : 0, "px ").concat(Fe < 0 ? Fe / 2 : 0, "px"),
                        width: "".concat(Y + d.marginH, "px"),
                        height: "".concat(me + d.marginV, "px")
                    },
                    {
                        margin: 0,
                        width: 0,
                        height: 0
                    }
                ], {
                    duration: i.duration,
                    easing: i.easing,
                    fill: i.fill,
                    delay: i.delay
                }), c = i.keepToClone === !0 ? void 0 : _.animate([
                    Ae === !0 ? {
                        margin: "".concat(De < 0 ? De / 2 : 0, "px ").concat(Fe < 0 ? Fe / 2 : 0, "px"),
                        width: "".concat(Y + d.marginH, "px"),
                        height: "".concat(me + d.marginV, "px")
                    } : {
                        margin: 0,
                        width: 0,
                        height: 0
                    },
                    {
                        margin: "".concat(se < 0 ? se / 2 : 0, "px ").concat(ne < 0 ? ne / 2 : 0, "px"),
                        width: "".concat(Pe + ce.marginH, "px"),
                        height: "".concat(Ee + ce.marginV, "px")
                    }
                ], {
                    duration: i.duration,
                    easing: i.easing,
                    fill: i.fill,
                    delay: i.delay
                });
                var ht = function(ro) {
                    l !== void 0 && l.cancel(), s !== void 0 && s.cancel(), c !== void 0 && c.cancel(), u.cancel(), u.removeEventListener("finish", ht), u.removeEventListener("cancel", ht), K(ro), l = void 0, s = void 0, c = void 0, u = void 0;
                };
                a.qMorphCancel = function() {
                    a.qMorphCancel = void 0, o = !0, ht();
                }, x.qMorphCancel = function() {
                    x.qMorphCancel = void 0, o = !0, ht();
                }, u.addEventListener("finish", ht), u.addEventListener("cancel", ht), t = function(ro) {
                    return o === !0 || u === void 0 ? !1 : ro === !0 ? (ht(!0), !0) : (r = r !== !0, l !== void 0 && l.reverse(), s !== void 0 && s.reverse(), c !== void 0 && c.reverse(), u.reverse(), !0);
                };
            } else {
                var ee2 = "q-morph-anim-".concat(++Zk), ke1 = document.createElement("style"), ze1 = i.resize === !0 ? "\n            transform: translate(".concat(be, "px, ").concat(Me, "px);\n            width: ").concat(Y, "px;\n            height: ").concat(me, "px;\n          ") : "transform: translate(".concat(be, "px, ").concat(Me, "px) scale(").concat(le, ", ").concat(Re, ");"), ye1 = i.resize === !0 ? "\n            width: ".concat(Pe, "px;\n            height: ").concat(Ee, "px;\n          ") : "", Ge1 = i.resize === !0 ? "\n            width: ".concat(Y, "px;\n            height: ").concat(me, "px;\n          ") : "", mt1 = i.resize === !0 ? "\n            transform: translate(".concat(-1 * be, "px, ").concat(-1 * Me, "px);\n            width: ").concat(Pe, "px;\n            height: ").concat(Ee, "px;\n          ") : "transform: translate(".concat(-1 * be, "px, ").concat(-1 * Me, "px) scale(").concat(1 / le, ", ").concat(1 / Re, ");"), ht1 = B !== void 0 ? "opacity: ".concat(i.tweenToOpacity, ";") : "background-color: ".concat(g, ";"), ro = B !== void 0 ? "opacity: 1;" : "background-color: ".concat(te, ";"), qo = B === void 0 ? "" : "\n            @keyframes ".concat(ee2, "-from-tween {\n              0% {\n                opacity: ").concat(i.tweenFromOpacity, ";\n                margin: 0;\n                border-width: ").concat(p, ";\n                border-style: ").concat(C, ";\n                border-color: ").concat(b, ";\n                border-radius: ").concat(h, ";\n                z-index: ").concat(dt, ";\n                transform-origin: 0 0;\n                transform: ").concat(S, ";\n                ").concat(Ge1, "\n              }\n\n              100% {\n                opacity: 0;\n                margin: 0;\n                border-width: ").concat(I, ";\n                border-style: ").concat(oe, ";\n                border-color: ").concat(T, ";\n                border-radius: ").concat(D, ";\n                z-index: ").concat(G, ";\n                transform-origin: 0 0;\n                ").concat(mt1, "\n              }\n            }\n          "), kn = i.hideFromClone === !0 || Ae === !0 ? "" : "\n            @keyframes ".concat(ee2, "-from {\n              0% {\n                margin: ").concat(De < 0 ? De / 2 : 0, "px ").concat(Fe < 0 ? Fe / 2 : 0, "px;\n                width: ").concat(Y + d.marginH, "px;\n                height: ").concat(me + d.marginV, "px;\n              }\n\n              100% {\n                margin: 0;\n                width: 0;\n                height: 0;\n              }\n            }\n          "), en = Ae === !0 ? "\n            margin: ".concat(De < 0 ? De / 2 : 0, "px ").concat(Fe < 0 ? Fe / 2 : 0, "px;\n            width: ").concat(Y + d.marginH, "px;\n            height: ").concat(me + d.marginV, "px;\n          ") : "\n            margin: 0;\n            width: 0;\n            height: 0;\n          ", Z = i.keepToClone === !0 ? "" : "\n            @keyframes ".concat(ee2, "-to {\n              0% {\n                ").concat(en, "\n              }\n\n              100% {\n                margin: ").concat(se < 0 ? se / 2 : 0, "px ").concat(ne < 0 ? ne / 2 : 0, "px;\n                width: ").concat(Pe + ce.marginH, "px;\n                height: ").concat(Ee + ce.marginV, "px;\n              }\n            }\n          ");
                ke1.innerHTML = "\n          @keyframes ".concat(ee2, " {\n            0% {\n              margin: 0;\n              border-width: ").concat(p, ";\n              border-style: ").concat(C, ";\n              border-color: ").concat(b, ";\n              border-radius: ").concat(h, ";\n              background-color: ").concat(g, ";\n              z-index: ").concat(dt, ";\n              transform-origin: 0 0;\n              ").concat(ze1, "\n              ").concat(ht1, "\n            }\n\n            100% {\n              margin: 0;\n              border-width: ").concat(I, ";\n              border-style: ").concat(oe, ";\n              border-color: ").concat(T, ";\n              border-radius: ").concat(D, ";\n              background-color: ").concat(te, ";\n              z-index: ").concat(G, ";\n              transform-origin: 0 0;\n              transform: ").concat(z, ";\n              ").concat(ye1, "\n              ").concat(ro, "\n            }\n          }\n\n          ").concat(kn, "\n\n          ").concat(qo, "\n\n          ").concat(Z, "\n        "), document.head.appendChild(ke1);
                var ve = "normal";
                A.style.animation = "".concat(i.duration, "ms ").concat(i.easing, " ").concat(i.delay, "ms ").concat(ve, " ").concat(i.fill, " ").concat(ee2, "-from"), B !== void 0 && (B.style.animation = "".concat(i.duration, "ms ").concat(i.easing, " ").concat(i.delay, "ms ").concat(ve, " ").concat(i.fill, " ").concat(ee2, "-from-tween")), _.style.animation = "".concat(i.duration, "ms ").concat(i.easing, " ").concat(i.delay, "ms ").concat(ve, " ").concat(i.fill, " ").concat(ee2, "-to"), x.style.animation = "".concat(i.duration, "ms ").concat(i.easing, " ").concat(i.delay, "ms ").concat(ve, " ").concat(i.fill, " ").concat(ee2);
                var qe = function(Be) {
                    Be === Object(Be) && Be.animationName !== ee2 || (x.removeEventListener("animationend", qe), x.removeEventListener("animationcancel", qe), K(), ke1.remove());
                };
                a.qMorphCancel = function() {
                    a.qMorphCancel = void 0, o = !0, qe();
                }, x.qMorphCancel = function() {
                    x.qMorphCancel = void 0, o = !0, qe();
                }, x.addEventListener("animationend", qe), x.addEventListener("animationcancel", qe), t = function(Be) {
                    return o === !0 || !x || !A || !_ ? !1 : Be === !0 ? (qe(), !0) : (r = r !== !0, ve = ve === "normal" ? "reverse" : "normal", A.style.animationDirection = ve, B.style.animationDirection = ve, _.style.animationDirection = ve, x.style.animationDirection = ve, !0);
                };
            }
        };
        i.waitFor > 0 || i.waitFor === "transitionend" || i.waitFor === Object(i.waitFor) && typeof i.waitFor.then == "function" ? (i.waitFor > 0 ? new Promise(function(ie) {
            return setTimeout(ie, i.waitFor);
        }) : i.waitFor === "transitionend" ? new Promise(function(ie) {
            var V = function() {
                _ !== null && (clearTimeout(_), _ = null), x && (x.removeEventListener("transitionend", V), x.removeEventListener("transitioncancel", V)), ie();
            }, _ = setTimeout(V, 400);
            x.addEventListener("transitionend", V), x.addEventListener("transitioncancel", V);
        }) : i.waitFor).then(H).catch(function() {
            typeof x.qMorphCancel == "function" && x.qMorphCancel();
        }) : H();
    };
    return typeof e.onToggle == "function" && e.onToggle(), requestAnimationFrame(q), function(x) {
        return t(x);
    };
}
var Ms = {}, rq = [
    "duration",
    "delay",
    "easing",
    "fill",
    "classes",
    "style",
    "duration",
    "resize",
    "useCSS",
    "hideFromClone",
    "keepToClone",
    "tween",
    "tweenFromOpacity",
    "tweenToOpacity",
    "waitFor",
    "onEnd"
], iq = [
    "resize",
    "useCSS",
    "hideFromClone",
    "keepToClone",
    "tween"
];
function _a(e, t) {
    e.clsAction !== t && (e.clsAction = t, e.el.classList[t]("q-morph--invisible"));
}
function wp(e) {
    if (e.animating === !0 || e.queue.length < 2) return;
    var _e_queue = (0, $4f96i._)(e.queue, 2), t = _e_queue[0], o = _e_queue[1];
    e.animating = !0, t.animating = !0, o.animating = !0, _a(t, "remove"), _a(o, "remove");
    var r = Ts((0, $8typN._)((0, $8pZMQ._)({
        from: t.el,
        to: o.el,
        onToggle: function() {
            _a(t, "add"), _a(o, "remove");
        }
    }, o.opts), {
        onEnd: function(n, i) {
            o.opts.onEnd !== void 0 && o.opts.onEnd(n, i), i !== !0 && (t.animating = !1, o.animating = !1, e.animating = !1, e.cancel = void 0, e.queue.shift(), wp(e));
        }
    }));
    e.cancel = function() {
        r(!0), e.cancel = void 0;
    };
}
function kp(e, t) {
    var o = t.opts;
    iq.forEach(function(r) {
        o[r] = e[r] === !0;
    });
}
function aq(e, t) {
    var o = typeof e == "string" && e.length !== 0 ? e.split(":") : [];
    t.name = o[0], t.group = o[1], Object.assign(t.opts, {
        duration: isNaN(o[2]) === !0 ? 300 : parseFloat(o[2]),
        waitFor: o[3]
    });
}
function lq(e, t) {
    e.group !== void 0 && (t.group = e.group), e.name !== void 0 && (t.name = e.name);
    var o = t.opts;
    rq.forEach(function(r) {
        e[r] !== void 0 && (o[r] = e[r]);
    });
}
function uq(e, t) {
    if (t.name === e) {
        var o = Ms[t.group];
        o === void 0 ? (Ms[t.group] = {
            name: t.group,
            model: e,
            queue: [
                t
            ],
            animating: !1
        }, _a(t, "remove")) : o.model !== e && (o.model = e, o.queue.push(t), o.animating === !1 && o.queue.length === 2 && wp(o));
        return;
    }
    t.animating === !1 && _a(t, "add");
}
function Cp(e, t) {
    var o;
    Object(t) === t ? (o = "" + t.model, lq(t, e), kp(t, e)) : o = "" + t, o !== e.model ? (e.model = o, uq(o, e)) : e.animating === !1 && e.clsAction !== void 0 && e.el.classList[e.clsAction]("q-morph--invisible");
}
var qp = Mt({
    name: "morph",
    mounted: function(e, t) {
        var o = {
            el: e,
            animating: !1,
            opts: {}
        };
        kp(t.modifiers, o), aq(t.arg, o), Cp(o, t.value), e.__qmorph = o;
    },
    updated: function(e, t) {
        Cp(e.__qmorph, t.value);
    },
    beforeUnmount: function(e) {
        var t = e.__qmorph, o = Ms[t.group];
        o !== void 0 && o.queue.indexOf(t) !== -1 && (o.queue = o.queue.filter(function(n) {
            return n !== t;
        }), o.queue.length === 0 && (o.cancel !== void 0 && o.cancel(), delete Ms[t.group])), t.clsAction === "add" && e.classList.remove("q-morph--invisible"), delete e.__qmorph;
    }
});
var sq = {
    childList: !0,
    subtree: !0,
    attributes: !0,
    characterData: !0,
    attributeOldValue: !0,
    characterDataOldValue: !0
};
function Tp(e, t, o) {
    t.handler = o, t.observer !== void 0 && t.observer.disconnect(), t.observer = new MutationObserver(function(r) {
        typeof t.handler == "function" && (t.handler(r) === !1 || t.once === !0) && Mp(e);
    }), t.observer.observe(e, t.opts);
}
function Mp(e) {
    var t = e.__qmutation;
    t !== void 0 && (t.observer !== void 0 && t.observer.disconnect(), delete e.__qmutation);
}
var Rp = Mt({
    name: "mutation",
    mounted: function(e, _param) {
        var _param_modifiers = _param.modifiers, t = _param_modifiers.once, r = _param.value, o = (0, $lhEla._)(_param.modifiers, [
            "once"
        ]);
        var n = {
            once: t,
            opts: Object.keys(o).length === 0 ? sq : o
        };
        Tp(e, n, r), e.__qmutation = n;
    },
    updated: function(e, param) {
        var t = param.oldValue, o = param.value;
        var r = e.__qmutation;
        r !== void 0 && t !== o && Tp(e, r, o);
    },
    beforeUnmount: Mp
});
var Rs = Xe.passive;
function Pp(e, param) {
    var t = param.value, o = param.oldValue;
    if (typeof t != "function") {
        e.scrollTarget.removeEventListener("scroll", e.scroll, Rs);
        return;
    }
    e.handler = t, typeof o != "function" && (e.scrollTarget.addEventListener("scroll", e.scroll, Rs), e.scroll());
}
var Ap = Mt({
    name: "scroll-fire",
    mounted: function(e, t) {
        var o = {
            scrollTarget: At(e),
            scroll: So(function() {
                var r, n;
                o.scrollTarget === window ? (n = e.getBoundingClientRect().bottom, r = window.innerHeight) : (n = Tr(e).top + nn(e), r = Tr(o.scrollTarget).top + nn(o.scrollTarget)), n > 0 && n < r && (o.scrollTarget.removeEventListener("scroll", o.scroll, Rs), o.handler(e));
            }, 25)
        };
        Pp(o, t), e.__qscrollfire = o;
    },
    updated: function(e, t) {
        t.value !== t.oldValue && Pp(e.__qscrollfire, t);
    },
    beforeUnmount: function(e) {
        var t = e.__qscrollfire;
        t.scrollTarget.removeEventListener("scroll", t.scroll, Rs), t.scroll.cancel(), delete e.__qscrollfire;
    }
});
function $p(e, param) {
    var t = param.value, o = param.oldValue;
    if (typeof t != "function") {
        e.scrollTarget.removeEventListener("scroll", e.scroll, Xe.passive);
        return;
    }
    e.handler = t, typeof o != "function" && e.scrollTarget.addEventListener("scroll", e.scroll, Xe.passive);
}
var Ep = Mt({
    name: "scroll",
    mounted: function(e, t) {
        var o = {
            scrollTarget: At(e),
            scroll: function() {
                o.handler(fo(o.scrollTarget), er(o.scrollTarget));
            }
        };
        $p(o, t), e.__qscroll = o;
    },
    updated: function(e, t) {
        e.__qscroll !== void 0 && t.oldValue !== t.value && $p(e.__qscroll, t);
    },
    beforeUnmount: function(e) {
        var t = e.__qscroll;
        t.scrollTarget.removeEventListener("scroll", t.scroll, Xe.passive), delete e.__qscroll;
    }
});
var Bp = Mt({
    name: "touch-hold",
    beforeMount: function(e, t) {
        var o = t.modifiers;
        if (o.mouse !== !0 && Ce.has.touch !== !0) return;
        var r = {
            handler: t.value,
            noop: Qe,
            mouseStart: function(i) {
                typeof r.handler == "function" && Tn(i) === !0 && (lt(r, "temp", [
                    [
                        document,
                        "mousemove",
                        "move",
                        "passiveCapture"
                    ],
                    [
                        document,
                        "click",
                        "end",
                        "notPassiveCapture"
                    ]
                ]), r.start(i, !0));
            },
            touchStart: function(i) {
                if (i.target !== void 0 && typeof r.handler == "function") {
                    var a = i.target;
                    lt(r, "temp", [
                        [
                            a,
                            "touchmove",
                            "move",
                            "passiveCapture"
                        ],
                        [
                            a,
                            "touchcancel",
                            "end",
                            "notPassiveCapture"
                        ],
                        [
                            a,
                            "touchend",
                            "end",
                            "notPassiveCapture"
                        ]
                    ]), r.start(i);
                }
            },
            start: function(i, a) {
                r.origin = yt(i);
                var l = Date.now();
                Ce.is.mobile === !0 && (document.body.classList.add("non-selectable"), Ut(), r.styleCleanup = function(s) {
                    r.styleCleanup = void 0;
                    var c = function() {
                        document.body.classList.remove("non-selectable");
                    };
                    s === !0 ? (Ut(), setTimeout(c, 10)) : c();
                }), r.triggered = !1, r.sensitivity = a === !0 ? r.mouseSensitivity : r.touchSensitivity, r.timer = setTimeout(function() {
                    r.timer = void 0, Ut(), r.triggered = !0, r.handler({
                        evt: i,
                        touch: a !== !0,
                        mouse: a === !0,
                        position: r.origin,
                        duration: Date.now() - l
                    });
                }, r.duration);
            },
            move: function(i) {
                var _yt = yt(i), a = _yt.top, l = _yt.left;
                r.timer !== void 0 && (Math.abs(l - r.origin.left) >= r.sensitivity || Math.abs(a - r.origin.top) >= r.sensitivity) && (clearTimeout(r.timer), r.timer = void 0);
            },
            end: function(i) {
                Ct(r, "temp"), r.styleCleanup !== void 0 && r.styleCleanup(r.triggered), r.triggered === !0 ? i !== void 0 && Se(i) : r.timer !== void 0 && (clearTimeout(r.timer), r.timer = void 0);
            }
        }, n = [
            600,
            5,
            7
        ];
        var ref;
        if (typeof t.arg == "string" && t.arg.length !== 0 && t.arg.split(":").forEach(function(i, a) {
            var l = parseInt(i, 10);
            l && (n[a] = l);
        }), ref = (0, $4f96i._)(n, 3), r.duration = ref[0], r.touchSensitivity = ref[1], r.mouseSensitivity = ref[2], ref, e.__qtouchhold = r, o.mouse === !0) {
            var i = o.mouseCapture === !0 || o.mousecapture === !0 ? "Capture" : "";
            lt(r, "main", [
                [
                    e,
                    "mousedown",
                    "mouseStart",
                    "passive".concat(i)
                ]
            ]);
        }
        Ce.has.touch === !0 && lt(r, "main", [
            [
                e,
                "touchstart",
                "touchStart",
                "passive".concat(o.capture === !0 ? "Capture" : "")
            ],
            [
                e,
                "touchend",
                "noop",
                "notPassiveCapture"
            ]
        ]);
    },
    updated: function(e, t) {
        var o = e.__qtouchhold;
        o !== void 0 && t.oldValue !== t.value && (typeof t.value != "function" && o.end(), o.handler = t.value);
    },
    beforeUnmount: function(e) {
        var t = e.__qtouchhold;
        t !== void 0 && (Ct(t, "main"), Ct(t, "temp"), t.timer !== void 0 && clearTimeout(t.timer), t.styleCleanup !== void 0 && t.styleCleanup(), delete e.__qtouchhold);
    }
});
var Lp = {
    esc: 27,
    tab: 9,
    enter: 13,
    space: 32,
    up: 38,
    left: 37,
    right: 39,
    down: 40,
    delete: [
        8,
        46
    ]
}, cq = new RegExp("^([\\d+]+|".concat(Object.keys(Lp).join("|"), ")$"), "i");
function dq(e, t) {
    var _yt = yt(e), o = _yt.top, r = _yt.left;
    return Math.abs(r - t.left) >= 7 || Math.abs(o - t.top) >= 7;
}
var Fp = Mt({
    name: "touch-repeat",
    beforeMount: function(e, param) {
        var t = param.modifiers, o = param.value, r = param.arg;
        var n = Object.keys(t).reduce(function(s, c) {
            if (cq.test(c) === !0) {
                var u = isNaN(parseInt(c, 10)) ? Lp[c.toLowerCase()] : parseInt(c, 10);
                u >= 0 && s.push(u);
            }
            return s;
        }, []);
        if (t.mouse !== !0 && Ce.has.touch !== !0 && n.length === 0) return;
        var i = typeof r == "string" && r.length !== 0 ? r.split(":").map(function(s) {
            return parseInt(s, 10);
        }) : [
            0,
            600,
            300
        ], a = i.length - 1, l = {
            keyboard: n,
            handler: o,
            noop: Qe,
            mouseStart: function(s) {
                l.event === void 0 && typeof l.handler == "function" && Tn(s) === !0 && (lt(l, "temp", [
                    [
                        document,
                        "mousemove",
                        "move",
                        "passiveCapture"
                    ],
                    [
                        document,
                        "click",
                        "end",
                        "notPassiveCapture"
                    ]
                ]), l.start(s, !0));
            },
            keyboardStart: function(s) {
                if (typeof l.handler == "function" && wt(s, n) === !0) {
                    if ((i[0] === 0 || l.event !== void 0) && (Se(s), e.focus(), l.event !== void 0)) return;
                    lt(l, "temp", [
                        [
                            document,
                            "keyup",
                            "end",
                            "notPassiveCapture"
                        ],
                        [
                            document,
                            "click",
                            "end",
                            "notPassiveCapture"
                        ]
                    ]), l.start(s, !1, !0);
                }
            },
            touchStart: function(s) {
                if (s.target !== void 0 && typeof l.handler == "function") {
                    var c = s.target;
                    lt(l, "temp", [
                        [
                            c,
                            "touchmove",
                            "move",
                            "passiveCapture"
                        ],
                        [
                            c,
                            "touchcancel",
                            "end",
                            "notPassiveCapture"
                        ],
                        [
                            c,
                            "touchend",
                            "end",
                            "notPassiveCapture"
                        ]
                    ]), l.start(s);
                }
            },
            start: function(s, c, u) {
                u !== !0 && (l.origin = yt(s));
                function v(d) {
                    l.styleCleanup = void 0, document.documentElement.style.cursor = "";
                    var m = function() {
                        document.body.classList.remove("non-selectable");
                    };
                    d === !0 ? (Ut(), setTimeout(m, 10)) : m();
                }
                Ce.is.mobile === !0 && (document.body.classList.add("non-selectable"), Ut(), l.styleCleanup = v), l.event = {
                    touch: c !== !0 && u !== !0,
                    mouse: c === !0,
                    keyboard: u === !0,
                    startTime: Date.now(),
                    repeatCount: 0
                };
                var f = function() {
                    if (l.timer = void 0, l.event === void 0) return;
                    l.event.repeatCount === 0 && (l.event.evt = s, u === !0 ? l.event.keyCode = s.keyCode : l.event.position = yt(s), Ce.is.mobile !== !0 && (document.documentElement.style.cursor = "pointer", document.body.classList.add("non-selectable"), Ut(), l.styleCleanup = v)), l.event.duration = Date.now() - l.event.startTime, l.event.repeatCount += 1, l.handler(l.event);
                    var d = a < l.event.repeatCount ? a : l.event.repeatCount;
                    l.timer = setTimeout(f, i[d]);
                };
                i[0] === 0 ? f() : l.timer = setTimeout(f, i[0]);
            },
            move: function(s) {
                l.event !== void 0 && l.timer !== void 0 && dq(s, l.origin) === !0 && (clearTimeout(l.timer), l.timer = void 0);
            },
            end: function(s) {
                l.event !== void 0 && (l.styleCleanup !== void 0 && l.styleCleanup(!0), s !== void 0 && l.event.repeatCount > 0 && Se(s), Ct(l, "temp"), l.timer !== void 0 && (clearTimeout(l.timer), l.timer = void 0), l.event = void 0);
            }
        };
        if (e.__qtouchrepeat = l, t.mouse === !0) {
            var s = t.mouseCapture === !0 || t.mousecapture === !0 ? "Capture" : "";
            lt(l, "main", [
                [
                    e,
                    "mousedown",
                    "mouseStart",
                    "passive".concat(s)
                ]
            ]);
        }
        if (Ce.has.touch === !0 && lt(l, "main", [
            [
                e,
                "touchstart",
                "touchStart",
                "passive".concat(t.capture === !0 ? "Capture" : "")
            ],
            [
                e,
                "touchend",
                "noop",
                "passiveCapture"
            ]
        ]), n.length !== 0) {
            var s1 = t.keyCapture === !0 || t.keycapture === !0 ? "Capture" : "";
            lt(l, "main", [
                [
                    e,
                    "keydown",
                    "keyboardStart",
                    "notPassive".concat(s1)
                ]
            ]);
        }
    },
    updated: function(e, param) {
        var t = param.oldValue, o = param.value;
        var r = e.__qtouchrepeat;
        r !== void 0 && t !== o && (typeof o != "function" && r.end(), r.handler = o);
    },
    beforeUnmount: function(e) {
        var t = e.__qtouchrepeat;
        t !== void 0 && (t.timer !== void 0 && clearTimeout(t.timer), Ct(t, "main"), Ct(t, "temp"), t.styleCleanup !== void 0 && t.styleCleanup(), delete e.__qtouchrepeat);
    }
});
function Ps(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : document.body;
    if (typeof e != "string") throw new TypeError("Expected a string as propName");
    if (!(t instanceof Element)) throw new TypeError("Expected a DOM element");
    return getComputedStyle(t).getPropertyValue("--q-".concat(e)).trim() || null;
}
var As;
function fq() {
    return Ce.is.winphone ? "msapplication-navbutton-color" : Ce.is.safari ? "apple-mobile-web-app-status-bar-style" : "theme-color";
}
function mq(e) {
    var t = document.getElementsByTagName("META");
    for(var o in t)if (t[o].name === e) return t[o];
}
function vq(e) {
    As === void 0 && (As = fq());
    var t = mq(As), o = t === void 0;
    o && (t = document.createElement("meta"), t.setAttribute("name", As)), t.setAttribute("content", e), o && document.head.appendChild(t);
}
var gq = {
    set: Ce.is.mobile === !0 && (Ce.is.nativeMobile === !0 || Ce.is.winphone === !0 || Ce.is.safari === !0 || Ce.is.webkit === !0 || Ce.is.vivaldi === !0) ? function(e) {
        var t = e || Ps("primary");
        Ce.is.nativeMobile === !0 && window.StatusBar ? window.StatusBar.backgroundColorByHexString(t) : vq(t);
    } : Qe,
    install: function(param) {
        var e = param.$q;
        e.addressbarColor = this, e.config.addressbarColor && this.set(e.config.addressbarColor);
    }
};
var bl = {};
function hq(e) {
    Object.assign(Yt, {
        request: e,
        exit: e,
        toggle: e
    });
}
function Vp() {
    return document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement || document.msFullscreenElement || null;
}
function zp() {
    var e = Yt.activeEl = Yt.isActive === !1 ? null : Vp();
    Hf(e === null || e === document.documentElement ? document.body : e);
}
function pq() {
    Yt.isActive = Yt.isActive === !1, zp();
}
function Dp(e, t) {
    try {
        var _$o = e[t]();
        return _$o === void 0 ? Promise.resolve() : _$o;
    } catch (o) {
        return Promise.reject(o);
    }
}
var Yt = Xt({
    isActive: !1,
    activeEl: null
}, {
    isCapable: !1,
    install: function(param) {
        var e = param.$q;
        e.fullscreen = this;
    }
});
bl.request = [
    "requestFullscreen",
    "msRequestFullscreen",
    "mozRequestFullScreen",
    "webkitRequestFullscreen"
].find(function(e) {
    return document.documentElement[e] !== void 0;
}), Yt.isCapable = bl.request !== void 0, Yt.isCapable === !1 ? hq(function() {
    return Promise.reject("Not capable");
}) : (Object.assign(Yt, {
    request: function(e) {
        var t = e || document.documentElement, o = Yt.activeEl;
        return t === o ? Promise.resolve() : (o !== null && t.contains(o) === !0 ? Yt.exit() : Promise.resolve()).finally(function() {
            return Dp(t, bl.request);
        });
    },
    exit: function() {
        return Yt.isActive === !0 ? Dp(document, bl.exit) : Promise.resolve();
    },
    toggle: function(e) {
        return Yt.isActive === !0 ? Yt.exit() : Yt.request(e);
    }
}), bl.exit = [
    "exitFullscreen",
    "msExitFullscreen",
    "mozCancelFullScreen",
    "webkitExitFullscreen"
].find(function(e) {
    return document[e];
}), Yt.isActive = !!Vp(), Yt.isActive === !0 && zp(), [
    "onfullscreenchange",
    "onmsfullscreenchange",
    "onwebkitfullscreenchange"
].forEach(function(e) {
    document[e] = pq;
}));
var bq = Yt;
var Op = Xt({
    appVisible: !0
}, {
    install: function(param) {
        var _this = this;
        var e = param.$q;
        it(e, "appVisible", function() {
            return _this.appVisible;
        });
    }
});
{
    var e4, t2;
    if ((0, $jzTO1._)(document.hidden) < "u" ? (e4 = "hidden", t2 = "visibilitychange") : (0, $jzTO1._)(document.msHidden) < "u" ? (e4 = "msHidden", t2 = "msvisibilitychange") : (0, $jzTO1._)(document.webkitHidden) < "u" && (e4 = "webkitHidden", t2 = "webkitvisibilitychange"), t2 && (0, $jzTO1._)(document[e4]) < "u") {
        var o = function() {
            Op.appVisible = !document[e4];
        };
        document.addEventListener(t2, o, !1);
    }
}var yq = Op;
var Ip = R({
    name: "BottomSheetComponent",
    props: (0, $8typN._)((0, $8pZMQ._)({}, he), {
        title: String,
        message: String,
        actions: Array,
        grid: Boolean,
        cardClass: [
            String,
            Array,
            Object
        ],
        cardStyle: [
            String,
            Array,
            Object
        ]
    }),
    emits: [
        "ok",
        "hide"
    ],
    setup: function(e, param) {
        var t = param.emit;
        var _xq = (0, $aD8ZA.getCurrentInstance)(), o = _xq.proxy, r = pe(e, o.$q), n = (0, $aAzpa.ref)(null);
        function i() {
            n.value.show();
        }
        function a() {
            n.value.hide();
        }
        function l(d) {
            t("ok", d), a();
        }
        function s() {
            t("hide");
        }
        function c() {
            return e.actions.map(function(d) {
                var m = d.avatar || d.img;
                return d.label === void 0 ? (0, $aD8ZA.h)(Co, {
                    class: "col-all",
                    dark: r.value
                }) : (0, $aD8ZA.h)("div", {
                    class: [
                        "q-bottom-sheet__item q-hoverable q-focusable cursor-pointer relative-position",
                        d.class
                    ],
                    style: d.style,
                    tabindex: 0,
                    role: "listitem",
                    onClick: function() {
                        l(d);
                    },
                    onKeyup: function(y) {
                        y.keyCode === 13 && l(d);
                    }
                }, [
                    (0, $aD8ZA.h)("div", {
                        class: "q-focus-helper"
                    }),
                    d.icon ? (0, $aD8ZA.h)(we, {
                        name: d.icon,
                        color: d.color
                    }) : m ? (0, $aD8ZA.h)("img", {
                        class: d.avatar ? "q-bottom-sheet__avatar" : "",
                        src: m
                    }) : (0, $aD8ZA.h)("div", {
                        class: "q-bottom-sheet__empty-icon"
                    }),
                    (0, $aD8ZA.h)("div", d.label)
                ]);
            });
        }
        function u() {
            return e.actions.map(function(d) {
                var m = d.avatar || d.img;
                return d.label === void 0 ? (0, $aD8ZA.h)(Co, {
                    spaced: !0,
                    dark: r.value
                }) : (0, $aD8ZA.h)(hn, {
                    class: [
                        "q-bottom-sheet__item",
                        d.classes
                    ],
                    style: d.style,
                    tabindex: 0,
                    clickable: !0,
                    dark: r.value,
                    onClick: function() {
                        l(d);
                    }
                }, function() {
                    return [
                        (0, $aD8ZA.h)(ho, {
                            avatar: !0
                        }, function() {
                            return d.icon ? (0, $aD8ZA.h)(we, {
                                name: d.icon,
                                color: d.color
                            }) : m ? (0, $aD8ZA.h)("img", {
                                class: d.avatar ? "q-bottom-sheet__avatar" : "",
                                src: m
                            }) : null;
                        }),
                        (0, $aD8ZA.h)(ho, function() {
                            return d.label;
                        })
                    ];
                });
            });
        }
        function v() {
            var d = [];
            return e.title && d.push((0, $aD8ZA.h)(Ho, {
                class: "q-dialog__title"
            }, function() {
                return e.title;
            })), e.message && d.push((0, $aD8ZA.h)(Ho, {
                class: "q-dialog__message"
            }, function() {
                return e.message;
            })), d.push(e.grid === !0 ? (0, $aD8ZA.h)("div", {
                class: "row items-stretch justify-start",
                role: "list"
            }, c()) : (0, $aD8ZA.h)("div", {
                role: "list"
            }, u())), d;
        }
        function f() {
            return [
                (0, $aD8ZA.h)($i, {
                    class: [
                        "q-bottom-sheet q-bottom-sheet--".concat(e.grid === !0 ? "grid" : "list") + (r.value === !0 ? " q-bottom-sheet--dark q-dark" : ""),
                        e.cardClass
                    ],
                    style: e.cardStyle
                }, v)
            ];
        }
        return Object.assign(o, {
            show: i,
            hide: a
        }), function() {
            return (0, $aD8ZA.h)(gn, {
                ref: n,
                position: "bottom",
                onHide: s
            }, f);
        };
    }
});
function Hp(e, t) {
    for(var o in t)o !== "spinner" && Object(t[o]) === t[o] ? (e[o] = Object(e[o]) !== e[o] ? {} : (0, $8pZMQ._)({}, e[o]), Hp(e[o], t[o])) : e[o] = t[o];
}
function $s(e, t, o) {
    return function(r) {
        var n, i, a = t === !0 && r.component !== void 0;
        if (a === !0) {
            var b = r.component, h = r.componentProps;
            n = typeof b == "string" ? o.component(b) : b, i = h || {};
        } else {
            var b1 = r.class, h1 = r.style, g = (0, $lhEla._)(r, [
                "class",
                "style"
            ]);
            n = e, i = g, b1 !== void 0 && (g.cardClass = b1), h1 !== void 0 && (g.cardStyle = h1);
        }
        var l, s = !1, c = (0, $aAzpa.ref)(null), u = an(!1, "dialog"), v = function(b) {
            if (c.value !== null && c.value[b] !== void 0) {
                c.value[b]();
                return;
            }
            var h = l.$.subTree;
            if (h && h.component) {
                if (h.component.proxy && h.component.proxy[b]) {
                    h.component.proxy[b]();
                    return;
                }
                if (h.component.subTree && h.component.subTree.component && h.component.subTree.component.proxy && h.component.subTree.component.proxy[b]) {
                    h.component.subTree.component.proxy[b]();
                    return;
                }
            }
            console.error("[Quasar] Incorrectly defined Dialog component");
        }, f = [], d = [], m = {
            onOk: function(b) {
                return f.push(b), m;
            },
            onCancel: function(b) {
                return d.push(b), m;
            },
            onDismiss: function(b) {
                return f.push(b), d.push(b), m;
            },
            hide: function() {
                return v("hide"), m;
            },
            update: function(b) {
                if (l !== null) {
                    if (a === !0) Object.assign(i, b);
                    else {
                        var h = b.class, g = b.style, S = (0, $lhEla._)(b, [
                            "class",
                            "style"
                        ]);
                        h !== void 0 && (S.cardClass = h), g !== void 0 && (S.cardStyle = g), Hp(i, S);
                    }
                    l.$forceUpdate();
                }
                return m;
            }
        }, y = function(b) {
            s = !0, f.forEach(function(h) {
                h(b);
            });
        }, p = function() {
            C.unmount(u), yi(u), C = null, l = null, s !== !0 && d.forEach(function(b) {
                b();
            });
        }, C = Wn({
            name: "QGlobalDialog",
            setup: function() {
                return function() {
                    return (0, $aD8ZA.h)(n, (0, $8typN._)((0, $8pZMQ._)({}, i), {
                        ref: c,
                        onOk: y,
                        onHide: p,
                        onVnodeMounted: function() {
                            for(var _len = arguments.length, b = new Array(_len), _key = 0; _key < _len; _key++){
                                b[_key] = arguments[_key];
                            }
                            var _i;
                            typeof i.onVnodeMounted == "function" && (_i = i).onVnodeMounted.apply(_i, (0, $79xu7._)(b)), (0, $aD8ZA.nextTick)(function() {
                                return v("show");
                            });
                        }
                    }));
                };
            }
        }, o);
        return l = C.mount(u), m;
    };
}
var kq = {
    install: function(param) {
        var e = param.$q, t = param.parentApp;
        e.bottomSheet = this.create = $s(Ip, !1, t);
    }
};
function Np(e) {
    return encodeURIComponent(e);
}
function Qp(e) {
    return decodeURIComponent(e);
}
function qq(e) {
    return Np(e === Object(e) ? JSON.stringify(e) : "" + e);
}
function Tq(e) {
    if (e === "") return e;
    e.indexOf('"') === 0 && (e = e.slice(1, -1).replace(/\\"/g, '"').replace(/\\\\/g, "\\")), e = Qp(e.replace(/\+/g, " "));
    try {
        var t = JSON.parse(e);
        (t === Object(t) || Array.isArray(t) === !0) && (e = t);
    } catch (e) {}
    return e;
}
function jp(e) {
    var t = new Date;
    return t.setMilliseconds(t.getMilliseconds() + e), t.toUTCString();
}
function Mq(e) {
    var t = 0, o = e.match(/(\d+)d/), r = e.match(/(\d+)h/), n = e.match(/(\d+)m/), i = e.match(/(\d+)s/);
    return o && (t += o[1] * 864e5), r && (t += r[1] * 36e5), n && (t += n[1] * 6e4), i && (t += i[1] * 1e3), t === 0 ? e : jp(t);
}
function Up(e, t) {
    var o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r = arguments.length > 3 ? arguments[3] : void 0;
    var n, i;
    o.expires !== void 0 && (Object.prototype.toString.call(o.expires) === "[object Date]" ? n = o.expires.toUTCString() : typeof o.expires == "string" ? n = Mq(o.expires) : (i = parseFloat(o.expires), n = isNaN(i) === !1 ? jp(i * 864e5) : o.expires));
    var a = "".concat(Np(e), "=").concat(qq(t)), l = [
        a,
        n !== void 0 ? "; Expires=" + n : "",
        o.path ? "; Path=" + o.path : "",
        o.domain ? "; Domain=" + o.domain : "",
        o.sameSite ? "; SameSite=" + o.sameSite : "",
        o.httpOnly ? "; HttpOnly" : "",
        o.secure ? "; Secure" : "",
        o.other ? "; " + o.other : ""
    ].join("");
    if (r) {
        r.req.qCookies ? r.req.qCookies.push(l) : r.req.qCookies = [
            l
        ], r.res.setHeader("Set-Cookie", r.req.qCookies);
        var s = r.req.headers.cookie || "";
        if (n !== void 0 && i < 0) {
            var c = Es(e, r);
            c !== void 0 && (s = s.replace("".concat(e, "=").concat(c, "; "), "").replace("; ".concat(e, "=").concat(c), "").replace("".concat(e, "=").concat(c), ""));
        } else s = s ? "".concat(a, "; ").concat(s) : l;
        r.req.headers.cookie = s;
    } else document.cookie = l;
}
function Es(e, t) {
    var o = t ? t.req.headers : document, r = o.cookie ? o.cookie.split("; ") : [], n = r.length, i = e ? null : {}, a = 0, l, s, c;
    for(; a < n; a++)if (l = r[a].split("="), s = Qp(l.shift()), c = l.join("="), !e) i[s] = c;
    else if (e === s) {
        i = Tq(c);
        break;
    }
    return i;
}
function Rq(e, t, o) {
    Up(e, "", (0, $8pZMQ._)({
        expires: -1
    }, t), o);
}
function Pq(e, t) {
    return Es(e, t) !== null;
}
function Aq(e) {
    return {
        get: function(t) {
            return Es(t, e);
        },
        set: function(t, o, r) {
            return Up(t, o, r, e);
        },
        has: function(t) {
            return Pq(t, e);
        },
        remove: function(t, o) {
            return Rq(t, o, e);
        },
        getAll: function() {
            return Es(null, e);
        }
    };
}
var Kp = {
    install: function(param) {
        var e = param.$q, t = param.ssrContext;
        e.cookies = this;
    }
};
Object.assign(Kp, Aq());
var $q = Kp;
var Xp = R({
    name: "DialogPluginComponent",
    props: (0, $8typN._)((0, $8pZMQ._)({}, he), {
        title: String,
        message: String,
        prompt: Object,
        options: Object,
        progress: [
            Boolean,
            Object
        ],
        html: Boolean,
        ok: {
            type: [
                String,
                Object,
                Boolean
            ],
            default: !0
        },
        cancel: [
            String,
            Object,
            Boolean
        ],
        focus: {
            type: String,
            default: "ok",
            validator: function(e) {
                return [
                    "ok",
                    "cancel",
                    "none"
                ].includes(e);
            }
        },
        stackButtons: Boolean,
        color: String,
        cardClass: [
            String,
            Array,
            Object
        ],
        cardStyle: [
            String,
            Array,
            Object
        ]
    }),
    emits: [
        "ok",
        "hide"
    ],
    setup: function(e, param) {
        var t = param.emit;
        var _Bq = (0, $aD8ZA.getCurrentInstance)(), o = _Bq.proxy, r = o.$q, n = pe(e, r), i = (0, $aAzpa.ref)(null), a = (0, $aAzpa.ref)(e.prompt !== void 0 ? e.prompt.model : e.options !== void 0 ? e.options.model : void 0), l = (0, $aAzpa.computed)(function() {
            return "q-dialog-plugin" + (n.value === !0 ? " q-dialog-plugin--dark q-dark" : "") + (e.progress !== !1 ? " q-dialog-plugin--progress" : "");
        }), s = (0, $aAzpa.computed)(function() {
            return e.color || (n.value === !0 ? "amber" : "primary");
        }), c = (0, $aAzpa.computed)(function() {
            return e.progress === !1 ? null : at(e.progress) === !0 ? {
                component: e.progress.spinner || xt,
                props: {
                    color: e.progress.color || s.value
                }
            } : {
                component: xt,
                props: {
                    color: s.value
                }
            };
        }), u = (0, $aAzpa.computed)(function() {
            return e.prompt !== void 0 || e.options !== void 0;
        }), v = (0, $aAzpa.computed)(function() {
            if (u.value !== !0) return {};
            var _ref = e.prompt !== void 0 ? e.prompt : e.options, k = _ref.model, j = _ref.isValid, Q = _ref.items, w = (0, $lhEla._)(_ref, [
                "model",
                "isValid",
                "items"
            ]);
            return w;
        }), f = (0, $aAzpa.computed)(function() {
            return at(e.ok) === !0 || e.ok === !0 ? r.lang.label.ok : e.ok;
        }), d = (0, $aAzpa.computed)(function() {
            return at(e.cancel) === !0 || e.cancel === !0 ? r.lang.label.cancel : e.cancel;
        }), m = (0, $aAzpa.computed)(function() {
            return e.prompt !== void 0 ? e.prompt.isValid !== void 0 && e.prompt.isValid(a.value) !== !0 : e.options !== void 0 ? e.options.isValid !== void 0 && e.options.isValid(a.value) !== !0 : !1;
        }), y = (0, $aAzpa.computed)(function() {
            return (0, $8typN._)((0, $8pZMQ._)({
                color: s.value,
                label: f.value,
                ripple: !1,
                disable: m.value
            }, at(e.ok) === !0 ? e.ok : {
                flat: !0
            }), {
                "data-autofocus": e.focus === "ok" && u.value !== !0 || void 0,
                onClick: h
            });
        }), p = (0, $aAzpa.computed)(function() {
            return (0, $8typN._)((0, $8pZMQ._)({
                color: s.value,
                label: d.value,
                ripple: !1
            }, at(e.cancel) === !0 ? e.cancel : {
                flat: !0
            }), {
                "data-autofocus": e.focus === "cancel" && u.value !== !0 || void 0,
                onClick: g
            });
        });
        (0, $aD8ZA.watch)(function() {
            return e.prompt && e.prompt.model;
        }, P), (0, $aD8ZA.watch)(function() {
            return e.options && e.options.model;
        }, P);
        function C() {
            i.value.show();
        }
        function b() {
            i.value.hide();
        }
        function h() {
            t("ok", (0, $aAzpa.toRaw)(a.value)), b();
        }
        function g() {
            b();
        }
        function S() {
            t("hide");
        }
        function P(k) {
            a.value = k;
        }
        function $(k) {
            m.value !== !0 && e.prompt.type !== "textarea" && wt(k, 13) === !0 && h();
        }
        function L(k, j) {
            return e.html === !0 ? (0, $aD8ZA.h)(Ho, {
                class: k,
                innerHTML: j
            }) : (0, $aD8ZA.h)(Ho, {
                class: k
            }, function() {
                return j;
            });
        }
        function E() {
            return [
                (0, $aD8ZA.h)(da, (0, $8typN._)((0, $8pZMQ._)({
                    color: s.value,
                    dense: !0,
                    autofocus: !0,
                    dark: n.value
                }, v.value), {
                    modelValue: a.value,
                    "onUpdate:modelValue": P,
                    onKeyup: $
                }))
            ];
        }
        function A() {
            return [
                (0, $aD8ZA.h)(Gu, (0, $8typN._)((0, $8pZMQ._)({
                    color: s.value,
                    options: e.options.items,
                    dark: n.value
                }, v.value), {
                    modelValue: a.value,
                    "onUpdate:modelValue": P
                }))
            ];
        }
        function B() {
            var k = [];
            return e.cancel && k.push((0, $aD8ZA.h)(Le, p.value)), e.ok && k.push((0, $aD8ZA.h)(Le, y.value)), (0, $aD8ZA.h)(Wl, {
                class: e.stackButtons === !0 ? "items-end" : "",
                vertical: e.stackButtons,
                align: "right"
            }, function() {
                return k;
            });
        }
        function q() {
            var k = [];
            return e.title && k.push(L("q-dialog__title", e.title)), e.progress !== !1 && k.push((0, $aD8ZA.h)(Ho, {
                class: "q-dialog__progress"
            }, function() {
                return (0, $aD8ZA.h)(c.value.component, c.value.props);
            })), e.message && k.push(L("q-dialog__message", e.message)), e.prompt !== void 0 ? k.push((0, $aD8ZA.h)(Ho, {
                class: "scroll q-dialog-plugin__form"
            }, E)) : e.options !== void 0 && k.push((0, $aD8ZA.h)(Co, {
                dark: n.value
            }), (0, $aD8ZA.h)(Ho, {
                class: "scroll q-dialog-plugin__form"
            }, A), (0, $aD8ZA.h)(Co, {
                dark: n.value
            })), (e.ok || e.cancel) && k.push(B()), k;
        }
        function x() {
            return [
                (0, $aD8ZA.h)($i, {
                    class: [
                        l.value,
                        e.cardClass
                    ],
                    style: e.cardStyle,
                    dark: n.value
                }, q)
            ];
        }
        return Object.assign(o, {
            show: C,
            hide: b
        }), function() {
            return (0, $aD8ZA.h)(gn, {
                ref: i,
                onHide: S
            }, x);
        };
    }
});
var Lq = {
    install: function(param) {
        var e = param.$q, t = param.parentApp;
        e.dialog = this.create = $s(Xp, !0, t);
    }
};
var wa, Rd, Gp = 0, ei = null, Qt = {}, ti = {}, Zp = {
    group: "__default_quasar_group__",
    delay: 0,
    message: !1,
    html: !1,
    spinnerSize: 80,
    spinnerColor: "",
    messageColor: "",
    backgroundColor: "",
    boxClass: "",
    spinner: xt,
    customClass: ""
}, Jp = (0, $8pZMQ._)({}, Zp);
function Vq(e) {
    if (e && e.group !== void 0 && ti[e.group] !== void 0) return Object.assign(ti[e.group], e);
    var t = at(e) === !0 && e.ignoreDefaults === !0 ? (0, $8pZMQ._)({}, Zp, e) : (0, $8pZMQ._)({}, Jp, e);
    return ti[t.group] = t, t;
}
var Go = Xt({
    isActive: !1
}, {
    show: function(e) {
        Qt = Vq(e);
        var t = Qt.group;
        return Go.isActive = !0, wa !== void 0 ? (Qt.uid = Gp, Rd.$forceUpdate()) : (Qt.uid = ++Gp, ei !== null && clearTimeout(ei), ei = setTimeout(function() {
            ei = null;
            var o = an("q-loading");
            wa = Wn({
                name: "QLoading",
                setup: function() {
                    (0, $aD8ZA.onMounted)(function() {
                        Za(!0);
                    });
                    function r() {
                        Go.isActive !== !0 && wa !== void 0 && (Za(!1), wa.unmount(o), yi(o), wa = void 0, Rd = void 0);
                    }
                    function n() {
                        if (Go.isActive !== !0) return null;
                        var i = [
                            (0, $aD8ZA.h)(Qt.spinner, {
                                class: "q-loading__spinner",
                                color: Qt.spinnerColor,
                                size: Qt.spinnerSize
                            })
                        ];
                        return Qt.message && i.push((0, $aD8ZA.h)("div", {
                            class: "q-loading__message" + (Qt.messageColor ? " text-".concat(Qt.messageColor) : ""),
                            [Qt.html === !0 ? "innerHTML" : "textContent"]: Qt.message
                        })), (0, $aD8ZA.h)("div", {
                            class: "q-loading fullscreen flex flex-center z-max " + Qt.customClass.trim(),
                            key: Qt.uid
                        }, [
                            (0, $aD8ZA.h)("div", {
                                class: "q-loading__backdrop" + (Qt.backgroundColor ? " bg-".concat(Qt.backgroundColor) : "")
                            }),
                            (0, $aD8ZA.h)("div", {
                                class: "q-loading__box column items-center " + Qt.boxClass
                            }, i)
                        ]);
                    }
                    return function() {
                        return (0, $aD8ZA.h)((0, $iMtOP.Transition), {
                            name: "q-transition--fade",
                            appear: !0,
                            onAfterLeave: r
                        }, n);
                    };
                }
            }, Go.__parentApp), Rd = wa.mount(o);
        }, Qt.delay)), function(o) {
            if (o === void 0 || Object(o) !== o) {
                Go.hide(t);
                return;
            }
            Go.show((0, $8typN._)((0, $8pZMQ._)({}, o), {
                group: t
            }));
        };
    },
    hide: function(e) {
        if (Go.isActive === !0) {
            if (e === void 0) ti = {};
            else {
                if (ti[e] === void 0) return;
                {
                    delete ti[e];
                    var t = Object.keys(ti);
                    if (t.length !== 0) {
                        var o = t[t.length - 1];
                        Go.show({
                            group: o
                        });
                        return;
                    }
                }
            }
            ei !== null && (clearTimeout(ei), ei = null), Go.isActive = !1;
        }
    },
    setDefaults: function(e) {
        at(e) === !0 && Object.assign(Jp, e);
    },
    install: function(param) {
        var e = param.$q, t = param.parentApp;
        e.loading = this, Go.__parentApp = t, e.config.loading !== void 0 && this.setDefaults(e.config.loading);
    }
}), zq = Go;
var Bs = (0, $aAzpa.ref)(null), Pd = Xt({
    isActive: !1
}, {
    start: Qe,
    stop: Qe,
    increment: Qe,
    setDefaults: Qe,
    install: function(param) {
        var e = param.$q, t = param.parentApp;
        if (e.loadingBar = this, this.__installed === !0) {
            e.config.loadingBar !== void 0 && this.setDefaults(e.config.loadingBar);
            return;
        }
        var o = (0, $aAzpa.ref)(e.config.loadingBar !== void 0 ? (0, $8pZMQ._)({}, e.config.loadingBar) : {});
        function r() {
            Pd.isActive = !0;
        }
        function n() {
            Pd.isActive = !1;
        }
        var i = an("q-loading-bar");
        Wn({
            name: "LoadingBar",
            devtools: {
                hide: !0
            },
            setup: function() {
                return function() {
                    return (0, $aD8ZA.h)(Pl, (0, $8typN._)((0, $8pZMQ._)({}, o.value), {
                        onStart: r,
                        onStop: n,
                        ref: Bs
                    }));
                };
            }
        }, t).mount(i), Object.assign(this, {
            start: function(a) {
                Bs.value.start(a);
            },
            stop: function() {
                Bs.value.stop();
            },
            increment: function() {
                Bs.value.increment.apply(null, arguments);
            },
            setDefaults: function(a) {
                at(a) === !0 && Object.assign(o.value, a);
            }
        });
    }
}), Iq = Pd;
var Ls = null, Ad, Zo = [];
function Hq(e) {
    e.title && (e.title = e.titleTemplate ? e.titleTemplate(e.title) : e.title, delete e.titleTemplate), [
        [
            "meta",
            "content"
        ],
        [
            "link",
            "href"
        ]
    ].forEach(function(t) {
        var o = e[t[0]], r = t[1];
        for(var n in o){
            var i = o[n];
            i.template && (Object.keys(i).length === 1 ? delete o[n] : (i[r] = i.template(i[r] || ""), delete i.template));
        }
    });
}
function Nq(e, t) {
    if (Object.keys(e).length !== Object.keys(t).length) return !0;
    for(var o in e)if (e[o] !== t[o]) return !0;
}
function t0(e) {
    return [
        "class",
        "style"
    ].includes(e) === !1;
}
function o0(e) {
    return [
        "lang",
        "dir"
    ].includes(e) === !1;
}
function Qq(e, t) {
    var o = {}, r = {};
    return e === void 0 ? {
        add: t,
        remove: r
    } : (e.title !== t.title && (o.title = t.title), [
        "meta",
        "link",
        "script",
        "htmlAttr",
        "bodyAttr"
    ].forEach(function(n) {
        var i = e[n], a = t[n];
        if (r[n] = [], i == null) {
            o[n] = a;
            return;
        }
        o[n] = {};
        for(var l in i)a.hasOwnProperty(l) === !1 && r[n].push(l);
        for(var l1 in a)i.hasOwnProperty(l1) === !1 ? o[n][l1] = a[l1] : Nq(i[l1], a[l1]) === !0 && (r[n].push(l1), o[n][l1] = a[l1]);
    }), {
        add: o,
        remove: r
    });
}
function jq(param) {
    var e = param.add, t = param.remove;
    e.title && (document.title = e.title), Object.keys(t).length !== 0 && ([
        "meta",
        "link",
        "script"
    ].forEach(function(o) {
        t[o].forEach(function(r) {
            document.head.querySelector("".concat(o, '[data-qmeta="').concat(r, '"]')).remove();
        });
    }), t.htmlAttr.filter(o0).forEach(function(o) {
        document.documentElement.removeAttribute(o);
    }), t.bodyAttr.filter(t0).forEach(function(o) {
        document.body.removeAttribute(o);
    })), [
        "meta",
        "link",
        "script"
    ].forEach(function(o) {
        var r = e[o];
        for(var n in r){
            var i = document.createElement(o);
            for(var a in r[n])a !== "innerHTML" && i.setAttribute(a, r[n][a]);
            i.setAttribute("data-qmeta", n), o === "script" && (i.innerHTML = r[n].innerHTML || ""), document.head.appendChild(i);
        }
    }), Object.keys(e.htmlAttr).filter(o0).forEach(function(o) {
        document.documentElement.setAttribute(o, e.htmlAttr[o] || "");
    }), Object.keys(e.bodyAttr).filter(t0).forEach(function(o) {
        document.body.setAttribute(o, e.bodyAttr[o] || "");
    });
}
function Uq() {
    Ls = null;
    var e = {
        title: "",
        titleTemplate: null,
        meta: {},
        link: {},
        script: {},
        htmlAttr: {},
        bodyAttr: {}
    };
    for(var t = 0; t < Zo.length; t++){
        var _Zo_t = Zo[t], o = _Zo_t.active, r = _Zo_t.val;
        o === !0 && Ir(!0, e, r);
    }
    Hq(e), jq(Qq(Ad, e)), Ad = e;
}
function ko() {
    Ls !== null && clearTimeout(Ls), Ls = setTimeout(Uq, 50);
}
var Kq = {
    install: function(e) {
        this.__installed !== !0 && bt.value === !0 && (Ad = window.__Q_META__, document.getElementById("qmeta-init").remove());
    }
};
var Gq = 0, Fs = {}, Ds = {}, Jo = {}, r0 = {}, Zq = /^\s*$/, i0 = [], Jq = [
    void 0,
    null,
    !0,
    !1,
    ""
], $d = [
    "top-left",
    "top-right",
    "bottom-left",
    "bottom-right",
    "top",
    "bottom",
    "left",
    "right",
    "center"
], eT = [
    "top-left",
    "top-right",
    "bottom-left",
    "bottom-right"
], ka = {
    positive: {
        icon: function(e) {
            return e.iconSet.type.positive;
        },
        color: "positive"
    },
    negative: {
        icon: function(e) {
            return e.iconSet.type.negative;
        },
        color: "negative"
    },
    warning: {
        icon: function(e) {
            return e.iconSet.type.warning;
        },
        color: "warning",
        textColor: "dark"
    },
    info: {
        icon: function(e) {
            return e.iconSet.type.info;
        },
        color: "info"
    },
    ongoing: {
        group: !1,
        timeout: 0,
        spinner: !0,
        color: "grey-8"
    }
};
function a0(e, t, o) {
    if (!e) return yl("parameter required");
    var r, n = {
        textColor: "white"
    };
    if (e.ignoreDefaults !== !0 && Object.assign(n, Fs), at(e) === !1 && (n.type && Object.assign(n, ka[n.type]), e = {
        message: e
    }), Object.assign(n, ka[e.type || n.type], e), typeof n.icon == "function" && (n.icon = n.icon(t)), n.spinner ? (n.spinner === !0 && (n.spinner = xt), n.spinner = (0, $aAzpa.markRaw)(n.spinner)) : n.spinner = !1, n.meta = {
        hasMedia: !!(n.spinner !== !1 || n.icon || n.avatar),
        hasText: n0(n.message) || n0(n.caption)
    }, n.position) {
        if ($d.includes(n.position) === !1) return yl("wrong position", e);
    } else n.position = "bottom";
    if (Jq.includes(n.timeout) === !0) n.timeout = 5e3;
    else {
        var s = Number(n.timeout);
        if (isNaN(s) || s < 0) return yl("wrong timeout", e);
        n.timeout = Number.isFinite(s) ? s : 0;
    }
    n.timeout === 0 ? n.progress = !1 : n.progress === !0 && (n.meta.progressClass = "q-notification__progress" + (n.progressClass ? " ".concat(n.progressClass) : ""), n.meta.progressStyle = {
        animationDuration: "".concat(n.timeout + 1e3, "ms")
    });
    var i = (Array.isArray(e.actions) === !0 ? e.actions : []).concat(e.ignoreDefaults !== !0 && Array.isArray(Fs.actions) === !0 ? Fs.actions : []).concat(ka[e.type] !== void 0 && Array.isArray(ka[e.type].actions) === !0 ? ka[e.type].actions : []), a = n.closeBtn;
    var _i_map;
    if (a && i.push({
        label: typeof a == "string" ? a : t.lang.label.close
    }), _i_map = i.map(function(_param) {
        var s = _param.handler, c = _param.noDismiss, u = (0, $lhEla._)(_param, [
            "handler",
            "noDismiss"
        ]);
        return (0, $8typN._)((0, $8pZMQ._)({
            flat: !0
        }, u), {
            onClick: typeof s == "function" ? function() {
                s(), c !== !0 && l();
            } : function() {
                l();
            }
        });
    }), n.actions = _i_map, _i_map, n.multiLine === void 0 && (n.multiLine = n.actions.length > 1), Object.assign(n.meta, {
        class: "q-notification row items-stretch q-notification--".concat(n.multiLine === !0 ? "multi-line" : "standard") + (n.color !== void 0 ? " bg-".concat(n.color) : "") + (n.textColor !== void 0 ? " text-".concat(n.textColor) : "") + (n.classes !== void 0 ? " ".concat(n.classes) : ""),
        wrapperClass: "q-notification__wrapper col relative-position border-radius-inherit " + (n.multiLine === !0 ? "column no-wrap justify-center" : "row items-center"),
        contentClass: "q-notification__content row items-center" + (n.multiLine === !0 ? "" : " col"),
        leftClass: n.meta.hasText === !0 ? "additional" : "single",
        attrs: (0, $8pZMQ._)({
            role: "alert"
        }, n.attrs)
    }), n.group === !1 ? (n.group = void 0, n.meta.group = void 0) : ((n.group === void 0 || n.group === !0) && (n.group = [
        n.message,
        n.caption,
        n.multiline
    ].concat(n.actions.map(function(s) {
        return "".concat(s.label, "*").concat(s.icon);
    })).join("|")), n.meta.group = n.group + "|" + n.position), n.actions.length === 0 ? n.actions = void 0 : n.meta.actionsClass = "q-notification__actions row items-center " + (n.multiLine === !0 ? "justify-end" : "col-auto") + (n.meta.hasMedia === !0 ? " q-notification__actions--with-media" : ""), o !== void 0) {
        o.notif.meta.timer && (clearTimeout(o.notif.meta.timer), o.notif.meta.timer = void 0), n.meta.uid = o.notif.meta.uid;
        var s1 = Jo[n.position].value.indexOf(o.notif);
        Jo[n.position].value[s1] = n;
    } else {
        var s2 = Ds[n.meta.group];
        if (s2 === void 0) {
            if (n.meta.uid = Gq++, n.meta.badge = 1, [
                "left",
                "right",
                "center"
            ].indexOf(n.position) !== -1) Jo[n.position].value.splice(Math.floor(Jo[n.position].value.length / 2), 0, n);
            else {
                var c = n.position.indexOf("top") !== -1 ? "unshift" : "push";
                Jo[n.position].value[c](n);
            }
            n.group !== void 0 && (Ds[n.meta.group] = n);
        } else {
            if (s2.meta.timer && (clearTimeout(s2.meta.timer), s2.meta.timer = void 0), n.badgePosition !== void 0) {
                if (eT.includes(n.badgePosition) === !1) return yl("wrong badgePosition", e);
            } else n.badgePosition = "top-".concat(n.position.indexOf("left") !== -1 ? "right" : "left");
            n.meta.uid = s2.meta.uid, n.meta.badge = s2.meta.badge + 1, n.meta.badgeClass = "q-notification__badge q-notification__badge--".concat(n.badgePosition) + (n.badgeColor !== void 0 ? " bg-".concat(n.badgeColor) : "") + (n.badgeTextColor !== void 0 ? " text-".concat(n.badgeTextColor) : "") + (n.badgeClass ? " ".concat(n.badgeClass) : "");
            var c1 = Jo[n.position].value.indexOf(s2);
            Jo[n.position].value[c1] = Ds[n.meta.group] = n;
        }
    }
    var l = function() {
        tT(n), r = void 0;
    };
    if (n.timeout > 0 && (n.meta.timer = setTimeout(function() {
        n.meta.timer = void 0, l();
    }, n.timeout + 1e3)), n.group !== void 0) return function(s) {
        s !== void 0 ? yl("trying to update a grouped one which is forbidden", e) : l();
    };
    if (r = {
        dismiss: l,
        config: e,
        notif: n
    }, o !== void 0) {
        Object.assign(o, r);
        return;
    }
    return function(s) {
        if (r !== void 0) {
            if (s === void 0) r.dismiss();
            else {
                var c = Object.assign({}, r.config, s, {
                    group: !1,
                    position: n.position
                });
                a0(c, t, r);
            }
        }
    };
}
function tT(e) {
    e.meta.timer && (clearTimeout(e.meta.timer), e.meta.timer = void 0);
    var t = Jo[e.position].value.indexOf(e);
    if (t !== -1) {
        e.group !== void 0 && delete Ds[e.meta.group];
        var o = i0["" + e.meta.uid];
        if (o) {
            var _getComputedStyle = getComputedStyle(o), r = _getComputedStyle.width, n = _getComputedStyle.height;
            o.style.left = "".concat(o.offsetLeft, "px"), o.style.width = r, o.style.height = n;
        }
        Jo[e.position].value.splice(t, 1), typeof e.onDismiss == "function" && e.onDismiss();
    }
}
function n0(e) {
    return e != null && Zq.test(e) !== !0;
}
function yl(e, t) {
    return console.error("Notify: ".concat(e), t), !1;
}
function oT() {
    return R({
        name: "QNotifications",
        devtools: {
            hide: !0
        },
        setup: function() {
            return function() {
                return (0, $aD8ZA.h)("div", {
                    class: "q-notifications"
                }, $d.map(function(e) {
                    return (0, $aD8ZA.h)((0, $iMtOP.TransitionGroup), {
                        key: e,
                        class: r0[e],
                        tag: "div",
                        name: "q-notification--".concat(e)
                    }, function() {
                        return Jo[e].value.map(function(t) {
                            var o = t.meta, r = [];
                            if (o.hasMedia === !0 && (t.spinner !== !1 ? r.push((0, $aD8ZA.h)(t.spinner, {
                                class: "q-notification__spinner q-notification__spinner--" + o.leftClass,
                                color: t.spinnerColor,
                                size: t.spinnerSize
                            })) : t.icon ? r.push((0, $aD8ZA.h)(we, {
                                class: "q-notification__icon q-notification__icon--" + o.leftClass,
                                name: t.icon,
                                color: t.iconColor,
                                size: t.iconSize,
                                role: "img"
                            })) : t.avatar && r.push((0, $aD8ZA.h)($l, {
                                class: "q-notification__avatar q-notification__avatar--" + o.leftClass
                            }, function() {
                                return (0, $aD8ZA.h)("img", {
                                    src: t.avatar,
                                    "aria-hidden": "true"
                                });
                            }))), o.hasText === !0) {
                                var i, a = {
                                    class: "q-notification__message col"
                                };
                                if (t.html === !0) a.innerHTML = t.caption ? "<div>".concat(t.message, '</div><div class="q-notification__caption">').concat(t.caption, "</div>") : t.message;
                                else {
                                    var l = [
                                        t.message
                                    ];
                                    i = t.caption ? [
                                        (0, $aD8ZA.h)("div", l),
                                        (0, $aD8ZA.h)("div", {
                                            class: "q-notification__caption"
                                        }, [
                                            t.caption
                                        ])
                                    ] : l;
                                }
                                r.push((0, $aD8ZA.h)("div", a, i));
                            }
                            var n = [
                                (0, $aD8ZA.h)("div", {
                                    class: o.contentClass
                                }, r)
                            ];
                            return t.progress === !0 && n.push((0, $aD8ZA.h)("div", {
                                key: "".concat(o.uid, "|p|").concat(o.badge),
                                class: o.progressClass,
                                style: o.progressStyle
                            })), t.actions !== void 0 && n.push((0, $aD8ZA.h)("div", {
                                class: o.actionsClass
                            }, t.actions.map(function(i) {
                                return (0, $aD8ZA.h)(Le, i);
                            }))), o.badge > 1 && n.push((0, $aD8ZA.h)("div", {
                                key: "".concat(o.uid, "|").concat(o.badge),
                                class: t.meta.badgeClass,
                                style: t.badgeStyle
                            }, [
                                o.badge
                            ])), (0, $aD8ZA.h)("div", (0, $8pZMQ._)({
                                ref: function(i) {
                                    i0["" + o.uid] = i;
                                },
                                key: o.uid,
                                class: o.class
                            }, o.attrs), [
                                (0, $aD8ZA.h)("div", {
                                    class: o.wrapperClass
                                }, n)
                            ]);
                        });
                    });
                }));
            };
        }
    });
}
var nT = {
    setDefaults: function(e) {
        at(e) === !0 && Object.assign(Fs, e);
    },
    registerType: function(e, t) {
        at(t) === !0 && (ka[e] = t);
    },
    install: function(param) {
        var e = param.$q, t = param.parentApp;
        if (e.notify = this.create = function(o) {
            return a0(o, e);
        }, e.notify.setDefaults = this.setDefaults, e.notify.registerType = this.registerType, e.config.notify !== void 0 && this.setDefaults(e.config.notify), this.__installed !== !0) {
            $d.forEach(function(r) {
                Jo[r] = (0, $aAzpa.ref)([]);
                var n = [
                    "left",
                    "center",
                    "right"
                ].includes(r) === !0 ? "center" : r.indexOf("top") !== -1 ? "top" : "bottom", i = r.indexOf("left") !== -1 ? "start" : r.indexOf("right") !== -1 ? "end" : "center", a = [
                    "left",
                    "right"
                ].includes(r) ? "items-".concat(r === "left" ? "start" : "end", " justify-center") : r === "center" ? "flex-center" : "items-".concat(i);
                r0[r] = "q-notifications__list q-notifications__list--".concat(n, " fixed column no-wrap ").concat(a);
            });
            var o = an("q-notify");
            Wn(oT(), t).mount(o);
        }
    }
};
function rT(e) {
    return Pn(e) === !0 ? "__q_date|" + e.getTime() : Js(e) === !0 ? "__q_expr|" + e.source : typeof e == "number" ? "__q_numb|" + e : typeof e == "boolean" ? "__q_bool|" + (e ? "1" : "0") : typeof e == "string" ? "__q_strn|" + e : typeof e == "function" ? "__q_strn|" + e.toString() : e === Object(e) ? "__q_objt|" + JSON.stringify(e) : e;
}
function iT(e) {
    if (e.length < 9) return e;
    var o = e.substring(0, 8), r = e.substring(9);
    switch(o){
        case "__q_date":
            var n = Number(r);
            return new Date(Number.isNaN(n) === !0 ? r : n);
        case "__q_expr":
            return new RegExp(r);
        case "__q_numb":
            return Number(r);
        case "__q_bool":
            return r === "1";
        case "__q_strn":
            return "" + r;
        case "__q_objt":
            return JSON.parse(r);
        default:
            return e;
    }
}
function Vs() {
    var e = function() {
        return null;
    };
    return {
        has: function() {
            return !1;
        },
        hasItem: function() {
            return !1;
        },
        getLength: function() {
            return 0;
        },
        getItem: e,
        getIndex: e,
        getKey: e,
        getAll: function() {},
        getAllKeys: function() {
            return [];
        },
        set: Qe,
        setItem: Qe,
        remove: Qe,
        removeItem: Qe,
        clear: Qe,
        isEmpty: function() {
            return !0;
        }
    };
}
function zs(e) {
    var t = window[e + "Storage"], o = function(a) {
        var l = t.getItem(a);
        return l ? iT(l) : null;
    }, r = function(a) {
        return t.getItem(a) !== null;
    }, n = function(a, l) {
        t.setItem(a, rT(l));
    }, i = function(a) {
        t.removeItem(a);
    };
    return {
        has: r,
        hasItem: r,
        getLength: function() {
            return t.length;
        },
        getItem: o,
        getIndex: function(a) {
            return a < t.length ? o(t.key(a)) : null;
        },
        getKey: function(a) {
            return a < t.length ? t.key(a) : null;
        },
        getAll: function() {
            var a, l = {}, s = t.length;
            for(var c = 0; c < s; c++)a = t.key(c), l[a] = o(a);
            return l;
        },
        getAllKeys: function() {
            var a = [], l = t.length;
            for(var s = 0; s < l; s++)a.push(t.key(s));
            return a;
        },
        set: n,
        setItem: n,
        remove: i,
        removeItem: i,
        clear: function() {
            t.clear();
        },
        isEmpty: function() {
            return t.length === 0;
        }
    };
}
var l0 = Ce.has.webStorage === !1 ? Vs() : zs("local"), u0 = {
    install: function(param) {
        var e = param.$q;
        e.localStorage = l0;
    }
};
Object.assign(u0, l0);
var aT = u0;
var s0 = Ce.has.webStorage === !1 ? Vs() : zs("session"), c0 = {
    install: function(param) {
        var e = param.$q;
        e.sessionStorage = s0;
    }
};
Object.assign(c0, s0);
var lT = c0;
function Os() {
    var _sT = (0, $aD8ZA.getCurrentInstance)(), e = _sT.emit, t = _sT.proxy, o = (0, $aAzpa.ref)(null);
    function r() {
        o.value.show();
    }
    function n() {
        o.value.hide();
    }
    function i(l) {
        e("ok", l), n();
    }
    function a() {
        e("hide");
    }
    return Object.assign(t, {
        show: r,
        hide: n
    }), {
        dialogRef: o,
        onDialogHide: a,
        onDialogOK: i,
        onDialogCancel: n
    };
}
var d0 = [
    "ok",
    "hide"
];
Os.emits = d0;
Os.emitsObject = ks(d0);
function gT(e) {
    {
        var t = {
            active: !0
        };
        if (typeof e == "function") {
            var o = (0, $aAzpa.computed)(e);
            t.val = o.value, (0, $aD8ZA.watch)(o, function(r) {
                t.val = r, t.active === !0 && ko();
            });
        } else t.val = e;
        Zo.push(t), ko(), (0, $aD8ZA.onActivated)(function() {
            t.active = !0, ko();
        }), (0, $aD8ZA.onDeactivated)(function() {
            t.active = !1, ko();
        }), (0, $aD8ZA.onUnmounted)(function() {
            Zo.splice(Zo.indexOf(t), 1), ko();
        });
    }
}
function f0() {
    return (0, $aD8ZA.inject)(_l);
}
function ST() {
    var e = null, t = (0, $aD8ZA.getCurrentInstance)();
    function o() {
        e !== null && (clearInterval(e), e = null);
    }
    return (0, $aD8ZA.onDeactivated)(o), (0, $aD8ZA.onBeforeUnmount)(o), {
        removeInterval: o,
        registerInterval: function(r, n) {
            o(e), Jt(t) === !1 && (e = setInterval(r, n));
        }
    };
}
function xT(e) {
    var t = document.createElement("textarea");
    t.value = e, t.contentEditable = "true", t.style.position = "fixed";
    var o = function() {};
    wi(o), document.body.appendChild(t), t.focus(), t.select();
    var r = document.execCommand("copy");
    return t.remove(), Er(o), r;
}
function _T(e) {
    return navigator.clipboard !== void 0 ? navigator.clipboard.writeText(e) : new Promise(function(t, o) {
        var r = xT(e);
        r ? t(!0) : o(r);
    });
}
var CT = function(e) {
    var t = {
        activated: function() {
            this.__qMeta.active = !0, ko();
        },
        deactivated: function() {
            this.__qMeta.active = !1, ko();
        },
        unmounted: function() {
            Zo.splice(Zo.indexOf(this.__qMeta), 1), ko(), this.__qMeta = void 0;
        }
    };
    return typeof e == "function" ? Object.assign(t, {
        computed: {
            __qMetaOptions: function() {
                return e.call(this) || {};
            }
        },
        watch: {
            __qMetaOptions: function(o) {
                this.__qMeta.val = o, this.__qMeta.active === !0 && ko();
            }
        },
        created: function() {
            this.__qMeta = {
                active: !0,
                val: this.__qMetaOptions
            }, Zo.push(this.__qMeta), ko();
        }
    }) : t.created = function CT() {
        this.__qMeta = {
            active: !0,
            val: e
        }, Zo.push(this.__qMeta), ko();
    }, t;
};
var Is = /*#__PURE__*/ function() {
    "use strict";
    function Is() {
        (0, $luoZD._)(this, Is);
        this.__stack = {};
    }
    (0, $fYUO3._)(Is, [
        {
            key: "on",
            value: function on(t, o, r) {
                return (this.__stack[t] || (this.__stack[t] = [])).push({
                    fn: o,
                    ctx: r
                }), this;
            }
        },
        {
            key: "once",
            value: function once(t, o, r) {
                var _this = this;
                var n = function() {
                    for(var _len = arguments.length, i = new Array(_len), _key = 0; _key < _len; _key++){
                        i[_key] = arguments[_key];
                    }
                    _this.off(t, n), o.apply(r, i);
                };
                return n.__callback = o, this.on(t, n, r);
            }
        },
        {
            key: "emit",
            value: function emit(t) {
                var o = this.__stack[t];
                if (o !== void 0) {
                    var r = [].slice.call(arguments, 1);
                    o.forEach(function(n) {
                        n.fn.apply(n.ctx, r);
                    });
                }
                return this;
            }
        },
        {
            key: "off",
            value: function off(t, o) {
                var r = this.__stack[t];
                if (r === void 0) return this;
                if (o === void 0) return delete this.__stack[t], this;
                var n = r.filter(function(i) {
                    return i.fn !== o && i.fn.__callback !== o;
                });
                return n.length !== 0 ? this.__stack[t] = n : delete this.__stack[t], this;
            }
        }
    ]);
    return Is;
}();
function m0(e) {
    setTimeout(function() {
        window.URL.revokeObjectURL(e.href);
    }, 1e4), e.remove();
}
function wT(e, t) {
    var o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var _ref = typeof o == "string" ? {
        mimeType: o
    } : o, r = _ref.mimeType, n = _ref.byteOrderMark, i = _ref.encoding, a = i !== void 0 ? new TextEncoder(i).encode([
        t
    ]) : t, l = n !== void 0 ? [
        n,
        a
    ] : [
        a
    ], s = new Blob(l, {
        type: r || "application/octet-stream"
    }), c = document.createElement("a");
    c.href = window.URL.createObjectURL(s), c.setAttribute("download", e), (0, $jzTO1._)(c.download) > "u" && c.setAttribute("target", "_blank"), c.classList.add("hidden"), c.style.position = "fixed", document.body.appendChild(c);
    try {
        return c.click(), m0(c), !0;
    } catch (u) {
        return m0(c), u;
    }
}
function kT(e) {
    var t = Object.assign({
        noopener: !0
    }, e), o = [];
    for(var r in t){
        var n = t[r];
        n === !0 ? o.push(r) : (Mo(n) || typeof n == "string" && n !== "") && o.push(r + "=" + n);
    }
    return o.join(",");
}
function v0(e, t, o) {
    var r = window.open;
    if (qn.is.cordova === !0) {
        if (cordova !== void 0 && cordova.InAppBrowser !== void 0 && cordova.InAppBrowser.open !== void 0) r = cordova.InAppBrowser.open;
        else if (navigator !== void 0 && navigator.app !== void 0) return navigator.app.loadUrl(e, {
            openExternal: !0
        });
    }
    var n = r(e, "_blank", kT(o));
    if (n) return qn.is.desktop && n.focus(), n;
    t && t();
}
var qT = function(e, t, o) {
    if (qn.is.ios === !0 && window.SafariViewController !== void 0) {
        window.SafariViewController.isAvailable(function(r) {
            r ? window.SafariViewController.show({
                url: e
            }, Qe, t) : v0(e, t, o);
        });
        return;
    }
    return v0(e, t, o);
};
function TT(e) {
    var t = Array.isArray(e);
    if (t === !0) {
        var n = e.length;
        return {
            isList: t,
            totalJobs: n,
            resultAggregator: Array(n).fill(null)
        };
    }
    var o = Object.keys(e), r = {};
    return o.forEach(function(n) {
        r[n] = null;
    }), {
        isList: t,
        totalJobs: o.length,
        resultAggregator: r,
        resultKeys: o
    };
}
function g0(e) {
    var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, tmp = _ref.threadsNumber, t = tmp === void 0 ? 1 : tmp, tmp1 = _ref.abortOnFail, o = tmp1 === void 0 ? !0 : tmp1;
    var r = -1, n = !1, _TT = TT(e), i = _TT.isList, a = _TT.totalJobs, l = _TT.resultAggregator, s = _TT.resultKeys, c = function() {
        return new Promise(function(v, f) {
            function d() {
                var m = ++r;
                if (n === !0 || m >= a) {
                    v();
                    return;
                }
                var y = i === !0 ? m : s[m];
                e[y](l).then(function(p) {
                    if (n === !0) {
                        v();
                        return;
                    }
                    l[y] = {
                        key: y,
                        status: "fulfilled",
                        value: p
                    }, setTimeout(d);
                }).catch(function(p) {
                    if (n === !0) {
                        v();
                        return;
                    }
                    var C = {
                        key: y,
                        status: "rejected",
                        reason: p
                    };
                    if (l[y] = C, o === !0) {
                        n = !0, f((0, $8typN._)((0, $8pZMQ._)({}, C), {
                            resultAggregator: l
                        }));
                        return;
                    }
                    setTimeout(d);
                });
            }
            d();
        });
    }, u = Array(t).fill(c());
    return Promise.all(u).then(function() {
        return l;
    });
}
var CX = {
    version: "2.15.4",
    install: function(e, t, o) {
        rf(e, (0, $8pZMQ._)({
            components: Td,
            directives: Md
        }, t), o);
    },
    lang: Kn,
    iconSet: Ta
};

});
parcelRegister("luoZD", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $fa4fc9703b223de7$export$2996f80ef42b8419; });
function $fa4fc9703b223de7$export$2996f80ef42b8419(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("fYUO3", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $ba28862f91ec404a$export$d60067ff2358eee8; });
function $ba28862f91ec404a$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $ba28862f91ec404a$export$d60067ff2358eee8(Constructor, protoProps, staticProps) {
    if (protoProps) $ba28862f91ec404a$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $ba28862f91ec404a$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}

});

parcelRegister("8pZMQ", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $621096155a85468e$export$581ff339ea0ba762; });

var $hrLxz = parcelRequire("hrLxz");
function $621096155a85468e$export$581ff339ea0ba762(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $hrLxz._define_property)(target, key, source[key]);
        });
    }
    return target;
}

});
parcelRegister("hrLxz", function(module, exports) {

$parcel$export(module.exports, "_define_property", function () { return $cb39d5d38d51b974$export$1e71eb4bef00f6b0; });
function $cb39d5d38d51b974$export$1e71eb4bef00f6b0(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});


parcelRegister("8typN", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $62bbba4b62f9b931$export$4fa2f4023c9cbda5; });
function $62bbba4b62f9b931$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $62bbba4b62f9b931$export$4fa2f4023c9cbda5(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $62bbba4b62f9b931$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}

});

parcelRegister("lhEla", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $f7ea7a4274de251a$export$69fdd232f62cde60; });

var $6w72H = parcelRequire("6w72H");
function $f7ea7a4274de251a$export$69fdd232f62cde60(source, excluded) {
    if (source == null) return {};
    var target = (0, $6w72H._object_without_properties_loose)(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}

});
parcelRegister("6w72H", function(module, exports) {

$parcel$export(module.exports, "_object_without_properties_loose", function () { return $4beb31c14ed0df85$export$7a4a7e38737aceb4; });
function $4beb31c14ed0df85$export$7a4a7e38737aceb4(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

});


parcelRegister("4f96i", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $316f9f54a2303539$export$fdf2a89c76341bbf; });

var $9ve0X = parcelRequire("9ve0X");

var $ittti = parcelRequire("ittti");

var $979nd = parcelRequire("979nd");

var $bM5Ei = parcelRequire("bM5Ei");
function $316f9f54a2303539$export$fdf2a89c76341bbf(arr, i) {
    return (0, $9ve0X._array_with_holes)(arr) || (0, $ittti._iterable_to_array_limit)(arr, i) || (0, $bM5Ei._unsupported_iterable_to_array)(arr, i) || (0, $979nd._non_iterable_rest)();
}

});
parcelRegister("9ve0X", function(module, exports) {

$parcel$export(module.exports, "_array_with_holes", function () { return $6eb1e148e28902f2$export$e6256bf45c68d561; });
function $6eb1e148e28902f2$export$e6256bf45c68d561(arr) {
    if (Array.isArray(arr)) return arr;
}

});

parcelRegister("ittti", function(module, exports) {

$parcel$export(module.exports, "_iterable_to_array_limit", function () { return $d731cbd7d86c765e$export$2fd15edff6687200; });
function $d731cbd7d86c765e$export$2fd15edff6687200(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}

});

parcelRegister("979nd", function(module, exports) {

$parcel$export(module.exports, "_non_iterable_rest", function () { return $6a2c09daf467e4df$export$60dbc22abd7da546; });
function $6a2c09daf467e4df$export$60dbc22abd7da546() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});

parcelRegister("bM5Ei", function(module, exports) {

$parcel$export(module.exports, "_unsupported_iterable_to_array", function () { return $89288f2be0c22489$export$a5be06335b3a083c; });

var $gFiZs = parcelRequire("gFiZs");
function $89288f2be0c22489$export$a5be06335b3a083c(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $gFiZs._array_like_to_array)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $gFiZs._array_like_to_array)(o, minLen);
}

});
parcelRegister("gFiZs", function(module, exports) {

$parcel$export(module.exports, "_array_like_to_array", function () { return $c21f34c1b6eb0b0e$export$79e617b1955a2616; });
function $c21f34c1b6eb0b0e$export$79e617b1955a2616(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});



parcelRegister("79xu7", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $53535909f5ee29a1$export$1b5e630bc3aea29f; });

var $fzb4p = parcelRequire("fzb4p");

var $37KRu = parcelRequire("37KRu");

var $l0Crn = parcelRequire("l0Crn");

var $bM5Ei = parcelRequire("bM5Ei");
function $53535909f5ee29a1$export$1b5e630bc3aea29f(arr) {
    return (0, $fzb4p._array_without_holes)(arr) || (0, $37KRu._iterable_to_array)(arr) || (0, $bM5Ei._unsupported_iterable_to_array)(arr) || (0, $l0Crn._non_iterable_spread)();
}

});
parcelRegister("fzb4p", function(module, exports) {

$parcel$export(module.exports, "_array_without_holes", function () { return $b552b62f67cc8a3c$export$7e0947b5ad3404e2; });

var $gFiZs = parcelRequire("gFiZs");
function $b552b62f67cc8a3c$export$7e0947b5ad3404e2(arr) {
    if (Array.isArray(arr)) return (0, $gFiZs._array_like_to_array)(arr);
}

});

parcelRegister("37KRu", function(module, exports) {

$parcel$export(module.exports, "_iterable_to_array", function () { return $24666049daa07ff7$export$1eb58a6e75231000; });
function $24666049daa07ff7$export$1eb58a6e75231000(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});

parcelRegister("l0Crn", function(module, exports) {

$parcel$export(module.exports, "_non_iterable_spread", function () { return $f4b76a8ea84892bb$export$e6f3c4780d19eb2b; });
function $f4b76a8ea84892bb$export$e6f3c4780d19eb2b() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("5eKWL", function(module, exports) {
$parcel$export(module.exports, "computed", function () { return (parcelRequire("aD8ZA")).computed; });
$parcel$export(module.exports, "defineComponent", function () { return (parcelRequire("aD8ZA")).defineComponent; });
$parcel$export(module.exports, "Fragment", function () { return (parcelRequire("aD8ZA")).Fragment; });
$parcel$export(module.exports, "getCurrentInstance", function () { return (parcelRequire("aD8ZA")).getCurrentInstance; });
$parcel$export(module.exports, "h", function () { return (parcelRequire("aD8ZA")).h; });
$parcel$export(module.exports, "initCustomFormatter", function () { return (parcelRequire("aD8ZA")).initCustomFormatter; });
$parcel$export(module.exports, "inject", function () { return (parcelRequire("aD8ZA")).inject; });
$parcel$export(module.exports, "isRef", function () { return (parcelRequire("aAzpa")).isRef; });
$parcel$export(module.exports, "KeepAlive", function () { return (parcelRequire("aD8ZA")).KeepAlive; });
$parcel$export(module.exports, "markRaw", function () { return (parcelRequire("aAzpa")).markRaw; });
$parcel$export(module.exports, "nextTick", function () { return (parcelRequire("aD8ZA")).nextTick; });
$parcel$export(module.exports, "onActivated", function () { return (parcelRequire("aD8ZA")).onActivated; });
$parcel$export(module.exports, "onBeforeMount", function () { return (parcelRequire("aD8ZA")).onBeforeMount; });
$parcel$export(module.exports, "onBeforeUnmount", function () { return (parcelRequire("aD8ZA")).onBeforeUnmount; });
$parcel$export(module.exports, "onBeforeUpdate", function () { return (parcelRequire("aD8ZA")).onBeforeUpdate; });
$parcel$export(module.exports, "onDeactivated", function () { return (parcelRequire("aD8ZA")).onDeactivated; });
$parcel$export(module.exports, "onMounted", function () { return (parcelRequire("aD8ZA")).onMounted; });
$parcel$export(module.exports, "onUnmounted", function () { return (parcelRequire("aD8ZA")).onUnmounted; });
$parcel$export(module.exports, "onUpdated", function () { return (parcelRequire("aD8ZA")).onUpdated; });
$parcel$export(module.exports, "provide", function () { return (parcelRequire("aD8ZA")).provide; });
$parcel$export(module.exports, "reactive", function () { return (parcelRequire("aAzpa")).reactive; });
$parcel$export(module.exports, "ref", function () { return (parcelRequire("aAzpa")).ref; });
$parcel$export(module.exports, "shallowReactive", function () { return (parcelRequire("aAzpa")).shallowReactive; });
$parcel$export(module.exports, "Teleport", function () { return (parcelRequire("aD8ZA")).Teleport; });
$parcel$export(module.exports, "toRaw", function () { return (parcelRequire("aAzpa")).toRaw; });
$parcel$export(module.exports, "watch", function () { return (parcelRequire("aD8ZA")).watch; });
$parcel$export(module.exports, "withDirectives", function () { return (parcelRequire("aD8ZA")).withDirectives; });
$parcel$export(module.exports, "createApp", function () { return (parcelRequire("iMtOP")).createApp; });
$parcel$export(module.exports, "Transition", function () { return (parcelRequire("iMtOP")).Transition; });
$parcel$export(module.exports, "TransitionGroup", function () { return (parcelRequire("iMtOP")).TransitionGroup; });
$parcel$export(module.exports, "vShow", function () { return (parcelRequire("iMtOP")).vShow; });
/**
* vue v3.4.25
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $aD8ZA = parcelRequire("aD8ZA");parcelRequire("iMtOP");
var $aAzpa = parcelRequire("aAzpa");
function $3d02ad339233d4cd$var$initDev() {
    (0, $aD8ZA.initCustomFormatter)();
}
var $3d02ad339233d4cd$export$ef7acd7185315e22 = function() {};
$parcel$exportWildcard(module.exports, $aAzpa);

});
parcelRegister("aD8ZA", function(module, exports) {

$parcel$export(module.exports, "callWithAsyncErrorHandling", function () { return $7bd48593473bea18$export$dae85862a8d94378; });
$parcel$export(module.exports, "nextTick", function () { return $7bd48593473bea18$export$bdd553fddd433dcb; });
$parcel$export(module.exports, "Fragment", function () { return $7bd48593473bea18$export$ffb0004e005737fa; });
$parcel$export(module.exports, "Static", function () { return $7bd48593473bea18$export$c1b9a1d3af45b7b6; });
$parcel$export(module.exports, "createVNode", function () { return $7bd48593473bea18$export$bf5c4cf060303d58; });
$parcel$export(module.exports, "inject", function () { return $7bd48593473bea18$export$a976684a0efeb93f; });
$parcel$export(module.exports, "watchPostEffect", function () { return $7bd48593473bea18$export$b7f27ea67102d543; });
$parcel$export(module.exports, "watch", function () { return $7bd48593473bea18$export$3db5d71bdb2d5499; });
$parcel$export(module.exports, "withDirectives", function () { return $7bd48593473bea18$export$49729353e7c1e6c5; });
$parcel$export(module.exports, "useTransitionState", function () { return $7bd48593473bea18$export$d2a0a1bc267c90f6; });
$parcel$export(module.exports, "onMounted", function () { return $7bd48593473bea18$export$6d1641039221b5cb; });
$parcel$export(module.exports, "onBeforeUnmount", function () { return $7bd48593473bea18$export$40c420df62d2614; });
$parcel$export(module.exports, "BaseTransitionPropsValidators", function () { return $7bd48593473bea18$export$b876c99684f8cf3b; });
$parcel$export(module.exports, "getCurrentInstance", function () { return $7bd48593473bea18$export$f13e630aa3915748; });
$parcel$export(module.exports, "getTransitionRawChildren", function () { return $7bd48593473bea18$export$a67f9b1229c7c97a; });
$parcel$export(module.exports, "resolveTransitionHooks", function () { return $7bd48593473bea18$export$76ac1779589cd824; });
$parcel$export(module.exports, "setTransitionHooks", function () { return $7bd48593473bea18$export$7770a22486565649; });
$parcel$export(module.exports, "BaseTransition", function () { return $7bd48593473bea18$export$abd95b5f5e8a8837; });
$parcel$export(module.exports, "defineComponent", function () { return $7bd48593473bea18$export$afa64b67e5a01c3b; });
$parcel$export(module.exports, "onUpdated", function () { return $7bd48593473bea18$export$5876c47052fb88b1; });
$parcel$export(module.exports, "KeepAlive", function () { return $7bd48593473bea18$export$70eb8a58709972df; });
$parcel$export(module.exports, "onActivated", function () { return $7bd48593473bea18$export$ba52d824b95a2154; });
$parcel$export(module.exports, "onDeactivated", function () { return $7bd48593473bea18$export$bf1440eeaf5fa709; });
$parcel$export(module.exports, "onUnmounted", function () { return $7bd48593473bea18$export$13348a43ccacfe58; });
$parcel$export(module.exports, "onBeforeMount", function () { return $7bd48593473bea18$export$23b7aeb0d671f804; });
$parcel$export(module.exports, "onBeforeUpdate", function () { return $7bd48593473bea18$export$ab91988a13872e4c; });
$parcel$export(module.exports, "computed", function () { return $7bd48593473bea18$export$2983e091f1a1e8e2; });
$parcel$export(module.exports, "provide", function () { return $7bd48593473bea18$export$abe1e183e22e10ad; });
$parcel$export(module.exports, "createRenderer", function () { return $7bd48593473bea18$export$53ae2f996c64e9a; });
$parcel$export(module.exports, "createHydrationRenderer", function () { return $7bd48593473bea18$export$200524cf0d997ff0; });
$parcel$export(module.exports, "Teleport", function () { return $7bd48593473bea18$export$76d55a0304a371f4; });
$parcel$export(module.exports, "isRuntimeOnly", function () { return $7bd48593473bea18$export$c93a9c496c5211fa; });
$parcel$export(module.exports, "h", function () { return $7bd48593473bea18$export$dda1d9f60106f0e9; });
$parcel$export(module.exports, "initCustomFormatter", function () { return $7bd48593473bea18$export$aed4979be6a60047; });
$parcel$export(module.exports, "warn", function () { return $7bd48593473bea18$export$c106dd0671a0fc2d; });
$parcel$export(module.exports, "isRef", function () { return (parcelRequire("aAzpa")).isRef; });
$parcel$export(module.exports, "markRaw", function () { return (parcelRequire("aAzpa")).markRaw; });
$parcel$export(module.exports, "reactive", function () { return (parcelRequire("aAzpa")).reactive; });
$parcel$export(module.exports, "ref", function () { return (parcelRequire("aAzpa")).ref; });
$parcel$export(module.exports, "shallowReactive", function () { return (parcelRequire("aAzpa")).shallowReactive; });
$parcel$export(module.exports, "toRaw", function () { return (parcelRequire("aAzpa")).toRaw; });
$parcel$export(module.exports, "camelize", function () { return (parcelRequire("lbCQA")).camelize; });
/**
* @vue/runtime-core v3.4.25
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $4f96i = parcelRequire("4f96i");

var $79xu7 = parcelRequire("79xu7");

var $jzTO1 = parcelRequire("jzTO1");

var $aAzpa = parcelRequire("aAzpa");

var $lbCQA = parcelRequire("lbCQA");
var $7bd48593473bea18$var$stack = [];
function $7bd48593473bea18$var$pushWarningContext(vnode) {
    $7bd48593473bea18$var$stack.push(vnode);
}
function $7bd48593473bea18$var$popWarningContext() {
    $7bd48593473bea18$var$stack.pop();
}
function $7bd48593473bea18$var$warn$1(msg) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    (0, $aAzpa.pauseTracking)();
    var instance = $7bd48593473bea18$var$stack.length ? $7bd48593473bea18$var$stack[$7bd48593473bea18$var$stack.length - 1].component : null;
    var appWarnHandler = instance && instance.appContext.config.warnHandler;
    var trace = $7bd48593473bea18$var$getComponentTrace();
    if (appWarnHandler) $7bd48593473bea18$export$b22fcaf88446e9bf(appWarnHandler, instance, 11, [
        msg + args.map(function(a) {
            var _a, _b;
            return (_b = (_a = a.toString) == null ? void 0 : _a.call(a)) != null ? _b : JSON.stringify(a);
        }).join(""),
        instance && instance.proxy,
        trace.map(function(param) {
            var vnode = param.vnode;
            return "at <".concat($7bd48593473bea18$var$formatComponentName(instance, vnode.type), ">");
        }).join("\n"),
        trace
    ]);
    else {
        var _warnArgs, _console;
        var warnArgs = [
            "[Vue warn]: ".concat(msg)
        ].concat((0, $79xu7._)(args));
        if (trace.length && // avoid spamming console during tests
        true) (_warnArgs = warnArgs).push.apply(_warnArgs, [
            "\n"
        ].concat((0, $79xu7._)($7bd48593473bea18$var$formatTrace(trace))));
        (_console = console).warn.apply(_console, (0, $79xu7._)(warnArgs));
    }
    (0, $aAzpa.resetTracking)();
}
function $7bd48593473bea18$var$getComponentTrace() {
    var currentVNode = $7bd48593473bea18$var$stack[$7bd48593473bea18$var$stack.length - 1];
    if (!currentVNode) return [];
    var normalizedStack = [];
    while(currentVNode){
        var last = normalizedStack[0];
        if (last && last.vnode === currentVNode) last.recurseCount++;
        else normalizedStack.push({
            vnode: currentVNode,
            recurseCount: 0
        });
        var parentInstance = currentVNode.component && currentVNode.component.parent;
        currentVNode = parentInstance && parentInstance.vnode;
    }
    return normalizedStack;
}
function $7bd48593473bea18$var$formatTrace(trace) {
    var logs = [];
    trace.forEach(function(entry, i) {
        var _logs;
        (_logs = logs).push.apply(_logs, (0, $79xu7._)(i === 0 ? [] : [
            "\n"
        ]).concat((0, $79xu7._)($7bd48593473bea18$var$formatTraceEntry(entry))));
    });
    return logs;
}
function $7bd48593473bea18$var$formatTraceEntry(param) {
    var vnode = param.vnode, recurseCount = param.recurseCount;
    var postfix = recurseCount > 0 ? "... (".concat(recurseCount, " recursive calls)") : "";
    var isRoot = vnode.component ? vnode.component.parent == null : false;
    var open = " at <".concat($7bd48593473bea18$var$formatComponentName(vnode.component, vnode.type, isRoot));
    var close = ">" + postfix;
    return vnode.props ? [
        open
    ].concat((0, $79xu7._)($7bd48593473bea18$var$formatProps(vnode.props)), [
        close
    ]) : [
        open + close
    ];
}
function $7bd48593473bea18$var$formatProps(props) {
    var res = [];
    var keys = Object.keys(props);
    keys.slice(0, 3).forEach(function(key) {
        var _res;
        (_res = res).push.apply(_res, (0, $79xu7._)($7bd48593473bea18$var$formatProp(key, props[key])));
    });
    if (keys.length > 3) res.push(" ...");
    return res;
}
function $7bd48593473bea18$var$formatProp(key, value, raw) {
    if ((0, $lbCQA.isString)(value)) {
        value = JSON.stringify(value);
        return raw ? value : [
            "".concat(key, "=").concat(value)
        ];
    } else if (typeof value === "number" || typeof value === "boolean" || value == null) return raw ? value : [
        "".concat(key, "=").concat(value)
    ];
    else if ((0, $aAzpa.isRef)(value)) {
        value = $7bd48593473bea18$var$formatProp(key, (0, $aAzpa.toRaw)(value.value), true);
        return raw ? value : [
            "".concat(key, "=Ref<"),
            value,
            ">"
        ];
    } else if ((0, $lbCQA.isFunction)(value)) return [
        "".concat(key, "=fn").concat(value.name ? "<".concat(value.name, ">") : "")
    ];
    else {
        value = (0, $aAzpa.toRaw)(value);
        return raw ? value : [
            "".concat(key, "="),
            value
        ];
    }
}
function $7bd48593473bea18$export$dfbcecb440255e4a(val, type) {
    return;
}
var $7bd48593473bea18$export$10e8e1cf990558d7 = {
    "SETUP_FUNCTION": 0,
    "0": "SETUP_FUNCTION",
    "RENDER_FUNCTION": 1,
    "1": "RENDER_FUNCTION",
    "WATCH_GETTER": 2,
    "2": "WATCH_GETTER",
    "WATCH_CALLBACK": 3,
    "3": "WATCH_CALLBACK",
    "WATCH_CLEANUP": 4,
    "4": "WATCH_CLEANUP",
    "NATIVE_EVENT_HANDLER": 5,
    "5": "NATIVE_EVENT_HANDLER",
    "COMPONENT_EVENT_HANDLER": 6,
    "6": "COMPONENT_EVENT_HANDLER",
    "VNODE_HOOK": 7,
    "7": "VNODE_HOOK",
    "DIRECTIVE_HOOK": 8,
    "8": "DIRECTIVE_HOOK",
    "TRANSITION_HOOK": 9,
    "9": "TRANSITION_HOOK",
    "APP_ERROR_HANDLER": 10,
    "10": "APP_ERROR_HANDLER",
    "APP_WARN_HANDLER": 11,
    "11": "APP_WARN_HANDLER",
    "FUNCTION_REF": 12,
    "12": "FUNCTION_REF",
    "ASYNC_COMPONENT_LOADER": 13,
    "13": "ASYNC_COMPONENT_LOADER",
    "SCHEDULER": 14,
    "14": "SCHEDULER"
};
var $7bd48593473bea18$var$ErrorTypeStrings$1 = {
    ["sp"]: "serverPrefetch hook",
    ["bc"]: "beforeCreate hook",
    ["c"]: "created hook",
    ["bm"]: "beforeMount hook",
    ["m"]: "mounted hook",
    ["bu"]: "beforeUpdate hook",
    ["u"]: "updated",
    ["bum"]: "beforeUnmount hook",
    ["um"]: "unmounted hook",
    ["a"]: "activated hook",
    ["da"]: "deactivated hook",
    ["ec"]: "errorCaptured hook",
    ["rtc"]: "renderTracked hook",
    ["rtg"]: "renderTriggered hook",
    [0]: "setup function",
    [1]: "render function",
    [2]: "watcher getter",
    [3]: "watcher callback",
    [4]: "watcher cleanup function",
    [5]: "native event handler",
    [6]: "component event handler",
    [7]: "vnode hook",
    [8]: "directive hook",
    [9]: "transition hook",
    [10]: "app errorHandler",
    [11]: "app warnHandler",
    [12]: "ref function",
    [13]: "async component loader",
    [14]: "scheduler flush. This is likely a Vue internals bug. Please open an issue at https://github.com/vuejs/core ."
};
function $7bd48593473bea18$export$b22fcaf88446e9bf(fn, instance, type, args) {
    try {
        return args ? fn.apply(void 0, (0, $79xu7._)(args)) : fn();
    } catch (err) {
        $7bd48593473bea18$export$d3da1ecaf1206c58(err, instance, type);
    }
}
function $7bd48593473bea18$export$dae85862a8d94378(fn, instance, type, args) {
    if ((0, $lbCQA.isFunction)(fn)) {
        var res = $7bd48593473bea18$export$b22fcaf88446e9bf(fn, instance, type, args);
        if (res && (0, $lbCQA.isPromise)(res)) res.catch(function(err) {
            $7bd48593473bea18$export$d3da1ecaf1206c58(err, instance, type);
        });
        return res;
    }
    if ((0, $lbCQA.isArray)(fn)) {
        var values = [];
        for(var i = 0; i < fn.length; i++)values.push($7bd48593473bea18$export$dae85862a8d94378(fn[i], instance, type, args));
        return values;
    }
}
function $7bd48593473bea18$export$d3da1ecaf1206c58(err, instance, type) {
    var throwInDev = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : true;
    var contextVNode = instance ? instance.vnode : null;
    if (instance) {
        var cur = instance.parent;
        var exposedInstance = instance.proxy;
        var errorInfo = "https://vuejs.org/error-reference/#runtime-".concat(type);
        while(cur){
            var errorCapturedHooks = cur.ec;
            if (errorCapturedHooks) for(var i = 0; i < errorCapturedHooks.length; i++){
                if (errorCapturedHooks[i](err, exposedInstance, errorInfo) === false) return;
            }
            cur = cur.parent;
        }
        var appErrorHandler = instance.appContext.config.errorHandler;
        if (appErrorHandler) {
            (0, $aAzpa.pauseTracking)();
            $7bd48593473bea18$export$b22fcaf88446e9bf(appErrorHandler, null, 10, [
                err,
                exposedInstance,
                errorInfo
            ]);
            (0, $aAzpa.resetTracking)();
            return;
        }
    }
    $7bd48593473bea18$var$logError(err, type, contextVNode, throwInDev);
}
function $7bd48593473bea18$var$logError(err, type, contextVNode) {
    var throwInDev = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : true;
    console.error(err);
}
var $7bd48593473bea18$var$isFlushing = false;
var $7bd48593473bea18$var$isFlushPending = false;
var $7bd48593473bea18$var$queue = [];
var $7bd48593473bea18$var$flushIndex = 0;
var $7bd48593473bea18$var$pendingPostFlushCbs = [];
var $7bd48593473bea18$var$activePostFlushCbs = null;
var $7bd48593473bea18$var$postFlushIndex = 0;
var $7bd48593473bea18$var$resolvedPromise = /* @__PURE__ */ Promise.resolve();
var $7bd48593473bea18$var$currentFlushPromise = null;
var $7bd48593473bea18$var$RECURSION_LIMIT = 100;
function $7bd48593473bea18$export$bdd553fddd433dcb(fn) {
    var p = $7bd48593473bea18$var$currentFlushPromise || $7bd48593473bea18$var$resolvedPromise;
    return fn ? p.then(this ? fn.bind(this) : fn) : p;
}
function $7bd48593473bea18$var$findInsertionIndex(id) {
    var start = $7bd48593473bea18$var$flushIndex + 1;
    var end = $7bd48593473bea18$var$queue.length;
    while(start < end){
        var middle = start + end >>> 1;
        var middleJob = $7bd48593473bea18$var$queue[middle];
        var middleJobId = $7bd48593473bea18$var$getId(middleJob);
        if (middleJobId < id || middleJobId === id && middleJob.pre) start = middle + 1;
        else end = middle;
    }
    return start;
}
function $7bd48593473bea18$var$queueJob(job) {
    if (!$7bd48593473bea18$var$queue.length || !$7bd48593473bea18$var$queue.includes(job, $7bd48593473bea18$var$isFlushing && job.allowRecurse ? $7bd48593473bea18$var$flushIndex + 1 : $7bd48593473bea18$var$flushIndex)) {
        if (job.id == null) $7bd48593473bea18$var$queue.push(job);
        else $7bd48593473bea18$var$queue.splice($7bd48593473bea18$var$findInsertionIndex(job.id), 0, job);
        $7bd48593473bea18$var$queueFlush();
    }
}
function $7bd48593473bea18$var$queueFlush() {
    if (!$7bd48593473bea18$var$isFlushing && !$7bd48593473bea18$var$isFlushPending) {
        $7bd48593473bea18$var$isFlushPending = true;
        $7bd48593473bea18$var$currentFlushPromise = $7bd48593473bea18$var$resolvedPromise.then($7bd48593473bea18$var$flushJobs);
    }
}
function $7bd48593473bea18$var$invalidateJob(job) {
    var i = $7bd48593473bea18$var$queue.indexOf(job);
    if (i > $7bd48593473bea18$var$flushIndex) $7bd48593473bea18$var$queue.splice(i, 1);
}
function $7bd48593473bea18$export$59536a0199721cab(cb) {
    var _pendingPostFlushCbs;
    if (!(0, $lbCQA.isArray)(cb)) {
        if (!$7bd48593473bea18$var$activePostFlushCbs || !$7bd48593473bea18$var$activePostFlushCbs.includes(cb, cb.allowRecurse ? $7bd48593473bea18$var$postFlushIndex + 1 : $7bd48593473bea18$var$postFlushIndex)) $7bd48593473bea18$var$pendingPostFlushCbs.push(cb);
    } else (_pendingPostFlushCbs = $7bd48593473bea18$var$pendingPostFlushCbs).push.apply(_pendingPostFlushCbs, (0, $79xu7._)(cb));
    $7bd48593473bea18$var$queueFlush();
}
function $7bd48593473bea18$var$flushPreFlushCbs(instance, seen) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $7bd48593473bea18$var$isFlushing ? $7bd48593473bea18$var$flushIndex + 1 : 0;
    for(; i < $7bd48593473bea18$var$queue.length; i++){
        var cb = $7bd48593473bea18$var$queue[i];
        if (cb && cb.pre) {
            if (instance && cb.id !== instance.uid) continue;
            $7bd48593473bea18$var$queue.splice(i, 1);
            i--;
            cb();
        }
    }
}
function $7bd48593473bea18$var$flushPostFlushCbs(seen) {
    if ($7bd48593473bea18$var$pendingPostFlushCbs.length) {
        var deduped = (0, $79xu7._)(new Set($7bd48593473bea18$var$pendingPostFlushCbs)).sort(function(a, b) {
            return $7bd48593473bea18$var$getId(a) - $7bd48593473bea18$var$getId(b);
        });
        $7bd48593473bea18$var$pendingPostFlushCbs.length = 0;
        if ($7bd48593473bea18$var$activePostFlushCbs) {
            var _activePostFlushCbs;
            (_activePostFlushCbs = $7bd48593473bea18$var$activePostFlushCbs).push.apply(_activePostFlushCbs, (0, $79xu7._)(deduped));
            return;
        }
        $7bd48593473bea18$var$activePostFlushCbs = deduped;
        for($7bd48593473bea18$var$postFlushIndex = 0; $7bd48593473bea18$var$postFlushIndex < $7bd48593473bea18$var$activePostFlushCbs.length; $7bd48593473bea18$var$postFlushIndex++)$7bd48593473bea18$var$activePostFlushCbs[$7bd48593473bea18$var$postFlushIndex]();
        $7bd48593473bea18$var$activePostFlushCbs = null;
        $7bd48593473bea18$var$postFlushIndex = 0;
    }
}
var $7bd48593473bea18$var$getId = function(job) {
    return job.id == null ? Infinity : job.id;
};
var $7bd48593473bea18$var$comparator = function(a, b) {
    var diff = $7bd48593473bea18$var$getId(a) - $7bd48593473bea18$var$getId(b);
    if (diff === 0) {
        if (a.pre && !b.pre) return -1;
        if (b.pre && !a.pre) return 1;
    }
    return diff;
};
function $7bd48593473bea18$var$flushJobs(seen) {
    $7bd48593473bea18$var$isFlushPending = false;
    $7bd48593473bea18$var$isFlushing = true;
    $7bd48593473bea18$var$queue.sort($7bd48593473bea18$var$comparator);
    var check = (0, $lbCQA.NOOP);
    try {
        for($7bd48593473bea18$var$flushIndex = 0; $7bd48593473bea18$var$flushIndex < $7bd48593473bea18$var$queue.length; $7bd48593473bea18$var$flushIndex++){
            var job = $7bd48593473bea18$var$queue[$7bd48593473bea18$var$flushIndex];
            if (job && job.active !== false) $7bd48593473bea18$export$b22fcaf88446e9bf(job, null, 14);
        }
    } finally{
        $7bd48593473bea18$var$flushIndex = 0;
        $7bd48593473bea18$var$queue.length = 0;
        $7bd48593473bea18$var$flushPostFlushCbs(seen);
        $7bd48593473bea18$var$isFlushing = false;
        $7bd48593473bea18$var$currentFlushPromise = null;
        if ($7bd48593473bea18$var$queue.length || $7bd48593473bea18$var$pendingPostFlushCbs.length) $7bd48593473bea18$var$flushJobs(seen);
    }
}
function $7bd48593473bea18$var$checkRecursiveUpdates(seen, fn) {
    if (!seen.has(fn)) seen.set(fn, 1);
    else {
        var count = seen.get(fn);
        if (count > $7bd48593473bea18$var$RECURSION_LIMIT) {
            var instance = fn.ownerInstance;
            var componentName = instance && $7bd48593473bea18$var$getComponentName(instance.type);
            $7bd48593473bea18$export$d3da1ecaf1206c58("Maximum recursive updates exceeded".concat(componentName ? " in component <".concat(componentName, ">") : "", ". This means you have a reactive effect that is mutating its own dependencies and thus recursively triggering itself. Possible sources include component template, render function, updated hook or watcher source function."), null, 10);
            return true;
        } else seen.set(fn, count + 1);
    }
}
var $7bd48593473bea18$var$isHmrUpdating = false;
var $7bd48593473bea18$var$hmrDirtyComponents = /* @__PURE__ */ new Set();
var $7bd48593473bea18$var$map = /* @__PURE__ */ new Map();
function $7bd48593473bea18$var$registerHMR(instance) {
    var id = instance.type.__hmrId;
    var record = $7bd48593473bea18$var$map.get(id);
    if (!record) {
        $7bd48593473bea18$var$createRecord(id, instance.type);
        record = $7bd48593473bea18$var$map.get(id);
    }
    record.instances.add(instance);
}
function $7bd48593473bea18$var$unregisterHMR(instance) {
    $7bd48593473bea18$var$map.get(instance.type.__hmrId).instances.delete(instance);
}
function $7bd48593473bea18$var$createRecord(id, initialDef) {
    if ($7bd48593473bea18$var$map.has(id)) return false;
    $7bd48593473bea18$var$map.set(id, {
        initialDef: $7bd48593473bea18$var$normalizeClassComponent(initialDef),
        instances: /* @__PURE__ */ new Set()
    });
    return true;
}
function $7bd48593473bea18$var$normalizeClassComponent(component) {
    return $7bd48593473bea18$var$isClassComponent(component) ? component.__vccOpts : component;
}
function $7bd48593473bea18$var$rerender(id, newRender) {
    var record = $7bd48593473bea18$var$map.get(id);
    if (!record) return;
    record.initialDef.render = newRender;
    (0, $79xu7._)(record.instances).forEach(function(instance) {
        if (newRender) {
            instance.render = newRender;
            $7bd48593473bea18$var$normalizeClassComponent(instance.type).render = newRender;
        }
        instance.renderCache = [];
        $7bd48593473bea18$var$isHmrUpdating = true;
        instance.effect.dirty = true;
        instance.update();
        $7bd48593473bea18$var$isHmrUpdating = false;
    });
}
function $7bd48593473bea18$var$reload(id, newComp) {
    var record = $7bd48593473bea18$var$map.get(id);
    if (!record) return;
    newComp = $7bd48593473bea18$var$normalizeClassComponent(newComp);
    $7bd48593473bea18$var$updateComponentDef(record.initialDef, newComp);
    var instances = (0, $79xu7._)(record.instances);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = instances[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var instance = _step.value;
            var oldComp = $7bd48593473bea18$var$normalizeClassComponent(instance.type);
            if (!$7bd48593473bea18$var$hmrDirtyComponents.has(oldComp)) {
                if (oldComp !== record.initialDef) $7bd48593473bea18$var$updateComponentDef(oldComp, newComp);
                $7bd48593473bea18$var$hmrDirtyComponents.add(oldComp);
            }
            instance.appContext.propsCache.delete(instance.type);
            instance.appContext.emitsCache.delete(instance.type);
            instance.appContext.optionsCache.delete(instance.type);
            if (instance.ceReload) {
                $7bd48593473bea18$var$hmrDirtyComponents.add(oldComp);
                instance.ceReload(newComp.styles);
                $7bd48593473bea18$var$hmrDirtyComponents.delete(oldComp);
            } else if (instance.parent) {
                instance.parent.effect.dirty = true;
                $7bd48593473bea18$var$queueJob(instance.parent.update);
            } else if (instance.appContext.reload) instance.appContext.reload();
            else if (typeof window !== "undefined") window.location.reload();
            else console.warn("[HMR] Root or manually mounted instance modified. Full reload required.");
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    $7bd48593473bea18$export$59536a0199721cab(function() {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = instances[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var instance = _step.value;
                $7bd48593473bea18$var$hmrDirtyComponents.delete($7bd48593473bea18$var$normalizeClassComponent(instance.type));
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    });
}
function $7bd48593473bea18$var$updateComponentDef(oldComp, newComp) {
    (0, $lbCQA.extend)(oldComp, newComp);
    for(var key in oldComp)if (key !== "__file" && !(key in newComp)) delete oldComp[key];
}
function $7bd48593473bea18$var$tryWrap(fn) {
    return function(id, arg) {
        try {
            return fn(id, arg);
        } catch (e) {
            console.error(e);
            console.warn("[HMR] Something went wrong during Vue component hot-reload. Full reload required.");
        }
    };
}
var $7bd48593473bea18$var$devtools$1;
var $7bd48593473bea18$var$buffer = [];
var $7bd48593473bea18$var$devtoolsNotInstalled = false;
function $7bd48593473bea18$var$emit$1(event) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    var _devtools$1;
    if ($7bd48593473bea18$var$devtools$1) (_devtools$1 = $7bd48593473bea18$var$devtools$1).emit.apply(_devtools$1, [
        event
    ].concat((0, $79xu7._)(args)));
    else if (!$7bd48593473bea18$var$devtoolsNotInstalled) $7bd48593473bea18$var$buffer.push({
        event: event,
        args: args
    });
}
function $7bd48593473bea18$var$setDevtoolsHook$1(hook, target) {
    var _a, _b;
    $7bd48593473bea18$var$devtools$1 = hook;
    if ($7bd48593473bea18$var$devtools$1) {
        var _devtools$1;
        $7bd48593473bea18$var$devtools$1.enabled = true;
        $7bd48593473bea18$var$buffer.forEach(function(param) {
            var event = param.event, args = param.args;
            return (_devtools$1 = $7bd48593473bea18$var$devtools$1).emit.apply(_devtools$1, [
                event
            ].concat((0, $79xu7._)(args)));
        });
        $7bd48593473bea18$var$buffer = [];
    } else if (// handle late devtools injection - only do this if we are in an actual
    // browser environment to avoid the timer handle stalling test runner exit
    // (#4815)
    typeof window !== "undefined" && // some envs mock window but not fully
    window.HTMLElement && // also exclude jsdom
    !((_b = (_a = window.navigator) == null ? void 0 : _a.userAgent) == null ? void 0 : _b.includes("jsdom"))) {
        var replay = target.__VUE_DEVTOOLS_HOOK_REPLAY__ = target.__VUE_DEVTOOLS_HOOK_REPLAY__ || [];
        replay.push(function(newHook) {
            $7bd48593473bea18$var$setDevtoolsHook$1(newHook, target);
        });
        setTimeout(function() {
            if (!$7bd48593473bea18$var$devtools$1) {
                target.__VUE_DEVTOOLS_HOOK_REPLAY__ = null;
                $7bd48593473bea18$var$devtoolsNotInstalled = true;
                $7bd48593473bea18$var$buffer = [];
            }
        }, 3e3);
    } else {
        $7bd48593473bea18$var$devtoolsNotInstalled = true;
        $7bd48593473bea18$var$buffer = [];
    }
}
function $7bd48593473bea18$var$devtoolsInitApp(app, version) {
    $7bd48593473bea18$var$emit$1("app:init" /* APP_INIT */ , app, version, {
        Fragment: $7bd48593473bea18$export$ffb0004e005737fa,
        Text: $7bd48593473bea18$export$5f1af8db9871e1d6,
        Comment: $7bd48593473bea18$export$4d299b491347818a,
        Static: $7bd48593473bea18$export$c1b9a1d3af45b7b6
    });
}
function $7bd48593473bea18$var$devtoolsUnmountApp(app) {
    $7bd48593473bea18$var$emit$1("app:unmount" /* APP_UNMOUNT */ , app);
}
var $7bd48593473bea18$var$devtoolsComponentAdded = /* @__PURE__ */ $7bd48593473bea18$var$createDevtoolsComponentHook("component:added" /* COMPONENT_ADDED */ );
var $7bd48593473bea18$var$devtoolsComponentUpdated = /* @__PURE__ */ $7bd48593473bea18$var$createDevtoolsComponentHook("component:updated" /* COMPONENT_UPDATED */ );
var $7bd48593473bea18$var$_devtoolsComponentRemoved = /* @__PURE__ */ $7bd48593473bea18$var$createDevtoolsComponentHook("component:removed" /* COMPONENT_REMOVED */ );
var $7bd48593473bea18$var$devtoolsComponentRemoved = function(component) {
    if ($7bd48593473bea18$var$devtools$1 && typeof $7bd48593473bea18$var$devtools$1.cleanupBuffer === "function" && // remove the component if it wasn't buffered
    !$7bd48593473bea18$var$devtools$1.cleanupBuffer(component)) $7bd48593473bea18$var$_devtoolsComponentRemoved(component);
};
/*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function $7bd48593473bea18$var$createDevtoolsComponentHook(hook) {
    return function(component) {
        $7bd48593473bea18$var$emit$1(hook, component.appContext.app, component.uid, component.parent ? component.parent.uid : void 0, component);
    };
}
var $7bd48593473bea18$var$devtoolsPerfStart = /* @__PURE__ */ $7bd48593473bea18$var$createDevtoolsPerformanceHook("perf:start" /* PERFORMANCE_START */ );
var $7bd48593473bea18$var$devtoolsPerfEnd = /* @__PURE__ */ $7bd48593473bea18$var$createDevtoolsPerformanceHook("perf:end" /* PERFORMANCE_END */ );
function $7bd48593473bea18$var$createDevtoolsPerformanceHook(hook) {
    return function(component, type, time) {
        $7bd48593473bea18$var$emit$1(hook, component.appContext.app, component.uid, component, type, time);
    };
}
function $7bd48593473bea18$var$devtoolsComponentEmit(component, event, params) {
    $7bd48593473bea18$var$emit$1("component:emit" /* COMPONENT_EMIT */ , component.appContext.app, component, event, params);
}
function $7bd48593473bea18$var$emit(instance, event) {
    for(var _len = arguments.length, rawArgs = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
        rawArgs[_key - 2] = arguments[_key];
    }
    if (instance.isUnmounted) return;
    var props = instance.vnode.props || (0, $lbCQA.EMPTY_OBJ);
    var args = rawArgs;
    var isModelListener = event.startsWith("update:");
    var modelArg = isModelListener && event.slice(7);
    if (modelArg && modelArg in props) {
        var modifiersKey = "".concat(modelArg === "modelValue" ? "model" : modelArg, "Modifiers");
        var _ref = props[modifiersKey] || (0, $lbCQA.EMPTY_OBJ), number = _ref.number, trim = _ref.trim;
        if (trim) args = rawArgs.map(function(a) {
            return (0, $lbCQA.isString)(a) ? a.trim() : a;
        });
        if (number) args = rawArgs.map((0, $lbCQA.looseToNumber));
    }
    if (__VUE_PROD_DEVTOOLS__) $7bd48593473bea18$var$devtoolsComponentEmit(instance, event, args);
    var handlerName;
    var handler = props[handlerName = (0, $lbCQA.toHandlerKey)(event)] || // also try camelCase event handler (#2249)
    props[handlerName = (0, $lbCQA.toHandlerKey)((0, $lbCQA.camelize)(event))];
    if (!handler && isModelListener) handler = props[handlerName = (0, $lbCQA.toHandlerKey)((0, $lbCQA.hyphenate)(event))];
    if (handler) $7bd48593473bea18$export$dae85862a8d94378(handler, instance, 6, args);
    var onceHandler = props[handlerName + "Once"];
    if (onceHandler) {
        if (!instance.emitted) instance.emitted = {};
        else if (instance.emitted[handlerName]) return;
        instance.emitted[handlerName] = true;
        $7bd48593473bea18$export$dae85862a8d94378(onceHandler, instance, 6, args);
    }
}
function $7bd48593473bea18$var$normalizeEmitsOptions(comp, appContext) {
    var asMixin = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var cache = appContext.emitsCache;
    var cached = cache.get(comp);
    if (cached !== void 0) return cached;
    var raw = comp.emits;
    var normalized = {};
    var hasExtends = false;
    if (__VUE_OPTIONS_API__ && !(0, $lbCQA.isFunction)(comp)) {
        var extendEmits = function(raw2) {
            var normalizedFromExtend = $7bd48593473bea18$var$normalizeEmitsOptions(raw2, appContext, true);
            if (normalizedFromExtend) {
                hasExtends = true;
                (0, $lbCQA.extend)(normalized, normalizedFromExtend);
            }
        };
        if (!asMixin && appContext.mixins.length) appContext.mixins.forEach(extendEmits);
        if (comp.extends) extendEmits(comp.extends);
        if (comp.mixins) comp.mixins.forEach(extendEmits);
    }
    if (!raw && !hasExtends) {
        if ((0, $lbCQA.isObject)(comp)) cache.set(comp, null);
        return null;
    }
    if ((0, $lbCQA.isArray)(raw)) raw.forEach(function(key) {
        return normalized[key] = null;
    });
    else (0, $lbCQA.extend)(normalized, raw);
    if ((0, $lbCQA.isObject)(comp)) cache.set(comp, normalized);
    return normalized;
}
function $7bd48593473bea18$var$isEmitListener(options, key) {
    if (!options || !(0, $lbCQA.isOn)(key)) return false;
    key = key.slice(2).replace(/Once$/, "");
    return (0, $lbCQA.hasOwn)(options, key[0].toLowerCase() + key.slice(1)) || (0, $lbCQA.hasOwn)(options, (0, $lbCQA.hyphenate)(key)) || (0, $lbCQA.hasOwn)(options, key);
}
var $7bd48593473bea18$var$currentRenderingInstance = null;
var $7bd48593473bea18$var$currentScopeId = null;
function $7bd48593473bea18$var$setCurrentRenderingInstance(instance) {
    var prev = $7bd48593473bea18$var$currentRenderingInstance;
    $7bd48593473bea18$var$currentRenderingInstance = instance;
    $7bd48593473bea18$var$currentScopeId = instance && instance.type.__scopeId || null;
    return prev;
}
function $7bd48593473bea18$export$ac020265ca2cc4cd(id) {
    $7bd48593473bea18$var$currentScopeId = id;
}
function $7bd48593473bea18$export$f2dc6805dc11834e() {
    $7bd48593473bea18$var$currentScopeId = null;
}
var $7bd48593473bea18$export$15ba313e13f3dd04 = function(_id) {
    return $7bd48593473bea18$export$694b237e827a3d23;
};
function $7bd48593473bea18$export$694b237e827a3d23(fn) {
    var ctx = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $7bd48593473bea18$var$currentRenderingInstance, isNonScopedSlot = arguments.length > 2 ? arguments[2] : void 0;
    if (!ctx) return fn;
    if (fn._n) return fn;
    var renderFnWithContext = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        if (renderFnWithContext._d) $7bd48593473bea18$export$c20bee82f26f1e27(-1);
        var prevInstance = $7bd48593473bea18$var$setCurrentRenderingInstance(ctx);
        var res;
        try {
            res = fn.apply(void 0, (0, $79xu7._)(args));
        } finally{
            $7bd48593473bea18$var$setCurrentRenderingInstance(prevInstance);
            if (renderFnWithContext._d) $7bd48593473bea18$export$c20bee82f26f1e27(1);
        }
        if (__VUE_PROD_DEVTOOLS__) $7bd48593473bea18$var$devtoolsComponentUpdated(ctx);
        return res;
    };
    renderFnWithContext._n = true;
    renderFnWithContext._c = true;
    renderFnWithContext._d = true;
    return renderFnWithContext;
}
var $7bd48593473bea18$var$accessedAttrs = false;
function $7bd48593473bea18$var$markAttrsAccessed() {
    $7bd48593473bea18$var$accessedAttrs = true;
}
function $7bd48593473bea18$var$renderComponentRoot(instance) {
    var Component = instance.type, vnode = instance.vnode, proxy = instance.proxy, withProxy = instance.withProxy, _instance_propsOptions = (0, $4f96i._)(instance.propsOptions, 1), propsOptions = _instance_propsOptions[0], slots = instance.slots, attrs = instance.attrs, emit = instance.emit, render = instance.render, renderCache = instance.renderCache, props = instance.props, data = instance.data, setupState = instance.setupState, ctx = instance.ctx, inheritAttrs = instance.inheritAttrs;
    var prev = $7bd48593473bea18$var$setCurrentRenderingInstance(instance);
    var result;
    var fallthroughAttrs;
    try {
        if (vnode.shapeFlag & 4) {
            var proxyToUse = withProxy || proxy;
            var thisProxy = proxyToUse;
            result = $7bd48593473bea18$var$normalizeVNode(render.call(thisProxy, proxyToUse, renderCache, props, setupState, data, ctx));
            fallthroughAttrs = attrs;
        } else {
            var render2 = Component;
            result = $7bd48593473bea18$var$normalizeVNode(render2.length > 1 ? render2(props, {
                attrs: attrs,
                slots: slots,
                emit: emit
            }) : render2(props, null));
            fallthroughAttrs = Component.props ? attrs : $7bd48593473bea18$var$getFunctionalFallthrough(attrs);
        }
    } catch (err) {
        $7bd48593473bea18$var$blockStack.length = 0;
        $7bd48593473bea18$export$d3da1ecaf1206c58(err, instance, 1);
        result = $7bd48593473bea18$export$bf5c4cf060303d58($7bd48593473bea18$export$4d299b491347818a);
    }
    var root = result;
    var setRoot = void 0;
    if (fallthroughAttrs && inheritAttrs !== false) {
        var keys = Object.keys(fallthroughAttrs);
        var shapeFlag = root.shapeFlag;
        if (keys.length) {
            if (shapeFlag & 7) {
                if (propsOptions && keys.some((0, $lbCQA.isModelListener))) fallthroughAttrs = $7bd48593473bea18$var$filterModelListeners(fallthroughAttrs, propsOptions);
                root = $7bd48593473bea18$export$ee4f9e12c0a92a1a(root, fallthroughAttrs);
            }
        }
    }
    if (vnode.dirs) {
        root = $7bd48593473bea18$export$ee4f9e12c0a92a1a(root);
        root.dirs = root.dirs ? root.dirs.concat(vnode.dirs) : vnode.dirs;
    }
    if (vnode.transition) root.transition = vnode.transition;
    result = root;
    $7bd48593473bea18$var$setCurrentRenderingInstance(prev);
    return result;
}
var $7bd48593473bea18$var$getChildRoot = function(vnode) {
    var rawChildren = vnode.children;
    var dynamicChildren = vnode.dynamicChildren;
    var childRoot = $7bd48593473bea18$var$filterSingleRoot(rawChildren, false);
    if (!childRoot) return [
        vnode,
        void 0
    ];
    var index = rawChildren.indexOf(childRoot);
    var dynamicIndex = dynamicChildren ? dynamicChildren.indexOf(childRoot) : -1;
    var setRoot = function(updatedRoot) {
        rawChildren[index] = updatedRoot;
        if (dynamicChildren) {
            if (dynamicIndex > -1) dynamicChildren[dynamicIndex] = updatedRoot;
            else if (updatedRoot.patchFlag > 0) vnode.dynamicChildren = (0, $79xu7._)(dynamicChildren).concat([
                updatedRoot
            ]);
        }
    };
    return [
        $7bd48593473bea18$var$normalizeVNode(childRoot),
        setRoot
    ];
};
function $7bd48593473bea18$var$filterSingleRoot(children) {
    var recurse = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    var singleRoot;
    for(var i = 0; i < children.length; i++){
        var child = children[i];
        if ($7bd48593473bea18$export$3868d13f8734ae81(child)) {
            if (child.type !== $7bd48593473bea18$export$4d299b491347818a || child.children === "v-if") {
                if (singleRoot) return;
                else singleRoot = child;
            }
        } else return;
    }
    return singleRoot;
}
var $7bd48593473bea18$var$getFunctionalFallthrough = function(attrs) {
    var res;
    for(var key in attrs)if (key === "class" || key === "style" || (0, $lbCQA.isOn)(key)) (res || (res = {}))[key] = attrs[key];
    return res;
};
var $7bd48593473bea18$var$filterModelListeners = function(attrs, props) {
    var res = {};
    for(var key in attrs)if (!(0, $lbCQA.isModelListener)(key) || !(key.slice(9) in props)) res[key] = attrs[key];
    return res;
};
var $7bd48593473bea18$var$isElementRoot = function(vnode) {
    return vnode.shapeFlag & 7 || vnode.type === $7bd48593473bea18$export$4d299b491347818a;
};
function $7bd48593473bea18$var$shouldUpdateComponent(prevVNode, nextVNode, optimized) {
    var prevProps = prevVNode.props, prevChildren = prevVNode.children, component = prevVNode.component;
    var nextProps = nextVNode.props, nextChildren = nextVNode.children, patchFlag = nextVNode.patchFlag;
    var emits = component.emitsOptions;
    if (nextVNode.dirs || nextVNode.transition) return true;
    if (optimized && patchFlag >= 0) {
        if (patchFlag & 1024) return true;
        if (patchFlag & 16) {
            if (!prevProps) return !!nextProps;
            return $7bd48593473bea18$var$hasPropsChanged(prevProps, nextProps, emits);
        } else if (patchFlag & 8) {
            var dynamicProps = nextVNode.dynamicProps;
            for(var i = 0; i < dynamicProps.length; i++){
                var key = dynamicProps[i];
                if (nextProps[key] !== prevProps[key] && !$7bd48593473bea18$var$isEmitListener(emits, key)) return true;
            }
        }
    } else {
        if (prevChildren || nextChildren) {
            if (!nextChildren || !nextChildren.$stable) return true;
        }
        if (prevProps === nextProps) return false;
        if (!prevProps) return !!nextProps;
        if (!nextProps) return true;
        return $7bd48593473bea18$var$hasPropsChanged(prevProps, nextProps, emits);
    }
    return false;
}
function $7bd48593473bea18$var$hasPropsChanged(prevProps, nextProps, emitsOptions) {
    var nextKeys = Object.keys(nextProps);
    if (nextKeys.length !== Object.keys(prevProps).length) return true;
    for(var i = 0; i < nextKeys.length; i++){
        var key = nextKeys[i];
        if (nextProps[key] !== prevProps[key] && !$7bd48593473bea18$var$isEmitListener(emitsOptions, key)) return true;
    }
    return false;
}
function $7bd48593473bea18$var$updateHOCHostEl(param, el) {
    var vnode = param.vnode, parent = param.parent;
    while(parent){
        var root = parent.subTree;
        if (root.suspense && root.suspense.activeBranch === vnode) root.el = vnode.el;
        if (root === vnode) {
            (vnode = parent.vnode).el = el;
            parent = parent.parent;
        } else break;
    }
}
var $7bd48593473bea18$var$COMPONENTS = "components";
var $7bd48593473bea18$var$DIRECTIVES = "directives";
function $7bd48593473bea18$export$681d65eec9d1d1e8(name, maybeSelfReference) {
    return $7bd48593473bea18$var$resolveAsset($7bd48593473bea18$var$COMPONENTS, name, true, maybeSelfReference) || name;
}
var $7bd48593473bea18$var$NULL_DYNAMIC_COMPONENT = Symbol.for("v-ndc");
function $7bd48593473bea18$export$b44c564a05ca975(component) {
    if ((0, $lbCQA.isString)(component)) return $7bd48593473bea18$var$resolveAsset($7bd48593473bea18$var$COMPONENTS, component, false) || component;
    else return component || $7bd48593473bea18$var$NULL_DYNAMIC_COMPONENT;
}
function $7bd48593473bea18$export$a1989e995cd481be(name) {
    return $7bd48593473bea18$var$resolveAsset($7bd48593473bea18$var$DIRECTIVES, name);
}
function $7bd48593473bea18$var$resolveAsset(type, name) {
    var warnMissing = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true, maybeSelfReference = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var instance = $7bd48593473bea18$var$currentRenderingInstance || $7bd48593473bea18$var$currentInstance;
    if (instance) {
        var Component = instance.type;
        if (type === $7bd48593473bea18$var$COMPONENTS) {
            var selfName = $7bd48593473bea18$var$getComponentName(Component, false);
            if (selfName && (selfName === name || selfName === (0, $lbCQA.camelize)(name) || selfName === (0, $lbCQA.capitalize)((0, $lbCQA.camelize)(name)))) return Component;
        }
        var res = // local registration
        // check instance[type] first which is resolved for options API
        $7bd48593473bea18$var$resolve(instance[type] || Component[type], name) || // global registration
        $7bd48593473bea18$var$resolve(instance.appContext[type], name);
        if (!res && maybeSelfReference) return Component;
        return res;
    }
}
function $7bd48593473bea18$var$resolve(registry, name) {
    return registry && (registry[name] || registry[(0, $lbCQA.camelize)(name)] || registry[(0, $lbCQA.capitalize)((0, $lbCQA.camelize)(name))]);
}
var $7bd48593473bea18$var$isSuspense = function(type) {
    return type.__isSuspense;
};
var $7bd48593473bea18$var$suspenseId = 0;
var $7bd48593473bea18$var$SuspenseImpl = {
    name: "Suspense",
    // In order to make Suspense tree-shakable, we need to avoid importing it
    // directly in the renderer. The renderer checks for the __isSuspense flag
    // on a vnode's type and calls the `process` method, passing in renderer
    // internals.
    __isSuspense: true,
    process: function(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals) {
        if (n1 == null) $7bd48593473bea18$var$mountSuspense(n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals);
        else {
            if (parentSuspense && parentSuspense.deps > 0 && !n1.suspense.isInFallback) {
                n2.suspense = n1.suspense;
                n2.suspense.vnode = n2;
                n2.el = n1.el;
                return;
            }
            $7bd48593473bea18$var$patchSuspense(n1, n2, container, anchor, parentComponent, namespace, slotScopeIds, optimized, rendererInternals);
        }
    },
    hydrate: $7bd48593473bea18$var$hydrateSuspense,
    create: $7bd48593473bea18$var$createSuspenseBoundary,
    normalize: $7bd48593473bea18$var$normalizeSuspenseChildren
};
var $7bd48593473bea18$export$74bf444e3cd11ea5 = $7bd48593473bea18$var$SuspenseImpl;
function $7bd48593473bea18$var$triggerEvent(vnode, name) {
    var eventListener = vnode.props && vnode.props[name];
    if ((0, $lbCQA.isFunction)(eventListener)) eventListener();
}
function $7bd48593473bea18$var$mountSuspense(vnode, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals) {
    var patch = rendererInternals.p, createElement = rendererInternals.o.createElement;
    var hiddenContainer = createElement("div");
    var suspense = vnode.suspense = $7bd48593473bea18$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, container, hiddenContainer, anchor, namespace, slotScopeIds, optimized, rendererInternals);
    patch(null, suspense.pendingBranch = vnode.ssContent, hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds);
    if (suspense.deps > 0) {
        $7bd48593473bea18$var$triggerEvent(vnode, "onPending");
        $7bd48593473bea18$var$triggerEvent(vnode, "onFallback");
        patch(null, vnode.ssFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
        namespace, slotScopeIds);
        $7bd48593473bea18$var$setActiveBranch(suspense, vnode.ssFallback);
    } else suspense.resolve(false, true);
}
function $7bd48593473bea18$var$patchSuspense(n1, n2, container, anchor, parentComponent, namespace, slotScopeIds, optimized, param) {
    var patch = param.p, unmount = param.um, createElement = param.o.createElement;
    var suspense = n2.suspense = n1.suspense;
    suspense.vnode = n2;
    n2.el = n1.el;
    var newBranch = n2.ssContent;
    var newFallback = n2.ssFallback;
    var activeBranch = suspense.activeBranch, pendingBranch = suspense.pendingBranch, isInFallback = suspense.isInFallback, isHydrating = suspense.isHydrating;
    if (pendingBranch) {
        suspense.pendingBranch = newBranch;
        if ($7bd48593473bea18$var$isSameVNodeType(newBranch, pendingBranch)) {
            patch(pendingBranch, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
            if (suspense.deps <= 0) suspense.resolve();
            else if (isInFallback) {
                if (!isHydrating) {
                    patch(activeBranch, newFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
                    namespace, slotScopeIds, optimized);
                    $7bd48593473bea18$var$setActiveBranch(suspense, newFallback);
                }
            }
        } else {
            suspense.pendingId = $7bd48593473bea18$var$suspenseId++;
            if (isHydrating) {
                suspense.isHydrating = false;
                suspense.activeBranch = pendingBranch;
            } else unmount(pendingBranch, parentComponent, suspense);
            suspense.deps = 0;
            suspense.effects.length = 0;
            suspense.hiddenContainer = createElement("div");
            if (isInFallback) {
                patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
                if (suspense.deps <= 0) suspense.resolve();
                else {
                    patch(activeBranch, newFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
                    namespace, slotScopeIds, optimized);
                    $7bd48593473bea18$var$setActiveBranch(suspense, newFallback);
                }
            } else if (activeBranch && $7bd48593473bea18$var$isSameVNodeType(newBranch, activeBranch)) {
                patch(activeBranch, newBranch, container, anchor, parentComponent, suspense, namespace, slotScopeIds, optimized);
                suspense.resolve(true);
            } else {
                patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
                if (suspense.deps <= 0) suspense.resolve();
            }
        }
    } else if (activeBranch && $7bd48593473bea18$var$isSameVNodeType(newBranch, activeBranch)) {
        patch(activeBranch, newBranch, container, anchor, parentComponent, suspense, namespace, slotScopeIds, optimized);
        $7bd48593473bea18$var$setActiveBranch(suspense, newBranch);
    } else {
        $7bd48593473bea18$var$triggerEvent(n2, "onPending");
        suspense.pendingBranch = newBranch;
        if (newBranch.shapeFlag & 512) suspense.pendingId = newBranch.component.suspenseId;
        else suspense.pendingId = $7bd48593473bea18$var$suspenseId++;
        patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
        if (suspense.deps <= 0) suspense.resolve();
        else {
            var timeout = suspense.timeout, pendingId = suspense.pendingId;
            if (timeout > 0) setTimeout(function() {
                if (suspense.pendingId === pendingId) suspense.fallback(newFallback);
            }, timeout);
            else if (timeout === 0) suspense.fallback(newFallback);
        }
    }
}
var $7bd48593473bea18$var$hasWarned = false;
function $7bd48593473bea18$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, container, hiddenContainer, anchor, namespace, slotScopeIds, optimized, rendererInternals) {
    var isHydrating = arguments.length > 10 && arguments[10] !== void 0 ? arguments[10] : false;
    var patch = rendererInternals.p, move = rendererInternals.m, unmount = rendererInternals.um, next = rendererInternals.n, _rendererInternals_o = rendererInternals.o, parentNode = _rendererInternals_o.parentNode, remove = _rendererInternals_o.remove;
    var parentSuspenseId;
    var isSuspensible = $7bd48593473bea18$var$isVNodeSuspensible(vnode);
    if (isSuspensible) {
        if (parentSuspense == null ? void 0 : parentSuspense.pendingBranch) {
            parentSuspenseId = parentSuspense.pendingId;
            parentSuspense.deps++;
        }
    }
    var timeout = vnode.props ? (0, $lbCQA.toNumber)(vnode.props.timeout) : void 0;
    var initialAnchor = anchor;
    var suspense = {
        vnode: vnode,
        parent: parentSuspense,
        parentComponent: parentComponent,
        namespace: namespace,
        container: container,
        hiddenContainer: hiddenContainer,
        deps: 0,
        pendingId: $7bd48593473bea18$var$suspenseId++,
        timeout: typeof timeout === "number" ? timeout : -1,
        activeBranch: null,
        pendingBranch: null,
        isInFallback: !isHydrating,
        isHydrating: isHydrating,
        isUnmounted: false,
        effects: [],
        resolve: function() {
            var resume = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, sync = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
            var vnode2 = suspense.vnode, activeBranch = suspense.activeBranch, pendingBranch = suspense.pendingBranch, pendingId = suspense.pendingId, effects = suspense.effects, parentComponent2 = suspense.parentComponent, container2 = suspense.container;
            var delayEnter = false;
            if (suspense.isHydrating) suspense.isHydrating = false;
            else if (!resume) {
                delayEnter = activeBranch && pendingBranch.transition && pendingBranch.transition.mode === "out-in";
                if (delayEnter) activeBranch.transition.afterLeave = function() {
                    if (pendingId === suspense.pendingId) {
                        move(pendingBranch, container2, anchor === initialAnchor ? next(activeBranch) : anchor, 0);
                        $7bd48593473bea18$export$59536a0199721cab(effects);
                    }
                };
                if (activeBranch) {
                    if (parentNode(activeBranch.el) !== suspense.hiddenContainer) anchor = next(activeBranch);
                    unmount(activeBranch, parentComponent2, suspense, true);
                }
                if (!delayEnter) move(pendingBranch, container2, anchor, 0);
            }
            $7bd48593473bea18$var$setActiveBranch(suspense, pendingBranch);
            suspense.pendingBranch = null;
            suspense.isInFallback = false;
            var parent = suspense.parent;
            var hasUnresolvedAncestor = false;
            while(parent){
                if (parent.pendingBranch) {
                    var _parent_effects;
                    (_parent_effects = parent.effects).push.apply(_parent_effects, (0, $79xu7._)(effects));
                    hasUnresolvedAncestor = true;
                    break;
                }
                parent = parent.parent;
            }
            if (!hasUnresolvedAncestor && !delayEnter) $7bd48593473bea18$export$59536a0199721cab(effects);
            suspense.effects = [];
            if (isSuspensible) {
                if (parentSuspense && parentSuspense.pendingBranch && parentSuspenseId === parentSuspense.pendingId) {
                    parentSuspense.deps--;
                    if (parentSuspense.deps === 0 && !sync) parentSuspense.resolve();
                }
            }
            $7bd48593473bea18$var$triggerEvent(vnode2, "onResolve");
        },
        fallback: function(fallbackVNode) {
            if (!suspense.pendingBranch) return;
            var vnode2 = suspense.vnode, activeBranch = suspense.activeBranch, parentComponent2 = suspense.parentComponent, container2 = suspense.container, namespace2 = suspense.namespace;
            $7bd48593473bea18$var$triggerEvent(vnode2, "onFallback");
            var anchor2 = next(activeBranch);
            var mountFallback = function() {
                if (!suspense.isInFallback) return;
                patch(null, fallbackVNode, container2, anchor2, parentComponent2, null, // fallback tree will not have suspense context
                namespace2, slotScopeIds, optimized);
                $7bd48593473bea18$var$setActiveBranch(suspense, fallbackVNode);
            };
            var delayEnter = fallbackVNode.transition && fallbackVNode.transition.mode === "out-in";
            if (delayEnter) activeBranch.transition.afterLeave = mountFallback;
            suspense.isInFallback = true;
            unmount(activeBranch, parentComponent2, null, // no suspense so unmount hooks fire now
            true);
            if (!delayEnter) mountFallback();
        },
        move: function(container2, anchor2, type) {
            suspense.activeBranch && move(suspense.activeBranch, container2, anchor2, type);
            suspense.container = container2;
        },
        next: function() {
            return suspense.activeBranch && next(suspense.activeBranch);
        },
        registerDep: function(instance, setupRenderEffect) {
            var isInPendingSuspense = !!suspense.pendingBranch;
            if (isInPendingSuspense) suspense.deps++;
            var hydratedEl = instance.vnode.el;
            instance.asyncDep.catch(function(err) {
                $7bd48593473bea18$export$d3da1ecaf1206c58(err, instance, 0);
            }).then(function(asyncSetupResult) {
                if (instance.isUnmounted || suspense.isUnmounted || suspense.pendingId !== instance.suspenseId) return;
                instance.asyncResolved = true;
                var vnode2 = instance.vnode;
                $7bd48593473bea18$var$handleSetupResult(instance, asyncSetupResult, false);
                if (hydratedEl) vnode2.el = hydratedEl;
                var placeholder = !hydratedEl && instance.subTree.el;
                setupRenderEffect(instance, vnode2, // component may have been moved before resolve.
                // if this is not a hydration, instance.subTree will be the comment
                // placeholder.
                parentNode(hydratedEl || instance.subTree.el), // anchor will not be used if this is hydration, so only need to
                // consider the comment placeholder case.
                hydratedEl ? null : next(instance.subTree), suspense, namespace, optimized);
                if (placeholder) remove(placeholder);
                $7bd48593473bea18$var$updateHOCHostEl(instance, vnode2.el);
                if (isInPendingSuspense && --suspense.deps === 0) suspense.resolve();
            });
        },
        unmount: function(parentSuspense2, doRemove) {
            suspense.isUnmounted = true;
            if (suspense.activeBranch) unmount(suspense.activeBranch, parentComponent, parentSuspense2, doRemove);
            if (suspense.pendingBranch) unmount(suspense.pendingBranch, parentComponent, parentSuspense2, doRemove);
        }
    };
    return suspense;
}
function $7bd48593473bea18$var$hydrateSuspense(node, vnode, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals, hydrateNode) {
    var suspense = vnode.suspense = $7bd48593473bea18$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, node.parentNode, // eslint-disable-next-line no-restricted-globals
    document.createElement("div"), null, namespace, slotScopeIds, optimized, rendererInternals, true);
    var result = hydrateNode(node, suspense.pendingBranch = vnode.ssContent, parentComponent, suspense, slotScopeIds, optimized);
    if (suspense.deps === 0) suspense.resolve(false, true);
    return result;
}
function $7bd48593473bea18$var$normalizeSuspenseChildren(vnode) {
    var shapeFlag = vnode.shapeFlag, children = vnode.children;
    var isSlotChildren = shapeFlag & 32;
    vnode.ssContent = $7bd48593473bea18$var$normalizeSuspenseSlot(isSlotChildren ? children.default : children);
    vnode.ssFallback = isSlotChildren ? $7bd48593473bea18$var$normalizeSuspenseSlot(children.fallback) : $7bd48593473bea18$export$bf5c4cf060303d58($7bd48593473bea18$export$4d299b491347818a);
}
function $7bd48593473bea18$var$normalizeSuspenseSlot(s) {
    var block;
    if ((0, $lbCQA.isFunction)(s)) {
        var trackBlock = $7bd48593473bea18$var$isBlockTreeEnabled && s._c;
        if (trackBlock) {
            s._d = false;
            $7bd48593473bea18$export$e7eaa45e502fe5cc();
        }
        s = s();
        if (trackBlock) {
            s._d = true;
            block = $7bd48593473bea18$var$currentBlock;
            $7bd48593473bea18$var$closeBlock();
        }
    }
    if ((0, $lbCQA.isArray)(s)) {
        var singleChild = $7bd48593473bea18$var$filterSingleRoot(s);
        s = singleChild;
    }
    s = $7bd48593473bea18$var$normalizeVNode(s);
    if (block && !s.dynamicChildren) s.dynamicChildren = block.filter(function(c) {
        return c !== s;
    });
    return s;
}
function $7bd48593473bea18$var$queueEffectWithSuspense(fn, suspense) {
    if (suspense && suspense.pendingBranch) {
        var _suspense_effects;
        if ((0, $lbCQA.isArray)(fn)) (_suspense_effects = suspense.effects).push.apply(_suspense_effects, (0, $79xu7._)(fn));
        else suspense.effects.push(fn);
    } else $7bd48593473bea18$export$59536a0199721cab(fn);
}
function $7bd48593473bea18$var$setActiveBranch(suspense, branch) {
    suspense.activeBranch = branch;
    var vnode = suspense.vnode, parentComponent = suspense.parentComponent;
    var el = branch.el;
    while(!el && branch.component){
        branch = branch.component.subTree;
        el = branch.el;
    }
    vnode.el = el;
    if (parentComponent && parentComponent.subTree === vnode) {
        parentComponent.vnode.el = el;
        $7bd48593473bea18$var$updateHOCHostEl(parentComponent, el);
    }
}
function $7bd48593473bea18$var$isVNodeSuspensible(vnode) {
    var _a;
    return ((_a = vnode.props) == null ? void 0 : _a.suspensible) != null && vnode.props.suspensible !== false;
}
var $7bd48593473bea18$export$f2549a27e18acf2d = Symbol.for("v-scx");
var $7bd48593473bea18$export$6b1c54dc4befcda = function() {
    {
        var ctx = $7bd48593473bea18$export$a976684a0efeb93f($7bd48593473bea18$export$f2549a27e18acf2d);
        ctx;
        return ctx;
    }
};
function $7bd48593473bea18$export$ede35fc0e5500309(effect, options) {
    return $7bd48593473bea18$var$doWatch(effect, null, options);
}
function $7bd48593473bea18$export$b7f27ea67102d543(effect, options) {
    return $7bd48593473bea18$var$doWatch(effect, null, {
        flush: "post"
    });
}
function $7bd48593473bea18$export$2035654f31b0e555(effect, options) {
    return $7bd48593473bea18$var$doWatch(effect, null, {
        flush: "sync"
    });
}
var $7bd48593473bea18$var$INITIAL_WATCHER_VALUE = {};
function $7bd48593473bea18$export$3db5d71bdb2d5499(source, cb, options) {
    return $7bd48593473bea18$var$doWatch(source, cb, options);
}
function $7bd48593473bea18$var$doWatch(source, cb) {
    var _ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : (0, $lbCQA.EMPTY_OBJ), immediate = _ref.immediate, deep = _ref.deep, flush = _ref.flush, once = _ref.once, onTrack = _ref.onTrack, onTrigger = _ref.onTrigger;
    if (cb && once) {
        var _cb = cb;
        cb = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            _cb.apply(void 0, (0, $79xu7._)(args));
            unwatch();
        };
    }
    var warnInvalidSource = function(s) {
        $7bd48593473bea18$var$warn$1("Invalid watch source: ", s, "A watch source can only be a getter/effect function, a ref, a reactive object, or an array of these types.");
    };
    var instance = $7bd48593473bea18$var$currentInstance;
    var reactiveGetter = function(source2) {
        return deep === true ? source2 : // for deep: false, only traverse root-level properties
        $7bd48593473bea18$var$traverse(source2, deep === false ? 1 : void 0);
    };
    var getter;
    var forceTrigger = false;
    var isMultiSource = false;
    if ((0, $aAzpa.isRef)(source)) {
        getter = function() {
            return source.value;
        };
        forceTrigger = (0, $aAzpa.isShallow)(source);
    } else if ((0, $aAzpa.isReactive)(source)) {
        getter = function() {
            return reactiveGetter(source);
        };
        forceTrigger = true;
    } else if ((0, $lbCQA.isArray)(source)) {
        isMultiSource = true;
        forceTrigger = source.some(function(s) {
            return (0, $aAzpa.isReactive)(s) || (0, $aAzpa.isShallow)(s);
        });
        getter = function() {
            return source.map(function(s) {
                if ((0, $aAzpa.isRef)(s)) return s.value;
                else if ((0, $aAzpa.isReactive)(s)) return reactiveGetter(s);
                else if ((0, $lbCQA.isFunction)(s)) return $7bd48593473bea18$export$b22fcaf88446e9bf(s, instance, 2);
            });
        };
    } else if ((0, $lbCQA.isFunction)(source)) {
        if (cb) getter = function() {
            return $7bd48593473bea18$export$b22fcaf88446e9bf(source, instance, 2);
        };
        else getter = function() {
            if (cleanup) cleanup();
            return $7bd48593473bea18$export$dae85862a8d94378(source, instance, 3, [
                onCleanup
            ]);
        };
    } else getter = (0, $lbCQA.NOOP);
    if (cb && deep) {
        var baseGetter = getter;
        getter = function() {
            return $7bd48593473bea18$var$traverse(baseGetter());
        };
    }
    var cleanup;
    var onCleanup = function(fn) {
        cleanup = effect.onStop = function() {
            $7bd48593473bea18$export$b22fcaf88446e9bf(fn, instance, 4);
            cleanup = effect.onStop = void 0;
        };
    };
    var ssrCleanup;
    if ($7bd48593473bea18$var$isInSSRComponentSetup) {
        onCleanup = (0, $lbCQA.NOOP);
        if (!cb) getter();
        else if (immediate) $7bd48593473bea18$export$dae85862a8d94378(cb, instance, 3, [
            getter(),
            isMultiSource ? [] : void 0,
            onCleanup
        ]);
        if (flush === "sync") {
            var ctx = $7bd48593473bea18$export$6b1c54dc4befcda();
            ssrCleanup = ctx.__watcherHandles || (ctx.__watcherHandles = []);
        } else return 0, $lbCQA.NOOP;
    }
    var oldValue = isMultiSource ? new Array(source.length).fill($7bd48593473bea18$var$INITIAL_WATCHER_VALUE) : $7bd48593473bea18$var$INITIAL_WATCHER_VALUE;
    var job = function() {
        if (!effect.active || !effect.dirty) return;
        if (cb) {
            var newValue = effect.run();
            if (deep || forceTrigger || (isMultiSource ? newValue.some(function(v1, i) {
                return (0, $lbCQA.hasChanged)(v1, oldValue[i]);
            }) : (0, $lbCQA.hasChanged)(newValue, oldValue)) || false) {
                if (cleanup) cleanup();
                $7bd48593473bea18$export$dae85862a8d94378(cb, instance, 3, [
                    newValue,
                    // pass undefined as the old value when it's changed for the first time
                    oldValue === $7bd48593473bea18$var$INITIAL_WATCHER_VALUE ? void 0 : isMultiSource && oldValue[0] === $7bd48593473bea18$var$INITIAL_WATCHER_VALUE ? [] : oldValue,
                    onCleanup
                ]);
                oldValue = newValue;
            }
        } else effect.run();
    };
    job.allowRecurse = !!cb;
    var scheduler;
    if (flush === "sync") scheduler = job;
    else if (flush === "post") scheduler = function() {
        return $7bd48593473bea18$var$queuePostRenderEffect(job, instance && instance.suspense);
    };
    else {
        job.pre = true;
        if (instance) job.id = instance.uid;
        scheduler = function() {
            return $7bd48593473bea18$var$queueJob(job);
        };
    }
    var effect = new (0, $aAzpa.ReactiveEffect)(getter, (0, $lbCQA.NOOP), scheduler);
    var scope = (0, $aAzpa.getCurrentScope)();
    var unwatch = function() {
        effect.stop();
        if (scope) (0, $lbCQA.remove)(scope.effects, effect);
    };
    if (cb) {
        if (immediate) job();
        else oldValue = effect.run();
    } else if (flush === "post") $7bd48593473bea18$var$queuePostRenderEffect(effect.run.bind(effect), instance && instance.suspense);
    else effect.run();
    if (ssrCleanup) ssrCleanup.push(unwatch);
    return unwatch;
}
function $7bd48593473bea18$var$instanceWatch(source, value, options) {
    var publicThis = this.proxy;
    var getter = (0, $lbCQA.isString)(source) ? source.includes(".") ? $7bd48593473bea18$var$createPathGetter(publicThis, source) : function() {
        return publicThis[source];
    } : source.bind(publicThis, publicThis);
    var cb;
    if ((0, $lbCQA.isFunction)(value)) cb = value;
    else {
        cb = value.handler;
        options = value;
    }
    var reset = $7bd48593473bea18$var$setCurrentInstance(this);
    var res = $7bd48593473bea18$var$doWatch(getter, cb.bind(publicThis), options);
    reset();
    return res;
}
function $7bd48593473bea18$var$createPathGetter(ctx, path) {
    var segments = path.split(".");
    return function() {
        var cur = ctx;
        for(var i = 0; i < segments.length && cur; i++)cur = cur[segments[i]];
        return cur;
    };
}
function $7bd48593473bea18$var$traverse(value, depth) {
    var currentDepth = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, seen = arguments.length > 3 ? arguments[3] : void 0;
    if (!(0, $lbCQA.isObject)(value) || value["__v_skip"]) return value;
    if (depth && depth > 0) {
        if (currentDepth >= depth) return value;
        currentDepth++;
    }
    seen = seen || /* @__PURE__ */ new Set();
    if (seen.has(value)) return value;
    seen.add(value);
    if ((0, $aAzpa.isRef)(value)) $7bd48593473bea18$var$traverse(value.value, depth, currentDepth, seen);
    else if ((0, $lbCQA.isArray)(value)) for(var i = 0; i < value.length; i++)$7bd48593473bea18$var$traverse(value[i], depth, currentDepth, seen);
    else if ((0, $lbCQA.isSet)(value) || (0, $lbCQA.isMap)(value)) value.forEach(function(v1) {
        $7bd48593473bea18$var$traverse(v1, depth, currentDepth, seen);
    });
    else if ((0, $lbCQA.isPlainObject)(value)) for(var key in value)$7bd48593473bea18$var$traverse(value[key], depth, currentDepth, seen);
    return value;
}
function $7bd48593473bea18$var$validateDirectiveName(name) {
    if ((0, $lbCQA.isBuiltInDirective)(name)) $7bd48593473bea18$var$warn$1("Do not use built-in directive ids as custom directive id: " + name);
}
function $7bd48593473bea18$export$49729353e7c1e6c5(vnode, directives) {
    if ($7bd48593473bea18$var$currentRenderingInstance === null) return vnode;
    var instance = $7bd48593473bea18$var$getExposeProxy($7bd48593473bea18$var$currentRenderingInstance) || $7bd48593473bea18$var$currentRenderingInstance.proxy;
    var bindings = vnode.dirs || (vnode.dirs = []);
    for(var i = 0; i < directives.length; i++){
        var _directives_i = (0, $4f96i._)(directives[i], 4), dir = _directives_i[0], value = _directives_i[1], arg = _directives_i[2], tmp = _directives_i[3], modifiers = tmp === void 0 ? (0, $lbCQA.EMPTY_OBJ) : tmp;
        if (dir) {
            if ((0, $lbCQA.isFunction)(dir)) dir = {
                mounted: dir,
                updated: dir
            };
            if (dir.deep) $7bd48593473bea18$var$traverse(value);
            bindings.push({
                dir: dir,
                instance: instance,
                value: value,
                oldValue: void 0,
                arg: arg,
                modifiers: modifiers
            });
        }
    }
    return vnode;
}
function $7bd48593473bea18$var$invokeDirectiveHook(vnode, prevVNode, instance, name) {
    var bindings = vnode.dirs;
    var oldBindings = prevVNode && prevVNode.dirs;
    for(var i = 0; i < bindings.length; i++){
        var binding = bindings[i];
        if (oldBindings) binding.oldValue = oldBindings[i].value;
        var hook = binding.dir[name];
        if (hook) {
            (0, $aAzpa.pauseTracking)();
            $7bd48593473bea18$export$dae85862a8d94378(hook, instance, 8, [
                vnode.el,
                binding,
                vnode,
                prevVNode
            ]);
            (0, $aAzpa.resetTracking)();
        }
    }
}
var $7bd48593473bea18$var$leaveCbKey = Symbol("_leaveCb");
var $7bd48593473bea18$var$enterCbKey = Symbol("_enterCb");
function $7bd48593473bea18$export$d2a0a1bc267c90f6() {
    var state = {
        isMounted: false,
        isLeaving: false,
        isUnmounting: false,
        leavingVNodes: /* @__PURE__ */ new Map()
    };
    $7bd48593473bea18$export$6d1641039221b5cb(function() {
        state.isMounted = true;
    });
    $7bd48593473bea18$export$40c420df62d2614(function() {
        state.isUnmounting = true;
    });
    return state;
}
var $7bd48593473bea18$var$TransitionHookValidator = [
    Function,
    Array
];
var $7bd48593473bea18$export$b876c99684f8cf3b = {
    mode: String,
    appear: Boolean,
    persisted: Boolean,
    // enter
    onBeforeEnter: $7bd48593473bea18$var$TransitionHookValidator,
    onEnter: $7bd48593473bea18$var$TransitionHookValidator,
    onAfterEnter: $7bd48593473bea18$var$TransitionHookValidator,
    onEnterCancelled: $7bd48593473bea18$var$TransitionHookValidator,
    // leave
    onBeforeLeave: $7bd48593473bea18$var$TransitionHookValidator,
    onLeave: $7bd48593473bea18$var$TransitionHookValidator,
    onAfterLeave: $7bd48593473bea18$var$TransitionHookValidator,
    onLeaveCancelled: $7bd48593473bea18$var$TransitionHookValidator,
    // appear
    onBeforeAppear: $7bd48593473bea18$var$TransitionHookValidator,
    onAppear: $7bd48593473bea18$var$TransitionHookValidator,
    onAfterAppear: $7bd48593473bea18$var$TransitionHookValidator,
    onAppearCancelled: $7bd48593473bea18$var$TransitionHookValidator
};
var $7bd48593473bea18$var$BaseTransitionImpl = {
    name: "BaseTransition",
    props: $7bd48593473bea18$export$b876c99684f8cf3b,
    setup: function(props, param) {
        var slots = param.slots;
        var instance = $7bd48593473bea18$export$f13e630aa3915748();
        var state = $7bd48593473bea18$export$d2a0a1bc267c90f6();
        return function() {
            var children = slots.default && $7bd48593473bea18$export$a67f9b1229c7c97a(slots.default(), true);
            if (!children || !children.length) return;
            var child = children[0];
            if (children.length > 1) {
                var hasFound = false;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var c = _step.value;
                        if (c.type !== $7bd48593473bea18$export$4d299b491347818a) {
                            child = c;
                            hasFound = true;
                            break;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
            var rawProps = (0, $aAzpa.toRaw)(props);
            var mode = rawProps.mode;
            if (state.isLeaving) return $7bd48593473bea18$var$emptyPlaceholder(child);
            var innerChild = $7bd48593473bea18$var$getKeepAliveChild(child);
            if (!innerChild) return $7bd48593473bea18$var$emptyPlaceholder(child);
            var enterHooks = $7bd48593473bea18$export$76ac1779589cd824(innerChild, rawProps, state, instance);
            $7bd48593473bea18$export$7770a22486565649(innerChild, enterHooks);
            var oldChild = instance.subTree;
            var oldInnerChild = oldChild && $7bd48593473bea18$var$getKeepAliveChild(oldChild);
            if (oldInnerChild && oldInnerChild.type !== $7bd48593473bea18$export$4d299b491347818a && !$7bd48593473bea18$var$isSameVNodeType(innerChild, oldInnerChild)) {
                var leavingHooks = $7bd48593473bea18$export$76ac1779589cd824(oldInnerChild, rawProps, state, instance);
                $7bd48593473bea18$export$7770a22486565649(oldInnerChild, leavingHooks);
                if (mode === "out-in") {
                    state.isLeaving = true;
                    leavingHooks.afterLeave = function() {
                        state.isLeaving = false;
                        if (instance.update.active !== false) {
                            instance.effect.dirty = true;
                            instance.update();
                        }
                    };
                    return $7bd48593473bea18$var$emptyPlaceholder(child);
                } else if (mode === "in-out" && innerChild.type !== $7bd48593473bea18$export$4d299b491347818a) leavingHooks.delayLeave = function(el, earlyRemove, delayedLeave) {
                    var leavingVNodesCache = $7bd48593473bea18$var$getLeavingNodesForType(state, oldInnerChild);
                    leavingVNodesCache[String(oldInnerChild.key)] = oldInnerChild;
                    el[$7bd48593473bea18$var$leaveCbKey] = function() {
                        earlyRemove();
                        el[$7bd48593473bea18$var$leaveCbKey] = void 0;
                        delete enterHooks.delayedLeave;
                    };
                    enterHooks.delayedLeave = delayedLeave;
                };
            }
            return child;
        };
    }
};
var $7bd48593473bea18$export$abd95b5f5e8a8837 = $7bd48593473bea18$var$BaseTransitionImpl;
function $7bd48593473bea18$var$getLeavingNodesForType(state, vnode) {
    var leavingVNodes = state.leavingVNodes;
    var leavingVNodesCache = leavingVNodes.get(vnode.type);
    if (!leavingVNodesCache) {
        leavingVNodesCache = /* @__PURE__ */ Object.create(null);
        leavingVNodes.set(vnode.type, leavingVNodesCache);
    }
    return leavingVNodesCache;
}
function $7bd48593473bea18$export$76ac1779589cd824(vnode, props, state, instance) {
    var appear = props.appear, mode = props.mode, _props_persisted = props.persisted, persisted = _props_persisted === void 0 ? false : _props_persisted, onBeforeEnter = props.onBeforeEnter, onEnter = props.onEnter, onAfterEnter = props.onAfterEnter, onEnterCancelled = props.onEnterCancelled, onBeforeLeave = props.onBeforeLeave, onLeave = props.onLeave, onAfterLeave = props.onAfterLeave, onLeaveCancelled = props.onLeaveCancelled, onBeforeAppear = props.onBeforeAppear, onAppear = props.onAppear, onAfterAppear = props.onAfterAppear, onAppearCancelled = props.onAppearCancelled;
    var key = String(vnode.key);
    var leavingVNodesCache = $7bd48593473bea18$var$getLeavingNodesForType(state, vnode);
    var callHook = function(hook, args) {
        hook && $7bd48593473bea18$export$dae85862a8d94378(hook, instance, 9, args);
    };
    var callAsyncHook = function(hook, args) {
        var done = args[1];
        callHook(hook, args);
        if ((0, $lbCQA.isArray)(hook)) {
            if (hook.every(function(hook2) {
                return hook2.length <= 1;
            })) done();
        } else if (hook.length <= 1) done();
    };
    var hooks = {
        mode: mode,
        persisted: persisted,
        beforeEnter: function(el) {
            var hook = onBeforeEnter;
            if (!state.isMounted) {
                if (appear) hook = onBeforeAppear || onBeforeEnter;
                else return;
            }
            if (el[$7bd48593473bea18$var$leaveCbKey]) el[$7bd48593473bea18$var$leaveCbKey](true);
            var leavingVNode = leavingVNodesCache[key];
            if (leavingVNode && $7bd48593473bea18$var$isSameVNodeType(vnode, leavingVNode) && leavingVNode.el[$7bd48593473bea18$var$leaveCbKey]) leavingVNode.el[$7bd48593473bea18$var$leaveCbKey]();
            callHook(hook, [
                el
            ]);
        },
        enter: function(el) {
            var hook = onEnter;
            var afterHook = onAfterEnter;
            var cancelHook = onEnterCancelled;
            if (!state.isMounted) {
                if (appear) {
                    hook = onAppear || onEnter;
                    afterHook = onAfterAppear || onAfterEnter;
                    cancelHook = onAppearCancelled || onEnterCancelled;
                } else return;
            }
            var called = false;
            var done = el[$7bd48593473bea18$var$enterCbKey] = function(cancelled) {
                if (called) return;
                called = true;
                if (cancelled) callHook(cancelHook, [
                    el
                ]);
                else callHook(afterHook, [
                    el
                ]);
                if (hooks.delayedLeave) hooks.delayedLeave();
                el[$7bd48593473bea18$var$enterCbKey] = void 0;
            };
            if (hook) callAsyncHook(hook, [
                el,
                done
            ]);
            else done();
        },
        leave: function(el, remove) {
            var key2 = String(vnode.key);
            if (el[$7bd48593473bea18$var$enterCbKey]) el[$7bd48593473bea18$var$enterCbKey](true);
            if (state.isUnmounting) return remove();
            callHook(onBeforeLeave, [
                el
            ]);
            var called = false;
            var done = el[$7bd48593473bea18$var$leaveCbKey] = function(cancelled) {
                if (called) return;
                called = true;
                remove();
                if (cancelled) callHook(onLeaveCancelled, [
                    el
                ]);
                else callHook(onAfterLeave, [
                    el
                ]);
                el[$7bd48593473bea18$var$leaveCbKey] = void 0;
                if (leavingVNodesCache[key2] === vnode) delete leavingVNodesCache[key2];
            };
            leavingVNodesCache[key2] = vnode;
            if (onLeave) callAsyncHook(onLeave, [
                el,
                done
            ]);
            else done();
        },
        clone: function(vnode2) {
            return $7bd48593473bea18$export$76ac1779589cd824(vnode2, props, state, instance);
        }
    };
    return hooks;
}
function $7bd48593473bea18$var$emptyPlaceholder(vnode) {
    if ($7bd48593473bea18$var$isKeepAlive(vnode)) {
        vnode = $7bd48593473bea18$export$ee4f9e12c0a92a1a(vnode);
        vnode.children = null;
        return vnode;
    }
}
function $7bd48593473bea18$var$getKeepAliveChild(vnode) {
    if (!$7bd48593473bea18$var$isKeepAlive(vnode)) return vnode;
    var shapeFlag = vnode.shapeFlag, children = vnode.children;
    if (children) {
        if (shapeFlag & 16) return children[0];
        if (shapeFlag & 32 && (0, $lbCQA.isFunction)(children.default)) return children.default();
    }
}
function $7bd48593473bea18$export$7770a22486565649(vnode, hooks) {
    if (vnode.shapeFlag & 6 && vnode.component) $7bd48593473bea18$export$7770a22486565649(vnode.component.subTree, hooks);
    else if (vnode.shapeFlag & 128) {
        vnode.ssContent.transition = hooks.clone(vnode.ssContent);
        vnode.ssFallback.transition = hooks.clone(vnode.ssFallback);
    } else vnode.transition = hooks;
}
function $7bd48593473bea18$export$a67f9b1229c7c97a(children) {
    var keepComment = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, parentKey = arguments.length > 2 ? arguments[2] : void 0;
    var ret = [];
    var keyedFragmentCount = 0;
    for(var i = 0; i < children.length; i++){
        var child = children[i];
        var key = parentKey == null ? child.key : String(parentKey) + String(child.key != null ? child.key : i);
        if (child.type === $7bd48593473bea18$export$ffb0004e005737fa) {
            if (child.patchFlag & 128) keyedFragmentCount++;
            ret = ret.concat($7bd48593473bea18$export$a67f9b1229c7c97a(child.children, keepComment, key));
        } else if (keepComment || child.type !== $7bd48593473bea18$export$4d299b491347818a) ret.push(key != null ? $7bd48593473bea18$export$ee4f9e12c0a92a1a(child, {
            key: key
        }) : child);
    }
    if (keyedFragmentCount > 1) for(var i1 = 0; i1 < ret.length; i1++)ret[i1].patchFlag = -2;
    return ret;
}
/*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function $7bd48593473bea18$export$afa64b67e5a01c3b(options, extraOptions) {
    return (0, $lbCQA.isFunction)(options) ? // #8326: extend call and options.name access are considered side-effects
    // by Rollup, so we have to wrap it in a pure-annotated IIFE.
    /* @__PURE__ */ function() {
        return (0, $lbCQA.extend)({
            name: options.name
        }, extraOptions, {
            setup: options
        });
    }() : options;
}
var $7bd48593473bea18$var$isAsyncWrapper = function(i) {
    return !!i.type.__asyncLoader;
};
/*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function $7bd48593473bea18$export$d75d499b4c16cf21(source) {
    if ((0, $lbCQA.isFunction)(source)) source = {
        loader: source
    };
    var loader = source.loader, loadingComponent = source.loadingComponent, errorComponent = source.errorComponent, _source_delay = source.delay, delay = _source_delay === void 0 ? 200 : _source_delay, timeout = source.timeout, _source_suspensible = source.// undefined = never times out
    suspensible, suspensible = _source_suspensible === void 0 ? true : _source_suspensible, userOnError = source.onError;
    var pendingRequest = null;
    var resolvedComp;
    var retries = 0;
    var retry = function() {
        retries++;
        pendingRequest = null;
        return load();
    };
    var load = function() {
        var thisRequest;
        return pendingRequest || (thisRequest = pendingRequest = loader().catch(function(err) {
            err = err instanceof Error ? err : new Error(String(err));
            if (userOnError) return new Promise(function(resolve, reject) {
                var userRetry = function() {
                    return resolve(retry());
                };
                var userFail = function() {
                    return reject(err);
                };
                userOnError(err, userRetry, userFail, retries + 1);
            });
            else throw err;
        }).then(function(comp) {
            if (thisRequest !== pendingRequest && pendingRequest) return pendingRequest;
            if (comp && (comp.__esModule || comp[Symbol.toStringTag] === "Module")) comp = comp.default;
            resolvedComp = comp;
            return comp;
        }));
    };
    return $7bd48593473bea18$export$afa64b67e5a01c3b({
        name: "AsyncComponentWrapper",
        __asyncLoader: load,
        get __asyncResolved () {
            return resolvedComp;
        },
        setup: function() {
            var instance = $7bd48593473bea18$var$currentInstance;
            if (resolvedComp) return function() {
                return $7bd48593473bea18$var$createInnerComp(resolvedComp, instance);
            };
            var onError = function(err) {
                pendingRequest = null;
                $7bd48593473bea18$export$d3da1ecaf1206c58(err, instance, 13, !errorComponent);
            };
            if (suspensible && instance.suspense || $7bd48593473bea18$var$isInSSRComponentSetup) return load().then(function(comp) {
                return function() {
                    return $7bd48593473bea18$var$createInnerComp(comp, instance);
                };
            }).catch(function(err) {
                onError(err);
                return function() {
                    return errorComponent ? $7bd48593473bea18$export$bf5c4cf060303d58(errorComponent, {
                        error: err
                    }) : null;
                };
            });
            var loaded = (0, $aAzpa.ref)(false);
            var error = (0, $aAzpa.ref)();
            var delayed = (0, $aAzpa.ref)(!!delay);
            if (delay) setTimeout(function() {
                delayed.value = false;
            }, delay);
            if (timeout != null) setTimeout(function() {
                if (!loaded.value && !error.value) {
                    var err = new Error("Async component timed out after ".concat(timeout, "ms."));
                    onError(err);
                    error.value = err;
                }
            }, timeout);
            load().then(function() {
                loaded.value = true;
                if (instance.parent && $7bd48593473bea18$var$isKeepAlive(instance.parent.vnode)) {
                    instance.parent.effect.dirty = true;
                    $7bd48593473bea18$var$queueJob(instance.parent.update);
                }
            }).catch(function(err) {
                onError(err);
                error.value = err;
            });
            return function() {
                if (loaded.value && resolvedComp) return $7bd48593473bea18$var$createInnerComp(resolvedComp, instance);
                else if (error.value && errorComponent) return $7bd48593473bea18$export$bf5c4cf060303d58(errorComponent, {
                    error: error.value
                });
                else if (loadingComponent && !delayed.value) return $7bd48593473bea18$export$bf5c4cf060303d58(loadingComponent);
            };
        }
    });
}
function $7bd48593473bea18$var$createInnerComp(comp, parent) {
    var _parent_vnode = parent.vnode, ref2 = _parent_vnode.ref, props = _parent_vnode.props, children = _parent_vnode.children, ce = _parent_vnode.ce;
    var vnode = $7bd48593473bea18$export$bf5c4cf060303d58(comp, props, children);
    vnode.ref = ref2;
    vnode.ce = ce;
    delete parent.vnode.ce;
    return vnode;
}
var $7bd48593473bea18$var$isKeepAlive = function(vnode) {
    return vnode.type.__isKeepAlive;
};
var $7bd48593473bea18$var$KeepAliveImpl = {
    name: "KeepAlive",
    // Marker for special handling inside the renderer. We are not using a ===
    // check directly on KeepAlive in the renderer, because importing it directly
    // would prevent it from being tree-shaken.
    __isKeepAlive: true,
    props: {
        include: [
            String,
            RegExp,
            Array
        ],
        exclude: [
            String,
            RegExp,
            Array
        ],
        max: [
            String,
            Number
        ]
    },
    setup: function(props, param) {
        var slots = param.slots;
        var instance = $7bd48593473bea18$export$f13e630aa3915748();
        var sharedContext = instance.ctx;
        if (!sharedContext.renderer) return function() {
            var children = slots.default && slots.default();
            return children && children.length === 1 ? children[0] : children;
        };
        var cache = /* @__PURE__ */ new Map();
        var keys = /* @__PURE__ */ new Set();
        var current = null;
        if (__VUE_PROD_DEVTOOLS__) instance.__v_cache = cache;
        var parentSuspense = instance.suspense;
        var _sharedContext_renderer = sharedContext.renderer, patch = _sharedContext_renderer.p, move = _sharedContext_renderer.m, _unmount = _sharedContext_renderer.um, createElement = _sharedContext_renderer.o.createElement;
        var storageContainer = createElement("div");
        sharedContext.activate = function(vnode, container, anchor, namespace, optimized) {
            var instance2 = vnode.component;
            move(vnode, container, anchor, 0, parentSuspense);
            patch(instance2.vnode, vnode, container, anchor, instance2, parentSuspense, namespace, vnode.slotScopeIds, optimized);
            $7bd48593473bea18$var$queuePostRenderEffect(function() {
                instance2.isDeactivated = false;
                if (instance2.a) (0, $lbCQA.invokeArrayFns)(instance2.a);
                var vnodeHook = vnode.props && vnode.props.onVnodeMounted;
                if (vnodeHook) $7bd48593473bea18$var$invokeVNodeHook(vnodeHook, instance2.parent, vnode);
            }, parentSuspense);
            if (__VUE_PROD_DEVTOOLS__) $7bd48593473bea18$var$devtoolsComponentAdded(instance2);
        };
        sharedContext.deactivate = function(vnode) {
            var instance2 = vnode.component;
            move(vnode, storageContainer, null, 1, parentSuspense);
            $7bd48593473bea18$var$queuePostRenderEffect(function() {
                if (instance2.da) (0, $lbCQA.invokeArrayFns)(instance2.da);
                var vnodeHook = vnode.props && vnode.props.onVnodeUnmounted;
                if (vnodeHook) $7bd48593473bea18$var$invokeVNodeHook(vnodeHook, instance2.parent, vnode);
                instance2.isDeactivated = true;
            }, parentSuspense);
            if (__VUE_PROD_DEVTOOLS__) $7bd48593473bea18$var$devtoolsComponentAdded(instance2);
        };
        function unmount(vnode) {
            $7bd48593473bea18$var$resetShapeFlag(vnode);
            _unmount(vnode, instance, parentSuspense, true);
        }
        function pruneCache(filter) {
            cache.forEach(function(vnode, key) {
                var name = $7bd48593473bea18$var$getComponentName(vnode.type);
                if (name && (!filter || !filter(name))) pruneCacheEntry(key);
            });
        }
        function pruneCacheEntry(key) {
            var cached = cache.get(key);
            if (!current || !$7bd48593473bea18$var$isSameVNodeType(cached, current)) unmount(cached);
            else if (current) $7bd48593473bea18$var$resetShapeFlag(current);
            cache.delete(key);
            keys.delete(key);
        }
        $7bd48593473bea18$export$3db5d71bdb2d5499(function() {
            return [
                props.include,
                props.exclude
            ];
        }, function(param) {
            var _param = (0, $4f96i._)(param, 2), include = _param[0], exclude = _param[1];
            include && pruneCache(function(name) {
                return $7bd48593473bea18$var$matches(include, name);
            });
            exclude && pruneCache(function(name) {
                return !$7bd48593473bea18$var$matches(exclude, name);
            });
        }, // prune post-render after `current` has been updated
        {
            flush: "post",
            deep: true
        });
        var pendingCacheKey = null;
        var cacheSubtree = function() {
            if (pendingCacheKey != null) cache.set(pendingCacheKey, $7bd48593473bea18$var$getInnerChild(instance.subTree));
        };
        $7bd48593473bea18$export$6d1641039221b5cb(cacheSubtree);
        $7bd48593473bea18$export$5876c47052fb88b1(cacheSubtree);
        $7bd48593473bea18$export$40c420df62d2614(function() {
            cache.forEach(function(cached) {
                var subTree = instance.subTree, suspense = instance.suspense;
                var vnode = $7bd48593473bea18$var$getInnerChild(subTree);
                if (cached.type === vnode.type && cached.key === vnode.key) {
                    $7bd48593473bea18$var$resetShapeFlag(vnode);
                    var da = vnode.component.da;
                    da && $7bd48593473bea18$var$queuePostRenderEffect(da, suspense);
                    return;
                }
                unmount(cached);
            });
        });
        return function() {
            pendingCacheKey = null;
            if (!slots.default) return current = null;
            var children = slots.default();
            var rawVNode = children[0];
            if (children.length > 1) {
                current = null;
                return children;
            } else if (!$7bd48593473bea18$export$3868d13f8734ae81(rawVNode) || !(rawVNode.shapeFlag & 4) && !(rawVNode.shapeFlag & 128)) {
                current = null;
                return rawVNode;
            }
            var vnode = $7bd48593473bea18$var$getInnerChild(rawVNode);
            var comp = vnode.type;
            var name = $7bd48593473bea18$var$getComponentName($7bd48593473bea18$var$isAsyncWrapper(vnode) ? vnode.type.__asyncResolved || {} : comp);
            var include = props.include, exclude = props.exclude, max = props.max;
            if (include && (!name || !$7bd48593473bea18$var$matches(include, name)) || exclude && name && $7bd48593473bea18$var$matches(exclude, name)) {
                current = vnode;
                return rawVNode;
            }
            var key = vnode.key == null ? comp : vnode.key;
            var cachedVNode = cache.get(key);
            if (vnode.el) {
                vnode = $7bd48593473bea18$export$ee4f9e12c0a92a1a(vnode);
                if (rawVNode.shapeFlag & 128) rawVNode.ssContent = vnode;
            }
            pendingCacheKey = key;
            if (cachedVNode) {
                vnode.el = cachedVNode.el;
                vnode.component = cachedVNode.component;
                if (vnode.transition) $7bd48593473bea18$export$7770a22486565649(vnode, vnode.transition);
                vnode.shapeFlag |= 512;
                keys.delete(key);
                keys.add(key);
            } else {
                keys.add(key);
                if (max && keys.size > parseInt(max, 10)) pruneCacheEntry(keys.values().next().value);
            }
            vnode.shapeFlag |= 256;
            current = vnode;
            return $7bd48593473bea18$var$isSuspense(rawVNode.type) ? rawVNode : vnode;
        };
    }
};
var $7bd48593473bea18$export$70eb8a58709972df = $7bd48593473bea18$var$KeepAliveImpl;
function $7bd48593473bea18$var$matches(pattern, name) {
    if ((0, $lbCQA.isArray)(pattern)) return pattern.some(function(p) {
        return $7bd48593473bea18$var$matches(p, name);
    });
    else if ((0, $lbCQA.isString)(pattern)) return pattern.split(",").includes(name);
    else if ((0, $lbCQA.isRegExp)(pattern)) return pattern.test(name);
    return false;
}
function $7bd48593473bea18$export$ba52d824b95a2154(hook, target) {
    $7bd48593473bea18$var$registerKeepAliveHook(hook, "a", target);
}
function $7bd48593473bea18$export$bf1440eeaf5fa709(hook, target) {
    $7bd48593473bea18$var$registerKeepAliveHook(hook, "da", target);
}
function $7bd48593473bea18$var$registerKeepAliveHook(hook, type) {
    var target = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $7bd48593473bea18$var$currentInstance;
    var wrappedHook = hook.__wdc || (hook.__wdc = function() {
        var current = target;
        while(current){
            if (current.isDeactivated) return;
            current = current.parent;
        }
        return hook();
    });
    $7bd48593473bea18$var$injectHook(type, wrappedHook, target);
    if (target) {
        var current = target.parent;
        while(current && current.parent){
            if ($7bd48593473bea18$var$isKeepAlive(current.parent.vnode)) $7bd48593473bea18$var$injectToKeepAliveRoot(wrappedHook, type, target, current);
            current = current.parent;
        }
    }
}
function $7bd48593473bea18$var$injectToKeepAliveRoot(hook, type, target, keepAliveRoot) {
    var injected = $7bd48593473bea18$var$injectHook(type, hook, keepAliveRoot, true);
    $7bd48593473bea18$export$13348a43ccacfe58(function() {
        (0, $lbCQA.remove)(keepAliveRoot[type], injected);
    }, target);
}
function $7bd48593473bea18$var$resetShapeFlag(vnode) {
    vnode.shapeFlag &= -257;
    vnode.shapeFlag &= -513;
}
function $7bd48593473bea18$var$getInnerChild(vnode) {
    return vnode.shapeFlag & 128 ? vnode.ssContent : vnode;
}
function $7bd48593473bea18$var$injectHook(type, hook) {
    var target = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $7bd48593473bea18$var$currentInstance, prepend = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    if (target) {
        var hooks = target[type] || (target[type] = []);
        var wrappedHook = hook.__weh || (hook.__weh = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            if (target.isUnmounted) return;
            (0, $aAzpa.pauseTracking)();
            var reset = $7bd48593473bea18$var$setCurrentInstance(target);
            var res = $7bd48593473bea18$export$dae85862a8d94378(hook, target, type, args);
            reset();
            (0, $aAzpa.resetTracking)();
            return res;
        });
        if (prepend) hooks.unshift(wrappedHook);
        else hooks.push(wrappedHook);
        return wrappedHook;
    }
}
var $7bd48593473bea18$var$createHook = function(lifecycle) {
    return function(hook) {
        var target = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $7bd48593473bea18$var$currentInstance;
        return(// post-create lifecycle registrations are noops during SSR (except for serverPrefetch)
        (!$7bd48593473bea18$var$isInSSRComponentSetup || lifecycle === "sp") && $7bd48593473bea18$var$injectHook(lifecycle, function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            return hook.apply(void 0, (0, $79xu7._)(args));
        }, target));
    };
};
var $7bd48593473bea18$export$23b7aeb0d671f804 = $7bd48593473bea18$var$createHook("bm");
var $7bd48593473bea18$export$6d1641039221b5cb = $7bd48593473bea18$var$createHook("m");
var $7bd48593473bea18$export$ab91988a13872e4c = $7bd48593473bea18$var$createHook("bu");
var $7bd48593473bea18$export$5876c47052fb88b1 = $7bd48593473bea18$var$createHook("u");
var $7bd48593473bea18$export$40c420df62d2614 = $7bd48593473bea18$var$createHook("bum");
var $7bd48593473bea18$export$13348a43ccacfe58 = $7bd48593473bea18$var$createHook("um");
var $7bd48593473bea18$export$ebf0c601f267bceb = $7bd48593473bea18$var$createHook("sp");
var $7bd48593473bea18$export$898295a813d662eb = $7bd48593473bea18$var$createHook("rtg");
var $7bd48593473bea18$export$2b41f4235363e921 = $7bd48593473bea18$var$createHook("rtc");
function $7bd48593473bea18$export$6a3a15856e50ad19(hook) {
    var target = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $7bd48593473bea18$var$currentInstance;
    $7bd48593473bea18$var$injectHook("ec", hook, target);
}
function $7bd48593473bea18$export$4bf387f59bfc6d67(source, renderItem, cache, index) {
    var ret;
    var cached = cache && cache[index];
    if ((0, $lbCQA.isArray)(source) || (0, $lbCQA.isString)(source)) {
        ret = new Array(source.length);
        for(var i = 0, l = source.length; i < l; i++)ret[i] = renderItem(source[i], i, void 0, cached && cached[i]);
    } else if (typeof source === "number") {
        ret = new Array(source);
        for(var i1 = 0; i1 < source; i1++)ret[i1] = renderItem(i1 + 1, i1, void 0, cached && cached[i1]);
    } else if ((0, $lbCQA.isObject)(source)) {
        if (source[Symbol.iterator]) ret = Array.from(source, function(item, i) {
            return renderItem(item, i, void 0, cached && cached[i]);
        });
        else {
            var keys = Object.keys(source);
            ret = new Array(keys.length);
            for(var i2 = 0, l1 = keys.length; i2 < l1; i2++){
                var key = keys[i2];
                ret[i2] = renderItem(source[key], key, i2, cached && cached[i2]);
            }
        }
    } else ret = [];
    if (cache) cache[index] = ret;
    return ret;
}
function $7bd48593473bea18$export$85738f8fcd0a5430(slots, dynamicSlots) {
    var _loop = function(i) {
        var slot = dynamicSlots[i];
        if ((0, $lbCQA.isArray)(slot)) for(var j = 0; j < slot.length; j++)slots[slot[j].name] = slot[j].fn;
        else if (slot) slots[slot.name] = slot.key ? function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            var _slot;
            var res = (_slot = slot).fn.apply(_slot, (0, $79xu7._)(args));
            if (res) res.key = slot.key;
            return res;
        } : slot.fn;
    };
    for(var i = 0; i < dynamicSlots.length; i++)_loop(i);
    return slots;
}
function $7bd48593473bea18$export$4abee4c34694ada1(slots, name) {
    var props = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, fallback = arguments.length > 3 ? arguments[3] : void 0, noSlotted = arguments.length > 4 ? arguments[4] : void 0;
    if ($7bd48593473bea18$var$currentRenderingInstance.isCE || $7bd48593473bea18$var$currentRenderingInstance.parent && $7bd48593473bea18$var$isAsyncWrapper($7bd48593473bea18$var$currentRenderingInstance.parent) && $7bd48593473bea18$var$currentRenderingInstance.parent.isCE) {
        if (name !== "default") props.name = name;
        return $7bd48593473bea18$export$bf5c4cf060303d58("slot", props, fallback && fallback());
    }
    var slot = slots[name];
    if (slot && slot._c) slot._d = false;
    $7bd48593473bea18$export$e7eaa45e502fe5cc();
    var validSlotContent = slot && $7bd48593473bea18$var$ensureValidVNode(slot(props));
    var rendered = $7bd48593473bea18$export$9f2dfe8048dfb22b($7bd48593473bea18$export$ffb0004e005737fa, {
        key: props.key || // slot content array of a dynamic conditional slot may have a branch
        // key attached in the `createSlots` helper, respect that
        validSlotContent && validSlotContent.key || "_".concat(name)
    }, validSlotContent || (fallback ? fallback() : []), validSlotContent && slots._ === 1 ? 64 : -2);
    if (!noSlotted && rendered.scopeId) rendered.slotScopeIds = [
        rendered.scopeId + "-s"
    ];
    if (slot && slot._c) slot._d = true;
    return rendered;
}
function $7bd48593473bea18$var$ensureValidVNode(vnodes) {
    return vnodes.some(function(child) {
        if (!$7bd48593473bea18$export$3868d13f8734ae81(child)) return true;
        if (child.type === $7bd48593473bea18$export$4d299b491347818a) return false;
        if (child.type === $7bd48593473bea18$export$ffb0004e005737fa && !$7bd48593473bea18$var$ensureValidVNode(child.children)) return false;
        return true;
    }) ? vnodes : null;
}
function $7bd48593473bea18$export$2fb94ff667a6a1a(obj, preserveCaseIfNecessary) {
    var ret = {};
    for(var key in obj)ret[preserveCaseIfNecessary && /[A-Z]/.test(key) ? "on:".concat(key) : (0, $lbCQA.toHandlerKey)(key)] = obj[key];
    return ret;
}
var $7bd48593473bea18$var$getPublicInstance = function(i) {
    if (!i) return null;
    if ($7bd48593473bea18$var$isStatefulComponent(i)) return $7bd48593473bea18$var$getExposeProxy(i) || i.proxy;
    return $7bd48593473bea18$var$getPublicInstance(i.parent);
};
var $7bd48593473bea18$var$publicPropertiesMap = // Move PURE marker to new line to workaround compiler discarding it
// due to type annotation
/* @__PURE__ */ (0, $lbCQA.extend)(/* @__PURE__ */ Object.create(null), {
    $: function(i) {
        return i;
    },
    $el: function(i) {
        return i.vnode.el;
    },
    $data: function(i) {
        return i.data;
    },
    $props: function(i) {
        return 0, i.props;
    },
    $attrs: function(i) {
        return 0, i.attrs;
    },
    $slots: function(i) {
        return 0, i.slots;
    },
    $refs: function(i) {
        return 0, i.refs;
    },
    $parent: function(i) {
        return $7bd48593473bea18$var$getPublicInstance(i.parent);
    },
    $root: function(i) {
        return $7bd48593473bea18$var$getPublicInstance(i.root);
    },
    $emit: function(i) {
        return i.emit;
    },
    $options: function(i) {
        return __VUE_OPTIONS_API__ ? $7bd48593473bea18$var$resolveMergedOptions(i) : i.type;
    },
    $forceUpdate: function(i) {
        return i.f || (i.f = function() {
            i.effect.dirty = true;
            $7bd48593473bea18$var$queueJob(i.update);
        });
    },
    $nextTick: function(i) {
        return i.n || (i.n = $7bd48593473bea18$export$bdd553fddd433dcb.bind(i.proxy));
    },
    $watch: function(i) {
        return __VUE_OPTIONS_API__ ? $7bd48593473bea18$var$instanceWatch.bind(i) : (0, $lbCQA.NOOP);
    }
});
var $7bd48593473bea18$var$isReservedPrefix = function(key) {
    return key === "_" || key === "$";
};
var $7bd48593473bea18$var$hasSetupBinding = function(state, key) {
    return state !== (0, $lbCQA.EMPTY_OBJ) && !state.__isScriptSetup && (0, $lbCQA.hasOwn)(state, key);
};
var $7bd48593473bea18$var$PublicInstanceProxyHandlers = {
    get: function(param, key) {
        var instance = param._;
        if (key === "__v_skip") return true;
        var ctx = instance.ctx, setupState = instance.setupState, data = instance.data, props = instance.props, accessCache = instance.accessCache, type = instance.type, appContext = instance.appContext;
        var normalizedProps;
        if (key[0] !== "$") {
            var n = accessCache[key];
            if (n !== void 0) switch(n){
                case 1 /* SETUP */ :
                    return setupState[key];
                case 2 /* DATA */ :
                    return data[key];
                case 4 /* CONTEXT */ :
                    return ctx[key];
                case 3 /* PROPS */ :
                    return props[key];
            }
            else if ($7bd48593473bea18$var$hasSetupBinding(setupState, key)) {
                accessCache[key] = 1 /* SETUP */ ;
                return setupState[key];
            } else if (data !== (0, $lbCQA.EMPTY_OBJ) && (0, $lbCQA.hasOwn)(data, key)) {
                accessCache[key] = 2 /* DATA */ ;
                return data[key];
            } else if (// only cache other properties when instance has declared (thus stable)
            // props
            (normalizedProps = instance.propsOptions[0]) && (0, $lbCQA.hasOwn)(normalizedProps, key)) {
                accessCache[key] = 3 /* PROPS */ ;
                return props[key];
            } else if (ctx !== (0, $lbCQA.EMPTY_OBJ) && (0, $lbCQA.hasOwn)(ctx, key)) {
                accessCache[key] = 4 /* CONTEXT */ ;
                return ctx[key];
            } else if (!__VUE_OPTIONS_API__ || $7bd48593473bea18$var$shouldCacheAccess) accessCache[key] = 0 /* OTHER */ ;
        }
        var publicGetter = $7bd48593473bea18$var$publicPropertiesMap[key];
        var cssModule, globalProperties;
        if (publicGetter) {
            if (key === "$attrs") (0, $aAzpa.track)(instance.attrs, "get", "");
            return publicGetter(instance);
        } else if (// css module (injected by vue-loader)
        (cssModule = type.__cssModules) && (cssModule = cssModule[key])) return cssModule;
        else if (ctx !== (0, $lbCQA.EMPTY_OBJ) && (0, $lbCQA.hasOwn)(ctx, key)) {
            accessCache[key] = 4 /* CONTEXT */ ;
            return ctx[key];
        } else if (// global properties
        globalProperties = appContext.config.globalProperties, (0, $lbCQA.hasOwn)(globalProperties, key)) return globalProperties[key];
    },
    set: function(param, key, value) {
        var instance = param._;
        var data = instance.data, setupState = instance.setupState, ctx = instance.ctx;
        if ($7bd48593473bea18$var$hasSetupBinding(setupState, key)) {
            setupState[key] = value;
            return true;
        } else {
            if (data !== (0, $lbCQA.EMPTY_OBJ) && (0, $lbCQA.hasOwn)(data, key)) {
                data[key] = value;
                return true;
            } else if ((0, $lbCQA.hasOwn)(instance.props, key)) return false;
        }
        if (key[0] === "$" && key.slice(1) in instance) return false;
        else ctx[key] = value;
        return true;
    },
    has: function(param, key) {
        var _param__ = param._, data = _param__.data, setupState = _param__.setupState, accessCache = _param__.accessCache, ctx = _param__.ctx, appContext = _param__.appContext, propsOptions = _param__.propsOptions;
        var normalizedProps;
        return !!accessCache[key] || data !== (0, $lbCQA.EMPTY_OBJ) && (0, $lbCQA.hasOwn)(data, key) || $7bd48593473bea18$var$hasSetupBinding(setupState, key) || (normalizedProps = propsOptions[0]) && (0, $lbCQA.hasOwn)(normalizedProps, key) || (0, $lbCQA.hasOwn)(ctx, key) || (0, $lbCQA.hasOwn)($7bd48593473bea18$var$publicPropertiesMap, key) || (0, $lbCQA.hasOwn)(appContext.config.globalProperties, key);
    },
    defineProperty: function(target, key, descriptor) {
        if (descriptor.get != null) target._.accessCache[key] = 0;
        else if ((0, $lbCQA.hasOwn)(descriptor, "value")) this.set(target, key, descriptor.value, null);
        return Reflect.defineProperty(target, key, descriptor);
    }
};
var $7bd48593473bea18$var$target;
var $7bd48593473bea18$var$RuntimeCompiledPublicInstanceProxyHandlers = /* @__PURE__ */ (0, $lbCQA.extend)({}, $7bd48593473bea18$var$PublicInstanceProxyHandlers, {
    get: function(target, key) {
        if (key === Symbol.unscopables) return;
        return $7bd48593473bea18$var$PublicInstanceProxyHandlers.get(target, key, target);
    },
    has: function(_, key) {
        var has = key[0] !== "_" && !(0, $lbCQA.isGloballyAllowed)(key);
        return has;
    }
});
function $7bd48593473bea18$var$createDevRenderContext(instance) {
    var target = {};
    Object.defineProperty(target, "_", {
        configurable: true,
        enumerable: false,
        get: function() {
            return instance;
        }
    });
    Object.keys($7bd48593473bea18$var$publicPropertiesMap).forEach(function(key) {
        Object.defineProperty(target, key, {
            configurable: true,
            enumerable: false,
            get: function() {
                return $7bd48593473bea18$var$publicPropertiesMap[key](instance);
            },
            // intercepted by the proxy so no need for implementation,
            // but needed to prevent set errors
            set: (0, $lbCQA.NOOP)
        });
    });
    return target;
}
function $7bd48593473bea18$var$exposePropsOnRenderContext(instance) {
    var ctx = instance.ctx, _instance_propsOptions = (0, $4f96i._)(instance.propsOptions, 1), propsOptions = _instance_propsOptions[0];
    if (propsOptions) Object.keys(propsOptions).forEach(function(key) {
        Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: function() {
                return instance.props[key];
            },
            set: (0, $lbCQA.NOOP)
        });
    });
}
function $7bd48593473bea18$var$exposeSetupStateOnRenderContext(instance) {
    var ctx = instance.ctx, setupState = instance.setupState;
    Object.keys((0, $aAzpa.toRaw)(setupState)).forEach(function(key) {
        if (!setupState.__isScriptSetup) {
            if ($7bd48593473bea18$var$isReservedPrefix(key[0])) {
                $7bd48593473bea18$var$warn$1("setup() return property ".concat(JSON.stringify(key), ' should not start with "$" or "_" which are reserved prefixes for Vue internals.'));
                return;
            }
            Object.defineProperty(ctx, key, {
                enumerable: true,
                configurable: true,
                get: function() {
                    return setupState[key];
                },
                set: (0, $lbCQA.NOOP)
            });
        }
    });
}
var $7bd48593473bea18$var$warnRuntimeUsage = function(method) {
    return $7bd48593473bea18$var$warn$1("".concat(method, "() is a compiler-hint helper that is only usable inside <script setup> of a single file component. Its arguments should be compiled away and passing it at runtime has no effect."));
};
function $7bd48593473bea18$export$80b33eababae110e() {
    return null;
}
function $7bd48593473bea18$export$51ecece22fc17ddc() {
    return null;
}
function $7bd48593473bea18$export$da25b65ca24b518a(exposed) {}
function $7bd48593473bea18$export$77e79129327f3d0d(options) {}
function $7bd48593473bea18$export$1b3acd4bb805b712() {
    return null;
}
function $7bd48593473bea18$export$acd55aa037e791bb() {}
function $7bd48593473bea18$export$4df9c0969a9e0160(props, defaults) {
    return null;
}
function $7bd48593473bea18$export$9203a8e84125433c() {
    return $7bd48593473bea18$var$getContext().slots;
}
function $7bd48593473bea18$export$75e29435042cd2ea() {
    return $7bd48593473bea18$var$getContext().attrs;
}
function $7bd48593473bea18$var$getContext() {
    var i = $7bd48593473bea18$export$f13e630aa3915748();
    return i.setupContext || (i.setupContext = $7bd48593473bea18$var$createSetupContext(i));
}
function $7bd48593473bea18$var$normalizePropsOrEmits(props) {
    return (0, $lbCQA.isArray)(props) ? props.reduce(function(normalized, p) {
        return normalized[p] = null, normalized;
    }, {}) : props;
}
function $7bd48593473bea18$export$ec60f47d4a8a2e7f(raw, defaults) {
    var props = $7bd48593473bea18$var$normalizePropsOrEmits(raw);
    for(var key in defaults){
        if (key.startsWith("__skip")) continue;
        var opt = props[key];
        if (opt) {
            if ((0, $lbCQA.isArray)(opt) || (0, $lbCQA.isFunction)(opt)) opt = props[key] = {
                type: opt,
                default: defaults[key]
            };
            else opt.default = defaults[key];
        } else if (opt === null) opt = props[key] = {
            default: defaults[key]
        };
        if (opt && defaults["__skip_".concat(key)]) opt.skipFactory = true;
    }
    return props;
}
function $7bd48593473bea18$export$ad4f724f587e6828(a, b) {
    if (!a || !b) return a || b;
    if ((0, $lbCQA.isArray)(a) && (0, $lbCQA.isArray)(b)) return a.concat(b);
    return (0, $lbCQA.extend)({}, $7bd48593473bea18$var$normalizePropsOrEmits(a), $7bd48593473bea18$var$normalizePropsOrEmits(b));
}
function $7bd48593473bea18$export$7c343e855c563faa(props, excludedKeys) {
    var _loop = function(key) {
        if (!excludedKeys.includes(key)) Object.defineProperty(ret, key, {
            enumerable: true,
            get: function() {
                return props[key];
            }
        });
    };
    var ret = {};
    for(var key in props)_loop(key);
    return ret;
}
function $7bd48593473bea18$export$d6d6f7369f1fb104(getAwaitable) {
    var ctx = $7bd48593473bea18$export$f13e630aa3915748();
    var awaitable = getAwaitable();
    $7bd48593473bea18$var$unsetCurrentInstance();
    if ((0, $lbCQA.isPromise)(awaitable)) awaitable = awaitable.catch(function(e) {
        $7bd48593473bea18$var$setCurrentInstance(ctx);
        throw e;
    });
    return [
        awaitable,
        function() {
            return $7bd48593473bea18$var$setCurrentInstance(ctx);
        }
    ];
}
function $7bd48593473bea18$var$createDuplicateChecker() {
    var cache = /* @__PURE__ */ Object.create(null);
    return function(type, key) {
        if (cache[key]) $7bd48593473bea18$var$warn$1("".concat(type, ' property "').concat(key, '" is already defined in ').concat(cache[key], "."));
        else cache[key] = type;
    };
}
var $7bd48593473bea18$var$shouldCacheAccess = true;
function $7bd48593473bea18$var$applyOptions(instance) {
    var _loop = function(key1) {
        var opt = computedOptions[key1];
        var get = (0, $lbCQA.isFunction)(opt) ? opt.bind(publicThis, publicThis) : (0, $lbCQA.isFunction)(opt.get) ? opt.get.bind(publicThis, publicThis) : (0, $lbCQA.NOOP);
        var set = !(0, $lbCQA.isFunction)(opt) && (0, $lbCQA.isFunction)(opt.set) ? opt.set.bind(publicThis) : (0, $lbCQA.NOOP);
        var c = $7bd48593473bea18$export$2983e091f1a1e8e2({
            get: get,
            set: set
        });
        Object.defineProperty(ctx, key1, {
            enumerable: true,
            configurable: true,
            get: function() {
                return c.value;
            },
            set: function(v1) {
                return c.value = v1;
            }
        });
    };
    var options = $7bd48593473bea18$var$resolveMergedOptions(instance);
    var publicThis = instance.proxy;
    var ctx = instance.ctx;
    $7bd48593473bea18$var$shouldCacheAccess = false;
    if (options.beforeCreate) $7bd48593473bea18$var$callHook(options.beforeCreate, instance, "bc");
    var // state
    dataOptions = options.data, computedOptions = options.computed, methods = options.methods, watchOptions = options.watch, provideOptions = options.provide, injectOptions = options.inject, // lifecycle
    created = options.created, beforeMount = options.beforeMount, mounted = options.mounted, beforeUpdate = options.beforeUpdate, updated = options.updated, activated = options.activated, deactivated = options.deactivated, beforeDestroy = options.beforeDestroy, beforeUnmount = options.beforeUnmount, destroyed = options.destroyed, unmounted = options.unmounted, render = options.render, renderTracked = options.renderTracked, renderTriggered = options.renderTriggered, errorCaptured = options.errorCaptured, serverPrefetch = options.serverPrefetch, // public API
    expose = options.expose, inheritAttrs = options.inheritAttrs, // assets
    components = options.components, directives = options.directives, filters = options.filters;
    var checkDuplicateProperties = null;
    if (injectOptions) $7bd48593473bea18$var$resolveInjections(injectOptions, ctx, checkDuplicateProperties);
    if (methods) for(var key in methods){
        var methodHandler = methods[key];
        if ((0, $lbCQA.isFunction)(methodHandler)) ctx[key] = methodHandler.bind(publicThis);
    }
    if (dataOptions) {
        var data = dataOptions.call(publicThis, publicThis);
        if (!(0, $lbCQA.isObject)(data)) ;
        else instance.data = (0, $aAzpa.reactive)(data);
    }
    $7bd48593473bea18$var$shouldCacheAccess = true;
    if (computedOptions) for(var key1 in computedOptions)_loop(key1);
    if (watchOptions) for(var key2 in watchOptions)$7bd48593473bea18$var$createWatcher(watchOptions[key2], ctx, publicThis, key2);
    if (provideOptions) {
        var provides = (0, $lbCQA.isFunction)(provideOptions) ? provideOptions.call(publicThis) : provideOptions;
        Reflect.ownKeys(provides).forEach(function(key) {
            $7bd48593473bea18$export$abe1e183e22e10ad(key, provides[key]);
        });
    }
    if (created) $7bd48593473bea18$var$callHook(created, instance, "c");
    function registerLifecycleHook(register, hook) {
        if ((0, $lbCQA.isArray)(hook)) hook.forEach(function(_hook) {
            return register(_hook.bind(publicThis));
        });
        else if (hook) register(hook.bind(publicThis));
    }
    registerLifecycleHook($7bd48593473bea18$export$23b7aeb0d671f804, beforeMount);
    registerLifecycleHook($7bd48593473bea18$export$6d1641039221b5cb, mounted);
    registerLifecycleHook($7bd48593473bea18$export$ab91988a13872e4c, beforeUpdate);
    registerLifecycleHook($7bd48593473bea18$export$5876c47052fb88b1, updated);
    registerLifecycleHook($7bd48593473bea18$export$ba52d824b95a2154, activated);
    registerLifecycleHook($7bd48593473bea18$export$bf1440eeaf5fa709, deactivated);
    registerLifecycleHook($7bd48593473bea18$export$6a3a15856e50ad19, errorCaptured);
    registerLifecycleHook($7bd48593473bea18$export$2b41f4235363e921, renderTracked);
    registerLifecycleHook($7bd48593473bea18$export$898295a813d662eb, renderTriggered);
    registerLifecycleHook($7bd48593473bea18$export$40c420df62d2614, beforeUnmount);
    registerLifecycleHook($7bd48593473bea18$export$13348a43ccacfe58, unmounted);
    registerLifecycleHook($7bd48593473bea18$export$ebf0c601f267bceb, serverPrefetch);
    if ((0, $lbCQA.isArray)(expose)) {
        if (expose.length) {
            var exposed = instance.exposed || (instance.exposed = {});
            expose.forEach(function(key) {
                Object.defineProperty(exposed, key, {
                    get: function() {
                        return publicThis[key];
                    },
                    set: function(val) {
                        return publicThis[key] = val;
                    }
                });
            });
        } else if (!instance.exposed) instance.exposed = {};
    }
    if (render && instance.render === (0, $lbCQA.NOOP)) instance.render = render;
    if (inheritAttrs != null) instance.inheritAttrs = inheritAttrs;
    if (components) instance.components = components;
    if (directives) instance.directives = directives;
}
function $7bd48593473bea18$var$resolveInjections(injectOptions, ctx) {
    var _loop = function(key) {
        var opt = injectOptions[key];
        var injected = void 0;
        if ((0, $lbCQA.isObject)(opt)) {
            if ("default" in opt) injected = $7bd48593473bea18$export$a976684a0efeb93f(opt.from || key, opt.default, true);
            else injected = $7bd48593473bea18$export$a976684a0efeb93f(opt.from || key);
        } else injected = $7bd48593473bea18$export$a976684a0efeb93f(opt);
        if ((0, $aAzpa.isRef)(injected)) Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: function() {
                return injected.value;
            },
            set: function(v1) {
                return injected.value = v1;
            }
        });
        else ctx[key] = injected;
    };
    var checkDuplicateProperties = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : (0, $lbCQA.NOOP);
    if ((0, $lbCQA.isArray)(injectOptions)) injectOptions = $7bd48593473bea18$var$normalizeInject(injectOptions);
    for(var key in injectOptions)_loop(key);
}
function $7bd48593473bea18$var$callHook(hook, instance, type) {
    $7bd48593473bea18$export$dae85862a8d94378((0, $lbCQA.isArray)(hook) ? hook.map(function(h) {
        return h.bind(instance.proxy);
    }) : hook.bind(instance.proxy), instance, type);
}
function $7bd48593473bea18$var$createWatcher(raw, ctx, publicThis, key) {
    var getter = key.includes(".") ? $7bd48593473bea18$var$createPathGetter(publicThis, key) : function() {
        return publicThis[key];
    };
    if ((0, $lbCQA.isString)(raw)) {
        var handler = ctx[raw];
        if ((0, $lbCQA.isFunction)(handler)) $7bd48593473bea18$export$3db5d71bdb2d5499(getter, handler);
    } else if ((0, $lbCQA.isFunction)(raw)) $7bd48593473bea18$export$3db5d71bdb2d5499(getter, raw.bind(publicThis));
    else if ((0, $lbCQA.isObject)(raw)) {
        if ((0, $lbCQA.isArray)(raw)) raw.forEach(function(r) {
            return $7bd48593473bea18$var$createWatcher(r, ctx, publicThis, key);
        });
        else {
            var handler1 = (0, $lbCQA.isFunction)(raw.handler) ? raw.handler.bind(publicThis) : ctx[raw.handler];
            if ((0, $lbCQA.isFunction)(handler1)) $7bd48593473bea18$export$3db5d71bdb2d5499(getter, handler1, raw);
        }
    } else ;
}
function $7bd48593473bea18$var$resolveMergedOptions(instance) {
    var base = instance.type;
    var mixins = base.mixins, extendsOptions = base.extends;
    var _instance_appContext = instance.appContext, globalMixins = _instance_appContext.mixins, cache = _instance_appContext.optionsCache, optionMergeStrategies = _instance_appContext.config.optionMergeStrategies;
    var cached = cache.get(base);
    var resolved;
    if (cached) resolved = cached;
    else if (!globalMixins.length && !mixins && !extendsOptions) resolved = base;
    else {
        resolved = {};
        if (globalMixins.length) globalMixins.forEach(function(m) {
            return $7bd48593473bea18$var$mergeOptions(resolved, m, optionMergeStrategies, true);
        });
        $7bd48593473bea18$var$mergeOptions(resolved, base, optionMergeStrategies);
    }
    if ((0, $lbCQA.isObject)(base)) cache.set(base, resolved);
    return resolved;
}
function $7bd48593473bea18$var$mergeOptions(to, from, strats) {
    var asMixin = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var mixins = from.mixins, extendsOptions = from.extends;
    if (extendsOptions) $7bd48593473bea18$var$mergeOptions(to, extendsOptions, strats, true);
    if (mixins) mixins.forEach(function(m) {
        return $7bd48593473bea18$var$mergeOptions(to, m, strats, true);
    });
    for(var key in from){
        if (asMixin && key === "expose") ;
        else {
            var strat = $7bd48593473bea18$var$internalOptionMergeStrats[key] || strats && strats[key];
            to[key] = strat ? strat(to[key], from[key]) : from[key];
        }
    }
    return to;
}
var $7bd48593473bea18$var$internalOptionMergeStrats = {
    data: $7bd48593473bea18$var$mergeDataFn,
    props: $7bd48593473bea18$var$mergeEmitsOrPropsOptions,
    emits: $7bd48593473bea18$var$mergeEmitsOrPropsOptions,
    // objects
    methods: $7bd48593473bea18$var$mergeObjectOptions,
    computed: $7bd48593473bea18$var$mergeObjectOptions,
    // lifecycle
    beforeCreate: $7bd48593473bea18$var$mergeAsArray,
    created: $7bd48593473bea18$var$mergeAsArray,
    beforeMount: $7bd48593473bea18$var$mergeAsArray,
    mounted: $7bd48593473bea18$var$mergeAsArray,
    beforeUpdate: $7bd48593473bea18$var$mergeAsArray,
    updated: $7bd48593473bea18$var$mergeAsArray,
    beforeDestroy: $7bd48593473bea18$var$mergeAsArray,
    beforeUnmount: $7bd48593473bea18$var$mergeAsArray,
    destroyed: $7bd48593473bea18$var$mergeAsArray,
    unmounted: $7bd48593473bea18$var$mergeAsArray,
    activated: $7bd48593473bea18$var$mergeAsArray,
    deactivated: $7bd48593473bea18$var$mergeAsArray,
    errorCaptured: $7bd48593473bea18$var$mergeAsArray,
    serverPrefetch: $7bd48593473bea18$var$mergeAsArray,
    // assets
    components: $7bd48593473bea18$var$mergeObjectOptions,
    directives: $7bd48593473bea18$var$mergeObjectOptions,
    // watch
    watch: $7bd48593473bea18$var$mergeWatchOptions,
    // provide / inject
    provide: $7bd48593473bea18$var$mergeDataFn,
    inject: $7bd48593473bea18$var$mergeInject
};
function $7bd48593473bea18$var$mergeDataFn(to, from) {
    if (!from) return to;
    if (!to) return from;
    return function mergedDataFn() {
        return (0, $lbCQA.extend)((0, $lbCQA.isFunction)(to) ? to.call(this, this) : to, (0, $lbCQA.isFunction)(from) ? from.call(this, this) : from);
    };
}
function $7bd48593473bea18$var$mergeInject(to, from) {
    return $7bd48593473bea18$var$mergeObjectOptions($7bd48593473bea18$var$normalizeInject(to), $7bd48593473bea18$var$normalizeInject(from));
}
function $7bd48593473bea18$var$normalizeInject(raw) {
    if ((0, $lbCQA.isArray)(raw)) {
        var res = {};
        for(var i = 0; i < raw.length; i++)res[raw[i]] = raw[i];
        return res;
    }
    return raw;
}
function $7bd48593473bea18$var$mergeAsArray(to, from) {
    return to ? (0, $79xu7._)(new Set([].concat(to, from))) : from;
}
function $7bd48593473bea18$var$mergeObjectOptions(to, from) {
    return to ? (0, $lbCQA.extend)(/* @__PURE__ */ Object.create(null), to, from) : from;
}
function $7bd48593473bea18$var$mergeEmitsOrPropsOptions(to, from) {
    if (to) {
        if ((0, $lbCQA.isArray)(to) && (0, $lbCQA.isArray)(from)) return (0, $79xu7._)(/* @__PURE__ */ new Set((0, $79xu7._)(to).concat((0, $79xu7._)(from))));
        return (0, $lbCQA.extend)(/* @__PURE__ */ Object.create(null), $7bd48593473bea18$var$normalizePropsOrEmits(to), $7bd48593473bea18$var$normalizePropsOrEmits(from != null ? from : {}));
    } else return from;
}
function $7bd48593473bea18$var$mergeWatchOptions(to, from) {
    if (!to) return from;
    if (!from) return to;
    var merged = (0, $lbCQA.extend)(/* @__PURE__ */ Object.create(null), to);
    for(var key in from)merged[key] = $7bd48593473bea18$var$mergeAsArray(to[key], from[key]);
    return merged;
}
function $7bd48593473bea18$var$createAppContext() {
    return {
        app: null,
        config: {
            isNativeTag: (0, $lbCQA.NO),
            performance: false,
            globalProperties: {},
            optionMergeStrategies: {},
            errorHandler: void 0,
            warnHandler: void 0,
            compilerOptions: {}
        },
        mixins: [],
        components: {},
        directives: {},
        provides: /* @__PURE__ */ Object.create(null),
        optionsCache: /* @__PURE__ */ new WeakMap(),
        propsCache: /* @__PURE__ */ new WeakMap(),
        emitsCache: /* @__PURE__ */ new WeakMap()
    };
}
var $7bd48593473bea18$var$uid$1 = 0;
function $7bd48593473bea18$var$createAppAPI(render, hydrate) {
    return function createApp(rootComponent) {
        var rootProps = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
        if (!(0, $lbCQA.isFunction)(rootComponent)) rootComponent = (0, $lbCQA.extend)({}, rootComponent);
        if (rootProps != null && !(0, $lbCQA.isObject)(rootProps)) rootProps = null;
        var context = $7bd48593473bea18$var$createAppContext();
        var installedPlugins = /* @__PURE__ */ new WeakSet();
        var isMounted = false;
        var app = context.app = {
            _uid: $7bd48593473bea18$var$uid$1++,
            _component: rootComponent,
            _props: rootProps,
            _container: null,
            _context: context,
            _instance: null,
            version: $7bd48593473bea18$export$83d89fbfd8236492,
            get config () {
                return context.config;
            },
            set config (v){},
            use: function(plugin) {
                for(var _len = arguments.length, options = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    options[_key - 1] = arguments[_key];
                }
                if (installedPlugins.has(plugin)) ;
                else if (plugin && (0, $lbCQA.isFunction)(plugin.install)) {
                    var _plugin;
                    installedPlugins.add(plugin);
                    (_plugin = plugin).install.apply(_plugin, [
                        app
                    ].concat((0, $79xu7._)(options)));
                } else if ((0, $lbCQA.isFunction)(plugin)) {
                    installedPlugins.add(plugin);
                    plugin.apply(void 0, [
                        app
                    ].concat((0, $79xu7._)(options)));
                }
                return app;
            },
            mixin: function(mixin) {
                if (__VUE_OPTIONS_API__) {
                    if (!context.mixins.includes(mixin)) context.mixins.push(mixin);
                }
                return app;
            },
            component: function(name, component) {
                if (!component) return context.components[name];
                context.components[name] = component;
                return app;
            },
            directive: function(name, directive) {
                if (!directive) return context.directives[name];
                context.directives[name] = directive;
                return app;
            },
            mount: function(rootContainer, isHydrate, namespace) {
                if (!isMounted) {
                    var vnode = $7bd48593473bea18$export$bf5c4cf060303d58(rootComponent, rootProps);
                    vnode.appContext = context;
                    if (namespace === true) namespace = "svg";
                    else if (namespace === false) namespace = void 0;
                    if (isHydrate && hydrate) hydrate(vnode, rootContainer);
                    else render(vnode, rootContainer, namespace);
                    isMounted = true;
                    app._container = rootContainer;
                    rootContainer.__vue_app__ = app;
                    if (__VUE_PROD_DEVTOOLS__) {
                        app._instance = vnode.component;
                        $7bd48593473bea18$var$devtoolsInitApp(app, $7bd48593473bea18$export$83d89fbfd8236492);
                    }
                    return $7bd48593473bea18$var$getExposeProxy(vnode.component) || vnode.component.proxy;
                }
            },
            unmount: function() {
                if (isMounted) {
                    render(null, app._container);
                    if (__VUE_PROD_DEVTOOLS__) {
                        app._instance = null;
                        $7bd48593473bea18$var$devtoolsUnmountApp(app);
                    }
                    delete app._container.__vue_app__;
                }
            },
            provide: function(key, value) {
                context.provides[key] = value;
                return app;
            },
            runWithContext: function(fn) {
                var lastApp = $7bd48593473bea18$var$currentApp;
                $7bd48593473bea18$var$currentApp = app;
                try {
                    return fn();
                } finally{
                    $7bd48593473bea18$var$currentApp = lastApp;
                }
            }
        };
        return app;
    };
}
var $7bd48593473bea18$var$currentApp = null;
function $7bd48593473bea18$export$abe1e183e22e10ad(key, value) {
    if (!$7bd48593473bea18$var$currentInstance) ;
    else {
        var provides = $7bd48593473bea18$var$currentInstance.provides;
        var parentProvides = $7bd48593473bea18$var$currentInstance.parent && $7bd48593473bea18$var$currentInstance.parent.provides;
        if (parentProvides === provides) provides = $7bd48593473bea18$var$currentInstance.provides = Object.create(parentProvides);
        provides[key] = value;
    }
}
function $7bd48593473bea18$export$a976684a0efeb93f(key, defaultValue) {
    var treatDefaultAsFactory = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var instance = $7bd48593473bea18$var$currentInstance || $7bd48593473bea18$var$currentRenderingInstance;
    if (instance || $7bd48593473bea18$var$currentApp) {
        var provides = instance ? instance.parent == null ? instance.vnode.appContext && instance.vnode.appContext.provides : instance.parent.provides : $7bd48593473bea18$var$currentApp._context.provides;
        if (provides && key in provides) return provides[key];
        else if (arguments.length > 1) return treatDefaultAsFactory && (0, $lbCQA.isFunction)(defaultValue) ? defaultValue.call(instance && instance.proxy) : defaultValue;
    }
}
function $7bd48593473bea18$export$caf6761f24fc571a() {
    return !!($7bd48593473bea18$var$currentInstance || $7bd48593473bea18$var$currentRenderingInstance || $7bd48593473bea18$var$currentApp);
}
var $7bd48593473bea18$var$internalObjectProto = {};
var $7bd48593473bea18$var$createInternalObject = function() {
    return Object.create($7bd48593473bea18$var$internalObjectProto);
};
var $7bd48593473bea18$var$isInternalObject = function(obj) {
    return Object.getPrototypeOf(obj) === $7bd48593473bea18$var$internalObjectProto;
};
function $7bd48593473bea18$var$initProps(instance, rawProps, isStateful) {
    var isSSR = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var props = {};
    var attrs = $7bd48593473bea18$var$createInternalObject();
    instance.propsDefaults = /* @__PURE__ */ Object.create(null);
    $7bd48593473bea18$var$setFullProps(instance, rawProps, props, attrs);
    for(var key in instance.propsOptions[0])if (!(key in props)) props[key] = void 0;
    if (isStateful) instance.props = isSSR ? props : (0, $aAzpa.shallowReactive)(props);
    else if (!instance.type.props) instance.props = attrs;
    else instance.props = props;
    instance.attrs = attrs;
}
function $7bd48593473bea18$var$isInHmrContext(instance) {
    while(instance){
        if (instance.type.__hmrId) return true;
        instance = instance.parent;
    }
}
function $7bd48593473bea18$var$updateProps(instance, rawProps, rawPrevProps, optimized) {
    var props = instance.props, attrs = instance.attrs, patchFlag = instance.vnode.patchFlag;
    var rawCurrentProps = (0, $aAzpa.toRaw)(props);
    var _instance_propsOptions = (0, $4f96i._)(instance.propsOptions, 1), options = _instance_propsOptions[0];
    var hasAttrsChanged = false;
    if (// always force full diff in dev
    // - #1942 if hmr is enabled with sfc component
    // - vite#872 non-sfc component used by sfc component
    (optimized || patchFlag > 0) && !(patchFlag & 16)) {
        if (patchFlag & 8) {
            var propsToUpdate = instance.vnode.dynamicProps;
            for(var i = 0; i < propsToUpdate.length; i++){
                var key = propsToUpdate[i];
                if ($7bd48593473bea18$var$isEmitListener(instance.emitsOptions, key)) continue;
                var value = rawProps[key];
                if (options) {
                    if ((0, $lbCQA.hasOwn)(attrs, key)) {
                        if (value !== attrs[key]) {
                            attrs[key] = value;
                            hasAttrsChanged = true;
                        }
                    } else {
                        var camelizedKey = (0, $lbCQA.camelize)(key);
                        props[camelizedKey] = $7bd48593473bea18$var$resolvePropValue(options, rawCurrentProps, camelizedKey, value, instance, false);
                    }
                } else if (value !== attrs[key]) {
                    attrs[key] = value;
                    hasAttrsChanged = true;
                }
            }
        }
    } else {
        if ($7bd48593473bea18$var$setFullProps(instance, rawProps, props, attrs)) hasAttrsChanged = true;
        var kebabKey;
        for(var key1 in rawCurrentProps)if (!rawProps || // for camelCase
        !(0, $lbCQA.hasOwn)(rawProps, key1) && // it's possible the original props was passed in as kebab-case
        // and converted to camelCase (#955)
        ((kebabKey = (0, $lbCQA.hyphenate)(key1)) === key1 || !(0, $lbCQA.hasOwn)(rawProps, kebabKey))) {
            if (options) {
                if (rawPrevProps && // for camelCase
                (rawPrevProps[key1] !== void 0 || // for kebab-case
                rawPrevProps[kebabKey] !== void 0)) props[key1] = $7bd48593473bea18$var$resolvePropValue(options, rawCurrentProps, key1, void 0, instance, true);
            } else delete props[key1];
        }
        if (attrs !== rawCurrentProps) {
            for(var key2 in attrs)if (!rawProps || !(0, $lbCQA.hasOwn)(rawProps, key2) && true) {
                delete attrs[key2];
                hasAttrsChanged = true;
            }
        }
    }
    if (hasAttrsChanged) (0, $aAzpa.trigger)(instance.attrs, "set", "");
}
function $7bd48593473bea18$var$setFullProps(instance, rawProps, props, attrs) {
    var _instance_propsOptions = (0, $4f96i._)(instance.propsOptions, 2), options = _instance_propsOptions[0], needCastKeys = _instance_propsOptions[1];
    var hasAttrsChanged = false;
    var rawCastValues;
    if (rawProps) for(var key in rawProps){
        if ((0, $lbCQA.isReservedProp)(key)) continue;
        var value = rawProps[key];
        var camelKey = void 0;
        if (options && (0, $lbCQA.hasOwn)(options, camelKey = (0, $lbCQA.camelize)(key))) {
            if (!needCastKeys || !needCastKeys.includes(camelKey)) props[camelKey] = value;
            else (rawCastValues || (rawCastValues = {}))[camelKey] = value;
        } else if (!$7bd48593473bea18$var$isEmitListener(instance.emitsOptions, key)) {
            if (!(key in attrs) || value !== attrs[key]) {
                attrs[key] = value;
                hasAttrsChanged = true;
            }
        }
    }
    if (needCastKeys) {
        var rawCurrentProps = (0, $aAzpa.toRaw)(props);
        var castValues = rawCastValues || (0, $lbCQA.EMPTY_OBJ);
        for(var i = 0; i < needCastKeys.length; i++){
            var key1 = needCastKeys[i];
            props[key1] = $7bd48593473bea18$var$resolvePropValue(options, rawCurrentProps, key1, castValues[key1], instance, !(0, $lbCQA.hasOwn)(castValues, key1));
        }
    }
    return hasAttrsChanged;
}
function $7bd48593473bea18$var$resolvePropValue(options, props, key, value, instance, isAbsent) {
    var opt = options[key];
    if (opt != null) {
        var hasDefault = (0, $lbCQA.hasOwn)(opt, "default");
        if (hasDefault && value === void 0) {
            var defaultValue = opt.default;
            if (opt.type !== Function && !opt.skipFactory && (0, $lbCQA.isFunction)(defaultValue)) {
                var propsDefaults = instance.propsDefaults;
                if (key in propsDefaults) value = propsDefaults[key];
                else {
                    var reset = $7bd48593473bea18$var$setCurrentInstance(instance);
                    value = propsDefaults[key] = defaultValue.call(null, props);
                    reset();
                }
            } else value = defaultValue;
        }
        if (opt[0 /* shouldCast */ ]) {
            if (isAbsent && !hasDefault) value = false;
            else if (opt[1 /* shouldCastTrue */ ] && (value === "" || value === (0, $lbCQA.hyphenate)(key))) value = true;
        }
    }
    return value;
}
function $7bd48593473bea18$var$normalizePropsOptions(comp, appContext) {
    var asMixin = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var cache = appContext.propsCache;
    var cached = cache.get(comp);
    if (cached) return cached;
    var raw = comp.props;
    var normalized = {};
    var needCastKeys = [];
    var hasExtends = false;
    if (__VUE_OPTIONS_API__ && !(0, $lbCQA.isFunction)(comp)) {
        var extendProps = function(raw2) {
            var _needCastKeys;
            hasExtends = true;
            var _normalizePropsOptions = (0, $4f96i._)($7bd48593473bea18$var$normalizePropsOptions(raw2, appContext, true), 2), props = _normalizePropsOptions[0], keys = _normalizePropsOptions[1];
            (0, $lbCQA.extend)(normalized, props);
            if (keys) (_needCastKeys = needCastKeys).push.apply(_needCastKeys, (0, $79xu7._)(keys));
        };
        if (!asMixin && appContext.mixins.length) appContext.mixins.forEach(extendProps);
        if (comp.extends) extendProps(comp.extends);
        if (comp.mixins) comp.mixins.forEach(extendProps);
    }
    if (!raw && !hasExtends) {
        if ((0, $lbCQA.isObject)(comp)) cache.set(comp, (0, $lbCQA.EMPTY_ARR));
        return 0, $lbCQA.EMPTY_ARR;
    }
    if ((0, $lbCQA.isArray)(raw)) for(var i = 0; i < raw.length; i++){
        var normalizedKey = (0, $lbCQA.camelize)(raw[i]);
        if ($7bd48593473bea18$var$validatePropName(normalizedKey)) normalized[normalizedKey] = (0, $lbCQA.EMPTY_OBJ);
    }
    else if (raw) for(var key in raw){
        var normalizedKey1 = (0, $lbCQA.camelize)(key);
        if ($7bd48593473bea18$var$validatePropName(normalizedKey1)) {
            var opt = raw[key];
            var prop = normalized[normalizedKey1] = (0, $lbCQA.isArray)(opt) || (0, $lbCQA.isFunction)(opt) ? {
                type: opt
            } : (0, $lbCQA.extend)({}, opt);
            if (prop) {
                var booleanIndex = $7bd48593473bea18$var$getTypeIndex(Boolean, prop.type);
                var stringIndex = $7bd48593473bea18$var$getTypeIndex(String, prop.type);
                prop[0 /* shouldCast */ ] = booleanIndex > -1;
                prop[1 /* shouldCastTrue */ ] = stringIndex < 0 || booleanIndex < stringIndex;
                if (booleanIndex > -1 || (0, $lbCQA.hasOwn)(prop, "default")) needCastKeys.push(normalizedKey1);
            }
        }
    }
    var res = [
        normalized,
        needCastKeys
    ];
    if ((0, $lbCQA.isObject)(comp)) cache.set(comp, res);
    return res;
}
function $7bd48593473bea18$var$validatePropName(key) {
    if (key[0] !== "$" && !(0, $lbCQA.isReservedProp)(key)) return true;
    return false;
}
function $7bd48593473bea18$var$getType(ctor) {
    if (ctor === null) return "null";
    if (typeof ctor === "function") return ctor.name || "";
    else if (typeof ctor === "object") {
        var name = ctor.constructor && ctor.constructor.name;
        return name || "";
    }
    return "";
}
function $7bd48593473bea18$var$isSameType(a, b) {
    return $7bd48593473bea18$var$getType(a) === $7bd48593473bea18$var$getType(b);
}
function $7bd48593473bea18$var$getTypeIndex(type, expectedTypes) {
    if ((0, $lbCQA.isArray)(expectedTypes)) return expectedTypes.findIndex(function(t) {
        return $7bd48593473bea18$var$isSameType(t, type);
    });
    else if ((0, $lbCQA.isFunction)(expectedTypes)) return $7bd48593473bea18$var$isSameType(expectedTypes, type) ? 0 : -1;
    return -1;
}
function $7bd48593473bea18$var$validateProps(rawProps, props, instance) {
    var resolvedValues = (0, $aAzpa.toRaw)(props);
    var options = instance.propsOptions[0];
    for(var key in options){
        var opt = options[key];
        if (opt == null) continue;
        $7bd48593473bea18$var$validateProp(key, resolvedValues[key], opt, resolvedValues, !(0, $lbCQA.hasOwn)(rawProps, key) && !(0, $lbCQA.hasOwn)(rawProps, (0, $lbCQA.hyphenate)(key)));
    }
}
function $7bd48593473bea18$var$validateProp(name, value, prop, props, isAbsent) {
    var type = prop.type, required = prop.required, validator = prop.validator, skipCheck = prop.skipCheck;
    if (required && isAbsent) {
        $7bd48593473bea18$var$warn$1('Missing required prop: "' + name + '"');
        return;
    }
    if (value == null && !required) return;
    if (type != null && type !== true && !skipCheck) {
        var isValid = false;
        var types = (0, $lbCQA.isArray)(type) ? type : [
            type
        ];
        var expectedTypes = [];
        for(var i = 0; i < types.length && !isValid; i++){
            var _assertType = $7bd48593473bea18$var$assertType(value, types[i]), valid = _assertType.valid, expectedType = _assertType.expectedType;
            expectedTypes.push(expectedType || "");
            isValid = valid;
        }
        if (!isValid) {
            $7bd48593473bea18$var$warn$1($7bd48593473bea18$var$getInvalidTypeMessage(name, value, expectedTypes));
            return;
        }
    }
    if (validator && !validator(value, props)) $7bd48593473bea18$var$warn$1('Invalid prop: custom validator check failed for prop "' + name + '".');
}
var $7bd48593473bea18$var$isSimpleType = /* @__PURE__ */ (0, $lbCQA.makeMap)("String,Number,Boolean,Function,Symbol,BigInt");
function $7bd48593473bea18$var$assertType(value, type) {
    var valid;
    var expectedType = $7bd48593473bea18$var$getType(type);
    if ($7bd48593473bea18$var$isSimpleType(expectedType)) {
        var t = typeof value === "undefined" ? "undefined" : (0, $jzTO1._)(value);
        valid = t === expectedType.toLowerCase();
        if (!valid && t === "object") valid = value instanceof type;
    } else if (expectedType === "Object") valid = (0, $lbCQA.isObject)(value);
    else if (expectedType === "Array") valid = (0, $lbCQA.isArray)(value);
    else if (expectedType === "null") valid = value === null;
    else valid = value instanceof type;
    return {
        valid: valid,
        expectedType: expectedType
    };
}
function $7bd48593473bea18$var$getInvalidTypeMessage(name, value, expectedTypes) {
    if (expectedTypes.length === 0) return 'Prop type [] for prop "'.concat(name, "\" won't match anything. Did you mean to use type Array instead?");
    var message = 'Invalid prop: type check failed for prop "'.concat(name, '". Expected ').concat(expectedTypes.map((0, $lbCQA.capitalize)).join(" | "));
    var expectedType = expectedTypes[0];
    var receivedType = (0, $lbCQA.toRawType)(value);
    var expectedValue = $7bd48593473bea18$var$styleValue(value, expectedType);
    var receivedValue = $7bd48593473bea18$var$styleValue(value, receivedType);
    if (expectedTypes.length === 1 && $7bd48593473bea18$var$isExplicable(expectedType) && !$7bd48593473bea18$var$isBoolean(expectedType, receivedType)) message += " with value ".concat(expectedValue);
    message += ", got ".concat(receivedType, " ");
    if ($7bd48593473bea18$var$isExplicable(receivedType)) message += "with value ".concat(receivedValue, ".");
    return message;
}
function $7bd48593473bea18$var$styleValue(value, type) {
    if (type === "String") return '"'.concat(value, '"');
    else if (type === "Number") return "".concat(Number(value));
    else return "".concat(value);
}
function $7bd48593473bea18$var$isExplicable(type) {
    var explicitTypes = [
        "string",
        "number",
        "boolean"
    ];
    return explicitTypes.some(function(elem) {
        return type.toLowerCase() === elem;
    });
}
function $7bd48593473bea18$var$isBoolean() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    return args.some(function(elem) {
        return elem.toLowerCase() === "boolean";
    });
}
var $7bd48593473bea18$var$isInternalKey = function(key) {
    return key[0] === "_" || key === "$stable";
};
var $7bd48593473bea18$var$normalizeSlotValue = function(value) {
    return (0, $lbCQA.isArray)(value) ? value.map($7bd48593473bea18$var$normalizeVNode) : [
        $7bd48593473bea18$var$normalizeVNode(value)
    ];
};
var $7bd48593473bea18$var$normalizeSlot = function(key, rawSlot, ctx) {
    if (rawSlot._n) return rawSlot;
    var normalized = $7bd48593473bea18$export$694b237e827a3d23(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return $7bd48593473bea18$var$normalizeSlotValue(rawSlot.apply(void 0, (0, $79xu7._)(args)));
    }, ctx);
    normalized._c = false;
    return normalized;
};
var $7bd48593473bea18$var$normalizeObjectSlots = function(rawSlots, slots, instance) {
    var _loop = function(key) {
        if ($7bd48593473bea18$var$isInternalKey(key)) return "continue";
        var value = rawSlots[key];
        if ((0, $lbCQA.isFunction)(value)) slots[key] = $7bd48593473bea18$var$normalizeSlot(key, value, ctx);
        else if (value != null) {
            var normalized = $7bd48593473bea18$var$normalizeSlotValue(value);
            slots[key] = function() {
                return normalized;
            };
        }
    };
    var ctx = rawSlots._ctx;
    for(var key in rawSlots)_loop(key);
};
var $7bd48593473bea18$var$normalizeVNodeSlots = function(instance, children) {
    var normalized = $7bd48593473bea18$var$normalizeSlotValue(children);
    instance.slots.default = function() {
        return normalized;
    };
};
var $7bd48593473bea18$var$initSlots = function(instance, children) {
    var slots = instance.slots = $7bd48593473bea18$var$createInternalObject();
    if (instance.vnode.shapeFlag & 32) {
        var type = children._;
        if (type) {
            (0, $lbCQA.extend)(slots, children);
            (0, $lbCQA.def)(slots, "_", type);
        } else $7bd48593473bea18$var$normalizeObjectSlots(children, slots);
    } else if (children) $7bd48593473bea18$var$normalizeVNodeSlots(instance, children);
};
var $7bd48593473bea18$var$updateSlots = function(instance, children, optimized) {
    var vnode = instance.vnode, slots = instance.slots;
    var needDeletionCheck = true;
    var deletionComparisonTarget = (0, $lbCQA.EMPTY_OBJ);
    if (vnode.shapeFlag & 32) {
        var type = children._;
        if (type) {
            if (optimized && type === 1) needDeletionCheck = false;
            else {
                (0, $lbCQA.extend)(slots, children);
                if (!optimized && type === 1) delete slots._;
            }
        } else {
            needDeletionCheck = !children.$stable;
            $7bd48593473bea18$var$normalizeObjectSlots(children, slots);
        }
        deletionComparisonTarget = children;
    } else if (children) {
        $7bd48593473bea18$var$normalizeVNodeSlots(instance, children);
        deletionComparisonTarget = {
            default: 1
        };
    }
    if (needDeletionCheck) {
        for(var key in slots)if (!$7bd48593473bea18$var$isInternalKey(key) && deletionComparisonTarget[key] == null) delete slots[key];
    }
};
function $7bd48593473bea18$var$setRef(rawRef, oldRawRef, parentSuspense, vnode) {
    var isUnmount = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
    if ((0, $lbCQA.isArray)(rawRef)) {
        rawRef.forEach(function(r, i) {
            return $7bd48593473bea18$var$setRef(r, oldRawRef && ((0, $lbCQA.isArray)(oldRawRef) ? oldRawRef[i] : oldRawRef), parentSuspense, vnode, isUnmount);
        });
        return;
    }
    if ($7bd48593473bea18$var$isAsyncWrapper(vnode) && !isUnmount) return;
    var refValue = vnode.shapeFlag & 4 ? $7bd48593473bea18$var$getExposeProxy(vnode.component) || vnode.component.proxy : vnode.el;
    var value = isUnmount ? null : refValue;
    var owner = rawRef.i, ref = rawRef.r;
    var oldRef = oldRawRef && oldRawRef.r;
    var refs = owner.refs === (0, $lbCQA.EMPTY_OBJ) ? owner.refs = {} : owner.refs;
    var setupState = owner.setupState;
    if (oldRef != null && oldRef !== ref) {
        if ((0, $lbCQA.isString)(oldRef)) {
            refs[oldRef] = null;
            if ((0, $lbCQA.hasOwn)(setupState, oldRef)) setupState[oldRef] = null;
        } else if ((0, $aAzpa.isRef)(oldRef)) oldRef.value = null;
    }
    if ((0, $lbCQA.isFunction)(ref)) $7bd48593473bea18$export$b22fcaf88446e9bf(ref, owner, 12, [
        value,
        refs
    ]);
    else {
        var _isString = (0, $lbCQA.isString)(ref);
        var _isRef = (0, $aAzpa.isRef)(ref);
        if (_isString || _isRef) {
            var doSet = function() {
                if (rawRef.f) {
                    var existing = _isString ? (0, $lbCQA.hasOwn)(setupState, ref) ? setupState[ref] : refs[ref] : ref.value;
                    if (isUnmount) (0, $lbCQA.isArray)(existing) && (0, $lbCQA.remove)(existing, refValue);
                    else {
                        if (!(0, $lbCQA.isArray)(existing)) {
                            if (_isString) {
                                refs[ref] = [
                                    refValue
                                ];
                                if ((0, $lbCQA.hasOwn)(setupState, ref)) setupState[ref] = refs[ref];
                            } else {
                                ref.value = [
                                    refValue
                                ];
                                if (rawRef.k) refs[rawRef.k] = ref.value;
                            }
                        } else if (!existing.includes(refValue)) existing.push(refValue);
                    }
                } else if (_isString) {
                    refs[ref] = value;
                    if ((0, $lbCQA.hasOwn)(setupState, ref)) setupState[ref] = value;
                } else if (_isRef) {
                    ref.value = value;
                    if (rawRef.k) refs[rawRef.k] = value;
                }
            };
            if (value) {
                doSet.id = -1;
                $7bd48593473bea18$var$queuePostRenderEffect(doSet, parentSuspense);
            } else doSet();
        }
    }
}
var $7bd48593473bea18$var$hasMismatch = false;
var $7bd48593473bea18$var$isSVGContainer = function(container) {
    return container.namespaceURI.includes("svg") && container.tagName !== "foreignObject";
};
var $7bd48593473bea18$var$isMathMLContainer = function(container) {
    return container.namespaceURI.includes("MathML");
};
var $7bd48593473bea18$var$getContainerType = function(container) {
    if ($7bd48593473bea18$var$isSVGContainer(container)) return "svg";
    if ($7bd48593473bea18$var$isMathMLContainer(container)) return "mathml";
    return void 0;
};
var $7bd48593473bea18$var$isComment = function(node) {
    return node.nodeType === 8 /* COMMENT */ ;
};
function $7bd48593473bea18$var$createHydrationFunctions(rendererInternals) {
    var mountComponent = rendererInternals.mt, patch = rendererInternals.p, _rendererInternals_o = rendererInternals.o, patchProp = _rendererInternals_o.patchProp, createText = _rendererInternals_o.createText, nextSibling = _rendererInternals_o.nextSibling, parentNode = _rendererInternals_o.parentNode, remove = _rendererInternals_o.remove, insert = _rendererInternals_o.insert, createComment = _rendererInternals_o.createComment;
    var hydrate = function(vnode, container) {
        if (!container.hasChildNodes()) {
            __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $7bd48593473bea18$var$warn$1("Attempting to hydrate existing markup but container is empty. Performing full mount instead.");
            patch(null, vnode, container);
            $7bd48593473bea18$var$flushPostFlushCbs();
            container._vnode = vnode;
            return;
        }
        $7bd48593473bea18$var$hasMismatch = false;
        hydrateNode(container.firstChild, vnode, null, null, null);
        $7bd48593473bea18$var$flushPostFlushCbs();
        container._vnode = vnode;
        if ($7bd48593473bea18$var$hasMismatch && true) console.error("Hydration completed but contains mismatches.");
    };
    var hydrateNode = function(node, vnode, parentComponent, parentSuspense, slotScopeIds) {
        var optimized = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : false;
        optimized = optimized || !!vnode.dynamicChildren;
        var isFragmentStart = $7bd48593473bea18$var$isComment(node) && node.data === "[";
        var onMismatch = function() {
            return handleMismatch(node, vnode, parentComponent, parentSuspense, slotScopeIds, isFragmentStart);
        };
        var type = vnode.type, ref = vnode.ref, shapeFlag = vnode.shapeFlag, patchFlag = vnode.patchFlag;
        var domType = node.nodeType;
        vnode.el = node;
        if (__VUE_PROD_DEVTOOLS__) {
            if (!("__vnode" in node)) Object.defineProperty(node, "__vnode", {
                value: vnode,
                enumerable: false
            });
            if (!("__vueParentComponent" in node)) Object.defineProperty(node, "__vueParentComponent", {
                value: parentComponent,
                enumerable: false
            });
        }
        if (patchFlag === -2) {
            optimized = false;
            vnode.dynamicChildren = null;
        }
        var nextNode = null;
        switch(type){
            case $7bd48593473bea18$export$5f1af8db9871e1d6:
                if (domType !== 3 /* TEXT */ ) {
                    if (vnode.children === "") {
                        insert(vnode.el = createText(""), parentNode(node), node);
                        nextNode = node;
                    } else nextNode = onMismatch();
                } else {
                    if (node.data !== vnode.children) {
                        $7bd48593473bea18$var$hasMismatch = true;
                        __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $7bd48593473bea18$var$warn$1("Hydration text mismatch in", node.parentNode, "\n  - rendered on server: ".concat(JSON.stringify(node.data), "\n  - expected on client: ").concat(JSON.stringify(vnode.children)));
                        node.data = vnode.children;
                    }
                    nextNode = nextSibling(node);
                }
                break;
            case $7bd48593473bea18$export$4d299b491347818a:
                if (isTemplateNode(node)) {
                    nextNode = nextSibling(node);
                    replaceNode(vnode.el = node.content.firstChild, node, parentComponent);
                } else if (domType !== 8 /* COMMENT */  || isFragmentStart) nextNode = onMismatch();
                else nextNode = nextSibling(node);
                break;
            case $7bd48593473bea18$export$c1b9a1d3af45b7b6:
                if (isFragmentStart) {
                    node = nextSibling(node);
                    domType = node.nodeType;
                }
                if (domType === 1 /* ELEMENT */  || domType === 3 /* TEXT */ ) {
                    nextNode = node;
                    var needToAdoptContent = !vnode.children.length;
                    for(var i = 0; i < vnode.staticCount; i++){
                        if (needToAdoptContent) vnode.children += nextNode.nodeType === 1 /* ELEMENT */  ? nextNode.outerHTML : nextNode.data;
                        if (i === vnode.staticCount - 1) vnode.anchor = nextNode;
                        nextNode = nextSibling(nextNode);
                    }
                    return isFragmentStart ? nextSibling(nextNode) : nextNode;
                } else onMismatch();
                break;
            case $7bd48593473bea18$export$ffb0004e005737fa:
                if (!isFragmentStart) nextNode = onMismatch();
                else nextNode = hydrateFragment(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
                break;
            default:
                if (shapeFlag & 1) {
                    if ((domType !== 1 /* ELEMENT */  || vnode.type.toLowerCase() !== node.tagName.toLowerCase()) && !isTemplateNode(node)) nextNode = onMismatch();
                    else nextNode = hydrateElement(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
                } else if (shapeFlag & 6) {
                    vnode.slotScopeIds = slotScopeIds;
                    var container = parentNode(node);
                    if (isFragmentStart) nextNode = locateClosingAnchor(node);
                    else if ($7bd48593473bea18$var$isComment(node) && node.data === "teleport start") nextNode = locateClosingAnchor(node, node.data, "teleport end");
                    else nextNode = nextSibling(node);
                    mountComponent(vnode, container, null, parentComponent, parentSuspense, $7bd48593473bea18$var$getContainerType(container), optimized);
                    if ($7bd48593473bea18$var$isAsyncWrapper(vnode)) {
                        var subTree;
                        if (isFragmentStart) {
                            subTree = $7bd48593473bea18$export$bf5c4cf060303d58($7bd48593473bea18$export$ffb0004e005737fa);
                            subTree.anchor = nextNode ? nextNode.previousSibling : container.lastChild;
                        } else subTree = node.nodeType === 3 ? $7bd48593473bea18$export$22f9b5ffd89dac9("") : $7bd48593473bea18$export$bf5c4cf060303d58("div");
                        subTree.el = node;
                        vnode.component.subTree = subTree;
                    }
                } else if (shapeFlag & 64) {
                    if (domType !== 8 /* COMMENT */ ) nextNode = onMismatch();
                    else nextNode = vnode.type.hydrate(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized, rendererInternals, hydrateChildren);
                } else if (shapeFlag & 128) nextNode = vnode.type.hydrate(node, vnode, parentComponent, parentSuspense, $7bd48593473bea18$var$getContainerType(parentNode(node)), slotScopeIds, optimized, rendererInternals, hydrateNode);
                else if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__) $7bd48593473bea18$var$warn$1("Invalid HostVNode type:", type, "(".concat(typeof type === "undefined" ? "undefined" : (0, $jzTO1._)(type), ")"));
        }
        if (ref != null) $7bd48593473bea18$var$setRef(ref, null, parentSuspense, vnode);
        return nextNode;
    };
    var hydrateElement = function(el, vnode, parentComponent, parentSuspense, slotScopeIds, optimized) {
        optimized = optimized || !!vnode.dynamicChildren;
        var type = vnode.type, props = vnode.props, patchFlag = vnode.patchFlag, shapeFlag = vnode.shapeFlag, dirs = vnode.dirs, transition = vnode.transition;
        var forcePatch = type === "input" || type === "option";
        if (forcePatch || patchFlag !== -1) {
            if (dirs) $7bd48593473bea18$var$invokeDirectiveHook(vnode, null, parentComponent, "created");
            var needCallTransitionHooks = false;
            if (isTemplateNode(el)) {
                needCallTransitionHooks = $7bd48593473bea18$var$needTransition(parentSuspense, transition) && parentComponent && parentComponent.vnode.props && parentComponent.vnode.props.appear;
                var content = el.content.firstChild;
                if (needCallTransitionHooks) transition.beforeEnter(content);
                replaceNode(content, el, parentComponent);
                vnode.el = el = content;
            }
            if (shapeFlag & 16 && // skip if element has innerHTML / textContent
            !(props && (props.innerHTML || props.textContent))) {
                var next = hydrateChildren(el.firstChild, vnode, el, parentComponent, parentSuspense, slotScopeIds, optimized);
                var hasWarned = false;
                while(next){
                    $7bd48593473bea18$var$hasMismatch = true;
                    if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && !hasWarned) {
                        $7bd48593473bea18$var$warn$1("Hydration children mismatch on", el, "\nServer rendered element contains more child nodes than client vdom.");
                        hasWarned = true;
                    }
                    var cur = next;
                    next = next.nextSibling;
                    remove(cur);
                }
            } else if (shapeFlag & 8) {
                if (el.textContent !== vnode.children) {
                    $7bd48593473bea18$var$hasMismatch = true;
                    __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $7bd48593473bea18$var$warn$1("Hydration text content mismatch on", el, "\n  - rendered on server: ".concat(el.textContent, "\n  - expected on client: ").concat(vnode.children));
                    el.textContent = vnode.children;
                }
            }
            if (props) {
                if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ || forcePatch || !optimized || patchFlag & 48) for(var key in props){
                    if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $7bd48593473bea18$var$propHasMismatch(el, key, props[key], vnode, parentComponent)) $7bd48593473bea18$var$hasMismatch = true;
                    if (forcePatch && (key.endsWith("value") || key === "indeterminate") || (0, $lbCQA.isOn)(key) && !(0, $lbCQA.isReservedProp)(key) || // force hydrate v-bind with .prop modifiers
                    key[0] === ".") patchProp(el, key, null, props[key], void 0, void 0, parentComponent);
                }
                else if (props.onClick) patchProp(el, "onClick", null, props.onClick, void 0, void 0, parentComponent);
            }
            var vnodeHooks;
            if (vnodeHooks = props && props.onVnodeBeforeMount) $7bd48593473bea18$var$invokeVNodeHook(vnodeHooks, parentComponent, vnode);
            if (dirs) $7bd48593473bea18$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeMount");
            if ((vnodeHooks = props && props.onVnodeMounted) || dirs || needCallTransitionHooks) $7bd48593473bea18$var$queueEffectWithSuspense(function() {
                vnodeHooks && $7bd48593473bea18$var$invokeVNodeHook(vnodeHooks, parentComponent, vnode);
                needCallTransitionHooks && transition.enter(el);
                dirs && $7bd48593473bea18$var$invokeDirectiveHook(vnode, null, parentComponent, "mounted");
            }, parentSuspense);
        }
        return el.nextSibling;
    };
    var hydrateChildren = function(node, parentVNode, container, parentComponent, parentSuspense, slotScopeIds, optimized) {
        optimized = optimized || !!parentVNode.dynamicChildren;
        var children = parentVNode.children;
        var l = children.length;
        var hasWarned = false;
        for(var i = 0; i < l; i++){
            var vnode = optimized ? children[i] : children[i] = $7bd48593473bea18$var$normalizeVNode(children[i]);
            if (node) node = hydrateNode(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
            else if (vnode.type === $7bd48593473bea18$export$5f1af8db9871e1d6 && !vnode.children) continue;
            else {
                $7bd48593473bea18$var$hasMismatch = true;
                if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && !hasWarned) {
                    $7bd48593473bea18$var$warn$1("Hydration children mismatch on", container, "\nServer rendered element contains fewer child nodes than client vdom.");
                    hasWarned = true;
                }
                patch(null, vnode, container, null, parentComponent, parentSuspense, $7bd48593473bea18$var$getContainerType(container), slotScopeIds);
            }
        }
        return node;
    };
    var hydrateFragment = function(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized) {
        var fragmentSlotScopeIds = vnode.slotScopeIds;
        if (fragmentSlotScopeIds) slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
        var container = parentNode(node);
        var next = hydrateChildren(nextSibling(node), vnode, container, parentComponent, parentSuspense, slotScopeIds, optimized);
        if (next && $7bd48593473bea18$var$isComment(next) && next.data === "]") return nextSibling(vnode.anchor = next);
        else {
            $7bd48593473bea18$var$hasMismatch = true;
            insert(vnode.anchor = createComment("]"), container, next);
            return next;
        }
    };
    var handleMismatch = function(node, vnode, parentComponent, parentSuspense, slotScopeIds, isFragment) {
        $7bd48593473bea18$var$hasMismatch = true;
        __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $7bd48593473bea18$var$warn$1("Hydration node mismatch:\n- rendered on server:", node, node.nodeType === 3 /* TEXT */  ? "(text)" : $7bd48593473bea18$var$isComment(node) && node.data === "[" ? "(start of fragment)" : "", "\n- expected on client:", vnode.type);
        vnode.el = null;
        if (isFragment) {
            var end = locateClosingAnchor(node);
            while(true){
                var next2 = nextSibling(node);
                if (next2 && next2 !== end) remove(next2);
                else break;
            }
        }
        var next = nextSibling(node);
        var container = parentNode(node);
        remove(node);
        patch(null, vnode, container, next, parentComponent, parentSuspense, $7bd48593473bea18$var$getContainerType(container), slotScopeIds);
        return next;
    };
    var locateClosingAnchor = function(node) {
        var open = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "[", close = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "]";
        var match = 0;
        while(node){
            node = nextSibling(node);
            if (node && $7bd48593473bea18$var$isComment(node)) {
                if (node.data === open) match++;
                if (node.data === close) {
                    if (match === 0) return nextSibling(node);
                    else match--;
                }
            }
        }
        return node;
    };
    var replaceNode = function(newNode, oldNode, parentComponent) {
        var parentNode2 = oldNode.parentNode;
        if (parentNode2) parentNode2.replaceChild(newNode, oldNode);
        var parent = parentComponent;
        while(parent){
            if (parent.vnode.el === oldNode) parent.vnode.el = parent.subTree.el = newNode;
            parent = parent.parent;
        }
    };
    var isTemplateNode = function(node) {
        return node.nodeType === 1 /* ELEMENT */  && node.tagName.toLowerCase() === "template";
    };
    return [
        hydrate,
        hydrateNode
    ];
}
function $7bd48593473bea18$var$propHasMismatch(el, key, clientValue, vnode, instance) {
    var _a;
    var mismatchType;
    var mismatchKey;
    var actual;
    var expected;
    if (key === "class") {
        actual = el.getAttribute("class");
        expected = (0, $lbCQA.normalizeClass)(clientValue);
        if (!$7bd48593473bea18$var$isSetEqual($7bd48593473bea18$var$toClassSet(actual || ""), $7bd48593473bea18$var$toClassSet(expected))) mismatchType = mismatchKey = "class";
    } else if (key === "style") {
        actual = el.getAttribute("style");
        expected = (0, $lbCQA.isString)(clientValue) ? clientValue : (0, $lbCQA.stringifyStyle)((0, $lbCQA.normalizeStyle)(clientValue));
        var actualMap = $7bd48593473bea18$var$toStyleMap(actual);
        var expectedMap = $7bd48593473bea18$var$toStyleMap(expected);
        if (vnode.dirs) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = vnode.dirs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _step_value = _step.value, dir = _step_value.dir, value = _step_value.value;
                    if (dir.name === "show" && !value) expectedMap.set("display", "none");
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
        var root = instance == null ? void 0 : instance.subTree;
        if (vnode === root || (root == null ? void 0 : root.type) === $7bd48593473bea18$export$ffb0004e005737fa && root.children.includes(vnode)) {
            var cssVars = (_a = instance == null ? void 0 : instance.getCssVars) == null ? void 0 : _a.call(instance);
            for(var key2 in cssVars)expectedMap.set("--".concat(key2), String(cssVars[key2]));
        }
        if (!$7bd48593473bea18$var$isMapEqual(actualMap, expectedMap)) mismatchType = mismatchKey = "style";
    } else if (el instanceof SVGElement && (0, $lbCQA.isKnownSvgAttr)(key) || el instanceof HTMLElement && ((0, $lbCQA.isBooleanAttr)(key) || (0, $lbCQA.isKnownHtmlAttr)(key))) {
        if ((0, $lbCQA.isBooleanAttr)(key)) {
            actual = el.hasAttribute(key);
            expected = (0, $lbCQA.includeBooleanAttr)(clientValue);
        } else if (clientValue == null) {
            actual = el.hasAttribute(key);
            expected = false;
        } else {
            if (el.hasAttribute(key)) actual = el.getAttribute(key);
            else if (key === "value" && el.tagName === "TEXTAREA") actual = el.value;
            else actual = false;
            expected = (0, $lbCQA.isRenderableAttrValue)(clientValue) ? String(clientValue) : false;
        }
        if (actual !== expected) {
            mismatchType = "attribute";
            mismatchKey = key;
        }
    }
    if (mismatchType) {
        var format = function(v1) {
            return v1 === false ? "(not rendered)" : "".concat(mismatchKey, '="').concat(v1, '"');
        };
        var preSegment = "Hydration ".concat(mismatchType, " mismatch on");
        var postSegment = "\n  - rendered on server: ".concat(format(actual), "\n  - expected on client: ").concat(format(expected), "\n  Note: this mismatch is check-only. The DOM will not be rectified in production due to performance overhead.\n  You should fix the source of the mismatch.");
        $7bd48593473bea18$var$warn$1(preSegment, el, postSegment);
        return true;
    }
    return false;
}
function $7bd48593473bea18$var$toClassSet(str) {
    return new Set(str.trim().split(/\s+/));
}
function $7bd48593473bea18$var$isSetEqual(a, b) {
    if (a.size !== b.size) return false;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = a[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var s = _step.value;
            if (!b.has(s)) return false;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return true;
}
function $7bd48593473bea18$var$toStyleMap(str) {
    var styleMap = /* @__PURE__ */ new Map();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = str.split(";")[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var item = _step.value;
            var _item_split = (0, $4f96i._)(item.split(":"), 2), key = _item_split[0], value = _item_split[1];
            key = key == null ? void 0 : key.trim();
            value = value == null ? void 0 : value.trim();
            if (key && value) styleMap.set(key, value);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return styleMap;
}
function $7bd48593473bea18$var$isMapEqual(a, b) {
    if (a.size !== b.size) return false;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = a[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $4f96i._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
            if (value !== b.get(key)) return false;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return true;
}
var $7bd48593473bea18$var$supported;
var $7bd48593473bea18$var$perf;
function $7bd48593473bea18$var$startMeasure(instance, type) {
    if (instance.appContext.config.performance && $7bd48593473bea18$var$isSupported()) $7bd48593473bea18$var$perf.mark("vue-".concat(type, "-").concat(instance.uid));
    if (__VUE_PROD_DEVTOOLS__) $7bd48593473bea18$var$devtoolsPerfStart(instance, type, $7bd48593473bea18$var$isSupported() ? $7bd48593473bea18$var$perf.now() : Date.now());
}
function $7bd48593473bea18$var$endMeasure(instance, type) {
    if (instance.appContext.config.performance && $7bd48593473bea18$var$isSupported()) {
        var startTag = "vue-".concat(type, "-").concat(instance.uid);
        var endTag = startTag + ":end";
        $7bd48593473bea18$var$perf.mark(endTag);
        $7bd48593473bea18$var$perf.measure("<".concat($7bd48593473bea18$var$formatComponentName(instance, instance.type), "> ").concat(type), startTag, endTag);
        $7bd48593473bea18$var$perf.clearMarks(startTag);
        $7bd48593473bea18$var$perf.clearMarks(endTag);
    }
    if (__VUE_PROD_DEVTOOLS__) $7bd48593473bea18$var$devtoolsPerfEnd(instance, type, $7bd48593473bea18$var$isSupported() ? $7bd48593473bea18$var$perf.now() : Date.now());
}
function $7bd48593473bea18$var$isSupported() {
    if ($7bd48593473bea18$var$supported !== void 0) return $7bd48593473bea18$var$supported;
    if (typeof window !== "undefined" && window.performance) {
        $7bd48593473bea18$var$supported = true;
        $7bd48593473bea18$var$perf = window.performance;
    } else $7bd48593473bea18$var$supported = false;
    return $7bd48593473bea18$var$supported;
}
function $7bd48593473bea18$var$initFeatureFlags() {
    var needWarn = [];
    if (typeof __VUE_OPTIONS_API__ !== "boolean") (0, $lbCQA.getGlobalThis)().__VUE_OPTIONS_API__ = true;
    if (typeof __VUE_PROD_DEVTOOLS__ !== "boolean") (0, $lbCQA.getGlobalThis)().__VUE_PROD_DEVTOOLS__ = false;
    if (typeof __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ !== "boolean") (0, $lbCQA.getGlobalThis)().__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ = false;
}
var $7bd48593473bea18$var$queuePostRenderEffect = $7bd48593473bea18$var$queueEffectWithSuspense;
function $7bd48593473bea18$export$53ae2f996c64e9a(options) {
    return $7bd48593473bea18$var$baseCreateRenderer(options);
}
function $7bd48593473bea18$export$200524cf0d997ff0(options) {
    return $7bd48593473bea18$var$baseCreateRenderer(options, $7bd48593473bea18$var$createHydrationFunctions);
}
function $7bd48593473bea18$var$baseCreateRenderer(options, createHydrationFns) {
    $7bd48593473bea18$var$initFeatureFlags();
    var target = (0, $lbCQA.getGlobalThis)();
    target.__VUE__ = true;
    if (__VUE_PROD_DEVTOOLS__) $7bd48593473bea18$var$setDevtoolsHook$1(target.__VUE_DEVTOOLS_GLOBAL_HOOK__, target);
    var hostInsert = options.insert, hostRemove = options.remove, hostPatchProp = options.patchProp, hostCreateElement = options.createElement, hostCreateText = options.createText, hostCreateComment = options.createComment, hostSetText = options.setText, hostSetElementText = options.setElementText, hostParentNode = options.parentNode, hostNextSibling = options.nextSibling, tmp = options.setScopeId, hostSetScopeId = tmp === void 0 ? (0, $lbCQA.NOOP) : tmp, hostInsertStaticContent = options.insertStaticContent;
    var patch = function(n1, n2, container) {
        var anchor = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null, parentComponent = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null, parentSuspense = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : null, namespace = arguments.length > 6 ? arguments[6] : void 0, slotScopeIds = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : null, optimized = arguments.length > 8 && arguments[8] !== void 0 ? arguments[8] : !!n2.dynamicChildren;
        if (n1 === n2) return;
        if (n1 && !$7bd48593473bea18$var$isSameVNodeType(n1, n2)) {
            anchor = getNextHostNode(n1);
            unmount(n1, parentComponent, parentSuspense, true);
            n1 = null;
        }
        if (n2.patchFlag === -2) {
            optimized = false;
            n2.dynamicChildren = null;
        }
        var type = n2.type, ref = n2.ref, shapeFlag = n2.shapeFlag;
        switch(type){
            case $7bd48593473bea18$export$5f1af8db9871e1d6:
                processText(n1, n2, container, anchor);
                break;
            case $7bd48593473bea18$export$4d299b491347818a:
                processCommentNode(n1, n2, container, anchor);
                break;
            case $7bd48593473bea18$export$c1b9a1d3af45b7b6:
                if (n1 == null) mountStaticNode(n2, container, anchor, namespace);
                break;
            case $7bd48593473bea18$export$ffb0004e005737fa:
                processFragment(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                break;
            default:
                if (shapeFlag & 1) processElement(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (shapeFlag & 6) processComponent(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (shapeFlag & 64) type.process(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals);
                else if (shapeFlag & 128) type.process(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals);
        }
        if (ref != null && parentComponent) $7bd48593473bea18$var$setRef(ref, n1 && n1.ref, parentSuspense, n2 || n1, !n2);
    };
    var processText = function(n1, n2, container, anchor) {
        if (n1 == null) hostInsert(n2.el = hostCreateText(n2.children), container, anchor);
        else {
            var el = n2.el = n1.el;
            if (n2.children !== n1.children) hostSetText(el, n2.children);
        }
    };
    var processCommentNode = function(n1, n2, container, anchor) {
        if (n1 == null) hostInsert(n2.el = hostCreateComment(n2.children || ""), container, anchor);
        else n2.el = n1.el;
    };
    var mountStaticNode = function(n2, container, anchor, namespace) {
        var ref;
        ref = (0, $4f96i._)(hostInsertStaticContent(n2.children, container, anchor, namespace, n2.el, n2.anchor), 2), n2.el = ref[0], n2.anchor = ref[1], ref;
    };
    var patchStaticNode = function(n1, n2, container, namespace) {
        if (n2.children !== n1.children) {
            var anchor = hostNextSibling(n1.anchor);
            removeStaticNode(n1);
            var ref;
            ref = (0, $4f96i._)(hostInsertStaticContent(n2.children, container, anchor, namespace), 2), n2.el = ref[0], n2.anchor = ref[1], ref;
        } else {
            n2.el = n1.el;
            n2.anchor = n1.anchor;
        }
    };
    var moveStaticNode = function(param, container, nextSibling) {
        var el = param.el, anchor = param.anchor;
        var next;
        while(el && el !== anchor){
            next = hostNextSibling(el);
            hostInsert(el, container, nextSibling);
            el = next;
        }
        hostInsert(anchor, container, nextSibling);
    };
    var removeStaticNode = function(param) {
        var el = param.el, anchor = param.anchor;
        var next;
        while(el && el !== anchor){
            next = hostNextSibling(el);
            hostRemove(el);
            el = next;
        }
        hostRemove(anchor);
    };
    var processElement = function(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized) {
        if (n2.type === "svg") namespace = "svg";
        else if (n2.type === "math") namespace = "mathml";
        if (n1 == null) mountElement(n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        else patchElement(n1, n2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
    };
    var mountElement = function(vnode, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized) {
        var el;
        var vnodeHook;
        var props = vnode.props, shapeFlag = vnode.shapeFlag, transition = vnode.transition, dirs = vnode.dirs;
        el = vnode.el = hostCreateElement(vnode.type, namespace, props && props.is, props);
        if (shapeFlag & 8) hostSetElementText(el, vnode.children);
        else if (shapeFlag & 16) mountChildren(vnode.children, el, null, parentComponent, parentSuspense, $7bd48593473bea18$var$resolveChildrenNamespace(vnode, namespace), slotScopeIds, optimized);
        if (dirs) $7bd48593473bea18$var$invokeDirectiveHook(vnode, null, parentComponent, "created");
        setScopeId(el, vnode, vnode.scopeId, slotScopeIds, parentComponent);
        if (props) {
            for(var key in props)if (key !== "value" && !(0, $lbCQA.isReservedProp)(key)) hostPatchProp(el, key, null, props[key], namespace, vnode.children, parentComponent, parentSuspense, unmountChildren);
            if ("value" in props) hostPatchProp(el, "value", null, props.value, namespace);
            if (vnodeHook = props.onVnodeBeforeMount) $7bd48593473bea18$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
        }
        if (__VUE_PROD_DEVTOOLS__) {
            Object.defineProperty(el, "__vnode", {
                value: vnode,
                enumerable: false
            });
            Object.defineProperty(el, "__vueParentComponent", {
                value: parentComponent,
                enumerable: false
            });
        }
        if (dirs) $7bd48593473bea18$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeMount");
        var needCallTransitionHooks = $7bd48593473bea18$var$needTransition(parentSuspense, transition);
        if (needCallTransitionHooks) transition.beforeEnter(el);
        hostInsert(el, container, anchor);
        if ((vnodeHook = props && props.onVnodeMounted) || needCallTransitionHooks || dirs) $7bd48593473bea18$var$queuePostRenderEffect(function() {
            vnodeHook && $7bd48593473bea18$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
            needCallTransitionHooks && transition.enter(el);
            dirs && $7bd48593473bea18$var$invokeDirectiveHook(vnode, null, parentComponent, "mounted");
        }, parentSuspense);
    };
    var setScopeId = function(el, vnode, scopeId, slotScopeIds, parentComponent) {
        if (scopeId) hostSetScopeId(el, scopeId);
        if (slotScopeIds) for(var i = 0; i < slotScopeIds.length; i++)hostSetScopeId(el, slotScopeIds[i]);
        if (parentComponent) {
            var subTree = parentComponent.subTree;
            if (vnode === subTree) {
                var parentVNode = parentComponent.vnode;
                setScopeId(el, parentVNode, parentVNode.scopeId, parentVNode.slotScopeIds, parentComponent.parent);
            }
        }
    };
    var mountChildren = function(children, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized) {
        var start = arguments.length > 8 && arguments[8] !== void 0 ? arguments[8] : 0;
        for(var i = start; i < children.length; i++){
            var child = children[i] = optimized ? $7bd48593473bea18$var$cloneIfMounted(children[i]) : $7bd48593473bea18$var$normalizeVNode(children[i]);
            patch(null, child, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
    };
    var patchElement = function(n1, n2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized) {
        var el = n2.el = n1.el;
        var patchFlag = n2.patchFlag, dynamicChildren = n2.dynamicChildren, dirs = n2.dirs;
        patchFlag |= n1.patchFlag & 16;
        var oldProps = n1.props || (0, $lbCQA.EMPTY_OBJ);
        var newProps = n2.props || (0, $lbCQA.EMPTY_OBJ);
        var vnodeHook;
        parentComponent && $7bd48593473bea18$var$toggleRecurse(parentComponent, false);
        if (vnodeHook = newProps.onVnodeBeforeUpdate) $7bd48593473bea18$var$invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
        if (dirs) $7bd48593473bea18$var$invokeDirectiveHook(n2, n1, parentComponent, "beforeUpdate");
        parentComponent && $7bd48593473bea18$var$toggleRecurse(parentComponent, true);
        if (dynamicChildren) patchBlockChildren(n1.dynamicChildren, dynamicChildren, el, parentComponent, parentSuspense, $7bd48593473bea18$var$resolveChildrenNamespace(n2, namespace), slotScopeIds);
        else if (!optimized) patchChildren(n1, n2, el, null, parentComponent, parentSuspense, $7bd48593473bea18$var$resolveChildrenNamespace(n2, namespace), slotScopeIds, false);
        if (patchFlag > 0) {
            if (patchFlag & 16) patchProps(el, n2, oldProps, newProps, parentComponent, parentSuspense, namespace);
            else {
                if (patchFlag & 2) {
                    if (oldProps.class !== newProps.class) hostPatchProp(el, "class", null, newProps.class, namespace);
                }
                if (patchFlag & 4) hostPatchProp(el, "style", oldProps.style, newProps.style, namespace);
                if (patchFlag & 8) {
                    var propsToUpdate = n2.dynamicProps;
                    for(var i = 0; i < propsToUpdate.length; i++){
                        var key = propsToUpdate[i];
                        var prev = oldProps[key];
                        var next = newProps[key];
                        if (next !== prev || key === "value") hostPatchProp(el, key, prev, next, namespace, n1.children, parentComponent, parentSuspense, unmountChildren);
                    }
                }
            }
            if (patchFlag & 1) {
                if (n1.children !== n2.children) hostSetElementText(el, n2.children);
            }
        } else if (!optimized && dynamicChildren == null) patchProps(el, n2, oldProps, newProps, parentComponent, parentSuspense, namespace);
        if ((vnodeHook = newProps.onVnodeUpdated) || dirs) $7bd48593473bea18$var$queuePostRenderEffect(function() {
            vnodeHook && $7bd48593473bea18$var$invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
            dirs && $7bd48593473bea18$var$invokeDirectiveHook(n2, n1, parentComponent, "updated");
        }, parentSuspense);
    };
    var patchBlockChildren = function(oldChildren, newChildren, fallbackContainer, parentComponent, parentSuspense, namespace, slotScopeIds) {
        for(var i = 0; i < newChildren.length; i++){
            var oldVNode = oldChildren[i];
            var newVNode = newChildren[i];
            var container = // oldVNode may be an errored async setup() component inside Suspense
            // which will not have a mounted element
            oldVNode.el && // - In the case of a Fragment, we need to provide the actual parent
            // of the Fragment itself so it can move its children.
            (oldVNode.type === $7bd48593473bea18$export$ffb0004e005737fa || // - In the case of different nodes, there is going to be a replacement
            // which also requires the correct parent container
            !$7bd48593473bea18$var$isSameVNodeType(oldVNode, newVNode) || // - In the case of a component, it could contain anything.
            oldVNode.shapeFlag & 70) ? hostParentNode(oldVNode.el) : // In other cases, the parent container is not actually used so we
            // just pass the block element here to avoid a DOM parentNode call.
            fallbackContainer;
            patch(oldVNode, newVNode, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, true);
        }
    };
    var patchProps = function(el, vnode, oldProps, newProps, parentComponent, parentSuspense, namespace) {
        if (oldProps !== newProps) {
            if (oldProps !== (0, $lbCQA.EMPTY_OBJ)) {
                for(var key in oldProps)if (!(0, $lbCQA.isReservedProp)(key) && !(key in newProps)) hostPatchProp(el, key, oldProps[key], null, namespace, vnode.children, parentComponent, parentSuspense, unmountChildren);
            }
            for(var key1 in newProps){
                if ((0, $lbCQA.isReservedProp)(key1)) continue;
                var next = newProps[key1];
                var prev = oldProps[key1];
                if (next !== prev && key1 !== "value") hostPatchProp(el, key1, prev, next, namespace, vnode.children, parentComponent, parentSuspense, unmountChildren);
            }
            if ("value" in newProps) hostPatchProp(el, "value", oldProps.value, newProps.value, namespace);
        }
    };
    var processFragment = function(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized) {
        var fragmentStartAnchor = n2.el = n1 ? n1.el : hostCreateText("");
        var fragmentEndAnchor = n2.anchor = n1 ? n1.anchor : hostCreateText("");
        var patchFlag = n2.patchFlag, dynamicChildren = n2.dynamicChildren, fragmentSlotScopeIds = n2.slotScopeIds;
        if (fragmentSlotScopeIds) slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
        if (n1 == null) {
            hostInsert(fragmentStartAnchor, container, anchor);
            hostInsert(fragmentEndAnchor, container, anchor);
            mountChildren(// #10007
            // such fragment like `<></>` will be compiled into
            // a fragment which doesn't have a children.
            // In this case fallback to an empty array
            n2.children || [], container, fragmentEndAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        } else if (patchFlag > 0 && patchFlag & 64 && dynamicChildren && // #2715 the previous fragment could've been a BAILed one as a result
        // of renderSlot() with no valid children
        n1.dynamicChildren) {
            patchBlockChildren(n1.dynamicChildren, dynamicChildren, container, parentComponent, parentSuspense, namespace, slotScopeIds);
            if (// #2080 if the stable fragment has a key, it's a <template v-for> that may
            //  get moved around. Make sure all root level vnodes inherit el.
            // #2134 or if it's a component root, it may also get moved around
            // as the component is being moved.
            n2.key != null || parentComponent && n2 === parentComponent.subTree) $7bd48593473bea18$var$traverseStaticChildren(n1, n2, true);
        } else patchChildren(n1, n2, container, fragmentEndAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
    };
    var processComponent = function(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized) {
        n2.slotScopeIds = slotScopeIds;
        if (n1 == null) {
            if (n2.shapeFlag & 512) parentComponent.ctx.activate(n2, container, anchor, namespace, optimized);
            else mountComponent(n2, container, anchor, parentComponent, parentSuspense, namespace, optimized);
        } else updateComponent(n1, n2, optimized);
    };
    var mountComponent = function(initialVNode, container, anchor, parentComponent, parentSuspense, namespace, optimized) {
        var instance = initialVNode.component = $7bd48593473bea18$var$createComponentInstance(initialVNode, parentComponent, parentSuspense);
        if ($7bd48593473bea18$var$isKeepAlive(initialVNode)) instance.ctx.renderer = internals;
        $7bd48593473bea18$var$setupComponent(instance);
        if (instance.asyncDep) {
            parentSuspense && parentSuspense.registerDep(instance, setupRenderEffect);
            if (!initialVNode.el) {
                var placeholder = instance.subTree = $7bd48593473bea18$export$bf5c4cf060303d58($7bd48593473bea18$export$4d299b491347818a);
                processCommentNode(null, placeholder, container, anchor);
            }
        } else setupRenderEffect(instance, initialVNode, container, anchor, parentSuspense, namespace, optimized);
    };
    var updateComponent = function(n1, n2, optimized) {
        var instance = n2.component = n1.component;
        if ($7bd48593473bea18$var$shouldUpdateComponent(n1, n2, optimized)) {
            if (instance.asyncDep && !instance.asyncResolved) {
                updateComponentPreRender(instance, n2, optimized);
                return;
            } else {
                instance.next = n2;
                $7bd48593473bea18$var$invalidateJob(instance.update);
                instance.effect.dirty = true;
                instance.update();
            }
        } else {
            n2.el = n1.el;
            instance.vnode = n2;
        }
    };
    var setupRenderEffect = function(instance, initialVNode, container, anchor, parentSuspense, namespace, optimized) {
        var componentUpdateFn = function() {
            if (!instance.isMounted) {
                var vnodeHook;
                var el = initialVNode.el, props = initialVNode.props;
                var bm = instance.bm, m = instance.m, parent = instance.parent;
                var isAsyncWrapperVNode = $7bd48593473bea18$var$isAsyncWrapper(initialVNode);
                $7bd48593473bea18$var$toggleRecurse(instance, false);
                if (bm) (0, $lbCQA.invokeArrayFns)(bm);
                if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeBeforeMount)) $7bd48593473bea18$var$invokeVNodeHook(vnodeHook, parent, initialVNode);
                $7bd48593473bea18$var$toggleRecurse(instance, true);
                if (el && hydrateNode) {
                    var hydrateSubTree = function() {
                        instance.subTree = $7bd48593473bea18$var$renderComponentRoot(instance);
                        hydrateNode(el, instance.subTree, instance, parentSuspense, null);
                    };
                    if (isAsyncWrapperVNode) initialVNode.type.__asyncLoader().then(// note: we are moving the render call into an async callback,
                    // which means it won't track dependencies - but it's ok because
                    // a server-rendered async wrapper is already in resolved state
                    // and it will never need to change.
                    function() {
                        return !instance.isUnmounted && hydrateSubTree();
                    });
                    else hydrateSubTree();
                } else {
                    var subTree = instance.subTree = $7bd48593473bea18$var$renderComponentRoot(instance);
                    patch(null, subTree, container, anchor, instance, parentSuspense, namespace);
                    initialVNode.el = subTree.el;
                }
                if (m) $7bd48593473bea18$var$queuePostRenderEffect(m, parentSuspense);
                if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeMounted)) {
                    var scopedInitialVNode = initialVNode;
                    $7bd48593473bea18$var$queuePostRenderEffect(function() {
                        return $7bd48593473bea18$var$invokeVNodeHook(vnodeHook, parent, scopedInitialVNode);
                    }, parentSuspense);
                }
                if (initialVNode.shapeFlag & 256 || parent && $7bd48593473bea18$var$isAsyncWrapper(parent.vnode) && parent.vnode.shapeFlag & 256) instance.a && $7bd48593473bea18$var$queuePostRenderEffect(instance.a, parentSuspense);
                instance.isMounted = true;
                if (__VUE_PROD_DEVTOOLS__) $7bd48593473bea18$var$devtoolsComponentAdded(instance);
                initialVNode = container = anchor = null;
            } else {
                var next = instance.next, bu = instance.bu, u = instance.u, parent1 = instance.parent, vnode = instance.vnode;
                {
                    var nonHydratedAsyncRoot = $7bd48593473bea18$var$locateNonHydratedAsyncRoot(instance);
                    if (nonHydratedAsyncRoot) {
                        if (next) {
                            next.el = vnode.el;
                            updateComponentPreRender(instance, next, optimized);
                        }
                        nonHydratedAsyncRoot.asyncDep.then(function() {
                            if (!instance.isUnmounted) componentUpdateFn();
                        });
                        return;
                    }
                }
                var originNext = next;
                var vnodeHook1;
                $7bd48593473bea18$var$toggleRecurse(instance, false);
                if (next) {
                    next.el = vnode.el;
                    updateComponentPreRender(instance, next, optimized);
                } else next = vnode;
                if (bu) (0, $lbCQA.invokeArrayFns)(bu);
                if (vnodeHook1 = next.props && next.props.onVnodeBeforeUpdate) $7bd48593473bea18$var$invokeVNodeHook(vnodeHook1, parent1, next, vnode);
                $7bd48593473bea18$var$toggleRecurse(instance, true);
                var nextTree = $7bd48593473bea18$var$renderComponentRoot(instance);
                var prevTree = instance.subTree;
                instance.subTree = nextTree;
                patch(prevTree, nextTree, // parent may have changed if it's in a teleport
                hostParentNode(prevTree.el), // anchor may have changed if it's in a fragment
                getNextHostNode(prevTree), instance, parentSuspense, namespace);
                next.el = nextTree.el;
                if (originNext === null) $7bd48593473bea18$var$updateHOCHostEl(instance, nextTree.el);
                if (u) $7bd48593473bea18$var$queuePostRenderEffect(u, parentSuspense);
                if (vnodeHook1 = next.props && next.props.onVnodeUpdated) $7bd48593473bea18$var$queuePostRenderEffect(function() {
                    return $7bd48593473bea18$var$invokeVNodeHook(vnodeHook1, parent1, next, vnode);
                }, parentSuspense);
                if (__VUE_PROD_DEVTOOLS__) $7bd48593473bea18$var$devtoolsComponentUpdated(instance);
            }
        };
        var effect = instance.effect = new (0, $aAzpa.ReactiveEffect)(componentUpdateFn, (0, $lbCQA.NOOP), function() {
            return $7bd48593473bea18$var$queueJob(update);
        }, instance.scope);
        var update = instance.update = function() {
            if (effect.dirty) effect.run();
        };
        update.id = instance.uid;
        $7bd48593473bea18$var$toggleRecurse(instance, true);
        var e, e1;
        update();
    };
    var updateComponentPreRender = function(instance, nextVNode, optimized) {
        nextVNode.component = instance;
        var prevProps = instance.vnode.props;
        instance.vnode = nextVNode;
        instance.next = null;
        $7bd48593473bea18$var$updateProps(instance, nextVNode.props, prevProps, optimized);
        $7bd48593473bea18$var$updateSlots(instance, nextVNode.children, optimized);
        (0, $aAzpa.pauseTracking)();
        $7bd48593473bea18$var$flushPreFlushCbs(instance);
        (0, $aAzpa.resetTracking)();
    };
    var patchChildren = function(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds) {
        var optimized = arguments.length > 8 && arguments[8] !== void 0 ? arguments[8] : false;
        var c1 = n1 && n1.children;
        var prevShapeFlag = n1 ? n1.shapeFlag : 0;
        var c2 = n2.children;
        var patchFlag = n2.patchFlag, shapeFlag = n2.shapeFlag;
        if (patchFlag > 0) {
            if (patchFlag & 128) {
                patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                return;
            } else if (patchFlag & 256) {
                patchUnkeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                return;
            }
        }
        if (shapeFlag & 8) {
            if (prevShapeFlag & 16) unmountChildren(c1, parentComponent, parentSuspense);
            if (c2 !== c1) hostSetElementText(container, c2);
        } else if (prevShapeFlag & 16) {
            if (shapeFlag & 16) patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else unmountChildren(c1, parentComponent, parentSuspense, true);
        } else {
            if (prevShapeFlag & 8) hostSetElementText(container, "");
            if (shapeFlag & 16) mountChildren(c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
    };
    var patchUnkeyedChildren = function(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized) {
        c1 = c1 || (0, $lbCQA.EMPTY_ARR);
        c2 = c2 || (0, $lbCQA.EMPTY_ARR);
        var oldLength = c1.length;
        var newLength = c2.length;
        var commonLength = Math.min(oldLength, newLength);
        var i;
        for(i = 0; i < commonLength; i++){
            var nextChild = c2[i] = optimized ? $7bd48593473bea18$var$cloneIfMounted(c2[i]) : $7bd48593473bea18$var$normalizeVNode(c2[i]);
            patch(c1[i], nextChild, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
        if (oldLength > newLength) unmountChildren(c1, parentComponent, parentSuspense, true, false, commonLength);
        else mountChildren(c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, commonLength);
    };
    var patchKeyedChildren = function(c1, c2, container, parentAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized) {
        var i = 0;
        var l2 = c2.length;
        var e1 = c1.length - 1;
        var e2 = l2 - 1;
        while(i <= e1 && i <= e2){
            var n1 = c1[i];
            var n2 = c2[i] = optimized ? $7bd48593473bea18$var$cloneIfMounted(c2[i]) : $7bd48593473bea18$var$normalizeVNode(c2[i]);
            if ($7bd48593473bea18$var$isSameVNodeType(n1, n2)) patch(n1, n2, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else break;
            i++;
        }
        while(i <= e1 && i <= e2){
            var n11 = c1[e1];
            var n21 = c2[e2] = optimized ? $7bd48593473bea18$var$cloneIfMounted(c2[e2]) : $7bd48593473bea18$var$normalizeVNode(c2[e2]);
            if ($7bd48593473bea18$var$isSameVNodeType(n11, n21)) patch(n11, n21, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else break;
            e1--;
            e2--;
        }
        if (i > e1) {
            if (i <= e2) {
                var nextPos = e2 + 1;
                var anchor = nextPos < l2 ? c2[nextPos].el : parentAnchor;
                while(i <= e2){
                    patch(null, c2[i] = optimized ? $7bd48593473bea18$var$cloneIfMounted(c2[i]) : $7bd48593473bea18$var$normalizeVNode(c2[i]), container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                    i++;
                }
            }
        } else if (i > e2) while(i <= e1){
            unmount(c1[i], parentComponent, parentSuspense, true);
            i++;
        }
        else {
            var s1 = i;
            var s2 = i;
            var keyToNewIndexMap = /* @__PURE__ */ new Map();
            for(i = s2; i <= e2; i++){
                var nextChild = c2[i] = optimized ? $7bd48593473bea18$var$cloneIfMounted(c2[i]) : $7bd48593473bea18$var$normalizeVNode(c2[i]);
                if (nextChild.key != null) keyToNewIndexMap.set(nextChild.key, i);
            }
            var j;
            var patched = 0;
            var toBePatched = e2 - s2 + 1;
            var moved = false;
            var maxNewIndexSoFar = 0;
            var newIndexToOldIndexMap = new Array(toBePatched);
            for(i = 0; i < toBePatched; i++)newIndexToOldIndexMap[i] = 0;
            for(i = s1; i <= e1; i++){
                var prevChild = c1[i];
                if (patched >= toBePatched) {
                    unmount(prevChild, parentComponent, parentSuspense, true);
                    continue;
                }
                var newIndex = void 0;
                if (prevChild.key != null) newIndex = keyToNewIndexMap.get(prevChild.key);
                else {
                    for(j = s2; j <= e2; j++)if (newIndexToOldIndexMap[j - s2] === 0 && $7bd48593473bea18$var$isSameVNodeType(prevChild, c2[j])) {
                        newIndex = j;
                        break;
                    }
                }
                if (newIndex === void 0) unmount(prevChild, parentComponent, parentSuspense, true);
                else {
                    newIndexToOldIndexMap[newIndex - s2] = i + 1;
                    if (newIndex >= maxNewIndexSoFar) maxNewIndexSoFar = newIndex;
                    else moved = true;
                    patch(prevChild, c2[newIndex], container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                    patched++;
                }
            }
            var increasingNewIndexSequence = moved ? $7bd48593473bea18$var$getSequence(newIndexToOldIndexMap) : (0, $lbCQA.EMPTY_ARR);
            j = increasingNewIndexSequence.length - 1;
            for(i = toBePatched - 1; i >= 0; i--){
                var nextIndex = s2 + i;
                var nextChild1 = c2[nextIndex];
                var anchor1 = nextIndex + 1 < l2 ? c2[nextIndex + 1].el : parentAnchor;
                if (newIndexToOldIndexMap[i] === 0) patch(null, nextChild1, container, anchor1, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (moved) {
                    if (j < 0 || i !== increasingNewIndexSequence[j]) move(nextChild1, container, anchor1, 2);
                    else j--;
                }
            }
        }
    };
    var move = function(vnode, container, anchor, moveType) {
        var parentSuspense = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null;
        var el = vnode.el, type = vnode.type, transition = vnode.transition, children = vnode.children, shapeFlag = vnode.shapeFlag;
        if (shapeFlag & 6) {
            move(vnode.component.subTree, container, anchor, moveType);
            return;
        }
        if (shapeFlag & 128) {
            vnode.suspense.move(container, anchor, moveType);
            return;
        }
        if (shapeFlag & 64) {
            type.move(vnode, container, anchor, internals);
            return;
        }
        if (type === $7bd48593473bea18$export$ffb0004e005737fa) {
            hostInsert(el, container, anchor);
            for(var i = 0; i < children.length; i++)move(children[i], container, anchor, moveType);
            hostInsert(vnode.anchor, container, anchor);
            return;
        }
        if (type === $7bd48593473bea18$export$c1b9a1d3af45b7b6) {
            moveStaticNode(vnode, container, anchor);
            return;
        }
        var needTransition2 = moveType !== 2 && shapeFlag & 1 && transition;
        if (needTransition2) {
            if (moveType === 0) {
                transition.beforeEnter(el);
                hostInsert(el, container, anchor);
                $7bd48593473bea18$var$queuePostRenderEffect(function() {
                    return transition.enter(el);
                }, parentSuspense);
            } else {
                var leave = transition.leave, delayLeave = transition.delayLeave, afterLeave = transition.afterLeave;
                var remove2 = function() {
                    return hostInsert(el, container, anchor);
                };
                var performLeave = function() {
                    leave(el, function() {
                        remove2();
                        afterLeave && afterLeave();
                    });
                };
                if (delayLeave) delayLeave(el, remove2, performLeave);
                else performLeave();
            }
        } else hostInsert(el, container, anchor);
    };
    var unmount = function(vnode, parentComponent, parentSuspense) {
        var doRemove = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false, optimized = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
        var type = vnode.type, props = vnode.props, ref = vnode.ref, children = vnode.children, dynamicChildren = vnode.dynamicChildren, shapeFlag = vnode.shapeFlag, patchFlag = vnode.patchFlag, dirs = vnode.dirs;
        if (ref != null) $7bd48593473bea18$var$setRef(ref, null, parentSuspense, vnode, true);
        if (shapeFlag & 256) {
            parentComponent.ctx.deactivate(vnode);
            return;
        }
        var shouldInvokeDirs = shapeFlag & 1 && dirs;
        var shouldInvokeVnodeHook = !$7bd48593473bea18$var$isAsyncWrapper(vnode);
        var vnodeHook;
        if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeBeforeUnmount)) $7bd48593473bea18$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
        if (shapeFlag & 6) unmountComponent(vnode.component, parentSuspense, doRemove);
        else {
            if (shapeFlag & 128) {
                vnode.suspense.unmount(parentSuspense, doRemove);
                return;
            }
            if (shouldInvokeDirs) $7bd48593473bea18$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeUnmount");
            if (shapeFlag & 64) vnode.type.remove(vnode, parentComponent, parentSuspense, optimized, internals, doRemove);
            else if (dynamicChildren && // #1153: fast path should not be taken for non-stable (v-for) fragments
            (type !== $7bd48593473bea18$export$ffb0004e005737fa || patchFlag > 0 && patchFlag & 64)) unmountChildren(dynamicChildren, parentComponent, parentSuspense, false, true);
            else if (type === $7bd48593473bea18$export$ffb0004e005737fa && patchFlag & 384 || !optimized && shapeFlag & 16) unmountChildren(children, parentComponent, parentSuspense);
            if (doRemove) remove(vnode);
        }
        if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeUnmounted) || shouldInvokeDirs) $7bd48593473bea18$var$queuePostRenderEffect(function() {
            vnodeHook && $7bd48593473bea18$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
            shouldInvokeDirs && $7bd48593473bea18$var$invokeDirectiveHook(vnode, null, parentComponent, "unmounted");
        }, parentSuspense);
    };
    var remove = function(vnode) {
        var type = vnode.type, el = vnode.el, anchor = vnode.anchor, transition = vnode.transition;
        if (type === $7bd48593473bea18$export$ffb0004e005737fa) {
            var child;
            removeFragment(el, anchor);
            return;
        }
        if (type === $7bd48593473bea18$export$c1b9a1d3af45b7b6) {
            removeStaticNode(vnode);
            return;
        }
        var performRemove = function() {
            hostRemove(el);
            if (transition && !transition.persisted && transition.afterLeave) transition.afterLeave();
        };
        if (vnode.shapeFlag & 1 && transition && !transition.persisted) {
            var leave = transition.leave, delayLeave = transition.delayLeave;
            var performLeave = function() {
                return leave(el, performRemove);
            };
            if (delayLeave) delayLeave(vnode.el, performRemove, performLeave);
            else performLeave();
        } else performRemove();
    };
    var removeFragment = function(cur, end) {
        var next;
        while(cur !== end){
            next = hostNextSibling(cur);
            hostRemove(cur);
            cur = next;
        }
        hostRemove(end);
    };
    var unmountComponent = function(instance, parentSuspense, doRemove) {
        var bum = instance.bum, scope = instance.scope, update = instance.update, subTree = instance.subTree, um = instance.um;
        if (bum) (0, $lbCQA.invokeArrayFns)(bum);
        scope.stop();
        if (update) {
            update.active = false;
            unmount(subTree, instance, parentSuspense, doRemove);
        }
        if (um) $7bd48593473bea18$var$queuePostRenderEffect(um, parentSuspense);
        $7bd48593473bea18$var$queuePostRenderEffect(function() {
            instance.isUnmounted = true;
        }, parentSuspense);
        if (parentSuspense && parentSuspense.pendingBranch && !parentSuspense.isUnmounted && instance.asyncDep && !instance.asyncResolved && instance.suspenseId === parentSuspense.pendingId) {
            parentSuspense.deps--;
            if (parentSuspense.deps === 0) parentSuspense.resolve();
        }
        if (__VUE_PROD_DEVTOOLS__) $7bd48593473bea18$var$devtoolsComponentRemoved(instance);
    };
    var unmountChildren = function(children, parentComponent, parentSuspense) {
        var doRemove = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false, optimized = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false, start = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : 0;
        for(var i = start; i < children.length; i++)unmount(children[i], parentComponent, parentSuspense, doRemove, optimized);
    };
    var getNextHostNode = function(vnode) {
        if (vnode.shapeFlag & 6) return getNextHostNode(vnode.component.subTree);
        if (vnode.shapeFlag & 128) return vnode.suspense.next();
        return hostNextSibling(vnode.anchor || vnode.el);
    };
    var isFlushing = false;
    var render = function(vnode, container, namespace) {
        if (vnode == null) {
            if (container._vnode) unmount(container._vnode, null, null, true);
        } else patch(container._vnode || null, vnode, container, null, null, null, namespace);
        if (!isFlushing) {
            isFlushing = true;
            $7bd48593473bea18$var$flushPreFlushCbs();
            $7bd48593473bea18$var$flushPostFlushCbs();
            isFlushing = false;
        }
        container._vnode = vnode;
    };
    var internals = {
        p: patch,
        um: unmount,
        m: move,
        r: remove,
        mt: mountComponent,
        mc: mountChildren,
        pc: patchChildren,
        pbc: patchBlockChildren,
        n: getNextHostNode,
        o: options
    };
    var hydrate;
    var hydrateNode;
    var ref;
    if (createHydrationFns) ref = (0, $4f96i._)(createHydrationFns(internals), 2), hydrate = ref[0], hydrateNode = ref[1], ref;
    return {
        render: render,
        hydrate: hydrate,
        createApp: $7bd48593473bea18$var$createAppAPI(render, hydrate)
    };
}
function $7bd48593473bea18$var$resolveChildrenNamespace(param, currentNamespace) {
    var type = param.type, props = param.props;
    return currentNamespace === "svg" && type === "foreignObject" || currentNamespace === "mathml" && type === "annotation-xml" && props && props.encoding && props.encoding.includes("html") ? void 0 : currentNamespace;
}
function $7bd48593473bea18$var$toggleRecurse(param, allowed) {
    var effect = param.effect, update = param.update;
    effect.allowRecurse = update.allowRecurse = allowed;
}
function $7bd48593473bea18$var$needTransition(parentSuspense, transition) {
    return (!parentSuspense || parentSuspense && !parentSuspense.pendingBranch) && transition && !transition.persisted;
}
function $7bd48593473bea18$var$traverseStaticChildren(n1, n2) {
    var shallow = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var ch1 = n1.children;
    var ch2 = n2.children;
    if ((0, $lbCQA.isArray)(ch1) && (0, $lbCQA.isArray)(ch2)) for(var i = 0; i < ch1.length; i++){
        var c1 = ch1[i];
        var c2 = ch2[i];
        if (c2.shapeFlag & 1 && !c2.dynamicChildren) {
            if (c2.patchFlag <= 0 || c2.patchFlag === 32) {
                c2 = ch2[i] = $7bd48593473bea18$var$cloneIfMounted(ch2[i]);
                c2.el = c1.el;
            }
            if (!shallow) $7bd48593473bea18$var$traverseStaticChildren(c1, c2);
        }
        if (c2.type === $7bd48593473bea18$export$5f1af8db9871e1d6) c2.el = c1.el;
    }
}
function $7bd48593473bea18$var$getSequence(arr) {
    var p = arr.slice();
    var result = [
        0
    ];
    var i, j, u, v1, c;
    var len = arr.length;
    for(i = 0; i < len; i++){
        var arrI = arr[i];
        if (arrI !== 0) {
            j = result[result.length - 1];
            if (arr[j] < arrI) {
                p[i] = j;
                result.push(i);
                continue;
            }
            u = 0;
            v1 = result.length - 1;
            while(u < v1){
                c = u + v1 >> 1;
                if (arr[result[c]] < arrI) u = c + 1;
                else v1 = c;
            }
            if (arrI < arr[result[u]]) {
                if (u > 0) p[i] = result[u - 1];
                result[u] = i;
            }
        }
    }
    u = result.length;
    v1 = result[u - 1];
    while(u-- > 0){
        result[u] = v1;
        v1 = p[v1];
    }
    return result;
}
function $7bd48593473bea18$var$locateNonHydratedAsyncRoot(instance) {
    var subComponent = instance.subTree.component;
    if (subComponent) {
        if (subComponent.asyncDep && !subComponent.asyncResolved) return subComponent;
        else return $7bd48593473bea18$var$locateNonHydratedAsyncRoot(subComponent);
    }
}
var $7bd48593473bea18$var$isTeleport = function(type) {
    return type.__isTeleport;
};
var $7bd48593473bea18$var$isTeleportDisabled = function(props) {
    return props && (props.disabled || props.disabled === "");
};
var $7bd48593473bea18$var$isTargetSVG = function(target) {
    return typeof SVGElement !== "undefined" && target instanceof SVGElement;
};
var $7bd48593473bea18$var$isTargetMathML = function(target) {
    return typeof MathMLElement === "function" && target instanceof MathMLElement;
};
var $7bd48593473bea18$var$resolveTarget = function(props, select) {
    var targetSelector = props && props.to;
    if ((0, $lbCQA.isString)(targetSelector)) {
        if (!select) return null;
        else {
            var target = select(targetSelector);
            target;
            return target;
        }
    } else return targetSelector;
};
var $7bd48593473bea18$var$TeleportImpl = {
    name: "Teleport",
    __isTeleport: true,
    process: function(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals) {
        var mountChildren = internals.mc, patchChildren = internals.pc, patchBlockChildren = internals.pbc, _internals_o = internals.o, insert = _internals_o.insert, querySelector = _internals_o.querySelector, createText = _internals_o.createText, createComment = _internals_o.createComment;
        var disabled = $7bd48593473bea18$var$isTeleportDisabled(n2.props);
        var shapeFlag = n2.shapeFlag, children = n2.children, dynamicChildren = n2.dynamicChildren;
        if (n1 == null) {
            var placeholder = n2.el = createText("");
            var mainAnchor = n2.anchor = createText("");
            insert(placeholder, container, anchor);
            insert(mainAnchor, container, anchor);
            var target = n2.target = $7bd48593473bea18$var$resolveTarget(n2.props, querySelector);
            var targetAnchor = n2.targetAnchor = createText("");
            if (target) {
                insert(targetAnchor, target);
                if (namespace === "svg" || $7bd48593473bea18$var$isTargetSVG(target)) namespace = "svg";
                else if (namespace === "mathml" || $7bd48593473bea18$var$isTargetMathML(target)) namespace = "mathml";
            }
            var mount = function(container2, anchor2) {
                if (shapeFlag & 16) mountChildren(children, container2, anchor2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            };
            if (disabled) mount(container, mainAnchor);
            else if (target) mount(target, targetAnchor);
        } else {
            n2.el = n1.el;
            var mainAnchor1 = n2.anchor = n1.anchor;
            var target1 = n2.target = n1.target;
            var targetAnchor1 = n2.targetAnchor = n1.targetAnchor;
            var wasDisabled = $7bd48593473bea18$var$isTeleportDisabled(n1.props);
            var currentContainer = wasDisabled ? container : target1;
            var currentAnchor = wasDisabled ? mainAnchor1 : targetAnchor1;
            if (namespace === "svg" || $7bd48593473bea18$var$isTargetSVG(target1)) namespace = "svg";
            else if (namespace === "mathml" || $7bd48593473bea18$var$isTargetMathML(target1)) namespace = "mathml";
            if (dynamicChildren) {
                patchBlockChildren(n1.dynamicChildren, dynamicChildren, currentContainer, parentComponent, parentSuspense, namespace, slotScopeIds);
                $7bd48593473bea18$var$traverseStaticChildren(n1, n2, true);
            } else if (!optimized) patchChildren(n1, n2, currentContainer, currentAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, false);
            if (disabled) {
                if (!wasDisabled) $7bd48593473bea18$var$moveTeleport(n2, container, mainAnchor1, internals, 1);
                else if (n2.props && n1.props && n2.props.to !== n1.props.to) n2.props.to = n1.props.to;
            } else {
                if ((n2.props && n2.props.to) !== (n1.props && n1.props.to)) {
                    var nextTarget = n2.target = $7bd48593473bea18$var$resolveTarget(n2.props, querySelector);
                    if (nextTarget) $7bd48593473bea18$var$moveTeleport(n2, nextTarget, null, internals, 0);
                } else if (wasDisabled) $7bd48593473bea18$var$moveTeleport(n2, target1, targetAnchor1, internals, 1);
            }
        }
        $7bd48593473bea18$var$updateCssVars(n2);
    },
    remove: function(vnode, parentComponent, parentSuspense, optimized, param, doRemove) {
        var unmount = param.um, _param_o = param.o, hostRemove = _param_o.remove;
        var shapeFlag = vnode.shapeFlag, children = vnode.children, anchor = vnode.anchor, targetAnchor = vnode.targetAnchor, target = vnode.target, props = vnode.props;
        if (target) hostRemove(targetAnchor);
        doRemove && hostRemove(anchor);
        if (shapeFlag & 16) {
            var shouldRemove = doRemove || !$7bd48593473bea18$var$isTeleportDisabled(props);
            for(var i = 0; i < children.length; i++){
                var child = children[i];
                unmount(child, parentComponent, parentSuspense, shouldRemove, !!child.dynamicChildren);
            }
        }
    },
    move: $7bd48593473bea18$var$moveTeleport,
    hydrate: $7bd48593473bea18$var$hydrateTeleport
};
function $7bd48593473bea18$var$moveTeleport(vnode, container, parentAnchor, param) {
    var insert = param.o.insert, move = param.m, moveType = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 2;
    if (moveType === 0) insert(vnode.targetAnchor, container, parentAnchor);
    var el = vnode.el, anchor = vnode.anchor, shapeFlag = vnode.shapeFlag, children = vnode.children, props = vnode.props;
    var isReorder = moveType === 2;
    if (isReorder) insert(el, container, parentAnchor);
    if (!isReorder || $7bd48593473bea18$var$isTeleportDisabled(props)) {
        if (shapeFlag & 16) for(var i = 0; i < children.length; i++)move(children[i], container, parentAnchor, 2);
    }
    if (isReorder) insert(anchor, container, parentAnchor);
}
function $7bd48593473bea18$var$hydrateTeleport(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized, param, hydrateChildren) {
    var _param_o = param.o, nextSibling = _param_o.nextSibling, parentNode = _param_o.parentNode, querySelector = _param_o.querySelector;
    var target = vnode.target = $7bd48593473bea18$var$resolveTarget(vnode.props, querySelector);
    if (target) {
        var targetNode = target._lpa || target.firstChild;
        if (vnode.shapeFlag & 16) {
            if ($7bd48593473bea18$var$isTeleportDisabled(vnode.props)) {
                vnode.anchor = hydrateChildren(nextSibling(node), vnode, parentNode(node), parentComponent, parentSuspense, slotScopeIds, optimized);
                vnode.targetAnchor = targetNode;
            } else {
                vnode.anchor = nextSibling(node);
                var targetAnchor = targetNode;
                while(targetAnchor){
                    targetAnchor = nextSibling(targetAnchor);
                    if (targetAnchor && targetAnchor.nodeType === 8 && targetAnchor.data === "teleport anchor") {
                        vnode.targetAnchor = targetAnchor;
                        target._lpa = vnode.targetAnchor && nextSibling(vnode.targetAnchor);
                        break;
                    }
                }
                hydrateChildren(targetNode, vnode, target, parentComponent, parentSuspense, slotScopeIds, optimized);
            }
        }
        $7bd48593473bea18$var$updateCssVars(vnode);
    }
    return vnode.anchor && nextSibling(vnode.anchor);
}
var $7bd48593473bea18$export$76d55a0304a371f4 = $7bd48593473bea18$var$TeleportImpl;
function $7bd48593473bea18$var$updateCssVars(vnode) {
    var ctx = vnode.ctx;
    if (ctx && ctx.ut) {
        var node = vnode.children[0].el;
        while(node && node !== vnode.targetAnchor){
            if (node.nodeType === 1) node.setAttribute("data-v-owner", ctx.uid);
            node = node.nextSibling;
        }
        ctx.ut();
    }
}
var $7bd48593473bea18$export$ffb0004e005737fa = Symbol.for("v-fgt");
var $7bd48593473bea18$export$5f1af8db9871e1d6 = Symbol.for("v-txt");
var $7bd48593473bea18$export$4d299b491347818a = Symbol.for("v-cmt");
var $7bd48593473bea18$export$c1b9a1d3af45b7b6 = Symbol.for("v-stc");
var $7bd48593473bea18$var$blockStack = [];
var $7bd48593473bea18$var$currentBlock = null;
function $7bd48593473bea18$export$e7eaa45e502fe5cc() {
    var disableTracking = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    $7bd48593473bea18$var$blockStack.push($7bd48593473bea18$var$currentBlock = disableTracking ? null : []);
}
function $7bd48593473bea18$var$closeBlock() {
    $7bd48593473bea18$var$blockStack.pop();
    $7bd48593473bea18$var$currentBlock = $7bd48593473bea18$var$blockStack[$7bd48593473bea18$var$blockStack.length - 1] || null;
}
var $7bd48593473bea18$var$isBlockTreeEnabled = 1;
function $7bd48593473bea18$export$c20bee82f26f1e27(value) {
    $7bd48593473bea18$var$isBlockTreeEnabled += value;
}
function $7bd48593473bea18$var$setupBlock(vnode) {
    vnode.dynamicChildren = $7bd48593473bea18$var$isBlockTreeEnabled > 0 ? $7bd48593473bea18$var$currentBlock || (0, $lbCQA.EMPTY_ARR) : null;
    $7bd48593473bea18$var$closeBlock();
    if ($7bd48593473bea18$var$isBlockTreeEnabled > 0 && $7bd48593473bea18$var$currentBlock) $7bd48593473bea18$var$currentBlock.push(vnode);
    return vnode;
}
function $7bd48593473bea18$export$167055419fc69ec1(type, props, children, patchFlag, dynamicProps, shapeFlag) {
    return $7bd48593473bea18$var$setupBlock($7bd48593473bea18$export$42098e0eaa15c48e(type, props, children, patchFlag, dynamicProps, shapeFlag, true));
}
function $7bd48593473bea18$export$9f2dfe8048dfb22b(type, props, children, patchFlag, dynamicProps) {
    return $7bd48593473bea18$var$setupBlock($7bd48593473bea18$export$bf5c4cf060303d58(type, props, children, patchFlag, dynamicProps, true));
}
function $7bd48593473bea18$export$3868d13f8734ae81(value) {
    return value ? value.__v_isVNode === true : false;
}
function $7bd48593473bea18$var$isSameVNodeType(n1, n2) {
    return n1.type === n2.type && n1.key === n2.key;
}
var $7bd48593473bea18$var$vnodeArgsTransformer;
function $7bd48593473bea18$export$83beccd3afeeb809(transformer) {
    $7bd48593473bea18$var$vnodeArgsTransformer = transformer;
}
var $7bd48593473bea18$var$createVNodeWithArgsTransform = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    return $7bd48593473bea18$var$_createVNode.apply(void 0, (0, $79xu7._)($7bd48593473bea18$var$vnodeArgsTransformer ? $7bd48593473bea18$var$vnodeArgsTransformer(args, $7bd48593473bea18$var$currentRenderingInstance) : args));
};
var $7bd48593473bea18$var$normalizeKey = function(param) {
    var key = param.key;
    return key != null ? key : null;
};
var $7bd48593473bea18$var$normalizeRef = function(param) {
    var ref = param.ref, ref_key = param.ref_key, ref_for = param.ref_for;
    if (typeof ref === "number") ref = "" + ref;
    return ref != null ? (0, $lbCQA.isString)(ref) || (0, $aAzpa.isRef)(ref) || (0, $lbCQA.isFunction)(ref) ? {
        i: $7bd48593473bea18$var$currentRenderingInstance,
        r: ref,
        k: ref_key,
        f: !!ref_for
    } : ref : null;
};
function $7bd48593473bea18$export$42098e0eaa15c48e(type) {
    var props = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, children = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, patchFlag = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, dynamicProps = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null, shapeFlag = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : type === $7bd48593473bea18$export$ffb0004e005737fa ? 0 : 1, isBlockNode = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : false, needFullChildrenNormalization = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : false;
    var vnode = {
        __v_isVNode: true,
        __v_skip: true,
        type: type,
        props: props,
        key: props && $7bd48593473bea18$var$normalizeKey(props),
        ref: props && $7bd48593473bea18$var$normalizeRef(props),
        scopeId: $7bd48593473bea18$var$currentScopeId,
        slotScopeIds: null,
        children: children,
        component: null,
        suspense: null,
        ssContent: null,
        ssFallback: null,
        dirs: null,
        transition: null,
        el: null,
        anchor: null,
        target: null,
        targetAnchor: null,
        staticCount: 0,
        shapeFlag: shapeFlag,
        patchFlag: patchFlag,
        dynamicProps: dynamicProps,
        dynamicChildren: null,
        appContext: null,
        ctx: $7bd48593473bea18$var$currentRenderingInstance
    };
    if (needFullChildrenNormalization) {
        $7bd48593473bea18$var$normalizeChildren(vnode, children);
        if (shapeFlag & 128) type.normalize(vnode);
    } else if (children) vnode.shapeFlag |= (0, $lbCQA.isString)(children) ? 8 : 16;
    if ($7bd48593473bea18$var$isBlockTreeEnabled > 0 && // avoid a block node from tracking itself
    !isBlockNode && // has current parent block
    $7bd48593473bea18$var$currentBlock && // presence of a patch flag indicates this node needs patching on updates.
    // component nodes also should always be patched, because even if the
    // component doesn't need to update, it needs to persist the instance on to
    // the next vnode so that it can be properly unmounted later.
    (vnode.patchFlag > 0 || shapeFlag & 6) && // the EVENTS flag is only for hydration and if it is the only flag, the
    // vnode should not be considered dynamic due to handler caching.
    vnode.patchFlag !== 32) $7bd48593473bea18$var$currentBlock.push(vnode);
    return vnode;
}
var $7bd48593473bea18$export$bf5c4cf060303d58 = $7bd48593473bea18$var$_createVNode;
function $7bd48593473bea18$var$_createVNode(type) {
    var props = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, children = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, patchFlag = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, dynamicProps = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null, isBlockNode = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : false;
    if (!type || type === $7bd48593473bea18$var$NULL_DYNAMIC_COMPONENT) type = $7bd48593473bea18$export$4d299b491347818a;
    if ($7bd48593473bea18$export$3868d13f8734ae81(type)) {
        var cloned = $7bd48593473bea18$export$ee4f9e12c0a92a1a(type, props, true);
        if (children) $7bd48593473bea18$var$normalizeChildren(cloned, children);
        if ($7bd48593473bea18$var$isBlockTreeEnabled > 0 && !isBlockNode && $7bd48593473bea18$var$currentBlock) {
            if (cloned.shapeFlag & 6) $7bd48593473bea18$var$currentBlock[$7bd48593473bea18$var$currentBlock.indexOf(type)] = cloned;
            else $7bd48593473bea18$var$currentBlock.push(cloned);
        }
        cloned.patchFlag |= -2;
        return cloned;
    }
    if ($7bd48593473bea18$var$isClassComponent(type)) type = type.__vccOpts;
    if (props) {
        props = $7bd48593473bea18$export$1f1be0e0e384d7d2(props);
        var klass = props.class, style = props.style;
        if (klass && !(0, $lbCQA.isString)(klass)) props.class = (0, $lbCQA.normalizeClass)(klass);
        if ((0, $lbCQA.isObject)(style)) {
            if ((0, $aAzpa.isProxy)(style) && !(0, $lbCQA.isArray)(style)) style = (0, $lbCQA.extend)({}, style);
            props.style = (0, $lbCQA.normalizeStyle)(style);
        }
    }
    var shapeFlag = (0, $lbCQA.isString)(type) ? 1 : $7bd48593473bea18$var$isSuspense(type) ? 128 : $7bd48593473bea18$var$isTeleport(type) ? 64 : (0, $lbCQA.isObject)(type) ? 4 : (0, $lbCQA.isFunction)(type) ? 2 : 0;
    return $7bd48593473bea18$export$42098e0eaa15c48e(type, props, children, patchFlag, dynamicProps, shapeFlag, isBlockNode, true);
}
function $7bd48593473bea18$export$1f1be0e0e384d7d2(props) {
    if (!props) return null;
    return (0, $aAzpa.isProxy)(props) || $7bd48593473bea18$var$isInternalObject(props) ? (0, $lbCQA.extend)({}, props) : props;
}
function $7bd48593473bea18$export$ee4f9e12c0a92a1a(vnode, extraProps) {
    var mergeRef = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var props = vnode.props, ref = vnode.ref, patchFlag = vnode.patchFlag, children = vnode.children;
    var mergedProps = extraProps ? $7bd48593473bea18$export$9d1611c77c2fe928(props || {}, extraProps) : props;
    var cloned = {
        __v_isVNode: true,
        __v_skip: true,
        type: vnode.type,
        props: mergedProps,
        key: mergedProps && $7bd48593473bea18$var$normalizeKey(mergedProps),
        ref: extraProps && extraProps.ref ? // #2078 in the case of <component :is="vnode" ref="extra"/>
        // if the vnode itself already has a ref, cloneVNode will need to merge
        // the refs so the single vnode can be set on multiple refs
        mergeRef && ref ? (0, $lbCQA.isArray)(ref) ? ref.concat($7bd48593473bea18$var$normalizeRef(extraProps)) : [
            ref,
            $7bd48593473bea18$var$normalizeRef(extraProps)
        ] : $7bd48593473bea18$var$normalizeRef(extraProps) : ref,
        scopeId: vnode.scopeId,
        slotScopeIds: vnode.slotScopeIds,
        children: children,
        target: vnode.target,
        targetAnchor: vnode.targetAnchor,
        staticCount: vnode.staticCount,
        shapeFlag: vnode.shapeFlag,
        // if the vnode is cloned with extra props, we can no longer assume its
        // existing patch flag to be reliable and need to add the FULL_PROPS flag.
        // note: preserve flag for fragments since they use the flag for children
        // fast paths only.
        patchFlag: extraProps && vnode.type !== $7bd48593473bea18$export$ffb0004e005737fa ? patchFlag === -1 ? 16 : patchFlag | 16 : patchFlag,
        dynamicProps: vnode.dynamicProps,
        dynamicChildren: vnode.dynamicChildren,
        appContext: vnode.appContext,
        dirs: vnode.dirs,
        transition: vnode.transition,
        // These should technically only be non-null on mounted VNodes. However,
        // they *should* be copied for kept-alive vnodes. So we just always copy
        // them since them being non-null during a mount doesn't affect the logic as
        // they will simply be overwritten.
        component: vnode.component,
        suspense: vnode.suspense,
        ssContent: vnode.ssContent && $7bd48593473bea18$export$ee4f9e12c0a92a1a(vnode.ssContent),
        ssFallback: vnode.ssFallback && $7bd48593473bea18$export$ee4f9e12c0a92a1a(vnode.ssFallback),
        el: vnode.el,
        anchor: vnode.anchor,
        ctx: vnode.ctx,
        ce: vnode.ce
    };
    return cloned;
}
function $7bd48593473bea18$var$deepCloneVNode(vnode) {
    var cloned = $7bd48593473bea18$export$ee4f9e12c0a92a1a(vnode);
    if ((0, $lbCQA.isArray)(vnode.children)) cloned.children = vnode.children.map($7bd48593473bea18$var$deepCloneVNode);
    return cloned;
}
function $7bd48593473bea18$export$22f9b5ffd89dac9() {
    var text = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : " ", flag = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $7bd48593473bea18$export$bf5c4cf060303d58($7bd48593473bea18$export$5f1af8db9871e1d6, null, text, flag);
}
function $7bd48593473bea18$export$33a9f6dd2840e6bb(content, numberOfNodes) {
    var vnode = $7bd48593473bea18$export$bf5c4cf060303d58($7bd48593473bea18$export$c1b9a1d3af45b7b6, null, content);
    vnode.staticCount = numberOfNodes;
    return vnode;
}
function $7bd48593473bea18$export$49553837c7236d3c() {
    var text = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", asBlock = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return asBlock ? ($7bd48593473bea18$export$e7eaa45e502fe5cc(), $7bd48593473bea18$export$9f2dfe8048dfb22b($7bd48593473bea18$export$4d299b491347818a, null, text)) : $7bd48593473bea18$export$bf5c4cf060303d58($7bd48593473bea18$export$4d299b491347818a, null, text);
}
function $7bd48593473bea18$var$normalizeVNode(child) {
    if (child == null || typeof child === "boolean") return $7bd48593473bea18$export$bf5c4cf060303d58($7bd48593473bea18$export$4d299b491347818a);
    else if ((0, $lbCQA.isArray)(child)) return $7bd48593473bea18$export$bf5c4cf060303d58($7bd48593473bea18$export$ffb0004e005737fa, null, // #3666, avoid reference pollution when reusing vnode
    child.slice());
    else if (typeof child === "object") return $7bd48593473bea18$var$cloneIfMounted(child);
    else return $7bd48593473bea18$export$bf5c4cf060303d58($7bd48593473bea18$export$5f1af8db9871e1d6, null, String(child));
}
function $7bd48593473bea18$var$cloneIfMounted(child) {
    return child.el === null && child.patchFlag !== -1 || child.memo ? child : $7bd48593473bea18$export$ee4f9e12c0a92a1a(child);
}
function $7bd48593473bea18$var$normalizeChildren(vnode, children) {
    var type = 0;
    var shapeFlag = vnode.shapeFlag;
    if (children == null) children = null;
    else if ((0, $lbCQA.isArray)(children)) type = 16;
    else if (typeof children === "object") {
        if (shapeFlag & 65) {
            var slot = children.default;
            if (slot) {
                slot._c && (slot._d = false);
                $7bd48593473bea18$var$normalizeChildren(vnode, slot());
                slot._c && (slot._d = true);
            }
            return;
        } else {
            type = 32;
            var slotFlag = children._;
            if (!slotFlag && !$7bd48593473bea18$var$isInternalObject(children)) children._ctx = $7bd48593473bea18$var$currentRenderingInstance;
            else if (slotFlag === 3 && $7bd48593473bea18$var$currentRenderingInstance) {
                if ($7bd48593473bea18$var$currentRenderingInstance.slots._ === 1) children._ = 1;
                else {
                    children._ = 2;
                    vnode.patchFlag |= 1024;
                }
            }
        }
    } else if ((0, $lbCQA.isFunction)(children)) {
        children = {
            default: children,
            _ctx: $7bd48593473bea18$var$currentRenderingInstance
        };
        type = 32;
    } else {
        children = String(children);
        if (shapeFlag & 64) {
            type = 16;
            children = [
                $7bd48593473bea18$export$22f9b5ffd89dac9(children)
            ];
        } else type = 8;
    }
    vnode.children = children;
    vnode.shapeFlag |= type;
}
function $7bd48593473bea18$export$9d1611c77c2fe928() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var ret = {};
    for(var i = 0; i < args.length; i++){
        var toMerge = args[i];
        for(var key in toMerge){
            if (key === "class") {
                if (ret.class !== toMerge.class) ret.class = (0, $lbCQA.normalizeClass)([
                    ret.class,
                    toMerge.class
                ]);
            } else if (key === "style") ret.style = (0, $lbCQA.normalizeStyle)([
                ret.style,
                toMerge.style
            ]);
            else if ((0, $lbCQA.isOn)(key)) {
                var existing = ret[key];
                var incoming = toMerge[key];
                if (incoming && existing !== incoming && !((0, $lbCQA.isArray)(existing) && existing.includes(incoming))) ret[key] = existing ? [].concat(existing, incoming) : incoming;
            } else if (key !== "") ret[key] = toMerge[key];
        }
    }
    return ret;
}
function $7bd48593473bea18$var$invokeVNodeHook(hook, instance, vnode) {
    var prevVNode = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
    $7bd48593473bea18$export$dae85862a8d94378(hook, instance, 7, [
        vnode,
        prevVNode
    ]);
}
var $7bd48593473bea18$var$emptyAppContext = $7bd48593473bea18$var$createAppContext();
var $7bd48593473bea18$var$uid = 0;
function $7bd48593473bea18$var$createComponentInstance(vnode, parent, suspense) {
    var type = vnode.type;
    var appContext = (parent ? parent.appContext : vnode.appContext) || $7bd48593473bea18$var$emptyAppContext;
    var instance = {
        uid: $7bd48593473bea18$var$uid++,
        vnode: vnode,
        type: type,
        parent: parent,
        appContext: appContext,
        root: null,
        // to be immediately set
        next: null,
        subTree: null,
        // will be set synchronously right after creation
        effect: null,
        update: null,
        // will be set synchronously right after creation
        scope: new (0, $aAzpa.EffectScope)(true),
        render: null,
        proxy: null,
        exposed: null,
        exposeProxy: null,
        withProxy: null,
        provides: parent ? parent.provides : Object.create(appContext.provides),
        accessCache: null,
        renderCache: [],
        // local resolved assets
        components: null,
        directives: null,
        // resolved props and emits options
        propsOptions: $7bd48593473bea18$var$normalizePropsOptions(type, appContext),
        emitsOptions: $7bd48593473bea18$var$normalizeEmitsOptions(type, appContext),
        // emit
        emit: null,
        // to be set immediately
        emitted: null,
        // props default value
        propsDefaults: (0, $lbCQA.EMPTY_OBJ),
        // inheritAttrs
        inheritAttrs: type.inheritAttrs,
        // state
        ctx: (0, $lbCQA.EMPTY_OBJ),
        data: (0, $lbCQA.EMPTY_OBJ),
        props: (0, $lbCQA.EMPTY_OBJ),
        attrs: (0, $lbCQA.EMPTY_OBJ),
        slots: (0, $lbCQA.EMPTY_OBJ),
        refs: (0, $lbCQA.EMPTY_OBJ),
        setupState: (0, $lbCQA.EMPTY_OBJ),
        setupContext: null,
        attrsProxy: null,
        slotsProxy: null,
        // suspense related
        suspense: suspense,
        suspenseId: suspense ? suspense.pendingId : 0,
        asyncDep: null,
        asyncResolved: false,
        // lifecycle hooks
        // not using enums here because it results in computed properties
        isMounted: false,
        isUnmounted: false,
        isDeactivated: false,
        bc: null,
        c: null,
        bm: null,
        m: null,
        bu: null,
        u: null,
        um: null,
        bum: null,
        da: null,
        a: null,
        rtg: null,
        rtc: null,
        ec: null,
        sp: null
    };
    instance.ctx = {
        _: instance
    };
    instance.root = parent ? parent.root : instance;
    instance.emit = $7bd48593473bea18$var$emit.bind(null, instance);
    if (vnode.ce) vnode.ce(instance);
    return instance;
}
var $7bd48593473bea18$var$currentInstance = null;
var $7bd48593473bea18$export$f13e630aa3915748 = function() {
    return $7bd48593473bea18$var$currentInstance || $7bd48593473bea18$var$currentRenderingInstance;
};
var $7bd48593473bea18$var$internalSetCurrentInstance;
var $7bd48593473bea18$var$setInSSRSetupState;
{
    var $7bd48593473bea18$var$g = (0, $lbCQA.getGlobalThis)();
    var $7bd48593473bea18$var$registerGlobalSetter = function(key, setter) {
        var setters;
        if (!(setters = $7bd48593473bea18$var$g[key])) setters = $7bd48593473bea18$var$g[key] = [];
        setters.push(setter);
        return function(v1) {
            if (setters.length > 1) setters.forEach(function(set) {
                return set(v1);
            });
            else setters[0](v1);
        };
    };
    $7bd48593473bea18$var$internalSetCurrentInstance = $7bd48593473bea18$var$registerGlobalSetter("__VUE_INSTANCE_SETTERS__", function(v1) {
        return $7bd48593473bea18$var$currentInstance = v1;
    });
    $7bd48593473bea18$var$setInSSRSetupState = $7bd48593473bea18$var$registerGlobalSetter("__VUE_SSR_SETTERS__", function(v1) {
        return $7bd48593473bea18$var$isInSSRComponentSetup = v1;
    });
}var $7bd48593473bea18$var$setCurrentInstance = function(instance) {
    var prev = $7bd48593473bea18$var$currentInstance;
    $7bd48593473bea18$var$internalSetCurrentInstance(instance);
    instance.scope.on();
    return function() {
        instance.scope.off();
        $7bd48593473bea18$var$internalSetCurrentInstance(prev);
    };
};
var $7bd48593473bea18$var$unsetCurrentInstance = function() {
    $7bd48593473bea18$var$currentInstance && $7bd48593473bea18$var$currentInstance.scope.off();
    $7bd48593473bea18$var$internalSetCurrentInstance(null);
};
var $7bd48593473bea18$var$isBuiltInTag = /* @__PURE__ */ (0, $lbCQA.makeMap)("slot,component");
function $7bd48593473bea18$var$validateComponentName(name, param) {
    var isNativeTag = param.isNativeTag;
    if ($7bd48593473bea18$var$isBuiltInTag(name) || isNativeTag(name)) $7bd48593473bea18$var$warn$1("Do not use built-in or reserved HTML elements as component id: " + name);
}
function $7bd48593473bea18$var$isStatefulComponent(instance) {
    return instance.vnode.shapeFlag & 4;
}
var $7bd48593473bea18$var$isInSSRComponentSetup = false;
function $7bd48593473bea18$var$setupComponent(instance) {
    var isSSR = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    isSSR && $7bd48593473bea18$var$setInSSRSetupState(isSSR);
    var _instance_vnode = instance.vnode, props = _instance_vnode.props, children = _instance_vnode.children;
    var isStateful = $7bd48593473bea18$var$isStatefulComponent(instance);
    $7bd48593473bea18$var$initProps(instance, props, isStateful, isSSR);
    $7bd48593473bea18$var$initSlots(instance, children);
    var setupResult = isStateful ? $7bd48593473bea18$var$setupStatefulComponent(instance, isSSR) : void 0;
    isSSR && $7bd48593473bea18$var$setInSSRSetupState(false);
    return setupResult;
}
function $7bd48593473bea18$var$setupStatefulComponent(instance, isSSR) {
    var _a;
    var Component = instance.type;
    instance.accessCache = /* @__PURE__ */ Object.create(null);
    instance.proxy = new Proxy(instance.ctx, $7bd48593473bea18$var$PublicInstanceProxyHandlers);
    var setup = Component.setup;
    if (setup) {
        var setupContext = instance.setupContext = setup.length > 1 ? $7bd48593473bea18$var$createSetupContext(instance) : null;
        var reset = $7bd48593473bea18$var$setCurrentInstance(instance);
        (0, $aAzpa.pauseTracking)();
        var setupResult = $7bd48593473bea18$export$b22fcaf88446e9bf(setup, instance, 0, [
            (0, instance.props),
            setupContext
        ]);
        (0, $aAzpa.resetTracking)();
        reset();
        if ((0, $lbCQA.isPromise)(setupResult)) {
            setupResult.then($7bd48593473bea18$var$unsetCurrentInstance, $7bd48593473bea18$var$unsetCurrentInstance);
            if (isSSR) return setupResult.then(function(resolvedResult) {
                $7bd48593473bea18$var$handleSetupResult(instance, resolvedResult, isSSR);
            }).catch(function(e) {
                $7bd48593473bea18$export$d3da1ecaf1206c58(e, instance, 0);
            });
            else instance.asyncDep = setupResult;
        } else $7bd48593473bea18$var$handleSetupResult(instance, setupResult, isSSR);
    } else $7bd48593473bea18$var$finishComponentSetup(instance, isSSR);
}
function $7bd48593473bea18$var$handleSetupResult(instance, setupResult, isSSR) {
    if ((0, $lbCQA.isFunction)(setupResult)) {
        if (instance.type.__ssrInlineRender) instance.ssrRender = setupResult;
        else instance.render = setupResult;
    } else if ((0, $lbCQA.isObject)(setupResult)) {
        if (__VUE_PROD_DEVTOOLS__) instance.devtoolsRawSetupState = setupResult;
        instance.setupState = (0, $aAzpa.proxyRefs)(setupResult);
    }
    $7bd48593473bea18$var$finishComponentSetup(instance, isSSR);
}
var $7bd48593473bea18$var$compile;
var $7bd48593473bea18$var$installWithProxy;
function $7bd48593473bea18$export$667bb5a67822b941(_compile) {
    $7bd48593473bea18$var$compile = _compile;
    $7bd48593473bea18$var$installWithProxy = function(i) {
        if (i.render._rc) i.withProxy = new Proxy(i.ctx, $7bd48593473bea18$var$RuntimeCompiledPublicInstanceProxyHandlers);
    };
}
var $7bd48593473bea18$export$c93a9c496c5211fa = function() {
    return !$7bd48593473bea18$var$compile;
};
function $7bd48593473bea18$var$finishComponentSetup(instance, isSSR, skipOptions) {
    var Component = instance.type;
    if (!instance.render) {
        if (!isSSR && $7bd48593473bea18$var$compile && !Component.render) {
            var template = Component.template || $7bd48593473bea18$var$resolveMergedOptions(instance).template;
            if (template) {
                var _instance_appContext_config = instance.appContext.config, isCustomElement = _instance_appContext_config.isCustomElement, compilerOptions = _instance_appContext_config.compilerOptions;
                var delimiters = Component.delimiters, componentCompilerOptions = Component.compilerOptions;
                var finalCompilerOptions = (0, $lbCQA.extend)((0, $lbCQA.extend)({
                    isCustomElement: isCustomElement,
                    delimiters: delimiters
                }, compilerOptions), componentCompilerOptions);
                Component.render = $7bd48593473bea18$var$compile(template, finalCompilerOptions);
            }
        }
        instance.render = Component.render || (0, $lbCQA.NOOP);
        if ($7bd48593473bea18$var$installWithProxy) $7bd48593473bea18$var$installWithProxy(instance);
    }
    if (__VUE_OPTIONS_API__ && true) {
        var reset = $7bd48593473bea18$var$setCurrentInstance(instance);
        (0, $aAzpa.pauseTracking)();
        try {
            $7bd48593473bea18$var$applyOptions(instance);
        } finally{
            (0, $aAzpa.resetTracking)();
            reset();
        }
    }
}
var $7bd48593473bea18$var$attrsProxyHandlers = {
    get: function(target, key) {
        (0, $aAzpa.track)(target, "get", "");
        return target[key];
    }
};
function $7bd48593473bea18$var$getSlotsProxy(instance) {
    return instance.slotsProxy || (instance.slotsProxy = new Proxy(instance.slots, {
        get: function(target, key) {
            (0, $aAzpa.track)(instance, "get", "$slots");
            return target[key];
        }
    }));
}
function $7bd48593473bea18$var$createSetupContext(instance) {
    var expose = function(exposed) {
        instance.exposed = exposed || {};
    };
    var event, args;
    return {
        attrs: new Proxy(instance.attrs, $7bd48593473bea18$var$attrsProxyHandlers),
        slots: instance.slots,
        emit: instance.emit,
        expose: expose
    };
}
function $7bd48593473bea18$var$getExposeProxy(instance) {
    if (instance.exposed) return instance.exposeProxy || (instance.exposeProxy = new Proxy((0, $aAzpa.proxyRefs)((0, $aAzpa.markRaw)(instance.exposed)), {
        get: function(target, key) {
            if (key in target) return target[key];
            else if (key in $7bd48593473bea18$var$publicPropertiesMap) return $7bd48593473bea18$var$publicPropertiesMap[key](instance);
        },
        has: function(target, key) {
            return key in target || key in $7bd48593473bea18$var$publicPropertiesMap;
        }
    }));
}
var $7bd48593473bea18$var$classifyRE = /(?:^|[-_])(\w)/g;
var $7bd48593473bea18$var$classify = function(str) {
    return str.replace($7bd48593473bea18$var$classifyRE, function(c) {
        return c.toUpperCase();
    }).replace(/[-_]/g, "");
};
function $7bd48593473bea18$var$getComponentName(Component) {
    var includeInferred = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    return (0, $lbCQA.isFunction)(Component) ? Component.displayName || Component.name : Component.name || includeInferred && Component.__name;
}
function $7bd48593473bea18$var$formatComponentName(instance, Component) {
    var isRoot = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var name = $7bd48593473bea18$var$getComponentName(Component);
    if (!name && Component.__file) {
        var match = Component.__file.match(/([^/\\]+)\.\w+$/);
        if (match) name = match[1];
    }
    if (!name && instance && instance.parent) {
        var inferFromRegistry = function(registry) {
            for(var key in registry){
                if (registry[key] === Component) return key;
            }
        };
        name = inferFromRegistry(instance.components || instance.parent.type.components) || inferFromRegistry(instance.appContext.components);
    }
    return name ? $7bd48593473bea18$var$classify(name) : isRoot ? "App" : "Anonymous";
}
function $7bd48593473bea18$var$isClassComponent(value) {
    return (0, $lbCQA.isFunction)(value) && "__vccOpts" in value;
}
var $7bd48593473bea18$export$2983e091f1a1e8e2 = function(getterOrOptions, debugOptions) {
    var c = (0, $aAzpa.computed)(getterOrOptions, debugOptions, $7bd48593473bea18$var$isInSSRComponentSetup);
    return c;
};
function $7bd48593473bea18$export$fb78bd113157f1a1(props, name) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : (0, $lbCQA.EMPTY_OBJ);
    var i = $7bd48593473bea18$export$f13e630aa3915748();
    var camelizedName = (0, $lbCQA.camelize)(name);
    var hyphenatedName = (0, $lbCQA.hyphenate)(name);
    var res = (0, $aAzpa.customRef)(function(track, trigger) {
        var localValue;
        $7bd48593473bea18$export$2035654f31b0e555(function() {
            var propValue = props[name];
            if ((0, $lbCQA.hasChanged)(localValue, propValue)) {
                localValue = propValue;
                trigger();
            }
        });
        return {
            get: function() {
                track();
                return options.get ? options.get(localValue) : localValue;
            },
            set: function(value) {
                var rawProps = i.vnode.props;
                if (!(rawProps && // check if parent has passed v-model
                (name in rawProps || camelizedName in rawProps || hyphenatedName in rawProps) && ("onUpdate:".concat(name) in rawProps || "onUpdate:".concat(camelizedName) in rawProps || "onUpdate:".concat(hyphenatedName) in rawProps)) && (0, $lbCQA.hasChanged)(value, localValue)) {
                    localValue = value;
                    trigger();
                }
                i.emit("update:".concat(name), options.set ? options.set(value) : value);
            }
        };
    });
    var modifierKey = name === "modelValue" ? "modelModifiers" : "".concat(name, "Modifiers");
    res[Symbol.iterator] = function() {
        var i2 = 0;
        return {
            next: function() {
                if (i2 < 2) return {
                    value: i2++ ? props[modifierKey] || {} : res,
                    done: false
                };
                else return {
                    done: true
                };
            }
        };
    };
    return res;
}
function $7bd48593473bea18$export$dda1d9f60106f0e9(type, propsOrChildren, children) {
    var l = arguments.length;
    if (l === 2) {
        if ((0, $lbCQA.isObject)(propsOrChildren) && !(0, $lbCQA.isArray)(propsOrChildren)) {
            if ($7bd48593473bea18$export$3868d13f8734ae81(propsOrChildren)) return $7bd48593473bea18$export$bf5c4cf060303d58(type, null, [
                propsOrChildren
            ]);
            return $7bd48593473bea18$export$bf5c4cf060303d58(type, propsOrChildren);
        } else return $7bd48593473bea18$export$bf5c4cf060303d58(type, null, propsOrChildren);
    } else {
        if (l > 3) children = Array.prototype.slice.call(arguments, 2);
        else if (l === 3 && $7bd48593473bea18$export$3868d13f8734ae81(children)) children = [
            children
        ];
        return $7bd48593473bea18$export$bf5c4cf060303d58(type, propsOrChildren, children);
    }
}
function $7bd48593473bea18$export$aed4979be6a60047() {
    return;
    function formatInstance(instance) {
        var blocks = [];
        if (instance.type.props && instance.props) blocks.push(createInstanceBlock("props", (0, $aAzpa.toRaw)(instance.props)));
        if (instance.setupState !== (0, $lbCQA.EMPTY_OBJ)) blocks.push(createInstanceBlock("setup", instance.setupState));
        if (instance.data !== (0, $lbCQA.EMPTY_OBJ)) blocks.push(createInstanceBlock("data", (0, $aAzpa.toRaw)(instance.data)));
        var computed = extractKeys(instance, "computed");
        if (computed) blocks.push(createInstanceBlock("computed", computed));
        var injected = extractKeys(instance, "inject");
        if (injected) blocks.push(createInstanceBlock("injected", injected));
        blocks.push([
            "div",
            {},
            [
                "span",
                {
                    style: keywordStyle.style + ";opacity:0.66"
                },
                "$ (internal): "
            ],
            [
                "object",
                {
                    object: instance
                }
            ]
        ]);
        return blocks;
    }
    function createInstanceBlock(type, target) {
        target = (0, $lbCQA.extend)({}, target);
        if (!Object.keys(target).length) return [
            "span",
            {}
        ];
        return [
            "div",
            {
                style: "line-height:1.25em;margin-bottom:0.6em"
            },
            [
                "div",
                {
                    style: "color:#476582"
                },
                type
            ],
            [
                "div",
                {
                    style: "padding-left:1.25em"
                }
            ].concat((0, $79xu7._)(Object.keys(target).map(function(key) {
                return [
                    "div",
                    {},
                    [
                        "span",
                        keywordStyle,
                        key + ": "
                    ],
                    formatValue(target[key], false)
                ];
            })))
        ];
    }
    function formatValue(v1) {
        var asRaw = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
        if (typeof v1 === "number") return [
            "span",
            numberStyle,
            v1
        ];
        else if (typeof v1 === "string") return [
            "span",
            stringStyle,
            JSON.stringify(v1)
        ];
        else if (typeof v1 === "boolean") return [
            "span",
            keywordStyle,
            v1
        ];
        else if ((0, $lbCQA.isObject)(v1)) return [
            "object",
            {
                object: asRaw ? (0, $aAzpa.toRaw)(v1) : v1
            }
        ];
        else return [
            "span",
            stringStyle,
            String(v1)
        ];
    }
    function extractKeys(instance, type) {
        var Comp = instance.type;
        if ((0, $lbCQA.isFunction)(Comp)) return;
        var extracted = {};
        for(var key in instance.ctx)if (isKeyOfType(Comp, key, type)) extracted[key] = instance.ctx[key];
        return extracted;
    }
    function isKeyOfType(Comp, key, type) {
        var opts = Comp[type];
        if ((0, $lbCQA.isArray)(opts) && opts.includes(key) || (0, $lbCQA.isObject)(opts) && key in opts) return true;
        if (Comp.extends && isKeyOfType(Comp.extends, key, type)) return true;
        if (Comp.mixins && Comp.mixins.some(function(m) {
            return isKeyOfType(m, key, type);
        })) return true;
    }
    function genRefFlag(v1) {
        if ((0, $aAzpa.isShallow)(v1)) return "ShallowRef";
        if (v1.effect) return "ComputedRef";
        return "Ref";
    }
}
function $7bd48593473bea18$export$2a6d714a4d738ae(memo, render, cache, index) {
    var cached = cache[index];
    if (cached && $7bd48593473bea18$export$bf525184d622787c(cached, memo)) return cached;
    var ret = render();
    ret.memo = memo.slice();
    return cache[index] = ret;
}
function $7bd48593473bea18$export$bf525184d622787c(cached, memo) {
    var prev = cached.memo;
    if (prev.length != memo.length) return false;
    for(var i = 0; i < prev.length; i++){
        if ((0, $lbCQA.hasChanged)(prev[i], memo[i])) return false;
    }
    if ($7bd48593473bea18$var$isBlockTreeEnabled > 0 && $7bd48593473bea18$var$currentBlock) $7bd48593473bea18$var$currentBlock.push(cached);
    return true;
}
var $7bd48593473bea18$export$83d89fbfd8236492 = "3.4.25";
var $7bd48593473bea18$export$c106dd0671a0fc2d = (0, $lbCQA.NOOP);
var $7bd48593473bea18$export$795e0ad4a0e2ed30 = $7bd48593473bea18$var$ErrorTypeStrings$1;
var $7bd48593473bea18$export$6922d3b3a607469e = $7bd48593473bea18$var$devtools$1;
var $7bd48593473bea18$export$b0c258b32c26c785 = $7bd48593473bea18$var$setDevtoolsHook$1;
var $7bd48593473bea18$var$_ssrUtils = {
    createComponentInstance: $7bd48593473bea18$var$createComponentInstance,
    setupComponent: $7bd48593473bea18$var$setupComponent,
    renderComponentRoot: $7bd48593473bea18$var$renderComponentRoot,
    setCurrentRenderingInstance: $7bd48593473bea18$var$setCurrentRenderingInstance,
    isVNode: $7bd48593473bea18$export$3868d13f8734ae81,
    normalizeVNode: $7bd48593473bea18$var$normalizeVNode
};
var $7bd48593473bea18$export$a9679033567b336d = $7bd48593473bea18$var$_ssrUtils;
var $7bd48593473bea18$export$83cf26e06ea620e1 = null;
var $7bd48593473bea18$export$dc678eddf276286e = null;
var $7bd48593473bea18$export$22072a82865312f6 = null;

});
parcelRegister("aAzpa", function(module, exports) {

$parcel$export(module.exports, "EffectScope", function () { return EffectScope; });
$parcel$export(module.exports, "getCurrentScope", function () { return getCurrentScope; });
$parcel$export(module.exports, "ReactiveEffect", function () { return ReactiveEffect; });
$parcel$export(module.exports, "pauseTracking", function () { return pauseTracking; });
$parcel$export(module.exports, "resetTracking", function () { return resetTracking; });
$parcel$export(module.exports, "track", function () { return track; });
$parcel$export(module.exports, "trigger", function () { return trigger; });
$parcel$export(module.exports, "toRaw", function () { return toRaw; });
$parcel$export(module.exports, "isRef", function () { return isRef; });
$parcel$export(module.exports, "reactive", function () { return reactive; });
$parcel$export(module.exports, "isShallow", function () { return isShallow; });
$parcel$export(module.exports, "shallowReactive", function () { return shallowReactive; });
$parcel$export(module.exports, "isReactive", function () { return isReactive; });
$parcel$export(module.exports, "isProxy", function () { return isProxy; });
$parcel$export(module.exports, "markRaw", function () { return markRaw; });
$parcel$export(module.exports, "computed", function () { return computed; });
$parcel$export(module.exports, "ref", function () { return ref; });
$parcel$export(module.exports, "unref", function () { return unref; });
$parcel$export(module.exports, "proxyRefs", function () { return proxyRefs; });
$parcel$export(module.exports, "customRef", function () { return customRef; });
/**
* @vue/reactivity v3.4.25
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $luoZD = parcelRequire("luoZD");

var $fYUO3 = parcelRequire("fYUO3");

var $7DbRq = parcelRequire("7DbRq");

var $4f96i = parcelRequire("4f96i");

var $79xu7 = parcelRequire("79xu7");

var $ju9pQ = parcelRequire("ju9pQ");

var $lbCQA = parcelRequire("lbCQA");
function warn(msg) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    var _console;
    (_console = console).warn.apply(_console, [
        "[Vue warn] ".concat(msg)
    ].concat((0, $79xu7._)(args)));
}
var activeEffectScope;
var EffectScope = /*#__PURE__*/ function() {
    "use strict";
    function EffectScope() {
        var detached = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        (0, $luoZD._)(this, EffectScope);
        this.detached = detached;
        /**
     * @internal
     */ this._active = true;
        /**
     * @internal
     */ this.effects = [];
        /**
     * @internal
     */ this.cleanups = [];
        this.parent = activeEffectScope;
        if (!detached && activeEffectScope) this.index = (activeEffectScope.scopes || (activeEffectScope.scopes = [])).push(this) - 1;
    }
    (0, $fYUO3._)(EffectScope, [
        {
            key: "active",
            get: function get() {
                return this._active;
            }
        },
        {
            key: "run",
            value: function run(fn) {
                if (this._active) {
                    var currentEffectScope = activeEffectScope;
                    try {
                        activeEffectScope = this;
                        return fn();
                    } finally{
                        activeEffectScope = currentEffectScope;
                    }
                }
            }
        },
        {
            /**
   * This should only be called on non-detached scopes
   * @internal
   */ key: "on",
            value: function on() {
                activeEffectScope = this;
            }
        },
        {
            /**
   * This should only be called on non-detached scopes
   * @internal
   */ key: "off",
            value: function off() {
                activeEffectScope = this.parent;
            }
        },
        {
            key: "stop",
            value: function stop(fromParent) {
                if (this._active) {
                    var i, l;
                    for(i = 0, l = this.effects.length; i < l; i++)this.effects[i].stop();
                    for(i = 0, l = this.cleanups.length; i < l; i++)this.cleanups[i]();
                    if (this.scopes) for(i = 0, l = this.scopes.length; i < l; i++)this.scopes[i].stop(true);
                    if (!this.detached && this.parent && !fromParent) {
                        var last = this.parent.scopes.pop();
                        if (last && last !== this) {
                            this.parent.scopes[this.index] = last;
                            last.index = this.index;
                        }
                    }
                    this.parent = void 0;
                    this._active = false;
                }
            }
        }
    ]);
    return EffectScope;
}();
function effectScope(detached) {
    return new EffectScope(detached);
}
function recordEffectScope(effect) {
    var scope = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : activeEffectScope;
    if (scope && scope.active) scope.effects.push(effect);
}
function getCurrentScope() {
    return activeEffectScope;
}
function onScopeDispose(fn) {
    if (activeEffectScope) activeEffectScope.cleanups.push(fn);
}
var activeEffect;
var ReactiveEffect = /*#__PURE__*/ function() {
    "use strict";
    function ReactiveEffect(fn, trigger, scheduler, scope) {
        (0, $luoZD._)(this, ReactiveEffect);
        this.fn = fn;
        this.trigger = trigger;
        this.scheduler = scheduler;
        this.active = true;
        this.deps = [];
        /**
     * @internal
     */ this._dirtyLevel = 4;
        /**
     * @internal
     */ this._trackId = 0;
        /**
     * @internal
     */ this._runnings = 0;
        /**
     * @internal
     */ this._shouldSchedule = false;
        /**
     * @internal
     */ this._depsLength = 0;
        recordEffectScope(this, scope);
    }
    (0, $fYUO3._)(ReactiveEffect, [
        {
            key: "dirty",
            get: function get() {
                if (this._dirtyLevel === 2 || this._dirtyLevel === 3) {
                    this._dirtyLevel = 1;
                    pauseTracking();
                    for(var i = 0; i < this._depsLength; i++){
                        var dep = this.deps[i];
                        if (dep.computed) {
                            triggerComputed(dep.computed);
                            if (this._dirtyLevel >= 4) break;
                        }
                    }
                    if (this._dirtyLevel === 1) this._dirtyLevel = 0;
                    resetTracking();
                }
                return this._dirtyLevel >= 4;
            },
            set: function set(v) {
                this._dirtyLevel = v ? 4 : 0;
            }
        },
        {
            key: "run",
            value: function run() {
                this._dirtyLevel = 0;
                if (!this.active) return this.fn();
                var lastShouldTrack = shouldTrack;
                var lastEffect = activeEffect;
                try {
                    shouldTrack = true;
                    activeEffect = this;
                    this._runnings++;
                    preCleanupEffect(this);
                    return this.fn();
                } finally{
                    postCleanupEffect(this);
                    this._runnings--;
                    activeEffect = lastEffect;
                    shouldTrack = lastShouldTrack;
                }
            }
        },
        {
            key: "stop",
            value: function stop() {
                var _a;
                if (this.active) {
                    preCleanupEffect(this);
                    postCleanupEffect(this);
                    (_a = this.onStop) == null || _a.call(this);
                    this.active = false;
                }
            }
        }
    ]);
    return ReactiveEffect;
}();
function triggerComputed(computed) {
    return computed.value;
}
function preCleanupEffect(effect2) {
    effect2._trackId++;
    effect2._depsLength = 0;
}
function postCleanupEffect(effect2) {
    if (effect2.deps.length > effect2._depsLength) {
        for(var i = effect2._depsLength; i < effect2.deps.length; i++)cleanupDepEffect(effect2.deps[i], effect2);
        effect2.deps.length = effect2._depsLength;
    }
}
function cleanupDepEffect(dep, effect2) {
    var trackId = dep.get(effect2);
    if (trackId !== void 0 && effect2._trackId !== trackId) {
        dep.delete(effect2);
        if (dep.size === 0) dep.cleanup();
    }
}
function effect(fn, options) {
    if (fn.effect instanceof ReactiveEffect) fn = fn.effect.fn;
    var _effect = new ReactiveEffect(fn, (0, $lbCQA.NOOP), function() {
        if (_effect.dirty) _effect.run();
    });
    if (options) {
        (0, $lbCQA.extend)(_effect, options);
        if (options.scope) recordEffectScope(_effect, options.scope);
    }
    if (!options || !options.lazy) _effect.run();
    var runner = _effect.run.bind(_effect);
    runner.effect = _effect;
    return runner;
}
function stop(runner) {
    runner.effect.stop();
}
var shouldTrack = true;
var pauseScheduleStack = 0;
var trackStack = [];
function pauseTracking() {
    trackStack.push(shouldTrack);
    shouldTrack = false;
}
function enableTracking() {
    trackStack.push(shouldTrack);
    shouldTrack = true;
}
function resetTracking() {
    var last = trackStack.pop();
    shouldTrack = last === void 0 ? true : last;
}
function pauseScheduling() {
    pauseScheduleStack++;
}
function resetScheduling() {
    pauseScheduleStack--;
    while(!pauseScheduleStack && queueEffectSchedulers.length)queueEffectSchedulers.shift()();
}
function trackEffect(effect2, dep, debuggerEventExtraInfo) {
    var _a;
    if (dep.get(effect2) !== effect2._trackId) {
        dep.set(effect2, effect2._trackId);
        var oldDep = effect2.deps[effect2._depsLength];
        if (oldDep !== dep) {
            if (oldDep) cleanupDepEffect(oldDep, effect2);
            effect2.deps[effect2._depsLength++] = dep;
        } else effect2._depsLength++;
    }
}
var queueEffectSchedulers = [];
function triggerEffects(dep, dirtyLevel, debuggerEventExtraInfo) {
    var _a;
    pauseScheduling();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = dep.keys()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var effect2 = _step.value;
            var tracking = void 0;
            if (effect2._dirtyLevel < dirtyLevel && (tracking != null ? tracking : tracking = dep.get(effect2) === effect2._trackId)) {
                effect2._shouldSchedule || (effect2._shouldSchedule = effect2._dirtyLevel === 0);
                effect2._dirtyLevel = dirtyLevel;
            }
            if (effect2._shouldSchedule && (tracking != null ? tracking : tracking = dep.get(effect2) === effect2._trackId)) {
                effect2.trigger();
                if ((!effect2._runnings || effect2.allowRecurse) && effect2._dirtyLevel !== 2) {
                    effect2._shouldSchedule = false;
                    if (effect2.scheduler) queueEffectSchedulers.push(effect2.scheduler);
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    resetScheduling();
}
var createDep = function(cleanup, computed) {
    var dep = /* @__PURE__ */ new Map();
    dep.cleanup = cleanup;
    dep.computed = computed;
    return dep;
};
var targetMap = /* @__PURE__ */ new WeakMap();
var ITERATE_KEY = Symbol("");
var MAP_KEY_ITERATE_KEY = Symbol("");
function track(target, type, key) {
    if (shouldTrack && activeEffect) {
        var depsMap = targetMap.get(target);
        if (!depsMap) targetMap.set(target, depsMap = /* @__PURE__ */ new Map());
        var dep = depsMap.get(key);
        if (!dep) depsMap.set(key, dep = createDep(function() {
            return depsMap.delete(key);
        }));
        trackEffect(activeEffect, dep, void 0);
    }
}
function trigger(target, type, key, newValue, oldValue, oldTarget) {
    var depsMap = targetMap.get(target);
    if (!depsMap) return;
    var deps = [];
    if (type === "clear") deps = (0, $79xu7._)(depsMap.values());
    else if (key === "length" && (0, $lbCQA.isArray)(target)) {
        var newLength = Number(newValue);
        depsMap.forEach(function(dep, key2) {
            if (key2 === "length" || !(0, $lbCQA.isSymbol)(key2) && key2 >= newLength) deps.push(dep);
        });
    } else {
        if (key !== void 0) deps.push(depsMap.get(key));
        switch(type){
            case "add":
                if (!(0, $lbCQA.isArray)(target)) {
                    deps.push(depsMap.get(ITERATE_KEY));
                    if ((0, $lbCQA.isMap)(target)) deps.push(depsMap.get(MAP_KEY_ITERATE_KEY));
                } else if ((0, $lbCQA.isIntegerKey)(key)) deps.push(depsMap.get("length"));
                break;
            case "delete":
                if (!(0, $lbCQA.isArray)(target)) {
                    deps.push(depsMap.get(ITERATE_KEY));
                    if ((0, $lbCQA.isMap)(target)) deps.push(depsMap.get(MAP_KEY_ITERATE_KEY));
                }
                break;
            case "set":
                if ((0, $lbCQA.isMap)(target)) deps.push(depsMap.get(ITERATE_KEY));
                break;
        }
    }
    pauseScheduling();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = deps[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var dep = _step.value;
            if (dep) triggerEffects(dep, 4, void 0);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    resetScheduling();
}
function getDepFromReactive(object, key) {
    var _a;
    return (_a = targetMap.get(object)) == null ? void 0 : _a.get(key);
}
var isNonTrackableKeys = /* @__PURE__ */ (0, $lbCQA.makeMap)("__proto__,__v_isRef,__isVue");
var builtInSymbols = new Set(/* @__PURE__ */ Object.getOwnPropertyNames(Symbol).filter(function(key) {
    return key !== "arguments" && key !== "caller";
}).map(function(key) {
    return Symbol[key];
}).filter((0, $lbCQA.isSymbol)));
var arrayInstrumentations = /* @__PURE__ */ createArrayInstrumentations();
function createArrayInstrumentations() {
    var instrumentations = {};
    [
        "includes",
        "indexOf",
        "lastIndexOf"
    ].forEach(function(key) {
        instrumentations[key] = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            var _arr, _arr1;
            var arr = toRaw(this);
            for(var i = 0, l = this.length; i < l; i++)track(arr, "get", i + "");
            var res = (_arr = arr)[key].apply(_arr, (0, $79xu7._)(args));
            if (res === -1 || res === false) return (_arr1 = arr)[key].apply(_arr1, (0, $79xu7._)(args.map(toRaw)));
            else return res;
        };
    });
    [
        "push",
        "pop",
        "shift",
        "unshift",
        "splice"
    ].forEach(function(key) {
        instrumentations[key] = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            pauseTracking();
            pauseScheduling();
            var res = toRaw(this)[key].apply(this, args);
            resetScheduling();
            resetTracking();
            return res;
        };
    });
    return instrumentations;
}
function hasOwnProperty(key) {
    if (!(0, $lbCQA.isSymbol)(key)) key = String(key);
    var obj = toRaw(this);
    track(obj, "has", key);
    return obj.hasOwnProperty(key);
}
var BaseReactiveHandler = /*#__PURE__*/ function() {
    "use strict";
    function BaseReactiveHandler() {
        var _isReadonly = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, _isShallow = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        (0, $luoZD._)(this, BaseReactiveHandler);
        this._isReadonly = _isReadonly;
        this._isShallow = _isShallow;
    }
    (0, $fYUO3._)(BaseReactiveHandler, [
        {
            key: "get",
            value: function get(target, key, receiver) {
                var isReadonly2 = this._isReadonly, isShallow2 = this._isShallow;
                if (key === "__v_isReactive") return !isReadonly2;
                else if (key === "__v_isReadonly") return isReadonly2;
                else if (key === "__v_isShallow") return isShallow2;
                else if (key === "__v_raw") {
                    if (receiver === (isReadonly2 ? isShallow2 ? shallowReadonlyMap : readonlyMap : isShallow2 ? shallowReactiveMap : reactiveMap).get(target) || // receiver is not the reactive proxy, but has the same prototype
                    // this means the reciever is a user proxy of the reactive proxy
                    Object.getPrototypeOf(target) === Object.getPrototypeOf(receiver)) return target;
                    return;
                }
                var targetIsArray = (0, $lbCQA.isArray)(target);
                if (!isReadonly2) {
                    if (targetIsArray && (0, $lbCQA.hasOwn)(arrayInstrumentations, key)) return Reflect.get(arrayInstrumentations, key, receiver);
                    if (key === "hasOwnProperty") return hasOwnProperty;
                }
                var res = Reflect.get(target, key, receiver);
                if ((0, $lbCQA.isSymbol)(key) ? builtInSymbols.has(key) : isNonTrackableKeys(key)) return res;
                if (!isReadonly2) track(target, "get", key);
                if (isShallow2) return res;
                if (isRef(res)) return targetIsArray && (0, $lbCQA.isIntegerKey)(key) ? res : res.value;
                if ((0, $lbCQA.isObject)(res)) return isReadonly2 ? readonly(res) : reactive(res);
                return res;
            }
        }
    ]);
    return BaseReactiveHandler;
}();
var MutableReactiveHandler = /*#__PURE__*/ function(BaseReactiveHandler) {
    "use strict";
    (0, $7DbRq._)(MutableReactiveHandler, BaseReactiveHandler);
    var _super = (0, $ju9pQ._)(MutableReactiveHandler);
    function MutableReactiveHandler() {
        var isShallow2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        (0, $luoZD._)(this, MutableReactiveHandler);
        return _super.call(this, false, isShallow2);
    }
    (0, $fYUO3._)(MutableReactiveHandler, [
        {
            key: "set",
            value: function set(target, key, value, receiver) {
                var oldValue = target[key];
                if (!this._isShallow) {
                    var isOldValueReadonly = isReadonly(oldValue);
                    if (!isShallow(value) && !isReadonly(value)) {
                        oldValue = toRaw(oldValue);
                        value = toRaw(value);
                    }
                    if (!(0, $lbCQA.isArray)(target) && isRef(oldValue) && !isRef(value)) {
                        if (isOldValueReadonly) return false;
                        else {
                            oldValue.value = value;
                            return true;
                        }
                    }
                }
                var hadKey = (0, $lbCQA.isArray)(target) && (0, $lbCQA.isIntegerKey)(key) ? Number(key) < target.length : (0, $lbCQA.hasOwn)(target, key);
                var result = Reflect.set(target, key, value, receiver);
                if (target === toRaw(receiver)) {
                    if (!hadKey) trigger(target, "add", key, value);
                    else if ((0, $lbCQA.hasChanged)(value, oldValue)) trigger(target, "set", key, value, oldValue);
                }
                return result;
            }
        },
        {
            key: "deleteProperty",
            value: function deleteProperty(target, key) {
                var hadKey = (0, $lbCQA.hasOwn)(target, key);
                var oldValue = target[key];
                var result = Reflect.deleteProperty(target, key);
                if (result && hadKey) trigger(target, "delete", key, void 0, oldValue);
                return result;
            }
        },
        {
            key: "has",
            value: function has(target, key) {
                var result = Reflect.has(target, key);
                if (!(0, $lbCQA.isSymbol)(key) || !builtInSymbols.has(key)) track(target, "has", key);
                return result;
            }
        },
        {
            key: "ownKeys",
            value: function ownKeys(target) {
                track(target, "iterate", (0, $lbCQA.isArray)(target) ? "length" : ITERATE_KEY);
                return Reflect.ownKeys(target);
            }
        }
    ]);
    return MutableReactiveHandler;
}(BaseReactiveHandler);
var ReadonlyReactiveHandler = /*#__PURE__*/ function(BaseReactiveHandler) {
    "use strict";
    (0, $7DbRq._)(ReadonlyReactiveHandler, BaseReactiveHandler);
    var _super = (0, $ju9pQ._)(ReadonlyReactiveHandler);
    function ReadonlyReactiveHandler() {
        var isShallow2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        (0, $luoZD._)(this, ReadonlyReactiveHandler);
        return _super.call(this, true, isShallow2);
    }
    (0, $fYUO3._)(ReadonlyReactiveHandler, [
        {
            key: "set",
            value: function set(target, key) {
                return true;
            }
        },
        {
            key: "deleteProperty",
            value: function deleteProperty(target, key) {
                return true;
            }
        }
    ]);
    return ReadonlyReactiveHandler;
}(BaseReactiveHandler);
var mutableHandlers = /* @__PURE__ */ new MutableReactiveHandler();
var readonlyHandlers = /* @__PURE__ */ new ReadonlyReactiveHandler();
var shallowReactiveHandlers = /* @__PURE__ */ new MutableReactiveHandler(true);
var shallowReadonlyHandlers = /* @__PURE__ */ new ReadonlyReactiveHandler(true);
var toShallow = function(value) {
    return value;
};
var getProto = function(v) {
    return Reflect.getPrototypeOf(v);
};
function get(target, key) {
    var isReadonly = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, isShallow = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    target = target["__v_raw"];
    var rawTarget = toRaw(target);
    var rawKey = toRaw(key);
    if (!isReadonly) {
        if ((0, $lbCQA.hasChanged)(key, rawKey)) track(rawTarget, "get", key);
        track(rawTarget, "get", rawKey);
    }
    var _getProto = getProto(rawTarget), has2 = _getProto.has;
    var wrap = isShallow ? toShallow : isReadonly ? toReadonly : toReactive;
    if (has2.call(rawTarget, key)) return wrap(target.get(key));
    else if (has2.call(rawTarget, rawKey)) return wrap(target.get(rawKey));
    else if (target !== rawTarget) target.get(key);
}
function has(key) {
    var isReadonly = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var target = this["__v_raw"];
    var rawTarget = toRaw(target);
    var rawKey = toRaw(key);
    if (!isReadonly) {
        if ((0, $lbCQA.hasChanged)(key, rawKey)) track(rawTarget, "has", key);
        track(rawTarget, "has", rawKey);
    }
    return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
}
function size(target) {
    var isReadonly = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    target = target["__v_raw"];
    !isReadonly && track(toRaw(target), "iterate", ITERATE_KEY);
    return Reflect.get(target, "size", target);
}
function add(value) {
    value = toRaw(value);
    var target = toRaw(this);
    var proto = getProto(target);
    var hadKey = proto.has.call(target, value);
    if (!hadKey) {
        target.add(value);
        trigger(target, "add", value, value);
    }
    return this;
}
function set(key, value) {
    value = toRaw(value);
    var target = toRaw(this);
    var _getProto = getProto(target), has2 = _getProto.has, get2 = _getProto.get;
    var hadKey = has2.call(target, key);
    if (!hadKey) {
        key = toRaw(key);
        hadKey = has2.call(target, key);
    }
    var oldValue = get2.call(target, key);
    target.set(key, value);
    if (!hadKey) trigger(target, "add", key, value);
    else if ((0, $lbCQA.hasChanged)(value, oldValue)) trigger(target, "set", key, value, oldValue);
    return this;
}
function deleteEntry(key) {
    var target = toRaw(this);
    var _getProto = getProto(target), has2 = _getProto.has, get2 = _getProto.get;
    var hadKey = has2.call(target, key);
    if (!hadKey) {
        key = toRaw(key);
        hadKey = has2.call(target, key);
    }
    var oldValue = get2 ? get2.call(target, key) : void 0;
    var result = target.delete(key);
    if (hadKey) trigger(target, "delete", key, void 0, oldValue);
    return result;
}
function clear() {
    var target = toRaw(this);
    var hadItems = target.size !== 0;
    var oldTarget = void 0;
    var result = target.clear();
    if (hadItems) trigger(target, "clear", void 0, void 0, oldTarget);
    return result;
}
function createForEach(isReadonly, isShallow) {
    return function forEach(callback, thisArg) {
        var observed = this;
        var target = observed["__v_raw"];
        var rawTarget = toRaw(target);
        var wrap = isShallow ? toShallow : isReadonly ? toReadonly : toReactive;
        !isReadonly && track(rawTarget, "iterate", ITERATE_KEY);
        return target.forEach(function(value, key) {
            return callback.call(thisArg, wrap(value), wrap(key), observed);
        });
    };
}
function createIterableMethod(method, isReadonly, isShallow) {
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var _target;
        var target = this["__v_raw"];
        var rawTarget = toRaw(target);
        var targetIsMap = (0, $lbCQA.isMap)(rawTarget);
        var isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
        var isKeyOnly = method === "keys" && targetIsMap;
        var innerIterator = (_target = target)[method].apply(_target, (0, $79xu7._)(args));
        var wrap = isShallow ? toShallow : isReadonly ? toReadonly : toReactive;
        !isReadonly && track(rawTarget, "iterate", isKeyOnly ? MAP_KEY_ITERATE_KEY : ITERATE_KEY);
        return {
            // iterator protocol
            next: function() {
                var _innerIterator_next = innerIterator.next(), value = _innerIterator_next.value, done = _innerIterator_next.done;
                return done ? {
                    value: value,
                    done: done
                } : {
                    value: isPair ? [
                        wrap(value[0]),
                        wrap(value[1])
                    ] : wrap(value),
                    done: done
                };
            },
            // iterable protocol
            [Symbol.iterator]: function() {
                return this;
            }
        };
    };
}
function createReadonlyMethod(type) {
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return type === "delete" ? false : type === "clear" ? void 0 : this;
    };
}
function createInstrumentations() {
    var mutableInstrumentations2 = {
        get: function(key) {
            return get(this, key);
        },
        get size () {
            return size(this);
        },
        has: has,
        add: add,
        set: set,
        delete: deleteEntry,
        clear: clear,
        forEach: createForEach(false, false)
    };
    var shallowInstrumentations2 = {
        get: function(key) {
            return get(this, key, false, true);
        },
        get size () {
            return size(this);
        },
        has: has,
        add: add,
        set: set,
        delete: deleteEntry,
        clear: clear,
        forEach: createForEach(false, true)
    };
    var readonlyInstrumentations2 = {
        get: function(key) {
            return get(this, key, true);
        },
        get size () {
            return size(this, true);
        },
        has: function(key) {
            return has.call(this, key, true);
        },
        add: createReadonlyMethod("add"),
        set: createReadonlyMethod("set"),
        delete: createReadonlyMethod("delete"),
        clear: createReadonlyMethod("clear"),
        forEach: createForEach(true, false)
    };
    var shallowReadonlyInstrumentations2 = {
        get: function(key) {
            return get(this, key, true, true);
        },
        get size () {
            return size(this, true);
        },
        has: function(key) {
            return has.call(this, key, true);
        },
        add: createReadonlyMethod("add"),
        set: createReadonlyMethod("set"),
        delete: createReadonlyMethod("delete"),
        clear: createReadonlyMethod("clear"),
        forEach: createForEach(true, true)
    };
    var iteratorMethods = [
        "keys",
        "values",
        "entries",
        Symbol.iterator
    ];
    iteratorMethods.forEach(function(method) {
        mutableInstrumentations2[method] = createIterableMethod(method, false, false);
        readonlyInstrumentations2[method] = createIterableMethod(method, true, false);
        shallowInstrumentations2[method] = createIterableMethod(method, false, true);
        shallowReadonlyInstrumentations2[method] = createIterableMethod(method, true, true);
    });
    return [
        mutableInstrumentations2,
        readonlyInstrumentations2,
        shallowInstrumentations2,
        shallowReadonlyInstrumentations2
    ];
}
var /* @__PURE__ */ _createInstrumentations = (0, $4f96i._)(createInstrumentations(), 4), mutableInstrumentations = _createInstrumentations[0], readonlyInstrumentations = _createInstrumentations[1], shallowInstrumentations = _createInstrumentations[2], shallowReadonlyInstrumentations = _createInstrumentations[3];
function createInstrumentationGetter(isReadonly, shallow) {
    var instrumentations = shallow ? isReadonly ? shallowReadonlyInstrumentations : shallowInstrumentations : isReadonly ? readonlyInstrumentations : mutableInstrumentations;
    return function(target, key, receiver) {
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw") return target;
        return Reflect.get((0, $lbCQA.hasOwn)(instrumentations, key) && key in target ? instrumentations : target, key, receiver);
    };
}
var mutableCollectionHandlers = {
    get: /* @__PURE__ */ createInstrumentationGetter(false, false)
};
var shallowCollectionHandlers = {
    get: /* @__PURE__ */ createInstrumentationGetter(false, true)
};
var readonlyCollectionHandlers = {
    get: /* @__PURE__ */ createInstrumentationGetter(true, false)
};
var shallowReadonlyCollectionHandlers = {
    get: /* @__PURE__ */ createInstrumentationGetter(true, true)
};
function checkIdentityKeys(target, has2, key) {
    var rawKey = toRaw(key);
    if (rawKey !== key && has2.call(target, rawKey)) {
        var type = (0, $lbCQA.toRawType)(target);
        warn("Reactive ".concat(type, " contains both the raw and reactive versions of the same object").concat(type === "Map" ? " as keys" : "", ", which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible."));
    }
}
var reactiveMap = /* @__PURE__ */ new WeakMap();
var shallowReactiveMap = /* @__PURE__ */ new WeakMap();
var readonlyMap = /* @__PURE__ */ new WeakMap();
var shallowReadonlyMap = /* @__PURE__ */ new WeakMap();
function targetTypeMap(rawType) {
    switch(rawType){
        case "Object":
        case "Array":
            return 1 /* COMMON */ ;
        case "Map":
        case "Set":
        case "WeakMap":
        case "WeakSet":
            return 2 /* COLLECTION */ ;
        default:
            return 0 /* INVALID */ ;
    }
}
function getTargetType(value) {
    return value["__v_skip"] || !Object.isExtensible(value) ? 0 /* INVALID */  : targetTypeMap((0, $lbCQA.toRawType)(value));
}
function reactive(target) {
    if (isReadonly(target)) return target;
    return createReactiveObject(target, false, mutableHandlers, mutableCollectionHandlers, reactiveMap);
}
function shallowReactive(target) {
    return createReactiveObject(target, false, shallowReactiveHandlers, shallowCollectionHandlers, shallowReactiveMap);
}
function readonly(target) {
    return createReactiveObject(target, true, readonlyHandlers, readonlyCollectionHandlers, readonlyMap);
}
function shallowReadonly(target) {
    return createReactiveObject(target, true, shallowReadonlyHandlers, shallowReadonlyCollectionHandlers, shallowReadonlyMap);
}
function createReactiveObject(target, isReadonly2, baseHandlers, collectionHandlers, proxyMap) {
    if (!(0, $lbCQA.isObject)(target)) return target;
    if (target["__v_raw"] && !(isReadonly2 && target["__v_isReactive"])) return target;
    var existingProxy = proxyMap.get(target);
    if (existingProxy) return existingProxy;
    var targetType = getTargetType(target);
    if (targetType === 0 /* INVALID */ ) return target;
    var proxy = new Proxy(target, targetType === 2 /* COLLECTION */  ? collectionHandlers : baseHandlers);
    proxyMap.set(target, proxy);
    return proxy;
}
function isReactive(value) {
    if (isReadonly(value)) return isReactive(value["__v_raw"]);
    return !!(value && value["__v_isReactive"]);
}
function isReadonly(value) {
    return !!(value && value["__v_isReadonly"]);
}
function isShallow(value) {
    return !!(value && value["__v_isShallow"]);
}
function isProxy(value) {
    return value ? !!value["__v_raw"] : false;
}
function toRaw(observed) {
    var raw = observed && observed["__v_raw"];
    return raw ? toRaw(raw) : observed;
}
function markRaw(value) {
    if (Object.isExtensible(value)) (0, $lbCQA.def)(value, "__v_skip", true);
    return value;
}
var toReactive = function(value) {
    return (0, $lbCQA.isObject)(value) ? reactive(value) : value;
};
var toReadonly = function(value) {
    return (0, $lbCQA.isObject)(value) ? readonly(value) : value;
};
var COMPUTED_SIDE_EFFECT_WARN = "Computed is still dirty after getter evaluation, likely because a computed is mutating its own dependency in its getter. State mutations in computed getters should be avoided.  Check the docs for more details: https://vuejs.org/guide/essentials/computed.html#getters-should-be-side-effect-free";
var ComputedRefImpl = /*#__PURE__*/ function() {
    "use strict";
    function ComputedRefImpl(getter, _setter, isReadonly, isSSR) {
        var _this = this;
        (0, $luoZD._)(this, ComputedRefImpl);
        this.getter = getter;
        this._setter = _setter;
        this.dep = void 0;
        this.__v_isRef = true;
        this["__v_isReadonly"] = false;
        this.effect = new ReactiveEffect(function() {
            return getter(_this._value);
        }, function() {
            return triggerRefValue(_this, _this.effect._dirtyLevel === 2 ? 2 : 3);
        });
        this.effect.computed = this;
        this.effect.active = this._cacheable = !isSSR;
        this["__v_isReadonly"] = isReadonly;
    }
    (0, $fYUO3._)(ComputedRefImpl, [
        {
            key: "value",
            get: function get() {
                var self = toRaw(this);
                if ((!self._cacheable || self.effect.dirty) && (0, $lbCQA.hasChanged)(self._value, self._value = self.effect.run())) triggerRefValue(self, 4);
                trackRefValue(self);
                if (self.effect._dirtyLevel >= 2) triggerRefValue(self, 2);
                return self._value;
            },
            set: function set(newValue) {
                this._setter(newValue);
            }
        },
        {
            key: "_dirty",
            get: // #region polyfill _dirty for backward compatibility third party code for Vue <= 3.3.x
            function get() {
                return this.effect.dirty;
            },
            set: function set(v) {
                this.effect.dirty = v;
            }
        }
    ]);
    return ComputedRefImpl;
}();
function computed(getterOrOptions, debugOptions) {
    var isSSR = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var getter;
    var setter;
    var onlyGetter = (0, $lbCQA.isFunction)(getterOrOptions);
    if (onlyGetter) {
        getter = getterOrOptions;
        setter = (0, $lbCQA.NOOP);
    } else {
        getter = getterOrOptions.get;
        setter = getterOrOptions.set;
    }
    var cRef = new ComputedRefImpl(getter, setter, onlyGetter || !setter, isSSR);
    return cRef;
}
function trackRefValue(ref2) {
    var _a;
    if (shouldTrack && activeEffect) {
        ref2 = toRaw(ref2);
        trackEffect(activeEffect, (_a = ref2.dep) != null ? _a : ref2.dep = createDep(function() {
            return ref2.dep = void 0;
        }, ref2 instanceof ComputedRefImpl ? ref2 : void 0), void 0);
    }
}
function triggerRefValue(ref2) {
    var dirtyLevel = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 4, newVal = arguments.length > 2 ? arguments[2] : void 0;
    ref2 = toRaw(ref2);
    var dep = ref2.dep;
    if (dep) triggerEffects(dep, dirtyLevel, void 0);
}
function isRef(r) {
    return !!(r && r.__v_isRef === true);
}
function ref(value) {
    return createRef(value, false);
}
function shallowRef(value) {
    return createRef(value, true);
}
function createRef(rawValue, shallow) {
    if (isRef(rawValue)) return rawValue;
    return new RefImpl(rawValue, shallow);
}
var RefImpl = /*#__PURE__*/ function() {
    "use strict";
    function RefImpl(value, __v_isShallow) {
        (0, $luoZD._)(this, RefImpl);
        this.__v_isShallow = __v_isShallow;
        this.dep = void 0;
        this.__v_isRef = true;
        this._rawValue = __v_isShallow ? value : toRaw(value);
        this._value = __v_isShallow ? value : toReactive(value);
    }
    (0, $fYUO3._)(RefImpl, [
        {
            key: "value",
            get: function get() {
                trackRefValue(this);
                return this._value;
            },
            set: function set(newVal) {
                var useDirectValue = this.__v_isShallow || isShallow(newVal) || isReadonly(newVal);
                newVal = useDirectValue ? newVal : toRaw(newVal);
                if ((0, $lbCQA.hasChanged)(newVal, this._rawValue)) {
                    this._rawValue = newVal;
                    this._value = useDirectValue ? newVal : toReactive(newVal);
                    triggerRefValue(this, 4, newVal);
                }
            }
        }
    ]);
    return RefImpl;
}();
function triggerRef(ref2) {
    triggerRefValue(ref2, 4, void 0);
}
function unref(ref2) {
    return isRef(ref2) ? ref2.value : ref2;
}
function toValue(source) {
    return (0, $lbCQA.isFunction)(source) ? source() : unref(source);
}
var shallowUnwrapHandlers = {
    get: function(target, key, receiver) {
        return unref(Reflect.get(target, key, receiver));
    },
    set: function(target, key, value, receiver) {
        var oldValue = target[key];
        if (isRef(oldValue) && !isRef(value)) {
            oldValue.value = value;
            return true;
        } else return Reflect.set(target, key, value, receiver);
    }
};
function proxyRefs(objectWithRefs) {
    return isReactive(objectWithRefs) ? objectWithRefs : new Proxy(objectWithRefs, shallowUnwrapHandlers);
}
var CustomRefImpl = /*#__PURE__*/ function() {
    "use strict";
    function CustomRefImpl(factory) {
        var _this = this;
        (0, $luoZD._)(this, CustomRefImpl);
        this.dep = void 0;
        this.__v_isRef = true;
        var _factory = factory(function() {
            return trackRefValue(_this);
        }, function() {
            return triggerRefValue(_this);
        }), get = _factory.get, set = _factory.set;
        this._get = get;
        this._set = set;
    }
    (0, $fYUO3._)(CustomRefImpl, [
        {
            key: "value",
            get: function get() {
                return this._get();
            },
            set: function set(newVal) {
                this._set(newVal);
            }
        }
    ]);
    return CustomRefImpl;
}();
function customRef(factory) {
    return new CustomRefImpl(factory);
}
function toRefs(object) {
    var ret = (0, $lbCQA.isArray)(object) ? new Array(object.length) : {};
    for(var key in object)ret[key] = propertyToRef(object, key);
    return ret;
}
var ObjectRefImpl = /*#__PURE__*/ function() {
    "use strict";
    function ObjectRefImpl(_object, _key, _defaultValue) {
        (0, $luoZD._)(this, ObjectRefImpl);
        this._object = _object;
        this._key = _key;
        this._defaultValue = _defaultValue;
        this.__v_isRef = true;
    }
    (0, $fYUO3._)(ObjectRefImpl, [
        {
            key: "value",
            get: function get() {
                var val = this._object[this._key];
                return val === void 0 ? this._defaultValue : val;
            },
            set: function set(newVal) {
                this._object[this._key] = newVal;
            }
        },
        {
            key: "dep",
            get: function get() {
                return getDepFromReactive(toRaw(this._object), this._key);
            }
        }
    ]);
    return ObjectRefImpl;
}();
var GetterRefImpl = /*#__PURE__*/ function() {
    "use strict";
    function GetterRefImpl(_getter) {
        (0, $luoZD._)(this, GetterRefImpl);
        this._getter = _getter;
        this.__v_isRef = true;
        this.__v_isReadonly = true;
    }
    (0, $fYUO3._)(GetterRefImpl, [
        {
            key: "value",
            get: function get() {
                return this._getter();
            }
        }
    ]);
    return GetterRefImpl;
}();
function toRef(source, key, defaultValue) {
    if (isRef(source)) return source;
    else if ((0, $lbCQA.isFunction)(source)) return new GetterRefImpl(source);
    else if ((0, $lbCQA.isObject)(source) && arguments.length > 1) return propertyToRef(source, key, defaultValue);
    else return ref(source);
}
function propertyToRef(source, key, defaultValue) {
    var val = source[key];
    return isRef(val) ? val : new ObjectRefImpl(source, key, defaultValue);
}
var deferredComputed = computed;
var TrackOpTypes = {
    "GET": "get",
    "HAS": "has",
    "ITERATE": "iterate"
};
var TriggerOpTypes = {
    "SET": "set",
    "ADD": "add",
    "DELETE": "delete",
    "CLEAR": "clear"
};
var ReactiveFlags = {
    "SKIP": "__v_skip",
    "IS_REACTIVE": "__v_isReactive",
    "IS_READONLY": "__v_isReadonly",
    "IS_SHALLOW": "__v_isShallow",
    "RAW": "__v_raw"
};

});
parcelRegister("7DbRq", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $58e5603a39334781$export$7e4530ad35d3bb8; });

var $fx5GK = parcelRequire("fx5GK");
function $58e5603a39334781$export$7e4530ad35d3bb8(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) (0, $fx5GK._set_prototype_of)(subClass, superClass);
}

});
parcelRegister("fx5GK", function(module, exports) {

$parcel$export(module.exports, "_set_prototype_of", function () { return $b4ee59b8cb0b8f05$export$c2c98ac76e997b63; });
function $b4ee59b8cb0b8f05$export$c2c98ac76e997b63(o, p) {
    $b4ee59b8cb0b8f05$export$c2c98ac76e997b63 = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $b4ee59b8cb0b8f05$export$c2c98ac76e997b63(o, p);
}

});


parcelRegister("ju9pQ", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $e2f81f757274eb21$export$8dd05c13f5255580; });

var $3Oamm = parcelRequire("3Oamm");

var $bYsjm = parcelRequire("bYsjm");

var $fo4pf = parcelRequire("fo4pf");
function $e2f81f757274eb21$export$8dd05c13f5255580(Derived) {
    var hasNativeReflectConstruct = (0, $bYsjm._is_native_reflect_construct)();
    return function _createSuperInternal() {
        var Super = (0, $3Oamm._get_prototype_of)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $3Oamm._get_prototype_of)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $fo4pf._possible_constructor_return)(this, result);
    };
}

});
parcelRegister("3Oamm", function(module, exports) {

$parcel$export(module.exports, "_get_prototype_of", function () { return $2c5e13cc6824762c$export$f09211a7d3c496a1; });
$parcel$export(module.exports, "_", function () { return $2c5e13cc6824762c$export$f09211a7d3c496a1; });
function $2c5e13cc6824762c$export$f09211a7d3c496a1(o) {
    $2c5e13cc6824762c$export$f09211a7d3c496a1 = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $2c5e13cc6824762c$export$f09211a7d3c496a1(o);
}

});

parcelRegister("bYsjm", function(module, exports) {

$parcel$export(module.exports, "_is_native_reflect_construct", function () { return $8b7b425522f8f232$export$685354647fba1516; });
function $8b7b425522f8f232$export$685354647fba1516() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}

});

parcelRegister("fo4pf", function(module, exports) {

$parcel$export(module.exports, "_possible_constructor_return", function () { return $b33c83e5691359de$export$ef97c660ca164e52; });

var $iJSF3 = parcelRequire("iJSF3");

var $jzTO1 = parcelRequire("jzTO1");
function $b33c83e5691359de$export$ef97c660ca164e52(self, call) {
    if (call && ((0, $jzTO1._type_of)(call) === "object" || typeof call === "function")) return call;
    return (0, $iJSF3._assert_this_initialized)(self);
}

});
parcelRegister("iJSF3", function(module, exports) {

$parcel$export(module.exports, "_assert_this_initialized", function () { return $da46d48416b58661$export$f3b8ed2e4a5d10b8; });
$parcel$export(module.exports, "_", function () { return $da46d48416b58661$export$f3b8ed2e4a5d10b8; });
function $da46d48416b58661$export$f3b8ed2e4a5d10b8(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

});



parcelRegister("lbCQA", function(module, exports) {

$parcel$export(module.exports, "makeMap", function () { return $f6c8c24690686b95$export$b41394a5437791c8; });
$parcel$export(module.exports, "EMPTY_OBJ", function () { return $f6c8c24690686b95$export$cf583d23ab39677c; });
$parcel$export(module.exports, "EMPTY_ARR", function () { return $f6c8c24690686b95$export$6bd8558f433f1cc1; });
$parcel$export(module.exports, "NOOP", function () { return $f6c8c24690686b95$export$5702a91a6f42969f; });
$parcel$export(module.exports, "NO", function () { return $f6c8c24690686b95$export$c01351c0af048e39; });
$parcel$export(module.exports, "isOn", function () { return $f6c8c24690686b95$export$1a2d97de39ecbb75; });
$parcel$export(module.exports, "isModelListener", function () { return $f6c8c24690686b95$export$793aa5469768d691; });
$parcel$export(module.exports, "extend", function () { return $f6c8c24690686b95$export$8b58be045bf06082; });
$parcel$export(module.exports, "remove", function () { return $f6c8c24690686b95$export$cd7f480d6b8286c3; });
$parcel$export(module.exports, "hasOwn", function () { return $f6c8c24690686b95$export$b5a638e9b3fff9f3; });
$parcel$export(module.exports, "isArray", function () { return $f6c8c24690686b95$export$43bee75e5e14138e; });
$parcel$export(module.exports, "isMap", function () { return $f6c8c24690686b95$export$5c90113a285f2241; });
$parcel$export(module.exports, "isSet", function () { return $f6c8c24690686b95$export$6750766a7c7ec627; });
$parcel$export(module.exports, "isRegExp", function () { return $f6c8c24690686b95$export$49841c62b9eff15; });
$parcel$export(module.exports, "isFunction", function () { return $f6c8c24690686b95$export$f6e2535fb5126e54; });
$parcel$export(module.exports, "isString", function () { return $f6c8c24690686b95$export$844ec244b1367d54; });
$parcel$export(module.exports, "isSymbol", function () { return $f6c8c24690686b95$export$a244864fd9645c7f; });
$parcel$export(module.exports, "isObject", function () { return $f6c8c24690686b95$export$a6cdc56e425d0d0a; });
$parcel$export(module.exports, "isPromise", function () { return $f6c8c24690686b95$export$4369c812aac99591; });
$parcel$export(module.exports, "toRawType", function () { return $f6c8c24690686b95$export$5ad0a3c360b8fbb5; });
$parcel$export(module.exports, "isPlainObject", function () { return $f6c8c24690686b95$export$53b83ca8eaab0383; });
$parcel$export(module.exports, "isIntegerKey", function () { return $f6c8c24690686b95$export$e2a2b93446ec9fe; });
$parcel$export(module.exports, "isReservedProp", function () { return $f6c8c24690686b95$export$bf7d3c0236f0aa85; });
$parcel$export(module.exports, "isBuiltInDirective", function () { return $f6c8c24690686b95$export$a9c1fdb3030c2a6b; });
$parcel$export(module.exports, "camelize", function () { return $f6c8c24690686b95$export$161d051f5dd25de7; });
$parcel$export(module.exports, "hyphenate", function () { return $f6c8c24690686b95$export$6e6a0a3676c4b8bb; });
$parcel$export(module.exports, "capitalize", function () { return $f6c8c24690686b95$export$9a00dee1beb8f576; });
$parcel$export(module.exports, "toHandlerKey", function () { return $f6c8c24690686b95$export$8c022799eeaaefcd; });
$parcel$export(module.exports, "hasChanged", function () { return $f6c8c24690686b95$export$f619eb8b89076d23; });
$parcel$export(module.exports, "invokeArrayFns", function () { return $f6c8c24690686b95$export$39951422d618a9d3; });
$parcel$export(module.exports, "def", function () { return $f6c8c24690686b95$export$8afb76124cf08683; });
$parcel$export(module.exports, "looseToNumber", function () { return $f6c8c24690686b95$export$d3be7195bcc2f31b; });
$parcel$export(module.exports, "toNumber", function () { return $f6c8c24690686b95$export$a0a81dc3380ce7d3; });
$parcel$export(module.exports, "getGlobalThis", function () { return $f6c8c24690686b95$export$ff5f2eeb11fc7e14; });
$parcel$export(module.exports, "isGloballyAllowed", function () { return $f6c8c24690686b95$export$f73b8c13b7f97ebf; });
$parcel$export(module.exports, "normalizeStyle", function () { return $f6c8c24690686b95$export$8756898546458274; });
$parcel$export(module.exports, "stringifyStyle", function () { return $f6c8c24690686b95$export$9466a5a0ee6f1479; });
$parcel$export(module.exports, "normalizeClass", function () { return $f6c8c24690686b95$export$4f7022d2d68e2c5a; });
$parcel$export(module.exports, "isHTMLTag", function () { return $f6c8c24690686b95$export$1ccf854a0984f890; });
$parcel$export(module.exports, "isSVGTag", function () { return $f6c8c24690686b95$export$6328ce7565ea1049; });
$parcel$export(module.exports, "isMathMLTag", function () { return $f6c8c24690686b95$export$4a46ca4c5be17b20; });
$parcel$export(module.exports, "isSpecialBooleanAttr", function () { return $f6c8c24690686b95$export$d186f5eb2e810715; });
$parcel$export(module.exports, "isBooleanAttr", function () { return $f6c8c24690686b95$export$f763ba3b84e9cd8c; });
$parcel$export(module.exports, "includeBooleanAttr", function () { return $f6c8c24690686b95$export$e3f3cdb1390d56ce; });
$parcel$export(module.exports, "isKnownHtmlAttr", function () { return $f6c8c24690686b95$export$f7e7a1cc7da8d5e9; });
$parcel$export(module.exports, "isKnownSvgAttr", function () { return $f6c8c24690686b95$export$80da416f43933831; });
$parcel$export(module.exports, "isRenderableAttrValue", function () { return $f6c8c24690686b95$export$921dd2acf0d386a3; });
$parcel$export(module.exports, "looseEqual", function () { return $f6c8c24690686b95$export$ae8015769846262c; });
$parcel$export(module.exports, "looseIndexOf", function () { return $f6c8c24690686b95$export$42912a80cedb8bd4; });
/**
* @vue/shared v3.4.25
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ /*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__

var $4f96i = parcelRequire("4f96i");

var $79xu7 = parcelRequire("79xu7");

var $jzTO1 = parcelRequire("jzTO1");
function $f6c8c24690686b95$export$b41394a5437791c8(str, expectsLowerCase) {
    var set = new Set(str.split(","));
    return expectsLowerCase ? function(val) {
        return set.has(val.toLowerCase());
    } : function(val) {
        return set.has(val);
    };
}
var $f6c8c24690686b95$export$cf583d23ab39677c = {};
var $f6c8c24690686b95$export$6bd8558f433f1cc1 = [];
var $f6c8c24690686b95$export$5702a91a6f42969f = function() {};
var $f6c8c24690686b95$export$c01351c0af048e39 = function() {
    return false;
};
var $f6c8c24690686b95$export$1a2d97de39ecbb75 = function(key) {
    return key.charCodeAt(0) === 111 && key.charCodeAt(1) === 110 && // uppercase letter
    (key.charCodeAt(2) > 122 || key.charCodeAt(2) < 97);
};
var $f6c8c24690686b95$export$793aa5469768d691 = function(key) {
    return key.startsWith("onUpdate:");
};
var $f6c8c24690686b95$export$8b58be045bf06082 = Object.assign;
var $f6c8c24690686b95$export$cd7f480d6b8286c3 = function(arr, el) {
    var i = arr.indexOf(el);
    if (i > -1) arr.splice(i, 1);
};
var $f6c8c24690686b95$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $f6c8c24690686b95$export$b5a638e9b3fff9f3 = function(val, key) {
    return $f6c8c24690686b95$var$hasOwnProperty.call(val, key);
};
var $f6c8c24690686b95$export$43bee75e5e14138e = Array.isArray;
var $f6c8c24690686b95$export$5c90113a285f2241 = function(val) {
    return $f6c8c24690686b95$export$1dccc787cc36538b(val) === "[object Map]";
};
var $f6c8c24690686b95$export$6750766a7c7ec627 = function(val) {
    return $f6c8c24690686b95$export$1dccc787cc36538b(val) === "[object Set]";
};
var $f6c8c24690686b95$export$871608497c498473 = function(val) {
    return $f6c8c24690686b95$export$1dccc787cc36538b(val) === "[object Date]";
};
var $f6c8c24690686b95$export$49841c62b9eff15 = function(val) {
    return $f6c8c24690686b95$export$1dccc787cc36538b(val) === "[object RegExp]";
};
var $f6c8c24690686b95$export$f6e2535fb5126e54 = function(val) {
    return typeof val === "function";
};
var $f6c8c24690686b95$export$844ec244b1367d54 = function(val) {
    return typeof val === "string";
};
var $f6c8c24690686b95$export$a244864fd9645c7f = function(val) {
    return (typeof val === "undefined" ? "undefined" : (0, $jzTO1._)(val)) === "symbol";
};
var $f6c8c24690686b95$export$a6cdc56e425d0d0a = function(val) {
    return val !== null && typeof val === "object";
};
var $f6c8c24690686b95$export$4369c812aac99591 = function(val) {
    return ($f6c8c24690686b95$export$a6cdc56e425d0d0a(val) || $f6c8c24690686b95$export$f6e2535fb5126e54(val)) && $f6c8c24690686b95$export$f6e2535fb5126e54(val.then) && $f6c8c24690686b95$export$f6e2535fb5126e54(val.catch);
};
var $f6c8c24690686b95$export$830c053460e5ddf6 = Object.prototype.toString;
var $f6c8c24690686b95$export$1dccc787cc36538b = function(value) {
    return $f6c8c24690686b95$export$830c053460e5ddf6.call(value);
};
var $f6c8c24690686b95$export$5ad0a3c360b8fbb5 = function(value) {
    return $f6c8c24690686b95$export$1dccc787cc36538b(value).slice(8, -1);
};
var $f6c8c24690686b95$export$53b83ca8eaab0383 = function(val) {
    return $f6c8c24690686b95$export$1dccc787cc36538b(val) === "[object Object]";
};
var $f6c8c24690686b95$export$e2a2b93446ec9fe = function(key) {
    return $f6c8c24690686b95$export$844ec244b1367d54(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
};
var $f6c8c24690686b95$export$bf7d3c0236f0aa85 = /* @__PURE__ */ $f6c8c24690686b95$export$b41394a5437791c8(// the leading comma is intentional so empty string "" is also included
",key,ref,ref_for,ref_key,onVnodeBeforeMount,onVnodeMounted,onVnodeBeforeUpdate,onVnodeUpdated,onVnodeBeforeUnmount,onVnodeUnmounted");
var $f6c8c24690686b95$export$a9c1fdb3030c2a6b = /* @__PURE__ */ $f6c8c24690686b95$export$b41394a5437791c8("bind,cloak,else-if,else,for,html,if,model,on,once,pre,show,slot,text,memo");
var $f6c8c24690686b95$var$cacheStringFunction = function(fn) {
    var cache = /* @__PURE__ */ Object.create(null);
    return function(str) {
        var hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
};
var $f6c8c24690686b95$var$camelizeRE = /-(\w)/g;
var $f6c8c24690686b95$export$161d051f5dd25de7 = $f6c8c24690686b95$var$cacheStringFunction(function(str) {
    return str.replace($f6c8c24690686b95$var$camelizeRE, function(_, c) {
        return c ? c.toUpperCase() : "";
    });
});
var $f6c8c24690686b95$var$hyphenateRE = /\B([A-Z])/g;
var $f6c8c24690686b95$export$6e6a0a3676c4b8bb = $f6c8c24690686b95$var$cacheStringFunction(function(str) {
    return str.replace($f6c8c24690686b95$var$hyphenateRE, "-$1").toLowerCase();
});
var $f6c8c24690686b95$export$9a00dee1beb8f576 = $f6c8c24690686b95$var$cacheStringFunction(function(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
});
var $f6c8c24690686b95$export$8c022799eeaaefcd = $f6c8c24690686b95$var$cacheStringFunction(function(str) {
    var s = str ? "on".concat($f6c8c24690686b95$export$9a00dee1beb8f576(str)) : "";
    return s;
});
var $f6c8c24690686b95$export$f619eb8b89076d23 = function(value, oldValue) {
    return !Object.is(value, oldValue);
};
var $f6c8c24690686b95$export$39951422d618a9d3 = function(fns, arg) {
    for(var i = 0; i < fns.length; i++)fns[i](arg);
};
var $f6c8c24690686b95$export$8afb76124cf08683 = function(obj, key, value) {
    Object.defineProperty(obj, key, {
        configurable: true,
        enumerable: false,
        value: value
    });
};
var $f6c8c24690686b95$export$d3be7195bcc2f31b = function(val) {
    var n = parseFloat(val);
    return isNaN(n) ? val : n;
};
var $f6c8c24690686b95$export$a0a81dc3380ce7d3 = function(val) {
    var n = $f6c8c24690686b95$export$844ec244b1367d54(val) ? Number(val) : NaN;
    return isNaN(n) ? val : n;
};
var $f6c8c24690686b95$var$_globalThis;
var $f6c8c24690686b95$export$ff5f2eeb11fc7e14 = function() {
    return $f6c8c24690686b95$var$_globalThis || ($f6c8c24690686b95$var$_globalThis = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : {});
};
var $f6c8c24690686b95$var$identRE = /^[_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*$/;
function $f6c8c24690686b95$export$53d5e12f9a1d3cde(name) {
    return $f6c8c24690686b95$var$identRE.test(name) ? "__props.".concat(name) : "__props[".concat(JSON.stringify(name), "]");
}
var $f6c8c24690686b95$export$4bcc674e2ac54ab0 = {
    "TEXT": 1,
    "1": "TEXT",
    "CLASS": 2,
    "2": "CLASS",
    "STYLE": 4,
    "4": "STYLE",
    "PROPS": 8,
    "8": "PROPS",
    "FULL_PROPS": 16,
    "16": "FULL_PROPS",
    "NEED_HYDRATION": 32,
    "32": "NEED_HYDRATION",
    "STABLE_FRAGMENT": 64,
    "64": "STABLE_FRAGMENT",
    "KEYED_FRAGMENT": 128,
    "128": "KEYED_FRAGMENT",
    "UNKEYED_FRAGMENT": 256,
    "256": "UNKEYED_FRAGMENT",
    "NEED_PATCH": 512,
    "512": "NEED_PATCH",
    "DYNAMIC_SLOTS": 1024,
    "1024": "DYNAMIC_SLOTS",
    "DEV_ROOT_FRAGMENT": 2048,
    "2048": "DEV_ROOT_FRAGMENT",
    "HOISTED": -1,
    "-1": "HOISTED",
    "BAIL": -2,
    "-2": "BAIL"
};
var $f6c8c24690686b95$export$def7dc2c2e95a08a = {
    [1]: "TEXT",
    [2]: "CLASS",
    [4]: "STYLE",
    [8]: "PROPS",
    [16]: "FULL_PROPS",
    [32]: "NEED_HYDRATION",
    [64]: "STABLE_FRAGMENT",
    [128]: "KEYED_FRAGMENT",
    [256]: "UNKEYED_FRAGMENT",
    [512]: "NEED_PATCH",
    [1024]: "DYNAMIC_SLOTS",
    [2048]: "DEV_ROOT_FRAGMENT",
    [-1]: "HOISTED",
    [-2]: "BAIL"
};
var $f6c8c24690686b95$export$ff27c1ebf2311072 = {
    "ELEMENT": 1,
    "1": "ELEMENT",
    "FUNCTIONAL_COMPONENT": 2,
    "2": "FUNCTIONAL_COMPONENT",
    "STATEFUL_COMPONENT": 4,
    "4": "STATEFUL_COMPONENT",
    "TEXT_CHILDREN": 8,
    "8": "TEXT_CHILDREN",
    "ARRAY_CHILDREN": 16,
    "16": "ARRAY_CHILDREN",
    "SLOTS_CHILDREN": 32,
    "32": "SLOTS_CHILDREN",
    "TELEPORT": 64,
    "64": "TELEPORT",
    "SUSPENSE": 128,
    "128": "SUSPENSE",
    "COMPONENT_SHOULD_KEEP_ALIVE": 256,
    "256": "COMPONENT_SHOULD_KEEP_ALIVE",
    "COMPONENT_KEPT_ALIVE": 512,
    "512": "COMPONENT_KEPT_ALIVE",
    "COMPONENT": 6,
    "6": "COMPONENT"
};
var $f6c8c24690686b95$export$b1e6fe37bcdef5be = {
    "STABLE": 1,
    "1": "STABLE",
    "DYNAMIC": 2,
    "2": "DYNAMIC",
    "FORWARDED": 3,
    "3": "FORWARDED"
};
var $f6c8c24690686b95$export$624972196ed3745f = {
    [1]: "STABLE",
    [2]: "DYNAMIC",
    [3]: "FORWARDED"
};
var $f6c8c24690686b95$var$GLOBALS_ALLOWED = "Infinity,undefined,NaN,isFinite,isNaN,parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,BigInt,console,Error";
var $f6c8c24690686b95$export$f73b8c13b7f97ebf = /* @__PURE__ */ $f6c8c24690686b95$export$b41394a5437791c8($f6c8c24690686b95$var$GLOBALS_ALLOWED);
var $f6c8c24690686b95$export$d6571a1911e4f27e = $f6c8c24690686b95$export$f73b8c13b7f97ebf;
var $f6c8c24690686b95$var$range = 2;
function $f6c8c24690686b95$export$f9c0d8b6684a279b(source) {
    var start = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, end = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : source.length;
    var lines = source.split(/(\r?\n)/);
    var newlineSequences = lines.filter(function(_, idx) {
        return idx % 2 === 1;
    });
    lines = lines.filter(function(_, idx) {
        return idx % 2 === 0;
    });
    var count = 0;
    var res = [];
    for(var i = 0; i < lines.length; i++){
        count += lines[i].length + (newlineSequences[i] && newlineSequences[i].length || 0);
        if (count >= start) {
            for(var j = i - $f6c8c24690686b95$var$range; j <= i + $f6c8c24690686b95$var$range || end > count; j++){
                if (j < 0 || j >= lines.length) continue;
                var line = j + 1;
                res.push("".concat(line).concat(" ".repeat(Math.max(3 - String(line).length, 0)), "|  ").concat(lines[j]));
                var lineLength = lines[j].length;
                var newLineSeqLength = newlineSequences[j] && newlineSequences[j].length || 0;
                if (j === i) {
                    var pad = start - (count - (lineLength + newLineSeqLength));
                    var length = Math.max(1, end > count ? lineLength - pad : end - start);
                    res.push("   |  " + " ".repeat(pad) + "^".repeat(length));
                } else if (j > i) {
                    if (end > count) {
                        var length1 = Math.max(Math.min(end - count, lineLength), 1);
                        res.push("   |  " + "^".repeat(length1));
                    }
                    count += lineLength + newLineSeqLength;
                }
            }
            break;
        }
    }
    return res.join("\n");
}
function $f6c8c24690686b95$export$8756898546458274(value) {
    if ($f6c8c24690686b95$export$43bee75e5e14138e(value)) {
        var res = {};
        for(var i = 0; i < value.length; i++){
            var item = value[i];
            var normalized = $f6c8c24690686b95$export$844ec244b1367d54(item) ? $f6c8c24690686b95$export$76a205ce979d066a(item) : $f6c8c24690686b95$export$8756898546458274(item);
            if (normalized) for(var key in normalized)res[key] = normalized[key];
        }
        return res;
    } else if ($f6c8c24690686b95$export$844ec244b1367d54(value) || $f6c8c24690686b95$export$a6cdc56e425d0d0a(value)) return value;
}
var $f6c8c24690686b95$var$listDelimiterRE = /;(?![^(]*\))/g;
var $f6c8c24690686b95$var$propertyDelimiterRE = /:([^]+)/;
var $f6c8c24690686b95$var$styleCommentRE = /\/\*[^]*?\*\//g;
function $f6c8c24690686b95$export$76a205ce979d066a(cssText) {
    var ret = {};
    cssText.replace($f6c8c24690686b95$var$styleCommentRE, "").split($f6c8c24690686b95$var$listDelimiterRE).forEach(function(item) {
        if (item) {
            var tmp = item.split($f6c8c24690686b95$var$propertyDelimiterRE);
            tmp.length > 1 && (ret[tmp[0].trim()] = tmp[1].trim());
        }
    });
    return ret;
}
function $f6c8c24690686b95$export$9466a5a0ee6f1479(styles) {
    var ret = "";
    if (!styles || $f6c8c24690686b95$export$844ec244b1367d54(styles)) return ret;
    for(var key in styles){
        var value = styles[key];
        var normalizedKey = key.startsWith("--") ? key : $f6c8c24690686b95$export$6e6a0a3676c4b8bb(key);
        if ($f6c8c24690686b95$export$844ec244b1367d54(value) || typeof value === "number") ret += "".concat(normalizedKey, ":").concat(value, ";");
    }
    return ret;
}
function $f6c8c24690686b95$export$4f7022d2d68e2c5a(value) {
    var res = "";
    if ($f6c8c24690686b95$export$844ec244b1367d54(value)) res = value;
    else if ($f6c8c24690686b95$export$43bee75e5e14138e(value)) for(var i = 0; i < value.length; i++){
        var normalized = $f6c8c24690686b95$export$4f7022d2d68e2c5a(value[i]);
        if (normalized) res += normalized + " ";
    }
    else if ($f6c8c24690686b95$export$a6cdc56e425d0d0a(value)) {
        for(var name in value)if (value[name]) res += name + " ";
    }
    return res.trim();
}
function $f6c8c24690686b95$export$601abcd8103db5e4(props) {
    if (!props) return null;
    var klass = props.class, style = props.style;
    if (klass && !$f6c8c24690686b95$export$844ec244b1367d54(klass)) props.class = $f6c8c24690686b95$export$4f7022d2d68e2c5a(klass);
    if (style) props.style = $f6c8c24690686b95$export$8756898546458274(style);
    return props;
}
var $f6c8c24690686b95$var$HTML_TAGS = "html,body,base,head,link,meta,style,title,address,article,aside,footer,header,hgroup,h1,h2,h3,h4,h5,h6,nav,section,div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,summary,template,blockquote,iframe,tfoot";
var $f6c8c24690686b95$var$SVG_TAGS = "svg,animate,animateMotion,animateTransform,circle,clipPath,color-profile,defs,desc,discard,ellipse,feBlend,feColorMatrix,feComponentTransfer,feComposite,feConvolveMatrix,feDiffuseLighting,feDisplacementMap,feDistantLight,feDropShadow,feFlood,feFuncA,feFuncB,feFuncG,feFuncR,feGaussianBlur,feImage,feMerge,feMergeNode,feMorphology,feOffset,fePointLight,feSpecularLighting,feSpotLight,feTile,feTurbulence,filter,foreignObject,g,hatch,hatchpath,image,line,linearGradient,marker,mask,mesh,meshgradient,meshpatch,meshrow,metadata,mpath,path,pattern,polygon,polyline,radialGradient,rect,set,solidcolor,stop,switch,symbol,text,textPath,title,tspan,unknown,use,view";
var $f6c8c24690686b95$var$MATH_TAGS = "annotation,annotation-xml,maction,maligngroup,malignmark,math,menclose,merror,mfenced,mfrac,mfraction,mglyph,mi,mlabeledtr,mlongdiv,mmultiscripts,mn,mo,mover,mpadded,mphantom,mprescripts,mroot,mrow,ms,mscarries,mscarry,msgroup,msline,mspace,msqrt,msrow,mstack,mstyle,msub,msubsup,msup,mtable,mtd,mtext,mtr,munder,munderover,none,semantics";
var $f6c8c24690686b95$var$VOID_TAGS = "area,base,br,col,embed,hr,img,input,link,meta,param,source,track,wbr";
var $f6c8c24690686b95$export$1ccf854a0984f890 = /* @__PURE__ */ $f6c8c24690686b95$export$b41394a5437791c8($f6c8c24690686b95$var$HTML_TAGS);
var $f6c8c24690686b95$export$6328ce7565ea1049 = /* @__PURE__ */ $f6c8c24690686b95$export$b41394a5437791c8($f6c8c24690686b95$var$SVG_TAGS);
var $f6c8c24690686b95$export$4a46ca4c5be17b20 = /* @__PURE__ */ $f6c8c24690686b95$export$b41394a5437791c8($f6c8c24690686b95$var$MATH_TAGS);
var $f6c8c24690686b95$export$e5f2d3d97d9367a4 = /* @__PURE__ */ $f6c8c24690686b95$export$b41394a5437791c8($f6c8c24690686b95$var$VOID_TAGS);
var $f6c8c24690686b95$var$specialBooleanAttrs = "itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly";
var $f6c8c24690686b95$export$d186f5eb2e810715 = /* @__PURE__ */ $f6c8c24690686b95$export$b41394a5437791c8($f6c8c24690686b95$var$specialBooleanAttrs);
var $f6c8c24690686b95$export$f763ba3b84e9cd8c = /* @__PURE__ */ $f6c8c24690686b95$export$b41394a5437791c8($f6c8c24690686b95$var$specialBooleanAttrs + ",async,autofocus,autoplay,controls,default,defer,disabled,hidden,inert,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected");
function $f6c8c24690686b95$export$e3f3cdb1390d56ce(value) {
    return !!value || value === "";
}
var $f6c8c24690686b95$var$unsafeAttrCharRE = /[>/="'\u0009\u000a\u000c\u0020]/;
var $f6c8c24690686b95$var$attrValidationCache = {};
function $f6c8c24690686b95$export$d55ef77660f30d12(name) {
    if ($f6c8c24690686b95$var$attrValidationCache.hasOwnProperty(name)) return $f6c8c24690686b95$var$attrValidationCache[name];
    var isUnsafe = $f6c8c24690686b95$var$unsafeAttrCharRE.test(name);
    if (isUnsafe) console.error("unsafe attribute name: ".concat(name));
    return $f6c8c24690686b95$var$attrValidationCache[name] = !isUnsafe;
}
var $f6c8c24690686b95$export$b66fd0cae8dec3c8 = {
    acceptCharset: "accept-charset",
    className: "class",
    htmlFor: "for",
    httpEquiv: "http-equiv"
};
var $f6c8c24690686b95$export$f7e7a1cc7da8d5e9 = /* @__PURE__ */ $f6c8c24690686b95$export$b41394a5437791c8("accept,accept-charset,accesskey,action,align,allow,alt,async,autocapitalize,autocomplete,autofocus,autoplay,background,bgcolor,border,buffered,capture,challenge,charset,checked,cite,class,code,codebase,color,cols,colspan,content,contenteditable,contextmenu,controls,coords,crossorigin,csp,data,datetime,decoding,default,defer,dir,dirname,disabled,download,draggable,dropzone,enctype,enterkeyhint,for,form,formaction,formenctype,formmethod,formnovalidate,formtarget,headers,height,hidden,high,href,hreflang,http-equiv,icon,id,importance,inert,integrity,ismap,itemprop,keytype,kind,label,lang,language,loading,list,loop,low,manifest,max,maxlength,minlength,media,min,multiple,muted,name,novalidate,open,optimum,pattern,ping,placeholder,poster,preload,radiogroup,readonly,referrerpolicy,rel,required,reversed,rows,rowspan,sandbox,scope,scoped,selected,shape,size,sizes,slot,span,spellcheck,src,srcdoc,srclang,srcset,start,step,style,summary,tabindex,target,title,translate,type,usemap,value,width,wrap");
var $f6c8c24690686b95$export$80da416f43933831 = /* @__PURE__ */ $f6c8c24690686b95$export$b41394a5437791c8("xmlns,accent-height,accumulate,additive,alignment-baseline,alphabetic,amplitude,arabic-form,ascent,attributeName,attributeType,azimuth,baseFrequency,baseline-shift,baseProfile,bbox,begin,bias,by,calcMode,cap-height,class,clip,clipPathUnits,clip-path,clip-rule,color,color-interpolation,color-interpolation-filters,color-profile,color-rendering,contentScriptType,contentStyleType,crossorigin,cursor,cx,cy,d,decelerate,descent,diffuseConstant,direction,display,divisor,dominant-baseline,dur,dx,dy,edgeMode,elevation,enable-background,end,exponent,fill,fill-opacity,fill-rule,filter,filterRes,filterUnits,flood-color,flood-opacity,font-family,font-size,font-size-adjust,font-stretch,font-style,font-variant,font-weight,format,from,fr,fx,fy,g1,g2,glyph-name,glyph-orientation-horizontal,glyph-orientation-vertical,glyphRef,gradientTransform,gradientUnits,hanging,height,href,hreflang,horiz-adv-x,horiz-origin-x,id,ideographic,image-rendering,in,in2,intercept,k,k1,k2,k3,k4,kernelMatrix,kernelUnitLength,kerning,keyPoints,keySplines,keyTimes,lang,lengthAdjust,letter-spacing,lighting-color,limitingConeAngle,local,marker-end,marker-mid,marker-start,markerHeight,markerUnits,markerWidth,mask,maskContentUnits,maskUnits,mathematical,max,media,method,min,mode,name,numOctaves,offset,opacity,operator,order,orient,orientation,origin,overflow,overline-position,overline-thickness,panose-1,paint-order,path,pathLength,patternContentUnits,patternTransform,patternUnits,ping,pointer-events,points,pointsAtX,pointsAtY,pointsAtZ,preserveAlpha,preserveAspectRatio,primitiveUnits,r,radius,referrerPolicy,refX,refY,rel,rendering-intent,repeatCount,repeatDur,requiredExtensions,requiredFeatures,restart,result,rotate,rx,ry,scale,seed,shape-rendering,slope,spacing,specularConstant,specularExponent,speed,spreadMethod,startOffset,stdDeviation,stemh,stemv,stitchTiles,stop-color,stop-opacity,strikethrough-position,strikethrough-thickness,string,stroke,stroke-dasharray,stroke-dashoffset,stroke-linecap,stroke-linejoin,stroke-miterlimit,stroke-opacity,stroke-width,style,surfaceScale,systemLanguage,tabindex,tableValues,target,targetX,targetY,text-anchor,text-decoration,text-rendering,textLength,to,transform,transform-origin,type,u1,u2,underline-position,underline-thickness,unicode,unicode-bidi,unicode-range,units-per-em,v-alphabetic,v-hanging,v-ideographic,v-mathematical,values,vector-effect,version,vert-adv-y,vert-origin-x,vert-origin-y,viewBox,viewTarget,visibility,width,widths,word-spacing,writing-mode,x,x-height,x1,x2,xChannelSelector,xlink:actuate,xlink:arcrole,xlink:href,xlink:role,xlink:show,xlink:title,xlink:type,xmlns:xlink,xml:base,xml:lang,xml:space,y,y1,y2,yChannelSelector,z,zoomAndPan");
function $f6c8c24690686b95$export$921dd2acf0d386a3(value) {
    if (value == null) return false;
    var type = typeof value === "undefined" ? "undefined" : (0, $jzTO1._)(value);
    return type === "string" || type === "number" || type === "boolean";
}
var $f6c8c24690686b95$var$escapeRE = /["'&<>]/;
function $f6c8c24690686b95$export$4cf11838cdc2a8a8(string) {
    var str = "" + string;
    var match = $f6c8c24690686b95$var$escapeRE.exec(str);
    if (!match) return str;
    var html = "";
    var escaped;
    var index;
    var lastIndex = 0;
    for(index = match.index; index < str.length; index++){
        switch(str.charCodeAt(index)){
            case 34:
                escaped = "&quot;";
                break;
            case 38:
                escaped = "&amp;";
                break;
            case 39:
                escaped = "&#39;";
                break;
            case 60:
                escaped = "&lt;";
                break;
            case 62:
                escaped = "&gt;";
                break;
            default:
                continue;
        }
        if (lastIndex !== index) html += str.slice(lastIndex, index);
        lastIndex = index + 1;
        html += escaped;
    }
    return lastIndex !== index ? html + str.slice(lastIndex, index) : html;
}
var $f6c8c24690686b95$var$commentStripRE = /^-?>|<!--|-->|--!>|<!-$/g;
function $f6c8c24690686b95$export$7b105034a53bde5f(src) {
    return src.replace($f6c8c24690686b95$var$commentStripRE, "");
}
function $f6c8c24690686b95$var$looseCompareArrays(a, b) {
    if (a.length !== b.length) return false;
    var equal = true;
    for(var i = 0; equal && i < a.length; i++)equal = $f6c8c24690686b95$export$ae8015769846262c(a[i], b[i]);
    return equal;
}
function $f6c8c24690686b95$export$ae8015769846262c(a, b) {
    if (a === b) return true;
    var aValidType = $f6c8c24690686b95$export$871608497c498473(a);
    var bValidType = $f6c8c24690686b95$export$871608497c498473(b);
    if (aValidType || bValidType) return aValidType && bValidType ? a.getTime() === b.getTime() : false;
    aValidType = $f6c8c24690686b95$export$a244864fd9645c7f(a);
    bValidType = $f6c8c24690686b95$export$a244864fd9645c7f(b);
    if (aValidType || bValidType) return a === b;
    aValidType = $f6c8c24690686b95$export$43bee75e5e14138e(a);
    bValidType = $f6c8c24690686b95$export$43bee75e5e14138e(b);
    if (aValidType || bValidType) return aValidType && bValidType ? $f6c8c24690686b95$var$looseCompareArrays(a, b) : false;
    aValidType = $f6c8c24690686b95$export$a6cdc56e425d0d0a(a);
    bValidType = $f6c8c24690686b95$export$a6cdc56e425d0d0a(b);
    if (aValidType || bValidType) {
        if (!aValidType || !bValidType) return false;
        var aKeysCount = Object.keys(a).length;
        var bKeysCount = Object.keys(b).length;
        if (aKeysCount !== bKeysCount) return false;
        for(var key in a){
            var aHasKey = a.hasOwnProperty(key);
            var bHasKey = b.hasOwnProperty(key);
            if (aHasKey && !bHasKey || !aHasKey && bHasKey || !$f6c8c24690686b95$export$ae8015769846262c(a[key], b[key])) return false;
        }
    }
    return String(a) === String(b);
}
function $f6c8c24690686b95$export$42912a80cedb8bd4(arr, val) {
    return arr.findIndex(function(item) {
        return $f6c8c24690686b95$export$ae8015769846262c(item, val);
    });
}
var $f6c8c24690686b95$export$b5b1545233b45293 = function(val) {
    return $f6c8c24690686b95$export$844ec244b1367d54(val) ? val : val == null ? "" : $f6c8c24690686b95$export$43bee75e5e14138e(val) || $f6c8c24690686b95$export$a6cdc56e425d0d0a(val) && (val.toString === $f6c8c24690686b95$export$830c053460e5ddf6 || !$f6c8c24690686b95$export$f6e2535fb5126e54(val.toString)) ? JSON.stringify(val, $f6c8c24690686b95$var$replacer, 2) : String(val);
};
var $f6c8c24690686b95$var$replacer = function(_key, val) {
    if (val && val.__v_isRef) return $f6c8c24690686b95$var$replacer(_key, val.value);
    else if ($f6c8c24690686b95$export$5c90113a285f2241(val)) return {
        ["Map(".concat(val.size, ")")]: (0, $79xu7._)(val.entries()).reduce(function(entries, param, i) {
            var _param = (0, $4f96i._)(param, 2), key = _param[0], val2 = _param[1];
            entries[$f6c8c24690686b95$var$stringifySymbol(key, i) + " =>"] = val2;
            return entries;
        }, {})
    };
    else if ($f6c8c24690686b95$export$6750766a7c7ec627(val)) return {
        ["Set(".concat(val.size, ")")]: (0, $79xu7._)(val.values()).map(function(v) {
            return $f6c8c24690686b95$var$stringifySymbol(v);
        })
    };
    else if ($f6c8c24690686b95$export$a244864fd9645c7f(val)) return $f6c8c24690686b95$var$stringifySymbol(val);
    else if ($f6c8c24690686b95$export$a6cdc56e425d0d0a(val) && !$f6c8c24690686b95$export$43bee75e5e14138e(val) && !$f6c8c24690686b95$export$53b83ca8eaab0383(val)) return String(val);
    return val;
};
var $f6c8c24690686b95$var$stringifySymbol = function(v) {
    var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    var _a;
    return(// Symbol.description in es2019+ so we need to cast here to pass
    // the lib: es2016 check
    $f6c8c24690686b95$export$a244864fd9645c7f(v) ? "Symbol(".concat((_a = v.description) != null ? _a : i, ")") : v);
};

});



parcelRegister("iMtOP", function(module, exports) {
$parcel$export(module.exports, "BaseTransition", function () { return (parcelRequire("aD8ZA")).BaseTransition; });
$parcel$export(module.exports, "BaseTransitionPropsValidators", function () { return (parcelRequire("aD8ZA")).BaseTransitionPropsValidators; });
$parcel$export(module.exports, "callWithAsyncErrorHandling", function () { return (parcelRequire("aD8ZA")).callWithAsyncErrorHandling; });
$parcel$export(module.exports, "camelize", function () { return (parcelRequire("lbCQA")).camelize; });
$parcel$export(module.exports, "computed", function () { return (parcelRequire("aD8ZA")).computed; });
$parcel$export(module.exports, "createHydrationRenderer", function () { return (parcelRequire("aD8ZA")).createHydrationRenderer; });
$parcel$export(module.exports, "createRenderer", function () { return (parcelRequire("aD8ZA")).createRenderer; });
$parcel$export(module.exports, "createVNode", function () { return (parcelRequire("aD8ZA")).createVNode; });
$parcel$export(module.exports, "defineComponent", function () { return (parcelRequire("aD8ZA")).defineComponent; });
$parcel$export(module.exports, "Fragment", function () { return (parcelRequire("aD8ZA")).Fragment; });
$parcel$export(module.exports, "getCurrentInstance", function () { return (parcelRequire("aD8ZA")).getCurrentInstance; });
$parcel$export(module.exports, "getTransitionRawChildren", function () { return (parcelRequire("aD8ZA")).getTransitionRawChildren; });
$parcel$export(module.exports, "h", function () { return (parcelRequire("aD8ZA")).h; });
$parcel$export(module.exports, "initCustomFormatter", function () { return (parcelRequire("aD8ZA")).initCustomFormatter; });
$parcel$export(module.exports, "inject", function () { return (parcelRequire("aD8ZA")).inject; });
$parcel$export(module.exports, "isRef", function () { return (parcelRequire("aAzpa")).isRef; });
$parcel$export(module.exports, "isRuntimeOnly", function () { return (parcelRequire("aD8ZA")).isRuntimeOnly; });
$parcel$export(module.exports, "KeepAlive", function () { return (parcelRequire("aD8ZA")).KeepAlive; });
$parcel$export(module.exports, "markRaw", function () { return (parcelRequire("aAzpa")).markRaw; });
$parcel$export(module.exports, "nextTick", function () { return (parcelRequire("aD8ZA")).nextTick; });
$parcel$export(module.exports, "onActivated", function () { return (parcelRequire("aD8ZA")).onActivated; });
$parcel$export(module.exports, "onBeforeMount", function () { return (parcelRequire("aD8ZA")).onBeforeMount; });
$parcel$export(module.exports, "onBeforeUnmount", function () { return (parcelRequire("aD8ZA")).onBeforeUnmount; });
$parcel$export(module.exports, "onBeforeUpdate", function () { return (parcelRequire("aD8ZA")).onBeforeUpdate; });
$parcel$export(module.exports, "onDeactivated", function () { return (parcelRequire("aD8ZA")).onDeactivated; });
$parcel$export(module.exports, "onMounted", function () { return (parcelRequire("aD8ZA")).onMounted; });
$parcel$export(module.exports, "onUnmounted", function () { return (parcelRequire("aD8ZA")).onUnmounted; });
$parcel$export(module.exports, "onUpdated", function () { return (parcelRequire("aD8ZA")).onUpdated; });
$parcel$export(module.exports, "provide", function () { return (parcelRequire("aD8ZA")).provide; });
$parcel$export(module.exports, "reactive", function () { return (parcelRequire("aAzpa")).reactive; });
$parcel$export(module.exports, "ref", function () { return (parcelRequire("aAzpa")).ref; });
$parcel$export(module.exports, "resolveTransitionHooks", function () { return (parcelRequire("aD8ZA")).resolveTransitionHooks; });
$parcel$export(module.exports, "setTransitionHooks", function () { return (parcelRequire("aD8ZA")).setTransitionHooks; });
$parcel$export(module.exports, "shallowReactive", function () { return (parcelRequire("aAzpa")).shallowReactive; });
$parcel$export(module.exports, "Static", function () { return (parcelRequire("aD8ZA")).Static; });
$parcel$export(module.exports, "Teleport", function () { return (parcelRequire("aD8ZA")).Teleport; });
$parcel$export(module.exports, "toRaw", function () { return (parcelRequire("aAzpa")).toRaw; });
$parcel$export(module.exports, "useTransitionState", function () { return (parcelRequire("aD8ZA")).useTransitionState; });
$parcel$export(module.exports, "warn", function () { return (parcelRequire("aD8ZA")).warn; });
$parcel$export(module.exports, "watch", function () { return (parcelRequire("aD8ZA")).watch; });
$parcel$export(module.exports, "watchPostEffect", function () { return (parcelRequire("aD8ZA")).watchPostEffect; });
$parcel$export(module.exports, "withDirectives", function () { return (parcelRequire("aD8ZA")).withDirectives; });

$parcel$export(module.exports, "Transition", function () { return $dac3d718c0e87681$export$be58926105124dd4; });
$parcel$export(module.exports, "vShow", function () { return $dac3d718c0e87681$export$5cb4fcdc6937d7e1; });
$parcel$export(module.exports, "TransitionGroup", function () { return $dac3d718c0e87681$export$19ffa8f511f7bc2e; });
$parcel$export(module.exports, "createApp", function () { return $dac3d718c0e87681$export$4e373c34abfa8c68; });
/**
* @vue/runtime-dom v3.4.25
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $luoZD = parcelRequire("luoZD");

var $fYUO3 = parcelRequire("fYUO3");

var $7DbRq = parcelRequire("7DbRq");

var $4f96i = parcelRequire("4f96i");

var $79xu7 = parcelRequire("79xu7");

var $jzTO1 = parcelRequire("jzTO1");

var $ju9pQ = parcelRequire("ju9pQ");

var $aD8ZA = parcelRequire("aD8ZA");
var $lbCQA = parcelRequire("lbCQA");
var $aAzpa = parcelRequire("aAzpa");
var $aAzpa = parcelRequire("aAzpa");

var $lbCQA = parcelRequire("lbCQA");
var $dac3d718c0e87681$var$svgNS = "http://www.w3.org/2000/svg";
var $dac3d718c0e87681$var$mathmlNS = "http://www.w3.org/1998/Math/MathML";
var $dac3d718c0e87681$var$doc = typeof document !== "undefined" ? document : null;
var $dac3d718c0e87681$var$templateContainer = $dac3d718c0e87681$var$doc && /* @__PURE__ */ $dac3d718c0e87681$var$doc.createElement("template");
var $dac3d718c0e87681$var$nodeOps = {
    insert: function(child, parent, anchor) {
        parent.insertBefore(child, anchor || null);
    },
    remove: function(child) {
        var parent = child.parentNode;
        if (parent) parent.removeChild(child);
    },
    createElement: function(tag, namespace, is, props) {
        var el = namespace === "svg" ? $dac3d718c0e87681$var$doc.createElementNS($dac3d718c0e87681$var$svgNS, tag) : namespace === "mathml" ? $dac3d718c0e87681$var$doc.createElementNS($dac3d718c0e87681$var$mathmlNS, tag) : $dac3d718c0e87681$var$doc.createElement(tag, is ? {
            is: is
        } : void 0);
        if (tag === "select" && props && props.multiple != null) el.setAttribute("multiple", props.multiple);
        return el;
    },
    createText: function(text) {
        return $dac3d718c0e87681$var$doc.createTextNode(text);
    },
    createComment: function(text) {
        return $dac3d718c0e87681$var$doc.createComment(text);
    },
    setText: function(node, text) {
        node.nodeValue = text;
    },
    setElementText: function(el, text) {
        el.textContent = text;
    },
    parentNode: function(node) {
        return node.parentNode;
    },
    nextSibling: function(node) {
        return node.nextSibling;
    },
    querySelector: function(selector) {
        return $dac3d718c0e87681$var$doc.querySelector(selector);
    },
    setScopeId: function(el, id) {
        el.setAttribute(id, "");
    },
    // __UNSAFE__
    // Reason: innerHTML.
    // Static content here can only come from compiled templates.
    // As long as the user only uses trusted templates, this is safe.
    insertStaticContent: function(content, parent, anchor, namespace, start, end) {
        var before = anchor ? anchor.previousSibling : parent.lastChild;
        if (start && (start === end || start.nextSibling)) while(true){
            parent.insertBefore(start.cloneNode(true), anchor);
            if (start === end || !(start = start.nextSibling)) break;
        }
        else {
            $dac3d718c0e87681$var$templateContainer.innerHTML = namespace === "svg" ? "<svg>".concat(content, "</svg>") : namespace === "mathml" ? "<math>".concat(content, "</math>") : content;
            var template = $dac3d718c0e87681$var$templateContainer.content;
            if (namespace === "svg" || namespace === "mathml") {
                var wrapper = template.firstChild;
                while(wrapper.firstChild)template.appendChild(wrapper.firstChild);
                template.removeChild(wrapper);
            }
            parent.insertBefore(template, anchor);
        }
        return [
            // first
            before ? before.nextSibling : parent.firstChild,
            // last
            anchor ? anchor.previousSibling : parent.lastChild
        ];
    }
};
var $dac3d718c0e87681$var$TRANSITION = "transition";
var $dac3d718c0e87681$var$ANIMATION = "animation";
var $dac3d718c0e87681$var$vtcKey = Symbol("_vtc");
var $dac3d718c0e87681$export$be58926105124dd4 = function(props, param) {
    var slots = param.slots;
    return (0, $aD8ZA.h)((0, $aD8ZA.BaseTransition), $dac3d718c0e87681$var$resolveTransitionProps(props), slots);
};
$dac3d718c0e87681$export$be58926105124dd4.displayName = "Transition";
var $dac3d718c0e87681$var$DOMTransitionPropsValidators = {
    name: String,
    type: String,
    css: {
        type: Boolean,
        default: true
    },
    duration: [
        String,
        Number,
        Object
    ],
    enterFromClass: String,
    enterActiveClass: String,
    enterToClass: String,
    appearFromClass: String,
    appearActiveClass: String,
    appearToClass: String,
    leaveFromClass: String,
    leaveActiveClass: String,
    leaveToClass: String
};
var $dac3d718c0e87681$var$TransitionPropsValidators = $dac3d718c0e87681$export$be58926105124dd4.props = /* @__PURE__ */ (0, $lbCQA.extend)({}, (0, $aD8ZA.BaseTransitionPropsValidators), $dac3d718c0e87681$var$DOMTransitionPropsValidators);
var $dac3d718c0e87681$var$callHook = function(hook) {
    var args = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    if ((0, $lbCQA.isArray)(hook)) hook.forEach(function(h2) {
        return h2.apply(void 0, (0, $79xu7._)(args));
    });
    else if (hook) hook.apply(void 0, (0, $79xu7._)(args));
};
var $dac3d718c0e87681$var$hasExplicitCallback = function(hook) {
    return hook ? (0, $lbCQA.isArray)(hook) ? hook.some(function(h2) {
        return h2.length > 1;
    }) : hook.length > 1 : false;
};
function $dac3d718c0e87681$var$resolveTransitionProps(rawProps) {
    var baseProps = {};
    for(var key in rawProps)if (!(key in $dac3d718c0e87681$var$DOMTransitionPropsValidators)) baseProps[key] = rawProps[key];
    if (rawProps.css === false) return baseProps;
    var _rawProps_name = rawProps.name, name = _rawProps_name === void 0 ? "v" : _rawProps_name, type = rawProps.type, duration = rawProps.duration, _rawProps_enterFromClass = rawProps.enterFromClass, enterFromClass = _rawProps_enterFromClass === void 0 ? "".concat(name, "-enter-from") : _rawProps_enterFromClass, _rawProps_enterActiveClass = rawProps.enterActiveClass, enterActiveClass = _rawProps_enterActiveClass === void 0 ? "".concat(name, "-enter-active") : _rawProps_enterActiveClass, _rawProps_enterToClass = rawProps.enterToClass, enterToClass = _rawProps_enterToClass === void 0 ? "".concat(name, "-enter-to") : _rawProps_enterToClass, _rawProps_appearFromClass = rawProps.appearFromClass, appearFromClass = _rawProps_appearFromClass === void 0 ? enterFromClass : _rawProps_appearFromClass, _rawProps_appearActiveClass = rawProps.appearActiveClass, appearActiveClass = _rawProps_appearActiveClass === void 0 ? enterActiveClass : _rawProps_appearActiveClass, _rawProps_appearToClass = rawProps.appearToClass, appearToClass = _rawProps_appearToClass === void 0 ? enterToClass : _rawProps_appearToClass, _rawProps_leaveFromClass = rawProps.leaveFromClass, leaveFromClass = _rawProps_leaveFromClass === void 0 ? "".concat(name, "-leave-from") : _rawProps_leaveFromClass, _rawProps_leaveActiveClass = rawProps.leaveActiveClass, leaveActiveClass = _rawProps_leaveActiveClass === void 0 ? "".concat(name, "-leave-active") : _rawProps_leaveActiveClass, _rawProps_leaveToClass = rawProps.leaveToClass, leaveToClass = _rawProps_leaveToClass === void 0 ? "".concat(name, "-leave-to") : _rawProps_leaveToClass;
    var durations = $dac3d718c0e87681$var$normalizeDuration(duration);
    var enterDuration = durations && durations[0];
    var leaveDuration = durations && durations[1];
    var onBeforeEnter = baseProps.onBeforeEnter, onEnter = baseProps.onEnter, onEnterCancelled = baseProps.onEnterCancelled, onLeave = baseProps.onLeave, onLeaveCancelled = baseProps.onLeaveCancelled, _baseProps_onBeforeAppear = baseProps.onBeforeAppear, onBeforeAppear = _baseProps_onBeforeAppear === void 0 ? onBeforeEnter : _baseProps_onBeforeAppear, _baseProps_onAppear = baseProps.onAppear, onAppear = _baseProps_onAppear === void 0 ? onEnter : _baseProps_onAppear, _baseProps_onAppearCancelled = baseProps.onAppearCancelled, onAppearCancelled = _baseProps_onAppearCancelled === void 0 ? onEnterCancelled : _baseProps_onAppearCancelled;
    var finishEnter = function(el, isAppear, done) {
        $dac3d718c0e87681$var$removeTransitionClass(el, isAppear ? appearToClass : enterToClass);
        $dac3d718c0e87681$var$removeTransitionClass(el, isAppear ? appearActiveClass : enterActiveClass);
        done && done();
    };
    var finishLeave = function(el, done) {
        el._isLeaving = false;
        $dac3d718c0e87681$var$removeTransitionClass(el, leaveFromClass);
        $dac3d718c0e87681$var$removeTransitionClass(el, leaveToClass);
        $dac3d718c0e87681$var$removeTransitionClass(el, leaveActiveClass);
        done && done();
    };
    var makeEnterHook = function(isAppear) {
        return function(el, done) {
            var hook = isAppear ? onAppear : onEnter;
            var resolve = function() {
                return finishEnter(el, isAppear, done);
            };
            $dac3d718c0e87681$var$callHook(hook, [
                el,
                resolve
            ]);
            $dac3d718c0e87681$var$nextFrame(function() {
                $dac3d718c0e87681$var$removeTransitionClass(el, isAppear ? appearFromClass : enterFromClass);
                $dac3d718c0e87681$var$addTransitionClass(el, isAppear ? appearToClass : enterToClass);
                if (!$dac3d718c0e87681$var$hasExplicitCallback(hook)) $dac3d718c0e87681$var$whenTransitionEnds(el, type, enterDuration, resolve);
            });
        };
    };
    return (0, $lbCQA.extend)(baseProps, {
        onBeforeEnter: function(el) {
            $dac3d718c0e87681$var$callHook(onBeforeEnter, [
                el
            ]);
            $dac3d718c0e87681$var$addTransitionClass(el, enterFromClass);
            $dac3d718c0e87681$var$addTransitionClass(el, enterActiveClass);
        },
        onBeforeAppear: function(el) {
            $dac3d718c0e87681$var$callHook(onBeforeAppear, [
                el
            ]);
            $dac3d718c0e87681$var$addTransitionClass(el, appearFromClass);
            $dac3d718c0e87681$var$addTransitionClass(el, appearActiveClass);
        },
        onEnter: makeEnterHook(false),
        onAppear: makeEnterHook(true),
        onLeave: function(el, done) {
            el._isLeaving = true;
            var resolve = function() {
                return finishLeave(el, done);
            };
            $dac3d718c0e87681$var$addTransitionClass(el, leaveFromClass);
            $dac3d718c0e87681$var$addTransitionClass(el, leaveActiveClass);
            $dac3d718c0e87681$var$forceReflow();
            $dac3d718c0e87681$var$nextFrame(function() {
                if (!el._isLeaving) return;
                $dac3d718c0e87681$var$removeTransitionClass(el, leaveFromClass);
                $dac3d718c0e87681$var$addTransitionClass(el, leaveToClass);
                if (!$dac3d718c0e87681$var$hasExplicitCallback(onLeave)) $dac3d718c0e87681$var$whenTransitionEnds(el, type, leaveDuration, resolve);
            });
            $dac3d718c0e87681$var$callHook(onLeave, [
                el,
                resolve
            ]);
        },
        onEnterCancelled: function(el) {
            finishEnter(el, false);
            $dac3d718c0e87681$var$callHook(onEnterCancelled, [
                el
            ]);
        },
        onAppearCancelled: function(el) {
            finishEnter(el, true);
            $dac3d718c0e87681$var$callHook(onAppearCancelled, [
                el
            ]);
        },
        onLeaveCancelled: function(el) {
            finishLeave(el);
            $dac3d718c0e87681$var$callHook(onLeaveCancelled, [
                el
            ]);
        }
    });
}
function $dac3d718c0e87681$var$normalizeDuration(duration) {
    if (duration == null) return null;
    else if ((0, $lbCQA.isObject)(duration)) return [
        $dac3d718c0e87681$var$NumberOf(duration.enter),
        $dac3d718c0e87681$var$NumberOf(duration.leave)
    ];
    else {
        var n = $dac3d718c0e87681$var$NumberOf(duration);
        return [
            n,
            n
        ];
    }
}
function $dac3d718c0e87681$var$NumberOf(val) {
    var res = (0, $lbCQA.toNumber)(val);
    return res;
}
function $dac3d718c0e87681$var$addTransitionClass(el, cls) {
    cls.split(/\s+/).forEach(function(c) {
        return c && el.classList.add(c);
    });
    (el[$dac3d718c0e87681$var$vtcKey] || (el[$dac3d718c0e87681$var$vtcKey] = /* @__PURE__ */ new Set())).add(cls);
}
function $dac3d718c0e87681$var$removeTransitionClass(el, cls) {
    cls.split(/\s+/).forEach(function(c) {
        return c && el.classList.remove(c);
    });
    var _vtc = el[$dac3d718c0e87681$var$vtcKey];
    if (_vtc) {
        _vtc.delete(cls);
        if (!_vtc.size) el[$dac3d718c0e87681$var$vtcKey] = void 0;
    }
}
function $dac3d718c0e87681$var$nextFrame(cb) {
    requestAnimationFrame(function() {
        requestAnimationFrame(cb);
    });
}
var $dac3d718c0e87681$var$endId = 0;
function $dac3d718c0e87681$var$whenTransitionEnds(el, expectedType, explicitTimeout, resolve) {
    var id = el._endId = ++$dac3d718c0e87681$var$endId;
    var resolveIfNotStale = function() {
        if (id === el._endId) resolve();
    };
    if (explicitTimeout) return setTimeout(resolveIfNotStale, explicitTimeout);
    var _getTransitionInfo = $dac3d718c0e87681$var$getTransitionInfo(el, expectedType), type = _getTransitionInfo.type, timeout = _getTransitionInfo.timeout, propCount = _getTransitionInfo.propCount;
    if (!type) return resolve();
    var endEvent = type + "end";
    var ended = 0;
    var end = function() {
        el.removeEventListener(endEvent, onEnd);
        resolveIfNotStale();
    };
    var onEnd = function(e) {
        if (e.target === el && ++ended >= propCount) end();
    };
    setTimeout(function() {
        if (ended < propCount) end();
    }, timeout + 1);
    el.addEventListener(endEvent, onEnd);
}
function $dac3d718c0e87681$var$getTransitionInfo(el, expectedType) {
    var styles = window.getComputedStyle(el);
    var getStyleProperties = function(key) {
        return (styles[key] || "").split(", ");
    };
    var transitionDelays = getStyleProperties("".concat($dac3d718c0e87681$var$TRANSITION, "Delay"));
    var transitionDurations = getStyleProperties("".concat($dac3d718c0e87681$var$TRANSITION, "Duration"));
    var transitionTimeout = $dac3d718c0e87681$var$getTimeout(transitionDelays, transitionDurations);
    var animationDelays = getStyleProperties("".concat($dac3d718c0e87681$var$ANIMATION, "Delay"));
    var animationDurations = getStyleProperties("".concat($dac3d718c0e87681$var$ANIMATION, "Duration"));
    var animationTimeout = $dac3d718c0e87681$var$getTimeout(animationDelays, animationDurations);
    var type = null;
    var timeout = 0;
    var propCount = 0;
    if (expectedType === $dac3d718c0e87681$var$TRANSITION) {
        if (transitionTimeout > 0) {
            type = $dac3d718c0e87681$var$TRANSITION;
            timeout = transitionTimeout;
            propCount = transitionDurations.length;
        }
    } else if (expectedType === $dac3d718c0e87681$var$ANIMATION) {
        if (animationTimeout > 0) {
            type = $dac3d718c0e87681$var$ANIMATION;
            timeout = animationTimeout;
            propCount = animationDurations.length;
        }
    } else {
        timeout = Math.max(transitionTimeout, animationTimeout);
        type = timeout > 0 ? transitionTimeout > animationTimeout ? $dac3d718c0e87681$var$TRANSITION : $dac3d718c0e87681$var$ANIMATION : null;
        propCount = type ? type === $dac3d718c0e87681$var$TRANSITION ? transitionDurations.length : animationDurations.length : 0;
    }
    var hasTransform = type === $dac3d718c0e87681$var$TRANSITION && /\b(transform|all)(,|$)/.test(getStyleProperties("".concat($dac3d718c0e87681$var$TRANSITION, "Property")).toString());
    return {
        type: type,
        timeout: timeout,
        propCount: propCount,
        hasTransform: hasTransform
    };
}
function $dac3d718c0e87681$var$getTimeout(delays, durations) {
    var _Math;
    while(delays.length < durations.length)delays = delays.concat(delays);
    return (_Math = Math).max.apply(_Math, (0, $79xu7._)(durations.map(function(d, i) {
        return $dac3d718c0e87681$var$toMs(d) + $dac3d718c0e87681$var$toMs(delays[i]);
    })));
}
function $dac3d718c0e87681$var$toMs(s) {
    if (s === "auto") return 0;
    return Number(s.slice(0, -1).replace(",", ".")) * 1e3;
}
function $dac3d718c0e87681$var$forceReflow() {
    return document.body.offsetHeight;
}
function $dac3d718c0e87681$var$patchClass(el, value, isSVG) {
    var transitionClasses = el[$dac3d718c0e87681$var$vtcKey];
    if (transitionClasses) value = (value ? [
        value
    ].concat((0, $79xu7._)(transitionClasses)) : (0, $79xu7._)(transitionClasses)).join(" ");
    if (value == null) el.removeAttribute("class");
    else if (isSVG) el.setAttribute("class", value);
    else el.className = value;
}
var $dac3d718c0e87681$var$vShowOriginalDisplay = Symbol("_vod");
var $dac3d718c0e87681$var$vShowHidden = Symbol("_vsh");
var $dac3d718c0e87681$export$5cb4fcdc6937d7e1 = {
    beforeMount: function(el, param, param1) {
        var value = param.value, transition = param1.transition;
        el[$dac3d718c0e87681$var$vShowOriginalDisplay] = el.style.display === "none" ? "" : el.style.display;
        if (transition && value) transition.beforeEnter(el);
        else $dac3d718c0e87681$var$setDisplay(el, value);
    },
    mounted: function(el, param, param1) {
        var value = param.value, transition = param1.transition;
        if (transition && value) transition.enter(el);
    },
    updated: function(el, param, param1) {
        var value = param.value, oldValue = param.oldValue, transition = param1.transition;
        if (!value === !oldValue) return;
        if (transition) {
            if (value) {
                transition.beforeEnter(el);
                $dac3d718c0e87681$var$setDisplay(el, true);
                transition.enter(el);
            } else transition.leave(el, function() {
                $dac3d718c0e87681$var$setDisplay(el, false);
            });
        } else $dac3d718c0e87681$var$setDisplay(el, value);
    },
    beforeUnmount: function(el, param) {
        var value = param.value;
        $dac3d718c0e87681$var$setDisplay(el, value);
    }
};
function $dac3d718c0e87681$var$setDisplay(el, value) {
    el.style.display = value ? el[$dac3d718c0e87681$var$vShowOriginalDisplay] : "none";
    el[$dac3d718c0e87681$var$vShowHidden] = !value;
}
function $dac3d718c0e87681$var$initVShowForSSR() {
    $dac3d718c0e87681$export$5cb4fcdc6937d7e1.getSSRProps = function(param) {
        var value = param.value;
        if (!value) return {
            style: {
                display: "none"
            }
        };
    };
}
var $dac3d718c0e87681$var$CSS_VAR_TEXT = Symbol("");
function $dac3d718c0e87681$export$ef28b76f07940108(getter) {
    var instance = (0, $aD8ZA.getCurrentInstance)();
    if (!instance) return;
    var updateTeleports = instance.ut = function() {
        var vars = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : getter(instance.proxy);
        Array.from(document.querySelectorAll('[data-v-owner="'.concat(instance.uid, '"]'))).forEach(function(node) {
            return $dac3d718c0e87681$var$setVarsOnNode(node, vars);
        });
    };
    var setVars = function() {
        var vars = getter(instance.proxy);
        $dac3d718c0e87681$var$setVarsOnVNode(instance.subTree, vars);
        updateTeleports(vars);
    };
    (0, $aD8ZA.onMounted)(function() {
        (0, $aD8ZA.watchPostEffect)(setVars);
        var ob = new MutationObserver(setVars);
        ob.observe(instance.subTree.el.parentNode, {
            childList: true
        });
        (0, $aD8ZA.onUnmounted)(function() {
            return ob.disconnect();
        });
    });
}
function $dac3d718c0e87681$var$setVarsOnVNode(vnode, vars) {
    if (vnode.shapeFlag & 128) {
        var suspense = vnode.suspense;
        vnode = suspense.activeBranch;
        if (suspense.pendingBranch && !suspense.isHydrating) suspense.effects.push(function() {
            $dac3d718c0e87681$var$setVarsOnVNode(suspense.activeBranch, vars);
        });
    }
    while(vnode.component)vnode = vnode.component.subTree;
    if (vnode.shapeFlag & 1 && vnode.el) $dac3d718c0e87681$var$setVarsOnNode(vnode.el, vars);
    else if (vnode.type === (0, $aD8ZA.Fragment)) vnode.children.forEach(function(c) {
        return $dac3d718c0e87681$var$setVarsOnVNode(c, vars);
    });
    else if (vnode.type === (0, $aD8ZA.Static)) {
        var el = vnode.el, anchor = vnode.anchor;
        while(el){
            $dac3d718c0e87681$var$setVarsOnNode(el, vars);
            if (el === anchor) break;
            el = el.nextSibling;
        }
    }
}
function $dac3d718c0e87681$var$setVarsOnNode(el, vars) {
    if (el.nodeType === 1) {
        var style = el.style;
        var cssText = "";
        for(var key in vars){
            style.setProperty("--".concat(key), vars[key]);
            cssText += "--".concat(key, ": ").concat(vars[key], ";");
        }
        style[$dac3d718c0e87681$var$CSS_VAR_TEXT] = cssText;
    }
}
var $dac3d718c0e87681$var$displayRE = /(^|;)\s*display\s*:/;
function $dac3d718c0e87681$var$patchStyle(el, prev, next) {
    var style = el.style;
    var isCssString = (0, $lbCQA.isString)(next);
    var hasControlledDisplay = false;
    if (next && !isCssString) {
        if (prev) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            if (!(0, $lbCQA.isString)(prev)) {
                for(var key in prev)if (next[key] == null) $dac3d718c0e87681$var$setStyle(style, key, "");
            } else try {
                for(var _iterator = prev.split(";")[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var prevStyle = _step.value;
                    var key1 = prevStyle.slice(0, prevStyle.indexOf(":")).trim();
                    if (next[key1] == null) $dac3d718c0e87681$var$setStyle(style, key1, "");
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
        for(var key2 in next){
            if (key2 === "display") hasControlledDisplay = true;
            $dac3d718c0e87681$var$setStyle(style, key2, next[key2]);
        }
    } else {
        if (isCssString) {
            if (prev !== next) {
                var cssVarText = style[$dac3d718c0e87681$var$CSS_VAR_TEXT];
                if (cssVarText) next += ";" + cssVarText;
                style.cssText = next;
                hasControlledDisplay = $dac3d718c0e87681$var$displayRE.test(next);
            }
        } else if (prev) el.removeAttribute("style");
    }
    if ($dac3d718c0e87681$var$vShowOriginalDisplay in el) {
        el[$dac3d718c0e87681$var$vShowOriginalDisplay] = hasControlledDisplay ? style.display : "";
        if (el[$dac3d718c0e87681$var$vShowHidden]) style.display = "none";
    }
}
var $dac3d718c0e87681$var$semicolonRE = /[^\\];\s*$/;
var $dac3d718c0e87681$var$importantRE = /\s*!important$/;
function $dac3d718c0e87681$var$setStyle(style, name, val) {
    if ((0, $lbCQA.isArray)(val)) val.forEach(function(v) {
        return $dac3d718c0e87681$var$setStyle(style, name, v);
    });
    else {
        if (val == null) val = "";
        if (name.startsWith("--")) style.setProperty(name, val);
        else {
            var prefixed = $dac3d718c0e87681$var$autoPrefix(style, name);
            if ($dac3d718c0e87681$var$importantRE.test(val)) style.setProperty((0, $lbCQA.hyphenate)(prefixed), val.replace($dac3d718c0e87681$var$importantRE, ""), "important");
            else style[prefixed] = val;
        }
    }
}
var $dac3d718c0e87681$var$prefixes = [
    "Webkit",
    "Moz",
    "ms"
];
var $dac3d718c0e87681$var$prefixCache = {};
function $dac3d718c0e87681$var$autoPrefix(style, rawName) {
    var cached = $dac3d718c0e87681$var$prefixCache[rawName];
    if (cached) return cached;
    var name = (0, $lbCQA.camelize)(rawName);
    if (name !== "filter" && name in style) return $dac3d718c0e87681$var$prefixCache[rawName] = name;
    name = (0, $lbCQA.capitalize)(name);
    for(var i = 0; i < $dac3d718c0e87681$var$prefixes.length; i++){
        var prefixed = $dac3d718c0e87681$var$prefixes[i] + name;
        if (prefixed in style) return $dac3d718c0e87681$var$prefixCache[rawName] = prefixed;
    }
    return rawName;
}
var $dac3d718c0e87681$var$xlinkNS = "http://www.w3.org/1999/xlink";
function $dac3d718c0e87681$var$patchAttr(el, key, value, isSVG, instance) {
    if (isSVG && key.startsWith("xlink:")) {
        if (value == null) el.removeAttributeNS($dac3d718c0e87681$var$xlinkNS, key.slice(6, key.length));
        else el.setAttributeNS($dac3d718c0e87681$var$xlinkNS, key, value);
    } else {
        var isBoolean = (0, $lbCQA.isSpecialBooleanAttr)(key);
        if (value == null || isBoolean && !(0, $lbCQA.includeBooleanAttr)(value)) el.removeAttribute(key);
        else el.setAttribute(key, isBoolean ? "" : value);
    }
}
function $dac3d718c0e87681$var$patchDOMProp(el, key, value, prevChildren, parentComponent, parentSuspense, unmountChildren) {
    if (key === "innerHTML" || key === "textContent") {
        if (prevChildren) unmountChildren(prevChildren, parentComponent, parentSuspense);
        el[key] = value == null ? "" : value;
        return;
    }
    var tag = el.tagName;
    if (key === "value" && tag !== "PROGRESS" && // custom elements may use _value internally
    !tag.includes("-")) {
        var oldValue = tag === "OPTION" ? el.getAttribute("value") || "" : el.value;
        var newValue = value == null ? "" : value;
        if (oldValue !== newValue || !("_value" in el)) el.value = newValue;
        if (value == null) el.removeAttribute(key);
        el._value = value;
        return;
    }
    var needRemove = false;
    if (value === "" || value == null) {
        var type = (0, $jzTO1._)(el[key]);
        if (type === "boolean") value = (0, $lbCQA.includeBooleanAttr)(value);
        else if (value == null && type === "string") {
            value = "";
            needRemove = true;
        } else if (type === "number") {
            value = 0;
            needRemove = true;
        }
    }
    try {
        el[key] = value;
    } catch (e) {}
    needRemove && el.removeAttribute(key);
}
function $dac3d718c0e87681$var$addEventListener(el, event, handler, options) {
    el.addEventListener(event, handler, options);
}
function $dac3d718c0e87681$var$removeEventListener(el, event, handler, options) {
    el.removeEventListener(event, handler, options);
}
var $dac3d718c0e87681$var$veiKey = Symbol("_vei");
function $dac3d718c0e87681$var$patchEvent(el, rawName, prevValue, nextValue) {
    var instance = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null;
    var invokers = el[$dac3d718c0e87681$var$veiKey] || (el[$dac3d718c0e87681$var$veiKey] = {});
    var existingInvoker = invokers[rawName];
    if (nextValue && existingInvoker) existingInvoker.value = nextValue;
    else {
        var _parseName = (0, $4f96i._)($dac3d718c0e87681$var$parseName(rawName), 2), name = _parseName[0], options = _parseName[1];
        if (nextValue) {
            var invoker = invokers[rawName] = $dac3d718c0e87681$var$createInvoker(nextValue, instance);
            $dac3d718c0e87681$var$addEventListener(el, name, invoker, options);
        } else if (existingInvoker) {
            $dac3d718c0e87681$var$removeEventListener(el, name, existingInvoker, options);
            invokers[rawName] = void 0;
        }
    }
}
var $dac3d718c0e87681$var$optionsModifierRE = /(?:Once|Passive|Capture)$/;
function $dac3d718c0e87681$var$parseName(name) {
    var options;
    if ($dac3d718c0e87681$var$optionsModifierRE.test(name)) {
        options = {};
        var m;
        while(m = name.match($dac3d718c0e87681$var$optionsModifierRE)){
            name = name.slice(0, name.length - m[0].length);
            options[m[0].toLowerCase()] = true;
        }
    }
    var event = name[2] === ":" ? name.slice(3) : (0, $lbCQA.hyphenate)(name.slice(2));
    return [
        event,
        options
    ];
}
var $dac3d718c0e87681$var$cachedNow = 0;
var $dac3d718c0e87681$var$p = /* @__PURE__ */ Promise.resolve();
var $dac3d718c0e87681$var$getNow = function() {
    return $dac3d718c0e87681$var$cachedNow || ($dac3d718c0e87681$var$p.then(function() {
        return $dac3d718c0e87681$var$cachedNow = 0;
    }), $dac3d718c0e87681$var$cachedNow = Date.now());
};
function $dac3d718c0e87681$var$createInvoker(initialValue, instance) {
    var invoker = function(e) {
        if (!e._vts) e._vts = Date.now();
        else if (e._vts <= invoker.attached) return;
        (0, $aD8ZA.callWithAsyncErrorHandling)($dac3d718c0e87681$var$patchStopImmediatePropagation(e, invoker.value), instance, 5, [
            e
        ]);
    };
    invoker.value = initialValue;
    invoker.attached = $dac3d718c0e87681$var$getNow();
    return invoker;
}
function $dac3d718c0e87681$var$sanitizeEventValue(value, propName) {
    if ((0, $lbCQA.isFunction)(value) || (0, $lbCQA.isArray)(value)) return value;
    (0, $aD8ZA.warn)("Wrong type passed as event handler to ".concat(propName, " - did you forget @ or : in front of your prop?\nExpected function or array of functions, received type ").concat(typeof value === "undefined" ? "undefined" : (0, $jzTO1._)(value), "."));
    return 0, $lbCQA.NOOP;
}
function $dac3d718c0e87681$var$patchStopImmediatePropagation(e, value) {
    if ((0, $lbCQA.isArray)(value)) {
        var originalStop = e.stopImmediatePropagation;
        e.stopImmediatePropagation = function() {
            originalStop.call(e);
            e._stopped = true;
        };
        return value.map(function(fn) {
            return function(e2) {
                return !e2._stopped && fn && fn(e2);
            };
        });
    } else return value;
}
var $dac3d718c0e87681$var$isNativeOn = function(key) {
    return key.charCodeAt(0) === 111 && key.charCodeAt(1) === 110 && // lowercase letter
    key.charCodeAt(2) > 96 && key.charCodeAt(2) < 123;
};
var $dac3d718c0e87681$var$patchProp = function(el, key, prevValue, nextValue, namespace, prevChildren, parentComponent, parentSuspense, unmountChildren) {
    var isSVG = namespace === "svg";
    if (key === "class") $dac3d718c0e87681$var$patchClass(el, nextValue, isSVG);
    else if (key === "style") $dac3d718c0e87681$var$patchStyle(el, prevValue, nextValue);
    else if ((0, $lbCQA.isOn)(key)) {
        if (!(0, $lbCQA.isModelListener)(key)) $dac3d718c0e87681$var$patchEvent(el, key, prevValue, nextValue, parentComponent);
    } else if (key[0] === "." ? (key = key.slice(1), true) : key[0] === "^" ? (key = key.slice(1), false) : $dac3d718c0e87681$var$shouldSetAsProp(el, key, nextValue, isSVG)) $dac3d718c0e87681$var$patchDOMProp(el, key, nextValue, prevChildren, parentComponent, parentSuspense, unmountChildren);
    else {
        if (key === "true-value") el._trueValue = nextValue;
        else if (key === "false-value") el._falseValue = nextValue;
        $dac3d718c0e87681$var$patchAttr(el, key, nextValue, isSVG);
    }
};
function $dac3d718c0e87681$var$shouldSetAsProp(el, key, value, isSVG) {
    if (isSVG) {
        if (key === "innerHTML" || key === "textContent") return true;
        if (key in el && $dac3d718c0e87681$var$isNativeOn(key) && (0, $lbCQA.isFunction)(value)) return true;
        return false;
    }
    if (key === "spellcheck" || key === "draggable" || key === "translate") return false;
    if (key === "form") return false;
    if (key === "list" && el.tagName === "INPUT") return false;
    if (key === "type" && el.tagName === "TEXTAREA") return false;
    if (key === "width" || key === "height") {
        var tag = el.tagName;
        if (tag === "IMG" || tag === "VIDEO" || tag === "CANVAS" || tag === "SOURCE") return false;
    }
    if ($dac3d718c0e87681$var$isNativeOn(key) && (0, $lbCQA.isString)(value)) return false;
    return key in el;
}
/*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function $dac3d718c0e87681$export$a00e2346eabbdbef(options, hydrate2) {
    var Comp = (0, $aD8ZA.defineComponent)(options);
    var VueCustomElement = /*#__PURE__*/ function(VueElement) {
        "use strict";
        (0, $7DbRq._)(VueCustomElement, VueElement);
        var _super = (0, $ju9pQ._)(VueCustomElement);
        function VueCustomElement(initialProps) {
            (0, $luoZD._)(this, VueCustomElement);
            return _super.call(this, Comp, initialProps, hydrate2);
        }
        return VueCustomElement;
    }($dac3d718c0e87681$export$b337c1a55163dbe3);
    VueCustomElement.def = Comp;
    return VueCustomElement;
}
/*! #__NO_SIDE_EFFECTS__ */ var $dac3d718c0e87681$export$6debb2e68f212638 = /* @__NO_SIDE_EFFECTS__ */ function(options) {
    return /* @__PURE__ */ $dac3d718c0e87681$export$a00e2346eabbdbef(options, $dac3d718c0e87681$export$fa8d919ba61d84db);
};
var $dac3d718c0e87681$var$BaseClass = typeof HTMLElement !== "undefined" ? HTMLElement : function _class() {
    "use strict";
    (0, $luoZD._)(this, _class);
};
var $dac3d718c0e87681$export$b337c1a55163dbe3 = /*#__PURE__*/ function(BaseClass) {
    "use strict";
    (0, $7DbRq._)(VueElement, BaseClass);
    var _super = (0, $ju9pQ._)(VueElement);
    function VueElement(_def) {
        var _props = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, hydrate2 = arguments.length > 2 ? arguments[2] : void 0;
        (0, $luoZD._)(this, VueElement);
        var _this;
        _this = _super.call(this);
        _this._def = _def;
        _this._props = _props;
        /**
     * @internal
     */ _this._instance = null;
        _this._connected = false;
        _this._resolved = false;
        _this._numberProps = null;
        _this._ob = null;
        if (_this.shadowRoot && hydrate2) hydrate2(_this._createVNode(), _this.shadowRoot);
        else {
            _this.attachShadow({
                mode: "open"
            });
            if (!_this._def.__asyncLoader) _this._resolveProps(_this._def);
        }
        return _this;
    }
    (0, $fYUO3._)(VueElement, [
        {
            key: "connectedCallback",
            value: function connectedCallback() {
                this._connected = true;
                if (!this._instance) {
                    if (this._resolved) this._update();
                    else this._resolveDef();
                }
            }
        },
        {
            key: "disconnectedCallback",
            value: function disconnectedCallback() {
                var _this = this;
                this._connected = false;
                if (this._ob) {
                    this._ob.disconnect();
                    this._ob = null;
                }
                (0, $aD8ZA.nextTick)(function() {
                    if (!_this._connected) {
                        $dac3d718c0e87681$export$b3890eb0ae9dca99(null, _this.shadowRoot);
                        _this._instance = null;
                    }
                });
            }
        },
        {
            /**
   * resolve inner component definition (handle possible async component)
   */ key: "_resolveDef",
            value: function _resolveDef() {
                var _this = this;
                var _this1 = this;
                this._resolved = true;
                for(var i = 0; i < this.attributes.length; i++)this._setAttr(this.attributes[i].name);
                this._ob = new MutationObserver(function(mutations) {
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = mutations[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var m = _step.value;
                            _this._setAttr(m.attributeName);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                });
                this._ob.observe(this, {
                    attributes: true
                });
                var resolve = function(def) {
                    var isAsync = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                    var props = def.props, styles = def.styles;
                    var numberProps;
                    if (props && !(0, $lbCQA.isArray)(props)) for(var key in props){
                        var opt = props[key];
                        if (opt === Number || opt && opt.type === Number) {
                            if (key in _this1._props) _this1._props[key] = (0, $lbCQA.toNumber)(_this1._props[key]);
                            (numberProps || (numberProps = /* @__PURE__ */ Object.create(null)))[(0, $lbCQA.camelize)(key)] = true;
                        }
                    }
                    _this1._numberProps = numberProps;
                    if (isAsync) _this1._resolveProps(def);
                    _this1._applyStyles(styles);
                    _this1._update();
                };
                var asyncDef = this._def.__asyncLoader;
                if (asyncDef) asyncDef().then(function(def) {
                    return resolve(def, true);
                });
                else resolve(this._def);
            }
        },
        {
            key: "_resolveProps",
            value: function _resolveProps(def) {
                var props = def.props;
                var declaredPropKeys = (0, $lbCQA.isArray)(props) ? props : Object.keys(props || {});
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Object.keys(this)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var key = _step.value;
                        if (key[0] !== "_" && declaredPropKeys.includes(key)) this._setProp(key, this[key], true, false);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    var _this = this, _loop = function() {
                        var key = _step1.value;
                        Object.defineProperty(_this, key, {
                            get: function() {
                                return this._getProp(key);
                            },
                            set: function(val) {
                                this._setProp(key, val);
                            }
                        });
                    };
                    for(var _iterator1 = declaredPropKeys.map((0, $lbCQA.camelize))[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true)_loop();
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
            }
        },
        {
            key: "_setAttr",
            value: function _setAttr(key) {
                var value = this.hasAttribute(key) ? this.getAttribute(key) : void 0;
                var camelKey = (0, $lbCQA.camelize)(key);
                if (this._numberProps && this._numberProps[camelKey]) value = (0, $lbCQA.toNumber)(value);
                this._setProp(camelKey, value, false);
            }
        },
        {
            /**
   * @internal
   */ key: "_getProp",
            value: function _getProp(key) {
                return this._props[key];
            }
        },
        {
            /**
   * @internal
   */ key: "_setProp",
            value: function _setProp(key, val) {
                var shouldReflect = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true, shouldUpdate = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : true;
                if (val !== this._props[key]) {
                    this._props[key] = val;
                    if (shouldUpdate && this._instance) this._update();
                    if (shouldReflect) {
                        if (val === true) this.setAttribute((0, $lbCQA.hyphenate)(key), "");
                        else if (typeof val === "string" || typeof val === "number") this.setAttribute((0, $lbCQA.hyphenate)(key), val + "");
                        else if (!val) this.removeAttribute((0, $lbCQA.hyphenate)(key));
                    }
                }
            }
        },
        {
            key: "_update",
            value: function _update() {
                $dac3d718c0e87681$export$b3890eb0ae9dca99(this._createVNode(), this.shadowRoot);
            }
        },
        {
            key: "_createVNode",
            value: function _createVNode() {
                var _this = this;
                var vnode = (0, $aD8ZA.createVNode)(this._def, (0, $lbCQA.extend)({}, this._props));
                if (!this._instance) vnode.ce = function(instance) {
                    _this._instance = instance;
                    instance.isCE = true;
                    var newStyles, s;
                    var dispatch = function(event, args) {
                        _this.dispatchEvent(new CustomEvent(event, {
                            detail: args
                        }));
                    };
                    instance.emit = function(event) {
                        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                            args[_key - 1] = arguments[_key];
                        }
                        dispatch(event, args);
                        if ((0, $lbCQA.hyphenate)(event) !== event) dispatch((0, $lbCQA.hyphenate)(event), args);
                    };
                    var parent = _this;
                    while(parent = parent && (parent.parentNode || parent.host))if (parent instanceof VueElement) {
                        instance.parent = parent._instance;
                        instance.provides = parent._instance.provides;
                        break;
                    }
                };
                return vnode;
            }
        },
        {
            key: "_applyStyles",
            value: function _applyStyles(styles) {
                var _this = this;
                if (styles) styles.forEach(function(css) {
                    var s = document.createElement("style");
                    s.textContent = css;
                    _this.shadowRoot.appendChild(s);
                });
            }
        }
    ]);
    return VueElement;
}($dac3d718c0e87681$var$BaseClass);
function $dac3d718c0e87681$export$9300d5b90d56e3d1() {
    var name = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "$style";
    {
        var instance = (0, $aD8ZA.getCurrentInstance)();
        if (!instance) return 0, $lbCQA.EMPTY_OBJ;
        var modules = instance.type.__cssModules;
        if (!modules) return 0, $lbCQA.EMPTY_OBJ;
        var mod = modules[name];
        if (!mod) return 0, $lbCQA.EMPTY_OBJ;
        return mod;
    }
}
var $dac3d718c0e87681$var$positionMap = /* @__PURE__ */ new WeakMap();
var $dac3d718c0e87681$var$newPositionMap = /* @__PURE__ */ new WeakMap();
var $dac3d718c0e87681$var$moveCbKey = Symbol("_moveCb");
var $dac3d718c0e87681$var$enterCbKey = Symbol("_enterCb");
var $dac3d718c0e87681$var$TransitionGroupImpl = {
    name: "TransitionGroup",
    props: /* @__PURE__ */ (0, $lbCQA.extend)({}, $dac3d718c0e87681$var$TransitionPropsValidators, {
        tag: String,
        moveClass: String
    }),
    setup: function(props, param) {
        var slots = param.slots;
        var instance = (0, $aD8ZA.getCurrentInstance)();
        var state = (0, $aD8ZA.useTransitionState)();
        var prevChildren;
        var children;
        (0, $aD8ZA.onUpdated)(function() {
            if (!prevChildren.length) return;
            var moveClass = props.moveClass || "".concat(props.name || "v", "-move");
            if (!$dac3d718c0e87681$var$hasCSSTransform(prevChildren[0].el, instance.vnode.el, moveClass)) return;
            prevChildren.forEach($dac3d718c0e87681$var$callPendingCbs);
            prevChildren.forEach($dac3d718c0e87681$var$recordPosition);
            var movedChildren = prevChildren.filter($dac3d718c0e87681$var$applyTranslation);
            $dac3d718c0e87681$var$forceReflow();
            movedChildren.forEach(function(c) {
                var el = c.el;
                var style = el.style;
                $dac3d718c0e87681$var$addTransitionClass(el, moveClass);
                style.transform = style.webkitTransform = style.transitionDuration = "";
                var cb = el[$dac3d718c0e87681$var$moveCbKey] = function(e) {
                    if (e && e.target !== el) return;
                    if (!e || /transform$/.test(e.propertyName)) {
                        el.removeEventListener("transitionend", cb);
                        el[$dac3d718c0e87681$var$moveCbKey] = null;
                        $dac3d718c0e87681$var$removeTransitionClass(el, moveClass);
                    }
                };
                el.addEventListener("transitionend", cb);
            });
        });
        return function() {
            var rawProps = (0, $aAzpa.toRaw)(props);
            var cssTransitionProps = $dac3d718c0e87681$var$resolveTransitionProps(rawProps);
            var tag = rawProps.tag || (0, $aD8ZA.Fragment);
            prevChildren = [];
            if (children) for(var i = 0; i < children.length; i++){
                var child = children[i];
                if (child.el && child.el instanceof Element) {
                    prevChildren.push(child);
                    (0, $aD8ZA.setTransitionHooks)(child, (0, $aD8ZA.resolveTransitionHooks)(child, cssTransitionProps, state, instance));
                    $dac3d718c0e87681$var$positionMap.set(child, child.el.getBoundingClientRect());
                }
            }
            children = slots.default ? (0, $aD8ZA.getTransitionRawChildren)(slots.default()) : [];
            for(var i1 = 0; i1 < children.length; i1++){
                var child1 = children[i1];
                if (child1.key != null) (0, $aD8ZA.setTransitionHooks)(child1, (0, $aD8ZA.resolveTransitionHooks)(child1, cssTransitionProps, state, instance));
            }
            return (0, $aD8ZA.createVNode)(tag, null, children);
        };
    }
};
var $dac3d718c0e87681$var$removeMode = function(props) {
    return delete props.mode;
};
/* @__PURE__ */ $dac3d718c0e87681$var$removeMode($dac3d718c0e87681$var$TransitionGroupImpl.props);
var $dac3d718c0e87681$export$19ffa8f511f7bc2e = $dac3d718c0e87681$var$TransitionGroupImpl;
function $dac3d718c0e87681$var$callPendingCbs(c) {
    var el = c.el;
    if (el[$dac3d718c0e87681$var$moveCbKey]) el[$dac3d718c0e87681$var$moveCbKey]();
    if (el[$dac3d718c0e87681$var$enterCbKey]) el[$dac3d718c0e87681$var$enterCbKey]();
}
function $dac3d718c0e87681$var$recordPosition(c) {
    $dac3d718c0e87681$var$newPositionMap.set(c, c.el.getBoundingClientRect());
}
function $dac3d718c0e87681$var$applyTranslation(c) {
    var oldPos = $dac3d718c0e87681$var$positionMap.get(c);
    var newPos = $dac3d718c0e87681$var$newPositionMap.get(c);
    var dx = oldPos.left - newPos.left;
    var dy = oldPos.top - newPos.top;
    if (dx || dy) {
        var s = c.el.style;
        s.transform = s.webkitTransform = "translate(".concat(dx, "px,").concat(dy, "px)");
        s.transitionDuration = "0s";
        return c;
    }
}
function $dac3d718c0e87681$var$hasCSSTransform(el, root, moveClass) {
    var clone = el.cloneNode();
    var _vtc = el[$dac3d718c0e87681$var$vtcKey];
    if (_vtc) _vtc.forEach(function(cls) {
        cls.split(/\s+/).forEach(function(c) {
            return c && clone.classList.remove(c);
        });
    });
    moveClass.split(/\s+/).forEach(function(c) {
        return c && clone.classList.add(c);
    });
    clone.style.display = "none";
    var container = root.nodeType === 1 ? root : root.parentNode;
    container.appendChild(clone);
    var hasTransform = $dac3d718c0e87681$var$getTransitionInfo(clone).hasTransform;
    container.removeChild(clone);
    return hasTransform;
}
var $dac3d718c0e87681$var$getModelAssigner = function(vnode) {
    var fn = vnode.props["onUpdate:modelValue"] || false;
    return (0, $lbCQA.isArray)(fn) ? function(value) {
        return (0, $lbCQA.invokeArrayFns)(fn, value);
    } : fn;
};
function $dac3d718c0e87681$var$onCompositionStart(e) {
    e.target.composing = true;
}
function $dac3d718c0e87681$var$onCompositionEnd(e) {
    var target = e.target;
    if (target.composing) {
        target.composing = false;
        target.dispatchEvent(new Event("input"));
    }
}
var $dac3d718c0e87681$var$assignKey = Symbol("_assign");
var $dac3d718c0e87681$export$f1f88689f5728478 = {
    created: function(el, param, vnode) {
        var _param_modifiers = param.modifiers, lazy = _param_modifiers.lazy, trim = _param_modifiers.trim, number = _param_modifiers.number;
        el[$dac3d718c0e87681$var$assignKey] = $dac3d718c0e87681$var$getModelAssigner(vnode);
        var castToNumber = number || vnode.props && vnode.props.type === "number";
        $dac3d718c0e87681$var$addEventListener(el, lazy ? "change" : "input", function(e) {
            if (e.target.composing) return;
            var domValue = el.value;
            if (trim) domValue = domValue.trim();
            if (castToNumber) domValue = (0, $lbCQA.looseToNumber)(domValue);
            el[$dac3d718c0e87681$var$assignKey](domValue);
        });
        if (trim) $dac3d718c0e87681$var$addEventListener(el, "change", function() {
            el.value = el.value.trim();
        });
        if (!lazy) {
            $dac3d718c0e87681$var$addEventListener(el, "compositionstart", $dac3d718c0e87681$var$onCompositionStart);
            $dac3d718c0e87681$var$addEventListener(el, "compositionend", $dac3d718c0e87681$var$onCompositionEnd);
            $dac3d718c0e87681$var$addEventListener(el, "change", $dac3d718c0e87681$var$onCompositionEnd);
        }
    },
    // set value on mounted so it's after min/max for type="range"
    mounted: function(el, param) {
        var value = param.value;
        el.value = value == null ? "" : value;
    },
    beforeUpdate: function(el, param, vnode) {
        var value = param.value, _param_modifiers = param.modifiers, lazy = _param_modifiers.lazy, trim = _param_modifiers.trim, number = _param_modifiers.number;
        el[$dac3d718c0e87681$var$assignKey] = $dac3d718c0e87681$var$getModelAssigner(vnode);
        if (el.composing) return;
        var elValue = (number || el.type === "number") && !/^0\d/.test(el.value) ? (0, $lbCQA.looseToNumber)(el.value) : el.value;
        var newValue = value == null ? "" : value;
        if (elValue === newValue) return;
        if (document.activeElement === el && el.type !== "range") {
            if (lazy) return;
            if (trim && el.value.trim() === newValue) return;
        }
        el.value = newValue;
    }
};
var $dac3d718c0e87681$export$8847c2e532b35714 = {
    // #4096 array checkboxes need to be deep traversed
    deep: true,
    created: function(el, _, vnode) {
        el[$dac3d718c0e87681$var$assignKey] = $dac3d718c0e87681$var$getModelAssigner(vnode);
        $dac3d718c0e87681$var$addEventListener(el, "change", function() {
            var modelValue = el._modelValue;
            var elementValue = $dac3d718c0e87681$var$getValue(el);
            var checked = el.checked;
            var assign = el[$dac3d718c0e87681$var$assignKey];
            if ((0, $lbCQA.isArray)(modelValue)) {
                var index = (0, $lbCQA.looseIndexOf)(modelValue, elementValue);
                var found = index !== -1;
                if (checked && !found) assign(modelValue.concat(elementValue));
                else if (!checked && found) {
                    var filtered = (0, $79xu7._)(modelValue);
                    filtered.splice(index, 1);
                    assign(filtered);
                }
            } else if ((0, $lbCQA.isSet)(modelValue)) {
                var cloned = new Set(modelValue);
                if (checked) cloned.add(elementValue);
                else cloned.delete(elementValue);
                assign(cloned);
            } else assign($dac3d718c0e87681$var$getCheckboxValue(el, checked));
        });
    },
    // set initial checked on mount to wait for true-value/false-value
    mounted: $dac3d718c0e87681$var$setChecked,
    beforeUpdate: function(el, binding, vnode) {
        el[$dac3d718c0e87681$var$assignKey] = $dac3d718c0e87681$var$getModelAssigner(vnode);
        $dac3d718c0e87681$var$setChecked(el, binding, vnode);
    }
};
function $dac3d718c0e87681$var$setChecked(el, param, vnode) {
    var value = param.value, oldValue = param.oldValue;
    el._modelValue = value;
    if ((0, $lbCQA.isArray)(value)) el.checked = (0, $lbCQA.looseIndexOf)(value, vnode.props.value) > -1;
    else if ((0, $lbCQA.isSet)(value)) el.checked = value.has(vnode.props.value);
    else if (value !== oldValue) el.checked = (0, $lbCQA.looseEqual)(value, $dac3d718c0e87681$var$getCheckboxValue(el, true));
}
var $dac3d718c0e87681$export$b4356c59b38b7aa9 = {
    created: function(el, param, vnode) {
        var value = param.value;
        el.checked = (0, $lbCQA.looseEqual)(value, vnode.props.value);
        el[$dac3d718c0e87681$var$assignKey] = $dac3d718c0e87681$var$getModelAssigner(vnode);
        $dac3d718c0e87681$var$addEventListener(el, "change", function() {
            el[$dac3d718c0e87681$var$assignKey]($dac3d718c0e87681$var$getValue(el));
        });
    },
    beforeUpdate: function(el, param, vnode) {
        var value = param.value, oldValue = param.oldValue;
        el[$dac3d718c0e87681$var$assignKey] = $dac3d718c0e87681$var$getModelAssigner(vnode);
        if (value !== oldValue) el.checked = (0, $lbCQA.looseEqual)(value, vnode.props.value);
    }
};
var $dac3d718c0e87681$export$87d227567b51ca39 = {
    // <select multiple> value need to be deep traversed
    deep: true,
    created: function(el, param, vnode) {
        var value = param.value, number = param.modifiers.number;
        var isSetModel = (0, $lbCQA.isSet)(value);
        $dac3d718c0e87681$var$addEventListener(el, "change", function() {
            var selectedVal = Array.prototype.filter.call(el.options, function(o) {
                return o.selected;
            }).map(function(o) {
                return number ? (0, $lbCQA.looseToNumber)($dac3d718c0e87681$var$getValue(o)) : $dac3d718c0e87681$var$getValue(o);
            });
            el[$dac3d718c0e87681$var$assignKey](el.multiple ? isSetModel ? new Set(selectedVal) : selectedVal : selectedVal[0]);
            el._assigning = true;
            (0, $aD8ZA.nextTick)(function() {
                el._assigning = false;
            });
        });
        el[$dac3d718c0e87681$var$assignKey] = $dac3d718c0e87681$var$getModelAssigner(vnode);
    },
    // set value in mounted & updated because <select> relies on its children
    // <option>s.
    mounted: function(el, param) {
        var value = param.value, number = param.modifiers.number;
        $dac3d718c0e87681$var$setSelected(el, value);
    },
    beforeUpdate: function(el, _binding, vnode) {
        el[$dac3d718c0e87681$var$assignKey] = $dac3d718c0e87681$var$getModelAssigner(vnode);
    },
    updated: function(el, param) {
        var value = param.value, number = param.modifiers.number;
        if (!el._assigning) $dac3d718c0e87681$var$setSelected(el, value);
    }
};
function $dac3d718c0e87681$var$setSelected(el, value, number) {
    var _loop = function(i, l) {
        var option = el.options[i];
        var optionValue = $dac3d718c0e87681$var$getValue(option);
        if (isMultiple) {
            if (isArrayValue) {
                var optionType = typeof optionValue === "undefined" ? "undefined" : (0, $jzTO1._)(optionValue);
                if (optionType === "string" || optionType === "number") option.selected = value.some(function(v) {
                    return String(v) === String(optionValue);
                });
                else option.selected = (0, $lbCQA.looseIndexOf)(value, optionValue) > -1;
            } else option.selected = value.has(optionValue);
        } else if ((0, $lbCQA.looseEqual)($dac3d718c0e87681$var$getValue(option), value)) {
            if (el.selectedIndex !== i) el.selectedIndex = i;
            return {
                v: void void 0
            };
        }
    };
    var isMultiple = el.multiple;
    var isArrayValue = (0, $lbCQA.isArray)(value);
    if (isMultiple && !isArrayValue && !(0, $lbCQA.isSet)(value)) return;
    for(var i = 0, l = el.options.length; i < l; i++){
        var _ret = _loop(i, l);
        if ((0, $jzTO1._)(_ret) === "object") return _ret.v;
    }
    if (!isMultiple && el.selectedIndex !== -1) el.selectedIndex = -1;
}
function $dac3d718c0e87681$var$getValue(el) {
    return "_value" in el ? el._value : el.value;
}
function $dac3d718c0e87681$var$getCheckboxValue(el, checked) {
    var key = checked ? "_trueValue" : "_falseValue";
    return key in el ? el[key] : checked;
}
var $dac3d718c0e87681$export$5ad5c0e01ff62c5 = {
    created: function(el, binding, vnode) {
        $dac3d718c0e87681$var$callModelHook(el, binding, vnode, null, "created");
    },
    mounted: function(el, binding, vnode) {
        $dac3d718c0e87681$var$callModelHook(el, binding, vnode, null, "mounted");
    },
    beforeUpdate: function(el, binding, vnode, prevVNode) {
        $dac3d718c0e87681$var$callModelHook(el, binding, vnode, prevVNode, "beforeUpdate");
    },
    updated: function(el, binding, vnode, prevVNode) {
        $dac3d718c0e87681$var$callModelHook(el, binding, vnode, prevVNode, "updated");
    }
};
function $dac3d718c0e87681$var$resolveDynamicModel(tagName, type) {
    switch(tagName){
        case "SELECT":
            return $dac3d718c0e87681$export$87d227567b51ca39;
        case "TEXTAREA":
            return $dac3d718c0e87681$export$f1f88689f5728478;
        default:
            switch(type){
                case "checkbox":
                    return $dac3d718c0e87681$export$8847c2e532b35714;
                case "radio":
                    return $dac3d718c0e87681$export$b4356c59b38b7aa9;
                default:
                    return $dac3d718c0e87681$export$f1f88689f5728478;
            }
    }
}
function $dac3d718c0e87681$var$callModelHook(el, binding, vnode, prevVNode, hook) {
    var modelToUse = $dac3d718c0e87681$var$resolveDynamicModel(el.tagName, vnode.props && vnode.props.type);
    var fn = modelToUse[hook];
    fn && fn(el, binding, vnode, prevVNode);
}
function $dac3d718c0e87681$var$initVModelForSSR() {
    $dac3d718c0e87681$export$f1f88689f5728478.getSSRProps = function(param) {
        var value = param.value;
        return {
            value: value
        };
    };
    $dac3d718c0e87681$export$b4356c59b38b7aa9.getSSRProps = function(param, vnode) {
        var value = param.value;
        if (vnode.props && (0, $lbCQA.looseEqual)(vnode.props.value, value)) return {
            checked: true
        };
    };
    $dac3d718c0e87681$export$8847c2e532b35714.getSSRProps = function(param, vnode) {
        var value = param.value;
        if ((0, $lbCQA.isArray)(value)) {
            if (vnode.props && (0, $lbCQA.looseIndexOf)(value, vnode.props.value) > -1) return {
                checked: true
            };
        } else if ((0, $lbCQA.isSet)(value)) {
            if (vnode.props && value.has(vnode.props.value)) return {
                checked: true
            };
        } else if (value) return {
            checked: true
        };
    };
    $dac3d718c0e87681$export$5ad5c0e01ff62c5.getSSRProps = function(binding, vnode) {
        if (typeof vnode.type !== "string") return;
        var modelToUse = $dac3d718c0e87681$var$resolveDynamicModel(// resolveDynamicModel expects an uppercase tag name, but vnode.type is lowercase
        vnode.type.toUpperCase(), vnode.props && vnode.props.type);
        if (modelToUse.getSSRProps) return modelToUse.getSSRProps(binding, vnode);
    };
}
var $dac3d718c0e87681$var$systemModifiers = [
    "ctrl",
    "shift",
    "alt",
    "meta"
];
var $dac3d718c0e87681$var$modifierGuards = {
    stop: function(e) {
        return e.stopPropagation();
    },
    prevent: function(e) {
        return e.preventDefault();
    },
    self: function(e) {
        return e.target !== e.currentTarget;
    },
    ctrl: function(e) {
        return !e.ctrlKey;
    },
    shift: function(e) {
        return !e.shiftKey;
    },
    alt: function(e) {
        return !e.altKey;
    },
    meta: function(e) {
        return !e.metaKey;
    },
    left: function(e) {
        return "button" in e && e.button !== 0;
    },
    middle: function(e) {
        return "button" in e && e.button !== 1;
    },
    right: function(e) {
        return "button" in e && e.button !== 2;
    },
    exact: function(e, modifiers) {
        return $dac3d718c0e87681$var$systemModifiers.some(function(m) {
            return e["".concat(m, "Key")] && !modifiers.includes(m);
        });
    }
};
var $dac3d718c0e87681$export$26bd3b8e29e6f273 = function(fn, modifiers) {
    var cache = fn._withMods || (fn._withMods = {});
    var cacheKey = modifiers.join(".");
    return cache[cacheKey] || (cache[cacheKey] = function(event) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            args[_key - 1] = arguments[_key];
        }
        for(var i = 0; i < modifiers.length; i++){
            var guard = $dac3d718c0e87681$var$modifierGuards[modifiers[i]];
            if (guard && guard(event, modifiers)) return;
        }
        return fn.apply(void 0, [
            event
        ].concat((0, $79xu7._)(args)));
    });
};
var $dac3d718c0e87681$var$keyNames = {
    esc: "escape",
    space: " ",
    up: "arrow-up",
    left: "arrow-left",
    right: "arrow-right",
    down: "arrow-down",
    delete: "backspace"
};
var $dac3d718c0e87681$export$f691a8759658f782 = function(fn, modifiers) {
    var cache = fn._withKeys || (fn._withKeys = {});
    var cacheKey = modifiers.join(".");
    return cache[cacheKey] || (cache[cacheKey] = function(event) {
        if (!("key" in event)) return;
        var eventKey = (0, $lbCQA.hyphenate)(event.key);
        if (modifiers.some(function(k) {
            return k === eventKey || $dac3d718c0e87681$var$keyNames[k] === eventKey;
        })) return fn(event);
    });
};
var $dac3d718c0e87681$var$rendererOptions = /* @__PURE__ */ (0, $lbCQA.extend)({
    patchProp: $dac3d718c0e87681$var$patchProp
}, $dac3d718c0e87681$var$nodeOps);
var $dac3d718c0e87681$var$renderer;
var $dac3d718c0e87681$var$enabledHydration = false;
function $dac3d718c0e87681$var$ensureRenderer() {
    return $dac3d718c0e87681$var$renderer || ($dac3d718c0e87681$var$renderer = (0, $aD8ZA.createRenderer)($dac3d718c0e87681$var$rendererOptions));
}
function $dac3d718c0e87681$var$ensureHydrationRenderer() {
    $dac3d718c0e87681$var$renderer = $dac3d718c0e87681$var$enabledHydration ? $dac3d718c0e87681$var$renderer : (0, $aD8ZA.createHydrationRenderer)($dac3d718c0e87681$var$rendererOptions);
    $dac3d718c0e87681$var$enabledHydration = true;
    return $dac3d718c0e87681$var$renderer;
}
var $dac3d718c0e87681$export$b3890eb0ae9dca99 = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var _ensureRenderer;
    (_ensureRenderer = $dac3d718c0e87681$var$ensureRenderer()).render.apply(_ensureRenderer, (0, $79xu7._)(args));
};
var $dac3d718c0e87681$export$fa8d919ba61d84db = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var _ensureHydrationRenderer;
    (_ensureHydrationRenderer = $dac3d718c0e87681$var$ensureHydrationRenderer()).hydrate.apply(_ensureHydrationRenderer, (0, $79xu7._)(args));
};
var $dac3d718c0e87681$export$4e373c34abfa8c68 = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var _ensureRenderer;
    var app = (_ensureRenderer = $dac3d718c0e87681$var$ensureRenderer()).createApp.apply(_ensureRenderer, (0, $79xu7._)(args));
    var mount = app.mount;
    app.mount = function(containerOrSelector) {
        var container = $dac3d718c0e87681$var$normalizeContainer(containerOrSelector);
        if (!container) return;
        var component = app._component;
        if (!(0, $lbCQA.isFunction)(component) && !component.render && !component.template) component.template = container.innerHTML;
        container.innerHTML = "";
        var proxy = mount(container, false, $dac3d718c0e87681$var$resolveRootNamespace(container));
        if (container instanceof Element) {
            container.removeAttribute("v-cloak");
            container.setAttribute("data-v-app", "");
        }
        return proxy;
    };
    return app;
};
var $dac3d718c0e87681$export$35800275c0037383 = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var _ensureHydrationRenderer;
    var app = (_ensureHydrationRenderer = $dac3d718c0e87681$var$ensureHydrationRenderer()).createApp.apply(_ensureHydrationRenderer, (0, $79xu7._)(args));
    var mount = app.mount;
    app.mount = function(containerOrSelector) {
        var container = $dac3d718c0e87681$var$normalizeContainer(containerOrSelector);
        if (container) return mount(container, true, $dac3d718c0e87681$var$resolveRootNamespace(container));
    };
    return app;
};
function $dac3d718c0e87681$var$resolveRootNamespace(container) {
    if (container instanceof SVGElement) return "svg";
    if (typeof MathMLElement === "function" && container instanceof MathMLElement) return "mathml";
}
function $dac3d718c0e87681$var$injectNativeTagCheck(app) {
    Object.defineProperty(app.config, "isNativeTag", {
        value: function(tag) {
            return (0, $lbCQA.isHTMLTag)(tag) || (0, $lbCQA.isSVGTag)(tag) || (0, $lbCQA.isMathMLTag)(tag);
        },
        writable: false
    });
}
function $dac3d718c0e87681$var$injectCompilerOptionsCheck(app) {
    if ((0, $aD8ZA.isRuntimeOnly)()) {
        var isCustomElement = app.config.isCustomElement;
        Object.defineProperty(app.config, "isCustomElement", {
            get: function() {
                return isCustomElement;
            },
            set: function() {
                (0, $aD8ZA.warn)("The `isCustomElement` config option is deprecated. Use `compilerOptions.isCustomElement` instead.");
            }
        });
        var compilerOptions = app.config.compilerOptions;
        var msg = 'The `compilerOptions` config option is only respected when using a build of Vue.js that includes the runtime compiler (aka "full build"). Since you are using the runtime-only build, `compilerOptions` must be passed to `@vue/compiler-dom` in the build setup instead.\n- For vue-loader: pass it via vue-loader\'s `compilerOptions` loader option.\n- For vue-cli: see https://cli.vuejs.org/guide/webpack.html#modifying-options-of-a-loader\n- For vite: pass it via @vitejs/plugin-vue options. See https://github.com/vitejs/vite-plugin-vue/tree/main/packages/plugin-vue#example-for-passing-options-to-vuecompiler-sfc';
        Object.defineProperty(app.config, "compilerOptions", {
            get: function() {
                (0, $aD8ZA.warn)(msg);
                return compilerOptions;
            },
            set: function() {
                (0, $aD8ZA.warn)(msg);
            }
        });
    }
}
function $dac3d718c0e87681$var$normalizeContainer(container) {
    if ((0, $lbCQA.isString)(container)) {
        var res = document.querySelector(container);
        return res;
    }
    return container;
}
var $dac3d718c0e87681$var$ssrDirectiveInitialized = false;
var $dac3d718c0e87681$export$800b28255aa678d9 = function() {
    if (!$dac3d718c0e87681$var$ssrDirectiveInitialized) {
        $dac3d718c0e87681$var$ssrDirectiveInitialized = true;
        $dac3d718c0e87681$var$initVModelForSSR();
        $dac3d718c0e87681$var$initVShowForSSR();
    }
};
$parcel$exportWildcard(module.exports, $aAzpa);

});



parcelRegister("jBC23", function(module, exports) {

$parcel$export(module.exports, "DayGridView", function () { return DayTableView; });
$parcel$export(module.exports, "TableDateProfileGenerator", function () { return TableDateProfileGenerator; });

var $luoZD = parcelRequire("luoZD");

var $fYUO3 = parcelRequire("fYUO3");

var $9WbNX = parcelRequire("9WbNX");

var $3Oamm = parcelRequire("3Oamm");

var $7DbRq = parcelRequire("7DbRq");

var $79xu7 = parcelRequire("79xu7");

var $ju9pQ = parcelRequire("ju9pQ");

var $4a7Gb = parcelRequire("4a7Gb");

var $ihX0O = parcelRequire("ihX0O");
/* An abstract class for the daygrid views, as well as month view. Renders one or more rows of day cells.
----------------------------------------------------------------------------------------------------------------------*/ // It is a manager for a Table subcomponent, which does most of the heavy lifting.
// It is responsible for managing width/height.
var TableView = /*#__PURE__*/ function(DateComponent) {
    "use strict";
    (0, $7DbRq._)(TableView, DateComponent);
    var _super = (0, $ju9pQ._)(TableView);
    function TableView() {
        (0, $luoZD._)(this, TableView);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.headerElRef = (0, $ihX0O.createRef)();
        return _this;
    }
    (0, $fYUO3._)(TableView, [
        {
            key: "renderSimpleLayout",
            value: function renderSimpleLayout(headerRowContent, bodyContent) {
                var _this = this, props = _this.props, context = _this.context;
                var sections = [];
                var stickyHeaderDates = (0, $4a7Gb.ca)(context.options);
                if (headerRowContent) sections.push({
                    type: "header",
                    key: "header",
                    isSticky: stickyHeaderDates,
                    chunk: {
                        elRef: this.headerElRef,
                        tableClassName: "fc-col-header",
                        rowContent: headerRowContent
                    }
                });
                sections.push({
                    type: "body",
                    key: "body",
                    liquid: true,
                    chunk: {
                        content: bodyContent
                    }
                });
                return (0, $ihX0O.createElement)((0, $4a7Gb.cq), {
                    elClasses: [
                        "fc-daygrid"
                    ],
                    viewSpec: context.viewSpec
                }, (0, $ihX0O.createElement)((0, $4a7Gb.bZ), {
                    liquid: !props.isHeightAuto && !props.forPrint,
                    collapsibleWidth: props.forPrint,
                    cols: [],
                    sections: sections
                }));
            }
        },
        {
            key: "renderHScrollLayout",
            value: function renderHScrollLayout(headerRowContent, bodyContent, colCnt, dayMinWidth) {
                var ScrollGrid = this.context.pluginHooks.scrollGridImpl;
                if (!ScrollGrid) throw new Error("No ScrollGrid implementation");
                var _this = this, props = _this.props, context = _this.context;
                var stickyHeaderDates = !props.forPrint && (0, $4a7Gb.ca)(context.options);
                var stickyFooterScrollbar = !props.forPrint && (0, $4a7Gb.c9)(context.options);
                var sections = [];
                if (headerRowContent) sections.push({
                    type: "header",
                    key: "header",
                    isSticky: stickyHeaderDates,
                    chunks: [
                        {
                            key: "main",
                            elRef: this.headerElRef,
                            tableClassName: "fc-col-header",
                            rowContent: headerRowContent
                        }
                    ]
                });
                sections.push({
                    type: "body",
                    key: "body",
                    liquid: true,
                    chunks: [
                        {
                            key: "main",
                            content: bodyContent
                        }
                    ]
                });
                if (stickyFooterScrollbar) sections.push({
                    type: "footer",
                    key: "footer",
                    isSticky: true,
                    chunks: [
                        {
                            key: "main",
                            content: (0, $4a7Gb.c8)
                        }
                    ]
                });
                return (0, $ihX0O.createElement)((0, $4a7Gb.cq), {
                    elClasses: [
                        "fc-daygrid"
                    ],
                    viewSpec: context.viewSpec
                }, (0, $ihX0O.createElement)(ScrollGrid, {
                    liquid: !props.isHeightAuto && !props.forPrint,
                    forPrint: props.forPrint,
                    collapsibleWidth: props.forPrint,
                    colGroups: [
                        {
                            cols: [
                                {
                                    span: colCnt,
                                    minWidth: dayMinWidth
                                }
                            ]
                        }
                    ],
                    sections: sections
                }));
            }
        }
    ]);
    return TableView;
}((0, $4a7Gb.bc));
function splitSegsByRow(segs, rowCnt) {
    var byRow = [];
    for(var i = 0; i < rowCnt; i += 1)byRow[i] = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = segs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var seg = _step.value;
            byRow[seg.row].push(seg);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return byRow;
}
function splitSegsByFirstCol(segs, colCnt) {
    var byCol = [];
    for(var i = 0; i < colCnt; i += 1)byCol[i] = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = segs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var seg = _step.value;
            byCol[seg.firstCol].push(seg);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return byCol;
}
function splitInteractionByRow(ui, rowCnt) {
    var byRow = [];
    if (!ui) for(var i = 0; i < rowCnt; i += 1)byRow[i] = null;
    else {
        for(var i1 = 0; i1 < rowCnt; i1 += 1)byRow[i1] = {
            affectedInstances: ui.affectedInstances,
            isEvent: ui.isEvent,
            segs: []
        };
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = ui.segs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var seg = _step.value;
                byRow[seg.row].segs.push(seg);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return byRow;
}
var DEFAULT_TABLE_EVENT_TIME_FORMAT = (0, $4a7Gb.x)({
    hour: "numeric",
    minute: "2-digit",
    omitZeroMinute: true,
    meridiem: "narrow"
});
function hasListItemDisplay(seg) {
    var display = seg.eventRange.ui.display;
    return display === "list-item" || display === "auto" && !seg.eventRange.def.allDay && seg.firstCol === seg.lastCol && // can't be multi-day
    seg.isStart && // "
    seg.isEnd // "
    ;
}
var TableBlockEvent = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $7DbRq._)(TableBlockEvent, BaseComponent);
    var _super = (0, $ju9pQ._)(TableBlockEvent);
    function TableBlockEvent() {
        (0, $luoZD._)(this, TableBlockEvent);
        return _super.apply(this, arguments);
    }
    (0, $fYUO3._)(TableBlockEvent, [
        {
            key: "render",
            value: function render() {
                var props = this.props;
                return (0, $ihX0O.createElement)((0, $4a7Gb.cg), Object.assign({}, props, {
                    elClasses: [
                        "fc-daygrid-event",
                        "fc-daygrid-block-event",
                        "fc-h-event"
                    ],
                    defaultTimeFormat: DEFAULT_TABLE_EVENT_TIME_FORMAT,
                    defaultDisplayEventEnd: props.defaultDisplayEventEnd,
                    disableResizing: !props.seg.eventRange.def.allDay
                }));
            }
        }
    ]);
    return TableBlockEvent;
}((0, $4a7Gb.B));
var TableListItemEvent = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $7DbRq._)(TableListItemEvent, BaseComponent);
    var _super = (0, $ju9pQ._)(TableListItemEvent);
    function TableListItemEvent() {
        (0, $luoZD._)(this, TableListItemEvent);
        return _super.apply(this, arguments);
    }
    (0, $fYUO3._)(TableListItemEvent, [
        {
            key: "render",
            value: function render() {
                var _this = this, props = _this.props, context = _this.context;
                var options = context.options;
                var seg = props.seg;
                var timeFormat = options.eventTimeFormat || DEFAULT_TABLE_EVENT_TIME_FORMAT;
                var timeText = (0, $4a7Gb.bO)(seg, timeFormat, context, true, props.defaultDisplayEventEnd);
                return (0, $ihX0O.createElement)((0, $4a7Gb.ck), Object.assign({}, props, {
                    elTag: "a",
                    elClasses: [
                        "fc-daygrid-event",
                        "fc-daygrid-dot-event"
                    ],
                    elAttrs: (0, $4a7Gb.bS)(props.seg, context),
                    defaultGenerator: renderInnerContent,
                    timeText: timeText,
                    isResizing: false,
                    isDateSelecting: false
                }));
            }
        }
    ]);
    return TableListItemEvent;
}((0, $4a7Gb.B));
function renderInnerContent(renderProps) {
    return (0, $ihX0O.createElement)((0, $ihX0O.Fragment), null, (0, $ihX0O.createElement)("div", {
        className: "fc-daygrid-event-dot",
        style: {
            borderColor: renderProps.borderColor || renderProps.backgroundColor
        }
    }), renderProps.timeText && (0, $ihX0O.createElement)("div", {
        className: "fc-event-time"
    }, renderProps.timeText), (0, $ihX0O.createElement)("div", {
        className: "fc-event-title"
    }, renderProps.event.title || (0, $ihX0O.createElement)((0, $ihX0O.Fragment), null, "\xa0")));
}
var TableCellMoreLink = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $7DbRq._)(TableCellMoreLink, BaseComponent);
    var _super = (0, $ju9pQ._)(TableCellMoreLink);
    function TableCellMoreLink() {
        (0, $luoZD._)(this, TableCellMoreLink);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.compileSegs = (0, $4a7Gb.z)(compileSegs);
        return _this;
    }
    (0, $fYUO3._)(TableCellMoreLink, [
        {
            key: "render",
            value: function render() {
                var props = this.props;
                var _this_compileSegs = this.compileSegs(props.singlePlacements), allSegs = _this_compileSegs.allSegs, invisibleSegs = _this_compileSegs.invisibleSegs;
                return (0, $ihX0O.createElement)((0, $4a7Gb.co), {
                    elClasses: [
                        "fc-daygrid-more-link"
                    ],
                    dateProfile: props.dateProfile,
                    todayRange: props.todayRange,
                    allDayDate: props.allDayDate,
                    moreCnt: props.moreCnt,
                    allSegs: allSegs,
                    hiddenSegs: invisibleSegs,
                    alignmentElRef: props.alignmentElRef,
                    alignGridTop: props.alignGridTop,
                    extraDateSpan: props.extraDateSpan,
                    popoverContent: function() {
                        var isForcedInvisible = (props.eventDrag ? props.eventDrag.affectedInstances : null) || (props.eventResize ? props.eventResize.affectedInstances : null) || {};
                        return (0, $ihX0O.createElement)((0, $ihX0O.Fragment), null, allSegs.map(function(seg) {
                            var instanceId = seg.eventRange.instance.instanceId;
                            return (0, $ihX0O.createElement)("div", {
                                className: "fc-daygrid-event-harness",
                                key: instanceId,
                                style: {
                                    visibility: isForcedInvisible[instanceId] ? "hidden" : ""
                                }
                            }, hasListItemDisplay(seg) ? (0, $ihX0O.createElement)(TableListItemEvent, Object.assign({
                                seg: seg,
                                isDragging: false,
                                isSelected: instanceId === props.eventSelection,
                                defaultDisplayEventEnd: false
                            }, (0, $4a7Gb.bQ)(seg, props.todayRange))) : (0, $ihX0O.createElement)(TableBlockEvent, Object.assign({
                                seg: seg,
                                isDragging: false,
                                isResizing: false,
                                isDateSelecting: false,
                                isSelected: instanceId === props.eventSelection,
                                defaultDisplayEventEnd: false
                            }, (0, $4a7Gb.bQ)(seg, props.todayRange))));
                        }));
                    }
                });
            }
        }
    ]);
    return TableCellMoreLink;
}((0, $4a7Gb.B));
function compileSegs(singlePlacements) {
    var allSegs = [];
    var invisibleSegs = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = singlePlacements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var placement = _step.value;
            allSegs.push(placement.seg);
            if (!placement.isVisible) invisibleSegs.push(placement.seg);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return {
        allSegs: allSegs,
        invisibleSegs: invisibleSegs
    };
}
var DEFAULT_WEEK_NUM_FORMAT = (0, $4a7Gb.x)({
    week: "narrow"
});
var TableCell = /*#__PURE__*/ function(DateComponent) {
    "use strict";
    (0, $7DbRq._)(TableCell, DateComponent);
    var _super = (0, $ju9pQ._)(TableCell);
    function TableCell() {
        (0, $luoZD._)(this, TableCell);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.rootElRef = (0, $ihX0O.createRef)();
        _this.state = {
            dayNumberId: (0, $4a7Gb.a3)()
        };
        _this.handleRootEl = function(el) {
            (0, $4a7Gb.W)(_this.rootElRef, el);
            (0, $4a7Gb.W)(_this.props.elRef, el);
        };
        return _this;
    }
    (0, $fYUO3._)(TableCell, [
        {
            key: "render",
            value: function render() {
                var _this = this, context = _this.context, props = _this.props, state = _this.state, rootElRef = _this.rootElRef;
                var options = context.options, dateEnv = context.dateEnv;
                var date = props.date, dateProfile = props.dateProfile;
                // TODO: memoize this?
                var isMonthStart = props.showDayNumber && shouldDisplayMonthStart(date, dateProfile.currentRange, dateEnv);
                return (0, $ihX0O.createElement)((0, $4a7Gb.ci), {
                    elTag: "td",
                    elRef: this.handleRootEl,
                    elClasses: [
                        "fc-daygrid-day"
                    ].concat((0, $79xu7._)(props.extraClassNames || [])),
                    elAttrs: Object.assign(Object.assign(Object.assign({}, props.extraDataAttrs), props.showDayNumber ? {
                        "aria-labelledby": state.dayNumberId
                    } : {}), {
                        role: "gridcell"
                    }),
                    defaultGenerator: renderTopInner,
                    date: date,
                    dateProfile: dateProfile,
                    todayRange: props.todayRange,
                    showDayNumber: props.showDayNumber,
                    isMonthStart: isMonthStart,
                    extraRenderProps: props.extraRenderProps
                }, function(InnerContent, renderProps) {
                    return (0, $ihX0O.createElement)("div", {
                        ref: props.innerElRef,
                        className: "fc-daygrid-day-frame fc-scrollgrid-sync-inner",
                        style: {
                            minHeight: props.minHeight
                        }
                    }, props.showWeekNumber && (0, $ihX0O.createElement)((0, $4a7Gb.cn), {
                        elTag: "a",
                        elClasses: [
                            "fc-daygrid-week-number"
                        ],
                        elAttrs: (0, $4a7Gb.a_)(context, date, "week"),
                        date: date,
                        defaultFormat: DEFAULT_WEEK_NUM_FORMAT
                    }), !renderProps.isDisabled && (props.showDayNumber || (0, $4a7Gb.cj)(options) || props.forceDayTop) ? (0, $ihX0O.createElement)("div", {
                        className: "fc-daygrid-day-top"
                    }, (0, $ihX0O.createElement)(InnerContent, {
                        elTag: "a",
                        elClasses: [
                            "fc-daygrid-day-number",
                            isMonthStart && "fc-daygrid-month-start"
                        ],
                        elAttrs: Object.assign(Object.assign({}, (0, $4a7Gb.a_)(context, date)), {
                            id: state.dayNumberId
                        })
                    })) : props.showDayNumber ? // for creating correct amount of space (see issue #7162)
                    (0, $ihX0O.createElement)("div", {
                        className: "fc-daygrid-day-top",
                        style: {
                            visibility: "hidden"
                        }
                    }, (0, $ihX0O.createElement)("a", {
                        className: "fc-daygrid-day-number"
                    }, "\xa0")) : undefined, (0, $ihX0O.createElement)("div", {
                        className: "fc-daygrid-day-events",
                        ref: props.fgContentElRef
                    }, props.fgContent, (0, $ihX0O.createElement)("div", {
                        className: "fc-daygrid-day-bottom",
                        style: {
                            marginTop: props.moreMarginTop
                        }
                    }, (0, $ihX0O.createElement)(TableCellMoreLink, {
                        allDayDate: date,
                        singlePlacements: props.singlePlacements,
                        moreCnt: props.moreCnt,
                        alignmentElRef: rootElRef,
                        alignGridTop: !props.showDayNumber,
                        extraDateSpan: props.extraDateSpan,
                        dateProfile: props.dateProfile,
                        eventSelection: props.eventSelection,
                        eventDrag: props.eventDrag,
                        eventResize: props.eventResize,
                        todayRange: props.todayRange
                    }))), (0, $ihX0O.createElement)("div", {
                        className: "fc-daygrid-day-bg"
                    }, props.bgContent));
                });
            }
        }
    ]);
    return TableCell;
}((0, $4a7Gb.bc));
function renderTopInner(props) {
    return props.dayNumberText || (0, $ihX0O.createElement)((0, $ihX0O.Fragment), null, "\xa0");
}
function shouldDisplayMonthStart(date, currentRange, dateEnv) {
    var currentStart = currentRange.start, currentEnd = currentRange.end;
    var currentEndIncl = (0, $4a7Gb.be)(currentEnd, -1);
    var currentFirstYear = dateEnv.getYear(currentStart);
    var currentFirstMonth = dateEnv.getMonth(currentStart);
    var currentLastYear = dateEnv.getYear(currentEndIncl);
    var currentLastMonth = dateEnv.getMonth(currentEndIncl);
    // spans more than one month?
    return !(currentFirstYear === currentLastYear && currentFirstMonth === currentLastMonth) && Boolean(// first date in current view?
    date.valueOf() === currentStart.valueOf() || // a month-start that's within the current range?
    dateEnv.getDay(date) === 1 && date.valueOf() < currentEnd.valueOf());
}
function generateSegKey(seg) {
    return seg.eventRange.instance.instanceId + ":" + seg.firstCol;
}
function generateSegUid(seg) {
    return generateSegKey(seg) + ":" + seg.lastCol;
}
function computeFgSegPlacement(segs, dayMaxEvents, dayMaxEventRows, strictOrder, segHeights, maxContentHeight, cells) {
    var hierarchy = new DayGridSegHierarchy(function(segEntry) {
        // TODO: more DRY with generateSegUid
        var segUid = segs[segEntry.index].eventRange.instance.instanceId + ":" + segEntry.span.start + ":" + (segEntry.span.end - 1);
        // if no thickness known, assume 1 (if 0, so small it always fits)
        return segHeights[segUid] || 1;
    });
    hierarchy.allowReslicing = true;
    hierarchy.strictOrder = strictOrder;
    if (dayMaxEvents === true || dayMaxEventRows === true) {
        hierarchy.maxCoord = maxContentHeight;
        hierarchy.hiddenConsumes = true;
    } else if (typeof dayMaxEvents === "number") hierarchy.maxStackCnt = dayMaxEvents;
    else if (typeof dayMaxEventRows === "number") {
        hierarchy.maxStackCnt = dayMaxEventRows;
        hierarchy.hiddenConsumes = true;
    }
    // create segInputs only for segs with known heights
    var segInputs = [];
    var unknownHeightSegs = [];
    for(var i = 0; i < segs.length; i += 1){
        var seg = segs[i];
        var segUid = generateSegUid(seg);
        var eventHeight = segHeights[segUid];
        if (eventHeight != null) segInputs.push({
            index: i,
            span: {
                start: seg.firstCol,
                end: seg.lastCol + 1
            }
        });
        else unknownHeightSegs.push(seg);
    }
    var hiddenEntries = hierarchy.addSegs(segInputs);
    var segRects = hierarchy.toRects();
    var _placeRects = placeRects(segRects, segs, cells), singleColPlacements = _placeRects.singleColPlacements, multiColPlacements = _placeRects.multiColPlacements, leftoverMargins = _placeRects.leftoverMargins;
    var moreCnts = [];
    var moreMarginTops = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        // add segs with unknown heights
        for(var _iterator = unknownHeightSegs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var seg1 = _step.value;
            multiColPlacements[seg1.firstCol].push({
                seg: seg1,
                isVisible: false,
                isAbsolute: true,
                absoluteTop: 0,
                marginTop: 0
            });
            for(var col = seg1.firstCol; col <= seg1.lastCol; col += 1)singleColPlacements[col].push({
                seg: resliceSeg(seg1, col, col + 1, cells),
                isVisible: false,
                isAbsolute: false,
                absoluteTop: 0,
                marginTop: 0
            });
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    // add the hidden entries
    for(var col1 = 0; col1 < cells.length; col1 += 1)moreCnts.push(0);
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator1 = hiddenEntries[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
            var hiddenEntry = _step1.value;
            var seg2 = segs[hiddenEntry.index];
            var hiddenSpan = hiddenEntry.span;
            multiColPlacements[hiddenSpan.start].push({
                seg: resliceSeg(seg2, hiddenSpan.start, hiddenSpan.end, cells),
                isVisible: false,
                isAbsolute: true,
                absoluteTop: 0,
                marginTop: 0
            });
            for(var col2 = hiddenSpan.start; col2 < hiddenSpan.end; col2 += 1){
                moreCnts[col2] += 1;
                singleColPlacements[col2].push({
                    seg: resliceSeg(seg2, col2, col2 + 1, cells),
                    isVisible: false,
                    isAbsolute: false,
                    absoluteTop: 0,
                    marginTop: 0
                });
            }
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                _iterator1.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    // deal with leftover margins
    for(var col3 = 0; col3 < cells.length; col3 += 1)moreMarginTops.push(leftoverMargins[col3]);
    return {
        singleColPlacements: singleColPlacements,
        multiColPlacements: multiColPlacements,
        moreCnts: moreCnts,
        moreMarginTops: moreMarginTops
    };
}
// rects ordered by top coord, then left
function placeRects(allRects, segs, cells) {
    var rectsByEachCol = groupRectsByEachCol(allRects, cells.length);
    var singleColPlacements = [];
    var multiColPlacements = [];
    var leftoverMargins = [];
    for(var col = 0; col < cells.length; col += 1){
        var rects = rectsByEachCol[col];
        // compute all static segs in singlePlacements
        var singlePlacements = [];
        var currentHeight = 0;
        var currentMarginTop = 0;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = rects[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var rect = _step.value;
                var seg = segs[rect.index];
                singlePlacements.push({
                    seg: resliceSeg(seg, col, col + 1, cells),
                    isVisible: true,
                    isAbsolute: false,
                    absoluteTop: rect.levelCoord,
                    marginTop: rect.levelCoord - currentHeight
                });
                currentHeight = rect.levelCoord + rect.thickness;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        // compute mixed static/absolute segs in multiPlacements
        var multiPlacements = [];
        currentHeight = 0;
        currentMarginTop = 0;
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = rects[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var rect1 = _step1.value;
                var seg1 = segs[rect1.index];
                var isAbsolute = rect1.span.end - rect1.span.start > 1; // multi-column?
                var isFirstCol = rect1.span.start === col;
                currentMarginTop += rect1.levelCoord - currentHeight; // amount of space since bottom of previous seg
                currentHeight = rect1.levelCoord + rect1.thickness; // height will now be bottom of current seg
                if (isAbsolute) {
                    currentMarginTop += rect1.thickness;
                    if (isFirstCol) multiPlacements.push({
                        seg: resliceSeg(seg1, rect1.span.start, rect1.span.end, cells),
                        isVisible: true,
                        isAbsolute: true,
                        absoluteTop: rect1.levelCoord,
                        marginTop: 0
                    });
                } else if (isFirstCol) {
                    multiPlacements.push({
                        seg: resliceSeg(seg1, rect1.span.start, rect1.span.end, cells),
                        isVisible: true,
                        isAbsolute: false,
                        absoluteTop: rect1.levelCoord,
                        marginTop: currentMarginTop
                    });
                    currentMarginTop = 0;
                }
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
        singleColPlacements.push(singlePlacements);
        multiColPlacements.push(multiPlacements);
        leftoverMargins.push(currentMarginTop);
    }
    return {
        singleColPlacements: singleColPlacements,
        multiColPlacements: multiColPlacements,
        leftoverMargins: leftoverMargins
    };
}
function groupRectsByEachCol(rects, colCnt) {
    var rectsByEachCol = [];
    for(var col = 0; col < colCnt; col += 1)rectsByEachCol.push([]);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = rects[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var rect = _step.value;
            for(var col1 = rect.span.start; col1 < rect.span.end; col1 += 1)rectsByEachCol[col1].push(rect);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return rectsByEachCol;
}
function resliceSeg(seg, spanStart, spanEnd, cells) {
    if (seg.firstCol === spanStart && seg.lastCol === spanEnd - 1) return seg;
    var eventRange = seg.eventRange;
    var origRange = eventRange.range;
    var slicedRange = (0, $4a7Gb.o)(origRange, {
        start: cells[spanStart].date,
        end: (0, $4a7Gb.t)(cells[spanEnd - 1].date, 1)
    });
    return Object.assign(Object.assign({}, seg), {
        firstCol: spanStart,
        lastCol: spanEnd - 1,
        eventRange: {
            def: eventRange.def,
            ui: Object.assign(Object.assign({}, eventRange.ui), {
                durationEditable: false
            }),
            instance: eventRange.instance,
            range: slicedRange
        },
        isStart: seg.isStart && slicedRange.start.valueOf() === origRange.start.valueOf(),
        isEnd: seg.isEnd && slicedRange.end.valueOf() === origRange.end.valueOf()
    });
}
var DayGridSegHierarchy = /*#__PURE__*/ function(SegHierarchy) {
    "use strict";
    (0, $7DbRq._)(DayGridSegHierarchy, SegHierarchy);
    var _super = (0, $ju9pQ._)(DayGridSegHierarchy);
    function DayGridSegHierarchy() {
        (0, $luoZD._)(this, DayGridSegHierarchy);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        // config
        _this.hiddenConsumes = false;
        // allows us to keep hidden entries in the hierarchy so they take up space
        _this.forceHidden = {};
        return _this;
    }
    (0, $fYUO3._)(DayGridSegHierarchy, [
        {
            key: "addSegs",
            value: function addSegs(segInputs) {
                var _this = this;
                var hiddenSegs = (0, $9WbNX._)((0, $3Oamm._)(DayGridSegHierarchy.prototype), "addSegs", this).call(this, segInputs);
                var entriesByLevel = this.entriesByLevel;
                var excludeHidden = function(entry) {
                    return !_this.forceHidden[(0, $4a7Gb.bz)(entry)];
                };
                // remove the forced-hidden segs
                for(var level = 0; level < entriesByLevel.length; level += 1)entriesByLevel[level] = entriesByLevel[level].filter(excludeHidden);
                return hiddenSegs;
            }
        },
        {
            key: "handleInvalidInsertion",
            value: function handleInvalidInsertion(insertion, entry, hiddenEntries) {
                var _this = this, entriesByLevel = _this.entriesByLevel, forceHidden = _this.forceHidden;
                var touchingEntry = insertion.touchingEntry, touchingLevel = insertion.touchingLevel, touchingLateral = insertion.touchingLateral;
                // the entry that the new insertion is touching must be hidden
                if (this.hiddenConsumes && touchingEntry) {
                    var touchingEntryId = (0, $4a7Gb.bz)(touchingEntry);
                    if (!forceHidden[touchingEntryId]) {
                        if (this.allowReslicing) {
                            // split up the touchingEntry, reinsert it
                            var hiddenEntry = Object.assign(Object.assign({}, touchingEntry), {
                                span: (0, $4a7Gb.bD)(touchingEntry.span, entry.span)
                            });
                            // reinsert the area that turned into a "more" link (so no other entries try to
                            // occupy the space) but mark it forced-hidden
                            var hiddenEntryId = (0, $4a7Gb.bz)(hiddenEntry);
                            forceHidden[hiddenEntryId] = true;
                            entriesByLevel[touchingLevel][touchingLateral] = hiddenEntry;
                            hiddenEntries.push(hiddenEntry);
                            this.splitEntry(touchingEntry, entry, hiddenEntries);
                        } else {
                            forceHidden[touchingEntryId] = true;
                            hiddenEntries.push(touchingEntry);
                        }
                    }
                }
                // will try to reslice...
                (0, $9WbNX._)((0, $3Oamm._)(DayGridSegHierarchy.prototype), "handleInvalidInsertion", this).call(this, insertion, entry, hiddenEntries);
            }
        }
    ]);
    return DayGridSegHierarchy;
}((0, $4a7Gb.by));
var TableRow = /*#__PURE__*/ function(DateComponent) {
    "use strict";
    (0, $7DbRq._)(TableRow, DateComponent);
    var _super = (0, $ju9pQ._)(TableRow);
    function TableRow() {
        (0, $luoZD._)(this, TableRow);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.cellElRefs = new (0, $4a7Gb.cd)(); // the <td>
        _this.frameElRefs = new (0, $4a7Gb.cd)(); // the fc-daygrid-day-frame
        _this.fgElRefs = new (0, $4a7Gb.cd)(); // the fc-daygrid-day-events
        _this.segHarnessRefs = new (0, $4a7Gb.cd)(); // indexed by "instanceId:firstCol"
        _this.rootElRef = (0, $ihX0O.createRef)();
        _this.state = {
            framePositions: null,
            maxContentHeight: null,
            segHeights: {}
        };
        _this.handleResize = function(isForced) {
            if (isForced) _this.updateSizing(true); // isExternal=true
        };
        return _this;
    }
    (0, $fYUO3._)(TableRow, [
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _this1 = this, props = _this1.props, state = _this1.state, context = _this1.context;
                var options = context.options;
                var colCnt = props.cells.length;
                var businessHoursByCol = splitSegsByFirstCol(props.businessHourSegs, colCnt);
                var bgEventSegsByCol = splitSegsByFirstCol(props.bgEventSegs, colCnt);
                var highlightSegsByCol = splitSegsByFirstCol(this.getHighlightSegs(), colCnt);
                var mirrorSegsByCol = splitSegsByFirstCol(this.getMirrorSegs(), colCnt);
                var _computeFgSegPlacement = computeFgSegPlacement((0, $4a7Gb.bP)(props.fgEventSegs, options.eventOrder), props.dayMaxEvents, props.dayMaxEventRows, options.eventOrderStrict, state.segHeights, state.maxContentHeight, props.cells), singleColPlacements = _computeFgSegPlacement.singleColPlacements, multiColPlacements = _computeFgSegPlacement.multiColPlacements, moreCnts = _computeFgSegPlacement.moreCnts, moreMarginTops = _computeFgSegPlacement.moreMarginTops;
                var isForcedInvisible = props.eventDrag && props.eventDrag.affectedInstances || props.eventResize && props.eventResize.affectedInstances || {};
                return (0, $ihX0O.createElement)("tr", {
                    ref: this.rootElRef,
                    role: "row"
                }, props.renderIntro && props.renderIntro(), props.cells.map(function(cell, col) {
                    var normalFgNodes = _this.renderFgSegs(col, props.forPrint ? singleColPlacements[col] : multiColPlacements[col], props.todayRange, isForcedInvisible);
                    var mirrorFgNodes = _this.renderFgSegs(col, buildMirrorPlacements(mirrorSegsByCol[col], multiColPlacements), props.todayRange, {}, Boolean(props.eventDrag), Boolean(props.eventResize), false);
                    return (0, $ihX0O.createElement)(TableCell, {
                        key: cell.key,
                        elRef: _this.cellElRefs.createRef(cell.key),
                        innerElRef: _this.frameElRefs.createRef(cell.key),
                        dateProfile: props.dateProfile,
                        date: cell.date,
                        showDayNumber: props.showDayNumbers,
                        showWeekNumber: props.showWeekNumbers && col === 0,
                        forceDayTop: props.showWeekNumbers /* even displaying weeknum for row, not necessarily day */ ,
                        todayRange: props.todayRange,
                        eventSelection: props.eventSelection,
                        eventDrag: props.eventDrag,
                        eventResize: props.eventResize,
                        extraRenderProps: cell.extraRenderProps,
                        extraDataAttrs: cell.extraDataAttrs,
                        extraClassNames: cell.extraClassNames,
                        extraDateSpan: cell.extraDateSpan,
                        moreCnt: moreCnts[col],
                        moreMarginTop: moreMarginTops[col],
                        singlePlacements: singleColPlacements[col],
                        fgContentElRef: _this.fgElRefs.createRef(cell.key),
                        fgContent: (0, $ihX0O.createElement)((0, $ihX0O.Fragment), null, (0, $ihX0O.createElement)((0, $ihX0O.Fragment), null, normalFgNodes), (0, $ihX0O.createElement)((0, $ihX0O.Fragment), null, mirrorFgNodes)),
                        bgContent: (0, $ihX0O.createElement)((0, $ihX0O.Fragment), null, _this.renderFillSegs(highlightSegsByCol[col], "highlight"), _this.renderFillSegs(businessHoursByCol[col], "non-business"), _this.renderFillSegs(bgEventSegsByCol[col], "bg-event")),
                        minHeight: props.cellMinHeight
                    });
                }));
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.updateSizing(true);
                this.context.addResizeHandler(this.handleResize);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState) {
                var currentProps = this.props;
                this.updateSizing(!(0, $4a7Gb.E)(prevProps, currentProps));
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.context.removeResizeHandler(this.handleResize);
            }
        },
        {
            key: "getHighlightSegs",
            value: function getHighlightSegs() {
                var props = this.props;
                if (props.eventDrag && props.eventDrag.segs.length) return props.eventDrag.segs;
                if (props.eventResize && props.eventResize.segs.length) return props.eventResize.segs;
                return props.dateSelectionSegs;
            }
        },
        {
            key: "getMirrorSegs",
            value: function getMirrorSegs() {
                var props = this.props;
                if (props.eventResize && props.eventResize.segs.length) return props.eventResize.segs;
                return [];
            }
        },
        {
            key: "renderFgSegs",
            value: function renderFgSegs(col, segPlacements, todayRange, isForcedInvisible, isDragging, isResizing, isDateSelecting) {
                var context = this.context;
                var eventSelection = this.props.eventSelection;
                var framePositions = this.state.framePositions;
                var defaultDisplayEventEnd = this.props.cells.length === 1; // colCnt === 1
                var isMirror = isDragging || isResizing || isDateSelecting;
                var nodes = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                if (framePositions) try {
                    for(var _iterator = segPlacements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var placement = _step.value;
                        var seg = placement.seg;
                        var instanceId = seg.eventRange.instance.instanceId;
                        var isVisible = placement.isVisible && !isForcedInvisible[instanceId];
                        var isAbsolute = placement.isAbsolute;
                        var left = "";
                        var right = "";
                        if (isAbsolute) {
                            if (context.isRtl) {
                                right = 0;
                                left = framePositions.lefts[seg.lastCol] - framePositions.lefts[seg.firstCol];
                            } else {
                                left = 0;
                                right = framePositions.rights[seg.firstCol] - framePositions.rights[seg.lastCol];
                            }
                        }
                        /*
                known bug: events that are force to be list-item but span multiple days still take up space in later columns
                todo: in print view, for multi-day events, don't display title within non-start/end segs
                */ nodes.push((0, $ihX0O.createElement)("div", {
                            className: "fc-daygrid-event-harness" + (isAbsolute ? " fc-daygrid-event-harness-abs" : ""),
                            key: generateSegKey(seg),
                            ref: isMirror ? null : this.segHarnessRefs.createRef(generateSegUid(seg)),
                            style: {
                                visibility: isVisible ? "" : "hidden",
                                marginTop: isAbsolute ? "" : placement.marginTop,
                                top: isAbsolute ? placement.absoluteTop : "",
                                left: left,
                                right: right
                            }
                        }, hasListItemDisplay(seg) ? (0, $ihX0O.createElement)(TableListItemEvent, Object.assign({
                            seg: seg,
                            isDragging: isDragging,
                            isSelected: instanceId === eventSelection,
                            defaultDisplayEventEnd: defaultDisplayEventEnd
                        }, (0, $4a7Gb.bQ)(seg, todayRange))) : (0, $ihX0O.createElement)(TableBlockEvent, Object.assign({
                            seg: seg,
                            isDragging: isDragging,
                            isResizing: isResizing,
                            isDateSelecting: isDateSelecting,
                            isSelected: instanceId === eventSelection,
                            defaultDisplayEventEnd: defaultDisplayEventEnd
                        }, (0, $4a7Gb.bQ)(seg, todayRange)))));
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return nodes;
            }
        },
        {
            key: "renderFillSegs",
            value: function renderFillSegs(segs, fillType) {
                var isRtl = this.context.isRtl;
                var todayRange = this.props.todayRange;
                var framePositions = this.state.framePositions;
                var nodes = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                if (framePositions) try {
                    for(var _iterator = segs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var seg = _step.value;
                        var leftRightCss = isRtl ? {
                            right: 0,
                            left: framePositions.lefts[seg.lastCol] - framePositions.lefts[seg.firstCol]
                        } : {
                            left: 0,
                            right: framePositions.rights[seg.firstCol] - framePositions.rights[seg.lastCol]
                        };
                        nodes.push((0, $ihX0O.createElement)("div", {
                            key: (0, $4a7Gb.bR)(seg.eventRange),
                            className: "fc-daygrid-bg-harness",
                            style: leftRightCss
                        }, fillType === "bg-event" ? (0, $ihX0O.createElement)((0, $4a7Gb.cm), Object.assign({
                            seg: seg
                        }, (0, $4a7Gb.bQ)(seg, todayRange))) : (0, $4a7Gb.cl)(fillType)));
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return (0, $ihX0O.createElement).apply(void 0, [
                    (0, $ihX0O.Fragment),
                    {}
                ].concat((0, $79xu7._)(nodes)));
            }
        },
        {
            key: "updateSizing",
            value: function updateSizing(isExternalSizingChange) {
                var _this = this, props = _this.props, state = _this.state, frameElRefs = _this.frameElRefs;
                if (!props.forPrint && props.clientWidth !== null // positioning ready?
                ) {
                    if (isExternalSizingChange) {
                        var frameEls = props.cells.map(function(cell) {
                            return frameElRefs.currentMap[cell.key];
                        });
                        if (frameEls.length) {
                            var originEl = this.rootElRef.current;
                            var newPositionCache = new (0, $4a7Gb.b8)(originEl, frameEls, true, false);
                            if (!state.framePositions || !state.framePositions.similarTo(newPositionCache)) this.setState({
                                framePositions: new (0, $4a7Gb.b8)(originEl, frameEls, true, false)
                            });
                        }
                    }
                    var oldSegHeights = this.state.segHeights;
                    var newSegHeights = this.querySegHeights();
                    var limitByContentHeight = props.dayMaxEvents === true || props.dayMaxEventRows === true;
                    this.safeSetState({
                        // HACK to prevent oscillations of events being shown/hidden from max-event-rows
                        // Essentially, once you compute an element's height, never null-out.
                        // TODO: always display all events, as visibility:hidden?
                        segHeights: Object.assign(Object.assign({}, oldSegHeights), newSegHeights),
                        maxContentHeight: limitByContentHeight ? this.computeMaxContentHeight() : null
                    });
                }
            }
        },
        {
            key: "querySegHeights",
            value: function querySegHeights() {
                var segElMap = this.segHarnessRefs.currentMap;
                var segHeights = {};
                // get the max height amongst instance segs
                for(var segUid in segElMap){
                    var height = Math.round(segElMap[segUid].getBoundingClientRect().height);
                    segHeights[segUid] = Math.max(segHeights[segUid] || 0, height);
                }
                return segHeights;
            }
        },
        {
            key: "computeMaxContentHeight",
            value: function computeMaxContentHeight() {
                var firstKey = this.props.cells[0].key;
                var cellEl = this.cellElRefs.currentMap[firstKey];
                var fcContainerEl = this.fgElRefs.currentMap[firstKey];
                return cellEl.getBoundingClientRect().bottom - fcContainerEl.getBoundingClientRect().top;
            }
        },
        {
            key: "getCellEls",
            value: function getCellEls() {
                var elMap = this.cellElRefs.currentMap;
                return this.props.cells.map(function(cell) {
                    return elMap[cell.key];
                });
            }
        }
    ]);
    return TableRow;
}((0, $4a7Gb.bc));
TableRow.addStateEquality({
    segHeights: (0, $4a7Gb.E)
});
function buildMirrorPlacements(mirrorSegs, colPlacements) {
    if (!mirrorSegs.length) return [];
    var topsByInstanceId = buildAbsoluteTopHash(colPlacements); // TODO: cache this at first render?
    return mirrorSegs.map(function(seg) {
        return {
            seg: seg,
            isVisible: true,
            isAbsolute: true,
            absoluteTop: topsByInstanceId[seg.eventRange.instance.instanceId],
            marginTop: 0
        };
    });
}
function buildAbsoluteTopHash(colPlacements) {
    var topsByInstanceId = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined, _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator = colPlacements[Symbol.iterator](), _step; !(_iteratorNormalCompletion1 = (_step = _iterator.next()).done); _iteratorNormalCompletion1 = true){
            var placements = _step.value;
            try {
                for(var _iterator1 = placements[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion = true){
                    var placement = _step1.value;
                    topsByInstanceId[placement.seg.eventRange.instance.instanceId] = placement.absoluteTop;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    return topsByInstanceId;
}
var TableRows = /*#__PURE__*/ function(DateComponent) {
    "use strict";
    (0, $7DbRq._)(TableRows, DateComponent);
    var _super = (0, $ju9pQ._)(TableRows);
    function TableRows() {
        (0, $luoZD._)(this, TableRows);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.splitBusinessHourSegs = (0, $4a7Gb.z)(splitSegsByRow);
        _this.splitBgEventSegs = (0, $4a7Gb.z)(splitSegsByRow);
        _this.splitFgEventSegs = (0, $4a7Gb.z)(splitSegsByRow);
        _this.splitDateSelectionSegs = (0, $4a7Gb.z)(splitSegsByRow);
        _this.splitEventDrag = (0, $4a7Gb.z)(splitInteractionByRow);
        _this.splitEventResize = (0, $4a7Gb.z)(splitInteractionByRow);
        _this.rowRefs = new (0, $4a7Gb.cd)();
        return _this;
    }
    (0, $fYUO3._)(TableRows, [
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _this1 = this, props = _this1.props, context = _this1.context;
                var rowCnt = props.cells.length;
                var businessHourSegsByRow = this.splitBusinessHourSegs(props.businessHourSegs, rowCnt);
                var bgEventSegsByRow = this.splitBgEventSegs(props.bgEventSegs, rowCnt);
                var fgEventSegsByRow = this.splitFgEventSegs(props.fgEventSegs, rowCnt);
                var dateSelectionSegsByRow = this.splitDateSelectionSegs(props.dateSelectionSegs, rowCnt);
                var eventDragByRow = this.splitEventDrag(props.eventDrag, rowCnt);
                var eventResizeByRow = this.splitEventResize(props.eventResize, rowCnt);
                // for DayGrid view with many rows, force a min-height on cells so doesn't appear squished
                // choose 7 because a month view will have max 6 rows
                var cellMinHeight = rowCnt >= 7 && props.clientWidth ? props.clientWidth / context.options.aspectRatio / 6 : null;
                return (0, $ihX0O.createElement)((0, $4a7Gb.a6), {
                    unit: "day"
                }, function(nowDate, todayRange) {
                    return (0, $ihX0O.createElement)((0, $ihX0O.Fragment), null, props.cells.map(function(cells, row) {
                        return (0, $ihX0O.createElement)(TableRow, {
                            ref: _this.rowRefs.createRef(row),
                            key: cells.length ? cells[0].date.toISOString() : row // in case there are no cells (like when resource view is loading)
                            ,
                            showDayNumbers: rowCnt > 1,
                            showWeekNumbers: props.showWeekNumbers,
                            todayRange: todayRange,
                            dateProfile: props.dateProfile,
                            cells: cells,
                            renderIntro: props.renderRowIntro,
                            businessHourSegs: businessHourSegsByRow[row],
                            eventSelection: props.eventSelection,
                            bgEventSegs: bgEventSegsByRow[row].filter(isSegAllDay),
                            fgEventSegs: fgEventSegsByRow[row],
                            dateSelectionSegs: dateSelectionSegsByRow[row],
                            eventDrag: eventDragByRow[row],
                            eventResize: eventResizeByRow[row],
                            dayMaxEvents: props.dayMaxEvents,
                            dayMaxEventRows: props.dayMaxEventRows,
                            clientWidth: props.clientWidth,
                            clientHeight: props.clientHeight,
                            cellMinHeight: cellMinHeight,
                            forPrint: props.forPrint
                        });
                    }));
                });
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.registerInteractiveComponent();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                // for if started with zero cells
                this.registerInteractiveComponent();
            }
        },
        {
            key: "registerInteractiveComponent",
            value: function registerInteractiveComponent() {
                if (!this.rootEl) {
                    // HACK: need a daygrid wrapper parent to do positioning
                    // NOTE: a daygrid resource view w/o resources can have zero cells
                    var firstCellEl = this.rowRefs.currentMap[0].getCellEls()[0];
                    var rootEl = firstCellEl ? firstCellEl.closest(".fc-daygrid-body") : null;
                    if (rootEl) {
                        this.rootEl = rootEl;
                        this.context.registerInteractiveComponent(this, {
                            el: rootEl,
                            isHitComboAllowed: this.props.isHitComboAllowed
                        });
                    }
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (this.rootEl) {
                    this.context.unregisterInteractiveComponent(this);
                    this.rootEl = null;
                }
            }
        },
        {
            // Hit System
            // ----------------------------------------------------------------------------------------------------
            key: "prepareHits",
            value: function prepareHits() {
                this.rowPositions = new (0, $4a7Gb.b8)(this.rootEl, this.rowRefs.collect().map(function(rowObj) {
                    return rowObj.getCellEls()[0];
                }), false, true);
                this.colPositions = new (0, $4a7Gb.b8)(this.rootEl, this.rowRefs.currentMap[0].getCellEls(), true, false);
            }
        },
        {
            key: "queryHit",
            value: function queryHit(positionLeft, positionTop) {
                var _this = this, colPositions = _this.colPositions, rowPositions = _this.rowPositions;
                var col = colPositions.leftToIndex(positionLeft);
                var row = rowPositions.topToIndex(positionTop);
                if (row != null && col != null) {
                    var cell = this.props.cells[row][col];
                    return {
                        dateProfile: this.props.dateProfile,
                        dateSpan: Object.assign({
                            range: this.getCellRange(row, col),
                            allDay: true
                        }, cell.extraDateSpan),
                        dayEl: this.getCellEl(row, col),
                        rect: {
                            left: colPositions.lefts[col],
                            right: colPositions.rights[col],
                            top: rowPositions.tops[row],
                            bottom: rowPositions.bottoms[row]
                        },
                        layer: 0
                    };
                }
                return null;
            }
        },
        {
            key: "getCellEl",
            value: function getCellEl(row, col) {
                return this.rowRefs.currentMap[row].getCellEls()[col]; // TODO: not optimal
            }
        },
        {
            key: "getCellRange",
            value: function getCellRange(row, col) {
                var start = this.props.cells[row][col].date;
                var end = (0, $4a7Gb.t)(start, 1);
                return {
                    start: start,
                    end: end
                };
            }
        }
    ]);
    return TableRows;
}((0, $4a7Gb.bc));
function isSegAllDay(seg) {
    return seg.eventRange.def.allDay;
}
var Table = /*#__PURE__*/ function(DateComponent) {
    "use strict";
    (0, $7DbRq._)(Table, DateComponent);
    var _super = (0, $ju9pQ._)(Table);
    function Table() {
        (0, $luoZD._)(this, Table);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.elRef = (0, $ihX0O.createRef)();
        _this.needsScrollReset = false;
        return _this;
    }
    (0, $fYUO3._)(Table, [
        {
            key: "render",
            value: function render() {
                var props = this.props;
                var dayMaxEventRows = props.dayMaxEventRows, dayMaxEvents = props.dayMaxEvents, expandRows = props.expandRows;
                var limitViaBalanced = dayMaxEvents === true || dayMaxEventRows === true;
                // if rows can't expand to fill fixed height, can't do balanced-height event limit
                // TODO: best place to normalize these options?
                if (limitViaBalanced && !expandRows) {
                    limitViaBalanced = false;
                    dayMaxEventRows = null;
                    dayMaxEvents = null;
                }
                var classNames = [
                    "fc-daygrid-body",
                    limitViaBalanced ? "fc-daygrid-body-balanced" : "fc-daygrid-body-unbalanced",
                    expandRows ? "" : "fc-daygrid-body-natural"
                ];
                return (0, $ihX0O.createElement)("div", {
                    ref: this.elRef,
                    className: classNames.join(" "),
                    style: {
                        // these props are important to give this wrapper correct dimensions for interactions
                        // TODO: if we set it here, can we avoid giving to inner tables?
                        width: props.clientWidth,
                        minWidth: props.tableMinWidth
                    }
                }, (0, $ihX0O.createElement)("table", {
                    role: "presentation",
                    className: "fc-scrollgrid-sync-table",
                    style: {
                        width: props.clientWidth,
                        minWidth: props.tableMinWidth,
                        height: expandRows ? props.clientHeight : ""
                    }
                }, props.colGroupNode, (0, $ihX0O.createElement)("tbody", {
                    role: "presentation"
                }, (0, $ihX0O.createElement)(TableRows, {
                    dateProfile: props.dateProfile,
                    cells: props.cells,
                    renderRowIntro: props.renderRowIntro,
                    showWeekNumbers: props.showWeekNumbers,
                    clientWidth: props.clientWidth,
                    clientHeight: props.clientHeight,
                    businessHourSegs: props.businessHourSegs,
                    bgEventSegs: props.bgEventSegs,
                    fgEventSegs: props.fgEventSegs,
                    dateSelectionSegs: props.dateSelectionSegs,
                    eventSelection: props.eventSelection,
                    eventDrag: props.eventDrag,
                    eventResize: props.eventResize,
                    dayMaxEvents: dayMaxEvents,
                    dayMaxEventRows: dayMaxEventRows,
                    forPrint: props.forPrint,
                    isHitComboAllowed: props.isHitComboAllowed
                }))));
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.requestScrollReset();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                if (prevProps.dateProfile !== this.props.dateProfile) this.requestScrollReset();
                else this.flushScrollReset();
            }
        },
        {
            key: "requestScrollReset",
            value: function requestScrollReset() {
                this.needsScrollReset = true;
                this.flushScrollReset();
            }
        },
        {
            key: "flushScrollReset",
            value: function flushScrollReset() {
                if (this.needsScrollReset && this.props.clientWidth // sizes computed?
                ) {
                    var subjectEl = getScrollSubjectEl(this.elRef.current, this.props.dateProfile);
                    if (subjectEl) {
                        var originEl = subjectEl.closest(".fc-daygrid-body");
                        var scrollEl = originEl.closest(".fc-scroller");
                        var scrollTop = subjectEl.getBoundingClientRect().top - originEl.getBoundingClientRect().top;
                        scrollEl.scrollTop = scrollTop ? scrollTop + 1 : 0; // overcome border
                    }
                    this.needsScrollReset = false;
                }
            }
        }
    ]);
    return Table;
}((0, $4a7Gb.bc));
function getScrollSubjectEl(containerEl, dateProfile) {
    var el;
    if (dateProfile.currentRangeUnit.match(/year|month/)) el = containerEl.querySelector('[data-date="'.concat((0, $4a7Gb.bv)(dateProfile.currentDate), '-01"]'));
    if (!el) el = containerEl.querySelector('[data-date="'.concat((0, $4a7Gb.bt)(dateProfile.currentDate), '"]'));
    return el;
}
var DayTableSlicer = /*#__PURE__*/ function(Slicer) {
    "use strict";
    (0, $7DbRq._)(DayTableSlicer, Slicer);
    var _super = (0, $ju9pQ._)(DayTableSlicer);
    function DayTableSlicer() {
        (0, $luoZD._)(this, DayTableSlicer);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.forceDayIfListItem = true;
        return _this;
    }
    (0, $fYUO3._)(DayTableSlicer, [
        {
            key: "sliceRange",
            value: function sliceRange(dateRange, dayTableModel) {
                return dayTableModel.sliceRange(dateRange);
            }
        }
    ]);
    return DayTableSlicer;
}((0, $4a7Gb.bU));
var DayTable = /*#__PURE__*/ function(DateComponent) {
    "use strict";
    (0, $7DbRq._)(DayTable, DateComponent);
    var _super = (0, $ju9pQ._)(DayTable);
    function DayTable() {
        (0, $luoZD._)(this, DayTable);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.slicer = new DayTableSlicer();
        _this.tableRef = (0, $ihX0O.createRef)();
        return _this;
    }
    (0, $fYUO3._)(DayTable, [
        {
            key: "render",
            value: function render() {
                var _this = this, props = _this.props, context = _this.context;
                return (0, $ihX0O.createElement)(Table, Object.assign({
                    ref: this.tableRef
                }, this.slicer.sliceProps(props, props.dateProfile, props.nextDayThreshold, context, props.dayTableModel), {
                    dateProfile: props.dateProfile,
                    cells: props.dayTableModel.cells,
                    colGroupNode: props.colGroupNode,
                    tableMinWidth: props.tableMinWidth,
                    renderRowIntro: props.renderRowIntro,
                    dayMaxEvents: props.dayMaxEvents,
                    dayMaxEventRows: props.dayMaxEventRows,
                    showWeekNumbers: props.showWeekNumbers,
                    expandRows: props.expandRows,
                    headerAlignElRef: props.headerAlignElRef,
                    clientWidth: props.clientWidth,
                    clientHeight: props.clientHeight,
                    forPrint: props.forPrint
                }));
            }
        }
    ]);
    return DayTable;
}((0, $4a7Gb.bc));
var DayTableView = /*#__PURE__*/ function(TableView) {
    "use strict";
    (0, $7DbRq._)(DayTableView, TableView);
    var _super = (0, $ju9pQ._)(DayTableView);
    function DayTableView() {
        (0, $luoZD._)(this, DayTableView);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.buildDayTableModel = (0, $4a7Gb.z)(buildDayTableModel);
        _this.headerRef = (0, $ihX0O.createRef)();
        _this.tableRef = (0, $ihX0O.createRef)();
        return _this;
    }
    (0, $fYUO3._)(DayTableView, [
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _this_context = this.context, options = _this_context.options, dateProfileGenerator = _this_context.dateProfileGenerator;
                var props = this.props;
                var dayTableModel = this.buildDayTableModel(props.dateProfile, dateProfileGenerator);
                var headerContent = options.dayHeaders && (0, $ihX0O.createElement)((0, $4a7Gb.bI), {
                    ref: this.headerRef,
                    dateProfile: props.dateProfile,
                    dates: dayTableModel.headerDates,
                    datesRepDistinctDays: dayTableModel.rowCnt === 1
                });
                var bodyContent = function(contentArg) {
                    return (0, $ihX0O.createElement)(DayTable, {
                        ref: _this.tableRef,
                        dateProfile: props.dateProfile,
                        dayTableModel: dayTableModel,
                        businessHours: props.businessHours,
                        dateSelection: props.dateSelection,
                        eventStore: props.eventStore,
                        eventUiBases: props.eventUiBases,
                        eventSelection: props.eventSelection,
                        eventDrag: props.eventDrag,
                        eventResize: props.eventResize,
                        nextDayThreshold: options.nextDayThreshold,
                        colGroupNode: contentArg.tableColGroupNode,
                        tableMinWidth: contentArg.tableMinWidth,
                        dayMaxEvents: options.dayMaxEvents,
                        dayMaxEventRows: options.dayMaxEventRows,
                        showWeekNumbers: options.weekNumbers,
                        expandRows: !props.isHeightAuto,
                        headerAlignElRef: _this.headerElRef,
                        clientWidth: contentArg.clientWidth,
                        clientHeight: contentArg.clientHeight,
                        forPrint: props.forPrint
                    });
                };
                return options.dayMinWidth ? this.renderHScrollLayout(headerContent, bodyContent, dayTableModel.colCnt, options.dayMinWidth) : this.renderSimpleLayout(headerContent, bodyContent);
            }
        }
    ]);
    return DayTableView;
}(TableView);
function buildDayTableModel(dateProfile, dateProfileGenerator) {
    var daySeries = new (0, $4a7Gb.bM)(dateProfile.renderRange, dateProfileGenerator);
    return new (0, $4a7Gb.bT)(daySeries, /year|month|week/.test(dateProfile.currentRangeUnit));
}
var TableDateProfileGenerator = /*#__PURE__*/ function(DateProfileGenerator) {
    "use strict";
    (0, $7DbRq._)(TableDateProfileGenerator, DateProfileGenerator);
    var _super = (0, $ju9pQ._)(TableDateProfileGenerator);
    function TableDateProfileGenerator() {
        (0, $luoZD._)(this, TableDateProfileGenerator);
        return _super.apply(this, arguments);
    }
    (0, $fYUO3._)(TableDateProfileGenerator, [
        {
            // Computes the date range that will be rendered
            key: "buildRenderRange",
            value: function buildRenderRange(currentRange, currentRangeUnit, isRangeAllDay) {
                var renderRange = (0, $9WbNX._)((0, $3Oamm._)(TableDateProfileGenerator.prototype), "buildRenderRange", this).call(this, currentRange, currentRangeUnit, isRangeAllDay);
                var props = this.props;
                return buildDayTableRenderRange({
                    currentRange: renderRange,
                    snapToWeek: /^(year|month)$/.test(currentRangeUnit),
                    fixedWeekCount: props.fixedWeekCount,
                    dateEnv: props.dateEnv
                });
            }
        }
    ]);
    return TableDateProfileGenerator;
}((0, $4a7Gb.R));
function buildDayTableRenderRange(props) {
    var dateEnv = props.dateEnv, currentRange = props.currentRange;
    var start = currentRange.start, end = currentRange.end;
    var endOfWeek;
    // year and month views should be aligned with weeks. this is already done for week
    if (props.snapToWeek) {
        start = dateEnv.startOfWeek(start);
        // make end-of-week if not already
        endOfWeek = dateEnv.startOfWeek(end);
        if (endOfWeek.valueOf() !== end.valueOf()) end = (0, $4a7Gb.bf)(endOfWeek, 1);
    }
    // ensure 6 weeks
    if (props.fixedWeekCount) {
        // TODO: instead of these date-math gymnastics (for multimonth view),
        // compute dateprofiles of all months, then use start of first and end of last.
        var lastMonthRenderStart = dateEnv.startOfWeek(dateEnv.startOfMonth((0, $4a7Gb.t)(currentRange.end, -1)));
        var rowCnt = Math.ceil((0, $4a7Gb.bg)(lastMonthRenderStart, end));
        end = (0, $4a7Gb.bf)(end, 6 - rowCnt);
    }
    return {
        start: start,
        end: end
    };
}
var css_248z = ':root{--fc-daygrid-event-dot-width:8px}.fc-daygrid-day-events:after,.fc-daygrid-day-events:before,.fc-daygrid-day-frame:after,.fc-daygrid-day-frame:before,.fc-daygrid-event-harness:after,.fc-daygrid-event-harness:before{clear:both;content:"";display:table}.fc .fc-daygrid-body{position:relative;z-index:1}.fc .fc-daygrid-day.fc-day-today{background-color:var(--fc-today-bg-color)}.fc .fc-daygrid-day-frame{min-height:100%;position:relative}.fc .fc-daygrid-day-top{display:flex;flex-direction:row-reverse}.fc .fc-day-other .fc-daygrid-day-top{opacity:.3}.fc .fc-daygrid-day-number{padding:4px;position:relative;z-index:4}.fc .fc-daygrid-month-start{font-size:1.1em;font-weight:700}.fc .fc-daygrid-day-events{margin-top:1px}.fc .fc-daygrid-body-balanced .fc-daygrid-day-events{left:0;position:absolute;right:0}.fc .fc-daygrid-body-unbalanced .fc-daygrid-day-events{min-height:2em;position:relative}.fc .fc-daygrid-body-natural .fc-daygrid-day-events{margin-bottom:1em}.fc .fc-daygrid-event-harness{position:relative}.fc .fc-daygrid-event-harness-abs{left:0;position:absolute;right:0;top:0}.fc .fc-daygrid-bg-harness{bottom:0;position:absolute;top:0}.fc .fc-daygrid-day-bg .fc-non-business{z-index:1}.fc .fc-daygrid-day-bg .fc-bg-event{z-index:2}.fc .fc-daygrid-day-bg .fc-highlight{z-index:3}.fc .fc-daygrid-event{margin-top:1px;z-index:6}.fc .fc-daygrid-event.fc-event-mirror{z-index:7}.fc .fc-daygrid-day-bottom{font-size:.85em;margin:0 2px}.fc .fc-daygrid-day-bottom:after,.fc .fc-daygrid-day-bottom:before{clear:both;content:"";display:table}.fc .fc-daygrid-more-link{border-radius:3px;cursor:pointer;line-height:1;margin-top:1px;max-width:100%;overflow:hidden;padding:2px;position:relative;white-space:nowrap;z-index:4}.fc .fc-daygrid-more-link:hover{background-color:rgba(0,0,0,.1)}.fc .fc-daygrid-week-number{background-color:var(--fc-neutral-bg-color);color:var(--fc-neutral-text-color);min-width:1.5em;padding:2px;position:absolute;text-align:center;top:0;z-index:5}.fc .fc-more-popover .fc-popover-body{min-width:220px;padding:10px}.fc-direction-ltr .fc-daygrid-event.fc-event-start,.fc-direction-rtl .fc-daygrid-event.fc-event-end{margin-left:2px}.fc-direction-ltr .fc-daygrid-event.fc-event-end,.fc-direction-rtl .fc-daygrid-event.fc-event-start{margin-right:2px}.fc-direction-ltr .fc-daygrid-more-link{float:left}.fc-direction-ltr .fc-daygrid-week-number{border-radius:0 0 3px 0;left:0}.fc-direction-rtl .fc-daygrid-more-link{float:right}.fc-direction-rtl .fc-daygrid-week-number{border-radius:0 0 0 3px;right:0}.fc-liquid-hack .fc-daygrid-day-frame{position:static}.fc-daygrid-event{border-radius:3px;font-size:var(--fc-small-font-size);position:relative;white-space:nowrap}.fc-daygrid-block-event .fc-event-time{font-weight:700}.fc-daygrid-block-event .fc-event-time,.fc-daygrid-block-event .fc-event-title{padding:1px}.fc-daygrid-dot-event{align-items:center;display:flex;padding:2px 0}.fc-daygrid-dot-event .fc-event-title{flex-grow:1;flex-shrink:1;font-weight:700;min-width:0;overflow:hidden}.fc-daygrid-dot-event.fc-event-mirror,.fc-daygrid-dot-event:hover{background:rgba(0,0,0,.1)}.fc-daygrid-dot-event.fc-event-selected:before{bottom:-10px;top:-10px}.fc-daygrid-event-dot{border:calc(var(--fc-daygrid-event-dot-width)/2) solid var(--fc-event-border-color);border-radius:calc(var(--fc-daygrid-event-dot-width)/2);box-sizing:content-box;height:0;margin:0 4px;width:0}.fc-direction-ltr .fc-daygrid-event .fc-event-time{margin-right:3px}.fc-direction-rtl .fc-daygrid-event .fc-event-time{margin-left:3px}';
(0, $4a7Gb.ct)(css_248z);

});
parcelRegister("9WbNX", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $73c2b0072389dff5$export$afb3516d9d608401; });

var $gnyBC = parcelRequire("gnyBC");
function $73c2b0072389dff5$export$afb3516d9d608401(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) $73c2b0072389dff5$export$afb3516d9d608401 = Reflect.get;
    else $73c2b0072389dff5$export$afb3516d9d608401 = function get(target, property, receiver) {
        var base = (0, $gnyBC._super_prop_base)(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.get) return desc.get.call(receiver || target);
        return desc.value;
    };
    return $73c2b0072389dff5$export$afb3516d9d608401(target, property, receiver || target);
}

});
parcelRegister("gnyBC", function(module, exports) {

$parcel$export(module.exports, "_super_prop_base", function () { return $bec9a34bd5948d3c$export$e4187255aefbc259; });

var $3Oamm = parcelRequire("3Oamm");
function $bec9a34bd5948d3c$export$e4187255aefbc259(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = (0, $3Oamm._get_prototype_of)(object);
        if (object === null) break;
    }
    return object;
}

});


parcelRegister("4a7Gb", function(module, exports) {

$parcel$export(module.exports, "ct", function () { return $307e0d89efad9a8a$export$e9316ff9106cdb75; });
$parcel$export(module.exports, "ab", function () { return $307e0d89efad9a8a$export$555508cbc6add439; });
$parcel$export(module.exports, "D", function () { return $307e0d89efad9a8a$export$96f57966bedc81b4; });
$parcel$export(module.exports, "aM", function () { return $307e0d89efad9a8a$export$9f4f30ee63539e24; });
$parcel$export(module.exports, "Z", function () { return $307e0d89efad9a8a$export$dc98b0b04f4c7758; });
$parcel$export(module.exports, "aO", function () { return $307e0d89efad9a8a$export$c03999cb2f36933f; });
$parcel$export(module.exports, "aN", function () { return $307e0d89efad9a8a$export$faec65b429be379; });
$parcel$export(module.exports, "ac", function () { return $307e0d89efad9a8a$export$2219238a014317b0; });
$parcel$export(module.exports, "aP", function () { return $307e0d89efad9a8a$export$2ed0fc6709e59212; });
$parcel$export(module.exports, "a3", function () { return $307e0d89efad9a8a$export$6559d589eb85fbb6; });
$parcel$export(module.exports, "$", function () { return $307e0d89efad9a8a$export$3d8c2f653ac9d0b9; });
$parcel$export(module.exports, "a0", function () { return $307e0d89efad9a8a$export$34aec0b863436764; });
$parcel$export(module.exports, "b0", function () { return $307e0d89efad9a8a$export$8c78c7c36408ea29; });
$parcel$export(module.exports, "g", function () { return $307e0d89efad9a8a$export$39b482c5e57630a8; });
$parcel$export(module.exports, "av", function () { return $307e0d89efad9a8a$export$d66dc83d8cfc8dd; });
$parcel$export(module.exports, "au", function () { return $307e0d89efad9a8a$export$1fbe638ecf81657e; });
$parcel$export(module.exports, "ap", function () { return $307e0d89efad9a8a$export$2f6ca3d3b1f80bf5; });
$parcel$export(module.exports, "aq", function () { return $307e0d89efad9a8a$export$8a5498727ef6be21; });
$parcel$export(module.exports, "ar", function () { return $307e0d89efad9a8a$export$d24c54395ce0c509; });
$parcel$export(module.exports, "as", function () { return $307e0d89efad9a8a$export$6554612db691658e; });
$parcel$export(module.exports, "k", function () { return $307e0d89efad9a8a$export$342063e11d6c3cad; });
$parcel$export(module.exports, "at", function () { return $307e0d89efad9a8a$export$493d36ec626b6698; });
$parcel$export(module.exports, "d", function () { return $307e0d89efad9a8a$export$4368d992c4eafac0; });
$parcel$export(module.exports, "s", function () { return $307e0d89efad9a8a$export$2408f22a0fab9ae5; });
$parcel$export(module.exports, "c", function () { return $307e0d89efad9a8a$export$db3b6bfb95261072; });
$parcel$export(module.exports, "i", function () { return $307e0d89efad9a8a$export$23f2a1d2818174ef; });
$parcel$export(module.exports, "bf", function () { return $307e0d89efad9a8a$export$151db275011178c4; });
$parcel$export(module.exports, "t", function () { return $307e0d89efad9a8a$export$625550452a3fa3ec; });
$parcel$export(module.exports, "be", function () { return $307e0d89efad9a8a$export$51b138e5a065c2bb; });
$parcel$export(module.exports, "bg", function () { return $307e0d89efad9a8a$export$136fd86de524d3c2; });
$parcel$export(module.exports, "q", function () { return $307e0d89efad9a8a$export$9e5f44173e64f162; });
$parcel$export(module.exports, "y", function () { return $307e0d89efad9a8a$export$4a5767248b18ef41; });
$parcel$export(module.exports, "bt", function () { return $307e0d89efad9a8a$export$56350196709588fc; });
$parcel$export(module.exports, "bv", function () { return $307e0d89efad9a8a$export$5dbe06c6d8c68cfb; });
$parcel$export(module.exports, "z", function () { return $307e0d89efad9a8a$export$df995fae86a55f06; });
$parcel$export(module.exports, "A", function () { return $307e0d89efad9a8a$export$ebd11618f299a286; });
$parcel$export(module.exports, "E", function () { return $307e0d89efad9a8a$export$a9c23c6ac3fc3eca; });
$parcel$export(module.exports, "x", function () { return $307e0d89efad9a8a$export$d141bba7fdc215a3; });
$parcel$export(module.exports, "L", function () { return $307e0d89efad9a8a$export$61196ced6d74a310; });
$parcel$export(module.exports, "n", function () { return $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5; });
$parcel$export(module.exports, "e", function () { return $307e0d89efad9a8a$export$f1e1789686576879; });
$parcel$export(module.exports, "M", function () { return $307e0d89efad9a8a$export$3a1a48c8f6ef640e; });
$parcel$export(module.exports, "N", function () { return $307e0d89efad9a8a$export$a07804094c3ecf2d; });
$parcel$export(module.exports, "O", function () { return $307e0d89efad9a8a$export$c4ce752e73470fba; });
$parcel$export(module.exports, "P", function () { return $307e0d89efad9a8a$export$56c0d5a1e737357d; });
$parcel$export(module.exports, "K", function () { return $307e0d89efad9a8a$export$3466f893ebf79586; });
$parcel$export(module.exports, "m", function () { return $307e0d89efad9a8a$export$953cecd6e717a553; });
$parcel$export(module.exports, "h", function () { return $307e0d89efad9a8a$export$dda1d9f60106f0e9; });
$parcel$export(module.exports, "a", function () { return $307e0d89efad9a8a$export$407448d2b89b1813; });
$parcel$export(module.exports, "f", function () { return $307e0d89efad9a8a$export$2d1720544b23b823; });
$parcel$export(module.exports, "v", function () { return $307e0d89efad9a8a$export$90a7f3efeed30595; });
$parcel$export(module.exports, "Q", function () { return $307e0d89efad9a8a$export$3722cfe417b6ed86; });
$parcel$export(module.exports, "T", function () { return $307e0d89efad9a8a$export$971d5caa766a69d7; });
$parcel$export(module.exports, "a8", function () { return $307e0d89efad9a8a$export$c3950d9923825c02; });
$parcel$export(module.exports, "V", function () { return $307e0d89efad9a8a$export$e7c866399fa523f5; });
$parcel$export(module.exports, "a2", function () { return $307e0d89efad9a8a$export$ce26c07117d59d6a; });
$parcel$export(module.exports, "a1", function () { return $307e0d89efad9a8a$export$3c2fa207a37baaea; });
$parcel$export(module.exports, "B", function () { return $307e0d89efad9a8a$export$ef35774e6d314e91; });
$parcel$export(module.exports, "W", function () { return $307e0d89efad9a8a$export$71cec2538cb2c617; });
$parcel$export(module.exports, "aa", function () { return $307e0d89efad9a8a$export$7910e0436ed8d1de; });
$parcel$export(module.exports, "C", function () { return $307e0d89efad9a8a$export$e7094788287c5e9b; });
$parcel$export(module.exports, "cq", function () { return $307e0d89efad9a8a$export$a3c9165b94390bcd; });
$parcel$export(module.exports, "b", function () { return $307e0d89efad9a8a$export$8b22cf2602fb60ce; });
$parcel$export(module.exports, "o", function () { return $307e0d89efad9a8a$export$ae1af26003f05816; });
$parcel$export(module.exports, "b7", function () { return $307e0d89efad9a8a$export$f074adc9fbd50943; });
$parcel$export(module.exports, "G", function () { return $307e0d89efad9a8a$export$2329c99376c9d0a4; });
$parcel$export(module.exports, "ay", function () { return $307e0d89efad9a8a$export$28f7fcd39efa255; });
$parcel$export(module.exports, "R", function () { return $307e0d89efad9a8a$export$db202ddc8be9136; });
$parcel$export(module.exports, "ah", function () { return $307e0d89efad9a8a$export$995eb9fca571757; });
$parcel$export(module.exports, "aj", function () { return $307e0d89efad9a8a$export$3b513254972cfc9c; });
$parcel$export(module.exports, "ai", function () { return $307e0d89efad9a8a$export$f38c853ae54ed474; });
$parcel$export(module.exports, "S", function () { return $307e0d89efad9a8a$export$25ce5a424b770e84; });
$parcel$export(module.exports, "H", function () { return $307e0d89efad9a8a$export$7f8ddf7c7c20b3cd; });
$parcel$export(module.exports, "aU", function () { return $307e0d89efad9a8a$export$317a3d46287192d8; });
$parcel$export(module.exports, "aT", function () { return $307e0d89efad9a8a$export$667d3bf0c5f83305; });
$parcel$export(module.exports, "p", function () { return $307e0d89efad9a8a$export$ffb5f4729a158638; });
$parcel$export(module.exports, "j", function () { return $307e0d89efad9a8a$export$35e795649ee09318; });
$parcel$export(module.exports, "I", function () { return $307e0d89efad9a8a$export$9bb611d729802a56; });
$parcel$export(module.exports, "J", function () { return $307e0d89efad9a8a$export$b4171a6734a65d42; });
$parcel$export(module.exports, "F", function () { return $307e0d89efad9a8a$export$d66501df72047452; });
$parcel$export(module.exports, "U", function () { return $307e0d89efad9a8a$export$3a6d5c9ae78a2c08; });
$parcel$export(module.exports, "cr", function () { return $307e0d89efad9a8a$export$cbfbec548517f2b6; });
$parcel$export(module.exports, "cs", function () { return $307e0d89efad9a8a$export$bde1ed0f60b38f2f; });
$parcel$export(module.exports, "bV", function () { return $307e0d89efad9a8a$export$dabba94403d45c8e; });
$parcel$export(module.exports, "_", function () { return $307e0d89efad9a8a$export$71511d61b312f219; });
$parcel$export(module.exports, "w", function () { return $307e0d89efad9a8a$export$efccba1c4a2ef57b; });
$parcel$export(module.exports, "ad", function () { return $307e0d89efad9a8a$export$4c3d22f3d993c33f; });
$parcel$export(module.exports, "Y", function () { return $307e0d89efad9a8a$export$8743009a87fcb00f; });
$parcel$export(module.exports, "bP", function () { return $307e0d89efad9a8a$export$a91cd623adc48128; });
$parcel$export(module.exports, "bO", function () { return $307e0d89efad9a8a$export$2538633961795d6b; });
$parcel$export(module.exports, "bQ", function () { return $307e0d89efad9a8a$export$993a080e5cb62d74; });
$parcel$export(module.exports, "bR", function () { return $307e0d89efad9a8a$export$4d522598b426bb73; });
$parcel$export(module.exports, "bS", function () { return $307e0d89efad9a8a$export$6dabbe08653f866f; });
$parcel$export(module.exports, "bd", function () { return $307e0d89efad9a8a$export$7f557e5eb95176c2; });
$parcel$export(module.exports, "l", function () { return $307e0d89efad9a8a$export$882b5998b3b9117c; });
$parcel$export(module.exports, "u", function () { return $307e0d89efad9a8a$export$3b14a55fb2447963; });
$parcel$export(module.exports, "r", function () { return $307e0d89efad9a8a$export$43caf9889c228507; });
$parcel$export(module.exports, "a9", function () { return $307e0d89efad9a8a$export$a9c996f45e5784d0; });
$parcel$export(module.exports, "X", function () { return $307e0d89efad9a8a$export$78acf4525d8a74c4; });
$parcel$export(module.exports, "a4", function () { return $307e0d89efad9a8a$export$efca4cbe5dd06740; });
$parcel$export(module.exports, "bE", function () { return $307e0d89efad9a8a$export$381353cf1dd55255; });
$parcel$export(module.exports, "a5", function () { return $307e0d89efad9a8a$export$a8550f7dbe79f93a; });
$parcel$export(module.exports, "a6", function () { return $307e0d89efad9a8a$export$2e2af4578d910ddf; });
$parcel$export(module.exports, "a7", function () { return $307e0d89efad9a8a$export$a93c5207d687da10; });
$parcel$export(module.exports, "aD", function () { return $307e0d89efad9a8a$export$24baa2b76016ce0e; });
$parcel$export(module.exports, "aC", function () { return $307e0d89efad9a8a$export$890c4ad488842ce7; });
$parcel$export(module.exports, "aE", function () { return $307e0d89efad9a8a$export$158acd800e1ef08b; });
$parcel$export(module.exports, "aF", function () { return $307e0d89efad9a8a$export$cf2f7c5792f80b46; });
$parcel$export(module.exports, "aG", function () { return $307e0d89efad9a8a$export$53a70dd1ebbae346; });
$parcel$export(module.exports, "a_", function () { return $307e0d89efad9a8a$export$a17c37559e1db147; });
$parcel$export(module.exports, "b1", function () { return $307e0d89efad9a8a$export$d29e374196577086; });
$parcel$export(module.exports, "b4", function () { return $307e0d89efad9a8a$export$39c1cc7c062529d4; });
$parcel$export(module.exports, "b3", function () { return $307e0d89efad9a8a$export$53c86fa97d611818; });
$parcel$export(module.exports, "b8", function () { return $307e0d89efad9a8a$export$ad4aebacdcaf47f8; });
$parcel$export(module.exports, "b9", function () { return $307e0d89efad9a8a$export$4ae495d48253603d; });
$parcel$export(module.exports, "ba", function () { return $307e0d89efad9a8a$export$7060da4b5db56fb9; });
$parcel$export(module.exports, "bb", function () { return $307e0d89efad9a8a$export$c5d1328b37d47994; });
$parcel$export(module.exports, "bc", function () { return $307e0d89efad9a8a$export$d22783b3c2400a3a; });
$parcel$export(module.exports, "by", function () { return $307e0d89efad9a8a$export$766bf7dcfb630b6c; });
$parcel$export(module.exports, "bD", function () { return $307e0d89efad9a8a$export$b0165a7e514844; });
$parcel$export(module.exports, "bz", function () { return $307e0d89efad9a8a$export$674f8f4247a5112e; });
$parcel$export(module.exports, "bF", function () { return $307e0d89efad9a8a$export$b2bcef12bcefba04; });
$parcel$export(module.exports, "bG", function () { return $307e0d89efad9a8a$export$aff10ba49ece4b91; });
$parcel$export(module.exports, "bH", function () { return $307e0d89efad9a8a$export$60bb826a6acf3081; });
$parcel$export(module.exports, "bI", function () { return $307e0d89efad9a8a$export$27d1aff6bea49709; });
$parcel$export(module.exports, "bM", function () { return $307e0d89efad9a8a$export$ebb8f7cd71856fb9; });
$parcel$export(module.exports, "bT", function () { return $307e0d89efad9a8a$export$1314441b8d04e1d5; });
$parcel$export(module.exports, "bU", function () { return $307e0d89efad9a8a$export$e0c3a065614c6254; });
$parcel$export(module.exports, "bX", function () { return $307e0d89efad9a8a$export$6d1e945284085e64; });
$parcel$export(module.exports, "bY", function () { return $307e0d89efad9a8a$export$545a72cc0d3f00b0; });
$parcel$export(module.exports, "cd", function () { return $307e0d89efad9a8a$export$807f1ba34db587c7; });
$parcel$export(module.exports, "c8", function () { return $307e0d89efad9a8a$export$1ec7a8278ebd1290; });
$parcel$export(module.exports, "ca", function () { return $307e0d89efad9a8a$export$89e9012e902952b6; });
$parcel$export(module.exports, "c9", function () { return $307e0d89efad9a8a$export$4ad369a19af21c23; });
$parcel$export(module.exports, "bZ", function () { return $307e0d89efad9a8a$export$c667925124dac624; });
$parcel$export(module.exports, "ck", function () { return $307e0d89efad9a8a$export$c1df809846363ebe; });
$parcel$export(module.exports, "cg", function () { return $307e0d89efad9a8a$export$6735ce526161c7bd; });
$parcel$export(module.exports, "ci", function () { return $307e0d89efad9a8a$export$c5d7c1ac98841e53; });
$parcel$export(module.exports, "cj", function () { return $307e0d89efad9a8a$export$d92db8a7dc823bb0; });
$parcel$export(module.exports, "cm", function () { return $307e0d89efad9a8a$export$b02498c06ddfef28; });
$parcel$export(module.exports, "cl", function () { return $307e0d89efad9a8a$export$b975d55abac2bbe3; });
$parcel$export(module.exports, "cn", function () { return $307e0d89efad9a8a$export$1343a74baacb0543; });
$parcel$export(module.exports, "co", function () { return $307e0d89efad9a8a$export$87b6ab1c2cb8b955; });
$parcel$export(module.exports, "cv", function () { return $307e0d89efad9a8a$export$1776704b6532a19a; });

var $iJSF3 = parcelRequire("iJSF3");

var $luoZD = parcelRequire("luoZD");

var $fYUO3 = parcelRequire("fYUO3");

var $7DbRq = parcelRequire("7DbRq");

var $4f96i = parcelRequire("4f96i");

var $79xu7 = parcelRequire("79xu7");

var $a3QmP = parcelRequire("a3QmP");

var $ju9pQ = parcelRequire("ju9pQ");

var $ihX0O = parcelRequire("ihX0O");

var $7hN3J = parcelRequire("7hN3J");
var $307e0d89efad9a8a$var$styleTexts = [];
var $307e0d89efad9a8a$var$styleEls = new Map();
function $307e0d89efad9a8a$export$e9316ff9106cdb75(styleText) {
    $307e0d89efad9a8a$var$styleTexts.push(styleText);
    $307e0d89efad9a8a$var$styleEls.forEach(function(styleEl) {
        $307e0d89efad9a8a$var$appendStylesTo(styleEl, styleText);
    });
}
function $307e0d89efad9a8a$export$555508cbc6add439(el) {
    if (el.isConnected && // sometimes true if SSR system simulates DOM
    el.getRootNode // sometimes undefined if SSR system simulates DOM
    ) $307e0d89efad9a8a$var$registerStylesRoot(el.getRootNode());
}
function $307e0d89efad9a8a$var$registerStylesRoot(rootNode) {
    var styleEl = $307e0d89efad9a8a$var$styleEls.get(rootNode);
    if (!styleEl || !styleEl.isConnected) {
        styleEl = rootNode.querySelector("style[data-fullcalendar]");
        if (!styleEl) {
            styleEl = document.createElement("style");
            styleEl.setAttribute("data-fullcalendar", "");
            var nonce = $307e0d89efad9a8a$var$getNonceValue();
            if (nonce) styleEl.nonce = nonce;
            var parentEl = rootNode === document ? document.head : rootNode;
            var insertBefore = rootNode === document ? parentEl.querySelector("script,link[rel=stylesheet],link[as=style],style") : parentEl.firstChild;
            parentEl.insertBefore(styleEl, insertBefore);
        }
        $307e0d89efad9a8a$var$styleEls.set(rootNode, styleEl);
        $307e0d89efad9a8a$var$hydrateStylesRoot(styleEl);
    }
}
function $307e0d89efad9a8a$var$hydrateStylesRoot(styleEl) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = $307e0d89efad9a8a$var$styleTexts[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var styleText = _step.value;
            $307e0d89efad9a8a$var$appendStylesTo(styleEl, styleText);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
function $307e0d89efad9a8a$var$appendStylesTo(styleEl, styleText) {
    var sheet = styleEl.sheet;
    var ruleCnt = sheet.cssRules.length;
    styleText.split("}").forEach(function(styleStr, i) {
        styleStr = styleStr.trim();
        if (styleStr) sheet.insertRule(styleStr + "}", ruleCnt + i);
    });
}
// nonce
// -------------------------------------------------------------------------------------------------
var $307e0d89efad9a8a$var$queriedNonceValue;
function $307e0d89efad9a8a$var$getNonceValue() {
    if ($307e0d89efad9a8a$var$queriedNonceValue === undefined) $307e0d89efad9a8a$var$queriedNonceValue = $307e0d89efad9a8a$var$queryNonceValue();
    return $307e0d89efad9a8a$var$queriedNonceValue;
}
/*
TODO: discourage meta tag and instead put nonce attribute on placeholder <style> tag
*/ function $307e0d89efad9a8a$var$queryNonceValue() {
    var metaWithNonce = document.querySelector('meta[name="csp-nonce"]');
    if (metaWithNonce && metaWithNonce.hasAttribute("content")) return metaWithNonce.getAttribute("content");
    var elWithNonce = document.querySelector("script[nonce]");
    if (elWithNonce) return elWithNonce.nonce || "";
    return "";
}
// main
// -------------------------------------------------------------------------------------------------
if (typeof document !== "undefined") $307e0d89efad9a8a$var$registerStylesRoot(document);
var $307e0d89efad9a8a$var$css_248z = ':root{--fc-small-font-size:.85em;--fc-page-bg-color:#fff;--fc-neutral-bg-color:hsla(0,0%,82%,.3);--fc-neutral-text-color:grey;--fc-border-color:#ddd;--fc-button-text-color:#fff;--fc-button-bg-color:#2c3e50;--fc-button-border-color:#2c3e50;--fc-button-hover-bg-color:#1e2b37;--fc-button-hover-border-color:#1a252f;--fc-button-active-bg-color:#1a252f;--fc-button-active-border-color:#151e27;--fc-event-bg-color:#3788d8;--fc-event-border-color:#3788d8;--fc-event-text-color:#fff;--fc-event-selected-overlay-color:rgba(0,0,0,.25);--fc-more-link-bg-color:#d0d0d0;--fc-more-link-text-color:inherit;--fc-event-resizer-thickness:8px;--fc-event-resizer-dot-total-width:8px;--fc-event-resizer-dot-border-width:1px;--fc-non-business-color:hsla(0,0%,84%,.3);--fc-bg-event-color:#8fdf82;--fc-bg-event-opacity:0.3;--fc-highlight-color:rgba(188,232,241,.3);--fc-today-bg-color:rgba(255,220,40,.15);--fc-now-indicator-color:red}.fc-not-allowed,.fc-not-allowed .fc-event{cursor:not-allowed}.fc{display:flex;flex-direction:column;font-size:1em}.fc,.fc *,.fc :after,.fc :before{box-sizing:border-box}.fc table{border-collapse:collapse;border-spacing:0;font-size:1em}.fc th{text-align:center}.fc td,.fc th{padding:0;vertical-align:top}.fc a[data-navlink]{cursor:pointer}.fc a[data-navlink]:hover{text-decoration:underline}.fc-direction-ltr{direction:ltr;text-align:left}.fc-direction-rtl{direction:rtl;text-align:right}.fc-theme-standard td,.fc-theme-standard th{border:1px solid var(--fc-border-color)}.fc-liquid-hack td,.fc-liquid-hack th{position:relative}@font-face{font-family:fcicons;font-style:normal;font-weight:400;src:url("data:application/x-font-ttf;charset=utf-8;base64,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") format("truetype")}.fc-icon{speak:none;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;display:inline-block;font-family:fcicons!important;font-style:normal;font-variant:normal;font-weight:400;height:1em;line-height:1;text-align:center;text-transform:none;-webkit-user-select:none;-moz-user-select:none;user-select:none;width:1em}.fc-icon-chevron-left:before{content:"\\e900"}.fc-icon-chevron-right:before{content:"\\e901"}.fc-icon-chevrons-left:before{content:"\\e902"}.fc-icon-chevrons-right:before{content:"\\e903"}.fc-icon-minus-square:before{content:"\\e904"}.fc-icon-plus-square:before{content:"\\e905"}.fc-icon-x:before{content:"\\e906"}.fc .fc-button{border-radius:0;font-family:inherit;font-size:inherit;line-height:inherit;margin:0;overflow:visible;text-transform:none}.fc .fc-button:focus{outline:1px dotted;outline:5px auto -webkit-focus-ring-color}.fc .fc-button{-webkit-appearance:button}.fc .fc-button:not(:disabled){cursor:pointer}.fc .fc-button{background-color:transparent;border:1px solid transparent;border-radius:.25em;display:inline-block;font-size:1em;font-weight:400;line-height:1.5;padding:.4em .65em;text-align:center;-webkit-user-select:none;-moz-user-select:none;user-select:none;vertical-align:middle}.fc .fc-button:hover{text-decoration:none}.fc .fc-button:focus{box-shadow:0 0 0 .2rem rgba(44,62,80,.25);outline:0}.fc .fc-button:disabled{opacity:.65}.fc .fc-button-primary{background-color:var(--fc-button-bg-color);border-color:var(--fc-button-border-color);color:var(--fc-button-text-color)}.fc .fc-button-primary:hover{background-color:var(--fc-button-hover-bg-color);border-color:var(--fc-button-hover-border-color);color:var(--fc-button-text-color)}.fc .fc-button-primary:disabled{background-color:var(--fc-button-bg-color);border-color:var(--fc-button-border-color);color:var(--fc-button-text-color)}.fc .fc-button-primary:focus{box-shadow:0 0 0 .2rem rgba(76,91,106,.5)}.fc .fc-button-primary:not(:disabled).fc-button-active,.fc .fc-button-primary:not(:disabled):active{background-color:var(--fc-button-active-bg-color);border-color:var(--fc-button-active-border-color);color:var(--fc-button-text-color)}.fc .fc-button-primary:not(:disabled).fc-button-active:focus,.fc .fc-button-primary:not(:disabled):active:focus{box-shadow:0 0 0 .2rem rgba(76,91,106,.5)}.fc .fc-button .fc-icon{font-size:1.5em;vertical-align:middle}.fc .fc-button-group{display:inline-flex;position:relative;vertical-align:middle}.fc .fc-button-group>.fc-button{flex:1 1 auto;position:relative}.fc .fc-button-group>.fc-button.fc-button-active,.fc .fc-button-group>.fc-button:active,.fc .fc-button-group>.fc-button:focus,.fc .fc-button-group>.fc-button:hover{z-index:1}.fc-direction-ltr .fc-button-group>.fc-button:not(:first-child){border-bottom-left-radius:0;border-top-left-radius:0;margin-left:-1px}.fc-direction-ltr .fc-button-group>.fc-button:not(:last-child){border-bottom-right-radius:0;border-top-right-radius:0}.fc-direction-rtl .fc-button-group>.fc-button:not(:first-child){border-bottom-right-radius:0;border-top-right-radius:0;margin-right:-1px}.fc-direction-rtl .fc-button-group>.fc-button:not(:last-child){border-bottom-left-radius:0;border-top-left-radius:0}.fc .fc-toolbar{align-items:center;display:flex;justify-content:space-between}.fc .fc-toolbar.fc-header-toolbar{margin-bottom:1.5em}.fc .fc-toolbar.fc-footer-toolbar{margin-top:1.5em}.fc .fc-toolbar-title{font-size:1.75em;margin:0}.fc-direction-ltr .fc-toolbar>*>:not(:first-child){margin-left:.75em}.fc-direction-rtl .fc-toolbar>*>:not(:first-child){margin-right:.75em}.fc-direction-rtl .fc-toolbar-ltr{flex-direction:row-reverse}.fc .fc-scroller{-webkit-overflow-scrolling:touch;position:relative}.fc .fc-scroller-liquid{height:100%}.fc .fc-scroller-liquid-absolute{bottom:0;left:0;position:absolute;right:0;top:0}.fc .fc-scroller-harness{direction:ltr;overflow:hidden;position:relative}.fc .fc-scroller-harness-liquid{height:100%}.fc-direction-rtl .fc-scroller-harness>.fc-scroller{direction:rtl}.fc-theme-standard .fc-scrollgrid{border:1px solid var(--fc-border-color)}.fc .fc-scrollgrid,.fc .fc-scrollgrid table{table-layout:fixed;width:100%}.fc .fc-scrollgrid table{border-left-style:hidden;border-right-style:hidden;border-top-style:hidden}.fc .fc-scrollgrid{border-bottom-width:0;border-collapse:separate;border-right-width:0}.fc .fc-scrollgrid-liquid{height:100%}.fc .fc-scrollgrid-section,.fc .fc-scrollgrid-section table,.fc .fc-scrollgrid-section>td{height:1px}.fc .fc-scrollgrid-section-liquid>td{height:100%}.fc .fc-scrollgrid-section>*{border-left-width:0;border-top-width:0}.fc .fc-scrollgrid-section-footer>*,.fc .fc-scrollgrid-section-header>*{border-bottom-width:0}.fc .fc-scrollgrid-section-body table,.fc .fc-scrollgrid-section-footer table{border-bottom-style:hidden}.fc .fc-scrollgrid-section-sticky>*{background:var(--fc-page-bg-color);position:sticky;z-index:3}.fc .fc-scrollgrid-section-header.fc-scrollgrid-section-sticky>*{top:0}.fc .fc-scrollgrid-section-footer.fc-scrollgrid-section-sticky>*{bottom:0}.fc .fc-scrollgrid-sticky-shim{height:1px;margin-bottom:-1px}.fc-sticky{position:sticky}.fc .fc-view-harness{flex-grow:1;position:relative}.fc .fc-view-harness-active>.fc-view{bottom:0;left:0;position:absolute;right:0;top:0}.fc .fc-col-header-cell-cushion{display:inline-block;padding:2px 4px}.fc .fc-bg-event,.fc .fc-highlight,.fc .fc-non-business{bottom:0;left:0;position:absolute;right:0;top:0}.fc .fc-non-business{background:var(--fc-non-business-color)}.fc .fc-bg-event{background:var(--fc-bg-event-color);opacity:var(--fc-bg-event-opacity)}.fc .fc-bg-event .fc-event-title{font-size:var(--fc-small-font-size);font-style:italic;margin:.5em}.fc .fc-highlight{background:var(--fc-highlight-color)}.fc .fc-cell-shaded,.fc .fc-day-disabled{background:var(--fc-neutral-bg-color)}a.fc-event,a.fc-event:hover{text-decoration:none}.fc-event.fc-event-draggable,.fc-event[href]{cursor:pointer}.fc-event .fc-event-main{position:relative;z-index:2}.fc-event-dragging:not(.fc-event-selected){opacity:.75}.fc-event-dragging.fc-event-selected{box-shadow:0 2px 7px rgba(0,0,0,.3)}.fc-event .fc-event-resizer{display:none;position:absolute;z-index:4}.fc-event-selected .fc-event-resizer,.fc-event:hover .fc-event-resizer{display:block}.fc-event-selected .fc-event-resizer{background:var(--fc-page-bg-color);border-color:inherit;border-radius:calc(var(--fc-event-resizer-dot-total-width)/2);border-style:solid;border-width:var(--fc-event-resizer-dot-border-width);height:var(--fc-event-resizer-dot-total-width);width:var(--fc-event-resizer-dot-total-width)}.fc-event-selected .fc-event-resizer:before{bottom:-20px;content:"";left:-20px;position:absolute;right:-20px;top:-20px}.fc-event-selected,.fc-event:focus{box-shadow:0 2px 5px rgba(0,0,0,.2)}.fc-event-selected:before,.fc-event:focus:before{bottom:0;content:"";left:0;position:absolute;right:0;top:0;z-index:3}.fc-event-selected:after,.fc-event:focus:after{background:var(--fc-event-selected-overlay-color);bottom:-1px;content:"";left:-1px;position:absolute;right:-1px;top:-1px;z-index:1}.fc-h-event{background-color:var(--fc-event-bg-color);border:1px solid var(--fc-event-border-color);display:block}.fc-h-event .fc-event-main{color:var(--fc-event-text-color)}.fc-h-event .fc-event-main-frame{display:flex}.fc-h-event .fc-event-time{max-width:100%;overflow:hidden}.fc-h-event .fc-event-title-container{flex-grow:1;flex-shrink:1;min-width:0}.fc-h-event .fc-event-title{display:inline-block;left:0;max-width:100%;overflow:hidden;right:0;vertical-align:top}.fc-h-event.fc-event-selected:before{bottom:-10px;top:-10px}.fc-direction-ltr .fc-daygrid-block-event:not(.fc-event-start),.fc-direction-rtl .fc-daygrid-block-event:not(.fc-event-end){border-bottom-left-radius:0;border-left-width:0;border-top-left-radius:0}.fc-direction-ltr .fc-daygrid-block-event:not(.fc-event-end),.fc-direction-rtl .fc-daygrid-block-event:not(.fc-event-start){border-bottom-right-radius:0;border-right-width:0;border-top-right-radius:0}.fc-h-event:not(.fc-event-selected) .fc-event-resizer{bottom:0;top:0;width:var(--fc-event-resizer-thickness)}.fc-direction-ltr .fc-h-event:not(.fc-event-selected) .fc-event-resizer-start,.fc-direction-rtl .fc-h-event:not(.fc-event-selected) .fc-event-resizer-end{cursor:w-resize;left:calc(var(--fc-event-resizer-thickness)*-.5)}.fc-direction-ltr .fc-h-event:not(.fc-event-selected) .fc-event-resizer-end,.fc-direction-rtl .fc-h-event:not(.fc-event-selected) .fc-event-resizer-start{cursor:e-resize;right:calc(var(--fc-event-resizer-thickness)*-.5)}.fc-h-event.fc-event-selected .fc-event-resizer{margin-top:calc(var(--fc-event-resizer-dot-total-width)*-.5);top:50%}.fc-direction-ltr .fc-h-event.fc-event-selected .fc-event-resizer-start,.fc-direction-rtl .fc-h-event.fc-event-selected .fc-event-resizer-end{left:calc(var(--fc-event-resizer-dot-total-width)*-.5)}.fc-direction-ltr .fc-h-event.fc-event-selected .fc-event-resizer-end,.fc-direction-rtl .fc-h-event.fc-event-selected .fc-event-resizer-start{right:calc(var(--fc-event-resizer-dot-total-width)*-.5)}.fc .fc-popover{box-shadow:0 2px 6px rgba(0,0,0,.15);position:absolute;z-index:9999}.fc .fc-popover-header{align-items:center;display:flex;flex-direction:row;justify-content:space-between;padding:3px 4px}.fc .fc-popover-title{margin:0 2px}.fc .fc-popover-close{cursor:pointer;font-size:1.1em;opacity:.65}.fc-theme-standard .fc-popover{background:var(--fc-page-bg-color);border:1px solid var(--fc-border-color)}.fc-theme-standard .fc-popover-header{background:var(--fc-neutral-bg-color)}';
$307e0d89efad9a8a$export$e9316ff9106cdb75($307e0d89efad9a8a$var$css_248z);
var $307e0d89efad9a8a$export$96f57966bedc81b4 = /*#__PURE__*/ function() {
    "use strict";
    function DelayedRunner(drainedOption) {
        (0, $luoZD._)(this, DelayedRunner);
        this.drainedOption = drainedOption;
        this.isRunning = false;
        this.isDirty = false;
        this.pauseDepths = {};
        this.timeoutId = 0;
    }
    (0, $fYUO3._)(DelayedRunner, [
        {
            key: "request",
            value: function request(delay) {
                this.isDirty = true;
                if (!this.isPaused()) {
                    this.clearTimeout();
                    if (delay == null) this.tryDrain();
                    else this.timeoutId = setTimeout(this.tryDrain.bind(this), delay);
                }
            }
        },
        {
            key: "pause",
            value: function pause() {
                var scope = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
                var pauseDepths = this.pauseDepths;
                pauseDepths[scope] = (pauseDepths[scope] || 0) + 1;
                this.clearTimeout();
            }
        },
        {
            key: "resume",
            value: function resume() {
                var scope = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", force = arguments.length > 1 ? arguments[1] : void 0;
                var pauseDepths = this.pauseDepths;
                if (scope in pauseDepths) {
                    if (force) delete pauseDepths[scope];
                    else {
                        pauseDepths[scope] -= 1;
                        var depth = pauseDepths[scope];
                        if (depth <= 0) delete pauseDepths[scope];
                    }
                    this.tryDrain();
                }
            }
        },
        {
            key: "isPaused",
            value: function isPaused() {
                return Object.keys(this.pauseDepths).length;
            }
        },
        {
            key: "tryDrain",
            value: function tryDrain() {
                if (!this.isRunning && !this.isPaused()) {
                    this.isRunning = true;
                    while(this.isDirty){
                        this.isDirty = false;
                        this.drained(); // might set isDirty to true again
                    }
                    this.isRunning = false;
                }
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.clearTimeout();
                this.isDirty = false;
                this.pauseDepths = {};
            }
        },
        {
            key: "clearTimeout",
            value: function clearTimeout1() {
                if (this.timeoutId) {
                    clearTimeout(this.timeoutId);
                    this.timeoutId = 0;
                }
            }
        },
        {
            key: "drained",
            value: function drained() {
                if (this.drainedOption) this.drainedOption();
            }
        }
    ]);
    return DelayedRunner;
}();
function $307e0d89efad9a8a$export$9f4f30ee63539e24(el) {
    if (el.parentNode) el.parentNode.removeChild(el);
}
// Querying
// ----------------------------------------------------------------------------------------------------------------
function $307e0d89efad9a8a$export$dc98b0b04f4c7758(el, selector) {
    if (el.closest) return el.closest(selector);
    if (!document.documentElement.contains(el)) return null;
    do {
        if ($307e0d89efad9a8a$export$c03999cb2f36933f(el, selector)) return el;
        el = el.parentElement || el.parentNode;
    }while (el !== null && el.nodeType === 1);
    return null;
}
function $307e0d89efad9a8a$export$c03999cb2f36933f(el, selector) {
    var method = el.matches || el.matchesSelector || el.msMatchesSelector;
    return method.call(el, selector);
}
// accepts multiple subject els
// returns a real array. good for methods like forEach
// TODO: accept the document
function $307e0d89efad9a8a$export$23ebac1979863676(container, selector) {
    var containers = container instanceof HTMLElement ? [
        container
    ] : container;
    var allMatches = [];
    for(var i = 0; i < containers.length; i += 1){
        var matches = containers[i].querySelectorAll(selector);
        for(var j = 0; j < matches.length; j += 1)allMatches.push(matches[j]);
    }
    return allMatches;
}
// accepts multiple subject els
// only queries direct child elements // TODO: rename to findDirectChildren!
function $307e0d89efad9a8a$export$91477dc880baac21(parent, selector) {
    var parents = parent instanceof HTMLElement ? [
        parent
    ] : parent;
    var allMatches = [];
    for(var i = 0; i < parents.length; i += 1){
        var childNodes = parents[i].children; // only ever elements
        for(var j = 0; j < childNodes.length; j += 1){
            var childNode = childNodes[j];
            if (!selector || $307e0d89efad9a8a$export$c03999cb2f36933f(childNode, selector)) allMatches.push(childNode);
        }
    }
    return allMatches;
}
// Style
// ----------------------------------------------------------------------------------------------------------------
var $307e0d89efad9a8a$var$PIXEL_PROP_RE = /(top|left|right|bottom|width|height)$/i;
function $307e0d89efad9a8a$export$faec65b429be379(el, props) {
    for(var propName in props)$307e0d89efad9a8a$export$2219238a014317b0(el, propName, props[propName]);
}
function $307e0d89efad9a8a$export$2219238a014317b0(el, name, val) {
    if (val == null) el.style[name] = "";
    else if (typeof val === "number" && $307e0d89efad9a8a$var$PIXEL_PROP_RE.test(name)) el.style[name] = "".concat(val, "px");
    else el.style[name] = val;
}
// Event Handling
// ----------------------------------------------------------------------------------------------------------------
// if intercepting bubbled events at the document/window/body level,
// and want to see originating element (the 'target'), use this util instead
// of `ev.target` because it goes within web-component boundaries.
function $307e0d89efad9a8a$export$2ed0fc6709e59212(ev) {
    var _a, _b;
    return (_b = (_a = ev.composedPath) === null || _a === void 0 ? void 0 : _a.call(ev)[0]) !== null && _b !== void 0 ? _b : ev.target;
}
// Unique ID for DOM attribute
var $307e0d89efad9a8a$var$guid$1 = 0;
function $307e0d89efad9a8a$export$6559d589eb85fbb6() {
    $307e0d89efad9a8a$var$guid$1 += 1;
    return "fc-dom-" + $307e0d89efad9a8a$var$guid$1;
}
// Stops a mouse/touch event from doing it's native browser action
function $307e0d89efad9a8a$export$fef3dfd9bad05307(ev) {
    ev.preventDefault();
}
// Event Delegation
// ----------------------------------------------------------------------------------------------------------------
function $307e0d89efad9a8a$var$buildDelegationHandler(selector, handler) {
    return function(ev) {
        var matchedChild = $307e0d89efad9a8a$export$dc98b0b04f4c7758(ev.target, selector);
        if (matchedChild) handler.call(matchedChild, ev, matchedChild);
    };
}
function $307e0d89efad9a8a$export$3d8c2f653ac9d0b9(container, eventType, selector, handler) {
    var attachedHandler = $307e0d89efad9a8a$var$buildDelegationHandler(selector, handler);
    container.addEventListener(eventType, attachedHandler);
    return function() {
        container.removeEventListener(eventType, attachedHandler);
    };
}
function $307e0d89efad9a8a$export$34aec0b863436764(container, selector, onMouseEnter, onMouseLeave) {
    var currentMatchedChild;
    return $307e0d89efad9a8a$export$3d8c2f653ac9d0b9(container, "mouseover", selector, function(mouseOverEv, matchedChild) {
        if (matchedChild !== currentMatchedChild) {
            currentMatchedChild = matchedChild;
            onMouseEnter(mouseOverEv, matchedChild);
            var realOnMouseLeave = function(mouseLeaveEv) {
                currentMatchedChild = null;
                onMouseLeave(mouseLeaveEv, matchedChild);
                matchedChild.removeEventListener("mouseleave", realOnMouseLeave);
            };
            // listen to the next mouseleave, and then unattach
            matchedChild.addEventListener("mouseleave", realOnMouseLeave);
        }
    });
}
// Animation
// ----------------------------------------------------------------------------------------------------------------
var $307e0d89efad9a8a$var$transitionEventNames = [
    "webkitTransitionEnd",
    "otransitionend",
    "oTransitionEnd",
    "msTransitionEnd",
    "transitionend"
];
// triggered only when the next single subsequent transition finishes
function $307e0d89efad9a8a$export$8c78c7c36408ea29(el, callback) {
    var realCallback = function(ev) {
        callback(ev);
        $307e0d89efad9a8a$var$transitionEventNames.forEach(function(eventName) {
            el.removeEventListener(eventName, realCallback);
        });
    };
    $307e0d89efad9a8a$var$transitionEventNames.forEach(function(eventName) {
        el.addEventListener(eventName, realCallback); // cross-browser way to determine when the transition finishes
    });
}
// ARIA workarounds
// ----------------------------------------------------------------------------------------------------------------
function $307e0d89efad9a8a$var$createAriaClickAttrs(handler) {
    return Object.assign({
        onClick: handler
    }, $307e0d89efad9a8a$var$createAriaKeyboardAttrs(handler));
}
function $307e0d89efad9a8a$var$createAriaKeyboardAttrs(handler) {
    return {
        tabIndex: 0,
        onKeyDown: function(ev) {
            if (ev.key === "Enter" || ev.key === " ") {
                handler(ev);
                ev.preventDefault(); // if space, don't scroll down page
            }
        }
    };
}
var $307e0d89efad9a8a$var$guidNumber = 0;
function $307e0d89efad9a8a$export$39b482c5e57630a8() {
    $307e0d89efad9a8a$var$guidNumber += 1;
    return String($307e0d89efad9a8a$var$guidNumber);
}
/* FullCalendar-specific DOM Utilities
----------------------------------------------------------------------------------------------------------------------*/ // Make the mouse cursor express that an event is not allowed in the current area
function $307e0d89efad9a8a$export$d66dc83d8cfc8dd() {
    document.body.classList.add("fc-not-allowed");
}
// Returns the mouse cursor to its original look
function $307e0d89efad9a8a$export$1fbe638ecf81657e() {
    document.body.classList.remove("fc-not-allowed");
}
/* Selection
----------------------------------------------------------------------------------------------------------------------*/ function $307e0d89efad9a8a$export$2f6ca3d3b1f80bf5(el) {
    el.style.userSelect = "none";
    el.style.webkitUserSelect = "none";
    el.addEventListener("selectstart", $307e0d89efad9a8a$export$fef3dfd9bad05307);
}
function $307e0d89efad9a8a$export$8a5498727ef6be21(el) {
    el.style.userSelect = "";
    el.style.webkitUserSelect = "";
    el.removeEventListener("selectstart", $307e0d89efad9a8a$export$fef3dfd9bad05307);
}
/* Context Menu
----------------------------------------------------------------------------------------------------------------------*/ function $307e0d89efad9a8a$export$d24c54395ce0c509(el) {
    el.addEventListener("contextmenu", $307e0d89efad9a8a$export$fef3dfd9bad05307);
}
function $307e0d89efad9a8a$export$6554612db691658e(el) {
    el.removeEventListener("contextmenu", $307e0d89efad9a8a$export$fef3dfd9bad05307);
}
function $307e0d89efad9a8a$export$1a82df3d29112e01(input) {
    var specs = [];
    var tokens = [];
    var i;
    var token;
    if (typeof input === "string") tokens = input.split(/\s*,\s*/);
    else if (typeof input === "function") tokens = [
        input
    ];
    else if (Array.isArray(input)) tokens = input;
    for(i = 0; i < tokens.length; i += 1){
        token = tokens[i];
        if (typeof token === "string") specs.push(token.charAt(0) === "-" ? {
            field: token.substring(1),
            order: -1
        } : {
            field: token,
            order: 1
        });
        else if (typeof token === "function") specs.push({
            func: token
        });
    }
    return specs;
}
function $307e0d89efad9a8a$export$306ddfe3a8403e2(obj0, obj1, fieldSpecs) {
    var i;
    var cmp;
    for(i = 0; i < fieldSpecs.length; i += 1){
        cmp = $307e0d89efad9a8a$var$compareByFieldSpec(obj0, obj1, fieldSpecs[i]);
        if (cmp) return cmp;
    }
    return 0;
}
function $307e0d89efad9a8a$var$compareByFieldSpec(obj0, obj1, fieldSpec) {
    if (fieldSpec.func) return fieldSpec.func(obj0, obj1);
    return $307e0d89efad9a8a$export$7a38258bbe170828(obj0[fieldSpec.field], obj1[fieldSpec.field]) * (fieldSpec.order || 1);
}
function $307e0d89efad9a8a$export$7a38258bbe170828(a, b) {
    if (!a && !b) return 0;
    if (b == null) return -1;
    if (a == null) return 1;
    if (typeof a === "string" || typeof b === "string") return String(a).localeCompare(String(b));
    return a - b;
}
/* String Utilities
----------------------------------------------------------------------------------------------------------------------*/ function $307e0d89efad9a8a$export$21579262ef46735b(val, len) {
    var s = String(val);
    return "000".substr(0, len - s.length) + s;
}
function $307e0d89efad9a8a$export$342063e11d6c3cad(formatter, args, fallbackText) {
    if (typeof formatter === "function") return formatter.apply(void 0, (0, $79xu7._)(args));
    if (typeof formatter === "string") return args.reduce(function(str, arg, index) {
        return str.replace("$" + index, arg || "");
    }, formatter);
    return fallbackText;
}
/* Number Utilities
----------------------------------------------------------------------------------------------------------------------*/ function $307e0d89efad9a8a$export$493d36ec626b6698(a, b) {
    return a - b;
}
function $307e0d89efad9a8a$export$ab83b03e4111b1d0(n) {
    return n % 1 === 0;
}
/* FC-specific DOM dimension stuff
----------------------------------------------------------------------------------------------------------------------*/ function $307e0d89efad9a8a$var$computeSmallestCellWidth(cellEl) {
    var allWidthEl = cellEl.querySelector(".fc-scrollgrid-shrink-frame");
    var contentWidthEl = cellEl.querySelector(".fc-scrollgrid-shrink-cushion");
    if (!allWidthEl) throw new Error("needs fc-scrollgrid-shrink-frame className"); // TODO: use const
    if (!contentWidthEl) throw new Error("needs fc-scrollgrid-shrink-cushion className");
    return cellEl.getBoundingClientRect().width - allWidthEl.getBoundingClientRect().width + // the cell padding+border
    contentWidthEl.getBoundingClientRect().width;
}
var $307e0d89efad9a8a$var$INTERNAL_UNITS = [
    "years",
    "months",
    "days",
    "milliseconds"
];
var $307e0d89efad9a8a$var$PARSE_RE = /^(-?)(?:(\d+)\.)?(\d+):(\d\d)(?::(\d\d)(?:\.(\d\d\d))?)?/;
// Parsing and Creation
function $307e0d89efad9a8a$export$4368d992c4eafac0(input, unit) {
    if (typeof input === "string") return $307e0d89efad9a8a$var$parseString(input);
    if (typeof input === "object" && input) return $307e0d89efad9a8a$var$parseObject(input);
    if (typeof input === "number") return $307e0d89efad9a8a$var$parseObject({
        [unit || "milliseconds"]: input
    });
    return null;
}
function $307e0d89efad9a8a$var$parseString(s) {
    var m = $307e0d89efad9a8a$var$PARSE_RE.exec(s);
    if (m) {
        var sign = m[1] ? -1 : 1;
        return {
            years: 0,
            months: 0,
            days: sign * (m[2] ? parseInt(m[2], 10) : 0),
            milliseconds: sign * ((m[3] ? parseInt(m[3], 10) : 0) * 3600000 + // hours
            (m[4] ? parseInt(m[4], 10) : 0) * 60000 + // minutes
            (m[5] ? parseInt(m[5], 10) : 0) * 1000 + // seconds
            (m[6] ? parseInt(m[6], 10) : 0 // ms
            ))
        };
    }
    return null;
}
function $307e0d89efad9a8a$var$parseObject(obj) {
    var duration = {
        years: obj.years || obj.year || 0,
        months: obj.months || obj.month || 0,
        days: obj.days || obj.day || 0,
        milliseconds: (obj.hours || obj.hour || 0) * 3600000 + // hours
        (obj.minutes || obj.minute || 0) * 60000 + // minutes
        (obj.seconds || obj.second || 0) * 1000 + // seconds
        (obj.milliseconds || obj.millisecond || obj.ms || 0)
    };
    var weeks = obj.weeks || obj.week;
    if (weeks) {
        duration.days += weeks * 7;
        duration.specifiedWeeks = true;
    }
    return duration;
}
// Equality
function $307e0d89efad9a8a$var$durationsEqual(d0, d1) {
    return d0.years === d1.years && d0.months === d1.months && d0.days === d1.days && d0.milliseconds === d1.milliseconds;
}
function $307e0d89efad9a8a$export$a36fb7d24305ed9d(dur) {
    if (!dur.years && !dur.months && !dur.milliseconds) return dur.days;
    return 0;
}
// Simple Math
function $307e0d89efad9a8a$export$acf3ba20e47771d(d0, d1) {
    return {
        years: d0.years + d1.years,
        months: d0.months + d1.months,
        days: d0.days + d1.days,
        milliseconds: d0.milliseconds + d1.milliseconds
    };
}
function $307e0d89efad9a8a$export$2408f22a0fab9ae5(d1, d0) {
    return {
        years: d1.years - d0.years,
        months: d1.months - d0.months,
        days: d1.days - d0.days,
        milliseconds: d1.milliseconds - d0.milliseconds
    };
}
function $307e0d89efad9a8a$export$55ff3cc1821e8445(d, n) {
    return {
        years: d.years * n,
        months: d.months * n,
        days: d.days * n,
        milliseconds: d.milliseconds * n
    };
}
// Conversions
// "Rough" because they are based on average-case Gregorian months/years
function $307e0d89efad9a8a$var$asRoughYears(dur) {
    return $307e0d89efad9a8a$var$asRoughDays(dur) / 365;
}
function $307e0d89efad9a8a$var$asRoughMonths(dur) {
    return $307e0d89efad9a8a$var$asRoughDays(dur) / 30;
}
function $307e0d89efad9a8a$var$asRoughDays(dur) {
    return $307e0d89efad9a8a$export$4b170465d7badfa1(dur) / 864e5;
}
function $307e0d89efad9a8a$export$847533e5bf524f5f(dur) {
    return $307e0d89efad9a8a$export$4b170465d7badfa1(dur) / 60000;
}
function $307e0d89efad9a8a$export$b169257caa88022a(dur) {
    return $307e0d89efad9a8a$export$4b170465d7badfa1(dur) / 1000;
}
function $307e0d89efad9a8a$export$4b170465d7badfa1(dur) {
    return dur.years * (365 * 864e5) + dur.months * (30 * 864e5) + dur.days * 864e5 + dur.milliseconds;
}
// Advanced Math
function $307e0d89efad9a8a$export$479ac0420f53ed26(numerator, denominator) {
    var res = null;
    for(var i = 0; i < $307e0d89efad9a8a$var$INTERNAL_UNITS.length; i += 1){
        var unit = $307e0d89efad9a8a$var$INTERNAL_UNITS[i];
        if (denominator[unit]) {
            var localRes = numerator[unit] / denominator[unit];
            if (!$307e0d89efad9a8a$export$ab83b03e4111b1d0(localRes) || res !== null && res !== localRes) return null;
            res = localRes;
        } else if (numerator[unit]) // needs to divide by something but can't!
        return null;
    }
    return res;
}
function $307e0d89efad9a8a$export$db3b6bfb95261072(dur) {
    var ms = dur.milliseconds;
    if (ms) {
        if (ms % 1000 !== 0) return {
            unit: "millisecond",
            value: ms
        };
        if (ms % 60000 !== 0) return {
            unit: "second",
            value: ms / 1000
        };
        if (ms % 3600000 !== 0) return {
            unit: "minute",
            value: ms / 60000
        };
        if (ms) return {
            unit: "hour",
            value: ms / 3600000
        };
    }
    if (dur.days) {
        if (dur.specifiedWeeks && dur.days % 7 === 0) return {
            unit: "week",
            value: dur.days / 7
        };
        return {
            unit: "day",
            value: dur.days
        };
    }
    if (dur.months) return {
        unit: "month",
        value: dur.months
    };
    if (dur.years) return {
        unit: "year",
        value: dur.years
    };
    return {
        unit: "millisecond",
        value: 0
    };
}
// TODO: new util arrayify?
function $307e0d89efad9a8a$export$3d12bd131bb975d1(array, exactVal) {
    var removeCnt = 0;
    var i = 0;
    while(i < array.length)if (array[i] === exactVal) {
        array.splice(i, 1);
        removeCnt += 1;
    } else i += 1;
    return removeCnt;
}
function $307e0d89efad9a8a$export$23f2a1d2818174ef(a0, a1, equalityFunc) {
    if (a0 === a1) return true;
    var len = a0.length;
    var i;
    if (len !== a1.length) return false;
    for(i = 0; i < len; i += 1){
        if (!(equalityFunc ? equalityFunc(a0[i], a1[i]) : a0[i] === a1[i])) return false;
    }
    return true;
}
var $307e0d89efad9a8a$var$DAY_IDS = [
    "sun",
    "mon",
    "tue",
    "wed",
    "thu",
    "fri",
    "sat"
];
// Adding
function $307e0d89efad9a8a$export$151db275011178c4(m, n) {
    var a = $307e0d89efad9a8a$var$dateToUtcArray(m);
    a[2] += n * 7;
    return $307e0d89efad9a8a$var$arrayToUtcDate(a);
}
function $307e0d89efad9a8a$export$625550452a3fa3ec(m, n) {
    var a = $307e0d89efad9a8a$var$dateToUtcArray(m);
    a[2] += n;
    return $307e0d89efad9a8a$var$arrayToUtcDate(a);
}
function $307e0d89efad9a8a$export$51b138e5a065c2bb(m, n) {
    var a = $307e0d89efad9a8a$var$dateToUtcArray(m);
    a[6] += n;
    return $307e0d89efad9a8a$var$arrayToUtcDate(a);
}
// Diffing (all return floats)
// TODO: why not use ranges?
function $307e0d89efad9a8a$export$136fd86de524d3c2(m0, m1) {
    return $307e0d89efad9a8a$export$b4d5ecaefe2b27f3(m0, m1) / 7;
}
function $307e0d89efad9a8a$export$b4d5ecaefe2b27f3(m0, m1) {
    return (m1.valueOf() - m0.valueOf()) / 86400000;
}
function $307e0d89efad9a8a$var$diffHours(m0, m1) {
    return (m1.valueOf() - m0.valueOf()) / 3600000;
}
function $307e0d89efad9a8a$var$diffMinutes(m0, m1) {
    return (m1.valueOf() - m0.valueOf()) / 60000;
}
function $307e0d89efad9a8a$var$diffSeconds(m0, m1) {
    return (m1.valueOf() - m0.valueOf()) / 1000;
}
function $307e0d89efad9a8a$export$62d08d6fa708df47(m0, m1) {
    var m0day = $307e0d89efad9a8a$export$9e5f44173e64f162(m0);
    var m1day = $307e0d89efad9a8a$export$9e5f44173e64f162(m1);
    return {
        years: 0,
        months: 0,
        days: Math.round($307e0d89efad9a8a$export$b4d5ecaefe2b27f3(m0day, m1day)),
        milliseconds: m1.valueOf() - m1day.valueOf() - (m0.valueOf() - m0day.valueOf())
    };
}
// Diffing Whole Units
function $307e0d89efad9a8a$export$31e67cf12fc9668(m0, m1) {
    var d = $307e0d89efad9a8a$export$4a5767248b18ef41(m0, m1);
    if (d !== null && d % 7 === 0) return d / 7;
    return null;
}
function $307e0d89efad9a8a$export$4a5767248b18ef41(m0, m1) {
    if ($307e0d89efad9a8a$var$timeAsMs(m0) === $307e0d89efad9a8a$var$timeAsMs(m1)) return Math.round($307e0d89efad9a8a$export$b4d5ecaefe2b27f3(m0, m1));
    return null;
}
// Start-Of
function $307e0d89efad9a8a$export$9e5f44173e64f162(m) {
    return $307e0d89efad9a8a$var$arrayToUtcDate([
        m.getUTCFullYear(),
        m.getUTCMonth(),
        m.getUTCDate()
    ]);
}
function $307e0d89efad9a8a$var$startOfHour(m) {
    return $307e0d89efad9a8a$var$arrayToUtcDate([
        m.getUTCFullYear(),
        m.getUTCMonth(),
        m.getUTCDate(),
        m.getUTCHours()
    ]);
}
function $307e0d89efad9a8a$var$startOfMinute(m) {
    return $307e0d89efad9a8a$var$arrayToUtcDate([
        m.getUTCFullYear(),
        m.getUTCMonth(),
        m.getUTCDate(),
        m.getUTCHours(),
        m.getUTCMinutes()
    ]);
}
function $307e0d89efad9a8a$var$startOfSecond(m) {
    return $307e0d89efad9a8a$var$arrayToUtcDate([
        m.getUTCFullYear(),
        m.getUTCMonth(),
        m.getUTCDate(),
        m.getUTCHours(),
        m.getUTCMinutes(),
        m.getUTCSeconds()
    ]);
}
// Week Computation
function $307e0d89efad9a8a$var$weekOfYear(marker, dow, doy) {
    var y = marker.getUTCFullYear();
    var w = $307e0d89efad9a8a$var$weekOfGivenYear(marker, y, dow, doy);
    if (w < 1) return $307e0d89efad9a8a$var$weekOfGivenYear(marker, y - 1, dow, doy);
    var nextW = $307e0d89efad9a8a$var$weekOfGivenYear(marker, y + 1, dow, doy);
    if (nextW >= 1) return Math.min(w, nextW);
    return w;
}
function $307e0d89efad9a8a$var$weekOfGivenYear(marker, year, dow, doy) {
    var firstWeekStart = $307e0d89efad9a8a$var$arrayToUtcDate([
        year,
        0,
        1 + $307e0d89efad9a8a$var$firstWeekOffset(year, dow, doy)
    ]);
    var dayStart = $307e0d89efad9a8a$export$9e5f44173e64f162(marker);
    var days = Math.round($307e0d89efad9a8a$export$b4d5ecaefe2b27f3(firstWeekStart, dayStart));
    return Math.floor(days / 7) + 1; // zero-indexed
}
// start-of-first-week - start-of-year
function $307e0d89efad9a8a$var$firstWeekOffset(year, dow, doy) {
    // first-week day -- which january is always in the first week (4 for iso, 1 for other)
    var fwd = 7 + dow - doy;
    // first-week day local weekday -- which local weekday is fwd
    var fwdlw = (7 + $307e0d89efad9a8a$var$arrayToUtcDate([
        year,
        0,
        fwd
    ]).getUTCDay() - dow) % 7;
    return -fwdlw + fwd - 1;
}
// Array Conversion
function $307e0d89efad9a8a$var$dateToLocalArray(date) {
    return [
        date.getFullYear(),
        date.getMonth(),
        date.getDate(),
        date.getHours(),
        date.getMinutes(),
        date.getSeconds(),
        date.getMilliseconds()
    ];
}
function $307e0d89efad9a8a$var$arrayToLocalDate(a) {
    return new Date(a[0], a[1] || 0, a[2] == null ? 1 : a[2], a[3] || 0, a[4] || 0, a[5] || 0);
}
function $307e0d89efad9a8a$var$dateToUtcArray(date) {
    return [
        date.getUTCFullYear(),
        date.getUTCMonth(),
        date.getUTCDate(),
        date.getUTCHours(),
        date.getUTCMinutes(),
        date.getUTCSeconds(),
        date.getUTCMilliseconds()
    ];
}
function $307e0d89efad9a8a$var$arrayToUtcDate(a) {
    var _Date;
    // according to web standards (and Safari), a month index is required.
    // massage if only given a year.
    if (a.length === 1) a = a.concat([
        0
    ]);
    return new Date((_Date = Date).UTC.apply(_Date, (0, $79xu7._)(a)));
}
// Other Utils
function $307e0d89efad9a8a$export$5521614468b862fb(m) {
    return !isNaN(m.valueOf());
}
function $307e0d89efad9a8a$var$timeAsMs(m) {
    return m.getUTCHours() * 3600000 + m.getUTCMinutes() * 60000 + m.getUTCSeconds() * 1000 + m.getUTCMilliseconds();
}
// timeZoneOffset is in minutes
function $307e0d89efad9a8a$export$f438b12253c2b499(marker, timeZoneOffset) {
    var stripZeroTime = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var s = marker.toISOString();
    s = s.replace(".000", "");
    if (stripZeroTime) s = s.replace("T00:00:00Z", "");
    if (s.length > 10) {
        if (timeZoneOffset == null) s = s.replace("Z", "");
        else if (timeZoneOffset !== 0) s = s.replace("Z", $307e0d89efad9a8a$var$formatTimeZoneOffset(timeZoneOffset, true));
    // otherwise, its UTC-0 and we want to keep the Z
    }
    return s;
}
// formats the date, but with no time part
// TODO: somehow merge with buildIsoString and stripZeroTime
// TODO: rename. omit "string"
function $307e0d89efad9a8a$export$56350196709588fc(marker) {
    return marker.toISOString().replace(/T.*$/, "");
}
function $307e0d89efad9a8a$export$5dbe06c6d8c68cfb(marker) {
    return marker.toISOString().match(/^\d{4}-\d{2}/)[0];
}
// TODO: use Date::toISOString and use everything after the T?
function $307e0d89efad9a8a$export$4e222d082f82ee97(marker) {
    return $307e0d89efad9a8a$export$21579262ef46735b(marker.getUTCHours(), 2) + ":" + $307e0d89efad9a8a$export$21579262ef46735b(marker.getUTCMinutes(), 2) + ":" + $307e0d89efad9a8a$export$21579262ef46735b(marker.getUTCSeconds(), 2);
}
function $307e0d89efad9a8a$var$formatTimeZoneOffset(minutes) {
    var doIso = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var sign = minutes < 0 ? "-" : "+";
    var abs = Math.abs(minutes);
    var hours = Math.floor(abs / 60);
    var mins = Math.round(abs % 60);
    if (doIso) return "".concat(sign + $307e0d89efad9a8a$export$21579262ef46735b(hours, 2), ":").concat($307e0d89efad9a8a$export$21579262ef46735b(mins, 2));
    return "GMT".concat(sign).concat(hours).concat(mins ? ":".concat($307e0d89efad9a8a$export$21579262ef46735b(mins, 2)) : "");
}
function $307e0d89efad9a8a$export$df995fae86a55f06(workerFunc, resEquality, teardownFunc) {
    var currentArgs;
    var currentRes;
    return function() {
        for(var _len = arguments.length, newArgs = new Array(_len), _key = 0; _key < _len; _key++){
            newArgs[_key] = arguments[_key];
        }
        if (!currentArgs) currentRes = workerFunc.apply(this, newArgs);
        else if (!$307e0d89efad9a8a$export$23f2a1d2818174ef(currentArgs, newArgs)) {
            if (teardownFunc) teardownFunc(currentRes);
            var res = workerFunc.apply(this, newArgs);
            if (!resEquality || !resEquality(res, currentRes)) currentRes = res;
        }
        currentArgs = newArgs;
        return currentRes;
    };
}
function $307e0d89efad9a8a$export$ebd11618f299a286(workerFunc, resEquality, teardownFunc) {
    var _this = this;
    var currentArg;
    var currentRes;
    return function(newArg) {
        if (!currentArg) currentRes = workerFunc.call(_this, newArg);
        else if (!$307e0d89efad9a8a$export$a9c23c6ac3fc3eca(currentArg, newArg)) {
            if (teardownFunc) teardownFunc(currentRes);
            var res = workerFunc.call(_this, newArg);
            if (!resEquality || !resEquality(res, currentRes)) currentRes = res;
        }
        currentArg = newArg;
        return currentRes;
    };
}
function $307e0d89efad9a8a$export$91c6e00c14e7e6fd(workerFunc, resEquality, teardownFunc) {
    var _this = this;
    var currentArgSets = [];
    var currentResults = [];
    return function(newArgSets) {
        var currentLen = currentArgSets.length;
        var newLen = newArgSets.length;
        var i = 0;
        for(; i < currentLen; i += 1){
            if (!newArgSets[i]) {
                if (teardownFunc) teardownFunc(currentResults[i]);
            } else if (!$307e0d89efad9a8a$export$23f2a1d2818174ef(currentArgSets[i], newArgSets[i])) {
                if (teardownFunc) teardownFunc(currentResults[i]);
                var res = workerFunc.apply(_this, newArgSets[i]);
                if (!resEquality || !resEquality(res, currentResults[i])) currentResults[i] = res;
            }
        }
        for(; i < newLen; i += 1)currentResults[i] = workerFunc.apply(_this, newArgSets[i]);
        currentArgSets = newArgSets;
        currentResults.splice(newLen); // remove excess
        return currentResults;
    };
}
function $307e0d89efad9a8a$export$9d398bebfec1c039(workerFunc, resEquality, teardownFunc) {
    var _this = this;
    var currentArgHash = {};
    var currentResHash = {};
    return function(newArgHash) {
        var newResHash = {};
        for(var key in newArgHash){
            if (!currentResHash[key]) newResHash[key] = workerFunc.apply(_this, newArgHash[key]);
            else if (!$307e0d89efad9a8a$export$23f2a1d2818174ef(currentArgHash[key], newArgHash[key])) {
                if (teardownFunc) teardownFunc(currentResHash[key]);
                var res = workerFunc.apply(_this, newArgHash[key]);
                newResHash[key] = resEquality && resEquality(res, currentResHash[key]) ? currentResHash[key] : res;
            } else newResHash[key] = currentResHash[key];
        }
        currentArgHash = newArgHash;
        currentResHash = newResHash;
        return newResHash;
    };
}
var $307e0d89efad9a8a$var$EXTENDED_SETTINGS_AND_SEVERITIES = {
    week: 3,
    separator: 9,
    omitZeroMinute: 9,
    meridiem: 9,
    omitCommas: 9
};
var $307e0d89efad9a8a$var$STANDARD_DATE_PROP_SEVERITIES = {
    timeZoneName: 7,
    era: 6,
    year: 5,
    month: 4,
    day: 2,
    weekday: 2,
    hour: 1,
    minute: 1,
    second: 1
};
var $307e0d89efad9a8a$var$MERIDIEM_RE = /\s*([ap])\.?m\.?/i; // eats up leading spaces too
var $307e0d89efad9a8a$var$COMMA_RE = /,/g; // we need re for globalness
var $307e0d89efad9a8a$var$MULTI_SPACE_RE = /\s+/g;
var $307e0d89efad9a8a$var$LTR_RE = /\u200e/g; // control character
var $307e0d89efad9a8a$var$UTC_RE = /UTC|GMT/;
var $307e0d89efad9a8a$var$NativeFormatter = /*#__PURE__*/ function() {
    "use strict";
    function NativeFormatter(formatSettings) {
        (0, $luoZD._)(this, NativeFormatter);
        var standardDateProps = {};
        var extendedSettings = {};
        var smallestUnitNum = 9; // the smallest unit in the formatter (9 is a sentinel, beyond max)
        for(var name in formatSettings)if (name in $307e0d89efad9a8a$var$EXTENDED_SETTINGS_AND_SEVERITIES) {
            extendedSettings[name] = formatSettings[name];
            var severity = $307e0d89efad9a8a$var$EXTENDED_SETTINGS_AND_SEVERITIES[name];
            if (severity < 9) smallestUnitNum = Math.min($307e0d89efad9a8a$var$EXTENDED_SETTINGS_AND_SEVERITIES[name], smallestUnitNum);
        } else {
            standardDateProps[name] = formatSettings[name];
            if (name in $307e0d89efad9a8a$var$STANDARD_DATE_PROP_SEVERITIES) smallestUnitNum = Math.min($307e0d89efad9a8a$var$STANDARD_DATE_PROP_SEVERITIES[name], smallestUnitNum);
        }
        this.standardDateProps = standardDateProps;
        this.extendedSettings = extendedSettings;
        this.smallestUnitNum = smallestUnitNum;
        this.buildFormattingFunc = $307e0d89efad9a8a$export$df995fae86a55f06($307e0d89efad9a8a$var$buildFormattingFunc);
    }
    (0, $fYUO3._)(NativeFormatter, [
        {
            key: "format",
            value: function format(date, context) {
                return this.buildFormattingFunc(this.standardDateProps, this.extendedSettings, context)(date);
            }
        },
        {
            key: "formatRange",
            value: function formatRange(start, end, context, betterDefaultSeparator) {
                var _this = this, standardDateProps = _this.standardDateProps, extendedSettings = _this.extendedSettings;
                var diffSeverity = $307e0d89efad9a8a$var$computeMarkerDiffSeverity(start.marker, end.marker, context.calendarSystem);
                if (!diffSeverity) return this.format(start, context);
                var biggestUnitForPartial = diffSeverity;
                if (biggestUnitForPartial > 1 && // the two dates are different in a way that's larger scale than time
                (standardDateProps.year === "numeric" || standardDateProps.year === "2-digit") && (standardDateProps.month === "numeric" || standardDateProps.month === "2-digit") && (standardDateProps.day === "numeric" || standardDateProps.day === "2-digit")) biggestUnitForPartial = 1; // make it look like the dates are only different in terms of time
                var full0 = this.format(start, context);
                var full1 = this.format(end, context);
                if (full0 === full1) return full0;
                var partialDateProps = $307e0d89efad9a8a$var$computePartialFormattingOptions(standardDateProps, biggestUnitForPartial);
                var partialFormattingFunc = $307e0d89efad9a8a$var$buildFormattingFunc(partialDateProps, extendedSettings, context);
                var partial0 = partialFormattingFunc(start);
                var partial1 = partialFormattingFunc(end);
                var insertion = $307e0d89efad9a8a$var$findCommonInsertion(full0, partial0, full1, partial1);
                var separator = extendedSettings.separator || betterDefaultSeparator || context.defaultSeparator || "";
                if (insertion) return insertion.before + partial0 + separator + partial1 + insertion.after;
                return full0 + separator + full1;
            }
        },
        {
            key: "getSmallestUnit",
            value: function getSmallestUnit() {
                switch(this.smallestUnitNum){
                    case 7:
                    case 6:
                    case 5:
                        return "year";
                    case 4:
                        return "month";
                    case 3:
                        return "week";
                    case 2:
                        return "day";
                    default:
                        return "time"; // really?
                }
            }
        }
    ]);
    return NativeFormatter;
}();
function $307e0d89efad9a8a$var$buildFormattingFunc(standardDateProps, extendedSettings, context) {
    var standardDatePropCnt = Object.keys(standardDateProps).length;
    if (standardDatePropCnt === 1 && standardDateProps.timeZoneName === "short") return function(date) {
        return $307e0d89efad9a8a$var$formatTimeZoneOffset(date.timeZoneOffset);
    };
    if (standardDatePropCnt === 0 && extendedSettings.week) return function(date) {
        return $307e0d89efad9a8a$var$formatWeekNumber(context.computeWeekNumber(date.marker), context.weekText, context.weekTextLong, context.locale, extendedSettings.week);
    };
    return $307e0d89efad9a8a$var$buildNativeFormattingFunc(standardDateProps, extendedSettings, context);
}
function $307e0d89efad9a8a$var$buildNativeFormattingFunc(standardDateProps, extendedSettings, context) {
    standardDateProps = Object.assign({}, standardDateProps); // copy
    extendedSettings = Object.assign({}, extendedSettings); // copy
    $307e0d89efad9a8a$var$sanitizeSettings(standardDateProps, extendedSettings);
    standardDateProps.timeZone = "UTC"; // we leverage the only guaranteed timeZone for our UTC markers
    var normalFormat = new Intl.DateTimeFormat(context.locale.codes, standardDateProps);
    var zeroFormat; // needed?
    if (extendedSettings.omitZeroMinute) {
        var zeroProps = Object.assign({}, standardDateProps);
        delete zeroProps.minute; // seconds and ms were already considered in sanitizeSettings
        zeroFormat = new Intl.DateTimeFormat(context.locale.codes, zeroProps);
    }
    return function(date) {
        var marker = date.marker;
        var format;
        if (zeroFormat && !marker.getUTCMinutes()) format = zeroFormat;
        else format = normalFormat;
        var s = format.format(marker);
        return $307e0d89efad9a8a$var$postProcess(s, date, standardDateProps, extendedSettings, context);
    };
}
function $307e0d89efad9a8a$var$sanitizeSettings(standardDateProps, extendedSettings) {
    // deal with a browser inconsistency where formatting the timezone
    // requires that the hour/minute be present.
    if (standardDateProps.timeZoneName) {
        if (!standardDateProps.hour) standardDateProps.hour = "2-digit";
        if (!standardDateProps.minute) standardDateProps.minute = "2-digit";
    }
    // only support short timezone names
    if (standardDateProps.timeZoneName === "long") standardDateProps.timeZoneName = "short";
    // if requesting to display seconds, MUST display minutes
    if (extendedSettings.omitZeroMinute && (standardDateProps.second || standardDateProps.millisecond)) delete extendedSettings.omitZeroMinute;
}
function $307e0d89efad9a8a$var$postProcess(s, date, standardDateProps, extendedSettings, context) {
    s = s.replace($307e0d89efad9a8a$var$LTR_RE, ""); // remove left-to-right control chars. do first. good for other regexes
    if (standardDateProps.timeZoneName === "short") s = $307e0d89efad9a8a$var$injectTzoStr(s, context.timeZone === "UTC" || date.timeZoneOffset == null ? "UTC" : $307e0d89efad9a8a$var$formatTimeZoneOffset(date.timeZoneOffset));
    if (extendedSettings.omitCommas) s = s.replace($307e0d89efad9a8a$var$COMMA_RE, "").trim();
    if (extendedSettings.omitZeroMinute) s = s.replace(":00", ""); // zeroFormat doesn't always achieve this
    // ^ do anything that might create adjacent spaces before this point,
    // because MERIDIEM_RE likes to eat up loading spaces
    if (extendedSettings.meridiem === false) s = s.replace($307e0d89efad9a8a$var$MERIDIEM_RE, "").trim();
    else if (extendedSettings.meridiem === "narrow") s = s.replace($307e0d89efad9a8a$var$MERIDIEM_RE, function(m0, m1) {
        return m1.toLocaleLowerCase();
    });
    else if (extendedSettings.meridiem === "short") s = s.replace($307e0d89efad9a8a$var$MERIDIEM_RE, function(m0, m1) {
        return "".concat(m1.toLocaleLowerCase(), "m");
    });
    else if (extendedSettings.meridiem === "lowercase") s = s.replace($307e0d89efad9a8a$var$MERIDIEM_RE, function(m0) {
        return m0.toLocaleLowerCase();
    });
    s = s.replace($307e0d89efad9a8a$var$MULTI_SPACE_RE, " ");
    s = s.trim();
    return s;
}
function $307e0d89efad9a8a$var$injectTzoStr(s, tzoStr) {
    var replaced = false;
    s = s.replace($307e0d89efad9a8a$var$UTC_RE, function() {
        replaced = true;
        return tzoStr;
    });
    // IE11 doesn't include UTC/GMT in the original string, so append to end
    if (!replaced) s += " ".concat(tzoStr);
    return s;
}
function $307e0d89efad9a8a$var$formatWeekNumber(num, weekText, weekTextLong, locale, display) {
    var parts = [];
    if (display === "long") parts.push(weekTextLong);
    else if (display === "short" || display === "narrow") parts.push(weekText);
    if (display === "long" || display === "short") parts.push(" ");
    parts.push(locale.simpleNumberFormat.format(num));
    if (locale.options.direction === "rtl") parts.reverse();
    return parts.join("");
}
// Range Formatting Utils
// 0 = exactly the same
// 1 = different by time
// and bigger
function $307e0d89efad9a8a$var$computeMarkerDiffSeverity(d0, d1, ca) {
    if (ca.getMarkerYear(d0) !== ca.getMarkerYear(d1)) return 5;
    if (ca.getMarkerMonth(d0) !== ca.getMarkerMonth(d1)) return 4;
    if (ca.getMarkerDay(d0) !== ca.getMarkerDay(d1)) return 2;
    if ($307e0d89efad9a8a$var$timeAsMs(d0) !== $307e0d89efad9a8a$var$timeAsMs(d1)) return 1;
    return 0;
}
function $307e0d89efad9a8a$var$computePartialFormattingOptions(options, biggestUnit) {
    var partialOptions = {};
    for(var name in options)if (!(name in $307e0d89efad9a8a$var$STANDARD_DATE_PROP_SEVERITIES) || // not a date part prop (like timeZone)
    $307e0d89efad9a8a$var$STANDARD_DATE_PROP_SEVERITIES[name] <= biggestUnit) partialOptions[name] = options[name];
    return partialOptions;
}
function $307e0d89efad9a8a$var$findCommonInsertion(full0, partial0, full1, partial1) {
    var i0 = 0;
    while(i0 < full0.length){
        var found0 = full0.indexOf(partial0, i0);
        if (found0 === -1) break;
        var before0 = full0.substr(0, found0);
        i0 = found0 + partial0.length;
        var after0 = full0.substr(i0);
        var i1 = 0;
        while(i1 < full1.length){
            var found1 = full1.indexOf(partial1, i1);
            if (found1 === -1) break;
            var before1 = full1.substr(0, found1);
            i1 = found1 + partial1.length;
            var after1 = full1.substr(i1);
            if (before0 === before1 && after0 === after1) return {
                before: before0,
                after: after0
            };
        }
    }
    return null;
}
function $307e0d89efad9a8a$var$expandZonedMarker(dateInfo, calendarSystem) {
    var a = calendarSystem.markerToArray(dateInfo.marker);
    return {
        marker: dateInfo.marker,
        timeZoneOffset: dateInfo.timeZoneOffset,
        array: a,
        year: a[0],
        month: a[1],
        day: a[2],
        hour: a[3],
        minute: a[4],
        second: a[5],
        millisecond: a[6]
    };
}
function $307e0d89efad9a8a$var$createVerboseFormattingArg(start, end, context, betterDefaultSeparator) {
    var startInfo = $307e0d89efad9a8a$var$expandZonedMarker(start, context.calendarSystem);
    var endInfo = end ? $307e0d89efad9a8a$var$expandZonedMarker(end, context.calendarSystem) : null;
    return {
        date: startInfo,
        start: startInfo,
        end: endInfo,
        timeZone: context.timeZone,
        localeCodes: context.locale.codes,
        defaultSeparator: betterDefaultSeparator || context.defaultSeparator
    };
}
/*
TODO: fix the terminology of "formatter" vs "formatting func"
*/ /*
At the time of instantiation, this object does not know which cmd-formatting system it will use.
It receives this at the time of formatting, as a setting.
*/ var $307e0d89efad9a8a$var$CmdFormatter = /*#__PURE__*/ function() {
    "use strict";
    function CmdFormatter(cmdStr) {
        (0, $luoZD._)(this, CmdFormatter);
        this.cmdStr = cmdStr;
    }
    (0, $fYUO3._)(CmdFormatter, [
        {
            key: "format",
            value: function format(date, context, betterDefaultSeparator) {
                return context.cmdFormatter(this.cmdStr, $307e0d89efad9a8a$var$createVerboseFormattingArg(date, null, context, betterDefaultSeparator));
            }
        },
        {
            key: "formatRange",
            value: function formatRange(start, end, context, betterDefaultSeparator) {
                return context.cmdFormatter(this.cmdStr, $307e0d89efad9a8a$var$createVerboseFormattingArg(start, end, context, betterDefaultSeparator));
            }
        }
    ]);
    return CmdFormatter;
}();
var $307e0d89efad9a8a$var$FuncFormatter = /*#__PURE__*/ function() {
    "use strict";
    function FuncFormatter(func) {
        (0, $luoZD._)(this, FuncFormatter);
        this.func = func;
    }
    (0, $fYUO3._)(FuncFormatter, [
        {
            key: "format",
            value: function format(date, context, betterDefaultSeparator) {
                return this.func($307e0d89efad9a8a$var$createVerboseFormattingArg(date, null, context, betterDefaultSeparator));
            }
        },
        {
            key: "formatRange",
            value: function formatRange(start, end, context, betterDefaultSeparator) {
                return this.func($307e0d89efad9a8a$var$createVerboseFormattingArg(start, end, context, betterDefaultSeparator));
            }
        }
    ]);
    return FuncFormatter;
}();
function $307e0d89efad9a8a$export$d141bba7fdc215a3(input) {
    if (typeof input === "object" && input) return new $307e0d89efad9a8a$var$NativeFormatter(input);
    if (typeof input === "string") return new $307e0d89efad9a8a$var$CmdFormatter(input);
    if (typeof input === "function") return new $307e0d89efad9a8a$var$FuncFormatter(input);
    return null;
}
// base options
// ------------
var $307e0d89efad9a8a$export$61196ced6d74a310 = {
    navLinkDayClick: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    navLinkWeekClick: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    duration: $307e0d89efad9a8a$export$4368d992c4eafac0,
    bootstrapFontAwesome: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    buttonIcons: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    customButtons: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    defaultAllDayEventDuration: $307e0d89efad9a8a$export$4368d992c4eafac0,
    defaultTimedEventDuration: $307e0d89efad9a8a$export$4368d992c4eafac0,
    nextDayThreshold: $307e0d89efad9a8a$export$4368d992c4eafac0,
    scrollTime: $307e0d89efad9a8a$export$4368d992c4eafac0,
    scrollTimeReset: Boolean,
    slotMinTime: $307e0d89efad9a8a$export$4368d992c4eafac0,
    slotMaxTime: $307e0d89efad9a8a$export$4368d992c4eafac0,
    dayPopoverFormat: $307e0d89efad9a8a$export$d141bba7fdc215a3,
    slotDuration: $307e0d89efad9a8a$export$4368d992c4eafac0,
    snapDuration: $307e0d89efad9a8a$export$4368d992c4eafac0,
    headerToolbar: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    footerToolbar: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    defaultRangeSeparator: String,
    titleRangeSeparator: String,
    forceEventDuration: Boolean,
    dayHeaders: Boolean,
    dayHeaderFormat: $307e0d89efad9a8a$export$d141bba7fdc215a3,
    dayHeaderClassNames: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    dayHeaderContent: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    dayHeaderDidMount: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    dayHeaderWillUnmount: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    dayCellClassNames: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    dayCellContent: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    dayCellDidMount: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    dayCellWillUnmount: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    initialView: String,
    aspectRatio: Number,
    weekends: Boolean,
    weekNumberCalculation: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    weekNumbers: Boolean,
    weekNumberClassNames: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    weekNumberContent: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    weekNumberDidMount: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    weekNumberWillUnmount: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    editable: Boolean,
    viewClassNames: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    viewDidMount: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    viewWillUnmount: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    nowIndicator: Boolean,
    nowIndicatorSnap: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    nowIndicatorClassNames: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    nowIndicatorContent: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    nowIndicatorDidMount: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    nowIndicatorWillUnmount: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    showNonCurrentDates: Boolean,
    lazyFetching: Boolean,
    startParam: String,
    endParam: String,
    timeZoneParam: String,
    timeZone: String,
    locales: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    locale: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    themeSystem: String,
    dragRevertDuration: Number,
    dragScroll: Boolean,
    allDayMaintainDuration: Boolean,
    unselectAuto: Boolean,
    dropAccept: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    eventOrder: $307e0d89efad9a8a$export$1a82df3d29112e01,
    eventOrderStrict: Boolean,
    handleWindowResize: Boolean,
    windowResizeDelay: Number,
    longPressDelay: Number,
    eventDragMinDistance: Number,
    expandRows: Boolean,
    height: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    contentHeight: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    direction: String,
    weekNumberFormat: $307e0d89efad9a8a$export$d141bba7fdc215a3,
    eventResizableFromStart: Boolean,
    displayEventTime: Boolean,
    displayEventEnd: Boolean,
    weekText: String,
    weekTextLong: String,
    progressiveEventRendering: Boolean,
    businessHours: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    initialDate: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    now: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    eventDataTransform: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    stickyHeaderDates: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    stickyFooterScrollbar: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    viewHeight: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    defaultAllDay: Boolean,
    eventSourceFailure: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    eventSourceSuccess: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    eventDisplay: String,
    eventStartEditable: Boolean,
    eventDurationEditable: Boolean,
    eventOverlap: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    eventConstraint: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    eventAllow: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    eventBackgroundColor: String,
    eventBorderColor: String,
    eventTextColor: String,
    eventColor: String,
    eventClassNames: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    eventContent: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    eventDidMount: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    eventWillUnmount: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    selectConstraint: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    selectOverlap: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    selectAllow: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    droppable: Boolean,
    unselectCancel: String,
    slotLabelFormat: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    slotLaneClassNames: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    slotLaneContent: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    slotLaneDidMount: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    slotLaneWillUnmount: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    slotLabelClassNames: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    slotLabelContent: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    slotLabelDidMount: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    slotLabelWillUnmount: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    dayMaxEvents: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    dayMaxEventRows: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    dayMinWidth: Number,
    slotLabelInterval: $307e0d89efad9a8a$export$4368d992c4eafac0,
    allDayText: String,
    allDayClassNames: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    allDayContent: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    allDayDidMount: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    allDayWillUnmount: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    slotMinWidth: Number,
    navLinks: Boolean,
    eventTimeFormat: $307e0d89efad9a8a$export$d141bba7fdc215a3,
    rerenderDelay: Number,
    moreLinkText: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    moreLinkHint: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    selectMinDistance: Number,
    selectable: Boolean,
    selectLongPressDelay: Number,
    eventLongPressDelay: Number,
    selectMirror: Boolean,
    eventMaxStack: Number,
    eventMinHeight: Number,
    eventMinWidth: Number,
    eventShortHeight: Number,
    slotEventOverlap: Boolean,
    plugins: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    firstDay: Number,
    dayCount: Number,
    dateAlignment: String,
    dateIncrement: $307e0d89efad9a8a$export$4368d992c4eafac0,
    hiddenDays: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    fixedWeekCount: Boolean,
    validRange: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    visibleRange: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    titleFormat: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    eventInteractive: Boolean,
    // only used by list-view, but languages define the value, so we need it in base options
    noEventsText: String,
    viewHint: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    navLinkHint: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    closeHint: String,
    timeHint: String,
    eventHint: String,
    moreLinkClick: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    moreLinkClassNames: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    moreLinkContent: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    moreLinkDidMount: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    moreLinkWillUnmount: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    monthStartFormat: $307e0d89efad9a8a$export$d141bba7fdc215a3,
    // for connectors
    // (can't be part of plugin system b/c must be provided at runtime)
    handleCustomRendering: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    customRenderingMetaMap: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    customRenderingReplaces: Boolean
};
// do NOT give a type here. need `typeof BASE_OPTION_DEFAULTS` to give real results.
// raw values.
var $307e0d89efad9a8a$export$f1e1789686576879 = {
    eventDisplay: "auto",
    defaultRangeSeparator: " - ",
    titleRangeSeparator: " \u2013 ",
    defaultTimedEventDuration: "01:00:00",
    defaultAllDayEventDuration: {
        day: 1
    },
    forceEventDuration: false,
    nextDayThreshold: "00:00:00",
    dayHeaders: true,
    initialView: "",
    aspectRatio: 1.35,
    headerToolbar: {
        start: "title",
        center: "",
        end: "today prev,next"
    },
    weekends: true,
    weekNumbers: false,
    weekNumberCalculation: "local",
    editable: false,
    nowIndicator: false,
    scrollTime: "06:00:00",
    scrollTimeReset: true,
    slotMinTime: "00:00:00",
    slotMaxTime: "24:00:00",
    showNonCurrentDates: true,
    lazyFetching: true,
    startParam: "start",
    endParam: "end",
    timeZoneParam: "timeZone",
    timeZone: "local",
    locales: [],
    locale: "",
    themeSystem: "standard",
    dragRevertDuration: 500,
    dragScroll: true,
    allDayMaintainDuration: false,
    unselectAuto: true,
    dropAccept: "*",
    eventOrder: "start,-duration,allDay,title",
    dayPopoverFormat: {
        month: "long",
        day: "numeric",
        year: "numeric"
    },
    handleWindowResize: true,
    windowResizeDelay: 100,
    longPressDelay: 1000,
    eventDragMinDistance: 5,
    expandRows: false,
    navLinks: false,
    selectable: false,
    eventMinHeight: 15,
    eventMinWidth: 30,
    eventShortHeight: 30,
    monthStartFormat: {
        month: "long",
        day: "numeric"
    },
    nowIndicatorSnap: "auto"
};
// calendar listeners
// ------------------
var $307e0d89efad9a8a$export$3a1a48c8f6ef640e = {
    datesSet: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    eventsSet: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    eventAdd: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    eventChange: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    eventRemove: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    windowResize: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    eventClick: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    eventMouseEnter: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    eventMouseLeave: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    select: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    unselect: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    loading: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    // internal
    _unmount: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    _beforeprint: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    _afterprint: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    _noEventDrop: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    _noEventResize: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    _resize: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    _scrollRequest: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5
};
// calendar-specific options
// -------------------------
var $307e0d89efad9a8a$export$a07804094c3ecf2d = {
    buttonText: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    buttonHints: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    views: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    plugins: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    initialEvents: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    events: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    eventSources: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5
};
var $307e0d89efad9a8a$export$c4ce752e73470fba = {
    headerToolbar: $307e0d89efad9a8a$var$isMaybeObjectsEqual,
    footerToolbar: $307e0d89efad9a8a$var$isMaybeObjectsEqual,
    buttonText: $307e0d89efad9a8a$var$isMaybeObjectsEqual,
    buttonHints: $307e0d89efad9a8a$var$isMaybeObjectsEqual,
    buttonIcons: $307e0d89efad9a8a$var$isMaybeObjectsEqual,
    dateIncrement: $307e0d89efad9a8a$var$isMaybeObjectsEqual,
    plugins: $307e0d89efad9a8a$var$isMaybeArraysEqual,
    events: $307e0d89efad9a8a$var$isMaybeArraysEqual,
    eventSources: $307e0d89efad9a8a$var$isMaybeArraysEqual,
    ["resources"]: $307e0d89efad9a8a$var$isMaybeArraysEqual
};
function $307e0d89efad9a8a$var$isMaybeObjectsEqual(a, b) {
    if (typeof a === "object" && typeof b === "object" && a && b) return $307e0d89efad9a8a$export$a9c23c6ac3fc3eca(a, b);
    return a === b;
}
function $307e0d89efad9a8a$var$isMaybeArraysEqual(a, b) {
    if (Array.isArray(a) && Array.isArray(b)) return $307e0d89efad9a8a$export$23f2a1d2818174ef(a, b);
    return a === b;
}
// view-specific options
// ---------------------
var $307e0d89efad9a8a$export$56c0d5a1e737357d = {
    type: String,
    component: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    buttonText: String,
    buttonTextKey: String,
    dateProfileGeneratorClass: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    usesMinMaxTime: Boolean,
    classNames: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    content: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    didMount: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    willUnmount: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5
};
// util funcs
// ----------------------------------------------------------------------------------------------------
function $307e0d89efad9a8a$export$3466f893ebf79586(optionSets) {
    return $307e0d89efad9a8a$export$953cecd6e717a553(optionSets, $307e0d89efad9a8a$export$c4ce752e73470fba);
}
function $307e0d89efad9a8a$export$ee7c8ad385a60b7b(input, refiners) {
    var refined = {};
    var extra = {};
    for(var propName in refiners)if (propName in input) refined[propName] = refiners[propName](input[propName]);
    for(var propName1 in input)if (!(propName1 in refiners)) extra[propName1] = input[propName1];
    return {
        refined: refined,
        extra: extra
    };
}
function $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5(raw) {
    return raw;
}
var $307e0d89efad9a8a$var$hasOwnProperty = Object.prototype.hasOwnProperty;
// Merges an array of objects into a single object.
// The second argument allows for an array of property names who's object values will be merged together.
function $307e0d89efad9a8a$export$953cecd6e717a553(propObjs, complexPropsMap) {
    var dest = {};
    if (complexPropsMap) {
        for(var name in complexPropsMap)if (complexPropsMap[name] === $307e0d89efad9a8a$var$isMaybeObjectsEqual) {
            var complexObjs = [];
            // collect the trailing object values, stopping when a non-object is discovered
            for(var i = propObjs.length - 1; i >= 0; i -= 1){
                var val = propObjs[i][name];
                if (typeof val === "object" && val) complexObjs.unshift(val);
                else if (val !== undefined) {
                    dest[name] = val; // if there were no objects, this value will be used
                    break;
                }
            }
            // if the trailing values were objects, use the merged value
            if (complexObjs.length) dest[name] = $307e0d89efad9a8a$export$953cecd6e717a553(complexObjs);
        }
    }
    // copy values into the destination, going from last to first
    for(var i1 = propObjs.length - 1; i1 >= 0; i1 -= 1){
        var props = propObjs[i1];
        for(var name1 in props)if (!(name1 in dest)) dest[name1] = props[name1];
    }
    return dest;
}
function $307e0d89efad9a8a$export$dda1d9f60106f0e9(hash, func) {
    var filtered = {};
    for(var key in hash)if (func(hash[key], key)) filtered[key] = hash[key];
    return filtered;
}
function $307e0d89efad9a8a$export$407448d2b89b1813(hash, func) {
    var newHash = {};
    for(var key in hash)newHash[key] = func(hash[key], key);
    return newHash;
}
function $307e0d89efad9a8a$export$2d1720544b23b823(a) {
    var hash = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = a[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var item = _step.value;
            hash[item] = true;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return hash;
}
// TODO: reassess browser support
// https://caniuse.com/?search=object.values
function $307e0d89efad9a8a$export$90a7f3efeed30595(obj) {
    var a = [];
    for(var key in obj)a.push(obj[key]);
    return a;
}
function $307e0d89efad9a8a$export$a9c23c6ac3fc3eca(obj0, obj1) {
    if (obj0 === obj1) return true;
    for(var key in obj0)if ($307e0d89efad9a8a$var$hasOwnProperty.call(obj0, key)) {
        if (!(key in obj1)) return false;
    }
    for(var key1 in obj1)if ($307e0d89efad9a8a$var$hasOwnProperty.call(obj1, key1)) {
        if (obj0[key1] !== obj1[key1]) return false;
    }
    return true;
}
var $307e0d89efad9a8a$var$HANDLER_RE = /^on[A-Z]/;
function $307e0d89efad9a8a$var$isNonHandlerPropsEqual(obj0, obj1) {
    var keys = $307e0d89efad9a8a$var$getUnequalProps(obj0, obj1);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            if (!$307e0d89efad9a8a$var$HANDLER_RE.test(key)) return false;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return true;
}
function $307e0d89efad9a8a$var$getUnequalProps(obj0, obj1) {
    var keys = [];
    for(var key in obj0){
        if ($307e0d89efad9a8a$var$hasOwnProperty.call(obj0, key)) {
            if (!(key in obj1)) keys.push(key);
        }
    }
    for(var key1 in obj1){
        if ($307e0d89efad9a8a$var$hasOwnProperty.call(obj1, key1)) {
            if (obj0[key1] !== obj1[key1]) keys.push(key1);
        }
    }
    return keys;
}
function $307e0d89efad9a8a$export$b9a6b53f9be3734(oldProps, newProps) {
    var equalityFuncs = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    if (oldProps === newProps) return true;
    // if (debug) {
    //   for (let key in newProps) {
    //     if (key in oldProps && isObjValsEqual(oldProps[key], newProps[key], equalityFuncs[key])) {
    //       // equal
    //     } else {
    //       if (debug) {
    //         console.log('prop difference', key, oldProps[key], newProps[key])
    //       }
    //     }
    //   }
    //   // check for props that were omitted in the new
    //   for (let key in oldProps) {
    //     if (!(key in newProps)) {
    //       if (debug) {
    //         console.log('prop absent', key)
    //       }
    //     }
    //   }
    // }
    for(var key in newProps){
        if (key in oldProps && $307e0d89efad9a8a$var$isObjValsEqual(oldProps[key], newProps[key], equalityFuncs[key])) ;
        else return false;
    }
    // check for props that were omitted in the new
    for(var key1 in oldProps){
        if (!(key1 in newProps)) return false;
    }
    return true;
}
/*
assumed "true" equality for handler names like "onReceiveSomething"
*/ function $307e0d89efad9a8a$var$isObjValsEqual(val0, val1, comparator) {
    if (val0 === val1 || comparator === true) return true;
    if (comparator) return comparator(val0, val1);
    return false;
}
function $307e0d89efad9a8a$export$a05254e7c3aeba6e(hash) {
    var startIndex = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, endIndex = arguments.length > 2 ? arguments[2] : void 0, step = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 1;
    var res = [];
    if (endIndex == null) endIndex = Object.keys(hash).length;
    for(var i = startIndex; i < endIndex; i += step){
        var val = hash[i];
        if (val !== undefined) res.push(val);
    }
    return res;
}
var $307e0d89efad9a8a$var$calendarSystemClassMap = {};
function $307e0d89efad9a8a$var$registerCalendarSystem(name, theClass) {
    $307e0d89efad9a8a$var$calendarSystemClassMap[name] = theClass;
}
function $307e0d89efad9a8a$var$createCalendarSystem(name) {
    return new $307e0d89efad9a8a$var$calendarSystemClassMap[name]();
}
var $307e0d89efad9a8a$var$GregorianCalendarSystem = /*#__PURE__*/ function() {
    "use strict";
    function GregorianCalendarSystem() {
        (0, $luoZD._)(this, GregorianCalendarSystem);
    }
    (0, $fYUO3._)(GregorianCalendarSystem, [
        {
            key: "getMarkerYear",
            value: function getMarkerYear(d) {
                return d.getUTCFullYear();
            }
        },
        {
            key: "getMarkerMonth",
            value: function getMarkerMonth(d) {
                return d.getUTCMonth();
            }
        },
        {
            key: "getMarkerDay",
            value: function getMarkerDay(d) {
                return d.getUTCDate();
            }
        },
        {
            key: "arrayToMarker",
            value: function arrayToMarker(arr) {
                return $307e0d89efad9a8a$var$arrayToUtcDate(arr);
            }
        },
        {
            key: "markerToArray",
            value: function markerToArray(marker) {
                return $307e0d89efad9a8a$var$dateToUtcArray(marker);
            }
        }
    ]);
    return GregorianCalendarSystem;
}();
$307e0d89efad9a8a$var$registerCalendarSystem("gregory", $307e0d89efad9a8a$var$GregorianCalendarSystem);
var $307e0d89efad9a8a$var$ISO_RE = /^\s*(\d{4})(-?(\d{2})(-?(\d{2})([T ](\d{2}):?(\d{2})(:?(\d{2})(\.(\d+))?)?(Z|(([-+])(\d{2})(:?(\d{2}))?))?)?)?)?$/;
function $307e0d89efad9a8a$export$26a0a7676ca7aa04(str) {
    var m = $307e0d89efad9a8a$var$ISO_RE.exec(str);
    if (m) {
        var marker = new Date(Date.UTC(Number(m[1]), m[3] ? Number(m[3]) - 1 : 0, Number(m[5] || 1), Number(m[7] || 0), Number(m[8] || 0), Number(m[10] || 0), m[12] ? Number("0.".concat(m[12])) * 1000 : 0));
        if ($307e0d89efad9a8a$export$5521614468b862fb(marker)) {
            var timeZoneOffset = null;
            if (m[13]) timeZoneOffset = (m[15] === "-" ? -1 : 1) * (Number(m[16] || 0) * 60 + Number(m[18] || 0));
            return {
                marker: marker,
                isTimeUnspecified: !m[6],
                timeZoneOffset: timeZoneOffset
            };
        }
    }
    return null;
}
var $307e0d89efad9a8a$export$3722cfe417b6ed86 = /*#__PURE__*/ function() {
    "use strict";
    function DateEnv(settings) {
        (0, $luoZD._)(this, DateEnv);
        var timeZone = this.timeZone = settings.timeZone;
        var isNamedTimeZone = timeZone !== "local" && timeZone !== "UTC";
        if (settings.namedTimeZoneImpl && isNamedTimeZone) this.namedTimeZoneImpl = new settings.namedTimeZoneImpl(timeZone);
        this.canComputeOffset = Boolean(!isNamedTimeZone || this.namedTimeZoneImpl);
        this.calendarSystem = $307e0d89efad9a8a$var$createCalendarSystem(settings.calendarSystem);
        this.locale = settings.locale;
        this.weekDow = settings.locale.week.dow;
        this.weekDoy = settings.locale.week.doy;
        if (settings.weekNumberCalculation === "ISO") {
            this.weekDow = 1;
            this.weekDoy = 4;
        }
        if (typeof settings.firstDay === "number") this.weekDow = settings.firstDay;
        if (typeof settings.weekNumberCalculation === "function") this.weekNumberFunc = settings.weekNumberCalculation;
        this.weekText = settings.weekText != null ? settings.weekText : settings.locale.options.weekText;
        this.weekTextLong = (settings.weekTextLong != null ? settings.weekTextLong : settings.locale.options.weekTextLong) || this.weekText;
        this.cmdFormatter = settings.cmdFormatter;
        this.defaultSeparator = settings.defaultSeparator;
    }
    (0, $fYUO3._)(DateEnv, [
        {
            // Creating / Parsing
            key: "createMarker",
            value: function createMarker(input) {
                var meta = this.createMarkerMeta(input);
                if (meta === null) return null;
                return meta.marker;
            }
        },
        {
            key: "createNowMarker",
            value: function createNowMarker() {
                if (this.canComputeOffset) return this.timestampToMarker(new Date().valueOf());
                // if we can't compute the current date val for a timezone,
                // better to give the current local date vals than UTC
                return $307e0d89efad9a8a$var$arrayToUtcDate($307e0d89efad9a8a$var$dateToLocalArray(new Date()));
            }
        },
        {
            key: "createMarkerMeta",
            value: function createMarkerMeta(input) {
                if (typeof input === "string") return this.parse(input);
                var marker = null;
                if (typeof input === "number") marker = this.timestampToMarker(input);
                else if (input instanceof Date) {
                    input = input.valueOf();
                    if (!isNaN(input)) marker = this.timestampToMarker(input);
                } else if (Array.isArray(input)) marker = $307e0d89efad9a8a$var$arrayToUtcDate(input);
                if (marker === null || !$307e0d89efad9a8a$export$5521614468b862fb(marker)) return null;
                return {
                    marker: marker,
                    isTimeUnspecified: false,
                    forcedTzo: null
                };
            }
        },
        {
            key: "parse",
            value: function parse1(s) {
                var parts = $307e0d89efad9a8a$export$26a0a7676ca7aa04(s);
                if (parts === null) return null;
                var marker = parts.marker;
                var forcedTzo = null;
                if (parts.timeZoneOffset !== null) {
                    if (this.canComputeOffset) marker = this.timestampToMarker(marker.valueOf() - parts.timeZoneOffset * 60000);
                    else forcedTzo = parts.timeZoneOffset;
                }
                return {
                    marker: marker,
                    isTimeUnspecified: parts.isTimeUnspecified,
                    forcedTzo: forcedTzo
                };
            }
        },
        {
            // Accessors
            key: "getYear",
            value: function getYear(marker) {
                return this.calendarSystem.getMarkerYear(marker);
            }
        },
        {
            key: "getMonth",
            value: function getMonth(marker) {
                return this.calendarSystem.getMarkerMonth(marker);
            }
        },
        {
            key: "getDay",
            value: function getDay(marker) {
                return this.calendarSystem.getMarkerDay(marker);
            }
        },
        {
            // Adding / Subtracting
            key: "add",
            value: function add(marker, dur) {
                var a = this.calendarSystem.markerToArray(marker);
                a[0] += dur.years;
                a[1] += dur.months;
                a[2] += dur.days;
                a[6] += dur.milliseconds;
                return this.calendarSystem.arrayToMarker(a);
            }
        },
        {
            key: "subtract",
            value: function subtract(marker, dur) {
                var a = this.calendarSystem.markerToArray(marker);
                a[0] -= dur.years;
                a[1] -= dur.months;
                a[2] -= dur.days;
                a[6] -= dur.milliseconds;
                return this.calendarSystem.arrayToMarker(a);
            }
        },
        {
            key: "addYears",
            value: function addYears(marker, n) {
                var a = this.calendarSystem.markerToArray(marker);
                a[0] += n;
                return this.calendarSystem.arrayToMarker(a);
            }
        },
        {
            key: "addMonths",
            value: function addMonths(marker, n) {
                var a = this.calendarSystem.markerToArray(marker);
                a[1] += n;
                return this.calendarSystem.arrayToMarker(a);
            }
        },
        {
            // Diffing Whole Units
            key: "diffWholeYears",
            value: function diffWholeYears(m0, m1) {
                var calendarSystem = this.calendarSystem;
                if ($307e0d89efad9a8a$var$timeAsMs(m0) === $307e0d89efad9a8a$var$timeAsMs(m1) && calendarSystem.getMarkerDay(m0) === calendarSystem.getMarkerDay(m1) && calendarSystem.getMarkerMonth(m0) === calendarSystem.getMarkerMonth(m1)) return calendarSystem.getMarkerYear(m1) - calendarSystem.getMarkerYear(m0);
                return null;
            }
        },
        {
            key: "diffWholeMonths",
            value: function diffWholeMonths(m0, m1) {
                var calendarSystem = this.calendarSystem;
                if ($307e0d89efad9a8a$var$timeAsMs(m0) === $307e0d89efad9a8a$var$timeAsMs(m1) && calendarSystem.getMarkerDay(m0) === calendarSystem.getMarkerDay(m1)) return calendarSystem.getMarkerMonth(m1) - calendarSystem.getMarkerMonth(m0) + (calendarSystem.getMarkerYear(m1) - calendarSystem.getMarkerYear(m0)) * 12;
                return null;
            }
        },
        {
            // Range / Duration
            key: "greatestWholeUnit",
            value: function greatestWholeUnit(m0, m1) {
                var n = this.diffWholeYears(m0, m1);
                if (n !== null) return {
                    unit: "year",
                    value: n
                };
                n = this.diffWholeMonths(m0, m1);
                if (n !== null) return {
                    unit: "month",
                    value: n
                };
                n = $307e0d89efad9a8a$export$31e67cf12fc9668(m0, m1);
                if (n !== null) return {
                    unit: "week",
                    value: n
                };
                n = $307e0d89efad9a8a$export$4a5767248b18ef41(m0, m1);
                if (n !== null) return {
                    unit: "day",
                    value: n
                };
                n = $307e0d89efad9a8a$var$diffHours(m0, m1);
                if ($307e0d89efad9a8a$export$ab83b03e4111b1d0(n)) return {
                    unit: "hour",
                    value: n
                };
                n = $307e0d89efad9a8a$var$diffMinutes(m0, m1);
                if ($307e0d89efad9a8a$export$ab83b03e4111b1d0(n)) return {
                    unit: "minute",
                    value: n
                };
                n = $307e0d89efad9a8a$var$diffSeconds(m0, m1);
                if ($307e0d89efad9a8a$export$ab83b03e4111b1d0(n)) return {
                    unit: "second",
                    value: n
                };
                return {
                    unit: "millisecond",
                    value: m1.valueOf() - m0.valueOf()
                };
            }
        },
        {
            key: "countDurationsBetween",
            value: function countDurationsBetween(m0, m1, d) {
                // TODO: can use greatestWholeUnit
                var diff;
                if (d.years) {
                    diff = this.diffWholeYears(m0, m1);
                    if (diff !== null) return diff / $307e0d89efad9a8a$var$asRoughYears(d);
                }
                if (d.months) {
                    diff = this.diffWholeMonths(m0, m1);
                    if (diff !== null) return diff / $307e0d89efad9a8a$var$asRoughMonths(d);
                }
                if (d.days) {
                    diff = $307e0d89efad9a8a$export$4a5767248b18ef41(m0, m1);
                    if (diff !== null) return diff / $307e0d89efad9a8a$var$asRoughDays(d);
                }
                return (m1.valueOf() - m0.valueOf()) / $307e0d89efad9a8a$export$4b170465d7badfa1(d);
            }
        },
        {
            // Start-Of
            // these DON'T return zoned-dates. only UTC start-of dates
            key: "startOf",
            value: function startOf(m, unit) {
                if (unit === "year") return this.startOfYear(m);
                if (unit === "month") return this.startOfMonth(m);
                if (unit === "week") return this.startOfWeek(m);
                if (unit === "day") return $307e0d89efad9a8a$export$9e5f44173e64f162(m);
                if (unit === "hour") return $307e0d89efad9a8a$var$startOfHour(m);
                if (unit === "minute") return $307e0d89efad9a8a$var$startOfMinute(m);
                if (unit === "second") return $307e0d89efad9a8a$var$startOfSecond(m);
                return null;
            }
        },
        {
            key: "startOfYear",
            value: function startOfYear(m) {
                return this.calendarSystem.arrayToMarker([
                    this.calendarSystem.getMarkerYear(m)
                ]);
            }
        },
        {
            key: "startOfMonth",
            value: function startOfMonth(m) {
                return this.calendarSystem.arrayToMarker([
                    this.calendarSystem.getMarkerYear(m),
                    this.calendarSystem.getMarkerMonth(m)
                ]);
            }
        },
        {
            key: "startOfWeek",
            value: function startOfWeek(m) {
                return this.calendarSystem.arrayToMarker([
                    this.calendarSystem.getMarkerYear(m),
                    this.calendarSystem.getMarkerMonth(m),
                    m.getUTCDate() - (m.getUTCDay() - this.weekDow + 7) % 7
                ]);
            }
        },
        {
            // Week Number
            key: "computeWeekNumber",
            value: function computeWeekNumber(marker) {
                if (this.weekNumberFunc) return this.weekNumberFunc(this.toDate(marker));
                return $307e0d89efad9a8a$var$weekOfYear(marker, this.weekDow, this.weekDoy);
            }
        },
        {
            // TODO: choke on timeZoneName: long
            key: "format",
            value: function format(marker, formatter) {
                var dateOptions = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                return formatter.format({
                    marker: marker,
                    timeZoneOffset: dateOptions.forcedTzo != null ? dateOptions.forcedTzo : this.offsetForMarker(marker)
                }, this);
            }
        },
        {
            key: "formatRange",
            value: function formatRange(start, end, formatter) {
                var dateOptions = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
                if (dateOptions.isEndExclusive) end = $307e0d89efad9a8a$export$51b138e5a065c2bb(end, -1);
                return formatter.formatRange({
                    marker: start,
                    timeZoneOffset: dateOptions.forcedStartTzo != null ? dateOptions.forcedStartTzo : this.offsetForMarker(start)
                }, {
                    marker: end,
                    timeZoneOffset: dateOptions.forcedEndTzo != null ? dateOptions.forcedEndTzo : this.offsetForMarker(end)
                }, this, dateOptions.defaultSeparator);
            }
        },
        {
            /*
    DUMB: the omitTime arg is dumb. if we omit the time, we want to omit the timezone offset. and if we do that,
    might as well use buildIsoString or some other util directly
    */ key: "formatIso",
            value: function formatIso(marker) {
                var extraOptions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var timeZoneOffset = null;
                if (!extraOptions.omitTimeZoneOffset) {
                    if (extraOptions.forcedTzo != null) timeZoneOffset = extraOptions.forcedTzo;
                    else timeZoneOffset = this.offsetForMarker(marker);
                }
                return $307e0d89efad9a8a$export$f438b12253c2b499(marker, timeZoneOffset, extraOptions.omitTime);
            }
        },
        {
            // TimeZone
            key: "timestampToMarker",
            value: function timestampToMarker(ms) {
                if (this.timeZone === "local") return $307e0d89efad9a8a$var$arrayToUtcDate($307e0d89efad9a8a$var$dateToLocalArray(new Date(ms)));
                if (this.timeZone === "UTC" || !this.namedTimeZoneImpl) return new Date(ms);
                return $307e0d89efad9a8a$var$arrayToUtcDate(this.namedTimeZoneImpl.timestampToArray(ms));
            }
        },
        {
            key: "offsetForMarker",
            value: function offsetForMarker(m) {
                if (this.timeZone === "local") return -$307e0d89efad9a8a$var$arrayToLocalDate($307e0d89efad9a8a$var$dateToUtcArray(m)).getTimezoneOffset(); // convert "inverse" offset to "normal" offset
                if (this.timeZone === "UTC") return 0;
                if (this.namedTimeZoneImpl) return this.namedTimeZoneImpl.offsetForArray($307e0d89efad9a8a$var$dateToUtcArray(m));
                return null;
            }
        },
        {
            // Conversion
            key: "toDate",
            value: function toDate(m, forcedTzo) {
                if (this.timeZone === "local") return $307e0d89efad9a8a$var$arrayToLocalDate($307e0d89efad9a8a$var$dateToUtcArray(m));
                if (this.timeZone === "UTC") return new Date(m.valueOf()); // make sure it's a copy
                if (!this.namedTimeZoneImpl) return new Date(m.valueOf() - (forcedTzo || 0));
                return new Date(m.valueOf() - this.namedTimeZoneImpl.offsetForArray($307e0d89efad9a8a$var$dateToUtcArray(m)) * 60000);
            }
        }
    ]);
    return DateEnv;
}();
var $307e0d89efad9a8a$export$971d5caa766a69d7 = /*#__PURE__*/ function() {
    "use strict";
    function Theme(calendarOptions) {
        (0, $luoZD._)(this, Theme);
        if (this.iconOverrideOption) this.setIconOverride(calendarOptions[this.iconOverrideOption]);
    }
    (0, $fYUO3._)(Theme, [
        {
            key: "setIconOverride",
            value: function setIconOverride(iconOverrideHash) {
                var iconClassesCopy;
                var buttonName;
                if (typeof iconOverrideHash === "object" && iconOverrideHash) {
                    iconClassesCopy = Object.assign({}, this.iconClasses);
                    for(buttonName in iconOverrideHash)iconClassesCopy[buttonName] = this.applyIconOverridePrefix(iconOverrideHash[buttonName]);
                    this.iconClasses = iconClassesCopy;
                } else if (iconOverrideHash === false) this.iconClasses = {};
            }
        },
        {
            key: "applyIconOverridePrefix",
            value: function applyIconOverridePrefix(className) {
                var prefix = this.iconOverridePrefix;
                if (prefix && className.indexOf(prefix) !== 0) className = prefix + className;
                return className;
            }
        },
        {
            key: "getClass",
            value: function getClass(key) {
                return this.classes[key] || "";
            }
        },
        {
            key: "getIconClass",
            value: function getIconClass(buttonName, isRtl) {
                var className;
                if (isRtl && this.rtlIconClasses) className = this.rtlIconClasses[buttonName] || this.iconClasses[buttonName];
                else className = this.iconClasses[buttonName];
                if (className) return "".concat(this.baseIconClass, " ").concat(className);
                return "";
            }
        },
        {
            key: "getCustomButtonIconClass",
            value: function getCustomButtonIconClass(customButtonProps) {
                var className;
                if (this.iconOverrideCustomButtonOption) {
                    className = customButtonProps[this.iconOverrideCustomButtonOption];
                    if (className) return "".concat(this.baseIconClass, " ").concat(this.applyIconOverridePrefix(className));
                }
                return "";
            }
        }
    ]);
    return Theme;
}();
$307e0d89efad9a8a$export$971d5caa766a69d7.prototype.classes = {};
$307e0d89efad9a8a$export$971d5caa766a69d7.prototype.iconClasses = {};
$307e0d89efad9a8a$export$971d5caa766a69d7.prototype.baseIconClass = "";
$307e0d89efad9a8a$export$971d5caa766a69d7.prototype.iconOverridePrefix = "";
/*
NOTE: this can be a public API, especially createElement for hooks.
See examples/typescript-scheduler/src/index.ts
*/ function $307e0d89efad9a8a$export$c3950d9923825c02(runBeforeFlush) {
    runBeforeFlush();
    var oldDebounceRendering = $ihX0O.options.debounceRendering; // orig
    var callbackQ = [];
    function execCallbackSync(callback) {
        callbackQ.push(callback);
    }
    $ihX0O.options.debounceRendering = execCallbackSync;
    $ihX0O.render($ihX0O.createElement($307e0d89efad9a8a$var$FakeComponent, {}), document.createElement("div"));
    while(callbackQ.length)callbackQ.shift()();
    $ihX0O.options.debounceRendering = oldDebounceRendering;
}
var $307e0d89efad9a8a$var$FakeComponent = /*#__PURE__*/ function(_preact_Component) {
    "use strict";
    (0, $7DbRq._)(FakeComponent, _preact_Component);
    var _super = (0, $ju9pQ._)(FakeComponent);
    function FakeComponent() {
        (0, $luoZD._)(this, FakeComponent);
        return _super.apply(this, arguments);
    }
    (0, $fYUO3._)(FakeComponent, [
        {
            key: "render",
            value: function render() {
                return $ihX0O.createElement("div", {});
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.setState({});
            }
        }
    ]);
    return FakeComponent;
}($ihX0O.Component);
// TODO: use preact/compat instead?
function $307e0d89efad9a8a$export$c9170ad7d4cd7e57(defaultValue) {
    var ContextType = $ihX0O.createContext(defaultValue);
    var origProvider = ContextType.Provider;
    ContextType.Provider = function() {
        var _this = this;
        var isNew = !this.getChildContext;
        var children = origProvider.apply(this, arguments); // eslint-disable-line prefer-rest-params
        if (isNew) {
            var subs = [];
            this.shouldComponentUpdate = function(_props) {
                if (_this.props.value !== _props.value) subs.forEach(function(c) {
                    c.context = _props.value;
                    c.forceUpdate();
                });
            };
            this.sub = function(c) {
                subs.push(c);
                var old = c.componentWillUnmount;
                c.componentWillUnmount = function() {
                    subs.splice(subs.indexOf(c), 1);
                    old && old.call(c);
                };
            };
        }
        return children;
    };
    return ContextType;
}
var $307e0d89efad9a8a$export$49e6ee724f7f1ace = /*#__PURE__*/ function() {
    "use strict";
    function ScrollResponder(execFunc, emitter, scrollTime, scrollTimeReset) {
        var _this = this;
        (0, $luoZD._)(this, ScrollResponder);
        this.execFunc = execFunc;
        this.emitter = emitter;
        this.scrollTime = scrollTime;
        this.scrollTimeReset = scrollTimeReset;
        this.handleScrollRequest = function(request) {
            _this.queuedRequest = Object.assign({}, _this.queuedRequest || {}, request);
            _this.drain();
        };
        emitter.on("_scrollRequest", this.handleScrollRequest);
        this.fireInitialScroll();
    }
    (0, $fYUO3._)(ScrollResponder, [
        {
            key: "detach",
            value: function detach() {
                this.emitter.off("_scrollRequest", this.handleScrollRequest);
            }
        },
        {
            key: "update",
            value: function update(isDatesNew) {
                if (isDatesNew && this.scrollTimeReset) this.fireInitialScroll(); // will drain
                else this.drain();
            }
        },
        {
            key: "fireInitialScroll",
            value: function fireInitialScroll() {
                this.handleScrollRequest({
                    time: this.scrollTime
                });
            }
        },
        {
            key: "drain",
            value: function drain() {
                if (this.queuedRequest && this.execFunc(this.queuedRequest)) this.queuedRequest = null;
            }
        }
    ]);
    return ScrollResponder;
}();
var $307e0d89efad9a8a$export$e7c866399fa523f5 = $307e0d89efad9a8a$export$c9170ad7d4cd7e57({}); // for Components
function $307e0d89efad9a8a$export$ce26c07117d59d6a(viewSpec, viewApi, viewOptions, dateProfileGenerator, dateEnv, nowManager, theme, pluginHooks, dispatch, getCurrentData, emitter, calendarApi, registerInteractiveComponent, unregisterInteractiveComponent) {
    return {
        dateEnv: dateEnv,
        nowManager: nowManager,
        options: viewOptions,
        pluginHooks: pluginHooks,
        emitter: emitter,
        dispatch: dispatch,
        getCurrentData: getCurrentData,
        calendarApi: calendarApi,
        viewSpec: viewSpec,
        viewApi: viewApi,
        dateProfileGenerator: dateProfileGenerator,
        theme: theme,
        isRtl: viewOptions.direction === "rtl",
        addResizeHandler: function(handler) {
            emitter.on("_resize", handler);
        },
        removeResizeHandler: function(handler) {
            emitter.off("_resize", handler);
        },
        createScrollResponder: function(execFunc) {
            return new $307e0d89efad9a8a$export$49e6ee724f7f1ace(execFunc, emitter, $307e0d89efad9a8a$export$4368d992c4eafac0(viewOptions.scrollTime), viewOptions.scrollTimeReset);
        },
        registerInteractiveComponent: registerInteractiveComponent,
        unregisterInteractiveComponent: unregisterInteractiveComponent
    };
}
/* eslint max-classes-per-file: off */ var $307e0d89efad9a8a$export$3c2fa207a37baaea = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $7DbRq._)(PureComponent, Component);
    var _super = (0, $ju9pQ._)(PureComponent);
    function PureComponent() {
        (0, $luoZD._)(this, PureComponent);
        return _super.apply(this, arguments);
    }
    (0, $fYUO3._)(PureComponent, [
        {
            // debug: boolean
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(nextProps, nextState) {
                var shouldUpdate = !$307e0d89efad9a8a$export$b9a6b53f9be3734(this.props, nextProps, this.propEquality /*, this.debug */ ) || !$307e0d89efad9a8a$export$b9a6b53f9be3734(this.state, nextState, this.stateEquality /*, this.debug */ );
                // if (this.debug && shouldUpdate) {
                //   console.log('shouldUpdate!')
                // }
                return shouldUpdate;
            }
        },
        {
            // HACK for freakin' React StrictMode
            key: "safeSetState",
            value: function safeSetState(newState) {
                if (!$307e0d89efad9a8a$export$b9a6b53f9be3734(this.state, Object.assign(Object.assign({}, this.state), newState), this.stateEquality)) this.setState(newState);
            }
        }
    ]);
    return PureComponent;
}((0, $ihX0O.Component));
$307e0d89efad9a8a$export$3c2fa207a37baaea.addPropsEquality = $307e0d89efad9a8a$var$addPropsEquality;
$307e0d89efad9a8a$export$3c2fa207a37baaea.addStateEquality = $307e0d89efad9a8a$var$addStateEquality;
$307e0d89efad9a8a$export$3c2fa207a37baaea.contextType = $307e0d89efad9a8a$export$e7c866399fa523f5;
$307e0d89efad9a8a$export$3c2fa207a37baaea.prototype.propEquality = {};
$307e0d89efad9a8a$export$3c2fa207a37baaea.prototype.stateEquality = {};
var $307e0d89efad9a8a$export$ef35774e6d314e91 = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0, $7DbRq._)(BaseComponent, PureComponent);
    var _super = (0, $ju9pQ._)(BaseComponent);
    function BaseComponent() {
        (0, $luoZD._)(this, BaseComponent);
        return _super.apply(this, arguments);
    }
    return BaseComponent;
}($307e0d89efad9a8a$export$3c2fa207a37baaea);
$307e0d89efad9a8a$export$ef35774e6d314e91.contextType = $307e0d89efad9a8a$export$e7c866399fa523f5;
function $307e0d89efad9a8a$var$addPropsEquality(propEquality) {
    var hash = Object.create(this.prototype.propEquality);
    Object.assign(hash, propEquality);
    this.prototype.propEquality = hash;
}
function $307e0d89efad9a8a$var$addStateEquality(stateEquality) {
    var hash = Object.create(this.prototype.stateEquality);
    Object.assign(hash, stateEquality);
    this.prototype.stateEquality = hash;
}
// use other one
function $307e0d89efad9a8a$export$71cec2538cb2c617(ref, current) {
    if (typeof ref === "function") ref(current);
    else if (ref) // see https://github.com/facebook/react/issues/13029
    ref.current = current;
}
var $307e0d89efad9a8a$var$ContentInjector = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $7DbRq._)(ContentInjector, BaseComponent);
    var _super = (0, $ju9pQ._)(ContentInjector);
    function ContentInjector() {
        (0, $luoZD._)(this, ContentInjector);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.id = $307e0d89efad9a8a$export$39b482c5e57630a8();
        _this.queuedDomNodes = [];
        _this.currentDomNodes = [];
        _this.handleEl = function(el) {
            var options = _this.context.options;
            var generatorName = _this.props.generatorName;
            if (!options.customRenderingReplaces || !$307e0d89efad9a8a$var$hasCustomRenderingHandler(generatorName, options)) _this.updateElRef(el);
        };
        _this.updateElRef = function(el) {
            if (_this.props.elRef) $307e0d89efad9a8a$export$71cec2538cb2c617(_this.props.elRef, el);
        };
        return _this;
    }
    (0, $fYUO3._)(ContentInjector, [
        {
            key: "render",
            value: function render() {
                var _this = this, props = _this.props, context = _this.context;
                var options = context.options;
                var customGenerator = props.customGenerator, defaultGenerator = props.defaultGenerator, renderProps = props.renderProps;
                var attrs = $307e0d89efad9a8a$export$9ddbdd0bfc5623a(props, [], this.handleEl);
                var useDefault = false;
                var innerContent;
                var queuedDomNodes = [];
                var currentGeneratorMeta;
                if (customGenerator != null) {
                    var customGeneratorRes = typeof customGenerator === "function" ? customGenerator(renderProps, (0, $ihX0O.createElement)) : customGenerator;
                    if (customGeneratorRes === true) useDefault = true;
                    else {
                        var isObject = customGeneratorRes && typeof customGeneratorRes === "object"; // non-null
                        if (isObject && "html" in customGeneratorRes) attrs.dangerouslySetInnerHTML = {
                            __html: customGeneratorRes.html
                        };
                        else if (isObject && "domNodes" in customGeneratorRes) queuedDomNodes = Array.prototype.slice.call(customGeneratorRes.domNodes);
                        else if (isObject ? (0, $ihX0O.isValidElement)(customGeneratorRes) // vdom node
                         : typeof customGeneratorRes !== "function" // primitive value (like string or number)
                        ) // use in vdom
                        innerContent = customGeneratorRes;
                        else // an exotic object for handleCustomRendering
                        currentGeneratorMeta = customGeneratorRes;
                    }
                } else useDefault = !$307e0d89efad9a8a$var$hasCustomRenderingHandler(props.generatorName, options);
                if (useDefault && defaultGenerator) innerContent = defaultGenerator(renderProps);
                this.queuedDomNodes = queuedDomNodes;
                this.currentGeneratorMeta = currentGeneratorMeta;
                return (0, $ihX0O.createElement)(props.elTag, attrs, innerContent);
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.applyQueueudDomNodes();
                this.triggerCustomRendering(true);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                this.applyQueueudDomNodes();
                this.triggerCustomRendering(true);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.triggerCustomRendering(false); // TODO: different API for removal?
            }
        },
        {
            key: "triggerCustomRendering",
            value: function triggerCustomRendering(isActive) {
                var _a;
                var _this = this, props = _this.props, context = _this.context;
                var _context_options = context.options, handleCustomRendering = _context_options.handleCustomRendering, customRenderingMetaMap = _context_options.customRenderingMetaMap;
                if (handleCustomRendering) {
                    var generatorMeta = (_a = this.currentGeneratorMeta) !== null && _a !== void 0 ? _a : customRenderingMetaMap === null || customRenderingMetaMap === void 0 ? void 0 : customRenderingMetaMap[props.generatorName];
                    if (generatorMeta) handleCustomRendering(Object.assign(Object.assign({
                        id: this.id,
                        isActive: isActive,
                        containerEl: this.base,
                        reportNewContainerEl: this.updateElRef,
                        generatorMeta: generatorMeta
                    }, props), {
                        elClasses: (props.elClasses || []).filter($307e0d89efad9a8a$var$isTruthy)
                    }));
                }
            }
        },
        {
            key: "applyQueueudDomNodes",
            value: function applyQueueudDomNodes() {
                var _this = this, queuedDomNodes = _this.queuedDomNodes, currentDomNodes = _this.currentDomNodes;
                var el = this.base;
                if (!$307e0d89efad9a8a$export$23f2a1d2818174ef(queuedDomNodes, currentDomNodes)) {
                    currentDomNodes.forEach($307e0d89efad9a8a$export$9f4f30ee63539e24);
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = queuedDomNodes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var newNode = _step.value;
                            el.appendChild(newNode);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    this.currentDomNodes = queuedDomNodes;
                }
            }
        }
    ]);
    return ContentInjector;
}($307e0d89efad9a8a$export$ef35774e6d314e91);
$307e0d89efad9a8a$var$ContentInjector.addPropsEquality({
    elClasses: $307e0d89efad9a8a$export$23f2a1d2818174ef,
    elStyle: $307e0d89efad9a8a$export$a9c23c6ac3fc3eca,
    elAttrs: $307e0d89efad9a8a$var$isNonHandlerPropsEqual,
    renderProps: $307e0d89efad9a8a$export$a9c23c6ac3fc3eca
});
// Util
/*
Does UI-framework provide custom way of rendering that does not use Preact VDOM
AND does the calendar's options define custom rendering?
AKA. Should we NOT render the default content?
*/ function $307e0d89efad9a8a$var$hasCustomRenderingHandler(generatorName, options) {
    var _a;
    return Boolean(options.handleCustomRendering && generatorName && ((_a = options.customRenderingMetaMap) === null || _a === void 0 ? void 0 : _a[generatorName]));
}
function $307e0d89efad9a8a$export$9ddbdd0bfc5623a(props, extraClassNames, elRef) {
    var attrs = Object.assign(Object.assign({}, props.elAttrs), {
        ref: elRef
    });
    if (props.elClasses || extraClassNames) attrs.className = (props.elClasses || []).concat(extraClassNames || []).concat(attrs.className || []).filter(Boolean).join(" ");
    if (props.elStyle) attrs.style = props.elStyle;
    return attrs;
}
function $307e0d89efad9a8a$var$isTruthy(val) {
    return Boolean(val);
}
var $307e0d89efad9a8a$export$7910e0436ed8d1de = $307e0d89efad9a8a$export$c9170ad7d4cd7e57(0);
var $307e0d89efad9a8a$export$e7094788287c5e9b = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $7DbRq._)(ContentContainer, Component);
    var _super = (0, $ju9pQ._)(ContentContainer);
    function ContentContainer() {
        (0, $luoZD._)(this, ContentContainer);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.InnerContent = $307e0d89efad9a8a$var$InnerContentInjector.bind(undefined, (0, $iJSF3._)(_this));
        _this.handleEl = function(el) {
            _this.el = el;
            if (_this.props.elRef) {
                $307e0d89efad9a8a$export$71cec2538cb2c617(_this.props.elRef, el);
                if (el && _this.didMountMisfire) _this.componentDidMount();
            }
        };
        return _this;
    }
    (0, $fYUO3._)(ContentContainer, [
        {
            key: "render",
            value: function render() {
                var props = this.props;
                var generatedClassNames = $307e0d89efad9a8a$var$generateClassNames(props.classNameGenerator, props.renderProps);
                if (props.children) {
                    var elAttrs = $307e0d89efad9a8a$export$9ddbdd0bfc5623a(props, generatedClassNames, this.handleEl);
                    var children = props.children(this.InnerContent, props.renderProps, elAttrs);
                    if (props.elTag) return (0, $ihX0O.createElement)(props.elTag, elAttrs, children);
                    else return children;
                } else return (0, $ihX0O.createElement)($307e0d89efad9a8a$var$ContentInjector, Object.assign(Object.assign({}, props), {
                    elRef: this.handleEl,
                    elTag: props.elTag || "div",
                    elClasses: (props.elClasses || []).concat(generatedClassNames),
                    renderId: this.context
                }));
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _a, _b;
                if (this.el) (_b = (_a = this.props).didMount) === null || _b === void 0 || _b.call(_a, Object.assign(Object.assign({}, this.props.renderProps), {
                    el: this.el
                }));
                else this.didMountMisfire = true;
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                var _a, _b;
                (_b = (_a = this.props).willUnmount) === null || _b === void 0 || _b.call(_a, Object.assign(Object.assign({}, this.props.renderProps), {
                    el: this.el
                }));
            }
        }
    ]);
    return ContentContainer;
}((0, $ihX0O.Component));
$307e0d89efad9a8a$export$e7094788287c5e9b.contextType = $307e0d89efad9a8a$export$7910e0436ed8d1de;
function $307e0d89efad9a8a$var$InnerContentInjector(containerComponent, props) {
    var parentProps = containerComponent.props;
    return (0, $ihX0O.createElement)($307e0d89efad9a8a$var$ContentInjector, Object.assign({
        renderProps: parentProps.renderProps,
        generatorName: parentProps.generatorName,
        customGenerator: parentProps.customGenerator,
        defaultGenerator: parentProps.defaultGenerator,
        renderId: containerComponent.context
    }, props));
}
// Utils
function $307e0d89efad9a8a$var$generateClassNames(classNameGenerator, renderProps) {
    var classNames = typeof classNameGenerator === "function" ? classNameGenerator(renderProps) : classNameGenerator || [];
    return typeof classNames === "string" ? [
        classNames
    ] : classNames;
}
var $307e0d89efad9a8a$export$a3c9165b94390bcd = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $7DbRq._)(ViewContainer, BaseComponent);
    var _super = (0, $ju9pQ._)(ViewContainer);
    function ViewContainer() {
        (0, $luoZD._)(this, ViewContainer);
        return _super.apply(this, arguments);
    }
    (0, $fYUO3._)(ViewContainer, [
        {
            key: "render",
            value: function render() {
                var _this = this, props = _this.props, context = _this.context;
                var options = context.options;
                var renderProps = {
                    view: context.viewApi
                };
                return (0, $ihX0O.createElement)($307e0d89efad9a8a$export$e7094788287c5e9b, {
                    elRef: props.elRef,
                    elTag: props.elTag || "div",
                    elAttrs: props.elAttrs,
                    elClasses: (0, $79xu7._)($307e0d89efad9a8a$export$8b22cf2602fb60ce(props.viewSpec)).concat((0, $79xu7._)(props.elClasses || [])),
                    elStyle: props.elStyle,
                    renderProps: renderProps,
                    classNameGenerator: options.viewClassNames,
                    generatorName: undefined,
                    didMount: options.viewDidMount,
                    willUnmount: options.viewWillUnmount
                }, function() {
                    return props.children;
                });
            }
        }
    ]);
    return ViewContainer;
}($307e0d89efad9a8a$export$ef35774e6d314e91);
function $307e0d89efad9a8a$export$8b22cf2602fb60ce(viewSpec) {
    return [
        "fc-".concat(viewSpec.type, "-view"),
        "fc-view"
    ];
}
function $307e0d89efad9a8a$var$parseRange(input, dateEnv) {
    var start = null;
    var end = null;
    if (input.start) start = dateEnv.createMarker(input.start);
    if (input.end) end = dateEnv.createMarker(input.end);
    if (!start && !end) return null;
    if (start && end && end < start) return null;
    return {
        start: start,
        end: end
    };
}
// SIDE-EFFECT: will mutate ranges.
// Will return a new array result.
function $307e0d89efad9a8a$var$invertRanges(ranges, constraintRange) {
    var invertedRanges = [];
    var start = constraintRange.start; // the end of the previous range. the start of the new range
    var i;
    var dateRange;
    // ranges need to be in order. required for our date-walking algorithm
    ranges.sort($307e0d89efad9a8a$var$compareRanges);
    for(i = 0; i < ranges.length; i += 1){
        dateRange = ranges[i];
        // add the span of time before the event (if there is any)
        if (dateRange.start > start) invertedRanges.push({
            start: start,
            end: dateRange.start
        });
        if (dateRange.end > start) start = dateRange.end;
    }
    // add the span of time after the last event (if there is any)
    if (start < constraintRange.end) invertedRanges.push({
        start: start,
        end: constraintRange.end
    });
    return invertedRanges;
}
function $307e0d89efad9a8a$var$compareRanges(range0, range1) {
    return range0.start.valueOf() - range1.start.valueOf(); // earlier ranges go first
}
function $307e0d89efad9a8a$export$ae1af26003f05816(range0, range1) {
    var start = range0.start, end = range0.end;
    var newRange = null;
    if (range1.start !== null) {
        if (start === null) start = range1.start;
        else start = new Date(Math.max(start.valueOf(), range1.start.valueOf()));
    }
    if (range1.end != null) {
        if (end === null) end = range1.end;
        else end = new Date(Math.min(end.valueOf(), range1.end.valueOf()));
    }
    if (start === null || end === null || start < end) newRange = {
        start: start,
        end: end
    };
    return newRange;
}
function $307e0d89efad9a8a$export$7a0bdf7d4a91ea88(range0, range1) {
    return (range0.start === null ? null : range0.start.valueOf()) === (range1.start === null ? null : range1.start.valueOf()) && (range0.end === null ? null : range0.end.valueOf()) === (range1.end === null ? null : range1.end.valueOf());
}
function $307e0d89efad9a8a$export$c18d01048907ea92(range0, range1) {
    return (range0.end === null || range1.start === null || range0.end > range1.start) && (range0.start === null || range1.end === null || range0.start < range1.end);
}
function $307e0d89efad9a8a$export$f074adc9fbd50943(outerRange, innerRange) {
    return (outerRange.start === null || innerRange.start !== null && innerRange.start >= outerRange.start) && (outerRange.end === null || innerRange.end !== null && innerRange.end <= outerRange.end);
}
function $307e0d89efad9a8a$export$2329c99376c9d0a4(range, date) {
    return (range.start === null || date >= range.start) && (range.end === null || date < range.end);
}
// If the given date is not within the given range, move it inside.
// (If it's past the end, make it one millisecond before the end).
function $307e0d89efad9a8a$var$constrainMarkerToRange(date, range) {
    if (range.start != null && date < range.start) return range.start;
    if (range.end != null && date >= range.end) return new Date(range.end.valueOf() - 1);
    return date;
}
/* Date stuff that doesn't belong in datelib core
----------------------------------------------------------------------------------------------------------------------*/ // given a timed range, computes an all-day range that has the same exact duration,
// but whose start time is aligned with the start of the day.
function $307e0d89efad9a8a$var$computeAlignedDayRange(timedRange) {
    var dayCnt = Math.floor($307e0d89efad9a8a$export$b4d5ecaefe2b27f3(timedRange.start, timedRange.end)) || 1;
    var start = $307e0d89efad9a8a$export$9e5f44173e64f162(timedRange.start);
    var end = $307e0d89efad9a8a$export$625550452a3fa3ec(start, dayCnt);
    return {
        start: start,
        end: end
    };
}
// given a timed range, computes an all-day range based on how for the end date bleeds into the next day
// TODO: give nextDayThreshold a default arg
function $307e0d89efad9a8a$export$92108d983e8ee699(timedRange) {
    var nextDayThreshold = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $307e0d89efad9a8a$export$4368d992c4eafac0(0);
    var startDay = null;
    var endDay = null;
    if (timedRange.end) {
        endDay = $307e0d89efad9a8a$export$9e5f44173e64f162(timedRange.end);
        var endTimeMS = timedRange.end.valueOf() - endDay.valueOf(); // # of milliseconds into `endDay`
        // If the end time is actually inclusively part of the next day and is equal to or
        // beyond the next day threshold, adjust the end to be the exclusive end of `endDay`.
        // Otherwise, leaving it as inclusive will cause it to exclude `endDay`.
        if (endTimeMS && endTimeMS >= $307e0d89efad9a8a$export$4b170465d7badfa1(nextDayThreshold)) endDay = $307e0d89efad9a8a$export$625550452a3fa3ec(endDay, 1);
    }
    if (timedRange.start) {
        startDay = $307e0d89efad9a8a$export$9e5f44173e64f162(timedRange.start); // the beginning of the day the range starts
        // If end is within `startDay` but not past nextDayThreshold, assign the default duration of one day.
        if (endDay && endDay <= startDay) endDay = $307e0d89efad9a8a$export$625550452a3fa3ec(startDay, 1);
    }
    return {
        start: startDay,
        end: endDay
    };
}
// spans from one day into another?
function $307e0d89efad9a8a$export$9fa96a7d116ea3ce(range) {
    var visibleRange = $307e0d89efad9a8a$export$92108d983e8ee699(range);
    return $307e0d89efad9a8a$export$b4d5ecaefe2b27f3(visibleRange.start, visibleRange.end) > 1;
}
function $307e0d89efad9a8a$export$28f7fcd39efa255(date0, date1, dateEnv, largeUnit) {
    if (largeUnit === "year") return $307e0d89efad9a8a$export$4368d992c4eafac0(dateEnv.diffWholeYears(date0, date1), "year");
    if (largeUnit === "month") return $307e0d89efad9a8a$export$4368d992c4eafac0(dateEnv.diffWholeMonths(date0, date1), "month");
    return $307e0d89efad9a8a$export$62d08d6fa708df47(date0, date1); // returns a duration
}
var $307e0d89efad9a8a$export$db202ddc8be9136 = /*#__PURE__*/ function() {
    "use strict";
    function DateProfileGenerator(props) {
        (0, $luoZD._)(this, DateProfileGenerator);
        this.props = props;
        this.initHiddenDays();
    }
    (0, $fYUO3._)(DateProfileGenerator, [
        {
            /* Date Range Computation
    ------------------------------------------------------------------------------------------------------------------*/ // Builds a structure with info about what the dates/ranges will be for the "prev" view.
            key: "buildPrev",
            value: function buildPrev(currentDateProfile, currentDate, forceToValid) {
                var dateEnv = this.props.dateEnv;
                var prevDate = dateEnv.subtract(dateEnv.startOf(currentDate, currentDateProfile.currentRangeUnit), currentDateProfile.dateIncrement);
                return this.build(prevDate, -1, forceToValid);
            }
        },
        {
            // Builds a structure with info about what the dates/ranges will be for the "next" view.
            key: "buildNext",
            value: function buildNext(currentDateProfile, currentDate, forceToValid) {
                var dateEnv = this.props.dateEnv;
                var nextDate = dateEnv.add(dateEnv.startOf(currentDate, currentDateProfile.currentRangeUnit), currentDateProfile.dateIncrement);
                return this.build(nextDate, 1, forceToValid);
            }
        },
        {
            // Builds a structure holding dates/ranges for rendering around the given date.
            // Optional direction param indicates whether the date is being incremented/decremented
            // from its previous value. decremented = -1, incremented = 1 (default).
            key: "build",
            value: function build(currentDate, direction) {
                var forceToValid = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
                var props = this.props;
                var validRange;
                var currentInfo;
                var isRangeAllDay;
                var renderRange;
                var activeRange;
                var isValid;
                validRange = this.buildValidRange();
                validRange = this.trimHiddenDays(validRange);
                if (forceToValid) currentDate = $307e0d89efad9a8a$var$constrainMarkerToRange(currentDate, validRange);
                currentInfo = this.buildCurrentRangeInfo(currentDate, direction);
                isRangeAllDay = /^(year|month|week|day)$/.test(currentInfo.unit);
                renderRange = this.buildRenderRange(this.trimHiddenDays(currentInfo.range), currentInfo.unit, isRangeAllDay);
                renderRange = this.trimHiddenDays(renderRange);
                activeRange = renderRange;
                if (!props.showNonCurrentDates) activeRange = $307e0d89efad9a8a$export$ae1af26003f05816(activeRange, currentInfo.range);
                activeRange = this.adjustActiveRange(activeRange);
                activeRange = $307e0d89efad9a8a$export$ae1af26003f05816(activeRange, validRange); // might return null
                // it's invalid if the originally requested date is not contained,
                // or if the range is completely outside of the valid range.
                isValid = $307e0d89efad9a8a$export$c18d01048907ea92(currentInfo.range, validRange);
                // HACK: constrain to render-range so `currentDate` is more useful to view rendering
                if (!$307e0d89efad9a8a$export$2329c99376c9d0a4(renderRange, currentDate)) currentDate = renderRange.start;
                return {
                    currentDate: currentDate,
                    // constraint for where prev/next operations can go and where events can be dragged/resized to.
                    // an object with optional start and end properties.
                    validRange: validRange,
                    // range the view is formally responsible for.
                    // for example, a month view might have 1st-31st, excluding padded dates
                    currentRange: currentInfo.range,
                    // name of largest unit being displayed, like "month" or "week"
                    currentRangeUnit: currentInfo.unit,
                    isRangeAllDay: isRangeAllDay,
                    // dates that display events and accept drag-n-drop
                    // will be `null` if no dates accept events
                    activeRange: activeRange,
                    // date range with a rendered skeleton
                    // includes not-active days that need some sort of DOM
                    renderRange: renderRange,
                    // Duration object that denotes the first visible time of any given day
                    slotMinTime: props.slotMinTime,
                    // Duration object that denotes the exclusive visible end time of any given day
                    slotMaxTime: props.slotMaxTime,
                    isValid: isValid,
                    // how far the current date will move for a prev/next operation
                    dateIncrement: this.buildDateIncrement(currentInfo.duration)
                };
            }
        },
        {
            // Builds an object with optional start/end properties.
            // Indicates the minimum/maximum dates to display.
            // not responsible for trimming hidden days.
            key: "buildValidRange",
            value: function buildValidRange() {
                var input = this.props.validRangeInput;
                var simpleInput = typeof input === "function" ? input.call(this.props.calendarApi, this.props.dateEnv.toDate(this.props.nowManager.getDateMarker())) : input;
                return this.refineRange(simpleInput) || {
                    start: null,
                    end: null
                }; // completely open-ended
            }
        },
        {
            // Builds a structure with info about the "current" range, the range that is
            // highlighted as being the current month for example.
            // See build() for a description of `direction`.
            // Guaranteed to have `range` and `unit` properties. `duration` is optional.
            key: "buildCurrentRangeInfo",
            value: function buildCurrentRangeInfo(date, direction) {
                var props = this.props;
                var duration = null;
                var unit = null;
                var range = null;
                var dayCount;
                if (props.duration) {
                    duration = props.duration;
                    unit = props.durationUnit;
                    range = this.buildRangeFromDuration(date, direction, duration, unit);
                } else if (dayCount = this.props.dayCount) {
                    unit = "day";
                    range = this.buildRangeFromDayCount(date, direction, dayCount);
                } else if (range = this.buildCustomVisibleRange(date)) unit = props.dateEnv.greatestWholeUnit(range.start, range.end).unit;
                else {
                    duration = this.getFallbackDuration();
                    unit = $307e0d89efad9a8a$export$db3b6bfb95261072(duration).unit;
                    range = this.buildRangeFromDuration(date, direction, duration, unit);
                }
                return {
                    duration: duration,
                    unit: unit,
                    range: range
                };
            }
        },
        {
            key: "getFallbackDuration",
            value: function getFallbackDuration() {
                return $307e0d89efad9a8a$export$4368d992c4eafac0({
                    day: 1
                });
            }
        },
        {
            // Returns a new activeRange to have time values (un-ambiguate)
            // slotMinTime or slotMaxTime causes the range to expand.
            key: "adjustActiveRange",
            value: function adjustActiveRange(range) {
                var _this_props = this.props, dateEnv = _this_props.dateEnv, usesMinMaxTime = _this_props.usesMinMaxTime, slotMinTime = _this_props.slotMinTime, slotMaxTime = _this_props.slotMaxTime;
                var start = range.start, end = range.end;
                if (usesMinMaxTime) {
                    // expand active range if slotMinTime is negative (why not when positive?)
                    if ($307e0d89efad9a8a$var$asRoughDays(slotMinTime) < 0) {
                        start = $307e0d89efad9a8a$export$9e5f44173e64f162(start); // necessary?
                        start = dateEnv.add(start, slotMinTime);
                    }
                    // expand active range if slotMaxTime is beyond one day (why not when negative?)
                    if ($307e0d89efad9a8a$var$asRoughDays(slotMaxTime) > 1) {
                        end = $307e0d89efad9a8a$export$9e5f44173e64f162(end); // necessary?
                        end = $307e0d89efad9a8a$export$625550452a3fa3ec(end, -1);
                        end = dateEnv.add(end, slotMaxTime);
                    }
                }
                return {
                    start: start,
                    end: end
                };
            }
        },
        {
            // Builds the "current" range when it is specified as an explicit duration.
            // `unit` is the already-computed greatestDurationDenominator unit of duration.
            key: "buildRangeFromDuration",
            value: function buildRangeFromDuration(date, direction, duration, unit) {
                var _this_props = this.props, dateEnv = _this_props.dateEnv, dateAlignment = _this_props.dateAlignment;
                var start;
                var end;
                var res;
                // compute what the alignment should be
                if (!dateAlignment) {
                    var dateIncrement = this.props.dateIncrement;
                    if (dateIncrement) {
                        // use the smaller of the two units
                        if ($307e0d89efad9a8a$export$4b170465d7badfa1(dateIncrement) < $307e0d89efad9a8a$export$4b170465d7badfa1(duration)) dateAlignment = $307e0d89efad9a8a$export$db3b6bfb95261072(dateIncrement).unit;
                        else dateAlignment = unit;
                    } else dateAlignment = unit;
                }
                // if the view displays a single day or smaller
                if ($307e0d89efad9a8a$var$asRoughDays(duration) <= 1) {
                    if (this.isHiddenDay(start)) {
                        start = this.skipHiddenDays(start, direction);
                        start = $307e0d89efad9a8a$export$9e5f44173e64f162(start);
                    }
                }
                function computeRes() {
                    start = dateEnv.startOf(date, dateAlignment);
                    end = dateEnv.add(start, duration);
                    res = {
                        start: start,
                        end: end
                    };
                }
                computeRes();
                // if range is completely enveloped by hidden days, go past the hidden days
                if (!this.trimHiddenDays(res)) {
                    date = this.skipHiddenDays(date, direction);
                    computeRes();
                }
                return res;
            }
        },
        {
            // Builds the "current" range when a dayCount is specified.
            key: "buildRangeFromDayCount",
            value: function buildRangeFromDayCount(date, direction, dayCount) {
                var _this_props = this.props, dateEnv = _this_props.dateEnv, dateAlignment = _this_props.dateAlignment;
                var runningCount = 0;
                var start = date;
                var end;
                if (dateAlignment) start = dateEnv.startOf(start, dateAlignment);
                start = $307e0d89efad9a8a$export$9e5f44173e64f162(start);
                start = this.skipHiddenDays(start, direction);
                end = start;
                do {
                    end = $307e0d89efad9a8a$export$625550452a3fa3ec(end, 1);
                    if (!this.isHiddenDay(end)) runningCount += 1;
                }while (runningCount < dayCount);
                return {
                    start: start,
                    end: end
                };
            }
        },
        {
            // Builds a normalized range object for the "visible" range,
            // which is a way to define the currentRange and activeRange at the same time.
            key: "buildCustomVisibleRange",
            value: function buildCustomVisibleRange(date) {
                var props = this.props;
                var input = props.visibleRangeInput;
                var simpleInput = typeof input === "function" ? input.call(props.calendarApi, props.dateEnv.toDate(date)) : input;
                var range = this.refineRange(simpleInput);
                if (range && (range.start == null || range.end == null)) return null;
                return range;
            }
        },
        {
            // Computes the range that will represent the element/cells for *rendering*,
            // but which may have voided days/times.
            // not responsible for trimming hidden days.
            key: "buildRenderRange",
            value: function buildRenderRange(currentRange, currentRangeUnit, isRangeAllDay) {
                return currentRange;
            }
        },
        {
            // Compute the duration value that should be added/substracted to the current date
            // when a prev/next operation happens.
            key: "buildDateIncrement",
            value: function buildDateIncrement(fallback) {
                var dateIncrement = this.props.dateIncrement;
                var customAlignment;
                if (dateIncrement) return dateIncrement;
                if (customAlignment = this.props.dateAlignment) return $307e0d89efad9a8a$export$4368d992c4eafac0(1, customAlignment);
                if (fallback) return fallback;
                return $307e0d89efad9a8a$export$4368d992c4eafac0({
                    days: 1
                });
            }
        },
        {
            key: "refineRange",
            value: function refineRange(rangeInput) {
                if (rangeInput) {
                    var range = $307e0d89efad9a8a$var$parseRange(rangeInput, this.props.dateEnv);
                    if (range) range = $307e0d89efad9a8a$export$92108d983e8ee699(range);
                    return range;
                }
                return null;
            }
        },
        {
            /* Hidden Days
    ------------------------------------------------------------------------------------------------------------------*/ // Initializes internal variables related to calculating hidden days-of-week
            key: "initHiddenDays",
            value: function initHiddenDays() {
                var hiddenDays = this.props.hiddenDays || []; // array of day-of-week indices that are hidden
                var isHiddenDayHash = []; // is the day-of-week hidden? (hash with day-of-week-index -> bool)
                var dayCnt = 0;
                var i;
                if (this.props.weekends === false) hiddenDays.push(0, 6); // 0=sunday, 6=saturday
                for(i = 0; i < 7; i += 1)if (!(isHiddenDayHash[i] = hiddenDays.indexOf(i) !== -1)) dayCnt += 1;
                if (!dayCnt) throw new Error("invalid hiddenDays"); // all days were hidden? bad.
                this.isHiddenDayHash = isHiddenDayHash;
            }
        },
        {
            // Remove days from the beginning and end of the range that are computed as hidden.
            // If the whole range is trimmed off, returns null
            key: "trimHiddenDays",
            value: function trimHiddenDays(range) {
                var start = range.start, end = range.end;
                if (start) start = this.skipHiddenDays(start);
                if (end) end = this.skipHiddenDays(end, -1, true);
                if (start == null || end == null || start < end) return {
                    start: start,
                    end: end
                };
                return null;
            }
        },
        {
            // Is the current day hidden?
            // `day` is a day-of-week index (0-6), or a Date (used for UTC)
            key: "isHiddenDay",
            value: function isHiddenDay(day) {
                if (day instanceof Date) day = day.getUTCDay();
                return this.isHiddenDayHash[day];
            }
        },
        {
            // Incrementing the current day until it is no longer a hidden day, returning a copy.
            // DOES NOT CONSIDER validRange!
            // If the initial value of `date` is not a hidden day, don't do anything.
            // Pass `isExclusive` as `true` if you are dealing with an end date.
            // `inc` defaults to `1` (increment one day forward each time)
            key: "skipHiddenDays",
            value: function skipHiddenDays(date) {
                var inc = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, isExclusive = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
                while(this.isHiddenDayHash[(date.getUTCDay() + (isExclusive ? inc : 0) + 7) % 7])date = $307e0d89efad9a8a$export$625550452a3fa3ec(date, inc);
                return date;
            }
        }
    ]);
    return DateProfileGenerator;
}();
function $307e0d89efad9a8a$export$995eb9fca571757(defId, range, forcedStartTzo, forcedEndTzo) {
    return {
        instanceId: $307e0d89efad9a8a$export$39b482c5e57630a8(),
        defId: defId,
        range: range,
        forcedStartTzo: forcedStartTzo == null ? null : forcedStartTzo,
        forcedEndTzo: forcedEndTzo == null ? null : forcedEndTzo
    };
}
function $307e0d89efad9a8a$var$parseRecurring(refined, defaultAllDay, dateEnv, recurringTypes) {
    for(var i = 0; i < recurringTypes.length; i += 1){
        var parsed = recurringTypes[i].parse(refined, dateEnv);
        if (parsed) {
            var allDay = refined.allDay;
            if (allDay == null) {
                allDay = defaultAllDay;
                if (allDay == null) {
                    allDay = parsed.allDayGuess;
                    if (allDay == null) allDay = false;
                }
            }
            return {
                allDay: allDay,
                duration: parsed.duration,
                typeData: parsed.typeData,
                typeId: i
            };
        }
    }
    return null;
}
function $307e0d89efad9a8a$var$expandRecurring(eventStore, framingRange, context) {
    var dateEnv = context.dateEnv, pluginHooks = context.pluginHooks, options = context.options;
    var defs = eventStore.defs, instances = eventStore.instances;
    // remove existing recurring instances
    // TODO: bad. always expand events as a second step
    instances = $307e0d89efad9a8a$export$dda1d9f60106f0e9(instances, function(instance) {
        return !defs[instance.defId].recurringDef;
    });
    for(var defId in defs){
        var def = defs[defId];
        if (def.recurringDef) {
            var duration = def.recurringDef.duration;
            if (!duration) duration = def.allDay ? options.defaultAllDayEventDuration : options.defaultTimedEventDuration;
            var starts = $307e0d89efad9a8a$var$expandRecurringRanges(def, duration, framingRange, dateEnv, pluginHooks.recurringTypes);
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = starts[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var start = _step.value;
                    var instance = $307e0d89efad9a8a$export$995eb9fca571757(defId, {
                        start: start,
                        end: dateEnv.add(start, duration)
                    });
                    instances[instance.instanceId] = instance;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    }
    return {
        defs: defs,
        instances: instances
    };
}
/*
Event MUST have a recurringDef
*/ function $307e0d89efad9a8a$var$expandRecurringRanges(eventDef, duration, framingRange, dateEnv, recurringTypes) {
    var typeDef = recurringTypes[eventDef.recurringDef.typeId];
    var markers = typeDef.expand(eventDef.recurringDef.typeData, {
        start: dateEnv.subtract(framingRange.start, duration),
        end: framingRange.end
    }, dateEnv);
    // the recurrence plugins don't guarantee that all-day events are start-of-day, so we have to
    if (eventDef.allDay) markers = markers.map($307e0d89efad9a8a$export$9e5f44173e64f162);
    return markers;
}
var $307e0d89efad9a8a$var$EVENT_NON_DATE_REFINERS = {
    id: String,
    groupId: String,
    title: String,
    url: String,
    interactive: Boolean
};
var $307e0d89efad9a8a$var$EVENT_DATE_REFINERS = {
    start: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    end: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    date: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    allDay: Boolean
};
var $307e0d89efad9a8a$var$EVENT_REFINERS = Object.assign(Object.assign(Object.assign({}, $307e0d89efad9a8a$var$EVENT_NON_DATE_REFINERS), $307e0d89efad9a8a$var$EVENT_DATE_REFINERS), {
    extendedProps: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5
});
function $307e0d89efad9a8a$var$parseEvent(raw, eventSource, context, allowOpenRange) {
    var refiners = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : $307e0d89efad9a8a$var$buildEventRefiners(context), defIdMap = arguments.length > 5 ? arguments[5] : void 0, instanceIdMap = arguments.length > 6 ? arguments[6] : void 0;
    var _refineEventDef = $307e0d89efad9a8a$export$3b513254972cfc9c(raw, context, refiners), refined = _refineEventDef.refined, extra = _refineEventDef.extra;
    var defaultAllDay = $307e0d89efad9a8a$var$computeIsDefaultAllDay(eventSource, context);
    var recurringRes = $307e0d89efad9a8a$var$parseRecurring(refined, defaultAllDay, context.dateEnv, context.pluginHooks.recurringTypes);
    if (recurringRes) {
        var def = $307e0d89efad9a8a$export$f38c853ae54ed474(refined, extra, eventSource ? eventSource.sourceId : "", recurringRes.allDay, Boolean(recurringRes.duration), context, defIdMap);
        def.recurringDef = {
            typeId: recurringRes.typeId,
            typeData: recurringRes.typeData,
            duration: recurringRes.duration
        };
        return {
            def: def,
            instance: null
        };
    }
    var singleRes = $307e0d89efad9a8a$var$parseSingle(refined, defaultAllDay, context, allowOpenRange);
    if (singleRes) {
        var def1 = $307e0d89efad9a8a$export$f38c853ae54ed474(refined, extra, eventSource ? eventSource.sourceId : "", singleRes.allDay, singleRes.hasEnd, context, defIdMap);
        var instance = $307e0d89efad9a8a$export$995eb9fca571757(def1.defId, singleRes.range, singleRes.forcedStartTzo, singleRes.forcedEndTzo);
        if (instanceIdMap && def1.publicId && instanceIdMap[def1.publicId]) instance.instanceId = instanceIdMap[def1.publicId];
        return {
            def: def1,
            instance: instance
        };
    }
    return null;
}
function $307e0d89efad9a8a$export$3b513254972cfc9c(raw, context) {
    var refiners = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $307e0d89efad9a8a$var$buildEventRefiners(context);
    return $307e0d89efad9a8a$export$ee7c8ad385a60b7b(raw, refiners);
}
function $307e0d89efad9a8a$var$buildEventRefiners(context) {
    return Object.assign(Object.assign(Object.assign({}, $307e0d89efad9a8a$var$EVENT_UI_REFINERS), $307e0d89efad9a8a$var$EVENT_REFINERS), context.pluginHooks.eventRefiners);
}
/*
Will NOT populate extendedProps with the leftover properties.
Will NOT populate date-related props.
*/ function $307e0d89efad9a8a$export$f38c853ae54ed474(refined, extra, sourceId, allDay, hasEnd, context, defIdMap) {
    var def = {
        title: refined.title || "",
        groupId: refined.groupId || "",
        publicId: refined.id || "",
        url: refined.url || "",
        recurringDef: null,
        defId: (defIdMap && refined.id ? defIdMap[refined.id] : "") || $307e0d89efad9a8a$export$39b482c5e57630a8(),
        sourceId: sourceId,
        allDay: allDay,
        hasEnd: hasEnd,
        interactive: refined.interactive,
        ui: $307e0d89efad9a8a$export$25ce5a424b770e84(refined, context),
        extendedProps: Object.assign(Object.assign({}, refined.extendedProps || {}), extra)
    };
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = context.pluginHooks.eventDefMemberAdders[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var memberAdder = _step.value;
            Object.assign(def, memberAdder(refined));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    // help out EventImpl from having user modify props
    Object.freeze(def.ui.classNames);
    Object.freeze(def.extendedProps);
    return def;
}
function $307e0d89efad9a8a$var$parseSingle(refined, defaultAllDay, context, allowOpenRange) {
    var allDay = refined.allDay;
    var startMeta;
    var startMarker = null;
    var hasEnd = false;
    var endMeta;
    var endMarker = null;
    var startInput = refined.start != null ? refined.start : refined.date;
    startMeta = context.dateEnv.createMarkerMeta(startInput);
    if (startMeta) startMarker = startMeta.marker;
    else if (!allowOpenRange) return null;
    if (refined.end != null) endMeta = context.dateEnv.createMarkerMeta(refined.end);
    if (allDay == null) {
        if (defaultAllDay != null) allDay = defaultAllDay;
        else // fall back to the date props LAST
        allDay = (!startMeta || startMeta.isTimeUnspecified) && (!endMeta || endMeta.isTimeUnspecified);
    }
    if (allDay && startMarker) startMarker = $307e0d89efad9a8a$export$9e5f44173e64f162(startMarker);
    if (endMeta) {
        endMarker = endMeta.marker;
        if (allDay) endMarker = $307e0d89efad9a8a$export$9e5f44173e64f162(endMarker);
        if (startMarker && endMarker <= startMarker) endMarker = null;
    }
    if (endMarker) hasEnd = true;
    else if (!allowOpenRange) {
        hasEnd = context.options.forceEventDuration || false;
        endMarker = context.dateEnv.add(startMarker, allDay ? context.options.defaultAllDayEventDuration : context.options.defaultTimedEventDuration);
    }
    return {
        allDay: allDay,
        hasEnd: hasEnd,
        range: {
            start: startMarker,
            end: endMarker
        },
        forcedStartTzo: startMeta ? startMeta.forcedTzo : null,
        forcedEndTzo: endMeta ? endMeta.forcedTzo : null
    };
}
function $307e0d89efad9a8a$var$computeIsDefaultAllDay(eventSource, context) {
    var res = null;
    if (eventSource) res = eventSource.defaultAllDay;
    if (res == null) res = context.options.defaultAllDay;
    return res;
}
function $307e0d89efad9a8a$var$parseEvents(rawEvents, eventSource, context, allowOpenRange, defIdMap, instanceIdMap) {
    var eventStore = $307e0d89efad9a8a$export$7f8ddf7c7c20b3cd();
    var eventRefiners = $307e0d89efad9a8a$var$buildEventRefiners(context);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = rawEvents[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var rawEvent = _step.value;
            var tuple = $307e0d89efad9a8a$var$parseEvent(rawEvent, eventSource, context, allowOpenRange, eventRefiners, defIdMap, instanceIdMap);
            if (tuple) $307e0d89efad9a8a$export$317a3d46287192d8(tuple, eventStore);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return eventStore;
}
function $307e0d89efad9a8a$export$317a3d46287192d8(tuple) {
    var eventStore = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $307e0d89efad9a8a$export$7f8ddf7c7c20b3cd();
    eventStore.defs[tuple.def.defId] = tuple.def;
    if (tuple.instance) eventStore.instances[tuple.instance.instanceId] = tuple.instance;
    return eventStore;
}
// retrieves events that have the same groupId as the instance specified by `instanceId`
// or they are the same as the instance.
// why might instanceId not be in the store? an event from another calendar?
function $307e0d89efad9a8a$export$667d3bf0c5f83305(eventStore, instanceId) {
    var instance = eventStore.instances[instanceId];
    if (instance) {
        var def = eventStore.defs[instance.defId];
        // get events/instances with same group
        var newStore = $307e0d89efad9a8a$var$filterEventStoreDefs(eventStore, function(lookDef) {
            return $307e0d89efad9a8a$var$isEventDefsGrouped(def, lookDef);
        });
        // add the original
        // TODO: wish we could use eventTupleToStore or something like it
        newStore.defs[def.defId] = def;
        newStore.instances[instance.instanceId] = instance;
        return newStore;
    }
    return $307e0d89efad9a8a$export$7f8ddf7c7c20b3cd();
}
function $307e0d89efad9a8a$var$isEventDefsGrouped(def0, def1) {
    return Boolean(def0.groupId && def0.groupId === def1.groupId);
}
function $307e0d89efad9a8a$export$7f8ddf7c7c20b3cd() {
    return {
        defs: {},
        instances: {}
    };
}
function $307e0d89efad9a8a$export$d377dcb2b61d6c4e(store0, store1) {
    return {
        defs: Object.assign(Object.assign({}, store0.defs), store1.defs),
        instances: Object.assign(Object.assign({}, store0.instances), store1.instances)
    };
}
function $307e0d89efad9a8a$var$filterEventStoreDefs(eventStore, filterFunc) {
    var defs = $307e0d89efad9a8a$export$dda1d9f60106f0e9(eventStore.defs, filterFunc);
    var instances = $307e0d89efad9a8a$export$dda1d9f60106f0e9(eventStore.instances, function(instance) {
        return defs[instance.defId] // still exists?
        ;
    });
    return {
        defs: defs,
        instances: instances
    };
}
function $307e0d89efad9a8a$var$excludeSubEventStore(master, sub) {
    var defs = master.defs, instances = master.instances;
    var filteredDefs = {};
    var filteredInstances = {};
    for(var defId in defs)if (!sub.defs[defId]) filteredDefs[defId] = defs[defId];
    for(var instanceId in instances)if (!sub.instances[instanceId] && // not explicitly excluded
    filteredDefs[instances[instanceId].defId] // def wasn't filtered away
    ) filteredInstances[instanceId] = instances[instanceId];
    return {
        defs: filteredDefs,
        instances: filteredInstances
    };
}
function $307e0d89efad9a8a$var$normalizeConstraint(input, context) {
    if (Array.isArray(input)) return $307e0d89efad9a8a$var$parseEvents(input, null, context, true); // allowOpenRange=true
    if (typeof input === "object" && input) return $307e0d89efad9a8a$var$parseEvents([
        input
    ], null, context, true); // allowOpenRange=true
    if (input != null) return String(input);
    return null;
}
function $307e0d89efad9a8a$export$f96d196f7728bb5(raw) {
    if (Array.isArray(raw)) return raw;
    if (typeof raw === "string") return raw.split(/\s+/);
    return [];
}
// TODO: better called "EventSettings" or "EventConfig"
// TODO: move this file into structs
// TODO: separate constraint/overlap/allow, because selection uses only that, not other props
var $307e0d89efad9a8a$var$EVENT_UI_REFINERS = {
    display: String,
    editable: Boolean,
    startEditable: Boolean,
    durationEditable: Boolean,
    constraint: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    overlap: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    allow: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    className: $307e0d89efad9a8a$export$f96d196f7728bb5,
    classNames: $307e0d89efad9a8a$export$f96d196f7728bb5,
    color: String,
    backgroundColor: String,
    borderColor: String,
    textColor: String
};
var $307e0d89efad9a8a$var$EMPTY_EVENT_UI = {
    display: null,
    startEditable: null,
    durationEditable: null,
    constraints: [],
    overlap: null,
    allows: [],
    backgroundColor: "",
    borderColor: "",
    textColor: "",
    classNames: []
};
function $307e0d89efad9a8a$export$25ce5a424b770e84(refined, context) {
    var constraint = $307e0d89efad9a8a$var$normalizeConstraint(refined.constraint, context);
    return {
        display: refined.display || null,
        startEditable: refined.startEditable != null ? refined.startEditable : refined.editable,
        durationEditable: refined.durationEditable != null ? refined.durationEditable : refined.editable,
        constraints: constraint != null ? [
            constraint
        ] : [],
        overlap: refined.overlap != null ? refined.overlap : null,
        allows: refined.allow != null ? [
            refined.allow
        ] : [],
        backgroundColor: refined.backgroundColor || refined.color || "",
        borderColor: refined.borderColor || refined.color || "",
        textColor: refined.textColor || "",
        classNames: (refined.className || []).concat(refined.classNames || [])
    };
}
// TODO: prevent against problems with <2 args!
function $307e0d89efad9a8a$export$1ee57be6f6687d2c(uis) {
    return uis.reduce($307e0d89efad9a8a$var$combineTwoEventUis, $307e0d89efad9a8a$var$EMPTY_EVENT_UI);
}
function $307e0d89efad9a8a$var$combineTwoEventUis(item0, item1) {
    return {
        display: item1.display != null ? item1.display : item0.display,
        startEditable: item1.startEditable != null ? item1.startEditable : item0.startEditable,
        durationEditable: item1.durationEditable != null ? item1.durationEditable : item0.durationEditable,
        constraints: item0.constraints.concat(item1.constraints),
        overlap: typeof item1.overlap === "boolean" ? item1.overlap : item0.overlap,
        allows: item0.allows.concat(item1.allows),
        backgroundColor: item1.backgroundColor || item0.backgroundColor,
        borderColor: item1.borderColor || item0.borderColor,
        textColor: item1.textColor || item0.textColor,
        classNames: item0.classNames.concat(item1.classNames)
    };
}
var $307e0d89efad9a8a$var$EVENT_SOURCE_REFINERS = {
    id: String,
    defaultAllDay: Boolean,
    url: String,
    format: String,
    events: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    eventDataTransform: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    // for any network-related sources
    success: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    failure: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5
};
function $307e0d89efad9a8a$export$ffb5f4729a158638(raw, context) {
    var refiners = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $307e0d89efad9a8a$export$35e795649ee09318(context);
    var rawObj;
    if (typeof raw === "string") rawObj = {
        url: raw
    };
    else if (typeof raw === "function" || Array.isArray(raw)) rawObj = {
        events: raw
    };
    else if (typeof raw === "object" && raw) rawObj = raw;
    if (rawObj) {
        var _refineProps = $307e0d89efad9a8a$export$ee7c8ad385a60b7b(rawObj, refiners), refined = _refineProps.refined, extra = _refineProps.extra;
        var metaRes = $307e0d89efad9a8a$var$buildEventSourceMeta(refined, context);
        if (metaRes) return {
            _raw: raw,
            isFetching: false,
            latestFetchId: "",
            fetchRange: null,
            defaultAllDay: refined.defaultAllDay,
            eventDataTransform: refined.eventDataTransform,
            success: refined.success,
            failure: refined.failure,
            publicId: refined.id || "",
            sourceId: $307e0d89efad9a8a$export$39b482c5e57630a8(),
            sourceDefId: metaRes.sourceDefId,
            meta: metaRes.meta,
            ui: $307e0d89efad9a8a$export$25ce5a424b770e84(refined, context),
            extendedProps: extra
        };
    }
    return null;
}
function $307e0d89efad9a8a$export$35e795649ee09318(context) {
    return Object.assign(Object.assign(Object.assign({}, $307e0d89efad9a8a$var$EVENT_UI_REFINERS), $307e0d89efad9a8a$var$EVENT_SOURCE_REFINERS), context.pluginHooks.eventSourceRefiners);
}
function $307e0d89efad9a8a$var$buildEventSourceMeta(raw, context) {
    var defs = context.pluginHooks.eventSourceDefs;
    for(var i = defs.length - 1; i >= 0; i -= 1){
        var def = defs[i];
        var meta = def.parseMeta(raw);
        if (meta) return {
            sourceDefId: i,
            meta: meta
        };
    }
    return null;
}
function $307e0d89efad9a8a$export$9bb611d729802a56(eventStore, action, eventSources, dateProfile, context) {
    switch(action.type){
        case "RECEIVE_EVENTS":
            return $307e0d89efad9a8a$var$receiveRawEvents(eventStore, eventSources[action.sourceId], action.fetchId, action.fetchRange, action.rawEvents, context);
        case "RESET_RAW_EVENTS":
            return $307e0d89efad9a8a$var$resetRawEvents(eventStore, eventSources[action.sourceId], action.rawEvents, dateProfile.activeRange, context);
        case "ADD_EVENTS":
            return $307e0d89efad9a8a$var$addEvent(eventStore, action.eventStore, dateProfile ? dateProfile.activeRange : null, context);
        case "RESET_EVENTS":
            return action.eventStore;
        case "MERGE_EVENTS":
            return $307e0d89efad9a8a$export$d377dcb2b61d6c4e(eventStore, action.eventStore);
        case "PREV":
        case "NEXT":
        case "CHANGE_DATE":
        case "CHANGE_VIEW_TYPE":
            if (dateProfile) return $307e0d89efad9a8a$var$expandRecurring(eventStore, dateProfile.activeRange, context);
            return eventStore;
        case "REMOVE_EVENTS":
            return $307e0d89efad9a8a$var$excludeSubEventStore(eventStore, action.eventStore);
        case "REMOVE_EVENT_SOURCE":
            return $307e0d89efad9a8a$var$excludeEventsBySourceId(eventStore, action.sourceId);
        case "REMOVE_ALL_EVENT_SOURCES":
            return $307e0d89efad9a8a$var$filterEventStoreDefs(eventStore, function(eventDef) {
                return !eventDef.sourceId // only keep events with no source id
                ;
            });
        case "REMOVE_ALL_EVENTS":
            return $307e0d89efad9a8a$export$7f8ddf7c7c20b3cd();
        default:
            return eventStore;
    }
}
function $307e0d89efad9a8a$var$receiveRawEvents(eventStore, eventSource, fetchId, fetchRange, rawEvents, context) {
    if (eventSource && // not already removed
    fetchId === eventSource.latestFetchId // TODO: wish this logic was always in event-sources
    ) {
        var subset = $307e0d89efad9a8a$var$parseEvents($307e0d89efad9a8a$var$transformRawEvents(rawEvents, eventSource, context), eventSource, context);
        if (fetchRange) subset = $307e0d89efad9a8a$var$expandRecurring(subset, fetchRange, context);
        return $307e0d89efad9a8a$export$d377dcb2b61d6c4e($307e0d89efad9a8a$var$excludeEventsBySourceId(eventStore, eventSource.sourceId), subset);
    }
    return eventStore;
}
function $307e0d89efad9a8a$var$resetRawEvents(existingEventStore, eventSource, rawEvents, activeRange, context) {
    var _buildPublicIdMaps = $307e0d89efad9a8a$var$buildPublicIdMaps(existingEventStore), defIdMap = _buildPublicIdMaps.defIdMap, instanceIdMap = _buildPublicIdMaps.instanceIdMap;
    var newEventStore = $307e0d89efad9a8a$var$parseEvents($307e0d89efad9a8a$var$transformRawEvents(rawEvents, eventSource, context), eventSource, context, false, defIdMap, instanceIdMap);
    return $307e0d89efad9a8a$var$expandRecurring(newEventStore, activeRange, context);
}
function $307e0d89efad9a8a$var$transformRawEvents(rawEvents, eventSource, context) {
    var calEachTransform = context.options.eventDataTransform;
    var sourceEachTransform = eventSource ? eventSource.eventDataTransform : null;
    if (sourceEachTransform) rawEvents = $307e0d89efad9a8a$var$transformEachRawEvent(rawEvents, sourceEachTransform);
    if (calEachTransform) rawEvents = $307e0d89efad9a8a$var$transformEachRawEvent(rawEvents, calEachTransform);
    return rawEvents;
}
function $307e0d89efad9a8a$var$transformEachRawEvent(rawEvents, func) {
    var refinedEvents;
    if (!func) refinedEvents = rawEvents;
    else {
        refinedEvents = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = rawEvents[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var rawEvent = _step.value;
                var refinedEvent = func(rawEvent);
                if (refinedEvent) refinedEvents.push(refinedEvent);
                else if (refinedEvent == null) refinedEvents.push(rawEvent);
                 // if a different falsy value, do nothing
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return refinedEvents;
}
function $307e0d89efad9a8a$var$addEvent(eventStore, subset, expandRange, context) {
    if (expandRange) subset = $307e0d89efad9a8a$var$expandRecurring(subset, expandRange, context);
    return $307e0d89efad9a8a$export$d377dcb2b61d6c4e(eventStore, subset);
}
function $307e0d89efad9a8a$export$b4171a6734a65d42(eventStore, oldDateEnv, newDateEnv) {
    var defs = eventStore.defs;
    var instances = $307e0d89efad9a8a$export$407448d2b89b1813(eventStore.instances, function(instance) {
        var def = defs[instance.defId];
        if (def.allDay) return instance; // isn't dependent on timezone
        return Object.assign(Object.assign({}, instance), {
            range: {
                start: newDateEnv.createMarker(oldDateEnv.toDate(instance.range.start, instance.forcedStartTzo)),
                end: newDateEnv.createMarker(oldDateEnv.toDate(instance.range.end, instance.forcedEndTzo))
            },
            forcedStartTzo: newDateEnv.canComputeOffset ? null : instance.forcedStartTzo,
            forcedEndTzo: newDateEnv.canComputeOffset ? null : instance.forcedEndTzo
        });
    });
    return {
        defs: defs,
        instances: instances
    };
}
function $307e0d89efad9a8a$var$excludeEventsBySourceId(eventStore, sourceId) {
    return $307e0d89efad9a8a$var$filterEventStoreDefs(eventStore, function(eventDef) {
        return eventDef.sourceId !== sourceId;
    });
}
// QUESTION: why not just return instances? do a general object-property-exclusion util
function $307e0d89efad9a8a$var$excludeInstances(eventStore, removals) {
    return {
        defs: eventStore.defs,
        instances: $307e0d89efad9a8a$export$dda1d9f60106f0e9(eventStore.instances, function(instance) {
            return !removals[instance.instanceId];
        })
    };
}
function $307e0d89efad9a8a$var$buildPublicIdMaps(eventStore) {
    var defs = eventStore.defs, instances = eventStore.instances;
    var defIdMap = {};
    var instanceIdMap = {};
    for(var defId in defs){
        var def = defs[defId];
        var publicId = def.publicId;
        if (publicId) defIdMap[publicId] = defId;
    }
    for(var instanceId in instances){
        var instance = instances[instanceId];
        var def1 = defs[instance.defId];
        var publicId1 = def1.publicId;
        if (publicId1) instanceIdMap[publicId1] = instanceId;
    }
    return {
        defIdMap: defIdMap,
        instanceIdMap: instanceIdMap
    };
}
var $307e0d89efad9a8a$export$d66501df72047452 = /*#__PURE__*/ function() {
    "use strict";
    function Emitter() {
        (0, $luoZD._)(this, Emitter);
        this.handlers = {};
        this.thisContext = null;
    }
    (0, $fYUO3._)(Emitter, [
        {
            key: "setThisContext",
            value: function setThisContext(thisContext) {
                this.thisContext = thisContext;
            }
        },
        {
            key: "setOptions",
            value: function setOptions(options) {
                this.options = options;
            }
        },
        {
            key: "on",
            value: function on(type, handler) {
                $307e0d89efad9a8a$var$addToHash(this.handlers, type, handler);
            }
        },
        {
            key: "off",
            value: function off(type, handler) {
                $307e0d89efad9a8a$var$removeFromHash(this.handlers, type, handler);
            }
        },
        {
            key: "trigger",
            value: function trigger(type) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    args[_key - 1] = arguments[_key];
                }
                var attachedHandlers = this.handlers[type] || [];
                var optionHandler = this.options && this.options[type];
                var handlers = [].concat(optionHandler || [], attachedHandlers);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = handlers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var handler = _step.value;
                        handler.apply(this.thisContext, args);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "hasHandlers",
            value: function hasHandlers(type) {
                return Boolean(this.handlers[type] && this.handlers[type].length || this.options && this.options[type]);
            }
        }
    ]);
    return Emitter;
}();
function $307e0d89efad9a8a$var$addToHash(hash, type, handler) {
    (hash[type] || (hash[type] = [])).push(handler);
}
function $307e0d89efad9a8a$var$removeFromHash(hash, type, handler) {
    if (handler) {
        if (hash[type]) hash[type] = hash[type].filter(function(func) {
            return func !== handler;
        });
    } else delete hash[type]; // remove all handler funcs for this type
}
var $307e0d89efad9a8a$var$DEF_DEFAULTS = {
    startTime: "09:00",
    endTime: "17:00",
    daysOfWeek: [
        1,
        2,
        3,
        4,
        5
    ],
    display: "inverse-background",
    classNames: "fc-non-business",
    groupId: "_businessHours"
};
/*
TODO: pass around as EventDefHash!!!
*/ function $307e0d89efad9a8a$export$3a6d5c9ae78a2c08(input, context) {
    return $307e0d89efad9a8a$var$parseEvents($307e0d89efad9a8a$var$refineInputs(input), null, context);
}
function $307e0d89efad9a8a$var$refineInputs(input) {
    var rawDefs;
    if (input === true) rawDefs = [
        {}
    ]; // will get DEF_DEFAULTS verbatim
    else if (Array.isArray(input)) // if specifying an array, every sub-definition NEEDS a day-of-week
    rawDefs = input.filter(function(rawDef) {
        return rawDef.daysOfWeek;
    });
    else if (typeof input === "object" && input) rawDefs = [
        input
    ];
    else rawDefs = [];
    rawDefs = rawDefs.map(function(rawDef) {
        return Object.assign(Object.assign({}, $307e0d89efad9a8a$var$DEF_DEFAULTS), rawDef);
    });
    return rawDefs;
}
function $307e0d89efad9a8a$export$cbfbec548517f2b6(selection, pev, context) {
    context.emitter.trigger("select", Object.assign(Object.assign({}, $307e0d89efad9a8a$var$buildDateSpanApiWithContext(selection, context)), {
        jsEvent: pev ? pev.origEvent : null,
        view: context.viewApi || context.calendarApi.view
    }));
}
function $307e0d89efad9a8a$var$triggerDateUnselect(pev, context) {
    context.emitter.trigger("unselect", {
        jsEvent: pev ? pev.origEvent : null,
        view: context.viewApi || context.calendarApi.view
    });
}
function $307e0d89efad9a8a$var$buildDateSpanApiWithContext(dateSpan, context) {
    var props = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = context.pluginHooks.dateSpanTransforms[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var transform = _step.value;
            Object.assign(props, transform(dateSpan, context));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    Object.assign(props, $307e0d89efad9a8a$var$buildDateSpanApi(dateSpan, context.dateEnv));
    return props;
}
// Given an event's allDay status and start date, return what its fallback end date should be.
// TODO: rename to computeDefaultEventEnd
function $307e0d89efad9a8a$export$bde1ed0f60b38f2f(allDay, marker, context) {
    var dateEnv = context.dateEnv, options = context.options;
    var end = marker;
    if (allDay) {
        end = $307e0d89efad9a8a$export$9e5f44173e64f162(end);
        end = dateEnv.add(end, options.defaultAllDayEventDuration);
    } else end = dateEnv.add(end, options.defaultTimedEventDuration);
    return end;
}
// applies the mutation to ALL defs/instances within the event store
function $307e0d89efad9a8a$export$dabba94403d45c8e(eventStore, eventConfigBase, mutation, context) {
    var eventConfigs = $307e0d89efad9a8a$var$compileEventUis(eventStore.defs, eventConfigBase);
    var dest = $307e0d89efad9a8a$export$7f8ddf7c7c20b3cd();
    for(var defId in eventStore.defs){
        var def = eventStore.defs[defId];
        dest.defs[defId] = $307e0d89efad9a8a$var$applyMutationToEventDef(def, eventConfigs[defId], mutation, context);
    }
    for(var instanceId in eventStore.instances){
        var instance = eventStore.instances[instanceId];
        var def1 = dest.defs[instance.defId]; // important to grab the newly modified def
        dest.instances[instanceId] = $307e0d89efad9a8a$var$applyMutationToEventInstance(instance, def1, eventConfigs[instance.defId], mutation, context);
    }
    return dest;
}
function $307e0d89efad9a8a$var$applyMutationToEventDef(eventDef, eventConfig, mutation, context) {
    var standardProps = mutation.standardProps || {};
    // if hasEnd has not been specified, guess a good value based on deltas.
    // if duration will change, there's no way the default duration will persist,
    // and thus, we need to mark the event as having a real end
    if (standardProps.hasEnd == null && eventConfig.durationEditable && (mutation.startDelta || mutation.endDelta)) standardProps.hasEnd = true; // TODO: is this mutation okay?
    var copy = Object.assign(Object.assign(Object.assign({}, eventDef), standardProps), {
        ui: Object.assign(Object.assign({}, eventDef.ui), standardProps.ui)
    });
    if (mutation.extendedProps) copy.extendedProps = Object.assign(Object.assign({}, copy.extendedProps), mutation.extendedProps);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = context.pluginHooks.eventDefMutationAppliers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var applier = _step.value;
            applier(copy, mutation, context);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    if (!copy.hasEnd && context.options.forceEventDuration) copy.hasEnd = true;
    return copy;
}
function $307e0d89efad9a8a$var$applyMutationToEventInstance(eventInstance, eventDef, eventConfig, mutation, context) {
    var dateEnv = context.dateEnv;
    var forceAllDay = mutation.standardProps && mutation.standardProps.allDay === true;
    var clearEnd = mutation.standardProps && mutation.standardProps.hasEnd === false;
    var copy = Object.assign({}, eventInstance);
    if (forceAllDay) copy.range = $307e0d89efad9a8a$var$computeAlignedDayRange(copy.range);
    if (mutation.datesDelta && eventConfig.startEditable) copy.range = {
        start: dateEnv.add(copy.range.start, mutation.datesDelta),
        end: dateEnv.add(copy.range.end, mutation.datesDelta)
    };
    if (mutation.startDelta && eventConfig.durationEditable) copy.range = {
        start: dateEnv.add(copy.range.start, mutation.startDelta),
        end: copy.range.end
    };
    if (mutation.endDelta && eventConfig.durationEditable) copy.range = {
        start: copy.range.start,
        end: dateEnv.add(copy.range.end, mutation.endDelta)
    };
    if (clearEnd) copy.range = {
        start: copy.range.start,
        end: $307e0d89efad9a8a$export$bde1ed0f60b38f2f(eventDef.allDay, copy.range.start, context)
    };
    // in case event was all-day but the supplied deltas were not
    // better util for this?
    if (eventDef.allDay) copy.range = {
        start: $307e0d89efad9a8a$export$9e5f44173e64f162(copy.range.start),
        end: $307e0d89efad9a8a$export$9e5f44173e64f162(copy.range.end)
    };
    // handle invalid durations
    if (copy.range.end < copy.range.start) copy.range.end = $307e0d89efad9a8a$export$bde1ed0f60b38f2f(eventDef.allDay, copy.range.start, context);
    return copy;
}
var $307e0d89efad9a8a$var$EventSourceImpl = /*#__PURE__*/ function() {
    "use strict";
    function EventSourceImpl(context, internalEventSource) {
        (0, $luoZD._)(this, EventSourceImpl);
        this.context = context;
        this.internalEventSource = internalEventSource;
    }
    (0, $fYUO3._)(EventSourceImpl, [
        {
            key: "remove",
            value: function remove() {
                this.context.dispatch({
                    type: "REMOVE_EVENT_SOURCE",
                    sourceId: this.internalEventSource.sourceId
                });
            }
        },
        {
            key: "refetch",
            value: function refetch() {
                this.context.dispatch({
                    type: "FETCH_EVENT_SOURCES",
                    sourceIds: [
                        this.internalEventSource.sourceId
                    ],
                    isRefetch: true
                });
            }
        },
        {
            key: "id",
            get: function get() {
                return this.internalEventSource.publicId;
            }
        },
        {
            key: "url",
            get: function get() {
                return this.internalEventSource.meta.url;
            }
        },
        {
            key: "format",
            get: function get() {
                return this.internalEventSource.meta.format; // TODO: bad. not guaranteed
            }
        }
    ]);
    return EventSourceImpl;
}();
var $307e0d89efad9a8a$export$71511d61b312f219 = /*#__PURE__*/ function() {
    "use strict";
    function EventImpl(context, def, instance) {
        (0, $luoZD._)(this, EventImpl);
        this._context = context;
        this._def = def;
        this._instance = instance || null;
    }
    (0, $fYUO3._)(EventImpl, [
        {
            /*
    TODO: make event struct more responsible for this
    */ key: "setProp",
            value: function setProp(name, val) {
                if (name in $307e0d89efad9a8a$var$EVENT_DATE_REFINERS) console.warn("Could not set date-related prop 'name'. Use one of the date-related methods instead.");
                else if (name === "id") {
                    val = $307e0d89efad9a8a$var$EVENT_NON_DATE_REFINERS[name](val);
                    this.mutate({
                        standardProps: {
                            publicId: val
                        }
                    });
                } else if (name in $307e0d89efad9a8a$var$EVENT_NON_DATE_REFINERS) {
                    val = $307e0d89efad9a8a$var$EVENT_NON_DATE_REFINERS[name](val);
                    this.mutate({
                        standardProps: {
                            [name]: val
                        }
                    });
                } else if (name in $307e0d89efad9a8a$var$EVENT_UI_REFINERS) {
                    var ui = $307e0d89efad9a8a$var$EVENT_UI_REFINERS[name](val);
                    if (name === "color") ui = {
                        backgroundColor: val,
                        borderColor: val
                    };
                    else if (name === "editable") ui = {
                        startEditable: val,
                        durationEditable: val
                    };
                    else ui = {
                        [name]: val
                    };
                    this.mutate({
                        standardProps: {
                            ui: ui
                        }
                    });
                } else console.warn("Could not set prop '".concat(name, "'. Use setExtendedProp instead."));
            }
        },
        {
            key: "setExtendedProp",
            value: function setExtendedProp(name, val) {
                this.mutate({
                    extendedProps: {
                        [name]: val
                    }
                });
            }
        },
        {
            key: "setStart",
            value: function setStart(startInput) {
                var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var dateEnv = this._context.dateEnv;
                var start = dateEnv.createMarker(startInput);
                if (start && this._instance) {
                    var instanceRange = this._instance.range;
                    var startDelta = $307e0d89efad9a8a$export$28f7fcd39efa255(instanceRange.start, start, dateEnv, options.granularity); // what if parsed bad!?
                    if (options.maintainDuration) this.mutate({
                        datesDelta: startDelta
                    });
                    else this.mutate({
                        startDelta: startDelta
                    });
                }
            }
        },
        {
            key: "setEnd",
            value: function setEnd(endInput) {
                var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var dateEnv = this._context.dateEnv;
                var end;
                if (endInput != null) {
                    end = dateEnv.createMarker(endInput);
                    if (!end) return; // TODO: warning if parsed bad
                }
                if (this._instance) {
                    if (end) {
                        var endDelta = $307e0d89efad9a8a$export$28f7fcd39efa255(this._instance.range.end, end, dateEnv, options.granularity);
                        this.mutate({
                            endDelta: endDelta
                        });
                    } else this.mutate({
                        standardProps: {
                            hasEnd: false
                        }
                    });
                }
            }
        },
        {
            key: "setDates",
            value: function setDates(startInput, endInput) {
                var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                var dateEnv = this._context.dateEnv;
                var standardProps = {
                    allDay: options.allDay
                };
                var start = dateEnv.createMarker(startInput);
                var end;
                if (!start) return; // TODO: warning if parsed bad
                if (endInput != null) {
                    end = dateEnv.createMarker(endInput);
                    if (!end) return;
                }
                if (this._instance) {
                    var instanceRange = this._instance.range;
                    // when computing the diff for an event being converted to all-day,
                    // compute diff off of the all-day values the way event-mutation does.
                    if (options.allDay === true) instanceRange = $307e0d89efad9a8a$var$computeAlignedDayRange(instanceRange);
                    var startDelta = $307e0d89efad9a8a$export$28f7fcd39efa255(instanceRange.start, start, dateEnv, options.granularity);
                    if (end) {
                        var endDelta = $307e0d89efad9a8a$export$28f7fcd39efa255(instanceRange.end, end, dateEnv, options.granularity);
                        if ($307e0d89efad9a8a$var$durationsEqual(startDelta, endDelta)) this.mutate({
                            datesDelta: startDelta,
                            standardProps: standardProps
                        });
                        else this.mutate({
                            startDelta: startDelta,
                            endDelta: endDelta,
                            standardProps: standardProps
                        });
                    } else {
                        standardProps.hasEnd = false;
                        this.mutate({
                            datesDelta: startDelta,
                            standardProps: standardProps
                        });
                    }
                }
            }
        },
        {
            key: "moveStart",
            value: function moveStart(deltaInput) {
                var delta = $307e0d89efad9a8a$export$4368d992c4eafac0(deltaInput);
                if (delta) this.mutate({
                    startDelta: delta
                });
            }
        },
        {
            key: "moveEnd",
            value: function moveEnd(deltaInput) {
                var delta = $307e0d89efad9a8a$export$4368d992c4eafac0(deltaInput);
                if (delta) this.mutate({
                    endDelta: delta
                });
            }
        },
        {
            key: "moveDates",
            value: function moveDates(deltaInput) {
                var delta = $307e0d89efad9a8a$export$4368d992c4eafac0(deltaInput);
                if (delta) this.mutate({
                    datesDelta: delta
                });
            }
        },
        {
            key: "setAllDay",
            value: function setAllDay(allDay) {
                var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var standardProps = {
                    allDay: allDay
                };
                var maintainDuration = options.maintainDuration;
                if (maintainDuration == null) maintainDuration = this._context.options.allDayMaintainDuration;
                if (this._def.allDay !== allDay) standardProps.hasEnd = maintainDuration;
                this.mutate({
                    standardProps: standardProps
                });
            }
        },
        {
            key: "formatRange",
            value: function formatRange(formatInput) {
                var dateEnv = this._context.dateEnv;
                var instance = this._instance;
                var formatter = $307e0d89efad9a8a$export$d141bba7fdc215a3(formatInput);
                if (this._def.hasEnd) return dateEnv.formatRange(instance.range.start, instance.range.end, formatter, {
                    forcedStartTzo: instance.forcedStartTzo,
                    forcedEndTzo: instance.forcedEndTzo
                });
                return dateEnv.format(instance.range.start, formatter, {
                    forcedTzo: instance.forcedStartTzo
                });
            }
        },
        {
            key: "mutate",
            value: function mutate(mutation) {
                var instance = this._instance;
                if (instance) {
                    var def = this._def;
                    var context = this._context;
                    var eventStore = context.getCurrentData().eventStore;
                    var relevantEvents = $307e0d89efad9a8a$export$667d3bf0c5f83305(eventStore, instance.instanceId);
                    var eventConfigBase = {
                        "": {
                            display: "",
                            startEditable: true,
                            durationEditable: true,
                            constraints: [],
                            overlap: null,
                            allows: [],
                            backgroundColor: "",
                            borderColor: "",
                            textColor: "",
                            classNames: []
                        }
                    };
                    relevantEvents = $307e0d89efad9a8a$export$dabba94403d45c8e(relevantEvents, eventConfigBase, mutation, context);
                    var oldEvent = new EventImpl(context, def, instance); // snapshot
                    this._def = relevantEvents.defs[def.defId];
                    this._instance = relevantEvents.instances[instance.instanceId];
                    context.dispatch({
                        type: "MERGE_EVENTS",
                        eventStore: relevantEvents
                    });
                    context.emitter.trigger("eventChange", {
                        oldEvent: oldEvent,
                        event: this,
                        relatedEvents: $307e0d89efad9a8a$export$efccba1c4a2ef57b(relevantEvents, context, instance),
                        revert: function() {
                            context.dispatch({
                                type: "RESET_EVENTS",
                                eventStore: eventStore
                            });
                        }
                    });
                }
            }
        },
        {
            key: "remove",
            value: function remove() {
                var context = this._context;
                var asStore = $307e0d89efad9a8a$var$eventApiToStore(this);
                context.dispatch({
                    type: "REMOVE_EVENTS",
                    eventStore: asStore
                });
                context.emitter.trigger("eventRemove", {
                    event: this,
                    relatedEvents: [],
                    revert: function() {
                        context.dispatch({
                            type: "MERGE_EVENTS",
                            eventStore: asStore
                        });
                    }
                });
            }
        },
        {
            key: "source",
            get: function get() {
                var sourceId = this._def.sourceId;
                if (sourceId) return new $307e0d89efad9a8a$var$EventSourceImpl(this._context, this._context.getCurrentData().eventSources[sourceId]);
                return null;
            }
        },
        {
            key: "start",
            get: function get() {
                return this._instance ? this._context.dateEnv.toDate(this._instance.range.start) : null;
            }
        },
        {
            key: "end",
            get: function get() {
                return this._instance && this._def.hasEnd ? this._context.dateEnv.toDate(this._instance.range.end) : null;
            }
        },
        {
            key: "startStr",
            get: function get() {
                var instance = this._instance;
                if (instance) return this._context.dateEnv.formatIso(instance.range.start, {
                    omitTime: this._def.allDay,
                    forcedTzo: instance.forcedStartTzo
                });
                return "";
            }
        },
        {
            key: "endStr",
            get: function get() {
                var instance = this._instance;
                if (instance && this._def.hasEnd) return this._context.dateEnv.formatIso(instance.range.end, {
                    omitTime: this._def.allDay,
                    forcedTzo: instance.forcedEndTzo
                });
                return "";
            }
        },
        {
            key: "id",
            get: // computable props that all access the def
            // TODO: find a TypeScript-compatible way to do this at scale
            function get() {
                return this._def.publicId;
            }
        },
        {
            key: "groupId",
            get: function get() {
                return this._def.groupId;
            }
        },
        {
            key: "allDay",
            get: function get() {
                return this._def.allDay;
            }
        },
        {
            key: "title",
            get: function get() {
                return this._def.title;
            }
        },
        {
            key: "url",
            get: function get() {
                return this._def.url;
            }
        },
        {
            key: "display",
            get: function get() {
                return this._def.ui.display || "auto";
            } // bad. just normalize the type earlier
        },
        {
            key: "startEditable",
            get: function get() {
                return this._def.ui.startEditable;
            }
        },
        {
            key: "durationEditable",
            get: function get() {
                return this._def.ui.durationEditable;
            }
        },
        {
            key: "constraint",
            get: function get() {
                return this._def.ui.constraints[0] || null;
            }
        },
        {
            key: "overlap",
            get: function get() {
                return this._def.ui.overlap;
            }
        },
        {
            key: "allow",
            get: function get() {
                return this._def.ui.allows[0] || null;
            }
        },
        {
            key: "backgroundColor",
            get: function get() {
                return this._def.ui.backgroundColor;
            }
        },
        {
            key: "borderColor",
            get: function get() {
                return this._def.ui.borderColor;
            }
        },
        {
            key: "textColor",
            get: function get() {
                return this._def.ui.textColor;
            }
        },
        {
            key: "classNames",
            get: // NOTE: user can't modify these because Object.freeze was called in event-def parsing
            function get() {
                return this._def.ui.classNames;
            }
        },
        {
            key: "extendedProps",
            get: function get() {
                return this._def.extendedProps;
            }
        },
        {
            key: "toPlainObject",
            value: function toPlainObject() {
                var settings = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var def = this._def;
                var ui = def.ui;
                var _this = this, startStr = _this.startStr, endStr = _this.endStr;
                var res = {
                    allDay: def.allDay
                };
                if (def.title) res.title = def.title;
                if (startStr) res.start = startStr;
                if (endStr) res.end = endStr;
                if (def.publicId) res.id = def.publicId;
                if (def.groupId) res.groupId = def.groupId;
                if (def.url) res.url = def.url;
                if (ui.display && ui.display !== "auto") res.display = ui.display;
                // TODO: what about recurring-event properties???
                // TODO: include startEditable/durationEditable/constraint/overlap/allow
                if (settings.collapseColor && ui.backgroundColor && ui.backgroundColor === ui.borderColor) res.color = ui.backgroundColor;
                else {
                    if (ui.backgroundColor) res.backgroundColor = ui.backgroundColor;
                    if (ui.borderColor) res.borderColor = ui.borderColor;
                }
                if (ui.textColor) res.textColor = ui.textColor;
                if (ui.classNames.length) res.classNames = ui.classNames;
                if (Object.keys(def.extendedProps).length) {
                    if (settings.collapseExtendedProps) Object.assign(res, def.extendedProps);
                    else res.extendedProps = def.extendedProps;
                }
                return res;
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return this.toPlainObject();
            }
        }
    ]);
    return EventImpl;
}();
function $307e0d89efad9a8a$var$eventApiToStore(eventApi) {
    var def = eventApi._def;
    var instance = eventApi._instance;
    return {
        defs: {
            [def.defId]: def
        },
        instances: instance ? {
            [instance.instanceId]: instance
        } : {}
    };
}
function $307e0d89efad9a8a$export$efccba1c4a2ef57b(eventStore, context, excludeInstance) {
    var defs = eventStore.defs, instances = eventStore.instances;
    var eventApis = [];
    var excludeInstanceId = excludeInstance ? excludeInstance.instanceId : "";
    for(var id in instances){
        var instance = instances[id];
        var def = defs[instance.defId];
        if (instance.instanceId !== excludeInstanceId) eventApis.push(new $307e0d89efad9a8a$export$71511d61b312f219(context, def, instance));
    }
    return eventApis;
}
/*
Specifying nextDayThreshold signals that all-day ranges should be sliced.
*/ function $307e0d89efad9a8a$export$4c3d22f3d993c33f(eventStore, eventUiBases, framingRange, nextDayThreshold) {
    var inverseBgByGroupId = {};
    var inverseBgByDefId = {};
    var defByGroupId = {};
    var bgRanges = [];
    var fgRanges = [];
    var eventUis = $307e0d89efad9a8a$var$compileEventUis(eventStore.defs, eventUiBases);
    for(var defId in eventStore.defs){
        var def = eventStore.defs[defId];
        var ui = eventUis[def.defId];
        if (ui.display === "inverse-background") {
            if (def.groupId) {
                inverseBgByGroupId[def.groupId] = [];
                if (!defByGroupId[def.groupId]) defByGroupId[def.groupId] = def;
            } else inverseBgByDefId[defId] = [];
        }
    }
    for(var instanceId in eventStore.instances){
        var instance = eventStore.instances[instanceId];
        var def1 = eventStore.defs[instance.defId];
        var ui1 = eventUis[def1.defId];
        var origRange = instance.range;
        var normalRange = !def1.allDay && nextDayThreshold ? $307e0d89efad9a8a$export$92108d983e8ee699(origRange, nextDayThreshold) : origRange;
        var slicedRange = $307e0d89efad9a8a$export$ae1af26003f05816(normalRange, framingRange);
        if (slicedRange) {
            if (ui1.display === "inverse-background") {
                if (def1.groupId) inverseBgByGroupId[def1.groupId].push(slicedRange);
                else inverseBgByDefId[instance.defId].push(slicedRange);
            } else if (ui1.display !== "none") (ui1.display === "background" ? bgRanges : fgRanges).push({
                def: def1,
                ui: ui1,
                instance: instance,
                range: slicedRange,
                isStart: normalRange.start && normalRange.start.valueOf() === slicedRange.start.valueOf(),
                isEnd: normalRange.end && normalRange.end.valueOf() === slicedRange.end.valueOf()
            });
        }
    }
    for(var groupId in inverseBgByGroupId){
        var ranges = inverseBgByGroupId[groupId];
        var invertedRanges = $307e0d89efad9a8a$var$invertRanges(ranges, framingRange);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = invertedRanges[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var invertedRange = _step.value;
                var def2 = defByGroupId[groupId];
                var ui2 = eventUis[def2.defId];
                bgRanges.push({
                    def: def2,
                    ui: ui2,
                    instance: null,
                    range: invertedRange,
                    isStart: false,
                    isEnd: false
                });
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    for(var defId1 in inverseBgByDefId){
        var ranges1 = inverseBgByDefId[defId1];
        var invertedRanges1 = $307e0d89efad9a8a$var$invertRanges(ranges1, framingRange);
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = invertedRanges1[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var invertedRange1 = _step1.value;
                bgRanges.push({
                    def: eventStore.defs[defId1],
                    ui: eventUis[defId1],
                    instance: null,
                    range: invertedRange1,
                    isStart: false,
                    isEnd: false
                });
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
    }
    return {
        bg: bgRanges,
        fg: fgRanges
    };
}
function $307e0d89efad9a8a$export$45aabb5431c2d04f(def) {
    return def.ui.display === "background" || def.ui.display === "inverse-background";
}
function $307e0d89efad9a8a$var$setElSeg(el, seg) {
    el.fcSeg = seg;
}
function $307e0d89efad9a8a$export$8743009a87fcb00f(el) {
    return el.fcSeg || el.parentNode.fcSeg || // for the harness
    null;
}
// event ui computation
function $307e0d89efad9a8a$var$compileEventUis(eventDefs, eventUiBases) {
    return $307e0d89efad9a8a$export$407448d2b89b1813(eventDefs, function(eventDef) {
        return $307e0d89efad9a8a$var$compileEventUi(eventDef, eventUiBases);
    });
}
function $307e0d89efad9a8a$var$compileEventUi(eventDef, eventUiBases) {
    var uis = [];
    if (eventUiBases[""]) uis.push(eventUiBases[""]);
    if (eventUiBases[eventDef.defId]) uis.push(eventUiBases[eventDef.defId]);
    uis.push(eventDef.ui);
    return $307e0d89efad9a8a$export$1ee57be6f6687d2c(uis);
}
function $307e0d89efad9a8a$export$a91cd623adc48128(segs, eventOrderSpecs) {
    var objs = segs.map($307e0d89efad9a8a$var$buildSegCompareObj);
    objs.sort(function(obj0, obj1) {
        return $307e0d89efad9a8a$export$306ddfe3a8403e2(obj0, obj1, eventOrderSpecs);
    });
    return objs.map(function(c) {
        return c._seg;
    });
}
// returns a object with all primitive props that can be compared
function $307e0d89efad9a8a$var$buildSegCompareObj(seg) {
    var eventRange = seg.eventRange;
    var eventDef = eventRange.def;
    var range = eventRange.instance ? eventRange.instance.range : eventRange.range;
    var start = range.start ? range.start.valueOf() : 0; // TODO: better support for open-range events
    var end = range.end ? range.end.valueOf() : 0; // "
    return Object.assign(Object.assign(Object.assign({}, eventDef.extendedProps), eventDef), {
        id: eventDef.publicId,
        start: start,
        end: end,
        duration: end - start,
        allDay: Number(eventDef.allDay),
        _seg: seg
    });
}
function $307e0d89efad9a8a$var$computeSegDraggable(seg, context) {
    var pluginHooks = context.pluginHooks;
    var transformers = pluginHooks.isDraggableTransformers;
    var _seg_eventRange = seg.eventRange, def = _seg_eventRange.def, ui = _seg_eventRange.ui;
    var val = ui.startEditable;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = transformers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var transformer = _step.value;
            val = transformer(val, def, ui, context);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return val;
}
function $307e0d89efad9a8a$var$computeSegStartResizable(seg, context) {
    return seg.isStart && seg.eventRange.ui.durationEditable && context.options.eventResizableFromStart;
}
function $307e0d89efad9a8a$var$computeSegEndResizable(seg, context) {
    return seg.isEnd && seg.eventRange.ui.durationEditable;
}
function $307e0d89efad9a8a$export$2538633961795d6b(seg, timeFormat, context, defaultDisplayEventTime, defaultDisplayEventEnd, startOverride, endOverride) {
    var dateEnv = context.dateEnv, options = context.options;
    var displayEventTime = options.displayEventTime, displayEventEnd = options.displayEventEnd;
    var eventDef = seg.eventRange.def;
    var eventInstance = seg.eventRange.instance;
    if (displayEventTime == null) displayEventTime = defaultDisplayEventTime !== false;
    if (displayEventEnd == null) displayEventEnd = defaultDisplayEventEnd !== false;
    var wholeEventStart = eventInstance.range.start;
    var wholeEventEnd = eventInstance.range.end;
    var segStart = startOverride || seg.start || seg.eventRange.range.start;
    var segEnd = endOverride || seg.end || seg.eventRange.range.end;
    var isStartDay = $307e0d89efad9a8a$export$9e5f44173e64f162(wholeEventStart).valueOf() === $307e0d89efad9a8a$export$9e5f44173e64f162(segStart).valueOf();
    var isEndDay = $307e0d89efad9a8a$export$9e5f44173e64f162($307e0d89efad9a8a$export$51b138e5a065c2bb(wholeEventEnd, -1)).valueOf() === $307e0d89efad9a8a$export$9e5f44173e64f162($307e0d89efad9a8a$export$51b138e5a065c2bb(segEnd, -1)).valueOf();
    if (displayEventTime && !eventDef.allDay && (isStartDay || isEndDay)) {
        segStart = isStartDay ? wholeEventStart : segStart;
        segEnd = isEndDay ? wholeEventEnd : segEnd;
        if (displayEventEnd && eventDef.hasEnd) return dateEnv.formatRange(segStart, segEnd, timeFormat, {
            forcedStartTzo: startOverride ? null : eventInstance.forcedStartTzo,
            forcedEndTzo: endOverride ? null : eventInstance.forcedEndTzo
        });
        return dateEnv.format(segStart, timeFormat, {
            forcedTzo: startOverride ? null : eventInstance.forcedStartTzo
        });
    }
    return "";
}
function $307e0d89efad9a8a$export$993a080e5cb62d74(seg, todayRange, nowDate) {
    var segRange = seg.eventRange.range;
    return {
        isPast: segRange.end <= (nowDate || todayRange.start),
        isFuture: segRange.start >= (nowDate || todayRange.end),
        isToday: todayRange && $307e0d89efad9a8a$export$2329c99376c9d0a4(todayRange, segRange.start)
    };
}
function $307e0d89efad9a8a$var$getEventClassNames(props) {
    var classNames = [
        "fc-event"
    ];
    if (props.isMirror) classNames.push("fc-event-mirror");
    if (props.isDraggable) classNames.push("fc-event-draggable");
    if (props.isStartResizable || props.isEndResizable) classNames.push("fc-event-resizable");
    if (props.isDragging) classNames.push("fc-event-dragging");
    if (props.isResizing) classNames.push("fc-event-resizing");
    if (props.isSelected) classNames.push("fc-event-selected");
    if (props.isStart) classNames.push("fc-event-start");
    if (props.isEnd) classNames.push("fc-event-end");
    if (props.isPast) classNames.push("fc-event-past");
    if (props.isToday) classNames.push("fc-event-today");
    if (props.isFuture) classNames.push("fc-event-future");
    return classNames;
}
function $307e0d89efad9a8a$export$4d522598b426bb73(eventRange) {
    return eventRange.instance ? eventRange.instance.instanceId : "".concat(eventRange.def.defId, ":").concat(eventRange.range.start.toISOString());
// inverse-background events don't have specific instances. TODO: better solution
}
function $307e0d89efad9a8a$export$6dabbe08653f866f(seg, context) {
    var _seg_eventRange = seg.eventRange, def = _seg_eventRange.def, instance = _seg_eventRange.instance;
    var url = def.url;
    if (url) return {
        href: url
    };
    var emitter = context.emitter, options = context.options;
    var eventInteractive = options.eventInteractive;
    if (eventInteractive == null) {
        eventInteractive = def.interactive;
        if (eventInteractive == null) eventInteractive = Boolean(emitter.hasHandlers("eventClick"));
    }
    // mock what happens in EventClicking
    if (eventInteractive) // only attach keyboard-related handlers because click handler is already done in EventClicking
    return $307e0d89efad9a8a$var$createAriaKeyboardAttrs(function(ev) {
        emitter.trigger("eventClick", {
            el: ev.target,
            event: new $307e0d89efad9a8a$export$71511d61b312f219(context, def, instance),
            jsEvent: ev,
            view: context.viewApi
        });
    });
    return {};
}
var $307e0d89efad9a8a$var$STANDARD_PROPS = {
    start: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    end: $307e0d89efad9a8a$export$7ccc53e8f1e7dfc5,
    allDay: Boolean
};
function $307e0d89efad9a8a$var$parseDateSpan(raw, dateEnv, defaultDuration) {
    var span = $307e0d89efad9a8a$var$parseOpenDateSpan(raw, dateEnv);
    var range = span.range;
    if (!range.start) return null;
    if (!range.end) {
        if (defaultDuration == null) return null;
        range.end = dateEnv.add(range.start, defaultDuration);
    }
    return span;
}
/*
TODO: somehow combine with parseRange?
Will return null if the start/end props were present but parsed invalidly.
*/ function $307e0d89efad9a8a$var$parseOpenDateSpan(raw, dateEnv) {
    var _refineProps = $307e0d89efad9a8a$export$ee7c8ad385a60b7b(raw, $307e0d89efad9a8a$var$STANDARD_PROPS), standardProps = _refineProps.refined, extra = _refineProps.extra;
    var startMeta = standardProps.start ? dateEnv.createMarkerMeta(standardProps.start) : null;
    var endMeta = standardProps.end ? dateEnv.createMarkerMeta(standardProps.end) : null;
    var allDay = standardProps.allDay;
    if (allDay == null) allDay = startMeta && startMeta.isTimeUnspecified && (!endMeta || endMeta.isTimeUnspecified);
    return Object.assign({
        range: {
            start: startMeta ? startMeta.marker : null,
            end: endMeta ? endMeta.marker : null
        },
        allDay: allDay
    }, extra);
}
function $307e0d89efad9a8a$export$7f557e5eb95176c2(span0, span1) {
    return $307e0d89efad9a8a$export$7a0bdf7d4a91ea88(span0.range, span1.range) && span0.allDay === span1.allDay && $307e0d89efad9a8a$var$isSpanPropsEqual(span0, span1);
}
// the NON-DATE-RELATED props
function $307e0d89efad9a8a$var$isSpanPropsEqual(span0, span1) {
    for(var propName in span1)if (propName !== "range" && propName !== "allDay") {
        if (span0[propName] !== span1[propName]) return false;
    }
    // are there any props that span0 has that span1 DOESN'T have?
    // both have range/allDay, so no need to special-case.
    for(var propName1 in span0){
        if (!(propName1 in span1)) return false;
    }
    return true;
}
function $307e0d89efad9a8a$var$buildDateSpanApi(span, dateEnv) {
    return Object.assign(Object.assign({}, $307e0d89efad9a8a$var$buildRangeApi(span.range, dateEnv, span.allDay)), {
        allDay: span.allDay
    });
}
function $307e0d89efad9a8a$export$882b5998b3b9117c(range, dateEnv, omitTime) {
    return Object.assign(Object.assign({}, $307e0d89efad9a8a$var$buildRangeApi(range, dateEnv, omitTime)), {
        timeZone: dateEnv.timeZone
    });
}
function $307e0d89efad9a8a$var$buildRangeApi(range, dateEnv, omitTime) {
    return {
        start: dateEnv.toDate(range.start),
        end: dateEnv.toDate(range.end),
        startStr: dateEnv.formatIso(range.start, {
            omitTime: omitTime
        }),
        endStr: dateEnv.formatIso(range.end, {
            omitTime: omitTime
        })
    };
}
function $307e0d89efad9a8a$var$fabricateEventRange(dateSpan, eventUiBases, context) {
    var res = $307e0d89efad9a8a$export$3b513254972cfc9c({
        editable: false
    }, context);
    var def = $307e0d89efad9a8a$export$f38c853ae54ed474(res.refined, res.extra, "", dateSpan.allDay, true, context);
    return {
        def: def,
        ui: $307e0d89efad9a8a$var$compileEventUi(def, eventUiBases),
        instance: $307e0d89efad9a8a$export$995eb9fca571757(def.defId, dateSpan.range),
        range: dateSpan.range,
        isStart: true,
        isEnd: true
    };
}
/*
given a function that resolves a result asynchronously.
the function can either call passed-in success and failure callbacks,
or it can return a promise.
if you need to pass additional params to func, bind them first.
*/ function $307e0d89efad9a8a$export$3b14a55fb2447963(func, normalizedSuccessCallback, normalizedFailureCallback) {
    // guard against success/failure callbacks being called more than once
    // and guard against a promise AND callback being used together.
    var isResolved = false;
    var wrappedSuccess = function wrappedSuccess(res) {
        if (!isResolved) {
            isResolved = true;
            normalizedSuccessCallback(res);
        }
    };
    var wrappedFailure = function wrappedFailure(error) {
        if (!isResolved) {
            isResolved = true;
            normalizedFailureCallback(error);
        }
    };
    var res = func(wrappedSuccess, wrappedFailure);
    if (res && typeof res.then === "function") res.then(wrappedSuccess, wrappedFailure);
}
var $307e0d89efad9a8a$export$f787f51d84a910ad = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $7DbRq._)(JsonRequestError, Error1);
    var _super = (0, $ju9pQ._)(JsonRequestError);
    function JsonRequestError(message, response) {
        (0, $luoZD._)(this, JsonRequestError);
        var _this;
        _this = _super.call(this, message);
        _this.response = response;
        return _this;
    }
    return JsonRequestError;
}((0, $a3QmP._)(Error));
function $307e0d89efad9a8a$export$43caf9889c228507(method, url, params) {
    method = method.toUpperCase();
    var fetchOptions = {
        method: method
    };
    if (method === "GET") url += (url.indexOf("?") === -1 ? "?" : "&") + new URLSearchParams(params);
    else {
        fetchOptions.body = new URLSearchParams(params);
        fetchOptions.headers = {
            "Content-Type": "application/x-www-form-urlencoded"
        };
    }
    return fetch(url, fetchOptions).then(function(fetchRes) {
        if (fetchRes.ok) return fetchRes.json().then(function(parsedResponse) {
            return [
                parsedResponse,
                fetchRes
            ];
        }, function() {
            throw new $307e0d89efad9a8a$export$f787f51d84a910ad("Failure parsing JSON", fetchRes);
        });
        else throw new $307e0d89efad9a8a$export$f787f51d84a910ad("Request failed", fetchRes);
    });
}
var $307e0d89efad9a8a$var$canVGrowWithinCell;
function $307e0d89efad9a8a$export$738ab4df8bf92ae9() {
    if ($307e0d89efad9a8a$var$canVGrowWithinCell == null) $307e0d89efad9a8a$var$canVGrowWithinCell = $307e0d89efad9a8a$var$computeCanVGrowWithinCell();
    return $307e0d89efad9a8a$var$canVGrowWithinCell;
}
function $307e0d89efad9a8a$var$computeCanVGrowWithinCell() {
    // for SSR, because this function is call immediately at top-level
    // TODO: just make this logic execute top-level, immediately, instead of doing lazily
    if (typeof document === "undefined") return true;
    var el = document.createElement("div");
    el.style.position = "absolute";
    el.style.top = "0px";
    el.style.left = "0px";
    el.innerHTML = "<table><tr><td><div></div></td></tr></table>";
    el.querySelector("table").style.height = "100px";
    el.querySelector("div").style.height = "100%";
    document.body.appendChild(el);
    var div = el.querySelector("div");
    var possible = div.offsetHeight > 0;
    document.body.removeChild(el);
    return possible;
}
var $307e0d89efad9a8a$export$a9c996f45e5784d0 = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $7DbRq._)(CalendarRoot, BaseComponent);
    var _super = (0, $ju9pQ._)(CalendarRoot);
    function CalendarRoot() {
        (0, $luoZD._)(this, CalendarRoot);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.state = {
            forPrint: false
        };
        _this.handleBeforePrint = function() {
            $307e0d89efad9a8a$export$c3950d9923825c02(function() {
                _this.setState({
                    forPrint: true
                });
            });
        };
        _this.handleAfterPrint = function() {
            $307e0d89efad9a8a$export$c3950d9923825c02(function() {
                _this.setState({
                    forPrint: false
                });
            });
        };
        return _this;
    }
    (0, $fYUO3._)(CalendarRoot, [
        {
            key: "render",
            value: function render() {
                var props = this.props;
                var options = props.options;
                var forPrint = this.state.forPrint;
                var isHeightAuto = forPrint || options.height === "auto" || options.contentHeight === "auto";
                var height = !isHeightAuto && options.height != null ? options.height : "";
                var classNames = [
                    "fc",
                    forPrint ? "fc-media-print" : "fc-media-screen",
                    "fc-direction-".concat(options.direction),
                    props.theme.getClass("root")
                ];
                if (!$307e0d89efad9a8a$export$738ab4df8bf92ae9()) classNames.push("fc-liquid-hack");
                return props.children(classNames, height, isHeightAuto, forPrint);
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var emitter = this.props.emitter;
                emitter.on("_beforeprint", this.handleBeforePrint);
                emitter.on("_afterprint", this.handleAfterPrint);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                var emitter = this.props.emitter;
                emitter.off("_beforeprint", this.handleBeforePrint);
                emitter.off("_afterprint", this.handleAfterPrint);
            }
        }
    ]);
    return CalendarRoot;
}($307e0d89efad9a8a$export$ef35774e6d314e91);
var $307e0d89efad9a8a$export$78acf4525d8a74c4 = /*#__PURE__*/ function() {
    "use strict";
    function Interaction(settings) {
        (0, $luoZD._)(this, Interaction);
        this.component = settings.component;
        this.isHitComboAllowed = settings.isHitComboAllowed || null;
    }
    (0, $fYUO3._)(Interaction, [
        {
            key: "destroy",
            value: function destroy() {}
        }
    ]);
    return Interaction;
}();
function $307e0d89efad9a8a$export$efca4cbe5dd06740(component, input) {
    return {
        component: component,
        el: input.el,
        useEventCenter: input.useEventCenter != null ? input.useEventCenter : true,
        isHitComboAllowed: input.isHitComboAllowed || null
    };
}
function $307e0d89efad9a8a$export$381353cf1dd55255(settings) {
    return {
        [settings.component.uid]: settings
    };
}
// global state
var $307e0d89efad9a8a$export$a8550f7dbe79f93a = {};
var $307e0d89efad9a8a$export$2e2af4578d910ddf = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $7DbRq._)(NowTimer, Component);
    var _super = (0, $ju9pQ._)(NowTimer);
    function NowTimer(props, context) {
        (0, $luoZD._)(this, NowTimer);
        var _this;
        _this = _super.call(this, props, context);
        _this.handleRefresh = function() {
            var timing = _this.computeTiming();
            if (timing.state.nowDate.valueOf() !== _this.state.nowDate.valueOf()) _this.setState(timing.state);
            _this.clearTimeout();
            _this.setTimeout(timing.waitMs);
        };
        _this.handleVisibilityChange = function() {
            if (!document.hidden) _this.handleRefresh();
        };
        _this.state = _this.computeTiming().state;
        return _this;
    }
    (0, $fYUO3._)(NowTimer, [
        {
            key: "render",
            value: function render() {
                var _this = this, props = _this.props, state = _this.state;
                return props.children(state.nowDate, state.todayRange);
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.setTimeout();
                this.context.nowManager.addResetListener(this.handleRefresh);
                // fired tab becomes visible after being hidden
                document.addEventListener("visibilitychange", this.handleVisibilityChange);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                if (prevProps.unit !== this.props.unit) {
                    this.clearTimeout();
                    this.setTimeout();
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.clearTimeout();
                this.context.nowManager.removeResetListener(this.handleRefresh);
                document.removeEventListener("visibilitychange", this.handleVisibilityChange);
            }
        },
        {
            key: "computeTiming",
            value: function computeTiming() {
                var _this = this, props = _this.props, context = _this.context;
                var unroundedNow = context.nowManager.getDateMarker();
                var nowIndicatorSnap = context.options.nowIndicatorSnap;
                if (nowIndicatorSnap === "auto") nowIndicatorSnap = // large unit?
                /year|month|week|day/.test(props.unit) || // if slotDuration 30 mins for example, would NOT appear to snap (legacy behavior)
                (props.unitValue || 1) === 1;
                var nowDate;
                var waitMs;
                if (nowIndicatorSnap) {
                    nowDate = context.dateEnv.startOf(unroundedNow, props.unit); // aka currentUnitStart
                    var nextUnitStart = context.dateEnv.add(nowDate, $307e0d89efad9a8a$export$4368d992c4eafac0(1, props.unit));
                    waitMs = nextUnitStart.valueOf() - unroundedNow.valueOf();
                } else {
                    nowDate = unroundedNow;
                    waitMs = 60000; // 1 minute
                }
                // there is a max setTimeout ms value (https://stackoverflow.com/a/3468650/96342)
                // ensure no longer than a day
                waitMs = Math.min(86400000, waitMs);
                return {
                    state: {
                        nowDate: nowDate,
                        todayRange: $307e0d89efad9a8a$var$buildDayRange(nowDate)
                    },
                    waitMs: waitMs
                };
            }
        },
        {
            key: "setTimeout",
            value: function setTimeout1() {
                var _this = this;
                var waitMs = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.computeTiming().waitMs;
                // NOTE: timeout could take longer than expected if tab sleeps,
                // which is why we listen to 'visibilitychange'
                this.timeoutId = setTimeout(function() {
                    // NOTE: timeout could also return *earlier* than expected, and we need to wait 2 ms more
                    // This is why use use same waitMs from computeTiming, so we don't skip an interval while
                    // .setState() is executing
                    var timing = _this.computeTiming();
                    _this.setState(timing.state, function() {
                        _this.setTimeout(timing.waitMs);
                    });
                }, waitMs);
            }
        },
        {
            key: "clearTimeout",
            value: function clearTimeout1() {
                if (this.timeoutId) clearTimeout(this.timeoutId);
            }
        }
    ]);
    return NowTimer;
}((0, $ihX0O.Component));
$307e0d89efad9a8a$export$2e2af4578d910ddf.contextType = $307e0d89efad9a8a$export$e7c866399fa523f5;
function $307e0d89efad9a8a$var$buildDayRange(date) {
    var start = $307e0d89efad9a8a$export$9e5f44173e64f162(date);
    var end = $307e0d89efad9a8a$export$625550452a3fa3ec(start, 1);
    return {
        start: start,
        end: end
    };
}
var $307e0d89efad9a8a$export$a93c5207d687da10 = /*#__PURE__*/ function() {
    "use strict";
    function CalendarImpl() {
        (0, $luoZD._)(this, CalendarImpl);
    }
    (0, $fYUO3._)(CalendarImpl, [
        {
            key: "getCurrentData",
            value: function getCurrentData() {
                return this.currentDataManager.getCurrentData();
            }
        },
        {
            key: "dispatch",
            value: function dispatch(action) {
                this.currentDataManager.dispatch(action);
            }
        },
        {
            key: "view",
            get: function get() {
                return this.getCurrentData().viewApi;
            }
        },
        {
            key: "batchRendering",
            value: function batchRendering(callback) {
                callback();
            }
        },
        {
            key: "updateSize",
            value: function updateSize() {
                this.trigger("_resize", true);
            }
        },
        {
            // Options
            // -----------------------------------------------------------------------------------------------------------------
            key: "setOption",
            value: function setOption(name, val) {
                this.dispatch({
                    type: "SET_OPTION",
                    optionName: name,
                    rawOptionValue: val
                });
            }
        },
        {
            key: "getOption",
            value: function getOption(name) {
                return this.currentDataManager.currentCalendarOptionsInput[name];
            }
        },
        {
            key: "getAvailableLocaleCodes",
            value: function getAvailableLocaleCodes() {
                return Object.keys(this.getCurrentData().availableRawLocales);
            }
        },
        {
            // Trigger
            // -----------------------------------------------------------------------------------------------------------------
            key: "on",
            value: function on(handlerName, handler) {
                var currentDataManager = this.currentDataManager;
                if (currentDataManager.currentCalendarOptionsRefiners[handlerName]) currentDataManager.emitter.on(handlerName, handler);
                else console.warn("Unknown listener name '".concat(handlerName, "'"));
            }
        },
        {
            key: "off",
            value: function off(handlerName, handler) {
                this.currentDataManager.emitter.off(handlerName, handler);
            }
        },
        {
            // not meant for public use
            key: "trigger",
            value: function trigger(handlerName) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    args[_key - 1] = arguments[_key];
                }
                var _this_currentDataManager_emitter;
                (_this_currentDataManager_emitter = this.currentDataManager.emitter).trigger.apply(_this_currentDataManager_emitter, [
                    handlerName
                ].concat((0, $79xu7._)(args)));
            }
        },
        {
            // View
            // -----------------------------------------------------------------------------------------------------------------
            key: "changeView",
            value: function changeView(viewType, dateOrRange) {
                var _this = this;
                this.batchRendering(function() {
                    _this.unselect();
                    if (dateOrRange) {
                        if (dateOrRange.start && dateOrRange.end) {
                            _this.dispatch({
                                type: "CHANGE_VIEW_TYPE",
                                viewType: viewType
                            });
                            _this.dispatch({
                                type: "SET_OPTION",
                                optionName: "visibleRange",
                                rawOptionValue: dateOrRange
                            });
                        } else {
                            var dateEnv = _this.getCurrentData().dateEnv;
                            _this.dispatch({
                                type: "CHANGE_VIEW_TYPE",
                                viewType: viewType,
                                dateMarker: dateEnv.createMarker(dateOrRange)
                            });
                        }
                    } else _this.dispatch({
                        type: "CHANGE_VIEW_TYPE",
                        viewType: viewType
                    });
                });
            }
        },
        {
            // Forces navigation to a view for the given date.
            // `viewType` can be a specific view name or a generic one like "week" or "day".
            // needs to change
            key: "zoomTo",
            value: function zoomTo(dateMarker, viewType) {
                var state = this.getCurrentData();
                var spec;
                viewType = viewType || "day"; // day is default zoom
                spec = state.viewSpecs[viewType] || this.getUnitViewSpec(viewType);
                this.unselect();
                if (spec) this.dispatch({
                    type: "CHANGE_VIEW_TYPE",
                    viewType: spec.type,
                    dateMarker: dateMarker
                });
                else this.dispatch({
                    type: "CHANGE_DATE",
                    dateMarker: dateMarker
                });
            }
        },
        {
            // Given a duration singular unit, like "week" or "day", finds a matching view spec.
            // Preference is given to views that have corresponding buttons.
            key: "getUnitViewSpec",
            value: function getUnitViewSpec(unit) {
                var _this_getCurrentData = this.getCurrentData(), viewSpecs = _this_getCurrentData.viewSpecs, toolbarConfig = _this_getCurrentData.toolbarConfig;
                var viewTypes = [].concat(toolbarConfig.header ? toolbarConfig.header.viewsWithButtons : [], toolbarConfig.footer ? toolbarConfig.footer.viewsWithButtons : []);
                var i;
                var spec;
                for(var viewType in viewSpecs)viewTypes.push(viewType);
                for(i = 0; i < viewTypes.length; i += 1){
                    spec = viewSpecs[viewTypes[i]];
                    if (spec) {
                        if (spec.singleUnit === unit) return spec;
                    }
                }
                return null;
            }
        },
        {
            // Current Date
            // -----------------------------------------------------------------------------------------------------------------
            key: "prev",
            value: function prev() {
                this.unselect();
                this.dispatch({
                    type: "PREV"
                });
            }
        },
        {
            key: "next",
            value: function next() {
                this.unselect();
                this.dispatch({
                    type: "NEXT"
                });
            }
        },
        {
            key: "prevYear",
            value: function prevYear() {
                var state = this.getCurrentData();
                this.unselect();
                this.dispatch({
                    type: "CHANGE_DATE",
                    dateMarker: state.dateEnv.addYears(state.currentDate, -1)
                });
            }
        },
        {
            key: "nextYear",
            value: function nextYear() {
                var state = this.getCurrentData();
                this.unselect();
                this.dispatch({
                    type: "CHANGE_DATE",
                    dateMarker: state.dateEnv.addYears(state.currentDate, 1)
                });
            }
        },
        {
            key: "today",
            value: function today() {
                var state = this.getCurrentData();
                this.unselect();
                this.dispatch({
                    type: "CHANGE_DATE",
                    dateMarker: state.nowManager.getDateMarker()
                });
            }
        },
        {
            key: "gotoDate",
            value: function gotoDate(zonedDateInput) {
                var state = this.getCurrentData();
                this.unselect();
                this.dispatch({
                    type: "CHANGE_DATE",
                    dateMarker: state.dateEnv.createMarker(zonedDateInput)
                });
            }
        },
        {
            key: "incrementDate",
            value: function incrementDate(deltaInput) {
                var state = this.getCurrentData();
                var delta = $307e0d89efad9a8a$export$4368d992c4eafac0(deltaInput);
                if (delta) {
                    this.unselect();
                    this.dispatch({
                        type: "CHANGE_DATE",
                        dateMarker: state.dateEnv.add(state.currentDate, delta)
                    });
                }
            }
        },
        {
            key: "getDate",
            value: function getDate() {
                var state = this.getCurrentData();
                return state.dateEnv.toDate(state.currentDate);
            }
        },
        {
            // Date Formatting Utils
            // -----------------------------------------------------------------------------------------------------------------
            key: "formatDate",
            value: function formatDate(d, formatter) {
                var dateEnv = this.getCurrentData().dateEnv;
                return dateEnv.format(dateEnv.createMarker(d), $307e0d89efad9a8a$export$d141bba7fdc215a3(formatter));
            }
        },
        {
            // `settings` is for formatter AND isEndExclusive
            key: "formatRange",
            value: function formatRange(d0, d1, settings) {
                var dateEnv = this.getCurrentData().dateEnv;
                return dateEnv.formatRange(dateEnv.createMarker(d0), dateEnv.createMarker(d1), $307e0d89efad9a8a$export$d141bba7fdc215a3(settings), settings);
            }
        },
        {
            key: "formatIso",
            value: function formatIso(d, omitTime) {
                var dateEnv = this.getCurrentData().dateEnv;
                return dateEnv.formatIso(dateEnv.createMarker(d), {
                    omitTime: omitTime
                });
            }
        },
        {
            // Date Selection / Event Selection / DayClick
            // -----------------------------------------------------------------------------------------------------------------
            key: "select",
            value: function select(dateOrObj, endDate) {
                var selectionInput;
                if (endDate == null) {
                    if (dateOrObj.start != null) selectionInput = dateOrObj;
                    else selectionInput = {
                        start: dateOrObj,
                        end: null
                    };
                } else selectionInput = {
                    start: dateOrObj,
                    end: endDate
                };
                var state = this.getCurrentData();
                var selection = $307e0d89efad9a8a$var$parseDateSpan(selectionInput, state.dateEnv, $307e0d89efad9a8a$export$4368d992c4eafac0({
                    days: 1
                }));
                if (selection) {
                    this.dispatch({
                        type: "SELECT_DATES",
                        selection: selection
                    });
                    $307e0d89efad9a8a$export$cbfbec548517f2b6(selection, null, state);
                }
            }
        },
        {
            key: "unselect",
            value: function unselect(pev) {
                var state = this.getCurrentData();
                if (state.dateSelection) {
                    this.dispatch({
                        type: "UNSELECT_DATES"
                    });
                    $307e0d89efad9a8a$var$triggerDateUnselect(pev, state);
                }
            }
        },
        {
            // Public Events API
            // -----------------------------------------------------------------------------------------------------------------
            key: "addEvent",
            value: function addEvent(eventInput, sourceInput) {
                if (eventInput instanceof $307e0d89efad9a8a$export$71511d61b312f219) {
                    var def = eventInput._def;
                    var instance = eventInput._instance;
                    var currentData = this.getCurrentData();
                    // not already present? don't want to add an old snapshot
                    if (!currentData.eventStore.defs[def.defId]) {
                        this.dispatch({
                            type: "ADD_EVENTS",
                            eventStore: $307e0d89efad9a8a$export$317a3d46287192d8({
                                def: def,
                                instance: instance
                            })
                        });
                        this.triggerEventAdd(eventInput);
                    }
                    return eventInput;
                }
                var state = this.getCurrentData();
                var eventSource;
                var ref;
                if (sourceInput instanceof $307e0d89efad9a8a$var$EventSourceImpl) eventSource = sourceInput.internalEventSource;
                else if (typeof sourceInput === "boolean") {
                    if (sourceInput) ref = (0, $4f96i._)($307e0d89efad9a8a$export$90a7f3efeed30595(state.eventSources), 1), eventSource = ref[0], ref;
                } else if (sourceInput != null) {
                    var sourceApi = this.getEventSourceById(sourceInput); // TODO: use an internal function
                    if (!sourceApi) {
                        console.warn('Could not find an event source with ID "'.concat(sourceInput, '"')); // TODO: test
                        return null;
                    }
                    eventSource = sourceApi.internalEventSource;
                }
                var tuple = $307e0d89efad9a8a$var$parseEvent(eventInput, eventSource, state, false);
                if (tuple) {
                    var newEventApi = new $307e0d89efad9a8a$export$71511d61b312f219(state, tuple.def, tuple.def.recurringDef ? null : tuple.instance);
                    this.dispatch({
                        type: "ADD_EVENTS",
                        eventStore: $307e0d89efad9a8a$export$317a3d46287192d8(tuple)
                    });
                    this.triggerEventAdd(newEventApi);
                    return newEventApi;
                }
                return null;
            }
        },
        {
            key: "triggerEventAdd",
            value: function triggerEventAdd(eventApi) {
                var _this = this;
                var emitter = this.getCurrentData().emitter;
                emitter.trigger("eventAdd", {
                    event: eventApi,
                    relatedEvents: [],
                    revert: function() {
                        _this.dispatch({
                            type: "REMOVE_EVENTS",
                            eventStore: $307e0d89efad9a8a$var$eventApiToStore(eventApi)
                        });
                    }
                });
            }
        },
        {
            // TODO: optimize
            key: "getEventById",
            value: function getEventById(id) {
                var state = this.getCurrentData();
                var _state_eventStore = state.eventStore, defs = _state_eventStore.defs, instances = _state_eventStore.instances;
                id = String(id);
                for(var defId in defs){
                    var def = defs[defId];
                    if (def.publicId === id) {
                        if (def.recurringDef) return new $307e0d89efad9a8a$export$71511d61b312f219(state, def, null);
                        for(var instanceId in instances){
                            var instance = instances[instanceId];
                            if (instance.defId === def.defId) return new $307e0d89efad9a8a$export$71511d61b312f219(state, def, instance);
                        }
                    }
                }
                return null;
            }
        },
        {
            key: "getEvents",
            value: function getEvents() {
                var currentData = this.getCurrentData();
                return $307e0d89efad9a8a$export$efccba1c4a2ef57b(currentData.eventStore, currentData);
            }
        },
        {
            key: "removeAllEvents",
            value: function removeAllEvents() {
                this.dispatch({
                    type: "REMOVE_ALL_EVENTS"
                });
            }
        },
        {
            // Public Event Sources API
            // -----------------------------------------------------------------------------------------------------------------
            key: "getEventSources",
            value: function getEventSources() {
                var state = this.getCurrentData();
                var sourceHash = state.eventSources;
                var sourceApis = [];
                for(var internalId in sourceHash)sourceApis.push(new $307e0d89efad9a8a$var$EventSourceImpl(state, sourceHash[internalId]));
                return sourceApis;
            }
        },
        {
            key: "getEventSourceById",
            value: function getEventSourceById(id) {
                var state = this.getCurrentData();
                var sourceHash = state.eventSources;
                id = String(id);
                for(var sourceId in sourceHash){
                    if (sourceHash[sourceId].publicId === id) return new $307e0d89efad9a8a$var$EventSourceImpl(state, sourceHash[sourceId]);
                }
                return null;
            }
        },
        {
            key: "addEventSource",
            value: function addEventSource(sourceInput) {
                var state = this.getCurrentData();
                if (sourceInput instanceof $307e0d89efad9a8a$var$EventSourceImpl) {
                    // not already present? don't want to add an old snapshot
                    if (!state.eventSources[sourceInput.internalEventSource.sourceId]) this.dispatch({
                        type: "ADD_EVENT_SOURCES",
                        sources: [
                            sourceInput.internalEventSource
                        ]
                    });
                    return sourceInput;
                }
                var eventSource = $307e0d89efad9a8a$export$ffb5f4729a158638(sourceInput, state);
                if (eventSource) {
                    this.dispatch({
                        type: "ADD_EVENT_SOURCES",
                        sources: [
                            eventSource
                        ]
                    });
                    return new $307e0d89efad9a8a$var$EventSourceImpl(state, eventSource);
                }
                return null;
            }
        },
        {
            key: "removeAllEventSources",
            value: function removeAllEventSources() {
                this.dispatch({
                    type: "REMOVE_ALL_EVENT_SOURCES"
                });
            }
        },
        {
            key: "refetchEvents",
            value: function refetchEvents() {
                this.dispatch({
                    type: "FETCH_EVENT_SOURCES",
                    isRefetch: true
                });
            }
        },
        {
            // Scroll
            // -----------------------------------------------------------------------------------------------------------------
            key: "scrollToTime",
            value: function scrollToTime(timeInput) {
                var time = $307e0d89efad9a8a$export$4368d992c4eafac0(timeInput);
                if (time) this.trigger("_scrollRequest", {
                    time: time
                });
            }
        }
    ]);
    return CalendarImpl;
}();
function $307e0d89efad9a8a$export$24baa2b76016ce0e(point, rect) {
    return point.left >= rect.left && point.left < rect.right && point.top >= rect.top && point.top < rect.bottom;
}
// Returns a new rectangle that is the intersection of the two rectangles. If they don't intersect, returns false
function $307e0d89efad9a8a$export$890c4ad488842ce7(rect1, rect2) {
    var res = {
        left: Math.max(rect1.left, rect2.left),
        right: Math.min(rect1.right, rect2.right),
        top: Math.max(rect1.top, rect2.top),
        bottom: Math.min(rect1.bottom, rect2.bottom)
    };
    if (res.left < res.right && res.top < res.bottom) return res;
    return false;
}
function $307e0d89efad9a8a$export$a33b77bbdbb8366c(rect, deltaX, deltaY) {
    return {
        left: rect.left + deltaX,
        right: rect.right + deltaX,
        top: rect.top + deltaY,
        bottom: rect.bottom + deltaY
    };
}
// Returns a new point that will have been moved to reside within the given rectangle
function $307e0d89efad9a8a$export$158acd800e1ef08b(point, rect) {
    return {
        left: Math.min(Math.max(point.left, rect.left), rect.right),
        top: Math.min(Math.max(point.top, rect.top), rect.bottom)
    };
}
// Returns a point that is the center of the given rectangle
function $307e0d89efad9a8a$export$cf2f7c5792f80b46(rect) {
    return {
        left: (rect.left + rect.right) / 2,
        top: (rect.top + rect.bottom) / 2
    };
}
// Subtracts point2's coordinates from point1's coordinates, returning a delta
function $307e0d89efad9a8a$export$53a70dd1ebbae346(point1, point2) {
    return {
        left: point1.left - point2.left,
        top: point1.top - point2.top
    };
}
var $307e0d89efad9a8a$var$EMPTY_EVENT_STORE = $307e0d89efad9a8a$export$7f8ddf7c7c20b3cd(); // for purecomponents. TODO: keep elsewhere
var $307e0d89efad9a8a$export$9d0e2d13d04f7070 = /*#__PURE__*/ function() {
    "use strict";
    function Splitter() {
        (0, $luoZD._)(this, Splitter);
        this.getKeysForEventDefs = $307e0d89efad9a8a$export$df995fae86a55f06(this._getKeysForEventDefs);
        this.splitDateSelection = $307e0d89efad9a8a$export$df995fae86a55f06(this._splitDateSpan);
        this.splitEventStore = $307e0d89efad9a8a$export$df995fae86a55f06(this._splitEventStore);
        this.splitIndividualUi = $307e0d89efad9a8a$export$df995fae86a55f06(this._splitIndividualUi);
        this.splitEventDrag = $307e0d89efad9a8a$export$df995fae86a55f06(this._splitInteraction);
        this.splitEventResize = $307e0d89efad9a8a$export$df995fae86a55f06(this._splitInteraction);
        this.eventUiBuilders = {}; // TODO: typescript protection
    }
    (0, $fYUO3._)(Splitter, [
        {
            key: "splitProps",
            value: function splitProps(props) {
                var _this = this;
                var keyInfos = this.getKeyInfo(props);
                var defKeys = this.getKeysForEventDefs(props.eventStore);
                var dateSelections = this.splitDateSelection(props.dateSelection);
                var individualUi = this.splitIndividualUi(props.eventUiBases, defKeys); // the individual *bases*
                var eventStores = this.splitEventStore(props.eventStore, defKeys);
                var eventDrags = this.splitEventDrag(props.eventDrag);
                var eventResizes = this.splitEventResize(props.eventResize);
                var splitProps = {};
                this.eventUiBuilders = $307e0d89efad9a8a$export$407448d2b89b1813(keyInfos, function(info, key) {
                    return _this.eventUiBuilders[key] || $307e0d89efad9a8a$export$df995fae86a55f06($307e0d89efad9a8a$var$buildEventUiForKey);
                });
                for(var key in keyInfos){
                    var keyInfo = keyInfos[key];
                    var eventStore = eventStores[key] || $307e0d89efad9a8a$var$EMPTY_EVENT_STORE;
                    var buildEventUi = this.eventUiBuilders[key];
                    splitProps[key] = {
                        businessHours: keyInfo.businessHours || props.businessHours,
                        dateSelection: dateSelections[key] || null,
                        eventStore: eventStore,
                        eventUiBases: buildEventUi(props.eventUiBases[""], keyInfo.ui, individualUi[key]),
                        eventSelection: eventStore.instances[props.eventSelection] ? props.eventSelection : "",
                        eventDrag: eventDrags[key] || null,
                        eventResize: eventResizes[key] || null
                    };
                }
                return splitProps;
            }
        },
        {
            key: "_splitDateSpan",
            value: function _splitDateSpan(dateSpan) {
                var dateSpans = {};
                if (dateSpan) {
                    var keys = this.getKeysForDateSpan(dateSpan);
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var key = _step.value;
                            dateSpans[key] = dateSpan;
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
                return dateSpans;
            }
        },
        {
            key: "_getKeysForEventDefs",
            value: function _getKeysForEventDefs(eventStore) {
                var _this = this;
                return $307e0d89efad9a8a$export$407448d2b89b1813(eventStore.defs, function(eventDef) {
                    return _this.getKeysForEventDef(eventDef);
                });
            }
        },
        {
            key: "_splitEventStore",
            value: function _splitEventStore(eventStore, defKeys) {
                var defs = eventStore.defs, instances = eventStore.instances;
                var splitStores = {};
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                for(var defId in defs)try {
                    for(var _iterator = defKeys[defId][Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var key = _step.value;
                        if (!splitStores[key]) splitStores[key] = $307e0d89efad9a8a$export$7f8ddf7c7c20b3cd();
                        splitStores[key].defs[defId] = defs[defId];
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                for(var instanceId in instances){
                    var instance = instances[instanceId];
                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    try {
                        for(var _iterator1 = defKeys[instance.defId][Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                            var key1 = _step1.value;
                            if (splitStores[key1]) splitStores[key1].instances[instanceId] = instance;
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                _iterator1.return();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                }
                return splitStores;
            }
        },
        {
            key: "_splitIndividualUi",
            value: function _splitIndividualUi(eventUiBases, defKeys) {
                var splitHashes = {};
                for(var defId in eventUiBases){
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    if (defId) try {
                        for(var _iterator = defKeys[defId][Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var key = _step.value;
                            if (!splitHashes[key]) splitHashes[key] = {};
                            splitHashes[key][defId] = eventUiBases[defId];
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
                return splitHashes;
            }
        },
        {
            key: "_splitInteraction",
            value: function _splitInteraction(interaction) {
                var splitStates = {};
                if (interaction) {
                    var affectedStores = this._splitEventStore(interaction.affectedEvents, this._getKeysForEventDefs(interaction.affectedEvents));
                    // can't rely on defKeys because event data is mutated
                    var mutatedKeysByDefId = this._getKeysForEventDefs(interaction.mutatedEvents);
                    var mutatedStores = this._splitEventStore(interaction.mutatedEvents, mutatedKeysByDefId);
                    var populate = function(key) {
                        if (!splitStates[key]) splitStates[key] = {
                            affectedEvents: affectedStores[key] || $307e0d89efad9a8a$var$EMPTY_EVENT_STORE,
                            mutatedEvents: mutatedStores[key] || $307e0d89efad9a8a$var$EMPTY_EVENT_STORE,
                            isEvent: interaction.isEvent
                        };
                    };
                    for(var key in affectedStores)populate(key);
                    for(var key1 in mutatedStores)populate(key1);
                }
                return splitStates;
            }
        }
    ]);
    return Splitter;
}();
function $307e0d89efad9a8a$var$buildEventUiForKey(allUi, eventUiForKey, individualUi) {
    var baseParts = [];
    if (allUi) baseParts.push(allUi);
    if (eventUiForKey) baseParts.push(eventUiForKey);
    var stuff = {
        "": $307e0d89efad9a8a$export$1ee57be6f6687d2c(baseParts)
    };
    if (individualUi) Object.assign(stuff, individualUi);
    return stuff;
}
function $307e0d89efad9a8a$export$e171bab687b50e0(date, todayRange, nowDate, dateProfile) {
    return {
        dow: date.getUTCDay(),
        isDisabled: Boolean(dateProfile && (!dateProfile.activeRange || !$307e0d89efad9a8a$export$2329c99376c9d0a4(dateProfile.activeRange, date))),
        isOther: Boolean(dateProfile && !$307e0d89efad9a8a$export$2329c99376c9d0a4(dateProfile.currentRange, date)),
        isToday: Boolean(todayRange && $307e0d89efad9a8a$export$2329c99376c9d0a4(todayRange, date)),
        isPast: Boolean(nowDate ? date < nowDate : todayRange ? date < todayRange.start : false),
        isFuture: Boolean(nowDate ? date > nowDate : todayRange ? date >= todayRange.end : false)
    };
}
function $307e0d89efad9a8a$export$1a8f5705751d8277(meta, theme) {
    var classNames = [
        "fc-day",
        "fc-day-".concat($307e0d89efad9a8a$var$DAY_IDS[meta.dow])
    ];
    if (meta.isDisabled) classNames.push("fc-day-disabled");
    else {
        if (meta.isToday) {
            classNames.push("fc-day-today");
            classNames.push(theme.getClass("today"));
        }
        if (meta.isPast) classNames.push("fc-day-past");
        if (meta.isFuture) classNames.push("fc-day-future");
        if (meta.isOther) classNames.push("fc-day-other");
    }
    return classNames;
}
function $307e0d89efad9a8a$export$527e9aa3390079e9(meta, theme) {
    var classNames = [
        "fc-slot",
        "fc-slot-".concat($307e0d89efad9a8a$var$DAY_IDS[meta.dow])
    ];
    if (meta.isDisabled) classNames.push("fc-slot-disabled");
    else {
        if (meta.isToday) {
            classNames.push("fc-slot-today");
            classNames.push(theme.getClass("today"));
        }
        if (meta.isPast) classNames.push("fc-slot-past");
        if (meta.isFuture) classNames.push("fc-slot-future");
    }
    return classNames;
}
var $307e0d89efad9a8a$var$DAY_FORMAT = $307e0d89efad9a8a$export$d141bba7fdc215a3({
    year: "numeric",
    month: "long",
    day: "numeric"
});
var $307e0d89efad9a8a$var$WEEK_FORMAT = $307e0d89efad9a8a$export$d141bba7fdc215a3({
    week: "long"
});
function $307e0d89efad9a8a$export$a17c37559e1db147(context, dateMarker) {
    var viewType = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "day", isTabbable = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : true;
    var dateEnv = context.dateEnv, options = context.options, calendarApi = context.calendarApi;
    var dateStr = dateEnv.format(dateMarker, viewType === "week" ? $307e0d89efad9a8a$var$WEEK_FORMAT : $307e0d89efad9a8a$var$DAY_FORMAT);
    if (options.navLinks) {
        var zonedDate = dateEnv.toDate(dateMarker);
        var handleInteraction = function(ev) {
            var customAction = viewType === "day" ? options.navLinkDayClick : viewType === "week" ? options.navLinkWeekClick : null;
            if (typeof customAction === "function") customAction.call(calendarApi, dateEnv.toDate(dateMarker), ev);
            else {
                if (typeof customAction === "string") viewType = customAction;
                calendarApi.zoomTo(dateMarker, viewType);
            }
        };
        return Object.assign({
            title: $307e0d89efad9a8a$export$342063e11d6c3cad(options.navLinkHint, [
                dateStr,
                zonedDate
            ], dateStr),
            "data-navlink": ""
        }, isTabbable ? $307e0d89efad9a8a$var$createAriaClickAttrs(handleInteraction) : {
            onClick: handleInteraction
        });
    }
    return {
        "aria-label": dateStr
    };
}
var $307e0d89efad9a8a$var$_isRtlScrollbarOnLeft = null;
function $307e0d89efad9a8a$export$c7ca7e4bc4f8a16e() {
    if ($307e0d89efad9a8a$var$_isRtlScrollbarOnLeft === null) $307e0d89efad9a8a$var$_isRtlScrollbarOnLeft = $307e0d89efad9a8a$var$computeIsRtlScrollbarOnLeft();
    return $307e0d89efad9a8a$var$_isRtlScrollbarOnLeft;
}
function $307e0d89efad9a8a$var$computeIsRtlScrollbarOnLeft() {
    var outerEl = document.createElement("div");
    $307e0d89efad9a8a$export$faec65b429be379(outerEl, {
        position: "absolute",
        top: -1000,
        left: 0,
        border: 0,
        padding: 0,
        overflow: "scroll",
        direction: "rtl"
    });
    outerEl.innerHTML = "<div></div>";
    document.body.appendChild(outerEl);
    var innerEl = outerEl.firstChild;
    var res = innerEl.getBoundingClientRect().left > outerEl.getBoundingClientRect().left;
    $307e0d89efad9a8a$export$9f4f30ee63539e24(outerEl);
    return res;
}
var $307e0d89efad9a8a$var$_scrollbarWidths;
function $307e0d89efad9a8a$export$a1edd97dd51cd48d() {
    if (!$307e0d89efad9a8a$var$_scrollbarWidths) $307e0d89efad9a8a$var$_scrollbarWidths = $307e0d89efad9a8a$var$computeScrollbarWidths();
    return $307e0d89efad9a8a$var$_scrollbarWidths;
}
function $307e0d89efad9a8a$var$computeScrollbarWidths() {
    var el = document.createElement("div");
    el.style.overflow = "scroll";
    el.style.position = "absolute";
    el.style.top = "-9999px";
    el.style.left = "-9999px";
    document.body.appendChild(el);
    var res = $307e0d89efad9a8a$var$computeScrollbarWidthsForEl(el);
    document.body.removeChild(el);
    return res;
}
// WARNING: will include border
function $307e0d89efad9a8a$var$computeScrollbarWidthsForEl(el) {
    return {
        x: el.offsetHeight - el.clientHeight,
        y: el.offsetWidth - el.clientWidth
    };
}
function $307e0d89efad9a8a$export$2ec5befb9e6c97d4(el) {
    var getPadding = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var computedStyle = window.getComputedStyle(el);
    var borderLeft = parseInt(computedStyle.borderLeftWidth, 10) || 0;
    var borderRight = parseInt(computedStyle.borderRightWidth, 10) || 0;
    var borderTop = parseInt(computedStyle.borderTopWidth, 10) || 0;
    var borderBottom = parseInt(computedStyle.borderBottomWidth, 10) || 0;
    var badScrollbarWidths = $307e0d89efad9a8a$var$computeScrollbarWidthsForEl(el); // includes border!
    var scrollbarLeftRight = badScrollbarWidths.y - borderLeft - borderRight;
    var scrollbarBottom = badScrollbarWidths.x - borderTop - borderBottom;
    var res = {
        borderLeft: borderLeft,
        borderRight: borderRight,
        borderTop: borderTop,
        borderBottom: borderBottom,
        scrollbarBottom: scrollbarBottom,
        scrollbarLeft: 0,
        scrollbarRight: 0
    };
    if ($307e0d89efad9a8a$export$c7ca7e4bc4f8a16e() && computedStyle.direction === "rtl") res.scrollbarLeft = scrollbarLeftRight;
    else res.scrollbarRight = scrollbarLeftRight;
    if (getPadding) {
        res.paddingLeft = parseInt(computedStyle.paddingLeft, 10) || 0;
        res.paddingRight = parseInt(computedStyle.paddingRight, 10) || 0;
        res.paddingTop = parseInt(computedStyle.paddingTop, 10) || 0;
        res.paddingBottom = parseInt(computedStyle.paddingBottom, 10) || 0;
    }
    return res;
}
function $307e0d89efad9a8a$export$d29e374196577086(el) {
    var goWithinPadding = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, doFromWindowViewport = arguments.length > 2 ? arguments[2] : void 0;
    var outerRect = doFromWindowViewport ? el.getBoundingClientRect() : $307e0d89efad9a8a$export$39c1cc7c062529d4(el);
    var edges = $307e0d89efad9a8a$export$2ec5befb9e6c97d4(el, goWithinPadding);
    var res = {
        left: outerRect.left + edges.borderLeft + edges.scrollbarLeft,
        right: outerRect.right - edges.borderRight - edges.scrollbarRight,
        top: outerRect.top + edges.borderTop,
        bottom: outerRect.bottom - edges.borderBottom - edges.scrollbarBottom
    };
    if (goWithinPadding) {
        res.left += edges.paddingLeft;
        res.right -= edges.paddingRight;
        res.top += edges.paddingTop;
        res.bottom -= edges.paddingBottom;
    }
    return res;
}
function $307e0d89efad9a8a$export$39c1cc7c062529d4(el) {
    var rect = el.getBoundingClientRect();
    return {
        left: rect.left + window.scrollX,
        top: rect.top + window.scrollY,
        right: rect.right + window.scrollX,
        bottom: rect.bottom + window.scrollY
    };
}
function $307e0d89efad9a8a$var$computeClippedClientRect(el) {
    var clippingParents = $307e0d89efad9a8a$export$53c86fa97d611818(el);
    var rect = el.getBoundingClientRect();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = clippingParents[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var clippingParent = _step.value;
            var intersection = $307e0d89efad9a8a$export$890c4ad488842ce7(rect, clippingParent.getBoundingClientRect());
            if (intersection) rect = intersection;
            else return null;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return rect;
}
// does not return window
function $307e0d89efad9a8a$export$53c86fa97d611818(el) {
    var parents = [];
    while(el instanceof HTMLElement){
        var computedStyle = window.getComputedStyle(el);
        if (computedStyle.position === "fixed") break;
        if (/(auto|scroll)/.test(computedStyle.overflow + computedStyle.overflowY + computedStyle.overflowX)) parents.push(el);
        el = el.parentNode;
    }
    return parents;
}
/*
Records offset information for a set of elements, relative to an origin element.
Can record the left/right OR the top/bottom OR both.
Provides methods for querying the cache by position.
*/ var $307e0d89efad9a8a$export$ad4aebacdcaf47f8 = /*#__PURE__*/ function() {
    "use strict";
    function PositionCache(originEl, els, isHorizontal, isVertical) {
        (0, $luoZD._)(this, PositionCache);
        this.els = els;
        var originClientRect = this.originClientRect = originEl.getBoundingClientRect(); // relative to viewport top-left
        if (isHorizontal) this.buildElHorizontals(originClientRect.left);
        if (isVertical) this.buildElVerticals(originClientRect.top);
    }
    (0, $fYUO3._)(PositionCache, [
        {
            // Populates the left/right internal coordinate arrays
            key: "buildElHorizontals",
            value: function buildElHorizontals(originClientLeft) {
                var lefts = [];
                var rights = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.els[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var el = _step.value;
                        var rect = el.getBoundingClientRect();
                        lefts.push(rect.left - originClientLeft);
                        rights.push(rect.right - originClientLeft);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                this.lefts = lefts;
                this.rights = rights;
            }
        },
        {
            // Populates the top/bottom internal coordinate arrays
            key: "buildElVerticals",
            value: function buildElVerticals(originClientTop) {
                var tops = [];
                var bottoms = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.els[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var el = _step.value;
                        var rect = el.getBoundingClientRect();
                        tops.push(rect.top - originClientTop);
                        bottoms.push(rect.bottom - originClientTop);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                this.tops = tops;
                this.bottoms = bottoms;
            }
        },
        {
            // Given a left offset (from document left), returns the index of the el that it horizontally intersects.
            // If no intersection is made, returns undefined.
            key: "leftToIndex",
            value: function leftToIndex(leftPosition) {
                var _this = this, lefts = _this.lefts, rights = _this.rights;
                var len = lefts.length;
                var i;
                for(i = 0; i < len; i += 1){
                    if (leftPosition >= lefts[i] && leftPosition < rights[i]) return i;
                }
                return undefined; // TODO: better
            }
        },
        {
            // Given a top offset (from document top), returns the index of the el that it vertically intersects.
            // If no intersection is made, returns undefined.
            key: "topToIndex",
            value: function topToIndex(topPosition) {
                var _this = this, tops = _this.tops, bottoms = _this.bottoms;
                var len = tops.length;
                var i;
                for(i = 0; i < len; i += 1){
                    if (topPosition >= tops[i] && topPosition < bottoms[i]) return i;
                }
                return undefined; // TODO: better
            }
        },
        {
            // Gets the width of the element at the given index
            key: "getWidth",
            value: function getWidth(leftIndex) {
                return this.rights[leftIndex] - this.lefts[leftIndex];
            }
        },
        {
            // Gets the height of the element at the given index
            key: "getHeight",
            value: function getHeight(topIndex) {
                return this.bottoms[topIndex] - this.tops[topIndex];
            }
        },
        {
            key: "similarTo",
            value: function similarTo(otherCache) {
                return $307e0d89efad9a8a$var$similarNumArrays(this.tops || [], otherCache.tops || []) && $307e0d89efad9a8a$var$similarNumArrays(this.bottoms || [], otherCache.bottoms || []) && $307e0d89efad9a8a$var$similarNumArrays(this.lefts || [], otherCache.lefts || []) && $307e0d89efad9a8a$var$similarNumArrays(this.rights || [], otherCache.rights || []);
            }
        }
    ]);
    return PositionCache;
}();
function $307e0d89efad9a8a$var$similarNumArrays(a, b) {
    var len = a.length;
    if (len !== b.length) return false;
    for(var i = 0; i < len; i++){
        if (Math.round(a[i]) !== Math.round(b[i])) return false;
    }
    return true;
}
/* eslint max-classes-per-file: "off" */ /*
An object for getting/setting scroll-related information for an element.
Internally, this is done very differently for window versus DOM element,
so this object serves as a common interface.
*/ var $307e0d89efad9a8a$export$4ae495d48253603d = /*#__PURE__*/ function() {
    "use strict";
    function ScrollController() {
        (0, $luoZD._)(this, ScrollController);
    }
    (0, $fYUO3._)(ScrollController, [
        {
            key: "getMaxScrollTop",
            value: function getMaxScrollTop() {
                return this.getScrollHeight() - this.getClientHeight();
            }
        },
        {
            key: "getMaxScrollLeft",
            value: function getMaxScrollLeft() {
                return this.getScrollWidth() - this.getClientWidth();
            }
        },
        {
            key: "canScrollVertically",
            value: function canScrollVertically() {
                return this.getMaxScrollTop() > 0;
            }
        },
        {
            key: "canScrollHorizontally",
            value: function canScrollHorizontally() {
                return this.getMaxScrollLeft() > 0;
            }
        },
        {
            key: "canScrollUp",
            value: function canScrollUp() {
                return this.getScrollTop() > 0;
            }
        },
        {
            key: "canScrollDown",
            value: function canScrollDown() {
                return this.getScrollTop() < this.getMaxScrollTop();
            }
        },
        {
            key: "canScrollLeft",
            value: function canScrollLeft() {
                return this.getScrollLeft() > 0;
            }
        },
        {
            key: "canScrollRight",
            value: function canScrollRight() {
                return this.getScrollLeft() < this.getMaxScrollLeft();
            }
        }
    ]);
    return ScrollController;
}();
var $307e0d89efad9a8a$export$7060da4b5db56fb9 = /*#__PURE__*/ function(ScrollController) {
    "use strict";
    (0, $7DbRq._)(ElementScrollController, ScrollController);
    var _super = (0, $ju9pQ._)(ElementScrollController);
    function ElementScrollController(el) {
        (0, $luoZD._)(this, ElementScrollController);
        var _this;
        _this = _super.call(this);
        _this.el = el;
        return _this;
    }
    (0, $fYUO3._)(ElementScrollController, [
        {
            key: "getScrollTop",
            value: function getScrollTop() {
                return this.el.scrollTop;
            }
        },
        {
            key: "getScrollLeft",
            value: function getScrollLeft() {
                return this.el.scrollLeft;
            }
        },
        {
            key: "setScrollTop",
            value: function setScrollTop(top) {
                this.el.scrollTop = top;
            }
        },
        {
            key: "setScrollLeft",
            value: function setScrollLeft(left) {
                this.el.scrollLeft = left;
            }
        },
        {
            key: "getScrollWidth",
            value: function getScrollWidth() {
                return this.el.scrollWidth;
            }
        },
        {
            key: "getScrollHeight",
            value: function getScrollHeight() {
                return this.el.scrollHeight;
            }
        },
        {
            key: "getClientHeight",
            value: function getClientHeight() {
                return this.el.clientHeight;
            }
        },
        {
            key: "getClientWidth",
            value: function getClientWidth() {
                return this.el.clientWidth;
            }
        }
    ]);
    return ElementScrollController;
}($307e0d89efad9a8a$export$4ae495d48253603d);
var $307e0d89efad9a8a$export$c5d1328b37d47994 = /*#__PURE__*/ function(ScrollController) {
    "use strict";
    (0, $7DbRq._)(WindowScrollController, ScrollController);
    var _super = (0, $ju9pQ._)(WindowScrollController);
    function WindowScrollController() {
        (0, $luoZD._)(this, WindowScrollController);
        return _super.apply(this, arguments);
    }
    (0, $fYUO3._)(WindowScrollController, [
        {
            key: "getScrollTop",
            value: function getScrollTop() {
                return window.scrollY;
            }
        },
        {
            key: "getScrollLeft",
            value: function getScrollLeft() {
                return window.scrollX;
            }
        },
        {
            key: "setScrollTop",
            value: function setScrollTop(n) {
                window.scroll(window.scrollX, n);
            }
        },
        {
            key: "setScrollLeft",
            value: function setScrollLeft(n) {
                window.scroll(n, window.scrollY);
            }
        },
        {
            key: "getScrollWidth",
            value: function getScrollWidth() {
                return document.documentElement.scrollWidth;
            }
        },
        {
            key: "getScrollHeight",
            value: function getScrollHeight() {
                return document.documentElement.scrollHeight;
            }
        },
        {
            key: "getClientHeight",
            value: function getClientHeight() {
                return document.documentElement.clientHeight;
            }
        },
        {
            key: "getClientWidth",
            value: function getClientWidth() {
                return document.documentElement.clientWidth;
            }
        }
    ]);
    return WindowScrollController;
}($307e0d89efad9a8a$export$4ae495d48253603d);
/*
an INTERACTABLE date component

PURPOSES:
- hook up to fg, fill, and mirror renderers
- interface for dragging and hits
*/ var $307e0d89efad9a8a$export$d22783b3c2400a3a = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $7DbRq._)(DateComponent, BaseComponent);
    var _super = (0, $ju9pQ._)(DateComponent);
    function DateComponent() {
        (0, $luoZD._)(this, DateComponent);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.uid = $307e0d89efad9a8a$export$39b482c5e57630a8();
        return _this;
    }
    (0, $fYUO3._)(DateComponent, [
        {
            // Hit System
            // -----------------------------------------------------------------------------------------------------------------
            key: "prepareHits",
            value: function prepareHits() {}
        },
        {
            key: "queryHit",
            value: function queryHit(positionLeft, positionTop, elWidth, elHeight) {
                return null; // this should be abstract
            }
        },
        {
            // Pointer Interaction Utils
            // -----------------------------------------------------------------------------------------------------------------
            key: "isValidSegDownEl",
            value: function isValidSegDownEl(el) {
                return !this.props.eventDrag && // HACK
                !this.props.eventResize && // HACK
                !$307e0d89efad9a8a$export$dc98b0b04f4c7758(el, ".fc-event-mirror");
            }
        },
        {
            key: "isValidDateDownEl",
            value: function isValidDateDownEl(el) {
                return !$307e0d89efad9a8a$export$dc98b0b04f4c7758(el, ".fc-event:not(.fc-bg-event)") && !$307e0d89efad9a8a$export$dc98b0b04f4c7758(el, ".fc-more-link") && // a "more.." link
                !$307e0d89efad9a8a$export$dc98b0b04f4c7758(el, "a[data-navlink]") && // a clickable nav link
                !$307e0d89efad9a8a$export$dc98b0b04f4c7758(el, ".fc-popover"); // hack
            }
        }
    ]);
    return DateComponent;
}($307e0d89efad9a8a$export$ef35774e6d314e91);
var $307e0d89efad9a8a$export$45d219bdcd8ac53c = function NamedTimeZoneImpl(timeZoneName) {
    "use strict";
    (0, $luoZD._)(this, NamedTimeZoneImpl);
    this.timeZoneName = timeZoneName;
};
var $307e0d89efad9a8a$export$766bf7dcfb630b6c = /*#__PURE__*/ function() {
    "use strict";
    function SegHierarchy() {
        var getEntryThickness = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : function(entry) {
            // if no thickness known, assume 1 (if 0, so small it always fits)
            return entry.thickness || 1;
        };
        (0, $luoZD._)(this, SegHierarchy);
        this.getEntryThickness = getEntryThickness;
        // settings
        this.strictOrder = false;
        this.allowReslicing = false;
        this.maxCoord = -1; // -1 means no max
        this.maxStackCnt = -1; // -1 means no max
        this.levelCoords = []; // ordered
        this.entriesByLevel = []; // parallel with levelCoords
        this.stackCnts = {}; // TODO: use better technique!?
    }
    (0, $fYUO3._)(SegHierarchy, [
        {
            key: "addSegs",
            value: function addSegs(inputs) {
                var hiddenEntries = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = inputs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var input = _step.value;
                        this.insertEntry(input, hiddenEntries);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return hiddenEntries;
            }
        },
        {
            key: "insertEntry",
            value: function insertEntry(entry, hiddenEntries) {
                var insertion = this.findInsertion(entry);
                if (this.isInsertionValid(insertion, entry)) this.insertEntryAt(entry, insertion);
                else this.handleInvalidInsertion(insertion, entry, hiddenEntries);
            }
        },
        {
            key: "isInsertionValid",
            value: function isInsertionValid(insertion, entry) {
                return (this.maxCoord === -1 || insertion.levelCoord + this.getEntryThickness(entry) <= this.maxCoord) && (this.maxStackCnt === -1 || insertion.stackCnt < this.maxStackCnt);
            }
        },
        {
            key: "handleInvalidInsertion",
            value: function handleInvalidInsertion(insertion, entry, hiddenEntries) {
                if (this.allowReslicing && insertion.touchingEntry) {
                    var hiddenEntry = Object.assign(Object.assign({}, entry), {
                        span: $307e0d89efad9a8a$export$b0165a7e514844(entry.span, insertion.touchingEntry.span)
                    });
                    hiddenEntries.push(hiddenEntry);
                    this.splitEntry(entry, insertion.touchingEntry, hiddenEntries);
                } else hiddenEntries.push(entry);
            }
        },
        {
            /*
    Does NOT add what hit the `barrier` into hiddenEntries. Should already be done.
    */ key: "splitEntry",
            value: function splitEntry(entry, barrier, hiddenEntries) {
                var entrySpan = entry.span;
                var barrierSpan = barrier.span;
                if (entrySpan.start < barrierSpan.start) this.insertEntry({
                    index: entry.index,
                    thickness: entry.thickness,
                    span: {
                        start: entrySpan.start,
                        end: barrierSpan.start
                    }
                }, hiddenEntries);
                if (entrySpan.end > barrierSpan.end) this.insertEntry({
                    index: entry.index,
                    thickness: entry.thickness,
                    span: {
                        start: barrierSpan.end,
                        end: entrySpan.end
                    }
                }, hiddenEntries);
            }
        },
        {
            key: "insertEntryAt",
            value: function insertEntryAt(entry, insertion) {
                var _this = this, entriesByLevel = _this.entriesByLevel, levelCoords = _this.levelCoords;
                if (insertion.lateral === -1) {
                    // create a new level
                    $307e0d89efad9a8a$var$insertAt(levelCoords, insertion.level, insertion.levelCoord);
                    $307e0d89efad9a8a$var$insertAt(entriesByLevel, insertion.level, [
                        entry
                    ]);
                } else // insert into existing level
                $307e0d89efad9a8a$var$insertAt(entriesByLevel[insertion.level], insertion.lateral, entry);
                this.stackCnts[$307e0d89efad9a8a$export$674f8f4247a5112e(entry)] = insertion.stackCnt;
            }
        },
        {
            /*
    does not care about limits
    */ key: "findInsertion",
            value: function findInsertion(newEntry) {
                var _this = this, levelCoords = _this.levelCoords, entriesByLevel = _this.entriesByLevel, strictOrder = _this.strictOrder, stackCnts = _this.stackCnts;
                var levelCnt = levelCoords.length;
                var candidateCoord = 0;
                var touchingLevel = -1;
                var touchingLateral = -1;
                var touchingEntry = null;
                var stackCnt = 0;
                for(var trackingLevel = 0; trackingLevel < levelCnt; trackingLevel += 1){
                    var trackingCoord = levelCoords[trackingLevel];
                    // if the current level is past the placed entry, we have found a good empty space and can stop.
                    // if strictOrder, keep finding more lateral intersections.
                    if (!strictOrder && trackingCoord >= candidateCoord + this.getEntryThickness(newEntry)) break;
                    var trackingEntries = entriesByLevel[trackingLevel];
                    var trackingEntry = void 0;
                    var searchRes = $307e0d89efad9a8a$export$eb84e45a33f6ba7c(trackingEntries, newEntry.span.start, $307e0d89efad9a8a$export$2e63b696b2c9441b); // find first entry after newEntry's end
                    var lateralIndex = searchRes[0] + searchRes[1]; // if exact match (which doesn't collide), go to next one
                    while((trackingEntry = trackingEntries[lateralIndex]) && // but not past the whole entry list
                    trackingEntry.span.start < newEntry.span.end // and not entirely past newEntry
                    ){
                        var trackingEntryBottom = trackingCoord + this.getEntryThickness(trackingEntry);
                        // intersects into the top of the candidate?
                        if (trackingEntryBottom > candidateCoord) {
                            candidateCoord = trackingEntryBottom;
                            touchingEntry = trackingEntry;
                            touchingLevel = trackingLevel;
                            touchingLateral = lateralIndex;
                        }
                        // butts up against top of candidate? (will happen if just intersected as well)
                        if (trackingEntryBottom === candidateCoord) // accumulate the highest possible stackCnt of the trackingEntries that butt up
                        stackCnt = Math.max(stackCnt, stackCnts[$307e0d89efad9a8a$export$674f8f4247a5112e(trackingEntry)] + 1);
                        lateralIndex += 1;
                    }
                }
                // the destination level will be after touchingEntry's level. find it
                var destLevel = 0;
                if (touchingEntry) {
                    destLevel = touchingLevel + 1;
                    while(destLevel < levelCnt && levelCoords[destLevel] < candidateCoord)destLevel += 1;
                }
                // if adding to an existing level, find where to insert
                var destLateral = -1;
                if (destLevel < levelCnt && levelCoords[destLevel] === candidateCoord) destLateral = $307e0d89efad9a8a$export$eb84e45a33f6ba7c(entriesByLevel[destLevel], newEntry.span.end, $307e0d89efad9a8a$export$2e63b696b2c9441b)[0];
                return {
                    touchingLevel: touchingLevel,
                    touchingLateral: touchingLateral,
                    touchingEntry: touchingEntry,
                    stackCnt: stackCnt,
                    levelCoord: candidateCoord,
                    level: destLevel,
                    lateral: destLateral
                };
            }
        },
        {
            // sorted by levelCoord (lowest to highest)
            key: "toRects",
            value: function toRects() {
                var _this = this, entriesByLevel = _this.entriesByLevel, levelCoords = _this.levelCoords;
                var levelCnt = entriesByLevel.length;
                var rects = [];
                for(var level = 0; level < levelCnt; level += 1){
                    var entries = entriesByLevel[level];
                    var levelCoord = levelCoords[level];
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var entry = _step.value;
                            rects.push(Object.assign(Object.assign({}, entry), {
                                thickness: this.getEntryThickness(entry),
                                levelCoord: levelCoord
                            }));
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
                return rects;
            }
        }
    ]);
    return SegHierarchy;
}();
function $307e0d89efad9a8a$export$2e63b696b2c9441b(entry) {
    return entry.span.end;
}
function $307e0d89efad9a8a$export$674f8f4247a5112e(entry) {
    return entry.index + ":" + entry.span.start;
}
// returns groups with entries sorted by input order
function $307e0d89efad9a8a$export$d76842aa27385215(entries) {
    var merges = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var entry = _step.value;
            var filteredMerges = [];
            var hungryMerge = {
                span: entry.span,
                entries: [
                    entry
                ]
            };
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = merges[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var merge = _step1.value;
                    if ($307e0d89efad9a8a$export$b0165a7e514844(merge.span, hungryMerge.span)) hungryMerge = {
                        entries: merge.entries.concat(hungryMerge.entries),
                        span: $307e0d89efad9a8a$var$joinSpans(merge.span, hungryMerge.span)
                    };
                    else filteredMerges.push(merge);
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
            filteredMerges.push(hungryMerge);
            merges = filteredMerges;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return merges;
}
function $307e0d89efad9a8a$var$joinSpans(span0, span1) {
    return {
        start: Math.min(span0.start, span1.start),
        end: Math.max(span0.end, span1.end)
    };
}
function $307e0d89efad9a8a$export$b0165a7e514844(span0, span1) {
    var start = Math.max(span0.start, span1.start);
    var end = Math.min(span0.end, span1.end);
    if (start < end) return {
        start: start,
        end: end
    };
    return null;
}
// general util
// ---------------------------------------------------------------------------------------------------------------------
function $307e0d89efad9a8a$var$insertAt(arr, index, item) {
    arr.splice(index, 0, item);
}
function $307e0d89efad9a8a$export$eb84e45a33f6ba7c(a, searchVal, getItemVal) {
    var startIndex = 0;
    var endIndex = a.length; // exclusive
    if (!endIndex || searchVal < getItemVal(a[startIndex])) return [
        0,
        0
    ];
    if (searchVal > getItemVal(a[endIndex - 1])) return [
        endIndex,
        0
    ];
    while(startIndex < endIndex){
        var middleIndex = Math.floor(startIndex + (endIndex - startIndex) / 2);
        var middleVal = getItemVal(a[middleIndex]);
        if (searchVal < middleVal) endIndex = middleIndex;
        else if (searchVal > middleVal) startIndex = middleIndex + 1;
        else return [
            middleIndex,
            1
        ];
    }
    return [
        startIndex,
        0
    ];
}
/*
An abstraction for a dragging interaction originating on an event.
Does higher-level things than PointerDragger, such as possibly:
- a "mirror" that moves with the pointer
- a minimum number of pixels or other criteria for a true drag to begin

subclasses must emit:
- pointerdown
- dragstart
- dragmove
- pointerup
- dragend
*/ var $307e0d89efad9a8a$export$b2bcef12bcefba04 = /*#__PURE__*/ function() {
    "use strict";
    function ElementDragging(el, selector) {
        (0, $luoZD._)(this, ElementDragging);
        this.emitter = new $307e0d89efad9a8a$export$d66501df72047452();
    }
    (0, $fYUO3._)(ElementDragging, [
        {
            key: "destroy",
            value: function destroy() {}
        },
        {
            key: "setMirrorIsVisible",
            value: function setMirrorIsVisible(bool) {
            // optional if subclass doesn't want to support a mirror
            }
        },
        {
            key: "setMirrorNeedsRevert",
            value: function setMirrorNeedsRevert(bool) {
            // optional if subclass doesn't want to support a mirror
            }
        },
        {
            key: "setAutoScrollEnabled",
            value: function setAutoScrollEnabled(bool) {
            // optional
            }
        }
    ]);
    return ElementDragging;
}();
// TODO: get rid of this in favor of options system,
// tho it's really easy to access this globally rather than pass thru options.
var $307e0d89efad9a8a$export$aff10ba49ece4b91 = {};
/*
Information about what will happen when an external element is dragged-and-dropped
onto a calendar. Contains information for creating an event.
*/ var $307e0d89efad9a8a$var$DRAG_META_REFINERS = {
    startTime: $307e0d89efad9a8a$export$4368d992c4eafac0,
    duration: $307e0d89efad9a8a$export$4368d992c4eafac0,
    create: Boolean,
    sourceId: String
};
function $307e0d89efad9a8a$export$60bb826a6acf3081(raw) {
    var _refineProps = $307e0d89efad9a8a$export$ee7c8ad385a60b7b(raw, $307e0d89efad9a8a$var$DRAG_META_REFINERS), refined = _refineProps.refined, extra = _refineProps.extra;
    return {
        startTime: refined.startTime || null,
        duration: refined.duration || null,
        create: refined.create != null ? refined.create : true,
        sourceId: refined.sourceId,
        leftoverProps: extra
    };
}
// Computes a default column header formatting string if `colFormat` is not explicitly defined
function $307e0d89efad9a8a$export$1abb261478089fe6(datesRepDistinctDays, dayCnt) {
    // if more than one week row, or if there are a lot of columns with not much space,
    // put just the day numbers will be in each cell
    if (!datesRepDistinctDays || dayCnt > 10) return $307e0d89efad9a8a$export$d141bba7fdc215a3({
        weekday: "short"
    }); // "Sat"
    if (dayCnt > 1) return $307e0d89efad9a8a$export$d141bba7fdc215a3({
        weekday: "short",
        month: "numeric",
        day: "numeric",
        omitCommas: true
    }); // "Sat 11/12"
    return $307e0d89efad9a8a$export$d141bba7fdc215a3({
        weekday: "long"
    }); // "Saturday"
}
var $307e0d89efad9a8a$var$CLASS_NAME = "fc-col-header-cell"; // do the cushion too? no
function $307e0d89efad9a8a$var$renderInner$1(renderProps) {
    return renderProps.text;
}
// BAD name for this class now. used in the Header
var $307e0d89efad9a8a$export$ebc5e65867841cbe = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $7DbRq._)(TableDateCell, BaseComponent);
    var _super = (0, $ju9pQ._)(TableDateCell);
    function TableDateCell() {
        (0, $luoZD._)(this, TableDateCell);
        return _super.apply(this, arguments);
    }
    (0, $fYUO3._)(TableDateCell, [
        {
            key: "render",
            value: function render() {
                var _this_context = this.context, dateEnv = _this_context.dateEnv, options = _this_context.options, theme = _this_context.theme, viewApi = _this_context.viewApi;
                var props = this.props;
                var date = props.date, dateProfile = props.dateProfile;
                var dayMeta = $307e0d89efad9a8a$export$e171bab687b50e0(date, props.todayRange, null, dateProfile);
                var classNames = [
                    $307e0d89efad9a8a$var$CLASS_NAME
                ].concat($307e0d89efad9a8a$export$1a8f5705751d8277(dayMeta, theme));
                var text = dateEnv.format(date, props.dayHeaderFormat);
                // if colCnt is 1, we are already in a day-view and don't need a navlink
                var navLinkAttrs = !dayMeta.isDisabled && props.colCnt > 1 ? $307e0d89efad9a8a$export$a17c37559e1db147(this.context, date) : {};
                var publicDate = dateEnv.toDate(date);
                // workaround for Luxon (and maybe moment) returning prior-days when start-of-day
                // in DST gap: https://github.com/fullcalendar/fullcalendar/issues/7633
                if (dateEnv.namedTimeZoneImpl) publicDate = $307e0d89efad9a8a$export$51b138e5a065c2bb(publicDate, 3600000); // add an hour
                var renderProps = Object.assign(Object.assign(Object.assign({
                    date: publicDate,
                    view: viewApi
                }, props.extraRenderProps), {
                    text: text
                }), dayMeta);
                return (0, $ihX0O.createElement)($307e0d89efad9a8a$export$e7094788287c5e9b, {
                    elTag: "th",
                    elClasses: classNames,
                    elAttrs: Object.assign({
                        role: "columnheader",
                        colSpan: props.colSpan,
                        "data-date": !dayMeta.isDisabled ? $307e0d89efad9a8a$export$56350196709588fc(date) : undefined
                    }, props.extraDataAttrs),
                    renderProps: renderProps,
                    generatorName: "dayHeaderContent",
                    customGenerator: options.dayHeaderContent,
                    defaultGenerator: $307e0d89efad9a8a$var$renderInner$1,
                    classNameGenerator: options.dayHeaderClassNames,
                    didMount: options.dayHeaderDidMount,
                    willUnmount: options.dayHeaderWillUnmount
                }, function(InnerContainer) {
                    return (0, $ihX0O.createElement)("div", {
                        className: "fc-scrollgrid-sync-inner"
                    }, !dayMeta.isDisabled && (0, $ihX0O.createElement)(InnerContainer, {
                        elTag: "a",
                        elAttrs: navLinkAttrs,
                        elClasses: [
                            "fc-col-header-cell-cushion",
                            props.isSticky && "fc-sticky"
                        ]
                    }));
                });
            }
        }
    ]);
    return TableDateCell;
}($307e0d89efad9a8a$export$ef35774e6d314e91);
var $307e0d89efad9a8a$var$WEEKDAY_FORMAT = $307e0d89efad9a8a$export$d141bba7fdc215a3({
    weekday: "long"
});
var $307e0d89efad9a8a$export$1ddf2d01943a3512 = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $7DbRq._)(TableDowCell, BaseComponent);
    var _super = (0, $ju9pQ._)(TableDowCell);
    function TableDowCell() {
        (0, $luoZD._)(this, TableDowCell);
        return _super.apply(this, arguments);
    }
    (0, $fYUO3._)(TableDowCell, [
        {
            key: "render",
            value: function render() {
                var props = this.props;
                var _this_context = this.context, dateEnv = _this_context.dateEnv, theme = _this_context.theme, viewApi = _this_context.viewApi, options = _this_context.options;
                var date = $307e0d89efad9a8a$export$625550452a3fa3ec(new Date(259200000), props.dow); // start with Sun, 04 Jan 1970 00:00:00 GMT
                var dateMeta = {
                    dow: props.dow,
                    isDisabled: false,
                    isFuture: false,
                    isPast: false,
                    isToday: false,
                    isOther: false
                };
                var text = dateEnv.format(date, props.dayHeaderFormat);
                var renderProps = Object.assign(Object.assign(Object.assign(Object.assign({
                    date: date
                }, dateMeta), {
                    view: viewApi
                }), props.extraRenderProps), {
                    text: text
                });
                return (0, $ihX0O.createElement)($307e0d89efad9a8a$export$e7094788287c5e9b, {
                    elTag: "th",
                    elClasses: [
                        $307e0d89efad9a8a$var$CLASS_NAME
                    ].concat((0, $79xu7._)($307e0d89efad9a8a$export$1a8f5705751d8277(dateMeta, theme)), (0, $79xu7._)(props.extraClassNames || [])),
                    elAttrs: Object.assign({
                        role: "columnheader",
                        colSpan: props.colSpan
                    }, props.extraDataAttrs),
                    renderProps: renderProps,
                    generatorName: "dayHeaderContent",
                    customGenerator: options.dayHeaderContent,
                    defaultGenerator: $307e0d89efad9a8a$var$renderInner$1,
                    classNameGenerator: options.dayHeaderClassNames,
                    didMount: options.dayHeaderDidMount,
                    willUnmount: options.dayHeaderWillUnmount
                }, function(InnerContent) {
                    return (0, $ihX0O.createElement)("div", {
                        className: "fc-scrollgrid-sync-inner"
                    }, (0, $ihX0O.createElement)(InnerContent, {
                        elTag: "a",
                        elClasses: [
                            "fc-col-header-cell-cushion",
                            props.isSticky && "fc-sticky"
                        ],
                        elAttrs: {
                            "aria-label": dateEnv.format(date, $307e0d89efad9a8a$var$WEEKDAY_FORMAT)
                        }
                    }));
                });
            }
        }
    ]);
    return TableDowCell;
}($307e0d89efad9a8a$export$ef35774e6d314e91);
var $307e0d89efad9a8a$export$27d1aff6bea49709 = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $7DbRq._)(DayHeader, BaseComponent);
    var _super = (0, $ju9pQ._)(DayHeader);
    function DayHeader() {
        (0, $luoZD._)(this, DayHeader);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.createDayHeaderFormatter = $307e0d89efad9a8a$export$df995fae86a55f06($307e0d89efad9a8a$var$createDayHeaderFormatter);
        return _this;
    }
    (0, $fYUO3._)(DayHeader, [
        {
            key: "render",
            value: function render() {
                var context = this.context;
                var _this_props = this.props, dates = _this_props.dates, dateProfile = _this_props.dateProfile, datesRepDistinctDays = _this_props.datesRepDistinctDays, renderIntro = _this_props.renderIntro;
                var dayHeaderFormat = this.createDayHeaderFormatter(context.options.dayHeaderFormat, datesRepDistinctDays, dates.length);
                return (0, $ihX0O.createElement)($307e0d89efad9a8a$export$2e2af4578d910ddf, {
                    unit: "day"
                }, function(nowDate, todayRange) {
                    return (0, $ihX0O.createElement)("tr", {
                        role: "row"
                    }, renderIntro && renderIntro("day"), dates.map(function(date) {
                        return datesRepDistinctDays ? (0, $ihX0O.createElement)($307e0d89efad9a8a$export$ebc5e65867841cbe, {
                            key: date.toISOString(),
                            date: date,
                            dateProfile: dateProfile,
                            todayRange: todayRange,
                            colCnt: dates.length,
                            dayHeaderFormat: dayHeaderFormat
                        }) : (0, $ihX0O.createElement)($307e0d89efad9a8a$export$1ddf2d01943a3512, {
                            key: date.getUTCDay(),
                            dow: date.getUTCDay(),
                            dayHeaderFormat: dayHeaderFormat
                        });
                    }));
                });
            }
        }
    ]);
    return DayHeader;
}($307e0d89efad9a8a$export$ef35774e6d314e91);
function $307e0d89efad9a8a$var$createDayHeaderFormatter(explicitFormat, datesRepDistinctDays, dateCnt) {
    return explicitFormat || $307e0d89efad9a8a$export$1abb261478089fe6(datesRepDistinctDays, dateCnt);
}
var $307e0d89efad9a8a$export$ebb8f7cd71856fb9 = /*#__PURE__*/ function() {
    "use strict";
    function DaySeriesModel(range, dateProfileGenerator) {
        (0, $luoZD._)(this, DaySeriesModel);
        var date = range.start;
        var end = range.end;
        var indices = [];
        var dates = [];
        var dayIndex = -1;
        while(date < end){
            if (dateProfileGenerator.isHiddenDay(date)) indices.push(dayIndex + 0.5); // mark that it's between indices
            else {
                dayIndex += 1;
                indices.push(dayIndex);
                dates.push(date);
            }
            date = $307e0d89efad9a8a$export$625550452a3fa3ec(date, 1);
        }
        this.dates = dates;
        this.indices = indices;
        this.cnt = dates.length;
    }
    (0, $fYUO3._)(DaySeriesModel, [
        {
            key: "sliceRange",
            value: function sliceRange(range) {
                var firstIndex = this.getDateDayIndex(range.start); // inclusive first index
                var lastIndex = this.getDateDayIndex($307e0d89efad9a8a$export$625550452a3fa3ec(range.end, -1)); // inclusive last index
                var clippedFirstIndex = Math.max(0, firstIndex);
                var clippedLastIndex = Math.min(this.cnt - 1, lastIndex);
                // deal with in-between indices
                clippedFirstIndex = Math.ceil(clippedFirstIndex); // in-between starts round to next cell
                clippedLastIndex = Math.floor(clippedLastIndex); // in-between ends round to prev cell
                if (clippedFirstIndex <= clippedLastIndex) return {
                    firstIndex: clippedFirstIndex,
                    lastIndex: clippedLastIndex,
                    isStart: firstIndex === clippedFirstIndex,
                    isEnd: lastIndex === clippedLastIndex
                };
                return null;
            }
        },
        {
            // Given a date, returns its chronolocial cell-index from the first cell of the grid.
            // If the date lies between cells (because of hiddenDays), returns a floating-point value between offsets.
            // If before the first offset, returns a negative number.
            // If after the last offset, returns an offset past the last cell offset.
            // Only works for *start* dates of cells. Will not work for exclusive end dates for cells.
            key: "getDateDayIndex",
            value: function getDateDayIndex(date) {
                var indices = this.indices;
                var dayOffset = Math.floor($307e0d89efad9a8a$export$b4d5ecaefe2b27f3(this.dates[0], date));
                if (dayOffset < 0) return indices[0] - 1;
                if (dayOffset >= indices.length) return indices[indices.length - 1] + 1;
                return indices[dayOffset];
            }
        }
    ]);
    return DaySeriesModel;
}();
var $307e0d89efad9a8a$export$1314441b8d04e1d5 = /*#__PURE__*/ function() {
    "use strict";
    function DayTableModel(daySeries, breakOnWeeks) {
        (0, $luoZD._)(this, DayTableModel);
        var dates = daySeries.dates;
        var daysPerRow;
        var firstDay;
        var rowCnt;
        if (breakOnWeeks) {
            // count columns until the day-of-week repeats
            firstDay = dates[0].getUTCDay();
            for(daysPerRow = 1; daysPerRow < dates.length; daysPerRow += 1){
                if (dates[daysPerRow].getUTCDay() === firstDay) break;
            }
            rowCnt = Math.ceil(dates.length / daysPerRow);
        } else {
            rowCnt = 1;
            daysPerRow = dates.length;
        }
        this.rowCnt = rowCnt;
        this.colCnt = daysPerRow;
        this.daySeries = daySeries;
        this.cells = this.buildCells();
        this.headerDates = this.buildHeaderDates();
    }
    (0, $fYUO3._)(DayTableModel, [
        {
            key: "buildCells",
            value: function buildCells() {
                var rows = [];
                for(var row = 0; row < this.rowCnt; row += 1){
                    var cells = [];
                    for(var col = 0; col < this.colCnt; col += 1)cells.push(this.buildCell(row, col));
                    rows.push(cells);
                }
                return rows;
            }
        },
        {
            key: "buildCell",
            value: function buildCell(row, col) {
                var date = this.daySeries.dates[row * this.colCnt + col];
                return {
                    key: date.toISOString(),
                    date: date
                };
            }
        },
        {
            key: "buildHeaderDates",
            value: function buildHeaderDates() {
                var dates = [];
                for(var col = 0; col < this.colCnt; col += 1)dates.push(this.cells[0][col].date);
                return dates;
            }
        },
        {
            key: "sliceRange",
            value: function sliceRange(range) {
                var colCnt = this.colCnt;
                var seriesSeg = this.daySeries.sliceRange(range);
                var segs = [];
                if (seriesSeg) {
                    var firstIndex = seriesSeg.firstIndex, lastIndex = seriesSeg.lastIndex;
                    var index = firstIndex;
                    while(index <= lastIndex){
                        var row = Math.floor(index / colCnt);
                        var nextIndex = Math.min((row + 1) * colCnt, lastIndex + 1);
                        segs.push({
                            row: row,
                            firstCol: index % colCnt,
                            lastCol: (nextIndex - 1) % colCnt,
                            isStart: seriesSeg.isStart && index === firstIndex,
                            isEnd: seriesSeg.isEnd && nextIndex - 1 === lastIndex
                        });
                        index = nextIndex;
                    }
                }
                return segs;
            }
        }
    ]);
    return DayTableModel;
}();
var $307e0d89efad9a8a$export$e0c3a065614c6254 = /*#__PURE__*/ function() {
    "use strict";
    function Slicer() {
        (0, $luoZD._)(this, Slicer);
        this.sliceBusinessHours = $307e0d89efad9a8a$export$df995fae86a55f06(this._sliceBusinessHours);
        this.sliceDateSelection = $307e0d89efad9a8a$export$df995fae86a55f06(this._sliceDateSpan);
        this.sliceEventStore = $307e0d89efad9a8a$export$df995fae86a55f06(this._sliceEventStore);
        this.sliceEventDrag = $307e0d89efad9a8a$export$df995fae86a55f06(this._sliceInteraction);
        this.sliceEventResize = $307e0d89efad9a8a$export$df995fae86a55f06(this._sliceInteraction);
        this.forceDayIfListItem = false; // hack
    }
    (0, $fYUO3._)(Slicer, [
        {
            key: "sliceProps",
            value: function sliceProps(props, dateProfile, nextDayThreshold, context) {
                for(var _len = arguments.length, extraArgs = new Array(_len > 4 ? _len - 4 : 0), _key = 4; _key < _len; _key++){
                    extraArgs[_key - 4] = arguments[_key];
                }
                var eventUiBases = props.eventUiBases;
                var eventSegs = this.sliceEventStore.apply(this, [
                    props.eventStore,
                    eventUiBases,
                    dateProfile,
                    nextDayThreshold
                ].concat((0, $79xu7._)(extraArgs)));
                return {
                    dateSelectionSegs: this.sliceDateSelection.apply(this, [
                        props.dateSelection,
                        dateProfile,
                        nextDayThreshold,
                        eventUiBases,
                        context
                    ].concat((0, $79xu7._)(extraArgs))),
                    businessHourSegs: this.sliceBusinessHours.apply(this, [
                        props.businessHours,
                        dateProfile,
                        nextDayThreshold,
                        context
                    ].concat((0, $79xu7._)(extraArgs))),
                    fgEventSegs: eventSegs.fg,
                    bgEventSegs: eventSegs.bg,
                    eventDrag: this.sliceEventDrag.apply(this, [
                        props.eventDrag,
                        eventUiBases,
                        dateProfile,
                        nextDayThreshold
                    ].concat((0, $79xu7._)(extraArgs))),
                    eventResize: this.sliceEventResize.apply(this, [
                        props.eventResize,
                        eventUiBases,
                        dateProfile,
                        nextDayThreshold
                    ].concat((0, $79xu7._)(extraArgs))),
                    eventSelection: props.eventSelection
                }; // TODO: give interactionSegs?
            }
        },
        {
            key: "sliceNowDate",
            value: function sliceNowDate(date, dateProfile, nextDayThreshold, context) {
                for(var _len = arguments.length, extraArgs = new Array(_len > 4 ? _len - 4 : 0), _key = 4; _key < _len; _key++){
                    extraArgs[_key - 4] = arguments[_key];
                }
                return this._sliceDateSpan.apply(this, [
                    {
                        range: {
                            start: date,
                            end: $307e0d89efad9a8a$export$51b138e5a065c2bb(date, 1)
                        },
                        allDay: false
                    },
                    dateProfile,
                    nextDayThreshold,
                    {},
                    context
                ].concat((0, $79xu7._)(extraArgs)));
            }
        },
        {
            key: "_sliceBusinessHours",
            value: function _sliceBusinessHours(businessHours, dateProfile, nextDayThreshold, context) {
                for(var _len = arguments.length, extraArgs = new Array(_len > 4 ? _len - 4 : 0), _key = 4; _key < _len; _key++){
                    extraArgs[_key - 4] = arguments[_key];
                }
                if (!businessHours) return [];
                return this._sliceEventStore.apply(this, [
                    $307e0d89efad9a8a$var$expandRecurring(businessHours, $307e0d89efad9a8a$var$computeActiveRange(dateProfile, Boolean(nextDayThreshold)), context),
                    {},
                    dateProfile,
                    nextDayThreshold
                ].concat((0, $79xu7._)(extraArgs))).bg;
            }
        },
        {
            key: "_sliceEventStore",
            value: function _sliceEventStore(eventStore, eventUiBases, dateProfile, nextDayThreshold) {
                for(var _len = arguments.length, extraArgs = new Array(_len > 4 ? _len - 4 : 0), _key = 4; _key < _len; _key++){
                    extraArgs[_key - 4] = arguments[_key];
                }
                if (eventStore) {
                    var rangeRes = $307e0d89efad9a8a$export$4c3d22f3d993c33f(eventStore, eventUiBases, $307e0d89efad9a8a$var$computeActiveRange(dateProfile, Boolean(nextDayThreshold)), nextDayThreshold);
                    return {
                        bg: this.sliceEventRanges(rangeRes.bg, extraArgs),
                        fg: this.sliceEventRanges(rangeRes.fg, extraArgs)
                    };
                }
                return {
                    bg: [],
                    fg: []
                };
            }
        },
        {
            key: "_sliceInteraction",
            value: function _sliceInteraction(interaction, eventUiBases, dateProfile, nextDayThreshold) {
                for(var _len = arguments.length, extraArgs = new Array(_len > 4 ? _len - 4 : 0), _key = 4; _key < _len; _key++){
                    extraArgs[_key - 4] = arguments[_key];
                }
                if (!interaction) return null;
                var rangeRes = $307e0d89efad9a8a$export$4c3d22f3d993c33f(interaction.mutatedEvents, eventUiBases, $307e0d89efad9a8a$var$computeActiveRange(dateProfile, Boolean(nextDayThreshold)), nextDayThreshold);
                return {
                    segs: this.sliceEventRanges(rangeRes.fg, extraArgs),
                    affectedInstances: interaction.affectedEvents.instances,
                    isEvent: interaction.isEvent
                };
            }
        },
        {
            key: "_sliceDateSpan",
            value: function _sliceDateSpan(dateSpan, dateProfile, nextDayThreshold, eventUiBases, context) {
                for(var _len = arguments.length, extraArgs = new Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++){
                    extraArgs[_key - 5] = arguments[_key];
                }
                if (!dateSpan) return [];
                var activeRange = $307e0d89efad9a8a$var$computeActiveRange(dateProfile, Boolean(nextDayThreshold));
                var activeDateSpanRange = $307e0d89efad9a8a$export$ae1af26003f05816(dateSpan.range, activeRange);
                if (activeDateSpanRange) {
                    dateSpan = Object.assign(Object.assign({}, dateSpan), {
                        range: activeDateSpanRange
                    });
                    var eventRange = $307e0d89efad9a8a$var$fabricateEventRange(dateSpan, eventUiBases, context);
                    var segs = this.sliceRange.apply(this, [
                        dateSpan.range
                    ].concat((0, $79xu7._)(extraArgs)));
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = segs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var seg = _step.value;
                            seg.eventRange = eventRange;
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return segs;
                }
                return [];
            }
        },
        {
            /*
    "complete" seg means it has component and eventRange
    */ key: "sliceEventRanges",
            value: function sliceEventRanges(eventRanges, extraArgs) {
                var _segs;
                var segs = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = eventRanges[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var eventRange = _step.value;
                        (_segs = segs).push.apply(_segs, (0, $79xu7._)(this.sliceEventRange(eventRange, extraArgs)));
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return segs;
            }
        },
        {
            /*
    "complete" seg means it has component and eventRange
    */ key: "sliceEventRange",
            value: function sliceEventRange(eventRange, extraArgs) {
                var dateRange = eventRange.range;
                // hack to make multi-day events that are being force-displayed as list-items to take up only one day
                if (this.forceDayIfListItem && eventRange.ui.display === "list-item") dateRange = {
                    start: dateRange.start,
                    end: $307e0d89efad9a8a$export$625550452a3fa3ec(dateRange.start, 1)
                };
                var segs = this.sliceRange.apply(this, [
                    dateRange
                ].concat((0, $79xu7._)(extraArgs)));
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = segs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var seg = _step.value;
                        seg.eventRange = eventRange;
                        seg.isStart = eventRange.isStart && seg.isStart;
                        seg.isEnd = eventRange.isEnd && seg.isEnd;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return segs;
            }
        }
    ]);
    return Slicer;
}();
/*
for incorporating slotMinTime/slotMaxTime if appropriate
TODO: should be part of DateProfile!
TimelineDateProfile already does this btw
*/ function $307e0d89efad9a8a$var$computeActiveRange(dateProfile, isComponentAllDay) {
    var range = dateProfile.activeRange;
    if (isComponentAllDay) return range;
    return {
        start: $307e0d89efad9a8a$export$51b138e5a065c2bb(range.start, dateProfile.slotMinTime.milliseconds),
        end: $307e0d89efad9a8a$export$51b138e5a065c2bb(range.end, dateProfile.slotMaxTime.milliseconds - 864e5)
    };
}
// high-level segmenting-aware tester functions
// ------------------------------------------------------------------------------------------------------------------------
function $307e0d89efad9a8a$export$6d1e945284085e64(interaction, dateProfile, context) {
    var instances = interaction.mutatedEvents.instances;
    for(var instanceId in instances){
        if (!$307e0d89efad9a8a$export$f074adc9fbd50943(dateProfile.validRange, instances[instanceId].range)) return false;
    }
    return $307e0d89efad9a8a$var$isNewPropsValid({
        eventDrag: interaction
    }, context); // HACK: the eventDrag props is used for ALL interactions
}
function $307e0d89efad9a8a$export$545a72cc0d3f00b0(dateSelection, dateProfile, context) {
    if (!$307e0d89efad9a8a$export$f074adc9fbd50943(dateProfile.validRange, dateSelection.range)) return false;
    return $307e0d89efad9a8a$var$isNewPropsValid({
        dateSelection: dateSelection
    }, context);
}
function $307e0d89efad9a8a$var$isNewPropsValid(newProps, context) {
    var calendarState = context.getCurrentData();
    var props = Object.assign({
        businessHours: calendarState.businessHours,
        dateSelection: "",
        eventStore: calendarState.eventStore,
        eventUiBases: calendarState.eventUiBases,
        eventSelection: "",
        eventDrag: null,
        eventResize: null
    }, newProps);
    return (context.pluginHooks.isPropsValid || $307e0d89efad9a8a$export$6b179bb11f7fd3a0)(props, context);
}
function $307e0d89efad9a8a$export$6b179bb11f7fd3a0(state, context) {
    var dateSpanMeta = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, filterConfig = arguments.length > 3 ? arguments[3] : void 0;
    if (state.eventDrag && !$307e0d89efad9a8a$var$isInteractionPropsValid(state, context, dateSpanMeta, filterConfig)) return false;
    if (state.dateSelection && !$307e0d89efad9a8a$var$isDateSelectionPropsValid(state, context, dateSpanMeta, filterConfig)) return false;
    return true;
}
// Moving Event Validation
// ------------------------------------------------------------------------------------------------------------------------
function $307e0d89efad9a8a$var$isInteractionPropsValid(state, context, dateSpanMeta, filterConfig) {
    var currentState = context.getCurrentData();
    var interaction = state.eventDrag; // HACK: the eventDrag props is used for ALL interactions
    var subjectEventStore = interaction.mutatedEvents;
    var subjectDefs = subjectEventStore.defs;
    var subjectInstances = subjectEventStore.instances;
    var subjectConfigs = $307e0d89efad9a8a$var$compileEventUis(subjectDefs, interaction.isEvent ? state.eventUiBases : {
        "": currentState.selectionConfig
    });
    if (filterConfig) subjectConfigs = $307e0d89efad9a8a$export$407448d2b89b1813(subjectConfigs, filterConfig);
    // exclude the subject events. TODO: exclude defs too?
    var otherEventStore = $307e0d89efad9a8a$var$excludeInstances(state.eventStore, interaction.affectedEvents.instances);
    var otherDefs = otherEventStore.defs;
    var otherInstances = otherEventStore.instances;
    var otherConfigs = $307e0d89efad9a8a$var$compileEventUis(otherDefs, state.eventUiBases);
    for(var subjectInstanceId in subjectInstances){
        var subjectInstance = subjectInstances[subjectInstanceId];
        var subjectRange = subjectInstance.range;
        var subjectConfig = subjectConfigs[subjectInstance.defId];
        var subjectDef = subjectDefs[subjectInstance.defId];
        // constraint
        if (!$307e0d89efad9a8a$var$allConstraintsPass(subjectConfig.constraints, subjectRange, otherEventStore, state.businessHours, context)) return false;
        // overlap
        var eventOverlap = context.options.eventOverlap;
        var eventOverlapFunc = typeof eventOverlap === "function" ? eventOverlap : null;
        for(var otherInstanceId in otherInstances){
            var otherInstance = otherInstances[otherInstanceId];
            // intersect! evaluate
            if ($307e0d89efad9a8a$export$c18d01048907ea92(subjectRange, otherInstance.range)) {
                var otherOverlap = otherConfigs[otherInstance.defId].overlap;
                // consider the other event's overlap. only do this if the subject event is a "real" event
                if (otherOverlap === false && interaction.isEvent) return false;
                if (subjectConfig.overlap === false) return false;
                if (eventOverlapFunc && !eventOverlapFunc(new $307e0d89efad9a8a$export$71511d61b312f219(context, otherDefs[otherInstance.defId], otherInstance), new $307e0d89efad9a8a$export$71511d61b312f219(context, subjectDef, subjectInstance))) return false;
            }
        }
        // allow (a function)
        var calendarEventStore = currentState.eventStore; // need global-to-calendar, not local to component (splittable)state
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = subjectConfig.allows[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var subjectAllow = _step.value;
                var subjectDateSpan = Object.assign(Object.assign({}, dateSpanMeta), {
                    range: subjectInstance.range,
                    allDay: subjectDef.allDay
                });
                var origDef = calendarEventStore.defs[subjectDef.defId];
                var origInstance = calendarEventStore.instances[subjectInstanceId];
                var eventApi = void 0;
                if (origDef) eventApi = new $307e0d89efad9a8a$export$71511d61b312f219(context, origDef, origInstance);
                else eventApi = new $307e0d89efad9a8a$export$71511d61b312f219(context, subjectDef); // no instance, because had no dates
                if (!subjectAllow($307e0d89efad9a8a$var$buildDateSpanApiWithContext(subjectDateSpan, context), eventApi)) return false;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return true;
}
// Date Selection Validation
// ------------------------------------------------------------------------------------------------------------------------
function $307e0d89efad9a8a$var$isDateSelectionPropsValid(state, context, dateSpanMeta, filterConfig) {
    var relevantEventStore = state.eventStore;
    var relevantDefs = relevantEventStore.defs;
    var relevantInstances = relevantEventStore.instances;
    var selection = state.dateSelection;
    var selectionRange = selection.range;
    var selectionConfig = context.getCurrentData().selectionConfig;
    if (filterConfig) selectionConfig = filterConfig(selectionConfig);
    // constraint
    if (!$307e0d89efad9a8a$var$allConstraintsPass(selectionConfig.constraints, selectionRange, relevantEventStore, state.businessHours, context)) return false;
    // overlap
    var selectOverlap = context.options.selectOverlap;
    var selectOverlapFunc = typeof selectOverlap === "function" ? selectOverlap : null;
    for(var relevantInstanceId in relevantInstances){
        var relevantInstance = relevantInstances[relevantInstanceId];
        // intersect! evaluate
        if ($307e0d89efad9a8a$export$c18d01048907ea92(selectionRange, relevantInstance.range)) {
            if (selectionConfig.overlap === false) return false;
            if (selectOverlapFunc && !selectOverlapFunc(new $307e0d89efad9a8a$export$71511d61b312f219(context, relevantDefs[relevantInstance.defId], relevantInstance), null)) return false;
        }
    }
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        // allow (a function)
        for(var _iterator = selectionConfig.allows[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var selectionAllow = _step.value;
            var fullDateSpan = Object.assign(Object.assign({}, dateSpanMeta), selection);
            if (!selectionAllow($307e0d89efad9a8a$var$buildDateSpanApiWithContext(fullDateSpan, context), null)) return false;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return true;
}
// Constraint Utils
// ------------------------------------------------------------------------------------------------------------------------
function $307e0d89efad9a8a$var$allConstraintsPass(constraints, subjectRange, otherEventStore, businessHoursUnexpanded, context) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = constraints[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var constraint = _step.value;
            if (!$307e0d89efad9a8a$var$anyRangesContainRange($307e0d89efad9a8a$var$constraintToRanges(constraint, subjectRange, otherEventStore, businessHoursUnexpanded, context), subjectRange)) return false;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return true;
}
function $307e0d89efad9a8a$var$constraintToRanges(constraint, subjectRange, otherEventStore, businessHoursUnexpanded, context) {
    if (constraint === "businessHours") return $307e0d89efad9a8a$var$eventStoreToRanges($307e0d89efad9a8a$var$expandRecurring(businessHoursUnexpanded, subjectRange, context));
    if (typeof constraint === "string") return $307e0d89efad9a8a$var$eventStoreToRanges($307e0d89efad9a8a$var$filterEventStoreDefs(otherEventStore, function(eventDef) {
        return eventDef.groupId === constraint;
    }));
    if (typeof constraint === "object" && constraint) return $307e0d89efad9a8a$var$eventStoreToRanges($307e0d89efad9a8a$var$expandRecurring(constraint, subjectRange, context));
    return []; // if it's false
}
// TODO: move to event-store file?
function $307e0d89efad9a8a$var$eventStoreToRanges(eventStore) {
    var instances = eventStore.instances;
    var ranges = [];
    for(var instanceId in instances)ranges.push(instances[instanceId].range);
    return ranges;
}
// TODO: move to geom file?
function $307e0d89efad9a8a$var$anyRangesContainRange(outerRanges, innerRange) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = outerRanges[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var outerRange = _step.value;
            if ($307e0d89efad9a8a$export$f074adc9fbd50943(outerRange, innerRange)) return true;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return false;
}
var $307e0d89efad9a8a$var$VISIBLE_HIDDEN_RE = /^(visible|hidden)$/;
var $307e0d89efad9a8a$export$54c4fabc2291e9c0 = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $7DbRq._)(Scroller, BaseComponent);
    var _super = (0, $ju9pQ._)(Scroller);
    function Scroller() {
        (0, $luoZD._)(this, Scroller);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.handleEl = function(el) {
            _this.el = el;
            $307e0d89efad9a8a$export$71cec2538cb2c617(_this.props.elRef, el);
        };
        return _this;
    }
    (0, $fYUO3._)(Scroller, [
        {
            key: "render",
            value: function render() {
                var props = this.props;
                var liquid = props.liquid, liquidIsAbsolute = props.liquidIsAbsolute;
                var isAbsolute = liquid && liquidIsAbsolute;
                var className = [
                    "fc-scroller"
                ];
                if (liquid) {
                    if (liquidIsAbsolute) className.push("fc-scroller-liquid-absolute");
                    else className.push("fc-scroller-liquid");
                }
                return (0, $ihX0O.createElement)("div", {
                    ref: this.handleEl,
                    className: className.join(" "),
                    style: {
                        overflowX: props.overflowX,
                        overflowY: props.overflowY,
                        left: isAbsolute && -(props.overcomeLeft || 0) || "",
                        right: isAbsolute && -(props.overcomeRight || 0) || "",
                        bottom: isAbsolute && -(props.overcomeBottom || 0) || "",
                        marginLeft: !isAbsolute && -(props.overcomeLeft || 0) || "",
                        marginRight: !isAbsolute && -(props.overcomeRight || 0) || "",
                        marginBottom: !isAbsolute && -(props.overcomeBottom || 0) || "",
                        maxHeight: props.maxHeight || ""
                    }
                }, props.children);
            }
        },
        {
            key: "needsXScrolling",
            value: function needsXScrolling() {
                if ($307e0d89efad9a8a$var$VISIBLE_HIDDEN_RE.test(this.props.overflowX)) return false;
                // testing scrollWidth>clientWidth is unreliable cross-browser when pixel heights aren't integers.
                // much more reliable to see if children are taller than the scroller, even tho doesn't account for
                // inner-child margins and absolute positioning
                var el = this.el;
                var realClientWidth = this.el.getBoundingClientRect().width - this.getYScrollbarWidth();
                var children = el.children;
                for(var i = 0; i < children.length; i += 1){
                    var childEl = children[i];
                    if (childEl.getBoundingClientRect().width > realClientWidth) return true;
                }
                return false;
            }
        },
        {
            key: "needsYScrolling",
            value: function needsYScrolling() {
                if ($307e0d89efad9a8a$var$VISIBLE_HIDDEN_RE.test(this.props.overflowY)) return false;
                // testing scrollHeight>clientHeight is unreliable cross-browser when pixel heights aren't integers.
                // much more reliable to see if children are taller than the scroller, even tho doesn't account for
                // inner-child margins and absolute positioning
                var el = this.el;
                var realClientHeight = this.el.getBoundingClientRect().height - this.getXScrollbarWidth();
                var children = el.children;
                for(var i = 0; i < children.length; i += 1){
                    var childEl = children[i];
                    if (childEl.getBoundingClientRect().height > realClientHeight) return true;
                }
                return false;
            }
        },
        {
            key: "getXScrollbarWidth",
            value: function getXScrollbarWidth() {
                if ($307e0d89efad9a8a$var$VISIBLE_HIDDEN_RE.test(this.props.overflowX)) return 0;
                return this.el.offsetHeight - this.el.clientHeight; // only works because we guarantee no borders. TODO: add to CSS with important?
            }
        },
        {
            key: "getYScrollbarWidth",
            value: function getYScrollbarWidth() {
                if ($307e0d89efad9a8a$var$VISIBLE_HIDDEN_RE.test(this.props.overflowY)) return 0;
                return this.el.offsetWidth - this.el.clientWidth; // only works because we guarantee no borders. TODO: add to CSS with important?
            }
        }
    ]);
    return Scroller;
}($307e0d89efad9a8a$export$ef35774e6d314e91);
/*
TODO: somehow infer OtherArgs from masterCallback?
TODO: infer RefType from masterCallback if provided
*/ var $307e0d89efad9a8a$export$807f1ba34db587c7 = /*#__PURE__*/ function() {
    "use strict";
    function RefMap(masterCallback) {
        var _this = this;
        (0, $luoZD._)(this, RefMap);
        this.masterCallback = masterCallback;
        this.currentMap = {};
        this.depths = {};
        this.callbackMap = {};
        this.handleValue = function(val, key) {
            var depths = _this.depths, currentMap = _this.currentMap;
            var removed = false;
            var added = false;
            if (val !== null) {
                // for bug... ACTUALLY: can probably do away with this now that callers don't share numeric indices anymore
                removed = key in currentMap;
                currentMap[key] = val;
                depths[key] = (depths[key] || 0) + 1;
                added = true;
            } else {
                depths[key] -= 1;
                if (!depths[key]) {
                    delete currentMap[key];
                    delete _this.callbackMap[key];
                    removed = true;
                }
            }
            if (_this.masterCallback) {
                if (removed) _this.masterCallback(null, String(key));
                if (added) _this.masterCallback(val, String(key));
            }
        };
    }
    (0, $fYUO3._)(RefMap, [
        {
            key: "createRef",
            value: function createRef(key) {
                var _this = this;
                var refCallback = this.callbackMap[key];
                if (!refCallback) refCallback = this.callbackMap[key] = function(val) {
                    _this.handleValue(val, String(key));
                };
                return refCallback;
            }
        },
        {
            // TODO: check callers that don't care about order. should use getAll instead
            // NOTE: this method has become less valuable now that we are encouraged to map order by some other index
            // TODO: provide ONE array-export function, buildArray, which fails on non-numeric indexes. caller can manipulate and "collect"
            key: "collect",
            value: function collect(startIndex, endIndex, step) {
                return $307e0d89efad9a8a$export$a05254e7c3aeba6e(this.currentMap, startIndex, endIndex, step);
            }
        },
        {
            key: "getAll",
            value: function getAll() {
                return $307e0d89efad9a8a$export$90a7f3efeed30595(this.currentMap);
            }
        }
    ]);
    return RefMap;
}();
function $307e0d89efad9a8a$export$7fe88b5920ffddd2(chunkEls) {
    var shrinkCells = $307e0d89efad9a8a$export$23ebac1979863676(chunkEls, ".fc-scrollgrid-shrink");
    var largestWidth = 0;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = shrinkCells[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var shrinkCell = _step.value;
            largestWidth = Math.max(largestWidth, $307e0d89efad9a8a$var$computeSmallestCellWidth(shrinkCell));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return Math.ceil(largestWidth); // <table> elements work best with integers. round up to ensure contents fits
}
function $307e0d89efad9a8a$export$60e660859c376841(props, sectionConfig) {
    return props.liquid && sectionConfig.liquid; // does the section do liquid-height? (need to have whole scrollgrid liquid-height as well)
}
function $307e0d89efad9a8a$export$df838d0240c938cf(props, sectionConfig) {
    return sectionConfig.maxHeight != null || // if its possible for the height to max out, we might need scrollbars
    $307e0d89efad9a8a$export$60e660859c376841(props, sectionConfig); // if the section is liquid height, it might condense enough to require scrollbars
}
// TODO: ONLY use `arg`. force out internal function to use same API
function $307e0d89efad9a8a$export$4f33f238a5c1ad77(sectionConfig, chunkConfig, arg, isHeader) {
    var expandRows = arg.expandRows;
    var content = typeof chunkConfig.content === "function" ? chunkConfig.content(arg) : (0, $ihX0O.createElement)("table", {
        role: "presentation",
        className: [
            chunkConfig.tableClassName,
            sectionConfig.syncRowHeights ? "fc-scrollgrid-sync-table" : ""
        ].join(" "),
        style: {
            minWidth: arg.tableMinWidth,
            width: arg.clientWidth,
            height: expandRows ? arg.clientHeight : ""
        }
    }, arg.tableColGroupNode, (0, $ihX0O.createElement)(isHeader ? "thead" : "tbody", {
        role: "presentation"
    }, typeof chunkConfig.rowContent === "function" ? chunkConfig.rowContent(arg) : chunkConfig.rowContent));
    return content;
}
function $307e0d89efad9a8a$export$f5339a28e56d1baf(cols0, cols1) {
    return $307e0d89efad9a8a$export$23f2a1d2818174ef(cols0, cols1, $307e0d89efad9a8a$export$a9c23c6ac3fc3eca);
}
function $307e0d89efad9a8a$export$add49c223b9ce4ea(cols, shrinkWidth) {
    var colNodes = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        /*
    for ColProps with spans, it would have been great to make a single <col span="">
    HOWEVER, Chrome was getting messing up distributing the width to <td>/<th> elements with colspans.
    SOLUTION: making individual <col> elements makes Chrome behave.
    */ for(var _iterator = cols[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var colProps = _step.value;
            var span = colProps.span || 1;
            for(var i = 0; i < span; i += 1)colNodes.push((0, $ihX0O.createElement)("col", {
                style: {
                    width: colProps.width === "shrink" ? $307e0d89efad9a8a$export$df7c425476ed4f2(shrinkWidth) : colProps.width || "",
                    minWidth: colProps.minWidth || ""
                }
            }));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return (0, $ihX0O.createElement).apply(void 0, [
        "colgroup",
        {}
    ].concat((0, $79xu7._)(colNodes)));
}
function $307e0d89efad9a8a$export$df7c425476ed4f2(shrinkWidth) {
    /* why 4? if we do 0, it will kill any border, which are needed for computeSmallestCellWidth
    4 accounts for 2 2-pixel borders. TODO: better solution? */ return shrinkWidth == null ? 4 : shrinkWidth;
}
function $307e0d89efad9a8a$export$c69d65aa55814164(cols) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = cols[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var col = _step.value;
            if (col.width === "shrink") return true;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return false;
}
function $307e0d89efad9a8a$export$65ab0ebced932b79(liquid, context) {
    var classNames = [
        "fc-scrollgrid",
        context.theme.getClass("table")
    ];
    if (liquid) classNames.push("fc-scrollgrid-liquid");
    return classNames;
}
function $307e0d89efad9a8a$export$101619b11a34a0bd(sectionConfig, wholeTableVGrow) {
    var classNames = [
        "fc-scrollgrid-section",
        "fc-scrollgrid-section-".concat(sectionConfig.type),
        sectionConfig.className
    ];
    if (wholeTableVGrow && sectionConfig.liquid && sectionConfig.maxHeight == null) classNames.push("fc-scrollgrid-section-liquid");
    if (sectionConfig.isSticky) classNames.push("fc-scrollgrid-section-sticky");
    return classNames;
}
function $307e0d89efad9a8a$export$1ec7a8278ebd1290(arg) {
    return (0, $ihX0O.createElement)("div", {
        className: "fc-scrollgrid-sticky-shim",
        style: {
            width: arg.clientWidth,
            minWidth: arg.tableMinWidth
        }
    });
}
function $307e0d89efad9a8a$export$89e9012e902952b6(options) {
    var stickyHeaderDates = options.stickyHeaderDates;
    if (stickyHeaderDates == null || stickyHeaderDates === "auto") stickyHeaderDates = options.height === "auto" || options.viewHeight === "auto";
    return stickyHeaderDates;
}
function $307e0d89efad9a8a$export$4ad369a19af21c23(options) {
    var stickyFooterScrollbar = options.stickyFooterScrollbar;
    if (stickyFooterScrollbar == null || stickyFooterScrollbar === "auto") stickyFooterScrollbar = options.height === "auto" || options.viewHeight === "auto";
    return stickyFooterScrollbar;
}
var $307e0d89efad9a8a$export$c667925124dac624 = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $7DbRq._)(SimpleScrollGrid, BaseComponent);
    var _super = (0, $ju9pQ._)(SimpleScrollGrid);
    function SimpleScrollGrid() {
        (0, $luoZD._)(this, SimpleScrollGrid);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.processCols = $307e0d89efad9a8a$export$df995fae86a55f06(function(a) {
            return a;
        }, $307e0d89efad9a8a$export$f5339a28e56d1baf); // so we get same `cols` props every time
        // yucky to memoize VNodes, but much more efficient for consumers
        _this.renderMicroColGroup = $307e0d89efad9a8a$export$df995fae86a55f06($307e0d89efad9a8a$export$add49c223b9ce4ea);
        _this.scrollerRefs = new $307e0d89efad9a8a$export$807f1ba34db587c7();
        _this.scrollerElRefs = new $307e0d89efad9a8a$export$807f1ba34db587c7(_this._handleScrollerEl.bind((0, $iJSF3._)(_this)));
        _this.state = {
            shrinkWidth: null,
            forceYScrollbars: false,
            scrollerClientWidths: {},
            scrollerClientHeights: {}
        };
        // TODO: can do a really simple print-view. dont need to join rows
        _this.handleSizing = function() {
            _this.safeSetState(Object.assign({
                shrinkWidth: _this.computeShrinkWidth()
            }, _this.computeScrollerDims()));
        };
        return _this;
    }
    (0, $fYUO3._)(SimpleScrollGrid, [
        {
            key: "render",
            value: function render() {
                var _this = this, props = _this.props, state = _this.state, context = _this.context;
                var sectionConfigs = props.sections || [];
                var cols = this.processCols(props.cols);
                var microColGroupNode = this.renderMicroColGroup(cols, state.shrinkWidth);
                var classNames = $307e0d89efad9a8a$export$65ab0ebced932b79(props.liquid, context);
                if (props.collapsibleWidth) classNames.push("fc-scrollgrid-collapsible");
                // TODO: make DRY
                var configCnt = sectionConfigs.length;
                var configI = 0;
                var currentConfig;
                var headSectionNodes = [];
                var bodySectionNodes = [];
                var footSectionNodes = [];
                while(configI < configCnt && (currentConfig = sectionConfigs[configI]).type === "header"){
                    headSectionNodes.push(this.renderSection(currentConfig, microColGroupNode, true));
                    configI += 1;
                }
                while(configI < configCnt && (currentConfig = sectionConfigs[configI]).type === "body"){
                    bodySectionNodes.push(this.renderSection(currentConfig, microColGroupNode, false));
                    configI += 1;
                }
                while(configI < configCnt && (currentConfig = sectionConfigs[configI]).type === "footer"){
                    footSectionNodes.push(this.renderSection(currentConfig, microColGroupNode, true));
                    configI += 1;
                }
                // firefox bug: when setting height on table and there is a thead or tfoot,
                // the necessary height:100% on the liquid-height body section forces the *whole* table to be taller. (bug #5524)
                // use getCanVGrowWithinCell as a way to detect table-stupid firefox.
                // if so, use a simpler dom structure, jam everything into a lone tbody.
                var isBuggy = !$307e0d89efad9a8a$export$738ab4df8bf92ae9();
                var roleAttrs = {
                    role: "rowgroup"
                };
                return (0, $ihX0O.createElement)("table", {
                    role: "grid",
                    className: classNames.join(" "),
                    style: {
                        height: props.height
                    }
                }, Boolean(!isBuggy && headSectionNodes.length) && (0, $ihX0O.createElement).apply(void 0, [
                    "thead",
                    roleAttrs
                ].concat((0, $79xu7._)(headSectionNodes))), Boolean(!isBuggy && bodySectionNodes.length) && (0, $ihX0O.createElement).apply(void 0, [
                    "tbody",
                    roleAttrs
                ].concat((0, $79xu7._)(bodySectionNodes))), Boolean(!isBuggy && footSectionNodes.length) && (0, $ihX0O.createElement).apply(void 0, [
                    "tfoot",
                    roleAttrs
                ].concat((0, $79xu7._)(footSectionNodes))), isBuggy && (0, $ihX0O.createElement).apply(void 0, [
                    "tbody",
                    roleAttrs
                ].concat((0, $79xu7._)(headSectionNodes), (0, $79xu7._)(bodySectionNodes), (0, $79xu7._)(footSectionNodes))));
            }
        },
        {
            key: "renderSection",
            value: function renderSection(sectionConfig, microColGroupNode, isHeader) {
                if ("outerContent" in sectionConfig) return (0, $ihX0O.createElement)((0, $ihX0O.Fragment), {
                    key: sectionConfig.key
                }, sectionConfig.outerContent);
                return (0, $ihX0O.createElement)("tr", {
                    key: sectionConfig.key,
                    role: "presentation",
                    className: $307e0d89efad9a8a$export$101619b11a34a0bd(sectionConfig, this.props.liquid).join(" ")
                }, this.renderChunkTd(sectionConfig, microColGroupNode, sectionConfig.chunk, isHeader));
            }
        },
        {
            key: "renderChunkTd",
            value: function renderChunkTd(sectionConfig, microColGroupNode, chunkConfig, isHeader) {
                if ("outerContent" in chunkConfig) return chunkConfig.outerContent;
                var props = this.props;
                var _this_state = this.state, forceYScrollbars = _this_state.forceYScrollbars, scrollerClientWidths = _this_state.scrollerClientWidths, scrollerClientHeights = _this_state.scrollerClientHeights;
                var needsYScrolling = $307e0d89efad9a8a$export$df838d0240c938cf(props, sectionConfig); // TODO: do lazily. do in section config?
                var isLiquid = $307e0d89efad9a8a$export$60e660859c376841(props, sectionConfig);
                // for `!props.liquid` - is WHOLE scrollgrid natural height?
                // TODO: do same thing in advanced scrollgrid? prolly not b/c always has horizontal scrollbars
                var overflowY = !props.liquid ? "visible" : forceYScrollbars ? "scroll" : !needsYScrolling ? "hidden" : "auto";
                var sectionKey = sectionConfig.key;
                var content = $307e0d89efad9a8a$export$4f33f238a5c1ad77(sectionConfig, chunkConfig, {
                    tableColGroupNode: microColGroupNode,
                    tableMinWidth: "",
                    clientWidth: !props.collapsibleWidth && scrollerClientWidths[sectionKey] !== undefined ? scrollerClientWidths[sectionKey] : null,
                    clientHeight: scrollerClientHeights[sectionKey] !== undefined ? scrollerClientHeights[sectionKey] : null,
                    expandRows: sectionConfig.expandRows,
                    syncRowHeights: false,
                    rowSyncHeights: [],
                    reportRowHeightChange: function() {}
                }, isHeader);
                return (0, $ihX0O.createElement)(isHeader ? "th" : "td", {
                    ref: chunkConfig.elRef,
                    role: "presentation"
                }, (0, $ihX0O.createElement)("div", {
                    className: "fc-scroller-harness".concat(isLiquid ? " fc-scroller-harness-liquid" : "")
                }, (0, $ihX0O.createElement)($307e0d89efad9a8a$export$54c4fabc2291e9c0, {
                    ref: this.scrollerRefs.createRef(sectionKey),
                    elRef: this.scrollerElRefs.createRef(sectionKey),
                    overflowY: overflowY,
                    overflowX: !props.liquid ? "visible" : "hidden" /* natural height? */ ,
                    maxHeight: sectionConfig.maxHeight,
                    liquid: isLiquid,
                    liquidIsAbsolute: true
                }, content)));
            }
        },
        {
            key: "_handleScrollerEl",
            value: function _handleScrollerEl(scrollerEl, key) {
                var section = $307e0d89efad9a8a$var$getSectionByKey(this.props.sections, key);
                if (section) $307e0d89efad9a8a$export$71cec2538cb2c617(section.chunk.scrollerElRef, scrollerEl);
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.handleSizing();
                this.context.addResizeHandler(this.handleSizing);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                // TODO: need better solution when state contains non-sizing things
                this.handleSizing();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.context.removeResizeHandler(this.handleSizing);
            }
        },
        {
            key: "computeShrinkWidth",
            value: function computeShrinkWidth1() {
                return $307e0d89efad9a8a$export$c69d65aa55814164(this.props.cols) ? $307e0d89efad9a8a$export$7fe88b5920ffddd2(this.scrollerElRefs.getAll()) : 0;
            }
        },
        {
            key: "computeScrollerDims",
            value: function computeScrollerDims() {
                var scrollbarWidth = $307e0d89efad9a8a$export$a1edd97dd51cd48d();
                var _this = this, scrollerRefs = _this.scrollerRefs, scrollerElRefs = _this.scrollerElRefs;
                var forceYScrollbars = false;
                var scrollerClientWidths = {};
                var scrollerClientHeights = {};
                for(var sectionKey in scrollerRefs.currentMap){
                    var scroller = scrollerRefs.currentMap[sectionKey];
                    if (scroller && scroller.needsYScrolling()) {
                        forceYScrollbars = true;
                        break;
                    }
                }
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.props.sections[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var section = _step.value;
                        var sectionKey1 = section.key;
                        var scrollerEl = scrollerElRefs.currentMap[sectionKey1];
                        if (scrollerEl) {
                            var harnessEl = scrollerEl.parentNode; // TODO: weird way to get this. need harness b/c doesn't include table borders
                            scrollerClientWidths[sectionKey1] = Math.floor(harnessEl.getBoundingClientRect().width - (forceYScrollbars ? scrollbarWidth.y // use global because scroller might not have scrollbars yet but will need them in future
                             : 0));
                            scrollerClientHeights[sectionKey1] = Math.floor(harnessEl.getBoundingClientRect().height);
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return {
                    forceYScrollbars: forceYScrollbars,
                    scrollerClientWidths: scrollerClientWidths,
                    scrollerClientHeights: scrollerClientHeights
                };
            }
        }
    ]);
    return SimpleScrollGrid;
}($307e0d89efad9a8a$export$ef35774e6d314e91);
$307e0d89efad9a8a$export$c667925124dac624.addStateEquality({
    scrollerClientWidths: $307e0d89efad9a8a$export$a9c23c6ac3fc3eca,
    scrollerClientHeights: $307e0d89efad9a8a$export$a9c23c6ac3fc3eca
});
function $307e0d89efad9a8a$var$getSectionByKey(sections, key) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = sections[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var section = _step.value;
            if (section.key === key) return section;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return null;
}
var $307e0d89efad9a8a$export$c1df809846363ebe = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $7DbRq._)(EventContainer, BaseComponent);
    var _super = (0, $ju9pQ._)(EventContainer);
    function EventContainer() {
        (0, $luoZD._)(this, EventContainer);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        // memo
        _this.buildPublicEvent = $307e0d89efad9a8a$export$df995fae86a55f06(function(context, eventDef, eventInstance) {
            return new $307e0d89efad9a8a$export$71511d61b312f219(context, eventDef, eventInstance);
        });
        _this.handleEl = function(el) {
            _this.el = el;
            $307e0d89efad9a8a$export$71cec2538cb2c617(_this.props.elRef, el);
            if (el) $307e0d89efad9a8a$var$setElSeg(el, _this.props.seg);
        };
        return _this;
    }
    (0, $fYUO3._)(EventContainer, [
        {
            key: "render",
            value: function render() {
                var _this = this, props = _this.props, context = _this.context;
                var options = context.options;
                var seg = props.seg;
                var eventRange = seg.eventRange;
                var ui = eventRange.ui;
                var renderProps = {
                    event: this.buildPublicEvent(context, eventRange.def, eventRange.instance),
                    view: context.viewApi,
                    timeText: props.timeText,
                    textColor: ui.textColor,
                    backgroundColor: ui.backgroundColor,
                    borderColor: ui.borderColor,
                    isDraggable: !props.disableDragging && $307e0d89efad9a8a$var$computeSegDraggable(seg, context),
                    isStartResizable: !props.disableResizing && $307e0d89efad9a8a$var$computeSegStartResizable(seg, context),
                    isEndResizable: !props.disableResizing && $307e0d89efad9a8a$var$computeSegEndResizable(seg),
                    isMirror: Boolean(props.isDragging || props.isResizing || props.isDateSelecting),
                    isStart: Boolean(seg.isStart),
                    isEnd: Boolean(seg.isEnd),
                    isPast: Boolean(props.isPast),
                    isFuture: Boolean(props.isFuture),
                    isToday: Boolean(props.isToday),
                    isSelected: Boolean(props.isSelected),
                    isDragging: Boolean(props.isDragging),
                    isResizing: Boolean(props.isResizing)
                };
                return (0, $ihX0O.createElement)($307e0d89efad9a8a$export$e7094788287c5e9b, {
                    elRef: this.handleEl,
                    elTag: props.elTag,
                    elAttrs: props.elAttrs,
                    elClasses: (0, $79xu7._)($307e0d89efad9a8a$var$getEventClassNames(renderProps)).concat((0, $79xu7._)(seg.eventRange.ui.classNames), (0, $79xu7._)(props.elClasses || [])),
                    elStyle: props.elStyle,
                    renderProps: renderProps,
                    generatorName: "eventContent",
                    customGenerator: options.eventContent,
                    defaultGenerator: props.defaultGenerator,
                    classNameGenerator: options.eventClassNames,
                    didMount: options.eventDidMount,
                    willUnmount: options.eventWillUnmount
                }, props.children);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                if (this.el && this.props.seg !== prevProps.seg) $307e0d89efad9a8a$var$setElSeg(this.el, this.props.seg);
            }
        }
    ]);
    return EventContainer;
}($307e0d89efad9a8a$export$ef35774e6d314e91);
// should not be a purecomponent
var $307e0d89efad9a8a$export$6735ce526161c7bd = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $7DbRq._)(StandardEvent, BaseComponent);
    var _super = (0, $ju9pQ._)(StandardEvent);
    function StandardEvent() {
        (0, $luoZD._)(this, StandardEvent);
        return _super.apply(this, arguments);
    }
    (0, $fYUO3._)(StandardEvent, [
        {
            key: "render",
            value: function render() {
                var _this = this, props = _this.props, context = _this.context;
                var options = context.options;
                var seg = props.seg;
                var ui = seg.eventRange.ui;
                var timeFormat = options.eventTimeFormat || props.defaultTimeFormat;
                var timeText = $307e0d89efad9a8a$export$2538633961795d6b(seg, timeFormat, context, props.defaultDisplayEventTime, props.defaultDisplayEventEnd);
                return (0, $ihX0O.createElement)($307e0d89efad9a8a$export$c1df809846363ebe, Object.assign({}, props /* includes elRef */ , {
                    elTag: "a",
                    elStyle: {
                        borderColor: ui.borderColor,
                        backgroundColor: ui.backgroundColor
                    },
                    elAttrs: $307e0d89efad9a8a$export$6dabbe08653f866f(seg, context),
                    defaultGenerator: $307e0d89efad9a8a$var$renderInnerContent$1,
                    timeText: timeText
                }), function(InnerContent, eventContentArg) {
                    return (0, $ihX0O.createElement)((0, $ihX0O.Fragment), null, (0, $ihX0O.createElement)(InnerContent, {
                        elTag: "div",
                        elClasses: [
                            "fc-event-main"
                        ],
                        elStyle: {
                            color: eventContentArg.textColor
                        }
                    }), Boolean(eventContentArg.isStartResizable) && (0, $ihX0O.createElement)("div", {
                        className: "fc-event-resizer fc-event-resizer-start"
                    }), Boolean(eventContentArg.isEndResizable) && (0, $ihX0O.createElement)("div", {
                        className: "fc-event-resizer fc-event-resizer-end"
                    }));
                });
            }
        }
    ]);
    return StandardEvent;
}($307e0d89efad9a8a$export$ef35774e6d314e91);
$307e0d89efad9a8a$export$6735ce526161c7bd.addPropsEquality({
    seg: $307e0d89efad9a8a$export$a9c23c6ac3fc3eca
});
function $307e0d89efad9a8a$var$renderInnerContent$1(innerProps) {
    return (0, $ihX0O.createElement)("div", {
        className: "fc-event-main-frame"
    }, innerProps.timeText && (0, $ihX0O.createElement)("div", {
        className: "fc-event-time"
    }, innerProps.timeText), (0, $ihX0O.createElement)("div", {
        className: "fc-event-title-container"
    }, (0, $ihX0O.createElement)("div", {
        className: "fc-event-title fc-sticky"
    }, innerProps.event.title || (0, $ihX0O.createElement)((0, $ihX0O.Fragment), null, "\xa0"))));
}
var $307e0d89efad9a8a$export$6e4b1d19c6e2e012 = function(props) {
    return (0, $ihX0O.createElement)($307e0d89efad9a8a$export$e7c866399fa523f5.Consumer, null, function(context) {
        var options = context.options;
        var renderProps = {
            isAxis: props.isAxis,
            date: context.dateEnv.toDate(props.date),
            view: context.viewApi
        };
        return (0, $ihX0O.createElement)($307e0d89efad9a8a$export$e7094788287c5e9b, {
            elRef: props.elRef,
            elTag: props.elTag || "div",
            elAttrs: props.elAttrs,
            elClasses: props.elClasses,
            elStyle: props.elStyle,
            renderProps: renderProps,
            generatorName: "nowIndicatorContent",
            customGenerator: options.nowIndicatorContent,
            classNameGenerator: options.nowIndicatorClassNames,
            didMount: options.nowIndicatorDidMount,
            willUnmount: options.nowIndicatorWillUnmount
        }, props.children);
    });
};
var $307e0d89efad9a8a$var$DAY_NUM_FORMAT = $307e0d89efad9a8a$export$d141bba7fdc215a3({
    day: "numeric"
});
var $307e0d89efad9a8a$export$c5d7c1ac98841e53 = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $7DbRq._)(DayCellContainer, BaseComponent);
    var _super = (0, $ju9pQ._)(DayCellContainer);
    function DayCellContainer() {
        (0, $luoZD._)(this, DayCellContainer);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.refineRenderProps = $307e0d89efad9a8a$export$ebd11618f299a286($307e0d89efad9a8a$var$refineRenderProps);
        return _this;
    }
    (0, $fYUO3._)(DayCellContainer, [
        {
            key: "render",
            value: function render() {
                var _this = this, props = _this.props, context = _this.context;
                var options = context.options;
                var renderProps = this.refineRenderProps({
                    date: props.date,
                    dateProfile: props.dateProfile,
                    todayRange: props.todayRange,
                    isMonthStart: props.isMonthStart || false,
                    showDayNumber: props.showDayNumber,
                    extraRenderProps: props.extraRenderProps,
                    viewApi: context.viewApi,
                    dateEnv: context.dateEnv,
                    monthStartFormat: options.monthStartFormat
                });
                return (0, $ihX0O.createElement)($307e0d89efad9a8a$export$e7094788287c5e9b, {
                    elRef: props.elRef,
                    elTag: props.elTag,
                    elAttrs: Object.assign(Object.assign({}, props.elAttrs), renderProps.isDisabled ? {} : {
                        "data-date": $307e0d89efad9a8a$export$56350196709588fc(props.date)
                    }),
                    elClasses: (0, $79xu7._)($307e0d89efad9a8a$export$1a8f5705751d8277(renderProps, context.theme)).concat((0, $79xu7._)(props.elClasses || [])),
                    elStyle: props.elStyle,
                    renderProps: renderProps,
                    generatorName: "dayCellContent",
                    customGenerator: options.dayCellContent,
                    defaultGenerator: props.defaultGenerator,
                    classNameGenerator: // don't use custom classNames if disabled
                    renderProps.isDisabled ? undefined : options.dayCellClassNames,
                    didMount: options.dayCellDidMount,
                    willUnmount: options.dayCellWillUnmount
                }, props.children);
            }
        }
    ]);
    return DayCellContainer;
}($307e0d89efad9a8a$export$ef35774e6d314e91);
function $307e0d89efad9a8a$export$d92db8a7dc823bb0(options) {
    return Boolean(options.dayCellContent || $307e0d89efad9a8a$var$hasCustomRenderingHandler("dayCellContent", options));
}
function $307e0d89efad9a8a$var$refineRenderProps(raw) {
    var date = raw.date, dateEnv = raw.dateEnv, dateProfile = raw.dateProfile, isMonthStart = raw.isMonthStart;
    var dayMeta = $307e0d89efad9a8a$export$e171bab687b50e0(date, raw.todayRange, null, dateProfile);
    var dayNumberText = raw.showDayNumber ? dateEnv.format(date, isMonthStart ? raw.monthStartFormat : $307e0d89efad9a8a$var$DAY_NUM_FORMAT) : "";
    return Object.assign(Object.assign(Object.assign({
        date: dateEnv.toDate(date),
        view: raw.viewApi
    }, dayMeta), {
        isMonthStart: isMonthStart,
        dayNumberText: dayNumberText
    }), raw.extraRenderProps);
}
var $307e0d89efad9a8a$export$b02498c06ddfef28 = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $7DbRq._)(BgEvent, BaseComponent);
    var _super = (0, $ju9pQ._)(BgEvent);
    function BgEvent() {
        (0, $luoZD._)(this, BgEvent);
        return _super.apply(this, arguments);
    }
    (0, $fYUO3._)(BgEvent, [
        {
            key: "render",
            value: function render() {
                var props = this.props;
                var seg = props.seg;
                return (0, $ihX0O.createElement)($307e0d89efad9a8a$export$c1df809846363ebe, {
                    elTag: "div",
                    elClasses: [
                        "fc-bg-event"
                    ],
                    elStyle: {
                        backgroundColor: seg.eventRange.ui.backgroundColor
                    },
                    defaultGenerator: $307e0d89efad9a8a$var$renderInnerContent,
                    seg: seg,
                    timeText: "",
                    isDragging: false,
                    isResizing: false,
                    isDateSelecting: false,
                    isSelected: false,
                    isPast: props.isPast,
                    isFuture: props.isFuture,
                    isToday: props.isToday,
                    disableDragging: true,
                    disableResizing: true
                });
            }
        }
    ]);
    return BgEvent;
}($307e0d89efad9a8a$export$ef35774e6d314e91);
function $307e0d89efad9a8a$var$renderInnerContent(props) {
    var title = props.event.title;
    return title && (0, $ihX0O.createElement)("div", {
        className: "fc-event-title"
    }, props.event.title);
}
function $307e0d89efad9a8a$export$b975d55abac2bbe3(fillType) {
    return (0, $ihX0O.createElement)("div", {
        className: "fc-".concat(fillType)
    });
}
var $307e0d89efad9a8a$export$1343a74baacb0543 = function(props) {
    return (0, $ihX0O.createElement)($307e0d89efad9a8a$export$e7c866399fa523f5.Consumer, null, function(context) {
        var dateEnv = context.dateEnv, options = context.options;
        var date = props.date;
        var format = options.weekNumberFormat || props.defaultFormat;
        var num = dateEnv.computeWeekNumber(date); // TODO: somehow use for formatting as well?
        var text = dateEnv.format(date, format);
        var renderProps = {
            num: num,
            text: text,
            date: date
        };
        return (0, $ihX0O.createElement)($307e0d89efad9a8a$export$e7094788287c5e9b // why isn't WeekNumberContentArg being auto-detected?
        , {
            elRef: props.elRef,
            elTag: props.elTag,
            elAttrs: props.elAttrs,
            elClasses: props.elClasses,
            elStyle: props.elStyle,
            renderProps: renderProps,
            generatorName: "weekNumberContent",
            customGenerator: options.weekNumberContent,
            defaultGenerator: $307e0d89efad9a8a$var$renderInner,
            classNameGenerator: options.weekNumberClassNames,
            didMount: options.weekNumberDidMount,
            willUnmount: options.weekNumberWillUnmount
        }, props.children);
    });
};
function $307e0d89efad9a8a$var$renderInner(innerProps) {
    return innerProps.text;
}
var $307e0d89efad9a8a$var$PADDING_FROM_VIEWPORT = 10;
var $307e0d89efad9a8a$var$Popover = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $7DbRq._)(Popover, BaseComponent);
    var _super = (0, $ju9pQ._)(Popover);
    function Popover() {
        (0, $luoZD._)(this, Popover);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.state = {
            titleId: $307e0d89efad9a8a$export$6559d589eb85fbb6()
        };
        _this.handleRootEl = function(el) {
            _this.rootEl = el;
            if (_this.props.elRef) $307e0d89efad9a8a$export$71cec2538cb2c617(_this.props.elRef, el);
        };
        // Triggered when the user clicks *anywhere* in the document, for the autoHide feature
        _this.handleDocumentMouseDown = function(ev) {
            // only hide the popover if the click happened outside the popover
            var target = $307e0d89efad9a8a$export$2ed0fc6709e59212(ev);
            if (!_this.rootEl.contains(target)) _this.handleCloseClick();
        };
        _this.handleDocumentKeyDown = function(ev) {
            if (ev.key === "Escape") _this.handleCloseClick();
        };
        _this.handleCloseClick = function() {
            var onClose = _this.props.onClose;
            if (onClose) onClose();
        };
        return _this;
    }
    (0, $fYUO3._)(Popover, [
        {
            key: "render",
            value: function render() {
                var _this_context = this.context, theme = _this_context.theme, options = _this_context.options;
                var _this = this, props = _this.props, state = _this.state;
                var classNames = [
                    "fc-popover",
                    theme.getClass("popover")
                ].concat(props.extraClassNames || []);
                return (0, $7hN3J.createPortal)((0, $ihX0O.createElement)("div", Object.assign({}, props.extraAttrs, {
                    id: props.id,
                    className: classNames.join(" "),
                    "aria-labelledby": state.titleId,
                    ref: this.handleRootEl
                }), (0, $ihX0O.createElement)("div", {
                    className: "fc-popover-header " + theme.getClass("popoverHeader")
                }, (0, $ihX0O.createElement)("span", {
                    className: "fc-popover-title",
                    id: state.titleId
                }, props.title), (0, $ihX0O.createElement)("span", {
                    className: "fc-popover-close " + theme.getIconClass("close"),
                    title: options.closeHint,
                    onClick: this.handleCloseClick
                })), (0, $ihX0O.createElement)("div", {
                    className: "fc-popover-body " + theme.getClass("popoverContent")
                }, props.children)), props.parentEl);
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                document.addEventListener("mousedown", this.handleDocumentMouseDown);
                document.addEventListener("keydown", this.handleDocumentKeyDown);
                this.updateSize();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                document.removeEventListener("mousedown", this.handleDocumentMouseDown);
                document.removeEventListener("keydown", this.handleDocumentKeyDown);
            }
        },
        {
            key: "updateSize",
            value: function updateSize() {
                var isRtl = this.context.isRtl;
                var _this_props = this.props, alignmentEl = _this_props.alignmentEl, alignGridTop = _this_props.alignGridTop;
                var rootEl = this.rootEl;
                var alignmentRect = $307e0d89efad9a8a$var$computeClippedClientRect(alignmentEl);
                if (alignmentRect) {
                    var popoverDims = rootEl.getBoundingClientRect();
                    // position relative to viewport
                    var popoverTop = alignGridTop ? $307e0d89efad9a8a$export$dc98b0b04f4c7758(alignmentEl, ".fc-scrollgrid").getBoundingClientRect().top : alignmentRect.top;
                    var popoverLeft = isRtl ? alignmentRect.right - popoverDims.width : alignmentRect.left;
                    // constrain
                    popoverTop = Math.max(popoverTop, $307e0d89efad9a8a$var$PADDING_FROM_VIEWPORT);
                    popoverLeft = Math.min(popoverLeft, document.documentElement.clientWidth - $307e0d89efad9a8a$var$PADDING_FROM_VIEWPORT - popoverDims.width);
                    popoverLeft = Math.max(popoverLeft, $307e0d89efad9a8a$var$PADDING_FROM_VIEWPORT);
                    var origin = rootEl.offsetParent.getBoundingClientRect();
                    $307e0d89efad9a8a$export$faec65b429be379(rootEl, {
                        top: popoverTop - origin.top,
                        left: popoverLeft - origin.left
                    });
                }
            }
        }
    ]);
    return Popover;
}($307e0d89efad9a8a$export$ef35774e6d314e91);
var $307e0d89efad9a8a$var$MorePopover = /*#__PURE__*/ function(DateComponent) {
    "use strict";
    (0, $7DbRq._)(MorePopover, DateComponent);
    var _super = (0, $ju9pQ._)(MorePopover);
    function MorePopover() {
        (0, $luoZD._)(this, MorePopover);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.handleRootEl = function(rootEl) {
            _this.rootEl = rootEl;
            if (rootEl) _this.context.registerInteractiveComponent((0, $iJSF3._)(_this), {
                el: rootEl,
                useEventCenter: false
            });
            else _this.context.unregisterInteractiveComponent((0, $iJSF3._)(_this));
        };
        return _this;
    }
    (0, $fYUO3._)(MorePopover, [
        {
            key: "render",
            value: function render() {
                var _this_context = this.context, options = _this_context.options, dateEnv = _this_context.dateEnv;
                var props = this.props;
                var startDate = props.startDate, todayRange = props.todayRange, dateProfile = props.dateProfile;
                var title = dateEnv.format(startDate, options.dayPopoverFormat);
                return (0, $ihX0O.createElement)($307e0d89efad9a8a$export$c5d7c1ac98841e53, {
                    elRef: this.handleRootEl,
                    date: startDate,
                    dateProfile: dateProfile,
                    todayRange: todayRange
                }, function(InnerContent, renderProps, elAttrs) {
                    return (0, $ihX0O.createElement)($307e0d89efad9a8a$var$Popover, {
                        elRef: elAttrs.ref,
                        id: props.id,
                        title: title,
                        extraClassNames: [
                            "fc-more-popover"
                        ].concat(elAttrs.className || []),
                        extraAttrs: elAttrs /* TODO: make these time-based when not whole-day? */ ,
                        parentEl: props.parentEl,
                        alignmentEl: props.alignmentEl,
                        alignGridTop: props.alignGridTop,
                        onClose: props.onClose
                    }, $307e0d89efad9a8a$export$d92db8a7dc823bb0(options) && (0, $ihX0O.createElement)(InnerContent, {
                        elTag: "div",
                        elClasses: [
                            "fc-more-popover-misc"
                        ]
                    }), props.children);
                });
            }
        },
        {
            key: "queryHit",
            value: function queryHit(positionLeft, positionTop, elWidth, elHeight) {
                var _this = this, rootEl = _this.rootEl, props = _this.props;
                if (positionLeft >= 0 && positionLeft < elWidth && positionTop >= 0 && positionTop < elHeight) return {
                    dateProfile: props.dateProfile,
                    dateSpan: Object.assign({
                        allDay: !props.forceTimed,
                        range: {
                            start: props.startDate,
                            end: props.endDate
                        }
                    }, props.extraDateSpan),
                    dayEl: rootEl,
                    rect: {
                        left: 0,
                        top: 0,
                        right: elWidth,
                        bottom: elHeight
                    },
                    layer: 1
                };
                return null;
            }
        }
    ]);
    return MorePopover;
}($307e0d89efad9a8a$export$d22783b3c2400a3a);
var $307e0d89efad9a8a$export$87b6ab1c2cb8b955 = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $7DbRq._)(MoreLinkContainer, BaseComponent);
    var _super = (0, $ju9pQ._)(MoreLinkContainer);
    function MoreLinkContainer() {
        (0, $luoZD._)(this, MoreLinkContainer);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.state = {
            isPopoverOpen: false,
            popoverId: $307e0d89efad9a8a$export$6559d589eb85fbb6()
        };
        _this.handleLinkEl = function(linkEl) {
            _this.linkEl = linkEl;
            if (_this.props.elRef) $307e0d89efad9a8a$export$71cec2538cb2c617(_this.props.elRef, linkEl);
        };
        _this.handleClick = function(ev) {
            var buildPublicSeg = function buildPublicSeg(seg) {
                var _seg_eventRange = seg.eventRange, def = _seg_eventRange.def, instance = _seg_eventRange.instance, range = _seg_eventRange.range;
                return {
                    event: new $307e0d89efad9a8a$export$71511d61b312f219(context, def, instance),
                    start: context.dateEnv.toDate(range.start),
                    end: context.dateEnv.toDate(range.end),
                    isStart: seg.isStart,
                    isEnd: seg.isEnd
                };
            };
            var _$_assert_this_initialized = (0, $iJSF3._)(_this), props = _$_assert_this_initialized.props, context = _$_assert_this_initialized.context;
            var moreLinkClick = context.options.moreLinkClick;
            var date = $307e0d89efad9a8a$var$computeRange(props).start;
            if (typeof moreLinkClick === "function") moreLinkClick = moreLinkClick({
                date: date,
                allDay: Boolean(props.allDayDate),
                allSegs: props.allSegs.map(buildPublicSeg),
                hiddenSegs: props.hiddenSegs.map(buildPublicSeg),
                jsEvent: ev,
                view: context.viewApi
            });
            if (!moreLinkClick || moreLinkClick === "popover") _this.setState({
                isPopoverOpen: true
            });
            else if (typeof moreLinkClick === "string") context.calendarApi.zoomTo(date, moreLinkClick);
        };
        _this.handlePopoverClose = function() {
            _this.setState({
                isPopoverOpen: false
            });
        };
        return _this;
    }
    (0, $fYUO3._)(MoreLinkContainer, [
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _this1 = this, props = _this1.props, state = _this1.state;
                return (0, $ihX0O.createElement)($307e0d89efad9a8a$export$e7c866399fa523f5.Consumer, null, function(context) {
                    var viewApi = context.viewApi, options = context.options, calendarApi = context.calendarApi;
                    var moreLinkText = options.moreLinkText;
                    var moreCnt = props.moreCnt;
                    var range = $307e0d89efad9a8a$var$computeRange(props);
                    var text = typeof moreLinkText === "function" // TODO: eventually use formatWithOrdinals
                     ? moreLinkText.call(calendarApi, moreCnt) : "+".concat(moreCnt, " ").concat(moreLinkText);
                    var hint = $307e0d89efad9a8a$export$342063e11d6c3cad(options.moreLinkHint, [
                        moreCnt
                    ], text);
                    var renderProps = {
                        num: moreCnt,
                        shortText: "+".concat(moreCnt),
                        text: text,
                        view: viewApi
                    };
                    return (0, $ihX0O.createElement)((0, $ihX0O.Fragment), null, Boolean(props.moreCnt) && (0, $ihX0O.createElement)($307e0d89efad9a8a$export$e7094788287c5e9b, {
                        elTag: props.elTag || "a",
                        elRef: _this.handleLinkEl,
                        elClasses: (0, $79xu7._)(props.elClasses || []).concat([
                            "fc-more-link"
                        ]),
                        elStyle: props.elStyle,
                        elAttrs: Object.assign(Object.assign(Object.assign({}, props.elAttrs), $307e0d89efad9a8a$var$createAriaClickAttrs(_this.handleClick)), {
                            title: hint,
                            "aria-expanded": state.isPopoverOpen,
                            "aria-controls": state.isPopoverOpen ? state.popoverId : ""
                        }),
                        renderProps: renderProps,
                        generatorName: "moreLinkContent",
                        customGenerator: options.moreLinkContent,
                        defaultGenerator: props.defaultGenerator || $307e0d89efad9a8a$var$renderMoreLinkInner,
                        classNameGenerator: options.moreLinkClassNames,
                        didMount: options.moreLinkDidMount,
                        willUnmount: options.moreLinkWillUnmount
                    }, props.children), state.isPopoverOpen && (0, $ihX0O.createElement)($307e0d89efad9a8a$var$MorePopover, {
                        id: state.popoverId,
                        startDate: range.start,
                        endDate: range.end,
                        dateProfile: props.dateProfile,
                        todayRange: props.todayRange,
                        extraDateSpan: props.extraDateSpan,
                        parentEl: _this.parentEl,
                        alignmentEl: props.alignmentElRef ? props.alignmentElRef.current : _this.linkEl,
                        alignGridTop: props.alignGridTop,
                        forceTimed: props.forceTimed,
                        onClose: _this.handlePopoverClose
                    }, props.popoverContent()));
                });
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.updateParentEl();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                this.updateParentEl();
            }
        },
        {
            key: "updateParentEl",
            value: function updateParentEl() {
                if (this.linkEl) this.parentEl = $307e0d89efad9a8a$export$dc98b0b04f4c7758(this.linkEl, ".fc-view-harness");
            }
        }
    ]);
    return MoreLinkContainer;
}($307e0d89efad9a8a$export$ef35774e6d314e91);
function $307e0d89efad9a8a$var$renderMoreLinkInner(props) {
    return props.text;
}
function $307e0d89efad9a8a$var$computeRange(props) {
    if (props.allDayDate) return {
        start: props.allDayDate,
        end: $307e0d89efad9a8a$export$625550452a3fa3ec(props.allDayDate, 1)
    };
    var hiddenSegs = props.hiddenSegs;
    return {
        start: $307e0d89efad9a8a$export$cd571ca6d1702b73(hiddenSegs),
        end: $307e0d89efad9a8a$var$computeLatestSegEnd(hiddenSegs)
    };
}
function $307e0d89efad9a8a$export$cd571ca6d1702b73(segs) {
    return segs.reduce($307e0d89efad9a8a$var$pickEarliestStart).eventRange.range.start;
}
function $307e0d89efad9a8a$var$pickEarliestStart(seg0, seg1) {
    return seg0.eventRange.range.start < seg1.eventRange.range.start ? seg0 : seg1;
}
function $307e0d89efad9a8a$var$computeLatestSegEnd(segs) {
    return segs.reduce($307e0d89efad9a8a$var$pickLatestEnd).eventRange.range.end;
}
function $307e0d89efad9a8a$var$pickLatestEnd(seg0, seg1) {
    return seg0.eventRange.range.end > seg1.eventRange.range.end ? seg0 : seg1;
}
var $307e0d89efad9a8a$var$Store = /*#__PURE__*/ function() {
    "use strict";
    function Store() {
        (0, $luoZD._)(this, Store);
        this.handlers = [];
    }
    (0, $fYUO3._)(Store, [
        {
            key: "set",
            value: function set(value) {
                this.currentValue = value;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.handlers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var handler = _step.value;
                        handler(value);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "subscribe",
            value: function subscribe(handler) {
                this.handlers.push(handler);
                if (this.currentValue !== undefined) handler(this.currentValue);
            }
        }
    ]);
    return Store;
}();
/*
Subscribers will get a LIST of CustomRenderings
*/ var $307e0d89efad9a8a$export$1776704b6532a19a = /*#__PURE__*/ function(Store) {
    "use strict";
    (0, $7DbRq._)(CustomRenderingStore, Store);
    var _super = (0, $ju9pQ._)(CustomRenderingStore);
    function CustomRenderingStore() {
        (0, $luoZD._)(this, CustomRenderingStore);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.map = new Map();
        return _this;
    }
    (0, $fYUO3._)(CustomRenderingStore, [
        {
            // for consistent order
            key: "handle",
            value: function handle(customRendering) {
                var map = this.map;
                var updated = false;
                if (customRendering.isActive) {
                    map.set(customRendering.id, customRendering);
                    updated = true;
                } else if (map.has(customRendering.id)) {
                    map.delete(customRendering.id);
                    updated = true;
                }
                if (updated) this.set(map);
            }
        }
    ]);
    return CustomRenderingStore;
}($307e0d89efad9a8a$var$Store);

});
parcelRegister("a3QmP", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $7532ce3ef989145b$export$2466d533fda16e33; });

var $kdppn = parcelRequire("kdppn");

var $3Oamm = parcelRequire("3Oamm");

var $9DNCh = parcelRequire("9DNCh");

var $fx5GK = parcelRequire("fx5GK");
function $7532ce3ef989145b$export$2466d533fda16e33(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $7532ce3ef989145b$export$2466d533fda16e33 = function(Class) {
        if (Class === null || !(0, $9DNCh._is_native_function)(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return (0, $kdppn._construct)(Class, arguments, (0, $3Oamm._get_prototype_of)(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return (0, $fx5GK._set_prototype_of)(Wrapper, Class);
    };
    return $7532ce3ef989145b$export$2466d533fda16e33(Class);
}

});
parcelRegister("kdppn", function(module, exports) {

$parcel$export(module.exports, "_construct", function () { return $eb78bb166a2c30b3$export$2d841144c5f8c4ab; });

var $bYsjm = parcelRequire("bYsjm");

var $fx5GK = parcelRequire("fx5GK");
function $eb78bb166a2c30b3$export$2d841144c5f8c4ab(Parent, args, Class) {
    if ((0, $bYsjm._is_native_reflect_construct)()) $eb78bb166a2c30b3$export$2d841144c5f8c4ab = Reflect.construct;
    else $eb78bb166a2c30b3$export$2d841144c5f8c4ab = function construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) (0, $fx5GK._set_prototype_of)(instance, Class.prototype);
        return instance;
    };
    return $eb78bb166a2c30b3$export$2d841144c5f8c4ab.apply(null, arguments);
}

});

parcelRegister("9DNCh", function(module, exports) {

$parcel$export(module.exports, "_is_native_function", function () { return $704e3e59741f3a7c$export$514eda94019f4334; });
function $704e3e59741f3a7c$export$514eda94019f4334(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

});


parcelRegister("ihX0O", function(module, exports) {

$parcel$export(module.exports, "options", function () { return $d507971d2dea7d86$export$41c562ebe57d11e2; });
$parcel$export(module.exports, "isValidElement", function () { return $d507971d2dea7d86$export$a8257692ac88316c; });
$parcel$export(module.exports, "createElement", function () { return $d507971d2dea7d86$export$c8a8987d4410bf2d; });
$parcel$export(module.exports, "createRef", function () { return $d507971d2dea7d86$export$7d1e3a5e95ceca43; });
$parcel$export(module.exports, "Fragment", function () { return $d507971d2dea7d86$export$ffb0004e005737fa; });
$parcel$export(module.exports, "Component", function () { return $d507971d2dea7d86$export$16fa2f45be04daa8; });
$parcel$export(module.exports, "toChildArray", function () { return $d507971d2dea7d86$export$47e4c5b300681277; });
$parcel$export(module.exports, "render", function () { return $d507971d2dea7d86$export$b3890eb0ae9dca99; });
$parcel$export(module.exports, "hydrate", function () { return $d507971d2dea7d86$export$fa8d919ba61d84db; });
$parcel$export(module.exports, "cloneElement", function () { return $d507971d2dea7d86$export$e530037191fcd5d7; });
$parcel$export(module.exports, "createContext", function () { return $d507971d2dea7d86$export$fd42f52fd3ae1109; });

var $jzTO1 = parcelRequire("jzTO1");
var $d507971d2dea7d86$var$n, $d507971d2dea7d86$export$41c562ebe57d11e2, $d507971d2dea7d86$var$u, $d507971d2dea7d86$export$a8257692ac88316c, $d507971d2dea7d86$var$t, $d507971d2dea7d86$var$r, $d507971d2dea7d86$var$o, $d507971d2dea7d86$var$f, $d507971d2dea7d86$var$e, $d507971d2dea7d86$var$c = {}, $d507971d2dea7d86$var$s = [], $d507971d2dea7d86$var$a = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i;
function $d507971d2dea7d86$var$h(n, l) {
    for(var u in l)n[u] = l[u];
    return n;
}
function $d507971d2dea7d86$var$v(n) {
    var l = n.parentNode;
    l && l.removeChild(n);
}
function $d507971d2dea7d86$export$c8a8987d4410bf2d(l, u, i) {
    var t, r, o, f = {};
    for(o in u)"key" == o ? t = u[o] : "ref" == o ? r = u[o] : f[o] = u[o];
    if (arguments.length > 2 && (f.children = arguments.length > 3 ? $d507971d2dea7d86$var$n.call(arguments, 2) : i), "function" == typeof l && null != l.defaultProps) for(o in l.defaultProps)void 0 === f[o] && (f[o] = l.defaultProps[o]);
    return $d507971d2dea7d86$var$p(l, f, t, r, null);
}
function $d507971d2dea7d86$var$p(n, i, t, r, o) {
    var f = {
        type: n,
        props: i,
        key: t,
        ref: r,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __d: void 0,
        __c: null,
        __h: null,
        constructor: void 0,
        __v: null == o ? ++$d507971d2dea7d86$var$u : o
    };
    return null == o && null != $d507971d2dea7d86$export$41c562ebe57d11e2.vnode && $d507971d2dea7d86$export$41c562ebe57d11e2.vnode(f), f;
}
function $d507971d2dea7d86$export$7d1e3a5e95ceca43() {
    return {
        current: null
    };
}
function $d507971d2dea7d86$export$ffb0004e005737fa(n) {
    return n.children;
}
function $d507971d2dea7d86$var$k(n, l, u, i, t) {
    var r;
    for(r in u)"children" === r || "key" === r || r in l || $d507971d2dea7d86$var$g(n, r, null, u[r], i);
    for(r in l)t && "function" != typeof l[r] || "children" === r || "key" === r || "value" === r || "checked" === r || u[r] === l[r] || $d507971d2dea7d86$var$g(n, r, l[r], u[r], i);
}
function $d507971d2dea7d86$var$b(n, l, u) {
    "-" === l[0] ? n.setProperty(l, null == u ? "" : u) : n[l] = null == u ? "" : "number" != typeof u || $d507971d2dea7d86$var$a.test(l) ? u : u + "px";
}
function $d507971d2dea7d86$var$g(n, l, u, i, t) {
    var r;
    n: if ("style" === l) {
        if ("string" == typeof u) n.style.cssText = u;
        else {
            if ("string" == typeof i && (n.style.cssText = i = ""), i) for(l in i)u && l in u || $d507971d2dea7d86$var$b(n.style, l, "");
            if (u) for(l in u)i && u[l] === i[l] || $d507971d2dea7d86$var$b(n.style, l, u[l]);
        }
    } else if ("o" === l[0] && "n" === l[1]) r = l !== (l = l.replace(/Capture$/, "")), l = l.toLowerCase() in n ? l.toLowerCase().slice(2) : l.slice(2), n.l || (n.l = {}), n.l[l + r] = u, u ? i || n.addEventListener(l, r ? $d507971d2dea7d86$var$w : $d507971d2dea7d86$var$m, r) : n.removeEventListener(l, r ? $d507971d2dea7d86$var$w : $d507971d2dea7d86$var$m, r);
    else if ("dangerouslySetInnerHTML" !== l) {
        if (t) l = l.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
        else if ("width" !== l && "height" !== l && "href" !== l && "list" !== l && "form" !== l && "tabIndex" !== l && "download" !== l && l in n) try {
            n[l] = null == u ? "" : u;
            break n;
        } catch (n) {}
        "function" == typeof u || (null == u || !1 === u && -1 == l.indexOf("-") ? n.removeAttribute(l) : n.setAttribute(l, u));
    }
}
function $d507971d2dea7d86$var$m(n) {
    $d507971d2dea7d86$var$t = !0;
    try {
        return this.l[n.type + !1]($d507971d2dea7d86$export$41c562ebe57d11e2.event ? $d507971d2dea7d86$export$41c562ebe57d11e2.event(n) : n);
    } finally{
        $d507971d2dea7d86$var$t = !1;
    }
}
function $d507971d2dea7d86$var$w(n) {
    $d507971d2dea7d86$var$t = !0;
    try {
        return this.l[n.type + !0]($d507971d2dea7d86$export$41c562ebe57d11e2.event ? $d507971d2dea7d86$export$41c562ebe57d11e2.event(n) : n);
    } finally{
        $d507971d2dea7d86$var$t = !1;
    }
}
function $d507971d2dea7d86$export$16fa2f45be04daa8(n, l) {
    this.props = n, this.context = l;
}
function $d507971d2dea7d86$var$A(n, l) {
    if (null == l) return n.__ ? $d507971d2dea7d86$var$A(n.__, n.__.__k.indexOf(n) + 1) : null;
    for(var u; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) return u.__e;
    return "function" == typeof n.type ? $d507971d2dea7d86$var$A(n) : null;
}
function $d507971d2dea7d86$var$P(n) {
    var l, u;
    if (null != (n = n.__) && null != n.__c) {
        for(n.__e = n.__c.base = null, l = 0; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) {
            n.__e = n.__c.base = u.__e;
            break;
        }
        return $d507971d2dea7d86$var$P(n);
    }
}
function $d507971d2dea7d86$var$C(n) {
    $d507971d2dea7d86$var$t ? setTimeout(n) : $d507971d2dea7d86$var$f(n);
}
function $d507971d2dea7d86$var$T(n) {
    (!n.__d && (n.__d = !0) && $d507971d2dea7d86$var$r.push(n) && !$d507971d2dea7d86$var$$.__r++ || $d507971d2dea7d86$var$o !== $d507971d2dea7d86$export$41c562ebe57d11e2.debounceRendering) && (($d507971d2dea7d86$var$o = $d507971d2dea7d86$export$41c562ebe57d11e2.debounceRendering) || $d507971d2dea7d86$var$C)($d507971d2dea7d86$var$$);
}
function $d507971d2dea7d86$var$$() {
    var n, l, u, i, t, o, f, e;
    for($d507971d2dea7d86$var$r.sort(function(n, l) {
        return n.__v.__b - l.__v.__b;
    }); n = $d507971d2dea7d86$var$r.shift();)n.__d && (l = $d507971d2dea7d86$var$r.length, i = void 0, t = void 0, f = (o = (u = n).__v).__e, (e = u.__P) && (i = [], (t = $d507971d2dea7d86$var$h({}, o)).__v = o.__v + 1, $d507971d2dea7d86$var$M(e, o, t, u.__n, void 0 !== e.ownerSVGElement, null != o.__h ? [
        f
    ] : null, i, null == f ? $d507971d2dea7d86$var$A(o) : f, o.__h), $d507971d2dea7d86$var$N(i, o), o.__e != f && $d507971d2dea7d86$var$P(o)), $d507971d2dea7d86$var$r.length > l && $d507971d2dea7d86$var$r.sort(function(n, l) {
        return n.__v.__b - l.__v.__b;
    }));
    $d507971d2dea7d86$var$$.__r = 0;
}
function $d507971d2dea7d86$var$H(n, l, u, i, t, r, o, f, e, a) {
    var h, v, y, d, k, b, g, m = i && i.__k || $d507971d2dea7d86$var$s, w = m.length;
    for(u.__k = [], h = 0; h < l.length; h++)if (null != (d = u.__k[h] = null == (d = l[h]) || "boolean" == typeof d ? null : "string" == typeof d || "number" == typeof d || "bigint" == (typeof d === "undefined" ? "undefined" : (0, $jzTO1._)(d)) ? $d507971d2dea7d86$var$p(null, d, null, null, d) : Array.isArray(d) ? $d507971d2dea7d86$var$p($d507971d2dea7d86$export$ffb0004e005737fa, {
        children: d
    }, null, null, null) : d.__b > 0 ? $d507971d2dea7d86$var$p(d.type, d.props, d.key, d.ref ? d.ref : null, d.__v) : d)) {
        if (d.__ = u, d.__b = u.__b + 1, null === (y = m[h]) || y && d.key == y.key && d.type === y.type) m[h] = void 0;
        else for(v = 0; v < w; v++){
            if ((y = m[v]) && d.key == y.key && d.type === y.type) {
                m[v] = void 0;
                break;
            }
            y = null;
        }
        $d507971d2dea7d86$var$M(n, d, y = y || $d507971d2dea7d86$var$c, t, r, o, f, e, a), k = d.__e, (v = d.ref) && y.ref != v && (g || (g = []), y.ref && g.push(y.ref, null, d), g.push(v, d.__c || k, d)), null != k ? (null == b && (b = k), "function" == typeof d.type && d.__k === y.__k ? d.__d = e = $d507971d2dea7d86$var$I(d, e, n) : e = $d507971d2dea7d86$var$z(n, d, y, m, k, e), "function" == typeof u.type && (u.__d = e)) : e && y.__e == e && e.parentNode != n && (e = $d507971d2dea7d86$var$A(y));
    }
    for(u.__e = b, h = w; h--;)null != m[h] && ("function" == typeof u.type && null != m[h].__e && m[h].__e == u.__d && (u.__d = $d507971d2dea7d86$var$L(i).nextSibling), $d507971d2dea7d86$var$q(m[h], m[h]));
    if (g) for(h = 0; h < g.length; h++)$d507971d2dea7d86$var$S(g[h], g[++h], g[++h]);
}
function $d507971d2dea7d86$var$I(n, l, u) {
    for(var i, t = n.__k, r = 0; t && r < t.length; r++)(i = t[r]) && (i.__ = n, l = "function" == typeof i.type ? $d507971d2dea7d86$var$I(i, l, u) : $d507971d2dea7d86$var$z(u, i, i, t, i.__e, l));
    return l;
}
function $d507971d2dea7d86$export$47e4c5b300681277(n, l) {
    return l = l || [], null == n || "boolean" == typeof n || (Array.isArray(n) ? n.some(function(n) {
        $d507971d2dea7d86$export$47e4c5b300681277(n, l);
    }) : l.push(n)), l;
}
function $d507971d2dea7d86$var$z(n, l, u, i, t, r) {
    var o, f, e;
    if (void 0 !== l.__d) o = l.__d, l.__d = void 0;
    else if (null == u || t != r || null == t.parentNode) n: if (null == r || r.parentNode !== n) n.appendChild(t), o = null;
    else {
        for(f = r, e = 0; (f = f.nextSibling) && e < i.length; e += 1)if (f == t) break n;
        n.insertBefore(t, r), o = r;
    }
    return void 0 !== o ? o : t.nextSibling;
}
function $d507971d2dea7d86$var$L(n) {
    var l, u, i;
    if (null == n.type || "string" == typeof n.type) return n.__e;
    if (n.__k) {
        for(l = n.__k.length - 1; l >= 0; l--)if ((u = n.__k[l]) && (i = $d507971d2dea7d86$var$L(u))) return i;
    }
    return null;
}
function $d507971d2dea7d86$var$M(n, u, i, t, r, o, f, e, c) {
    var s, a, v, y, p, d, k, b, g, m, w, A, P, C, T, _$$ = u.type;
    if (void 0 !== u.constructor) return null;
    null != i.__h && (c = i.__h, e = u.__e = i.__e, u.__h = null, o = [
        e
    ]), (s = $d507971d2dea7d86$export$41c562ebe57d11e2.__b) && s(u);
    try {
        n: if ("function" == typeof _$$) {
            if (b = u.props, g = (s = _$$.contextType) && t[s.__c], m = s ? g ? g.props.value : s.__ : t, i.__c ? k = (a = u.__c = i.__c).__ = a.__E : ("prototype" in _$$ && _$$.prototype.render ? u.__c = a = new _$$(b, m) : (u.__c = a = new $d507971d2dea7d86$export$16fa2f45be04daa8(b, m), a.constructor = _$$, a.render = $d507971d2dea7d86$var$B), g && g.sub(a), a.props = b, a.state || (a.state = {}), a.context = m, a.__n = t, v = a.__d = !0, a.__h = [], a._sb = []), null == a.__s && (a.__s = a.state), null != _$$.getDerivedStateFromProps && (a.__s == a.state && (a.__s = $d507971d2dea7d86$var$h({}, a.__s)), $d507971d2dea7d86$var$h(a.__s, _$$.getDerivedStateFromProps(b, a.__s))), y = a.props, p = a.state, a.__v = u, v) null == _$$.getDerivedStateFromProps && null != a.componentWillMount && a.componentWillMount(), null != a.componentDidMount && a.__h.push(a.componentDidMount);
            else {
                if (null == _$$.getDerivedStateFromProps && b !== y && null != a.componentWillReceiveProps && a.componentWillReceiveProps(b, m), !a.__e && null != a.shouldComponentUpdate && !1 === a.shouldComponentUpdate(b, a.__s, m) || u.__v === i.__v) {
                    for(u.__v !== i.__v && (a.props = b, a.state = a.__s, a.__d = !1), u.__e = i.__e, u.__k = i.__k, u.__k.forEach(function(n) {
                        n && (n.__ = u);
                    }), w = 0; w < a._sb.length; w++)a.__h.push(a._sb[w]);
                    a._sb = [], a.__h.length && f.push(a);
                    break n;
                }
                null != a.componentWillUpdate && a.componentWillUpdate(b, a.__s, m), null != a.componentDidUpdate && a.__h.push(function() {
                    a.componentDidUpdate(y, p, d);
                });
            }
            if (a.context = m, a.props = b, a.__P = n, A = $d507971d2dea7d86$export$41c562ebe57d11e2.__r, P = 0, "prototype" in _$$ && _$$.prototype.render) {
                for(a.state = a.__s, a.__d = !1, A && A(u), s = a.render(a.props, a.state, a.context), C = 0; C < a._sb.length; C++)a.__h.push(a._sb[C]);
                a._sb = [];
            } else do a.__d = !1, A && A(u), s = a.render(a.props, a.state, a.context), a.state = a.__s;
            while (a.__d && ++P < 25);
            a.state = a.__s, null != a.getChildContext && (t = $d507971d2dea7d86$var$h($d507971d2dea7d86$var$h({}, t), a.getChildContext())), v || null == a.getSnapshotBeforeUpdate || (d = a.getSnapshotBeforeUpdate(y, p)), T = null != s && s.type === $d507971d2dea7d86$export$ffb0004e005737fa && null == s.key ? s.props.children : s, $d507971d2dea7d86$var$H(n, Array.isArray(T) ? T : [
                T
            ], u, i, t, r, o, f, e, c), a.base = u.__e, u.__h = null, a.__h.length && f.push(a), k && (a.__E = a.__ = null), a.__e = !1;
        } else null == o && u.__v === i.__v ? (u.__k = i.__k, u.__e = i.__e) : u.__e = $d507971d2dea7d86$var$O(i.__e, u, i, t, r, o, f, c);
        (s = $d507971d2dea7d86$export$41c562ebe57d11e2.diffed) && s(u);
    } catch (n) {
        u.__v = null, (c || null != o) && (u.__e = e, u.__h = !!c, o[o.indexOf(e)] = null), $d507971d2dea7d86$export$41c562ebe57d11e2.__e(n, u, i);
    }
}
function $d507971d2dea7d86$var$N(n, u) {
    $d507971d2dea7d86$export$41c562ebe57d11e2.__c && $d507971d2dea7d86$export$41c562ebe57d11e2.__c(u, n), n.some(function(u) {
        try {
            n = u.__h, u.__h = [], n.some(function(n) {
                n.call(u);
            });
        } catch (n) {
            $d507971d2dea7d86$export$41c562ebe57d11e2.__e(n, u.__v);
        }
    });
}
function $d507971d2dea7d86$var$O(l, u, i, t, r, o, f, e) {
    var s, a, h, y = i.props, p = u.props, d = u.type, _$_ = 0;
    if ("svg" === d && (r = !0), null != o) {
        for(; _$_ < o.length; _$_++)if ((s = o[_$_]) && "setAttribute" in s == !!d && (d ? s.localName === d : 3 === s.nodeType)) {
            l = s, o[_$_] = null;
            break;
        }
    }
    if (null == l) {
        if (null === d) return document.createTextNode(p);
        l = r ? document.createElementNS("http://www.w3.org/2000/svg", d) : document.createElement(d, p.is && p), o = null, e = !1;
    }
    if (null === d) y === p || e && l.data === p || (l.data = p);
    else {
        if (o = o && $d507971d2dea7d86$var$n.call(l.childNodes), a = (y = i.props || $d507971d2dea7d86$var$c).dangerouslySetInnerHTML, h = p.dangerouslySetInnerHTML, !e) {
            if (null != o) for(y = {}, _$_ = 0; _$_ < l.attributes.length; _$_++)y[l.attributes[_$_].name] = l.attributes[_$_].value;
            (h || a) && (h && (a && h.__html == a.__html || h.__html === l.innerHTML) || (l.innerHTML = h && h.__html || ""));
        }
        if ($d507971d2dea7d86$var$k(l, p, y, r, e), h) u.__k = [];
        else if (_$_ = u.props.children, $d507971d2dea7d86$var$H(l, Array.isArray(_$_) ? _$_ : [
            _$_
        ], u, i, t, r && "foreignObject" !== d, o, f, o ? o[0] : i.__k && $d507971d2dea7d86$var$A(i, 0), e), null != o) for(_$_ = o.length; _$_--;)null != o[_$_] && $d507971d2dea7d86$var$v(o[_$_]);
        e || ("value" in p && void 0 !== (_$_ = p.value) && (_$_ !== l.value || "progress" === d && !_$_ || "option" === d && _$_ !== y.value) && $d507971d2dea7d86$var$g(l, "value", _$_, y.value, !1), "checked" in p && void 0 !== (_$_ = p.checked) && _$_ !== l.checked && $d507971d2dea7d86$var$g(l, "checked", _$_, y.checked, !1));
    }
    return l;
}
function $d507971d2dea7d86$var$S(n, u, i) {
    try {
        "function" == typeof n ? n(u) : n.current = u;
    } catch (n) {
        $d507971d2dea7d86$export$41c562ebe57d11e2.__e(n, i);
    }
}
function $d507971d2dea7d86$var$q(n, u, i) {
    var t, r;
    if ($d507971d2dea7d86$export$41c562ebe57d11e2.unmount && $d507971d2dea7d86$export$41c562ebe57d11e2.unmount(n), (t = n.ref) && (t.current && t.current !== n.__e || $d507971d2dea7d86$var$S(t, null, u)), null != (t = n.__c)) {
        if (t.componentWillUnmount) try {
            t.componentWillUnmount();
        } catch (n) {
            $d507971d2dea7d86$export$41c562ebe57d11e2.__e(n, u);
        }
        t.base = t.__P = null, n.__c = void 0;
    }
    if (t = n.__k) for(r = 0; r < t.length; r++)t[r] && $d507971d2dea7d86$var$q(t[r], u, i || "function" != typeof n.type);
    i || null == n.__e || $d507971d2dea7d86$var$v(n.__e), n.__ = n.__e = n.__d = void 0;
}
function $d507971d2dea7d86$var$B(n, l, u) {
    return this.constructor(n, u);
}
function $d507971d2dea7d86$export$b3890eb0ae9dca99(u, i, t) {
    var r, o, f;
    $d507971d2dea7d86$export$41c562ebe57d11e2.__ && $d507971d2dea7d86$export$41c562ebe57d11e2.__(u, i), o = (r = "function" == typeof t) ? null : t && t.__k || i.__k, f = [], $d507971d2dea7d86$var$M(i, u = (!r && t || i).__k = $d507971d2dea7d86$export$c8a8987d4410bf2d($d507971d2dea7d86$export$ffb0004e005737fa, null, [
        u
    ]), o || $d507971d2dea7d86$var$c, $d507971d2dea7d86$var$c, void 0 !== i.ownerSVGElement, !r && t ? [
        t
    ] : o ? null : i.firstChild ? $d507971d2dea7d86$var$n.call(i.childNodes) : null, f, !r && t ? t : o ? o.__e : i.firstChild, r), $d507971d2dea7d86$var$N(f, u);
}
function $d507971d2dea7d86$export$fa8d919ba61d84db(n, l) {
    $d507971d2dea7d86$export$b3890eb0ae9dca99(n, l, $d507971d2dea7d86$export$fa8d919ba61d84db);
}
function $d507971d2dea7d86$export$e530037191fcd5d7(l, u, i) {
    var t, r, o, f = $d507971d2dea7d86$var$h({}, l.props);
    for(o in u)"key" == o ? t = u[o] : "ref" == o ? r = u[o] : f[o] = u[o];
    return arguments.length > 2 && (f.children = arguments.length > 3 ? $d507971d2dea7d86$var$n.call(arguments, 2) : i), $d507971d2dea7d86$var$p(l.type, f, t || l.key, r || l.ref, null);
}
function $d507971d2dea7d86$export$fd42f52fd3ae1109(n, l) {
    var u = {
        __c: l = "__cC" + $d507971d2dea7d86$var$e++,
        __: n,
        Consumer: function Consumer(n, l) {
            return n.children(l);
        },
        Provider: function Provider(n) {
            var u, i;
            return this.getChildContext || (u = [], (i = {})[l] = this, this.getChildContext = function() {
                return i;
            }, this.shouldComponentUpdate = function(n) {
                this.props.value !== n.value && u.some(function(n) {
                    n.__e = !0, $d507971d2dea7d86$var$T(n);
                });
            }, this.sub = function(n) {
                u.push(n);
                var _$l = n.componentWillUnmount;
                n.componentWillUnmount = function() {
                    u.splice(u.indexOf(n), 1), _$l && _$l.call(n);
                };
            }), n.children;
        }
    };
    return u.Provider.__ = u.Consumer.contextType = u;
}
$d507971d2dea7d86$var$n = $d507971d2dea7d86$var$s.slice, $d507971d2dea7d86$export$41c562ebe57d11e2 = {
    __e: function __e(n, l, u, i) {
        for(var t, r, o; l = l.__;)if ((t = l.__c) && !t.__) try {
            if ((r = t.constructor) && null != r.getDerivedStateFromError && (t.setState(r.getDerivedStateFromError(n)), o = t.__d), null != t.componentDidCatch && (t.componentDidCatch(n, i || {}), o = t.__d), o) return t.__E = t;
        } catch (l) {
            n = l;
        }
        throw n;
    }
}, $d507971d2dea7d86$var$u = 0, $d507971d2dea7d86$export$a8257692ac88316c = function i(n) {
    return null != n && void 0 === n.constructor;
}, $d507971d2dea7d86$var$t = !1, $d507971d2dea7d86$export$16fa2f45be04daa8.prototype.setState = function(n, l) {
    var u;
    u = null != this.__s && this.__s !== this.state ? this.__s : this.__s = $d507971d2dea7d86$var$h({}, this.state), "function" == typeof n && (n = n($d507971d2dea7d86$var$h({}, u), this.props)), n && $d507971d2dea7d86$var$h(u, n), null != n && this.__v && (l && this._sb.push(l), $d507971d2dea7d86$var$T(this));
}, $d507971d2dea7d86$export$16fa2f45be04daa8.prototype.forceUpdate = function(n) {
    this.__v && (this.__e = !0, n && this.__h.push(n), $d507971d2dea7d86$var$T(this));
}, $d507971d2dea7d86$export$16fa2f45be04daa8.prototype.render = $d507971d2dea7d86$export$ffb0004e005737fa, $d507971d2dea7d86$var$r = [], $d507971d2dea7d86$var$f = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, $d507971d2dea7d86$var$$.__r = 0, $d507971d2dea7d86$var$e = 0;

});

parcelRegister("7hN3J", function(module, exports) {

$parcel$export(module.exports, "createPortal", function () { return $54e02d17dfd31132$export$d39a5bbd09211389; });

var $jzTO1 = parcelRequire("jzTO1");

var $ihX0O = parcelRequire("ihX0O");

var $a1Anb = parcelRequire("a1Anb");
function $54e02d17dfd31132$var$g(n, t) {
    for(var _$e in t)n[_$e] = t[_$e];
    return n;
}
function $54e02d17dfd31132$var$C(n, t) {
    for(var _$e in n)if ("__source" !== _$e && !(_$e in t)) return !0;
    for(var _$r in t)if ("__source" !== _$r && n[_$r] !== t[_$r]) return !0;
    return !1;
}
function $54e02d17dfd31132$var$E(n, t) {
    return n === t && (0 !== n || 1 / n == 1 / t) || n != n && t != t;
}
function $54e02d17dfd31132$export$221d75b3f55bb0bd(n) {
    this.props = n;
}
function $54e02d17dfd31132$export$7c73462e0d25e514(n, e) {
    function r(n) {
        var _$t = this.props.ref, _$r = _$t == n.ref;
        return !_$r && _$t && (_$t.call ? _$t(null) : _$t.current = null), e ? !e(this.props, n) || !_$r : $54e02d17dfd31132$var$C(this.props, n);
    }
    function u(e) {
        return this.shouldComponentUpdate = r, (0, $ihX0O.createElement)(n, e);
    }
    return u.displayName = "Memo(" + (n.displayName || n.name) + ")", u.prototype.isReactComponent = !0, u.__f = !0, u;
}
($54e02d17dfd31132$export$221d75b3f55bb0bd.prototype = new (0, $ihX0O.Component)).isPureReactComponent = !0, $54e02d17dfd31132$export$221d75b3f55bb0bd.prototype.shouldComponentUpdate = function(n, t) {
    return $54e02d17dfd31132$var$C(this.props, n) || $54e02d17dfd31132$var$C(this.state, t);
};
var $54e02d17dfd31132$var$x = (0, $ihX0O.options).__b;
(0, $ihX0O.options).__b = function(n) {
    n.type && n.type.__f && n.ref && (n.props.ref = n.ref, n.ref = null), $54e02d17dfd31132$var$x && $54e02d17dfd31132$var$x(n);
};
var $54e02d17dfd31132$var$N = "undefined" != typeof Symbol && Symbol.for && Symbol.for("react.forward_ref") || 3911;
function $54e02d17dfd31132$export$257a8862b851cb5b(n) {
    function t(t) {
        var _$e = $54e02d17dfd31132$var$g({}, t);
        return delete _$e.ref, n(_$e, t.ref || null);
    }
    return t.$$typeof = $54e02d17dfd31132$var$N, t.render = t, t.prototype.isReactComponent = t.__f = !0, t.displayName = "ForwardRef(" + (n.displayName || n.name) + ")", t;
}
var $54e02d17dfd31132$var$A = function A(n, t) {
    return null == n ? null : (0, $ihX0O.toChildArray)((0, $ihX0O.toChildArray)(n).map(t));
}, $54e02d17dfd31132$export$dca3b0875bd9a954 = {
    map: $54e02d17dfd31132$var$A,
    forEach: $54e02d17dfd31132$var$A,
    count: function count(n) {
        return n ? (0, $ihX0O.toChildArray)(n).length : 0;
    },
    only: function only(n) {
        var _$t = (0, $ihX0O.toChildArray)(n);
        if (1 !== _$t.length) throw "Children.only";
        return _$t[0];
    },
    toArray: (0, $ihX0O.toChildArray)
}, $54e02d17dfd31132$var$T = (0, $ihX0O.options).__e;
(0, $ihX0O.options).__e = function(n, t, e, r) {
    if (n.then) {
        for(var _$u, o = t; o = o.__;)if ((_$u = o.__c) && _$u.__c) return null == t.__e && (t.__e = e.__e, t.__k = e.__k), _$u.__c(n, t);
    }
    $54e02d17dfd31132$var$T(n, t, e, r);
};
var $54e02d17dfd31132$var$I = (0, $ihX0O.options).unmount;
function $54e02d17dfd31132$var$L(n, t, e) {
    return n && (n.__c && n.__c.__H && (n.__c.__H.__.forEach(function(n) {
        "function" == typeof n.__c && n.__c();
    }), n.__c.__H = null), null != (n = $54e02d17dfd31132$var$g({}, n)).__c && (n.__c.__P === e && (n.__c.__P = t), n.__c = null), n.__k = n.__k && n.__k.map(function(n) {
        return $54e02d17dfd31132$var$L(n, t, e);
    })), n;
}
function $54e02d17dfd31132$var$U(n, t, e) {
    return n && (n.__v = null, n.__k = n.__k && n.__k.map(function(n) {
        return $54e02d17dfd31132$var$U(n, t, e);
    }), n.__c && n.__c.__P === t && (n.__e && e.insertBefore(n.__e, n.__d), n.__c.__e = !0, n.__c.__P = e)), n;
}
function $54e02d17dfd31132$export$74bf444e3cd11ea5() {
    this.__u = 0, this.t = null, this.__b = null;
}
function $54e02d17dfd31132$var$F(n) {
    var _$t = n.__.__c;
    return _$t && _$t.__a && _$t.__a(n);
}
function $54e02d17dfd31132$export$488013bae63b21da(n) {
    var _$e, _$r, _$u;
    function o(o) {
        if (_$e || (_$e = n()).then(function(n) {
            _$r = n.default || n;
        }, function(n) {
            _$u = n;
        }), _$u) throw _$u;
        if (!_$r) throw _$e;
        return (0, $ihX0O.createElement)(_$r, o);
    }
    return o.displayName = "Lazy", o.__f = !0, o;
}
function $54e02d17dfd31132$export$998bcd577473dd93() {
    this.u = null, this.o = null;
}
(0, $ihX0O.options).unmount = function(n) {
    var _$t = n.__c;
    _$t && _$t.__R && _$t.__R(), _$t && !0 === n.__h && (n.type = null), $54e02d17dfd31132$var$I && $54e02d17dfd31132$var$I(n);
}, ($54e02d17dfd31132$export$74bf444e3cd11ea5.prototype = new (0, $ihX0O.Component)).__c = function(n, t) {
    var _$e = t.__c, _$r = this;
    null == _$r.t && (_$r.t = []), _$r.t.push(_$e);
    var _$u = $54e02d17dfd31132$var$F(_$r.__v), o = !1, i = function i() {
        o || (o = !0, _$e.__R = null, _$u ? _$u(_$l) : _$l());
    };
    _$e.__R = i;
    var _$l = function l() {
        if (!--_$r.__u) {
            if (_$r.state.__a) {
                var _$n = _$r.state.__a;
                _$r.__v.__k[0] = $54e02d17dfd31132$var$U(_$n, _$n.__c.__P, _$n.__c.__O);
            }
            var _$t;
            for(_$r.setState({
                __a: _$r.__b = null
            }); _$t = _$r.t.pop();)_$t.forceUpdate();
        }
    }, _$c = !0 === t.__h;
    _$r.__u++ || _$c || _$r.setState({
        __a: _$r.__b = _$r.__v.__k[0]
    }), n.then(i, i);
}, $54e02d17dfd31132$export$74bf444e3cd11ea5.prototype.componentWillUnmount = function() {
    this.t = [];
}, $54e02d17dfd31132$export$74bf444e3cd11ea5.prototype.render = function(n, e) {
    if (this.__b) {
        if (this.__v.__k) {
            var _$r = document.createElement("div"), o = this.__v.__k[0].__c;
            this.__v.__k[0] = $54e02d17dfd31132$var$L(this.__b, _$r, o.__O = o.__P);
        }
        this.__b = null;
    }
    var i = e.__a && (0, $ihX0O.createElement)((0, $ihX0O.Fragment), null, n.fallback);
    return i && (i.__h = null), [
        (0, $ihX0O.createElement)((0, $ihX0O.Fragment), null, e.__a ? null : n.children),
        i
    ];
};
var $54e02d17dfd31132$var$W = function W(n, t, e) {
    if (++e[1] === e[0] && n.o.delete(t), n.props.revealOrder && ("t" !== n.props.revealOrder[0] || !n.o.size)) for(e = n.u; e;){
        for(; e.length > 3;)e.pop()();
        if (e[1] < e[0]) break;
        n.u = e = e[2];
    }
};
function $54e02d17dfd31132$var$P(n) {
    return this.getChildContext = function() {
        return n.context;
    }, n.children;
}
function $54e02d17dfd31132$var$$(n) {
    var _$e = this, _$r = n.i;
    _$e.componentWillUnmount = function() {
        (0, $ihX0O.render)(null, _$e.l), _$e.l = null, _$e.i = null;
    }, _$e.i && _$e.i !== _$r && _$e.componentWillUnmount(), n.__v ? (_$e.l || (_$e.i = _$r, _$e.l = {
        nodeType: 1,
        parentNode: _$r,
        childNodes: [],
        appendChild: function appendChild(n) {
            this.childNodes.push(n), _$e.i.appendChild(n);
        },
        insertBefore: function insertBefore(n, t) {
            this.childNodes.push(n), _$e.i.appendChild(n);
        },
        removeChild: function removeChild(n) {
            this.childNodes.splice(this.childNodes.indexOf(n) >>> 1, 1), _$e.i.removeChild(n);
        }
    }), (0, $ihX0O.render)((0, $ihX0O.createElement)($54e02d17dfd31132$var$P, {
        context: _$e.context
    }, n.__v), _$e.l)) : _$e.l && _$e.componentWillUnmount();
}
function $54e02d17dfd31132$export$d39a5bbd09211389(n, e) {
    var _$r = (0, $ihX0O.createElement)($54e02d17dfd31132$var$$, {
        __v: n,
        i: e
    });
    return _$r.containerInfo = e, _$r;
}
($54e02d17dfd31132$export$998bcd577473dd93.prototype = new (0, $ihX0O.Component)).__a = function(n) {
    var _$t = this, _$e = $54e02d17dfd31132$var$F(_$t.__v), _$r = _$t.o.get(n);
    return _$r[0]++, function(u) {
        var o = function o() {
            _$t.props.revealOrder ? (_$r.push(u), $54e02d17dfd31132$var$W(_$t, n, _$r)) : u();
        };
        _$e ? _$e(o) : o();
    };
}, $54e02d17dfd31132$export$998bcd577473dd93.prototype.render = function(n) {
    this.u = null, this.o = new Map;
    var _$t = (0, $ihX0O.toChildArray)(n.children);
    n.revealOrder && "b" === n.revealOrder[0] && _$t.reverse();
    for(var _$e = _$t.length; _$e--;)this.o.set(_$t[_$e], this.u = [
        1,
        0,
        this.u
    ]);
    return n.children;
}, $54e02d17dfd31132$export$998bcd577473dd93.prototype.componentDidUpdate = $54e02d17dfd31132$export$998bcd577473dd93.prototype.componentDidMount = function() {
    var _$n = this;
    this.o.forEach(function(t, e) {
        $54e02d17dfd31132$var$W(_$n, e, t);
    });
};
var $54e02d17dfd31132$var$z = "undefined" != typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103, $54e02d17dfd31132$var$B = /^(?:accent|alignment|arabic|baseline|cap|clip(?!PathU)|color|dominant|fill|flood|font|glyph(?!R)|horiz|image|letter|lighting|marker(?!H|W|U)|overline|paint|pointer|shape|stop|strikethrough|stroke|text(?!L)|transform|underline|unicode|units|v|vector|vert|word|writing|x(?!C))[A-Z]/, $54e02d17dfd31132$var$H = "undefined" != typeof document, $54e02d17dfd31132$var$Z = function Z(n) {
    return ("undefined" != typeof Symbol && "symbol" == (0, $jzTO1._)(Symbol()) ? /fil|che|rad/i : /fil|che|ra/i).test(n);
};
function $54e02d17dfd31132$export$b3890eb0ae9dca99(n, t, e) {
    return null == t.__k && (t.textContent = ""), (0, $ihX0O.render)(n, t), "function" == typeof e && e(), n ? n.__c : null;
}
function $54e02d17dfd31132$export$fa8d919ba61d84db(n, t, e) {
    return (0, $ihX0O.hydrate)(n, t), "function" == typeof e && e(), n ? n.__c : null;
}
(0, $ihX0O.Component).prototype.isReactComponent = {}, [
    "componentWillMount",
    "componentWillReceiveProps",
    "componentWillUpdate"
].forEach(function(t) {
    Object.defineProperty((0, $ihX0O.Component).prototype, t, {
        configurable: !0,
        get: function get() {
            return this["UNSAFE_" + t];
        },
        set: function set(n) {
            Object.defineProperty(this, t, {
                configurable: !0,
                writable: !0,
                value: n
            });
        }
    });
});
var $54e02d17dfd31132$var$G = (0, $ihX0O.options).event;
function $54e02d17dfd31132$var$J() {}
function $54e02d17dfd31132$var$K() {
    return this.cancelBubble;
}
function $54e02d17dfd31132$var$Q() {
    return this.defaultPrevented;
}
(0, $ihX0O.options).event = function(n) {
    return $54e02d17dfd31132$var$G && (n = $54e02d17dfd31132$var$G(n)), n.persist = $54e02d17dfd31132$var$J, n.isPropagationStopped = $54e02d17dfd31132$var$K, n.isDefaultPrevented = $54e02d17dfd31132$var$Q, n.nativeEvent = n;
};
var $54e02d17dfd31132$var$X, $54e02d17dfd31132$var$nn = {
    configurable: !0,
    get: function get() {
        return this.class;
    }
}, $54e02d17dfd31132$var$tn = (0, $ihX0O.options).vnode;
(0, $ihX0O.options).vnode = function(n) {
    var _$t = n.type, _$e = n.props, _$u = _$e;
    if ("string" == typeof _$t) {
        var o = -1 === _$t.indexOf("-");
        for(var i in _$u = {}, _$e){
            var _$l = _$e[i];
            $54e02d17dfd31132$var$H && "children" === i && "noscript" === _$t || "value" === i && "defaultValue" in _$e && null == _$l || ("defaultValue" === i && "value" in _$e && null == _$e.value ? i = "value" : "download" === i && !0 === _$l ? _$l = "" : /ondoubleclick/i.test(i) ? i = "ondblclick" : /^onchange(textarea|input)/i.test(i + _$t) && !$54e02d17dfd31132$var$Z(_$e.type) ? i = "oninput" : /^onfocus$/i.test(i) ? i = "onfocusin" : /^onblur$/i.test(i) ? i = "onfocusout" : /^on(Ani|Tra|Tou|BeforeInp|Compo)/.test(i) ? i = i.toLowerCase() : o && $54e02d17dfd31132$var$B.test(i) ? i = i.replace(/[A-Z0-9]/g, "-$&").toLowerCase() : null === _$l && (_$l = void 0), /^oninput$/i.test(i) && (i = i.toLowerCase(), _$u[i] && (i = "oninputCapture")), _$u[i] = _$l);
        }
        "select" == _$t && _$u.multiple && Array.isArray(_$u.value) && (_$u.value = (0, $ihX0O.toChildArray)(_$e.children).forEach(function(n) {
            n.props.selected = -1 != _$u.value.indexOf(n.props.value);
        })), "select" == _$t && null != _$u.defaultValue && (_$u.value = (0, $ihX0O.toChildArray)(_$e.children).forEach(function(n) {
            n.props.selected = _$u.multiple ? -1 != _$u.defaultValue.indexOf(n.props.value) : _$u.defaultValue == n.props.value;
        })), n.props = _$u, _$e.class != _$e.className && ($54e02d17dfd31132$var$nn.enumerable = "className" in _$e, null != _$e.className && (_$u.class = _$e.className), Object.defineProperty(_$u, "className", $54e02d17dfd31132$var$nn));
    }
    n.$$typeof = $54e02d17dfd31132$var$z, $54e02d17dfd31132$var$tn && $54e02d17dfd31132$var$tn(n);
};
var $54e02d17dfd31132$var$en = (0, $ihX0O.options).__r;
(0, $ihX0O.options).__r = function(n) {
    $54e02d17dfd31132$var$en && $54e02d17dfd31132$var$en(n), $54e02d17dfd31132$var$X = n.__c;
};
var $54e02d17dfd31132$export$ae55be85d98224ed = {
    ReactCurrentDispatcher: {
        current: {
            readContext: function readContext(n) {
                return $54e02d17dfd31132$var$X.__n[n.__c].props.value;
            }
        }
    }
}, $54e02d17dfd31132$export$83d89fbfd8236492 = "17.0.2";
function $54e02d17dfd31132$export$d38cd72104c1f0e9(n) {
    return (0, $ihX0O.createElement).bind(null, n);
}
function $54e02d17dfd31132$export$a8257692ac88316c(n) {
    return !!n && n.$$typeof === $54e02d17dfd31132$var$z;
}
function $54e02d17dfd31132$export$e530037191fcd5d7(n) {
    return $54e02d17dfd31132$export$a8257692ac88316c(n) ? (0, $ihX0O.cloneElement).apply(null, arguments) : n;
}
function $54e02d17dfd31132$export$502457920280e6be(n) {
    return !!n.__k && ((0, $ihX0O.render)(null, n), !0);
}
function $54e02d17dfd31132$export$466bfc07425424d5(n) {
    return n && (n.base || 1 === n.nodeType && n) || null;
}
var $54e02d17dfd31132$export$c78a37762a8d58e1 = function sn(n, t) {
    return n(t);
}, $54e02d17dfd31132$export$cd75ccfd720a3cd4 = function hn(n, t) {
    return n(t);
}, $54e02d17dfd31132$export$5f8d39834fd61797 = (0, $ihX0O.Fragment);
function $54e02d17dfd31132$export$7568632d0d33d16d(n) {
    n();
}
function $54e02d17dfd31132$export$6a7bc4e911dc01cf(n) {
    return n;
}
function $54e02d17dfd31132$export$7b286972b8d8ccbf() {
    return [
        !1,
        $54e02d17dfd31132$export$7568632d0d33d16d
    ];
}
var $54e02d17dfd31132$export$aaabe4eda9ed9969 = (0, $a1Anb.useLayoutEffect);
function $54e02d17dfd31132$export$306c0aa65ff9ec16(n, t) {
    var _$e = t(), _$r = (0, $a1Anb.useState)({
        h: {
            __: _$e,
            v: t
        }
    }), _$u = _$r[0].h, o = _$r[1];
    return (0, $a1Anb.useLayoutEffect)(function() {
        _$u.__ = _$e, _$u.v = t, $54e02d17dfd31132$var$E(_$u.__, t()) || o({
            h: _$u
        });
    }, [
        n,
        _$e,
        t
    ]), (0, $a1Anb.useEffect)(function() {
        return $54e02d17dfd31132$var$E(_$u.__, _$u.v()) || o({
            h: _$u
        }), n(function() {
            $54e02d17dfd31132$var$E(_$u.__, _$u.v()) || o({
                h: _$u
            });
        });
    }, [
        n
    ]), _$e;
}
var $54e02d17dfd31132$export$2e2bcd8739ae039 = {
    useState: (0, $a1Anb.useState),
    useId: (0, $a1Anb.useId),
    useReducer: (0, $a1Anb.useReducer),
    useEffect: (0, $a1Anb.useEffect),
    useLayoutEffect: (0, $a1Anb.useLayoutEffect),
    useInsertionEffect: $54e02d17dfd31132$export$aaabe4eda9ed9969,
    useTransition: $54e02d17dfd31132$export$7b286972b8d8ccbf,
    useDeferredValue: $54e02d17dfd31132$export$6a7bc4e911dc01cf,
    useSyncExternalStore: $54e02d17dfd31132$export$306c0aa65ff9ec16,
    startTransition: $54e02d17dfd31132$export$7568632d0d33d16d,
    useRef: (0, $a1Anb.useRef),
    useImperativeHandle: (0, $a1Anb.useImperativeHandle),
    useMemo: (0, $a1Anb.useMemo),
    useCallback: (0, $a1Anb.useCallback),
    useContext: (0, $a1Anb.useContext),
    useDebugValue: (0, $a1Anb.useDebugValue),
    version: "17.0.2",
    Children: $54e02d17dfd31132$export$dca3b0875bd9a954,
    render: $54e02d17dfd31132$export$b3890eb0ae9dca99,
    hydrate: $54e02d17dfd31132$export$fa8d919ba61d84db,
    unmountComponentAtNode: $54e02d17dfd31132$export$502457920280e6be,
    createPortal: $54e02d17dfd31132$export$d39a5bbd09211389,
    createElement: (0, $ihX0O.createElement),
    createContext: (0, $ihX0O.createContext),
    createFactory: $54e02d17dfd31132$export$d38cd72104c1f0e9,
    cloneElement: $54e02d17dfd31132$export$e530037191fcd5d7,
    createRef: (0, $ihX0O.createRef),
    Fragment: (0, $ihX0O.Fragment),
    isValidElement: $54e02d17dfd31132$export$a8257692ac88316c,
    findDOMNode: $54e02d17dfd31132$export$466bfc07425424d5,
    Component: (0, $ihX0O.Component),
    PureComponent: $54e02d17dfd31132$export$221d75b3f55bb0bd,
    memo: $54e02d17dfd31132$export$7c73462e0d25e514,
    forwardRef: $54e02d17dfd31132$export$257a8862b851cb5b,
    flushSync: $54e02d17dfd31132$export$cd75ccfd720a3cd4,
    unstable_batchedUpdates: $54e02d17dfd31132$export$c78a37762a8d58e1,
    StrictMode: $54e02d17dfd31132$export$5f8d39834fd61797,
    Suspense: $54e02d17dfd31132$export$74bf444e3cd11ea5,
    SuspenseList: $54e02d17dfd31132$export$998bcd577473dd93,
    lazy: $54e02d17dfd31132$export$488013bae63b21da,
    __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: $54e02d17dfd31132$export$ae55be85d98224ed
};

});
parcelRegister("a1Anb", function(module, exports) {

$parcel$export(module.exports, "useState", function () { return $74c6364e05587f20$export$60241385465d0a34; });
$parcel$export(module.exports, "useReducer", function () { return $74c6364e05587f20$export$13e3392192263954; });
$parcel$export(module.exports, "useEffect", function () { return $74c6364e05587f20$export$6d9c69b0de29b591; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $74c6364e05587f20$export$e5c5a5f917a5871c; });
$parcel$export(module.exports, "useRef", function () { return $74c6364e05587f20$export$b8f5890fc79d6aca; });
$parcel$export(module.exports, "useMemo", function () { return $74c6364e05587f20$export$1538c33de8887b59; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $74c6364e05587f20$export$d5a552a76deda3c2; });
$parcel$export(module.exports, "useCallback", function () { return $74c6364e05587f20$export$35808ee640e87ca7; });
$parcel$export(module.exports, "useContext", function () { return $74c6364e05587f20$export$fae74005e78b1a27; });
$parcel$export(module.exports, "useDebugValue", function () { return $74c6364e05587f20$export$dc8fbce3eb94dc1e; });
$parcel$export(module.exports, "useId", function () { return $74c6364e05587f20$export$f680877a34711e37; });

var $ihX0O = parcelRequire("ihX0O");
var $74c6364e05587f20$var$t, $74c6364e05587f20$var$r, $74c6364e05587f20$var$u, $74c6364e05587f20$var$i, $74c6364e05587f20$var$o = 0, $74c6364e05587f20$var$f = [], $74c6364e05587f20$var$c = [], $74c6364e05587f20$var$e = (0, $ihX0O.options).__b, $74c6364e05587f20$var$a = (0, $ihX0O.options).__r, $74c6364e05587f20$var$v = (0, $ihX0O.options).diffed, $74c6364e05587f20$var$l = (0, $ihX0O.options).__c, $74c6364e05587f20$var$m = (0, $ihX0O.options).unmount;
function $74c6364e05587f20$var$d(t, u) {
    (0, $ihX0O.options).__h && (0, $ihX0O.options).__h($74c6364e05587f20$var$r, t, $74c6364e05587f20$var$o || u), $74c6364e05587f20$var$o = 0;
    var i = $74c6364e05587f20$var$r.__H || ($74c6364e05587f20$var$r.__H = {
        __: [],
        __h: []
    });
    return t >= i.__.length && i.__.push({
        __V: $74c6364e05587f20$var$c
    }), i.__[t];
}
function $74c6364e05587f20$export$60241385465d0a34(n) {
    return $74c6364e05587f20$var$o = 1, $74c6364e05587f20$export$13e3392192263954($74c6364e05587f20$var$B, n);
}
function $74c6364e05587f20$export$13e3392192263954(n, u, i) {
    var o = $74c6364e05587f20$var$d($74c6364e05587f20$var$t++, 2);
    if (o.t = n, !o.__c && (o.__ = [
        i ? i(u) : $74c6364e05587f20$var$B(void 0, u),
        function(n) {
            var t = o.__N ? o.__N[0] : o.__[0], r = o.t(t, n);
            t !== r && (o.__N = [
                r,
                o.__[1]
            ], o.__c.setState({}));
        }
    ], o.__c = $74c6364e05587f20$var$r, !$74c6364e05587f20$var$r.u)) {
        $74c6364e05587f20$var$r.u = !0;
        var f = $74c6364e05587f20$var$r.shouldComponentUpdate;
        $74c6364e05587f20$var$r.shouldComponentUpdate = function(n, t, r) {
            if (!o.__c.__H) return !0;
            var _$u = o.__c.__H.__.filter(function(n) {
                return n.__c;
            });
            if (_$u.every(function(n) {
                return !n.__N;
            })) return !f || f.call(this, n, t, r);
            var _$i = !1;
            return _$u.forEach(function(n) {
                if (n.__N) {
                    var _$t = n.__[0];
                    n.__ = n.__N, n.__N = void 0, _$t !== n.__[0] && (_$i = !0);
                }
            }), !(!_$i && o.__c.props === n) && (!f || f.call(this, n, t, r));
        };
    }
    return o.__N || o.__;
}
function $74c6364e05587f20$export$6d9c69b0de29b591(u, i) {
    var o = $74c6364e05587f20$var$d($74c6364e05587f20$var$t++, 3);
    !(0, $ihX0O.options).__s && $74c6364e05587f20$var$z(o.__H, i) && (o.__ = u, o.i = i, $74c6364e05587f20$var$r.__H.__h.push(o));
}
function $74c6364e05587f20$export$e5c5a5f917a5871c(u, i) {
    var o = $74c6364e05587f20$var$d($74c6364e05587f20$var$t++, 4);
    !(0, $ihX0O.options).__s && $74c6364e05587f20$var$z(o.__H, i) && (o.__ = u, o.i = i, $74c6364e05587f20$var$r.__h.push(o));
}
function $74c6364e05587f20$export$b8f5890fc79d6aca(n) {
    return $74c6364e05587f20$var$o = 5, $74c6364e05587f20$export$1538c33de8887b59(function() {
        return {
            current: n
        };
    }, []);
}
function $74c6364e05587f20$export$d5a552a76deda3c2(n, t, r) {
    $74c6364e05587f20$var$o = 6, $74c6364e05587f20$export$e5c5a5f917a5871c(function() {
        return "function" == typeof n ? (n(t()), function() {
            return n(null);
        }) : n ? (n.current = t(), function() {
            return n.current = null;
        }) : void 0;
    }, null == r ? r : r.concat(n));
}
function $74c6364e05587f20$export$1538c33de8887b59(n, r) {
    var u = $74c6364e05587f20$var$d($74c6364e05587f20$var$t++, 7);
    return $74c6364e05587f20$var$z(u.__H, r) ? (u.__V = n(), u.i = r, u.__h = n, u.__V) : u.__;
}
function $74c6364e05587f20$export$35808ee640e87ca7(n, t) {
    return $74c6364e05587f20$var$o = 8, $74c6364e05587f20$export$1538c33de8887b59(function() {
        return n;
    }, t);
}
function $74c6364e05587f20$export$fae74005e78b1a27(n) {
    var u = $74c6364e05587f20$var$r.context[n.__c], i = $74c6364e05587f20$var$d($74c6364e05587f20$var$t++, 9);
    return i.c = n, u ? (null == i.__ && (i.__ = !0, u.sub($74c6364e05587f20$var$r)), u.props.value) : n.__;
}
function $74c6364e05587f20$export$dc8fbce3eb94dc1e(t, r) {
    (0, $ihX0O.options).useDebugValue && (0, $ihX0O.options).useDebugValue(r ? r(t) : t);
}
function $74c6364e05587f20$export$c052f6604b7d51fe(n) {
    var u = $74c6364e05587f20$var$d($74c6364e05587f20$var$t++, 10), i = $74c6364e05587f20$export$60241385465d0a34();
    return u.__ = n, $74c6364e05587f20$var$r.componentDidCatch || ($74c6364e05587f20$var$r.componentDidCatch = function(n, t) {
        u.__ && u.__(n, t), i[1](n);
    }), [
        i[0],
        function() {
            i[1](void 0);
        }
    ];
}
function $74c6364e05587f20$export$f680877a34711e37() {
    var _$n = $74c6364e05587f20$var$d($74c6364e05587f20$var$t++, 11);
    if (!_$n.__) {
        for(var u = $74c6364e05587f20$var$r.__v; null !== u && !u.__m && null !== u.__;)u = u.__;
        var i = u.__m || (u.__m = [
            0,
            0
        ]);
        _$n.__ = "P" + i[0] + "-" + i[1]++;
    }
    return _$n.__;
}
function $74c6364e05587f20$var$b() {
    for(var t; t = $74c6364e05587f20$var$f.shift();)if (t.__P && t.__H) try {
        t.__H.__h.forEach($74c6364e05587f20$var$k), t.__H.__h.forEach($74c6364e05587f20$var$w), t.__H.__h = [];
    } catch (r) {
        t.__H.__h = [], (0, $ihX0O.options).__e(r, t.__v);
    }
}
(0, $ihX0O.options).__b = function(n) {
    $74c6364e05587f20$var$r = null, $74c6364e05587f20$var$e && $74c6364e05587f20$var$e(n);
}, (0, $ihX0O.options).__r = function(n) {
    $74c6364e05587f20$var$a && $74c6364e05587f20$var$a(n), $74c6364e05587f20$var$t = 0;
    var i = ($74c6364e05587f20$var$r = n.__c).__H;
    i && ($74c6364e05587f20$var$u === $74c6364e05587f20$var$r ? (i.__h = [], $74c6364e05587f20$var$r.__h = [], i.__.forEach(function(n) {
        n.__N && (n.__ = n.__N), n.__V = $74c6364e05587f20$var$c, n.__N = n.i = void 0;
    })) : (i.__h.forEach($74c6364e05587f20$var$k), i.__h.forEach($74c6364e05587f20$var$w), i.__h = [])), $74c6364e05587f20$var$u = $74c6364e05587f20$var$r;
}, (0, $ihX0O.options).diffed = function(t) {
    $74c6364e05587f20$var$v && $74c6364e05587f20$var$v(t);
    var o = t.__c;
    o && o.__H && (o.__H.__h.length && (1 !== $74c6364e05587f20$var$f.push(o) && $74c6364e05587f20$var$i === (0, $ihX0O.options).requestAnimationFrame || (($74c6364e05587f20$var$i = (0, $ihX0O.options).requestAnimationFrame) || $74c6364e05587f20$var$j)($74c6364e05587f20$var$b)), o.__H.__.forEach(function(n) {
        n.i && (n.__H = n.i), n.__V !== $74c6364e05587f20$var$c && (n.__ = n.__V), n.i = void 0, n.__V = $74c6364e05587f20$var$c;
    })), $74c6364e05587f20$var$u = $74c6364e05587f20$var$r = null;
}, (0, $ihX0O.options).__c = function(t, r) {
    r.some(function(t) {
        try {
            t.__h.forEach($74c6364e05587f20$var$k), t.__h = t.__h.filter(function(n) {
                return !n.__ || $74c6364e05587f20$var$w(n);
            });
        } catch (u) {
            r.some(function(n) {
                n.__h && (n.__h = []);
            }), r = [], (0, $ihX0O.options).__e(u, t.__v);
        }
    }), $74c6364e05587f20$var$l && $74c6364e05587f20$var$l(t, r);
}, (0, $ihX0O.options).unmount = function(t) {
    $74c6364e05587f20$var$m && $74c6364e05587f20$var$m(t);
    var r, u = t.__c;
    u && u.__H && (u.__H.__.forEach(function(n) {
        try {
            $74c6364e05587f20$var$k(n);
        } catch (n) {
            r = n;
        }
    }), u.__H = void 0, r && (0, $ihX0O.options).__e(r, u.__v));
};
var $74c6364e05587f20$var$g = "function" == typeof requestAnimationFrame;
function $74c6364e05587f20$var$j(n) {
    var t, r = function r() {
        clearTimeout(u), $74c6364e05587f20$var$g && cancelAnimationFrame(t), setTimeout(n);
    }, u = setTimeout(r, 100);
    $74c6364e05587f20$var$g && (t = requestAnimationFrame(r));
}
function $74c6364e05587f20$var$k(n) {
    var t = $74c6364e05587f20$var$r, u = n.__c;
    "function" == typeof u && (n.__c = void 0, u()), $74c6364e05587f20$var$r = t;
}
function $74c6364e05587f20$var$w(n) {
    var t = $74c6364e05587f20$var$r;
    n.__c = n.__(), $74c6364e05587f20$var$r = t;
}
function $74c6364e05587f20$var$z(n, t) {
    return !n || n.length !== t.length || t.some(function(t, r) {
        return t !== n[r];
    });
}
function $74c6364e05587f20$var$B(n, t) {
    return "function" == typeof t ? t(n) : t;
}

});




var $623458eab3ed86c4$exports = {};


(parcelRequire("fYuER")).register((parcelRequire("3uQPI")).getBundleURL("5RKGD"), JSON.parse('["5RKGD","index.js","bKQbr","bg-modal.2ae1f3e6.svg","g7eBC","index.css"]'));

var $f1e4b09a23995638$export$2e2bcd8739ae039 = {
    data: function() {
        return {
            optionsPadronizadas: [
                {
                    label: "Todos",
                    value: "",
                    id: 0
                },
                {
                    label: "A\xe7\xf5es",
                    value: "A\xe7\xf5es",
                    id: 1
                },
                {
                    label: "FIIs",
                    value: "FII - Fundo de Investimento Imobili\xe1rio",
                    id: 2
                },
                {
                    label: "Stocks",
                    value: "Stock",
                    id: 3
                },
                {
                    label: "REIT",
                    value: "REIT",
                    id: 4
                },
                {
                    label: "ETFs",
                    value: "ETF - Exchange Traded Fund",
                    id: 5
                },
                {
                    label: "Renda fixa",
                    value: "TesouroDireto",
                    id: 6
                }
            ],
            isMobile: false,
            tipo_ativo: "",
            baseURL: window.location.origin,
            GLOBAL: GLOBAL
        };
    },
    mounted: function() {
        this.setInitialValueOnSelectFromURL();
        // Verificando se a tela é móvel no momento do carregamento
        this.checkIfMobile();
        // Adicionando um listener para verificar quando a janela for redimensionada
        window.addEventListener("resize", this.checkIfMobile);
    },
    beforeDestroy: function() {
        // Certifique-se de remover o listener quando o componente for destruído
        window.removeEventListener("resize", this.checkIfMobile);
    },
    methods: {
        setInitialValueOnSelectFromURL: function() {
            var urlParams = new URLSearchParams(window.location.search);
            var tipoURL = urlParams.get("tipos_investimento");
            this.tipo_ativo = tipoURL;
        },
        submitFormOnChange: function(opcaoSelecionada) {
            var form = this.$refs.form_home;
            this.tipo_ativo = opcaoSelecionada.value;
            setTimeout(function() {
                form.submit();
            }, 500);
        },
        checkIfMobile: function() {
            this.isMobile = window.innerWidth < 1180;
        }
    },
    delimiters: [
        "{*",
        "*}"
    ]
};


function $a1727a7253abe12d$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $a1727a7253abe12d$export$7c398597f8905a1(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $a1727a7253abe12d$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $a1727a7253abe12d$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}



var $8pZMQ = parcelRequire("8pZMQ");

var $8typN = parcelRequire("8typN");

var $4f96i = parcelRequire("4f96i");

var $79xu7 = parcelRequire("79xu7");
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ 
var $jzTO1 = parcelRequire("jzTO1");
var $877235af7931ac6c$var$extendStatics = function extendStatics1(d, b) {
    $877235af7931ac6c$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $877235af7931ac6c$var$extendStatics(d, b);
};
function $877235af7931ac6c$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $877235af7931ac6c$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $877235af7931ac6c$export$18ce0697a983be9b = function __assign1() {
    $877235af7931ac6c$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $877235af7931ac6c$export$18ce0697a983be9b.apply(this, arguments);
};
function $877235af7931ac6c$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $877235af7931ac6c$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $877235af7931ac6c$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $877235af7931ac6c$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $877235af7931ac6c$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $877235af7931ac6c$export$6a2a36740a146cb8(x) {
    return (typeof x === "undefined" ? "undefined" : (0, $jzTO1._)(x)) === "symbol" ? x : "".concat(x);
}
function $877235af7931ac6c$export$d1a06452d3489bc7(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $jzTO1._)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $877235af7931ac6c$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $877235af7931ac6c$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $877235af7931ac6c$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $877235af7931ac6c$export$45d3717a4c69092e = Object.create ? function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $877235af7931ac6c$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $877235af7931ac6c$export$45d3717a4c69092e(o, m, p);
}
function $877235af7931ac6c$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $877235af7931ac6c$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $877235af7931ac6c$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($877235af7931ac6c$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $877235af7931ac6c$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $877235af7931ac6c$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $877235af7931ac6c$export$10c90e4f7922046c(v) {
    return this instanceof $877235af7931ac6c$export$10c90e4f7922046c ? (this.v = v, this) : new $877235af7931ac6c$export$10c90e4f7922046c(v);
}
function $877235af7931ac6c$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $877235af7931ac6c$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $877235af7931ac6c$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $877235af7931ac6c$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $877235af7931ac6c$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $877235af7931ac6c$export$19a8beecd37a4c45 === "function" ? $877235af7931ac6c$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $877235af7931ac6c$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $877235af7931ac6c$var$__setModuleDefault = Object.create ? function __setModuleDefault(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $877235af7931ac6c$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $877235af7931ac6c$export$45d3717a4c69092e(result, mod, k);
    }
    $877235af7931ac6c$var$__setModuleDefault(result, mod);
    return result;
}
function $877235af7931ac6c$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $877235af7931ac6c$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $877235af7931ac6c$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $877235af7931ac6c$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $877235af7931ac6c$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $877235af7931ac6c$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function _SuppressedError(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $877235af7931ac6c$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $877235af7931ac6c$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $877235af7931ac6c$export$2e2bcd8739ae039 = {
    __extends: $877235af7931ac6c$export$a8ba968b8961cb8a,
    __assign: $877235af7931ac6c$export$18ce0697a983be9b,
    __rest: $877235af7931ac6c$export$3c9a16f847548506,
    __decorate: $877235af7931ac6c$export$29e00dfd3077644b,
    __param: $877235af7931ac6c$export$d5ad3fd78186038f,
    __metadata: $877235af7931ac6c$export$f1db080c865becb9,
    __awaiter: $877235af7931ac6c$export$1050f835b63b671e,
    __generator: $877235af7931ac6c$export$67ebef60e6f28a6,
    __createBinding: $877235af7931ac6c$export$45d3717a4c69092e,
    __exportStar: $877235af7931ac6c$export$f33643c0debef087,
    __values: $877235af7931ac6c$export$19a8beecd37a4c45,
    __read: $877235af7931ac6c$export$8d051b38c9118094,
    __spread: $877235af7931ac6c$export$afc72e2116322959,
    __spreadArrays: $877235af7931ac6c$export$6388937ca91ccae8,
    __spreadArray: $877235af7931ac6c$export$1216008129fb82ed,
    __await: $877235af7931ac6c$export$10c90e4f7922046c,
    __asyncGenerator: $877235af7931ac6c$export$e427f37a30a4de9b,
    __asyncDelegator: $877235af7931ac6c$export$bbd80228419bb833,
    __asyncValues: $877235af7931ac6c$export$e3b29a3d6162315f,
    __makeTemplateObject: $877235af7931ac6c$export$4fb47efe1390b86f,
    __importStar: $877235af7931ac6c$export$c21735bcef00d192,
    __importDefault: $877235af7931ac6c$export$da59b14a69baef04,
    __classPrivateFieldGet: $877235af7931ac6c$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $877235af7931ac6c$export$d40a35129aaff81f,
    __classPrivateFieldIn: $877235af7931ac6c$export$81fdc39f203e4e04,
    __addDisposableResource: $877235af7931ac6c$export$88ac25d8e944e405,
    __disposeResources: $877235af7931ac6c$export$8f076105dc360e92
};


var $6512258bc9c13e32$exports = {};

var $jzTO1 = parcelRequire("jzTO1");
/*!
 * jQuery JavaScript Library v3.7.1
 * https://jquery.com/
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2023-08-28T13:37Z
 */ (function(global, factory) {
    "use strict";
    if (typeof $6512258bc9c13e32$exports === "object") // For CommonJS and CommonJS-like environments where a proper `window`
    // is present, execute the factory and get jQuery.
    // For environments that do not have a `window` with a `document`
    // (such as Node.js), expose a factory as module.exports.
    // This accentuates the need for the creation of a real `window`.
    // e.g. var jQuery = require("jquery")(window);
    // See ticket trac-14549 for more info.
    $6512258bc9c13e32$exports = global.document ? factory(global, true) : function(w) {
        if (!w.document) throw new Error("jQuery requires a window with a document");
        return factory(w);
    };
    else factory(global);
// Pass this if window is not defined yet
})(typeof window !== "undefined" ? window : undefined, function(window1, noGlobal) {
    // Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
    // throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
    // arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
    // enough that all such attempts are guarded in a try block.
    "use strict";
    var arr = [];
    var getProto = Object.getPrototypeOf;
    var slice = arr.slice;
    var flat = arr.flat ? function flat(array) {
        return arr.flat.call(array);
    } : function(array) {
        return arr.concat.apply([], array);
    };
    var push = arr.push;
    var indexOf = arr.indexOf;
    var class2type = {};
    var toString = class2type.toString;
    var hasOwn = class2type.hasOwnProperty;
    var fnToString = hasOwn.toString;
    var ObjectFunctionString = fnToString.call(Object);
    var support = {};
    var isFunction = function isFunction(obj) {
        // Support: Chrome <=57, Firefox <=52
        // In some browsers, typeof returns "function" for HTML <object> elements
        // (i.e., `typeof document.createElement( "object" ) === "function"`).
        // We don't want to classify *any* DOM node as a function.
        // Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
        // Plus for old WebKit, typeof returns "function" for HTML collections
        // (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
        return typeof obj === "function" && typeof obj.nodeType !== "number" && typeof obj.item !== "function";
    };
    var isWindow = function isWindow(obj) {
        return obj != null && obj === obj.window;
    };
    var document = window1.document;
    var preservedScriptAttributes = {
        type: true,
        src: true,
        nonce: true,
        noModule: true
    };
    function DOMEval(code, node, doc) {
        doc = doc || document;
        var i, val, script = doc.createElement("script");
        script.text = code;
        if (node) for(i in preservedScriptAttributes){
            // Support: Firefox 64+, Edge 18+
            // Some browsers don't support the "nonce" property on scripts.
            // On the other hand, just using `getAttribute` is not enough as
            // the `nonce` attribute is reset to an empty string whenever it
            // becomes browsing-context connected.
            // See https://github.com/whatwg/html/issues/2369
            // See https://html.spec.whatwg.org/#nonce-attributes
            // The `node.getAttribute` check was added for the sake of
            // `jQuery.globalEval` so that it can fake a nonce-containing node
            // via an object.
            val = node[i] || node.getAttribute && node.getAttribute(i);
            if (val) script.setAttribute(i, val);
        }
        doc.head.appendChild(script).parentNode.removeChild(script);
    }
    function toType(obj) {
        if (obj == null) return obj + "";
        // Support: Android <=2.3 only (functionish RegExp)
        return typeof obj === "object" || typeof obj === "function" ? class2type[toString.call(obj)] || "object" : typeof obj === "undefined" ? "undefined" : (0, $jzTO1._)(obj);
    }
    /* global Symbol */ // Defining this global in .eslintrc.json would create a danger of using the global
    // unguarded in another place, it seems safer to define global only for this module
    var version = "3.7.1", rhtmlSuffix = /HTML$/i, // Define a local copy of jQuery
    jQuery = function jQuery1(selector, context) {
        // The jQuery object is actually just the init constructor 'enhanced'
        // Need init if jQuery is called (just allow error to be thrown if not included)
        return new jQuery.fn.init(selector, context);
    };
    jQuery.fn = jQuery.prototype = {
        // The current version of jQuery being used
        jquery: version,
        constructor: jQuery,
        // The default length of a jQuery object is 0
        length: 0,
        toArray: function toArray() {
            return slice.call(this);
        },
        // Get the Nth element in the matched element set OR
        // Get the whole matched element set as a clean array
        get: function get(num) {
            // Return all the elements in a clean array
            if (num == null) return slice.call(this);
            // Return just the one element from the set
            return num < 0 ? this[num + this.length] : this[num];
        },
        // Take an array of elements and push it onto the stack
        // (returning the new matched element set)
        pushStack: function pushStack(elems) {
            // Build a new jQuery matched element set
            var ret = jQuery.merge(this.constructor(), elems);
            // Add the old object onto the stack (as a reference)
            ret.prevObject = this;
            // Return the newly-formed element set
            return ret;
        },
        // Execute a callback for every element in the matched set.
        each: function each(callback) {
            return jQuery.each(this, callback);
        },
        map: function map(callback) {
            return this.pushStack(jQuery.map(this, function(elem, i) {
                return callback.call(elem, i, elem);
            }));
        },
        slice: function slice1() {
            return this.pushStack(slice.apply(this, arguments));
        },
        first: function first() {
            return this.eq(0);
        },
        last: function last() {
            return this.eq(-1);
        },
        even: function even() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return (i + 1) % 2;
            }));
        },
        odd: function odd() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return i % 2;
            }));
        },
        eq: function eq(i) {
            var len = this.length, j = +i + (i < 0 ? len : 0);
            return this.pushStack(j >= 0 && j < len ? [
                this[j]
            ] : []);
        },
        end: function end() {
            return this.prevObject || this.constructor();
        },
        // For internal use only.
        // Behaves like an Array's method, not like a jQuery method.
        push: push,
        sort: arr.sort,
        splice: arr.splice
    };
    jQuery.extend = jQuery.fn.extend = function() {
        var options, name, src, copy, copyIsArray, clone, target = arguments[0] || {}, i = 1, length = arguments.length, deep = false;
        // Handle a deep copy situation
        if (typeof target === "boolean") {
            deep = target;
            // Skip the boolean and the target
            target = arguments[i] || {};
            i++;
        }
        // Handle case when target is a string or something (possible in deep copy)
        if (typeof target !== "object" && !isFunction(target)) target = {};
        // Extend jQuery itself if only one argument is passed
        if (i === length) {
            target = this;
            i--;
        }
        for(; i < length; i++){
            // Only deal with non-null/undefined values
            if ((options = arguments[i]) != null) // Extend the base object
            for(name in options){
                copy = options[name];
                // Prevent Object.prototype pollution
                // Prevent never-ending loop
                if (name === "__proto__" || target === copy) continue;
                // Recurse if we're merging plain objects or arrays
                if (deep && copy && (jQuery.isPlainObject(copy) || (copyIsArray = Array.isArray(copy)))) {
                    src = target[name];
                    // Ensure proper type for the source value
                    if (copyIsArray && !Array.isArray(src)) clone = [];
                    else if (!copyIsArray && !jQuery.isPlainObject(src)) clone = {};
                    else clone = src;
                    copyIsArray = false;
                    // Never move original objects, clone them
                    target[name] = jQuery.extend(deep, clone, copy);
                // Don't bring in undefined values
                } else if (copy !== undefined) target[name] = copy;
            }
        }
        // Return the modified object
        return target;
    };
    jQuery.extend({
        // Unique for each copy of jQuery on the page
        expando: "jQuery" + (version + Math.random()).replace(/\D/g, ""),
        // Assume jQuery is ready without the ready module
        isReady: true,
        error: function error(msg) {
            throw new Error(msg);
        },
        noop: function noop() {},
        isPlainObject: function isPlainObject(obj) {
            var proto, Ctor;
            // Detect obvious negatives
            // Use toString instead of jQuery.type to catch host objects
            if (!obj || toString.call(obj) !== "[object Object]") return false;
            proto = getProto(obj);
            // Objects with no prototype (e.g., `Object.create( null )`) are plain
            if (!proto) return true;
            // Objects with prototype are plain iff they were constructed by a global Object function
            Ctor = hasOwn.call(proto, "constructor") && proto.constructor;
            return typeof Ctor === "function" && fnToString.call(Ctor) === ObjectFunctionString;
        },
        isEmptyObject: function isEmptyObject(obj) {
            var name;
            for(name in obj)return false;
            return true;
        },
        // Evaluates a script in a provided context; falls back to the global one
        // if not specified.
        globalEval: function globalEval(code, options, doc) {
            DOMEval(code, {
                nonce: options && options.nonce
            }, doc);
        },
        each: function each(obj, callback) {
            var length, i = 0;
            if (isArrayLike(obj)) {
                length = obj.length;
                for(; i < length; i++){
                    if (callback.call(obj[i], i, obj[i]) === false) break;
                }
            } else for(i in obj){
                if (callback.call(obj[i], i, obj[i]) === false) break;
            }
            return obj;
        },
        // Retrieve the text value of an array of DOM nodes
        text: function text(elem) {
            var node, ret = "", i = 0, nodeType = elem.nodeType;
            if (!nodeType) // If no nodeType, this is expected to be an array
            while(node = elem[i++])// Do not traverse comment nodes
            ret += jQuery.text(node);
            if (nodeType === 1 || nodeType === 11) return elem.textContent;
            if (nodeType === 9) return elem.documentElement.textContent;
            if (nodeType === 3 || nodeType === 4) return elem.nodeValue;
            // Do not include comment or processing instruction nodes
            return ret;
        },
        // results is for internal usage only
        makeArray: function makeArray(arr, results) {
            var ret = results || [];
            if (arr != null) {
                if (isArrayLike(Object(arr))) jQuery.merge(ret, typeof arr === "string" ? [
                    arr
                ] : arr);
                else push.call(ret, arr);
            }
            return ret;
        },
        inArray: function inArray(elem, arr, i) {
            return arr == null ? -1 : indexOf.call(arr, elem, i);
        },
        isXMLDoc: function isXMLDoc(elem) {
            var namespace = elem && elem.namespaceURI, docElem = elem && (elem.ownerDocument || elem).documentElement;
            // Assume HTML when documentElement doesn't yet exist, such as inside
            // document fragments.
            return !rhtmlSuffix.test(namespace || docElem && docElem.nodeName || "HTML");
        },
        // Support: Android <=4.0 only, PhantomJS 1 only
        // push.apply(_, arraylike) throws on ancient WebKit
        merge: function merge(first, second) {
            var len = +second.length, j = 0, i = first.length;
            for(; j < len; j++)first[i++] = second[j];
            first.length = i;
            return first;
        },
        grep: function grep(elems, callback, invert) {
            var callbackInverse, matches = [], i = 0, length = elems.length, callbackExpect = !invert;
            // Go through the array, only saving the items
            // that pass the validator function
            for(; i < length; i++){
                callbackInverse = !callback(elems[i], i);
                if (callbackInverse !== callbackExpect) matches.push(elems[i]);
            }
            return matches;
        },
        // arg is for internal usage only
        map: function map(elems, callback, arg) {
            var length, value, i = 0, ret = [];
            // Go through the array, translating each of the items to their new values
            if (isArrayLike(elems)) {
                length = elems.length;
                for(; i < length; i++){
                    value = callback(elems[i], i, arg);
                    if (value != null) ret.push(value);
                }
            // Go through every key on the object,
            } else for(i in elems){
                value = callback(elems[i], i, arg);
                if (value != null) ret.push(value);
            }
            // Flatten any nested arrays
            return flat(ret);
        },
        // A global GUID counter for objects
        guid: 1,
        // jQuery.support is not used in Core but other projects attach their
        // properties to it so it needs to exist.
        support: support
    });
    if (typeof Symbol === "function") jQuery.fn[Symbol.iterator] = arr[Symbol.iterator];
    // Populate the class2type map
    jQuery.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function(_i, name) {
        class2type["[object " + name + "]"] = name.toLowerCase();
    });
    function isArrayLike(obj) {
        // Support: real iOS 8.2 only (not reproducible in simulator)
        // `in` check used to prevent JIT error (gh-2145)
        // hasOwn isn't used here due to false negatives
        // regarding Nodelist length in IE
        var length = !!obj && "length" in obj && obj.length, type = toType(obj);
        if (isFunction(obj) || isWindow(obj)) return false;
        return type === "array" || length === 0 || typeof length === "number" && length > 0 && length - 1 in obj;
    }
    function nodeName(elem, name) {
        return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
    }
    var pop = arr.pop;
    var sort = arr.sort;
    var splice = arr.splice;
    var whitespace = "[\\x20\\t\\r\\n\\f]";
    var rtrimCSS = new RegExp("^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g");
    // Note: an element does not contain itself
    jQuery.contains = function(a, b) {
        var bup = b && b.parentNode;
        return a === bup || !!(bup && bup.nodeType === 1 && // Support: IE 9 - 11+
        // IE doesn't have `contains` on SVG.
        (a.contains ? a.contains(bup) : a.compareDocumentPosition && a.compareDocumentPosition(bup) & 16));
    };
    // CSS string/identifier serialization
    // https://drafts.csswg.org/cssom/#common-serializing-idioms
    var rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;
    function fcssescape(ch, asCodePoint) {
        if (asCodePoint) {
            // U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
            if (ch === "\0") return "\uFFFD";
            // Control characters and (dependent upon position) numbers get escaped as code points
            return ch.slice(0, -1) + "\\" + ch.charCodeAt(ch.length - 1).toString(16) + " ";
        }
        // Other potentially-special ASCII characters get backslash-escaped
        return "\\" + ch;
    }
    jQuery.escapeSelector = function(sel) {
        return (sel + "").replace(rcssescape, fcssescape);
    };
    var preferredDoc = document, pushNative = push;
    (function() {
        var i, Expr, outermostContext, sortInput, hasDuplicate, push = pushNative, // Local document vars
        document, documentElement, documentIsHTML, rbuggyQSA, matches, // Instance-specific data
        expando = jQuery.expando, dirruns = 0, done = 0, classCache = createCache(), tokenCache = createCache(), compilerCache = createCache(), nonnativeSelectorCache = createCache(), sortOrder = function sortOrder(a, b) {
            if (a === b) hasDuplicate = true;
            return 0;
        }, booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped", // Regular expressions
        // https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
        identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+", // Attribute selectors: https://www.w3.org/TR/selectors/#attribute-selectors
        attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace + // Operator (capture 2)
        "*([*^$|!~]?=)" + whitespace + // "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
        "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace + "*\\]", pseudos = ":(" + identifier + ")(?:\\((" + // To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
        // 1. quoted (capture 3; capture 4 or capture 5)
        "('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" + // 2. simple (capture 6)
        "((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" + // 3. anything else (capture 2)
        ".*" + ")\\)|)", // Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
        rwhitespace = new RegExp(whitespace + "+", "g"), rcomma = new RegExp("^" + whitespace + "*," + whitespace + "*"), rleadingCombinator = new RegExp("^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*"), rdescend = new RegExp(whitespace + "|>"), rpseudo = new RegExp(pseudos), ridentifier = new RegExp("^" + identifier + "$"), matchExpr = {
            ID: new RegExp("^#(" + identifier + ")"),
            CLASS: new RegExp("^\\.(" + identifier + ")"),
            TAG: new RegExp("^(" + identifier + "|[*])"),
            ATTR: new RegExp("^" + attributes),
            PSEUDO: new RegExp("^" + pseudos),
            CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i"),
            bool: new RegExp("^(?:" + booleans + ")$", "i"),
            // For use in libraries implementing .is()
            // We use this for POS matching in `select`
            needsContext: new RegExp("^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i")
        }, rinputs = /^(?:input|select|textarea|button)$/i, rheader = /^h\d$/i, // Easily-parseable/retrievable ID or TAG or CLASS selectors
        rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, rsibling = /[+~]/, // CSS escapes
        // https://www.w3.org/TR/CSS21/syndata.html#escaped-characters
        runescape = new RegExp("\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g"), funescape = function funescape(escape, nonHex) {
            var high = "0x" + escape.slice(1) - 0x10000;
            if (nonHex) // Strip the backslash prefix from a non-hex escape sequence
            return nonHex;
            // Replace a hexadecimal escape sequence with the encoded Unicode code point
            // Support: IE <=11+
            // For values outside the Basic Multilingual Plane (BMP), manually construct a
            // surrogate pair
            return high < 0 ? String.fromCharCode(high + 0x10000) : String.fromCharCode(high >> 10 | 0xD800, high & 0x3FF | 0xDC00);
        }, // Used for iframes; see `setDocument`.
        // Support: IE 9 - 11+, Edge 12 - 18+
        // Removing the function wrapper causes a "Permission Denied"
        // error in IE/Edge.
        unloadHandler = function unloadHandler() {
            setDocument();
        }, inDisabledFieldset = addCombinator(function(elem) {
            return elem.disabled === true && nodeName(elem, "fieldset");
        }, {
            dir: "parentNode",
            next: "legend"
        });
        // Support: IE <=9 only
        // Accessing document.activeElement can throw unexpectedly
        // https://bugs.jquery.com/ticket/13393
        function safeActiveElement() {
            try {
                return document.activeElement;
            } catch (err) {}
        }
        // Optimize for push.apply( _, NodeList )
        try {
            push.apply(arr = slice.call(preferredDoc.childNodes), preferredDoc.childNodes);
            // Support: Android <=4.0
            // Detect silently failing push.apply
            // eslint-disable-next-line no-unused-expressions
            arr[preferredDoc.childNodes.length].nodeType;
        } catch (e) {
            push = {
                apply: function apply(target, els) {
                    pushNative.apply(target, slice.call(els));
                },
                call: function call(target) {
                    pushNative.apply(target, slice.call(arguments, 1));
                }
            };
        }
        function find(selector, context, results, seed) {
            var m, i, elem, nid, match, groups, newSelector, newContext = context && context.ownerDocument, // nodeType defaults to 9, since context defaults to document
            nodeType = context ? context.nodeType : 9;
            results = results || [];
            // Return early from calls with invalid selector or context
            if (typeof selector !== "string" || !selector || nodeType !== 1 && nodeType !== 9 && nodeType !== 11) return results;
            // Try to shortcut find operations (as opposed to filters) in HTML documents
            if (!seed) {
                setDocument(context);
                context = context || document;
                if (documentIsHTML) {
                    // If the selector is sufficiently simple, try using a "get*By*" DOM method
                    // (excepting DocumentFragment context, where the methods don't exist)
                    if (nodeType !== 11 && (match = rquickExpr.exec(selector))) {
                        // ID selector
                        if (m = match[1]) {
                            // Document context
                            if (nodeType === 9) {
                                if (elem = context.getElementById(m)) // Support: IE 9 only
                                // getElementById can match elements by name instead of ID
                                {
                                    if (elem.id === m) {
                                        push.call(results, elem);
                                        return results;
                                    }
                                } else return results;
                            // Element context
                            } else // Support: IE 9 only
                            // getElementById can match elements by name instead of ID
                            if (newContext && (elem = newContext.getElementById(m)) && find.contains(context, elem) && elem.id === m) {
                                push.call(results, elem);
                                return results;
                            }
                        // Type selector
                        } else if (match[2]) {
                            push.apply(results, context.getElementsByTagName(selector));
                            return results;
                        // Class selector
                        } else if ((m = match[3]) && context.getElementsByClassName) {
                            push.apply(results, context.getElementsByClassName(m));
                            return results;
                        }
                    }
                    // Take advantage of querySelectorAll
                    if (!nonnativeSelectorCache[selector + " "] && (!rbuggyQSA || !rbuggyQSA.test(selector))) {
                        newSelector = selector;
                        newContext = context;
                        // qSA considers elements outside a scoping root when evaluating child or
                        // descendant combinators, which is not what we want.
                        // In such cases, we work around the behavior by prefixing every selector in the
                        // list with an ID selector referencing the scope context.
                        // The technique has to be used as well when a leading combinator is used
                        // as such selectors are not recognized by querySelectorAll.
                        // Thanks to Andrew Dupont for this technique.
                        if (nodeType === 1 && (rdescend.test(selector) || rleadingCombinator.test(selector))) {
                            // Expand context for sibling selectors
                            newContext = rsibling.test(selector) && testContext(context.parentNode) || context;
                            // We can use :scope instead of the ID hack if the browser
                            // supports it & if we're not changing the context.
                            // Support: IE 11+, Edge 17 - 18+
                            // IE/Edge sometimes throw a "Permission denied" error when
                            // strict-comparing two documents; shallow comparisons work.
                            // eslint-disable-next-line eqeqeq
                            if (newContext != context || !support.scope) {
                                // Capture the context ID, setting it first if necessary
                                if (nid = context.getAttribute("id")) nid = jQuery.escapeSelector(nid);
                                else context.setAttribute("id", nid = expando);
                            }
                            // Prefix every selector in the list
                            groups = tokenize(selector);
                            i = groups.length;
                            while(i--)groups[i] = (nid ? "#" + nid : ":scope") + " " + toSelector(groups[i]);
                            newSelector = groups.join(",");
                        }
                        try {
                            push.apply(results, newContext.querySelectorAll(newSelector));
                            return results;
                        } catch (qsaError) {
                            nonnativeSelectorCache(selector, true);
                        } finally{
                            if (nid === expando) context.removeAttribute("id");
                        }
                    }
                }
            }
            // All others
            return select(selector.replace(rtrimCSS, "$1"), context, results, seed);
        }
        /**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */ function createCache() {
            var keys = [];
            function cache(key, value) {
                // Use (key + " ") to avoid collision with native prototype properties
                // (see https://github.com/jquery/sizzle/issues/157)
                if (keys.push(key + " ") > Expr.cacheLength) // Only keep the most recent entries
                delete cache[keys.shift()];
                return cache[key + " "] = value;
            }
            return cache;
        }
        /**
 * Mark a function for special use by jQuery selector module
 * @param {Function} fn The function to mark
 */ function markFunction(fn) {
            fn[expando] = true;
            return fn;
        }
        /**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */ function assert(fn) {
            var el = document.createElement("fieldset");
            try {
                return !!fn(el);
            } catch (e) {
                return false;
            } finally{
                // Remove from its parent by default
                if (el.parentNode) el.parentNode.removeChild(el);
                // release memory in IE
                el = null;
            }
        }
        /**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */ function createInputPseudo(type) {
            return function(elem) {
                return nodeName(elem, "input") && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */ function createButtonPseudo(type) {
            return function(elem) {
                return (nodeName(elem, "input") || nodeName(elem, "button")) && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */ function createDisabledPseudo(disabled) {
            // Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
            return function(elem) {
                // Only certain elements can match :enabled or :disabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
                if ("form" in elem) {
                    // Check for inherited disabledness on relevant non-disabled elements:
                    // * listed form-associated elements in a disabled fieldset
                    //   https://html.spec.whatwg.org/multipage/forms.html#category-listed
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
                    // * option elements in a disabled optgroup
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
                    // All such elements have a "form" property.
                    if (elem.parentNode && elem.disabled === false) {
                        // Option elements defer to a parent optgroup if present
                        if ("label" in elem) {
                            if ("label" in elem.parentNode) return elem.parentNode.disabled === disabled;
                            else return elem.disabled === disabled;
                        }
                        // Support: IE 6 - 11+
                        // Use the isDisabled shortcut property to check for disabled fieldset ancestors
                        return elem.isDisabled === disabled || // Where there is no isDisabled, check manually
                        elem.isDisabled !== !disabled && inDisabledFieldset(elem) === disabled;
                    }
                    return elem.disabled === disabled;
                // Try to winnow out elements that can't be disabled before trusting the disabled property.
                // Some victims get caught in our net (label, legend, menu, track), but it shouldn't
                // even exist on them, let alone have a boolean value.
                } else if ("label" in elem) return elem.disabled === disabled;
                // Remaining elements are neither :enabled nor :disabled
                return false;
            };
        }
        /**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */ function createPositionalPseudo(fn) {
            return markFunction(function(argument) {
                argument = +argument;
                return markFunction(function(seed, matches) {
                    var j, matchIndexes = fn([], seed.length, argument), i = matchIndexes.length;
                    // Match elements found at the specified indexes
                    while(i--)if (seed[j = matchIndexes[i]]) seed[j] = !(matches[j] = seed[j]);
                });
            });
        }
        /**
 * Checks a node for validity as a jQuery selector context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */ function testContext(context) {
            return context && typeof context.getElementsByTagName !== "undefined" && context;
        }
        /**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [node] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */ function setDocument(node) {
            var subWindow, doc = node ? node.ownerDocument || node : preferredDoc;
            // Return early if doc is invalid or already selected
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if (doc == document || doc.nodeType !== 9 || !doc.documentElement) return document;
            // Update global variables
            document = doc;
            documentElement = document.documentElement;
            documentIsHTML = !jQuery.isXMLDoc(document);
            // Support: iOS 7 only, IE 9 - 11+
            // Older browsers didn't support unprefixed `matches`.
            matches = documentElement.matches || documentElement.webkitMatchesSelector || documentElement.msMatchesSelector;
            // Support: IE 9 - 11+, Edge 12 - 18+
            // Accessing iframe documents after unload throws "permission denied" errors
            // (see trac-13936).
            // Limit the fix to IE & Edge Legacy; despite Edge 15+ implementing `matches`,
            // all IE 9+ and Edge Legacy versions implement `msMatchesSelector` as well.
            if (documentElement.msMatchesSelector && // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            preferredDoc != document && (subWindow = document.defaultView) && subWindow.top !== subWindow) // Support: IE 9 - 11+, Edge 12 - 18+
            subWindow.addEventListener("unload", unloadHandler);
            // Support: IE <10
            // Check if getElementById returns elements by name
            // The broken getElementById methods don't pick up programmatically-set names,
            // so use a roundabout getElementsByName test
            support.getById = assert(function(el) {
                documentElement.appendChild(el).id = jQuery.expando;
                return !document.getElementsByName || !document.getElementsByName(jQuery.expando).length;
            });
            // Support: IE 9 only
            // Check to see if it's possible to do matchesSelector
            // on a disconnected node.
            support.disconnectedMatch = assert(function(el) {
                return matches.call(el, "*");
            });
            // Support: IE 9 - 11+, Edge 12 - 18+
            // IE/Edge don't support the :scope pseudo-class.
            support.scope = assert(function() {
                return document.querySelectorAll(":scope");
            });
            // Support: Chrome 105 - 111 only, Safari 15.4 - 16.3 only
            // Make sure the `:has()` argument is parsed unforgivingly.
            // We include `*` in the test to detect buggy implementations that are
            // _selectively_ forgiving (specifically when the list includes at least
            // one valid selector).
            // Note that we treat complete lack of support for `:has()` as if it were
            // spec-compliant support, which is fine because use of `:has()` in such
            // environments will fail in the qSA path and fall back to jQuery traversal
            // anyway.
            support.cssHas = assert(function() {
                try {
                    document.querySelector(":has(*,:jqfake)");
                    return false;
                } catch (e) {
                    return true;
                }
            });
            // ID filter and find
            if (support.getById) {
                Expr.filter.ID = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        return elem.getAttribute("id") === attrId;
                    };
                };
                Expr.find.ID = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var elem = context.getElementById(id);
                        return elem ? [
                            elem
                        ] : [];
                    }
                };
            } else {
                Expr.filter.ID = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        var _$node = typeof elem.getAttributeNode !== "undefined" && elem.getAttributeNode("id");
                        return _$node && _$node.value === attrId;
                    };
                };
                // Support: IE 6 - 7 only
                // getElementById is not reliable as a find shortcut
                Expr.find.ID = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var _$node, i, elems, elem = context.getElementById(id);
                        if (elem) {
                            // Verify the id attribute
                            _$node = elem.getAttributeNode("id");
                            if (_$node && _$node.value === id) return [
                                elem
                            ];
                            // Fall back on getElementsByName
                            elems = context.getElementsByName(id);
                            i = 0;
                            while(elem = elems[i++]){
                                _$node = elem.getAttributeNode("id");
                                if (_$node && _$node.value === id) return [
                                    elem
                                ];
                            }
                        }
                        return [];
                    }
                };
            }
            // Tag
            Expr.find.TAG = function(tag, context) {
                if (typeof context.getElementsByTagName !== "undefined") return context.getElementsByTagName(tag);
                else return context.querySelectorAll(tag);
            };
            // Class
            Expr.find.CLASS = function(className, context) {
                if (typeof context.getElementsByClassName !== "undefined" && documentIsHTML) return context.getElementsByClassName(className);
            };
            /* QSA/matchesSelector
	---------------------------------------------------------------------- */ // QSA and matchesSelector support
            rbuggyQSA = [];
            // Build QSA regex
            // Regex strategy adopted from Diego Perini
            assert(function(el) {
                var input;
                documentElement.appendChild(el).innerHTML = "<a id='" + expando + "' href='' disabled='disabled'></a>" + "<select id='" + expando + "-\r\\' disabled='disabled'>" + "<option selected=''></option></select>";
                // Support: iOS <=7 - 8 only
                // Boolean attributes and "value" are not treated correctly in some XML documents
                if (!el.querySelectorAll("[selected]").length) rbuggyQSA.push("\\[" + whitespace + "*(?:value|" + booleans + ")");
                // Support: iOS <=7 - 8 only
                if (!el.querySelectorAll("[id~=" + expando + "-]").length) rbuggyQSA.push("~=");
                // Support: iOS 8 only
                // https://bugs.webkit.org/show_bug.cgi?id=136851
                // In-page `selector#id sibling-combinator selector` fails
                if (!el.querySelectorAll("a#" + expando + "+*").length) rbuggyQSA.push(".#.+[+~]");
                // Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
                // In some of the document kinds, these selectors wouldn't work natively.
                // This is probably OK but for backwards compatibility we want to maintain
                // handling them through jQuery traversal in jQuery 3.x.
                if (!el.querySelectorAll(":checked").length) rbuggyQSA.push(":checked");
                // Support: Windows 8 Native Apps
                // The type and name attributes are restricted during .innerHTML assignment
                input = document.createElement("input");
                input.setAttribute("type", "hidden");
                el.appendChild(input).setAttribute("name", "D");
                // Support: IE 9 - 11+
                // IE's :disabled selector does not pick up the children of disabled fieldsets
                // Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
                // In some of the document kinds, these selectors wouldn't work natively.
                // This is probably OK but for backwards compatibility we want to maintain
                // handling them through jQuery traversal in jQuery 3.x.
                documentElement.appendChild(el).disabled = true;
                if (el.querySelectorAll(":disabled").length !== 2) rbuggyQSA.push(":enabled", ":disabled");
                // Support: IE 11+, Edge 15 - 18+
                // IE 11/Edge don't find elements on a `[name='']` query in some cases.
                // Adding a temporary attribute to the document before the selection works
                // around the issue.
                // Interestingly, IE 10 & older don't seem to have the issue.
                input = document.createElement("input");
                input.setAttribute("name", "");
                el.appendChild(input);
                if (!el.querySelectorAll("[name='']").length) rbuggyQSA.push("\\[" + whitespace + "*name" + whitespace + "*=" + whitespace + "*(?:''|\"\")");
            });
            if (!support.cssHas) // Support: Chrome 105 - 110+, Safari 15.4 - 16.3+
            // Our regular `try-catch` mechanism fails to detect natively-unsupported
            // pseudo-classes inside `:has()` (such as `:has(:contains("Foo"))`)
            // in browsers that parse the `:has()` argument as a forgiving selector list.
            // https://drafts.csswg.org/selectors/#relational now requires the argument
            // to be parsed unforgivingly, but browsers have not yet fully adjusted.
            rbuggyQSA.push(":has");
            rbuggyQSA = rbuggyQSA.length && new RegExp(rbuggyQSA.join("|"));
            /* Sorting
	---------------------------------------------------------------------- */ // Document order sorting
            sortOrder = function sortOrder(a, b) {
                // Flag for duplicate removal
                if (a === b) {
                    hasDuplicate = true;
                    return 0;
                }
                // Sort on method existence if only one input has compareDocumentPosition
                var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
                if (compare) return compare;
                // Calculate position if both inputs belong to the same document
                // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                compare = (a.ownerDocument || a) == (b.ownerDocument || b) ? a.compareDocumentPosition(b) : // Otherwise we know they are disconnected
                1;
                // Disconnected nodes
                if (compare & 1 || !support.sortDetached && b.compareDocumentPosition(a) === compare) {
                    // Choose the first element that is related to our preferred document
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (a === document || a.ownerDocument == preferredDoc && find.contains(preferredDoc, a)) return -1;
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (b === document || b.ownerDocument == preferredDoc && find.contains(preferredDoc, b)) return 1;
                    // Maintain original order
                    return sortInput ? indexOf.call(sortInput, a) - indexOf.call(sortInput, b) : 0;
                }
                return compare & 4 ? -1 : 1;
            };
            return document;
        }
        find.matches = function(expr, elements) {
            return find(expr, null, null, elements);
        };
        find.matchesSelector = function(elem, expr) {
            setDocument(elem);
            if (documentIsHTML && !nonnativeSelectorCache[expr + " "] && (!rbuggyQSA || !rbuggyQSA.test(expr))) try {
                var ret = matches.call(elem, expr);
                // IE 9's matchesSelector returns false on disconnected nodes
                if (ret || support.disconnectedMatch || // As well, disconnected nodes are said to be in a document
                // fragment in IE 9
                elem.document && elem.document.nodeType !== 11) return ret;
            } catch (e) {
                nonnativeSelectorCache(expr, true);
            }
            return find(expr, document, null, [
                elem
            ]).length > 0;
        };
        find.contains = function(context, elem) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((context.ownerDocument || context) != document) setDocument(context);
            return jQuery.contains(context, elem);
        };
        find.attr = function(elem, name) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((elem.ownerDocument || elem) != document) setDocument(elem);
            var fn = Expr.attrHandle[name.toLowerCase()], // Don't get fooled by Object.prototype properties (see trac-13807)
            val = fn && hasOwn.call(Expr.attrHandle, name.toLowerCase()) ? fn(elem, name, !documentIsHTML) : undefined;
            if (val !== undefined) return val;
            return elem.getAttribute(name);
        };
        find.error = function(msg) {
            throw new Error("Syntax error, unrecognized expression: " + msg);
        };
        /**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */ jQuery.uniqueSort = function(results) {
            var elem, duplicates = [], j = 0, i = 0;
            // Unless we *know* we can detect duplicates, assume their presence
            //
            // Support: Android <=4.0+
            // Testing for detecting duplicates is unpredictable so instead assume we can't
            // depend on duplicate detection in all browsers without a stable sort.
            hasDuplicate = !support.sortStable;
            sortInput = !support.sortStable && slice.call(results, 0);
            sort.call(results, sortOrder);
            if (hasDuplicate) {
                while(elem = results[i++])if (elem === results[i]) j = duplicates.push(i);
                while(j--)splice.call(results, duplicates[j], 1);
            }
            // Clear input after sorting to release objects
            // See https://github.com/jquery/sizzle/pull/225
            sortInput = null;
            return results;
        };
        jQuery.fn.uniqueSort = function() {
            return this.pushStack(jQuery.uniqueSort(slice.apply(this)));
        };
        Expr = jQuery.expr = {
            // Can be adjusted by the user
            cacheLength: 50,
            createPseudo: markFunction,
            match: matchExpr,
            attrHandle: {},
            find: {},
            relative: {
                ">": {
                    dir: "parentNode",
                    first: true
                },
                " ": {
                    dir: "parentNode"
                },
                "+": {
                    dir: "previousSibling",
                    first: true
                },
                "~": {
                    dir: "previousSibling"
                }
            },
            preFilter: {
                ATTR: function ATTR(match) {
                    match[1] = match[1].replace(runescape, funescape);
                    // Move the given value to match[3] whether quoted or unquoted
                    match[3] = (match[3] || match[4] || match[5] || "").replace(runescape, funescape);
                    if (match[2] === "~=") match[3] = " " + match[3] + " ";
                    return match.slice(0, 4);
                },
                CHILD: function CHILD(match) {
                    /* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/ match[1] = match[1].toLowerCase();
                    if (match[1].slice(0, 3) === "nth") {
                        // nth-* requires argument
                        if (!match[3]) find.error(match[0]);
                        // numeric x and y parameters for Expr.filter.CHILD
                        // remember that false/true cast respectively to 0/1
                        match[4] = +(match[4] ? match[5] + (match[6] || 1) : 2 * (match[3] === "even" || match[3] === "odd"));
                        match[5] = +(match[7] + match[8] || match[3] === "odd");
                    // other types prohibit arguments
                    } else if (match[3]) find.error(match[0]);
                    return match;
                },
                PSEUDO: function PSEUDO(match) {
                    var excess, unquoted = !match[6] && match[2];
                    if (matchExpr.CHILD.test(match[0])) return null;
                    // Accept quoted arguments as-is
                    if (match[3]) match[2] = match[4] || match[5] || "";
                    else if (unquoted && rpseudo.test(unquoted) && // Get excess from tokenize (recursively)
                    (excess = tokenize(unquoted, true)) && // advance to the next closing parenthesis
                    (excess = unquoted.indexOf(")", unquoted.length - excess) - unquoted.length)) {
                        // excess is a negative index
                        match[0] = match[0].slice(0, excess);
                        match[2] = unquoted.slice(0, excess);
                    }
                    // Return only captures needed by the pseudo filter method (type and argument)
                    return match.slice(0, 3);
                }
            },
            filter: {
                TAG: function TAG(nodeNameSelector) {
                    var expectedNodeName = nodeNameSelector.replace(runescape, funescape).toLowerCase();
                    return nodeNameSelector === "*" ? function() {
                        return true;
                    } : function(elem) {
                        return nodeName(elem, expectedNodeName);
                    };
                },
                CLASS: function CLASS(className) {
                    var pattern = classCache[className + " "];
                    return pattern || (pattern = new RegExp("(^|" + whitespace + ")" + className + "(" + whitespace + "|$)"), classCache(className, function(elem) {
                        return pattern.test(typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "");
                    }));
                },
                ATTR: function ATTR(name, operator, check) {
                    return function(elem) {
                        var result = find.attr(elem, name);
                        if (result == null) return operator === "!=";
                        if (!operator) return true;
                        result += "";
                        if (operator === "=") return result === check;
                        if (operator === "!=") return result !== check;
                        if (operator === "^=") return check && result.indexOf(check) === 0;
                        if (operator === "*=") return check && result.indexOf(check) > -1;
                        if (operator === "$=") return check && result.slice(-check.length) === check;
                        if (operator === "~=") return (" " + result.replace(rwhitespace, " ") + " ").indexOf(check) > -1;
                        if (operator === "|=") return result === check || result.slice(0, check.length + 1) === check + "-";
                        return false;
                    };
                },
                CHILD: function CHILD(type, what, _argument, first, last) {
                    var simple = type.slice(0, 3) !== "nth", forward = type.slice(-4) !== "last", ofType = what === "of-type";
                    return first === 1 && last === 0 ? // Shortcut for :nth-*(n)
                    function(elem) {
                        return !!elem.parentNode;
                    } : function(elem, _context, xml) {
                        var cache, outerCache, node, nodeIndex, start, dir = simple !== forward ? "nextSibling" : "previousSibling", parent = elem.parentNode, name = ofType && elem.nodeName.toLowerCase(), useCache = !xml && !ofType, diff = false;
                        if (parent) {
                            // :(first|last|only)-(child|of-type)
                            if (simple) {
                                while(dir){
                                    node = elem;
                                    while(node = node[dir]){
                                        if (ofType ? nodeName(node, name) : node.nodeType === 1) return false;
                                    }
                                    // Reverse direction for :only-* (if we haven't yet done so)
                                    start = dir = type === "only" && !start && "nextSibling";
                                }
                                return true;
                            }
                            start = [
                                forward ? parent.firstChild : parent.lastChild
                            ];
                            // non-xml :nth-child(...) stores cache data on `parent`
                            if (forward && useCache) {
                                // Seek `elem` from a previously-cached index
                                outerCache = parent[expando] || (parent[expando] = {});
                                cache = outerCache[type] || [];
                                nodeIndex = cache[0] === dirruns && cache[1];
                                diff = nodeIndex && cache[2];
                                node = nodeIndex && parent.childNodes[nodeIndex];
                                while(node = ++nodeIndex && node && node[dir] || // Fallback to seeking `elem` from the start
                                (diff = nodeIndex = 0) || start.pop())// When found, cache indexes on `parent` and break
                                if (node.nodeType === 1 && ++diff && node === elem) {
                                    outerCache[type] = [
                                        dirruns,
                                        nodeIndex,
                                        diff
                                    ];
                                    break;
                                }
                            } else {
                                // Use previously-cached element index if available
                                if (useCache) {
                                    outerCache = elem[expando] || (elem[expando] = {});
                                    cache = outerCache[type] || [];
                                    nodeIndex = cache[0] === dirruns && cache[1];
                                    diff = nodeIndex;
                                }
                                // xml :nth-child(...)
                                // or :nth-last-child(...) or :nth(-last)?-of-type(...)
                                if (diff === false) {
                                    // Use the same loop as above to seek `elem` from the start
                                    while(node = ++nodeIndex && node && node[dir] || (diff = nodeIndex = 0) || start.pop())if ((ofType ? nodeName(node, name) : node.nodeType === 1) && ++diff) {
                                        // Cache the index of each encountered element
                                        if (useCache) {
                                            outerCache = node[expando] || (node[expando] = {});
                                            outerCache[type] = [
                                                dirruns,
                                                diff
                                            ];
                                        }
                                        if (node === elem) break;
                                    }
                                }
                            }
                            // Incorporate the offset, then check against cycle size
                            diff -= last;
                            return diff === first || diff % first === 0 && diff / first >= 0;
                        }
                    };
                },
                PSEUDO: function PSEUDO(pseudo, argument) {
                    // pseudo-class names are case-insensitive
                    // https://www.w3.org/TR/selectors/#pseudo-classes
                    // Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
                    // Remember that setFilters inherits from pseudos
                    var args, fn = Expr.pseudos[pseudo] || Expr.setFilters[pseudo.toLowerCase()] || find.error("unsupported pseudo: " + pseudo);
                    // The user may use createPseudo to indicate that
                    // arguments are needed to create the filter function
                    // just as jQuery does
                    if (fn[expando]) return fn(argument);
                    // But maintain support for old signatures
                    if (fn.length > 1) {
                        args = [
                            pseudo,
                            pseudo,
                            "",
                            argument
                        ];
                        return Expr.setFilters.hasOwnProperty(pseudo.toLowerCase()) ? markFunction(function(seed, matches) {
                            var idx, matched = fn(seed, argument), i = matched.length;
                            while(i--){
                                idx = indexOf.call(seed, matched[i]);
                                seed[idx] = !(matches[idx] = matched[i]);
                            }
                        }) : function(elem) {
                            return fn(elem, 0, args);
                        };
                    }
                    return fn;
                }
            },
            pseudos: {
                // Potentially complex pseudos
                not: markFunction(function(selector) {
                    // Trim the selector passed to compile
                    // to avoid treating leading and trailing
                    // spaces as combinators
                    var input = [], results = [], matcher = compile(selector.replace(rtrimCSS, "$1"));
                    return matcher[expando] ? markFunction(function(seed, matches, _context, xml) {
                        var elem, unmatched = matcher(seed, null, xml, []), i = seed.length;
                        // Match elements unmatched by `matcher`
                        while(i--)if (elem = unmatched[i]) seed[i] = !(matches[i] = elem);
                    }) : function(elem, _context, xml) {
                        input[0] = elem;
                        matcher(input, null, xml, results);
                        // Don't keep the element
                        // (see https://github.com/jquery/sizzle/issues/299)
                        input[0] = null;
                        return !results.pop();
                    };
                }),
                has: markFunction(function(selector) {
                    return function(elem) {
                        return find(selector, elem).length > 0;
                    };
                }),
                contains: markFunction(function(text) {
                    text = text.replace(runescape, funescape);
                    return function(elem) {
                        return (elem.textContent || jQuery.text(elem)).indexOf(text) > -1;
                    };
                }),
                // "Whether an element is represented by a :lang() selector
                // is based solely on the element's language value
                // being equal to the identifier C,
                // or beginning with the identifier C immediately followed by "-".
                // The matching of C against the element's language value is performed case-insensitively.
                // The identifier C does not have to be a valid language name."
                // https://www.w3.org/TR/selectors/#lang-pseudo
                lang: markFunction(function(lang) {
                    // lang value must be a valid identifier
                    if (!ridentifier.test(lang || "")) find.error("unsupported lang: " + lang);
                    lang = lang.replace(runescape, funescape).toLowerCase();
                    return function(elem) {
                        var elemLang;
                        do if (elemLang = documentIsHTML ? elem.lang : elem.getAttribute("xml:lang") || elem.getAttribute("lang")) {
                            elemLang = elemLang.toLowerCase();
                            return elemLang === lang || elemLang.indexOf(lang + "-") === 0;
                        }
                        while ((elem = elem.parentNode) && elem.nodeType === 1);
                        return false;
                    };
                }),
                // Miscellaneous
                target: function target(elem) {
                    var hash = window1.location && window1.location.hash;
                    return hash && hash.slice(1) === elem.id;
                },
                root: function root(elem) {
                    return elem === documentElement;
                },
                focus: function focus(elem) {
                    return elem === safeActiveElement() && document.hasFocus() && !!(elem.type || elem.href || ~elem.tabIndex);
                },
                // Boolean properties
                enabled: createDisabledPseudo(false),
                disabled: createDisabledPseudo(true),
                checked: function checked(elem) {
                    // In CSS3, :checked should return both checked and selected elements
                    // https://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
                    return nodeName(elem, "input") && !!elem.checked || nodeName(elem, "option") && !!elem.selected;
                },
                selected: function selected(elem) {
                    // Support: IE <=11+
                    // Accessing the selectedIndex property
                    // forces the browser to treat the default option as
                    // selected when in an optgroup.
                    if (elem.parentNode) // eslint-disable-next-line no-unused-expressions
                    elem.parentNode.selectedIndex;
                    return elem.selected === true;
                },
                // Contents
                empty: function empty(elem) {
                    // https://www.w3.org/TR/selectors/#empty-pseudo
                    // :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
                    //   but not by others (comment: 8; processing instruction: 7; etc.)
                    // nodeType < 6 works because attributes (2) do not appear as children
                    for(elem = elem.firstChild; elem; elem = elem.nextSibling){
                        if (elem.nodeType < 6) return false;
                    }
                    return true;
                },
                parent: function parent(elem) {
                    return !Expr.pseudos.empty(elem);
                },
                // Element/input types
                header: function header(elem) {
                    return rheader.test(elem.nodeName);
                },
                input: function input(elem) {
                    return rinputs.test(elem.nodeName);
                },
                button: function button(elem) {
                    return nodeName(elem, "input") && elem.type === "button" || nodeName(elem, "button");
                },
                text: function text(elem) {
                    var attr;
                    return nodeName(elem, "input") && elem.type === "text" && // Support: IE <10 only
                    // New HTML5 attribute values (e.g., "search") appear
                    // with elem.type === "text"
                    ((attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text");
                },
                // Position-in-collection
                first: createPositionalPseudo(function() {
                    return [
                        0
                    ];
                }),
                last: createPositionalPseudo(function(_matchIndexes, length) {
                    return [
                        length - 1
                    ];
                }),
                eq: createPositionalPseudo(function(_matchIndexes, length, argument) {
                    return [
                        argument < 0 ? argument + length : argument
                    ];
                }),
                even: createPositionalPseudo(function(matchIndexes, length) {
                    var i = 0;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                odd: createPositionalPseudo(function(matchIndexes, length) {
                    var i = 1;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                lt: createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i;
                    if (argument < 0) i = argument + length;
                    else if (argument > length) i = length;
                    else i = argument;
                    for(; --i >= 0;)matchIndexes.push(i);
                    return matchIndexes;
                }),
                gt: createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i = argument < 0 ? argument + length : argument;
                    for(; ++i < length;)matchIndexes.push(i);
                    return matchIndexes;
                })
            }
        };
        Expr.pseudos.nth = Expr.pseudos.eq;
        // Add button/input type pseudos
        for(i in {
            radio: true,
            checkbox: true,
            file: true,
            password: true,
            image: true
        })Expr.pseudos[i] = createInputPseudo(i);
        for(i in {
            submit: true,
            reset: true
        })Expr.pseudos[i] = createButtonPseudo(i);
        // Easy API for creating new setFilters
        function setFilters() {}
        setFilters.prototype = Expr.filters = Expr.pseudos;
        Expr.setFilters = new setFilters();
        function tokenize(selector, parseOnly) {
            var matched, match, tokens, type, soFar, groups, preFilters, cached = tokenCache[selector + " "];
            if (cached) return parseOnly ? 0 : cached.slice(0);
            soFar = selector;
            groups = [];
            preFilters = Expr.preFilter;
            while(soFar){
                // Comma and first run
                if (!matched || (match = rcomma.exec(soFar))) {
                    if (match) // Don't consume trailing commas as valid
                    soFar = soFar.slice(match[0].length) || soFar;
                    groups.push(tokens = []);
                }
                matched = false;
                // Combinators
                if (match = rleadingCombinator.exec(soFar)) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        // Cast descendant combinators to space
                        type: match[0].replace(rtrimCSS, " ")
                    });
                    soFar = soFar.slice(matched.length);
                }
                // Filters
                for(type in Expr.filter)if ((match = matchExpr[type].exec(soFar)) && (!preFilters[type] || (match = preFilters[type](match)))) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        type: type,
                        matches: match
                    });
                    soFar = soFar.slice(matched.length);
                }
                if (!matched) break;
            }
            // Return the length of the invalid excess
            // if we're just parsing
            // Otherwise, throw an error or return tokens
            if (parseOnly) return soFar.length;
            return soFar ? find.error(selector) : // Cache the tokens
            tokenCache(selector, groups).slice(0);
        }
        function toSelector(tokens) {
            var i = 0, len = tokens.length, selector = "";
            for(; i < len; i++)selector += tokens[i].value;
            return selector;
        }
        function addCombinator(matcher, combinator, base) {
            var dir = combinator.dir, skip = combinator.next, key = skip || dir, checkNonElements = base && key === "parentNode", doneName = done++;
            return combinator.first ? // Check against closest ancestor/preceding element
            function(elem, context, xml) {
                while(elem = elem[dir]){
                    if (elem.nodeType === 1 || checkNonElements) return matcher(elem, context, xml);
                }
                return false;
            } : // Check against all ancestor/preceding elements
            function(elem, context, xml) {
                var oldCache, outerCache, newCache = [
                    dirruns,
                    doneName
                ];
                // We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
                if (xml) {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        if (matcher(elem, context, xml)) return true;
                    }
                } else {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        outerCache = elem[expando] || (elem[expando] = {});
                        if (skip && nodeName(elem, skip)) elem = elem[dir] || elem;
                        else if ((oldCache = outerCache[key]) && oldCache[0] === dirruns && oldCache[1] === doneName) // Assign to newCache so results back-propagate to previous elements
                        return newCache[2] = oldCache[2];
                        else {
                            // Reuse newcache so results back-propagate to previous elements
                            outerCache[key] = newCache;
                            // A match means we're done; a fail means we have to keep checking
                            if (newCache[2] = matcher(elem, context, xml)) return true;
                        }
                    }
                }
                return false;
            };
        }
        function elementMatcher(matchers) {
            return matchers.length > 1 ? function(elem, context, xml) {
                var i = matchers.length;
                while(i--){
                    if (!matchers[i](elem, context, xml)) return false;
                }
                return true;
            } : matchers[0];
        }
        function multipleContexts(selector, contexts, results) {
            var i = 0, len = contexts.length;
            for(; i < len; i++)find(selector, contexts[i], results);
            return results;
        }
        function condense(unmatched, map, filter, context, xml) {
            var elem, newUnmatched = [], i = 0, len = unmatched.length, mapped = map != null;
            for(; i < len; i++){
                if (elem = unmatched[i]) {
                    if (!filter || filter(elem, context, xml)) {
                        newUnmatched.push(elem);
                        if (mapped) map.push(i);
                    }
                }
            }
            return newUnmatched;
        }
        function setMatcher(preFilter, selector, matcher, postFilter, postFinder, postSelector) {
            if (postFilter && !postFilter[expando]) postFilter = setMatcher(postFilter);
            if (postFinder && !postFinder[expando]) postFinder = setMatcher(postFinder, postSelector);
            return markFunction(function(seed, results, context, xml) {
                var temp, i, elem, matcherOut, preMap = [], postMap = [], preexisting = results.length, // Get initial elements from seed or context
                elems = seed || multipleContexts(selector || "*", context.nodeType ? [
                    context
                ] : context, []), // Prefilter to get matcher input, preserving a map for seed-results synchronization
                matcherIn = preFilter && (seed || !selector) ? condense(elems, preMap, preFilter, context, xml) : elems;
                if (matcher) {
                    // If we have a postFinder, or filtered seed, or non-seed postFilter
                    // or preexisting results,
                    matcherOut = postFinder || (seed ? preFilter : preexisting || postFilter) ? // ...intermediate processing is necessary
                    [] : // ...otherwise use results directly
                    results;
                    // Find primary matches
                    matcher(matcherIn, matcherOut, context, xml);
                } else matcherOut = matcherIn;
                // Apply postFilter
                if (postFilter) {
                    temp = condense(matcherOut, postMap);
                    postFilter(temp, [], context, xml);
                    // Un-match failing elements by moving them back to matcherIn
                    i = temp.length;
                    while(i--)if (elem = temp[i]) matcherOut[postMap[i]] = !(matcherIn[postMap[i]] = elem);
                }
                if (seed) {
                    if (postFinder || preFilter) {
                        if (postFinder) {
                            // Get the final matcherOut by condensing this intermediate into postFinder contexts
                            temp = [];
                            i = matcherOut.length;
                            while(i--)if (elem = matcherOut[i]) // Restore matcherIn since elem is not yet a final match
                            temp.push(matcherIn[i] = elem);
                            postFinder(null, matcherOut = [], temp, xml);
                        }
                        // Move matched elements from seed to results to keep them synchronized
                        i = matcherOut.length;
                        while(i--)if ((elem = matcherOut[i]) && (temp = postFinder ? indexOf.call(seed, elem) : preMap[i]) > -1) seed[temp] = !(results[temp] = elem);
                    }
                } else {
                    matcherOut = condense(matcherOut === results ? matcherOut.splice(preexisting, matcherOut.length) : matcherOut);
                    if (postFinder) postFinder(null, results, matcherOut, xml);
                    else push.apply(results, matcherOut);
                }
            });
        }
        function matcherFromTokens(tokens) {
            var checkContext, matcher, j, len = tokens.length, leadingRelative = Expr.relative[tokens[0].type], implicitRelative = leadingRelative || Expr.relative[" "], i = leadingRelative ? 1 : 0, // The foundational matcher ensures that elements are reachable from top-level context(s)
            matchContext = addCombinator(function(elem) {
                return elem === checkContext;
            }, implicitRelative, true), matchAnyContext = addCombinator(function(elem) {
                return indexOf.call(checkContext, elem) > -1;
            }, implicitRelative, true), matchers = [
                function(elem, context, xml) {
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    var ret = !leadingRelative && (xml || context != outermostContext) || ((checkContext = context).nodeType ? matchContext(elem, context, xml) : matchAnyContext(elem, context, xml));
                    // Avoid hanging onto element
                    // (see https://github.com/jquery/sizzle/issues/299)
                    checkContext = null;
                    return ret;
                }
            ];
            for(; i < len; i++)if (matcher = Expr.relative[tokens[i].type]) matchers = [
                addCombinator(elementMatcher(matchers), matcher)
            ];
            else {
                matcher = Expr.filter[tokens[i].type].apply(null, tokens[i].matches);
                // Return special upon seeing a positional matcher
                if (matcher[expando]) {
                    // Find the next relative operator (if any) for proper handling
                    j = ++i;
                    for(; j < len; j++){
                        if (Expr.relative[tokens[j].type]) break;
                    }
                    return setMatcher(i > 1 && elementMatcher(matchers), i > 1 && toSelector(// If the preceding token was a descendant combinator, insert an implicit any-element `*`
                    tokens.slice(0, i - 1).concat({
                        value: tokens[i - 2].type === " " ? "*" : ""
                    })).replace(rtrimCSS, "$1"), matcher, i < j && matcherFromTokens(tokens.slice(i, j)), j < len && matcherFromTokens(tokens = tokens.slice(j)), j < len && toSelector(tokens));
                }
                matchers.push(matcher);
            }
            return elementMatcher(matchers);
        }
        function matcherFromGroupMatchers(elementMatchers, setMatchers) {
            var bySet = setMatchers.length > 0, byElement = elementMatchers.length > 0, superMatcher = function superMatcher(seed, context, xml, results, outermost) {
                var elem, j, matcher, matchedCount = 0, i = "0", unmatched = seed && [], setMatched = [], contextBackup = outermostContext, // We must always have either seed elements or outermost context
                elems = seed || byElement && Expr.find.TAG("*", outermost), // Use integer dirruns iff this is the outermost matcher
                dirrunsUnique = dirruns += contextBackup == null ? 1 : Math.random() || 0.1, len = elems.length;
                if (outermost) // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                outermostContext = context == document || context || outermost;
                // Add elements passing elementMatchers directly to results
                // Support: iOS <=7 - 9 only
                // Tolerate NodeList properties (IE: "length"; Safari: <number>) matching
                // elements by id. (see trac-14142)
                for(; i !== len && (elem = elems[i]) != null; i++){
                    if (byElement && elem) {
                        j = 0;
                        // Support: IE 11+, Edge 17 - 18+
                        // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                        // two documents; shallow comparisons work.
                        // eslint-disable-next-line eqeqeq
                        if (!context && elem.ownerDocument != document) {
                            setDocument(elem);
                            xml = !documentIsHTML;
                        }
                        while(matcher = elementMatchers[j++])if (matcher(elem, context || document, xml)) {
                            push.call(results, elem);
                            break;
                        }
                        if (outermost) dirruns = dirrunsUnique;
                    }
                    // Track unmatched elements for set filters
                    if (bySet) {
                        // They will have gone through all possible matchers
                        if (elem = !matcher && elem) matchedCount--;
                        // Lengthen the array for every element, matched or not
                        if (seed) unmatched.push(elem);
                    }
                }
                // `i` is now the count of elements visited above, and adding it to `matchedCount`
                // makes the latter nonnegative.
                matchedCount += i;
                // Apply set filters to unmatched elements
                // NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
                // equals `i`), unless we didn't visit _any_ elements in the above loop because we have
                // no element matchers and no seed.
                // Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
                // case, which will result in a "00" `matchedCount` that differs from `i` but is also
                // numerically zero.
                if (bySet && i !== matchedCount) {
                    j = 0;
                    while(matcher = setMatchers[j++])matcher(unmatched, setMatched, context, xml);
                    if (seed) {
                        // Reintegrate element matches to eliminate the need for sorting
                        if (matchedCount > 0) {
                            while(i--)if (!(unmatched[i] || setMatched[i])) setMatched[i] = pop.call(results);
                        }
                        // Discard index placeholder values to get only actual matches
                        setMatched = condense(setMatched);
                    }
                    // Add matches to results
                    push.apply(results, setMatched);
                    // Seedless set matches succeeding multiple successful matchers stipulate sorting
                    if (outermost && !seed && setMatched.length > 0 && matchedCount + setMatchers.length > 1) jQuery.uniqueSort(results);
                }
                // Override manipulation of globals by nested matchers
                if (outermost) {
                    dirruns = dirrunsUnique;
                    outermostContext = contextBackup;
                }
                return unmatched;
            };
            return bySet ? markFunction(superMatcher) : superMatcher;
        }
        function compile(selector, match /* Internal Use Only */ ) {
            var i, setMatchers = [], elementMatchers = [], cached = compilerCache[selector + " "];
            if (!cached) {
                // Generate a function of recursive functions that can be used to check each element
                if (!match) match = tokenize(selector);
                i = match.length;
                while(i--){
                    cached = matcherFromTokens(match[i]);
                    if (cached[expando]) setMatchers.push(cached);
                    else elementMatchers.push(cached);
                }
                // Cache the compiled function
                cached = compilerCache(selector, matcherFromGroupMatchers(elementMatchers, setMatchers));
                // Save selector and tokenization
                cached.selector = selector;
            }
            return cached;
        }
        /**
 * A low-level selection function that works with jQuery's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with jQuery selector compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */ function select(selector, context, results, seed) {
            var i, tokens, token, type, _$find, compiled = typeof selector === "function" && selector, match = !seed && tokenize(selector = compiled.selector || selector);
            results = results || [];
            // Try to minimize operations if there is only one selector in the list and no seed
            // (the latter of which guarantees us context)
            if (match.length === 1) {
                // Reduce context if the leading compound selector is an ID
                tokens = match[0] = match[0].slice(0);
                if (tokens.length > 2 && (token = tokens[0]).type === "ID" && context.nodeType === 9 && documentIsHTML && Expr.relative[tokens[1].type]) {
                    context = (Expr.find.ID(token.matches[0].replace(runescape, funescape), context) || [])[0];
                    if (!context) return results;
                    else if (compiled) context = context.parentNode;
                    selector = selector.slice(tokens.shift().value.length);
                }
                // Fetch a seed set for right-to-left matching
                i = matchExpr.needsContext.test(selector) ? 0 : tokens.length;
                while(i--){
                    token = tokens[i];
                    // Abort if we hit a combinator
                    if (Expr.relative[type = token.type]) break;
                    if (_$find = Expr.find[type]) // Search, expanding context for leading sibling combinators
                    {
                        if (seed = _$find(token.matches[0].replace(runescape, funescape), rsibling.test(tokens[0].type) && testContext(context.parentNode) || context)) {
                            // If seed is empty or no tokens remain, we can return early
                            tokens.splice(i, 1);
                            selector = seed.length && toSelector(tokens);
                            if (!selector) {
                                push.apply(results, seed);
                                return results;
                            }
                            break;
                        }
                    }
                }
            }
            // Compile and execute a filtering function if one is not provided
            // Provide `match` to avoid retokenization if we modified the selector above
            (compiled || compile(selector, match))(seed, context, !documentIsHTML, results, !context || rsibling.test(selector) && testContext(context.parentNode) || context);
            return results;
        }
        // One-time assignments
        // Support: Android <=4.0 - 4.1+
        // Sort stability
        support.sortStable = expando.split("").sort(sortOrder).join("") === expando;
        // Initialize against the default document
        setDocument();
        // Support: Android <=4.0 - 4.1+
        // Detached nodes confoundingly follow *each other*
        support.sortDetached = assert(function(el) {
            // Should return 1, but returns 4 (following)
            return el.compareDocumentPosition(document.createElement("fieldset")) & 1;
        });
        jQuery.find = find;
        // Deprecated
        jQuery.expr[":"] = jQuery.expr.pseudos;
        jQuery.unique = jQuery.uniqueSort;
        // These have always been private, but they used to be documented as part of
        // Sizzle so let's maintain them for now for backwards compatibility purposes.
        find.compile = compile;
        find.select = select;
        find.setDocument = setDocument;
        find.tokenize = tokenize;
        find.escape = jQuery.escapeSelector;
        find.getText = jQuery.text;
        find.isXML = jQuery.isXMLDoc;
        find.selectors = jQuery.expr;
        find.support = jQuery.support;
        find.uniqueSort = jQuery.uniqueSort;
    /* eslint-enable */ })();
    var dir = function dir(elem, dir, until) {
        var matched = [], truncate = until !== undefined;
        while((elem = elem[dir]) && elem.nodeType !== 9)if (elem.nodeType === 1) {
            if (truncate && jQuery(elem).is(until)) break;
            matched.push(elem);
        }
        return matched;
    };
    var siblings = function siblings(n, elem) {
        var matched = [];
        for(; n; n = n.nextSibling)if (n.nodeType === 1 && n !== elem) matched.push(n);
        return matched;
    };
    var rneedsContext = jQuery.expr.match.needsContext;
    var rsingleTag = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
    // Implement the identical functionality for filter and not
    function winnow(elements, qualifier, not) {
        if (isFunction(qualifier)) return jQuery.grep(elements, function(elem, i) {
            return !!qualifier.call(elem, i, elem) !== not;
        });
        // Single element
        if (qualifier.nodeType) return jQuery.grep(elements, function(elem) {
            return elem === qualifier !== not;
        });
        // Arraylike of elements (jQuery, arguments, Array)
        if (typeof qualifier !== "string") return jQuery.grep(elements, function(elem) {
            return indexOf.call(qualifier, elem) > -1 !== not;
        });
        // Filtered directly for both simple and complex selectors
        return jQuery.filter(qualifier, elements, not);
    }
    jQuery.filter = function(expr, elems, not) {
        var elem = elems[0];
        if (not) expr = ":not(" + expr + ")";
        if (elems.length === 1 && elem.nodeType === 1) return jQuery.find.matchesSelector(elem, expr) ? [
            elem
        ] : [];
        return jQuery.find.matches(expr, jQuery.grep(elems, function(elem) {
            return elem.nodeType === 1;
        }));
    };
    jQuery.fn.extend({
        find: function find(selector) {
            var i, ret, len = this.length, self = this;
            if (typeof selector !== "string") return this.pushStack(jQuery(selector).filter(function() {
                for(i = 0; i < len; i++){
                    if (jQuery.contains(self[i], this)) return true;
                }
            }));
            ret = this.pushStack([]);
            for(i = 0; i < len; i++)jQuery.find(selector, self[i], ret);
            return len > 1 ? jQuery.uniqueSort(ret) : ret;
        },
        filter: function filter(selector) {
            return this.pushStack(winnow(this, selector || [], false));
        },
        not: function not(selector) {
            return this.pushStack(winnow(this, selector || [], true));
        },
        is: function is(selector) {
            return !!winnow(this, // If this is a positional/relative selector, check membership in the returned set
            // so $("p:first").is("p:last") won't return true for a doc with two "p".
            typeof selector === "string" && rneedsContext.test(selector) ? jQuery(selector) : selector || [], false).length;
        }
    });
    // Initialize a jQuery object
    // A central reference to the root jQuery(document)
    var rootjQuery, // A simple way to check for HTML strings
    // Prioritize #id over <tag> to avoid XSS via location.hash (trac-9521)
    // Strict HTML recognition (trac-11290: must start with <)
    // Shortcut simple #id case for speed
    rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/, init = jQuery.fn.init = function init(selector, context, root) {
        var match, elem;
        // HANDLE: $(""), $(null), $(undefined), $(false)
        if (!selector) return this;
        // Method init() accepts an alternate rootjQuery
        // so migrate can support jQuery.sub (gh-2101)
        root = root || rootjQuery;
        // Handle HTML strings
        if (typeof selector === "string") {
            if (selector[0] === "<" && selector[selector.length - 1] === ">" && selector.length >= 3) // Assume that strings that start and end with <> are HTML and skip the regex check
            match = [
                null,
                selector,
                null
            ];
            else match = rquickExpr.exec(selector);
            // Match html or make sure no context is specified for #id
            if (match && (match[1] || !context)) {
                // HANDLE: $(html) -> $(array)
                if (match[1]) {
                    context = context instanceof jQuery ? context[0] : context;
                    // Option to run scripts is true for back-compat
                    // Intentionally let the error be thrown if parseHTML is not present
                    jQuery.merge(this, jQuery.parseHTML(match[1], context && context.nodeType ? context.ownerDocument || context : document, true));
                    // HANDLE: $(html, props)
                    if (rsingleTag.test(match[1]) && jQuery.isPlainObject(context)) {
                        for(match in context)// Properties of context are called as methods if possible
                        if (isFunction(this[match])) this[match](context[match]);
                        else this.attr(match, context[match]);
                    }
                    return this;
                // HANDLE: $(#id)
                } else {
                    elem = document.getElementById(match[2]);
                    if (elem) {
                        // Inject the element directly into the jQuery object
                        this[0] = elem;
                        this.length = 1;
                    }
                    return this;
                }
            } else if (!context || context.jquery) return (context || root).find(selector);
            else return this.constructor(context).find(selector);
        // HANDLE: $(DOMElement)
        } else if (selector.nodeType) {
            this[0] = selector;
            this.length = 1;
            return this;
        // HANDLE: $(function)
        // Shortcut for document ready
        } else if (isFunction(selector)) return root.ready !== undefined ? root.ready(selector) : // Execute immediately if ready is not present
        selector(jQuery);
        return jQuery.makeArray(selector, this);
    };
    // Give the init function the jQuery prototype for later instantiation
    init.prototype = jQuery.fn;
    // Initialize central reference
    rootjQuery = jQuery(document);
    var rparentsprev = /^(?:parents|prev(?:Until|All))/, // Methods guaranteed to produce a unique set when starting from a unique set
    guaranteedUnique = {
        children: true,
        contents: true,
        next: true,
        prev: true
    };
    jQuery.fn.extend({
        has: function has(target) {
            var targets = jQuery(target, this), l = targets.length;
            return this.filter(function() {
                var i = 0;
                for(; i < l; i++){
                    if (jQuery.contains(this, targets[i])) return true;
                }
            });
        },
        closest: function closest(selectors, context) {
            var cur, i = 0, l = this.length, matched = [], targets = typeof selectors !== "string" && jQuery(selectors);
            // Positional selectors never match, since there's no _selection_ context
            if (!rneedsContext.test(selectors)) for(; i < l; i++){
                for(cur = this[i]; cur && cur !== context; cur = cur.parentNode)// Always skip document fragments
                if (cur.nodeType < 11 && (targets ? targets.index(cur) > -1 : // Don't pass non-elements to jQuery#find
                cur.nodeType === 1 && jQuery.find.matchesSelector(cur, selectors))) {
                    matched.push(cur);
                    break;
                }
            }
            return this.pushStack(matched.length > 1 ? jQuery.uniqueSort(matched) : matched);
        },
        // Determine the position of an element within the set
        index: function index(elem) {
            // No argument, return index in parent
            if (!elem) return this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
            // Index in selector
            if (typeof elem === "string") return indexOf.call(jQuery(elem), this[0]);
            // Locate the position of the desired element
            return indexOf.call(this, // If it receives a jQuery object, the first element is used
            elem.jquery ? elem[0] : elem);
        },
        add: function add(selector, context) {
            return this.pushStack(jQuery.uniqueSort(jQuery.merge(this.get(), jQuery(selector, context))));
        },
        addBack: function addBack(selector) {
            return this.add(selector == null ? this.prevObject : this.prevObject.filter(selector));
        }
    });
    function sibling(cur, dir) {
        while((cur = cur[dir]) && cur.nodeType !== 1);
        return cur;
    }
    jQuery.each({
        parent: function parent(elem) {
            var parent = elem.parentNode;
            return parent && parent.nodeType !== 11 ? parent : null;
        },
        parents: function parents(elem) {
            return dir(elem, "parentNode");
        },
        parentsUntil: function parentsUntil(elem, _i, until) {
            return dir(elem, "parentNode", until);
        },
        next: function next(elem) {
            return sibling(elem, "nextSibling");
        },
        prev: function prev(elem) {
            return sibling(elem, "previousSibling");
        },
        nextAll: function nextAll(elem) {
            return dir(elem, "nextSibling");
        },
        prevAll: function prevAll(elem) {
            return dir(elem, "previousSibling");
        },
        nextUntil: function nextUntil(elem, _i, until) {
            return dir(elem, "nextSibling", until);
        },
        prevUntil: function prevUntil(elem, _i, until) {
            return dir(elem, "previousSibling", until);
        },
        siblings: function siblings1(elem) {
            return siblings((elem.parentNode || {}).firstChild, elem);
        },
        children: function children(elem) {
            return siblings(elem.firstChild);
        },
        contents: function contents(elem) {
            if (elem.contentDocument != null && // Support: IE 11+
            // <object> elements with no `data` attribute has an object
            // `contentDocument` with a `null` prototype.
            getProto(elem.contentDocument)) return elem.contentDocument;
            // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
            // Treat the template element as a regular one in browsers that
            // don't support it.
            if (nodeName(elem, "template")) elem = elem.content || elem;
            return jQuery.merge([], elem.childNodes);
        }
    }, function(name, fn) {
        jQuery.fn[name] = function(until, selector) {
            var matched = jQuery.map(this, fn, until);
            if (name.slice(-5) !== "Until") selector = until;
            if (selector && typeof selector === "string") matched = jQuery.filter(selector, matched);
            if (this.length > 1) {
                // Remove duplicates
                if (!guaranteedUnique[name]) jQuery.uniqueSort(matched);
                // Reverse order for parents* and prev-derivatives
                if (rparentsprev.test(name)) matched.reverse();
            }
            return this.pushStack(matched);
        };
    });
    var rnothtmlwhite = /[^\x20\t\r\n\f]+/g;
    // Convert String-formatted options into Object-formatted ones
    function createOptions(options) {
        var object = {};
        jQuery.each(options.match(rnothtmlwhite) || [], function(_, flag) {
            object[flag] = true;
        });
        return object;
    }
    /*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */ jQuery.Callbacks = function(options) {
        // Convert options from String-formatted to Object-formatted if needed
        // (we check in cache first)
        options = typeof options === "string" ? createOptions(options) : jQuery.extend({}, options);
        var firing, // Last fire value for non-forgettable lists
        memory, // Flag to know if list was already fired
        fired, // Flag to prevent firing
        locked, // Actual callback list
        list = [], // Queue of execution data for repeatable lists
        queue = [], // Index of currently firing callback (modified by add/remove as needed)
        firingIndex = -1, // Fire callbacks
        fire = function fire() {
            // Enforce single-firing
            locked = locked || options.once;
            // Execute callbacks for all pending executions,
            // respecting firingIndex overrides and runtime changes
            fired = firing = true;
            for(; queue.length; firingIndex = -1){
                memory = queue.shift();
                while(++firingIndex < list.length)// Run callback and check for early termination
                if (list[firingIndex].apply(memory[0], memory[1]) === false && options.stopOnFalse) {
                    // Jump to end and forget the data so .add doesn't re-fire
                    firingIndex = list.length;
                    memory = false;
                }
            }
            // Forget the data if we're done with it
            if (!options.memory) memory = false;
            firing = false;
            // Clean up if we're done firing for good
            if (locked) {
                // Keep an empty list if we have data for future add calls
                if (memory) list = [];
                else list = "";
            }
        }, // Actual Callbacks object
        self = {
            // Add a callback or a collection of callbacks to the list
            add: function add() {
                if (list) {
                    // If we have memory from a past run, we should fire after adding
                    if (memory && !firing) {
                        firingIndex = list.length - 1;
                        queue.push(memory);
                    }
                    (function add(args) {
                        jQuery.each(args, function(_, arg) {
                            if (isFunction(arg)) {
                                if (!options.unique || !self.has(arg)) list.push(arg);
                            } else if (arg && arg.length && toType(arg) !== "string") // Inspect recursively
                            add(arg);
                        });
                    })(arguments);
                    if (memory && !firing) fire();
                }
                return this;
            },
            // Remove a callback from the list
            remove: function remove() {
                jQuery.each(arguments, function(_, arg) {
                    var index;
                    while((index = jQuery.inArray(arg, list, index)) > -1){
                        list.splice(index, 1);
                        // Handle firing indexes
                        if (index <= firingIndex) firingIndex--;
                    }
                });
                return this;
            },
            // Check if a given callback is in the list.
            // If no argument is given, return whether or not list has callbacks attached.
            has: function has(fn) {
                return fn ? jQuery.inArray(fn, list) > -1 : list.length > 0;
            },
            // Remove all callbacks from the list
            empty: function empty() {
                if (list) list = [];
                return this;
            },
            // Disable .fire and .add
            // Abort any current/pending executions
            // Clear all callbacks and values
            disable: function disable() {
                locked = queue = [];
                list = memory = "";
                return this;
            },
            disabled: function disabled() {
                return !list;
            },
            // Disable .fire
            // Also disable .add unless we have memory (since it would have no effect)
            // Abort any pending executions
            lock: function lock() {
                locked = queue = [];
                if (!memory && !firing) list = memory = "";
                return this;
            },
            locked: function locked1() {
                return !!locked;
            },
            // Call all callbacks with the given context and arguments
            fireWith: function fireWith(context, args) {
                if (!locked) {
                    args = args || [];
                    args = [
                        context,
                        args.slice ? args.slice() : args
                    ];
                    queue.push(args);
                    if (!firing) fire();
                }
                return this;
            },
            // Call all the callbacks with the given arguments
            fire: function fire() {
                self.fireWith(this, arguments);
                return this;
            },
            // To know if the callbacks have already been called at least once
            fired: function fired1() {
                return !!fired;
            }
        };
        return self;
    };
    function Identity(v) {
        return v;
    }
    function Thrower(ex) {
        throw ex;
    }
    function adoptValue(value, resolve, reject, noValue) {
        var method;
        try {
            // Check for promise aspect first to privilege synchronous behavior
            if (value && isFunction(method = value.promise)) method.call(value).done(resolve).fail(reject);
            else if (value && isFunction(method = value.then)) method.call(value, resolve, reject);
            else // Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
            // * false: [ value ].slice( 0 ) => resolve( value )
            // * true: [ value ].slice( 1 ) => resolve()
            resolve.apply(undefined, [
                value
            ].slice(noValue));
        // For Promises/A+, convert exceptions into rejections
        // Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
        // Deferred#then to conditionally suppress rejection.
        } catch (value) {
            // Support: Android 4.0 only
            // Strict mode functions invoked without .call/.apply get global-object context
            reject.apply(undefined, [
                value
            ]);
        }
    }
    jQuery.extend({
        Deferred: function Deferred(func) {
            var tuples = [
                // action, add listener, callbacks,
                // ... .then handlers, argument index, [final state]
                [
                    "notify",
                    "progress",
                    jQuery.Callbacks("memory"),
                    jQuery.Callbacks("memory"),
                    2
                ],
                [
                    "resolve",
                    "done",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    0,
                    "resolved"
                ],
                [
                    "reject",
                    "fail",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    1,
                    "rejected"
                ]
            ], state = "pending", promise = {
                state: function state1() {
                    return state;
                },
                always: function always() {
                    deferred.done(arguments).fail(arguments);
                    return this;
                },
                "catch": function(fn) {
                    return promise.then(null, fn);
                },
                // Keep pipe for back-compat
                pipe: function pipe() {
                    var fns = arguments;
                    return jQuery.Deferred(function(newDefer) {
                        jQuery.each(tuples, function(_i, tuple) {
                            // Map tuples (progress, done, fail) to arguments (done, fail, progress)
                            var fn = isFunction(fns[tuple[4]]) && fns[tuple[4]];
                            // deferred.progress(function() { bind to newDefer or newDefer.notify })
                            // deferred.done(function() { bind to newDefer or newDefer.resolve })
                            // deferred.fail(function() { bind to newDefer or newDefer.reject })
                            deferred[tuple[1]](function() {
                                var returned = fn && fn.apply(this, arguments);
                                if (returned && isFunction(returned.promise)) returned.promise().progress(newDefer.notify).done(newDefer.resolve).fail(newDefer.reject);
                                else newDefer[tuple[0] + "With"](this, fn ? [
                                    returned
                                ] : arguments);
                            });
                        });
                        fns = null;
                    }).promise();
                },
                then: function then(onFulfilled, onRejected, onProgress) {
                    var maxDepth = 0;
                    function resolve(depth, deferred, handler, special) {
                        return function() {
                            var that = this, args = arguments, mightThrow = function mightThrow() {
                                var returned, then;
                                // Support: Promises/A+ section 2.3.3.3.3
                                // https://promisesaplus.com/#point-59
                                // Ignore double-resolution attempts
                                if (depth < maxDepth) return;
                                returned = handler.apply(that, args);
                                // Support: Promises/A+ section 2.3.1
                                // https://promisesaplus.com/#point-48
                                if (returned === deferred.promise()) throw new TypeError("Thenable self-resolution");
                                // Support: Promises/A+ sections 2.3.3.1, 3.5
                                // https://promisesaplus.com/#point-54
                                // https://promisesaplus.com/#point-75
                                // Retrieve `then` only once
                                then = returned && // Support: Promises/A+ section 2.3.4
                                // https://promisesaplus.com/#point-64
                                // Only check objects and functions for thenability
                                (typeof returned === "object" || typeof returned === "function") && returned.then;
                                // Handle a returned thenable
                                if (isFunction(then)) {
                                    // Special processors (notify) just wait for resolution
                                    if (special) then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special));
                                    else {
                                        // ...and disregard older resolution values
                                        maxDepth++;
                                        then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special), resolve(maxDepth, deferred, Identity, deferred.notifyWith));
                                    }
                                } else {
                                    // Only substitute handlers pass on context
                                    // and multiple values (non-spec behavior)
                                    if (handler !== Identity) {
                                        that = undefined;
                                        args = [
                                            returned
                                        ];
                                    }
                                    // Process the value(s)
                                    // Default process is resolve
                                    (special || deferred.resolveWith)(that, args);
                                }
                            }, // Only normal processors (resolve) catch and reject exceptions
                            process = special ? mightThrow : function process1() {
                                try {
                                    mightThrow();
                                } catch (e) {
                                    if (jQuery.Deferred.exceptionHook) jQuery.Deferred.exceptionHook(e, process.error);
                                    // Support: Promises/A+ section 2.3.3.3.4.1
                                    // https://promisesaplus.com/#point-61
                                    // Ignore post-resolution exceptions
                                    if (depth + 1 >= maxDepth) {
                                        // Only substitute handlers pass on context
                                        // and multiple values (non-spec behavior)
                                        if (handler !== Thrower) {
                                            that = undefined;
                                            args = [
                                                e
                                            ];
                                        }
                                        deferred.rejectWith(that, args);
                                    }
                                }
                            };
                            // Support: Promises/A+ section 2.3.3.3.1
                            // https://promisesaplus.com/#point-57
                            // Re-resolve promises immediately to dodge false rejection from
                            // subsequent errors
                            if (depth) process();
                            else {
                                // Call an optional hook to record the error, in case of exception
                                // since it's otherwise lost when execution goes async
                                if (jQuery.Deferred.getErrorHook) process.error = jQuery.Deferred.getErrorHook();
                                else if (jQuery.Deferred.getStackHook) process.error = jQuery.Deferred.getStackHook();
                                window1.setTimeout(process);
                            }
                        };
                    }
                    return jQuery.Deferred(function(newDefer) {
                        // progress_handlers.add( ... )
                        tuples[0][3].add(resolve(0, newDefer, isFunction(onProgress) ? onProgress : Identity, newDefer.notifyWith));
                        // fulfilled_handlers.add( ... )
                        tuples[1][3].add(resolve(0, newDefer, isFunction(onFulfilled) ? onFulfilled : Identity));
                        // rejected_handlers.add( ... )
                        tuples[2][3].add(resolve(0, newDefer, isFunction(onRejected) ? onRejected : Thrower));
                    }).promise();
                },
                // Get a promise for this deferred
                // If obj is provided, the promise aspect is added to the object
                promise: function promise1(obj) {
                    return obj != null ? jQuery.extend(obj, promise) : promise;
                }
            }, deferred = {};
            // Add list-specific methods
            jQuery.each(tuples, function(i, tuple) {
                var list = tuple[2], stateString = tuple[5];
                // promise.progress = list.add
                // promise.done = list.add
                // promise.fail = list.add
                promise[tuple[1]] = list.add;
                // Handle state
                if (stateString) list.add(function() {
                    // state = "resolved" (i.e., fulfilled)
                    // state = "rejected"
                    state = stateString;
                }, // rejected_callbacks.disable
                // fulfilled_callbacks.disable
                tuples[3 - i][2].disable, // rejected_handlers.disable
                // fulfilled_handlers.disable
                tuples[3 - i][3].disable, // progress_callbacks.lock
                tuples[0][2].lock, // progress_handlers.lock
                tuples[0][3].lock);
                // progress_handlers.fire
                // fulfilled_handlers.fire
                // rejected_handlers.fire
                list.add(tuple[3].fire);
                // deferred.notify = function() { deferred.notifyWith(...) }
                // deferred.resolve = function() { deferred.resolveWith(...) }
                // deferred.reject = function() { deferred.rejectWith(...) }
                deferred[tuple[0]] = function() {
                    deferred[tuple[0] + "With"](this === deferred ? undefined : this, arguments);
                    return this;
                };
                // deferred.notifyWith = list.fireWith
                // deferred.resolveWith = list.fireWith
                // deferred.rejectWith = list.fireWith
                deferred[tuple[0] + "With"] = list.fireWith;
            });
            // Make the deferred a promise
            promise.promise(deferred);
            // Call given func if any
            if (func) func.call(deferred, deferred);
            // All done!
            return deferred;
        },
        // Deferred helper
        when: function when(singleValue) {
            var // count of uncompleted subordinates
            remaining = arguments.length, // count of unprocessed arguments
            i = remaining, // subordinate fulfillment data
            resolveContexts = Array(i), resolveValues = slice.call(arguments), // the primary Deferred
            primary = jQuery.Deferred(), // subordinate callback factory
            updateFunc = function updateFunc(i) {
                return function(value) {
                    resolveContexts[i] = this;
                    resolveValues[i] = arguments.length > 1 ? slice.call(arguments) : value;
                    if (!--remaining) primary.resolveWith(resolveContexts, resolveValues);
                };
            };
            // Single- and empty arguments are adopted like Promise.resolve
            if (remaining <= 1) {
                adoptValue(singleValue, primary.done(updateFunc(i)).resolve, primary.reject, !remaining);
                // Use .then() to unwrap secondary thenables (cf. gh-3000)
                if (primary.state() === "pending" || isFunction(resolveValues[i] && resolveValues[i].then)) return primary.then();
            }
            // Multiple arguments are aggregated like Promise.all array elements
            while(i--)adoptValue(resolveValues[i], updateFunc(i), primary.reject);
            return primary.promise();
        }
    });
    // These usually indicate a programmer mistake during development,
    // warn about them ASAP rather than swallowing them by default.
    var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
    // If `jQuery.Deferred.getErrorHook` is defined, `asyncError` is an error
    // captured before the async barrier to get the original error cause
    // which may otherwise be hidden.
    jQuery.Deferred.exceptionHook = function(error, asyncError) {
        // Support: IE 8 - 9 only
        // Console exists when dev tools are open, which can happen at any time
        if (window1.console && window1.console.warn && error && rerrorNames.test(error.name)) window1.console.warn("jQuery.Deferred exception: " + error.message, error.stack, asyncError);
    };
    jQuery.readyException = function(error) {
        window1.setTimeout(function() {
            throw error;
        });
    };
    // The deferred used on DOM ready
    var readyList = jQuery.Deferred();
    jQuery.fn.ready = function(fn) {
        readyList.then(fn)// Wrap jQuery.readyException in a function so that the lookup
        // happens at the time of error handling instead of callback
        // registration.
        .catch(function(error) {
            jQuery.readyException(error);
        });
        return this;
    };
    jQuery.extend({
        // Is the DOM ready to be used? Set to true once it occurs.
        isReady: false,
        // A counter to track how many items to wait for before
        // the ready event fires. See trac-6781
        readyWait: 1,
        // Handle when the DOM is ready
        ready: function ready(wait) {
            // Abort if there are pending holds or we're already ready
            if (wait === true ? --jQuery.readyWait : jQuery.isReady) return;
            // Remember that the DOM is ready
            jQuery.isReady = true;
            // If a normal DOM Ready event fired, decrement, and wait if need be
            if (wait !== true && --jQuery.readyWait > 0) return;
            // If there are functions bound, to execute
            readyList.resolveWith(document, [
                jQuery
            ]);
        }
    });
    jQuery.ready.then = readyList.then;
    // The ready event handler and self cleanup method
    function completed() {
        document.removeEventListener("DOMContentLoaded", completed);
        window1.removeEventListener("load", completed);
        jQuery.ready();
    }
    // Catch cases where $(document).ready() is called
    // after the browser event has already occurred.
    // Support: IE <=9 - 10 only
    // Older IE sometimes signals "interactive" too soon
    if (document.readyState === "complete" || document.readyState !== "loading" && !document.documentElement.doScroll) // Handle it asynchronously to allow scripts the opportunity to delay ready
    window1.setTimeout(jQuery.ready);
    else {
        // Use the handy event callback
        document.addEventListener("DOMContentLoaded", completed);
        // A fallback to window.onload, that will always work
        window1.addEventListener("load", completed);
    }
    // Multifunctional method to get and set values of a collection
    // The value/s can optionally be executed if it's a function
    var access = function access1(elems, fn, key, value, chainable, emptyGet, raw) {
        var i = 0, len = elems.length, bulk = key == null;
        // Sets many values
        if (toType(key) === "object") {
            chainable = true;
            for(i in key)access(elems, fn, i, key[i], true, emptyGet, raw);
        // Sets one value
        } else if (value !== undefined) {
            chainable = true;
            if (!isFunction(value)) raw = true;
            if (bulk) {
                // Bulk operations run against the entire set
                if (raw) {
                    fn.call(elems, value);
                    fn = null;
                // ...except when executing function values
                } else {
                    bulk = fn;
                    fn = function fn(elem, _key, value) {
                        return bulk.call(jQuery(elem), value);
                    };
                }
            }
            if (fn) for(; i < len; i++)fn(elems[i], key, raw ? value : value.call(elems[i], i, fn(elems[i], key)));
        }
        if (chainable) return elems;
        // Gets
        if (bulk) return fn.call(elems);
        return len ? fn(elems[0], key) : emptyGet;
    };
    // Matches dashed string for camelizing
    var rmsPrefix = /^-ms-/, rdashAlpha = /-([a-z])/g;
    // Used by camelCase as callback to replace()
    function fcamelCase(_all, letter) {
        return letter.toUpperCase();
    }
    // Convert dashed to camelCase; used by the css and data modules
    // Support: IE <=9 - 11, Edge 12 - 15
    // Microsoft forgot to hump their vendor prefix (trac-9572)
    function camelCase(string) {
        return string.replace(rmsPrefix, "ms-").replace(rdashAlpha, fcamelCase);
    }
    var acceptData = function acceptData(owner) {
        // Accepts only:
        //  - Node
        //    - Node.ELEMENT_NODE
        //    - Node.DOCUMENT_NODE
        //  - Object
        //    - Any
        return owner.nodeType === 1 || owner.nodeType === 9 || !+owner.nodeType;
    };
    function Data() {
        this.expando = jQuery.expando + Data.uid++;
    }
    Data.uid = 1;
    Data.prototype = {
        cache: function cache(owner) {
            // Check if the owner object already has a cache
            var value = owner[this.expando];
            // If not, create one
            if (!value) {
                value = {};
                // We can accept data for non-element nodes in modern browsers,
                // but we should not, see trac-8335.
                // Always return an empty object.
                if (acceptData(owner)) {
                    // If it is a node unlikely to be stringify-ed or looped over
                    // use plain assignment
                    if (owner.nodeType) owner[this.expando] = value;
                    else Object.defineProperty(owner, this.expando, {
                        value: value,
                        configurable: true
                    });
                }
            }
            return value;
        },
        set: function set(owner, data, value) {
            var prop, cache = this.cache(owner);
            // Handle: [ owner, key, value ] args
            // Always use camelCase key (gh-2257)
            if (typeof data === "string") cache[camelCase(data)] = value;
            else // Copy the properties one-by-one to the cache object
            for(prop in data)cache[camelCase(prop)] = data[prop];
            return cache;
        },
        get: function get(owner, key) {
            return key === undefined ? this.cache(owner) : // Always use camelCase key (gh-2257)
            owner[this.expando] && owner[this.expando][camelCase(key)];
        },
        access: function access(owner, key, value) {
            // In cases where either:
            //
            //   1. No key was specified
            //   2. A string key was specified, but no value provided
            //
            // Take the "read" path and allow the get method to determine
            // which value to return, respectively either:
            //
            //   1. The entire cache object
            //   2. The data stored at the key
            //
            if (key === undefined || key && typeof key === "string" && value === undefined) return this.get(owner, key);
            // When the key is not a string, or both a key and value
            // are specified, set or extend (existing objects) with either:
            //
            //   1. An object of properties
            //   2. A key and value
            //
            this.set(owner, key, value);
            // Since the "set" path can have two possible entry points
            // return the expected data based on which path was taken[*]
            return value !== undefined ? value : key;
        },
        remove: function remove(owner, key) {
            var i, cache = owner[this.expando];
            if (cache === undefined) return;
            if (key !== undefined) {
                // Support array or space separated string of keys
                if (Array.isArray(key)) // If key is an array of keys...
                // We always set camelCase keys, so remove that.
                key = key.map(camelCase);
                else {
                    key = camelCase(key);
                    // If a key with the spaces exists, use it.
                    // Otherwise, create an array by matching non-whitespace
                    key = key in cache ? [
                        key
                    ] : key.match(rnothtmlwhite) || [];
                }
                i = key.length;
                while(i--)delete cache[key[i]];
            }
            // Remove the expando if there's no more data
            if (key === undefined || jQuery.isEmptyObject(cache)) {
                // Support: Chrome <=35 - 45
                // Webkit & Blink performance suffers when deleting properties
                // from DOM nodes, so set to undefined instead
                // https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
                if (owner.nodeType) owner[this.expando] = undefined;
                else delete owner[this.expando];
            }
        },
        hasData: function hasData(owner) {
            var cache = owner[this.expando];
            return cache !== undefined && !jQuery.isEmptyObject(cache);
        }
    };
    var dataPriv = new Data();
    var dataUser = new Data();
    //	Implementation Summary
    //
    //	1. Enforce API surface and semantic compatibility with 1.9.x branch
    //	2. Improve the module's maintainability by reducing the storage
    //		paths to a single mechanism.
    //	3. Use the same single mechanism to support "private" and "user" data.
    //	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
    //	5. Avoid exposing implementation details on user objects (eg. expando properties)
    //	6. Provide a clear path for implementation upgrade to WeakMap in 2014
    var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/, rmultiDash = /[A-Z]/g;
    function getData(data) {
        if (data === "true") return true;
        if (data === "false") return false;
        if (data === "null") return null;
        // Only convert to a number if it doesn't change the string
        if (data === +data + "") return +data;
        if (rbrace.test(data)) return JSON.parse(data);
        return data;
    }
    function dataAttr(elem, key, data) {
        var name;
        // If nothing was found internally, try to fetch any
        // data from the HTML5 data-* attribute
        if (data === undefined && elem.nodeType === 1) {
            name = "data-" + key.replace(rmultiDash, "-$&").toLowerCase();
            data = elem.getAttribute(name);
            if (typeof data === "string") {
                try {
                    data = getData(data);
                } catch (e) {}
                // Make sure we set the data so it isn't changed later
                dataUser.set(elem, key, data);
            } else data = undefined;
        }
        return data;
    }
    jQuery.extend({
        hasData: function hasData(elem) {
            return dataUser.hasData(elem) || dataPriv.hasData(elem);
        },
        data: function data(elem, name, data) {
            return dataUser.access(elem, name, data);
        },
        removeData: function removeData(elem, name) {
            dataUser.remove(elem, name);
        },
        // TODO: Now that all calls to _data and _removeData have been replaced
        // with direct calls to dataPriv methods, these can be deprecated.
        _data: function _data(elem, name, data) {
            return dataPriv.access(elem, name, data);
        },
        _removeData: function _removeData(elem, name) {
            dataPriv.remove(elem, name);
        }
    });
    jQuery.fn.extend({
        data: function data(key, value) {
            var i, name, data, elem = this[0], attrs = elem && elem.attributes;
            // Gets all values
            if (key === undefined) {
                if (this.length) {
                    data = dataUser.get(elem);
                    if (elem.nodeType === 1 && !dataPriv.get(elem, "hasDataAttrs")) {
                        i = attrs.length;
                        while(i--)// Support: IE 11 only
                        // The attrs elements can be null (trac-14894)
                        if (attrs[i]) {
                            name = attrs[i].name;
                            if (name.indexOf("data-") === 0) {
                                name = camelCase(name.slice(5));
                                dataAttr(elem, name, data[name]);
                            }
                        }
                        dataPriv.set(elem, "hasDataAttrs", true);
                    }
                }
                return data;
            }
            // Sets multiple values
            if (typeof key === "object") return this.each(function() {
                dataUser.set(this, key);
            });
            return access(this, function(value) {
                var data;
                // The calling jQuery object (element matches) is not empty
                // (and therefore has an element appears at this[ 0 ]) and the
                // `value` parameter was not undefined. An empty jQuery object
                // will result in `undefined` for elem = this[ 0 ] which will
                // throw an exception if an attempt to read a data cache is made.
                if (elem && value === undefined) {
                    // Attempt to get data from the cache
                    // The key will always be camelCased in Data
                    data = dataUser.get(elem, key);
                    if (data !== undefined) return data;
                    // Attempt to "discover" the data in
                    // HTML5 custom data-* attrs
                    data = dataAttr(elem, key);
                    if (data !== undefined) return data;
                    // We tried really hard, but the data doesn't exist.
                    return;
                }
                // Set the data...
                this.each(function() {
                    // We always store the camelCased key
                    dataUser.set(this, key, value);
                });
            }, null, value, arguments.length > 1, null, true);
        },
        removeData: function removeData(key) {
            return this.each(function() {
                dataUser.remove(this, key);
            });
        }
    });
    jQuery.extend({
        queue: function queue(elem, type, data) {
            var queue;
            if (elem) {
                type = (type || "fx") + "queue";
                queue = dataPriv.get(elem, type);
                // Speed up dequeue by getting out quickly if this is just a lookup
                if (data) {
                    if (!queue || Array.isArray(data)) queue = dataPriv.access(elem, type, jQuery.makeArray(data));
                    else queue.push(data);
                }
                return queue || [];
            }
        },
        dequeue: function dequeue(elem, type) {
            type = type || "fx";
            var queue = jQuery.queue(elem, type), startLength = queue.length, fn = queue.shift(), hooks = jQuery._queueHooks(elem, type), next = function next() {
                jQuery.dequeue(elem, type);
            };
            // If the fx queue is dequeued, always remove the progress sentinel
            if (fn === "inprogress") {
                fn = queue.shift();
                startLength--;
            }
            if (fn) {
                // Add a progress sentinel to prevent the fx queue from being
                // automatically dequeued
                if (type === "fx") queue.unshift("inprogress");
                // Clear up the last queue stop function
                delete hooks.stop;
                fn.call(elem, next, hooks);
            }
            if (!startLength && hooks) hooks.empty.fire();
        },
        // Not public - generate a queueHooks object, or return the current one
        _queueHooks: function _queueHooks(elem, type) {
            var key = type + "queueHooks";
            return dataPriv.get(elem, key) || dataPriv.access(elem, key, {
                empty: jQuery.Callbacks("once memory").add(function() {
                    dataPriv.remove(elem, [
                        type + "queue",
                        key
                    ]);
                })
            });
        }
    });
    jQuery.fn.extend({
        queue: function queue(type, data) {
            var setter = 2;
            if (typeof type !== "string") {
                data = type;
                type = "fx";
                setter--;
            }
            if (arguments.length < setter) return jQuery.queue(this[0], type);
            return data === undefined ? this : this.each(function() {
                var queue = jQuery.queue(this, type, data);
                // Ensure a hooks for this queue
                jQuery._queueHooks(this, type);
                if (type === "fx" && queue[0] !== "inprogress") jQuery.dequeue(this, type);
            });
        },
        dequeue: function dequeue(type) {
            return this.each(function() {
                jQuery.dequeue(this, type);
            });
        },
        clearQueue: function clearQueue(type) {
            return this.queue(type || "fx", []);
        },
        // Get a promise resolved when queues of a certain type
        // are emptied (fx is the type by default)
        promise: function promise(type, obj) {
            var tmp, count = 1, defer = jQuery.Deferred(), elements = this, i = this.length, resolve = function resolve() {
                if (!--count) defer.resolveWith(elements, [
                    elements
                ]);
            };
            if (typeof type !== "string") {
                obj = type;
                type = undefined;
            }
            type = type || "fx";
            while(i--){
                tmp = dataPriv.get(elements[i], type + "queueHooks");
                if (tmp && tmp.empty) {
                    count++;
                    tmp.empty.add(resolve);
                }
            }
            resolve();
            return defer.promise(obj);
        }
    });
    var pnum = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source;
    var rcssNum = new RegExp("^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i");
    var cssExpand = [
        "Top",
        "Right",
        "Bottom",
        "Left"
    ];
    var documentElement = document.documentElement;
    var isAttached = function isAttached(elem) {
        return jQuery.contains(elem.ownerDocument, elem);
    }, composed = {
        composed: true
    };
    // Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
    // Check attachment across shadow DOM boundaries when possible (gh-3504)
    // Support: iOS 10.0-10.2 only
    // Early iOS 10 versions support `attachShadow` but not `getRootNode`,
    // leading to errors. We need to check for `getRootNode`.
    if (documentElement.getRootNode) isAttached = function isAttached(elem) {
        return jQuery.contains(elem.ownerDocument, elem) || elem.getRootNode(composed) === elem.ownerDocument;
    };
    var isHiddenWithinTree = function isHiddenWithinTree(elem, el) {
        // isHiddenWithinTree might be called from jQuery#filter function;
        // in that case, element will be second argument
        elem = el || elem;
        // Inline style trumps all
        return elem.style.display === "none" || elem.style.display === "" && // Otherwise, check computed style
        // Support: Firefox <=43 - 45
        // Disconnected elements can have computed display: none, so first confirm that elem is
        // in the document.
        isAttached(elem) && jQuery.css(elem, "display") === "none";
    };
    function adjustCSS(elem, prop, valueParts, tween) {
        var adjusted, scale, maxIterations = 20, currentValue = tween ? function currentValue() {
            return tween.cur();
        } : function() {
            return jQuery.css(elem, prop, "");
        }, initial = currentValue(), unit = valueParts && valueParts[3] || (jQuery.cssNumber[prop] ? "" : "px"), // Starting value computation is required for potential unit mismatches
        initialInUnit = elem.nodeType && (jQuery.cssNumber[prop] || unit !== "px" && +initial) && rcssNum.exec(jQuery.css(elem, prop));
        if (initialInUnit && initialInUnit[3] !== unit) {
            // Support: Firefox <=54
            // Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
            initial = initial / 2;
            // Trust units reported by jQuery.css
            unit = unit || initialInUnit[3];
            // Iteratively approximate from a nonzero starting point
            initialInUnit = +initial || 1;
            while(maxIterations--){
                // Evaluate and update our best guess (doubling guesses that zero out).
                // Finish if the scale equals or crosses 1 (making the old*new product non-positive).
                jQuery.style(elem, prop, initialInUnit + unit);
                if ((1 - scale) * (1 - (scale = currentValue() / initial || 0.5)) <= 0) maxIterations = 0;
                initialInUnit = initialInUnit / scale;
            }
            initialInUnit = initialInUnit * 2;
            jQuery.style(elem, prop, initialInUnit + unit);
            // Make sure we update the tween properties later on
            valueParts = valueParts || [];
        }
        if (valueParts) {
            initialInUnit = +initialInUnit || +initial || 0;
            // Apply relative offset (+=/-=) if specified
            adjusted = valueParts[1] ? initialInUnit + (valueParts[1] + 1) * valueParts[2] : +valueParts[2];
            if (tween) {
                tween.unit = unit;
                tween.start = initialInUnit;
                tween.end = adjusted;
            }
        }
        return adjusted;
    }
    var defaultDisplayMap = {};
    function getDefaultDisplay(elem) {
        var temp, doc = elem.ownerDocument, _$nodeName = elem.nodeName, display = defaultDisplayMap[_$nodeName];
        if (display) return display;
        temp = doc.body.appendChild(doc.createElement(_$nodeName));
        display = jQuery.css(temp, "display");
        temp.parentNode.removeChild(temp);
        if (display === "none") display = "block";
        defaultDisplayMap[_$nodeName] = display;
        return display;
    }
    function showHide(elements, show) {
        var display, elem, values = [], index = 0, length = elements.length;
        // Determine new display value for elements that need to change
        for(; index < length; index++){
            elem = elements[index];
            if (!elem.style) continue;
            display = elem.style.display;
            if (show) {
                // Since we force visibility upon cascade-hidden elements, an immediate (and slow)
                // check is required in this first loop unless we have a nonempty display value (either
                // inline or about-to-be-restored)
                if (display === "none") {
                    values[index] = dataPriv.get(elem, "display") || null;
                    if (!values[index]) elem.style.display = "";
                }
                if (elem.style.display === "" && isHiddenWithinTree(elem)) values[index] = getDefaultDisplay(elem);
            } else if (display !== "none") {
                values[index] = "none";
                // Remember what we're overwriting
                dataPriv.set(elem, "display", display);
            }
        }
        // Set the display of the elements in a second loop to avoid constant reflow
        for(index = 0; index < length; index++)if (values[index] != null) elements[index].style.display = values[index];
        return elements;
    }
    jQuery.fn.extend({
        show: function show() {
            return showHide(this, true);
        },
        hide: function hide() {
            return showHide(this);
        },
        toggle: function toggle(state) {
            if (typeof state === "boolean") return state ? this.show() : this.hide();
            return this.each(function() {
                if (isHiddenWithinTree(this)) jQuery(this).show();
                else jQuery(this).hide();
            });
        }
    });
    var rcheckableType = /^(?:checkbox|radio)$/i;
    var rtagName = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i;
    var rscriptType = /^$|^module$|\/(?:java|ecma)script/i;
    (function() {
        var fragment = document.createDocumentFragment(), div = fragment.appendChild(document.createElement("div")), input = document.createElement("input");
        // Support: Android 4.0 - 4.3 only
        // Check state lost if the name is set (trac-11217)
        // Support: Windows Web Apps (WWA)
        // `name` and `type` must use .setAttribute for WWA (trac-14901)
        input.setAttribute("type", "radio");
        input.setAttribute("checked", "checked");
        input.setAttribute("name", "t");
        div.appendChild(input);
        // Support: Android <=4.1 only
        // Older WebKit doesn't clone checked state correctly in fragments
        support.checkClone = div.cloneNode(true).cloneNode(true).lastChild.checked;
        // Support: IE <=11 only
        // Make sure textarea (and checkbox) defaultValue is properly cloned
        div.innerHTML = "<textarea>x</textarea>";
        support.noCloneChecked = !!div.cloneNode(true).lastChild.defaultValue;
        // Support: IE <=9 only
        // IE <=9 replaces <option> tags with their contents when inserted outside of
        // the select element.
        div.innerHTML = "<option></option>";
        support.option = !!div.lastChild;
    })();
    // We have to close these tags to support XHTML (trac-13200)
    var wrapMap = {
        // XHTML parsers do not magically insert elements in the
        // same way that tag soup parsers do. So we cannot shorten
        // this by omitting <tbody> or other required elements.
        thead: [
            1,
            "<table>",
            "</table>"
        ],
        col: [
            2,
            "<table><colgroup>",
            "</colgroup></table>"
        ],
        tr: [
            2,
            "<table><tbody>",
            "</tbody></table>"
        ],
        td: [
            3,
            "<table><tbody><tr>",
            "</tr></tbody></table>"
        ],
        _default: [
            0,
            "",
            ""
        ]
    };
    wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
    wrapMap.th = wrapMap.td;
    // Support: IE <=9 only
    if (!support.option) wrapMap.optgroup = wrapMap.option = [
        1,
        "<select multiple='multiple'>",
        "</select>"
    ];
    function getAll(context, tag) {
        // Support: IE <=9 - 11 only
        // Use typeof to avoid zero-argument method invocation on host objects (trac-15151)
        var ret;
        if (typeof context.getElementsByTagName !== "undefined") ret = context.getElementsByTagName(tag || "*");
        else if (typeof context.querySelectorAll !== "undefined") ret = context.querySelectorAll(tag || "*");
        else ret = [];
        if (tag === undefined || tag && nodeName(context, tag)) return jQuery.merge([
            context
        ], ret);
        return ret;
    }
    // Mark scripts as having already been evaluated
    function setGlobalEval(elems, refElements) {
        var i = 0, l = elems.length;
        for(; i < l; i++)dataPriv.set(elems[i], "globalEval", !refElements || dataPriv.get(refElements[i], "globalEval"));
    }
    var rhtml = /<|&#?\w+;/;
    function buildFragment(elems, context, scripts, selection, ignored) {
        var elem, tmp, tag, wrap, attached, j, fragment = context.createDocumentFragment(), nodes = [], i = 0, l = elems.length;
        for(; i < l; i++){
            elem = elems[i];
            if (elem || elem === 0) {
                // Add nodes directly
                if (toType(elem) === "object") // Support: Android <=4.0 only, PhantomJS 1 only
                // push.apply(_, arraylike) throws on ancient WebKit
                jQuery.merge(nodes, elem.nodeType ? [
                    elem
                ] : elem);
                else if (!rhtml.test(elem)) nodes.push(context.createTextNode(elem));
                else {
                    tmp = tmp || fragment.appendChild(context.createElement("div"));
                    // Deserialize a standard representation
                    tag = (rtagName.exec(elem) || [
                        "",
                        ""
                    ])[1].toLowerCase();
                    wrap = wrapMap[tag] || wrapMap._default;
                    tmp.innerHTML = wrap[1] + jQuery.htmlPrefilter(elem) + wrap[2];
                    // Descend through wrappers to the right content
                    j = wrap[0];
                    while(j--)tmp = tmp.lastChild;
                    // Support: Android <=4.0 only, PhantomJS 1 only
                    // push.apply(_, arraylike) throws on ancient WebKit
                    jQuery.merge(nodes, tmp.childNodes);
                    // Remember the top-level container
                    tmp = fragment.firstChild;
                    // Ensure the created nodes are orphaned (trac-12392)
                    tmp.textContent = "";
                }
            }
        }
        // Remove wrapper from fragment
        fragment.textContent = "";
        i = 0;
        while(elem = nodes[i++]){
            // Skip elements already in the context collection (trac-4087)
            if (selection && jQuery.inArray(elem, selection) > -1) {
                if (ignored) ignored.push(elem);
                continue;
            }
            attached = isAttached(elem);
            // Append to fragment
            tmp = getAll(fragment.appendChild(elem), "script");
            // Preserve script evaluation history
            if (attached) setGlobalEval(tmp);
            // Capture executables
            if (scripts) {
                j = 0;
                while(elem = tmp[j++])if (rscriptType.test(elem.type || "")) scripts.push(elem);
            }
        }
        return fragment;
    }
    var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
    function returnTrue() {
        return true;
    }
    function returnFalse() {
        return false;
    }
    function on(elem, types, selector, data, fn, one) {
        var origFn, type;
        // Types can be a map of types/handlers
        if (typeof types === "object") {
            // ( types-Object, selector, data )
            if (typeof selector !== "string") {
                // ( types-Object, data )
                data = data || selector;
                selector = undefined;
            }
            for(type in types)on(elem, type, selector, data, types[type], one);
            return elem;
        }
        if (data == null && fn == null) {
            // ( types, fn )
            fn = selector;
            data = selector = undefined;
        } else if (fn == null) {
            if (typeof selector === "string") {
                // ( types, selector, fn )
                fn = data;
                data = undefined;
            } else {
                // ( types, data, fn )
                fn = data;
                data = selector;
                selector = undefined;
            }
        }
        if (fn === false) fn = returnFalse;
        else if (!fn) return elem;
        if (one === 1) {
            origFn = fn;
            fn = function fn(event) {
                // Can use an empty set, since event contains the info
                jQuery().off(event);
                return origFn.apply(this, arguments);
            };
            // Use same guid so caller can remove using origFn
            fn.guid = origFn.guid || (origFn.guid = jQuery.guid++);
        }
        return elem.each(function() {
            jQuery.event.add(this, types, fn, data, selector);
        });
    }
    /*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */ jQuery.event = {
        global: {},
        add: function add(elem, types, handler, data, selector) {
            var handleObjIn, eventHandle, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.get(elem);
            // Only attach events to objects that accept data
            if (!acceptData(elem)) return;
            // Caller can pass in an object of custom data in lieu of the handler
            if (handler.handler) {
                handleObjIn = handler;
                handler = handleObjIn.handler;
                selector = handleObjIn.selector;
            }
            // Ensure that invalid selectors throw exceptions at attach time
            // Evaluate against documentElement in case elem is a non-element node (e.g., document)
            if (selector) jQuery.find.matchesSelector(documentElement, selector);
            // Make sure that the handler has a unique ID, used to find/remove it later
            if (!handler.guid) handler.guid = jQuery.guid++;
            // Init the element's event structure and main handler, if this is the first
            if (!(events = elemData.events)) events = elemData.events = Object.create(null);
            if (!(eventHandle = elemData.handle)) eventHandle = elemData.handle = function eventHandle(e) {
                // Discard the second event of a jQuery.event.trigger() and
                // when an event is called after a page has unloaded
                return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ? jQuery.event.dispatch.apply(elem, arguments) : undefined;
            };
            // Handle multiple events separated by a space
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // There *must* be a type, no attaching namespace-only handlers
                if (!type) continue;
                // If event changes its type, use the special event handlers for the changed type
                special = jQuery.event.special[type] || {};
                // If selector defined, determine special event api type, otherwise given type
                type = (selector ? special.delegateType : special.bindType) || type;
                // Update special based on newly reset type
                special = jQuery.event.special[type] || {};
                // handleObj is passed to all event handlers
                handleObj = jQuery.extend({
                    type: type,
                    origType: origType,
                    data: data,
                    handler: handler,
                    guid: handler.guid,
                    selector: selector,
                    needsContext: selector && jQuery.expr.match.needsContext.test(selector),
                    namespace: namespaces.join(".")
                }, handleObjIn);
                // Init the event handler queue if we're the first
                if (!(handlers = events[type])) {
                    handlers = events[type] = [];
                    handlers.delegateCount = 0;
                    // Only use addEventListener if the special events handler returns false
                    if (!special.setup || special.setup.call(elem, data, namespaces, eventHandle) === false) {
                        if (elem.addEventListener) elem.addEventListener(type, eventHandle);
                    }
                }
                if (special.add) {
                    special.add.call(elem, handleObj);
                    if (!handleObj.handler.guid) handleObj.handler.guid = handler.guid;
                }
                // Add to the element's handler list, delegates in front
                if (selector) handlers.splice(handlers.delegateCount++, 0, handleObj);
                else handlers.push(handleObj);
                // Keep track of which events have ever been used, for event optimization
                jQuery.event.global[type] = true;
            }
        },
        // Detach an event or set of events from an element
        remove: function remove(elem, types, handler, selector, mappedTypes) {
            var j, origCount, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.hasData(elem) && dataPriv.get(elem);
            if (!elemData || !(events = elemData.events)) return;
            // Once for each type.namespace in types; type may be omitted
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // Unbind all events (on this namespace, if provided) for the element
                if (!type) {
                    for(type in events)jQuery.event.remove(elem, type + types[t], handler, selector, true);
                    continue;
                }
                special = jQuery.event.special[type] || {};
                type = (selector ? special.delegateType : special.bindType) || type;
                handlers = events[type] || [];
                tmp = tmp[2] && new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)");
                // Remove matching events
                origCount = j = handlers.length;
                while(j--){
                    handleObj = handlers[j];
                    if ((mappedTypes || origType === handleObj.origType) && (!handler || handler.guid === handleObj.guid) && (!tmp || tmp.test(handleObj.namespace)) && (!selector || selector === handleObj.selector || selector === "**" && handleObj.selector)) {
                        handlers.splice(j, 1);
                        if (handleObj.selector) handlers.delegateCount--;
                        if (special.remove) special.remove.call(elem, handleObj);
                    }
                }
                // Remove generic event handler if we removed something and no more handlers exist
                // (avoids potential for endless recursion during removal of special event handlers)
                if (origCount && !handlers.length) {
                    if (!special.teardown || special.teardown.call(elem, namespaces, elemData.handle) === false) jQuery.removeEvent(elem, type, elemData.handle);
                    delete events[type];
                }
            }
            // Remove data and the expando if it's no longer used
            if (jQuery.isEmptyObject(events)) dataPriv.remove(elem, "handle events");
        },
        dispatch: function dispatch(nativeEvent) {
            var i, j, ret, matched, handleObj, handlerQueue, args = new Array(arguments.length), // Make a writable jQuery.Event from the native event object
            event = jQuery.event.fix(nativeEvent), handlers = (dataPriv.get(this, "events") || Object.create(null))[event.type] || [], special = jQuery.event.special[event.type] || {};
            // Use the fix-ed jQuery.Event rather than the (read-only) native event
            args[0] = event;
            for(i = 1; i < arguments.length; i++)args[i] = arguments[i];
            event.delegateTarget = this;
            // Call the preDispatch hook for the mapped type, and let it bail if desired
            if (special.preDispatch && special.preDispatch.call(this, event) === false) return;
            // Determine handlers
            handlerQueue = jQuery.event.handlers.call(this, event, handlers);
            // Run delegates first; they may want to stop propagation beneath us
            i = 0;
            while((matched = handlerQueue[i++]) && !event.isPropagationStopped()){
                event.currentTarget = matched.elem;
                j = 0;
                while((handleObj = matched.handlers[j++]) && !event.isImmediatePropagationStopped())// If the event is namespaced, then each handler is only invoked if it is
                // specially universal or its namespaces are a superset of the event's.
                if (!event.rnamespace || handleObj.namespace === false || event.rnamespace.test(handleObj.namespace)) {
                    event.handleObj = handleObj;
                    event.data = handleObj.data;
                    ret = ((jQuery.event.special[handleObj.origType] || {}).handle || handleObj.handler).apply(matched.elem, args);
                    if (ret !== undefined) {
                        if ((event.result = ret) === false) {
                            event.preventDefault();
                            event.stopPropagation();
                        }
                    }
                }
            }
            // Call the postDispatch hook for the mapped type
            if (special.postDispatch) special.postDispatch.call(this, event);
            return event.result;
        },
        handlers: function handlers(event, handlers) {
            var i, handleObj, sel, matchedHandlers, matchedSelectors, handlerQueue = [], delegateCount = handlers.delegateCount, cur = event.target;
            // Find delegate handlers
            if (delegateCount && // Support: IE <=9
            // Black-hole SVG <use> instance trees (trac-13180)
            cur.nodeType && // Support: Firefox <=42
            // Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
            // https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
            // Support: IE 11 only
            // ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
            !(event.type === "click" && event.button >= 1)) {
                for(; cur !== this; cur = cur.parentNode || this)// Don't check non-elements (trac-13208)
                // Don't process clicks on disabled elements (trac-6911, trac-8165, trac-11382, trac-11764)
                if (cur.nodeType === 1 && !(event.type === "click" && cur.disabled === true)) {
                    matchedHandlers = [];
                    matchedSelectors = {};
                    for(i = 0; i < delegateCount; i++){
                        handleObj = handlers[i];
                        // Don't conflict with Object.prototype properties (trac-13203)
                        sel = handleObj.selector + " ";
                        if (matchedSelectors[sel] === undefined) matchedSelectors[sel] = handleObj.needsContext ? jQuery(sel, this).index(cur) > -1 : jQuery.find(sel, this, null, [
                            cur
                        ]).length;
                        if (matchedSelectors[sel]) matchedHandlers.push(handleObj);
                    }
                    if (matchedHandlers.length) handlerQueue.push({
                        elem: cur,
                        handlers: matchedHandlers
                    });
                }
            }
            // Add the remaining (directly-bound) handlers
            cur = this;
            if (delegateCount < handlers.length) handlerQueue.push({
                elem: cur,
                handlers: handlers.slice(delegateCount)
            });
            return handlerQueue;
        },
        addProp: function addProp(name, hook) {
            Object.defineProperty(jQuery.Event.prototype, name, {
                enumerable: true,
                configurable: true,
                get: isFunction(hook) ? function() {
                    if (this.originalEvent) return hook(this.originalEvent);
                } : function() {
                    if (this.originalEvent) return this.originalEvent[name];
                },
                set: function set(value) {
                    Object.defineProperty(this, name, {
                        enumerable: true,
                        configurable: true,
                        writable: true,
                        value: value
                    });
                }
            });
        },
        fix: function fix(originalEvent) {
            return originalEvent[jQuery.expando] ? originalEvent : new jQuery.Event(originalEvent);
        },
        special: {
            load: {
                // Prevent triggered image.load events from bubbling to window.load
                noBubble: true
            },
            click: {
                // Utilize native event to ensure correct state for checkable inputs
                setup: function setup(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Claim the first handler
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) // dataPriv.set( el, "click", ... )
                    leverageNative(el, "click", true);
                    // Return false to allow normal processing in the caller
                    return false;
                },
                trigger: function trigger(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Force setup before triggering a click
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) leverageNative(el, "click");
                    // Return non-false to allow normal event-path propagation
                    return true;
                },
                // For cross-browser consistency, suppress native .click() on links
                // Also prevent it if we're currently inside a leveraged native-event stack
                _default: function _default(event) {
                    var target = event.target;
                    return rcheckableType.test(target.type) && target.click && nodeName(target, "input") && dataPriv.get(target, "click") || nodeName(target, "a");
                }
            },
            beforeunload: {
                postDispatch: function postDispatch(event) {
                    // Support: Firefox 20+
                    // Firefox doesn't alert if the returnValue field is not set.
                    if (event.result !== undefined && event.originalEvent) event.originalEvent.returnValue = event.result;
                }
            }
        }
    };
    // Ensure the presence of an event listener that handles manually-triggered
    // synthetic events by interrupting progress until reinvoked in response to
    // *native* events that it fires directly, ensuring that state changes have
    // already occurred before other listeners are invoked.
    function leverageNative(el, type, isSetup) {
        // Missing `isSetup` indicates a trigger call, which must force setup through jQuery.event.add
        if (!isSetup) {
            if (dataPriv.get(el, type) === undefined) jQuery.event.add(el, type, returnTrue);
            return;
        }
        // Register the controller as a special universal handler for all event namespaces
        dataPriv.set(el, type, false);
        jQuery.event.add(el, type, {
            namespace: false,
            handler: function handler(event) {
                var result, saved = dataPriv.get(this, type);
                if (event.isTrigger & 1 && this[type]) {
                    // Interrupt processing of the outer synthetic .trigger()ed event
                    if (!saved) {
                        // Store arguments for use when handling the inner native event
                        // There will always be at least one argument (an event object), so this array
                        // will not be confused with a leftover capture object.
                        saved = slice.call(arguments);
                        dataPriv.set(this, type, saved);
                        // Trigger the native event and capture its result
                        this[type]();
                        result = dataPriv.get(this, type);
                        dataPriv.set(this, type, false);
                        if (saved !== result) {
                            // Cancel the outer synthetic event
                            event.stopImmediatePropagation();
                            event.preventDefault();
                            return result;
                        }
                    // If this is an inner synthetic event for an event with a bubbling surrogate
                    // (focus or blur), assume that the surrogate already propagated from triggering
                    // the native event and prevent that from happening again here.
                    // This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
                    // bubbling surrogate propagates *after* the non-bubbling base), but that seems
                    // less bad than duplication.
                    } else if ((jQuery.event.special[type] || {}).delegateType) event.stopPropagation();
                // If this is a native event triggered above, everything is now in order
                // Fire an inner synthetic event with the original arguments
                } else if (saved) {
                    // ...and capture the result
                    dataPriv.set(this, type, jQuery.event.trigger(saved[0], saved.slice(1), this));
                    // Abort handling of the native event by all jQuery handlers while allowing
                    // native handlers on the same element to run. On target, this is achieved
                    // by stopping immediate propagation just on the jQuery event. However,
                    // the native event is re-wrapped by a jQuery one on each level of the
                    // propagation so the only way to stop it for jQuery is to stop it for
                    // everyone via native `stopPropagation()`. This is not a problem for
                    // focus/blur which don't bubble, but it does also stop click on checkboxes
                    // and radios. We accept this limitation.
                    event.stopPropagation();
                    event.isImmediatePropagationStopped = returnTrue;
                }
            }
        });
    }
    jQuery.removeEvent = function(elem, type, handle) {
        // This "if" is needed for plain objects
        if (elem.removeEventListener) elem.removeEventListener(type, handle);
    };
    jQuery.Event = function(src, props) {
        // Allow instantiation without the 'new' keyword
        if (!(this instanceof jQuery.Event)) return new jQuery.Event(src, props);
        // Event object
        if (src && src.type) {
            this.originalEvent = src;
            this.type = src.type;
            // Events bubbling up the document may have been marked as prevented
            // by a handler lower down the tree; reflect the correct value.
            this.isDefaultPrevented = src.defaultPrevented || src.defaultPrevented === undefined && // Support: Android <=2.3 only
            src.returnValue === false ? returnTrue : returnFalse;
            // Create target properties
            // Support: Safari <=6 - 7 only
            // Target should not be a text node (trac-504, trac-13143)
            this.target = src.target && src.target.nodeType === 3 ? src.target.parentNode : src.target;
            this.currentTarget = src.currentTarget;
            this.relatedTarget = src.relatedTarget;
        // Event type
        } else this.type = src;
        // Put explicitly provided properties onto the event object
        if (props) jQuery.extend(this, props);
        // Create a timestamp if incoming event doesn't have one
        this.timeStamp = src && src.timeStamp || Date.now();
        // Mark it as fixed
        this[jQuery.expando] = true;
    };
    // jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
    // https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
    jQuery.Event.prototype = {
        constructor: jQuery.Event,
        isDefaultPrevented: returnFalse,
        isPropagationStopped: returnFalse,
        isImmediatePropagationStopped: returnFalse,
        isSimulated: false,
        preventDefault: function preventDefault() {
            var e = this.originalEvent;
            this.isDefaultPrevented = returnTrue;
            if (e && !this.isSimulated) e.preventDefault();
        },
        stopPropagation: function stopPropagation() {
            var e = this.originalEvent;
            this.isPropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopPropagation();
        },
        stopImmediatePropagation: function stopImmediatePropagation() {
            var e = this.originalEvent;
            this.isImmediatePropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopImmediatePropagation();
            this.stopPropagation();
        }
    };
    // Includes all common event props including KeyEvent and MouseEvent specific props
    jQuery.each({
        altKey: true,
        bubbles: true,
        cancelable: true,
        changedTouches: true,
        ctrlKey: true,
        detail: true,
        eventPhase: true,
        metaKey: true,
        pageX: true,
        pageY: true,
        shiftKey: true,
        view: true,
        "char": true,
        code: true,
        charCode: true,
        key: true,
        keyCode: true,
        button: true,
        buttons: true,
        clientX: true,
        clientY: true,
        offsetX: true,
        offsetY: true,
        pointerId: true,
        pointerType: true,
        screenX: true,
        screenY: true,
        targetTouches: true,
        toElement: true,
        touches: true,
        which: true
    }, jQuery.event.addProp);
    jQuery.each({
        focus: "focusin",
        blur: "focusout"
    }, function(type, delegateType) {
        function focusMappedHandler(nativeEvent) {
            if (document.documentMode) {
                // Support: IE 11+
                // Attach a single focusin/focusout handler on the document while someone wants
                // focus/blur. This is because the former are synchronous in IE while the latter
                // are async. In other browsers, all those handlers are invoked synchronously.
                // `handle` from private data would already wrap the event, but we need
                // to change the `type` here.
                var handle = dataPriv.get(this, "handle"), event = jQuery.event.fix(nativeEvent);
                event.type = nativeEvent.type === "focusin" ? "focus" : "blur";
                event.isSimulated = true;
                // First, handle focusin/focusout
                handle(nativeEvent);
                // ...then, handle focus/blur
                //
                // focus/blur don't bubble while focusin/focusout do; simulate the former by only
                // invoking the handler at the lower level.
                if (event.target === event.currentTarget) // The setup part calls `leverageNative`, which, in turn, calls
                // `jQuery.event.add`, so event handle will already have been set
                // by this point.
                handle(event);
            } else // For non-IE browsers, attach a single capturing handler on the document
            // while someone wants focusin/focusout.
            jQuery.event.simulate(delegateType, nativeEvent.target, jQuery.event.fix(nativeEvent));
        }
        jQuery.event.special[type] = {
            // Utilize native event if possible so blur/focus sequence is correct
            setup: function setup() {
                var attaches;
                // Claim the first handler
                // dataPriv.set( this, "focus", ... )
                // dataPriv.set( this, "blur", ... )
                leverageNative(this, type, true);
                if (document.documentMode) {
                    // Support: IE 9 - 11+
                    // We use the same native handler for focusin & focus (and focusout & blur)
                    // so we need to coordinate setup & teardown parts between those events.
                    // Use `delegateType` as the key as `type` is already used by `leverageNative`.
                    attaches = dataPriv.get(this, delegateType);
                    if (!attaches) this.addEventListener(delegateType, focusMappedHandler);
                    dataPriv.set(this, delegateType, (attaches || 0) + 1);
                } else // Return false to allow normal processing in the caller
                return false;
            },
            trigger: function trigger() {
                // Force setup before trigger
                leverageNative(this, type);
                // Return non-false to allow normal event-path propagation
                return true;
            },
            teardown: function teardown() {
                var attaches;
                if (document.documentMode) {
                    attaches = dataPriv.get(this, delegateType) - 1;
                    if (!attaches) {
                        this.removeEventListener(delegateType, focusMappedHandler);
                        dataPriv.remove(this, delegateType);
                    } else dataPriv.set(this, delegateType, attaches);
                } else // Return false to indicate standard teardown should be applied
                return false;
            },
            // Suppress native focus or blur if we're currently inside
            // a leveraged native-event stack
            _default: function _default(event) {
                return dataPriv.get(event.target, type);
            },
            delegateType: delegateType
        };
        // Support: Firefox <=44
        // Firefox doesn't have focus(in | out) events
        // Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
        //
        // Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
        // focus(in | out) events fire after focus & blur events,
        // which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
        // Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
        //
        // Support: IE 9 - 11+
        // To preserve relative focusin/focus & focusout/blur event order guaranteed on the 3.x branch,
        // attach a single handler for both events in IE.
        jQuery.event.special[delegateType] = {
            setup: function setup() {
                // Handle: regular nodes (via `this.ownerDocument`), window
                // (via `this.document`) & document (via `this`).
                var doc = this.ownerDocument || this.document || this, dataHolder = document.documentMode ? this : doc, attaches = dataPriv.get(dataHolder, delegateType);
                // Support: IE 9 - 11+
                // We use the same native handler for focusin & focus (and focusout & blur)
                // so we need to coordinate setup & teardown parts between those events.
                // Use `delegateType` as the key as `type` is already used by `leverageNative`.
                if (!attaches) {
                    if (document.documentMode) this.addEventListener(delegateType, focusMappedHandler);
                    else doc.addEventListener(type, focusMappedHandler, true);
                }
                dataPriv.set(dataHolder, delegateType, (attaches || 0) + 1);
            },
            teardown: function teardown() {
                var doc = this.ownerDocument || this.document || this, dataHolder = document.documentMode ? this : doc, attaches = dataPriv.get(dataHolder, delegateType) - 1;
                if (!attaches) {
                    if (document.documentMode) this.removeEventListener(delegateType, focusMappedHandler);
                    else doc.removeEventListener(type, focusMappedHandler, true);
                    dataPriv.remove(dataHolder, delegateType);
                } else dataPriv.set(dataHolder, delegateType, attaches);
            }
        };
    });
    // Create mouseenter/leave events using mouseover/out and event-time checks
    // so that event delegation works in jQuery.
    // Do the same for pointerenter/pointerleave and pointerover/pointerout
    //
    // Support: Safari 7 only
    // Safari sends mouseenter too often; see:
    // https://bugs.chromium.org/p/chromium/issues/detail?id=470258
    // for the description of the bug (it existed in older Chrome versions as well).
    jQuery.each({
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout"
    }, function(orig, fix) {
        jQuery.event.special[orig] = {
            delegateType: fix,
            bindType: fix,
            handle: function handle(event) {
                var ret, target = this, related = event.relatedTarget, handleObj = event.handleObj;
                // For mouseenter/leave call the handler if related is outside the target.
                // NB: No relatedTarget if the mouse left/entered the browser window
                if (!related || related !== target && !jQuery.contains(target, related)) {
                    event.type = handleObj.origType;
                    ret = handleObj.handler.apply(this, arguments);
                    event.type = fix;
                }
                return ret;
            }
        };
    });
    jQuery.fn.extend({
        on: function on1(types, selector, data, fn) {
            return on(this, types, selector, data, fn);
        },
        one: function one(types, selector, data, fn) {
            return on(this, types, selector, data, fn, 1);
        },
        off: function off(types, selector, fn) {
            var handleObj, type;
            if (types && types.preventDefault && types.handleObj) {
                // ( event )  dispatched jQuery.Event
                handleObj = types.handleObj;
                jQuery(types.delegateTarget).off(handleObj.namespace ? handleObj.origType + "." + handleObj.namespace : handleObj.origType, handleObj.selector, handleObj.handler);
                return this;
            }
            if (typeof types === "object") {
                // ( types-object [, selector] )
                for(type in types)this.off(type, selector, types[type]);
                return this;
            }
            if (selector === false || typeof selector === "function") {
                // ( types [, fn] )
                fn = selector;
                selector = undefined;
            }
            if (fn === false) fn = returnFalse;
            return this.each(function() {
                jQuery.event.remove(this, types, fn, selector);
            });
        }
    });
    var // Support: IE <=10 - 11, Edge 12 - 13 only
    // In IE/Edge using regex groups here causes severe slowdowns.
    // See https://connect.microsoft.com/IE/feedback/details/1736512/
    rnoInnerhtml = /<script|<style|<link/i, // checked="checked" or checked
    rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i, rcleanScript = /^\s*<!\[CDATA\[|\]\]>\s*$/g;
    // Prefer a tbody over its parent table for containing new rows
    function manipulationTarget(elem, content) {
        if (nodeName(elem, "table") && nodeName(content.nodeType !== 11 ? content : content.firstChild, "tr")) return jQuery(elem).children("tbody")[0] || elem;
        return elem;
    }
    // Replace/restore the type attribute of script elements for safe DOM manipulation
    function disableScript(elem) {
        elem.type = (elem.getAttribute("type") !== null) + "/" + elem.type;
        return elem;
    }
    function restoreScript(elem) {
        if ((elem.type || "").slice(0, 5) === "true/") elem.type = elem.type.slice(5);
        else elem.removeAttribute("type");
        return elem;
    }
    function cloneCopyEvent(src, dest) {
        var i, l, type, pdataOld, udataOld, udataCur, events;
        if (dest.nodeType !== 1) return;
        // 1. Copy private data: events, handlers, etc.
        if (dataPriv.hasData(src)) {
            pdataOld = dataPriv.get(src);
            events = pdataOld.events;
            if (events) {
                dataPriv.remove(dest, "handle events");
                for(type in events)for(i = 0, l = events[type].length; i < l; i++)jQuery.event.add(dest, type, events[type][i]);
            }
        }
        // 2. Copy user data
        if (dataUser.hasData(src)) {
            udataOld = dataUser.access(src);
            udataCur = jQuery.extend({}, udataOld);
            dataUser.set(dest, udataCur);
        }
    }
    // Fix IE bugs, see support tests
    function fixInput(src, dest) {
        var _$nodeName = dest.nodeName.toLowerCase();
        // Fails to persist the checked state of a cloned checkbox or radio button.
        if (_$nodeName === "input" && rcheckableType.test(src.type)) dest.checked = src.checked;
        else if (_$nodeName === "input" || _$nodeName === "textarea") dest.defaultValue = src.defaultValue;
    }
    function domManip(collection, args, callback, ignored) {
        // Flatten any nested arrays
        args = flat(args);
        var fragment, first, scripts, hasScripts, node, doc, i = 0, l = collection.length, iNoClone = l - 1, value = args[0], valueIsFunction = isFunction(value);
        // We can't cloneNode fragments that contain checked, in WebKit
        if (valueIsFunction || l > 1 && typeof value === "string" && !support.checkClone && rchecked.test(value)) return collection.each(function(index) {
            var self = collection.eq(index);
            if (valueIsFunction) args[0] = value.call(this, index, self.html());
            domManip(self, args, callback, ignored);
        });
        if (l) {
            fragment = buildFragment(args, collection[0].ownerDocument, false, collection, ignored);
            first = fragment.firstChild;
            if (fragment.childNodes.length === 1) fragment = first;
            // Require either new content or an interest in ignored elements to invoke the callback
            if (first || ignored) {
                scripts = jQuery.map(getAll(fragment, "script"), disableScript);
                hasScripts = scripts.length;
                // Use the original fragment for the last item
                // instead of the first because it can end up
                // being emptied incorrectly in certain situations (trac-8070).
                for(; i < l; i++){
                    node = fragment;
                    if (i !== iNoClone) {
                        node = jQuery.clone(node, true, true);
                        // Keep references to cloned scripts for later restoration
                        if (hasScripts) // Support: Android <=4.0 only, PhantomJS 1 only
                        // push.apply(_, arraylike) throws on ancient WebKit
                        jQuery.merge(scripts, getAll(node, "script"));
                    }
                    callback.call(collection[i], node, i);
                }
                if (hasScripts) {
                    doc = scripts[scripts.length - 1].ownerDocument;
                    // Re-enable scripts
                    jQuery.map(scripts, restoreScript);
                    // Evaluate executable scripts on first document insertion
                    for(i = 0; i < hasScripts; i++){
                        node = scripts[i];
                        if (rscriptType.test(node.type || "") && !dataPriv.access(node, "globalEval") && jQuery.contains(doc, node)) {
                            if (node.src && (node.type || "").toLowerCase() !== "module") // Optional AJAX dependency, but won't run scripts if not present
                            {
                                if (jQuery._evalUrl && !node.noModule) jQuery._evalUrl(node.src, {
                                    nonce: node.nonce || node.getAttribute("nonce")
                                }, doc);
                            } else // Unwrap a CDATA section containing script contents. This shouldn't be
                            // needed as in XML documents they're already not visible when
                            // inspecting element contents and in HTML documents they have no
                            // meaning but we're preserving that logic for backwards compatibility.
                            // This will be removed completely in 4.0. See gh-4904.
                            DOMEval(node.textContent.replace(rcleanScript, ""), node, doc);
                        }
                    }
                }
            }
        }
        return collection;
    }
    function remove(elem, selector, keepData) {
        var node, nodes = selector ? jQuery.filter(selector, elem) : elem, i = 0;
        for(; (node = nodes[i]) != null; i++){
            if (!keepData && node.nodeType === 1) jQuery.cleanData(getAll(node));
            if (node.parentNode) {
                if (keepData && isAttached(node)) setGlobalEval(getAll(node, "script"));
                node.parentNode.removeChild(node);
            }
        }
        return elem;
    }
    jQuery.extend({
        htmlPrefilter: function htmlPrefilter(html) {
            return html;
        },
        clone: function clone(elem, dataAndEvents, deepDataAndEvents) {
            var i, l, srcElements, destElements, clone = elem.cloneNode(true), inPage = isAttached(elem);
            // Fix IE cloning issues
            if (!support.noCloneChecked && (elem.nodeType === 1 || elem.nodeType === 11) && !jQuery.isXMLDoc(elem)) {
                // We eschew jQuery#find here for performance reasons:
                // https://jsperf.com/getall-vs-sizzle/2
                destElements = getAll(clone);
                srcElements = getAll(elem);
                for(i = 0, l = srcElements.length; i < l; i++)fixInput(srcElements[i], destElements[i]);
            }
            // Copy the events from the original to the clone
            if (dataAndEvents) {
                if (deepDataAndEvents) {
                    srcElements = srcElements || getAll(elem);
                    destElements = destElements || getAll(clone);
                    for(i = 0, l = srcElements.length; i < l; i++)cloneCopyEvent(srcElements[i], destElements[i]);
                } else cloneCopyEvent(elem, clone);
            }
            // Preserve script evaluation history
            destElements = getAll(clone, "script");
            if (destElements.length > 0) setGlobalEval(destElements, !inPage && getAll(elem, "script"));
            // Return the cloned set
            return clone;
        },
        cleanData: function cleanData(elems) {
            var data, elem, type, special = jQuery.event.special, i = 0;
            for(; (elem = elems[i]) !== undefined; i++)if (acceptData(elem)) {
                if (data = elem[dataPriv.expando]) {
                    if (data.events) {
                        for(type in data.events)if (special[type]) jQuery.event.remove(elem, type);
                        else jQuery.removeEvent(elem, type, data.handle);
                    }
                    // Support: Chrome <=35 - 45+
                    // Assign undefined instead of using delete, see Data#remove
                    elem[dataPriv.expando] = undefined;
                }
                if (elem[dataUser.expando]) // Support: Chrome <=35 - 45+
                // Assign undefined instead of using delete, see Data#remove
                elem[dataUser.expando] = undefined;
            }
        }
    });
    jQuery.fn.extend({
        detach: function detach(selector) {
            return remove(this, selector, true);
        },
        remove: function remove1(selector) {
            return remove(this, selector);
        },
        text: function text(value) {
            return access(this, function(value) {
                return value === undefined ? jQuery.text(this) : this.empty().each(function() {
                    if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) this.textContent = value;
                });
            }, null, value, arguments.length);
        },
        append: function append() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.appendChild(elem);
                }
            });
        },
        prepend: function prepend() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.insertBefore(elem, target.firstChild);
                }
            });
        },
        before: function before() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this);
            });
        },
        after: function after() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this.nextSibling);
            });
        },
        empty: function empty() {
            var elem, i = 0;
            for(; (elem = this[i]) != null; i++)if (elem.nodeType === 1) {
                // Prevent memory leaks
                jQuery.cleanData(getAll(elem, false));
                // Remove any remaining nodes
                elem.textContent = "";
            }
            return this;
        },
        clone: function clone(dataAndEvents, deepDataAndEvents) {
            dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
            deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
            return this.map(function() {
                return jQuery.clone(this, dataAndEvents, deepDataAndEvents);
            });
        },
        html: function html(value) {
            return access(this, function(value) {
                var elem = this[0] || {}, i = 0, l = this.length;
                if (value === undefined && elem.nodeType === 1) return elem.innerHTML;
                // See if we can take a shortcut and just use innerHTML
                if (typeof value === "string" && !rnoInnerhtml.test(value) && !wrapMap[(rtagName.exec(value) || [
                    "",
                    ""
                ])[1].toLowerCase()]) {
                    value = jQuery.htmlPrefilter(value);
                    try {
                        for(; i < l; i++){
                            elem = this[i] || {};
                            // Remove element nodes and prevent memory leaks
                            if (elem.nodeType === 1) {
                                jQuery.cleanData(getAll(elem, false));
                                elem.innerHTML = value;
                            }
                        }
                        elem = 0;
                    // If using innerHTML throws an exception, use the fallback method
                    } catch (e) {}
                }
                if (elem) this.empty().append(value);
            }, null, value, arguments.length);
        },
        replaceWith: function replaceWith() {
            var ignored = [];
            // Make the changes, replacing each non-ignored context element with the new content
            return domManip(this, arguments, function(elem) {
                var parent = this.parentNode;
                if (jQuery.inArray(this, ignored) < 0) {
                    jQuery.cleanData(getAll(this));
                    if (parent) parent.replaceChild(elem, this);
                }
            // Force callback invocation
            }, ignored);
        }
    });
    jQuery.each({
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith"
    }, function(name, original) {
        jQuery.fn[name] = function(selector) {
            var elems, ret = [], insert = jQuery(selector), last = insert.length - 1, i = 0;
            for(; i <= last; i++){
                elems = i === last ? this : this.clone(true);
                jQuery(insert[i])[original](elems);
                // Support: Android <=4.0 only, PhantomJS 1 only
                // .get() because push.apply(_, arraylike) throws on ancient WebKit
                push.apply(ret, elems.get());
            }
            return this.pushStack(ret);
        };
    });
    var rnumnonpx = new RegExp("^(" + pnum + ")(?!px)[a-z%]+$", "i");
    var rcustomProp = /^--/;
    var getStyles = function getStyles(elem) {
        // Support: IE <=11 only, Firefox <=30 (trac-15098, trac-14150)
        // IE throws on elements created in popups
        // FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
        var view = elem.ownerDocument.defaultView;
        if (!view || !view.opener) view = window1;
        return view.getComputedStyle(elem);
    };
    var swap = function swap(elem, options, callback) {
        var ret, name, old = {};
        // Remember the old values, and insert the new ones
        for(name in options){
            old[name] = elem.style[name];
            elem.style[name] = options[name];
        }
        ret = callback.call(elem);
        // Revert the old values
        for(name in options)elem.style[name] = old[name];
        return ret;
    };
    var rboxStyle = new RegExp(cssExpand.join("|"), "i");
    (function() {
        // Executing both pixelPosition & boxSizingReliable tests require only one layout
        // so they're executed at the same time to save the second computation.
        function computeStyleTests() {
            // This is a singleton, we need to execute it only once
            if (!div) return;
            container.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0";
            div.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%";
            documentElement.appendChild(container).appendChild(div);
            var divStyle = window1.getComputedStyle(div);
            pixelPositionVal = divStyle.top !== "1%";
            // Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
            reliableMarginLeftVal = roundPixelMeasures(divStyle.marginLeft) === 12;
            // Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
            // Some styles come back with percentage values, even though they shouldn't
            div.style.right = "60%";
            pixelBoxStylesVal = roundPixelMeasures(divStyle.right) === 36;
            // Support: IE 9 - 11 only
            // Detect misreporting of content dimensions for box-sizing:border-box elements
            boxSizingReliableVal = roundPixelMeasures(divStyle.width) === 36;
            // Support: IE 9 only
            // Detect overflow:scroll screwiness (gh-3699)
            // Support: Chrome <=64
            // Don't get tricked when zoom affects offsetWidth (gh-4029)
            div.style.position = "absolute";
            scrollboxSizeVal = roundPixelMeasures(div.offsetWidth / 3) === 12;
            documentElement.removeChild(container);
            // Nullify the div so it wouldn't be stored in the memory and
            // it will also be a sign that checks already performed
            div = null;
        }
        function roundPixelMeasures(measure) {
            return Math.round(parseFloat(measure));
        }
        var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal, reliableTrDimensionsVal, reliableMarginLeftVal, container = document.createElement("div"), div = document.createElement("div");
        // Finish early in limited (non-browser) environments
        if (!div.style) return;
        // Support: IE <=9 - 11 only
        // Style of cloned element affects source element cloned (trac-8908)
        div.style.backgroundClip = "content-box";
        div.cloneNode(true).style.backgroundClip = "";
        support.clearCloneStyle = div.style.backgroundClip === "content-box";
        jQuery.extend(support, {
            boxSizingReliable: function boxSizingReliable() {
                computeStyleTests();
                return boxSizingReliableVal;
            },
            pixelBoxStyles: function pixelBoxStyles() {
                computeStyleTests();
                return pixelBoxStylesVal;
            },
            pixelPosition: function pixelPosition() {
                computeStyleTests();
                return pixelPositionVal;
            },
            reliableMarginLeft: function reliableMarginLeft() {
                computeStyleTests();
                return reliableMarginLeftVal;
            },
            scrollboxSize: function scrollboxSize() {
                computeStyleTests();
                return scrollboxSizeVal;
            },
            // Support: IE 9 - 11+, Edge 15 - 18+
            // IE/Edge misreport `getComputedStyle` of table rows with width/height
            // set in CSS while `offset*` properties report correct values.
            // Behavior in IE 9 is more subtle than in newer versions & it passes
            // some versions of this test; make sure not to make it pass there!
            //
            // Support: Firefox 70+
            // Only Firefox includes border widths
            // in computed dimensions. (gh-4529)
            reliableTrDimensions: function reliableTrDimensions() {
                var table, tr, trChild, trStyle;
                if (reliableTrDimensionsVal == null) {
                    table = document.createElement("table");
                    tr = document.createElement("tr");
                    trChild = document.createElement("div");
                    table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
                    tr.style.cssText = "box-sizing:content-box;border:1px solid";
                    // Support: Chrome 86+
                    // Height set through cssText does not get applied.
                    // Computed height then comes back as 0.
                    tr.style.height = "1px";
                    trChild.style.height = "9px";
                    // Support: Android 8 Chrome 86+
                    // In our bodyBackground.html iframe,
                    // display for all div elements is set to "inline",
                    // which causes a problem only in Android 8 Chrome 86.
                    // Ensuring the div is `display: block`
                    // gets around this issue.
                    trChild.style.display = "block";
                    documentElement.appendChild(table).appendChild(tr).appendChild(trChild);
                    trStyle = window1.getComputedStyle(tr);
                    reliableTrDimensionsVal = parseInt(trStyle.height, 10) + parseInt(trStyle.borderTopWidth, 10) + parseInt(trStyle.borderBottomWidth, 10) === tr.offsetHeight;
                    documentElement.removeChild(table);
                }
                return reliableTrDimensionsVal;
            }
        });
    })();
    function curCSS(elem, name, computed) {
        var width, minWidth, maxWidth, ret, isCustomProp = rcustomProp.test(name), // Support: Firefox 51+
        // Retrieving style before computed somehow
        // fixes an issue with getting wrong values
        // on detached elements
        style = elem.style;
        computed = computed || getStyles(elem);
        // getPropertyValue is needed for:
        //   .css('filter') (IE 9 only, trac-12537)
        //   .css('--customProperty) (gh-3144)
        if (computed) {
            // Support: IE <=9 - 11+
            // IE only supports `"float"` in `getPropertyValue`; in computed styles
            // it's only available as `"cssFloat"`. We no longer modify properties
            // sent to `.css()` apart from camelCasing, so we need to check both.
            // Normally, this would create difference in behavior: if
            // `getPropertyValue` returns an empty string, the value returned
            // by `.css()` would be `undefined`. This is usually the case for
            // disconnected elements. However, in IE even disconnected elements
            // with no styles return `"none"` for `getPropertyValue( "float" )`
            ret = computed.getPropertyValue(name) || computed[name];
            if (isCustomProp && ret) // Support: Firefox 105+, Chrome <=105+
            // Spec requires trimming whitespace for custom properties (gh-4926).
            // Firefox only trims leading whitespace. Chrome just collapses
            // both leading & trailing whitespace to a single space.
            //
            // Fall back to `undefined` if empty string returned.
            // This collapses a missing definition with property defined
            // and set to an empty string but there's no standard API
            // allowing us to differentiate them without a performance penalty
            // and returning `undefined` aligns with older jQuery.
            //
            // rtrimCSS treats U+000D CARRIAGE RETURN and U+000C FORM FEED
            // as whitespace while CSS does not, but this is not a problem
            // because CSS preprocessing replaces them with U+000A LINE FEED
            // (which *is* CSS whitespace)
            // https://www.w3.org/TR/css-syntax-3/#input-preprocessing
            ret = ret.replace(rtrimCSS, "$1") || undefined;
            if (ret === "" && !isAttached(elem)) ret = jQuery.style(elem, name);
            // A tribute to the "awesome hack by Dean Edwards"
            // Android Browser returns percentage for some values,
            // but width seems to be reliably pixels.
            // This is against the CSSOM draft spec:
            // https://drafts.csswg.org/cssom/#resolved-values
            if (!support.pixelBoxStyles() && rnumnonpx.test(ret) && rboxStyle.test(name)) {
                // Remember the original values
                width = style.width;
                minWidth = style.minWidth;
                maxWidth = style.maxWidth;
                // Put in the new values to get a computed value out
                style.minWidth = style.maxWidth = style.width = ret;
                ret = computed.width;
                // Revert the changed values
                style.width = width;
                style.minWidth = minWidth;
                style.maxWidth = maxWidth;
            }
        }
        return ret !== undefined ? // Support: IE <=9 - 11 only
        // IE returns zIndex value as an integer.
        ret + "" : ret;
    }
    function addGetHookIf(conditionFn, hookFn) {
        // Define the hook, we'll check on the first run if it's really needed.
        return {
            get: function get() {
                if (conditionFn()) {
                    // Hook not needed (or it's not possible to use it due
                    // to missing dependency), remove it.
                    delete this.get;
                    return;
                }
                // Hook needed; redefine it so that the support test is not executed again.
                return (this.get = hookFn).apply(this, arguments);
            }
        };
    }
    var cssPrefixes = [
        "Webkit",
        "Moz",
        "ms"
    ], emptyStyle = document.createElement("div").style, vendorProps = {};
    // Return a vendor-prefixed property or undefined
    function vendorPropName(name) {
        // Check for vendor prefixed names
        var capName = name[0].toUpperCase() + name.slice(1), i = cssPrefixes.length;
        while(i--){
            name = cssPrefixes[i] + capName;
            if (name in emptyStyle) return name;
        }
    }
    // Return a potentially-mapped jQuery.cssProps or vendor prefixed property
    function finalPropName(name) {
        var final = jQuery.cssProps[name] || vendorProps[name];
        if (final) return final;
        if (name in emptyStyle) return name;
        return vendorProps[name] = vendorPropName(name) || name;
    }
    var // Swappable if display is none or starts with table
    // except "table", "table-cell", or "table-caption"
    // See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
    rdisplayswap = /^(none|table(?!-c[ea]).+)/, cssShow = {
        position: "absolute",
        visibility: "hidden",
        display: "block"
    }, cssNormalTransform = {
        letterSpacing: "0",
        fontWeight: "400"
    };
    function setPositiveNumber(_elem, value, subtract) {
        // Any relative (+/-) values have already been
        // normalized at this point
        var matches = rcssNum.exec(value);
        return matches ? // Guard against undefined "subtract", e.g., when used as in cssHooks
        Math.max(0, matches[2] - (subtract || 0)) + (matches[3] || "px") : value;
    }
    function boxModelAdjustment(elem, dimension, box, isBorderBox, styles, computedVal) {
        var i = dimension === "width" ? 1 : 0, extra = 0, delta = 0, marginDelta = 0;
        // Adjustment may not be necessary
        if (box === (isBorderBox ? "border" : "content")) return 0;
        for(; i < 4; i += 2){
            // Both box models exclude margin
            // Count margin delta separately to only add it after scroll gutter adjustment.
            // This is needed to make negative margins work with `outerHeight( true )` (gh-3982).
            if (box === "margin") marginDelta += jQuery.css(elem, box + cssExpand[i], true, styles);
            // If we get here with a content-box, we're seeking "padding" or "border" or "margin"
            if (!isBorderBox) {
                // Add padding
                delta += jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "border" or "margin", add border
                if (box !== "padding") delta += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
                else extra += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            // If we get here with a border-box (content + padding + border), we're seeking "content" or
            // "padding" or "margin"
            } else {
                // For "content", subtract padding
                if (box === "content") delta -= jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "content" or "padding", subtract border
                if (box !== "margin") delta -= jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            }
        }
        // Account for positive content-box scroll gutter when requested by providing computedVal
        if (!isBorderBox && computedVal >= 0) // offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
        // Assuming integer scroll gutter, subtract the rest and round down
        delta += Math.max(0, Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - computedVal - delta - extra - 0.5)) || 0;
        return delta + marginDelta;
    }
    function getWidthOrHeight(elem, dimension, extra) {
        // Start with computed style
        var styles = getStyles(elem), // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
        // Fake content-box until we know it's needed to know the true value.
        boxSizingNeeded = !support.boxSizingReliable() || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", valueIsBorderBox = isBorderBox, val = curCSS(elem, dimension, styles), offsetProp = "offset" + dimension[0].toUpperCase() + dimension.slice(1);
        // Support: Firefox <=54
        // Return a confounding non-pixel value or feign ignorance, as appropriate.
        if (rnumnonpx.test(val)) {
            if (!extra) return val;
            val = "auto";
        }
        // Support: IE 9 - 11 only
        // Use offsetWidth/offsetHeight for when box sizing is unreliable.
        // In those cases, the computed value can be trusted to be border-box.
        if ((!support.boxSizingReliable() && isBorderBox || // Support: IE 10 - 11+, Edge 15 - 18+
        // IE/Edge misreport `getComputedStyle` of table rows with width/height
        // set in CSS while `offset*` properties report correct values.
        // Interestingly, in some cases IE 9 doesn't suffer from this issue.
        !support.reliableTrDimensions() && nodeName(elem, "tr") || // Fall back to offsetWidth/offsetHeight when value is "auto"
        // This happens for inline elements with no explicit setting (gh-3571)
        val === "auto" || // Support: Android <=4.1 - 4.3 only
        // Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
        !parseFloat(val) && jQuery.css(elem, "display", false, styles) === "inline") && // Make sure the element is visible & connected
        elem.getClientRects().length) {
            isBorderBox = jQuery.css(elem, "boxSizing", false, styles) === "border-box";
            // Where available, offsetWidth/offsetHeight approximate border box dimensions.
            // Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
            // retrieved value as a content box dimension.
            valueIsBorderBox = offsetProp in elem;
            if (valueIsBorderBox) val = elem[offsetProp];
        }
        // Normalize "" and auto
        val = parseFloat(val) || 0;
        // Adjust for the element's box model
        return val + boxModelAdjustment(elem, dimension, extra || (isBorderBox ? "border" : "content"), valueIsBorderBox, styles, // Provide the current computed size to request scroll gutter calculation (gh-3589)
        val) + "px";
    }
    jQuery.extend({
        // Add in style property hooks for overriding the default
        // behavior of getting and setting a style property
        cssHooks: {
            opacity: {
                get: function get(elem, computed) {
                    if (computed) {
                        // We should always get a number back from opacity
                        var ret = curCSS(elem, "opacity");
                        return ret === "" ? "1" : ret;
                    }
                }
            }
        },
        // Don't automatically add "px" to these possibly-unitless properties
        cssNumber: {
            animationIterationCount: true,
            aspectRatio: true,
            borderImageSlice: true,
            columnCount: true,
            flexGrow: true,
            flexShrink: true,
            fontWeight: true,
            gridArea: true,
            gridColumn: true,
            gridColumnEnd: true,
            gridColumnStart: true,
            gridRow: true,
            gridRowEnd: true,
            gridRowStart: true,
            lineHeight: true,
            opacity: true,
            order: true,
            orphans: true,
            scale: true,
            widows: true,
            zIndex: true,
            zoom: true,
            // SVG-related
            fillOpacity: true,
            floodOpacity: true,
            stopOpacity: true,
            strokeMiterlimit: true,
            strokeOpacity: true
        },
        // Add in properties whose names you wish to fix before
        // setting or getting the value
        cssProps: {},
        // Get and set the style property on a DOM Node
        style: function style(elem, name, value, extra) {
            // Don't set styles on text and comment nodes
            if (!elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style) return;
            // Make sure that we're working with the right name
            var ret, type, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name), style = elem.style;
            // Make sure that we're working with the right name. We don't
            // want to query the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Gets hook for the prefixed version, then unprefixed version
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // Check if we're setting a value
            if (value !== undefined) {
                type = typeof value === "undefined" ? "undefined" : (0, $jzTO1._)(value);
                // Convert "+=" or "-=" to relative numbers (trac-7345)
                if (type === "string" && (ret = rcssNum.exec(value)) && ret[1]) {
                    value = adjustCSS(elem, name, ret);
                    // Fixes bug trac-9237
                    type = "number";
                }
                // Make sure that null and NaN values aren't set (trac-7116)
                if (value == null || value !== value) return;
                // If a number was passed in, add the unit (except for certain CSS properties)
                // The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
                // "px" to a few hardcoded values.
                if (type === "number" && !isCustomProp) value += ret && ret[3] || (jQuery.cssNumber[origName] ? "" : "px");
                // background-* props affect original clone's values
                if (!support.clearCloneStyle && value === "" && name.indexOf("background") === 0) style[name] = "inherit";
                // If a hook was provided, use that value, otherwise just set the specified value
                if (!hooks || !("set" in hooks) || (value = hooks.set(elem, value, extra)) !== undefined) {
                    if (isCustomProp) style.setProperty(name, value);
                    else style[name] = value;
                }
            } else {
                // If a hook was provided get the non-computed value from there
                if (hooks && "get" in hooks && (ret = hooks.get(elem, false, extra)) !== undefined) return ret;
                // Otherwise just get the value from the style object
                return style[name];
            }
        },
        css: function css(elem, name, extra, styles) {
            var val, num, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name);
            // Make sure that we're working with the right name. We don't
            // want to modify the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Try prefixed name followed by the unprefixed name
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // If a hook was provided get the computed value from there
            if (hooks && "get" in hooks) val = hooks.get(elem, true, extra);
            // Otherwise, if a way to get the computed value exists, use that
            if (val === undefined) val = curCSS(elem, name, styles);
            // Convert "normal" to computed value
            if (val === "normal" && name in cssNormalTransform) val = cssNormalTransform[name];
            // Make numeric if forced or a qualifier was provided and val looks numeric
            if (extra === "" || extra) {
                num = parseFloat(val);
                return extra === true || isFinite(num) ? num || 0 : val;
            }
            return val;
        }
    });
    jQuery.each([
        "height",
        "width"
    ], function(_i, dimension) {
        jQuery.cssHooks[dimension] = {
            get: function get(elem, computed, extra) {
                if (computed) // Certain elements can have dimension info if we invisibly show them
                // but it must have a current display style that would benefit
                return rdisplayswap.test(jQuery.css(elem, "display")) && // Support: Safari 8+
                // Table columns in Safari have non-zero offsetWidth & zero
                // getBoundingClientRect().width unless display is changed.
                // Support: IE <=11 only
                // Running getBoundingClientRect on a disconnected node
                // in IE throws an error.
                (!elem.getClientRects().length || !elem.getBoundingClientRect().width) ? swap(elem, cssShow, function() {
                    return getWidthOrHeight(elem, dimension, extra);
                }) : getWidthOrHeight(elem, dimension, extra);
            },
            set: function set(elem, value, extra) {
                var matches, styles = getStyles(elem), // Only read styles.position if the test has a chance to fail
                // to avoid forcing a reflow.
                scrollboxSizeBuggy = !support.scrollboxSize() && styles.position === "absolute", // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
                boxSizingNeeded = scrollboxSizeBuggy || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", subtract = extra ? boxModelAdjustment(elem, dimension, extra, isBorderBox, styles) : 0;
                // Account for unreliable border-box dimensions by comparing offset* to computed and
                // faking a content-box to get border and padding (gh-3699)
                if (isBorderBox && scrollboxSizeBuggy) subtract -= Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - parseFloat(styles[dimension]) - boxModelAdjustment(elem, dimension, "border", false, styles) - 0.5);
                // Convert to pixels if value adjustment is needed
                if (subtract && (matches = rcssNum.exec(value)) && (matches[3] || "px") !== "px") {
                    elem.style[dimension] = value;
                    value = jQuery.css(elem, dimension);
                }
                return setPositiveNumber(elem, value, subtract);
            }
        };
    });
    jQuery.cssHooks.marginLeft = addGetHookIf(support.reliableMarginLeft, function(elem, computed) {
        if (computed) return (parseFloat(curCSS(elem, "marginLeft")) || elem.getBoundingClientRect().left - swap(elem, {
            marginLeft: 0
        }, function() {
            return elem.getBoundingClientRect().left;
        })) + "px";
    });
    // These hooks are used by animate to expand properties
    jQuery.each({
        margin: "",
        padding: "",
        border: "Width"
    }, function(prefix, suffix) {
        jQuery.cssHooks[prefix + suffix] = {
            expand: function expand(value) {
                var i = 0, expanded = {}, // Assumes a single number if not a string
                parts = typeof value === "string" ? value.split(" ") : [
                    value
                ];
                for(; i < 4; i++)expanded[prefix + cssExpand[i] + suffix] = parts[i] || parts[i - 2] || parts[0];
                return expanded;
            }
        };
        if (prefix !== "margin") jQuery.cssHooks[prefix + suffix].set = setPositiveNumber;
    });
    jQuery.fn.extend({
        css: function css(name, value) {
            return access(this, function(elem, name, value) {
                var styles, len, map = {}, i = 0;
                if (Array.isArray(name)) {
                    styles = getStyles(elem);
                    len = name.length;
                    for(; i < len; i++)map[name[i]] = jQuery.css(elem, name[i], false, styles);
                    return map;
                }
                return value !== undefined ? jQuery.style(elem, name, value) : jQuery.css(elem, name);
            }, name, value, arguments.length > 1);
        }
    });
    function Tween(elem, options, prop, end, easing) {
        return new Tween.prototype.init(elem, options, prop, end, easing);
    }
    jQuery.Tween = Tween;
    Tween.prototype = {
        constructor: Tween,
        init: function init(elem, options, prop, end, easing, unit) {
            this.elem = elem;
            this.prop = prop;
            this.easing = easing || jQuery.easing._default;
            this.options = options;
            this.start = this.now = this.cur();
            this.end = end;
            this.unit = unit || (jQuery.cssNumber[prop] ? "" : "px");
        },
        cur: function cur() {
            var hooks = Tween.propHooks[this.prop];
            return hooks && hooks.get ? hooks.get(this) : Tween.propHooks._default.get(this);
        },
        run: function run(percent) {
            var eased, hooks = Tween.propHooks[this.prop];
            if (this.options.duration) this.pos = eased = jQuery.easing[this.easing](percent, this.options.duration * percent, 0, 1, this.options.duration);
            else this.pos = eased = percent;
            this.now = (this.end - this.start) * eased + this.start;
            if (this.options.step) this.options.step.call(this.elem, this.now, this);
            if (hooks && hooks.set) hooks.set(this);
            else Tween.propHooks._default.set(this);
            return this;
        }
    };
    Tween.prototype.init.prototype = Tween.prototype;
    Tween.propHooks = {
        _default: {
            get: function get(tween) {
                var result;
                // Use a property on the element directly when it is not a DOM element,
                // or when there is no matching style property that exists.
                if (tween.elem.nodeType !== 1 || tween.elem[tween.prop] != null && tween.elem.style[tween.prop] == null) return tween.elem[tween.prop];
                // Passing an empty string as a 3rd parameter to .css will automatically
                // attempt a parseFloat and fallback to a string if the parse fails.
                // Simple values such as "10px" are parsed to Float;
                // complex values such as "rotate(1rad)" are returned as-is.
                result = jQuery.css(tween.elem, tween.prop, "");
                // Empty strings, null, undefined and "auto" are converted to 0.
                return !result || result === "auto" ? 0 : result;
            },
            set: function set(tween) {
                // Use step hook for back compat.
                // Use cssHook if its there.
                // Use .style if available and use plain properties where available.
                if (jQuery.fx.step[tween.prop]) jQuery.fx.step[tween.prop](tween);
                else if (tween.elem.nodeType === 1 && (jQuery.cssHooks[tween.prop] || tween.elem.style[finalPropName(tween.prop)] != null)) jQuery.style(tween.elem, tween.prop, tween.now + tween.unit);
                else tween.elem[tween.prop] = tween.now;
            }
        }
    };
    // Support: IE <=9 only
    // Panic based approach to setting things on disconnected nodes
    Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
        set: function set(tween) {
            if (tween.elem.nodeType && tween.elem.parentNode) tween.elem[tween.prop] = tween.now;
        }
    };
    jQuery.easing = {
        linear: function linear(p) {
            return p;
        },
        swing: function swing(p) {
            return 0.5 - Math.cos(p * Math.PI) / 2;
        },
        _default: "swing"
    };
    jQuery.fx = Tween.prototype.init;
    // Back compat <1.8 extension point
    jQuery.fx.step = {};
    var fxNow, inProgress, rfxtypes = /^(?:toggle|show|hide)$/, rrun = /queueHooks$/;
    function schedule() {
        if (inProgress) {
            if (document.hidden === false && window1.requestAnimationFrame) window1.requestAnimationFrame(schedule);
            else window1.setTimeout(schedule, jQuery.fx.interval);
            jQuery.fx.tick();
        }
    }
    // Animations created synchronously will run synchronously
    function createFxNow() {
        window1.setTimeout(function() {
            fxNow = undefined;
        });
        return fxNow = Date.now();
    }
    // Generate parameters to create a standard animation
    function genFx(type, includeWidth) {
        var which, i = 0, attrs = {
            height: type
        };
        // If we include width, step value is 1 to do all cssExpand values,
        // otherwise step value is 2 to skip over Left and Right
        includeWidth = includeWidth ? 1 : 0;
        for(; i < 4; i += 2 - includeWidth){
            which = cssExpand[i];
            attrs["margin" + which] = attrs["padding" + which] = type;
        }
        if (includeWidth) attrs.opacity = attrs.width = type;
        return attrs;
    }
    function createTween(value, prop, animation) {
        var tween, collection = (Animation.tweeners[prop] || []).concat(Animation.tweeners["*"]), index = 0, length = collection.length;
        for(; index < length; index++){
            if (tween = collection[index].call(animation, prop, value)) // We're done with this property
            return tween;
        }
    }
    function defaultPrefilter(elem, props, opts) {
        var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display, isBox = "width" in props || "height" in props, anim = this, orig = {}, style = elem.style, hidden = elem.nodeType && isHiddenWithinTree(elem), dataShow = dataPriv.get(elem, "fxshow");
        // Queue-skipping animations hijack the fx hooks
        if (!opts.queue) {
            hooks = jQuery._queueHooks(elem, "fx");
            if (hooks.unqueued == null) {
                hooks.unqueued = 0;
                oldfire = hooks.empty.fire;
                hooks.empty.fire = function() {
                    if (!hooks.unqueued) oldfire();
                };
            }
            hooks.unqueued++;
            anim.always(function() {
                // Ensure the complete handler is called before this completes
                anim.always(function() {
                    hooks.unqueued--;
                    if (!jQuery.queue(elem, "fx").length) hooks.empty.fire();
                });
            });
        }
        // Detect show/hide animations
        for(prop in props){
            value = props[prop];
            if (rfxtypes.test(value)) {
                delete props[prop];
                toggle = toggle || value === "toggle";
                if (value === (hidden ? "hide" : "show")) {
                    // Pretend to be hidden if this is a "show" and
                    // there is still data from a stopped show/hide
                    if (value === "show" && dataShow && dataShow[prop] !== undefined) hidden = true;
                    else continue;
                }
                orig[prop] = dataShow && dataShow[prop] || jQuery.style(elem, prop);
            }
        }
        // Bail out if this is a no-op like .hide().hide()
        propTween = !jQuery.isEmptyObject(props);
        if (!propTween && jQuery.isEmptyObject(orig)) return;
        // Restrict "overflow" and "display" styles during box animations
        if (isBox && elem.nodeType === 1) {
            // Support: IE <=9 - 11, Edge 12 - 15
            // Record all 3 overflow attributes because IE does not infer the shorthand
            // from identically-valued overflowX and overflowY and Edge just mirrors
            // the overflowX value there.
            opts.overflow = [
                style.overflow,
                style.overflowX,
                style.overflowY
            ];
            // Identify a display type, preferring old show/hide data over the CSS cascade
            restoreDisplay = dataShow && dataShow.display;
            if (restoreDisplay == null) restoreDisplay = dataPriv.get(elem, "display");
            display = jQuery.css(elem, "display");
            if (display === "none") {
                if (restoreDisplay) display = restoreDisplay;
                else {
                    // Get nonempty value(s) by temporarily forcing visibility
                    showHide([
                        elem
                    ], true);
                    restoreDisplay = elem.style.display || restoreDisplay;
                    display = jQuery.css(elem, "display");
                    showHide([
                        elem
                    ]);
                }
            }
            // Animate inline elements as inline-block
            if (display === "inline" || display === "inline-block" && restoreDisplay != null) {
                if (jQuery.css(elem, "float") === "none") {
                    // Restore the original display value at the end of pure show/hide animations
                    if (!propTween) {
                        anim.done(function() {
                            style.display = restoreDisplay;
                        });
                        if (restoreDisplay == null) {
                            display = style.display;
                            restoreDisplay = display === "none" ? "" : display;
                        }
                    }
                    style.display = "inline-block";
                }
            }
        }
        if (opts.overflow) {
            style.overflow = "hidden";
            anim.always(function() {
                style.overflow = opts.overflow[0];
                style.overflowX = opts.overflow[1];
                style.overflowY = opts.overflow[2];
            });
        }
        // Implement show/hide animations
        propTween = false;
        for(prop in orig){
            // General show/hide setup for this element animation
            if (!propTween) {
                if (dataShow) {
                    if ("hidden" in dataShow) hidden = dataShow.hidden;
                } else dataShow = dataPriv.access(elem, "fxshow", {
                    display: restoreDisplay
                });
                // Store hidden/visible for toggle so `.stop().toggle()` "reverses"
                if (toggle) dataShow.hidden = !hidden;
                // Show elements before animating them
                if (hidden) showHide([
                    elem
                ], true);
                /* eslint-disable no-loop-func */ anim.done(function() {
                    /* eslint-enable no-loop-func */ // The final step of a "hide" animation is actually hiding the element
                    if (!hidden) showHide([
                        elem
                    ]);
                    dataPriv.remove(elem, "fxshow");
                    for(prop in orig)jQuery.style(elem, prop, orig[prop]);
                });
            }
            // Per-property setup
            propTween = createTween(hidden ? dataShow[prop] : 0, prop, anim);
            if (!(prop in dataShow)) {
                dataShow[prop] = propTween.start;
                if (hidden) {
                    propTween.end = propTween.start;
                    propTween.start = 0;
                }
            }
        }
    }
    function propFilter(props, specialEasing) {
        var index, name, easing, value, hooks;
        // camelCase, specialEasing and expand cssHook pass
        for(index in props){
            name = camelCase(index);
            easing = specialEasing[name];
            value = props[index];
            if (Array.isArray(value)) {
                easing = value[1];
                value = props[index] = value[0];
            }
            if (index !== name) {
                props[name] = value;
                delete props[index];
            }
            hooks = jQuery.cssHooks[name];
            if (hooks && "expand" in hooks) {
                value = hooks.expand(value);
                delete props[name];
                // Not quite $.extend, this won't overwrite existing keys.
                // Reusing 'index' because we have the correct "name"
                for(index in value)if (!(index in props)) {
                    props[index] = value[index];
                    specialEasing[index] = easing;
                }
            } else specialEasing[name] = easing;
        }
    }
    function Animation(elem, properties, options) {
        var result, stopped, index = 0, length = Animation.prefilters.length, deferred = jQuery.Deferred().always(function() {
            // Don't match elem in the :animated selector
            delete tick.elem;
        }), tick = function tick() {
            if (stopped) return false;
            var currentTime = fxNow || createFxNow(), remaining = Math.max(0, animation.startTime + animation.duration - currentTime), // Support: Android 2.3 only
            // Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (trac-12497)
            temp = remaining / animation.duration || 0, percent = 1 - temp, index = 0, length = animation.tweens.length;
            for(; index < length; index++)animation.tweens[index].run(percent);
            deferred.notifyWith(elem, [
                animation,
                percent,
                remaining
            ]);
            // If there's more to do, yield
            if (percent < 1 && length) return remaining;
            // If this was an empty animation, synthesize a final progress notification
            if (!length) deferred.notifyWith(elem, [
                animation,
                1,
                0
            ]);
            // Resolve the animation and report its conclusion
            deferred.resolveWith(elem, [
                animation
            ]);
            return false;
        }, animation = deferred.promise({
            elem: elem,
            props: jQuery.extend({}, properties),
            opts: jQuery.extend(true, {
                specialEasing: {},
                easing: jQuery.easing._default
            }, options),
            originalProperties: properties,
            originalOptions: options,
            startTime: fxNow || createFxNow(),
            duration: options.duration,
            tweens: [],
            createTween: function createTween(prop, end) {
                var tween = jQuery.Tween(elem, animation.opts, prop, end, animation.opts.specialEasing[prop] || animation.opts.easing);
                animation.tweens.push(tween);
                return tween;
            },
            stop: function stop(gotoEnd) {
                var index = 0, // If we are going to the end, we want to run all the tweens
                // otherwise we skip this part
                length = gotoEnd ? animation.tweens.length : 0;
                if (stopped) return this;
                stopped = true;
                for(; index < length; index++)animation.tweens[index].run(1);
                // Resolve when we played the last frame; otherwise, reject
                if (gotoEnd) {
                    deferred.notifyWith(elem, [
                        animation,
                        1,
                        0
                    ]);
                    deferred.resolveWith(elem, [
                        animation,
                        gotoEnd
                    ]);
                } else deferred.rejectWith(elem, [
                    animation,
                    gotoEnd
                ]);
                return this;
            }
        }), props = animation.props;
        propFilter(props, animation.opts.specialEasing);
        for(; index < length; index++){
            result = Animation.prefilters[index].call(animation, elem, props, animation.opts);
            if (result) {
                if (isFunction(result.stop)) jQuery._queueHooks(animation.elem, animation.opts.queue).stop = result.stop.bind(result);
                return result;
            }
        }
        jQuery.map(props, createTween, animation);
        if (isFunction(animation.opts.start)) animation.opts.start.call(elem, animation);
        // Attach callbacks from options
        animation.progress(animation.opts.progress).done(animation.opts.done, animation.opts.complete).fail(animation.opts.fail).always(animation.opts.always);
        jQuery.fx.timer(jQuery.extend(tick, {
            elem: elem,
            anim: animation,
            queue: animation.opts.queue
        }));
        return animation;
    }
    jQuery.Animation = jQuery.extend(Animation, {
        tweeners: {
            "*": [
                function(prop, value) {
                    var tween = this.createTween(prop, value);
                    adjustCSS(tween.elem, prop, rcssNum.exec(value), tween);
                    return tween;
                }
            ]
        },
        tweener: function tweener(props, callback) {
            if (isFunction(props)) {
                callback = props;
                props = [
                    "*"
                ];
            } else props = props.match(rnothtmlwhite);
            var prop, index = 0, length = props.length;
            for(; index < length; index++){
                prop = props[index];
                Animation.tweeners[prop] = Animation.tweeners[prop] || [];
                Animation.tweeners[prop].unshift(callback);
            }
        },
        prefilters: [
            defaultPrefilter
        ],
        prefilter: function prefilter(callback, prepend) {
            if (prepend) Animation.prefilters.unshift(callback);
            else Animation.prefilters.push(callback);
        }
    });
    jQuery.speed = function(speed, easing, fn) {
        var opt = speed && typeof speed === "object" ? jQuery.extend({}, speed) : {
            complete: fn || !fn && easing || isFunction(speed) && speed,
            duration: speed,
            easing: fn && easing || easing && !isFunction(easing) && easing
        };
        // Go to the end state if fx are off
        if (jQuery.fx.off) opt.duration = 0;
        else if (typeof opt.duration !== "number") {
            if (opt.duration in jQuery.fx.speeds) opt.duration = jQuery.fx.speeds[opt.duration];
            else opt.duration = jQuery.fx.speeds._default;
        }
        // Normalize opt.queue - true/undefined/null -> "fx"
        if (opt.queue == null || opt.queue === true) opt.queue = "fx";
        // Queueing
        opt.old = opt.complete;
        opt.complete = function() {
            if (isFunction(opt.old)) opt.old.call(this);
            if (opt.queue) jQuery.dequeue(this, opt.queue);
        };
        return opt;
    };
    jQuery.fn.extend({
        fadeTo: function fadeTo(speed, to, easing, callback) {
            // Show any hidden elements after setting opacity to 0
            return this.filter(isHiddenWithinTree).css("opacity", 0).show()// Animate to the value specified
            .end().animate({
                opacity: to
            }, speed, easing, callback);
        },
        animate: function animate(prop, speed, easing, callback) {
            var empty = jQuery.isEmptyObject(prop), optall = jQuery.speed(speed, easing, callback), doAnimation = function doAnimation() {
                // Operate on a copy of prop so per-property easing won't be lost
                var anim = Animation(this, jQuery.extend({}, prop), optall);
                // Empty animations, or finishing resolves immediately
                if (empty || dataPriv.get(this, "finish")) anim.stop(true);
            };
            doAnimation.finish = doAnimation;
            return empty || optall.queue === false ? this.each(doAnimation) : this.queue(optall.queue, doAnimation);
        },
        stop: function stop(type, clearQueue, gotoEnd) {
            var stopQueue = function stopQueue(hooks) {
                var stop = hooks.stop;
                delete hooks.stop;
                stop(gotoEnd);
            };
            if (typeof type !== "string") {
                gotoEnd = clearQueue;
                clearQueue = type;
                type = undefined;
            }
            if (clearQueue) this.queue(type || "fx", []);
            return this.each(function() {
                var dequeue = true, index = type != null && type + "queueHooks", timers = jQuery.timers, data = dataPriv.get(this);
                if (index) {
                    if (data[index] && data[index].stop) stopQueue(data[index]);
                } else {
                    for(index in data)if (data[index] && data[index].stop && rrun.test(index)) stopQueue(data[index]);
                }
                for(index = timers.length; index--;)if (timers[index].elem === this && (type == null || timers[index].queue === type)) {
                    timers[index].anim.stop(gotoEnd);
                    dequeue = false;
                    timers.splice(index, 1);
                }
                // Start the next in the queue if the last step wasn't forced.
                // Timers currently will call their complete callbacks, which
                // will dequeue but only if they were gotoEnd.
                if (dequeue || !gotoEnd) jQuery.dequeue(this, type);
            });
        },
        finish: function finish(type) {
            if (type !== false) type = type || "fx";
            return this.each(function() {
                var index, data = dataPriv.get(this), queue = data[type + "queue"], hooks = data[type + "queueHooks"], timers = jQuery.timers, length = queue ? queue.length : 0;
                // Enable finishing flag on private data
                data.finish = true;
                // Empty the queue first
                jQuery.queue(this, type, []);
                if (hooks && hooks.stop) hooks.stop.call(this, true);
                // Look for any active animations, and finish them
                for(index = timers.length; index--;)if (timers[index].elem === this && timers[index].queue === type) {
                    timers[index].anim.stop(true);
                    timers.splice(index, 1);
                }
                // Look for any animations in the old queue and finish them
                for(index = 0; index < length; index++)if (queue[index] && queue[index].finish) queue[index].finish.call(this);
                // Turn off finishing flag
                delete data.finish;
            });
        }
    });
    jQuery.each([
        "toggle",
        "show",
        "hide"
    ], function(_i, name) {
        var cssFn = jQuery.fn[name];
        jQuery.fn[name] = function(speed, easing, callback) {
            return speed == null || typeof speed === "boolean" ? cssFn.apply(this, arguments) : this.animate(genFx(name, true), speed, easing, callback);
        };
    });
    // Generate shortcuts for custom animations
    jQuery.each({
        slideDown: genFx("show"),
        slideUp: genFx("hide"),
        slideToggle: genFx("toggle"),
        fadeIn: {
            opacity: "show"
        },
        fadeOut: {
            opacity: "hide"
        },
        fadeToggle: {
            opacity: "toggle"
        }
    }, function(name, props) {
        jQuery.fn[name] = function(speed, easing, callback) {
            return this.animate(props, speed, easing, callback);
        };
    });
    jQuery.timers = [];
    jQuery.fx.tick = function() {
        var timer, i = 0, timers = jQuery.timers;
        fxNow = Date.now();
        for(; i < timers.length; i++){
            timer = timers[i];
            // Run the timer and safely remove it when done (allowing for external removal)
            if (!timer() && timers[i] === timer) timers.splice(i--, 1);
        }
        if (!timers.length) jQuery.fx.stop();
        fxNow = undefined;
    };
    jQuery.fx.timer = function(timer) {
        jQuery.timers.push(timer);
        jQuery.fx.start();
    };
    jQuery.fx.interval = 13;
    jQuery.fx.start = function() {
        if (inProgress) return;
        inProgress = true;
        schedule();
    };
    jQuery.fx.stop = function() {
        inProgress = null;
    };
    jQuery.fx.speeds = {
        slow: 600,
        fast: 200,
        // Default speed
        _default: 400
    };
    // Based off of the plugin by Clint Helfers, with permission.
    jQuery.fn.delay = function(time, type) {
        time = jQuery.fx ? jQuery.fx.speeds[time] || time : time;
        type = type || "fx";
        return this.queue(type, function(next, hooks) {
            var timeout = window1.setTimeout(next, time);
            hooks.stop = function() {
                window1.clearTimeout(timeout);
            };
        });
    };
    (function() {
        var input = document.createElement("input"), select = document.createElement("select"), opt = select.appendChild(document.createElement("option"));
        input.type = "checkbox";
        // Support: Android <=4.3 only
        // Default value for a checkbox should be "on"
        support.checkOn = input.value !== "";
        // Support: IE <=11 only
        // Must access selectedIndex to make default options select
        support.optSelected = opt.selected;
        // Support: IE <=11 only
        // An input loses its value after becoming a radio
        input = document.createElement("input");
        input.value = "t";
        input.type = "radio";
        support.radioValue = input.value === "t";
    })();
    var boolHook, attrHandle = jQuery.expr.attrHandle;
    jQuery.fn.extend({
        attr: function attr(name, value) {
            return access(this, jQuery.attr, name, value, arguments.length > 1);
        },
        removeAttr: function removeAttr(name) {
            return this.each(function() {
                jQuery.removeAttr(this, name);
            });
        }
    });
    jQuery.extend({
        attr: function attr(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set attributes on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            // Fallback to prop when attributes are not supported
            if (typeof elem.getAttribute === "undefined") return jQuery.prop(elem, name, value);
            // Attribute hooks are determined by the lowercase version
            // Grab necessary hook if one is defined
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) hooks = jQuery.attrHooks[name.toLowerCase()] || (jQuery.expr.match.bool.test(name) ? boolHook : undefined);
            if (value !== undefined) {
                if (value === null) {
                    jQuery.removeAttr(elem, name);
                    return;
                }
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                elem.setAttribute(name, value + "");
                return value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            ret = jQuery.find.attr(elem, name);
            // Non-existent attributes return null, we normalize to undefined
            return ret == null ? undefined : ret;
        },
        attrHooks: {
            type: {
                set: function set(elem, value) {
                    if (!support.radioValue && value === "radio" && nodeName(elem, "input")) {
                        var val = elem.value;
                        elem.setAttribute("type", value);
                        if (val) elem.value = val;
                        return value;
                    }
                }
            }
        },
        removeAttr: function removeAttr(elem, value) {
            var name, i = 0, // Attribute names can contain non-HTML whitespace characters
            // https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
            attrNames = value && value.match(rnothtmlwhite);
            if (attrNames && elem.nodeType === 1) while(name = attrNames[i++])elem.removeAttribute(name);
        }
    });
    // Hooks for boolean attributes
    boolHook = {
        set: function set(elem, value, name) {
            if (value === false) // Remove boolean attributes when set to false
            jQuery.removeAttr(elem, name);
            else elem.setAttribute(name, name);
            return name;
        }
    };
    jQuery.each(jQuery.expr.match.bool.source.match(/\w+/g), function(_i, name) {
        var getter = attrHandle[name] || jQuery.find.attr;
        attrHandle[name] = function(elem, name, isXML) {
            var ret, handle, lowercaseName = name.toLowerCase();
            if (!isXML) {
                // Avoid an infinite loop by temporarily removing this function from the getter
                handle = attrHandle[lowercaseName];
                attrHandle[lowercaseName] = ret;
                ret = getter(elem, name, isXML) != null ? lowercaseName : null;
                attrHandle[lowercaseName] = handle;
            }
            return ret;
        };
    });
    var rfocusable = /^(?:input|select|textarea|button)$/i, rclickable = /^(?:a|area)$/i;
    jQuery.fn.extend({
        prop: function prop(name, value) {
            return access(this, jQuery.prop, name, value, arguments.length > 1);
        },
        removeProp: function removeProp(name) {
            return this.each(function() {
                delete this[jQuery.propFix[name] || name];
            });
        }
    });
    jQuery.extend({
        prop: function prop(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set properties on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
                // Fix name and attach hooks
                name = jQuery.propFix[name] || name;
                hooks = jQuery.propHooks[name];
            }
            if (value !== undefined) {
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                return elem[name] = value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            return elem[name];
        },
        propHooks: {
            tabIndex: {
                get: function get(elem) {
                    // Support: IE <=9 - 11 only
                    // elem.tabIndex doesn't always return the
                    // correct value when it hasn't been explicitly set
                    // Use proper attribute retrieval (trac-12072)
                    var tabindex = jQuery.find.attr(elem, "tabindex");
                    if (tabindex) return parseInt(tabindex, 10);
                    if (rfocusable.test(elem.nodeName) || rclickable.test(elem.nodeName) && elem.href) return 0;
                    return -1;
                }
            }
        },
        propFix: {
            "for": "htmlFor",
            "class": "className"
        }
    });
    // Support: IE <=11 only
    // Accessing the selectedIndex property
    // forces the browser to respect setting selected
    // on the option
    // The getter ensures a default option is selected
    // when in an optgroup
    // eslint rule "no-unused-expressions" is disabled for this code
    // since it considers such accessions noop
    if (!support.optSelected) jQuery.propHooks.selected = {
        get: function get(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent && parent.parentNode) parent.parentNode.selectedIndex;
            return null;
        },
        set: function set(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent) {
                parent.selectedIndex;
                if (parent.parentNode) parent.parentNode.selectedIndex;
            }
        }
    };
    jQuery.each([
        "tabIndex",
        "readOnly",
        "maxLength",
        "cellSpacing",
        "cellPadding",
        "rowSpan",
        "colSpan",
        "useMap",
        "frameBorder",
        "contentEditable"
    ], function() {
        jQuery.propFix[this.toLowerCase()] = this;
    });
    // Strip and collapse whitespace according to HTML spec
    // https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
    function stripAndCollapse(value) {
        var tokens = value.match(rnothtmlwhite) || [];
        return tokens.join(" ");
    }
    function getClass(elem) {
        return elem.getAttribute && elem.getAttribute("class") || "";
    }
    function classesToArray(value) {
        if (Array.isArray(value)) return value;
        if (typeof value === "string") return value.match(rnothtmlwhite) || [];
        return [];
    }
    jQuery.fn.extend({
        addClass: function addClass(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).addClass(value.call(this, j, getClass(this)));
            });
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        if (cur.indexOf(" " + className + " ") < 0) cur += className + " ";
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        removeClass: function removeClass(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).removeClass(value.call(this, j, getClass(this)));
            });
            if (!arguments.length) return this.attr("class", "");
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                // This expression is here for better compressibility (see addClass)
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Remove *all* instances
                        while(cur.indexOf(" " + className + " ") > -1)cur = cur.replace(" " + className + " ", " ");
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        toggleClass: function toggleClass(value, stateVal) {
            var classNames, className, i, self, type = typeof value === "undefined" ? "undefined" : (0, $jzTO1._)(value), isValidValue = type === "string" || Array.isArray(value);
            if (isFunction(value)) return this.each(function(i) {
                jQuery(this).toggleClass(value.call(this, i, getClass(this), stateVal), stateVal);
            });
            if (typeof stateVal === "boolean" && isValidValue) return stateVal ? this.addClass(value) : this.removeClass(value);
            classNames = classesToArray(value);
            return this.each(function() {
                if (isValidValue) {
                    // Toggle individual class names
                    self = jQuery(this);
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Check each className given, space separated list
                        if (self.hasClass(className)) self.removeClass(className);
                        else self.addClass(className);
                    }
                // Toggle whole class name
                } else if (value === undefined || type === "boolean") {
                    className = getClass(this);
                    if (className) // Store className if set
                    dataPriv.set(this, "__className__", className);
                    // If the element has a class name or if we're passed `false`,
                    // then remove the whole classname (if there was one, the above saved it).
                    // Otherwise bring back whatever was previously saved (if anything),
                    // falling back to the empty string if nothing was stored.
                    if (this.setAttribute) this.setAttribute("class", className || value === false ? "" : dataPriv.get(this, "__className__") || "");
                }
            });
        },
        hasClass: function hasClass(selector) {
            var className, elem, i = 0;
            className = " " + selector + " ";
            while(elem = this[i++]){
                if (elem.nodeType === 1 && (" " + stripAndCollapse(getClass(elem)) + " ").indexOf(className) > -1) return true;
            }
            return false;
        }
    });
    var rreturn = /\r/g;
    jQuery.fn.extend({
        val: function val(value) {
            var hooks, ret, valueIsFunction, elem = this[0];
            if (!arguments.length) {
                if (elem) {
                    hooks = jQuery.valHooks[elem.type] || jQuery.valHooks[elem.nodeName.toLowerCase()];
                    if (hooks && "get" in hooks && (ret = hooks.get(elem, "value")) !== undefined) return ret;
                    ret = elem.value;
                    // Handle most common string cases
                    if (typeof ret === "string") return ret.replace(rreturn, "");
                    // Handle cases where value is null/undef or number
                    return ret == null ? "" : ret;
                }
                return;
            }
            valueIsFunction = isFunction(value);
            return this.each(function(i) {
                var val;
                if (this.nodeType !== 1) return;
                if (valueIsFunction) val = value.call(this, i, jQuery(this).val());
                else val = value;
                // Treat null/undefined as ""; convert numbers to string
                if (val == null) val = "";
                else if (typeof val === "number") val += "";
                else if (Array.isArray(val)) val = jQuery.map(val, function(value) {
                    return value == null ? "" : value + "";
                });
                hooks = jQuery.valHooks[this.type] || jQuery.valHooks[this.nodeName.toLowerCase()];
                // If set returns undefined, fall back to normal setting
                if (!hooks || !("set" in hooks) || hooks.set(this, val, "value") === undefined) this.value = val;
            });
        }
    });
    jQuery.extend({
        valHooks: {
            option: {
                get: function get(elem) {
                    var val = jQuery.find.attr(elem, "value");
                    return val != null ? val : // Support: IE <=10 - 11 only
                    // option.text throws exceptions (trac-14686, trac-14858)
                    // Strip and collapse whitespace
                    // https://html.spec.whatwg.org/#strip-and-collapse-whitespace
                    stripAndCollapse(jQuery.text(elem));
                }
            },
            select: {
                get: function get(elem) {
                    var value, option, i, options = elem.options, index = elem.selectedIndex, one = elem.type === "select-one", values = one ? null : [], max = one ? index + 1 : options.length;
                    if (index < 0) i = max;
                    else i = one ? index : 0;
                    // Loop through all the selected options
                    for(; i < max; i++){
                        option = options[i];
                        // Support: IE <=9 only
                        // IE8-9 doesn't update selected after form reset (trac-2551)
                        if ((option.selected || i === index) && // Don't return options that are disabled or in a disabled optgroup
                        !option.disabled && (!option.parentNode.disabled || !nodeName(option.parentNode, "optgroup"))) {
                            // Get the specific value for the option
                            value = jQuery(option).val();
                            // We don't need an array for one selects
                            if (one) return value;
                            // Multi-Selects return an array
                            values.push(value);
                        }
                    }
                    return values;
                },
                set: function set(elem, value) {
                    var optionSet, option, options = elem.options, values = jQuery.makeArray(value), i = options.length;
                    while(i--){
                        option = options[i];
                        /* eslint-disable no-cond-assign */ if (option.selected = jQuery.inArray(jQuery.valHooks.option.get(option), values) > -1) optionSet = true;
                    /* eslint-enable no-cond-assign */ }
                    // Force browsers to behave consistently when non-matching value is set
                    if (!optionSet) elem.selectedIndex = -1;
                    return values;
                }
            }
        }
    });
    // Radios and checkboxes getter/setter
    jQuery.each([
        "radio",
        "checkbox"
    ], function() {
        jQuery.valHooks[this] = {
            set: function set(elem, value) {
                if (Array.isArray(value)) return elem.checked = jQuery.inArray(jQuery(elem).val(), value) > -1;
            }
        };
        if (!support.checkOn) jQuery.valHooks[this].get = function(elem) {
            return elem.getAttribute("value") === null ? "on" : elem.value;
        };
    });
    // Return jQuery for attributes-only inclusion
    var location = window1.location;
    var nonce = {
        guid: Date.now()
    };
    var rquery = /\?/;
    // Cross-browser xml parsing
    jQuery.parseXML = function(data) {
        var xml, parserErrorElem;
        if (!data || typeof data !== "string") return null;
        // Support: IE 9 - 11 only
        // IE throws on parseFromString with invalid input.
        try {
            xml = new window1.DOMParser().parseFromString(data, "text/xml");
        } catch (e) {}
        parserErrorElem = xml && xml.getElementsByTagName("parsererror")[0];
        if (!xml || parserErrorElem) jQuery.error("Invalid XML: " + (parserErrorElem ? jQuery.map(parserErrorElem.childNodes, function(el) {
            return el.textContent;
        }).join("\n") : data));
        return xml;
    };
    var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/, stopPropagationCallback = function stopPropagationCallback(e) {
        e.stopPropagation();
    };
    jQuery.extend(jQuery.event, {
        trigger: function trigger(event, data, elem, onlyHandlers) {
            var i, cur, tmp, bubbleType, ontype, handle, special, lastElement, eventPath = [
                elem || document
            ], type = hasOwn.call(event, "type") ? event.type : event, namespaces = hasOwn.call(event, "namespace") ? event.namespace.split(".") : [];
            cur = lastElement = tmp = elem = elem || document;
            // Don't do events on text and comment nodes
            if (elem.nodeType === 3 || elem.nodeType === 8) return;
            // focus/blur morphs to focusin/out; ensure we're not firing them right now
            if (rfocusMorph.test(type + jQuery.event.triggered)) return;
            if (type.indexOf(".") > -1) {
                // Namespaced trigger; create a regexp to match event type in handle()
                namespaces = type.split(".");
                type = namespaces.shift();
                namespaces.sort();
            }
            ontype = type.indexOf(":") < 0 && "on" + type;
            // Caller can pass in a jQuery.Event object, Object, or just an event type string
            event = event[jQuery.expando] ? event : new jQuery.Event(type, typeof event === "object" && event);
            // Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
            event.isTrigger = onlyHandlers ? 2 : 3;
            event.namespace = namespaces.join(".");
            event.rnamespace = event.namespace ? new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)") : null;
            // Clean up the event in case it is being reused
            event.result = undefined;
            if (!event.target) event.target = elem;
            // Clone any incoming data and prepend the event, creating the handler arg list
            data = data == null ? [
                event
            ] : jQuery.makeArray(data, [
                event
            ]);
            // Allow special events to draw outside the lines
            special = jQuery.event.special[type] || {};
            if (!onlyHandlers && special.trigger && special.trigger.apply(elem, data) === false) return;
            // Determine event propagation path in advance, per W3C events spec (trac-9951)
            // Bubble up to document, then to window; watch for a global ownerDocument var (trac-9724)
            if (!onlyHandlers && !special.noBubble && !isWindow(elem)) {
                bubbleType = special.delegateType || type;
                if (!rfocusMorph.test(bubbleType + type)) cur = cur.parentNode;
                for(; cur; cur = cur.parentNode){
                    eventPath.push(cur);
                    tmp = cur;
                }
                // Only add window if we got to document (e.g., not plain obj or detached DOM)
                if (tmp === (elem.ownerDocument || document)) eventPath.push(tmp.defaultView || tmp.parentWindow || window1);
            }
            // Fire handlers on the event path
            i = 0;
            while((cur = eventPath[i++]) && !event.isPropagationStopped()){
                lastElement = cur;
                event.type = i > 1 ? bubbleType : special.bindType || type;
                // jQuery handler
                handle = (dataPriv.get(cur, "events") || Object.create(null))[event.type] && dataPriv.get(cur, "handle");
                if (handle) handle.apply(cur, data);
                // Native handler
                handle = ontype && cur[ontype];
                if (handle && handle.apply && acceptData(cur)) {
                    event.result = handle.apply(cur, data);
                    if (event.result === false) event.preventDefault();
                }
            }
            event.type = type;
            // If nobody prevented the default action, do it now
            if (!onlyHandlers && !event.isDefaultPrevented()) {
                if ((!special._default || special._default.apply(eventPath.pop(), data) === false) && acceptData(elem)) // Call a native DOM method on the target with the same name as the event.
                // Don't do default actions on window, that's where global variables be (trac-6170)
                {
                    if (ontype && isFunction(elem[type]) && !isWindow(elem)) {
                        // Don't re-trigger an onFOO event when we call its FOO() method
                        tmp = elem[ontype];
                        if (tmp) elem[ontype] = null;
                        // Prevent re-triggering of the same event, since we already bubbled it above
                        jQuery.event.triggered = type;
                        if (event.isPropagationStopped()) lastElement.addEventListener(type, stopPropagationCallback);
                        elem[type]();
                        if (event.isPropagationStopped()) lastElement.removeEventListener(type, stopPropagationCallback);
                        jQuery.event.triggered = undefined;
                        if (tmp) elem[ontype] = tmp;
                    }
                }
            }
            return event.result;
        },
        // Piggyback on a donor event to simulate a different one
        // Used only for `focus(in | out)` events
        simulate: function simulate(type, elem, event) {
            var e = jQuery.extend(new jQuery.Event(), event, {
                type: type,
                isSimulated: true
            });
            jQuery.event.trigger(e, null, elem);
        }
    });
    jQuery.fn.extend({
        trigger: function trigger(type, data) {
            return this.each(function() {
                jQuery.event.trigger(type, data, this);
            });
        },
        triggerHandler: function triggerHandler(type, data) {
            var elem = this[0];
            if (elem) return jQuery.event.trigger(type, data, elem, true);
        }
    });
    var rbracket = /\[\]$/, rCRLF = /\r?\n/g, rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i, rsubmittable = /^(?:input|select|textarea|keygen)/i;
    function buildParams(prefix, obj, traditional, add) {
        var name;
        if (Array.isArray(obj)) // Serialize array item.
        jQuery.each(obj, function(i, v) {
            if (traditional || rbracket.test(prefix)) // Treat each array item as a scalar.
            add(prefix, v);
            else // Item is non-scalar (array or object), encode its numeric index.
            buildParams(prefix + "[" + (typeof v === "object" && v != null ? i : "") + "]", v, traditional, add);
        });
        else if (!traditional && toType(obj) === "object") // Serialize object item.
        for(name in obj)buildParams(prefix + "[" + name + "]", obj[name], traditional, add);
        else // Serialize scalar item.
        add(prefix, obj);
    }
    // Serialize an array of form elements or a set of
    // key/values into a query string
    jQuery.param = function(a, traditional) {
        var prefix, s = [], add = function add(key, valueOrFunction) {
            // If value is a function, invoke it and use its return value
            var value = isFunction(valueOrFunction) ? valueOrFunction() : valueOrFunction;
            s[s.length] = encodeURIComponent(key) + "=" + encodeURIComponent(value == null ? "" : value);
        };
        if (a == null) return "";
        // If an array was passed in, assume that it is an array of form elements.
        if (Array.isArray(a) || a.jquery && !jQuery.isPlainObject(a)) // Serialize the form elements
        jQuery.each(a, function() {
            add(this.name, this.value);
        });
        else // If traditional, encode the "old" way (the way 1.3.2 or older
        // did it), otherwise encode params recursively.
        for(prefix in a)buildParams(prefix, a[prefix], traditional, add);
        // Return the resulting serialization
        return s.join("&");
    };
    jQuery.fn.extend({
        serialize: function serialize() {
            return jQuery.param(this.serializeArray());
        },
        serializeArray: function serializeArray() {
            return this.map(function() {
                // Can add propHook for "elements" to filter or add form elements
                var elements = jQuery.prop(this, "elements");
                return elements ? jQuery.makeArray(elements) : this;
            }).filter(function() {
                var type = this.type;
                // Use .is( ":disabled" ) so that fieldset[disabled] works
                return this.name && !jQuery(this).is(":disabled") && rsubmittable.test(this.nodeName) && !rsubmitterTypes.test(type) && (this.checked || !rcheckableType.test(type));
            }).map(function(_i, elem) {
                var val = jQuery(this).val();
                if (val == null) return null;
                if (Array.isArray(val)) return jQuery.map(val, function(val) {
                    return {
                        name: elem.name,
                        value: val.replace(rCRLF, "\r\n")
                    };
                });
                return {
                    name: elem.name,
                    value: val.replace(rCRLF, "\r\n")
                };
            }).get();
        }
    });
    var r20 = /%20/g, rhash = /#.*$/, rantiCache = /([?&])_=[^&]*/, rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg, // trac-7653, trac-8125, trac-8152: local protocol detection
    rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/, rnoContent = /^(?:GET|HEAD)$/, rprotocol = /^\/\//, /* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */ prefilters = {}, /* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */ transports = {}, // Avoid comment-prolog char sequence (trac-10098); must appease lint and evade compression
    allTypes = "*/".concat("*"), // Anchor tag for parsing the document origin
    originAnchor = document.createElement("a");
    originAnchor.href = location.href;
    // Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
    function addToPrefiltersOrTransports(structure) {
        // dataTypeExpression is optional and defaults to "*"
        return function(dataTypeExpression, func) {
            if (typeof dataTypeExpression !== "string") {
                func = dataTypeExpression;
                dataTypeExpression = "*";
            }
            var dataType, i = 0, dataTypes = dataTypeExpression.toLowerCase().match(rnothtmlwhite) || [];
            if (isFunction(func)) {
                // For each dataType in the dataTypeExpression
                while(dataType = dataTypes[i++])// Prepend if requested
                if (dataType[0] === "+") {
                    dataType = dataType.slice(1) || "*";
                    (structure[dataType] = structure[dataType] || []).unshift(func);
                // Otherwise append
                } else (structure[dataType] = structure[dataType] || []).push(func);
            }
        };
    }
    // Base inspection function for prefilters and transports
    function inspectPrefiltersOrTransports(structure, options, originalOptions, jqXHR) {
        var inspected = {}, seekingTransport = structure === transports;
        function inspect(dataType) {
            var selected;
            inspected[dataType] = true;
            jQuery.each(structure[dataType] || [], function(_, prefilterOrFactory) {
                var dataTypeOrTransport = prefilterOrFactory(options, originalOptions, jqXHR);
                if (typeof dataTypeOrTransport === "string" && !seekingTransport && !inspected[dataTypeOrTransport]) {
                    options.dataTypes.unshift(dataTypeOrTransport);
                    inspect(dataTypeOrTransport);
                    return false;
                } else if (seekingTransport) return !(selected = dataTypeOrTransport);
            });
            return selected;
        }
        return inspect(options.dataTypes[0]) || !inspected["*"] && inspect("*");
    }
    // A special extend for ajax options
    // that takes "flat" options (not to be deep extended)
    // Fixes trac-9887
    function ajaxExtend(target, src) {
        var key, deep, flatOptions = jQuery.ajaxSettings.flatOptions || {};
        for(key in src)if (src[key] !== undefined) (flatOptions[key] ? target : deep || (deep = {}))[key] = src[key];
        if (deep) jQuery.extend(true, target, deep);
        return target;
    }
    /* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */ function ajaxHandleResponses(s, jqXHR, responses) {
        var ct, type, finalDataType, firstDataType, contents = s.contents, dataTypes = s.dataTypes;
        // Remove auto dataType and get content-type in the process
        while(dataTypes[0] === "*"){
            dataTypes.shift();
            if (ct === undefined) ct = s.mimeType || jqXHR.getResponseHeader("Content-Type");
        }
        // Check if we're dealing with a known content-type
        if (ct) {
            for(type in contents)if (contents[type] && contents[type].test(ct)) {
                dataTypes.unshift(type);
                break;
            }
        }
        // Check to see if we have a response for the expected dataType
        if (dataTypes[0] in responses) finalDataType = dataTypes[0];
        else {
            // Try convertible dataTypes
            for(type in responses){
                if (!dataTypes[0] || s.converters[type + " " + dataTypes[0]]) {
                    finalDataType = type;
                    break;
                }
                if (!firstDataType) firstDataType = type;
            }
            // Or just use first one
            finalDataType = finalDataType || firstDataType;
        }
        // If we found a dataType
        // We add the dataType to the list if needed
        // and return the corresponding response
        if (finalDataType) {
            if (finalDataType !== dataTypes[0]) dataTypes.unshift(finalDataType);
            return responses[finalDataType];
        }
    }
    /* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */ function ajaxConvert(s, response, jqXHR, isSuccess) {
        var conv2, current, conv, tmp, prev, converters = {}, // Work with a copy of dataTypes in case we need to modify it for conversion
        dataTypes = s.dataTypes.slice();
        // Create converters map with lowercased keys
        if (dataTypes[1]) for(conv in s.converters)converters[conv.toLowerCase()] = s.converters[conv];
        current = dataTypes.shift();
        // Convert to each sequential dataType
        while(current){
            if (s.responseFields[current]) jqXHR[s.responseFields[current]] = response;
            // Apply the dataFilter if provided
            if (!prev && isSuccess && s.dataFilter) response = s.dataFilter(response, s.dataType);
            prev = current;
            current = dataTypes.shift();
            if (current) {
                // There's only work to do if current dataType is non-auto
                if (current === "*") current = prev;
                else if (prev !== "*" && prev !== current) {
                    // Seek a direct converter
                    conv = converters[prev + " " + current] || converters["* " + current];
                    // If none found, seek a pair
                    if (!conv) for(conv2 in converters){
                        // If conv2 outputs current
                        tmp = conv2.split(" ");
                        if (tmp[1] === current) {
                            // If prev can be converted to accepted input
                            conv = converters[prev + " " + tmp[0]] || converters["* " + tmp[0]];
                            if (conv) {
                                // Condense equivalence converters
                                if (conv === true) conv = converters[conv2];
                                else if (converters[conv2] !== true) {
                                    current = tmp[0];
                                    dataTypes.unshift(tmp[1]);
                                }
                                break;
                            }
                        }
                    }
                    // Apply converter (if not an equivalence)
                    if (conv !== true) {
                        // Unless errors are allowed to bubble, catch and return them
                        if (conv && s.throws) response = conv(response);
                        else try {
                            response = conv(response);
                        } catch (e) {
                            return {
                                state: "parsererror",
                                error: conv ? e : "No conversion from " + prev + " to " + current
                            };
                        }
                    }
                }
            }
        }
        return {
            state: "success",
            data: response
        };
    }
    jQuery.extend({
        // Counter for holding the number of active queries
        active: 0,
        // Last-Modified header cache for next request
        lastModified: {},
        etag: {},
        ajaxSettings: {
            url: location.href,
            type: "GET",
            isLocal: rlocalProtocol.test(location.protocol),
            global: true,
            processData: true,
            async: true,
            contentType: "application/x-www-form-urlencoded; charset=UTF-8",
            /*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/ accepts: {
                "*": allTypes,
                text: "text/plain",
                html: "text/html",
                xml: "application/xml, text/xml",
                json: "application/json, text/javascript"
            },
            contents: {
                xml: /\bxml\b/,
                html: /\bhtml/,
                json: /\bjson\b/
            },
            responseFields: {
                xml: "responseXML",
                text: "responseText",
                json: "responseJSON"
            },
            // Data converters
            // Keys separate source (or catchall "*") and destination types with a single space
            converters: {
                // Convert anything to text
                "* text": String,
                // Text to html (true = no transformation)
                "text html": true,
                // Evaluate text as a json expression
                "text json": JSON.parse,
                // Parse text as xml
                "text xml": jQuery.parseXML
            },
            // For options that shouldn't be deep extended:
            // you can add your own custom options here if
            // and when you create one that shouldn't be
            // deep extended (see ajaxExtend)
            flatOptions: {
                url: true,
                context: true
            }
        },
        // Creates a full fledged settings object into target
        // with both ajaxSettings and settings fields.
        // If target is omitted, writes into ajaxSettings.
        ajaxSetup: function ajaxSetup(target, settings) {
            return settings ? // Building a settings object
            ajaxExtend(ajaxExtend(target, jQuery.ajaxSettings), settings) : // Extending ajaxSettings
            ajaxExtend(jQuery.ajaxSettings, target);
        },
        ajaxPrefilter: addToPrefiltersOrTransports(prefilters),
        ajaxTransport: addToPrefiltersOrTransports(transports),
        // Main method
        ajax: function ajax(url, options) {
            // If url is an object, simulate pre-1.5 signature
            if (typeof url === "object") {
                options = url;
                url = undefined;
            }
            // Force options to be an object
            options = options || {};
            var transport, // URL without anti-cache param
            cacheURL, // Response headers
            responseHeadersString, responseHeaders, // timeout handle
            timeoutTimer, // Url cleanup var
            urlAnchor, // Request state (becomes false upon send and true upon completion)
            _$completed, // To know if global events are to be dispatched
            fireGlobals, // Loop variable
            i, // uncached part of the url
            uncached, // Create the final options object
            s = jQuery.ajaxSetup({}, options), // Callbacks context
            callbackContext = s.context || s, // Context for global events is callbackContext if it is a DOM node or jQuery collection
            globalEventContext = s.context && (callbackContext.nodeType || callbackContext.jquery) ? jQuery(callbackContext) : jQuery.event, // Deferreds
            deferred = jQuery.Deferred(), completeDeferred = jQuery.Callbacks("once memory"), // Status-dependent callbacks
            statusCode = s.statusCode || {}, // Headers (they are sent all at once)
            requestHeaders = {}, requestHeadersNames = {}, // Default abort message
            strAbort = "canceled", // Fake xhr
            jqXHR = {
                readyState: 0,
                // Builds headers hashtable if needed
                getResponseHeader: function getResponseHeader(key) {
                    var match;
                    if (_$completed) {
                        if (!responseHeaders) {
                            responseHeaders = {};
                            while(match = rheaders.exec(responseHeadersString))responseHeaders[match[1].toLowerCase() + " "] = (responseHeaders[match[1].toLowerCase() + " "] || []).concat(match[2]);
                        }
                        match = responseHeaders[key.toLowerCase() + " "];
                    }
                    return match == null ? null : match.join(", ");
                },
                // Raw string
                getAllResponseHeaders: function getAllResponseHeaders() {
                    return _$completed ? responseHeadersString : null;
                },
                // Caches the header
                setRequestHeader: function setRequestHeader(name, value) {
                    if (_$completed == null) {
                        name = requestHeadersNames[name.toLowerCase()] = requestHeadersNames[name.toLowerCase()] || name;
                        requestHeaders[name] = value;
                    }
                    return this;
                },
                // Overrides response content-type header
                overrideMimeType: function overrideMimeType(type) {
                    if (_$completed == null) s.mimeType = type;
                    return this;
                },
                // Status-dependent callbacks
                statusCode: function statusCode1(map) {
                    var code;
                    if (map) {
                        if (_$completed) // Execute the appropriate callbacks
                        jqXHR.always(map[jqXHR.status]);
                        else // Lazy-add the new callbacks in a way that preserves old ones
                        for(code in map)statusCode[code] = [
                            statusCode[code],
                            map[code]
                        ];
                    }
                    return this;
                },
                // Cancel the request
                abort: function abort(statusText) {
                    var finalText = statusText || strAbort;
                    if (transport) transport.abort(finalText);
                    done(0, finalText);
                    return this;
                }
            };
            // Attach deferreds
            deferred.promise(jqXHR);
            // Add protocol if not provided (prefilters might expect it)
            // Handle falsy url in the settings object (trac-10093: consistency with old signature)
            // We also use the url parameter if available
            s.url = ((url || s.url || location.href) + "").replace(rprotocol, location.protocol + "//");
            // Alias method option to type as per ticket trac-12004
            s.type = options.method || options.type || s.method || s.type;
            // Extract dataTypes list
            s.dataTypes = (s.dataType || "*").toLowerCase().match(rnothtmlwhite) || [
                ""
            ];
            // A cross-domain request is in order when the origin doesn't match the current origin.
            if (s.crossDomain == null) {
                urlAnchor = document.createElement("a");
                // Support: IE <=8 - 11, Edge 12 - 15
                // IE throws exception on accessing the href property if url is malformed,
                // e.g. http://example.com:80x/
                try {
                    urlAnchor.href = s.url;
                    // Support: IE <=8 - 11 only
                    // Anchor's host property isn't correctly set when s.url is relative
                    urlAnchor.href = urlAnchor.href;
                    s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !== urlAnchor.protocol + "//" + urlAnchor.host;
                } catch (e) {
                    // If there is an error parsing the URL, assume it is crossDomain,
                    // it can be rejected by the transport if it is invalid
                    s.crossDomain = true;
                }
            }
            // Convert data if not already a string
            if (s.data && s.processData && typeof s.data !== "string") s.data = jQuery.param(s.data, s.traditional);
            // Apply prefilters
            inspectPrefiltersOrTransports(prefilters, s, options, jqXHR);
            // If request was aborted inside a prefilter, stop there
            if (_$completed) return jqXHR;
            // We can fire global events as of now if asked to
            // Don't fire events if jQuery.event is undefined in an AMD-usage scenario (trac-15118)
            fireGlobals = jQuery.event && s.global;
            // Watch for a new set of requests
            if (fireGlobals && jQuery.active++ === 0) jQuery.event.trigger("ajaxStart");
            // Uppercase the type
            s.type = s.type.toUpperCase();
            // Determine if request has content
            s.hasContent = !rnoContent.test(s.type);
            // Save the URL in case we're toying with the If-Modified-Since
            // and/or If-None-Match header later on
            // Remove hash to simplify url manipulation
            cacheURL = s.url.replace(rhash, "");
            // More options handling for requests with no content
            if (!s.hasContent) {
                // Remember the hash so we can put it back
                uncached = s.url.slice(cacheURL.length);
                // If data is available and should be processed, append data to url
                if (s.data && (s.processData || typeof s.data === "string")) {
                    cacheURL += (rquery.test(cacheURL) ? "&" : "?") + s.data;
                    // trac-9682: remove data so that it's not used in an eventual retry
                    delete s.data;
                }
                // Add or update anti-cache param if needed
                if (s.cache === false) {
                    cacheURL = cacheURL.replace(rantiCache, "$1");
                    uncached = (rquery.test(cacheURL) ? "&" : "?") + "_=" + nonce.guid++ + uncached;
                }
                // Put hash and anti-cache on the URL that will be requested (gh-1732)
                s.url = cacheURL + uncached;
            // Change '%20' to '+' if this is encoded form body content (gh-2658)
            } else if (s.data && s.processData && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0) s.data = s.data.replace(r20, "+");
            // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
            if (s.ifModified) {
                if (jQuery.lastModified[cacheURL]) jqXHR.setRequestHeader("If-Modified-Since", jQuery.lastModified[cacheURL]);
                if (jQuery.etag[cacheURL]) jqXHR.setRequestHeader("If-None-Match", jQuery.etag[cacheURL]);
            }
            // Set the correct header, if data is being sent
            if (s.data && s.hasContent && s.contentType !== false || options.contentType) jqXHR.setRequestHeader("Content-Type", s.contentType);
            // Set the Accepts header for the server, depending on the dataType
            jqXHR.setRequestHeader("Accept", s.dataTypes[0] && s.accepts[s.dataTypes[0]] ? s.accepts[s.dataTypes[0]] + (s.dataTypes[0] !== "*" ? ", " + allTypes + "; q=0.01" : "") : s.accepts["*"]);
            // Check for headers option
            for(i in s.headers)jqXHR.setRequestHeader(i, s.headers[i]);
            // Allow custom headers/mimetypes and early abort
            if (s.beforeSend && (s.beforeSend.call(callbackContext, jqXHR, s) === false || _$completed)) // Abort if not done already and return
            return jqXHR.abort();
            // Aborting is no longer a cancellation
            strAbort = "abort";
            // Install callbacks on deferreds
            completeDeferred.add(s.complete);
            jqXHR.done(s.success);
            jqXHR.fail(s.error);
            // Get transport
            transport = inspectPrefiltersOrTransports(transports, s, options, jqXHR);
            // If no transport, we auto-abort
            if (!transport) done(-1, "No Transport");
            else {
                jqXHR.readyState = 1;
                // Send global event
                if (fireGlobals) globalEventContext.trigger("ajaxSend", [
                    jqXHR,
                    s
                ]);
                // If request was aborted inside ajaxSend, stop there
                if (_$completed) return jqXHR;
                // Timeout
                if (s.async && s.timeout > 0) timeoutTimer = window1.setTimeout(function() {
                    jqXHR.abort("timeout");
                }, s.timeout);
                try {
                    _$completed = false;
                    transport.send(requestHeaders, done);
                } catch (e) {
                    // Rethrow post-completion exceptions
                    if (_$completed) throw e;
                    // Propagate others as results
                    done(-1, e);
                }
            }
            // Callback for when everything is done
            function done(status, nativeStatusText, responses, headers) {
                var isSuccess, success, error, response, modified, statusText = nativeStatusText;
                // Ignore repeat invocations
                if (_$completed) return;
                _$completed = true;
                // Clear timeout if it exists
                if (timeoutTimer) window1.clearTimeout(timeoutTimer);
                // Dereference transport for early garbage collection
                // (no matter how long the jqXHR object will be used)
                transport = undefined;
                // Cache response headers
                responseHeadersString = headers || "";
                // Set readyState
                jqXHR.readyState = status > 0 ? 4 : 0;
                // Determine if successful
                isSuccess = status >= 200 && status < 300 || status === 304;
                // Get response data
                if (responses) response = ajaxHandleResponses(s, jqXHR, responses);
                // Use a noop converter for missing script but not if jsonp
                if (!isSuccess && jQuery.inArray("script", s.dataTypes) > -1 && jQuery.inArray("json", s.dataTypes) < 0) s.converters["text script"] = function() {};
                // Convert no matter what (that way responseXXX fields are always set)
                response = ajaxConvert(s, response, jqXHR, isSuccess);
                // If successful, handle type chaining
                if (isSuccess) {
                    // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
                    if (s.ifModified) {
                        modified = jqXHR.getResponseHeader("Last-Modified");
                        if (modified) jQuery.lastModified[cacheURL] = modified;
                        modified = jqXHR.getResponseHeader("etag");
                        if (modified) jQuery.etag[cacheURL] = modified;
                    }
                    // if no content
                    if (status === 204 || s.type === "HEAD") statusText = "nocontent";
                    else if (status === 304) statusText = "notmodified";
                    else {
                        statusText = response.state;
                        success = response.data;
                        error = response.error;
                        isSuccess = !error;
                    }
                } else {
                    // Extract error from statusText and normalize for non-aborts
                    error = statusText;
                    if (status || !statusText) {
                        statusText = "error";
                        if (status < 0) status = 0;
                    }
                }
                // Set data for the fake xhr object
                jqXHR.status = status;
                jqXHR.statusText = (nativeStatusText || statusText) + "";
                // Success/Error
                if (isSuccess) deferred.resolveWith(callbackContext, [
                    success,
                    statusText,
                    jqXHR
                ]);
                else deferred.rejectWith(callbackContext, [
                    jqXHR,
                    statusText,
                    error
                ]);
                // Status-dependent callbacks
                jqXHR.statusCode(statusCode);
                statusCode = undefined;
                if (fireGlobals) globalEventContext.trigger(isSuccess ? "ajaxSuccess" : "ajaxError", [
                    jqXHR,
                    s,
                    isSuccess ? success : error
                ]);
                // Complete
                completeDeferred.fireWith(callbackContext, [
                    jqXHR,
                    statusText
                ]);
                if (fireGlobals) {
                    globalEventContext.trigger("ajaxComplete", [
                        jqXHR,
                        s
                    ]);
                    // Handle the global AJAX counter
                    if (!--jQuery.active) jQuery.event.trigger("ajaxStop");
                }
            }
            return jqXHR;
        },
        getJSON: function getJSON(url, data, callback) {
            return jQuery.get(url, data, callback, "json");
        },
        getScript: function getScript(url, callback) {
            return jQuery.get(url, undefined, callback, "script");
        }
    });
    jQuery.each([
        "get",
        "post"
    ], function(_i, method) {
        jQuery[method] = function(url, data, callback, type) {
            // Shift arguments if data argument was omitted
            if (isFunction(data)) {
                type = type || callback;
                callback = data;
                data = undefined;
            }
            // The url can be an options object (which then must have .url)
            return jQuery.ajax(jQuery.extend({
                url: url,
                type: method,
                dataType: type,
                data: data,
                success: callback
            }, jQuery.isPlainObject(url) && url));
        };
    });
    jQuery.ajaxPrefilter(function(s) {
        var i;
        for(i in s.headers)if (i.toLowerCase() === "content-type") s.contentType = s.headers[i] || "";
    });
    jQuery._evalUrl = function(url, options, doc) {
        return jQuery.ajax({
            url: url,
            // Make this explicit, since user can override this through ajaxSetup (trac-11264)
            type: "GET",
            dataType: "script",
            cache: true,
            async: false,
            global: false,
            // Only evaluate the response if it is successful (gh-4126)
            // dataFilter is not invoked for failure responses, so using it instead
            // of the default converter is kludgy but it works.
            converters: {
                "text script": function() {}
            },
            dataFilter: function dataFilter(response) {
                jQuery.globalEval(response, options, doc);
            }
        });
    };
    jQuery.fn.extend({
        wrapAll: function wrapAll(html) {
            var wrap;
            if (this[0]) {
                if (isFunction(html)) html = html.call(this[0]);
                // The elements to wrap the target around
                wrap = jQuery(html, this[0].ownerDocument).eq(0).clone(true);
                if (this[0].parentNode) wrap.insertBefore(this[0]);
                wrap.map(function() {
                    var elem = this;
                    while(elem.firstElementChild)elem = elem.firstElementChild;
                    return elem;
                }).append(this);
            }
            return this;
        },
        wrapInner: function wrapInner(html) {
            if (isFunction(html)) return this.each(function(i) {
                jQuery(this).wrapInner(html.call(this, i));
            });
            return this.each(function() {
                var self = jQuery(this), contents = self.contents();
                if (contents.length) contents.wrapAll(html);
                else self.append(html);
            });
        },
        wrap: function wrap(html) {
            var htmlIsFunction = isFunction(html);
            return this.each(function(i) {
                jQuery(this).wrapAll(htmlIsFunction ? html.call(this, i) : html);
            });
        },
        unwrap: function unwrap(selector) {
            this.parent(selector).not("body").each(function() {
                jQuery(this).replaceWith(this.childNodes);
            });
            return this;
        }
    });
    jQuery.expr.pseudos.hidden = function(elem) {
        return !jQuery.expr.pseudos.visible(elem);
    };
    jQuery.expr.pseudos.visible = function(elem) {
        return !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
    };
    jQuery.ajaxSettings.xhr = function() {
        try {
            return new window1.XMLHttpRequest();
        } catch (e) {}
    };
    var xhrSuccessStatus = {
        // File protocol always yields status code 0, assume 200
        0: 200,
        // Support: IE <=9 only
        // trac-1450: sometimes IE returns 1223 when it should be 204
        1223: 204
    }, xhrSupported = jQuery.ajaxSettings.xhr();
    support.cors = !!xhrSupported && "withCredentials" in xhrSupported;
    support.ajax = xhrSupported = !!xhrSupported;
    jQuery.ajaxTransport(function(options) {
        var callback, errorCallback;
        // Cross domain only allowed if supported through XMLHttpRequest
        if (support.cors || xhrSupported && !options.crossDomain) return {
            send: function send(headers, complete) {
                var i, xhr = options.xhr();
                xhr.open(options.type, options.url, options.async, options.username, options.password);
                // Apply custom fields if provided
                if (options.xhrFields) for(i in options.xhrFields)xhr[i] = options.xhrFields[i];
                // Override mime type if needed
                if (options.mimeType && xhr.overrideMimeType) xhr.overrideMimeType(options.mimeType);
                // X-Requested-With header
                // For cross-domain requests, seeing as conditions for a preflight are
                // akin to a jigsaw puzzle, we simply never set it to be sure.
                // (it can always be set on a per-request basis or even using ajaxSetup)
                // For same-domain requests, won't change header if already provided.
                if (!options.crossDomain && !headers["X-Requested-With"]) headers["X-Requested-With"] = "XMLHttpRequest";
                // Set headers
                for(i in headers)xhr.setRequestHeader(i, headers[i]);
                // Callback
                callback = function(type) {
                    return function() {
                        if (callback) {
                            callback = errorCallback = xhr.onload = xhr.onerror = xhr.onabort = xhr.ontimeout = xhr.onreadystatechange = null;
                            if (type === "abort") xhr.abort();
                            else if (type === "error") {
                                // Support: IE <=9 only
                                // On a manual native abort, IE9 throws
                                // errors on any property access that is not readyState
                                if (typeof xhr.status !== "number") complete(0, "error");
                                else complete(// File: protocol always yields status 0; see trac-8605, trac-14207
                                xhr.status, xhr.statusText);
                            } else complete(xhrSuccessStatus[xhr.status] || xhr.status, xhr.statusText, // Support: IE <=9 only
                            // IE9 has no XHR2 but throws on binary (trac-11426)
                            // For XHR2 non-text, let the caller handle it (gh-2498)
                            (xhr.responseType || "text") !== "text" || typeof xhr.responseText !== "string" ? {
                                binary: xhr.response
                            } : {
                                text: xhr.responseText
                            }, xhr.getAllResponseHeaders());
                        }
                    };
                };
                // Listen to events
                xhr.onload = callback();
                errorCallback = xhr.onerror = xhr.ontimeout = callback("error");
                // Support: IE 9 only
                // Use onreadystatechange to replace onabort
                // to handle uncaught aborts
                if (xhr.onabort !== undefined) xhr.onabort = errorCallback;
                else xhr.onreadystatechange = function() {
                    // Check readyState before timeout as it changes
                    if (xhr.readyState === 4) // Allow onerror to be called first,
                    // but that will not handle a native abort
                    // Also, save errorCallback to a variable
                    // as xhr.onerror cannot be accessed
                    window1.setTimeout(function() {
                        if (callback) errorCallback();
                    });
                };
                // Create the abort callback
                callback = callback("abort");
                try {
                    // Do send the request (this may raise an exception)
                    xhr.send(options.hasContent && options.data || null);
                } catch (e) {
                    // trac-14683: Only rethrow if this hasn't been notified as an error yet
                    if (callback) throw e;
                }
            },
            abort: function abort() {
                if (callback) callback();
            }
        };
    });
    // Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
    jQuery.ajaxPrefilter(function(s) {
        if (s.crossDomain) s.contents.script = false;
    });
    // Install script dataType
    jQuery.ajaxSetup({
        accepts: {
            script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
        },
        contents: {
            script: /\b(?:java|ecma)script\b/
        },
        converters: {
            "text script": function(text) {
                jQuery.globalEval(text);
                return text;
            }
        }
    });
    // Handle cache's special case and crossDomain
    jQuery.ajaxPrefilter("script", function(s) {
        if (s.cache === undefined) s.cache = false;
        if (s.crossDomain) s.type = "GET";
    });
    // Bind script tag hack transport
    jQuery.ajaxTransport("script", function(s) {
        // This transport only deals with cross domain or forced-by-attrs requests
        if (s.crossDomain || s.scriptAttrs) {
            var script, callback;
            return {
                send: function send(_, complete) {
                    script = jQuery("<script>").attr(s.scriptAttrs || {}).prop({
                        charset: s.scriptCharset,
                        src: s.url
                    }).on("load error", callback = function(evt) {
                        script.remove();
                        callback = null;
                        if (evt) complete(evt.type === "error" ? 404 : 200, evt.type);
                    });
                    // Use native DOM manipulation to avoid our domManip AJAX trickery
                    document.head.appendChild(script[0]);
                },
                abort: function abort() {
                    if (callback) callback();
                }
            };
        }
    });
    var oldCallbacks = [], rjsonp = /(=)\?(?=&|$)|\?\?/;
    // Default jsonp settings
    jQuery.ajaxSetup({
        jsonp: "callback",
        jsonpCallback: function jsonpCallback() {
            var callback = oldCallbacks.pop() || jQuery.expando + "_" + nonce.guid++;
            this[callback] = true;
            return callback;
        }
    });
    // Detect, normalize options and install callbacks for jsonp requests
    jQuery.ajaxPrefilter("json jsonp", function(s, originalSettings, jqXHR) {
        var callbackName, overwritten, responseContainer, jsonProp = s.jsonp !== false && (rjsonp.test(s.url) ? "url" : typeof s.data === "string" && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && rjsonp.test(s.data) && "data");
        // Handle iff the expected data type is "jsonp" or we have a parameter to set
        if (jsonProp || s.dataTypes[0] === "jsonp") {
            // Get callback name, remembering preexisting value associated with it
            callbackName = s.jsonpCallback = isFunction(s.jsonpCallback) ? s.jsonpCallback() : s.jsonpCallback;
            // Insert callback into url or form data
            if (jsonProp) s[jsonProp] = s[jsonProp].replace(rjsonp, "$1" + callbackName);
            else if (s.jsonp !== false) s.url += (rquery.test(s.url) ? "&" : "?") + s.jsonp + "=" + callbackName;
            // Use data converter to retrieve json after script execution
            s.converters["script json"] = function() {
                if (!responseContainer) jQuery.error(callbackName + " was not called");
                return responseContainer[0];
            };
            // Force json dataType
            s.dataTypes[0] = "json";
            // Install callback
            overwritten = window1[callbackName];
            window1[callbackName] = function() {
                responseContainer = arguments;
            };
            // Clean-up function (fires after converters)
            jqXHR.always(function() {
                // If previous value didn't exist - remove it
                if (overwritten === undefined) jQuery(window1).removeProp(callbackName);
                else window1[callbackName] = overwritten;
                // Save back as free
                if (s[callbackName]) {
                    // Make sure that re-using the options doesn't screw things around
                    s.jsonpCallback = originalSettings.jsonpCallback;
                    // Save the callback name for future use
                    oldCallbacks.push(callbackName);
                }
                // Call if it was a function and we have a response
                if (responseContainer && isFunction(overwritten)) overwritten(responseContainer[0]);
                responseContainer = overwritten = undefined;
            });
            // Delegate to script
            return "script";
        }
    });
    // Support: Safari 8 only
    // In Safari 8 documents created via document.implementation.createHTMLDocument
    // collapse sibling forms: the second one becomes a child of the first one.
    // Because of that, this security measure has to be disabled in Safari 8.
    // https://bugs.webkit.org/show_bug.cgi?id=137337
    support.createHTMLDocument = function() {
        var body = document.implementation.createHTMLDocument("").body;
        body.innerHTML = "<form></form><form></form>";
        return body.childNodes.length === 2;
    }();
    // Argument "data" should be string of html
    // context (optional): If specified, the fragment will be created in this context,
    // defaults to document
    // keepScripts (optional): If true, will include scripts passed in the html string
    jQuery.parseHTML = function(data, context, keepScripts) {
        if (typeof data !== "string") return [];
        if (typeof context === "boolean") {
            keepScripts = context;
            context = false;
        }
        var base, parsed, scripts;
        if (!context) {
            // Stop scripts or inline event handlers from being executed immediately
            // by using document.implementation
            if (support.createHTMLDocument) {
                context = document.implementation.createHTMLDocument("");
                // Set the base href for the created document
                // so any parsed elements with URLs
                // are based on the document's URL (gh-2965)
                base = context.createElement("base");
                base.href = document.location.href;
                context.head.appendChild(base);
            } else context = document;
        }
        parsed = rsingleTag.exec(data);
        scripts = !keepScripts && [];
        // Single tag
        if (parsed) return [
            context.createElement(parsed[1])
        ];
        parsed = buildFragment([
            data
        ], context, scripts);
        if (scripts && scripts.length) jQuery(scripts).remove();
        return jQuery.merge([], parsed.childNodes);
    };
    /**
 * Load a url into a page
 */ jQuery.fn.load = function(url, params, callback) {
        var selector, type, response, self = this, off = url.indexOf(" ");
        if (off > -1) {
            selector = stripAndCollapse(url.slice(off));
            url = url.slice(0, off);
        }
        // If it's a function
        if (isFunction(params)) {
            // We assume that it's the callback
            callback = params;
            params = undefined;
        // Otherwise, build a param string
        } else if (params && typeof params === "object") type = "POST";
        // If we have elements to modify, make the request
        if (self.length > 0) jQuery.ajax({
            url: url,
            // If "type" variable is undefined, then "GET" method will be used.
            // Make value of this field explicit since
            // user can override it through ajaxSetup method
            type: type || "GET",
            dataType: "html",
            data: params
        }).done(function(responseText) {
            // Save response for use in complete callback
            response = arguments;
            self.html(selector ? // If a selector was specified, locate the right elements in a dummy div
            // Exclude scripts to avoid IE 'Permission Denied' errors
            jQuery("<div>").append(jQuery.parseHTML(responseText)).find(selector) : // Otherwise use the full result
            responseText);
        // If the request succeeds, this function gets "data", "status", "jqXHR"
        // but they are ignored because response was set above.
        // If it fails, this function gets "jqXHR", "status", "error"
        }).always(callback && function(jqXHR, status) {
            self.each(function() {
                callback.apply(this, response || [
                    jqXHR.responseText,
                    status,
                    jqXHR
                ]);
            });
        });
        return this;
    };
    jQuery.expr.pseudos.animated = function(elem) {
        return jQuery.grep(jQuery.timers, function(fn) {
            return elem === fn.elem;
        }).length;
    };
    jQuery.offset = {
        setOffset: function setOffset(elem, options, i) {
            var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition, position = jQuery.css(elem, "position"), curElem = jQuery(elem), props = {};
            // Set position first, in-case top/left are set even on static elem
            if (position === "static") elem.style.position = "relative";
            curOffset = curElem.offset();
            curCSSTop = jQuery.css(elem, "top");
            curCSSLeft = jQuery.css(elem, "left");
            calculatePosition = (position === "absolute" || position === "fixed") && (curCSSTop + curCSSLeft).indexOf("auto") > -1;
            // Need to be able to calculate position if either
            // top or left is auto and position is either absolute or fixed
            if (calculatePosition) {
                curPosition = curElem.position();
                curTop = curPosition.top;
                curLeft = curPosition.left;
            } else {
                curTop = parseFloat(curCSSTop) || 0;
                curLeft = parseFloat(curCSSLeft) || 0;
            }
            if (isFunction(options)) // Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
            options = options.call(elem, i, jQuery.extend({}, curOffset));
            if (options.top != null) props.top = options.top - curOffset.top + curTop;
            if (options.left != null) props.left = options.left - curOffset.left + curLeft;
            if ("using" in options) options.using.call(elem, props);
            else curElem.css(props);
        }
    };
    jQuery.fn.extend({
        // offset() relates an element's border box to the document origin
        offset: function offset(options) {
            // Preserve chaining for setter
            if (arguments.length) return options === undefined ? this : this.each(function(i) {
                jQuery.offset.setOffset(this, options, i);
            });
            var rect, win, elem = this[0];
            if (!elem) return;
            // Return zeros for disconnected and hidden (display: none) elements (gh-2310)
            // Support: IE <=11 only
            // Running getBoundingClientRect on a
            // disconnected node in IE throws an error
            if (!elem.getClientRects().length) return {
                top: 0,
                left: 0
            };
            // Get document-relative position by adding viewport scroll to viewport-relative gBCR
            rect = elem.getBoundingClientRect();
            win = elem.ownerDocument.defaultView;
            return {
                top: rect.top + win.pageYOffset,
                left: rect.left + win.pageXOffset
            };
        },
        // position() relates an element's margin box to its offset parent's padding box
        // This corresponds to the behavior of CSS absolute positioning
        position: function position() {
            if (!this[0]) return;
            var offsetParent, offset, doc, elem = this[0], parentOffset = {
                top: 0,
                left: 0
            };
            // position:fixed elements are offset from the viewport, which itself always has zero offset
            if (jQuery.css(elem, "position") === "fixed") // Assume position:fixed implies availability of getBoundingClientRect
            offset = elem.getBoundingClientRect();
            else {
                offset = this.offset();
                // Account for the *real* offset parent, which can be the document or its root element
                // when a statically positioned element is identified
                doc = elem.ownerDocument;
                offsetParent = elem.offsetParent || doc.documentElement;
                while(offsetParent && (offsetParent === doc.body || offsetParent === doc.documentElement) && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.parentNode;
                if (offsetParent && offsetParent !== elem && offsetParent.nodeType === 1) {
                    // Incorporate borders into its offset, since they are outside its content origin
                    parentOffset = jQuery(offsetParent).offset();
                    parentOffset.top += jQuery.css(offsetParent, "borderTopWidth", true);
                    parentOffset.left += jQuery.css(offsetParent, "borderLeftWidth", true);
                }
            }
            // Subtract parent offsets and element margins
            return {
                top: offset.top - parentOffset.top - jQuery.css(elem, "marginTop", true),
                left: offset.left - parentOffset.left - jQuery.css(elem, "marginLeft", true)
            };
        },
        // This method will return documentElement in the following cases:
        // 1) For the element inside the iframe without offsetParent, this method will return
        //    documentElement of the parent window
        // 2) For the hidden or detached element
        // 3) For body or html element, i.e. in case of the html node - it will return itself
        //
        // but those exceptions were never presented as a real life use-cases
        // and might be considered as more preferable results.
        //
        // This logic, however, is not guaranteed and can change at any point in the future
        offsetParent: function offsetParent() {
            return this.map(function() {
                var offsetParent = this.offsetParent;
                while(offsetParent && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.offsetParent;
                return offsetParent || documentElement;
            });
        }
    });
    // Create scrollLeft and scrollTop methods
    jQuery.each({
        scrollLeft: "pageXOffset",
        scrollTop: "pageYOffset"
    }, function(method, prop) {
        var top = "pageYOffset" === prop;
        jQuery.fn[method] = function(val) {
            return access(this, function(elem, method, val) {
                // Coalesce documents and windows
                var win;
                if (isWindow(elem)) win = elem;
                else if (elem.nodeType === 9) win = elem.defaultView;
                if (val === undefined) return win ? win[prop] : elem[method];
                if (win) win.scrollTo(!top ? val : win.pageXOffset, top ? val : win.pageYOffset);
                else elem[method] = val;
            }, method, val, arguments.length);
        };
    });
    // Support: Safari <=7 - 9.1, Chrome <=37 - 49
    // Add the top/left cssHooks using jQuery.fn.position
    // Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
    // Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
    // getComputedStyle returns percent when specified for top/left/bottom/right;
    // rather than make the css module depend on the offset module, just check for it here
    jQuery.each([
        "top",
        "left"
    ], function(_i, prop) {
        jQuery.cssHooks[prop] = addGetHookIf(support.pixelPosition, function(elem, computed) {
            if (computed) {
                computed = curCSS(elem, prop);
                // If curCSS returns percentage, fallback to offset
                return rnumnonpx.test(computed) ? jQuery(elem).position()[prop] + "px" : computed;
            }
        });
    });
    // Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
    jQuery.each({
        Height: "height",
        Width: "width"
    }, function(name, type) {
        jQuery.each({
            padding: "inner" + name,
            content: type,
            "": "outer" + name
        }, function(defaultExtra, funcName) {
            // Margin is only for outerHeight, outerWidth
            jQuery.fn[funcName] = function(margin, value) {
                var chainable = arguments.length && (defaultExtra || typeof margin !== "boolean"), extra = defaultExtra || (margin === true || value === true ? "margin" : "border");
                return access(this, function(elem, type, value) {
                    var doc;
                    if (isWindow(elem)) // $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
                    return funcName.indexOf("outer") === 0 ? elem["inner" + name] : elem.document.documentElement["client" + name];
                    // Get document width or height
                    if (elem.nodeType === 9) {
                        doc = elem.documentElement;
                        // Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
                        // whichever is greatest
                        return Math.max(elem.body["scroll" + name], doc["scroll" + name], elem.body["offset" + name], doc["offset" + name], doc["client" + name]);
                    }
                    return value === undefined ? // Get width or height on the element, requesting but not forcing parseFloat
                    jQuery.css(elem, type, extra) : // Set width or height on the element
                    jQuery.style(elem, type, value, extra);
                }, type, chainable ? margin : undefined, chainable);
            };
        });
    });
    jQuery.each([
        "ajaxStart",
        "ajaxStop",
        "ajaxComplete",
        "ajaxError",
        "ajaxSuccess",
        "ajaxSend"
    ], function(_i, type) {
        jQuery.fn[type] = function(fn) {
            return this.on(type, fn);
        };
    });
    jQuery.fn.extend({
        bind: function bind(types, data, fn) {
            return this.on(types, null, data, fn);
        },
        unbind: function unbind(types, fn) {
            return this.off(types, null, fn);
        },
        delegate: function delegate(selector, types, data, fn) {
            return this.on(types, selector, data, fn);
        },
        undelegate: function undelegate(selector, types, fn) {
            // ( namespace ) or ( selector, types [, fn] )
            return arguments.length === 1 ? this.off(selector, "**") : this.off(types, selector || "**", fn);
        },
        hover: function hover(fnOver, fnOut) {
            return this.on("mouseenter", fnOver).on("mouseleave", fnOut || fnOver);
        }
    });
    jQuery.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function(_i, name) {
        // Handle event binding
        jQuery.fn[name] = function(data, fn) {
            return arguments.length > 0 ? this.on(name, null, data, fn) : this.trigger(name);
        };
    });
    // Support: Android <=4.0 only
    // Make sure we trim BOM and NBSP
    // Require that the "whitespace run" starts from a non-whitespace
    // to avoid O(N^2) behavior when the engine would try matching "\s+$" at each space position.
    var rtrim = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;
    // Bind a function to a context, optionally partially applying any
    // arguments.
    // jQuery.proxy is deprecated to promote standards (specifically Function#bind)
    // However, it is not slated for removal any time soon
    jQuery.proxy = function(fn, context) {
        var tmp, args, proxy;
        if (typeof context === "string") {
            tmp = fn[context];
            context = fn;
            fn = tmp;
        }
        // Quick check to determine if target is callable, in the spec
        // this throws a TypeError, but we will just return undefined.
        if (!isFunction(fn)) return undefined;
        // Simulated bind
        args = slice.call(arguments, 2);
        proxy = function proxy() {
            return fn.apply(context || this, args.concat(slice.call(arguments)));
        };
        // Set the guid of unique handler to the same of original handler, so it can be removed
        proxy.guid = fn.guid = fn.guid || jQuery.guid++;
        return proxy;
    };
    jQuery.holdReady = function(hold) {
        if (hold) jQuery.readyWait++;
        else jQuery.ready(true);
    };
    jQuery.isArray = Array.isArray;
    jQuery.parseJSON = JSON.parse;
    jQuery.nodeName = nodeName;
    jQuery.isFunction = isFunction;
    jQuery.isWindow = isWindow;
    jQuery.camelCase = camelCase;
    jQuery.type = toType;
    jQuery.now = Date.now;
    jQuery.isNumeric = function(obj) {
        // As of jQuery 3.0, isNumeric is limited to
        // strings and numbers (primitives or objects)
        // that can be coerced to finite numbers (gh-2662)
        var type = jQuery.type(obj);
        return (type === "number" || type === "string") && // parseFloat NaNs numeric-cast false positives ("")
        // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
        // subtraction forces infinities to NaN
        !isNaN(obj - parseFloat(obj));
    };
    jQuery.trim = function(text) {
        return text == null ? "" : (text + "").replace(rtrim, "$1");
    };
    // Register as a named AMD module, since jQuery can be concatenated with other
    // files that may use define, but not via a proper concatenation script that
    // understands anonymous AMD modules. A named AMD is safest and most robust
    // way to register. Lowercase jquery is used because AMD module names are
    // derived from file names, and jQuery is normally delivered in a lowercase
    // file name. Do this after creating the global so that if an AMD module wants
    // to call noConflict to hide this version of jQuery, it will work.
    // Note that for maximum portability, libraries that are not jQuery should
    // declare themselves as anonymous modules, and avoid setting a global if an
    // AMD loader is present. jQuery is a special case. For more information, see
    // https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
    if (typeof define === "function" && define.amd) define("jquery", [], function() {
        return jQuery;
    });
    var // Map over jQuery in case of overwrite
    _jQuery = window1.jQuery, // Map over the $ in case of overwrite
    _$ = window1.$;
    jQuery.noConflict = function(deep) {
        if (window1.$ === jQuery) window1.$ = _$;
        if (deep && window1.jQuery === jQuery) window1.jQuery = _jQuery;
        return jQuery;
    };
    // Expose jQuery and $ identifiers, even in AMD
    // (trac-7102#comment:10, https://github.com/jquery/jquery/pull/557)
    // and CommonJS for browser emulators (trac-13566)
    if (typeof noGlobal === "undefined") window1.jQuery = window1.$ = jQuery;
    return jQuery;
});



var $9Wwts = parcelRequire("9Wwts");
/**
 * Regras de recomendacao (nao bloqueantes) de alocacao do objetivo.
 *
 * Espelha o subconjunto de Objetivo.incorreto (investidores/models/objetivo.py)
 * usado como aviso ao vivo nas telas de porcentagem — tanto no wizard de
 * criacao (AdicionarObjetivo.js) quanto no modal de edicao do objetivo ja
 * criado (ModalComplexoVue.js). Compartilhado para os dois nao divergirem
 * das mensagens/faixas do backend com o tempo.
 *
 * Cada aviso carrega uma `fase` semantica (nao um numero de step): wizard e
 * modal numeram suas telas de forma diferente, entao cada um mapeia seus
 * proprios steps para essas fases ao filtrar o que exibir.
 *
 * Fases possiveis: 'macro' (Renda Fixa x Variavel), 'exterior' (Brasil x
 * EUA), 'mix_br' (Acoes x FIIs), 'mix_eua' (Stocks x REITs).
 */ var $3ebff57b58996a50$var$parPreenchido = function(campos, a, b) {
    return campos[a] !== "" && campos[b] !== "" && Math.round((Number(campos[a]) + Number(campos[b])) * 100) / 100 === 100;
};
function $3ebff57b58996a50$export$e9953c2d81f4872(campos_objetivo) {
    var c = campos_objetivo;
    var avisos = [];
    var noHaveRendaVariavel = c.pr_renda_variavel == 0;
    var noHaveBr = c.pr_renda_variavel_br == 0;
    var noHaveEUA = c.pr_renda_variavel_eua == 0;
    if ($3ebff57b58996a50$var$parPreenchido(c, "pr_renda_fixa", "pr_renda_variavel")) {
        var rf = Number(c.pr_renda_fixa);
        var rv = Number(c.pr_renda_variavel);
        if (rf < 20 || rf > 80) avisos.push({
            fase: "macro",
            mensagem: "Aten\xe7\xe3o: Renda Fixa est\xe1 em ".concat(rf.toFixed(2), "%, fora da faixa recomendada (20% a 80%).")
        });
        if (rv < 20 || rv > 80) avisos.push({
            fase: "macro",
            mensagem: "Aten\xe7\xe3o: Renda Vari\xe1vel est\xe1 em ".concat(rv.toFixed(2), "%, fora da faixa recomendada (20% a 80%).")
        });
    }
    var temRendaVariavel = $3ebff57b58996a50$var$parPreenchido(c, "pr_renda_fixa", "pr_renda_variavel") && !noHaveRendaVariavel;
    if (temRendaVariavel && $3ebff57b58996a50$var$parPreenchido(c, "pr_renda_variavel_br", "pr_renda_variavel_eua")) {
        var eua = Number(c.pr_renda_variavel_eua);
        if (eua < 20 || eua > 40) avisos.push({
            fase: "exterior",
            mensagem: "Aten\xe7\xe3o: o percentual no exterior (EUA) est\xe1 em ".concat(eua.toFixed(2), "%, fora da faixa recomendada (20% a 40%).")
        });
    }
    if (temRendaVariavel && !noHaveBr && $3ebff57b58996a50$var$parPreenchido(c, "pr_acoes", "pr_fiis")) {
        var acoes = Number(c.pr_acoes);
        var fiis = Number(c.pr_fiis);
        if (acoes < 30 || acoes > 70) avisos.push({
            fase: "mix_br",
            mensagem: "Aten\xe7\xe3o: A\xe7\xf5es est\xe1 em ".concat(acoes.toFixed(2), "%, fora da faixa recomendada (30% a 70%).")
        });
        if (fiis < 30 || fiis > 70) avisos.push({
            fase: "mix_br",
            mensagem: "Aten\xe7\xe3o: FIIs est\xe1 em ".concat(fiis.toFixed(2), "%, fora da faixa recomendada (30% a 70%).")
        });
    }
    if (temRendaVariavel && !noHaveEUA && $3ebff57b58996a50$var$parPreenchido(c, "pr_stocks", "pr_reits")) {
        var stocks = Number(c.pr_stocks);
        var reits = Number(c.pr_reits);
        if (stocks < 30 || stocks > 70) avisos.push({
            fase: "mix_eua",
            mensagem: "Aten\xe7\xe3o: Stocks est\xe1 em ".concat(stocks.toFixed(2), "%, fora da faixa recomendada (30% a 70%).")
        });
        if (reits < 30 || reits > 70) avisos.push({
            fase: "mix_eua",
            mensagem: "Aten\xe7\xe3o: REITs est\xe1 em ".concat(reits.toFixed(2), "%, fora da faixa recomendada (30% a 70%).")
        });
    }
    return avisos;
}


// Fase (ver regrasObjetivo.js) de cada step numerico do wizard.
var $95dff4962bd81e46$var$FASES_POR_STEP = {
    1: [
        "macro"
    ],
    2: [
        "exterior"
    ],
    3: [
        "mix_br"
    ],
    4: [
        "mix_eua"
    ]
};
var $95dff4962bd81e46$export$2e2bcd8739ae039 /* regra negócio

// updateValueStep({ currentTarget }, id, tipo = "vazio", nomeCorreto = "vazio") {
		// 	const idC = id - 1
		// 	const divPai = currentTarget.parentElement.closest(`.step-${idC}`)
		// 	console.log(divPai)
		// 	this.isPercentFull = false;
		// 	this.isValid = false;
		// 	this.showError = false;
		// 	this.modalValueIsValid = false;
		// 	this.isExclude = false
		// 	this.step = { id, tipo, nomeCorreto };
		// 	// const inputs = [...divPai.querySelectorAll('input')]
		// 	// const [input1, input2] = inputs;
		// 	this.nextStep
		// 	this.previousStep

		// 	const oi = {
		// 		'5':{
		// 			tipo: 'acoes',
		// 			nome: 'Ação'
		// 		},
		// 		'6':{
		// 			tipo: 'fiis',
		// 			nome: 'FIIs'
		// 		},
		// 		'7':{
		// 			tipo: 'stocks',
		// 			nome: 'Stock'
		// 		},
		// 		'8':{
		// 			tipo: 'reits',
		// 			nome: 'REIT'
		// 		},
		// 		'9': {
		// 			tipo: 'tesouro_direto',
		// 			nome:'Tesouro'
		// 		}

		// 	}

		// 	// 1 step
		// 	// se renda fixa 100 e renda variavel 0  => pula pro step 9
		// 	const noHaveRendaVariavel = () => this.campos_objetivo.pr_renda_variavel == 0

		// 	// 1 step
		// 	// se renda variavel for 100 e fixa for 0 => nao passa pro step 9
		// 	//  => botao submit fica no step 8
		// 	const noHaveRendaFixa = () => this.campos_objetivo.pr_renda_fixa == 0

		// 	// 2 step
		// 	// se brasil for igual a 100 e EUA for 0  nao passa no step 4
		// 	// consequentemente nao passa no 7 nem no 8

		// 	// se EUA for igual a 100 e brasil for igual a 0 nao passa no step 3
		// 	// se nao passar no step 3 consequentemente nao passa no step 5 e 6

		// 	// 3 step
		// 	// se for exibido
		// 	// se açoes for igual a 100 e FIIs for igual 0
		// 	// nao passa no step 6
		// 	// se FIIs for igual a 100 e açoes for igual a 0
		// 	// nao passa no step 5

		// 	// 4 step
		// 	// se stocks for igual a 100 e REITS for igual a 0
		// 	// nao passa no step 8
		// 	// se REITS for igual a 100 e STOCKS for igual a 0
		// 	// nao passa no step 7

		// },

		// preventMinusInsertOnInput(el) {
		// 	el.value = Math.abs(el.value);

		// },

*/  = {
    data: function() {
        return {
            modalIsOpen: false,
            modalAvisosOpen: false,
            isValid: false,
            showError: false,
            showErrorOnModal: false,
            isPercentFull: false,
            hasFinishedSteps: false,
            errorMessage: "",
            modalErrorMessage: "",
            tipo_atual: "",
            modalValueIsValid: false,
            show: false,
            search: "",
            loading: false,
            objEdicao: null,
            modalState: "",
            stepAnterior: null,
            objetivoFiltrado: "",
            baseURL: window.location.origin,
            showOptions: "",
            showOptionsFirst: false,
            isSaveBtn: false,
            hasSameValue: false,
            product_type_name: "",
            stepList: [
                {
                    id: 1,
                    enabled: true,
                    active: true
                },
                {
                    id: 2,
                    enabled: true,
                    active: false
                },
                {
                    id: 3,
                    enabled: true,
                    active: false
                },
                {
                    id: 4,
                    enabled: true,
                    active: false
                },
                {
                    id: 5,
                    enabled: true,
                    active: false
                },
                {
                    id: 6,
                    enabled: true,
                    active: false
                },
                {
                    id: 7,
                    enabled: true,
                    active: false
                },
                {
                    id: 8,
                    enabled: true,
                    active: false
                },
                {
                    id: 9,
                    enabled: true,
                    active: false
                }
            ],
            campos_objetivo: {
                pr_renda_fixa: "",
                pr_renda_variavel: "",
                pr_renda_variavel_eua: "",
                pr_renda_variavel_br: "",
                pr_acoes: "",
                pr_fiis: "",
                pr_reits: "",
                pr_stocks: ""
            },
            objetivos: {
                acoes: [],
                fiis: [],
                stocks: [],
                reits: [],
                tesouro_direto: []
            },
            concluido: true,
            novoObjetivo: {
                nome: "",
                porcentagem: 0
            },
            step: {
                id: 1,
                tipo: "",
                nomeCorreto: ""
            },
            dataToSave: {},
            options: [],
            optionsRendaFixa: [
                {
                    value: "Tesouro IPCA+",
                    label: "Tesouro IPCA+",
                    ticker_symbol: "Tesouro IPCA+"
                }
            ],
            isLoading: false,
            selected: null,
            pastTotalValue: 0,
            dadosRequisicaoInicial: null,
            protocol: window.location.protocol
        };
    },
    mounted: function() {
        return (0, $a1727a7253abe12d$export$7c398597f8905a1)(function() {
            var _this;
            return (0, $877235af7931ac6c$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _this = this;
                        document.addEventListener("click", function(e) {
                            return _this.outsideClick(e);
                        });
                        // await this.getObjectiveIncomplete();
                        return [
                            4,
                            this.setInitialLocalStorageState()
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        }).apply(this);
    },
    watch: {
        step: function(newValue, oldValue) {
            if (newValue.id <= 4 && newValue.id < oldValue.id) this.isValid = true;
        },
        valor_total_computado: function(newValue, oldValue) {
            if (!this.valor_total_computado) return;
            this.checkSumValueInInlineSteps();
        },
        stepList: function(newValue, oldValue) {
            var _this_step;
            var stepAtivos = newValue.filter(function(i) {
                return i.enabled;
            });
            var ultimoObjetoAtivo = stepAtivos.slice(-1)[0];
            if (ultimoObjetoAtivo && ultimoObjetoAtivo.id === ((_this_step = this.step) === null || _this_step === void 0 ? void 0 : _this_step.id)) this.isSaveBtn = true;
            else this.isSaveBtn = false;
        },
        lastStep: function(newValue, oldValue) {
            var botaoOld = document.querySelector(".step-".concat(oldValue, " .btn-update"));
            var botaoNew = document.querySelector(".step-".concat(newValue, " .btn-update"));
            botaoOld.setAttribute("type", "button");
            botaoOld.innerText = "Avan\xe7ar";
            botaoNew.setAttribute("type", "submit");
            botaoNew.innerText = "Enviar";
        }
    },
    computed: {
        valor_total_computado: function() {
            var _this_step;
            var objetivoAtual = this.objetivos[(_this_step = this.step) === null || _this_step === void 0 ? void 0 : _this_step.tipo];
            if (!objetivoAtual || !Array.isArray(objetivoAtual)) return 0;
            var porcentagens = objetivoAtual === null || objetivoAtual === void 0 ? void 0 : objetivoAtual.map(function(objetivo) {
                return Number(objetivo.porcentagem_desejada);
            });
            var total = porcentagens.reduce(function(acc, porcentagem) {
                return acc + porcentagem;
            }, 0);
            // return Math.round(total);
            return Math.round((total + Number.EPSILON) * 100) / 100;
        },
        quantidadeSteps: function() {
            var size = 9;
            return size;
        },
        noHaveRendaVariavel: function() {
            return this.campos_objetivo.pr_renda_variavel == 0;
        },
        noHaveRendaFixa: function() {
            return this.campos_objetivo.pr_renda_fixa == 0;
        },
        noHaveBr: function() {
            return this.campos_objetivo.pr_renda_variavel_br == 0;
        },
        noHaveEUA: function() {
            return this.campos_objetivo.pr_renda_variavel_eua == 0;
        },
        noHaveAcoes: function() {
            return this.campos_objetivo.pr_acoes == 0;
        },
        noHaveFiis: function() {
            return this.campos_objetivo.pr_fiis == 0;
        },
        noHaveReits: function() {
            return this.campos_objetivo.pr_reits == 0;
        },
        noHaveStocks: function() {
            return this.campos_objetivo.pr_stocks == 0;
        },
        /**
		 * Avisos de recomendação (não bloqueantes) para seções deixadas em 0%.
		 * Só avalia pares já preenchidos (soma 100) e só as seções que fazem
		 * parte do fluxo ativo — ex.: com renda variável 0%, os zeros de
		 * BR/EUA/Ações/FIIs/Stocks/REITs não geram aviso.
		 */ avisosRecomendacao: function() {
            return (0, $3ebff57b58996a50$export$e9953c2d81f4872)(this.campos_objetivo);
        },
        texto: function() {
            var _this_step, _this_step1, _this_step2, _this_step3, _this_step4;
            if (((_this_step = this.step) === null || _this_step === void 0 ? void 0 : _this_step.tipo) == "acoes") return "Qual o seu objetivo com esta a\xe7\xe3o?";
            else if (((_this_step1 = this.step) === null || _this_step1 === void 0 ? void 0 : _this_step1.tipo) == "fiis") return "Qual o seu objetivo com este FII?";
            else if (((_this_step2 = this.step) === null || _this_step2 === void 0 ? void 0 : _this_step2.tipo) == "stocks") return "Qual o seu objetivo com este Stock?";
            else if (((_this_step3 = this.step) === null || _this_step3 === void 0 ? void 0 : _this_step3.tipo) == "reits") return "Qual o seu objetivo com este Reit";
            else if (((_this_step4 = this.step) === null || _this_step4 === void 0 ? void 0 : _this_step4.tipo) == "tesouro_direto") return "Qual o seu objetivo com este Titulo de renda fixa?";
            else return "";
        }
    },
    methods: {
        /* funções responsáveis por gerenciar dados salvos no localstorage */ triggerError: function() {
            // Simular um erro (não faça isso em código de produção)
            console.log(variavelNaoDefinida); // Isso gerará um erro
        },
        setInitialLocalStorageState: function() {
            return (0, $a1727a7253abe12d$export$7c398597f8905a1)(function() {
                var _this_step, _;
                return (0, $877235af7931ac6c$export$67ebef60e6f28a6)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            this.isLoadingStorage = true;
                            _ = this;
                            return [
                                4,
                                this.getObjectiveIncomplete()
                            ];
                        case 1:
                            _.dataToSave = _state.sent();
                            if (!this.dataToSave) return [
                                2
                            ];
                            this.step = this.dataToSave.step;
                            this.stepList = this.dataToSave.stepList;
                            this.isSaveBtn = this.dataToSave.isSaveBtn;
                            this.campos_objetivo = this.dataToSave.campos_objetivo;
                            this.objetivos = this.dataToSave.objetivos;
                            this.options = this.dataToSave.options;
                            this.checkIfExistValidValuesOnAStep(this.dataToSave.step);
                            this.defineTypeProduct((_this_step = this.step) === null || _this_step === void 0 ? void 0 : _this_step.tipo);
                            return [
                                2
                            ];
                    }
                });
            }).apply(this);
        },
        getObjectiveIncomplete: function() {
            return (0, $a1727a7253abe12d$export$7c398597f8905a1)(function() {
                var data, error;
                return (0, $877235af7931ac6c$export$67ebef60e6f28a6)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                axios.get("".concat(this.baseURL, "/api/step_cadastro_objetivo/"))
                            ];
                        case 1:
                            data = _state.sent().data;
                            console.log(data);
                            return [
                                2,
                                data[0]
                            ];
                        case 2:
                            error = _state.sent();
                            console.log(error);
                            return [
                                3,
                                3
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            }).apply(this);
        },
        saveActualStateOnLocalStorage: function(obj) {
            return (0, $a1727a7253abe12d$export$7c398597f8905a1)(function() {
                var response, data, data1, error;
                return (0, $877235af7931ac6c$export$67ebef60e6f28a6)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                5,
                                ,
                                6
                            ]);
                            return [
                                4,
                                this.getObjectiveIncomplete()
                            ];
                        case 1:
                            response = _state.sent();
                            if (!response) return [
                                3,
                                3
                            ];
                            return [
                                4,
                                axios.put("".concat(this.baseURL, "/api/step_cadastro_objetivo/").concat(response.id, "/"), (0, $8pZMQ._)({}, obj))
                            ];
                        case 2:
                            data = _state.sent().data;
                            return [
                                2
                            ];
                        case 3:
                            return [
                                4,
                                axios.post("".concat(this.baseURL, "/api/step_cadastro_objetivo/"), (0, $8pZMQ._)({}, obj))
                            ];
                        case 4:
                            data1 = _state.sent().data;
                            return [
                                3,
                                6
                            ];
                        case 5:
                            error = _state.sent();
                            console.log(error);
                            return [
                                3,
                                6
                            ];
                        case 6:
                            return [
                                2
                            ];
                    }
                });
            }).apply(this);
        },
        dropdownShouldOpen: function(VueSelect) {
            if (this.options.length) return VueSelect.open;
            return VueSelect.search.length !== 0 && VueSelect.open;
        },
        removeLocalStorage: function() {
            if (!localStorage.getItem("estadoAtual")) return;
            localStorage.removeItem("estadoAtual");
        },
        checkIfExistValidValuesOnAStep: function(stepObj) {
            var stepsInline = [
                5,
                6,
                7,
                8,
                9
            ];
            var isInlineSteps = stepsInline.some(function(i) {
                return i === stepObj.id;
            });
            if (stepObj.id === 1) {
                if (this.campos_objetivo.pr_renda_variavel == "" && this.campos_objetivo.pr_renda_fixa == "") return;
                this.isValid = true;
            } else if (stepObj.id === 2) {
                if (this.campos_objetivo.pr_renda_variavel_br == "" && this.campos_objetivo.pr_renda_variavel_eua == "") return;
                this.isValid = true;
            } else if (stepObj.id === 3) {
                if (this.campos_objetivo.pr_acoes == "" && this.campos_objetivo.pr_fiis == "") return;
                this.isValid = true;
            } else if (stepObj.id === 4) {
                if (this.campos_objetivo.pr_reits == "" && this.campos_objetivo.pr_stocks == "") return;
                this.isValid = true;
            } else if (isInlineSteps) {
                if (this.valor_total_computado !== 100 || this.valor_total_computado > 100) return;
                this.isValid = true;
                this.modalValueIsValid = true;
            }
        },
        /* Funções de controle dos steps do wizard*/ verifyStepAndSetThePatterns: function(current) {
            var tipo = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "default";
            var _this_step;
            if (((_this_step = this.step) === null || _this_step === void 0 ? void 0 : _this_step.id) == current) {
                this.step.id = current;
                this.step.tipo = tipo;
                this.tipo_atual = tipo;
                return true;
            }
            return false;
        },
        changeStep: function(step) {
            var _stepProps_step, _stepProps_step1, _this_step;
            this.nextStep = step;
            //objeto para setar o tipo de produto
            var stepProps = {
                5: {
                    tipo: "acoes",
                    nome: "A\xe7\xe3o"
                },
                6: {
                    tipo: "fiis",
                    nome: "FIIs"
                },
                7: {
                    tipo: "stocks",
                    nome: "Stock"
                },
                8: {
                    tipo: "reits",
                    nome: "REIT"
                },
                9: {
                    tipo: "tesouro_direto",
                    nome: "Tesouro"
                }
            };
            var stepObj = {
                id: step
            };
            var tipo = (_stepProps_step = stepProps[step]) === null || _stepProps_step === void 0 ? void 0 : _stepProps_step.tipo;
            var nomeCorreto = (_stepProps_step1 = stepProps[step]) === null || _stepProps_step1 === void 0 ? void 0 : _stepProps_step1.nome;
            tipo ? stepObj.tipo = tipo : stepObj.tipo = "";
            nomeCorreto ? stepObj.nomeCorreto = nomeCorreto : stepObj.nomeCorreto = "";
            this.step = stepObj;
            this.defineTypeProduct((_this_step = this.step) === null || _this_step === void 0 ? void 0 : _this_step.tipo);
            this.dataToSave = {
                step: this.step,
                stepList: this.stepList,
                isSaveBtn: this.isSaveBtn,
                objetivos: this.objetivos,
                campos_objetivo: this.campos_objetivo,
                options: this.options
            };
            this.saveActualStateOnLocalStorage(this.dataToSave);
            this.checkIfExistValidValuesOnAStep(this.step);
        },
        getActiveStep: function() {
            var habilitados = this.stepList.filter(function(i) {
                return i.enabled;
            });
            var indexAtivo = habilitados.findIndex(function(i) {
                return i.active;
            });
            return {
                active: indexAtivo,
                enableds: habilitados
            };
        },
        nextStepFn: function() {
            var _next = this.getActiveStep().active + 1;
            var next = this.getActiveStep().enableds.at(_next);
            if (!next) return;
            this.stepList = this.stepList.map(function(i) {
                i.id === next.id ? i.active = true : i.active = false;
                return i;
            });
            return next;
        },
        toNextStep: function() {
            var _this_nextStepFn;
            var nextID = (_this_nextStepFn = this.nextStepFn()) === null || _this_nextStepFn === void 0 ? void 0 : _this_nextStepFn.id;
            nextID && this.changeStep(nextID);
        },
        previousStep: function() {
            var prev = this.getActiveStep().enableds.at(this.getActiveStep().active - 1);
            this.stepList = this.stepList.map(function(i) {
                i.id === prev.id ? i.active = true : i.active = false;
                return i;
            });
            return prev;
        },
        toPreviousStep: function() {
            this.changeStep(this.previousStep().id);
        },
        disableSteps: function(array) {
            this.stepList = this.stepList.map(function(i) {
                var a = array.forEach(function(n) {
                    return n === i.id && (i.enabled = false);
                });
                return i;
            });
        },
        enableSteps: function(array) {
            this.stepList = this.stepList.map(function(i) {
                var a = array.forEach(function(n) {
                    return n === i.id && (i.enabled = true);
                });
                return i;
            });
        },
        updateValueStep: function() {
            return (0, $a1727a7253abe12d$export$7c398597f8905a1)(function() {
                var t, _this_step, _this_step1, _this_step2, _this_step3, _this_step4, _this_step5, _this_step6, _this_step7;
                return (0, $877235af7931ac6c$export$67ebef60e6f28a6)(this, function(_state) {
                    t = this;
                    try {
                        ;
                        if (((_this_step = this.step) === null || _this_step === void 0 ? void 0 : _this_step.id) == this.lastStep) return [
                            2
                        ];
                        this.isPercentFull = false;
                        this.isValid = false;
                        this.showError = false;
                        this.modalValueIsValid = false;
                        this.isExclude = false;
                        // STEP 1
                        if (((_this_step1 = this.step) === null || _this_step1 === void 0 ? void 0 : _this_step1.id) === 1) {
                            if (this.noHaveRendaVariavel) this.disableSteps([
                                2,
                                3,
                                4,
                                5,
                                6,
                                7,
                                8
                            ]);
                            else // Enabled
                            this.enableSteps([
                                2,
                                3,
                                4,
                                5,
                                6,
                                7,
                                8
                            ]);
                            this.noHaveRendaFixa ? this.disableSteps([
                                9
                            ]) : this.enableSteps([
                                9
                            ]);
                            t.toNextStep();
                            console.log("passo 1");
                            return [
                                2
                            ];
                        } else if (((_this_step2 = this.step) === null || _this_step2 === void 0 ? void 0 : _this_step2.id) === 2) {
                            if (this.noHaveBr && !this.noHaveEUA) {
                                this.disableSteps([
                                    3,
                                    5,
                                    6
                                ]);
                                console.log("this.noHaveBR");
                            } else if (this.noHaveEUA && !this.noHaveBr) {
                                this.disableSteps([
                                    4,
                                    7,
                                    8
                                ]);
                                console.log("this.noHaveEUA");
                            }
                            // Enabled ================================
                            if (!this.noHaveBr && this.noHaveEUA) {
                                this.enableSteps([
                                    3,
                                    5,
                                    6
                                ]);
                                console.log("!this.noHaveBR");
                            } else if (!this.noHaveEUA && this.noHaveBr) {
                                this.enableSteps([
                                    4,
                                    7,
                                    8
                                ]);
                                console.log("!this.noHaveEUA");
                            } else if (!this.noHaveEUA && !this.noHaveBr) {
                                this.enableSteps([
                                    3,
                                    4,
                                    5,
                                    6,
                                    7,
                                    8
                                ]);
                                console.log("!this.noHaveEUA");
                            }
                        } else if (((_this_step3 = this.step) === null || _this_step3 === void 0 ? void 0 : _this_step3.id) === 3) {
                            if (this.noHaveFiis && this.noHaveEUA) {
                                console.log("this.noHaveFiis && this.noHaveEUA");
                                this.disableSteps([
                                    4
                                ]);
                                this.noHaveRendaFixa ? this.disableSteps([
                                    6,
                                    7,
                                    8,
                                    9
                                ]) : this.enableSteps([
                                    6,
                                    7,
                                    8,
                                    9
                                ]);
                            } else if (this.noHaveAcoes && this.noHaveEUA) {
                                console.log("this.noHaveAcoes && this.noHaveEUA");
                                this.disableSteps([
                                    4,
                                    5
                                ]);
                                this.noHaveRendaFixa && this.disableSteps([
                                    7,
                                    8,
                                    9
                                ]);
                            } else if (this.noHaveEUA) {
                                this.disableSteps([
                                    4
                                ]);
                                console.log("this.noHaveEUA");
                            } else if (this.noHaveAcoes) {
                                this.disableSteps([
                                    5
                                ]);
                                console.log("this.noHaveAcoes");
                            } else if (this.noHaveFiis) {
                                this.disableSteps([
                                    6
                                ]);
                                console.log("(this.noHaveFiis");
                            }
                            // Enabled ================================
                            if (!this.noHaveFiis && !this.noHaveEUA) {
                                this.enableSteps([
                                    4
                                ]);
                                !this.noHaveRendaFixa && this.enableSteps([
                                    6,
                                    7,
                                    8,
                                    9
                                ]);
                                console.log("!this.noHaveFiis && !this.noHaveEUA");
                            } else if (!this.noHaveAcoes && !this.noHaveEUA) {
                                this.enableSteps([
                                    4,
                                    5
                                ]);
                                !this.noHaveRendaFixa && this.enableSteps([
                                    7,
                                    8,
                                    9
                                ]);
                                console.log("!this.noHaveAcoes && !this.noHaveEUA");
                            } else if (!this.noHaveEUA) {
                                this.enableSteps([
                                    4
                                ]);
                                console.log("!this.noHaveEUA");
                            } else if (this.noHaveEUA && !this.noHaveAcoes) {
                                this.enableSteps([
                                    5
                                ]);
                                console.log("this.noHaveEUA && !this.noHaveAcoes");
                            } else if (this.noHaveEUA && !this.noHaveFiis) {
                                this.enableSteps([
                                    6
                                ]);
                                console.log("this.noHaveEUA && !this.noHaveFiis");
                            } else if (!this.noHaveAcoes) {
                                this.enableSteps([
                                    5
                                ]);
                                console.log("!this.noHaveAcoes");
                            } else if (!this.noHaveFiis) {
                                this.enableSteps([
                                    6
                                ]);
                                console.log("(!this.noHaveFiis");
                            } else if (!this.noHaveAcoes && !this.noHaveFiis) {
                                this.enableSteps([
                                    5,
                                    6
                                ]);
                                console.log("!this.noHaveAcoes && this.noHaveFiis");
                            }
                        } else if (((_this_step4 = this.step) === null || _this_step4 === void 0 ? void 0 : _this_step4.id) === 4) {
                            if (this.noHaveStocks && this.noHaveBr) {
                                this.disableSteps([
                                    5,
                                    6,
                                    7
                                ]);
                                this.noHaveRendaFixa && this.disableSteps([
                                    9
                                ]);
                                console.log("this.noHaveStocks && this.noHaveBr");
                            } else if (this.noHaveReits && this.noHaveBr) {
                                this.disableSteps([
                                    5,
                                    6
                                ]);
                                this.noHaveRendaFixa && this.disableSteps([
                                    8,
                                    9
                                ]);
                                console.log("this.noHaveReits && this.noHaveBr");
                            } else if (this.noHaveBr) {
                                this.disableSteps([
                                    5,
                                    6
                                ]);
                                console.log("this.noHaveBr");
                            // this.noHaveRendaFixa && (this.lastStep = this.lastStep);
                            } else if (this.noHaveAcoes) {
                                this.disableSteps([
                                    5
                                ]);
                                console.log("this.noHaveAcoes");
                            } else if (this.noHaveFiis) {
                                this.disableSteps([
                                    6
                                ]);
                                console.log("(this.noHaveFiis");
                            } else if (this.noHaveStocks) {
                                this.disableSteps([
                                    7
                                ]);
                                console.log("this.noHaveStocks");
                            } else if (this.noHaveReits) {
                                this.disableSteps([
                                    8
                                ]);
                                console.log("this.noHaveReits");
                            }
                            // Enabled ================================
                            if (!this.noHaveStocks && !this.noHaveBr && !this.noHaveAcoes && !this.noHaveFiis) {
                                this.enableSteps([
                                    5,
                                    6,
                                    7
                                ]);
                                !this.noHaveRendaFixa && this.enableSteps([
                                    9
                                ]);
                            } else if (!this.noHaveReits && !this.noHaveBr && !this.noHaveAcoes && !this.noHaveFiis) {
                                this.enableSteps([
                                    5,
                                    6
                                ]);
                                !this.noHaveRendaFixa && this.enableSteps([
                                    8,
                                    9
                                ]);
                                console.log("!this.noHaveReits && !this.noHaveBr");
                            } else if (!this.noHaveBr && !this.noHaveAcoes && !this.noHaveFiis) {
                                this.enableSteps([
                                    5,
                                    6
                                ]);
                                // this.noHaveRendaFixa && (this.lastStep = this.lastStep);
                                console.log("!this.noHaveBr");
                            } else if (!this.noHaveAcoes) {
                                this.enableSteps([
                                    5
                                ]);
                                console.log("!this.noHaveAcoes");
                            } else if (!this.noHaveFiis) {
                                this.enableSteps([
                                    6
                                ]);
                                console.log("!this.noHaveFiis");
                            } else if (!this.noHaveStocks) {
                                this.enableSteps([
                                    7
                                ]);
                                console.log("!this.noHaveStocks");
                            } else if (!this.noHaveReits) {
                                this.enableSteps([
                                    8
                                ]);
                                console.log("!this.noHaveReits");
                            } else if (!this.noHaveStocks && !this.noHaveReits) {
                                this.enableSteps([
                                    7,
                                    8
                                ]);
                                console.log("!this.noHaveAcoes && this.noHaveFiis");
                            } else if (this.noHaveBr && !this.noHaveStocks) {
                                this.enableSteps([
                                    7
                                ]);
                                console.log("this.noHaveBr && !this.noHaveStocks");
                            } else if (this.noHaveBr && !this.noHaveReits) {
                                this.enableSteps([
                                    8
                                ]);
                                console.log("this.noHaveBr && !this.noHaveReits");
                            }
                        } else if (((_this_step5 = this.step) === null || _this_step5 === void 0 ? void 0 : _this_step5.id) === 5) {
                            if (this.noHaveFiis && this.noHaveEUA) {
                                this.disableSteps([
                                    6,
                                    7,
                                    8
                                ]);
                                this.noHaveRendaFixa && this.disableSteps([
                                    6,
                                    7,
                                    8,
                                    9
                                ]);
                            } else if (this.noHaveFiis && this.noHaveReits) {
                                this.disableSteps([
                                    6
                                ]);
                                this.noHaveRendaFixa && this.disableSteps([
                                    8,
                                    9
                                ]);
                            } else if (this.noHaveFiis && this.noHaveStocks) {
                                this.disableSteps([
                                    6,
                                    7
                                ]);
                                this.noHaveRendaFixa && this.disableSteps([
                                    9
                                ]);
                            } else if (this.noHaveReits && this.noHaveStocks) this.noHaveRendaFixa && this.disableSteps([
                                7,
                                8,
                                9
                            ]);
                            // Enabled ================================
                            if (!this.noHaveFiis && !this.noHaveEUA) {
                                this.enableSteps([
                                    6,
                                    7,
                                    8
                                ]);
                                !this.noHaveRendaFixa && this.enableSteps([
                                    6,
                                    7,
                                    8,
                                    9
                                ]);
                            } else if (!this.noHaveFiis && !this.noHaveReits) {
                                this.enableSteps([
                                    6
                                ]);
                                !this.noHaveRendaFixa && this.enableSteps([
                                    8,
                                    9
                                ]);
                            } else if (!this.noHaveFiis && !this.noHaveStocks) {
                                this.enableSteps([
                                    6,
                                    7
                                ]);
                                !this.noHaveRendaFixa && this.enableSteps([
                                    9
                                ]);
                            } else if (!this.noHaveReits && !this.noHaveStocks) !this.noHaveRendaFixa && this.enableSteps([
                                7,
                                8,
                                9
                            ]);
                            else if (this.noHaveEUA && !this.noHaveFiis && !this.noHaveAcoes) {
                                this.enableSteps([
                                    5,
                                    6
                                ]);
                                console.log("this.noHaveEUA && !this.noHaveFiis && !this.noHaveAcoes");
                            }
                        } else if (((_this_step6 = this.step) === null || _this_step6 === void 0 ? void 0 : _this_step6.id) === 6) {
                            if (this.noHaveEUA) this.disableSteps([
                                7,
                                8
                            ]);
                            else if (this.noHaveReits) this.noHaveRendaFixa && this.disableSteps([
                                8,
                                9
                            ]);
                            else if (this.noHaveStocks) {
                                this.disableSteps([
                                    7
                                ]);
                                this.noHaveRendaFixa && this.disableSteps([
                                    9
                                ]);
                            }
                            // Enabled ================================
                            if (!this.noHaveEUA && !this.noHaveStocks && !this.noHaveReits) {
                                this.enableSteps([
                                    7,
                                    8
                                ]);
                                console.log("!this.noHaveEUA && !this.noHaveStocks");
                            } else if (!this.noHaveReits) !this.noHaveRendaFixa && this.enableSteps([
                                8,
                                9
                            ]);
                            else if (!this.noHaveStocks) {
                                this.enableSteps([
                                    7
                                ]);
                                console.log("!this.noHaveStocks");
                                !this.noHaveRendaFixa && this.enableSteps([
                                    9
                                ]);
                            }
                        } else if (((_this_step7 = this.step) === null || _this_step7 === void 0 ? void 0 : _this_step7.id) === 7) {
                            if (this.noHaveReits) this.disableSteps([
                                8
                            ]);
                            // Enabled ================================
                            if (!this.noHaveReits) this.enableSteps([
                                8
                            ]);
                        }
                        // } else if (this.step?.id === 8) {
                        // } else if (this.step?.id === 9) {
                        // }
                        t.toNextStep();
                    //  1 step
                    //  CHECK se renda fixa 100 e renda variavel 0  => pula pro step 9
                    // 1 step
                    // CHECK se renda variavel for 100 e fixa for 0 => nao passa pro step 9
                    //  CHECK => botao submit fica no step 8
                    // 2 step
                    // CHECK se EUA for igual a 100 e brasil for igual a 0 nao passa no step 3  NOHAVEBR
                    // CHECK se nao passar no step 3 consequentemente nao passa no step 5 e 6
                    // CHECK se brasil for igual a 100 e EUA for 0  nao passa no step 4
                    // CHECK consequentemente nao passa no 7 nem no 8
                    // 3 step
                    // se for exibido
                    // CHECK se açoes for igual a 100 e FIIs for igual 0
                    // nao passa no step 6
                    // CHECK se FIIs for igual a 100 e açoes for igual a 0
                    // nao passa no step 5
                    // 4 step
                    // CHECK se stocks for igual a 100 e REITS for igual a 0
                    // nao passa no step 8
                    // CHECK se REITS for igual a 100 e STOCKS for igual a 0
                    // nao passa no step 7
                    } catch (error) {
                        GLOBAL.showToastify("".concat(error), "#DE4B4F");
                    }
                    return [
                        2
                    ];
                });
            }).apply(this);
        },
        /* Funções que previne a adição de ativos que já existem no objetivo*/ checkIfStringExistsOnObject: function() {
            var _this = this;
            if (this.modalState == "adicionar") {
                console.log(this.objetivos[this.tipo_atual]);
                var equal = this.objetivos[this.tipo_atual].some(function(i) {
                    return i.ticker_symbol == _this.novoObjetivo.nome;
                });
                if (equal) {
                    this.hasSameValue = true;
                    return;
                }
                this.hasSameValue = false;
            } else if (this.modalState == "editar") {
                var equal1 = this.objetivos[this.tipo_atual].some(function(i) {
                    return i.ticker_symbol == _this.novoObjetivo.nome && i.ticker_symbol != _this.objEdicao.ticker_symbol.ticker_symbol;
                });
                if (equal1) {
                    this.hasSameValue = true;
                    this.modalValueIsValid = false;
                    return;
                }
                this.novoObjetivo.porcentagem = this.objEdicao.porcentagem_desejada;
                this.hasSameValue = false;
                this.modalValueIsValid = true;
            }
        },
        preventInsertTheSameTickerSymbol: function() {
            this.checkIfStringExistsOnObject();
            if (this.hasSameValue) {
                this.showErrorOnModal = true;
                this.modalErrorMessage = "Esse ativo j\xe1 foi adicionado antes";
                this.novoObjetivo.porcentagem = null;
                this.modalValueIsValid = false;
                return;
            } else {
                this.showErrorOnModal = false;
                this.modalErrorMessage = "";
            }
        },
        handleSearchSelect: function(opcaoSelecionada) {
            if (!opcaoSelecionada.value) return;
            this.novoObjetivo.nome = opcaoSelecionada.value;
            this.preventInsertTheSameTickerSymbol();
        },
        defineTypeProduct: function(variable) {
            switch(variable){
                case "acoes":
                    this.product_type_name = "A\xe7\xf5es";
                    break;
                case "fiis":
                    this.product_type_name = "FII - Fundo de Investimento Imobili\xe1rio";
                    break;
                case "stocks":
                    this.product_type_name = "Stock";
                    break;
                case "reits":
                    this.product_type_name = "REIT";
                    break;
            }
        },
        limitQuantityNumberAfterVirgula: function() {
            var input1 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null, input2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
            if (input1 && input1.value !== null && input1.value.toString().indexOf(".") !== -1) {
                var partes = input1.value.toString().split(".");
                if (partes[1].length > 2) {
                    input1.value = parseFloat(partes[0] + "." + partes[1].substr(0, 2));
                    this.novoObjetivo.porcentagem = input1.value;
                }
            }
            if (input2 && input2.value !== null && input2.value.toString().indexOf(".") !== -1) {
                var partes1 = input2.value.toString().split(".");
                if (partes1[1].length > 2) input2.value = parseFloat(partes1[0] + "." + partes1[1].substr(0, 2));
            }
        },
        /* Funções responsáveis por calcular valor dos objetivos*/ checkSumValueInNormalSteps: function(param) {
            var currentTarget = param.currentTarget, target = param.target;
            var _this_step;
            var cardItem = document.querySelector(".step-".concat((_this_step = this.step) === null || _this_step === void 0 ? void 0 : _this_step.id));
            var pai = cardItem.parentElement;
            var numeroPermitido = 100;
            var inputs = (0, $79xu7._)(cardItem.querySelectorAll("input"));
            var _inputs = (0, $4f96i._)(inputs, 2), input1 = _inputs[0], input2 = _inputs[1];
            var soma;
            // if (!currentTarget) return;
            if (currentTarget.value > numeroPermitido) currentTarget.value = "";
            this.limitQuantityNumberAfterVirgula(input1, input2);
            this.defineDynamicValueFromInputsInNormalSteps(currentTarget, input1, input2);
            soma = Number(input1.value) + Number(input2.value);
            this.compareSumValuesInNormalSteps(soma);
        },
        defineDynamicValueFromInputsInNormalSteps: function(elAtivo, firstInput, secondInput) {
            var attrName1 = firstInput.getAttribute("name");
            var attrName2 = secondInput.getAttribute("name");
            if (elAtivo == firstInput) {
                secondInput.value = (100 - firstInput.value).toFixed(2);
                this.campos_objetivo[attrName1] = parseFloat(firstInput.value);
                this.campos_objetivo[attrName2] = parseFloat(secondInput.value);
            } else if (elAtivo == secondInput) {
                firstInput.value = (100 - secondInput.value).toFixed(2);
                this.campos_objetivo[attrName1] = parseFloat(firstInput.value);
                this.campos_objetivo[attrName2] = parseFloat(secondInput.value);
            }
        },
        compareSumValuesInNormalSteps: function(soma) {
            if (soma > 100 || soma != 100) {
                this.isValid = false;
                this.showError = true;
                this.errorMessage = "O somat\xf3rio precisa ser igual a 100%";
                return;
            }
            this.isValid = true;
        },
        checkSumValueInInlineSteps: function() {
            var val = +this.valor_total_computado.toFixed(2);
            if (val > 100 || val !== 100) {
                this.isValid = false;
                this.isPercentFull = false;
                this.showError = true;
                this.errorMessage = "O somat\xf3rio precisa ser igual a 100%";
            } else if (val == 100) {
                this.isValid = true;
                this.isPercentFull = true;
            }
        },
        ["defineTypeProduct"]: function(variable) {
            switch(variable){
                case "acoes":
                    this.product_type_name = "A\xe7\xf5es";
                    break;
                case "fiis":
                    this.product_type_name = "FII - Fundo de Investimento Imobili\xe1rio";
                    break;
                case "stocks":
                    this.product_type_name = "Stock";
                    break;
                case "reits":
                    this.product_type_name = "REIT";
                    break;
                case "tesouro_direto":
                    this.product_type_name = "TesouroDireto";
                    break;
            }
        },
        saveActualStep: /* Funções responsáveis pelo pesquisar e setar as options dentro do Choices */ function() {
            return (0, $a1727a7253abe12d$export$7c398597f8905a1)(function() {
                return (0, $877235af7931ac6c$export$67ebef60e6f28a6)(this, function(_state) {
                    this.loading = true;
                    axios.post("".concat(this.baseURL, "/salvar_step/"), {
                        step: this.step,
                        stepList: this.stepList,
                        isSaveBtn: this.isSaveBtn,
                        objetivos: this.objetivos,
                        campos_objetivo: this.campos_objetivo
                    }).then(function(param) {
                        var data = param.data;
                        return data;
                    }).catch(function(error) {
                        GLOBAL.showToastify(error, "#DE4B4F");
                        console.error(error);
                        return;
                    });
                    return [
                        2
                    ];
                });
            }).apply(this);
        },
        /**
		 * @description função responsável pelo evento de pesquisar dentro do vue select
		 * @param {string} search
		 * @param {boolean} loading
		 **/ onSearch: function(search, loading) {
            var _this_step;
            if (((_this_step = this.step) === null || _this_step === void 0 ? void 0 : _this_step.id) === 9) return;
            if (search.length) {
                loading(true);
                this.getDataOnSearchSelect(loading, search, this);
            }
        },
        /**
		 * @description função responsável por fazer requisiçoes para API de acordo com a valor de busca, possui debounce.
		 * @param {string} search
		 * @param {boolean} loading
		 **/ getDataOnSearchSelect: (0, $9Wwts.debounce)(function() {
            var _ref = (0, $a1727a7253abe12d$export$7c398597f8905a1)(function(loading, search) {
                var data, response, response1, error;
                return (0, $877235af7931ac6c$export$67ebef60e6f28a6)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                7,
                                8,
                                9
                            ]);
                            if (!(this.tipo_atual == "tesouro_direto")) return [
                                3,
                                3
                            ];
                            return [
                                4,
                                fetch("".concat(this.baseURL, "/api/tesouro_direto/?ticker_symbol=").concat(search))
                            ];
                        case 1:
                            response = _state.sent();
                            return [
                                4,
                                response.json()
                            ];
                        case 2:
                            data = _state.sent();
                            return [
                                3,
                                6
                            ];
                        case 3:
                            return [
                                4,
                                fetch("".concat(this.baseURL, "/api/").concat(this.tipo_atual, "/?ticker_symbol=").concat(search))
                            ];
                        case 4:
                            response1 = _state.sent();
                            return [
                                4,
                                response1.json()
                            ];
                        case 5:
                            data = _state.sent();
                            _state.label = 6;
                        case 6:
                            this.options = data.map(function(param) {
                                var ticker_symbol = param.ticker_symbol;
                                return {
                                    value: ticker_symbol,
                                    label: ticker_symbol,
                                    ticker_symbol: ticker_symbol
                                };
                            });
                            loading(false);
                            this.isLoading = false;
                            return [
                                3,
                                9
                            ];
                        case 7:
                            error = _state.sent();
                            GLOBAL.showToastify(error);
                            console.error(error);
                            loading(false);
                            this.isLoading = false;
                            return [
                                3,
                                9
                            ];
                        case 8:
                            loading(false);
                            this.isLoading = false;
                            return [
                                7
                            ];
                        case 9:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(loading, search) {
                return _ref.apply(this, arguments);
            };
        }(), 600),
        /* Funções responsável por controlar array do objeto de edição */ setAEditObjectiveToArray: function(id) {
            this.modalIsOpen = true;
            var tipo = this.step.tipo;
            var filterObjetivo = this.objetivos[tipo].filter(function(item) {
                return item.id == id;
            });
            this.objEdicao = filterObjetivo[0];
            this.setValuesOnEditStateModal(filterObjetivo);
        },
        setNewObjectiveValueInOnKeyupEdit: function(e, cancelar) {
            var _this = this;
            var _this_step;
            var _this_step_tipo;
            var tipo = (_this_step_tipo = (_this_step = this.step) === null || _this_step === void 0 ? void 0 : _this_step.tipo) !== null && _this_step_tipo !== void 0 ? _this_step_tipo : "";
            if (cancelar || !tipo) // Se cancelar ou tipo não estiver definido, sai da função
            return;
            if (e.target) {
                e.preventDefault();
                this.limitQuantityNumberAfterVirgula(e.target);
                var updatedObjectives = this.objetivos[tipo].map(function(item) {
                    if (item.id === _this.objEdicao.id) {
                        var _this_novoObjetivo_porcentagem;
                        var porcentagem = (_this_novoObjetivo_porcentagem = _this.novoObjetivo.porcentagem) !== null && _this_novoObjetivo_porcentagem !== void 0 ? _this_novoObjetivo_porcentagem : item.porcentagem_desejada;
                        return (0, $8typN._)((0, $8pZMQ._)({}, item), {
                            porcentagem_desejada: porcentagem
                        });
                    }
                    return item;
                });
                this.objetivos[tipo] = updatedObjectives;
                this.validateModalFieldsOnEdit(e.target);
            }
        },
        updateObjectiveValue: function(item) {
            return (0, $8typN._)((0, $8pZMQ._)({}, item), {
                porcentagem_desejada: this.novoObjetivo.porcentagem
            });
        },
        setValuesOnEditStateModal: function(array) {
            this.novoObjetivo.nome = array[0].ticker_symbol;
            this.novoObjetivo.porcentagem = array[0].porcentagem_desejada;
        },
        /** 
		*Função responsável por ativar o modal e suas respectivas ações.
		* @param {string} valor
		* @param {string} id
		*/ activateModal: function(valor, id) {
            var _this_step;
            this.modalIsOpen = true;
            this.modalState = valor;
            var tipo = (_this_step = this.step) === null || _this_step === void 0 ? void 0 : _this_step.tipo;
            switch(this.modalState){
                case "adicionar":
                    this.options = [];
                    this.novoObjetivo = {
                        nome: "",
                        porcentagem: ""
                    };
                    this.modalValueIsValid = false;
                    this.hasSameValue = false;
                    this.showErrorOnModal = false;
                    break;
                case "editar":
                    var _this_step1;
                    this.modalValueIsValid = true;
                    this.hasSameValue = false;
                    this.showErrorOnModal = false;
                    // this.pastTotalValue = this.valor_total_computado;
                    var nomeAtivo = this.objetivos[(_this_step1 = this.step) === null || _this_step1 === void 0 ? void 0 : _this_step1.tipo].filter(function(i) {
                        return i.id === id;
                    }).reduce(function(acc, i) {
                        return acc = i;
                    }, {});
                    this.options = [
                        {
                            value: nomeAtivo.ticker_symbol,
                            label: nomeAtivo.ticker_symbol
                        }
                    ];
                    this.setAEditObjectiveToArray(id);
                    break;
            }
        },
        /** 
		 * Função responsável por definir o ticker_symbol na hora de editar um ativo.
		 */ defineTickerSymbolInEdit: function() {
            if (this.novoObjetivo.nome.ticker_symbol) return this.novoObjetivo.nome.ticker_symbol;
            else if (this.novoObjetivo.nome.value) return this.novoObjetivo.nome.value;
            else return this.novoObjetivo.nome;
        },
        editAExistantObjetive: /**
		 * Função responsável por editar um ativo no modal de objetivo.
 
		 */ function() {
            return (0, $a1727a7253abe12d$export$7c398597f8905a1)(function() {
                var _this, tipo, objetivosFiltrados;
                return (0, $877235af7931ac6c$export$67ebef60e6f28a6)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _this = this;
                            tipo = this.step.tipo;
                            objetivosFiltrados = this.objetivos[tipo].map(function(item) {
                                if (item.id == _this.objEdicao.id) return (0, $8typN._)((0, $8pZMQ._)({}, item), {
                                    ticker_symbol: _this.defineTickerSymbolInEdit(),
                                    porcentagem_desejada: _this.novoObjetivo.porcentagem
                                });
                                return item;
                            });
                            this.objetivos[tipo] = objetivosFiltrados;
                            this.dataToSave.objetivos = this.objetivos;
                            return [
                                4,
                                this.saveActualStateOnLocalStorage(this.dataToSave)
                            ];
                        case 1:
                            _state.sent();
                            this.checkSumValueInInlineSteps();
                            this.modalIsOpen = false;
                            return [
                                2
                            ];
                    }
                });
            }).apply(this);
        },
        saveANewObjective: /**
		 * Função responsável por salvar um ativo no modal de objetivo
		 * @param {*} event 
		 */ function(event) {
            return (0, $a1727a7253abe12d$export$7c398597f8905a1)(function() {
                var modalResponsavel, tipo, objetivosAtuais, found;
                return (0, $877235af7931ac6c$export$67ebef60e6f28a6)(this, function(_state) {
                    if (!this.product_type_name) return [
                        2
                    ];
                    modalResponsavel = event.currentTarget.closest(".modal-adicao");
                    tipo = this.step.tipo;
                    objetivosAtuais = this.objetivos[tipo];
                    found = false;
                    this.objetivos[tipo] = (0, $79xu7._)(objetivosAtuais).concat([
                        {
                            id: this.protocol === "https:" ? crypto.randomUUID() : GLOBAL.generateUUID(),
                            ticker_symbol: this.novoObjetivo.nome,
                            porcentagem_desejada: this.novoObjetivo.porcentagem,
                            tipo_ativo: "".concat(this.tipo_atual != "tesouro_direto" ? "Variavel" : "Fixa"),
                            product_type_name: this.product_type_name
                        }
                    ]);
                    this.dataToSave.objetivos = this.objetivos;
                    this.saveActualStateOnLocalStorage(this.dataToSave);
                    this.pastTotalValue = 0;
                    this.checkSumValueInInlineSteps();
                    this.resetModalForm();
                    this.modalIsOpen = false;
                    return [
                        2
                    ];
                });
            }).apply(this);
        },
        removeObjective: /**
		 * Função responsável por remover um ativo no modal de objetivo
		 * @param {*} id 
		 */ function(id) {
            return (0, $a1727a7253abe12d$export$7c398597f8905a1)(function() {
                var tipo;
                return (0, $877235af7931ac6c$export$67ebef60e6f28a6)(this, function(_state) {
                    tipo = this.step.tipo;
                    this.objetivos[tipo] = this.objetivos[tipo].filter(function(item) {
                        return item.id !== id;
                    });
                    this.checkSumValueInInlineSteps();
                    return [
                        2
                    ];
                });
            }).apply(this);
        },
        /**
		 * Função responsável por validar os campos do modal de adição
		 * @param {*} e
		 */ validateModalFieldsOnAdd: function(e) {
            this.limitQuantityNumberAfterVirgula(e.target);
            if (!this.novoObjetivo.nome || !this.novoObjetivo.porcentagem) {
                this.modalValueIsValid = false;
                this.showErrorOnModal = true;
                this.modalErrorMessage = "Os campos n\xe3o podem estar vazios";
            } else if (this.valor_total_computado + this.novoObjetivo.porcentagem > 100) {
                this.modalValueIsValid = false;
                this.showErrorOnModal = true;
                this.modalErrorMessage = "O somat\xf3rio precisa ser igual a 100%";
                this.novoObjetivo.porcentagem = null;
            } else {
                this.modalValueIsValid = true;
                this.showErrorOnModal = false;
                this.modalErrorMessage = "";
            }
        },
        /**
		 * Função responsável por retornar o valor original do objetivo
		 */ returnToOriginalValueObjetive: function() {
            var _this = this;
            var _this_step, _this_step1;
            this.novoObjetivo.porcentagem = this.objEdicao.porcentagem_desejada;
            var updatedObjectives = this.objetivos[(_this_step = this.step) === null || _this_step === void 0 ? void 0 : _this_step.tipo].map(function(item) {
                if (item.id === _this.objEdicao.id) {
                    var _this_novoObjetivo_porcentagem;
                    var porcentagem = (_this_novoObjetivo_porcentagem = _this.novoObjetivo.porcentagem) !== null && _this_novoObjetivo_porcentagem !== void 0 ? _this_novoObjetivo_porcentagem : item.porcentagem_desejada;
                    return (0, $8typN._)((0, $8pZMQ._)({}, item), {
                        porcentagem_desejada: porcentagem
                    });
                }
                return item;
            });
            this.objetivos[(_this_step1 = this.step) === null || _this_step1 === void 0 ? void 0 : _this_step1.tipo] = updatedObjectives;
            this.modalValueIsValid = true;
        },
        /**
		 * Função responsável por validar os campos do modal de edição
		 */ validateModalFieldsOnEdit: function(el) {
            if (!this.novoObjetivo.porcentagem) {
                this.modalValueIsValid = false;
                this.showErrorOnModal = true;
                this.modalErrorMessage = "Os campos n\xe3o podem estar vazios";
            } else if (this.valor_total_computado > 100 || this.novoObjetivo.porcentagem > 100) {
                this.modalValueIsValid = false;
                this.showErrorOnModal = true;
                this.modalErrorMessage = "O somat\xf3rio precisa ser igual a 100%";
                this.returnToOriginalValueObjetive();
            } else {
                this.modalValueIsValid = true;
                this.showErrorOnModal = false;
                this.modalErrorMessage = "";
            }
        },
        /**
		 * Função responsável por enviar o formulário ao final do wizard
		 * @param {*} e
		 */ /**
		 * Avisos de recomendação do step informado (para exibição inline)
		 */ avisosDoStep: function(stepId) {
            var fases = $95dff4962bd81e46$var$FASES_POR_STEP[stepId] || [];
            return this.avisosRecomendacao.filter(function(aviso) {
                return fases.includes(aviso.fase);
            });
        },
        /**
		 * Confirmação do modal de avisos: o investidor quer prosseguir mesmo assim
		 */ confirmarEnvio: function() {
            this.modalAvisosOpen = false;
            this.$refs.formulario.submit();
        },
        onSubmitAction: function(e) {
            return (0, $a1727a7253abe12d$export$7c398597f8905a1)(function() {
                var form;
                return (0, $877235af7931ac6c$export$67ebef60e6f28a6)(this, function(_state) {
                    e.preventDefault();
                    form = this.$refs.formulario;
                    // Seções em 0% não bloqueiam, mas pedem confirmação explícita
                    if (this.avisosRecomendacao.length) {
                        this.modalAvisosOpen = true;
                        return [
                            2
                        ];
                    }
                    form.submit();
                    return [
                        2
                    ];
                });
            //add complete true
            // Object.entries(this.objetivos).map(([key, value]) => {
            // 	const objetivo = this.objetivos[key]?.reduce((acc, i, idx) => {
            // 		const { id, ...rest } = i;
            // 		acc[idx] = rest;
            // 		return acc;
            // 	}, {});
            // 	this.objetivos[key] = objetivo;
            // 	//array de objetivos
            // });
            }).apply(this);
        },
        /**
		* Função responsável por resetar os campos do modal de adição
		* 
		*/ resetModalForm: function() {
            this.novoObjetivo = {
                nome: "",
                porcentagem: ""
            };
        },
        handleClickInOptions: function(id) {
            this.showOptions = id;
            this.showOptionsFirst = true;
        },
        onCloseModal: function() {
            var _this_step, _this_step1;
            this.modalIsOpen = false;
            var valoresOriginais = this.objetivos[(_this_step = this.step) === null || _this_step === void 0 ? void 0 : _this_step.tipo].map(function(objetivo) {
                return (0, $8pZMQ._)({}, objetivo);
            });
            this.objetivos[(_this_step1 = this.step) === null || _this_step1 === void 0 ? void 0 : _this_step1.tipo] = valoresOriginais;
            // this.setNewObjectiveValueInOnKeyupEdit(false, true);
            // this.pastTotalValue = 0;
            this.returnToOriginalValueObjetive();
            this.hasSameValue = false;
            this.showErrorOnModal = false;
            this.modalErrorMessage = "";
        },
        outsideClick: function(param) {
            var target = param.target;
            if (target.closest(".icone-three-points")) return;
            this.showOptionsFirst = false;
        }
    },
    delimiters: [
        "{*",
        "*}"
    ]
};




var $4f96i = parcelRequire("4f96i");


var $9Wwts = parcelRequire("9Wwts");
function $e4ffe90de00e70c4$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $e4ffe90de00e70c4$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $e4ffe90de00e70c4$export$2e2bcd8739ae039(o);
}


function $0acc3380b5849741$export$2e2bcd8739ae039(required, args) {
    if (args.length < required) throw new TypeError(required + " argument" + (required > 1 ? "s" : "") + " required, but only " + args.length + " present");
}


function $09750989ccd8081c$export$2e2bcd8739ae039(value) {
    (0, $0acc3380b5849741$export$2e2bcd8739ae039)(1, arguments);
    return value instanceof Date || (0, $e4ffe90de00e70c4$export$2e2bcd8739ae039)(value) === "object" && Object.prototype.toString.call(value) === "[object Date]";
}




function $b51729f4ea50d0db$export$2e2bcd8739ae039(argument) {
    (0, $0acc3380b5849741$export$2e2bcd8739ae039)(1, arguments);
    var argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || (0, $e4ffe90de00e70c4$export$2e2bcd8739ae039)(argument) === "object" && argStr === "[object Date]") // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === "number" || argStr === "[object Number]") return new Date(argument);
    else {
        if ((typeof argument === "string" || argStr === "[object String]") && typeof console !== "undefined") {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
            // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}



function $e280598527fe7137$export$2e2bcd8739ae039(dirtyDate) {
    (0, $0acc3380b5849741$export$2e2bcd8739ae039)(1, arguments);
    if (!(0, $09750989ccd8081c$export$2e2bcd8739ae039)(dirtyDate) && typeof dirtyDate !== "number") return false;
    var date = (0, $b51729f4ea50d0db$export$2e2bcd8739ae039)(dirtyDate);
    return !isNaN(Number(date));
}


function $bc43d2291f2f753b$export$2e2bcd8739ae039(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
    var number = Number(dirtyNumber);
    if (isNaN(number)) return number;
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}




function $3c0a0f813be0f9be$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $0acc3380b5849741$export$2e2bcd8739ae039)(2, arguments);
    var timestamp = (0, $b51729f4ea50d0db$export$2e2bcd8739ae039)(dirtyDate).getTime();
    var amount = (0, $bc43d2291f2f753b$export$2e2bcd8739ae039)(dirtyAmount);
    return new Date(timestamp + amount);
}




function $57b932d408e12458$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $0acc3380b5849741$export$2e2bcd8739ae039)(2, arguments);
    var amount = (0, $bc43d2291f2f753b$export$2e2bcd8739ae039)(dirtyAmount);
    return (0, $3c0a0f813be0f9be$export$2e2bcd8739ae039)(dirtyDate, -amount);
}





var $d3e104d949830c34$var$MILLISECONDS_IN_DAY = 86400000;
function $d3e104d949830c34$export$2e2bcd8739ae039(dirtyDate) {
    (0, $0acc3380b5849741$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $b51729f4ea50d0db$export$2e2bcd8739ae039)(dirtyDate);
    var timestamp = date.getTime();
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
    var startOfYearTimestamp = date.getTime();
    var difference = timestamp - startOfYearTimestamp;
    return Math.floor(difference / $d3e104d949830c34$var$MILLISECONDS_IN_DAY) + 1;
}





function $102e62bc0bde366c$export$2e2bcd8739ae039(dirtyDate) {
    (0, $0acc3380b5849741$export$2e2bcd8739ae039)(1, arguments);
    var weekStartsOn = 1;
    var date = (0, $b51729f4ea50d0db$export$2e2bcd8739ae039)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}





function $e4deef300293df5e$export$2e2bcd8739ae039(dirtyDate) {
    (0, $0acc3380b5849741$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $b51729f4ea50d0db$export$2e2bcd8739ae039)(dirtyDate);
    var year = date.getUTCFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $102e62bc0bde366c$export$2e2bcd8739ae039)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $102e62bc0bde366c$export$2e2bcd8739ae039)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}




function $7e54822387523a8e$export$2e2bcd8739ae039(dirtyDate) {
    (0, $0acc3380b5849741$export$2e2bcd8739ae039)(1, arguments);
    var year = (0, $e4deef300293df5e$export$2e2bcd8739ae039)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setUTCFullYear(year, 0, 4);
    fourthOfJanuary.setUTCHours(0, 0, 0, 0);
    var date = (0, $102e62bc0bde366c$export$2e2bcd8739ae039)(fourthOfJanuary);
    return date;
}



var $88eedbfaa3f52ec6$var$MILLISECONDS_IN_WEEK = 604800000;
function $88eedbfaa3f52ec6$export$2e2bcd8739ae039(dirtyDate) {
    (0, $0acc3380b5849741$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $b51729f4ea50d0db$export$2e2bcd8739ae039)(dirtyDate);
    var diff = (0, $102e62bc0bde366c$export$2e2bcd8739ae039)(date).getTime() - (0, $7e54822387523a8e$export$2e2bcd8739ae039)(date).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $88eedbfaa3f52ec6$var$MILLISECONDS_IN_WEEK) + 1;
}







var $4ea937067d9df9be$var$defaultOptions = {};
function $4ea937067d9df9be$export$430a3269e24b912e() {
    return $4ea937067d9df9be$var$defaultOptions;
}
function $4ea937067d9df9be$export$95365be1b0704abc(newOptions) {
    $4ea937067d9df9be$var$defaultOptions = newOptions;
}


function $9567c8f9dac05c85$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $0acc3380b5849741$export$2e2bcd8739ae039)(1, arguments);
    var defaultOptions = (0, $4ea937067d9df9be$export$430a3269e24b912e)();
    var weekStartsOn = (0, $bc43d2291f2f753b$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var date = (0, $b51729f4ea50d0db$export$2e2bcd8739ae039)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}







function $430aa354af57c1bf$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $0acc3380b5849741$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $b51729f4ea50d0db$export$2e2bcd8739ae039)(dirtyDate);
    var year = date.getUTCFullYear();
    var defaultOptions = (0, $4ea937067d9df9be$export$430a3269e24b912e)();
    var firstWeekContainsDate = (0, $bc43d2291f2f753b$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $9567c8f9dac05c85$export$2e2bcd8739ae039)(firstWeekOfNextYear, options);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $9567c8f9dac05c85$export$2e2bcd8739ae039)(firstWeekOfThisYear, options);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}






function $e01ac641276f7d2c$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $0acc3380b5849741$export$2e2bcd8739ae039)(1, arguments);
    var defaultOptions = (0, $4ea937067d9df9be$export$430a3269e24b912e)();
    var firstWeekContainsDate = (0, $bc43d2291f2f753b$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    var year = (0, $430aa354af57c1bf$export$2e2bcd8739ae039)(dirtyDate, options);
    var firstWeek = new Date(0);
    firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setUTCHours(0, 0, 0, 0);
    var date = (0, $9567c8f9dac05c85$export$2e2bcd8739ae039)(firstWeek, options);
    return date;
}



var $2d531c9758890e80$var$MILLISECONDS_IN_WEEK = 604800000;
function $2d531c9758890e80$export$2e2bcd8739ae039(dirtyDate, options) {
    (0, $0acc3380b5849741$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $b51729f4ea50d0db$export$2e2bcd8739ae039)(dirtyDate);
    var diff = (0, $9567c8f9dac05c85$export$2e2bcd8739ae039)(date, options).getTime() - (0, $e01ac641276f7d2c$export$2e2bcd8739ae039)(date, options).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $2d531c9758890e80$var$MILLISECONDS_IN_WEEK) + 1;
}



function $fb86b67448ae88c7$export$2e2bcd8739ae039(number, targetLength) {
    var sign = number < 0 ? "-" : "";
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = "0" + output;
    return sign + output;
}



/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */ var $314fba05b1f38e52$var$formatters = {
    // Year
    y: function y(date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        var signedYear = date.getUTCFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $fb86b67448ae88c7$export$2e2bcd8739ae039)(token === "yy" ? year % 100 : year, token.length);
    },
    // Month
    M: function M(date, token) {
        var month = date.getUTCMonth();
        return token === "M" ? String(month + 1) : (0, $fb86b67448ae88c7$export$2e2bcd8739ae039)(month + 1, 2);
    },
    // Day of the month
    d: function d(date, token) {
        return (0, $fb86b67448ae88c7$export$2e2bcd8739ae039)(date.getUTCDate(), token.length);
    },
    // AM or PM
    a: function a(date, token) {
        var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return dayPeriodEnumValue.toUpperCase();
            case "aaa":
                return dayPeriodEnumValue;
            case "aaaaa":
                return dayPeriodEnumValue[0];
            case "aaaa":
            default:
                return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
        }
    },
    // Hour [1-12]
    h: function h(date, token) {
        return (0, $fb86b67448ae88c7$export$2e2bcd8739ae039)(date.getUTCHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H: function H(date, token) {
        return (0, $fb86b67448ae88c7$export$2e2bcd8739ae039)(date.getUTCHours(), token.length);
    },
    // Minute
    m: function m(date, token) {
        return (0, $fb86b67448ae88c7$export$2e2bcd8739ae039)(date.getUTCMinutes(), token.length);
    },
    // Second
    s: function s(date, token) {
        return (0, $fb86b67448ae88c7$export$2e2bcd8739ae039)(date.getUTCSeconds(), token.length);
    },
    // Fraction of second
    S: function S(date, token) {
        var numberOfDigits = token.length;
        var milliseconds = date.getUTCMilliseconds();
        var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $fb86b67448ae88c7$export$2e2bcd8739ae039)(fractionalSeconds, token.length);
    }
};
var $314fba05b1f38e52$export$2e2bcd8739ae039 = $314fba05b1f38e52$var$formatters;


var $b4bfc34085b42475$var$dayPeriodEnum = {
    am: "am",
    pm: "pm",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */ var $b4bfc34085b42475$var$formatters = {
    // Era
    G: function G(date, token, localize) {
        var era = date.getUTCFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return localize.era(era, {
                    width: "abbreviated"
                });
            // A, B
            case "GGGGG":
                return localize.era(era, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return localize.era(era, {
                    width: "wide"
                });
        }
    },
    // Year
    y: function y(date, token, localize) {
        // Ordinal number
        if (token === "yo") {
            var signedYear = date.getUTCFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            var year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: "year"
            });
        }
        return (0, $314fba05b1f38e52$export$2e2bcd8739ae039).y(date, token);
    },
    // Local week-numbering year
    Y: function Y(date, token, localize, options) {
        var signedWeekYear = (0, $430aa354af57c1bf$export$2e2bcd8739ae039)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === "YY") {
            var twoDigitYear = weekYear % 100;
            return (0, $fb86b67448ae88c7$export$2e2bcd8739ae039)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === "Yo") return localize.ordinalNumber(weekYear, {
            unit: "year"
        });
        // Padding
        return (0, $fb86b67448ae88c7$export$2e2bcd8739ae039)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function R(date, token) {
        var isoWeekYear = (0, $e4deef300293df5e$export$2e2bcd8739ae039)(date);
        // Padding
        return (0, $fb86b67448ae88c7$export$2e2bcd8739ae039)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function u(date, token) {
        var year = date.getUTCFullYear();
        return (0, $fb86b67448ae88c7$export$2e2bcd8739ae039)(year, token.length);
    },
    // Quarter
    Q: function Q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "Q":
                return String(quarter);
            // 01, 02, 03, 04
            case "QQ":
                return (0, $fb86b67448ae88c7$export$2e2bcd8739ae039)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone quarter
    q: function q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "q":
                return String(quarter);
            // 01, 02, 03, 04
            case "qq":
                return (0, $fb86b67448ae88c7$export$2e2bcd8739ae039)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Month
    M: function M(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            case "M":
            case "MM":
                return (0, $314fba05b1f38e52$export$2e2bcd8739ae039).M(date, token);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "MMM":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return localize.month(month, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone month
    L: function L(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return String(month + 1);
            // 01, 02, ..., 12
            case "LL":
                return (0, $fb86b67448ae88c7$export$2e2bcd8739ae039)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "LLL":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return localize.month(month, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Local week of year
    w: function w(date, token, localize, options) {
        var week = (0, $2d531c9758890e80$export$2e2bcd8739ae039)(date, options);
        if (token === "wo") return localize.ordinalNumber(week, {
            unit: "week"
        });
        return (0, $fb86b67448ae88c7$export$2e2bcd8739ae039)(week, token.length);
    },
    // ISO week of year
    I: function I(date, token, localize) {
        var isoWeek = (0, $88eedbfaa3f52ec6$export$2e2bcd8739ae039)(date);
        if (token === "Io") return localize.ordinalNumber(isoWeek, {
            unit: "week"
        });
        return (0, $fb86b67448ae88c7$export$2e2bcd8739ae039)(isoWeek, token.length);
    },
    // Day of the month
    d: function d(date, token, localize) {
        if (token === "do") return localize.ordinalNumber(date.getUTCDate(), {
            unit: "date"
        });
        return (0, $314fba05b1f38e52$export$2e2bcd8739ae039).d(date, token);
    },
    // Day of year
    D: function D(date, token, localize) {
        var dayOfYear = (0, $d3e104d949830c34$export$2e2bcd8739ae039)(date);
        if (token === "Do") return localize.ordinalNumber(dayOfYear, {
            unit: "dayOfYear"
        });
        return (0, $fb86b67448ae88c7$export$2e2bcd8739ae039)(dayOfYear, token.length);
    },
    // Day of week
    E: function E(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Local day of week
    e: function e(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case "e":
                return String(localDayOfWeek);
            // Padded numerical value
            case "ee":
                return (0, $fb86b67448ae88c7$export$2e2bcd8739ae039)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case "eo":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "eee":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone local day of week
    c: function c(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case "c":
                return String(localDayOfWeek);
            // Padded numerical value
            case "cc":
                return (0, $fb86b67448ae88c7$export$2e2bcd8739ae039)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case "co":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "ccc":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // ISO day of week
    i: function i(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case "i":
                return String(isoDayOfWeek);
            // 02
            case "ii":
                return (0, $fb86b67448ae88c7$export$2e2bcd8739ae039)(isoDayOfWeek, token.length);
            // 2nd
            case "io":
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "iiiii":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "iiiiii":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "iiii":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM or PM
    a: function a(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "aaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "aaaaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM, PM, midnight, noon
    b: function b(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $b4bfc34085b42475$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $b4bfc34085b42475$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "b":
            case "bb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "bbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "bbbbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function B(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $b4bfc34085b42475$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $b4bfc34085b42475$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $b4bfc34085b42475$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $b4bfc34085b42475$var$dayPeriodEnum.night;
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "BBBBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Hour [1-12]
    h: function h(date, token, localize) {
        if (token === "ho") {
            var hours = date.getUTCHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: "hour"
            });
        }
        return (0, $314fba05b1f38e52$export$2e2bcd8739ae039).h(date, token);
    },
    // Hour [0-23]
    H: function H(date, token, localize) {
        if (token === "Ho") return localize.ordinalNumber(date.getUTCHours(), {
            unit: "hour"
        });
        return (0, $314fba05b1f38e52$export$2e2bcd8739ae039).H(date, token);
    },
    // Hour [0-11]
    K: function K(date, token, localize) {
        var hours = date.getUTCHours() % 12;
        if (token === "Ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $fb86b67448ae88c7$export$2e2bcd8739ae039)(hours, token.length);
    },
    // Hour [1-24]
    k: function k(date, token, localize) {
        var hours = date.getUTCHours();
        if (hours === 0) hours = 24;
        if (token === "ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $fb86b67448ae88c7$export$2e2bcd8739ae039)(hours, token.length);
    },
    // Minute
    m: function m(date, token, localize) {
        if (token === "mo") return localize.ordinalNumber(date.getUTCMinutes(), {
            unit: "minute"
        });
        return (0, $314fba05b1f38e52$export$2e2bcd8739ae039).m(date, token);
    },
    // Second
    s: function s(date, token, localize) {
        if (token === "so") return localize.ordinalNumber(date.getUTCSeconds(), {
            unit: "second"
        });
        return (0, $314fba05b1f38e52$export$2e2bcd8739ae039).s(date, token);
    },
    // Fraction of second
    S: function S(date, token) {
        return (0, $314fba05b1f38e52$export$2e2bcd8739ae039).S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function X(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        if (timezoneOffset === 0) return "Z";
        switch(token){
            // Hours and optional minutes
            case "X":
                return $b4bfc34085b42475$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case "XXXX":
            case "XX":
                // Hours and minutes without `:` delimiter
                return $b4bfc34085b42475$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case "XXXXX":
            case "XXX":
            default:
                return $b4bfc34085b42475$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function x(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case "x":
                return $b4bfc34085b42475$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case "xxxx":
            case "xx":
                // Hours and minutes without `:` delimiter
                return $b4bfc34085b42475$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case "xxxxx":
            case "xxx":
            default:
                return $b4bfc34085b42475$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (GMT)
    O: function O(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case "O":
            case "OO":
            case "OOO":
                return "GMT" + $b4bfc34085b42475$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "OOOO":
            default:
                return "GMT" + $b4bfc34085b42475$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (specific non-location)
    z: function z(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case "z":
            case "zz":
            case "zzz":
                return "GMT" + $b4bfc34085b42475$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "zzzz":
            default:
                return "GMT" + $b4bfc34085b42475$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Seconds timestamp
    t: function t(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = Math.floor(originalDate.getTime() / 1000);
        return (0, $fb86b67448ae88c7$export$2e2bcd8739ae039)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function T(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = originalDate.getTime();
        return (0, $fb86b67448ae88c7$export$2e2bcd8739ae039)(timestamp, token.length);
    }
};
function $b4bfc34085b42475$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? "-" : "+";
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || "";
    return sign + String(hours) + delimiter + (0, $fb86b67448ae88c7$export$2e2bcd8739ae039)(minutes, 2);
}
function $b4bfc34085b42475$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? "-" : "+";
        return sign + (0, $fb86b67448ae88c7$export$2e2bcd8739ae039)(Math.abs(offset) / 60, 2);
    }
    return $b4bfc34085b42475$var$formatTimezone(offset, dirtyDelimiter);
}
function $b4bfc34085b42475$var$formatTimezone(offset, dirtyDelimiter) {
    var delimiter = dirtyDelimiter || "";
    var sign = offset > 0 ? "-" : "+";
    var absOffset = Math.abs(offset);
    var hours = (0, $fb86b67448ae88c7$export$2e2bcd8739ae039)(Math.floor(absOffset / 60), 2);
    var minutes = (0, $fb86b67448ae88c7$export$2e2bcd8739ae039)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}
var $b4bfc34085b42475$export$2e2bcd8739ae039 = $b4bfc34085b42475$var$formatters;


var $6c5032b9951ac716$var$dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
    switch(pattern){
        case "P":
            return formatLong.date({
                width: "short"
            });
        case "PP":
            return formatLong.date({
                width: "medium"
            });
        case "PPP":
            return formatLong.date({
                width: "long"
            });
        case "PPPP":
        default:
            return formatLong.date({
                width: "full"
            });
    }
};
var $6c5032b9951ac716$var$timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
    switch(pattern){
        case "p":
            return formatLong.time({
                width: "short"
            });
        case "pp":
            return formatLong.time({
                width: "medium"
            });
        case "ppp":
            return formatLong.time({
                width: "long"
            });
        case "pppp":
        default:
            return formatLong.time({
                width: "full"
            });
    }
};
var $6c5032b9951ac716$var$dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/) || [];
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) return $6c5032b9951ac716$var$dateLongFormatter(pattern, formatLong);
    var dateTimeFormat;
    switch(datePattern){
        case "P":
            dateTimeFormat = formatLong.dateTime({
                width: "short"
            });
            break;
        case "PP":
            dateTimeFormat = formatLong.dateTime({
                width: "medium"
            });
            break;
        case "PPP":
            dateTimeFormat = formatLong.dateTime({
                width: "long"
            });
            break;
        case "PPPP":
        default:
            dateTimeFormat = formatLong.dateTime({
                width: "full"
            });
            break;
    }
    return dateTimeFormat.replace("{{date}}", $6c5032b9951ac716$var$dateLongFormatter(datePattern, formatLong)).replace("{{time}}", $6c5032b9951ac716$var$timeLongFormatter(timePattern, formatLong));
};
var $6c5032b9951ac716$var$longFormatters = {
    p: $6c5032b9951ac716$var$timeLongFormatter,
    P: $6c5032b9951ac716$var$dateTimeLongFormatter
};
var $6c5032b9951ac716$export$2e2bcd8739ae039 = $6c5032b9951ac716$var$longFormatters;


/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $ef85ebdafaf59809$export$2e2bcd8739ae039(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}


var $ebb0163f134ecb74$var$protectedDayOfYearTokens = [
    "D",
    "DD"
];
var $ebb0163f134ecb74$var$protectedWeekYearTokens = [
    "YY",
    "YYYY"
];
function $ebb0163f134ecb74$export$c6cc36aa33304772(token) {
    return $ebb0163f134ecb74$var$protectedDayOfYearTokens.indexOf(token) !== -1;
}
function $ebb0163f134ecb74$export$c6b49d6dceb604a1(token) {
    return $ebb0163f134ecb74$var$protectedWeekYearTokens.indexOf(token) !== -1;
}
function $ebb0163f134ecb74$export$8073c1ae88f0e727(token, format, input) {
    if (token === "YYYY") throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === "YY") throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === "D") throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === "DD") throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}





var $c50e578260564dc1$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
    },
    xSeconds: {
        one: "1 second",
        other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "about 1 hour",
        other: "about {{count}} hours"
    },
    xHours: {
        one: "1 hour",
        other: "{{count}} hours"
    },
    xDays: {
        one: "1 day",
        other: "{{count}} days"
    },
    aboutXWeeks: {
        one: "about 1 week",
        other: "about {{count}} weeks"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weeks"
    },
    aboutXMonths: {
        one: "about 1 month",
        other: "about {{count}} months"
    },
    xMonths: {
        one: "1 month",
        other: "{{count}} months"
    },
    aboutXYears: {
        one: "about 1 year",
        other: "about {{count}} years"
    },
    xYears: {
        one: "1 year",
        other: "{{count}} years"
    },
    overXYears: {
        one: "over 1 year",
        other: "over {{count}} years"
    },
    almostXYears: {
        one: "almost 1 year",
        other: "almost {{count}} years"
    }
};
var $c50e578260564dc1$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $c50e578260564dc1$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "in " + result;
        else return result + " ago";
    }
    return result;
};
var $c50e578260564dc1$export$2e2bcd8739ae039 = $c50e578260564dc1$var$formatDistance;


function $43b26b6638edc4bd$export$2e2bcd8739ae039(args) {
    return function() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // TODO: Remove String()
        var width = options.width ? String(options.width) : args.defaultWidth;
        var format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}


var $a31e957c698081b7$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
var $a31e957c698081b7$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
var $a31e957c698081b7$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $a31e957c698081b7$var$formatLong = {
    date: (0, $43b26b6638edc4bd$export$2e2bcd8739ae039)({
        formats: $a31e957c698081b7$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $43b26b6638edc4bd$export$2e2bcd8739ae039)({
        formats: $a31e957c698081b7$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $43b26b6638edc4bd$export$2e2bcd8739ae039)({
        formats: $a31e957c698081b7$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $a31e957c698081b7$export$2e2bcd8739ae039 = $a31e957c698081b7$var$formatLong;


var $63a00c21b8ab2b0f$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
};
var $63a00c21b8ab2b0f$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $63a00c21b8ab2b0f$var$formatRelativeLocale[token];
};
var $63a00c21b8ab2b0f$export$2e2bcd8739ae039 = $63a00c21b8ab2b0f$var$formatRelative;


function $fd85f8345cab8123$export$2e2bcd8739ae039(args) {
    return function(dirtyIndex, options) {
        var context = options !== null && options !== void 0 && options.context ? String(options.context) : "standalone";
        var valuesArray;
        if (context === "formatting" && args.formattingValues) {
            var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            var _defaultWidth = args.defaultWidth;
            var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[_width] || args.values[_defaultWidth];
        }
        var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
        // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}


var $f9ce9fcd773431bf$var$eraValues = {
    narrow: [
        "B",
        "A"
    ],
    abbreviated: [
        "BC",
        "AD"
    ],
    wide: [
        "Before Christ",
        "Anno Domini"
    ]
};
var $f9ce9fcd773431bf$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1st quarter",
        "2nd quarter",
        "3rd quarter",
        "4th quarter"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $f9ce9fcd773431bf$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ],
    wide: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ]
};
var $f9ce9fcd773431bf$var$dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "W",
        "T",
        "F",
        "S"
    ],
    short: [
        "Su",
        "Mo",
        "Tu",
        "We",
        "Th",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    wide: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ]
};
var $f9ce9fcd773431bf$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    }
};
var $f9ce9fcd773431bf$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    }
};
var $f9ce9fcd773431bf$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "st";
        case 2:
            return number + "nd";
        case 3:
            return number + "rd";
    }
    return number + "th";
};
var $f9ce9fcd773431bf$var$localize = {
    ordinalNumber: $f9ce9fcd773431bf$var$ordinalNumber,
    era: (0, $fd85f8345cab8123$export$2e2bcd8739ae039)({
        values: $f9ce9fcd773431bf$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $fd85f8345cab8123$export$2e2bcd8739ae039)({
        values: $f9ce9fcd773431bf$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $fd85f8345cab8123$export$2e2bcd8739ae039)({
        values: $f9ce9fcd773431bf$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $fd85f8345cab8123$export$2e2bcd8739ae039)({
        values: $f9ce9fcd773431bf$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $fd85f8345cab8123$export$2e2bcd8739ae039)({
        values: $f9ce9fcd773431bf$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $f9ce9fcd773431bf$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $f9ce9fcd773431bf$export$2e2bcd8739ae039 = $f9ce9fcd773431bf$var$localize;


function $343d05c7a1805419$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var width = options.width;
        var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        var matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        var key = Array.isArray(parsePatterns) ? $343d05c7a1805419$var$findIndex(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        }) : $343d05c7a1805419$var$findKey(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        });
        var value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $343d05c7a1805419$var$findKey(object, predicate) {
    for(var key in object){
        if (object.hasOwnProperty(key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $343d05c7a1805419$var$findIndex(array, predicate) {
    for(var key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}


function $c8c247705d19781d$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}


var $fb5c03c5dca93db6$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $fb5c03c5dca93db6$var$parseOrdinalNumberPattern = /\d+/i;
var $fb5c03c5dca93db6$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
var $fb5c03c5dca93db6$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var $fb5c03c5dca93db6$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
var $fb5c03c5dca93db6$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $fb5c03c5dca93db6$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var $fb5c03c5dca93db6$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $fb5c03c5dca93db6$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var $fb5c03c5dca93db6$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var $fb5c03c5dca93db6$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var $fb5c03c5dca93db6$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var $fb5c03c5dca93db6$var$match = {
    ordinalNumber: (0, $c8c247705d19781d$export$2e2bcd8739ae039)({
        matchPattern: $fb5c03c5dca93db6$var$matchOrdinalNumberPattern,
        parsePattern: $fb5c03c5dca93db6$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $343d05c7a1805419$export$2e2bcd8739ae039)({
        matchPatterns: $fb5c03c5dca93db6$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $fb5c03c5dca93db6$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $343d05c7a1805419$export$2e2bcd8739ae039)({
        matchPatterns: $fb5c03c5dca93db6$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $fb5c03c5dca93db6$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $343d05c7a1805419$export$2e2bcd8739ae039)({
        matchPatterns: $fb5c03c5dca93db6$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $fb5c03c5dca93db6$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $343d05c7a1805419$export$2e2bcd8739ae039)({
        matchPatterns: $fb5c03c5dca93db6$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $fb5c03c5dca93db6$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $343d05c7a1805419$export$2e2bcd8739ae039)({
        matchPatterns: $fb5c03c5dca93db6$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $fb5c03c5dca93db6$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $fb5c03c5dca93db6$export$2e2bcd8739ae039 = $fb5c03c5dca93db6$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var $52ad2d99fb62eab5$var$locale = {
    code: "en-US",
    formatDistance: (0, $c50e578260564dc1$export$2e2bcd8739ae039),
    formatLong: (0, $a31e957c698081b7$export$2e2bcd8739ae039),
    formatRelative: (0, $63a00c21b8ab2b0f$export$2e2bcd8739ae039),
    localize: (0, $f9ce9fcd773431bf$export$2e2bcd8739ae039),
    match: (0, $fb5c03c5dca93db6$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $52ad2d99fb62eab5$export$2e2bcd8739ae039 = $52ad2d99fb62eab5$var$locale;


var $3682a57969a1275e$export$2e2bcd8739ae039 = (0, $52ad2d99fb62eab5$export$2e2bcd8739ae039);


// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $0ba290dbf11af23c$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $0ba290dbf11af23c$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $0ba290dbf11af23c$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $0ba290dbf11af23c$var$doubleQuoteRegExp = /''/g;
var $0ba290dbf11af23c$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $0ba290dbf11af23c$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, $0acc3380b5849741$export$2e2bcd8739ae039)(2, arguments);
    var formatStr = String(dirtyFormatStr);
    var defaultOptions = (0, $4ea937067d9df9be$export$430a3269e24b912e)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $3682a57969a1275e$export$2e2bcd8739ae039);
    var firstWeekContainsDate = (0, $bc43d2291f2f753b$export$2e2bcd8739ae039)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var weekStartsOn = (0, $bc43d2291f2f753b$export$2e2bcd8739ae039)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    if (!locale.localize) throw new RangeError("locale must contain localize property");
    if (!locale.formatLong) throw new RangeError("locale must contain formatLong property");
    var originalDate = (0, $b51729f4ea50d0db$export$2e2bcd8739ae039)(dirtyDate);
    if (!(0, $e280598527fe7137$export$2e2bcd8739ae039)(originalDate)) throw new RangeError("Invalid time value");
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    // This ensures that when UTC functions will be implemented, locales will be compatible with them.
    // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
    var timezoneOffset = (0, $ef85ebdafaf59809$export$2e2bcd8739ae039)(originalDate);
    var utcDate = (0, $57b932d408e12458$export$2e2bcd8739ae039)(originalDate, timezoneOffset);
    var formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale,
        _originalDate: originalDate
    };
    var result = formatStr.match($0ba290dbf11af23c$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter === "p" || firstCharacter === "P") {
            var longFormatter = (0, $6c5032b9951ac716$export$2e2bcd8739ae039)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match($0ba290dbf11af23c$var$formattingTokensRegExp).map(function(substring) {
        // Replace two single quote characters with one single quote character
        if (substring === "''") return "'";
        var firstCharacter = substring[0];
        if (firstCharacter === "'") return $0ba290dbf11af23c$var$cleanEscapedString(substring);
        var formatter = (0, $b4bfc34085b42475$export$2e2bcd8739ae039)[firstCharacter];
        if (formatter) {
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, $ebb0163f134ecb74$export$c6b49d6dceb604a1)(substring)) (0, $ebb0163f134ecb74$export$8073c1ae88f0e727)(substring, dirtyFormatStr, String(dirtyDate));
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, $ebb0163f134ecb74$export$c6cc36aa33304772)(substring)) (0, $ebb0163f134ecb74$export$8073c1ae88f0e727)(substring, dirtyFormatStr, String(dirtyDate));
            return formatter(utcDate, substring, locale.localize, formatterOptions);
        }
        if (firstCharacter.match($0ba290dbf11af23c$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
        return substring;
    }).join("");
    return result;
}
function $0ba290dbf11af23c$var$cleanEscapedString(input) {
    var matched = input.match($0ba290dbf11af23c$var$escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace($0ba290dbf11af23c$var$doubleQuoteRegExp, "'");
}


// This file is generated automatically by `scripts/build/indices.js`. Please, don't change it.





var $28502a47b806ccb7$exports = {};
"use strict";
var $4636164a6053c410$exports = {};
function $4636164a6053c410$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
$4636164a6053c410$exports = $4636164a6053c410$var$_interopRequireDefault, $4636164a6053c410$exports.__esModule = true, $4636164a6053c410$exports["default"] = $4636164a6053c410$exports;


var $28502a47b806ccb7$require$_interopRequireDefault = $4636164a6053c410$exports.default;
Object.defineProperty($28502a47b806ccb7$exports, "__esModule", {
    value: true
});
$28502a47b806ccb7$exports.default = $28502a47b806ccb7$var$cloneObject;

var $28502a47b806ccb7$var$_index = $28502a47b806ccb7$require$_interopRequireDefault((parcelRequire("eA5uq")));
function $28502a47b806ccb7$var$cloneObject(object) {
    return (0, $28502a47b806ccb7$var$_index.default)({}, object);
}
$28502a47b806ccb7$exports = $28502a47b806ccb7$exports.default;


var $fb0bc4794db28de4$exports = {};
"use strict";
Object.defineProperty($fb0bc4794db28de4$exports, "__esModule", {
    value: true
});
$fb0bc4794db28de4$exports.default = $fb0bc4794db28de4$var$toInteger;
function $fb0bc4794db28de4$var$toInteger(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
    var number = Number(dirtyNumber);
    if (isNaN(number)) return number;
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}
$fb0bc4794db28de4$exports = $fb0bc4794db28de4$exports.default;


var $cf2b81c630886dc0$exports = {};
"use strict";
Object.defineProperty($cf2b81c630886dc0$exports, "__esModule", {
    value: true
});
$cf2b81c630886dc0$exports.default = $cf2b81c630886dc0$var$getTimezoneOffsetInMilliseconds;
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $cf2b81c630886dc0$var$getTimezoneOffsetInMilliseconds(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}
$cf2b81c630886dc0$exports = $cf2b81c630886dc0$exports.default;


/**
 * Returns the [year, month, day, hour, minute, seconds] tokens of the provided
 * `date` as it will be rendered in the `timeZone`.
 */ function $2e96455b305c42cf$export$2e2bcd8739ae039(date, timeZone) {
    var dtf = $2e96455b305c42cf$var$getDateTimeFormat(timeZone);
    return dtf.formatToParts ? $2e96455b305c42cf$var$partsOffset(dtf, date) : $2e96455b305c42cf$var$hackyOffset(dtf, date);
}
var $2e96455b305c42cf$var$typeToPos = {
    year: 0,
    month: 1,
    day: 2,
    hour: 3,
    minute: 4,
    second: 5
};
function $2e96455b305c42cf$var$partsOffset(dtf, date) {
    try {
        var formatted = dtf.formatToParts(date);
        var filled = [];
        for(var i = 0; i < formatted.length; i++){
            var pos = $2e96455b305c42cf$var$typeToPos[formatted[i].type];
            if (pos >= 0) filled[pos] = parseInt(formatted[i].value, 10);
        }
        return filled;
    } catch (error) {
        if (error instanceof RangeError) return [
            NaN
        ];
        throw error;
    }
}
function $2e96455b305c42cf$var$hackyOffset(dtf, date) {
    var formatted = dtf.format(date);
    var parsed = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(formatted);
    // var [, fMonth, fDay, fYear, fHour, fMinute, fSecond] = parsed
    // return [fYear, fMonth, fDay, fHour, fMinute, fSecond]
    return [
        parsed[3],
        parsed[1],
        parsed[2],
        parsed[4],
        parsed[5],
        parsed[6]
    ];
}
// Get a cached Intl.DateTimeFormat instance for the IANA `timeZone`. This can be used
// to get deterministic local date/time output according to the `en-US` locale which
// can be used to extract local time parts as necessary.
var $2e96455b305c42cf$var$dtfCache = {};
function $2e96455b305c42cf$var$getDateTimeFormat(timeZone) {
    if (!$2e96455b305c42cf$var$dtfCache[timeZone]) {
        // New browsers use `hourCycle`, IE and Chrome <73 does not support it and uses `hour12`
        var testDateFormatted = new Intl.DateTimeFormat("en-US", {
            hourCycle: "h23",
            timeZone: "America/New_York",
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit"
        }).format(new Date("2014-06-25T04:00:00.123Z"));
        var hourCycleSupported = testDateFormatted === "06/25/2014, 00:00:00" || testDateFormatted === "\u200E06\u200E/\u200E25\u200E/\u200E2014\u200E \u200E00\u200E:\u200E00\u200E:\u200E00";
        $2e96455b305c42cf$var$dtfCache[timeZone] = hourCycleSupported ? new Intl.DateTimeFormat("en-US", {
            hourCycle: "h23",
            timeZone: timeZone,
            year: "numeric",
            month: "numeric",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit"
        }) : new Intl.DateTimeFormat("en-US", {
            hour12: false,
            timeZone: timeZone,
            year: "numeric",
            month: "numeric",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit"
        });
    }
    return $2e96455b305c42cf$var$dtfCache[timeZone];
}


/**
 * Use instead of `new Date(Date.UTC(...))` to support years below 100 which doesn't work
 * otherwise due to the nature of the
 * [`Date` constructor](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#interpretation_of_two-digit_years.
 *
 * For `Date.UTC(...)`, use `newDateUTC(...).getTime()`.
 */ function $8564ec259d205d0c$export$2e2bcd8739ae039(fullYear, month, day, hour, minute, second, millisecond) {
    var utcDate = new Date(0);
    utcDate.setUTCFullYear(fullYear, month, day);
    utcDate.setUTCHours(hour, minute, second, millisecond);
    return utcDate;
}


var $cd83bc75021a72ec$var$MILLISECONDS_IN_HOUR = 3600000;
var $cd83bc75021a72ec$var$MILLISECONDS_IN_MINUTE = 60000;
var $cd83bc75021a72ec$var$patterns = {
    timezone: /([Z+-].*)$/,
    timezoneZ: /^(Z)$/,
    timezoneHH: /^([+-]\d{2})$/,
    timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/
};
function $cd83bc75021a72ec$export$2e2bcd8739ae039(timezoneString, date, isUtcDate) {
    var token;
    var absoluteOffset;
    // Empty string
    if (!timezoneString) return 0;
    // Z
    token = $cd83bc75021a72ec$var$patterns.timezoneZ.exec(timezoneString);
    if (token) return 0;
    var hours;
    // ±hh
    token = $cd83bc75021a72ec$var$patterns.timezoneHH.exec(timezoneString);
    if (token) {
        hours = parseInt(token[1], 10);
        if (!$cd83bc75021a72ec$var$validateTimezone(hours)) return NaN;
        return -(hours * $cd83bc75021a72ec$var$MILLISECONDS_IN_HOUR);
    }
    // ±hh:mm or ±hhmm
    token = $cd83bc75021a72ec$var$patterns.timezoneHHMM.exec(timezoneString);
    if (token) {
        hours = parseInt(token[2], 10);
        var minutes = parseInt(token[3], 10);
        if (!$cd83bc75021a72ec$var$validateTimezone(hours, minutes)) return NaN;
        absoluteOffset = Math.abs(hours) * $cd83bc75021a72ec$var$MILLISECONDS_IN_HOUR + minutes * $cd83bc75021a72ec$var$MILLISECONDS_IN_MINUTE;
        return token[1] === "+" ? -absoluteOffset : absoluteOffset;
    }
    // IANA time zone
    if ($cd83bc75021a72ec$var$isValidTimezoneIANAString(timezoneString)) {
        date = new Date(date || Date.now());
        var utcDate = isUtcDate ? date : $cd83bc75021a72ec$var$toUtcDate(date);
        var offset = $cd83bc75021a72ec$var$calcOffset(utcDate, timezoneString);
        var fixedOffset = isUtcDate ? offset : $cd83bc75021a72ec$var$fixOffset(date, offset, timezoneString);
        return -fixedOffset;
    }
    return NaN;
}
function $cd83bc75021a72ec$var$toUtcDate(date) {
    return (0, $8564ec259d205d0c$export$2e2bcd8739ae039)(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
}
function $cd83bc75021a72ec$var$calcOffset(date, timezoneString) {
    var tokens = (0, $2e96455b305c42cf$export$2e2bcd8739ae039)(date, timezoneString);
    // ms dropped because it's not provided by tzTokenizeDate
    var asUTC = (0, $8564ec259d205d0c$export$2e2bcd8739ae039)(tokens[0], tokens[1] - 1, tokens[2], tokens[3] % 24, tokens[4], tokens[5], 0).getTime();
    var asTS = date.getTime();
    var over = asTS % 1000;
    asTS -= over >= 0 ? over : 1000 + over;
    return asUTC - asTS;
}
function $cd83bc75021a72ec$var$fixOffset(date, offset, timezoneString) {
    var localTS = date.getTime();
    // Our UTC time is just a guess because our offset is just a guess
    var utcGuess = localTS - offset;
    // Test whether the zone matches the offset for this ts
    var o2 = $cd83bc75021a72ec$var$calcOffset(new Date(utcGuess), timezoneString);
    // If so, offset didn't change, and we're done
    if (offset === o2) return offset;
    // If not, change the ts by the difference in the offset
    utcGuess -= o2 - offset;
    // If that gives us the local time we want, we're done
    var o3 = $cd83bc75021a72ec$var$calcOffset(new Date(utcGuess), timezoneString);
    if (o2 === o3) return o2;
    // If it's different, we're in a hole time. The offset has changed, but we don't adjust the time
    return Math.max(o2, o3);
}
function $cd83bc75021a72ec$var$validateTimezone(hours, minutes) {
    return -23 <= hours && hours <= 23 && (minutes == null || 0 <= minutes && minutes <= 59);
}
var $cd83bc75021a72ec$var$validIANATimezoneCache = {};
function $cd83bc75021a72ec$var$isValidTimezoneIANAString(timeZoneString) {
    if ($cd83bc75021a72ec$var$validIANATimezoneCache[timeZoneString]) return true;
    try {
        new Intl.DateTimeFormat(undefined, {
            timeZone: timeZoneString
        });
        $cd83bc75021a72ec$var$validIANATimezoneCache[timeZoneString] = true;
        return true;
    } catch (error) {
        return false;
    }
}


/** Regex to identify the presence of a time zone specifier in a date string */ var $06dfdb1811cd7e8b$var$tzPattern = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/;
var $06dfdb1811cd7e8b$export$2e2bcd8739ae039 = $06dfdb1811cd7e8b$var$tzPattern;


var $800e4b8c5ec0177b$var$MILLISECONDS_IN_HOUR = 3600000;
var $800e4b8c5ec0177b$var$MILLISECONDS_IN_MINUTE = 60000;
var $800e4b8c5ec0177b$var$DEFAULT_ADDITIONAL_DIGITS = 2;
var $800e4b8c5ec0177b$var$patterns = {
    dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
    datePattern: /^([0-9W+-]+)(.*)/,
    plainTime: /:/,
    // year tokens
    YY: /^(\d{2})$/,
    YYY: [
        /^([+-]\d{2})$/,
        /^([+-]\d{3})$/,
        /^([+-]\d{4})$/
    ],
    YYYY: /^(\d{4})/,
    YYYYY: [
        /^([+-]\d{4})/,
        /^([+-]\d{5})/,
        /^([+-]\d{6})/
    ],
    // date tokens
    MM: /^-(\d{2})$/,
    DDD: /^-?(\d{3})$/,
    MMDD: /^-?(\d{2})-?(\d{2})$/,
    Www: /^-?W(\d{2})$/,
    WwwD: /^-?W(\d{2})-?(\d{1})$/,
    HH: /^(\d{2}([.,]\d*)?)$/,
    HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
    HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
    // time zone tokens (to identify the presence of a tz)
    timeZone: (0, $06dfdb1811cd7e8b$export$2e2bcd8739ae039)
};
function $800e4b8c5ec0177b$export$2e2bcd8739ae039(argument, dirtyOptions) {
    if (arguments.length < 1) throw new TypeError("1 argument required, but only " + arguments.length + " present");
    if (argument === null) return new Date(NaN);
    var options = dirtyOptions || {};
    var additionalDigits = options.additionalDigits == null ? $800e4b8c5ec0177b$var$DEFAULT_ADDITIONAL_DIGITS : (0, (/*@__PURE__*/$parcel$interopDefault($fb0bc4794db28de4$exports)))(options.additionalDigits);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError("additionalDigits must be 0, 1 or 2");
    // Clone the date
    if (argument instanceof Date || typeof argument === "object" && Object.prototype.toString.call(argument) === "[object Date]") // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === "number" || Object.prototype.toString.call(argument) === "[object Number]") return new Date(argument);
    else if (!(typeof argument === "string" || Object.prototype.toString.call(argument) === "[object String]")) return new Date(NaN);
    var dateStrings = $800e4b8c5ec0177b$var$splitDateString(argument);
    var parseYearResult = $800e4b8c5ec0177b$var$parseYear(dateStrings.date, additionalDigits);
    var year = parseYearResult.year;
    var restDateString = parseYearResult.restDateString;
    var date = $800e4b8c5ec0177b$var$parseDate(restDateString, year);
    if (isNaN(date)) return new Date(NaN);
    if (date) {
        var timestamp = date.getTime();
        var time = 0;
        var offset;
        if (dateStrings.time) {
            time = $800e4b8c5ec0177b$var$parseTime(dateStrings.time);
            if (isNaN(time)) return new Date(NaN);
        }
        if (dateStrings.timeZone || options.timeZone) {
            offset = (0, $cd83bc75021a72ec$export$2e2bcd8739ae039)(dateStrings.timeZone || options.timeZone, new Date(timestamp + time));
            if (isNaN(offset)) return new Date(NaN);
        } else {
            // get offset accurate to hour in time zones that change offset
            offset = (0, (/*@__PURE__*/$parcel$interopDefault($cf2b81c630886dc0$exports)))(new Date(timestamp + time));
            offset = (0, (/*@__PURE__*/$parcel$interopDefault($cf2b81c630886dc0$exports)))(new Date(timestamp + time + offset));
        }
        return new Date(timestamp + time + offset);
    } else return new Date(NaN);
}
function $800e4b8c5ec0177b$var$splitDateString(dateString) {
    var dateStrings = {};
    var parts = $800e4b8c5ec0177b$var$patterns.dateTimePattern.exec(dateString);
    var timeString;
    if (!parts) {
        parts = $800e4b8c5ec0177b$var$patterns.datePattern.exec(dateString);
        if (parts) {
            dateStrings.date = parts[1];
            timeString = parts[2];
        } else {
            dateStrings.date = null;
            timeString = dateString;
        }
    } else {
        dateStrings.date = parts[1];
        timeString = parts[3];
    }
    if (timeString) {
        var token = $800e4b8c5ec0177b$var$patterns.timeZone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], "");
            dateStrings.timeZone = token[1].trim();
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $800e4b8c5ec0177b$var$parseYear(dateString, additionalDigits) {
    var patternYYY = $800e4b8c5ec0177b$var$patterns.YYY[additionalDigits];
    var patternYYYYY = $800e4b8c5ec0177b$var$patterns.YYYYY[additionalDigits];
    var token;
    // YYYY or ±YYYYY
    token = $800e4b8c5ec0177b$var$patterns.YYYY.exec(dateString) || patternYYYYY.exec(dateString);
    if (token) {
        var yearString = token[1];
        return {
            year: parseInt(yearString, 10),
            restDateString: dateString.slice(yearString.length)
        };
    }
    // YY or ±YYY
    token = $800e4b8c5ec0177b$var$patterns.YY.exec(dateString) || patternYYY.exec(dateString);
    if (token) {
        var centuryString = token[1];
        return {
            year: parseInt(centuryString, 10) * 100,
            restDateString: dateString.slice(centuryString.length)
        };
    }
    // Invalid ISO-formatted year
    return {
        year: null
    };
}
function $800e4b8c5ec0177b$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return null;
    var token;
    var date;
    var month;
    var week;
    // YYYY
    if (dateString.length === 0) {
        date = new Date(0);
        date.setUTCFullYear(year);
        return date;
    }
    // YYYY-MM
    token = $800e4b8c5ec0177b$var$patterns.MM.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        if (!$800e4b8c5ec0177b$var$validateDate(year, month)) return new Date(NaN);
        date.setUTCFullYear(year, month);
        return date;
    }
    // YYYY-DDD or YYYYDDD
    token = $800e4b8c5ec0177b$var$patterns.DDD.exec(dateString);
    if (token) {
        date = new Date(0);
        var dayOfYear = parseInt(token[1], 10);
        if (!$800e4b8c5ec0177b$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, 0, dayOfYear);
        return date;
    }
    // yyyy-MM-dd or YYYYMMDD
    token = $800e4b8c5ec0177b$var$patterns.MMDD.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        var day = parseInt(token[2], 10);
        if (!$800e4b8c5ec0177b$var$validateDate(year, month, day)) return new Date(NaN);
        date.setUTCFullYear(year, month, day);
        return date;
    }
    // YYYY-Www or YYYYWww
    token = $800e4b8c5ec0177b$var$patterns.Www.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        if (!$800e4b8c5ec0177b$var$validateWeekDate(year, week)) return new Date(NaN);
        return $800e4b8c5ec0177b$var$dayOfISOWeekYear(year, week);
    }
    // YYYY-Www-D or YYYYWwwD
    token = $800e4b8c5ec0177b$var$patterns.WwwD.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        var dayOfWeek = parseInt(token[2], 10) - 1;
        if (!$800e4b8c5ec0177b$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $800e4b8c5ec0177b$var$dayOfISOWeekYear(year, week, dayOfWeek);
    }
    // Invalid ISO-formatted date
    return null;
}
function $800e4b8c5ec0177b$var$parseTime(timeString) {
    var token;
    var hours;
    var minutes;
    // hh
    token = $800e4b8c5ec0177b$var$patterns.HH.exec(timeString);
    if (token) {
        hours = parseFloat(token[1].replace(",", "."));
        if (!$800e4b8c5ec0177b$var$validateTime(hours)) return NaN;
        return hours % 24 * $800e4b8c5ec0177b$var$MILLISECONDS_IN_HOUR;
    }
    // hh:mm or hhmm
    token = $800e4b8c5ec0177b$var$patterns.HHMM.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseFloat(token[2].replace(",", "."));
        if (!$800e4b8c5ec0177b$var$validateTime(hours, minutes)) return NaN;
        return hours % 24 * $800e4b8c5ec0177b$var$MILLISECONDS_IN_HOUR + minutes * $800e4b8c5ec0177b$var$MILLISECONDS_IN_MINUTE;
    }
    // hh:mm:ss or hhmmss
    token = $800e4b8c5ec0177b$var$patterns.HHMMSS.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseInt(token[2], 10);
        var seconds = parseFloat(token[3].replace(",", "."));
        if (!$800e4b8c5ec0177b$var$validateTime(hours, minutes, seconds)) return NaN;
        return hours % 24 * $800e4b8c5ec0177b$var$MILLISECONDS_IN_HOUR + minutes * $800e4b8c5ec0177b$var$MILLISECONDS_IN_MINUTE + seconds * 1000;
    }
    // Invalid ISO-formatted time
    return null;
}
function $800e4b8c5ec0177b$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    week = week || 0;
    day = day || 0;
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = week * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
var $800e4b8c5ec0177b$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $800e4b8c5ec0177b$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $800e4b8c5ec0177b$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $800e4b8c5ec0177b$var$validateDate(year, month, date) {
    if (month < 0 || month > 11) return false;
    if (date != null) {
        if (date < 1) return false;
        var isLeapYear = $800e4b8c5ec0177b$var$isLeapYearIndex(year);
        if (isLeapYear && date > $800e4b8c5ec0177b$var$DAYS_IN_MONTH_LEAP_YEAR[month]) return false;
        if (!isLeapYear && date > $800e4b8c5ec0177b$var$DAYS_IN_MONTH[month]) return false;
    }
    return true;
}
function $800e4b8c5ec0177b$var$validateDayOfYearDate(year, dayOfYear) {
    if (dayOfYear < 1) return false;
    var isLeapYear = $800e4b8c5ec0177b$var$isLeapYearIndex(year);
    if (isLeapYear && dayOfYear > 366) return false;
    if (!isLeapYear && dayOfYear > 365) return false;
    return true;
}
function $800e4b8c5ec0177b$var$validateWeekDate(year, week, day) {
    if (week < 0 || week > 52) return false;
    if (day != null && (day < 0 || day > 6)) return false;
    return true;
}
function $800e4b8c5ec0177b$var$validateTime(hours, minutes, seconds) {
    if (hours != null && (hours < 0 || hours >= 25)) return false;
    if (minutes != null && (minutes < 0 || minutes >= 60)) return false;
    if (seconds != null && (seconds < 0 || seconds >= 60)) return false;
    return true;
}





function $9416a431c6bf649d$export$2e2bcd8739ae039(date, timeZone, options) {
    if (typeof date === "string" && !date.match((0, $06dfdb1811cd7e8b$export$2e2bcd8739ae039))) {
        var extendedOptions = (0, (/*@__PURE__*/$parcel$interopDefault($28502a47b806ccb7$exports)))(options);
        extendedOptions.timeZone = timeZone;
        return (0, $800e4b8c5ec0177b$export$2e2bcd8739ae039)(date, extendedOptions);
    }
    var d = (0, $800e4b8c5ec0177b$export$2e2bcd8739ae039)(date, options);
    var utc = (0, $8564ec259d205d0c$export$2e2bcd8739ae039)(d.getFullYear(), d.getMonth(), d.getDate(), d.getHours(), d.getMinutes(), d.getSeconds(), d.getMilliseconds()).getTime();
    var offsetMilliseconds = (0, $cd83bc75021a72ec$export$2e2bcd8739ae039)(timeZone, new Date(utc));
    return new Date(utc + offsetMilliseconds);
}





var $jW8xq = parcelRequire("jW8xq");
var $7805783b35864c91$var$inputPrecoTotal = function() {
    return document.querySelector('[name="gross_amount"]');
};
var $7805783b35864c91$var$inputQuantidade = function() {
    return document.querySelector("#id_quantidade");
};
var $7805783b35864c91$var$urlNegociacaoAtivos = window.location.origin + "/api/negociacao_ativos/";
var $7805783b35864c91$var$urlMovimentacaoTesouro = window.location.origin + "/api/movimentacao_tesouro/";
var $7805783b35864c91$export$2e2bcd8739ae039 = {
    data: function() {
        var timeZone = "America/Sao_Paulo"; // Fuso horário do Brasil
        var currentDate = new Date();
        var zonedDate = (0, $9416a431c6bf649d$export$2e2bcd8739ae039)(currentDate, timeZone);
        var formattedDate = (0, $0ba290dbf11af23c$export$2e2bcd8739ae039)(zonedDate, "yyyy-MM-dd");
        return {
            situation: "",
            tipo_ativo: "",
            ativoSelecionado: "",
            errorMessage: "",
            showError: false,
            data_response: null,
            acaoModal: "adicionar",
            dadosAcao: null,
            endpointsArr: [
                "acoes",
                "fiis",
                "stocks",
                "reits",
                "tesouro_direto"
            ],
            endpoint: "",
            baseURL: window.location.origin,
            ["endpoint"]: "",
            modalValueIsValid: true,
            hasValueInSearch: false,
            erros: [],
            selectsHasFilled: false,
            inputIsInvalid: false,
            inputValues: {
                ticker_symbol: "",
                quantidade: "",
                data_compra: "",
                preco_total: "",
                corretagem: ""
            },
            btnSave: true,
            options: {
                reverse: true,
                onKeyPress: function onKeyPress(valor, e, field, options) {
                    var masks = [
                        "#.##0,00",
                        "###0,00"
                    ];
                    var mask = valor.length > 4 ? masks[1] : masks[0];
                    jQuery(".id_preco_total").mask(mask, options);
                }
            },
            nomeAtivo: "",
            ativoId: "",
            date: new Date().getDate(),
            optionsPadronizadas: [
                {
                    label: "A\xe7\xf5es",
                    value: "A\xe7\xf5es",
                    id: 1
                },
                {
                    label: "FIIs",
                    value: "FII - Fundo de Investimento Imobili\xe1rio",
                    id: 2
                },
                {
                    label: "Stocks",
                    value: "Stock",
                    id: 3
                },
                {
                    label: "REIT",
                    value: "REIT",
                    id: 4
                },
                {
                    label: "Renda fixa",
                    value: "TesouroDireto",
                    id: 5
                }
            ],
            isTesouroDiretoPadrao: false,
            optionsDinamicas: [],
            dataAtivo: null,
            isEditing: false,
            selectedOption: null,
            isDesktop: false,
            isLoading: false,
            origem: "",
            naoTemInformacoesDividendo: false
        };
    },
    mounted: function() {
        tippy("[data-tippy-content]", {
            // allowHTML: true,
            zIndex: 1000000,
            placement: "bottom-start",
            boundary: "HTMLElement"
        });
        if (localStorage.getItem("lastRoute") === "reserva-emergencia") {
            setTimeout(function() {
                document.querySelector('[data-xopen="modal-novo-ativo"]').click();
            }, 500);
            localStorage.setItem("lastRoute", null);
        }
    },
    computed: {
        minDate: function() {
            var currentDate = new Date();
            console.log(currentDate);
            var minYear = currentDate.getFullYear() - 5;
            var min = new Date(currentDate);
            // Se o dia atual for sábado (6) ou domingo (0), ajuste minDate para o próximo dia útil (segunda-feira)
            if (min.getDay() === 6) {
                console.log("SABADO");
                min.setDate(min.getDate() + 2);
            } else if (min.getDay() === 0) {
                console.log("DOMINGO");
                min.setDate(min.getDate() + 1);
            }
            // } else {
            // 	console.log('OUTRO DIA')
            // 	min = new Date(minYear, min.getMonth(), min.getDate());
            // }
            var isStockOrREIT = this.tipo_ativo === "Stock" || this.tipo_ativo === "REIT" || this.tipo_ativo && this.tipo_ativo.value === "Stock" || this.tipo_ativo && this.tipo_ativo.value === "REIT";
            // console.log(`${minYear}-${min.getMonth() + 1}-${min.getDate() + 1}`)				
            // if (isStockOrREIT) {
            // 	const dateCorrect = `${min.getDay()}/${min.getMonth() + 1}/${min.getFullYear()}`
            // 	return dateCorrect
            // }
            return "";
        },
        dataCompraFormatada: function() {
            return this.inputValues.data_compra ? (0, $0ba290dbf11af23c$export$2e2bcd8739ae039)(new Date(this.inputValues.data_compra), "dd/MM/yyyy") : "";
        }
    },
    methods: {
        applyMonetaryMask: function() {
            setTimeout(function() {
                $(".mask-money-fix").maskMoney({
                    thousands: ".",
                    decimal: ","
                });
            }, 500);
            setTimeout(function() {
                $(".mask-money-int").maskMoney({
                    thousands: ".",
                    decimal: ",",
                    precision: 6
                });
            }, 500);
        },
        disableDates: function(date) {
            var today = new Date();
            var dayOfWeek = date.getDay(); // obter o dia da semana da data
            return date > today || dayOfWeek === 0 || dayOfWeek === 6; // desabilitar datas maiores que hoje ou em fins de semana
        },
        changeSituation: function(valor, idSelectTipo, idSelectBusca) {
            this.id_choices_tipo = idSelectTipo;
            this.id_choices_busca = idSelectBusca;
            this.situation = valor;
            this.acaoModal = "adicionar";
            this.applyMonetaryMask();
        },
        format: function(date) {
            var day = date.getDate();
            var month = date.getMonth() + 1;
            var year = date.getFullYear();
            return "".concat(day, "/").concat(month, "/").concat(year);
        },
        dropdownShouldOpen: function(VueSelect) {
            if (this.optionsDinamicas.length) return VueSelect.open;
            return VueSelect.search.length !== 0 && VueSelect.open;
        },
        getDetalheAtivo: function(idAtivo, tipo) {
            return (0, $a1727a7253abe12d$export$7c398597f8905a1)(function() {
                var endpoint, base, url, data, _, err;
                return (0, $877235af7931ac6c$export$67ebef60e6f28a6)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            endpoint = tipo === "TesouroDireto" ? "titulos_tesouro" : "ativos_variaveis";
                            console.log(endpoint);
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                4,
                                ,
                                5
                            ]);
                            base = window.location.origin;
                            url = "".concat(base, "/api/").concat(endpoint, "/").concat(idAtivo, "/");
                            return [
                                4,
                                axios.get(url)
                            ];
                        case 2:
                            data = _state.sent().data;
                            _ = this;
                            return [
                                4,
                                data
                            ];
                        case 3:
                            _.dataAtivo = _state.sent();
                            return [
                                3,
                                5
                            ];
                        case 4:
                            err = _state.sent();
                            console.log(err);
                            return [
                                3,
                                5
                            ];
                        case 5:
                            return [
                                2
                            ];
                    }
                });
            }).apply(this);
        },
        changeSituationDesktop: function(valor, idSelectTipo, idSelectBusca, e) {
            return (0, $a1727a7253abe12d$export$7c398597f8905a1)(function() {
                var _e_currentTarget_getAttribute, ticker, isTesouroIPCAWithoutNumbers, id, tipoAtual;
                return (0, $877235af7931ac6c$export$67ebef60e6f28a6)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            ticker = (_e_currentTarget_getAttribute = e.currentTarget.getAttribute("data-ticker")) === null || _e_currentTarget_getAttribute === void 0 ? void 0 : _e_currentTarget_getAttribute.toLowerCase();
                            isTesouroIPCAWithoutNumbers = ticker === "Tesouro IPCA+".toLowerCase();
                            this.isTesouroDiretoPadrao = isTesouroIPCAWithoutNumbers;
                            id = e.target.closest(".item.adicionar-manualmente").getAttribute("id");
                            tipoAtual = e.target.closest(".item.adicionar-manualmente").getAttribute("data-type");
                            return [
                                4,
                                this.getDetalheAtivo(id, tipoAtual)
                            ];
                        case 1:
                            _state.sent();
                            this.origem = "tabela";
                            this.isDesktop = true;
                            this.id_choices_tipo = idSelectTipo;
                            this.id_choices_busca = idSelectBusca;
                            this.situation = valor;
                            this.tipo_ativo = this.optionsPadronizadas.find(function(param) {
                                var value = param.value;
                                return value == tipoAtual;
                            });
                            this.endpoint = this.endpointsArr[this.tipo_ativo == "TesouroDireto" ? 4 : this.optionsPadronizadas.find(function(param) {
                                var value = param.value;
                                return value == tipoAtual;
                            }).id - 1];
                            this.optionsDinamicas = isTesouroIPCAWithoutNumbers && this.situation === "aporte" ? [] : [
                                {
                                    value: this.dataAtivo.ticker_symbol,
                                    label: this.dataAtivo.ticker_symbol,
                                    id: this.dataAtivo.id
                                }
                            ];
                            console.log(isTesouroIPCAWithoutNumbers, this.situation, this.optionsDinamicas, "OP\xc7\xd5ES DINAMICAS");
                            this.inputValues.ticker_symbol = isTesouroIPCAWithoutNumbers && this.situation === "aporte" ? "" : {
                                value: this.dataAtivo.ticker_symbol,
                                label: this.dataAtivo.ticker_symbol,
                                id: this.dataAtivo.id
                            };
                            this.hasValueInSearch = true;
                            this.selectsHasFilled = true;
                            this.isEditing = true;
                            this.acaoModal = "adicionar";
                            if (tipoAtual == "TesouroDireto" && valor == "aporte") this.setRendaFixa(true);
                            this.compareValues();
                            this.applyMonetaryMask();
                            return [
                                2
                            ];
                    }
                });
            }).apply(this);
        },
        handleChange: function(value) {
            this.tipo_ativo = value.label === "Renda fixa" ? "TesouroDireto" : value.value;
            this.endpoint = this.endpointsArr[value.id - 1];
            this.hasValueInSearch = false;
            this.optionsDinamicas = [];
            this.inputValues.ticker_symbol = "";
            this.inputValues.quantidade = null;
            this.naoTemInformacoesDividendo = false;
            if (this.tipo_ativo === "TesouroDireto") this.setRendaFixa();
            else this.optionsDinamicas = [];
            this.applyMonetaryMask();
        },
        setRendaFixa: (0, $9Wwts.debounce)(/*#__PURE__*/ (0, $a1727a7253abe12d$export$7c398597f8905a1)(function() {
            var isLineRequest, data, _, response1, response2, _tmp, dadosRecebidos, response3, dadosNovaVenda, error;
            var _arguments = arguments;
            return (0, $877235af7931ac6c$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        isLineRequest = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            15,
                            16,
                            17
                        ]);
                        _ = this.situation;
                        switch(_){
                            case "ativo":
                                return [
                                    3,
                                    2
                                ];
                            case "aporte":
                                return [
                                    3,
                                    5
                                ];
                            case "nova_venda":
                                return [
                                    3,
                                    11
                                ];
                        }
                        return [
                            3,
                            14
                        ];
                    case 2:
                        return [
                            4,
                            fetch("".concat(this.baseURL, "/api/").concat(this.endpoint, "/"))
                        ];
                    case 3:
                        response1 = _state.sent();
                        return [
                            4,
                            response1.json()
                        ];
                    case 4:
                        data = _state.sent();
                        return [
                            3,
                            14
                        ];
                    case 5:
                        if (!isLineRequest) return [
                            3,
                            7
                        ];
                        return [
                            4,
                            fetch("".concat(this.baseURL, "/api/").concat(this.endpoint, "/?ticker_symbol=IPCA"))
                        ];
                    case 6:
                        _tmp = _state.sent();
                        return [
                            3,
                            9
                        ];
                    case 7:
                        return [
                            4,
                            fetch("".concat(this.baseURL, "/api/").concat(this.endpoint, "/"))
                        ];
                    case 8:
                        _tmp = _state.sent();
                        _state.label = 9;
                    case 9:
                        response2 = _tmp;
                        return [
                            4,
                            response2.json()
                        ];
                    case 10:
                        dadosRecebidos = _state.sent();
                        data = dadosRecebidos;
                        return [
                            3,
                            14
                        ];
                    case 11:
                        return [
                            4,
                            fetch("".concat(this.baseURL, "/api/titulos_tesouro/?update_value=0"))
                        ];
                    case 12:
                        response3 = _state.sent();
                        return [
                            4,
                            response3.json()
                        ];
                    case 13:
                        dadosNovaVenda = _state.sent();
                        data = dadosNovaVenda;
                        console.log(data);
                        return [
                            3,
                            14
                        ];
                    case 14:
                        this.optionsDinamicas = data.map(function(param) {
                            var ticker_symbol = param.ticker_symbol;
                            return {
                                value: ticker_symbol,
                                label: ticker_symbol
                            };
                        });
                        return [
                            3,
                            17
                        ];
                    case 15:
                        error = _state.sent();
                        GLOBAL.showToastify(error);
                        console.error(error);
                        return [
                            3,
                            17
                        ];
                    case 16:
                        this.isLoading = false;
                        return [
                            7
                        ];
                    case 17:
                        return [
                            2
                        ];
                }
            });
        }), 600),
        onSearch: function(search, loading) {
            if (search.length) {
                loading(true);
                this.getDataOnSearchSelect(loading, search, this);
            }
        },
        isAcaoOuFII: function(tipoAtivoValue) {
            return tipoAtivoValue === "A\xe7\xf5es" || tipoAtivoValue === "FII - Fundo de Investimento Imobili\xe1rio";
        },
        handleSearchSelect: function(opcaoSelecionada) {
            if (!opcaoSelecionada || !opcaoSelecionada.value) {
                this.hasValueInSearch = false;
                this.inputValues.ticker_symbol = "";
                return;
            }
            this.hasValueInSearch = true;
            this.selectsHasFilled = true;
            console.log(this.tipo_ativo, "TIPO ATIVO");
            console.log("opcaoSelecionada:", opcaoSelecionada, "origem:", this.origem);
            // Se vem de auto preenchimento (origem tabela) ou é objeto com id, manter como objeto
            // Caso contrário (digitado do zero), extrair apenas o value como string
            if (this.origem === "tabela" || typeof opcaoSelecionada === "object" && opcaoSelecionada.id !== undefined && opcaoSelecionada.id !== null) {
                // Auto preenchido - manter como objeto para usar ticker_symbol_obj no POST
                this.inputValues.ticker_symbol = opcaoSelecionada;
                console.log("Mantendo como objeto (auto preenchido):", this.inputValues.ticker_symbol);
            } else {
                // Digitado do zero - usar apenas o value como string
                this.inputValues.ticker_symbol = opcaoSelecionada.value;
                console.log("Usando como string (digitado do zero):", this.inputValues.ticker_symbol);
            }
            if (this.isAcaoOuFII(this.tipo_ativo.value)) this.naoTemInformacoesDividendo = !opcaoSelecionada.tem_info_dividendo;
            this.compareValues();
        },
        compareValues: function() {
            return (0, $a1727a7253abe12d$export$7c398597f8905a1)(function() {
                var isAutoPreenchido, tickerSymbolValue, tickerParam, url, response, data;
                return (0, $877235af7931ac6c$export$67ebef60e6f28a6)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            isAutoPreenchido = typeof this.inputValues.ticker_symbol === "object" && this.inputValues.ticker_symbol !== null;
                            tickerSymbolValue = isAutoPreenchido ? this.inputValues.ticker_symbol.value : this.inputValues.ticker_symbol;
                            tickerParam = isAutoPreenchido ? "ticker_symbol_obj" : "ticker_symbol";
                            url = this.tipo_ativo.value === "TesouroDireto" ? "".concat(this.baseURL, "/api/titulos_tesouro/?ticker_symbol=").concat(encodeURIComponent(tickerSymbolValue)) : "".concat(this.baseURL, "/api/ativos_variaveis/?tipo=").concat(this.tipo_ativo.value ? this.tipo_ativo.value : this.tipo_ativo, "&").concat(tickerParam, "=").concat(tickerSymbolValue);
                            return [
                                4,
                                fetch(url)
                            ];
                        case 1:
                            response = _state.sent();
                            return [
                                4,
                                response.json()
                            ];
                        case 2:
                            data = _state.sent();
                            if (!data) return [
                                2
                            ];
                            this.dadosAcao = data;
                            return [
                                2
                            ];
                    }
                });
            }).apply(this);
        },
        getDataOnSearchSelect: (0, $9Wwts.debounce)(function() {
            var _ref = (0, $a1727a7253abe12d$export$7c398597f8905a1)(function(loading, search, vm) {
                var data, _, response1, response2, dadosRecebidos, response4, dadosRecebidos1, response21, response3, dadosRecebidos2, response31, error;
                return (0, $877235af7931ac6c$export$67ebef60e6f28a6)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                20,
                                21,
                                22
                            ]);
                            _ = this.situation;
                            switch(_){
                                case "ativo":
                                    return [
                                        3,
                                        1
                                    ];
                                case "aporte":
                                    return [
                                        3,
                                        4
                                    ];
                                case "nova_venda":
                                    return [
                                        3,
                                        13
                                    ];
                            }
                            return [
                                3,
                                19
                            ];
                        case 1:
                            return [
                                4,
                                fetch("".concat(this.baseURL, "/api/").concat(this.endpoint, "/?ticker_symbol=").concat(search))
                            ];
                        case 2:
                            response1 = _state.sent();
                            return [
                                4,
                                response1.json()
                            ];
                        case 3:
                            data = _state.sent();
                            return [
                                3,
                                19
                            ];
                        case 4:
                            if (!(this.tipo_ativo.value == "TesouroDireto" && !this.isDesktop)) return [
                                3,
                                7
                            ];
                            return [
                                4,
                                fetch("".concat(this.baseURL, "/api/titulos_tesouro/?ticker_symbol=").concat(search))
                            ];
                        case 5:
                            response2 = _state.sent();
                            return [
                                4,
                                response2.json()
                            ];
                        case 6:
                            dadosRecebidos = _state.sent();
                            data = dadosRecebidos.filter(function(param) {
                                var ticker_symbol = param.ticker_symbol;
                                return ticker_symbol !== "Tesouro IPCA+";
                            });
                            return [
                                3,
                                19
                            ];
                        case 7:
                            if (!(this.tipo_ativo.value == "TesouroDireto" && this.isDesktop)) return [
                                3,
                                10
                            ];
                            return [
                                4,
                                fetch("".concat(this.baseURL, "/api/").concat(this.endpoint, "/?ticker_symbol=").concat(search))
                            ];
                        case 8:
                            response4 = _state.sent();
                            return [
                                4,
                                response4.json()
                            ];
                        case 9:
                            dadosRecebidos1 = _state.sent();
                            data = dadosRecebidos1.filter(function(param) {
                                var ticker_symbol = param.ticker_symbol;
                                return ticker_symbol !== "Tesouro IPCA+";
                            });
                            return [
                                3,
                                19
                            ];
                        case 10:
                            return [
                                4,
                                fetch("".concat(this.baseURL, "/api/ativos_variaveis/?tipo=").concat(this.tipo_ativo.value ? this.tipo_ativo.value : this.tipo_ativo, "&ticker_symbol=").concat(search))
                            ];
                        case 11:
                            response21 = _state.sent();
                            return [
                                4,
                                response21.json()
                            ];
                        case 12:
                            data = _state.sent();
                            return [
                                3,
                                19
                            ];
                        case 13:
                            if (!(this.tipo_ativo.value == "TesouroDireto")) return [
                                3,
                                16
                            ];
                            return [
                                4,
                                fetch("".concat(this.baseURL, "/api/titulos_tesouro/?update_value=0&ticker_symbol=").concat(search))
                            ];
                        case 14:
                            response3 = _state.sent();
                            return [
                                4,
                                response3.json()
                            ];
                        case 15:
                            dadosRecebidos2 = _state.sent();
                            data = dadosRecebidos2.filter(function(param) {
                                var ticker_symbol = param.ticker_symbol;
                                return ticker_symbol !== "Tesouro IPCA+";
                            });
                            console.log(data);
                            return [
                                3,
                                19
                            ];
                        case 16:
                            console.log("OBJ:", this.tipo_ativo);
                            return [
                                4,
                                fetch("".concat(this.baseURL, "/api/ativos_variaveis/?update_value=0&tipo=").concat(this.tipo_ativo.value ? this.tipo_ativo.value : this.tipo_ativo, "&ticker_symbol=").concat(search))
                            ];
                        case 17:
                            response31 = _state.sent();
                            return [
                                4,
                                response31.json()
                            ];
                        case 18:
                            data = _state.sent();
                            return [
                                3,
                                19
                            ];
                        case 19:
                            this.optionsDinamicas = data.map(function(param) {
                                var ticker_symbol = param.ticker_symbol, tem_info_dividendo = param.tem_info_dividendo, id = param.id;
                                return {
                                    value: ticker_symbol,
                                    label: ticker_symbol,
                                    tem_info_dividendo: tem_info_dividendo,
                                    id: id
                                };
                            });
                            loading(false);
                            this.isLoading = false;
                            return [
                                3,
                                22
                            ];
                        case 20:
                            error = _state.sent();
                            GLOBAL.showToastify(error);
                            console.error(error);
                            return [
                                3,
                                22
                            ];
                        case 21:
                            loading(false);
                            this.isLoading = false;
                            return [
                                7
                            ];
                        case 22:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(loading, search, vm) {
                return _ref.apply(this, arguments);
            };
        }(), 600),
        clearStates: function() {
            this.tipo_ativo = "";
            this.situation = "";
            this.hasValueInSearch = false;
            this.selectsHasFilled = false;
            this.modalValueIsValid = true;
            this.showError = false;
            this.errorMessage = "";
            this.inputValues = {
                ticker_symbol: "",
                quantidade: "",
                data_compra: "",
                preco_total: "",
                corretagem: ""
            }, this.isEditing = false, this.dataAtivo = null;
            this.isDesktop = false;
            this.isTesouroDiretoPadrao = false;
            this.origem = "";
        },
        preventMinusInsertOnInput: function(el) {
            if (el.getAttribute("id") !== "id_data_compra" && el.getAttribute("id") !== "id_preco_total" && el.getAttribute("id") !== "id_corretagem") el.value = Math.abs(el.value);
        },
        validateModalFields: function(event, typeField) {
            if (typeField === "preco_total") this.onInputPrecoTotal(event);
            else if (typeField === "quantidade") this.onInputQuantidade(event);
            console.log(event);
            var self = this;
            var isNullish = Object.entries(self.inputValues).some(function(param) {
                var _param = (0, $4f96i._)(param, 2), key = _param[0], value = _param[1];
                if (key == "corretagem") return;
                if (!value) return true;
                return false;
            });
            var formatValuesWithPoint = function(value) {
                if (value.includes(".")) {
                    var returnValue = value.replaceAll(".", "");
                    var returnValueLeng = returnValue.length;
                    return returnValue.slice(0, returnValueLeng - 2) + "." + returnValue.slice(returnValueLeng - 2, returnValueLeng);
                } else return value;
            };
            var verifyAndShowError = function() {
                var quantityValue = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, priceValue = arguments.length > 1 ? arguments[1] : void 0;
                var qtd = self.inputValues.quantidade.replace(",", ".");
                var price = formatValuesWithPoint(self.inputValues.preco_total);
                var quantity = parseFloat(quantityValue.toString().replace(",", "."));
                var isMajor = Number(qtd) > Number(quantity);
                if (isMajor) {
                    var valorFormatadoComVirgula = quantity.toLocaleString("pt-BR", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                    });
                    var valorFormatado = Number.isInteger(quantity) ? quantity : Math.floor(quantity);
                    var tipos = [
                        "A\xe7\xf5es",
                        "FII - Fundo de Investimento Imobili\xe1rio"
                    ];
                    self.showError = true;
                    self.errorMessage = "Quantidade n\xe3o pode ser maior que ".concat(tipos.includes(self.tipo_ativo.value) ? valorFormatado : valorFormatadoComVirgula);
                    self.btnSave = false;
                    return true;
                } else {
                    self.showError = false;
                    self.errorMessage = null;
                    self.btnSave = true;
                }
            };
            // O teto de quantidade ("não pode ser maior que X") só faz sentido na
            // venda: não se pode vender mais do que se possui. No aporte não há
            // teto, então a checagem não deve rodar — senão a posição atual do
            // ativo vaza como erro no modal de "Adicionar novo aporte".
            if (self.dadosAcao && self.situation === "nova_venda") {
                var dataMap;
                if (self.tipo_ativo == "TesouroDireto" || self.tipo_ativo.value == "TesouroDireto") dataMap = self.dadosAcao.some(function(param) {
                    var treasury_bonds_quantity = param.treasury_bonds_quantity, application_value = param.application_value;
                    return verifyAndShowError(treasury_bonds_quantity, application_value);
                });
                else dataMap = self.dadosAcao.some(function(param) {
                    var equities_quantity = param.equities_quantity, update_value = param.update_value;
                    return verifyAndShowError(equities_quantity, update_value);
                });
                console.log(dataMap, isNullish, "VALORES");
                dataMap || isNullish ? self.modalValueIsValid = false : self.modalValueIsValid = true;
            } else {
                // Aporte (ou nenhum ativo selecionado): limpa qualquer erro de teto
                // remanescente da venda ao alternar de modal.
                self.showError = false;
                self.errorMessage = null;
                isNullish ? self.modalValueIsValid = false : self.modalValueIsValid = true;
            }
        },
        onCloseModal: function() {
            this.clearStates();
        },
        onCancelModal: function() {
            document.querySelector(".close-modal").click();
            this.clearStates();
        },
        openDeleteModal: function(param) {
            var currentTarget = param.currentTarget;
            return (0, $a1727a7253abe12d$export$7c398597f8905a1)(function() {
                var tickerAttribute, tickerId, tipo;
                return (0, $877235af7931ac6c$export$67ebef60e6f28a6)(this, function(_state) {
                    tickerAttribute = currentTarget.getAttribute("data-ticker");
                    tickerId = currentTarget.getAttribute("data-ativo-id");
                    tipo = currentTarget.getAttribute("data-tipo");
                    this.nomeAtivo = tickerAttribute;
                    this.ativoId = tickerId;
                    this.tipo_ativo = tipo;
                    return [
                        2
                    ];
                });
            }).apply(this);
        },
        onDelete: function() {
            return (0, $a1727a7253abe12d$export$7c398597f8905a1)(function() {
                var formData, url, data, error;
                return (0, $877235af7931ac6c$export$67ebef60e6f28a6)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!this.ativoId || !this.tipo_ativo) return [
                                2
                            ];
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            formData = new FormData();
                            url = this.tipo_ativo == "TesouroDireto" ? "".concat(this.baseURL, "/deletar-titulo/").concat(this.ativoId) : "".concat(this.baseURL, "/deletar-ativo/").concat(this.ativoId);
                            formData.append("id", this.ativoId);
                            formData.append("tipo", this.tipo_ativo);
                            return [
                                4,
                                axios.post("".concat(url), formData)
                            ];
                        case 2:
                            data = _state.sent().data;
                            window.location.reload();
                            return [
                                3,
                                4
                            ];
                        case 3:
                            error = _state.sent();
                            console.error(error);
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            }).apply(this);
        },
        validateInput: function() {
            this.erros = [];
            if (!this.inputValues.quantidade) this.erros.push("Informe a quantidade!");
            if (parseFloat(this.changeToFloatApi(this.inputValues.quantidade)) === 0) this.erros.push("A quantidade deve ser maior que zero!");
            if (!this.inputValues.data_compra) {
                if (this.situation === "nova_venda") {
                    this.erros.push("Informe a data de venda!");
                    return;
                }
                this.erros.push("Informe a data de compra!");
            }
            if (!this.inputValues.preco_total) {
                if (this.situation === "nova_venda") {
                    this.erros.push("Informe o pre\xe7o de venda!");
                    return;
                }
                this.erros.push("Informe o pre\xe7o de compra!");
            }
            if (parseFloat(this.changeToFloatApi(this.inputValues.preco_total)) === 0) this.erros.push("O pre\xe7o total deve ser maior que zero!");
            if (!this.inputValues.ticker_symbol) this.erros.push("Informe o ativo!");
        },
        showToastifyOnErrorInputs: function() {
            if (this.erros.length) {
                this.modalValueIsValid = false;
                this.erros.forEach(function(i) {
                    GLOBAL.showToastify(i, "#DE4B4F");
                    return;
                });
            }
        },
        // Extrai a mensagem de erro retornada pela API (DRF). As validações do
        // backend chegam como { campo: ["mensagem"] } (ex.: título vencido em
        // ticker_symbol) ou { detail: "..." }; pega a primeira mensagem legível
        // para exibir no toast em vez de só logar no console.
        extrairMensagemErro: function(error) {
            var _error_response;
            var data = error === null || error === void 0 ? void 0 : (_error_response = error.response) === null || _error_response === void 0 ? void 0 : _error_response.data;
            if (!data) return "N\xe3o foi poss\xedvel concluir a opera\xe7\xe3o.";
            if (typeof data === "string") return data;
            if (data.detail) return data.detail;
            var primeiro = Object.values(data)[0];
            if (Array.isArray(primeiro)) return primeiro[0];
            if (typeof primeiro === "string") return primeiro;
            return "N\xe3o foi poss\xedvel concluir a opera\xe7\xe3o.";
        },
        formatDate: function(date) {
            var day = date.getDate();
            var month = date.getMonth() + 1;
            var year = date.getFullYear();
            console.log(day, month, year);
            return "".concat(day, "-").concat(month, "-").concat(year);
        },
        changeToFloatApi: function(valor) {
            if (!valor) return null;
            return valor.replaceAll(".", "").replace(",", ".");
        },
        formatDateMovimentacao: function(date) {
            return (0, $a1727a7253abe12d$export$7c398597f8905a1)(function() {
                return (0, $877235af7931ac6c$export$67ebef60e6f28a6)(this, function(_state) {
                    return [
                        2,
                        (0, $0ba290dbf11af23c$export$2e2bcd8739ae039)(new Date(date), "dd/MM/yyyy")
                    ];
                });
            })();
        },
        onSubmit: function(param, tipoSide) {
            var currentTarget = param.currentTarget;
            return (0, $a1727a7253abe12d$export$7c398597f8905a1)(function() {
                var _tmp, error;
                return (0, $877235af7931ac6c$export$67ebef60e6f28a6)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                6,
                                ,
                                7
                            ]);
                            this.erros = [];
                            // Limpa erro de API anterior a cada nova tentativa.
                            this.showError = false;
                            this.errorMessage = "";
                            this.validateInput();
                            this.showToastifyOnErrorInputs();
                            if (!(this.acaoModal == "adicionar" && !this.erros.length)) return [
                                3,
                                5
                            ];
                            if (!(this.tipo_ativo.value === "TesouroDireto")) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                this.postMovimentacaoTesouro(currentTarget, tipoSide)
                            ];
                        case 1:
                            _tmp = _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 2:
                            return [
                                4,
                                this.postNegociacaoAtivos(currentTarget, tipoSide)
                            ];
                        case 3:
                            _tmp = _state.sent();
                            _state.label = 4;
                        case 4:
                            _tmp;
                            _state.label = 5;
                        case 5:
                            return [
                                3,
                                7
                            ];
                        case 6:
                            error = _state.sent();
                            console.error(error);
                            return [
                                3,
                                7
                            ];
                        case 7:
                            return [
                                2
                            ];
                    }
                });
            }).apply(this);
        },
        postNegociacaoAtivos: function(currentTarget, tipoSide) {
            return (0, $a1727a7253abe12d$export$7c398597f8905a1)(function() {
                var _payloadNegociacaoAtivos_product_type_name, payloadNegociacaoAtivos, form, productType, error;
                return (0, $877235af7931ac6c$export$67ebef60e6f28a6)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            payloadNegociacaoAtivos = {
                                side: tipoSide,
                                reference_date: this.inputValues.data_compra,
                                trade_quantity: this.inputValues.quantidade,
                                gross_amount: this.inputValues.preco_total,
                                product_type_name: this.tipo_ativo.value
                            };
                            // ticker_symbol: "",
                            // quantidade: "",
                            // data_compra: "",
                            // preco_total: "",
                            // corretagem: "",
                            form = currentTarget.closest("form");
                            productType = document.createElement("input");
                            productType.type = "hidden";
                            productType.name = "product_type_name";
                            productType.value = this.tipo_ativo;
                            form.appendChild(productType);
                            this.isLoading = true;
                            // form.submit();
                            payloadNegociacaoAtivos.ticker_symbol = typeof this.inputValues.ticker_symbol === "object" && this.inputValues.ticker_symbol !== null ? this.inputValues.ticker_symbol.value : this.inputValues.ticker_symbol;
                            payloadNegociacaoAtivos.product_type_name = ((_payloadNegociacaoAtivos_product_type_name = payloadNegociacaoAtivos.product_type_name) === null || _payloadNegociacaoAtivos_product_type_name === void 0 ? void 0 : _payloadNegociacaoAtivos_product_type_name.value) || payloadNegociacaoAtivos.product_type_name;
                            payloadNegociacaoAtivos.reference_date = (0, $jW8xq.date).formatDate(payloadNegociacaoAtivos.reference_date, "YYYY-MM-DD");
                            payloadNegociacaoAtivos.trade_quantity = this.changeToFloatApi(payloadNegociacaoAtivos.trade_quantity);
                            payloadNegociacaoAtivos.gross_amount = this.changeToFloatApi(payloadNegociacaoAtivos.gross_amount);
                            return [
                                4,
                                axios.post($7805783b35864c91$var$urlNegociacaoAtivos, payloadNegociacaoAtivos)
                            ];
                        case 1:
                            _state.sent();
                            setTimeout(function() {
                                window.location.reload();
                            }, 1000);
                            return [
                                3,
                                3
                            ];
                        case 2:
                            error = _state.sent();
                            this.isLoading = false;
                            console.error(error);
                            // Exibe a mensagem do backend DENTRO do modal (o toast renderiza
                            // fora dele, atrás do blur, e não fica visível).
                            this.errorMessage = this.extrairMensagemErro(error);
                            this.showError = true;
                            this.modalValueIsValid = false;
                            return [
                                3,
                                3
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            }).apply(this);
        },
        postMovimentacaoTesouro: function(currentTarget, tipoSide) {
            return (0, $a1727a7253abe12d$export$7c398597f8905a1)(function() {
                var payloadMovimentacaoTesouro, form, productType, error;
                return (0, $877235af7931ac6c$export$67ebef60e6f28a6)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            payloadMovimentacaoTesouro = {
                                reference_date: this.inputValues.data_compra,
                                movement_type: tipoSide,
                                treasury_bonds_quantity: this.inputValues.quantidade,
                                operation_value: this.inputValues.preco_total
                            };
                            // ticker_symbol: "",
                            // quantidade: "",
                            // data_compra: "",
                            // preco_total: "",
                            // corretagem: "",
                            form = currentTarget.closest("form");
                            productType = document.createElement("input");
                            productType.type = "hidden";
                            productType.name = "product_type_name";
                            productType.value = this.tipo_ativo;
                            form.appendChild(productType);
                            this.isLoading = true;
                            // form.submit();
                            payloadMovimentacaoTesouro.ticker_symbol = typeof this.inputValues.ticker_symbol === "object" && this.inputValues.ticker_symbol !== null ? this.inputValues.ticker_symbol.value : this.inputValues.ticker_symbol;
                            payloadMovimentacaoTesouro.reference_date = (0, $jW8xq.date).formatDate(payloadMovimentacaoTesouro.reference_date, "YYYY-MM-DD");
                            payloadMovimentacaoTesouro.treasury_bonds_quantity = this.changeToFloatApi(payloadMovimentacaoTesouro.treasury_bonds_quantity);
                            payloadMovimentacaoTesouro.operation_value = this.changeToFloatApi(payloadMovimentacaoTesouro.operation_value);
                            return [
                                4,
                                axios.post($7805783b35864c91$var$urlMovimentacaoTesouro, payloadMovimentacaoTesouro)
                            ];
                        case 1:
                            _state.sent();
                            setTimeout(function() {
                                window.location.reload();
                            }, 2000);
                            return [
                                3,
                                3
                            ];
                        case 2:
                            error = _state.sent();
                            this.isLoading = false;
                            console.error(error);
                            // Exibe a mensagem do backend DENTRO do modal (o toast renderiza
                            // fora dele, atrás do blur, e não fica visível).
                            this.errorMessage = this.extrairMensagemErro(error);
                            this.showError = true;
                            this.modalValueIsValid = false;
                            return [
                                3,
                                3
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            }).apply(this);
        },
        removeItemOnList: function(event) {
            var currentTarget = event.currentTarget;
            currentTarget.closest(".item").remove();
        },
        // validateValueInputQuantity(event) {
        // 	const inputValue = event.target.value;
        // 	let numerosValidos = false;
        // 	const removerCaracteres = (string, regexValue) => string.replace(regexValue, '');
        // 	const tiposAConsiderar = ['Ações', 'FII - Fundo de Investimento Imobiliário']
        // 	if (tiposAConsiderar.includes(this.tipo_ativo)) {
        // 		numerosValidos = /^[0-9]+$/.test(inputValue)
        // 		if (!numerosValidos) {
        // 			event.target.value = removerCaracteres(inputValue, /[^0-9]/g)
        // 		}
        // 	} else {
        // 		numerosValidos = /^\d+(,\d{1,5})?$/.test(inputValue)
        // 		if (!numerosValidos) {
        // 			event.target.value = removerCaracteres(inputValue, /[^\d,]|(,\d{3,})|(,\d{1,2}\D)/g)
        // 		}
        // 	}
        // },
        validateValueInputQuantity: function(event) {
            var inputValue = event.target.value;
            var numerosValidos = false;
            var removerCaracteres = function(string, regexValue) {
                return string.replace(regexValue, "");
            };
            numerosValidos = /^[0-9]+$/.test(inputValue);
            if (!numerosValidos) {
                event.target.value = removerCaracteres(inputValue, /[^0-9]/g);
                this.onInputQuantidade(event);
            }
        },
        validateValueInputPrice: function(event) {
            var inputValue = event.target.value;
            var numerosValidos = /^\d+(,\d{1,2})?$/.test(inputValue);
            var removerCaracteres = function(string) {
                return string.replace(/[^\d,]|(,\d{3,})|(,\d{1,2}\D)/g, "");
            };
            if (!numerosValidos) event.target.value = removerCaracteres(inputValue);
        },
        onInputPrecoTotal: function(event) {
            $7805783b35864c91$var$inputPrecoTotal().value = event.target.value;
            // inputPrecoTotal().value = this.changeToFloatApi(event.target.value)
            this.inputValues.preco_total = event.target.value;
        },
        onInputQuantidade: function(event) {
            $7805783b35864c91$var$inputQuantidade().value = event.target.value;
            // inputQuantidade().value = this.changeToFloatApi(event.target.value)
            this.inputValues.quantidade = event.target.value;
        }
    },
    delimiters: [
        "{*",
        "*}"
    ]
};


var $2b120c6cbfc19a29$export$2e2bcd8739ae039 = {
    data: function() {
        return {
            baseURL: window.location.origin,
            quantidadeItens: 3,
            verMaisIsOpen: false,
            tipo_atual: "",
            tiposInvestimento: {
                acoes: [],
                fiis: [],
                stocks: [],
                reits: [],
                tesouroDireto: []
            }
        };
    },
    mounted: function() {
        var _this = this;
        axios.get("".concat(this.baseURL, "/api/ativos_variaveis/?onde_aportar=1")).then(function(param) {
            var data = param.data;
            _this.tiposInvestimento.acoes = data.filter(function(i) {
                return i.product_type_name === "A\xe7\xf5es";
            }).sort(function(param, param1) {
                var a = param.distancia_objetivo, b = param1.distancia_objetivo;
                return b - a;
            });
            _this.tiposInvestimento.fiis = data.filter(function(i) {
                return i.product_type_name === "FII - Fundo de Investimento Imobili\xe1rio";
            }).sort(function(param, param1) {
                var a = param.distancia_objetivo, b = param1.distancia_objetivo;
                return b - a;
            });
            _this.tiposInvestimento.stocks = data.filter(function(i) {
                return i.product_type_name === "Stock";
            }).sort(function(param, param1) {
                var a = param.distancia_objetivo, b = param1.distancia_objetivo;
                return b - a;
            });
            _this.tiposInvestimento.reits = data.filter(function(i) {
                return i.product_type_name === "REIT";
            }).sort(function(param, param1) {
                var a = param.distancia_objetivo, b = param1.distancia_objetivo;
                return b - a;
            });
        }).catch(function(error) {
            GLOBAL.showToastify(error);
            console.error(error);
        });
        axios.get("".concat(this.baseURL, "/api/titulos_tesouro/?onde_aportar=1")).then(function(param) {
            var data = param.data;
            _this.tiposInvestimento.tesouroDireto = data.filter(function(i) {
                return i.product_type_name === "TesouroDireto";
            }).sort(function(param, param1) {
                var a = param.distancia_objetivo, b = param1.distancia_objetivo;
                return b - a;
            });
        }).catch(function(error) {
            GLOBAL.showToastify(error);
            console.error(error);
        });
    },
    computed: {
        toggleVerMais: function() {
            return this.quantidadeItens == 3 ? "Ver mais" : "Ver menos";
        }
    },
    methods: {
        outsideClick: function(param) {
            var target = param.target;
            if (target.closest(".btn-vermais")) return;
            this.quantidadeItens = 3;
        },
        handleToggle: function(tipo) {
            var isThree = this.quantidadeItens == 3 ? this.quantidadeItens = this.tiposInvestimento[tipo].length : this.quantidadeItens = 3;
            console.log(isThree);
            return isThree;
        }
    },
    delimiters: [
        "{*",
        "*}"
    ]
};




var $8pZMQ = parcelRequire("8pZMQ");

var $4f96i = parcelRequire("4f96i");

var $79xu7 = parcelRequire("79xu7");


var $jW8xq = parcelRequire("jW8xq");
/**
 * Ponto unico de decisao do texto de reforco positivo exibido apos a
 * confirmacao de um aporte na tela "onde aportar".
 *
 * A regra de negocio da sequencia (quantos meses civis consecutivos tem
 * aporte, grace period de 1 mes, aporte retroativo que nao infla o mes
 * corrente) vive no backend, em global_functions/helpers/sequencia_aportes.py
 * — que ja devolve `titulo` e `mensagem` prontos em GET /api/sequencia_aportes/.
 * O front NAO recalcula a frase a partir de `meses_consecutivos`: duplicar a
 * escolha em dois lugares faria os textos divergirem com o tempo.
 *
 * Sobra para ca uma unica decisao: usar o texto do backend quando ele veio, ou
 * cair no texto generico quando a resposta falhou/veio incompleta. A tela de
 * reforco positivo nunca pode quebrar por causa disso — o aporte ja foi
 * registrado com sucesso quando esta mensagem aparece.
 */ var $487faab14d210c20$export$ebd5e95cef6baaca = "Aporte registrado";
var $487faab14d210c20$export$a9b6821183cb0018 = "Voc\xea est\xe1 um passo mais perto do plano que desenhou";
var $487faab14d210c20$var$textoUtil = function(valor) {
    return typeof valor === "string" && valor.trim() !== "" ? valor.trim() : null;
};
function $487faab14d210c20$export$811b69ae2788164c(dados) {
    var payload = dados && typeof dados === "object" ? dados : {};
    return {
        titulo: $487faab14d210c20$var$textoUtil(payload.titulo) || $487faab14d210c20$export$ebd5e95cef6baaca,
        mensagem: $487faab14d210c20$var$textoUtil(payload.mensagem) || $487faab14d210c20$export$a9b6821183cb0018
    };
}


var $c11af2dcb9353b30$var$urlNegociacaoAtivos = window.location.origin + "/api/negociacao_ativos/";
var $c11af2dcb9353b30$var$urlSequenciaAportes = window.location.origin + "/api/sequencia_aportes/";
/**
 * Flag de sessao que atravessa o window.location.reload() disparado apos o
 * POST do aporte. Sem ela a mensagem de reforco se perderia no recarregamento.
 * sessionStorage (e nao localStorage) porque o reforco pertence a sessao: nao
 * deve reaparecer em outra aba nem dias depois.
 */ var $c11af2dcb9353b30$var$CHAVE_APORTE_REGISTRADO = "aporteRegistrado";
var $c11af2dcb9353b30$var$urlMovimentacaoTesouro = window.location.origin + "/api/movimentacao_tesouro/";
var $c11af2dcb9353b30$var$urlOpcoesTesouroDireto = window.location.origin + "/api/tesouro_direto/?ticker_symbol=IPCA";
var $c11af2dcb9353b30$export$2e2bcd8739ae039 = {
    data: function() {
        return {
            baseURL: window.location.origin,
            objetivos_api: {},
            campos_objetivo: {
                pr_renda_fixa: "",
                pr_renda_variavel: "",
                pr_renda_variavel_eua: "",
                pr_renda_variavel_br: ""
            },
            objetivos: {
                acoes: [],
                fiis: [],
                stocks: [],
                reits: [],
                titulos: []
            },
            tipo_atual: "",
            product_type_name: "",
            step: {
                id: 1,
                tipo: ""
            },
            modalActive: "",
            nome_correto: "",
            loading: false,
            errorSteps: [],
            modal1: null,
            modalAviso: null,
            modalNovoAporte: null,
            modalSucessoAporte: null,
            aporteRecemRegistrado: false,
            sequenciaAporte: {
                titulo: "",
                mensagem: ""
            },
            status_campos: {
                no_has_renda_variavel: false,
                no_has_br: false,
                no_has_acoes: false,
                no_has_fiis: false,
                no_has_eua: false,
                no_has_reits: false,
                no_has_stocks: false
            },
            origin_click: "",
            quantidadeItens: 3,
            verMaisIsOpen: false,
            ["tipo_atual"]: "",
            tiposInvestimento: {
                acoes: [],
                fiis: [],
                stocks: [],
                reits: [],
                tesouroDireto: []
            },
            naoMostrarNovamente: false,
            disponivelAportar: "0,00",
            disponivelAportarTotal: "0,00",
            hasAtivosListLoaded: false,
            idOndeAportar: null,
            ativosList: [],
            qtAtivosOptions: [
                {
                    label: "1",
                    value: 1
                },
                {
                    label: "2",
                    value: 2
                },
                {
                    label: "3",
                    value: 3
                }
            ],
            qtAtivosAportar: {
                label: "1",
                value: 1
            },
            isLoading: false,
            formModalAtivo: {
                ticker_symbol: "",
                side: "Compra",
                reference_date: "",
                trade_quantity: "",
                gross_amount: "",
                product_type_name: ""
            },
            corretagem: "",
            tipoAtivoOptions: [
                {
                    label: "A\xe7\xf5es",
                    value: "A\xe7\xf5es",
                    id: 1
                },
                {
                    label: "FIIs",
                    value: "FII - Fundo de Investimento Imobili\xe1rio",
                    id: 2
                },
                {
                    label: "Stocks",
                    value: "Stock",
                    id: 3
                },
                {
                    label: "REIT",
                    value: "REIT",
                    id: 4
                },
                {
                    label: "Renda fixa",
                    value: "TesouroDireto",
                    id: 5
                }
            ],
            ativoOptions: [],
            hasValueInSearch: false,
            inputIsInvalid: false,
            selectsHasFilled: false
        };
    },
    mounted: function() {
        return (0, $a1727a7253abe12d$export$7c398597f8905a1)(function() {
            return (0, $877235af7931ac6c$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        // Consumido antes de tudo: setValuesOndeAportar() precisa saber que
                        // veio de um aporte para nao abrir o modal de explicacao por cima do
                        // modal de reforco.
                        this.aporteRecemRegistrado = this.consumirFlagAporteRegistrado();
                        return [
                            4,
                            this.setValuesOndeAportar()
                        ];
                    case 1:
                        _state.sent();
                        return [
                            4,
                            this.getAtivosOndeAportar()
                        ];
                    case 2:
                        _state.sent();
                        return [
                            4,
                            this.exibirSucessoAporte()
                        ];
                    case 3:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        }).apply(this);
    },
    computed: {
        toggleVerMais: function() {
            return this.quantidadeItens == 3 ? "Ver mais" : "Ver menos";
        },
        minDate: function() {
            var currentDate = new Date();
            var minYear = currentDate.getFullYear() - 5;
            var min = new Date(currentDate);
            // Se o dia atual for sábado (6) ou domingo (0), ajuste minDate para o próximo dia útil (segunda-feira)
            if (min.getDay() === 6) min.setDate(min.getDate() + 2);
            else if (min.getDay() === 0) min.setDate(min.getDate() + 1);
            // } else {
            // 	min = new Date(minYear, min.getMonth(), min.getDate());
            // }
            var isStockOrREIT = this.formModalAtivo.product_type_name === "Stock" || this.formModalAtivo.product_type_name === "REIT" || this.formModalAtivo.product_type_name && this.formModalAtivo.product_type_name.value === "Stock" || this.formModalAtivo.product_type_name && this.formModalAtivo.product_type_name.value === "REIT";
            // console.log(`${minYear}-${min.getMonth() + 1}-${min.getDate() + 1}`)
            // if (isStockOrREIT) {
            // 	const dateCorrect = `${min.getDay()}/${
            // 		min.getMonth() + 1
            // 	}/${min.getFullYear()}`;
            // 	return dateCorrect;
            // }
            return "";
        }
    },
    methods: {
        /** Normaliza resposta do GET /api/onde_aportar/ (array direto, paginado ou { data: [] }) */ normalizarListaOndeAportar: function(data) {
            if (!data) return [];
            if (Array.isArray(data)) return data;
            var _data_results, _ref;
            return (_ref = (_data_results = data.results) !== null && _data_results !== void 0 ? _data_results : data.data) !== null && _ref !== void 0 ? _ref : [];
        },
        changeToMonetarioBrl: function(valor) {
            if (!valor) return null;
            return valor.toLocaleString("pt-BR", {
                minimumFractionDigits: 2
            });
        },
        changeToFloatApi: function(valor) {
            if (!valor) return null;
            return valor.replaceAll(".", "").replace(",", ".");
        },
        setValuesOndeAportar: function() {
            return (0, $a1727a7253abe12d$export$7c398597f8905a1)(function() {
                var _this, cardItem;
                return (0, $877235af7931ac6c$export$67ebef60e6f28a6)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _this = this;
                            this.modal1 = ModalX(".modal-edicao-objetivo", {
                                deep: true,
                                zIndex: 300000,
                                zIndexDeep: 20000,
                                bgModal: "rgb(30,33,36)",
                                closeOnDeep: false
                            });
                            this.modalAviso = ModalX(".modal-aviso", {
                                deep: true,
                                zIndex: 300000,
                                zIndexDeep: 20000,
                                closeOnDeep: true,
                                bgModal: "rgb(30,33,36)"
                            }).init();
                            this.modalNovoAporte = ModalX(".modal-novo-ativo", {
                                deep: true,
                                zIndex: 300000,
                                zIndexDeep: 20000,
                                closeOnDeep: false,
                                bgModal: "rgb(30,33,36)"
                            }).init();
                            this.modalSucessoAporte = ModalX(".modal-sucesso-aporte", {
                                deep: true,
                                zIndex: 300000,
                                zIndexDeep: 20000,
                                closeOnDeep: true,
                                bgModal: "rgb(30,33,36)"
                            }).init();
                            this.naoMostrarNovamente = GLOBAL.getCookie("naoMostrarNovamente") == "true" ? true : false;
                            cardItem = document.querySelector(".step-".concat(this.step.id));
                            this.modalActive = this.modal1;
                            this.modalActive.init();
                            return [
                                4,
                                this.getDataFromObjective()
                            ];
                        case 1:
                            _state.sent();
                            return [
                                4,
                                this.getObjetivos()
                            ];
                        case 2:
                            _state.sent();
                            return [
                                4,
                                this.verifyIfReceivedValuesIsNull()
                            ];
                        case 3:
                            _state.sent();
                            // await this.persistErrorIfHasInvalidModal(modal1)
                            axios.get("".concat(this.baseURL, "/api/ativos_variaveis/?onde_aportar=1")).then(function(param) {
                                var data = param.data;
                                console.log(data, "data");
                                _this.tiposInvestimento.acoes = data.filter(function(i) {
                                    return i.product_type_name === "A\xe7\xf5es";
                                }).sort(function(param, param1) {
                                    var a = param.distancia_objetivo, b = param1.distancia_objetivo;
                                    return b - a;
                                });
                                _this.tiposInvestimento.fiis = data.filter(function(i) {
                                    return i.product_type_name === "FII - Fundo de Investimento Imobili\xe1rio";
                                }).sort(function(param, param1) {
                                    var a = param.distancia_objetivo, b = param1.distancia_objetivo;
                                    return b - a;
                                });
                                _this.tiposInvestimento.stocks = data.filter(function(i) {
                                    return i.product_type_name === "Stock";
                                }).sort(function(param, param1) {
                                    var a = param.distancia_objetivo, b = param1.distancia_objetivo;
                                    return b - a;
                                });
                                _this.tiposInvestimento.reits = data.filter(function(i) {
                                    return i.product_type_name === "REIT";
                                }).sort(function(param, param1) {
                                    var a = param.distancia_objetivo, b = param1.distancia_objetivo;
                                    return b - a;
                                });
                            }).catch(function(error) {
                                GLOBAL.showToastify(error);
                                console.error(error);
                            });
                            axios.get("".concat(this.baseURL, "/api/titulos_tesouro/?onde_aportar=1")).then(function(param) {
                                var data = param.data;
                                _this.tiposInvestimento.tesouroDireto = data.filter(function(i) {
                                    return i.product_type_name === "TesouroDireto";
                                }).sort(function(param, param1) {
                                    var a = param.distancia_objetivo, b = param1.distancia_objetivo;
                                    return b - a;
                                });
                            }).catch(function(error) {
                                GLOBAL.showToastify(error);
                                console.error(error);
                            });
                            // Logo apos um aporte o reforco positivo tem prioridade sobre a
                            // explicacao do metodo — os dois modais abertos se empilhariam.
                            if (this.naoMostrarNovamente || this.aporteRecemRegistrado) return [
                                2
                            ];
                            this.modalAviso.openModal(1);
                            console.log(GLOBAL);
                            return [
                                2
                            ];
                    }
                });
            }).apply(this);
        },
        setDisponivelAportar: function(ev, varName) {
            return (0, $a1727a7253abe12d$export$7c398597f8905a1)(function() {
                var _tmp;
                return (0, $877235af7931ac6c$export$67ebef60e6f28a6)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            this[varName] = ev.target.value;
                            if (!// Usar idOndeAportar (registro já existe no backend) para decidir PATCH vs POST
                            this.idOndeAportar) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                this.patchAtivosOndeAportar()
                            ];
                        case 1:
                            _tmp = _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 2:
                            return [
                                4,
                                this.postAtivosOndeAportar()
                            ];
                        case 3:
                            _tmp = _state.sent();
                            _state.label = 4;
                        case 4:
                            _tmp;
                            return [
                                2
                            ];
                    }
                });
            }).apply(this);
        },
        setQtAtivosAportar: function(ev, varName) {
            return (0, $a1727a7253abe12d$export$7c398597f8905a1)(function() {
                var _tmp;
                return (0, $877235af7931ac6c$export$67ebef60e6f28a6)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            this[varName] = ev;
                            if (!// Usar idOndeAportar (registro já existe no backend) para decidir PATCH vs POST
                            this.idOndeAportar) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                this.patchAtivosOndeAportar()
                            ];
                        case 1:
                            _tmp = _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 2:
                            return [
                                4,
                                this.postAtivosOndeAportar()
                            ];
                        case 3:
                            _tmp = _state.sent();
                            _state.label = 4;
                        case 4:
                            _tmp;
                            return [
                                2
                            ];
                    }
                });
            }).apply(this);
        },
        getAtivosOndeAportar: function() {
            return (0, $a1727a7253abe12d$export$7c398597f8905a1)(function() {
                var data, list, first, error;
                return (0, $877235af7931ac6c$export$67ebef60e6f28a6)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                axios.get("".concat(this.baseURL, "/api/onde_aportar/"))
                            ];
                        case 1:
                            data = _state.sent().data;
                            list = this.normalizarListaOndeAportar(data);
                            if (list.length > 0) {
                                first = list[0];
                                this.idOndeAportar = first.id;
                                this.disponivelAportar = this.returnMonetaryValue(parseFloat(first.valor));
                                this.qtAtivosAportar = this.qtAtivosOptions.filter(function(v) {
                                    return v.value === first.num_ativos;
                                })[0] || this.qtAtivosAportar;
                                if (first.indicacao) {
                                    this.ativosList = first.indicacao.indicacoes || [];
                                    this.disponivelAportarTotal = this.returnMonetaryValue(first.indicacao.valor_total);
                                } else this.ativosList = [];
                            }
                            this.hasAtivosListLoaded = true;
                            return [
                                3,
                                3
                            ];
                        case 2:
                            error = _state.sent();
                            console.log(error);
                            return [
                                3,
                                3
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            }).apply(this);
        },
        patchAtivosOndeAportar: function() {
            return (0, $a1727a7253abe12d$export$7c398597f8905a1)(function() {
                var disponivelAportarFloat, payloadPostAportar, data, error;
                return (0, $877235af7931ac6c$export$67ebef60e6f28a6)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            disponivelAportarFloat = parseFloat(this.changeToFloatApi(this.disponivelAportar));
                            // const { data } = await axios.get(`${this.baseURL}/api/objetivo/onde_aportar/?quantidade=${this.qtAtivosAportar.value}&valor=${disponivelAportarFloat}`)
                            payloadPostAportar = {
                                num_ativos: this.qtAtivosAportar.value,
                                valor: disponivelAportarFloat
                            };
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                4,
                                ,
                                5
                            ]);
                            return [
                                4,
                                axios.patch("".concat(this.baseURL, "/api/onde_aportar/").concat(this.idOndeAportar, "/"), payloadPostAportar)
                            ];
                        case 2:
                            data = _state.sent().data;
                            console.log(data);
                            return [
                                4,
                                this.getAtivosOndeAportar()
                            ];
                        case 3:
                            _state.sent();
                            return [
                                3,
                                5
                            ];
                        case 4:
                            error = _state.sent();
                            Object.entries(error.response.data).map(function(param) {
                                var _param = (0, $4f96i._)(param, 2), key = _param[0], value = _param[1];
                                GLOBAL.showToastify("".concat(key, ": ").concat(value), "#DE4B4F");
                                throw new Error("".concat(key, ": ").concat(value));
                            });
                            throw new Error(error.response.data);
                        case 5:
                            return [
                                2
                            ];
                    }
                });
            }).apply(this);
        },
        postAtivosOndeAportar: function() {
            return (0, $a1727a7253abe12d$export$7c398597f8905a1)(function() {
                var payloadPostAportar, _ref, listData, list, existingId, error, _error_response_data, _error_response, msg, jaPossuiRegistro, _ref1, listData1, list1, existingId1, e;
                return (0, $877235af7931ac6c$export$67ebef60e6f28a6)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            payloadPostAportar = {
                                num_ativos: this.qtAtivosAportar.value,
                                valor: parseFloat(this.changeToFloatApi(this.disponivelAportar))
                            };
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                7,
                                ,
                                14
                            ]);
                            return [
                                4,
                                axios.get("".concat(this.baseURL, "/api/onde_aportar/"))
                            ];
                        case 2:
                            _ref = _state.sent(), listData = _ref.data;
                            list = this.normalizarListaOndeAportar(listData);
                            existingId = list.length > 0 ? list[0].id : null;
                            if (!(existingId != null && existingId !== "")) return [
                                3,
                                4
                            ];
                            this.idOndeAportar = existingId;
                            return [
                                4,
                                this.patchAtivosOndeAportar()
                            ];
                        case 3:
                            _state.sent();
                            return [
                                2
                            ];
                        case 4:
                            return [
                                4,
                                axios.post("".concat(this.baseURL, "/api/onde_aportar/"), payloadPostAportar)
                            ];
                        case 5:
                            _state.sent();
                            return [
                                4,
                                this.getAtivosOndeAportar()
                            ];
                        case 6:
                            _state.sent();
                            return [
                                3,
                                14
                            ];
                        case 7:
                            error = _state.sent();
                            // Fallback: backend disse que já existe registro → buscar id e fazer PATCH
                            msg = (_error_response = error.response) === null || _error_response === void 0 ? void 0 : (_error_response_data = _error_response.data) === null || _error_response_data === void 0 ? void 0 : _error_response_data.objetivo;
                            jaPossuiRegistro = Array.isArray(msg) ? msg.some(function(m) {
                                return String(m).includes("j\xe1 possui um registro de onde aportar");
                            }) : String(msg || "").includes("j\xe1 possui um registro de onde aportar");
                            if (!jaPossuiRegistro) return [
                                3,
                                13
                            ];
                            _state.label = 8;
                        case 8:
                            _state.trys.push([
                                8,
                                12,
                                ,
                                13
                            ]);
                            return [
                                4,
                                axios.get("".concat(this.baseURL, "/api/onde_aportar/"))
                            ];
                        case 9:
                            _ref1 = _state.sent(), listData1 = _ref1.data;
                            list1 = this.normalizarListaOndeAportar(listData1);
                            existingId1 = list1.length > 0 ? list1[0].id : null;
                            if (!(existingId1 != null && existingId1 !== "")) return [
                                3,
                                11
                            ];
                            this.idOndeAportar = existingId1;
                            return [
                                4,
                                this.patchAtivosOndeAportar()
                            ];
                        case 10:
                            _state.sent();
                            return [
                                2
                            ];
                        case 11:
                            return [
                                3,
                                13
                            ];
                        case 12:
                            e = _state.sent();
                            console.log(e);
                            return [
                                3,
                                13
                            ];
                        case 13:
                            console.log(error);
                            return [
                                3,
                                14
                            ];
                        case 14:
                            return [
                                2
                            ];
                    }
                });
            }).apply(this);
        },
        returnMonetaryValue: function(value) {
            if (!value) return null;
            return GLOBAL.FormatREALVirgula(value);
        },
        setPatternInputValue: function(value) {
            return value == null || isNaN(value) ? 0 : Number(value);
        },
        getDataFromObjective: function() {
            return (0, $a1727a7253abe12d$export$7c398597f8905a1)(function() {
                var _this;
                return (0, $877235af7931ac6c$export$67ebef60e6f28a6)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _this = this;
                            this.loading = true;
                            return [
                                4,
                                axios.get("".concat(this.baseURL, "/api/objetivo/")).then(function(param) {
                                    var data = param.data;
                                    var _this_objetivos_api_, _this_objetivos_api_1, _this_objetivos_api_2, _this_objetivos_api_3, _this_objetivos_api_4, _this_objetivos_api_5, _this_objetivos_api_6, _this_objetivos_api_7;
                                    _this.objetivos_api = data;
                                    _this.campos_objetivo.pr_renda_fixa = Number(_this.setPatternInputValue((_this_objetivos_api_ = _this.objetivos_api[0]) === null || _this_objetivos_api_ === void 0 ? void 0 : _this_objetivos_api_.pr_renda_fixa));
                                    _this.campos_objetivo.pr_renda_variavel = Number(_this.setPatternInputValue((_this_objetivos_api_1 = _this.objetivos_api[0]) === null || _this_objetivos_api_1 === void 0 ? void 0 : _this_objetivos_api_1.pr_renda_variavel));
                                    _this.campos_objetivo.pr_renda_variavel_br = Number(_this.setPatternInputValue((_this_objetivos_api_2 = _this.objetivos_api[0]) === null || _this_objetivos_api_2 === void 0 ? void 0 : _this_objetivos_api_2.pr_renda_variavel_br).toFixed(2));
                                    _this.campos_objetivo.pr_renda_variavel_eua = Number(_this.setPatternInputValue((_this_objetivos_api_3 = _this.objetivos_api[0]) === null || _this_objetivos_api_3 === void 0 ? void 0 : _this_objetivos_api_3.pr_renda_variavel_eua).toFixed(2));
                                    _this.campos_objetivo.pr_acoes = Number(_this.setPatternInputValue((_this_objetivos_api_4 = _this.objetivos_api[0]) === null || _this_objetivos_api_4 === void 0 ? void 0 : _this_objetivos_api_4.pr_acoes).toFixed(2));
                                    _this.campos_objetivo.pr_fiis = Number(_this.setPatternInputValue((_this_objetivos_api_5 = _this.objetivos_api[0]) === null || _this_objetivos_api_5 === void 0 ? void 0 : _this_objetivos_api_5.pr_fiis).toFixed(2));
                                    _this.campos_objetivo.pr_stocks = Number(_this.setPatternInputValue((_this_objetivos_api_6 = _this.objetivos_api[0]) === null || _this_objetivos_api_6 === void 0 ? void 0 : _this_objetivos_api_6.pr_stocks).toFixed(2));
                                    _this.campos_objetivo.pr_reits = Number(_this.setPatternInputValue((_this_objetivos_api_7 = _this.objetivos_api[0]) === null || _this_objetivos_api_7 === void 0 ? void 0 : _this_objetivos_api_7.pr_reits).toFixed(2));
                                }).catch(function(error) {
                                    GLOBAL.showToastify(error, "#DE4B4F");
                                    console.error(error);
                                }).finally(function() {
                                    _this.loading = false;
                                })
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            }).apply(this);
        },
        /* Funções de controle dos steps do wizard*/ verifyStepAndSetThePatterns: function(current) {
            var tipo = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "default";
            if (this.step.id == current) {
                this.step.tipo = tipo;
                this.tipo_atual = tipo;
            }
        },
        defineTypeProduct: function(variable) {
            switch(variable){
                case "acoes":
                    this.product_type_name = "A\xe7\xf5es";
                    break;
                case "fiis":
                    this.product_type_name = "FII - Fundo de Investimento Imobili\xe1rio";
                    break;
                case "stocks":
                    this.product_type_name = "Stock";
                    break;
                case "reits":
                    this.product_type_name = "REIT";
                    break;
                case "titulos":
                    this.product_type_name = "TesouroDireto";
                    break;
            }
        },
        setOriginClick: function(tipo) {
            if (tipo == "eua") this.origin_click = "eua";
            else if (tipo == "br") this.origin_click = "br";
            else if (tipo == "stocks") this.origin_click = "stocks";
            else if (tipo == "reits") this.origin_click = "reits";
            else if (tipo == "acoes") this.origin_click = "acoes";
            else if (tipo == "fiis") this.origin_click = "fiis";
        },
        verifyIfReceivedValuesIsNull: function() {
            return (0, $a1727a7253abe12d$export$7c398597f8905a1)(function() {
                return (0, $877235af7931ac6c$export$67ebef60e6f28a6)(this, function(_state) {
                    if (this.campos_objetivo.pr_renda_variavel_br === 0) {
                        this.status_campos.no_has_acoes = true;
                        this.status_campos.no_has_fiis = true;
                    }
                    if (this.campos_objetivo.pr_renda_variavel_eua === 0) {
                        this.status_campos.no_has_reits = true;
                        this.status_campos.no_has_stocks = true;
                    }
                    if (this.campos_objetivo.pr_renda_variavel == 0) {
                        this.status_campos.no_has_eua = true;
                        this.status_campos.no_has_br = true;
                        this.status_campos.no_has_acoes = true;
                        this.status_campos.no_has_fiis = true;
                        this.status_campos.no_has_stocks = true;
                        this.status_campos.no_has_reits = true;
                    }
                    return [
                        2
                    ];
                });
            }).apply(this);
        },
        updateValueStep: function(id) {
            var tipo = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "vazio";
            this.isPercentFull = false;
            this.isValid = false;
            this.showError = false;
            this.modalValueIsValid = false;
            this.getDataFromObjective();
            this.setOriginClick(tipo);
            this.step = {
                id: id,
                tipo: tipo
            };
            if (tipo == "eua" || tipo == "br") return;
            this.defineTypeProduct(this.step.tipo);
            this.verifyStepAndSetThePatterns(id, tipo);
        },
        hasErrorOnInit: function() {
            var _this = this;
            Object.entries(this.objetivos).map(function(param) {
                var _param = (0, $4f96i._)(param, 2), key = _param[0], value = _param[1];
                var calculo = value.reduce(function(acc, i) {
                    return acc = acc + Number(i.porcentagem_desejada);
                }, 0);
                if (calculo < 100) {
                    _this.errorSteps.push({
                        [key]: value
                    });
                    _this.modal1.openModal(5, key);
                    _this.updateValueStep(5, key);
                    return value;
                }
                return;
            });
        },
        getObjetivos: function(tipo) {
            return (0, $a1727a7253abe12d$export$7c398597f8905a1)(function() {
                var _this, entries, dadosCall;
                return (0, $877235af7931ac6c$export$67ebef60e6f28a6)(this, function(_state) {
                    _this = this;
                    entries = Object.entries(this.objetivos).map(function(param) {
                        var _param = (0, $4f96i._)(param, 2), key = _param[0], value = _param[1];
                        return key;
                    });
                    dadosCall = entries.map(function(key) {
                        return axios.get("".concat(_this.baseURL, "/api/item_objetivo_").concat(key, "/"));
                    });
                    Promise.all(dadosCall).then(function(response) {
                        response.forEach(function(param, index) {
                            var data = param.data;
                            var objetivosAtuais = data;
                            var objetivoModificado = objetivosAtuais.map(function(i, idx) {
                                var _this_objetivos_api_;
                                var secoes_ativos = [
                                    "pr_acoes",
                                    "pr_fiis",
                                    "pr_stocks",
                                    "pr_reits",
                                    "pr_renda_fixa"
                                ];
                                var teste2 = (_this_objetivos_api_ = _this.objetivos_api[0]) === null || _this_objetivos_api_ === void 0 ? void 0 : _this_objetivos_api_.pr_acoes;
                                var teste3 = Number(i.porcentagem_desejada);
                                i.porcentagem_desejada = Number(i.porcentagem_desejada).toFixed(2);
                                return i;
                            });
                            _this.objetivos[entries[index]] = (0, $79xu7._)(objetivoModificado);
                        });
                    }).catch(function(error) {
                        GLOBAL.showToastify(error, "#DE4B4F");
                        console.error(error);
                    });
                    return [
                        2
                    ];
                });
            }).apply(this);
        },
        updateNome: function(nome) {
            this.nome_correto = nome;
        },
        openModalAction: function(value, tipo) {
            this.modalActive.openModal(value);
            if (this.step.id == 1 && this.tipo_atual == "titulos_inicio" && this.campos_objetivo.pr_renda_fixa) {
                this.updateValueStep(5, "titulos");
                this.nome_correto = "Tesouro direto";
                this.product_type_name = "TesouroDireto";
            }
        // else if (this.step.id == 4 && this.tipo_atual == 'eua') {
        //   this.updateValueStep(5, 'reits')
        // }
        // else if (this.step.id == 3 && this.tipo_atual == 'br') {
        //   this.updateValueStep(5, 'acoes')
        // }
        },
        outsideClick: function(param) {
            var target = param.target;
            if (target.closest(".btn-vermais")) return;
            this.quantidadeItens = 3;
        },
        handleToggle: function(tipo) {
            var isThree = this.quantidadeItens == 3 ? this.quantidadeItens = this.tiposInvestimento[tipo].length : this.quantidadeItens = 3;
            console.log(isThree);
            return isThree;
        },
        submitModalAviso: function() {
            if (this.naoMostrarNovamente) GLOBAL.setCookie("naoMostrarNovamente", true, 7);
            else GLOBAL.setCookie("naoMostrarNovamente", false, 7);
            this.modalAviso.closeModal();
        },
        //////////////////////////////////////////////////////////////////////////////////////////
        format: function(date) {
            var day = date.getDate();
            var month = date.getMonth() + 1;
            var year = date.getFullYear();
            return "".concat(day, "/").concat(month, "/").concat(year);
        },
        disableDates: function(date) {
            var today = new Date();
            var dayOfWeek = date.getDay(); // obter o dia da semana da data
            return date > today || dayOfWeek === 0 || dayOfWeek === 6; // desabilitar datas maiores que hoje ou em fins de semana
        },
        validateModalFields: function(param) {
            var target = param.target;
            var isNullish = Object.entries(this.formModalAtivo).some(function(param) {
                var _param = (0, $4f96i._)(param, 2), key = _param[0], value = _param[1];
                if (key == "corretagem") return;
                if (!value) return true;
                return false;
            });
            this.modalValueIsValid = Boolean(!isNullish);
        },
        openModalNovoAporte: function(selectedAtivo, id) {
            return (0, $a1727a7253abe12d$export$7c398597f8905a1)(function() {
                var _this, data, error;
                return (0, $877235af7931ac6c$export$67ebef60e6f28a6)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _this = this;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                5,
                                ,
                                6
                            ]);
                            this.formModalAtivo.product_type_name = this.tipoAtivoOptions.filter(function(v) {
                                return v.value === selectedAtivo.product_type_name;
                            })[0];
                            if (!(selectedAtivo.product_type_name !== "TesouroDireto")) return [
                                3,
                                2
                            ];
                            this.ativoOptions = [
                                {
                                    value: selectedAtivo.ticker_symbol,
                                    label: selectedAtivo.ticker_symbol,
                                    id: id
                                }
                            ];
                            this.formModalAtivo.ticker_symbol = {
                                value: selectedAtivo.ticker_symbol,
                                label: selectedAtivo.ticker_symbol,
                                id: id
                            };
                            return [
                                3,
                                4
                            ];
                        case 2:
                            return [
                                4,
                                axios.get($c11af2dcb9353b30$var$urlOpcoesTesouroDireto)
                            ];
                        case 3:
                            data = _state.sent().data;
                            this.ativoOptions = data.map(function(param) {
                                var ticker_symbol = param.ticker_symbol;
                                return {
                                    value: ticker_symbol,
                                    label: ticker_symbol
                                };
                            });
                            _state.label = 4;
                        case 4:
                            this.hasValueInSearch = true;
                            this.selectsHasFilled = true;
                            this.applyMonetaryMask();
                            setTimeout(function() {
                                _this.modalNovoAporte.openModal(2);
                            }, 500);
                            return [
                                3,
                                6
                            ];
                        case 5:
                            error = _state.sent();
                            GLOBAL.showToastify(error);
                            console.error(error);
                            return [
                                3,
                                6
                            ];
                        case 6:
                            return [
                                2
                            ];
                    }
                });
            }).apply(this);
        },
        validateValueInputPrice: function(event, payloadName) {
            this.formModalAtivo[payloadName] = event.target.value;
        },
        changeVirgulaToComma: function(value) {
            return value.replace(",", ".");
        },
        validateValueInputQuantity: function(event) {
            var inputValue = event.target.value;
            var numerosValidos = false;
            var removerCaracteres = function(string, regexValue) {
                return string.replace(regexValue, "");
            };
            numerosValidos = /^[0-9]+$/.test(inputValue);
            if (!numerosValidos) {
                event.target.value = removerCaracteres(inputValue, /[^0-9]/g);
                this.validateValueInputPrice(event, "trade_quantity");
            }
        },
        validateInput: function() {
            this.erros = [];
            if (!this.formModalAtivo.trade_quantity) this.erros.push("Informe a quantidade!");
            if (parseFloat(this.changeToFloatApi(this.formModalAtivo.trade_quantity)) === 0) this.erros.push("A quantidade deve ser maior que zero!");
            if (!this.formModalAtivo.reference_date) this.erros.push("Informe a data de compra!");
            if (!this.formModalAtivo.gross_amount) this.erros.push("Informe o pre\xe7o de venda!");
            if (parseFloat(this.changeToFloatApi(this.formModalAtivo.gross_amount)) === 0) this.erros.push("O pre\xe7o de venda deve ser maior que zero!");
            if (!this.formModalAtivo.ticker_symbol) this.erros.push("Informe o ativo!");
        },
        showToastifyOnErrorInputs: function() {
            if (this.erros.length) {
                this.modalValueIsValid = false;
                this.erros.forEach(function(i) {
                    GLOBAL.showToastify(i, "#DE4B4F");
                    return;
                });
            }
        },
        /**
		 * Marca que um aporte acabou de ser confirmado, para que a mensagem de
		 * reforco seja exibida do outro lado do reload. Storage indisponivel
		 * (aba anonima, cookies bloqueados) nao pode derrubar o fluxo: o aporte
		 * ja foi salvo, so a mensagem deixa de aparecer.
		 */ marcarAporteRegistrado: function() {
            try {
                window.sessionStorage.setItem($c11af2dcb9353b30$var$CHAVE_APORTE_REGISTRADO, "1");
            } catch (error) {
                console.error(error);
            }
        },
        /**
		 * Le e ja apaga a flag deixada antes do reload. Apagar na leitura e o
		 * que garante "uma mensagem por confirmacao": um reload manual da tela
		 * depois disso nao reabre o modal.
		 */ consumirFlagAporteRegistrado: function() {
            try {
                var registrado = window.sessionStorage.getItem($c11af2dcb9353b30$var$CHAVE_APORTE_REGISTRADO) === "1";
                if (registrado) window.sessionStorage.removeItem($c11af2dcb9353b30$var$CHAVE_APORTE_REGISTRADO);
                return registrado;
            } catch (error) {
                console.error(error);
                return false;
            }
        },
        exibirSucessoAporte: /**
		 * Exibe o modal de reforco positivo com a sequencia de meses
		 * consecutivos com aporte. So roda quando a tela veio de uma
		 * confirmacao de aporte.
		 */ function() {
            return (0, $a1727a7253abe12d$export$7c398597f8905a1)(function() {
                var dados, ref, error;
                return (0, $877235af7931ac6c$export$67ebef60e6f28a6)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!this.aporteRecemRegistrado) return [
                                2
                            ];
                            dados = null;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                axios.get($c11af2dcb9353b30$var$urlSequenciaAportes)
                            ];
                        case 2:
                            ref = _state.sent(), dados = ref.data, ref;
                            return [
                                3,
                                4
                            ];
                        case 3:
                            error = _state.sent();
                            // Sem a sequencia o modal ainda abre, com a frase generica.
                            console.error(error);
                            return [
                                3,
                                4
                            ];
                        case 4:
                            this.sequenciaAporte = (0, $487faab14d210c20$export$811b69ae2788164c)(dados);
                            this.modalSucessoAporte.openModal(3);
                            return [
                                2
                            ];
                    }
                });
            }).apply(this);
        },
        onSubmitModalNovoAporte: function(param) {
            var currentTarget = param.currentTarget;
            return (0, $a1727a7253abe12d$export$7c398597f8905a1)(function() {
                var _tmp;
                return (0, $877235af7931ac6c$export$67ebef60e6f28a6)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            this.erros = [];
                            this.validateInput();
                            this.showToastifyOnErrorInputs();
                            if (!!this.erros.length) return [
                                3,
                                5
                            ];
                            if (!(this.formModalAtivo.product_type_name.value === "TesouroDireto")) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                this.postMovimentacaoTesouro(currentTarget)
                            ];
                        case 1:
                            _tmp = _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 2:
                            return [
                                4,
                                this.postNegociacaoAtivos(currentTarget)
                            ];
                        case 3:
                            _tmp = _state.sent();
                            _state.label = 4;
                        case 4:
                            _tmp;
                            _state.label = 5;
                        case 5:
                            return [
                                2
                            ];
                    }
                });
            }).apply(this);
        },
        postNegociacaoAtivos: function(currentTarget) {
            return (0, $a1727a7253abe12d$export$7c398597f8905a1)(function() {
                var payloadNegociacaoAtivos, form, productType, error;
                return (0, $877235af7931ac6c$export$67ebef60e6f28a6)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            payloadNegociacaoAtivos = (0, $8pZMQ._)({}, this.formModalAtivo);
                            form = currentTarget.closest("form");
                            this.formModalAtivo.product_type_name = this.formModalAtivo.product_type_name.value || this.formModalAtivo.product_type_name;
                            productType = document.createElement("input");
                            productType.type = "hidden";
                            productType.name = "product_type_name";
                            productType.value = this.formModalAtivo.product_type_name;
                            form.appendChild(productType);
                            this.isLoading = true;
                            // form.submit();
                            payloadNegociacaoAtivos.ticker_symbol = typeof payloadNegociacaoAtivos.ticker_symbol === "object" && payloadNegociacaoAtivos.ticker_symbol !== null ? payloadNegociacaoAtivos.ticker_symbol.value : payloadNegociacaoAtivos.ticker_symbol;
                            payloadNegociacaoAtivos.product_type_name = payloadNegociacaoAtivos.product_type_name.value;
                            payloadNegociacaoAtivos.reference_date = (0, $jW8xq.date).formatDate(payloadNegociacaoAtivos.reference_date, "YYYY-MM-DD");
                            payloadNegociacaoAtivos.trade_quantity = this.changeToFloatApi(payloadNegociacaoAtivos.trade_quantity);
                            payloadNegociacaoAtivos.gross_amount = this.changeToFloatApi(payloadNegociacaoAtivos.gross_amount);
                            return [
                                4,
                                axios.post($c11af2dcb9353b30$var$urlNegociacaoAtivos, payloadNegociacaoAtivos)
                            ];
                        case 1:
                            _state.sent();
                            this.marcarAporteRegistrado();
                            setTimeout(function() {
                                window.location.reload();
                            }, 1000);
                            return [
                                3,
                                3
                            ];
                        case 2:
                            error = _state.sent();
                            console.error(error);
                            return [
                                3,
                                3
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            }).apply(this);
        },
        postMovimentacaoTesouro: function(currentTarget) {
            return (0, $a1727a7253abe12d$export$7c398597f8905a1)(function() {
                var payloadMovimentacaoTesouro, form, productType, error;
                return (0, $877235af7931ac6c$export$67ebef60e6f28a6)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            payloadMovimentacaoTesouro = {
                                reference_date: this.formModalAtivo.reference_date,
                                movement_type: "Compra",
                                treasury_bonds_quantity: this.formModalAtivo.trade_quantity,
                                operation_value: this.formModalAtivo.gross_amount
                            };
                            form = currentTarget.closest("form");
                            this.formModalAtivo.product_type_name = this.formModalAtivo.product_type_name.value || this.formModalAtivo.product_type_name;
                            productType = document.createElement("input");
                            productType.type = "hidden";
                            productType.name = "product_type_name";
                            productType.value = this.formModalAtivo.product_type_name;
                            form.appendChild(productType);
                            this.isLoading = true;
                            // form.submit();
                            payloadMovimentacaoTesouro.ticker_symbol = typeof this.formModalAtivo.ticker_symbol === "object" && this.formModalAtivo.ticker_symbol !== null ? this.formModalAtivo.ticker_symbol.value : this.formModalAtivo.ticker_symbol;
                            payloadMovimentacaoTesouro.reference_date = (0, $jW8xq.date).formatDate(payloadMovimentacaoTesouro.reference_date, "YYYY-MM-DD");
                            payloadMovimentacaoTesouro.treasury_bonds_quantity = this.changeToFloatApi(payloadMovimentacaoTesouro.treasury_bonds_quantity);
                            payloadMovimentacaoTesouro.operation_value = this.changeToFloatApi(payloadMovimentacaoTesouro.operation_value);
                            return [
                                4,
                                axios.post($c11af2dcb9353b30$var$urlMovimentacaoTesouro, payloadMovimentacaoTesouro)
                            ];
                        case 1:
                            _state.sent();
                            this.marcarAporteRegistrado();
                            setTimeout(function() {
                                window.location.reload();
                            }, 2000);
                            return [
                                3,
                                3
                            ];
                        case 2:
                            error = _state.sent();
                            console.error(error);
                            return [
                                3,
                                3
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            }).apply(this);
        },
        onCloseModal: function() {
            this.clearStates();
        },
        onCancelModal: function() {
            document.querySelector(".close-modal-btn").click();
            this.clearStates();
        },
        clearStates: function() {
            this.hasValueInSearch = false;
            this.selectsHasFilled = false;
            this.modalValueIsValid = true;
            this.showError = false;
            this.errorMessage = "";
            this.formModalAtivo = {
                ticker_symbol: "",
                side: "Compra",
                reference_date: "",
                trade_quantity: "",
                gross_amount: "",
                product_type_name: ""
            };
        },
        applyMonetaryMask: function() {
            setTimeout(function() {
                $(".mask-money-fix").maskMoney({
                    thousands: ".",
                    decimal: ","
                });
            }, 500);
            setTimeout(function() {
                $(".mask-money-int").maskMoney({
                    thousands: ".",
                    decimal: ",",
                    precision: 5
                });
            }, 500);
        }
    },
    delimiters: [
        "{*",
        "*}"
    ]
};




var $4f96i = parcelRequire("4f96i");

var $79xu7 = parcelRequire("79xu7");

var $ee2bdca954332a18$export$2e2bcd8739ae039 = {
    data: function() {
        return {
            baseURL: window.location.origin,
            objetivos_api: {},
            campos_objetivo: {
                pr_renda_fixa: "",
                pr_renda_variavel: "",
                pr_renda_variavel_eua: "",
                pr_renda_variavel_br: ""
            },
            objetivos: {
                acoes: [],
                fiis: [],
                stocks: [],
                reits: [],
                titulos: []
            },
            tipo_atual: "",
            product_type_name: "",
            step: {
                id: 1,
                tipo: ""
            },
            modalActive: "",
            nome_correto: "",
            loading: false,
            errorSteps: [],
            modal1: null,
            status_campos: {
                no_has_renda_variavel: false,
                no_has_br: false,
                no_has_acoes: false,
                no_has_fiis: false,
                no_has_eua: false,
                no_has_reits: false,
                no_has_stocks: false
            },
            origin_click: "",
            quantidadeItens: 3,
            verMaisIsOpen: false,
            ["tipo_atual"]: "",
            tiposInvestimento: {
                acoes: [],
                fiis: [],
                stocks: [],
                reits: [],
                tesouroDireto: []
            },
            naoMostrarNovamente: false,
            incorretos: []
        };
    },
    mounted: function() {
        return (0, $a1727a7253abe12d$export$7c398597f8905a1)(function() {
            var _this, cardItem;
            return (0, $877235af7931ac6c$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _this = this;
                        this.modal1 = ModalX(".modal-edicao-objetivo", {
                            deep: true,
                            zIndex: 300000,
                            zIndexDeep: 20000,
                            bgModal: "rgb(30,33,36)",
                            closeOnDeep: false
                        });
                        this.naoMostrarNovamente = GLOBAL.getCookie("naoMostrarNovamente") == "true" ? true : false;
                        cardItem = document.querySelector(".step-".concat(this.step.id));
                        this.modalActive = this.modal1;
                        this.modalActive.init();
                        return [
                            4,
                            this.getDataFromObjective()
                        ];
                    case 1:
                        _state.sent();
                        return [
                            4,
                            this.getObjetivos()
                        ];
                    case 2:
                        _state.sent();
                        return [
                            4,
                            this.verifyIfReceivedValuesIsNull()
                        ];
                    case 3:
                        _state.sent();
                        // await this.persistErrorIfHasInvalidModal(modal1)
                        return [
                            4,
                            axios.get("".concat(this.baseURL, "/api/ativos_variaveis/?onde_aportar=1")).then(function(param) {
                                var data = param.data;
                                console.log(data);
                                _this.tiposInvestimento.acoes = data.filter(function(i) {
                                    return i.product_type_name === "A\xe7\xf5es";
                                }).sort(function(param, param1) {
                                    var a = param.distancia_objetivo, b = param1.distancia_objetivo;
                                    return b - a;
                                });
                                _this.tiposInvestimento.fiis = data.filter(function(i) {
                                    return i.product_type_name === "FII - Fundo de Investimento Imobili\xe1rio";
                                }).sort(function(param, param1) {
                                    var a = param.distancia_objetivo, b = param1.distancia_objetivo;
                                    return b - a;
                                });
                                _this.tiposInvestimento.stocks = data.filter(function(i) {
                                    return i.product_type_name === "Stock";
                                }).sort(function(param, param1) {
                                    var a = param.distancia_objetivo, b = param1.distancia_objetivo;
                                    return b - a;
                                });
                                _this.tiposInvestimento.reits = data.filter(function(i) {
                                    return i.product_type_name === "REIT";
                                }).sort(function(param, param1) {
                                    var a = param.distancia_objetivo, b = param1.distancia_objetivo;
                                    return b - a;
                                });
                            }).catch(function(error) {
                                GLOBAL.showToastify(error);
                                console.error(error);
                            })
                        ];
                    case 4:
                        _state.sent();
                        return [
                            4,
                            axios.get("".concat(this.baseURL, "/api/titulos_tesouro/?onde_aportar=1")).then(function(param) {
                                var data = param.data;
                                _this.tiposInvestimento.tesouroDireto = data.filter(function(i) {
                                    return i.product_type_name === "TesouroDireto";
                                }).sort(function(param, param1) {
                                    var a = param.distancia_objetivo, b = param1.distancia_objetivo;
                                    return b - a;
                                });
                            }).catch(function(error) {
                                GLOBAL.showToastify(error);
                                console.error(error);
                            })
                        ];
                    case 5:
                        _state.sent();
                        return [
                            4,
                            this.getObjetivosIncorretos()
                        ];
                    case 6:
                        _state.sent();
                        if (this.naoMostrarNovamente) return [
                            2
                        ];
                        return [
                            2
                        ];
                }
            });
        }).apply(this);
    },
    computed: {
        toggleVerMais: function() {
            return this.quantidadeItens == 3 ? "Ver mais" : "Ver menos";
        }
    },
    methods: {
        setPatternInputValue: function(value) {
            return value == null || isNaN(value) ? 0 : Number(value);
        },
        getDataFromObjective: function() {
            return (0, $a1727a7253abe12d$export$7c398597f8905a1)(function() {
                var _this;
                return (0, $877235af7931ac6c$export$67ebef60e6f28a6)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _this = this;
                            this.loading = true;
                            return [
                                4,
                                axios.get("".concat(this.baseURL, "/api/objetivo/")).then(function(param) {
                                    var data = param.data;
                                    var _this_objetivos_api_, _this_objetivos_api_1, _this_objetivos_api_2, _this_objetivos_api_3, _this_objetivos_api_4, _this_objetivos_api_5, _this_objetivos_api_6, _this_objetivos_api_7;
                                    _this.objetivos_api = data;
                                    _this.campos_objetivo.pr_renda_fixa = Number(_this.setPatternInputValue((_this_objetivos_api_ = _this.objetivos_api[0]) === null || _this_objetivos_api_ === void 0 ? void 0 : _this_objetivos_api_.pr_renda_fixa));
                                    _this.campos_objetivo.pr_renda_variavel = Number(_this.setPatternInputValue((_this_objetivos_api_1 = _this.objetivos_api[0]) === null || _this_objetivos_api_1 === void 0 ? void 0 : _this_objetivos_api_1.pr_renda_variavel));
                                    _this.campos_objetivo.pr_renda_variavel_br = Number(_this.setPatternInputValue((_this_objetivos_api_2 = _this.objetivos_api[0]) === null || _this_objetivos_api_2 === void 0 ? void 0 : _this_objetivos_api_2.pr_renda_variavel_br).toFixed(2));
                                    _this.campos_objetivo.pr_renda_variavel_eua = Number(_this.setPatternInputValue((_this_objetivos_api_3 = _this.objetivos_api[0]) === null || _this_objetivos_api_3 === void 0 ? void 0 : _this_objetivos_api_3.pr_renda_variavel_eua).toFixed(2));
                                    _this.campos_objetivo.pr_acoes = Number(_this.setPatternInputValue((_this_objetivos_api_4 = _this.objetivos_api[0]) === null || _this_objetivos_api_4 === void 0 ? void 0 : _this_objetivos_api_4.pr_acoes).toFixed(2));
                                    _this.campos_objetivo.pr_fiis = Number(_this.setPatternInputValue((_this_objetivos_api_5 = _this.objetivos_api[0]) === null || _this_objetivos_api_5 === void 0 ? void 0 : _this_objetivos_api_5.pr_fiis).toFixed(2));
                                    _this.campos_objetivo.pr_stocks = Number(_this.setPatternInputValue((_this_objetivos_api_6 = _this.objetivos_api[0]) === null || _this_objetivos_api_6 === void 0 ? void 0 : _this_objetivos_api_6.pr_stocks).toFixed(2));
                                    _this.campos_objetivo.pr_reits = Number(_this.setPatternInputValue((_this_objetivos_api_7 = _this.objetivos_api[0]) === null || _this_objetivos_api_7 === void 0 ? void 0 : _this_objetivos_api_7.pr_reits).toFixed(2));
                                }).catch(function(error) {
                                    GLOBAL.showToastify(error, "#DE4B4F");
                                    console.error(error);
                                }).finally(function() {
                                    _this.loading = false;
                                })
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            }).apply(this);
        },
        /* Funções de controle dos steps do wizard*/ verifyStepAndSetThePatterns: function(current) {
            var tipo = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "default";
            if (this.step.id == current) {
                this.step.tipo = tipo;
                this.tipo_atual = tipo;
            }
        },
        defineTypeProduct: function(variable) {
            switch(variable){
                case "acoes":
                    this.product_type_name = "A\xe7\xf5es";
                    break;
                case "fiis":
                    this.product_type_name = "FII - Fundo de Investimento Imobili\xe1rio";
                    break;
                case "stocks":
                    this.product_type_name = "Stock";
                    break;
                case "reits":
                    this.product_type_name = "REIT";
                    break;
                case "titulos":
                    this.product_type_name = "TesouroDireto";
                    break;
            }
        },
        setOriginClick: function(tipo) {
            if (tipo == "eua") this.origin_click = "eua";
            else if (tipo == "br") this.origin_click = "br";
            else if (tipo == "stocks") this.origin_click = "stocks";
            else if (tipo == "reits") this.origin_click = "reits";
            else if (tipo == "acoes") this.origin_click = "acoes";
            else if (tipo == "fiis") this.origin_click = "fiis";
        },
        verifyIfReceivedValuesIsNull: function() {
            return (0, $a1727a7253abe12d$export$7c398597f8905a1)(function() {
                return (0, $877235af7931ac6c$export$67ebef60e6f28a6)(this, function(_state) {
                    if (this.campos_objetivo.pr_renda_variavel_br === 0) {
                        this.status_campos.no_has_acoes = true;
                        this.status_campos.no_has_fiis = true;
                    }
                    if (this.campos_objetivo.pr_renda_variavel_eua === 0) {
                        this.status_campos.no_has_reits = true;
                        this.status_campos.no_has_stocks = true;
                    }
                    if (this.campos_objetivo.pr_renda_variavel == 0) {
                        this.status_campos.no_has_eua = true;
                        this.status_campos.no_has_br = true;
                        this.status_campos.no_has_acoes = true;
                        this.status_campos.no_has_fiis = true;
                        this.status_campos.no_has_stocks = true;
                        this.status_campos.no_has_reits = true;
                    }
                    return [
                        2
                    ];
                });
            }).apply(this);
        },
        updateValueStep: function(id) {
            var tipo = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "vazio";
            console.log(tipo);
            this.isPercentFull = false;
            this.isValid = false;
            this.showError = false;
            this.modalValueIsValid = false;
            this.setOriginClick(tipo);
            this.step = {
                id: id,
                tipo: tipo
            };
            if (tipo == "eua" || tipo == "br") return;
            this.defineTypeProduct(this.step.tipo);
            this.verifyStepAndSetThePatterns(id, tipo);
        },
        hasErrorOnInit: function() {
            var _this = this;
            Object.entries(this.objetivos).map(function(param) {
                var _param = (0, $4f96i._)(param, 2), key = _param[0], value = _param[1];
                var calculo = value.reduce(function(acc, i) {
                    return acc = acc + Number(i.porcentagem_desejada);
                }, 0);
                if (calculo < 100) {
                    _this.errorSteps.push({
                        [key]: value
                    });
                    _this.modal1.openModal(5, key);
                    _this.updateValueStep(5, key);
                    return value;
                }
                return;
            });
        },
        getObjetivos: function(tipo) {
            return (0, $a1727a7253abe12d$export$7c398597f8905a1)(function() {
                var _this, entries, dadosCall;
                return (0, $877235af7931ac6c$export$67ebef60e6f28a6)(this, function(_state) {
                    _this = this;
                    entries = Object.entries(this.objetivos).map(function(param) {
                        var _param = (0, $4f96i._)(param, 2), key = _param[0], value = _param[1];
                        return key;
                    });
                    dadosCall = entries.map(function(key) {
                        return axios.get("".concat(_this.baseURL, "/api/item_objetivo_").concat(key, "/"));
                    });
                    Promise.all(dadosCall).then(function(response) {
                        response.forEach(function(param, index) {
                            var data = param.data;
                            var objetivosAtuais = data;
                            var objetivoModificado = objetivosAtuais.map(function(i, idx) {
                                var _this_objetivos_api_;
                                var secoes_ativos = [
                                    "pr_acoes",
                                    "pr_fiis",
                                    "pr_stocks",
                                    "pr_reits",
                                    "pr_renda_fixa"
                                ];
                                var teste2 = (_this_objetivos_api_ = _this.objetivos_api[0]) === null || _this_objetivos_api_ === void 0 ? void 0 : _this_objetivos_api_.pr_acoes;
                                var teste3 = Number(i.porcentagem_desejada);
                                i.porcentagem_desejada = Number(i.porcentagem_desejada).toFixed(2);
                                return i;
                            });
                            _this.objetivos[entries[index]] = (0, $79xu7._)(objetivoModificado);
                        });
                    }).catch(function(error) {
                        GLOBAL.showToastify(error, "#DE4B4F");
                        console.error(error);
                    });
                    return [
                        2
                    ];
                });
            }).apply(this);
        },
        getObjetivosIncorretos: function() {
            return (0, $a1727a7253abe12d$export$7c398597f8905a1)(function() {
                var data, error;
                return (0, $877235af7931ac6c$export$67ebef60e6f28a6)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                3,
                                4
                            ]);
                            this.loading = true;
                            return [
                                4,
                                axios.get("/api/objetivo/")
                            ];
                        case 1:
                            data = _state.sent().data;
                            this.incorretos = data[0].incorreto;
                            return [
                                3,
                                4
                            ];
                        case 2:
                            error = _state.sent();
                            console.error(error);
                            return [
                                3,
                                4
                            ];
                        case 3:
                            this.loading = false;
                            return [
                                7
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            }).apply(this);
        },
        updateNome: function(nome) {
            this.nome_correto = nome;
        },
        openModalAction: function(value, tipo) {
            this.modalActive.openModal(value);
            if (this.step.id == 1 && this.tipo_atual == "titulos_inicio" && this.campos_objetivo.pr_renda_fixa) {
                this.updateValueStep(5, "titulos");
                this.nome_correto = "Tesouro direto";
                this.product_type_name = "TesouroDireto";
            }
        // else if (this.step.id == 4 && this.tipo_atual == 'eua') {
        //   this.updateValueStep(5, 'reits')
        // }
        // else if (this.step.id == 3 && this.tipo_atual == 'br') {
        //   this.updateValueStep(5, 'acoes')
        // }
        },
        outsideClick: function(param) {
            var target = param.target;
            if (target.closest(".btn-vermais")) return;
            this.quantidadeItens = 3;
        },
        handleToggle: function(tipo) {
            var isThree = this.quantidadeItens == 3 ? this.quantidadeItens = this.tiposInvestimento[tipo].length : this.quantidadeItens = 3;
            console.log(isThree);
            return isThree;
        }
    },
    delimiters: [
        "{*",
        "*}"
    ]
};




var $8pZMQ = parcelRequire("8pZMQ");

var $8typN = parcelRequire("8typN");

var $lhEla = parcelRequire("lhEla");

var $4f96i = parcelRequire("4f96i");
function $f40b125b35169f4a$export$263b15b19e6ed8f(strings, raw) {
    if (!raw) raw = strings.slice(0);
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}



var $79xu7 = parcelRequire("79xu7");

var $jzTO1 = parcelRequire("jzTO1");
function $2b5a3e82f3a5c7ce$export$4207bfed93925b51(input, hint) {
    if ((0, $jzTO1._type_of)(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ((0, $jzTO1._type_of)(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}



var $jzTO1 = parcelRequire("jzTO1");
function $e7f0c77ae710d29b$export$d0674b2051d6b645(arg) {
    var key = (0, $2b5a3e82f3a5c7ce$export$4207bfed93925b51)(arg, "string");
    return (0, $jzTO1._type_of)(key) === "symbol" ? key : String(key);
}




var $9Wwts = parcelRequire("9Wwts");

function $15043aedd156b5f2$var$_templateObject() {
    var data = (0, $f40b125b35169f4a$export$263b15b19e6ed8f)([
        '\n		<div>\n			<div class="modal-edicao-objetivo" data-position="center">\n				<!--MODAL DA RENDA FIXA E RENDA VARIAVEL = STEP 1-->\n				<section class="modal--content" data-id="1">\n					<div class="modal-header">\n						<img :src="bgModal" alt="" class="bg-header-modal" />\n						<h3>Editar Objetivo</h3>\n						<button\n							class="close-modal"\n							type="button"\n							data-id="1"\n							data-xclose="modal-edicao-objetivo"\n							@click="(e)=>onCloseModal(e)"\n						>\n							<svg class="w-8 h-8">\n								<use xlink:href="#icon-close"></use>\n							</svg>\n						</button>\n					</div>\n					<div class="conteudo step-1 p-24">\n						<p\n							class="text-base font-normal tracking-tight text-white leading-150 "\n						>\n							Qual a sua porcentagem desej\xe1vel em renda fixa e em renda\n							vari\xe1vel?\n						</p>\n						<form\n							class="!p-0"\n							@submit.prevent="(e) => onSubmitAction(e,\'pr_renda_fixa\', \'pr_renda_variavel\')"\n							@keydown.enter="$event.preventDefault()"\n						>\n							<div class="mt-24 input-box">\n								<label for="pr_renda_fixa" class="block label"\n									>Renda fixa</label\n								>\n								<div class="input-icon">\n									<input\n										type="number"\n										id="pr_renda_fixa"\n										name="pr_renda_fixa"\n										@input="checkSumValueInNormalSteps"\n										placeholder="%"\n										class="w-full h-48 text-sm input-text"\n										v-model.number="campos_objetivo.pr_renda_fixa"\n										:min="0"\n										:max="100"\n										step="0.01"\n									/>\n\n									<svg>\n										<use xlink:href="#icon-percent"></use>\n									</svg>\n								</div>\n							</div>\n							<div class="mt-16 input-box">\n								<label for="pr_renda_variavel" class="block label"\n									>Renda vari\xe1vel</label\n								>\n								<div class="input-icon">\n									<input\n										type="number"\n										id="pr_renda_variavel"\n										name="pr_renda_variavel"\n										v-model.number="campos_objetivo.pr_renda_variavel"\n										@input="checkSumValueInNormalSteps"\n										placeholder="%"\n										class="w-full h-48 text-sm input-text"\n										:min="0"\n										:max="100"\n										step="0.01"\n									/>\n									<svg>\n										<use xlink:href="#icon-percent"></use>\n									</svg>\n								</div>\n							</div>\n							<div\n								class="mt-16 error-message texthelper-icon"\n								data-tippy-content="helper"\n								v-show="!isValidModalSimple && showError"\n							>\n								<svg>\n									<use xlink:href="#icon-helper"></use>\n								</svg>\n\n								<span class="text-sm">{{ errorMessage }}</span>\n							</div>\n							<div\n								class="mt-16 aviso-recomendacao text-alert-red-100"\n								v-for="aviso in avisosDaFase(\'macro\')"\n								:key="aviso.mensagem"\n							>\n								<svg>\n									<use xlink:href="#icon-helper"></use>\n								</svg>\n								<span class="text-sm">{{ aviso.mensagem }}</span>\n							</div>\n							<div class="grid grid-cols-12 gap-16 mt-32 btn-container">\n								<button\n									type="button"\n									class="col-span-6 btn bg-primary-10-o text-primary-60-pure"\n									:data-id="step.id"\n									data-xclose="modal-edicao-objetivo"\n									@click="(e)=>onCloseModal(e)"\n								>\n									Cancelar\n								</button>\n								<button\n									type="submit"\n									class="col-span-6 btn"\n									:class="isValidModalSimple === true ? \'\' : \'disabled\'"\n								>\n									{{textoBotao}}\n								</button>\n							</div>\n						</form>\n					</div>\n				</section>\n\n				<!--MODAL DO BRASIL E EUA = STEP 2 -->\n				<section class="modal--content" data-id="2">\n					<div class="modal-header">\n						<img :src="bgModal" alt="" class="bg-header-modal" />\n						<h3>Editar Objetivo</h3>\n						<button\n							class="close-modal"\n							type="button"\n							data-id="2"\n							data-xclose="modal-edicao-objetivo"\n							@click="(e)=>onCloseModal(e)"\n						>\n							<svg class="w-8 h-8">\n								<use xlink:href="#icon-close"></use>\n							</svg>\n						</button>\n					</div>\n					<div class="conteudo step-2 p-24 ">\n						<p\n							class="text-base font-normal tracking-tight text-white leading-150"\n						>\n							Dentro da renda vari\xe1vel, qual a porcentagem desej\xe1vel no Brasil e\n							nos EUA?\n						</p>\n						<form\n							class="!p-0"\n							@submit.prevent="(e) => onSubmitAction(e,\'pr_renda_variavel_br\', \'pr_renda_variavel_eua\')"\n							@keydown.enter="$event.preventDefault()"\n						>\n							<div class="mt-24 input-box">\n								<label for="pr_renda_variavel_br" class="block label"\n									>Brasil</label\n								>\n								<div class="input-icon">\n									<input\n										type="number"\n										id="pr_renda_variavel_br"\n										name="pr_renda_variavel_br"\n										v-model.number="campos_objetivo.pr_renda_variavel_br"\n										@input="checkSumValueInNormalSteps"\n										placeholder="%"\n										class="w-full h-48 text-sm input-text"\n										:min="0"\n										:max="100"\n										step="0.01"\n									/>\n									<svg>\n										<use xlink:href="#icon-percent"></use>\n									</svg>\n								</div>\n							</div>\n							<div class="mt-16 input-box">\n								<label for="pr_renda_variavel_eua" class="block label"\n									>EUA</label\n								>\n								<div class="input-icon">\n									<input\n										type="number"\n										id="pr_renda_variavel_eua"\n										name="pr_renda_variavel_eua"\n										@input="checkSumValueInNormalSteps"\n										v-model.number="campos_objetivo.pr_renda_variavel_eua"\n										placeholder="%"\n										class="w-full h-48 text-sm input-text"\n										:min="0"\n										:max="100"\n										step="0.01"\n									/>\n									<svg>\n										<use xlink:href="#icon-percent"></use>\n									</svg>\n								</div>\n							</div>\n							<div\n								class="mt-16 error-message texthelper-icon"\n								data-tippy-content="helper"\n								v-show="!isValidModalSimple && showError"\n							>\n								<svg>\n									<use xlink:href="#icon-helper"></use>\n								</svg>\n								<span class="text-sm">{{ errorMessage }}</span>\n							</div>\n							<div\n								class="mt-16 aviso-recomendacao text-alert-red-100"\n								v-for="aviso in avisosDaFase(\'exterior\')"\n								:key="aviso.mensagem"\n							>\n								<svg>\n									<use xlink:href="#icon-helper"></use>\n								</svg>\n								<span class="text-sm">{{ aviso.mensagem }}</span>\n							</div>\n							<div class="grid grid-cols-12 gap-16 mt-32 btn-container">\n								<button\n									type="button"\n									class="col-span-6 btn bg-primary-10-o text-primary-60-pure"\n									:data-id="step.id"\n									data-xclose="modal-edicao-objetivo"\n									@click="(e)=> onCloseModal(e)"\n								>\n									Cancelar\n								</button>\n								<button\n									type="submit"\n									class="col-span-6 btn"\n									:class="isValidModalSimple === true ? \'\' : \'disabled\'"\n									@click="showai"\n								>\n									Salvar\n								</button>\n							</div>\n						</form>\n					</div>\n				</section>\n				<!-- MODAL PARA FIIS E A\xc7\xd5ES = STEP 3 -->\n				<section class="modal--content" data-id="3">\n					<div class="modal-header">\n						<img :src="bgModal" alt="" class="bg-header-modal" />\n						<h3>Editar Objetivo</h3>\n						<button\n							class="close-modal"\n							type="button"\n							data-id="3"\n							data-xclose="modal-edicao-objetivo"\n							@click="(e)=>onCloseModal(e)"\n						>\n							<svg class="w-8 h-8">\n								<use xlink:href="#icon-close"></use>\n							</svg>\n						</button>\n					</div>\n					<div class="conteudo step-3 p-24 ">\n						<p\n							class="text-base font-normal tracking-tight text-white leading-150"\n						>\n							Na renda vari\xe1vel no Brasil, quando em a\xe7\xf5es e quanto em FIIs?\n						</p>\n						<form\n							class="!p-0"\n							@submit.prevent="(e) => onSubmitAction(e,\'pr_acoes\', \'pr_fiis\')"\n							@keydown.enter="$event.preventDefault()"\n						>\n							<div class="mt-24 input-box">\n								<label for="pr_acoes" class="block label">A\xe7\xf5es</label>\n								<div class="input-icon">\n									<input\n										type="number"\n										id="pr_acoes"\n										name="pr_acoes"\n										@input="checkSumValueInNormalSteps"\n										v-model.number="campos_objetivo.pr_acoes"\n										placeholder="%"\n										class="w-full h-48 text-sm input-text"\n										:min="0"\n										:max="100"\n										step="0.01"\n									/>\n									<svg>\n										<use xlink:href="#icon-percent"></use>\n									</svg>\n								</div>\n							</div>\n							<div class="mt-16 input-box">\n								<label for="pr_fiis" class="block label">FIIs</label>\n								<div class="input-icon">\n									<input\n										type="number"\n										id="pr_fiis"\n										name="pr_fiis"\n										@input="checkSumValueInNormalSteps"\n										v-model.number="campos_objetivo.pr_fiis"\n										placeholder="%"\n										class="w-full h-48 text-sm input-text"\n										:min="0"\n										:max="100"\n										step="0.01"\n									/>\n									<svg>\n										<use xlink:href="#icon-percent"></use>\n									</svg>\n								</div>\n							</div>\n							<div\n								class="mt-16 error-message texthelper-icon"\n								data-tippy-content="helper"\n								v-show="!isValidModalSimple && showError"\n							>\n								<svg>\n									<use xlink:href="#icon-helper"></use>\n								</svg>\n								<span class="text-sm">{{ errorMessage }}</span>\n							</div>\n							<div\n								class="mt-16 aviso-recomendacao text-alert-red-100"\n								v-for="aviso in avisosDaFase(\'mix_br\')"\n								:key="aviso.mensagem"\n							>\n								<svg>\n									<use xlink:href="#icon-helper"></use>\n								</svg>\n								<span class="text-sm">{{ aviso.mensagem }}</span>\n							</div>\n							<div class="grid grid-cols-12 gap-16 mt-32 btn-container">\n								<button\n									type="button"\n									class="col-span-6 btn bg-primary-10-o text-primary-60-pure"\n									:data-id="step.id"\n									data-xclose="modal-edicao-objetivo"\n									@click="(e)=>onCloseModal(e)"\n								>\n									Cancelar\n								</button>\n								<button\n									type="submit"\n									class="col-span-6 btn"\n									:class="isValidModalSimple === true ? \'\' : \'disabled\'"\n								>\n									{{textoBotao}}\n								</button>\n							</div>\n						</form>\n					</div>\n				</section>\n				<!-- MODAL PARA STOCKS E REITS = STEP 4 -->\n				<section class="modal--content" data-id="4">\n					<div class="modal-header">\n						<img :src="bgModal" alt="" class="bg-header-modal" />\n						<h3>Editar Objetivo</h3>\n\n						<button\n							class="close-modal"\n							type="button"\n							data-id="4"\n							data-xclose="modal-edicao-objetivo"\n							@click="(e)=>onCloseModal(e)"\n						>\n							<svg class="w-8 h-8">\n								<use xlink:href="#icon-close"></use>\n							</svg>\n						</button>\n					</div>\n					<div class="conteudo step-4 p-24 ">\n						<p\n							class="text-base font-normal tracking-tight text-white leading-150"\n						>\n							Na renda vari\xe1vel no exterior, quando Stocks e em REITs? *\n						</p>\n						<form\n							class="!p-0"\n							@submit.prevent="(e) => onSubmitAction(e,\'pr_stocks\', \'pr_reits\')"\n							@keydown.enter="$event.preventDefault()"\n						>\n							<div class="mt-24 input-box">\n								<label for="pr_stocks" class="block label">Stocks</label>\n								<div class="input-icon">\n									<input\n										type="number"\n										id="pr_stocks"\n										name="pr_stocks"\n										@input="checkSumValueInNormalSteps"\n										v-model="campos_objetivo.pr_stocks"\n										placeholder="%"\n										class="w-full h-48 text-sm input-text"\n										:class="!isValidModalSimple ? \'isInvalid\' : \'\'"\n										:min="0"\n										:max="100"\n										step="0.01"\n									/>\n									<svg>\n										<use xlink:href="#icon-percent"></use>\n									</svg>\n								</div>\n							</div>\n							<div class="mt-16 input-box">\n								<label for="pr_reits" class="block label">Reits</label>\n								<div class="input-icon">\n									<input\n										type="number"\n										id="pr_reits"\n										name="pr_reits"\n										@input="checkSumValueInNormalSteps"\n										v-model="campos_objetivo.pr_reits"\n										placeholder="%"\n										class="w-full h-48 text-sm input-text"\n										:class="!isValidModalSimple ? \'isInvalid\' : \'\'"\n										:min="0"\n										:max="100"\n										step="0.01"\n									/>\n									<svg>\n										<use xlink:href="#icon-percent"></use>\n									</svg>\n								</div>\n							</div>\n							<div\n								class="mt-16 error-message texthelper-icon"\n								data-tippy-content="helper"\n								v-show="!isValidModalSimple && showError"\n							>\n								<svg>\n									<use xlink:href="#icon-helper"></use>\n								</svg>\n								<span class="text-sm">{{ errorMessage }}</span>\n							</div>\n							<div\n								class="mt-16 aviso-recomendacao text-alert-red-100"\n								v-for="aviso in avisosDaFase(\'mix_eua\')"\n								:key="aviso.mensagem"\n							>\n								<svg>\n									<use xlink:href="#icon-helper"></use>\n								</svg>\n								<span class="text-sm">{{ aviso.mensagem }}</span>\n							</div>\n							<div class="grid grid-cols-12 gap-16 mt-32 btn-container">\n								<button\n									type="button"\n									class="col-span-6 btn bg-primary-10-o text-primary-60-pure"\n									:data-id="step.id"\n									data-xclose="modal-edicao-objetivo"\n									@click="(e)=>onCloseModal(e)"\n								>\n									Cancelar\n								</button>\n								<button\n									type="submit"\n									class="col-span-6 btn"\n									:class="isValidModalSimple === true ? \'\' : \'disabled\'"\n								>\n									{{textoBotao}}\n								</button>\n							</div>\n						</form>\n					</div>\n				</section>\n\n				<!-- MODAL COM INLINES = STEP 5-->\n				<section class="modal--content" data-id="5">\n					<div class="py-24 px-24 border-b border-neutral-95">\n						<div className="titulo flex items-center justify-between">\n							<div class="flex flex-col">\n								<p class="text-sm" style="color: rgba(255, 255, 255, 0.70);">\n									OBJETIVO\n								</p>\n								<h3\n									class="font-bold text-lg tracking-tighter text-neutral-20 mt-2"\n								>\n									{{nome}}\n								</h3>\n							</div>\n							<button\n								class="close-modal"\n								type="button"\n								data-id="4"\n								data-xclose="modal-edicao-objetivo"\n								@click="(e)=>onCloseModal(e)"\n							>\n								<svg class="w-8 h-8">\n									<use xlink:href="#icon-close"></use>\n								</svg>\n							</button>\n						</div>\n						<div class="conteudo step-5 pt-24 ">\n							<form class="!p-0" @keydown.enter="$event.preventDefault()">\n								<div class="tabela-grafico max-h-[350px] overflow-y-scroll">\n									<div class="flex justify-between px-8 py-10">\n										<p\n											class="text-xs font-bold tracking-tight text-white leading-150"\n										>\n											TOTAL\n										</p>\n										<p\n											class="text-xs font-bold tracking-tight text-primary-50 leading-150"\n										>\n											{{ valor_total_computado.toFixed(2) }}%\n										</p>\n									</div>\n									<div class="mt-8 header grid-personalizado_novo">\n										<p class="label-objetivo">Ativo</p>\n										<p class="text-left label-objetivo">%</p>\n										<p></p>\n									</div>\n\n									<div\n										class="item grid-personalizado_novo"\n										v-if="this.objetivos[step.tipo]?.length"\n										v-for="item in this.objetivos[step.tipo]"\n										:key="item.id"\n										:class="{active: showOptions == item.id && showOptionsFirst}"\n										id="item.id"\n									>\n										<p class="ticker_symbol-objetivo">{{item.ticker_symbol}}</p>\n										<p class="text-left justify-start porcentagem-objetivo">\n											{{Number(item.porcentagem_desejada).toFixed(2)}} %\n										</p>\n										<span\n											class="icone-three-points options-objetivo"\n											@click="handleClickInOptions(item.id)"\n										>\n											<svg class="pointer-events-none">\n												<use xlink:href="#icon-three-points"></use>\n											</svg>\n											<ul class="options">\n												<li>\n													<a\n														:id="item.id"\n														@click="activateModal(\'editar\', item.objetivo, item.ticker_symbol, item.id)"\n														>Editar</a\n													>\n												</li>\n												<li>\n													<a :id="item.id" @click="removeObjective(item.id)"\n														>Remover</a\n													>\n												</li>\n											</ul>\n										</span>\n									</div>\n\n									<input\n										type="hidden"\n										name="secao_A\xe7\xf5es"\n										:value="JSON.stringify(this.objetivos[step.tipo])"\n									/>\n								</div>\n								<button\n									type="button"\n									class="w-full mt-4 btn quartenary personalizado"\n									@click="activateModal(\'adicionar\')"\n									:class="{disabled: isPercentFull}"\n									:disabled="isPercentFull"\n								>\n									Adicionar {{nome}}\n								</button>\n								<div\n									class="mt-16 error-message texthelper-icon"\n									data-tippy-content="helper"\n									v-show="!isValidModalObjective && showError"\n								>\n									<svg>\n										<use xlink:href="#icon-helper"></use>\n									</svg>\n\n									<span class="text-sm">{{ errorMessage }}</span>\n								</div>\n								<div class="grid grid-cols-12 gap-16 mt-32 btn-container">\n									<button\n										type="button"\n										class=" col-span-6 btn bg-primary-10-o text-primary-60-pure"\n										:data-id="step.id"\n										data-xclose="modal-edicao-objetivo"\n										@click="(e)=>onCloseModal(e)"\n									>\n										Cancelar\n									</button>\n									<button\n										type="button"\n										class="col-span-6 btn icon-left"\n										:class="{disabled: !isValidModalObjective}"\n										:disabled="isValidModalObjective == false"\n										@click="saveANewObjectiveOnApi"\n									>\n										Concluir\n									</button>\n								</div>\n							</form>\n						</div>\n					</div>\n				</section>\n			</div>\n\n			<div class="modal-fundo" :class="{active: modalIsOpen}">\n				<div\n					class="modal-novo tela-adicao"\n					v-show="modalState === \'adicionar\'"\n					:class="{active: modalIsOpen && modalState === \'adicionar\'}"\n				>\n					<div class="modal-header">\n						<img :src="bgModal" alt="" class="bg-header-modal" />\n						<h3>Adicionar {{nome}}</h3>\n						<button\n							class="close-modal"\n							type="button"\n							data-id="2"\n							data-xclose="modal-edicao"\n							@click="onCloseModal"\n						>\n							<svg class="w-8 h-8">\n								<use xlink:href="#icon-close"></use>\n							</svg>\n						</button>\n					</div>\n					<div class="p-24 modal-content">\n						<div class="input-box is-search">\n							<label class="label block" for="id_classe_acao"\n								>{{textoModal}}</label\n							>\n							<v-select\n								class="select-vue"\n								:option-label="\'ticker_symbol\' "\n								:options="product_type_name !== \'TesouroDireto\' ? options : optionsRendaFixa"\n								v-model="this.novoObjetivo.nome"\n								@search="onSearch"\n								:loading="isLoading"\n								:dropdown-should-open="dropdownShouldOpen"\n								@change="preventInsertTheSameTickerSymbol"\n								placeholder="Pesquisar..."\n								no-options-text="Nenhum resultado encontrado"\n								:clearable="false"\n								@update:model-value="(e) => handleSearchSelect(e)"\n							>\n							</v-select>\n						</div>\n						<div class="input-box">\n							<label class="block label mt-16" for="id_objetivo"\n								>Objetivo\n							</label>\n							<div class=" input-icon">\n								<input\n									type="number"\n									v-model="novoObjetivo.porcentagem"\n									@keyup="validateModalFieldsOnAdd"\n									id="id_objetivo"\n									class="w-full h-48 text-sm input-text"\n									:class="{disabled: hasSameValue}"\n									:disabled="hasSameValue"\n									:clearable="false"\n								/>\n								<svg>\n									<use xlink:href="#icon-percent"></use>\n								</svg>\n							</div>\n						</div>\n						<div\n							class="mt-16 error-message texthelper-icon"\n							data-tippy-content="helper"\n							v-if="!modalValueIsValid && showErrorOnModal"\n						>\n							<svg>\n								<use xlink:href="#icon-helper"></use>\n							</svg>\n							<span>{{ modalErrorMessage }}</span>\n						</div>\n						<div class="grid grid-cols-12 gap-16 mt-32 btn-container">\n							<button\n								type="button"\n								class="col-span-6 btn bg-primary-10-o text-primary-60-pure"\n								data-xclose="modal-adicao"\n								@click="onCloseModal"\n							>\n								Cancelar\n							</button>\n							<button\n								type="button"\n								class="col-span-6 btn"\n								:class="{disabled: !modalValueIsValid}"\n								:disabled="!modalValueIsValid"\n								@click="saveANewObjective"\n							>\n								Adicionar\n							</button>\n						</div>\n					</div>\n				</div>\n				<div\n					class="modal-novo tela-edicao"\n					v-show="modalState === \'editar\'"\n					:class="{active: modalIsOpen && modalState === \'editar\'}"\n				>\n					<div class="modal-header">\n						<img :src="bgModal" alt="" class="bg-header-modal" />\n						<h3>Editar {{nome}}</h3>\n						<button\n							class="close-modal"\n							type="button"\n							data-id="2"\n							data-xclose="modal-edicao"\n							@click="onCloseModal"\n						>\n							<svg class="w-8 h-8">\n								<use xlink:href="#icon-close"></use>\n							</svg>\n						</button>\n					</div>\n					<div class="p-24 modal-content">\n						<div class="input-box is-search">\n							<label class="label block" for="id_classe_acao"\n								>{{textoModal}}\n							</label>\n							<v-select\n								class="select-vue"\n								name="ticker_symbol"\n								:option-label="\'ticker_symbol\'"\n								:options="options"\n								v-model="this.novoObjetivo.nome"\n								@search="onSearch"\n								@input="setNewObjectiveValueInOnKeyupEdit"\n								:loading="isLoading"\n								:dropdown-should-open="dropdownShouldOpen"\n								@change="preventInsertTheSameTickerSymbol"\n								placeholder="Pesquisar..."\n								no-options-text="Nenhum resultado encontrado"\n								:disabled="true"\n							></v-select>\n						</div>\n\n						<div class="input-box">\n							<label class="block label mt-16" for="id_objetivo"\n								>Objetivo\n							</label>\n							<div class=" input-icon">\n								<input\n									type="number"\n									v-model="novoObjetivo.porcentagem"\n									@keyup="setNewObjectiveValueInOnKeyupEdit"\n									id="id_objetivo"\n									class="w-full h-48 text-sm input-text"\n								/>\n								<svg>\n									<use xlink:href="#icon-percent"></use>\n								</svg>\n							</div>\n						</div>\n						<div\n							class="mt-16 error-message texthelper-icon"\n							data-tippy-content="helper"\n							v-if="!modalValueIsValid && showErrorOnModal"\n						>\n							<svg>\n								<use xlink:href="#icon-helper"></use>\n							</svg>\n							<span>{{ modalErrorMessage }}</span>\n						</div>\n						<div class="grid grid-cols-12 gap-16 mt-32 btn-container">\n							<button\n								type="button"\n								class="col-span-6 btn bg-primary-10-o text-primary-60-pure"\n								data-xclose="modal-edicao"\n								@click="onCloseModal"\n							>\n								Cancelar\n							</button>\n							<button\n								type="button"\n								class="col-span-6 btn"\n								:class="{disabled: !modalValueIsValid}"\n								:disabled="!modalValueIsValid"\n								@click="editAExistantObjetive"\n							>\n								Continuar\n							</button>\n						</div>\n					</div>\n				</div>\n			</div>\n		</div>\n	'
    ]);
    $15043aedd156b5f2$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $d3e397aad4e6da30$exports = {};

$d3e397aad4e6da30$exports = (parcelRequire("3uQPI")).getBundleURL("5RKGD") + "bg-modal.2ae1f3e6.svg";


var $15043aedd156b5f2$var$modalComplexo = {
    props: [
        "objetivos_api",
        "step",
        "objetivos",
        "tipo_atual",
        "campos_objetivo",
        "nome_correto",
        "product_type_name",
        "loading",
        "origin_click",
        "status_campos"
    ],
    data: function() {
        return {
            bgModal: $d3e397aad4e6da30$exports,
            baseURL: window.location.origin,
            showErrorOnModal: false,
            isValidModalObjective: true,
            errorMessage: "",
            showError: false,
            isPercentFull: false,
            modalIsOpen: false,
            ["showErrorOnModal"]: false,
            ["isPercentFull"]: false,
            modalErrorMessage: "",
            modalValueIsValid: false,
            show: false,
            search: "",
            objEdicao: null,
            modalState: "",
            stepAnterior: null,
            objetivoFiltrado: "",
            ["baseURL"]: window.location.origin,
            quantidadeSteps: 8,
            hasZeroValues: false,
            hasSameValue: false,
            textoBotao: "Continuar",
            novoObjetivo: {
                nome: "",
                porcentagem: ""
            },
            showOptions: "",
            showOptionsFirst: false,
            idDoObjetivoAtual: "",
            options: [],
            optionsRendaFixa: [
                {
                    value: "Tesouro IPCA+",
                    label: "Tesouro IPCA+",
                    ticker_symbol: "Tesouro IPCA+"
                }
            ],
            isLoading: false,
            selected: null,
            pastTotalValue: 0,
            // Exclusoes pendentes escopadas por aba/classe: { [tipo]: [ids] }.
            // Evita arrastar remocoes de uma classe no save de outra.
            idsExcluidos: {},
            protocol: window.location.protocol,
            isValidModalSimple: true
        };
    },
    mounted: function() {
        var _this = this;
        document.addEventListener("click", function(e) {
            return _this.outsideClick(e);
        });
    },
    watch: {
        valor_total_computado: function(newValue, oldValue) {
            if (!this.valor_total_computado) return;
            this.checkSumValueInInlineSteps();
        },
        step: function(newValue, oldValue) {
            var id = newValue.id, tipo = newValue.tipo;
            if (id === 5) this.checkSumValueInInlineSteps();
        }
    },
    computed: {
        avisosRecomendacao: function() {
            return (0, $3ebff57b58996a50$export$e9953c2d81f4872)(this.campos_objetivo);
        },
        valor_total_computado: function() {
            var objetivoAtual = this.objetivos[this.step.tipo];
            if (!objetivoAtual) return 0;
            var porcentagens = objetivoAtual.map(function(objetivo) {
                return Number(objetivo.porcentagem_desejada);
            });
            var total = porcentagens.reduce(function(acc, porcentagem) {
                return acc + porcentagem;
            }, 0);
            // return Math.round(total);
            return Math.round((total + Number.EPSILON) * 100) / 100;
        },
        nome: function() {
            if (this.tipo_atual == "titulos" || this.tipo_atual == "titulos_inicio") return "Tesouro Direto";
            else if (this.tipo_atual == "reits") return "Reits";
            else if (this.tipo_atual == "stocks") return "Stocks";
            else if (this.tipo_atual == "acoes") return "A\xe7\xf5es";
            else if (this.tipo_atual == "fiis") return "FIIs";
            return "default";
        },
        textoModal: function() {
            if (this.step.tipo == "acoes") return "Qual o seu objetivo com esta a\xe7\xe3o?";
            else if (this.step.tipo == "fiis") return "Qual o seu objetivo com este FII?";
            else if (this.step.tipo == "stocks") return "Qual o seu objetivo com este Stock?";
            else if (this.step.tipo == "reits") return "Qual o seu objetivo com este Reit";
            else if (this.step.tipo == "tesouro_direto") return "Qual o seu objetivo com este Titulo de renda fixa?";
            else return "";
        }
    },
    methods: {
        /**
		 * Avisos de recomendação (não bloqueantes) da fase informada, para
		 * exibição inline dentro do modal — ver regrasObjetivo.js.
		 */ avisosDaFase: function(fase) {
            return this.avisosRecomendacao.filter(function(aviso) {
                return aviso.fase === fase;
            });
        },
        limitQuantityNumberAfterVirgula: function() {
            var input1 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null, input2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
            if (input1 && input1.value !== null && input1.value.toString().indexOf(".") !== -1) {
                var partes = input1.value.toString().split(".");
                if (partes[1].length > 2) {
                    input1.value = parseFloat(partes[0] + "." + partes[1].substr(0, 2));
                    this.novoObjetivo.porcentagem = input1.value;
                }
            }
            if (input2 && input2.value !== null && input2.value.toString().indexOf(".") !== -1) {
                var partes1 = input2.value.toString().split(".");
                if (partes1[1].length > 2) input2.value = parseFloat(partes1[0] + "." + partes1[1].substr(0, 2));
            }
        },
        /* Funções responsáveis por calcular valor dos objetivos*/ checkSumValueInNormalSteps: function(param) {
            var currentTarget = param.currentTarget, target = param.target;
            var cardItem = document.querySelector(".step-".concat(this.step.id));
            var pai = cardItem.parentElement;
            var numeroPermitido = 100;
            console.log(numeroPermitido);
            var inputs = (0, $79xu7._)(cardItem.querySelectorAll("input"));
            var _inputs = (0, $4f96i._)(inputs, 2), input1 = _inputs[0], input2 = _inputs[1];
            var soma;
            // if (!currentTarget) return;
            if (currentTarget.value > numeroPermitido) currentTarget.value = "";
            this.limitQuantityNumberAfterVirgula(input1, input2);
            this.defineDynamicValueFromInputsInNormalSteps(currentTarget, input1, input2);
            soma = Number(input1.value) + Number(input2.value);
            this.compareSumValuesInNormalSteps(soma);
        },
        dropdownShouldOpen: function(VueSelect) {
            if (this.options.length) return VueSelect.open;
            return VueSelect.search.length !== 0 && VueSelect.open;
        },
        defineDynamicValueFromInputsInNormalSteps: function(elAtivo, firstInput, secondInput) {
            var attrName1 = firstInput.getAttribute("name");
            var attrName2 = secondInput.getAttribute("name");
            if (elAtivo == firstInput) {
                secondInput.value = (100 - firstInput.value).toFixed(2);
                this.campos_objetivo[attrName1] = parseFloat(firstInput.value);
                this.campos_objetivo[attrName2] = parseFloat(secondInput.value);
            } else if (elAtivo == secondInput) {
                firstInput.value = (100 - secondInput.value).toFixed(2);
                this.campos_objetivo[attrName1] = parseFloat(firstInput.value);
                this.campos_objetivo[attrName2] = parseFloat(secondInput.value);
            }
            this.campos_objetivo[attrName1] == 0 || this.campos_objetivo[attrName2] == 0 ? this.hasZeroValues = true : this.hasZeroValues = false;
        },
        compareSumValuesInNormalSteps: function(soma) {
            if (soma > 100 || soma != 100) {
                this.isValidModalSimple = false;
                this.showError = true;
                this.errorMessage = "O somat\xf3rio precisa ser igual a 100%";
                return;
            }
            this.isValidModalSimple = true;
        },
        checkSumValueInInlineSteps: function() {
            if (this.valor_total_computado > 100 || this.valor_total_computado !== 100) {
                this.isValidModalObjective = false;
                this.isPercentFull = false;
                this.showError = true;
                this.errorMessage = "O somat\xf3rio precisa ser igual a 100%";
            } else if (this.valor_total_computado == 100) {
                this.isValidModalObjective = true;
                this.isPercentFull = true;
            }
        },
        /* Funções que previne a adição de ativos que já existem no objetivo*/ checkIfStringExistsOnObject: function() {
            var _this = this;
            if (this.modalState == "adicionar") {
                var equal = this.objetivos[this.tipo_atual].some(function(i) {
                    return i.ticker_symbol == _this.novoObjetivo.nome;
                });
                if (equal) {
                    this.hasSameValue = true;
                    return;
                }
                this.hasSameValue = false;
            } else if (this.modalState == "editar") {
                var equal1 = this.objetivos[this.tipo_atual].some(function(i) {
                    return i.ticker_symbol == _this.novoObjetivo.nome && i.ticker_symbol != _this.objEdicao.ticker_symbol;
                });
                if (equal1) {
                    this.hasSameValue = true;
                    this.modalValueIsValid = false;
                    return;
                }
                this.novoObjetivo.porcentagem = this.objEdicao.porcentagem_desejada;
                this.hasSameValue = false;
                this.modalValueIsValid = true;
            }
        },
        handleSearchSelect: function(opcaoSelecionada) {
            if (!opcaoSelecionada.value) return;
            console.log(opcaoSelecionada);
            this.novoObjetivo.nome = opcaoSelecionada.value;
            this.preventInsertTheSameTickerSymbol();
        },
        preventInsertTheSameTickerSymbol: function() {
            this.checkIfStringExistsOnObject();
            if (this.hasSameValue) {
                this.showErrorOnModal = true;
                this.modalErrorMessage = "Esse ativo j\xe1 foi adicionado antes";
                this.novoObjetivo.porcentagem = null;
                this.modalValueIsValid = false;
                return;
            } else {
                this.showErrorOnModal = false;
                this.modalErrorMessage = "";
            }
        },
        /* Funções responsáveis pelo pesquisar e setar as options dentro do Choices */ onSearch: function(search, loading) {
            if (this.product_type_name == "TesouroDireto") return;
            if (search.length) {
                loading(true);
                this.getDataOnSearchSelect(loading, search, this);
            }
        },
        getDataOnSearchSelect: (0, $9Wwts.debounce)(function() {
            var _ref = (0, $a1727a7253abe12d$export$7c398597f8905a1)(function(loading, search, vm) {
                var data, response, response1, error;
                return (0, $877235af7931ac6c$export$67ebef60e6f28a6)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                7,
                                8,
                                9
                            ]);
                            if (!(this.tipo_atual == "titulos")) return [
                                3,
                                3
                            ];
                            return [
                                4,
                                fetch("".concat(this.baseURL, "/api/tesouro_direto/?ticker_symbol=").concat(search))
                            ];
                        case 1:
                            response = _state.sent();
                            return [
                                4,
                                response.json()
                            ];
                        case 2:
                            data = _state.sent();
                            return [
                                3,
                                6
                            ];
                        case 3:
                            return [
                                4,
                                fetch("".concat(this.baseURL, "/api/").concat(this.tipo_atual, "/?ticker_symbol=").concat(search))
                            ];
                        case 4:
                            response1 = _state.sent();
                            return [
                                4,
                                response1.json()
                            ];
                        case 5:
                            data = _state.sent();
                            _state.label = 6;
                        case 6:
                            this.options = data.map(function(param) {
                                var ticker_symbol = param.ticker_symbol;
                                return {
                                    value: ticker_symbol,
                                    label: ticker_symbol,
                                    ticker_symbol: ticker_symbol
                                };
                            });
                            loading(false);
                            this.isLoading = false;
                            return [
                                3,
                                9
                            ];
                        case 7:
                            error = _state.sent();
                            // GLOBAL.showToastify(error);
                            console.error(error);
                            loading(false);
                            this.isLoading = false;
                            return [
                                3,
                                9
                            ];
                        case 8:
                            loading(false);
                            this.isLoading = false;
                            return [
                                7
                            ];
                        case 9:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(loading, search, vm) {
                return _ref.apply(this, arguments);
            };
        }(), 600),
        /* Funções responsável por controlar array do objeto de edição */ setAEditObjectiveToArray: function(id) {
            this.modalIsOpen = true;
            var tipo = this.step.tipo;
            var filterObjetivo = this.objetivos[tipo].filter(function(item) {
                return item.id == id;
            });
            this.objEdicao = filterObjetivo[0];
            this.setValuesOnEditStateModal(filterObjetivo);
        },
        setNewObjectiveValueInOnKeyupEdit: function(param, cancelar) {
            var _this = this;
            var target = param.target;
            var _this_step;
            var _this_step_tipo;
            var tipo = (_this_step_tipo = (_this_step = this.step) === null || _this_step === void 0 ? void 0 : _this_step.tipo) !== null && _this_step_tipo !== void 0 ? _this_step_tipo : "";
            if (cancelar || !tipo) // Se cancelar ou tipo não estiver definido, sai da função
            return;
            if (target) {
                this.limitQuantityNumberAfterVirgula(target);
                var updatedObjectives = this.objetivos[tipo].map(function(item) {
                    if (item.id === _this.objEdicao.id) {
                        var _this_novoObjetivo_porcentagem;
                        // Se estiver editando, atualiza com o novo valor ou valor original
                        var porcentagem = (_this_novoObjetivo_porcentagem = _this.novoObjetivo.porcentagem) !== null && _this_novoObjetivo_porcentagem !== void 0 ? _this_novoObjetivo_porcentagem : item.porcentagem_desejada;
                        return (0, $8typN._)((0, $8pZMQ._)({}, item), {
                            porcentagem_desejada: porcentagem
                        });
                    }
                    return item;
                });
                this.objetivos[tipo] = updatedObjectives;
                this.validateModalFieldsOnEdit(target);
            }
        },
        updateObjectiveValue: function(item) {
            return (0, $8typN._)((0, $8pZMQ._)({}, item), {
                porcentagem_desejada: this.novoObjetivo.porcentagem
            });
        },
        setValuesOnEditStateModal: function(array) {
            this.novoObjetivo.nome = array[0].ticker_symbol;
            this.novoObjetivo.porcentagem = array[0].porcentagem_desejada;
        },
        /*Função responsável por ativar o modal e suas respectivas ações */ activateModal: function(valor, objetivo, ticker_symbol, id) {
            this.modalIsOpen = true;
            this.modalState = valor;
            this.pastTotalValue = this.valor_total_computado;
            switch(this.modalState){
                case "adicionar":
                    this.options = [];
                    this.novoObjetivo = {
                        nome: "",
                        porcentagem: ""
                    };
                    this.modalValueIsValid = false;
                    this.hasSameValue = false;
                    this.showErrorOnModal = false;
                    break;
                case "editar":
                    this.modalValueIsValid = false;
                    this.hasSameValue = false;
                    this.showErrorOnModal = false;
                    var nomeAtivo = this.objetivos[this.step.tipo].filter(function(i) {
                        return i.id === id;
                    }).reduce(function(acc, i) {
                        return acc = i;
                    }, {});
                    this.options = [
                        {
                            value: nomeAtivo.ticker_symbol,
                            label: nomeAtivo.ticker_symbol
                        }
                    ];
                    this.setAEditObjectiveToArray(id);
                    break;
            }
        },
        /* Função responsável por salvar uma edição ou criação de objetivo*/ defineTickerSymbolInEdit: function() {
            console.log(this.novoObjetivo.nome);
            if (this.novoObjetivo.nome.ticker_symbol) return this.novoObjetivo.nome.ticker_symbol;
            else if (this.novoObjetivo.nome.value) return this.novoObjetivo.nome.value;
            else return this.novoObjetivo.nome;
        },
        editAExistantObjetive: function() {
            var _this = this;
            var tipo = this.step.tipo;
            var objetivosFiltrados = this.objetivos[tipo].map(function(item) {
                if (item.id == _this.objEdicao.id) return (0, $8typN._)((0, $8pZMQ._)({}, item), {
                    ticker_symbol: _this.defineTickerSymbolInEdit(),
                    porcentagem_desejada: _this.novoObjetivo.porcentagem
                });
                return item;
            });
            this.objetivos[tipo] = objetivosFiltrados;
            this.checkSumValueInInlineSteps();
            this.modalIsOpen = false;
        },
        saveANewObjective: function(event) {
            var modalResponsavel = event.currentTarget.closest(".modal-adicao");
            var tipo = this.step.tipo;
            var objetivosAtuais = this.objetivos[tipo];
            console.log(GLOBAL.generateUUID(), this.protocol);
            this.objetivos[tipo] = (0, $79xu7._)(objetivosAtuais).concat([
                {
                    id: this.protocol === "https:" ? crypto.randomUUID() : GLOBAL.generateUUID(),
                    ticker_symbol: this.novoObjetivo.nome,
                    porcentagem_desejada: this.novoObjetivo.porcentagem,
                    objetivo: this.objetivos_api[0].id,
                    tipo_ativo: "".concat(this.tipo_atual != "titulos" ? "Variavel" : "Fixa"),
                    product_type_name: this.product_type_name
                }
            ]);
            this.checkSumValueInInlineSteps();
            this.resetModalForm();
            this.modalIsOpen = false;
        },
        saveANewObjectiveOnApi: function() {
            return (0, $a1727a7253abe12d$export$7c398597f8905a1)(function() {
                var tipo, objetivosAtuais, keyToRemove, objetivosAtuaisParaApi, idsDaAba, idParaExclusaoSemCryptoID, data, error, _error_response, _data_erros, data1, mensagem;
                return (0, $877235af7931ac6c$export$67ebef60e6f28a6)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            tipo = this.step.tipo;
                            objetivosAtuais = this.objetivos[tipo];
                            keyToRemove = "id";
                            objetivosAtuaisParaApi = objetivosAtuais.map(function(obj) {
                                var removedKey = obj[keyToRemove], rest = (0, $lhEla._)(obj, [
                                    keyToRemove
                                ].map((0, $e7f0c77ae710d29b$export$d0674b2051d6b645)));
                                return rest;
                            });
                            // So envia as exclusoes DESTA aba (classe). idsExcluidos e
                            // escopado por tipo para nao arrastar remocoes de outra classe
                            // (ex.: salvar Stocks nao pode apagar itens de Acoes).
                            idsDaAba = this.idsExcluidos[tipo] || [];
                            idParaExclusaoSemCryptoID = idsDaAba.filter(function(item) {
                                return !isNaN(item) && typeof item === "number";
                            });
                            return [
                                4,
                                axios.post("".concat(this.baseURL, "/editar-objetivo/"), (0, $8typN._)((0, $8pZMQ._)({}, objetivosAtuaisParaApi), {
                                    ids: idParaExclusaoSemCryptoID
                                }))
                            ];
                        case 1:
                            data = _state.sent().data;
                            // Exclusoes desta aba ja persistidas: zera so as dela.
                            this.idsExcluidos[tipo] = [];
                            this.sucessConfirmation();
                            return [
                                3,
                                3
                            ];
                        case 2:
                            error = _state.sent();
                            // O backend (editar_objetivo) valida a integridade do objetivo e
                            // responde 400 com { message, erros: [...] } quando alguma classe
                            // nao fecha 100%. Mostra esses erros em vez do objeto de erro cru.
                            data1 = error === null || error === void 0 ? void 0 : (_error_response = error.response) === null || _error_response === void 0 ? void 0 : _error_response.data;
                            mensagem = (data1 === null || data1 === void 0 ? void 0 : (_data_erros = data1.erros) === null || _data_erros === void 0 ? void 0 : _data_erros.length) > 0 ? data1.erros.join(" ") : (data1 === null || data1 === void 0 ? void 0 : data1.message) || "Nao foi possivel salvar o objetivo. Tente novamente.";
                            GLOBAL.showToastify(mensagem, "#DE4B4F");
                            console.error(error);
                            return [
                                2
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            }).apply(this);
        },
        removeObjective: function(id) {
            var tipo = this.step.tipo;
            if (id) {
                // Escopa a exclusao na aba (classe) atual: so e enviada quando
                // ESTA aba for salva, nunca junto com o save de outra classe.
                if (!this.idsExcluidos[tipo]) this.idsExcluidos[tipo] = [];
                this.idsExcluidos[tipo].push(id);
            }
            this.objetivos[tipo] = this.objetivos[tipo].filter(function(item) {
                console.log(item.id, id);
                return item.id !== id;
            });
            this.checkSumValueInInlineSteps();
        },
        /* Validações*/ validateModalFieldsOnAdd: function(param) {
            var target = param.target;
            this.limitQuantityNumberAfterVirgula(target);
            if (!this.novoObjetivo.nome || !this.novoObjetivo.porcentagem) {
                this.modalValueIsValid = false;
                this.showErrorOnModal = true;
                this.modalErrorMessage = "Os campos n\xe3o podem estar vazios";
            } else if (this.valor_total_computado + this.novoObjetivo.porcentagem > 100) {
                this.modalValueIsValid = false;
                this.showErrorOnModal = true;
                this.modalErrorMessage = "O somat\xf3rio precisa ser igual a 100%";
                this.novoObjetivo.porcentagem = "";
            } else {
                this.modalValueIsValid = true;
                this.showErrorOnModal = false;
                this.modalErrorMessage = "";
            }
        },
        returnToOriginalValueObjetive: function() {
            var _this = this;
            var _this_objEdicao;
            this.novoObjetivo.porcentagem = (_this_objEdicao = this.objEdicao) === null || _this_objEdicao === void 0 ? void 0 : _this_objEdicao.porcentagem_desejada;
            var updatedObjectives = this.objetivos[this.step.tipo].map(function(item) {
                if (item.id === _this.objEdicao.id) {
                    var _this_novoObjetivo_porcentagem;
                    var porcentagem = (_this_novoObjetivo_porcentagem = _this.novoObjetivo.porcentagem) !== null && _this_novoObjetivo_porcentagem !== void 0 ? _this_novoObjetivo_porcentagem : item.porcentagem_desejada;
                    return (0, $8typN._)((0, $8pZMQ._)({}, item), {
                        porcentagem_desejada: porcentagem
                    });
                }
                return item;
            });
            this.objetivos[this.step.tipo] = updatedObjectives;
            this.modalValueIsValid = true;
        },
        validateModalFieldsOnEdit: function(target) {
            this.limitQuantityNumberAfterVirgula(target);
            if (!this.novoObjetivo.porcentagem) {
                this.modalValueIsValid = false;
                this.showErrorOnModal = true;
                this.modalErrorMessage = "Os campos n\xe3o podem estar vazios";
            } else if (this.valor_total_computado > 100 || this.novoObjetivo.porcentagem > 100) {
                this.modalValueIsValid = false;
                this.showErrorOnModal = true;
                this.modalErrorMessage = "O somat\xf3rio precisa ser igual a 100%";
                this.returnToOriginalValueObjetive();
            } else {
                this.modalValueIsValid = true;
                this.showErrorOnModal = false;
                this.modalErrorMessage = "";
            }
        },
        sucessConfirmation: function() {
            return (0, $a1727a7253abe12d$export$7c398597f8905a1)(function() {
                return (0, $877235af7931ac6c$export$67ebef60e6f28a6)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            GLOBAL.showToastify("Objetivo editado com sucesso!");
                            return [
                                4,
                                getObjetivos()
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            })();
        },
        //Essa função é responsável por mudar
        wizardUpdate: function() {
            if (this.step.id === 4 && this.step.tipo === "stocks" && this.campos_objetivo.pr_stocks) {
                this.$emit("update-nome", "Stock");
                this.$parent.updateValueStep(5, "stocks");
            } else if (this.step.id === 1 && this.step.tipo === "titulos_inicio" && this.campos_objetivo.pr_renda_fixa) {
                this.$emit("update-nome", "TesouroDireto");
                this.$parent.updateValueStep(5, "titulos");
            } else if (this.step.id === 4 && this.step.tipo === "reits" && this.campos_objetivo.pr_reits) {
                this.$emit("update-nome", "Reit");
                this.$parent.updateValueStep(5, "reits");
            } else if (this.step.id === 3 && this.step.tipo === "acoes" && this.campos_objetivo.pr_acoes) {
                this.$emit("update-nome", "A\xe7\xe3o");
                this.$parent.updateValueStep(5, "acoes");
            } else if (this.step.id === 3 && this.step.tipo === "fiis" && this.campos_objetivo.pr_fiis) {
                this.$emit("update-nome", "Fii");
                this.$parent.updateValueStep(5, "fiis");
            } else this.sucessConfirmation();
        },
        SendEmitForOpenAEspecificModal: function() {
            if (this.step.id === 1 && this.step.tipo === "titulos_inicio" && this.campos_objetivo.pr_renda_fixa) this.$emit("openModal", 5, "titulos_inicio");
            else if (this.step.id === 4 && this.step.tipo === "stocks" && this.campos_objetivo.pr_stocks) this.$emit("openModal", 5, "stocks");
            else if (this.step.id === 4 && this.step.tipo === "reits" && this.campos_objetivo.pr_reits) this.$emit("openModal", 5, "reits");
            else if (this.step.id === 3 && this.step.tipo === "acoes" && this.campos_objetivo.pr_acoes) this.$emit("openModal", 5, "acoes");
            else if (this.step.id === 3 && this.step.tipo === "fiis" && this.campos_objetivo.pr_fiis) this.$emit("openModal", 5, "fiis");
        },
        /* Envio do formulário */ onSubmitAction: function(param, nameInput1, nameInput2) {
            var _this = this;
            var currentTarget = param.currentTarget;
            var form = currentTarget;
            var cardItem = document.querySelector(".step-".concat(this.step.id));
            var inputs = (0, $79xu7._)(cardItem.querySelectorAll("input"));
            var _inputs = (0, $4f96i._)(inputs, 2), input1 = _inputs[0], input2 = _inputs[1];
            console.log(currentTarget, nameInput1, nameInput2);
            axios.patch("".concat(this.baseURL, "/api/objetivo/").concat(this.objetivos_api[0].id, "/"), (0, $8typN._)((0, $8pZMQ._)({}, this.campos_objetivo), {
                [nameInput1]: Number(input1.value),
                [nameInput2]: Number(input2.value)
            })).then(function(param) {
                var data = param.data;
                _this.wizardUpdate();
                _this.SendEmitForOpenAEspecificModal();
            }).catch(function(error) {
                GLOBAL.showToastify(error, "#DE4B4F");
                console.error(error);
            });
        },
        onSubmitActionInlineCase: function() {
            this.sucessConfirmation();
        },
        /* Reset */ resetModalForm: function() {
            this.novoObjetivo = {
                nome: "",
                porcentagem: ""
            };
        },
        handleClickInOptions: function(id) {
            this.showOptions = id;
            this.showOptionsFirst = true;
        },
        outsideClick: function(param) {
            var target = param.target;
            if (target.closest(".icone-three-points")) return;
            this.showOptionsFirst = false;
        },
        onCloseModal: function() {
            this.modalIsOpen = false;
            var valoresOriginais = this.objetivos[this.step.tipo].map(function(objetivo) {
                return (0, $8pZMQ._)({}, objetivo);
            });
            this.objetivos[this.step.tipo] = valoresOriginais;
            this.setNewObjectiveValueInOnKeyupEdit(false, true);
            this.pastTotalValue = 0;
            this.returnToOriginalValueObjetive();
            this.hasSameValue = false;
            this.showErrorOnModal = false;
            this.modalErrorMessage = "";
        },
        showai: function() {
            console.log(this.objetivos_api[0]);
        }
    },
    template: html($15043aedd156b5f2$var$_templateObject())
};
var $15043aedd156b5f2$export$2e2bcd8739ae039 = $15043aedd156b5f2$var$modalComplexo;




var $c4c9bed0678a7375$export$2e2bcd8739ae039 = {
    data: function() {
        return {
            dadosCardRendaPassiva: null
        };
    },
    mounted: function() {
        this.getDadosTabela();
    },
    methods: {
        formatReal: function(param) {
            return GLOBAL.FormatREALVirgula(param);
        },
        getDadosTabela: function() {
            var numPagina = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1, numLinhas = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 999;
            return (0, $a1727a7253abe12d$export$7c398597f8905a1)(function() {
                var base, url, data, _, err;
                return (0, $877235af7931ac6c$export$67ebef60e6f28a6)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                3,
                                ,
                                4
                            ]);
                            base = window.location.origin;
                            url = "".concat(base, "/api/eventos_provisionados/dividendos/?resumo=True");
                            return [
                                4,
                                axios.get(url)
                            ];
                        case 1:
                            data = _state.sent().data;
                            _ = this;
                            return [
                                4,
                                data
                            ];
                        case 2:
                            _.dadosCardRendaPassiva = _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 3:
                            err = _state.sent();
                            console.log(err);
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            }).apply(this);
        }
    },
    delimiters: [
        "{*",
        "*}"
    ]
};




var $8pZMQ = parcelRequire("8pZMQ");

var $4f96i = parcelRequire("4f96i");


var $9Wwts = parcelRequire("9Wwts");



var $jW8xq = parcelRequire("jW8xq");
var $3a55e7b45fb6c209$var$emptyValues = {
    aluguel_financiamento: null,
    agua_energia_gas: null,
    internet_tv_telefone: null,
    transporte_educacao: null,
    compras: null,
    plano_saude: null,
    lazer: null
};
var $3a55e7b45fb6c209$var$urlReservaEmergencia = window.location.origin + "/api/reserva_emergencia/";
var $3a55e7b45fb6c209$var$urlOpcoesTesouroSelic = window.location.origin + "/api/tesouro_direto/?ticker_symbol=Selic";
var $3a55e7b45fb6c209$var$urlMovimentacaoTesouro = window.location.origin + "/api/movimentacao_tesouro/";
var $3a55e7b45fb6c209$export$2e2bcd8739ae039 = {
    data: function() {
        return {
            tipoRequisicao: null,
            stepReservaEmergencia: 0,
            naoSeiPrecisoCalcular: true,
            isCalculating: false,
            objetivo_reserva: null,
            reserva_emergencia: null,
            quanto_falta_reserva: null,
            porcentagem_quanto_falta_reserva: "25%",
            isLoadingReservaEmergencia: true,
            valoresPayload: {
                id: null,
                idade: null,
                seguranca: null,
                tipo_mercado: null,
                facilidade_realocacao: null,
                dependentes: null,
                num_meses: null,
                custo_mensal: null,
                num_meses_manual: false,
                aluguel_financiamento: null,
                agua_energia_gas: null,
                internet_tv_telefone: null,
                transporte_educacao: null,
                compras: null,
                plano_saude: null,
                lazer: null
            },
            erros: [],
            isLoading: false,
            selectsHasFilled: false,
            hasValueInSearch: false,
            errorMessage: "",
            modalValueIsValid: true,
            inputIsInvalid: false,
            corretagem: "",
            optionsPadronizadas: [
                {
                    label: "Renda fixa",
                    value: "TesouroDireto",
                    id: 5
                }
            ],
            tesouroOptions: [],
            tipo_ativo: {
                id: 5,
                label: "Renda fixa",
                value: "TesouroDireto"
            },
            payloadModal: {
                ticker_symbol: "",
                reference_date: "",
                movement_type: "Compra",
                treasury_bonds_quantity: "",
                operation_value: ""
            },
            baseURL: window.location.origin
        };
    },
    computed: {
        isCalcularConsultaDisabled: function() {
            var calcularConsultaCondition = !this.valoresPayload.idade || !this.valoresPayload.seguranca || !this.valoresPayload.tipo_mercado || !this.valoresPayload.facilidade_realocacao || !this.valoresPayload.dependentes || // !this.valoresPayload.num_meses ||
            !this.valoresPayload.custo_mensal || this.isCalculating;
            return calcularConsultaCondition;
        },
        arrCustosMensais: function() {
            var arrCustos = [
                this.formatarMonetariaParaDecimal(this.valoresPayload.aluguel_financiamento),
                this.formatarMonetariaParaDecimal(this.valoresPayload.agua_energia_gas),
                this.formatarMonetariaParaDecimal(this.valoresPayload.internet_tv_telefone),
                this.formatarMonetariaParaDecimal(this.valoresPayload.transporte_educacao),
                this.formatarMonetariaParaDecimal(this.valoresPayload.compras),
                this.formatarMonetariaParaDecimal(this.valoresPayload.plano_saude),
                this.formatarMonetariaParaDecimal(this.valoresPayload.lazer)
            ];
            return arrCustos;
        },
        sumCustoMensal: function() {
            var arrCustos = [
                this.formatarMonetariaParaDecimal(this.valoresPayload.aluguel_financiamento),
                this.formatarMonetariaParaDecimal(this.valoresPayload.agua_energia_gas),
                this.formatarMonetariaParaDecimal(this.valoresPayload.internet_tv_telefone),
                this.formatarMonetariaParaDecimal(this.valoresPayload.transporte_educacao),
                this.formatarMonetariaParaDecimal(this.valoresPayload.compras),
                this.formatarMonetariaParaDecimal(this.valoresPayload.plano_saude),
                this.formatarMonetariaParaDecimal(this.valoresPayload.lazer)
            ];
            var soma = arrCustos.reduce(function(acc, valor) {
                return acc + (valor !== null && valor !== void 0 ? valor : 0);
            }, 0);
            return soma;
        },
        legendaSeguranca: function() {
            var legendaEscolha = "";
            if (this.valoresPayload.seguranca === 1) legendaEscolha = "Cargo onde tenho poucas chances de demiss\xe3o";
            else if (this.valoresPayload.seguranca === 2) legendaEscolha = "Cargo est\xe1vel, por\xe9m com alguma chance de demiss\xe3o";
            else if (this.valoresPayload.seguranca === 3) legendaEscolha = "Cargo onde h\xe1 pouca estabilidade";
            // Alto: Cargo onde tenho poucas chances de demissão
            // Médio: Cargo estável, porém com alguma chance de demissão
            // Baixo: Cargo onde há pouca estabilidade
            return legendaEscolha;
        },
        legendaTipoMercado: function() {
            var legendaEscolha = "";
            if (this.valoresPayload.tipo_mercado === 1) legendaEscolha = "Baixo risco de impacto em casos de crise - ex.: setores essenciais como sa\xfade ou aliment\xedcio";
            else if (this.valoresPayload.tipo_mercado === 2) legendaEscolha = "Pode ser impactado em casos de crise, ex.: ind\xfastria e setores ligados \xe0 ela como Marketing, RH, TI, etc";
            else if (this.valoresPayload.tipo_mercado === 3) legendaEscolha = "Grandes chances de ser impactado em casos de crises, ex.: com\xe9rcio";
            // Estável: Baixo risco de impacto em casos de crise - ex.: setores essenciais como saúde ou alimentício
            // Médio: Pode ser impactado em casos de crise, ex.: indústria e setores ligados à ela como Marketing, RH, TI, etc
            // Instável: Grandes chances de ser impactado em casos de crises, ex.: comércio
            return legendaEscolha;
        },
        legendaFacilidadeRealocacao: function() {
            var legendaEscolha = "";
            if (this.valoresPayload.facilidade_realocacao === 1) legendaEscolha = "F\xe1cil realoca\xe7\xe3o - mercado possui maior demanda do que oferta e voc\xea possui alta qualifica\xe7\xe3o";
            else if (this.valoresPayload.facilidade_realocacao === 2) legendaEscolha = "Realoca\xe7\xe3o m\xe9dia - mercado concorrido e possui qualifica\xe7\xe3o no mesmo n\xedvel que o mercado";
            else if (this.valoresPayload.facilidade_realocacao === 3) legendaEscolha = "Poss\xedvel dificuldade de realoca\xe7\xe3o - mercado saturado e com pouca oferta de emprego";
            // Baixa: Fácil realocação - mercado possui maior demanda do que oferta e você possui alta qualificação
            // Média: Realocação média - mercado concorrido e possui qualificação no mesmo nível que o mercado
            // Alta: Possível dificuldade de realocação - mercado saturado e com pouca oferta de emprego
            return legendaEscolha;
        },
        /////////////////////////////////////////////////////
        minDate: function() {
            var currentDate = new Date();
            console.log(currentDate);
            var minYear = currentDate.getFullYear() - 5;
            var min = new Date(currentDate);
            // Se o dia atual for sábado (6) ou domingo (0), ajuste minDate para o próximo dia útil (segunda-feira)
            if (min.getDay() === 6) {
                console.log("SABADO");
                min.setDate(min.getDate() + 2);
            } else if (min.getDay() === 0) {
                console.log("DOMINGO");
                min.setDate(min.getDate() + 1);
            } else {
                console.log("OUTRO DIA");
                min = new Date(minYear, min.getMonth(), min.getDate());
            }
            var isStockOrREIT = this.tipo_ativo === "Stock" || this.tipo_ativo === "REIT" || this.tipo_ativo && this.tipo_ativo.value === "Stock" || this.tipo_ativo && this.tipo_ativo.value === "REIT";
            // console.log(`${minYear}-${min.getMonth() + 1}-${min.getDate() + 1}`)				
            if (isStockOrREIT) {
                var dateCorrect = "".concat(min.getDay(), "/").concat(min.getMonth() + 1, "/").concat(min.getFullYear());
                return dateCorrect;
            }
            return "";
        }
    },
    watch: {
        sumCustoMensal: {
            handler: function handler(newVal, oldVal) {
                console.log("new Value is " + newVal);
            // this.valoresPayload.custo_mensal = newVal.toLocaleString().replaceAll('.', '')
            },
            deep: true
        },
        valoresPayload: {
            handler: function handler(newVal, oldVal) {
                var valoresIndividuais = {
                    aluguel_financiamento: newVal.aluguel_financiamento,
                    agua_energia_gas: newVal.agua_energia_gas,
                    internet_tv_telefone: newVal.internet_tv_telefone,
                    transporte_educacao: newVal.transporte_educacao,
                    compras: newVal.compras,
                    plano_saude: newVal.plano_saude,
                    lazer: newVal.lazer
                };
                if (!_.isEqual(valoresIndividuais, $3a55e7b45fb6c209$var$emptyValues)) // this.valoresPayload.custo_mensal = this.sumCustoMensal.toFixed(2).replace('.', ',')
                this.valoresPayload.custo_mensal = this.changeToMonetarioBrl(this.sumCustoMensal);
            },
            deep: true
        },
        stepReservaEmergencia: {
            handler: function handler(newVal, oldVal) {
                if (newVal === 0) this.applyModalAport();
            },
            deep: true
        }
    },
    methods: {
        changeToMonetarioBrl: function(valor) {
            if (!valor) return null;
            return valor.toLocaleString("pt-BR", {
                minimumFractionDigits: 2
            });
        },
        changeToFloatApi: function(valor) {
            if (valor == null || valor === "") return null;
            var str = String(valor).trim();
            // Formato BR: 1.234,56
            if (str.includes(",")) return str.replaceAll(".", "").replace(",", ".");
            // Maska com ###.## (ex.: 1.234.56): último segmento após '.' são centavos
            var dotParts = str.split(".");
            if (dotParts.length > 1) {
                var dec = dotParts[dotParts.length - 1];
                if (dec.length <= 2) return "".concat(dotParts.slice(0, -1).join(""), ".").concat(dec);
            }
            return str;
        },
        escolherOpcaoIdade: function(opcao, valor) {
            switch(opcao){
                case "idade":
                    this.valoresPayload.idade = valor;
                    break;
                case "seguranca":
                    this.valoresPayload.seguranca = valor;
                    break;
                case "tipo_mercado":
                    this.valoresPayload.tipo_mercado = valor;
                    break;
                case "facilidade_realocacao":
                    this.valoresPayload.facilidade_realocacao = valor;
                    break;
                case "dependentes":
                    this.valoresPayload.dependentes = valor;
                    break;
                default:
                    break;
            }
        },
        formatarMonetariaParaDecimal: function(monetaria) {
            if (!monetaria) return null;
            var mon = monetaria.replaceAll(".", "");
            // Remove os caracteres que não são números, ponto ou vírgula
            var numero = mon.replace(/[^\d.,-]/g, "");
            // Substitui a vírgula decimal por ponto, se necessário
            if (numero.includes(",")) numero = numero.replace(",", ".");
            // Encontra a posição do ponto decimal
            var pontoPos = numero.indexOf(".");
            if (pontoPos !== -1) // Trunca a string para duas casas decimais após o ponto
            numero = numero.substring(0, pontoPos + 3);
            // Converte a string para um número decimal
            return parseFloat(numero);
        },
        truncateDecimals: function(input) {
            // Expressão regular para encontrar números decimais
            var regex = /(\d+\,\d{2})\d*/g;
            // Função de callback para truncar o número
            var truncatedInput = input.replace(regex, function(match, p1) {
                return p1;
            });
            return truncatedInput;
        },
        clearValoresIndividuais: function() {
            this.valoresPayload.aluguel_financiamento = null;
            this.valoresPayload.agua_energia_gas = null;
            this.valoresPayload.internet_tv_telefone = null;
            this.valoresPayload.transporte_educacao = null;
            this.valoresPayload.compras = null;
            this.valoresPayload.plano_saude = null;
            this.valoresPayload.lazer = null;
        },
        validateValueInputPrice: function(event, payloadName) {
            console.log(event.target.value);
            this[payloadName][event.target.name] = event.target.value;
        },
        validateValueInputQuantity: function(event) {
            var inputValue = event.target.value;
            var numerosValidos = false;
            var removerCaracteres = function(string, regexValue) {
                return string.replace(regexValue, "");
            };
            numerosValidos = /^[0-9]+$/.test(inputValue);
            if (!numerosValidos) event.target.value = removerCaracteres(inputValue, /[^0-9]/g);
        },
        calcularPorcentagem: function(parte, total) {
            if (total === 0) return 0;
            var porcentagem = parte / total * 100;
            var procentagemDuasCasas = Math.round((porcentagem + Number.EPSILON) * 100) / 100;
            return "".concat(procentagemDuasCasas, "%");
        // return Math.round((porcentagem + Number.EPSILON) * 100) / 100
        },
        setarValoresQuadroObjetivo: function(valor) {
            var subtracaoObjetivoReserva = valor.objetivo_reserva - valor.reserva_emergencia;
            this.objetivo_reserva = valor.objetivo_reserva === 0 ? valor.objetivo_reserva.toFixed(2).replace(".", ",") : this.changeToMonetarioBrl(valor.objetivo_reserva);
            this.reserva_emergencia = valor.reserva_emergencia === 0 ? valor.reserva_emergencia.toFixed(2).replace(".", ",") : this.changeToMonetarioBrl(valor.reserva_emergencia);
            this.quanto_falta_reserva = subtracaoObjetivoReserva === 0 ? subtracaoObjetivoReserva.toFixed(2).replace(".", ",") : this.changeToMonetarioBrl(subtracaoObjetivoReserva);
            this.porcentagem_quanto_falta_reserva = this.calcularPorcentagem(parseFloat(valor.reserva_emergencia), valor.objetivo_reserva);
        },
        getDadosReservaEmergencia: function() {
            return (0, $a1727a7253abe12d$export$7c398597f8905a1)(function() {
                var data, error;
                return (0, $877235af7931ac6c$export$67ebef60e6f28a6)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                3,
                                4
                            ]);
                            this.isLoadingReservaEmergencia = true;
                            return [
                                4,
                                axios.get($3a55e7b45fb6c209$var$urlReservaEmergencia)
                            ];
                        case 1:
                            data = _state.sent().data;
                            if (data.length > 0) {
                                this.tipoRequisicao = "PATCH";
                                this.valoresPayload = {
                                    id: data[0].id,
                                    idade: data[0].idade,
                                    seguranca: data[0].seguranca,
                                    tipo_mercado: data[0].tipo_mercado,
                                    facilidade_realocacao: data[0].facilidade_realocacao,
                                    dependentes: data[0].dependentes,
                                    num_meses: data[0].num_meses,
                                    num_meses_manual: data[0].num_meses_manual,
                                    custo_mensal: !Boolean(parseFloat(data[0].custo_mensal)) ? null : this.changeToMonetarioBrl(parseFloat(data[0].custo_mensal)),
                                    aluguel_financiamento: !Boolean(parseFloat(data[0].aluguel_financiamento)) ? null : this.changeToMonetarioBrl(parseFloat(data[0].aluguel_financiamento)),
                                    agua_energia_gas: !Boolean(parseFloat(data[0].agua_energia_gas)) ? null : this.changeToMonetarioBrl(parseFloat(data[0].agua_energia_gas)),
                                    internet_tv_telefone: !Boolean(parseFloat(data[0].internet_tv_telefone)) ? null : this.changeToMonetarioBrl(parseFloat(data[0].internet_tv_telefone)),
                                    transporte_educacao: !Boolean(parseFloat(data[0].transporte_educacao)) ? null : this.changeToMonetarioBrl(parseFloat(data[0].transporte_educacao)),
                                    compras: !Boolean(parseFloat(data[0].compras)) ? null : this.changeToMonetarioBrl(parseFloat(data[0].compras)),
                                    plano_saude: !Boolean(parseFloat(data[0].plano_saude)) ? null : this.changeToMonetarioBrl(parseFloat(data[0].plano_saude)),
                                    lazer: !Boolean(parseFloat(data[0].lazer)) ? null : this.changeToMonetarioBrl(parseFloat(data[0].lazer))
                                };
                                this.setarValoresQuadroObjetivo(data[0]);
                            } else this.tipoRequisicao = "POST";
                            return [
                                3,
                                4
                            ];
                        case 2:
                            error = _state.sent();
                            console.log(error);
                            return [
                                3,
                                4
                            ];
                        case 3:
                            this.isLoadingReservaEmergencia = false;
                            return [
                                7
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            }).apply(this);
        },
        onInputCustoMensal: function(event) {
            this.validateValueInputPrice(event, "valoresPayload");
            var valoresIndividuais = {
                aluguel_financiamento: this.valoresPayload.aluguel_financiamento,
                agua_energia_gas: this.valoresPayload.agua_energia_gas,
                internet_tv_telefone: this.valoresPayload.internet_tv_telefone,
                transporte_educacao: this.valoresPayload.transporte_educacao,
                compras: this.valoresPayload.compras,
                plano_saude: this.valoresPayload.plano_saude,
                lazer: this.valoresPayload.lazer
            };
            if (!_.isEqual(valoresIndividuais, $3a55e7b45fb6c209$var$emptyValues) && this.sumCustoMensal !== this.formatarMonetariaParaDecimal(event.target.value)) this.clearValoresIndividuais();
        },
        calcularReservaEmergencia: function() {
            return (0, $a1727a7253abe12d$export$7c398597f8905a1)(function() {
                var payloadReservaEmergencia, data, _tmp, error;
                return (0, $877235af7931ac6c$export$67ebef60e6f28a6)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            payloadReservaEmergencia = (0, $8pZMQ._)({}, this.valoresPayload);
                            payloadReservaEmergencia.custo_mensal = this.changeToFloatApi(payloadReservaEmergencia.custo_mensal);
                            payloadReservaEmergencia.aluguel_financiamento = parseFloat(payloadReservaEmergencia.aluguel_financiamento) === 0 ? null : this.changeToFloatApi(payloadReservaEmergencia.aluguel_financiamento);
                            payloadReservaEmergencia.agua_energia_gas = parseFloat(payloadReservaEmergencia.agua_energia_gas) === 0 ? null : this.changeToFloatApi(payloadReservaEmergencia.agua_energia_gas);
                            payloadReservaEmergencia.internet_tv_telefone = parseFloat(payloadReservaEmergencia.internet_tv_telefone) === 0 ? null : this.changeToFloatApi(payloadReservaEmergencia.internet_tv_telefone);
                            payloadReservaEmergencia.transporte_educacao = parseFloat(payloadReservaEmergencia.transporte_educacao) === 0 ? null : this.changeToFloatApi(payloadReservaEmergencia.transporte_educacao);
                            payloadReservaEmergencia.compras = parseFloat(payloadReservaEmergencia.compras) === 0 ? null : this.changeToFloatApi(payloadReservaEmergencia.compras);
                            payloadReservaEmergencia.plano_saude = parseFloat(payloadReservaEmergencia.plano_saude) === 0 ? null : this.changeToFloatApi(payloadReservaEmergencia.plano_saude);
                            payloadReservaEmergencia.lazer = parseFloat(payloadReservaEmergencia.lazer) === 0 ? null : this.changeToFloatApi(payloadReservaEmergencia.lazer);
                            if (!payloadReservaEmergencia.num_meses || !payloadReservaEmergencia.num_meses_manual) delete payloadReservaEmergencia.num_meses;
                            if (!payloadReservaEmergencia.num_meses) {
                                this.valoresPayload.num_meses_manual = false;
                                payloadReservaEmergencia.num_meses_manual = false;
                            }
                            delete payloadReservaEmergencia.id;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                6,
                                7,
                                8
                            ]);
                            this.isCalculating = true;
                            if (!(this.tipoRequisicao === "POST")) return [
                                3,
                                3
                            ];
                            return [
                                4,
                                axios.post($3a55e7b45fb6c209$var$urlReservaEmergencia, payloadReservaEmergencia)
                            ];
                        case 2:
                            _tmp = _state.sent();
                            return [
                                3,
                                5
                            ];
                        case 3:
                            return [
                                4,
                                axios.patch("".concat($3a55e7b45fb6c209$var$urlReservaEmergencia).concat(this.valoresPayload.id, "/"), payloadReservaEmergencia)
                            ];
                        case 4:
                            _tmp = _state.sent();
                            _state.label = 5;
                        case 5:
                            data = _tmp.data;
                            this.setarValoresQuadroObjetivo(data);
                            this.valoresPayload.custo_mensal = parseFloat(data.custo_mensal) === 0 ? parseFloat(data.custo_mensal).toFixed(2).replace(".", ",") : parseFloat(data.custo_mensal).toLocaleString();
                            this.valoresPayload.num_meses = data.num_meses;
                            this.valoresPayload.id = data.id;
                            if (this.tipoRequisicao === "POST") this.tipoRequisicao = "PATCH";
                            console.log(data);
                            return [
                                3,
                                8
                            ];
                        case 6:
                            error = _state.sent();
                            console.log(error);
                            return [
                                3,
                                8
                            ];
                        case 7:
                            this.isCalculating = false;
                            return [
                                7
                            ];
                        case 8:
                            return [
                                2
                            ];
                    }
                });
            }).apply(this);
        },
        setPreviousURL: function() {
            // history.pushState({ previousURL: window.location.href }, '', 'reserva-emergencia');
            localStorage.setItem("lastRoute", "reserva-emergencia");
        },
        irCalculoReservaEmergencia: function() {
            this.stepReservaEmergencia = 1;
            this.applyMonetaryMask();
        },
        cancelarReservaEmergencia: function() {
            return (0, $a1727a7253abe12d$export$7c398597f8905a1)(function() {
                return (0, $877235af7931ac6c$export$67ebef60e6f28a6)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            this.stepReservaEmergencia = 0;
                            return [
                                4,
                                this.getDadosReservaEmergencia()
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            }).apply(this);
        },
        applyMonetaryMask: function() {
            setTimeout(function() {
                $(".mask-money").maskMoney({
                    thousands: ".",
                    decimal: ","
                });
            }, 500);
        },
        applyModalAport: function() {
            setTimeout(function() {
                ModalX(".modal-novo-ativo", {
                    deep: true,
                    zIndex: 300000,
                    zIndexDeep: 20000,
                    closeOnDeep: false,
                    bgModal: "rgb(30,33,36)"
                }).init();
            }, 500);
        },
        //////////////////// Funções Modal Novo Aporte /////////////////////////////////
        handleSearchSelect: function(opcaoSelecionada) {
            if (!opcaoSelecionada.value) {
                this.hasValueInSearch = false;
                return;
            }
            this.hasValueInSearch = true;
            this.selectsHasFilled = true;
            this.payloadModal.ticker_symbol = opcaoSelecionada.value;
        },
        validateValueInputPriceAporte: function(event) {
            var inputValue = event.target.value;
            var numerosValidos = /^\d+(,\d{1,2})?$/.test(inputValue);
            var removerCaracteres = function(string) {
                return string.replace(/[^\d,]|(,\d{3,})|(,\d{1,2}\D)/g, "");
            };
            if (!numerosValidos) event.target.value = removerCaracteres(inputValue);
        },
        format: function(date) {
            var day = date.getDate();
            var month = date.getMonth() + 1;
            var year = date.getFullYear();
            return "".concat(day, "/").concat(month, "/").concat(year);
        },
        disableDates: function(date) {
            var today = new Date();
            var dayOfWeek = date.getDay(); // obter o dia da semana da data
            return date > today || dayOfWeek === 0 || dayOfWeek === 6; // desabilitar datas maiores que hoje ou em fins de semana
        },
        validateModalFields: function(param) {
            var target = param.target;
            console.log(target);
            var isNullish = Object.entries(this.payloadModal).some(function(param) {
                var _param = (0, $4f96i._)(param, 2), key = _param[0], value = _param[1];
                if (key == "corretagem") return;
                if (!value) return true;
                return false;
            });
            this.modalValueIsValid = Boolean(!isNullish);
        },
        openModalNovoAporte: function(valor, idSelectTipo, idSelectBusca, e) {
            return (0, $a1727a7253abe12d$export$7c398597f8905a1)(function() {
                var data, error;
                return (0, $877235af7931ac6c$export$67ebef60e6f28a6)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                3,
                                4
                            ]);
                            return [
                                4,
                                axios.get($3a55e7b45fb6c209$var$urlOpcoesTesouroSelic)
                            ];
                        case 1:
                            data = _state.sent().data;
                            console.log(data);
                            this.tesouroOptions = data.map(function(param) {
                                var ticker_symbol = param.ticker_symbol;
                                return {
                                    value: ticker_symbol,
                                    label: ticker_symbol
                                };
                            });
                            this.hasValueInSearch = true;
                            this.selectsHasFilled = true;
                            return [
                                3,
                                4
                            ];
                        case 2:
                            error = _state.sent();
                            GLOBAL.showToastify(error);
                            console.error(error);
                            return [
                                3,
                                4
                            ];
                        case 3:
                            this.applyMonetaryMask();
                            return [
                                7
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            // this.compareValues()
            }).apply(this);
        },
        onSearch: function(search, loading) {
            if (search.length) {
                loading(true);
                this.getDataOnSearchSelect(loading, search, this);
            }
        },
        getDataOnSearchSelect: (0, $9Wwts.debounce)(function() {
            var _ref = (0, $a1727a7253abe12d$export$7c398597f8905a1)(function(loading, search, vm) {
                var data, response4, dadosRecebidos, error;
                return (0, $877235af7931ac6c$export$67ebef60e6f28a6)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                3,
                                4,
                                5
                            ]);
                            return [
                                4,
                                fetch("".concat(this.baseURL, "/api/tesouro_direto/?ticker_symbol=").concat(search))
                            ];
                        case 1:
                            response4 = _state.sent();
                            return [
                                4,
                                response4.json()
                            ];
                        case 2:
                            dadosRecebidos = _state.sent();
                            data = dadosRecebidos.filter(function(param) {
                                var ticker_symbol = param.ticker_symbol;
                                return ticker_symbol !== "Tesouro Selic";
                            });
                            this.tesouroOptions = data.map(function(param) {
                                var ticker_symbol = param.ticker_symbol, tem_info_dividendo = param.tem_info_dividendo;
                                return {
                                    value: ticker_symbol,
                                    label: ticker_symbol,
                                    tem_info_dividendo: tem_info_dividendo
                                };
                            });
                            loading(false);
                            this.isLoading = false;
                            return [
                                3,
                                5
                            ];
                        case 3:
                            error = _state.sent();
                            GLOBAL.showToastify(error);
                            console.error(error);
                            return [
                                3,
                                5
                            ];
                        case 4:
                            loading(false);
                            this.isLoading = false;
                            return [
                                7
                            ];
                        case 5:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(loading, search, vm) {
                return _ref.apply(this, arguments);
            };
        }(), 600),
        changeVirgulaToComma: function(value) {
            return value.replace(",", ".");
        },
        validateInput: function() {
            this.erros = [];
            if (!this.payloadModal.treasury_bonds_quantity) this.erros.push("Informe a quantidade!");
            if (parseFloat(this.changeToFloatApi(this.payloadModal.treasury_bonds_quantity)) === 0) this.erros.push("A quantidade deve ser maior que zero!");
            if (!this.payloadModal.reference_date) this.erros.push("Informe a data de compra!");
            if (!this.payloadModal.operation_value) this.erros.push("Informe o pre\xe7o de venda!");
            if (parseFloat(this.changeToFloatApi(this.payloadModal.operation_value)) === 0) this.erros.push("O pre\xe7o de venda deve ser maior que zero!");
            if (!this.payloadModal.ticker_symbol) this.erros.push("Informe o ativo!");
        },
        showToastifyOnErrorInputs: function() {
            if (this.erros.length) {
                this.modalValueIsValid = false;
                this.erros.forEach(function(i) {
                    GLOBAL.showToastify(i, "#DE4B4F");
                    return;
                });
            }
        },
        onSubmitModalNovoAporte: function(param) {
            var currentTarget = param.currentTarget;
            return (0, $a1727a7253abe12d$export$7c398597f8905a1)(function() {
                var _this, payloadMovimentacaoTesouro, self, form, productType, error;
                return (0, $877235af7931ac6c$export$67ebef60e6f28a6)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _this = this;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                5,
                                ,
                                6
                            ]);
                            payloadMovimentacaoTesouro = (0, $8pZMQ._)({}, this.payloadModal);
                            self = this;
                            form = currentTarget.closest("form");
                            this.erros = [];
                            this.validateInput();
                            this.showToastifyOnErrorInputs();
                            if (!!this.erros.length) return [
                                3,
                                4
                            ];
                            this.tipo_ativo = this.tipo_ativo.value || this.tipo_ativo;
                            productType = document.createElement("input");
                            productType.type = "hidden";
                            productType.name = "product_type";
                            productType.value = this.tipo_ativo;
                            form.appendChild(productType);
                            this.isLoading = true;
                            // form.submit();
                            payloadMovimentacaoTesouro.reference_date = (0, $jW8xq.date).formatDate(payloadMovimentacaoTesouro.reference_date, "YYYY-MM-DD");
                            payloadMovimentacaoTesouro.treasury_bonds_quantity = this.changeToFloatApi(payloadMovimentacaoTesouro.treasury_bonds_quantity);
                            payloadMovimentacaoTesouro.operation_value = this.changeToFloatApi(payloadMovimentacaoTesouro.operation_value);
                            return [
                                4,
                                axios.post($3a55e7b45fb6c209$var$urlMovimentacaoTesouro, payloadMovimentacaoTesouro)
                            ];
                        case 2:
                            _state.sent();
                            return [
                                4,
                                this.getDadosReservaEmergencia()
                            ];
                        case 3:
                            _state.sent();
                            setTimeout(function() {
                                document.querySelector("[data-xclose]").click();
                                self.applyModalAport();
                                _this.isLoading = false;
                            }, 1000);
                            _state.label = 4;
                        case 4:
                            return [
                                3,
                                6
                            ];
                        case 5:
                            error = _state.sent();
                            console.error(error);
                            return [
                                3,
                                6
                            ];
                        case 6:
                            return [
                                2
                            ];
                    }
                });
            }).apply(this);
        },
        onCloseModal: function() {
            this.clearStates();
        },
        clearStates: function() {
            this.hasValueInSearch = false;
            this.selectsHasFilled = false;
            this.modalValueIsValid = true;
            this.showError = false;
            this.errorMessage = "";
            this.payloadModal = {
                movement_type: "Compra",
                ticker_symbol: "",
                treasury_bonds_quantity: "",
                reference_date: "",
                operation_value: "",
                corretagem: ""
            };
        }
    },
    mounted: function() {
        return (0, $a1727a7253abe12d$export$7c398597f8905a1)(function() {
            return (0, $877235af7931ac6c$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            this.getDadosReservaEmergencia()
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        }).apply(this);
    },
    delimiters: [
        "{*",
        "*}"
    ]
};




var $8pZMQ = parcelRequire("8pZMQ");


var $8pZMQ = parcelRequire("8pZMQ");

var $8typN = parcelRequire("8typN");
parcelRequire("5eKWL");
var $aD8ZA = parcelRequire("aD8ZA");

var $iJSF3 = parcelRequire("iJSF3");

var $luoZD = parcelRequire("luoZD");

var $fYUO3 = parcelRequire("fYUO3");

var $9WbNX = parcelRequire("9WbNX");

var $3Oamm = parcelRequire("3Oamm");

var $7DbRq = parcelRequire("7DbRq");

var $4f96i = parcelRequire("4f96i");

var $79xu7 = parcelRequire("79xu7");

var $ju9pQ = parcelRequire("ju9pQ");

var $4a7Gb = parcelRequire("4a7Gb");

var $ihX0O = parcelRequire("ihX0O");
parcelRequire("7hN3J");
var $782b2550ae753193$export$794e7bef9c0b12d9 = [];
var $782b2550ae753193$var$MINIMAL_RAW_EN_LOCALE = {
    code: "en",
    week: {
        dow: 0,
        doy: 4
    },
    direction: "ltr",
    buttonText: {
        prev: "prev",
        next: "next",
        prevYear: "prev year",
        nextYear: "next year",
        year: "year",
        today: "today",
        month: "month",
        week: "week",
        day: "day",
        list: "list"
    },
    weekText: "W",
    weekTextLong: "Week",
    closeHint: "Close",
    timeHint: "Time",
    eventHint: "Event",
    allDayText: "all-day",
    moreLinkText: "more",
    noEventsText: "No events to display"
};
var $782b2550ae753193$var$RAW_EN_LOCALE = Object.assign(Object.assign({}, $782b2550ae753193$var$MINIMAL_RAW_EN_LOCALE), {
    // Includes things we don't want other locales to inherit,
    // things that derive from other translatable strings.
    buttonHints: {
        prev: "Previous $0",
        next: "Next $0",
        today: function(buttonText, unit) {
            return unit === "day" ? "Today" : "This ".concat(buttonText);
        }
    },
    viewHint: "$0 view",
    navLinkHint: "Go to $0",
    moreLinkHint: function(eventCnt) {
        return "Show ".concat(eventCnt, " more event").concat(eventCnt === 1 ? "" : "s");
    }
});
function $782b2550ae753193$var$organizeRawLocales(explicitRawLocales) {
    var defaultCode = explicitRawLocales.length > 0 ? explicitRawLocales[0].code : "en";
    var allRawLocales = $782b2550ae753193$export$794e7bef9c0b12d9.concat(explicitRawLocales);
    var rawLocaleMap = {
        en: $782b2550ae753193$var$RAW_EN_LOCALE
    };
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = allRawLocales[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var rawLocale = _step.value;
            rawLocaleMap[rawLocale.code] = rawLocale;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return {
        map: rawLocaleMap,
        defaultCode: defaultCode
    };
}
function $782b2550ae753193$var$buildLocale(inputSingular, available) {
    if (typeof inputSingular === "object" && !Array.isArray(inputSingular)) return $782b2550ae753193$var$parseLocale(inputSingular.code, [
        inputSingular.code
    ], inputSingular);
    return $782b2550ae753193$var$queryLocale(inputSingular, available);
}
function $782b2550ae753193$var$queryLocale(codeArg, available) {
    var codes = [].concat(codeArg || []); // will convert to array
    var raw = $782b2550ae753193$var$queryRawLocale(codes, available) || $782b2550ae753193$var$RAW_EN_LOCALE;
    return $782b2550ae753193$var$parseLocale(codeArg, codes, raw);
}
function $782b2550ae753193$var$queryRawLocale(codes, available) {
    for(var i = 0; i < codes.length; i += 1){
        var parts = codes[i].toLocaleLowerCase().split("-");
        for(var j = parts.length; j > 0; j -= 1){
            var simpleId = parts.slice(0, j).join("-");
            if (available[simpleId]) return available[simpleId];
        }
    }
    return null;
}
function $782b2550ae753193$var$parseLocale(codeArg, codes, raw) {
    var merged = (0, $4a7Gb.m)([
        $782b2550ae753193$var$MINIMAL_RAW_EN_LOCALE,
        raw
    ], [
        "buttonText"
    ]);
    delete merged.code; // don't want this part of the options
    var week = merged.week;
    delete merged.week;
    return {
        codeArg: codeArg,
        codes: codes,
        week: week,
        simpleNumberFormat: new Intl.NumberFormat(codeArg),
        options: merged
    };
}
// TODO: easier way to add new hooks? need to update a million things
function $782b2550ae753193$export$ae829ec7b2625219(input) {
    return {
        id: (0, $4a7Gb.g)(),
        name: input.name,
        premiumReleaseDate: input.premiumReleaseDate ? new Date(input.premiumReleaseDate) : undefined,
        deps: input.deps || [],
        reducers: input.reducers || [],
        isLoadingFuncs: input.isLoadingFuncs || [],
        contextInit: [].concat(input.contextInit || []),
        eventRefiners: input.eventRefiners || {},
        eventDefMemberAdders: input.eventDefMemberAdders || [],
        eventSourceRefiners: input.eventSourceRefiners || {},
        isDraggableTransformers: input.isDraggableTransformers || [],
        eventDragMutationMassagers: input.eventDragMutationMassagers || [],
        eventDefMutationAppliers: input.eventDefMutationAppliers || [],
        dateSelectionTransformers: input.dateSelectionTransformers || [],
        datePointTransforms: input.datePointTransforms || [],
        dateSpanTransforms: input.dateSpanTransforms || [],
        views: input.views || {},
        viewPropsTransformers: input.viewPropsTransformers || [],
        isPropsValid: input.isPropsValid || null,
        externalDefTransforms: input.externalDefTransforms || [],
        viewContainerAppends: input.viewContainerAppends || [],
        eventDropTransformers: input.eventDropTransformers || [],
        componentInteractions: input.componentInteractions || [],
        calendarInteractions: input.calendarInteractions || [],
        themeClasses: input.themeClasses || {},
        eventSourceDefs: input.eventSourceDefs || [],
        cmdFormatter: input.cmdFormatter,
        recurringTypes: input.recurringTypes || [],
        namedTimeZonedImpl: input.namedTimeZonedImpl,
        initialView: input.initialView || "",
        elementDraggingImpl: input.elementDraggingImpl,
        optionChangeHandlers: input.optionChangeHandlers || {},
        scrollGridImpl: input.scrollGridImpl || null,
        listenerRefiners: input.listenerRefiners || {},
        optionRefiners: input.optionRefiners || {},
        propSetHandlers: input.propSetHandlers || {}
    };
}
function $782b2550ae753193$var$buildPluginHooks(pluginDefs, globalDefs) {
    var currentPluginIds = {};
    var hooks = {
        premiumReleaseDate: undefined,
        reducers: [],
        isLoadingFuncs: [],
        contextInit: [],
        eventRefiners: {},
        eventDefMemberAdders: [],
        eventSourceRefiners: {},
        isDraggableTransformers: [],
        eventDragMutationMassagers: [],
        eventDefMutationAppliers: [],
        dateSelectionTransformers: [],
        datePointTransforms: [],
        dateSpanTransforms: [],
        views: {},
        viewPropsTransformers: [],
        isPropsValid: null,
        externalDefTransforms: [],
        viewContainerAppends: [],
        eventDropTransformers: [],
        componentInteractions: [],
        calendarInteractions: [],
        themeClasses: {},
        eventSourceDefs: [],
        cmdFormatter: null,
        recurringTypes: [],
        namedTimeZonedImpl: null,
        initialView: "",
        elementDraggingImpl: null,
        optionChangeHandlers: {},
        scrollGridImpl: null,
        listenerRefiners: {},
        optionRefiners: {},
        propSetHandlers: {}
    };
    function addDefs(defs) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = defs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var def = _step.value;
                var pluginName = def.name;
                var currentId = currentPluginIds[pluginName];
                if (currentId === undefined) {
                    currentPluginIds[pluginName] = def.id;
                    addDefs(def.deps);
                    hooks = $782b2550ae753193$var$combineHooks(hooks, def);
                } else if (currentId !== def.id) // different ID than the one already added
                console.warn("Duplicate plugin '".concat(pluginName, "'"));
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    if (pluginDefs) addDefs(pluginDefs);
    addDefs(globalDefs);
    return hooks;
}
function $782b2550ae753193$var$buildBuildPluginHooks() {
    var currentOverrideDefs = [];
    var currentGlobalDefs = [];
    var currentHooks;
    return function(overrideDefs, globalDefs) {
        if (!currentHooks || !(0, $4a7Gb.i)(overrideDefs, currentOverrideDefs) || !(0, $4a7Gb.i)(globalDefs, currentGlobalDefs)) currentHooks = $782b2550ae753193$var$buildPluginHooks(overrideDefs, globalDefs);
        currentOverrideDefs = overrideDefs;
        currentGlobalDefs = globalDefs;
        return currentHooks;
    };
}
function $782b2550ae753193$var$combineHooks(hooks0, hooks1) {
    return {
        premiumReleaseDate: $782b2550ae753193$var$compareOptionalDates(hooks0.premiumReleaseDate, hooks1.premiumReleaseDate),
        reducers: hooks0.reducers.concat(hooks1.reducers),
        isLoadingFuncs: hooks0.isLoadingFuncs.concat(hooks1.isLoadingFuncs),
        contextInit: hooks0.contextInit.concat(hooks1.contextInit),
        eventRefiners: Object.assign(Object.assign({}, hooks0.eventRefiners), hooks1.eventRefiners),
        eventDefMemberAdders: hooks0.eventDefMemberAdders.concat(hooks1.eventDefMemberAdders),
        eventSourceRefiners: Object.assign(Object.assign({}, hooks0.eventSourceRefiners), hooks1.eventSourceRefiners),
        isDraggableTransformers: hooks0.isDraggableTransformers.concat(hooks1.isDraggableTransformers),
        eventDragMutationMassagers: hooks0.eventDragMutationMassagers.concat(hooks1.eventDragMutationMassagers),
        eventDefMutationAppliers: hooks0.eventDefMutationAppliers.concat(hooks1.eventDefMutationAppliers),
        dateSelectionTransformers: hooks0.dateSelectionTransformers.concat(hooks1.dateSelectionTransformers),
        datePointTransforms: hooks0.datePointTransforms.concat(hooks1.datePointTransforms),
        dateSpanTransforms: hooks0.dateSpanTransforms.concat(hooks1.dateSpanTransforms),
        views: Object.assign(Object.assign({}, hooks0.views), hooks1.views),
        viewPropsTransformers: hooks0.viewPropsTransformers.concat(hooks1.viewPropsTransformers),
        isPropsValid: hooks1.isPropsValid || hooks0.isPropsValid,
        externalDefTransforms: hooks0.externalDefTransforms.concat(hooks1.externalDefTransforms),
        viewContainerAppends: hooks0.viewContainerAppends.concat(hooks1.viewContainerAppends),
        eventDropTransformers: hooks0.eventDropTransformers.concat(hooks1.eventDropTransformers),
        calendarInteractions: hooks0.calendarInteractions.concat(hooks1.calendarInteractions),
        componentInteractions: hooks0.componentInteractions.concat(hooks1.componentInteractions),
        themeClasses: Object.assign(Object.assign({}, hooks0.themeClasses), hooks1.themeClasses),
        eventSourceDefs: hooks0.eventSourceDefs.concat(hooks1.eventSourceDefs),
        cmdFormatter: hooks1.cmdFormatter || hooks0.cmdFormatter,
        recurringTypes: hooks0.recurringTypes.concat(hooks1.recurringTypes),
        namedTimeZonedImpl: hooks1.namedTimeZonedImpl || hooks0.namedTimeZonedImpl,
        initialView: hooks0.initialView || hooks1.initialView,
        elementDraggingImpl: hooks0.elementDraggingImpl || hooks1.elementDraggingImpl,
        optionChangeHandlers: Object.assign(Object.assign({}, hooks0.optionChangeHandlers), hooks1.optionChangeHandlers),
        scrollGridImpl: hooks1.scrollGridImpl || hooks0.scrollGridImpl,
        listenerRefiners: Object.assign(Object.assign({}, hooks0.listenerRefiners), hooks1.listenerRefiners),
        optionRefiners: Object.assign(Object.assign({}, hooks0.optionRefiners), hooks1.optionRefiners),
        propSetHandlers: Object.assign(Object.assign({}, hooks0.propSetHandlers), hooks1.propSetHandlers)
    };
}
function $782b2550ae753193$var$compareOptionalDates(date0, date1) {
    if (date0 === undefined) return date1;
    if (date1 === undefined) return date0;
    return new Date(Math.max(date0.valueOf(), date1.valueOf()));
}
var $782b2550ae753193$var$StandardTheme = /*#__PURE__*/ function(Theme) {
    "use strict";
    (0, $7DbRq._)(StandardTheme, Theme);
    var _super = (0, $ju9pQ._)(StandardTheme);
    function StandardTheme() {
        (0, $luoZD._)(this, StandardTheme);
        return _super.apply(this, arguments);
    }
    return StandardTheme;
}((0, $4a7Gb.T));
$782b2550ae753193$var$StandardTheme.prototype.classes = {
    root: "fc-theme-standard",
    tableCellShaded: "fc-cell-shaded",
    buttonGroup: "fc-button-group",
    button: "fc-button fc-button-primary",
    buttonActive: "fc-button-active"
};
$782b2550ae753193$var$StandardTheme.prototype.baseIconClass = "fc-icon";
$782b2550ae753193$var$StandardTheme.prototype.iconClasses = {
    close: "fc-icon-x",
    prev: "fc-icon-chevron-left",
    next: "fc-icon-chevron-right",
    prevYear: "fc-icon-chevrons-left",
    nextYear: "fc-icon-chevrons-right"
};
$782b2550ae753193$var$StandardTheme.prototype.rtlIconClasses = {
    prev: "fc-icon-chevron-right",
    next: "fc-icon-chevron-left",
    prevYear: "fc-icon-chevrons-right",
    nextYear: "fc-icon-chevrons-left"
};
$782b2550ae753193$var$StandardTheme.prototype.iconOverrideOption = "buttonIcons"; // TODO: make TS-friendly
$782b2550ae753193$var$StandardTheme.prototype.iconOverrideCustomButtonOption = "icon";
$782b2550ae753193$var$StandardTheme.prototype.iconOverridePrefix = "fc-icon-";
function $782b2550ae753193$var$compileViewDefs(defaultConfigs, overrideConfigs) {
    var hash = {};
    var viewType;
    for(viewType in defaultConfigs)$782b2550ae753193$var$ensureViewDef(viewType, hash, defaultConfigs, overrideConfigs);
    for(viewType in overrideConfigs)$782b2550ae753193$var$ensureViewDef(viewType, hash, defaultConfigs, overrideConfigs);
    return hash;
}
function $782b2550ae753193$var$ensureViewDef(viewType, hash, defaultConfigs, overrideConfigs) {
    if (hash[viewType]) return hash[viewType];
    var viewDef = $782b2550ae753193$var$buildViewDef(viewType, hash, defaultConfigs, overrideConfigs);
    if (viewDef) hash[viewType] = viewDef;
    return viewDef;
}
function $782b2550ae753193$var$buildViewDef(viewType, hash, defaultConfigs, overrideConfigs) {
    var defaultConfig = defaultConfigs[viewType];
    var overrideConfig = overrideConfigs[viewType];
    var queryProp = function(name) {
        return defaultConfig && defaultConfig[name] !== null ? defaultConfig[name] : overrideConfig && overrideConfig[name] !== null ? overrideConfig[name] : null;
    };
    var theComponent = queryProp("component");
    var superType = queryProp("superType");
    var superDef = null;
    if (superType) {
        if (superType === viewType) throw new Error("Can't have a custom view type that references itself");
        superDef = $782b2550ae753193$var$ensureViewDef(superType, hash, defaultConfigs, overrideConfigs);
    }
    if (!theComponent && superDef) theComponent = superDef.component;
    if (!theComponent) return null; // don't throw a warning, might be settings for a single-unit view
    return {
        type: viewType,
        component: theComponent,
        defaults: Object.assign(Object.assign({}, superDef ? superDef.defaults : {}), defaultConfig ? defaultConfig.rawOptions : {}),
        overrides: Object.assign(Object.assign({}, superDef ? superDef.overrides : {}), overrideConfig ? overrideConfig.rawOptions : {})
    };
}
function $782b2550ae753193$var$parseViewConfigs(inputs) {
    return (0, $4a7Gb.a)(inputs, $782b2550ae753193$var$parseViewConfig);
}
function $782b2550ae753193$var$parseViewConfig(input) {
    var rawOptions = typeof input === "function" ? {
        component: input
    } : input;
    var component = rawOptions.component;
    if (rawOptions.content) // TODO: remove content/classNames/didMount/etc from options?
    component = $782b2550ae753193$var$createViewHookComponent(rawOptions);
    else if (component && !(component.prototype instanceof (0, $4a7Gb.B))) // WHY?: people were using `component` property for `content`
    // TODO: converge on one setting name
    component = $782b2550ae753193$var$createViewHookComponent(Object.assign(Object.assign({}, rawOptions), {
        content: component
    }));
    return {
        superType: rawOptions.type,
        component: component,
        rawOptions: rawOptions
    };
}
function $782b2550ae753193$var$createViewHookComponent(options) {
    return function(viewProps) {
        return (0, $ihX0O.createElement)((0, $4a7Gb.V).Consumer, null, function(context) {
            return (0, $ihX0O.createElement)((0, $4a7Gb.C), {
                elTag: "div",
                elClasses: (0, $4a7Gb.b)(context.viewSpec),
                renderProps: Object.assign(Object.assign({}, viewProps), {
                    nextDayThreshold: context.options.nextDayThreshold
                }),
                generatorName: undefined,
                customGenerator: options.content,
                classNameGenerator: options.classNames,
                didMount: options.didMount,
                willUnmount: options.willUnmount
            });
        });
    };
}
function $782b2550ae753193$var$buildViewSpecs(defaultInputs, optionOverrides, dynamicOptionOverrides, localeDefaults) {
    var defaultConfigs = $782b2550ae753193$var$parseViewConfigs(defaultInputs);
    var overrideConfigs = $782b2550ae753193$var$parseViewConfigs(optionOverrides.views);
    var viewDefs = $782b2550ae753193$var$compileViewDefs(defaultConfigs, overrideConfigs);
    return (0, $4a7Gb.a)(viewDefs, function(viewDef) {
        return $782b2550ae753193$var$buildViewSpec(viewDef, overrideConfigs, optionOverrides, dynamicOptionOverrides, localeDefaults);
    });
}
function $782b2550ae753193$var$buildViewSpec(viewDef, overrideConfigs, optionOverrides, dynamicOptionOverrides, localeDefaults) {
    var durationInput = viewDef.overrides.duration || viewDef.defaults.duration || dynamicOptionOverrides.duration || optionOverrides.duration;
    var duration = null;
    var durationUnit = "";
    var singleUnit = "";
    var singleUnitOverrides = {};
    if (durationInput) {
        duration = $782b2550ae753193$var$createDurationCached(durationInput);
        if (duration) {
            var denom = (0, $4a7Gb.c)(duration);
            durationUnit = denom.unit;
            if (denom.value === 1) {
                singleUnit = durationUnit;
                singleUnitOverrides = overrideConfigs[durationUnit] ? overrideConfigs[durationUnit].rawOptions : {};
            }
        }
    }
    var queryButtonText = function(optionsSubset) {
        var buttonTextMap = optionsSubset.buttonText || {};
        var buttonTextKey = viewDef.defaults.buttonTextKey;
        if (buttonTextKey != null && buttonTextMap[buttonTextKey] != null) return buttonTextMap[buttonTextKey];
        if (buttonTextMap[viewDef.type] != null) return buttonTextMap[viewDef.type];
        if (buttonTextMap[singleUnit] != null) return buttonTextMap[singleUnit];
        return null;
    };
    var queryButtonTitle = function(optionsSubset) {
        var buttonHints = optionsSubset.buttonHints || {};
        var buttonKey = viewDef.defaults.buttonTextKey; // use same key as text
        if (buttonKey != null && buttonHints[buttonKey] != null) return buttonHints[buttonKey];
        if (buttonHints[viewDef.type] != null) return buttonHints[viewDef.type];
        if (buttonHints[singleUnit] != null) return buttonHints[singleUnit];
        return null;
    };
    return {
        type: viewDef.type,
        component: viewDef.component,
        duration: duration,
        durationUnit: durationUnit,
        singleUnit: singleUnit,
        optionDefaults: viewDef.defaults,
        optionOverrides: Object.assign(Object.assign({}, singleUnitOverrides), viewDef.overrides),
        buttonTextOverride: queryButtonText(dynamicOptionOverrides) || queryButtonText(optionOverrides) || // constructor-specified buttonText lookup hash takes precedence
        viewDef.overrides.buttonText,
        buttonTextDefault: queryButtonText(localeDefaults) || viewDef.defaults.buttonText || queryButtonText((0, $4a7Gb.e)) || viewDef.type,
        // not DRY
        buttonTitleOverride: queryButtonTitle(dynamicOptionOverrides) || queryButtonTitle(optionOverrides) || viewDef.overrides.buttonHint,
        buttonTitleDefault: queryButtonTitle(localeDefaults) || viewDef.defaults.buttonHint || queryButtonTitle((0, $4a7Gb.e))
    };
}
// hack to get memoization working
var $782b2550ae753193$var$durationInputMap = {};
function $782b2550ae753193$var$createDurationCached(durationInput) {
    var json = JSON.stringify(durationInput);
    var res = $782b2550ae753193$var$durationInputMap[json];
    if (res === undefined) {
        res = (0, $4a7Gb.d)(durationInput);
        $782b2550ae753193$var$durationInputMap[json] = res;
    }
    return res;
}
function $782b2550ae753193$var$reduceViewType(viewType, action) {
    switch(action.type){
        case "CHANGE_VIEW_TYPE":
            viewType = action.viewType;
    }
    return viewType;
}
function $782b2550ae753193$var$reduceCurrentDate(currentDate, action) {
    switch(action.type){
        case "CHANGE_DATE":
            return action.dateMarker;
        default:
            return currentDate;
    }
}
// should be initialized once and stay constant
// this will change too
function $782b2550ae753193$var$getInitialDate(options, dateEnv, nowManager) {
    var initialDateInput = options.initialDate;
    // compute the initial ambig-timezone date
    if (initialDateInput != null) return dateEnv.createMarker(initialDateInput);
    return nowManager.getDateMarker();
}
function $782b2550ae753193$var$reduceDynamicOptionOverrides(dynamicOptionOverrides, action) {
    switch(action.type){
        case "SET_OPTION":
            return Object.assign(Object.assign({}, dynamicOptionOverrides), {
                [action.optionName]: action.rawOptionValue
            });
        default:
            return dynamicOptionOverrides;
    }
}
function $782b2550ae753193$var$reduceDateProfile(currentDateProfile, action, currentDate, dateProfileGenerator) {
    var dp;
    switch(action.type){
        case "CHANGE_VIEW_TYPE":
            return dateProfileGenerator.build(action.dateMarker || currentDate);
        case "CHANGE_DATE":
            return dateProfileGenerator.build(action.dateMarker);
        case "PREV":
            dp = dateProfileGenerator.buildPrev(currentDateProfile, currentDate);
            if (dp.isValid) return dp;
            break;
        case "NEXT":
            dp = dateProfileGenerator.buildNext(currentDateProfile, currentDate);
            if (dp.isValid) return dp;
            break;
    }
    return currentDateProfile;
}
function $782b2550ae753193$var$initEventSources(calendarOptions, dateProfile, context) {
    var activeRange = dateProfile ? dateProfile.activeRange : null;
    return $782b2550ae753193$var$addSources({}, $782b2550ae753193$var$parseInitialSources(calendarOptions, context), activeRange, context);
}
function $782b2550ae753193$var$reduceEventSources(eventSources, action, dateProfile, context) {
    var activeRange = dateProfile ? dateProfile.activeRange : null; // need this check?
    switch(action.type){
        case "ADD_EVENT_SOURCES":
            return $782b2550ae753193$var$addSources(eventSources, action.sources, activeRange, context);
        case "REMOVE_EVENT_SOURCE":
            return $782b2550ae753193$var$removeSource(eventSources, action.sourceId);
        case "PREV":
        case "NEXT":
        case "CHANGE_DATE":
        case "CHANGE_VIEW_TYPE":
            if (dateProfile) return $782b2550ae753193$var$fetchDirtySources(eventSources, activeRange, context);
            return eventSources;
        case "FETCH_EVENT_SOURCES":
            return $782b2550ae753193$var$fetchSourcesByIds(eventSources, action.sourceIds ? (0, $4a7Gb.f)(action.sourceIds) : $782b2550ae753193$var$excludeStaticSources(eventSources, context), activeRange, action.isRefetch || false, context);
        case "RECEIVE_EVENTS":
        case "RECEIVE_EVENT_ERROR":
            return $782b2550ae753193$var$receiveResponse(eventSources, action.sourceId, action.fetchId, action.fetchRange);
        case "REMOVE_ALL_EVENT_SOURCES":
            return {};
        default:
            return eventSources;
    }
}
function $782b2550ae753193$var$reduceEventSourcesNewTimeZone(eventSources, dateProfile, context) {
    var activeRange = dateProfile ? dateProfile.activeRange : null; // need this check?
    return $782b2550ae753193$var$fetchSourcesByIds(eventSources, $782b2550ae753193$var$excludeStaticSources(eventSources, context), activeRange, true, context);
}
function $782b2550ae753193$var$computeEventSourcesLoading(eventSources) {
    for(var sourceId in eventSources){
        if (eventSources[sourceId].isFetching) return true;
    }
    return false;
}
function $782b2550ae753193$var$addSources(eventSourceHash, sources, fetchRange, context) {
    var hash = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = sources[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var source = _step.value;
            hash[source.sourceId] = source;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    if (fetchRange) hash = $782b2550ae753193$var$fetchDirtySources(hash, fetchRange, context);
    return Object.assign(Object.assign({}, eventSourceHash), hash);
}
function $782b2550ae753193$var$removeSource(eventSourceHash, sourceId) {
    return (0, $4a7Gb.h)(eventSourceHash, function(eventSource) {
        return eventSource.sourceId !== sourceId;
    });
}
function $782b2550ae753193$var$fetchDirtySources(sourceHash, fetchRange, context) {
    return $782b2550ae753193$var$fetchSourcesByIds(sourceHash, (0, $4a7Gb.h)(sourceHash, function(eventSource) {
        return $782b2550ae753193$var$isSourceDirty(eventSource, fetchRange, context);
    }), fetchRange, false, context);
}
function $782b2550ae753193$var$isSourceDirty(eventSource, fetchRange, context) {
    if (!$782b2550ae753193$var$doesSourceNeedRange(eventSource, context)) return !eventSource.latestFetchId;
    return !context.options.lazyFetching || !eventSource.fetchRange || eventSource.isFetching || // always cancel outdated in-progress fetches
    fetchRange.start < eventSource.fetchRange.start || fetchRange.end > eventSource.fetchRange.end;
}
function $782b2550ae753193$var$fetchSourcesByIds(prevSources, sourceIdHash, fetchRange, isRefetch, context) {
    var nextSources = {};
    for(var sourceId in prevSources){
        var source = prevSources[sourceId];
        if (sourceIdHash[sourceId]) nextSources[sourceId] = $782b2550ae753193$var$fetchSource(source, fetchRange, isRefetch, context);
        else nextSources[sourceId] = source;
    }
    return nextSources;
}
function $782b2550ae753193$var$fetchSource(eventSource, fetchRange, isRefetch, context) {
    var options = context.options, calendarApi = context.calendarApi;
    var sourceDef = context.pluginHooks.eventSourceDefs[eventSource.sourceDefId];
    var fetchId = (0, $4a7Gb.g)();
    sourceDef.fetch({
        eventSource: eventSource,
        range: fetchRange,
        isRefetch: isRefetch,
        context: context
    }, function(res) {
        var rawEvents = res.rawEvents;
        if (options.eventSourceSuccess) rawEvents = options.eventSourceSuccess.call(calendarApi, rawEvents, res.response) || rawEvents;
        if (eventSource.success) rawEvents = eventSource.success.call(calendarApi, rawEvents, res.response) || rawEvents;
        context.dispatch({
            type: "RECEIVE_EVENTS",
            sourceId: eventSource.sourceId,
            fetchId: fetchId,
            fetchRange: fetchRange,
            rawEvents: rawEvents
        });
    }, function(error) {
        var errorHandled = false;
        if (options.eventSourceFailure) {
            options.eventSourceFailure.call(calendarApi, error);
            errorHandled = true;
        }
        if (eventSource.failure) {
            eventSource.failure(error);
            errorHandled = true;
        }
        if (!errorHandled) console.warn(error.message, error);
        context.dispatch({
            type: "RECEIVE_EVENT_ERROR",
            sourceId: eventSource.sourceId,
            fetchId: fetchId,
            fetchRange: fetchRange,
            error: error
        });
    });
    return Object.assign(Object.assign({}, eventSource), {
        isFetching: true,
        latestFetchId: fetchId
    });
}
function $782b2550ae753193$var$receiveResponse(sourceHash, sourceId, fetchId, fetchRange) {
    var eventSource = sourceHash[sourceId];
    if (eventSource && // not already removed
    fetchId === eventSource.latestFetchId) return Object.assign(Object.assign({}, sourceHash), {
        [sourceId]: Object.assign(Object.assign({}, eventSource), {
            isFetching: false,
            fetchRange: fetchRange
        })
    });
    return sourceHash;
}
function $782b2550ae753193$var$excludeStaticSources(eventSources, context) {
    return (0, $4a7Gb.h)(eventSources, function(eventSource) {
        return $782b2550ae753193$var$doesSourceNeedRange(eventSource, context);
    });
}
function $782b2550ae753193$var$parseInitialSources(rawOptions, context) {
    var refiners = (0, $4a7Gb.j)(context);
    var rawSources = [].concat(rawOptions.eventSources || []);
    var sources = []; // parsed
    if (rawOptions.initialEvents) rawSources.unshift(rawOptions.initialEvents);
    if (rawOptions.events) rawSources.unshift(rawOptions.events);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = rawSources[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var rawSource = _step.value;
            var source = (0, $4a7Gb.p)(rawSource, context, refiners);
            if (source) sources.push(source);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return sources;
}
function $782b2550ae753193$var$doesSourceNeedRange(eventSource, context) {
    var defs = context.pluginHooks.eventSourceDefs;
    return !defs[eventSource.sourceDefId].ignoreRange;
}
function $782b2550ae753193$var$reduceDateSelection(currentSelection, action) {
    switch(action.type){
        case "UNSELECT_DATES":
            return null;
        case "SELECT_DATES":
            return action.selection;
        default:
            return currentSelection;
    }
}
function $782b2550ae753193$var$reduceSelectedEvent(currentInstanceId, action) {
    switch(action.type){
        case "UNSELECT_EVENT":
            return "";
        case "SELECT_EVENT":
            return action.eventInstanceId;
        default:
            return currentInstanceId;
    }
}
function $782b2550ae753193$var$reduceEventDrag(currentDrag, action) {
    var newDrag;
    switch(action.type){
        case "UNSET_EVENT_DRAG":
            return null;
        case "SET_EVENT_DRAG":
            newDrag = action.state;
            return {
                affectedEvents: newDrag.affectedEvents,
                mutatedEvents: newDrag.mutatedEvents,
                isEvent: newDrag.isEvent
            };
        default:
            return currentDrag;
    }
}
function $782b2550ae753193$var$reduceEventResize(currentResize, action) {
    var newResize;
    switch(action.type){
        case "UNSET_EVENT_RESIZE":
            return null;
        case "SET_EVENT_RESIZE":
            newResize = action.state;
            return {
                affectedEvents: newResize.affectedEvents,
                mutatedEvents: newResize.mutatedEvents,
                isEvent: newResize.isEvent
            };
        default:
            return currentResize;
    }
}
function $782b2550ae753193$var$parseToolbars(calendarOptions, calendarOptionOverrides, theme, viewSpecs, calendarApi) {
    var header = calendarOptions.headerToolbar ? $782b2550ae753193$var$parseToolbar(calendarOptions.headerToolbar, calendarOptions, calendarOptionOverrides, theme, viewSpecs, calendarApi) : null;
    var footer = calendarOptions.footerToolbar ? $782b2550ae753193$var$parseToolbar(calendarOptions.footerToolbar, calendarOptions, calendarOptionOverrides, theme, viewSpecs, calendarApi) : null;
    return {
        header: header,
        footer: footer
    };
}
function $782b2550ae753193$var$parseToolbar(sectionStrHash, calendarOptions, calendarOptionOverrides, theme, viewSpecs, calendarApi) {
    var sectionWidgets = {};
    var viewsWithButtons = [];
    var hasTitle = false;
    for(var sectionName in sectionStrHash){
        var _viewsWithButtons;
        var sectionStr = sectionStrHash[sectionName];
        var sectionRes = $782b2550ae753193$var$parseSection(sectionStr, calendarOptions, calendarOptionOverrides, theme, viewSpecs, calendarApi);
        sectionWidgets[sectionName] = sectionRes.widgets;
        (_viewsWithButtons = viewsWithButtons).push.apply(_viewsWithButtons, (0, $79xu7._)(sectionRes.viewsWithButtons));
        hasTitle = hasTitle || sectionRes.hasTitle;
    }
    return {
        sectionWidgets: sectionWidgets,
        viewsWithButtons: viewsWithButtons,
        hasTitle: hasTitle
    };
}
/*
BAD: querying icons and text here. should be done at render time
*/ function $782b2550ae753193$var$parseSection(sectionStr, calendarOptions, calendarOptionOverrides, theme, viewSpecs, calendarApi) {
    var isRtl = calendarOptions.direction === "rtl";
    var calendarCustomButtons = calendarOptions.customButtons || {};
    var calendarButtonTextOverrides = calendarOptionOverrides.buttonText || {};
    var calendarButtonText = calendarOptions.buttonText || {};
    var calendarButtonHintOverrides = calendarOptionOverrides.buttonHints || {};
    var calendarButtonHints = calendarOptions.buttonHints || {};
    var sectionSubstrs = sectionStr ? sectionStr.split(" ") : [];
    var viewsWithButtons = [];
    var hasTitle = false;
    var widgets = sectionSubstrs.map(function(buttonGroupStr) {
        return buttonGroupStr.split(",").map(function(buttonName) {
            if (buttonName === "title") {
                hasTitle = true;
                return {
                    buttonName: buttonName
                };
            }
            var customButtonProps;
            var viewSpec;
            var buttonClick;
            var buttonIcon; // only one of these will be set
            var buttonText; // "
            var buttonHint;
            // ^ for the title="" attribute, for accessibility
            if (customButtonProps = calendarCustomButtons[buttonName]) {
                buttonClick = function(ev) {
                    if (customButtonProps.click) customButtonProps.click.call(ev.target, ev, ev.target); // TODO: use Calendar this context?
                };
                (buttonIcon = theme.getCustomButtonIconClass(customButtonProps)) || (buttonIcon = theme.getIconClass(buttonName, isRtl)) || (buttonText = customButtonProps.text);
                buttonHint = customButtonProps.hint || customButtonProps.text;
            } else if (viewSpec = viewSpecs[buttonName]) {
                viewsWithButtons.push(buttonName);
                buttonClick = function() {
                    calendarApi.changeView(buttonName);
                };
                (buttonText = viewSpec.buttonTextOverride) || (buttonIcon = theme.getIconClass(buttonName, isRtl)) || (buttonText = viewSpec.buttonTextDefault);
                var textFallback = viewSpec.buttonTextOverride || viewSpec.buttonTextDefault;
                buttonHint = (0, $4a7Gb.k)(viewSpec.buttonTitleOverride || viewSpec.buttonTitleDefault || calendarOptions.viewHint, [
                    textFallback,
                    buttonName
                ], textFallback);
            } else if (calendarApi[buttonName]) {
                buttonClick = function() {
                    calendarApi[buttonName]();
                };
                (buttonText = calendarButtonTextOverrides[buttonName]) || (buttonIcon = theme.getIconClass(buttonName, isRtl)) || (buttonText = calendarButtonText[buttonName]); // everything else is considered default
                if (buttonName === "prevYear" || buttonName === "nextYear") {
                    var prevOrNext = buttonName === "prevYear" ? "prev" : "next";
                    buttonHint = (0, $4a7Gb.k)(calendarButtonHintOverrides[prevOrNext] || calendarButtonHints[prevOrNext], [
                        calendarButtonText.year || "year",
                        "year"
                    ], calendarButtonText[buttonName]);
                } else buttonHint = function(navUnit) {
                    return (0, $4a7Gb.k)(calendarButtonHintOverrides[buttonName] || calendarButtonHints[buttonName], [
                        calendarButtonText[navUnit] || navUnit,
                        navUnit
                    ], calendarButtonText[buttonName]);
                };
            }
            return {
                buttonName: buttonName,
                buttonClick: buttonClick,
                buttonIcon: buttonIcon,
                buttonText: buttonText,
                buttonHint: buttonHint
            };
        });
    });
    return {
        widgets: widgets,
        viewsWithButtons: viewsWithButtons,
        hasTitle: hasTitle
    };
}
// always represents the current view. otherwise, it'd need to change value every time date changes
var $782b2550ae753193$var$ViewImpl = /*#__PURE__*/ function() {
    "use strict";
    function ViewImpl(type, getCurrentData, dateEnv) {
        (0, $luoZD._)(this, ViewImpl);
        this.type = type;
        this.getCurrentData = getCurrentData;
        this.dateEnv = dateEnv;
    }
    (0, $fYUO3._)(ViewImpl, [
        {
            key: "calendar",
            get: function get() {
                return this.getCurrentData().calendarApi;
            }
        },
        {
            key: "title",
            get: function get() {
                return this.getCurrentData().viewTitle;
            }
        },
        {
            key: "activeStart",
            get: function get() {
                return this.dateEnv.toDate(this.getCurrentData().dateProfile.activeRange.start);
            }
        },
        {
            key: "activeEnd",
            get: function get() {
                return this.dateEnv.toDate(this.getCurrentData().dateProfile.activeRange.end);
            }
        },
        {
            key: "currentStart",
            get: function get() {
                return this.dateEnv.toDate(this.getCurrentData().dateProfile.currentRange.start);
            }
        },
        {
            key: "currentEnd",
            get: function get() {
                return this.dateEnv.toDate(this.getCurrentData().dateProfile.currentRange.end);
            }
        },
        {
            key: "getOption",
            value: function getOption(name) {
                return this.getCurrentData().options[name]; // are the view-specific options
            }
        }
    ]);
    return ViewImpl;
}();
var $782b2550ae753193$var$eventSourceDef$2 = {
    ignoreRange: true,
    parseMeta: function(refined) {
        if (Array.isArray(refined.events)) return refined.events;
        return null;
    },
    fetch: function(arg, successCallback) {
        successCallback({
            rawEvents: arg.eventSource.meta
        });
    }
};
var $782b2550ae753193$var$arrayEventSourcePlugin = $782b2550ae753193$export$ae829ec7b2625219({
    name: "array-event-source",
    eventSourceDefs: [
        $782b2550ae753193$var$eventSourceDef$2
    ]
});
var $782b2550ae753193$var$eventSourceDef$1 = {
    parseMeta: function(refined) {
        if (typeof refined.events === "function") return refined.events;
        return null;
    },
    fetch: function(arg, successCallback, errorCallback) {
        var dateEnv = arg.context.dateEnv;
        var func = arg.eventSource.meta;
        (0, $4a7Gb.u)(func.bind(null, (0, $4a7Gb.l)(arg.range, dateEnv)), function(rawEvents) {
            return successCallback({
                rawEvents: rawEvents
            });
        }, errorCallback);
    }
};
var $782b2550ae753193$var$funcEventSourcePlugin = $782b2550ae753193$export$ae829ec7b2625219({
    name: "func-event-source",
    eventSourceDefs: [
        $782b2550ae753193$var$eventSourceDef$1
    ]
});
var $782b2550ae753193$var$JSON_FEED_EVENT_SOURCE_REFINERS = {
    method: String,
    extraParams: (0, $4a7Gb.n),
    startParam: String,
    endParam: String,
    timeZoneParam: String
};
var $782b2550ae753193$var$eventSourceDef = {
    parseMeta: function(refined) {
        if (refined.url && (refined.format === "json" || !refined.format)) return {
            url: refined.url,
            format: "json",
            method: (refined.method || "GET").toUpperCase(),
            extraParams: refined.extraParams,
            startParam: refined.startParam,
            endParam: refined.endParam,
            timeZoneParam: refined.timeZoneParam
        };
        return null;
    },
    fetch: function(arg, successCallback, errorCallback) {
        var meta = arg.eventSource.meta;
        var requestParams = $782b2550ae753193$var$buildRequestParams(meta, arg.range, arg.context);
        (0, $4a7Gb.r)(meta.method, meta.url, requestParams).then(function(param) {
            var _param = (0, $4f96i._)(param, 2), rawEvents = _param[0], response = _param[1];
            successCallback({
                rawEvents: rawEvents,
                response: response
            });
        }, errorCallback);
    }
};
var $782b2550ae753193$var$jsonFeedEventSourcePlugin = $782b2550ae753193$export$ae829ec7b2625219({
    name: "json-event-source",
    eventSourceRefiners: $782b2550ae753193$var$JSON_FEED_EVENT_SOURCE_REFINERS,
    eventSourceDefs: [
        $782b2550ae753193$var$eventSourceDef
    ]
});
function $782b2550ae753193$var$buildRequestParams(meta, range, context) {
    var dateEnv = context.dateEnv, options = context.options;
    var startParam;
    var endParam;
    var timeZoneParam;
    var customRequestParams;
    var params = {};
    startParam = meta.startParam;
    if (startParam == null) startParam = options.startParam;
    endParam = meta.endParam;
    if (endParam == null) endParam = options.endParam;
    timeZoneParam = meta.timeZoneParam;
    if (timeZoneParam == null) timeZoneParam = options.timeZoneParam;
    // retrieve any outbound GET/POST data from the options
    if (typeof meta.extraParams === "function") // supplied as a function that returns a key/value object
    customRequestParams = meta.extraParams();
    else // probably supplied as a straight key/value object
    customRequestParams = meta.extraParams || {};
    Object.assign(params, customRequestParams);
    params[startParam] = dateEnv.formatIso(range.start);
    params[endParam] = dateEnv.formatIso(range.end);
    if (dateEnv.timeZone !== "local") params[timeZoneParam] = dateEnv.timeZone;
    return params;
}
var $782b2550ae753193$var$SIMPLE_RECURRING_REFINERS = {
    daysOfWeek: (0, $4a7Gb.n),
    startTime: (0, $4a7Gb.d),
    endTime: (0, $4a7Gb.d),
    duration: (0, $4a7Gb.d),
    startRecur: (0, $4a7Gb.n),
    endRecur: (0, $4a7Gb.n)
};
var $782b2550ae753193$var$recurring = {
    parse: function(refined, dateEnv) {
        if (refined.daysOfWeek || refined.startTime || refined.endTime || refined.startRecur || refined.endRecur) {
            var recurringData = {
                daysOfWeek: refined.daysOfWeek || null,
                startTime: refined.startTime || null,
                endTime: refined.endTime || null,
                startRecur: refined.startRecur ? dateEnv.createMarker(refined.startRecur) : null,
                endRecur: refined.endRecur ? dateEnv.createMarker(refined.endRecur) : null,
                dateEnv: dateEnv
            };
            var duration;
            if (refined.duration) duration = refined.duration;
            if (!duration && refined.startTime && refined.endTime) duration = (0, $4a7Gb.s)(refined.endTime, refined.startTime);
            return {
                allDayGuess: Boolean(!refined.startTime && !refined.endTime),
                duration: duration,
                typeData: recurringData
            };
        }
        return null;
    },
    expand: function(typeData, framingRange, dateEnv) {
        var clippedFramingRange = (0, $4a7Gb.o)(framingRange, {
            start: typeData.startRecur,
            end: typeData.endRecur
        });
        if (clippedFramingRange) return $782b2550ae753193$var$expandRanges(typeData.daysOfWeek, typeData.startTime, typeData.dateEnv, dateEnv, clippedFramingRange);
        return [];
    }
};
var $782b2550ae753193$var$simpleRecurringEventsPlugin = $782b2550ae753193$export$ae829ec7b2625219({
    name: "simple-recurring-event",
    recurringTypes: [
        $782b2550ae753193$var$recurring
    ],
    eventRefiners: $782b2550ae753193$var$SIMPLE_RECURRING_REFINERS
});
function $782b2550ae753193$var$expandRanges(daysOfWeek, startTime, eventDateEnv, calendarDateEnv, framingRange) {
    var dowHash = daysOfWeek ? (0, $4a7Gb.f)(daysOfWeek) : null;
    var dayMarker = (0, $4a7Gb.q)(framingRange.start);
    var endMarker = framingRange.end;
    var instanceStarts = [];
    // https://github.com/fullcalendar/fullcalendar/issues/7934
    if (startTime) {
        if (startTime.milliseconds < 0) // possible for next-day to have negative business hours that go into current day
        endMarker = (0, $4a7Gb.t)(endMarker, 1);
        else if (startTime.milliseconds >= 86400000) // possible for prev-day to have >24hr business hours that go into current day
        dayMarker = (0, $4a7Gb.t)(dayMarker, -1);
    }
    while(dayMarker < endMarker){
        var instanceStart = void 0;
        // if everyday, or this particular day-of-week
        if (!dowHash || dowHash[dayMarker.getUTCDay()]) {
            if (startTime) instanceStart = calendarDateEnv.add(dayMarker, startTime);
            else instanceStart = dayMarker;
            instanceStarts.push(calendarDateEnv.createMarker(eventDateEnv.toDate(instanceStart)));
        }
        dayMarker = (0, $4a7Gb.t)(dayMarker, 1);
    }
    return instanceStarts;
}
var $782b2550ae753193$var$changeHandlerPlugin = $782b2550ae753193$export$ae829ec7b2625219({
    name: "change-handler",
    optionChangeHandlers: {
        events: function(events, context) {
            $782b2550ae753193$var$handleEventSources([
                events
            ], context);
        },
        eventSources: $782b2550ae753193$var$handleEventSources
    }
});
/*
BUG: if `event` was supplied, all previously-given `eventSources` will be wiped out
*/ function $782b2550ae753193$var$handleEventSources(inputs, context) {
    var unfoundSources = (0, $4a7Gb.v)(context.getCurrentData().eventSources);
    if (unfoundSources.length === 1 && inputs.length === 1 && Array.isArray(unfoundSources[0]._raw) && Array.isArray(inputs[0])) {
        context.dispatch({
            type: "RESET_RAW_EVENTS",
            sourceId: unfoundSources[0].sourceId,
            rawEvents: inputs[0]
        });
        return;
    }
    var newInputs = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = inputs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var input = _step.value;
            var inputFound = false;
            for(var i = 0; i < unfoundSources.length; i += 1)if (unfoundSources[i]._raw === input) {
                unfoundSources.splice(i, 1); // delete
                inputFound = true;
                break;
            }
            if (!inputFound) newInputs.push(input);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator1 = unfoundSources[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
            var unfoundSource = _step1.value;
            context.dispatch({
                type: "REMOVE_EVENT_SOURCE",
                sourceId: unfoundSource.sourceId
            });
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                _iterator1.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
    try {
        for(var _iterator2 = newInputs[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
            var newInput = _step2.value;
            context.calendarApi.addEventSource(newInput);
        }
    } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                _iterator2.return();
            }
        } finally{
            if (_didIteratorError2) {
                throw _iteratorError2;
            }
        }
    }
}
function $782b2550ae753193$var$handleDateProfile(dateProfile, context) {
    context.emitter.trigger("datesSet", Object.assign(Object.assign({}, (0, $4a7Gb.l)(dateProfile.activeRange, context.dateEnv)), {
        view: context.viewApi
    }));
}
function $782b2550ae753193$var$handleEventStore(eventStore, context) {
    var emitter = context.emitter;
    if (emitter.hasHandlers("eventsSet")) emitter.trigger("eventsSet", (0, $4a7Gb.w)(eventStore, context));
}
/*
this array is exposed on the root namespace so that UMD plugins can add to it.
see the rollup-bundles script.
*/ var $782b2550ae753193$export$905153d94e0757fa = [
    $782b2550ae753193$var$arrayEventSourcePlugin,
    $782b2550ae753193$var$funcEventSourcePlugin,
    $782b2550ae753193$var$jsonFeedEventSourcePlugin,
    $782b2550ae753193$var$simpleRecurringEventsPlugin,
    $782b2550ae753193$var$changeHandlerPlugin,
    $782b2550ae753193$export$ae829ec7b2625219({
        name: "misc",
        isLoadingFuncs: [
            function(state) {
                return $782b2550ae753193$var$computeEventSourcesLoading(state.eventSources);
            }
        ],
        propSetHandlers: {
            dateProfile: $782b2550ae753193$var$handleDateProfile,
            eventStore: $782b2550ae753193$var$handleEventStore
        }
    })
];
var $782b2550ae753193$var$TaskRunner = /*#__PURE__*/ function() {
    "use strict";
    function TaskRunner(runTaskOption, drainedOption) {
        (0, $luoZD._)(this, TaskRunner);
        this.runTaskOption = runTaskOption;
        this.drainedOption = drainedOption;
        this.queue = [];
        this.delayedRunner = new (0, $4a7Gb.D)(this.drain.bind(this));
    }
    (0, $fYUO3._)(TaskRunner, [
        {
            key: "request",
            value: function request(task, delay) {
                this.queue.push(task);
                this.delayedRunner.request(delay);
            }
        },
        {
            key: "pause",
            value: function pause(scope) {
                this.delayedRunner.pause(scope);
            }
        },
        {
            key: "resume",
            value: function resume(scope, force) {
                this.delayedRunner.resume(scope, force);
            }
        },
        {
            key: "drain",
            value: function drain() {
                var queue = this.queue;
                while(queue.length){
                    var completedTasks = [];
                    var task = void 0;
                    while(task = queue.shift()){
                        this.runTask(task);
                        completedTasks.push(task);
                    }
                    this.drained(completedTasks);
                } // keep going, in case new tasks were added in the drained handler
            }
        },
        {
            key: "runTask",
            value: function runTask(task) {
                if (this.runTaskOption) this.runTaskOption(task);
            }
        },
        {
            key: "drained",
            value: function drained(completedTasks) {
                if (this.drainedOption) this.drainedOption(completedTasks);
            }
        }
    ]);
    return TaskRunner;
}();
// Computes what the title at the top of the calendarApi should be for this view
function $782b2550ae753193$var$buildTitle(dateProfile, viewOptions, dateEnv) {
    var range;
    // for views that span a large unit of time, show the proper interval, ignoring stray days before and after
    if (/^(year|month)$/.test(dateProfile.currentRangeUnit)) range = dateProfile.currentRange;
    else range = dateProfile.activeRange;
    return dateEnv.formatRange(range.start, range.end, (0, $4a7Gb.x)(viewOptions.titleFormat || $782b2550ae753193$var$buildTitleFormat(dateProfile)), {
        isEndExclusive: dateProfile.isRangeAllDay,
        defaultSeparator: viewOptions.titleRangeSeparator
    });
}
// Generates the format string that should be used to generate the title for the current date range.
// Attempts to compute the most appropriate format if not explicitly specified with `titleFormat`.
function $782b2550ae753193$var$buildTitleFormat(dateProfile) {
    var currentRangeUnit = dateProfile.currentRangeUnit;
    if (currentRangeUnit === "year") return {
        year: "numeric"
    };
    if (currentRangeUnit === "month") return {
        year: "numeric",
        month: "long"
    }; // like "September 2014"
    var days = (0, $4a7Gb.y)(dateProfile.currentRange.start, dateProfile.currentRange.end);
    if (days !== null && days > 1) // multi-day range. shorter, like "Sep 9 - 10 2014"
    return {
        year: "numeric",
        month: "short",
        day: "numeric"
    };
    // one day. longer, like "September 9 2014"
    return {
        year: "numeric",
        month: "long",
        day: "numeric"
    };
}
/*
TODO: test switching timezones when NO timezone plugin
*/ var $782b2550ae753193$var$CalendarNowManager = /*#__PURE__*/ function() {
    "use strict";
    function CalendarNowManager() {
        (0, $luoZD._)(this, CalendarNowManager);
        this.resetListeners = new Set();
    }
    (0, $fYUO3._)(CalendarNowManager, [
        {
            key: "handleInput",
            value: function handleInput(dateEnv, nowInput) {
                var oldDateEnv = this.dateEnv;
                if (dateEnv !== oldDateEnv) {
                    if (typeof nowInput === "function") this.nowFn = nowInput;
                    else if (!oldDateEnv) {
                        this.nowAnchorDate = dateEnv.toDate(nowInput ? dateEnv.createMarker(nowInput) : dateEnv.createNowMarker());
                        this.nowAnchorQueried = Date.now();
                    }
                    this.dateEnv = dateEnv;
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    // not first time? fire reset handlers
                    if (oldDateEnv) try {
                        for(var _iterator = this.resetListeners.values()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var resetListener = _step.value;
                            resetListener();
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
            }
        },
        {
            key: "getDateMarker",
            value: function getDateMarker() {
                return this.nowAnchorDate ? this.dateEnv.timestampToMarker(this.nowAnchorDate.valueOf() + (Date.now() - this.nowAnchorQueried)) : this.dateEnv.createMarker(this.nowFn());
            }
        },
        {
            key: "addResetListener",
            value: function addResetListener(handler) {
                this.resetListeners.add(handler);
            }
        },
        {
            key: "removeResetListener",
            value: function removeResetListener(handler) {
                this.resetListeners.delete(handler);
            }
        }
    ]);
    return CalendarNowManager;
}();
// in future refactor, do the redux-style function(state=initial) for initial-state
// also, whatever is happening in constructor, have it happen in action queue too
var $782b2550ae753193$var$CalendarDataManager = /*#__PURE__*/ function() {
    "use strict";
    function CalendarDataManager(props) {
        var _this = this;
        (0, $luoZD._)(this, CalendarDataManager);
        this.computeCurrentViewData = (0, $4a7Gb.z)(this._computeCurrentViewData);
        this.organizeRawLocales = (0, $4a7Gb.z)($782b2550ae753193$var$organizeRawLocales);
        this.buildLocale = (0, $4a7Gb.z)($782b2550ae753193$var$buildLocale);
        this.buildPluginHooks = $782b2550ae753193$var$buildBuildPluginHooks();
        this.buildDateEnv = (0, $4a7Gb.z)($782b2550ae753193$var$buildDateEnv$1);
        this.buildTheme = (0, $4a7Gb.z)($782b2550ae753193$var$buildTheme);
        this.parseToolbars = (0, $4a7Gb.z)($782b2550ae753193$var$parseToolbars);
        this.buildViewSpecs = (0, $4a7Gb.z)($782b2550ae753193$var$buildViewSpecs);
        this.buildDateProfileGenerator = (0, $4a7Gb.A)($782b2550ae753193$var$buildDateProfileGenerator);
        this.buildViewApi = (0, $4a7Gb.z)($782b2550ae753193$var$buildViewApi);
        this.buildViewUiProps = (0, $4a7Gb.A)($782b2550ae753193$var$buildViewUiProps);
        this.buildEventUiBySource = (0, $4a7Gb.z)($782b2550ae753193$var$buildEventUiBySource, (0, $4a7Gb.E));
        this.buildEventUiBases = (0, $4a7Gb.z)($782b2550ae753193$var$buildEventUiBases);
        this.parseContextBusinessHours = (0, $4a7Gb.A)($782b2550ae753193$var$parseContextBusinessHours);
        this.buildTitle = (0, $4a7Gb.z)($782b2550ae753193$var$buildTitle);
        this.nowManager = new $782b2550ae753193$var$CalendarNowManager();
        this.emitter = new (0, $4a7Gb.F)();
        this.actionRunner = new $782b2550ae753193$var$TaskRunner(this._handleAction.bind(this), this.updateData.bind(this));
        this.currentCalendarOptionsInput = {};
        this.currentCalendarOptionsRefined = {};
        this.currentViewOptionsInput = {};
        this.currentViewOptionsRefined = {};
        this.currentCalendarOptionsRefiners = {};
        this.optionsForRefining = [];
        this.optionsForHandling = [];
        this.getCurrentData = function() {
            return _this.data;
        };
        this.dispatch = function(action) {
            _this.actionRunner.request(action); // protects against recursive calls to _handleAction
        };
        this.props = props;
        this.actionRunner.pause();
        this.nowManager = new $782b2550ae753193$var$CalendarNowManager();
        var dynamicOptionOverrides = {};
        var optionsData = this.computeOptionsData(props.optionOverrides, dynamicOptionOverrides, props.calendarApi);
        var currentViewType = optionsData.calendarOptions.initialView || optionsData.pluginHooks.initialView;
        var currentViewData = this.computeCurrentViewData(currentViewType, optionsData, props.optionOverrides, dynamicOptionOverrides);
        // wire things up
        // TODO: not DRY
        props.calendarApi.currentDataManager = this;
        this.emitter.setThisContext(props.calendarApi);
        this.emitter.setOptions(currentViewData.options);
        var calendarContext = {
            nowManager: this.nowManager,
            dateEnv: optionsData.dateEnv,
            options: optionsData.calendarOptions,
            pluginHooks: optionsData.pluginHooks,
            calendarApi: props.calendarApi,
            dispatch: this.dispatch,
            emitter: this.emitter,
            getCurrentData: this.getCurrentData
        };
        var currentDate = $782b2550ae753193$var$getInitialDate(optionsData.calendarOptions, optionsData.dateEnv, this.nowManager);
        var dateProfile = currentViewData.dateProfileGenerator.build(currentDate);
        if (!(0, $4a7Gb.G)(dateProfile.activeRange, currentDate)) currentDate = dateProfile.currentRange.start;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            // needs to be after setThisContext
            for(var _iterator = optionsData.pluginHooks.contextInit[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var callback = _step.value;
                callback(calendarContext);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        // NOT DRY
        var eventSources = $782b2550ae753193$var$initEventSources(optionsData.calendarOptions, dateProfile, calendarContext);
        var initialState = {
            dynamicOptionOverrides: dynamicOptionOverrides,
            currentViewType: currentViewType,
            currentDate: currentDate,
            dateProfile: dateProfile,
            businessHours: this.parseContextBusinessHours(calendarContext),
            eventSources: eventSources,
            eventUiBases: {},
            eventStore: (0, $4a7Gb.H)(),
            renderableEventStore: (0, $4a7Gb.H)(),
            dateSelection: null,
            eventSelection: "",
            eventDrag: null,
            eventResize: null,
            selectionConfig: this.buildViewUiProps(calendarContext).selectionConfig
        };
        var contextAndState = Object.assign(Object.assign({}, calendarContext), initialState);
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = optionsData.pluginHooks.reducers[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var reducer = _step1.value;
                Object.assign(initialState, reducer(null, null, contextAndState));
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
        if ($782b2550ae753193$var$computeIsLoading(initialState, calendarContext)) this.emitter.trigger("loading", true); // NOT DRY
        this.state = initialState;
        this.updateData();
        this.actionRunner.resume();
    }
    (0, $fYUO3._)(CalendarDataManager, [
        {
            key: "resetOptions",
            value: function resetOptions(optionOverrides, changedOptionNames) {
                var props = this.props;
                if (changedOptionNames === undefined) props.optionOverrides = optionOverrides;
                else {
                    var _this_optionsForRefining;
                    props.optionOverrides = Object.assign(Object.assign({}, props.optionOverrides || {}), optionOverrides);
                    (_this_optionsForRefining = this.optionsForRefining).push.apply(_this_optionsForRefining, (0, $79xu7._)(changedOptionNames));
                }
                if (changedOptionNames === undefined || changedOptionNames.length) this.actionRunner.request({
                    type: "NOTHING"
                });
            }
        },
        {
            key: "_handleAction",
            value: function _handleAction(action) {
                var _this = this, props = _this.props, state = _this.state, emitter = _this.emitter;
                var dynamicOptionOverrides = $782b2550ae753193$var$reduceDynamicOptionOverrides(state.dynamicOptionOverrides, action);
                var optionsData = this.computeOptionsData(props.optionOverrides, dynamicOptionOverrides, props.calendarApi);
                var currentViewType = $782b2550ae753193$var$reduceViewType(state.currentViewType, action);
                var currentViewData = this.computeCurrentViewData(currentViewType, optionsData, props.optionOverrides, dynamicOptionOverrides);
                // wire things up
                // TODO: not DRY
                props.calendarApi.currentDataManager = this;
                emitter.setThisContext(props.calendarApi);
                emitter.setOptions(currentViewData.options);
                var calendarContext = {
                    nowManager: this.nowManager,
                    dateEnv: optionsData.dateEnv,
                    options: optionsData.calendarOptions,
                    pluginHooks: optionsData.pluginHooks,
                    calendarApi: props.calendarApi,
                    dispatch: this.dispatch,
                    emitter: emitter,
                    getCurrentData: this.getCurrentData
                };
                var currentDate = state.currentDate, dateProfile = state.dateProfile;
                if (this.data && this.data.dateProfileGenerator !== currentViewData.dateProfileGenerator) dateProfile = currentViewData.dateProfileGenerator.build(currentDate);
                currentDate = $782b2550ae753193$var$reduceCurrentDate(currentDate, action);
                dateProfile = $782b2550ae753193$var$reduceDateProfile(dateProfile, action, currentDate, currentViewData.dateProfileGenerator);
                if (action.type === "PREV" || // TODO: move this logic into DateProfileGenerator
                action.type === "NEXT" || // "
                !(0, $4a7Gb.G)(dateProfile.currentRange, currentDate)) currentDate = dateProfile.currentRange.start;
                var eventSources = $782b2550ae753193$var$reduceEventSources(state.eventSources, action, dateProfile, calendarContext);
                var eventStore = (0, $4a7Gb.I)(state.eventStore, action, eventSources, dateProfile, calendarContext);
                var isEventsLoading = $782b2550ae753193$var$computeEventSourcesLoading(eventSources); // BAD. also called in this func in computeIsLoading
                var renderableEventStore = isEventsLoading && !currentViewData.options.progressiveEventRendering ? state.renderableEventStore || eventStore : eventStore;
                var _this_buildViewUiProps = this.buildViewUiProps(calendarContext), eventUiSingleBase = _this_buildViewUiProps.eventUiSingleBase, selectionConfig = _this_buildViewUiProps.selectionConfig; // will memoize obj
                var eventUiBySource = this.buildEventUiBySource(eventSources);
                var eventUiBases = this.buildEventUiBases(renderableEventStore.defs, eventUiSingleBase, eventUiBySource);
                var newState = {
                    dynamicOptionOverrides: dynamicOptionOverrides,
                    currentViewType: currentViewType,
                    currentDate: currentDate,
                    dateProfile: dateProfile,
                    eventSources: eventSources,
                    eventStore: eventStore,
                    renderableEventStore: renderableEventStore,
                    selectionConfig: selectionConfig,
                    eventUiBases: eventUiBases,
                    businessHours: this.parseContextBusinessHours(calendarContext),
                    dateSelection: $782b2550ae753193$var$reduceDateSelection(state.dateSelection, action),
                    eventSelection: $782b2550ae753193$var$reduceSelectedEvent(state.eventSelection, action),
                    eventDrag: $782b2550ae753193$var$reduceEventDrag(state.eventDrag, action),
                    eventResize: $782b2550ae753193$var$reduceEventResize(state.eventResize, action)
                };
                var contextAndState = Object.assign(Object.assign({}, calendarContext), newState);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = optionsData.pluginHooks.reducers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var reducer = _step.value;
                        Object.assign(newState, reducer(state, action, contextAndState)); // give the OLD state, for old value
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var wasLoading = $782b2550ae753193$var$computeIsLoading(state, calendarContext);
                var isLoading = $782b2550ae753193$var$computeIsLoading(newState, calendarContext);
                // TODO: use propSetHandlers in plugin system
                if (!wasLoading && isLoading) emitter.trigger("loading", true);
                else if (wasLoading && !isLoading) emitter.trigger("loading", false);
                this.state = newState;
                if (props.onAction) props.onAction(action);
            }
        },
        {
            key: "updateData",
            value: function updateData() {
                var _this = this, props = _this.props, state = _this.state;
                var oldData = this.data;
                var optionsData = this.computeOptionsData(props.optionOverrides, state.dynamicOptionOverrides, props.calendarApi);
                var currentViewData = this.computeCurrentViewData(state.currentViewType, optionsData, props.optionOverrides, state.dynamicOptionOverrides);
                var data = this.data = Object.assign(Object.assign(Object.assign({
                    nowManager: this.nowManager,
                    viewTitle: this.buildTitle(state.dateProfile, currentViewData.options, optionsData.dateEnv),
                    calendarApi: props.calendarApi,
                    dispatch: this.dispatch,
                    emitter: this.emitter,
                    getCurrentData: this.getCurrentData
                }, optionsData), currentViewData), state);
                var changeHandlers = optionsData.pluginHooks.optionChangeHandlers;
                var oldCalendarOptions = oldData && oldData.calendarOptions;
                var newCalendarOptions = optionsData.calendarOptions;
                if (oldCalendarOptions && oldCalendarOptions !== newCalendarOptions) {
                    if (oldCalendarOptions.timeZone !== newCalendarOptions.timeZone) {
                        // hack
                        state.eventSources = data.eventSources = $782b2550ae753193$var$reduceEventSourcesNewTimeZone(data.eventSources, state.dateProfile, data);
                        state.eventStore = data.eventStore = (0, $4a7Gb.J)(data.eventStore, oldData.dateEnv, data.dateEnv);
                        state.renderableEventStore = data.renderableEventStore = (0, $4a7Gb.J)(data.renderableEventStore, oldData.dateEnv, data.dateEnv);
                    }
                    for(var optionName in changeHandlers)if (this.optionsForHandling.indexOf(optionName) !== -1 || oldCalendarOptions[optionName] !== newCalendarOptions[optionName]) changeHandlers[optionName](newCalendarOptions[optionName], data);
                }
                this.optionsForHandling = [];
                if (props.onData) props.onData(data);
            }
        },
        {
            key: "computeOptionsData",
            value: function computeOptionsData(optionOverrides, dynamicOptionOverrides, calendarApi) {
                // TODO: blacklist options that are handled by optionChangeHandlers
                if (!this.optionsForRefining.length && optionOverrides === this.stableOptionOverrides && dynamicOptionOverrides === this.stableDynamicOptionOverrides) return this.stableCalendarOptionsData;
                var _this_processRawCalendarOptions = this.processRawCalendarOptions(optionOverrides, dynamicOptionOverrides), refinedOptions = _this_processRawCalendarOptions.refinedOptions, pluginHooks = _this_processRawCalendarOptions.pluginHooks, localeDefaults = _this_processRawCalendarOptions.localeDefaults, availableLocaleData = _this_processRawCalendarOptions.availableLocaleData, extra = _this_processRawCalendarOptions.extra;
                $782b2550ae753193$var$warnUnknownOptions(extra);
                var dateEnv = this.buildDateEnv(refinedOptions.timeZone, refinedOptions.locale, refinedOptions.weekNumberCalculation, refinedOptions.firstDay, refinedOptions.weekText, pluginHooks, availableLocaleData, refinedOptions.defaultRangeSeparator);
                var viewSpecs = this.buildViewSpecs(pluginHooks.views, this.stableOptionOverrides, this.stableDynamicOptionOverrides, localeDefaults);
                var theme = this.buildTheme(refinedOptions, pluginHooks);
                var toolbarConfig = this.parseToolbars(refinedOptions, this.stableOptionOverrides, theme, viewSpecs, calendarApi);
                return this.stableCalendarOptionsData = {
                    calendarOptions: refinedOptions,
                    pluginHooks: pluginHooks,
                    dateEnv: dateEnv,
                    viewSpecs: viewSpecs,
                    theme: theme,
                    toolbarConfig: toolbarConfig,
                    localeDefaults: localeDefaults,
                    availableRawLocales: availableLocaleData.map
                };
            }
        },
        {
            // always called from behind a memoizer
            key: "processRawCalendarOptions",
            value: function processRawCalendarOptions(optionOverrides, dynamicOptionOverrides) {
                var _this_optionsForHandling;
                var _mergeRawOptions = (0, $4a7Gb.K)([
                    (0, $4a7Gb.e),
                    optionOverrides,
                    dynamicOptionOverrides
                ]), locales = _mergeRawOptions.locales, locale = _mergeRawOptions.locale;
                var availableLocaleData = this.organizeRawLocales(locales);
                var availableRawLocales = availableLocaleData.map;
                var localeDefaults = this.buildLocale(locale || availableLocaleData.defaultCode, availableRawLocales).options;
                var pluginHooks = this.buildPluginHooks(optionOverrides.plugins || [], $782b2550ae753193$export$905153d94e0757fa);
                var refiners = this.currentCalendarOptionsRefiners = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, (0, $4a7Gb.L)), (0, $4a7Gb.M)), (0, $4a7Gb.N)), pluginHooks.listenerRefiners), pluginHooks.optionRefiners);
                var extra = {};
                var raw = (0, $4a7Gb.K)([
                    (0, $4a7Gb.e),
                    localeDefaults,
                    optionOverrides,
                    dynamicOptionOverrides
                ]);
                var refined = {};
                var currentRaw = this.currentCalendarOptionsInput;
                var currentRefined = this.currentCalendarOptionsRefined;
                var anyChanges = false;
                for(var optionName in raw){
                    if (this.optionsForRefining.indexOf(optionName) === -1 && (raw[optionName] === currentRaw[optionName] || (0, $4a7Gb.O)[optionName] && optionName in currentRaw && (0, $4a7Gb.O)[optionName](currentRaw[optionName], raw[optionName]))) refined[optionName] = currentRefined[optionName];
                    else if (refiners[optionName]) {
                        refined[optionName] = refiners[optionName](raw[optionName]);
                        anyChanges = true;
                    } else extra[optionName] = currentRaw[optionName];
                }
                if (anyChanges) {
                    this.currentCalendarOptionsInput = raw;
                    this.currentCalendarOptionsRefined = refined;
                    this.stableOptionOverrides = optionOverrides;
                    this.stableDynamicOptionOverrides = dynamicOptionOverrides;
                }
                (_this_optionsForHandling = this.optionsForHandling).push.apply(_this_optionsForHandling, (0, $79xu7._)(this.optionsForRefining));
                this.optionsForRefining = [];
                return {
                    rawOptions: this.currentCalendarOptionsInput,
                    refinedOptions: this.currentCalendarOptionsRefined,
                    pluginHooks: pluginHooks,
                    availableLocaleData: availableLocaleData,
                    localeDefaults: localeDefaults,
                    extra: extra
                };
            }
        },
        {
            key: "_computeCurrentViewData",
            value: function _computeCurrentViewData(viewType, optionsData, optionOverrides, dynamicOptionOverrides) {
                var viewSpec = optionsData.viewSpecs[viewType];
                if (!viewSpec) throw new Error('viewType "'.concat(viewType, "\" is not available. Please make sure you've loaded all neccessary plugins"));
                var _this_processRawViewOptions = this.processRawViewOptions(viewSpec, optionsData.pluginHooks, optionsData.localeDefaults, optionOverrides, dynamicOptionOverrides), refinedOptions = _this_processRawViewOptions.refinedOptions, extra = _this_processRawViewOptions.extra;
                $782b2550ae753193$var$warnUnknownOptions(extra);
                this.nowManager.handleInput(optionsData.dateEnv, refinedOptions.now);
                var dateProfileGenerator = this.buildDateProfileGenerator({
                    dateProfileGeneratorClass: viewSpec.optionDefaults.dateProfileGeneratorClass,
                    nowManager: this.nowManager,
                    duration: viewSpec.duration,
                    durationUnit: viewSpec.durationUnit,
                    usesMinMaxTime: viewSpec.optionDefaults.usesMinMaxTime,
                    dateEnv: optionsData.dateEnv,
                    calendarApi: this.props.calendarApi,
                    slotMinTime: refinedOptions.slotMinTime,
                    slotMaxTime: refinedOptions.slotMaxTime,
                    showNonCurrentDates: refinedOptions.showNonCurrentDates,
                    dayCount: refinedOptions.dayCount,
                    dateAlignment: refinedOptions.dateAlignment,
                    dateIncrement: refinedOptions.dateIncrement,
                    hiddenDays: refinedOptions.hiddenDays,
                    weekends: refinedOptions.weekends,
                    validRangeInput: refinedOptions.validRange,
                    visibleRangeInput: refinedOptions.visibleRange,
                    fixedWeekCount: refinedOptions.fixedWeekCount
                });
                var viewApi = this.buildViewApi(viewType, this.getCurrentData, optionsData.dateEnv);
                return {
                    viewSpec: viewSpec,
                    options: refinedOptions,
                    dateProfileGenerator: dateProfileGenerator,
                    viewApi: viewApi
                };
            }
        },
        {
            key: "processRawViewOptions",
            value: function processRawViewOptions(viewSpec, pluginHooks, localeDefaults, optionOverrides, dynamicOptionOverrides) {
                var raw = (0, $4a7Gb.K)([
                    (0, $4a7Gb.e),
                    viewSpec.optionDefaults,
                    localeDefaults,
                    optionOverrides,
                    viewSpec.optionOverrides,
                    dynamicOptionOverrides
                ]);
                var refiners = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, (0, $4a7Gb.L)), (0, $4a7Gb.M)), (0, $4a7Gb.N)), (0, $4a7Gb.P)), pluginHooks.listenerRefiners), pluginHooks.optionRefiners);
                var refined = {};
                var currentRaw = this.currentViewOptionsInput;
                var currentRefined = this.currentViewOptionsRefined;
                var anyChanges = false;
                var extra = {};
                for(var optionName in raw)if (raw[optionName] === currentRaw[optionName] || (0, $4a7Gb.O)[optionName] && (0, $4a7Gb.O)[optionName](raw[optionName], currentRaw[optionName])) refined[optionName] = currentRefined[optionName];
                else {
                    if (raw[optionName] === this.currentCalendarOptionsInput[optionName] || (0, $4a7Gb.O)[optionName] && (0, $4a7Gb.O)[optionName](raw[optionName], this.currentCalendarOptionsInput[optionName])) {
                        if (optionName in this.currentCalendarOptionsRefined) refined[optionName] = this.currentCalendarOptionsRefined[optionName];
                    } else if (refiners[optionName]) refined[optionName] = refiners[optionName](raw[optionName]);
                    else extra[optionName] = raw[optionName];
                    anyChanges = true;
                }
                if (anyChanges) {
                    this.currentViewOptionsInput = raw;
                    this.currentViewOptionsRefined = refined;
                }
                return {
                    rawOptions: this.currentViewOptionsInput,
                    refinedOptions: this.currentViewOptionsRefined,
                    extra: extra
                };
            }
        }
    ]);
    return CalendarDataManager;
}();
function $782b2550ae753193$var$buildDateEnv$1(timeZone, explicitLocale, weekNumberCalculation, firstDay, weekText, pluginHooks, availableLocaleData, defaultSeparator) {
    var locale = $782b2550ae753193$var$buildLocale(explicitLocale || availableLocaleData.defaultCode, availableLocaleData.map);
    return new (0, $4a7Gb.Q)({
        calendarSystem: "gregory",
        timeZone: timeZone,
        namedTimeZoneImpl: pluginHooks.namedTimeZonedImpl,
        locale: locale,
        weekNumberCalculation: weekNumberCalculation,
        firstDay: firstDay,
        weekText: weekText,
        cmdFormatter: pluginHooks.cmdFormatter,
        defaultSeparator: defaultSeparator
    });
}
function $782b2550ae753193$var$buildTheme(options, pluginHooks) {
    var ThemeClass = pluginHooks.themeClasses[options.themeSystem] || $782b2550ae753193$var$StandardTheme;
    return new ThemeClass(options);
}
function $782b2550ae753193$var$buildDateProfileGenerator(props) {
    var DateProfileGeneratorClass = props.dateProfileGeneratorClass || (0, $4a7Gb.R);
    return new DateProfileGeneratorClass(props);
}
function $782b2550ae753193$var$buildViewApi(type, getCurrentData, dateEnv) {
    return new $782b2550ae753193$var$ViewImpl(type, getCurrentData, dateEnv);
}
function $782b2550ae753193$var$buildEventUiBySource(eventSources) {
    return (0, $4a7Gb.a)(eventSources, function(eventSource) {
        return eventSource.ui;
    });
}
function $782b2550ae753193$var$buildEventUiBases(eventDefs, eventUiSingleBase, eventUiBySource) {
    var eventUiBases = {
        "": eventUiSingleBase
    };
    for(var defId in eventDefs){
        var def = eventDefs[defId];
        if (def.sourceId && eventUiBySource[def.sourceId]) eventUiBases[defId] = eventUiBySource[def.sourceId];
    }
    return eventUiBases;
}
function $782b2550ae753193$var$buildViewUiProps(calendarContext) {
    var options = calendarContext.options;
    return {
        eventUiSingleBase: (0, $4a7Gb.S)({
            display: options.eventDisplay,
            editable: options.editable,
            startEditable: options.eventStartEditable,
            durationEditable: options.eventDurationEditable,
            constraint: options.eventConstraint,
            overlap: typeof options.eventOverlap === "boolean" ? options.eventOverlap : undefined,
            allow: options.eventAllow,
            backgroundColor: options.eventBackgroundColor,
            borderColor: options.eventBorderColor,
            textColor: options.eventTextColor,
            color: options.eventColor
        }, calendarContext),
        selectionConfig: (0, $4a7Gb.S)({
            constraint: options.selectConstraint,
            overlap: typeof options.selectOverlap === "boolean" ? options.selectOverlap : undefined,
            allow: options.selectAllow
        }, calendarContext)
    };
}
function $782b2550ae753193$var$computeIsLoading(state, context) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = context.pluginHooks.isLoadingFuncs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var isLoadingFunc = _step.value;
            if (isLoadingFunc(state)) return true;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return false;
}
function $782b2550ae753193$var$parseContextBusinessHours(calendarContext) {
    return (0, $4a7Gb.U)(calendarContext.options.businessHours, calendarContext);
}
function $782b2550ae753193$var$warnUnknownOptions(options, viewName) {
    for(var optionName in options)console.warn("Unknown option '".concat(optionName, "'") + (viewName ? " for view '".concat(viewName, "'") : ""));
}
var $782b2550ae753193$var$ToolbarSection = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $7DbRq._)(ToolbarSection, BaseComponent);
    var _super = (0, $ju9pQ._)(ToolbarSection);
    function ToolbarSection() {
        (0, $luoZD._)(this, ToolbarSection);
        return _super.apply(this, arguments);
    }
    (0, $fYUO3._)(ToolbarSection, [
        {
            key: "render",
            value: function render() {
                var _this = this;
                var children = this.props.widgetGroups.map(function(widgetGroup) {
                    return _this.renderWidgetGroup(widgetGroup);
                });
                return (0, $ihX0O.createElement).apply(void 0, [
                    "div",
                    {
                        className: "fc-toolbar-chunk"
                    }
                ].concat((0, $79xu7._)(children)));
            }
        },
        {
            key: "renderWidgetGroup",
            value: function renderWidgetGroup(widgetGroup) {
                var props = this.props;
                var theme = this.context.theme;
                var children = [];
                var isOnlyButtons = true;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = widgetGroup[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var widget = _step.value;
                        var buttonName = widget.buttonName, buttonClick = widget.buttonClick, buttonText = widget.buttonText, buttonIcon = widget.buttonIcon, buttonHint = widget.buttonHint;
                        if (buttonName === "title") {
                            isOnlyButtons = false;
                            children.push((0, $ihX0O.createElement)("h2", {
                                className: "fc-toolbar-title",
                                id: props.titleId
                            }, props.title));
                        } else {
                            var isPressed = buttonName === props.activeButton;
                            var isDisabled = !props.isTodayEnabled && buttonName === "today" || !props.isPrevEnabled && buttonName === "prev" || !props.isNextEnabled && buttonName === "next";
                            var buttonClasses = [
                                "fc-".concat(buttonName, "-button"),
                                theme.getClass("button")
                            ];
                            if (isPressed) buttonClasses.push(theme.getClass("buttonActive"));
                            children.push((0, $ihX0O.createElement)("button", {
                                type: "button",
                                title: typeof buttonHint === "function" ? buttonHint(props.navUnit) : buttonHint,
                                disabled: isDisabled,
                                "aria-pressed": isPressed,
                                className: buttonClasses.join(" "),
                                onClick: buttonClick
                            }, buttonText || (buttonIcon ? (0, $ihX0O.createElement)("span", {
                                className: buttonIcon,
                                role: "img"
                            }) : "")));
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                if (children.length > 1) {
                    var groupClassName = isOnlyButtons && theme.getClass("buttonGroup") || "";
                    return (0, $ihX0O.createElement).apply(void 0, [
                        "div",
                        {
                            className: groupClassName
                        }
                    ].concat((0, $79xu7._)(children)));
                }
                return children[0];
            }
        }
    ]);
    return ToolbarSection;
}((0, $4a7Gb.B));
var $782b2550ae753193$var$Toolbar = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $7DbRq._)(Toolbar, BaseComponent);
    var _super = (0, $ju9pQ._)(Toolbar);
    function Toolbar() {
        (0, $luoZD._)(this, Toolbar);
        return _super.apply(this, arguments);
    }
    (0, $fYUO3._)(Toolbar, [
        {
            key: "render",
            value: function render() {
                var _this_props = this.props, model = _this_props.model, extraClassName = _this_props.extraClassName;
                var forceLtr = false;
                var startContent;
                var endContent;
                var sectionWidgets = model.sectionWidgets;
                var centerContent = sectionWidgets.center;
                if (sectionWidgets.left) {
                    forceLtr = true;
                    startContent = sectionWidgets.left;
                } else startContent = sectionWidgets.start;
                if (sectionWidgets.right) {
                    forceLtr = true;
                    endContent = sectionWidgets.right;
                } else endContent = sectionWidgets.end;
                var classNames = [
                    extraClassName || "",
                    "fc-toolbar",
                    forceLtr ? "fc-toolbar-ltr" : ""
                ];
                return (0, $ihX0O.createElement)("div", {
                    className: classNames.join(" ")
                }, this.renderSection("start", startContent || []), this.renderSection("center", centerContent || []), this.renderSection("end", endContent || []));
            }
        },
        {
            key: "renderSection",
            value: function renderSection(key, widgetGroups) {
                var props = this.props;
                return (0, $ihX0O.createElement)($782b2550ae753193$var$ToolbarSection, {
                    key: key,
                    widgetGroups: widgetGroups,
                    title: props.title,
                    navUnit: props.navUnit,
                    activeButton: props.activeButton,
                    isTodayEnabled: props.isTodayEnabled,
                    isPrevEnabled: props.isPrevEnabled,
                    isNextEnabled: props.isNextEnabled,
                    titleId: props.titleId
                });
            }
        }
    ]);
    return Toolbar;
}((0, $4a7Gb.B));
var $782b2550ae753193$var$ViewHarness = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $7DbRq._)(ViewHarness, BaseComponent);
    var _super = (0, $ju9pQ._)(ViewHarness);
    function ViewHarness() {
        (0, $luoZD._)(this, ViewHarness);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.state = {
            availableWidth: null
        };
        _this.handleEl = function(el) {
            _this.el = el;
            (0, $4a7Gb.W)(_this.props.elRef, el);
            _this.updateAvailableWidth();
        };
        _this.handleResize = function() {
            _this.updateAvailableWidth();
        };
        return _this;
    }
    (0, $fYUO3._)(ViewHarness, [
        {
            key: "render",
            value: function render() {
                var _this = this, props = _this.props, state = _this.state;
                var aspectRatio = props.aspectRatio;
                var classNames = [
                    "fc-view-harness",
                    aspectRatio || props.liquid || props.height ? "fc-view-harness-active" // harness controls the height
                     : "fc-view-harness-passive"
                ];
                var height = "";
                var paddingBottom = "";
                if (aspectRatio) {
                    if (state.availableWidth !== null) height = state.availableWidth / aspectRatio;
                    else // while waiting to know availableWidth, we can't set height to *zero*
                    // because will cause lots of unnecessary scrollbars within scrollgrid.
                    // BETTER: don't start rendering ANYTHING yet until we know container width
                    // NOTE: why not always use paddingBottom? Causes height oscillation (issue 5606)
                    paddingBottom = "".concat(1 / aspectRatio * 100, "%");
                } else height = props.height || "";
                return (0, $ihX0O.createElement)("div", {
                    "aria-labelledby": props.labeledById,
                    ref: this.handleEl,
                    className: classNames.join(" "),
                    style: {
                        height: height,
                        paddingBottom: paddingBottom
                    }
                }, props.children);
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.context.addResizeHandler(this.handleResize);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.context.removeResizeHandler(this.handleResize);
            }
        },
        {
            key: "updateAvailableWidth",
            value: function updateAvailableWidth() {
                if (this.el && // needed. but why?
                this.props.aspectRatio // aspectRatio is the only height setting that needs availableWidth
                ) this.setState({
                    availableWidth: this.el.offsetWidth
                });
            }
        }
    ]);
    return ViewHarness;
}((0, $4a7Gb.B));
/*
Detects when the user clicks on an event within a DateComponent
*/ var $782b2550ae753193$var$EventClicking = /*#__PURE__*/ function(Interaction) {
    "use strict";
    (0, $7DbRq._)(EventClicking, Interaction);
    var _super = (0, $ju9pQ._)(EventClicking);
    function EventClicking(settings) {
        (0, $luoZD._)(this, EventClicking);
        var _this;
        _this = _super.call(this, settings);
        _this.handleSegClick = function(ev, segEl) {
            var component = (0, $iJSF3._)(_this).component;
            var context = component.context;
            var seg = (0, $4a7Gb.Y)(segEl);
            if (seg && // might be the <div> surrounding the more link
            component.isValidSegDownEl(ev.target)) {
                // our way to simulate a link click for elements that can't be <a> tags
                // grab before trigger fired in case trigger trashes DOM thru rerendering
                var hasUrlContainer = (0, $4a7Gb.Z)(ev.target, ".fc-event-forced-url");
                var url = hasUrlContainer ? hasUrlContainer.querySelector("a[href]").href : "";
                context.emitter.trigger("eventClick", {
                    el: segEl,
                    event: new (0, $4a7Gb._)(component.context, seg.eventRange.def, seg.eventRange.instance),
                    jsEvent: ev,
                    view: context.viewApi
                });
                if (url && !ev.defaultPrevented) window.location.href = url;
            }
        };
        _this.destroy = (0, $4a7Gb.$)(settings.el, "click", ".fc-event", _this.handleSegClick);
        return _this;
    }
    return EventClicking;
}((0, $4a7Gb.X));
/*
Triggers events and adds/removes core classNames when the user's pointer
enters/leaves event-elements of a component.
*/ var $782b2550ae753193$var$EventHovering = /*#__PURE__*/ function(Interaction) {
    "use strict";
    (0, $7DbRq._)(EventHovering, Interaction);
    var _super = (0, $ju9pQ._)(EventHovering);
    function EventHovering(settings) {
        (0, $luoZD._)(this, EventHovering);
        var _this;
        _this = _super.call(this, settings);
        // for simulating an eventMouseLeave when the event el is destroyed while mouse is over it
        _this.handleEventElRemove = function(el) {
            if (el === _this.currentSegEl) _this.handleSegLeave(null, _this.currentSegEl);
        };
        _this.handleSegEnter = function(ev, segEl) {
            if ((0, $4a7Gb.Y)(segEl)) {
                _this.currentSegEl = segEl;
                _this.triggerEvent("eventMouseEnter", ev, segEl);
            }
        };
        _this.handleSegLeave = function(ev, segEl) {
            if (_this.currentSegEl) {
                _this.currentSegEl = null;
                _this.triggerEvent("eventMouseLeave", ev, segEl);
            }
        };
        _this.removeHoverListeners = (0, $4a7Gb.a0)(settings.el, ".fc-event", _this.handleSegEnter, _this.handleSegLeave);
        return _this;
    }
    (0, $fYUO3._)(EventHovering, [
        {
            key: "destroy",
            value: function destroy() {
                this.removeHoverListeners();
            }
        },
        {
            key: "triggerEvent",
            value: function triggerEvent(publicEvName, ev, segEl) {
                var component = this.component;
                var context = component.context;
                var seg = (0, $4a7Gb.Y)(segEl);
                if (!ev || component.isValidSegDownEl(ev.target)) context.emitter.trigger(publicEvName, {
                    el: segEl,
                    event: new (0, $4a7Gb._)(context, seg.eventRange.def, seg.eventRange.instance),
                    jsEvent: ev,
                    view: context.viewApi
                });
            }
        }
    ]);
    return EventHovering;
}((0, $4a7Gb.X));
var $782b2550ae753193$var$CalendarContent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0, $7DbRq._)(CalendarContent, PureComponent);
    var _super = (0, $ju9pQ._)(CalendarContent);
    function CalendarContent() {
        (0, $luoZD._)(this, CalendarContent);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.buildViewContext = (0, $4a7Gb.z)((0, $4a7Gb.a2));
        _this.buildViewPropTransformers = (0, $4a7Gb.z)($782b2550ae753193$var$buildViewPropTransformers);
        _this.buildToolbarProps = (0, $4a7Gb.z)($782b2550ae753193$var$buildToolbarProps);
        _this.headerRef = (0, $ihX0O.createRef)();
        _this.footerRef = (0, $ihX0O.createRef)();
        _this.interactionsStore = {};
        // eslint-disable-next-line
        _this.state = {
            viewLabelId: (0, $4a7Gb.a3)()
        };
        // Component Registration
        // -----------------------------------------------------------------------------------------------------------------
        _this.registerInteractiveComponent = function(component, settingsInput) {
            var settings = (0, $4a7Gb.a4)(component, settingsInput);
            var DEFAULT_INTERACTIONS = [
                $782b2550ae753193$var$EventClicking,
                $782b2550ae753193$var$EventHovering
            ];
            var interactionClasses = DEFAULT_INTERACTIONS.concat(_this.props.pluginHooks.componentInteractions);
            var interactions = interactionClasses.map(function(TheInteractionClass) {
                return new TheInteractionClass(settings);
            });
            _this.interactionsStore[component.uid] = interactions;
            (0, $4a7Gb.a5)[component.uid] = settings;
        };
        _this.unregisterInteractiveComponent = function(component) {
            var listeners = _this.interactionsStore[component.uid];
            if (listeners) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = listeners[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var listener = _step.value;
                        listener.destroy();
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                delete _this.interactionsStore[component.uid];
            }
            delete (0, $4a7Gb.a5)[component.uid];
        };
        // Resizing
        // -----------------------------------------------------------------------------------------------------------------
        _this.resizeRunner = new (0, $4a7Gb.D)(function() {
            _this.props.emitter.trigger("_resize", true); // should window resizes be considered "forced" ?
            _this.props.emitter.trigger("windowResize", {
                view: _this.props.viewApi
            });
        });
        _this.handleWindowResize = function(ev) {
            var options = _this.props.options;
            if (options.handleWindowResize && ev.target === window // avoid jqui events
            ) _this.resizeRunner.request(options.windowResizeDelay);
        };
        return _this;
    }
    (0, $fYUO3._)(CalendarContent, [
        {
            /*
    renders INSIDE of an outer div
    */ key: "render",
            value: function render() {
                var _this = this;
                var props = this.props;
                var toolbarConfig = props.toolbarConfig, options = props.options;
                var viewVGrow = false;
                var viewHeight = "";
                var viewAspectRatio;
                if (props.isHeightAuto || props.forPrint) viewHeight = "";
                else if (options.height != null) viewVGrow = true;
                else if (options.contentHeight != null) viewHeight = options.contentHeight;
                else viewAspectRatio = Math.max(options.aspectRatio, 0.5); // prevent from getting too tall
                var viewContext = this.buildViewContext(props.viewSpec, props.viewApi, props.options, props.dateProfileGenerator, props.dateEnv, props.nowManager, props.theme, props.pluginHooks, props.dispatch, props.getCurrentData, props.emitter, props.calendarApi, this.registerInteractiveComponent, this.unregisterInteractiveComponent);
                var viewLabelId = toolbarConfig.header && toolbarConfig.header.hasTitle ? this.state.viewLabelId : undefined;
                return (0, $ihX0O.createElement)((0, $4a7Gb.V).Provider, {
                    value: viewContext
                }, (0, $ihX0O.createElement)((0, $4a7Gb.a6), {
                    unit: "day"
                }, function(nowDate) {
                    var toolbarProps = _this.buildToolbarProps(props.viewSpec, props.dateProfile, props.dateProfileGenerator, props.currentDate, nowDate, props.viewTitle);
                    return (0, $ihX0O.createElement)((0, $ihX0O.Fragment), null, toolbarConfig.header && (0, $ihX0O.createElement)($782b2550ae753193$var$Toolbar, Object.assign({
                        ref: _this.headerRef,
                        extraClassName: "fc-header-toolbar",
                        model: toolbarConfig.header,
                        titleId: viewLabelId
                    }, toolbarProps)), (0, $ihX0O.createElement)($782b2550ae753193$var$ViewHarness, {
                        liquid: viewVGrow,
                        height: viewHeight,
                        aspectRatio: viewAspectRatio,
                        labeledById: viewLabelId
                    }, _this.renderView(props), _this.buildAppendContent()), toolbarConfig.footer && (0, $ihX0O.createElement)($782b2550ae753193$var$Toolbar, Object.assign({
                        ref: _this.footerRef,
                        extraClassName: "fc-footer-toolbar",
                        model: toolbarConfig.footer,
                        titleId: ""
                    }, toolbarProps)));
                }));
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var props = this.props;
                this.calendarInteractions = props.pluginHooks.calendarInteractions.map(function(CalendarInteractionClass) {
                    return new CalendarInteractionClass(props);
                });
                window.addEventListener("resize", this.handleWindowResize);
                var propSetHandlers = props.pluginHooks.propSetHandlers;
                for(var propName in propSetHandlers)propSetHandlers[propName](props[propName], props);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var props = this.props;
                var propSetHandlers = props.pluginHooks.propSetHandlers;
                for(var propName in propSetHandlers)if (props[propName] !== prevProps[propName]) propSetHandlers[propName](props[propName], props);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                window.removeEventListener("resize", this.handleWindowResize);
                this.resizeRunner.clear();
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.calendarInteractions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var interaction = _step.value;
                        interaction.destroy();
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                this.props.emitter.trigger("_unmount");
            }
        },
        {
            key: "buildAppendContent",
            value: function buildAppendContent() {
                var props = this.props;
                var children = props.pluginHooks.viewContainerAppends.map(function(buildAppendContent) {
                    return buildAppendContent(props);
                });
                return (0, $ihX0O.createElement).apply(void 0, [
                    (0, $ihX0O.Fragment),
                    {}
                ].concat((0, $79xu7._)(children)));
            }
        },
        {
            key: "renderView",
            value: function renderView(props) {
                var pluginHooks = props.pluginHooks;
                var viewSpec = props.viewSpec;
                var viewProps = {
                    dateProfile: props.dateProfile,
                    businessHours: props.businessHours,
                    eventStore: props.renderableEventStore,
                    eventUiBases: props.eventUiBases,
                    dateSelection: props.dateSelection,
                    eventSelection: props.eventSelection,
                    eventDrag: props.eventDrag,
                    eventResize: props.eventResize,
                    isHeightAuto: props.isHeightAuto,
                    forPrint: props.forPrint
                };
                var transformers = this.buildViewPropTransformers(pluginHooks.viewPropsTransformers);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = transformers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var transformer = _step.value;
                        Object.assign(viewProps, transformer.transform(viewProps, props));
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var ViewComponent = viewSpec.component;
                return (0, $ihX0O.createElement)(ViewComponent, Object.assign({}, viewProps));
            }
        }
    ]);
    return CalendarContent;
}((0, $4a7Gb.a1));
function $782b2550ae753193$var$buildToolbarProps(viewSpec, dateProfile, dateProfileGenerator, currentDate, now, title) {
    // don't force any date-profiles to valid date profiles (the `false`) so that we can tell if it's invalid
    var todayInfo = dateProfileGenerator.build(now, undefined, false); // TODO: need `undefined` or else INFINITE LOOP for some reason
    var prevInfo = dateProfileGenerator.buildPrev(dateProfile, currentDate, false);
    var nextInfo = dateProfileGenerator.buildNext(dateProfile, currentDate, false);
    return {
        title: title,
        activeButton: viewSpec.type,
        navUnit: viewSpec.singleUnit,
        isTodayEnabled: todayInfo.isValid && !(0, $4a7Gb.G)(dateProfile.currentRange, now),
        isPrevEnabled: prevInfo.isValid,
        isNextEnabled: nextInfo.isValid
    };
}
// Plugin
// -----------------------------------------------------------------------------------------------------------------
function $782b2550ae753193$var$buildViewPropTransformers(theClasses) {
    return theClasses.map(function(TheClass) {
        return new TheClass();
    });
}
var $782b2550ae753193$export$e1aef45b828286de = /*#__PURE__*/ function(CalendarImpl) {
    "use strict";
    (0, $7DbRq._)(Calendar, CalendarImpl);
    var _super = (0, $ju9pQ._)(Calendar);
    function Calendar(el) {
        var optionOverrides = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        (0, $luoZD._)(this, Calendar);
        var _this;
        _this = _super.call(this);
        _this.isRendering = false;
        _this.isRendered = false;
        _this.currentClassNames = [];
        _this.customContentRenderId = 0;
        _this.handleAction = function(action) {
            // actions we know we want to render immediately
            switch(action.type){
                case "SET_EVENT_DRAG":
                case "SET_EVENT_RESIZE":
                    _this.renderRunner.tryDrain();
            }
        };
        _this.handleData = function(data) {
            _this.currentData = data;
            _this.renderRunner.request(data.calendarOptions.rerenderDelay);
        };
        _this.handleRenderRequest = function() {
            if (_this.isRendering) {
                _this.isRendered = true;
                var currentData = (0, $iJSF3._)(_this).currentData;
                (0, $4a7Gb.a8)(function() {
                    (0, $ihX0O.render)((0, $ihX0O.createElement)((0, $4a7Gb.a9), {
                        options: currentData.calendarOptions,
                        theme: currentData.theme,
                        emitter: currentData.emitter
                    }, function(classNames, height, isHeightAuto, forPrint) {
                        _this.setClassNames(classNames);
                        _this.setHeight(height);
                        return (0, $ihX0O.createElement)((0, $4a7Gb.aa).Provider, {
                            value: _this.customContentRenderId
                        }, (0, $ihX0O.createElement)($782b2550ae753193$var$CalendarContent, Object.assign({
                            isHeightAuto: isHeightAuto,
                            forPrint: forPrint
                        }, currentData)));
                    }), _this.el);
                });
            } else if (_this.isRendered) {
                _this.isRendered = false;
                (0, $ihX0O.render)(null, _this.el);
                _this.setClassNames([]);
                _this.setHeight("");
            }
        };
        (0, $4a7Gb.ab)(el);
        _this.el = el;
        _this.renderRunner = new (0, $4a7Gb.D)(_this.handleRenderRequest);
        new $782b2550ae753193$var$CalendarDataManager({
            optionOverrides: optionOverrides,
            calendarApi: (0, $iJSF3._)(_this),
            onAction: _this.handleAction,
            onData: _this.handleData
        });
        return _this;
    }
    (0, $fYUO3._)(Calendar, [
        {
            key: "render",
            value: function render() {
                var wasRendering = this.isRendering;
                if (!wasRendering) this.isRendering = true;
                else this.customContentRenderId += 1;
                this.renderRunner.request();
                if (wasRendering) this.updateSize();
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                if (this.isRendering) {
                    this.isRendering = false;
                    this.renderRunner.request();
                }
            }
        },
        {
            key: "updateSize",
            value: function updateSize() {
                var _this = this;
                (0, $4a7Gb.a8)(function() {
                    (0, $9WbNX._)((0, $3Oamm._)(Calendar.prototype), "updateSize", _this).call(_this);
                });
            }
        },
        {
            key: "batchRendering",
            value: function batchRendering(func) {
                this.renderRunner.pause("batchRendering");
                func();
                this.renderRunner.resume("batchRendering");
            }
        },
        {
            key: "pauseRendering",
            value: function pauseRendering() {
                this.renderRunner.pause("pauseRendering");
            }
        },
        {
            key: "resumeRendering",
            value: function resumeRendering() {
                this.renderRunner.resume("pauseRendering", true);
            }
        },
        {
            key: "resetOptions",
            value: function resetOptions(optionOverrides, changedOptionNames) {
                this.currentDataManager.resetOptions(optionOverrides, changedOptionNames);
            }
        },
        {
            key: "setClassNames",
            value: function setClassNames(classNames) {
                if (!(0, $4a7Gb.i)(classNames, this.currentClassNames)) {
                    var classList = this.el.classList;
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = this.currentClassNames[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var className = _step.value;
                            classList.remove(className);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    try {
                        for(var _iterator1 = classNames[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                            var className1 = _step1.value;
                            classList.add(className1);
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                _iterator1.return();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                    this.currentClassNames = classNames;
                }
            }
        },
        {
            key: "setHeight",
            value: function setHeight(height) {
                (0, $4a7Gb.ac)(this.el, "height", height);
            }
        }
    ]);
    return Calendar;
}((0, $4a7Gb.a7));
function $782b2550ae753193$export$3ae94a2503e890a1(dateInput) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var dateEnv = $782b2550ae753193$var$buildDateEnv(options);
    var formatter = (0, $4a7Gb.x)(options);
    var dateMeta = dateEnv.createMarkerMeta(dateInput);
    if (!dateMeta) return "";
    return dateEnv.format(dateMeta.marker, formatter, {
        forcedTzo: dateMeta.forcedTzo
    });
}
function $782b2550ae753193$export$9b1080e2eec9158(startInput, endInput, options) {
    var dateEnv = $782b2550ae753193$var$buildDateEnv(typeof options === "object" && options ? options : {}); // pass in if non-null object
    var formatter = (0, $4a7Gb.x)(options);
    var startMeta = dateEnv.createMarkerMeta(startInput);
    var endMeta = dateEnv.createMarkerMeta(endInput);
    if (!startMeta || !endMeta) return "";
    return dateEnv.formatRange(startMeta.marker, endMeta.marker, formatter, {
        forcedStartTzo: startMeta.forcedTzo,
        forcedEndTzo: endMeta.forcedTzo,
        isEndExclusive: options.isEndExclusive,
        defaultSeparator: (0, $4a7Gb.e).defaultRangeSeparator
    });
}
// TODO: more DRY and optimized
function $782b2550ae753193$var$buildDateEnv(settings) {
    var locale = $782b2550ae753193$var$buildLocale(settings.locale || "en", $782b2550ae753193$var$organizeRawLocales([]).map); // TODO: don't hardcode 'en' everywhere
    return new (0, $4a7Gb.Q)(Object.assign(Object.assign({
        timeZone: (0, $4a7Gb.e).timeZone,
        calendarSystem: "gregory"
    }, settings), {
        locale: locale
    }));
}
// HELPERS
/*
if nextDayThreshold is specified, slicing is done in an all-day fashion.
you can get nextDayThreshold from context.nextDayThreshold
*/ function $782b2550ae753193$export$3b384895d0cca0f2(props, allDay) {
    return (0, $4a7Gb.ad)(props.eventStore, props.eventUiBases, props.dateProfile.activeRange, allDay ? props.nextDayThreshold : null).fg;
}
var $782b2550ae753193$export$83d89fbfd8236492 = "6.1.21";



var $4a7Gb = parcelRequire("4a7Gb");
var $9999cb8e2fc653e7$export$a16f0a896a5485b = {
    headerToolbar: true,
    footerToolbar: true,
    events: true,
    eventSources: true,
    resources: true
};


var $b8fd8d6abad83926$var$FullCalendar = (0, $aD8ZA.defineComponent)({
    props: {
        options: Object
    },
    data: function() {
        return {
            renderId: 0,
            customRenderingMap: new Map()
        };
    },
    methods: {
        getApi: function() {
            return $b8fd8d6abad83926$var$getSecret(this).calendar;
        },
        buildOptions: function(suppliedOptions) {
            return (0, $8typN._)((0, $8pZMQ._)({}, suppliedOptions), {
                customRenderingMetaMap: $b8fd8d6abad83926$var$kebabToCamelKeys(this.$slots),
                handleCustomRendering: $b8fd8d6abad83926$var$getSecret(this).handleCustomRendering
            });
        }
    },
    render: function() {
        var customRenderingNodes = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = this.customRenderingMap.values()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var customRendering = _step.value;
                customRenderingNodes.push((0, $aD8ZA.h)($b8fd8d6abad83926$var$CustomRenderingComponent, {
                    key: customRendering.id,
                    customRendering: customRendering
                }));
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return (0, $aD8ZA.h)("div", {
            // when renderId is changed, Vue will trigger a real-DOM async rerender, calling beforeUpdate/updated
            attrs: {
                "data-fc-render-id": this.renderId
            }
        }, (0, $aD8ZA.h)((0, $aD8ZA.Fragment), customRenderingNodes)); // for containing CustomRendering keys
    },
    mounted: function() {
        var _this = this;
        var customRenderingStore = new (0, $4a7Gb.cv)();
        $b8fd8d6abad83926$var$getSecret(this).handleCustomRendering = customRenderingStore.handle.bind(customRenderingStore);
        var calendarOptions = this.buildOptions(this.options);
        var calendar = new (0, $782b2550ae753193$export$e1aef45b828286de)(this.$el, calendarOptions);
        $b8fd8d6abad83926$var$getSecret(this).calendar = calendar;
        calendar.render();
        customRenderingStore.subscribe(function(customRenderingMap) {
            _this.customRenderingMap = customRenderingMap; // likely same reference, so won't rerender
            _this.renderId++; // force rerender
            $b8fd8d6abad83926$var$getSecret(_this).needCustomRenderingResize = true;
        });
    },
    beforeUpdate: function() {
        this.getApi().resumeRendering(); // the watcher handlers paused it
    },
    updated: function() {
        if ($b8fd8d6abad83926$var$getSecret(this).needCustomRenderingResize) {
            $b8fd8d6abad83926$var$getSecret(this).needCustomRenderingResize = false;
            this.getApi().updateSize();
        }
    },
    beforeUnmount: function() {
        this.getApi().destroy();
    },
    watch: $b8fd8d6abad83926$var$buildWatchers()
});
var $b8fd8d6abad83926$export$2e2bcd8739ae039 = $b8fd8d6abad83926$var$FullCalendar;
// Custom Rendering
// -------------------------------------------------------------------------------------------------
var $b8fd8d6abad83926$var$CustomRenderingComponent = (0, $aD8ZA.defineComponent)({
    props: {
        customRendering: Object
    },
    render: function() {
        var customRendering = this.customRendering;
        var innerContent = typeof customRendering.generatorMeta === "function" ? customRendering.generatorMeta(customRendering.renderProps) : customRendering.generatorMeta; // probably a vue JSX node returned from content-inject func
        return (0, $aD8ZA.h)((0, $aD8ZA.Teleport), {
            to: customRendering.containerEl
        }, innerContent);
    }
});
// storing internal state:
// https://github.com/vuejs/vue/issues/1988#issuecomment-163013818
function $b8fd8d6abad83926$var$getSecret(inst) {
    return inst;
}
function $b8fd8d6abad83926$var$buildWatchers() {
    var _loop = function(complexOptionName) {
        // handlers called when nested objects change
        watchers["options.".concat(complexOptionName)] = {
            deep: true,
            handler: function(val) {
                // unfortunately the handler is called with undefined if new props were set, but the complex one wasn't ever set
                if (val !== undefined) {
                    var calendar = this.getApi();
                    calendar.pauseRendering();
                    calendar.resetOptions({
                        [complexOptionName]: val
                    }, [
                        complexOptionName
                    ]);
                    this.renderId++; // will queue a rerender
                }
            }
        };
    };
    var watchers = {
        // watches changes of ALL options and their nested objects,
        // but this is only a means to be notified of top-level non-complex options changes.
        options: {
            deep: true,
            handler: function(options) {
                var calendar = this.getApi();
                calendar.pauseRendering();
                var calendarOptions = this.buildOptions(options);
                calendar.resetOptions(calendarOptions);
                this.renderId++; // will queue a rerender
            }
        }
    };
    for(var complexOptionName in 0, $9999cb8e2fc653e7$export$a16f0a896a5485b)_loop(complexOptionName);
    return watchers;
}
// General Utils
// -------------------------------------------------------------------------------------------------
function $b8fd8d6abad83926$var$kebabToCamelKeys(map) {
    var newMap = {};
    for(var key in map)newMap[$b8fd8d6abad83926$var$kebabToCamel(key)] = map[key];
    return newMap;
}
function $b8fd8d6abad83926$var$kebabToCamel(s) {
    return s.split("-").map(function(word, index) {
        return index ? $b8fd8d6abad83926$var$capitalize(word) : word;
    }).join("");
}
function $b8fd8d6abad83926$var$capitalize(s) {
    return s.charAt(0).toUpperCase() + s.slice(1);
}


var $7336c146e4da07a9$export$2e2bcd8739ae039 = (0, $b8fd8d6abad83926$export$2e2bcd8739ae039);




var $jBC23 = parcelRequire("jBC23");


var $d8791a4f419a01c6$export$2e2bcd8739ae039 = (0, $782b2550ae753193$export$ae829ec7b2625219)({
    name: "@fullcalendar/daygrid",
    initialView: "dayGridMonth",
    views: {
        dayGrid: {
            component: (0, $jBC23.DayGridView),
            dateProfileGeneratorClass: (0, $jBC23.TableDateProfileGenerator)
        },
        dayGridDay: {
            type: "dayGrid",
            duration: {
                days: 1
            }
        },
        dayGridWeek: {
            type: "dayGrid",
            duration: {
                weeks: 1
            }
        },
        dayGridMonth: {
            type: "dayGrid",
            duration: {
                months: 1
            },
            fixedWeekCount: true
        },
        dayGridYear: {
            type: "dayGrid",
            duration: {
                years: 1
            }
        }
    }
});


var $b2e508448f8f4189$export$2e2bcd8739ae039 = {
    code: "pt-br",
    buttonText: {
        prev: "Anterior",
        next: "Pr\xf3ximo",
        prevYear: "Ano anterior",
        nextYear: "Pr\xf3ximo ano",
        year: "Ano",
        today: "Hoje",
        month: "M\xeas",
        week: "Semana",
        day: "Dia",
        list: "Lista"
    },
    buttonHints: {
        prev: "$0 Anterior",
        next: "Pr\xf3ximo $0",
        today: function(buttonText) {
            return buttonText === "Dia" ? "Hoje" : (buttonText === "Semana" ? "Esta" : "Este") + " " + buttonText.toLocaleLowerCase();
        }
    },
    viewHint: function(buttonText) {
        return "Visualizar " + (buttonText === "Semana" ? "a" : "o") + " " + buttonText.toLocaleLowerCase();
    },
    weekText: "Sm",
    weekTextLong: "Semana",
    allDayText: "dia inteiro",
    moreLinkText: function(n) {
        return "mais +" + n;
    },
    moreLinkHint: function(eventCnt) {
        return "Mostrar mais ".concat(eventCnt, " eventos");
    },
    noEventsText: "N\xe3o h\xe1 eventos para mostrar",
    navLinkHint: "Ir para $0",
    closeHint: "Fechar",
    timeHint: "A hora",
    eventHint: "Evento"
};


/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */ var $d3c0bf409b72241e$export$dfd9b671c89acc8e = 7;
var $d3c0bf409b72241e$export$3913210603d8e9ae = 365.2425;
var $d3c0bf409b72241e$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
var $d3c0bf409b72241e$export$91246f0b9bd9beff = 60000;
var $d3c0bf409b72241e$export$7f72910d6dfd237a = 3600000;
var $d3c0bf409b72241e$export$397c2d5776aa9055 = 1000;
var $d3c0bf409b72241e$export$4dec998e48f9c246 = -$d3c0bf409b72241e$export$81caae6e1cc7a622;
var $d3c0bf409b72241e$export$f2f5ae5a8e2d8f9f = 60;
var $d3c0bf409b72241e$export$3c58128db900d44e = 3;
var $d3c0bf409b72241e$export$80d7e435f744f319 = 12;
var $d3c0bf409b72241e$export$4db7641526e3241f = 4;
var $d3c0bf409b72241e$export$698aec755e92c695 = 3600;
var $d3c0bf409b72241e$export$a77c1a7ebebe2a5a = 60;
var $d3c0bf409b72241e$export$815a9362476d2fe3 = $d3c0bf409b72241e$export$698aec755e92c695 * 24;
var $d3c0bf409b72241e$export$34804a017b31e2fe = $d3c0bf409b72241e$export$815a9362476d2fe3 * 7;
var $d3c0bf409b72241e$export$7271e9e3478110d1 = $d3c0bf409b72241e$export$815a9362476d2fe3 * $d3c0bf409b72241e$export$3913210603d8e9ae;
var $d3c0bf409b72241e$export$8e6600bbdee7dabb = $d3c0bf409b72241e$export$7271e9e3478110d1 / 12;
var $d3c0bf409b72241e$export$be1dccf2de902d31 = $d3c0bf409b72241e$export$8e6600bbdee7dabb * 3;




function $a27bb432a68aee21$export$2e2bcd8739ae039(argument, options) {
    var _options$additionalDi;
    (0, $0acc3380b5849741$export$2e2bcd8739ae039)(1, arguments);
    var additionalDigits = (0, $bc43d2291f2f753b$export$2e2bcd8739ae039)((_options$additionalDi = options === null || options === void 0 ? void 0 : options.additionalDigits) !== null && _options$additionalDi !== void 0 ? _options$additionalDi : 2);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError("additionalDigits must be 0, 1 or 2");
    if (!(typeof argument === "string" || Object.prototype.toString.call(argument) === "[object String]")) return new Date(NaN);
    var dateStrings = $a27bb432a68aee21$var$splitDateString(argument);
    var date;
    if (dateStrings.date) {
        var parseYearResult = $a27bb432a68aee21$var$parseYear(dateStrings.date, additionalDigits);
        date = $a27bb432a68aee21$var$parseDate(parseYearResult.restDateString, parseYearResult.year);
    }
    if (!date || isNaN(date.getTime())) return new Date(NaN);
    var timestamp = date.getTime();
    var time = 0;
    var offset;
    if (dateStrings.time) {
        time = $a27bb432a68aee21$var$parseTime(dateStrings.time);
        if (isNaN(time)) return new Date(NaN);
    }
    if (dateStrings.timezone) {
        offset = $a27bb432a68aee21$var$parseTimezone(dateStrings.timezone);
        if (isNaN(offset)) return new Date(NaN);
    } else {
        var dirtyDate = new Date(timestamp + time);
        // js parsed string assuming it's in UTC timezone
        // but we need it to be parsed in our timezone
        // so we use utc values to build date in our timezone.
        // Year values from 0 to 99 map to the years 1900 to 1999
        // so set year explicitly with setFullYear.
        var result = new Date(0);
        result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
        result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
        return result;
    }
    return new Date(timestamp + time + offset);
}
var $a27bb432a68aee21$var$patterns = {
    dateTimeDelimiter: /[T ]/,
    timeZoneDelimiter: /[Z ]/i,
    timezone: /([Z+-].*)$/
};
var $a27bb432a68aee21$var$dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var $a27bb432a68aee21$var$timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var $a27bb432a68aee21$var$timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function $a27bb432a68aee21$var$splitDateString(dateString) {
    var dateStrings = {};
    var array = dateString.split($a27bb432a68aee21$var$patterns.dateTimeDelimiter);
    var timeString;
    // The regex match should only return at maximum two array elements.
    // [date], [time], or [date, time].
    if (array.length > 2) return dateStrings;
    if (/:/.test(array[0])) timeString = array[0];
    else {
        dateStrings.date = array[0];
        timeString = array[1];
        if ($a27bb432a68aee21$var$patterns.timeZoneDelimiter.test(dateStrings.date)) {
            dateStrings.date = dateString.split($a27bb432a68aee21$var$patterns.timeZoneDelimiter)[0];
            timeString = dateString.substr(dateStrings.date.length, dateString.length);
        }
    }
    if (timeString) {
        var token = $a27bb432a68aee21$var$patterns.timezone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], "");
            dateStrings.timezone = token[1];
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $a27bb432a68aee21$var$parseYear(dateString, additionalDigits) {
    var regex = new RegExp("^(?:(\\d{4}|[+-]\\d{" + (4 + additionalDigits) + "})|(\\d{2}|[+-]\\d{" + (2 + additionalDigits) + "})$)");
    var captures = dateString.match(regex);
    // Invalid ISO-formatted year
    if (!captures) return {
        year: NaN,
        restDateString: ""
    };
    var year = captures[1] ? parseInt(captures[1]) : null;
    var century = captures[2] ? parseInt(captures[2]) : null;
    // either year or century is null, not both
    return {
        year: century === null ? year : century * 100,
        restDateString: dateString.slice((captures[1] || captures[2]).length)
    };
}
function $a27bb432a68aee21$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return new Date(NaN);
    var captures = dateString.match($a27bb432a68aee21$var$dateRegex);
    // Invalid ISO-formatted string
    if (!captures) return new Date(NaN);
    var isWeekDate = !!captures[4];
    var dayOfYear = $a27bb432a68aee21$var$parseDateUnit(captures[1]);
    var month = $a27bb432a68aee21$var$parseDateUnit(captures[2]) - 1;
    var day = $a27bb432a68aee21$var$parseDateUnit(captures[3]);
    var week = $a27bb432a68aee21$var$parseDateUnit(captures[4]);
    var dayOfWeek = $a27bb432a68aee21$var$parseDateUnit(captures[5]) - 1;
    if (isWeekDate) {
        if (!$a27bb432a68aee21$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $a27bb432a68aee21$var$dayOfISOWeekYear(year, week, dayOfWeek);
    } else {
        var date = new Date(0);
        if (!$a27bb432a68aee21$var$validateDate(year, month, day) || !$a27bb432a68aee21$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
        return date;
    }
}
function $a27bb432a68aee21$var$parseDateUnit(value) {
    return value ? parseInt(value) : 1;
}
function $a27bb432a68aee21$var$parseTime(timeString) {
    var captures = timeString.match($a27bb432a68aee21$var$timeRegex);
    if (!captures) return NaN; // Invalid ISO-formatted time
    var hours = $a27bb432a68aee21$var$parseTimeUnit(captures[1]);
    var minutes = $a27bb432a68aee21$var$parseTimeUnit(captures[2]);
    var seconds = $a27bb432a68aee21$var$parseTimeUnit(captures[3]);
    if (!$a27bb432a68aee21$var$validateTime(hours, minutes, seconds)) return NaN;
    return hours * (0, $d3c0bf409b72241e$export$7f72910d6dfd237a) + minutes * (0, $d3c0bf409b72241e$export$91246f0b9bd9beff) + seconds * 1000;
}
function $a27bb432a68aee21$var$parseTimeUnit(value) {
    return value && parseFloat(value.replace(",", ".")) || 0;
}
function $a27bb432a68aee21$var$parseTimezone(timezoneString) {
    if (timezoneString === "Z") return 0;
    var captures = timezoneString.match($a27bb432a68aee21$var$timezoneRegex);
    if (!captures) return 0;
    var sign = captures[1] === "+" ? -1 : 1;
    var hours = parseInt(captures[2]);
    var minutes = captures[3] && parseInt(captures[3]) || 0;
    if (!$a27bb432a68aee21$var$validateTimezone(hours, minutes)) return NaN;
    return sign * (hours * (0, $d3c0bf409b72241e$export$7f72910d6dfd237a) + minutes * (0, $d3c0bf409b72241e$export$91246f0b9bd9beff));
}
function $a27bb432a68aee21$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
// February is null to handle the leap year (using ||)
var $a27bb432a68aee21$var$daysInMonths = [
    31,
    null,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $a27bb432a68aee21$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $a27bb432a68aee21$var$validateDate(year, month, date) {
    return month >= 0 && month <= 11 && date >= 1 && date <= ($a27bb432a68aee21$var$daysInMonths[month] || ($a27bb432a68aee21$var$isLeapYearIndex(year) ? 29 : 28));
}
function $a27bb432a68aee21$var$validateDayOfYearDate(year, dayOfYear) {
    return dayOfYear >= 1 && dayOfYear <= ($a27bb432a68aee21$var$isLeapYearIndex(year) ? 366 : 365);
}
function $a27bb432a68aee21$var$validateWeekDate(_year, week, day) {
    return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function $a27bb432a68aee21$var$validateTime(hours, minutes, seconds) {
    if (hours === 24) return minutes === 0 && seconds === 0;
    return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function $a27bb432a68aee21$var$validateTimezone(_hours, minutes) {
    return minutes >= 0 && minutes <= 59;
}



var $iJSF3 = parcelRequire("iJSF3");

var $luoZD = parcelRequire("luoZD");

var $fYUO3 = parcelRequire("fYUO3");

var $7DbRq = parcelRequire("7DbRq");

var $79xu7 = parcelRequire("79xu7");

var $ju9pQ = parcelRequire("ju9pQ");


var $4a7Gb = parcelRequire("4a7Gb");
(0, $4a7Gb.bG).touchMouseIgnoreWait = 500;
var $1f427812e01e9d4f$var$ignoreMouseDepth = 0;
var $1f427812e01e9d4f$var$listenerCnt = 0;
var $1f427812e01e9d4f$var$isWindowTouchMoveCancelled = false;
/*
Uses a "pointer" abstraction, which monitors UI events for both mouse and touch.
Tracks when the pointer "drags" on a certain element, meaning down+move+up.

Also, tracks if there was touch-scrolling.
Also, can prevent touch-scrolling from happening.
Also, can fire pointermove events when scrolling happens underneath, even when no real pointer movement.

emits:
- pointerdown
- pointermove
- pointerup
*/ var $1f427812e01e9d4f$var$PointerDragging = /*#__PURE__*/ function() {
    "use strict";
    function PointerDragging(containerEl) {
        var _this = this;
        (0, $luoZD._)(this, PointerDragging);
        this.subjectEl = null;
        // options that can be directly assigned by caller
        this.selector = ""; // will cause subjectEl in all emitted events to be this element
        this.handleSelector = "";
        this.shouldIgnoreMove = false;
        this.shouldWatchScroll = true; // for simulating pointermove on scroll
        // internal states
        this.isDragging = false;
        this.isTouchDragging = false;
        this.wasTouchScroll = false;
        // Mouse
        // ----------------------------------------------------------------------------------------------------
        this.handleMouseDown = function(ev) {
            if (!_this.shouldIgnoreMouse() && $1f427812e01e9d4f$var$isPrimaryMouseButton(ev) && _this.tryStart(ev)) {
                var pev = _this.createEventFromMouse(ev, true);
                _this.emitter.trigger("pointerdown", pev);
                _this.initScrollWatch(pev);
                if (!_this.shouldIgnoreMove) document.addEventListener("mousemove", _this.handleMouseMove);
                document.addEventListener("mouseup", _this.handleMouseUp);
            }
        };
        this.handleMouseMove = function(ev) {
            var pev = _this.createEventFromMouse(ev);
            _this.recordCoords(pev);
            _this.emitter.trigger("pointermove", pev);
        };
        this.handleMouseUp = function(ev) {
            document.removeEventListener("mousemove", _this.handleMouseMove);
            document.removeEventListener("mouseup", _this.handleMouseUp);
            _this.emitter.trigger("pointerup", _this.createEventFromMouse(ev));
            _this.cleanup(); // call last so that pointerup has access to props
        };
        // Touch
        // ----------------------------------------------------------------------------------------------------
        this.handleTouchStart = function(ev) {
            if (_this.tryStart(ev)) {
                _this.isTouchDragging = true;
                var pev = _this.createEventFromTouch(ev, true);
                _this.emitter.trigger("pointerdown", pev);
                _this.initScrollWatch(pev);
                // unlike mouse, need to attach to target, not document
                // https://stackoverflow.com/a/45760014
                var targetEl = ev.target;
                if (!_this.shouldIgnoreMove) targetEl.addEventListener("touchmove", _this.handleTouchMove);
                targetEl.addEventListener("touchend", _this.handleTouchEnd);
                targetEl.addEventListener("touchcancel", _this.handleTouchEnd); // treat it as a touch end
                // attach a handler to get called when ANY scroll action happens on the page.
                // this was impossible to do with normal on/off because 'scroll' doesn't bubble.
                // http://stackoverflow.com/a/32954565/96342
                window.addEventListener("scroll", _this.handleTouchScroll, true);
            }
        };
        this.handleTouchMove = function(ev) {
            var pev = _this.createEventFromTouch(ev);
            _this.recordCoords(pev);
            _this.emitter.trigger("pointermove", pev);
        };
        this.handleTouchEnd = function(ev) {
            if (_this.isDragging) {
                var targetEl = ev.target;
                targetEl.removeEventListener("touchmove", _this.handleTouchMove);
                targetEl.removeEventListener("touchend", _this.handleTouchEnd);
                targetEl.removeEventListener("touchcancel", _this.handleTouchEnd);
                window.removeEventListener("scroll", _this.handleTouchScroll, true); // useCaptured=true
                _this.emitter.trigger("pointerup", _this.createEventFromTouch(ev));
                _this.cleanup(); // call last so that pointerup has access to props
                _this.isTouchDragging = false;
                $1f427812e01e9d4f$var$startIgnoringMouse();
            }
        };
        this.handleTouchScroll = function() {
            _this.wasTouchScroll = true;
        };
        this.handleScroll = function(ev) {
            if (!_this.shouldIgnoreMove) {
                var pageX = window.scrollX - _this.prevScrollX + _this.prevPageX;
                var pageY = window.scrollY - _this.prevScrollY + _this.prevPageY;
                _this.emitter.trigger("pointermove", {
                    origEvent: ev,
                    isTouch: _this.isTouchDragging,
                    subjectEl: _this.subjectEl,
                    pageX: pageX,
                    pageY: pageY,
                    deltaX: pageX - _this.origPageX,
                    deltaY: pageY - _this.origPageY
                });
            }
        };
        this.containerEl = containerEl;
        this.emitter = new (0, $4a7Gb.F)();
        containerEl.addEventListener("mousedown", this.handleMouseDown);
        containerEl.addEventListener("touchstart", this.handleTouchStart, {
            passive: true
        });
        $1f427812e01e9d4f$var$listenerCreated();
    }
    (0, $fYUO3._)(PointerDragging, [
        {
            key: "destroy",
            value: function destroy() {
                this.containerEl.removeEventListener("mousedown", this.handleMouseDown);
                this.containerEl.removeEventListener("touchstart", this.handleTouchStart, {
                    passive: true
                });
                $1f427812e01e9d4f$var$listenerDestroyed();
            }
        },
        {
            key: "tryStart",
            value: function tryStart(ev) {
                var subjectEl = this.querySubjectEl(ev);
                var downEl = ev.target;
                if (subjectEl && (!this.handleSelector || (0, $4a7Gb.Z)(downEl, this.handleSelector))) {
                    this.subjectEl = subjectEl;
                    this.isDragging = true; // do this first so cancelTouchScroll will work
                    this.wasTouchScroll = false;
                    return true;
                }
                return false;
            }
        },
        {
            key: "cleanup",
            value: function cleanup() {
                $1f427812e01e9d4f$var$isWindowTouchMoveCancelled = false;
                this.isDragging = false;
                this.subjectEl = null;
                // keep wasTouchScroll around for later access
                this.destroyScrollWatch();
            }
        },
        {
            key: "querySubjectEl",
            value: function querySubjectEl(ev) {
                if (this.selector) return (0, $4a7Gb.Z)(ev.target, this.selector);
                return this.containerEl;
            }
        },
        {
            key: "shouldIgnoreMouse",
            value: function shouldIgnoreMouse() {
                return $1f427812e01e9d4f$var$ignoreMouseDepth || this.isTouchDragging;
            }
        },
        {
            // can be called by user of this class, to cancel touch-based scrolling for the current drag
            key: "cancelTouchScroll",
            value: function cancelTouchScroll() {
                if (this.isDragging) $1f427812e01e9d4f$var$isWindowTouchMoveCancelled = true;
            }
        },
        {
            // Scrolling that simulates pointermoves
            // ----------------------------------------------------------------------------------------------------
            key: "initScrollWatch",
            value: function initScrollWatch(ev) {
                if (this.shouldWatchScroll) {
                    this.recordCoords(ev);
                    window.addEventListener("scroll", this.handleScroll, true); // useCapture=true
                }
            }
        },
        {
            key: "recordCoords",
            value: function recordCoords(ev) {
                if (this.shouldWatchScroll) {
                    this.prevPageX = ev.pageX;
                    this.prevPageY = ev.pageY;
                    this.prevScrollX = window.scrollX;
                    this.prevScrollY = window.scrollY;
                }
            }
        },
        {
            key: "destroyScrollWatch",
            value: function destroyScrollWatch() {
                if (this.shouldWatchScroll) window.removeEventListener("scroll", this.handleScroll, true); // useCaptured=true
            }
        },
        {
            // Event Normalization
            // ----------------------------------------------------------------------------------------------------
            key: "createEventFromMouse",
            value: function createEventFromMouse(ev, isFirst) {
                var deltaX = 0;
                var deltaY = 0;
                // TODO: repeat code
                if (isFirst) {
                    this.origPageX = ev.pageX;
                    this.origPageY = ev.pageY;
                } else {
                    deltaX = ev.pageX - this.origPageX;
                    deltaY = ev.pageY - this.origPageY;
                }
                return {
                    origEvent: ev,
                    isTouch: false,
                    subjectEl: this.subjectEl,
                    pageX: ev.pageX,
                    pageY: ev.pageY,
                    deltaX: deltaX,
                    deltaY: deltaY
                };
            }
        },
        {
            key: "createEventFromTouch",
            value: function createEventFromTouch(ev, isFirst) {
                var touches = ev.touches;
                var pageX;
                var pageY;
                var deltaX = 0;
                var deltaY = 0;
                // if touch coords available, prefer,
                // because FF would give bad ev.pageX ev.pageY
                if (touches && touches.length) {
                    pageX = touches[0].pageX;
                    pageY = touches[0].pageY;
                } else {
                    pageX = ev.pageX;
                    pageY = ev.pageY;
                }
                // TODO: repeat code
                if (isFirst) {
                    this.origPageX = pageX;
                    this.origPageY = pageY;
                } else {
                    deltaX = pageX - this.origPageX;
                    deltaY = pageY - this.origPageY;
                }
                return {
                    origEvent: ev,
                    isTouch: true,
                    subjectEl: this.subjectEl,
                    pageX: pageX,
                    pageY: pageY,
                    deltaX: deltaX,
                    deltaY: deltaY
                };
            }
        }
    ]);
    return PointerDragging;
}();
// Returns a boolean whether this was a left mouse click and no ctrl key (which means right click on Mac)
function $1f427812e01e9d4f$var$isPrimaryMouseButton(ev) {
    return ev.button === 0 && !ev.ctrlKey;
}
// Ignoring fake mouse events generated by touch
// ----------------------------------------------------------------------------------------------------
function $1f427812e01e9d4f$var$startIgnoringMouse() {
    $1f427812e01e9d4f$var$ignoreMouseDepth += 1;
    setTimeout(function() {
        $1f427812e01e9d4f$var$ignoreMouseDepth -= 1;
    }, (0, $4a7Gb.bG).touchMouseIgnoreWait);
}
// We want to attach touchmove as early as possible for Safari
// ----------------------------------------------------------------------------------------------------
function $1f427812e01e9d4f$var$listenerCreated() {
    $1f427812e01e9d4f$var$listenerCnt += 1;
    if ($1f427812e01e9d4f$var$listenerCnt === 1) window.addEventListener("touchmove", $1f427812e01e9d4f$var$onWindowTouchMove, {
        passive: false
    });
}
function $1f427812e01e9d4f$var$listenerDestroyed() {
    $1f427812e01e9d4f$var$listenerCnt -= 1;
    if (!$1f427812e01e9d4f$var$listenerCnt) window.removeEventListener("touchmove", $1f427812e01e9d4f$var$onWindowTouchMove, {
        passive: false
    });
}
function $1f427812e01e9d4f$var$onWindowTouchMove(ev) {
    if ($1f427812e01e9d4f$var$isWindowTouchMoveCancelled) ev.preventDefault();
}
/*
An effect in which an element follows the movement of a pointer across the screen.
The moving element is a clone of some other element.
Must call start + handleMove + stop.
*/ var $1f427812e01e9d4f$var$ElementMirror = /*#__PURE__*/ function() {
    "use strict";
    function ElementMirror() {
        (0, $luoZD._)(this, ElementMirror);
        this.isVisible = false; // must be explicitly enabled
        this.sourceEl = null;
        this.mirrorEl = null;
        this.sourceElRect = null; // screen coords relative to viewport
        // options that can be set directly by caller
        this.parentNode = document.body; // HIGHLY SUGGESTED to set this to sidestep ShadowDOM issues
        this.zIndex = 9999;
        this.revertDuration = 0;
    }
    (0, $fYUO3._)(ElementMirror, [
        {
            key: "start",
            value: function start(sourceEl, pageX, pageY) {
                this.sourceEl = sourceEl;
                this.sourceElRect = this.sourceEl.getBoundingClientRect();
                this.origScreenX = pageX - window.scrollX;
                this.origScreenY = pageY - window.scrollY;
                this.deltaX = 0;
                this.deltaY = 0;
                this.updateElPosition();
            }
        },
        {
            key: "handleMove",
            value: function handleMove(pageX, pageY) {
                this.deltaX = pageX - window.scrollX - this.origScreenX;
                this.deltaY = pageY - window.scrollY - this.origScreenY;
                this.updateElPosition();
            }
        },
        {
            // can be called before start
            key: "setIsVisible",
            value: function setIsVisible(bool) {
                if (bool) {
                    if (!this.isVisible) {
                        if (this.mirrorEl) this.mirrorEl.style.display = "";
                        this.isVisible = bool; // needs to happen before updateElPosition
                        this.updateElPosition(); // because was not updating the position while invisible
                    }
                } else if (this.isVisible) {
                    if (this.mirrorEl) this.mirrorEl.style.display = "none";
                    this.isVisible = bool;
                }
            }
        },
        {
            // always async
            key: "stop",
            value: function stop(needsRevertAnimation, callback) {
                var _this = this;
                var done = function() {
                    _this.cleanup();
                    callback();
                };
                if (needsRevertAnimation && this.mirrorEl && this.isVisible && this.revertDuration && // if 0, transition won't work
                (this.deltaX || this.deltaY // if same coords, transition won't work
                )) this.doRevertAnimation(done, this.revertDuration);
                else setTimeout(done, 0);
            }
        },
        {
            key: "doRevertAnimation",
            value: function doRevertAnimation(callback, revertDuration) {
                var mirrorEl = this.mirrorEl;
                var finalSourceElRect = this.sourceEl.getBoundingClientRect(); // because autoscrolling might have happened
                mirrorEl.style.transition = "top " + revertDuration + "ms," + "left " + revertDuration + "ms";
                (0, $4a7Gb.aN)(mirrorEl, {
                    left: finalSourceElRect.left,
                    top: finalSourceElRect.top
                });
                (0, $4a7Gb.b0)(mirrorEl, function() {
                    mirrorEl.style.transition = "";
                    callback();
                });
            }
        },
        {
            key: "cleanup",
            value: function cleanup() {
                if (this.mirrorEl) {
                    (0, $4a7Gb.aM)(this.mirrorEl);
                    this.mirrorEl = null;
                }
                this.sourceEl = null;
            }
        },
        {
            key: "updateElPosition",
            value: function updateElPosition() {
                if (this.sourceEl && this.isVisible) (0, $4a7Gb.aN)(this.getMirrorEl(), {
                    left: this.sourceElRect.left + this.deltaX,
                    top: this.sourceElRect.top + this.deltaY
                });
            }
        },
        {
            key: "getMirrorEl",
            value: function getMirrorEl() {
                var sourceElRect = this.sourceElRect;
                var mirrorEl = this.mirrorEl;
                if (!mirrorEl) {
                    mirrorEl = this.mirrorEl = this.sourceEl.cloneNode(true); // cloneChildren=true
                    // we don't want long taps or any mouse interaction causing selection/menus.
                    // would use preventSelection(), but that prevents selectstart, causing problems.
                    mirrorEl.style.userSelect = "none";
                    mirrorEl.style.webkitUserSelect = "none";
                    mirrorEl.style.pointerEvents = "none";
                    mirrorEl.classList.add("fc-event-dragging");
                    (0, $4a7Gb.aN)(mirrorEl, {
                        position: "fixed",
                        zIndex: this.zIndex,
                        visibility: "",
                        boxSizing: "border-box",
                        width: sourceElRect.right - sourceElRect.left,
                        height: sourceElRect.bottom - sourceElRect.top,
                        right: "auto",
                        bottom: "auto",
                        margin: 0
                    });
                    this.parentNode.appendChild(mirrorEl);
                }
                return mirrorEl;
            }
        }
    ]);
    return ElementMirror;
}();
/*
Is a cache for a given element's scroll information (all the info that ScrollController stores)
in addition the "client rectangle" of the element.. the area within the scrollbars.

The cache can be in one of two modes:
- doesListening:false - ignores when the container is scrolled by someone else
- doesListening:true - watch for scrolling and update the cache
*/ var $1f427812e01e9d4f$var$ScrollGeomCache = /*#__PURE__*/ function(ScrollController) {
    "use strict";
    (0, $7DbRq._)(ScrollGeomCache, ScrollController);
    var _super = (0, $ju9pQ._)(ScrollGeomCache);
    function ScrollGeomCache(scrollController, doesListening) {
        (0, $luoZD._)(this, ScrollGeomCache);
        var _this;
        _this = _super.call(this);
        _this.handleScroll = function() {
            _this.scrollTop = _this.scrollController.getScrollTop();
            _this.scrollLeft = _this.scrollController.getScrollLeft();
            _this.handleScrollChange();
        };
        _this.scrollController = scrollController;
        _this.doesListening = doesListening;
        _this.scrollTop = _this.origScrollTop = scrollController.getScrollTop();
        _this.scrollLeft = _this.origScrollLeft = scrollController.getScrollLeft();
        _this.scrollWidth = scrollController.getScrollWidth();
        _this.scrollHeight = scrollController.getScrollHeight();
        _this.clientWidth = scrollController.getClientWidth();
        _this.clientHeight = scrollController.getClientHeight();
        _this.clientRect = _this.computeClientRect(); // do last in case it needs cached values
        if (_this.doesListening) _this.getEventTarget().addEventListener("scroll", _this.handleScroll);
        return _this;
    }
    (0, $fYUO3._)(ScrollGeomCache, [
        {
            key: "destroy",
            value: function destroy() {
                if (this.doesListening) this.getEventTarget().removeEventListener("scroll", this.handleScroll);
            }
        },
        {
            key: "getScrollTop",
            value: function getScrollTop() {
                return this.scrollTop;
            }
        },
        {
            key: "getScrollLeft",
            value: function getScrollLeft() {
                return this.scrollLeft;
            }
        },
        {
            key: "setScrollTop",
            value: function setScrollTop(top) {
                this.scrollController.setScrollTop(top);
                if (!this.doesListening) {
                    // we are not relying on the element to normalize out-of-bounds scroll values
                    // so we need to sanitize ourselves
                    this.scrollTop = Math.max(Math.min(top, this.getMaxScrollTop()), 0);
                    this.handleScrollChange();
                }
            }
        },
        {
            key: "setScrollLeft",
            value: function setScrollLeft(top) {
                this.scrollController.setScrollLeft(top);
                if (!this.doesListening) {
                    // we are not relying on the element to normalize out-of-bounds scroll values
                    // so we need to sanitize ourselves
                    this.scrollLeft = Math.max(Math.min(top, this.getMaxScrollLeft()), 0);
                    this.handleScrollChange();
                }
            }
        },
        {
            key: "getClientWidth",
            value: function getClientWidth() {
                return this.clientWidth;
            }
        },
        {
            key: "getClientHeight",
            value: function getClientHeight() {
                return this.clientHeight;
            }
        },
        {
            key: "getScrollWidth",
            value: function getScrollWidth() {
                return this.scrollWidth;
            }
        },
        {
            key: "getScrollHeight",
            value: function getScrollHeight() {
                return this.scrollHeight;
            }
        },
        {
            key: "handleScrollChange",
            value: function handleScrollChange() {}
        }
    ]);
    return ScrollGeomCache;
}((0, $4a7Gb.b9));
var $1f427812e01e9d4f$var$ElementScrollGeomCache = /*#__PURE__*/ function(ScrollGeomCache) {
    "use strict";
    (0, $7DbRq._)(ElementScrollGeomCache, ScrollGeomCache);
    var _super = (0, $ju9pQ._)(ElementScrollGeomCache);
    function ElementScrollGeomCache(el, doesListening) {
        (0, $luoZD._)(this, ElementScrollGeomCache);
        return _super.call(this, new (0, $4a7Gb.ba)(el), doesListening);
    }
    (0, $fYUO3._)(ElementScrollGeomCache, [
        {
            key: "getEventTarget",
            value: function getEventTarget() {
                return this.scrollController.el;
            }
        },
        {
            key: "computeClientRect",
            value: function computeClientRect() {
                return (0, $4a7Gb.b1)(this.scrollController.el);
            }
        }
    ]);
    return ElementScrollGeomCache;
}($1f427812e01e9d4f$var$ScrollGeomCache);
var $1f427812e01e9d4f$var$WindowScrollGeomCache = /*#__PURE__*/ function(ScrollGeomCache) {
    "use strict";
    (0, $7DbRq._)(WindowScrollGeomCache, ScrollGeomCache);
    var _super = (0, $ju9pQ._)(WindowScrollGeomCache);
    function WindowScrollGeomCache(doesListening) {
        (0, $luoZD._)(this, WindowScrollGeomCache);
        return _super.call(this, new (0, $4a7Gb.bb)(), doesListening);
    }
    (0, $fYUO3._)(WindowScrollGeomCache, [
        {
            key: "getEventTarget",
            value: function getEventTarget() {
                return window;
            }
        },
        {
            key: "computeClientRect",
            value: function computeClientRect() {
                return {
                    left: this.scrollLeft,
                    right: this.scrollLeft + this.clientWidth,
                    top: this.scrollTop,
                    bottom: this.scrollTop + this.clientHeight
                };
            }
        },
        {
            // the window is the only scroll object that changes it's rectangle relative
            // to the document's topleft as it scrolls
            key: "handleScrollChange",
            value: function handleScrollChange() {
                this.clientRect = this.computeClientRect();
            }
        }
    ]);
    return WindowScrollGeomCache;
}($1f427812e01e9d4f$var$ScrollGeomCache);
// If available we are using native "performance" API instead of "Date"
// Read more about it on MDN:
// https://developer.mozilla.org/en-US/docs/Web/API/Performance
var $1f427812e01e9d4f$var$getTime = typeof performance === "function" ? performance.now : Date.now;
/*
For a pointer interaction, automatically scrolls certain scroll containers when the pointer
approaches the edge.

The caller must call start + handleMove + stop.
*/ var $1f427812e01e9d4f$var$AutoScroller = /*#__PURE__*/ function() {
    "use strict";
    function AutoScroller() {
        var _this = this;
        (0, $luoZD._)(this, AutoScroller);
        // options that can be set by caller
        this.isEnabled = true;
        this.scrollQuery = [
            window,
            ".fc-scroller"
        ];
        this.edgeThreshold = 50; // pixels
        this.maxVelocity = 300; // pixels per second
        // internal state
        this.pointerScreenX = null;
        this.pointerScreenY = null;
        this.isAnimating = false;
        this.scrollCaches = null;
        // protect against the initial pointerdown being too close to an edge and starting the scroll
        this.everMovedUp = false;
        this.everMovedDown = false;
        this.everMovedLeft = false;
        this.everMovedRight = false;
        this.animate = function() {
            if (_this.isAnimating) {
                var edge = _this.computeBestEdge(_this.pointerScreenX + window.scrollX, _this.pointerScreenY + window.scrollY);
                if (edge) {
                    var now = $1f427812e01e9d4f$var$getTime();
                    _this.handleSide(edge, (now - _this.msSinceRequest) / 1000);
                    _this.requestAnimation(now);
                } else _this.isAnimating = false; // will stop animation
            }
        };
    }
    (0, $fYUO3._)(AutoScroller, [
        {
            key: "start",
            value: function start(pageX, pageY, scrollStartEl) {
                if (this.isEnabled) {
                    this.scrollCaches = this.buildCaches(scrollStartEl);
                    this.pointerScreenX = null;
                    this.pointerScreenY = null;
                    this.everMovedUp = false;
                    this.everMovedDown = false;
                    this.everMovedLeft = false;
                    this.everMovedRight = false;
                    this.handleMove(pageX, pageY);
                }
            }
        },
        {
            key: "handleMove",
            value: function handleMove(pageX, pageY) {
                if (this.isEnabled) {
                    var pointerScreenX = pageX - window.scrollX;
                    var pointerScreenY = pageY - window.scrollY;
                    var yDelta = this.pointerScreenY === null ? 0 : pointerScreenY - this.pointerScreenY;
                    var xDelta = this.pointerScreenX === null ? 0 : pointerScreenX - this.pointerScreenX;
                    if (yDelta < 0) this.everMovedUp = true;
                    else if (yDelta > 0) this.everMovedDown = true;
                    if (xDelta < 0) this.everMovedLeft = true;
                    else if (xDelta > 0) this.everMovedRight = true;
                    this.pointerScreenX = pointerScreenX;
                    this.pointerScreenY = pointerScreenY;
                    if (!this.isAnimating) {
                        this.isAnimating = true;
                        this.requestAnimation($1f427812e01e9d4f$var$getTime());
                    }
                }
            }
        },
        {
            key: "stop",
            value: function stop() {
                if (this.isEnabled) {
                    this.isAnimating = false; // will stop animation
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = this.scrollCaches[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var scrollCache = _step.value;
                            scrollCache.destroy();
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    this.scrollCaches = null;
                }
            }
        },
        {
            key: "requestAnimation",
            value: function requestAnimation(now) {
                this.msSinceRequest = now;
                requestAnimationFrame(this.animate);
            }
        },
        {
            key: "handleSide",
            value: function handleSide(edge, seconds) {
                var scrollCache = edge.scrollCache;
                var edgeThreshold = this.edgeThreshold;
                var invDistance = edgeThreshold - edge.distance;
                var velocity = invDistance * invDistance / (edgeThreshold * edgeThreshold) * // quadratic
                this.maxVelocity * seconds;
                var sign = 1;
                switch(edge.name){
                    case "left":
                        sign = -1;
                    // falls through
                    case "right":
                        scrollCache.setScrollLeft(scrollCache.getScrollLeft() + velocity * sign);
                        break;
                    case "top":
                        sign = -1;
                    // falls through
                    case "bottom":
                        scrollCache.setScrollTop(scrollCache.getScrollTop() + velocity * sign);
                        break;
                }
            }
        },
        {
            // left/top are relative to document topleft
            key: "computeBestEdge",
            value: function computeBestEdge(left, top) {
                var edgeThreshold = this.edgeThreshold;
                var bestSide = null;
                var scrollCaches = this.scrollCaches || [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = scrollCaches[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var scrollCache = _step.value;
                        var rect = scrollCache.clientRect;
                        var leftDist = left - rect.left;
                        var rightDist = rect.right - left;
                        var topDist = top - rect.top;
                        var bottomDist = rect.bottom - top;
                        // completely within the rect?
                        if (leftDist >= 0 && rightDist >= 0 && topDist >= 0 && bottomDist >= 0) {
                            if (topDist <= edgeThreshold && this.everMovedUp && scrollCache.canScrollUp() && (!bestSide || bestSide.distance > topDist)) bestSide = {
                                scrollCache: scrollCache,
                                name: "top",
                                distance: topDist
                            };
                            if (bottomDist <= edgeThreshold && this.everMovedDown && scrollCache.canScrollDown() && (!bestSide || bestSide.distance > bottomDist)) bestSide = {
                                scrollCache: scrollCache,
                                name: "bottom",
                                distance: bottomDist
                            };
                            /*
                TODO: fix broken RTL scrolling. canScrollLeft always returning false
                https://github.com/fullcalendar/fullcalendar/issues/4837
                */ if (leftDist <= edgeThreshold && this.everMovedLeft && scrollCache.canScrollLeft() && (!bestSide || bestSide.distance > leftDist)) bestSide = {
                                scrollCache: scrollCache,
                                name: "left",
                                distance: leftDist
                            };
                            if (rightDist <= edgeThreshold && this.everMovedRight && scrollCache.canScrollRight() && (!bestSide || bestSide.distance > rightDist)) bestSide = {
                                scrollCache: scrollCache,
                                name: "right",
                                distance: rightDist
                            };
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return bestSide;
            }
        },
        {
            key: "buildCaches",
            value: function buildCaches(scrollStartEl) {
                return this.queryScrollEls(scrollStartEl).map(function(el) {
                    if (el === window) return new $1f427812e01e9d4f$var$WindowScrollGeomCache(false); // false = don't listen to user-generated scrolls
                    return new $1f427812e01e9d4f$var$ElementScrollGeomCache(el, false); // false = don't listen to user-generated scrolls
                });
            }
        },
        {
            key: "queryScrollEls",
            value: function queryScrollEls(scrollStartEl) {
                var /*
                TODO: in the future, always have auto-scroll happen on element where current Hit came from
                Ticket: https://github.com/fullcalendar/fullcalendar/issues/4593
                */ _els;
                var els = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.scrollQuery[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var query = _step.value;
                        if (typeof query === "object") els.push(query);
                        else (_els = els).push.apply(_els, (0, $79xu7._)(Array.prototype.slice.call(scrollStartEl.getRootNode().querySelectorAll(query))));
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return els;
            }
        }
    ]);
    return AutoScroller;
}();
/*
Monitors dragging on an element. Has a number of high-level features:
- minimum distance required before dragging
- minimum wait time ("delay") before dragging
- a mirror element that follows the pointer
*/ var $1f427812e01e9d4f$var$FeaturefulElementDragging = /*#__PURE__*/ function(ElementDragging) {
    "use strict";
    (0, $7DbRq._)(FeaturefulElementDragging, ElementDragging);
    var _super = (0, $ju9pQ._)(FeaturefulElementDragging);
    function FeaturefulElementDragging(containerEl, selector) {
        (0, $luoZD._)(this, FeaturefulElementDragging);
        var _this;
        _this = _super.call(this, containerEl);
        _this.containerEl = containerEl;
        // options that can be directly set by caller
        // the caller can also set the PointerDragging's options as well
        _this.delay = null;
        _this.minDistance = 0;
        _this.touchScrollAllowed = true; // prevents drag from starting and blocks scrolling during drag
        _this.mirrorNeedsRevert = false;
        _this.isInteracting = false; // is the user validly moving the pointer? lasts until pointerup
        _this.isDragging = false; // is it INTENTFULLY dragging? lasts until after revert animation
        _this.isDelayEnded = false;
        _this.isDistanceSurpassed = false;
        _this.delayTimeoutId = null;
        _this.onPointerDown = function(ev) {
            if (!_this.isDragging) {
                _this.isInteracting = true;
                _this.isDelayEnded = false;
                _this.isDistanceSurpassed = false;
                (0, $4a7Gb.ap)(document.body);
                (0, $4a7Gb.ar)(document.body);
                // prevent links from being visited if there's an eventual drag.
                // also prevents selection in older browsers (maybe?).
                // not necessary for touch, besides, browser would complain about passiveness.
                if (!ev.isTouch) ev.origEvent.preventDefault();
                _this.emitter.trigger("pointerdown", ev);
                if (_this.isInteracting && // not destroyed via pointerdown handler
                !_this.pointer.shouldIgnoreMove) {
                    // actions related to initiating dragstart+dragmove+dragend...
                    _this.mirror.setIsVisible(false); // reset. caller must set-visible
                    _this.mirror.start(ev.subjectEl, ev.pageX, ev.pageY); // must happen on first pointer down
                    _this.startDelay(ev);
                    if (!_this.minDistance) _this.handleDistanceSurpassed(ev);
                }
            }
        };
        _this.onPointerMove = function(ev) {
            if (_this.isInteracting) {
                _this.emitter.trigger("pointermove", ev);
                if (!_this.isDistanceSurpassed) {
                    var minDistance = _this.minDistance;
                    var distanceSq; // current distance from the origin, squared
                    var deltaX = ev.deltaX, deltaY = ev.deltaY;
                    distanceSq = deltaX * deltaX + deltaY * deltaY;
                    if (distanceSq >= minDistance * minDistance) _this.handleDistanceSurpassed(ev);
                }
                if (_this.isDragging) {
                    // a real pointer move? (not one simulated by scrolling)
                    if (ev.origEvent.type !== "scroll") {
                        _this.mirror.handleMove(ev.pageX, ev.pageY);
                        _this.autoScroller.handleMove(ev.pageX, ev.pageY);
                    }
                    _this.emitter.trigger("dragmove", ev);
                }
            }
        };
        _this.onPointerUp = function(ev) {
            if (_this.isInteracting) {
                _this.isInteracting = false;
                (0, $4a7Gb.aq)(document.body);
                (0, $4a7Gb.as)(document.body);
                _this.emitter.trigger("pointerup", ev); // can potentially set mirrorNeedsRevert
                if (_this.isDragging) {
                    _this.autoScroller.stop();
                    _this.tryStopDrag(ev); // which will stop the mirror
                }
                if (_this.delayTimeoutId) {
                    clearTimeout(_this.delayTimeoutId);
                    _this.delayTimeoutId = null;
                }
            }
        };
        var pointer = _this.pointer = new $1f427812e01e9d4f$var$PointerDragging(containerEl);
        pointer.emitter.on("pointerdown", _this.onPointerDown);
        pointer.emitter.on("pointermove", _this.onPointerMove);
        pointer.emitter.on("pointerup", _this.onPointerUp);
        if (selector) pointer.selector = selector;
        _this.mirror = new $1f427812e01e9d4f$var$ElementMirror();
        _this.autoScroller = new $1f427812e01e9d4f$var$AutoScroller();
        return _this;
    }
    (0, $fYUO3._)(FeaturefulElementDragging, [
        {
            key: "destroy",
            value: function destroy() {
                this.pointer.destroy();
                // HACK: simulate a pointer-up to end the current drag
                // TODO: fire 'dragend' directly and stop interaction. discourage use of pointerup event (b/c might not fire)
                this.onPointerUp({});
            }
        },
        {
            key: "startDelay",
            value: function startDelay(ev) {
                var _this = this;
                if (typeof this.delay === "number") this.delayTimeoutId = setTimeout(function() {
                    _this.delayTimeoutId = null;
                    _this.handleDelayEnd(ev);
                }, this.delay); // not assignable to number!
                else this.handleDelayEnd(ev);
            }
        },
        {
            key: "handleDelayEnd",
            value: function handleDelayEnd(ev) {
                this.isDelayEnded = true;
                this.tryStartDrag(ev);
            }
        },
        {
            key: "handleDistanceSurpassed",
            value: function handleDistanceSurpassed(ev) {
                this.isDistanceSurpassed = true;
                this.tryStartDrag(ev);
            }
        },
        {
            key: "tryStartDrag",
            value: function tryStartDrag(ev) {
                if (this.isDelayEnded && this.isDistanceSurpassed) {
                    if (!this.pointer.wasTouchScroll || this.touchScrollAllowed) {
                        this.isDragging = true;
                        this.mirrorNeedsRevert = false;
                        this.autoScroller.start(ev.pageX, ev.pageY, this.containerEl);
                        this.emitter.trigger("dragstart", ev);
                        if (this.touchScrollAllowed === false) this.pointer.cancelTouchScroll();
                    }
                }
            }
        },
        {
            key: "tryStopDrag",
            value: function tryStopDrag(ev) {
                // .stop() is ALWAYS asynchronous, which we NEED because we want all pointerup events
                // that come from the document to fire beforehand. much more convenient this way.
                this.mirror.stop(this.mirrorNeedsRevert, this.stopDrag.bind(this, ev));
            }
        },
        {
            key: "stopDrag",
            value: function stopDrag(ev) {
                this.isDragging = false;
                this.emitter.trigger("dragend", ev);
            }
        },
        {
            // fill in the implementations...
            key: "setIgnoreMove",
            value: function setIgnoreMove(bool) {
                this.pointer.shouldIgnoreMove = bool;
            }
        },
        {
            key: "setMirrorIsVisible",
            value: function setMirrorIsVisible(bool) {
                this.mirror.setIsVisible(bool);
            }
        },
        {
            key: "setMirrorNeedsRevert",
            value: function setMirrorNeedsRevert(bool) {
                this.mirrorNeedsRevert = bool;
            }
        },
        {
            key: "setAutoScrollEnabled",
            value: function setAutoScrollEnabled(bool) {
                this.autoScroller.isEnabled = bool;
            }
        }
    ]);
    return FeaturefulElementDragging;
}((0, $4a7Gb.bF));
/*
When this class is instantiated, it records the offset of an element (relative to the document topleft),
and continues to monitor scrolling, updating the cached coordinates if it needs to.
Does not access the DOM after instantiation, so highly performant.

Also keeps track of all scrolling/overflow:hidden containers that are parents of the given element
and an determine if a given point is inside the combined clipping rectangle.
*/ var $1f427812e01e9d4f$var$OffsetTracker = /*#__PURE__*/ function() {
    "use strict";
    function OffsetTracker(el) {
        (0, $luoZD._)(this, OffsetTracker);
        this.el = el;
        this.origRect = (0, $4a7Gb.b4)(el);
        // will work fine for divs that have overflow:hidden
        this.scrollCaches = (0, $4a7Gb.b3)(el).map(function(scrollEl) {
            return new $1f427812e01e9d4f$var$ElementScrollGeomCache(scrollEl, true);
        });
    }
    (0, $fYUO3._)(OffsetTracker, [
        {
            key: "destroy",
            value: function destroy() {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.scrollCaches[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var scrollCache = _step.value;
                        scrollCache.destroy();
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "computeLeft",
            value: function computeLeft() {
                var left = this.origRect.left;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.scrollCaches[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var scrollCache = _step.value;
                        left += scrollCache.origScrollLeft - scrollCache.getScrollLeft();
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return left;
            }
        },
        {
            key: "computeTop",
            value: function computeTop() {
                var top = this.origRect.top;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.scrollCaches[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var scrollCache = _step.value;
                        top += scrollCache.origScrollTop - scrollCache.getScrollTop();
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return top;
            }
        },
        {
            key: "isWithinClipping",
            value: function isWithinClipping(pageX, pageY) {
                var point = {
                    left: pageX,
                    top: pageY
                };
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.scrollCaches[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var scrollCache = _step.value;
                        if (!$1f427812e01e9d4f$var$isIgnoredClipping(scrollCache.getEventTarget()) && !(0, $4a7Gb.aD)(point, scrollCache.clientRect)) return false;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return true;
            }
        }
    ]);
    return OffsetTracker;
}();
// certain clipping containers should never constrain interactions, like <html> and <body>
// https://github.com/fullcalendar/fullcalendar/issues/3615
function $1f427812e01e9d4f$var$isIgnoredClipping(node) {
    var tagName = node.tagName;
    return tagName === "HTML" || tagName === "BODY";
}
/*
Tracks movement over multiple droppable areas (aka "hits")
that exist in one or more DateComponents.
Relies on an existing draggable.

emits:
- pointerdown
- dragstart
- hitchange - fires initially, even if not over a hit
- pointerup
- (hitchange - again, to null, if ended over a hit)
- dragend
*/ var $1f427812e01e9d4f$var$HitDragging = /*#__PURE__*/ function() {
    "use strict";
    function HitDragging(dragging, droppableStore) {
        var _this = this;
        (0, $luoZD._)(this, HitDragging);
        // options that can be set by caller
        this.useSubjectCenter = false;
        this.requireInitial = true; // if doesn't start out on a hit, won't emit any events
        this.disablePointCheck = false;
        this.initialHit = null;
        this.movingHit = null;
        this.finalHit = null; // won't ever be populated if shouldIgnoreMove
        this.handlePointerDown = function(ev) {
            var _$dragging = _this.dragging;
            _this.initialHit = null;
            _this.movingHit = null;
            _this.finalHit = null;
            _this.prepareHits();
            _this.processFirstCoord(ev);
            if (_this.initialHit || !_this.requireInitial) {
                _$dragging.setIgnoreMove(false);
                // TODO: fire this before computing processFirstCoord, so listeners can cancel. this gets fired by almost every handler :(
                _this.emitter.trigger("pointerdown", ev);
            } else _$dragging.setIgnoreMove(true);
        };
        this.handleDragStart = function(ev) {
            _this.emitter.trigger("dragstart", ev);
            _this.handleMove(ev, true); // force = fire even if initially null
        };
        this.handleDragMove = function(ev) {
            _this.emitter.trigger("dragmove", ev);
            _this.handleMove(ev);
        };
        this.handlePointerUp = function(ev) {
            _this.releaseHits();
            _this.emitter.trigger("pointerup", ev);
        };
        this.handleDragEnd = function(ev) {
            if (_this.movingHit) _this.emitter.trigger("hitupdate", null, true, ev);
            _this.finalHit = _this.movingHit;
            _this.movingHit = null;
            _this.emitter.trigger("dragend", ev);
        };
        this.droppableStore = droppableStore;
        dragging.emitter.on("pointerdown", this.handlePointerDown);
        dragging.emitter.on("dragstart", this.handleDragStart);
        dragging.emitter.on("dragmove", this.handleDragMove);
        dragging.emitter.on("pointerup", this.handlePointerUp);
        dragging.emitter.on("dragend", this.handleDragEnd);
        this.dragging = dragging;
        this.emitter = new (0, $4a7Gb.F)();
    }
    (0, $fYUO3._)(HitDragging, [
        {
            // sets initialHit
            // sets coordAdjust
            key: "processFirstCoord",
            value: function processFirstCoord(ev) {
                var origPoint = {
                    left: ev.pageX,
                    top: ev.pageY
                };
                var adjustedPoint = origPoint;
                var subjectEl = ev.subjectEl;
                var subjectRect;
                if (subjectEl instanceof HTMLElement) {
                    subjectRect = (0, $4a7Gb.b4)(subjectEl);
                    adjustedPoint = (0, $4a7Gb.aE)(adjustedPoint, subjectRect);
                }
                var initialHit = this.initialHit = this.queryHitForOffset(adjustedPoint.left, adjustedPoint.top);
                if (initialHit) {
                    if (this.useSubjectCenter && subjectRect) {
                        var slicedSubjectRect = (0, $4a7Gb.aC)(subjectRect, initialHit.rect);
                        if (slicedSubjectRect) adjustedPoint = (0, $4a7Gb.aF)(slicedSubjectRect);
                    }
                    this.coordAdjust = (0, $4a7Gb.aG)(adjustedPoint, origPoint);
                } else this.coordAdjust = {
                    left: 0,
                    top: 0
                };
            }
        },
        {
            key: "handleMove",
            value: function handleMove(ev, forceHandle) {
                var hit = this.queryHitForOffset(ev.pageX + this.coordAdjust.left, ev.pageY + this.coordAdjust.top);
                if (forceHandle || !$1f427812e01e9d4f$var$isHitsEqual(this.movingHit, hit)) {
                    this.movingHit = hit;
                    this.emitter.trigger("hitupdate", hit, false, ev);
                }
            }
        },
        {
            key: "prepareHits",
            value: function prepareHits() {
                this.offsetTrackers = (0, $4a7Gb.a)(this.droppableStore, function(interactionSettings) {
                    interactionSettings.component.prepareHits();
                    return new $1f427812e01e9d4f$var$OffsetTracker(interactionSettings.el);
                });
            }
        },
        {
            key: "releaseHits",
            value: function releaseHits() {
                var offsetTrackers = this.offsetTrackers;
                for(var id in offsetTrackers)offsetTrackers[id].destroy();
                this.offsetTrackers = {};
            }
        },
        {
            key: "queryHitForOffset",
            value: function queryHitForOffset(offsetLeft, offsetTop) {
                var _this = this, droppableStore = _this.droppableStore, offsetTrackers = _this.offsetTrackers;
                var bestHit = null;
                for(var id in droppableStore){
                    var component = droppableStore[id].component;
                    var offsetTracker = offsetTrackers[id];
                    if (offsetTracker && // wasn't destroyed mid-drag
                    offsetTracker.isWithinClipping(offsetLeft, offsetTop)) {
                        var originLeft = offsetTracker.computeLeft();
                        var originTop = offsetTracker.computeTop();
                        var positionLeft = offsetLeft - originLeft;
                        var positionTop = offsetTop - originTop;
                        var origRect = offsetTracker.origRect;
                        var width = origRect.right - origRect.left;
                        var height = origRect.bottom - origRect.top;
                        if (// must be within the element's bounds
                        positionLeft >= 0 && positionLeft < width && positionTop >= 0 && positionTop < height) {
                            var hit = component.queryHit(positionLeft, positionTop, width, height);
                            if (hit && // make sure the hit is within activeRange, meaning it's not a dead cell
                            (0, $4a7Gb.b7)(hit.dateProfile.activeRange, hit.dateSpan.range) && // Ensure the component we are querying for the hit is accessibly my the pointer
                            // Prevents obscured calendars (ex: under a modal dialog) from accepting hit
                            // https://github.com/fullcalendar/fullcalendar/issues/5026
                            (this.disablePointCheck || offsetTracker.el.contains(offsetTracker.el.getRootNode().elementFromPoint(// add-back origins to get coordinate relative to top-left of window viewport
                            positionLeft + originLeft - window.scrollX, positionTop + originTop - window.scrollY))) && (!bestHit || hit.layer > bestHit.layer)) {
                                hit.componentId = id;
                                hit.context = component.context;
                                // TODO: better way to re-orient rectangle
                                hit.rect.left += originLeft;
                                hit.rect.right += originLeft;
                                hit.rect.top += originTop;
                                hit.rect.bottom += originTop;
                                bestHit = hit;
                            }
                        }
                    }
                }
                return bestHit;
            }
        }
    ]);
    return HitDragging;
}();
function $1f427812e01e9d4f$var$isHitsEqual(hit0, hit1) {
    if (!hit0 && !hit1) return true;
    if (Boolean(hit0) !== Boolean(hit1)) return false;
    return (0, $4a7Gb.bd)(hit0.dateSpan, hit1.dateSpan);
}
function $1f427812e01e9d4f$var$buildDatePointApiWithContext(dateSpan, context) {
    var props = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = context.pluginHooks.datePointTransforms[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var transform = _step.value;
            Object.assign(props, transform(dateSpan, context));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    Object.assign(props, $1f427812e01e9d4f$var$buildDatePointApi(dateSpan, context.dateEnv));
    return props;
}
function $1f427812e01e9d4f$var$buildDatePointApi(span, dateEnv) {
    return {
        date: dateEnv.toDate(span.range.start),
        dateStr: dateEnv.formatIso(span.range.start, {
            omitTime: span.allDay
        }),
        allDay: span.allDay
    };
}
/*
Monitors when the user clicks on a specific date/time of a component.
A pointerdown+pointerup on the same "hit" constitutes a click.
*/ var $1f427812e01e9d4f$var$DateClicking = /*#__PURE__*/ function(Interaction) {
    "use strict";
    (0, $7DbRq._)(DateClicking, Interaction);
    var _super = (0, $ju9pQ._)(DateClicking);
    function DateClicking(settings) {
        (0, $luoZD._)(this, DateClicking);
        var _this;
        _this = _super.call(this, settings);
        _this.handlePointerDown = function(pev) {
            var dragging = (0, $iJSF3._)(_this).dragging;
            var downEl = pev.origEvent.target;
            // do this in pointerdown (not dragend) because DOM might be mutated by the time dragend is fired
            dragging.setIgnoreMove(!_this.component.isValidDateDownEl(downEl));
        };
        // won't even fire if moving was ignored
        _this.handleDragEnd = function(ev) {
            var component = (0, $iJSF3._)(_this).component;
            var pointer = _this.dragging.pointer;
            if (!pointer.wasTouchScroll) {
                var _this_hitDragging = _this.hitDragging, initialHit = _this_hitDragging.initialHit, finalHit = _this_hitDragging.finalHit;
                if (initialHit && finalHit && $1f427812e01e9d4f$var$isHitsEqual(initialHit, finalHit)) {
                    var context = component.context;
                    var arg = Object.assign(Object.assign({}, $1f427812e01e9d4f$var$buildDatePointApiWithContext(initialHit.dateSpan, context)), {
                        dayEl: initialHit.dayEl,
                        jsEvent: ev.origEvent,
                        view: context.viewApi || context.calendarApi.view
                    });
                    context.emitter.trigger("dateClick", arg);
                }
            }
        };
        // we DO want to watch pointer moves because otherwise finalHit won't get populated
        _this.dragging = new $1f427812e01e9d4f$var$FeaturefulElementDragging(settings.el);
        _this.dragging.autoScroller.isEnabled = false;
        var hitDragging = _this.hitDragging = new $1f427812e01e9d4f$var$HitDragging(_this.dragging, (0, $4a7Gb.bE)(settings));
        hitDragging.emitter.on("pointerdown", _this.handlePointerDown);
        hitDragging.emitter.on("dragend", _this.handleDragEnd);
        return _this;
    }
    (0, $fYUO3._)(DateClicking, [
        {
            key: "destroy",
            value: function destroy() {
                this.dragging.destroy();
            }
        }
    ]);
    return DateClicking;
}((0, $4a7Gb.X));
/*
Tracks when the user selects a portion of time of a component,
constituted by a drag over date cells, with a possible delay at the beginning of the drag.
*/ var $1f427812e01e9d4f$var$DateSelecting = /*#__PURE__*/ function(Interaction) {
    "use strict";
    (0, $7DbRq._)(DateSelecting, Interaction);
    var _super = (0, $ju9pQ._)(DateSelecting);
    function DateSelecting(settings) {
        (0, $luoZD._)(this, DateSelecting);
        var _this;
        _this = _super.call(this, settings);
        _this.dragSelection = null;
        _this.handlePointerDown = function(ev) {
            var _$_assert_this_initialized = (0, $iJSF3._)(_this), component = _$_assert_this_initialized.component, dragging = _$_assert_this_initialized.dragging;
            var options = component.context.options;
            var canSelect = options.selectable && component.isValidDateDownEl(ev.origEvent.target);
            // don't bother to watch expensive moves if component won't do selection
            dragging.setIgnoreMove(!canSelect);
            // if touch, require user to hold down
            dragging.delay = ev.isTouch ? $1f427812e01e9d4f$var$getComponentTouchDelay$1(component) : null;
        };
        _this.handleDragStart = function(ev) {
            _this.component.context.calendarApi.unselect(ev); // unselect previous selections
        };
        _this.handleHitUpdate = function(hit, isFinal) {
            var context = _this.component.context;
            var dragSelection = null;
            var isInvalid = false;
            if (hit) {
                var initialHit = _this.hitDragging.initialHit;
                var disallowed = hit.componentId === initialHit.componentId && _this.isHitComboAllowed && !_this.isHitComboAllowed(initialHit, hit);
                if (!disallowed) dragSelection = $1f427812e01e9d4f$var$joinHitsIntoSelection(initialHit, hit, context.pluginHooks.dateSelectionTransformers);
                if (!dragSelection || !(0, $4a7Gb.bY)(dragSelection, hit.dateProfile, context)) {
                    isInvalid = true;
                    dragSelection = null;
                }
            }
            if (dragSelection) context.dispatch({
                type: "SELECT_DATES",
                selection: dragSelection
            });
            else if (!isFinal) context.dispatch({
                type: "UNSELECT_DATES"
            });
            if (!isInvalid) (0, $4a7Gb.au)();
            else (0, $4a7Gb.av)();
            if (!isFinal) _this.dragSelection = dragSelection; // only clear if moved away from all hits while dragging
        };
        _this.handlePointerUp = function(pev) {
            if (_this.dragSelection) {
                // selection is already rendered, so just need to report selection
                (0, $4a7Gb.cr)(_this.dragSelection, pev, _this.component.context);
                _this.dragSelection = null;
            }
        };
        var component = settings.component;
        var options = component.context.options;
        var dragging = _this.dragging = new $1f427812e01e9d4f$var$FeaturefulElementDragging(settings.el);
        dragging.touchScrollAllowed = false;
        dragging.minDistance = options.selectMinDistance || 0;
        dragging.autoScroller.isEnabled = options.dragScroll;
        var hitDragging = _this.hitDragging = new $1f427812e01e9d4f$var$HitDragging(_this.dragging, (0, $4a7Gb.bE)(settings));
        hitDragging.emitter.on("pointerdown", _this.handlePointerDown);
        hitDragging.emitter.on("dragstart", _this.handleDragStart);
        hitDragging.emitter.on("hitupdate", _this.handleHitUpdate);
        hitDragging.emitter.on("pointerup", _this.handlePointerUp);
        return _this;
    }
    (0, $fYUO3._)(DateSelecting, [
        {
            key: "destroy",
            value: function destroy() {
                this.dragging.destroy();
            }
        }
    ]);
    return DateSelecting;
}((0, $4a7Gb.X));
function $1f427812e01e9d4f$var$getComponentTouchDelay$1(component) {
    var options = component.context.options;
    var delay = options.selectLongPressDelay;
    if (delay == null) delay = options.longPressDelay;
    return delay;
}
function $1f427812e01e9d4f$var$joinHitsIntoSelection(hit0, hit1, dateSelectionTransformers) {
    var dateSpan0 = hit0.dateSpan;
    var dateSpan1 = hit1.dateSpan;
    var ms = [
        dateSpan0.range.start,
        dateSpan0.range.end,
        dateSpan1.range.start,
        dateSpan1.range.end
    ];
    ms.sort((0, $4a7Gb.at));
    var props = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = dateSelectionTransformers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var transformer = _step.value;
            var res = transformer(hit0, hit1);
            if (res === false) return null;
            if (res) Object.assign(props, res);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    props.range = {
        start: ms[0],
        end: ms[3]
    };
    props.allDay = dateSpan0.allDay;
    return props;
}
var $1f427812e01e9d4f$var$EventDragging = /*#__PURE__*/ function(Interaction) {
    "use strict";
    (0, $7DbRq._)(EventDragging, Interaction);
    var _super = (0, $ju9pQ._)(EventDragging);
    function EventDragging(settings) {
        (0, $luoZD._)(this, EventDragging);
        var _this;
        _this = _super.call(this, settings);
        // internal state
        _this.subjectEl = null;
        _this.subjectSeg = null; // the seg being selected/dragged
        _this.isDragging = false;
        _this.eventRange = null;
        _this.relevantEvents = null; // the events being dragged
        _this.receivingContext = null;
        _this.validMutation = null;
        _this.mutatedRelevantEvents = null;
        _this.handlePointerDown = function(ev) {
            var origTarget = ev.origEvent.target;
            var _$_assert_this_initialized = (0, $iJSF3._)(_this), component = _$_assert_this_initialized.component, dragging = _$_assert_this_initialized.dragging;
            var mirror = dragging.mirror;
            var options = component.context.options;
            var initialContext = component.context;
            _this.subjectEl = ev.subjectEl;
            var subjectSeg = _this.subjectSeg = (0, $4a7Gb.Y)(ev.subjectEl);
            var eventRange = _this.eventRange = subjectSeg.eventRange;
            var eventInstanceId = eventRange.instance.instanceId;
            _this.relevantEvents = (0, $4a7Gb.aT)(initialContext.getCurrentData().eventStore, eventInstanceId);
            dragging.minDistance = ev.isTouch ? 0 : options.eventDragMinDistance;
            dragging.delay = // only do a touch delay if touch and this event hasn't been selected yet
            ev.isTouch && eventInstanceId !== component.props.eventSelection ? $1f427812e01e9d4f$var$getComponentTouchDelay(component) : null;
            if (options.fixedMirrorParent) mirror.parentNode = options.fixedMirrorParent;
            else mirror.parentNode = (0, $4a7Gb.Z)(origTarget, ".fc");
            mirror.revertDuration = options.dragRevertDuration;
            var isValid = component.isValidSegDownEl(origTarget) && !(0, $4a7Gb.Z)(origTarget, ".fc-event-resizer"); // NOT on a resizer
            dragging.setIgnoreMove(!isValid);
            // disable dragging for elements that are resizable (ie, selectable)
            // but are not draggable
            _this.isDragging = isValid && ev.subjectEl.classList.contains("fc-event-draggable");
        };
        _this.handleDragStart = function(ev) {
            var initialContext = _this.component.context;
            var eventRange = _this.eventRange;
            var eventInstanceId = eventRange.instance.instanceId;
            if (ev.isTouch) // need to select a different event?
            {
                if (eventInstanceId !== _this.component.props.eventSelection) initialContext.dispatch({
                    type: "SELECT_EVENT",
                    eventInstanceId: eventInstanceId
                });
            } else // if now using mouse, but was previous touch interaction, clear selected event
            initialContext.dispatch({
                type: "UNSELECT_EVENT"
            });
            if (_this.isDragging) {
                initialContext.calendarApi.unselect(ev); // unselect *date* selection
                initialContext.emitter.trigger("eventDragStart", {
                    el: _this.subjectEl,
                    event: new (0, $4a7Gb._)(initialContext, eventRange.def, eventRange.instance),
                    jsEvent: ev.origEvent,
                    view: initialContext.viewApi
                });
            }
        };
        _this.handleHitUpdate = function(hit, isFinal) {
            if (!_this.isDragging) return;
            var relevantEvents = _this.relevantEvents;
            var initialHit = _this.hitDragging.initialHit;
            var initialContext = _this.component.context;
            // states based on new hit
            var receivingContext = null;
            var mutation = null;
            var mutatedRelevantEvents = null;
            var isInvalid = false;
            var interaction = {
                affectedEvents: relevantEvents,
                mutatedEvents: (0, $4a7Gb.H)(),
                isEvent: true
            };
            if (hit) {
                receivingContext = hit.context;
                var receivingOptions = receivingContext.options;
                if (initialContext === receivingContext || receivingOptions.editable && receivingOptions.droppable) {
                    mutation = $1f427812e01e9d4f$var$computeEventMutation(initialHit, hit, _this.eventRange.instance.range.start, receivingContext.getCurrentData().pluginHooks.eventDragMutationMassagers);
                    if (mutation) {
                        mutatedRelevantEvents = (0, $4a7Gb.bV)(relevantEvents, receivingContext.getCurrentData().eventUiBases, mutation, receivingContext);
                        interaction.mutatedEvents = mutatedRelevantEvents;
                        if (!(0, $4a7Gb.bX)(interaction, hit.dateProfile, receivingContext)) {
                            isInvalid = true;
                            mutation = null;
                            mutatedRelevantEvents = null;
                            interaction.mutatedEvents = (0, $4a7Gb.H)();
                        }
                    }
                } else receivingContext = null;
            }
            _this.displayDrag(receivingContext, interaction);
            if (!isInvalid) (0, $4a7Gb.au)();
            else (0, $4a7Gb.av)();
            if (!isFinal) {
                if (initialContext === receivingContext && // TODO: write test for this
                $1f427812e01e9d4f$var$isHitsEqual(initialHit, hit)) mutation = null;
                _this.dragging.setMirrorNeedsRevert(!mutation);
                // render the mirror if no already-rendered mirror
                // TODO: wish we could somehow wait for dispatch to guarantee render
                _this.dragging.setMirrorIsVisible(!hit || !_this.subjectEl.getRootNode().querySelector(".fc-event-mirror"));
                // assign states based on new hit
                _this.receivingContext = receivingContext;
                _this.validMutation = mutation;
                _this.mutatedRelevantEvents = mutatedRelevantEvents;
            }
        };
        _this.handlePointerUp = function() {
            if (!_this.isDragging) _this.cleanup(); // because handleDragEnd won't fire
        };
        _this.handleDragEnd = function(ev) {
            if (_this.isDragging) {
                var initialContext = _this.component.context;
                var initialView = initialContext.viewApi;
                var _$_assert_this_initialized = (0, $iJSF3._)(_this), receivingContext = _$_assert_this_initialized.receivingContext, validMutation = _$_assert_this_initialized.validMutation;
                var eventDef = _this.eventRange.def;
                var eventInstance = _this.eventRange.instance;
                var eventApi = new (0, $4a7Gb._)(initialContext, eventDef, eventInstance);
                var relevantEvents = _this.relevantEvents;
                var mutatedRelevantEvents = _this.mutatedRelevantEvents;
                var finalHit = _this.hitDragging.finalHit;
                _this.clearDrag(); // must happen after revert animation
                initialContext.emitter.trigger("eventDragStop", {
                    el: _this.subjectEl,
                    event: eventApi,
                    jsEvent: ev.origEvent,
                    view: initialView
                });
                if (validMutation) {
                    // dropped within same calendar
                    if (receivingContext === initialContext) {
                        var updatedEventApi = new (0, $4a7Gb._)(initialContext, mutatedRelevantEvents.defs[eventDef.defId], eventInstance ? mutatedRelevantEvents.instances[eventInstance.instanceId] : null);
                        initialContext.dispatch({
                            type: "MERGE_EVENTS",
                            eventStore: mutatedRelevantEvents
                        });
                        var eventChangeArg = {
                            oldEvent: eventApi,
                            event: updatedEventApi,
                            relatedEvents: (0, $4a7Gb.w)(mutatedRelevantEvents, initialContext, eventInstance),
                            revert: function() {
                                initialContext.dispatch({
                                    type: "MERGE_EVENTS",
                                    eventStore: relevantEvents
                                });
                            }
                        };
                        var transformed = {};
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = initialContext.getCurrentData().pluginHooks.eventDropTransformers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var transformer = _step.value;
                                Object.assign(transformed, transformer(validMutation, initialContext));
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        initialContext.emitter.trigger("eventDrop", Object.assign(Object.assign(Object.assign({}, eventChangeArg), transformed), {
                            el: ev.subjectEl,
                            delta: validMutation.datesDelta,
                            jsEvent: ev.origEvent,
                            view: initialView
                        }));
                        initialContext.emitter.trigger("eventChange", eventChangeArg);
                    // dropped in different calendar
                    } else if (receivingContext) {
                        var eventRemoveArg = {
                            event: eventApi,
                            relatedEvents: (0, $4a7Gb.w)(relevantEvents, initialContext, eventInstance),
                            revert: function() {
                                initialContext.dispatch({
                                    type: "MERGE_EVENTS",
                                    eventStore: relevantEvents
                                });
                            }
                        };
                        initialContext.emitter.trigger("eventLeave", Object.assign(Object.assign({}, eventRemoveArg), {
                            draggedEl: ev.subjectEl,
                            view: initialView
                        }));
                        initialContext.dispatch({
                            type: "REMOVE_EVENTS",
                            eventStore: relevantEvents
                        });
                        initialContext.emitter.trigger("eventRemove", eventRemoveArg);
                        var addedEventDef = mutatedRelevantEvents.defs[eventDef.defId];
                        var addedEventInstance = mutatedRelevantEvents.instances[eventInstance.instanceId];
                        var addedEventApi = new (0, $4a7Gb._)(receivingContext, addedEventDef, addedEventInstance);
                        receivingContext.dispatch({
                            type: "MERGE_EVENTS",
                            eventStore: mutatedRelevantEvents
                        });
                        var eventAddArg = {
                            event: addedEventApi,
                            relatedEvents: (0, $4a7Gb.w)(mutatedRelevantEvents, receivingContext, addedEventInstance),
                            revert: function() {
                                receivingContext.dispatch({
                                    type: "REMOVE_EVENTS",
                                    eventStore: mutatedRelevantEvents
                                });
                            }
                        };
                        receivingContext.emitter.trigger("eventAdd", eventAddArg);
                        if (ev.isTouch) receivingContext.dispatch({
                            type: "SELECT_EVENT",
                            eventInstanceId: eventInstance.instanceId
                        });
                        receivingContext.emitter.trigger("drop", Object.assign(Object.assign({}, $1f427812e01e9d4f$var$buildDatePointApiWithContext(finalHit.dateSpan, receivingContext)), {
                            draggedEl: ev.subjectEl,
                            jsEvent: ev.origEvent,
                            view: finalHit.context.viewApi
                        }));
                        receivingContext.emitter.trigger("eventReceive", Object.assign(Object.assign({}, eventAddArg), {
                            draggedEl: ev.subjectEl,
                            view: finalHit.context.viewApi
                        }));
                    }
                } else initialContext.emitter.trigger("_noEventDrop");
            }
            _this.cleanup();
        };
        var component = (0, $iJSF3._)(_this).component;
        var options = component.context.options;
        var dragging = _this.dragging = new $1f427812e01e9d4f$var$FeaturefulElementDragging(settings.el);
        dragging.pointer.selector = EventDragging.SELECTOR;
        dragging.touchScrollAllowed = false;
        dragging.autoScroller.isEnabled = options.dragScroll;
        var hitDragging = _this.hitDragging = new $1f427812e01e9d4f$var$HitDragging(_this.dragging, (0, $4a7Gb.a5));
        hitDragging.useSubjectCenter = settings.useEventCenter;
        hitDragging.emitter.on("pointerdown", _this.handlePointerDown);
        hitDragging.emitter.on("dragstart", _this.handleDragStart);
        hitDragging.emitter.on("hitupdate", _this.handleHitUpdate);
        hitDragging.emitter.on("pointerup", _this.handlePointerUp);
        hitDragging.emitter.on("dragend", _this.handleDragEnd);
        return _this;
    }
    (0, $fYUO3._)(EventDragging, [
        {
            key: "destroy",
            value: function destroy() {
                this.dragging.destroy();
            }
        },
        {
            // render a drag state on the next receivingCalendar
            key: "displayDrag",
            value: function displayDrag(nextContext, state) {
                var initialContext = this.component.context;
                var prevContext = this.receivingContext;
                // does the previous calendar need to be cleared?
                if (prevContext && prevContext !== nextContext) {
                    // does the initial calendar need to be cleared?
                    // if so, don't clear all the way. we still need to to hide the affectedEvents
                    if (prevContext === initialContext) prevContext.dispatch({
                        type: "SET_EVENT_DRAG",
                        state: {
                            affectedEvents: state.affectedEvents,
                            mutatedEvents: (0, $4a7Gb.H)(),
                            isEvent: true
                        }
                    });
                    else prevContext.dispatch({
                        type: "UNSET_EVENT_DRAG"
                    });
                }
                if (nextContext) nextContext.dispatch({
                    type: "SET_EVENT_DRAG",
                    state: state
                });
            }
        },
        {
            key: "clearDrag",
            value: function clearDrag() {
                var initialCalendar = this.component.context;
                var receivingContext = this.receivingContext;
                if (receivingContext) receivingContext.dispatch({
                    type: "UNSET_EVENT_DRAG"
                });
                // the initial calendar might have an dummy drag state from displayDrag
                if (initialCalendar !== receivingContext) initialCalendar.dispatch({
                    type: "UNSET_EVENT_DRAG"
                });
            }
        },
        {
            key: "cleanup",
            value: function cleanup() {
                this.subjectSeg = null;
                this.isDragging = false;
                this.eventRange = null;
                this.relevantEvents = null;
                this.receivingContext = null;
                this.validMutation = null;
                this.mutatedRelevantEvents = null;
            }
        }
    ]);
    return EventDragging;
}((0, $4a7Gb.X));
// TODO: test this in IE11
// QUESTION: why do we need it on the resizable???
$1f427812e01e9d4f$var$EventDragging.SELECTOR = ".fc-event-draggable, .fc-event-resizable";
function $1f427812e01e9d4f$var$computeEventMutation(hit0, hit1, eventInstanceStart, massagers) {
    var dateSpan0 = hit0.dateSpan;
    var dateSpan1 = hit1.dateSpan;
    var date0 = dateSpan0.range.start;
    var date1 = dateSpan1.range.start;
    var standardProps = {};
    if (dateSpan0.allDay !== dateSpan1.allDay) {
        standardProps.allDay = dateSpan1.allDay;
        standardProps.hasEnd = hit1.context.options.allDayMaintainDuration;
        if (dateSpan1.allDay) // means date1 is already start-of-day,
        // but date0 needs to be converted
        date0 = (0, $4a7Gb.q)(eventInstanceStart);
        else // Moving from allDate->timed
        // Doesn't matter where on the event the drag began, mutate the event's start-date to date1
        date0 = eventInstanceStart;
    }
    var delta = (0, $4a7Gb.ay)(date0, date1, hit0.context.dateEnv, hit0.componentId === hit1.componentId ? hit0.largeUnit : null);
    if (delta.milliseconds) standardProps.allDay = false;
    var mutation = {
        datesDelta: delta,
        standardProps: standardProps
    };
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = massagers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var massager = _step.value;
            massager(mutation, hit0, hit1);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return mutation;
}
function $1f427812e01e9d4f$var$getComponentTouchDelay(component) {
    var options = component.context.options;
    var delay = options.eventLongPressDelay;
    if (delay == null) delay = options.longPressDelay;
    return delay;
}
var $1f427812e01e9d4f$var$EventResizing = /*#__PURE__*/ function(Interaction) {
    "use strict";
    (0, $7DbRq._)(EventResizing, Interaction);
    var _super = (0, $ju9pQ._)(EventResizing);
    function EventResizing(settings) {
        (0, $luoZD._)(this, EventResizing);
        var _this;
        _this = _super.call(this, settings);
        // internal state
        _this.draggingSegEl = null;
        _this.draggingSeg = null; // TODO: rename to resizingSeg? subjectSeg?
        _this.eventRange = null;
        _this.relevantEvents = null;
        _this.validMutation = null;
        _this.mutatedRelevantEvents = null;
        _this.handlePointerDown = function(ev) {
            var component = (0, $iJSF3._)(_this).component;
            var segEl = _this.querySegEl(ev);
            var seg = (0, $4a7Gb.Y)(segEl);
            var eventRange = _this.eventRange = seg.eventRange;
            _this.dragging.minDistance = component.context.options.eventDragMinDistance;
            // if touch, need to be working with a selected event
            _this.dragging.setIgnoreMove(!_this.component.isValidSegDownEl(ev.origEvent.target) || ev.isTouch && _this.component.props.eventSelection !== eventRange.instance.instanceId);
        };
        _this.handleDragStart = function(ev) {
            var context = _this.component.context;
            var eventRange = _this.eventRange;
            _this.relevantEvents = (0, $4a7Gb.aT)(context.getCurrentData().eventStore, _this.eventRange.instance.instanceId);
            var segEl = _this.querySegEl(ev);
            _this.draggingSegEl = segEl;
            _this.draggingSeg = (0, $4a7Gb.Y)(segEl);
            context.calendarApi.unselect();
            context.emitter.trigger("eventResizeStart", {
                el: segEl,
                event: new (0, $4a7Gb._)(context, eventRange.def, eventRange.instance),
                jsEvent: ev.origEvent,
                view: context.viewApi
            });
        };
        _this.handleHitUpdate = function(hit, isFinal, ev) {
            var context = _this.component.context;
            var relevantEvents = _this.relevantEvents;
            var initialHit = _this.hitDragging.initialHit;
            var eventInstance = _this.eventRange.instance;
            var mutation = null;
            var mutatedRelevantEvents = null;
            var isInvalid = false;
            var interaction = {
                affectedEvents: relevantEvents,
                mutatedEvents: (0, $4a7Gb.H)(),
                isEvent: true
            };
            if (hit) {
                var disallowed = hit.componentId === initialHit.componentId && _this.isHitComboAllowed && !_this.isHitComboAllowed(initialHit, hit);
                if (!disallowed) mutation = $1f427812e01e9d4f$var$computeMutation(initialHit, hit, ev.subjectEl.classList.contains("fc-event-resizer-start"), eventInstance.range);
            }
            if (mutation) {
                mutatedRelevantEvents = (0, $4a7Gb.bV)(relevantEvents, context.getCurrentData().eventUiBases, mutation, context);
                interaction.mutatedEvents = mutatedRelevantEvents;
                if (!(0, $4a7Gb.bX)(interaction, hit.dateProfile, context)) {
                    isInvalid = true;
                    mutation = null;
                    mutatedRelevantEvents = null;
                    interaction.mutatedEvents = null;
                }
            }
            if (mutatedRelevantEvents) context.dispatch({
                type: "SET_EVENT_RESIZE",
                state: interaction
            });
            else context.dispatch({
                type: "UNSET_EVENT_RESIZE"
            });
            if (!isInvalid) (0, $4a7Gb.au)();
            else (0, $4a7Gb.av)();
            if (!isFinal) {
                if (mutation && $1f427812e01e9d4f$var$isHitsEqual(initialHit, hit)) mutation = null;
                _this.validMutation = mutation;
                _this.mutatedRelevantEvents = mutatedRelevantEvents;
            }
        };
        _this.handleDragEnd = function(ev) {
            var context = _this.component.context;
            var eventDef = _this.eventRange.def;
            var eventInstance = _this.eventRange.instance;
            var eventApi = new (0, $4a7Gb._)(context, eventDef, eventInstance);
            var relevantEvents = _this.relevantEvents;
            var mutatedRelevantEvents = _this.mutatedRelevantEvents;
            context.emitter.trigger("eventResizeStop", {
                el: _this.draggingSegEl,
                event: eventApi,
                jsEvent: ev.origEvent,
                view: context.viewApi
            });
            if (_this.validMutation) {
                var updatedEventApi = new (0, $4a7Gb._)(context, mutatedRelevantEvents.defs[eventDef.defId], eventInstance ? mutatedRelevantEvents.instances[eventInstance.instanceId] : null);
                context.dispatch({
                    type: "MERGE_EVENTS",
                    eventStore: mutatedRelevantEvents
                });
                var eventChangeArg = {
                    oldEvent: eventApi,
                    event: updatedEventApi,
                    relatedEvents: (0, $4a7Gb.w)(mutatedRelevantEvents, context, eventInstance),
                    revert: function() {
                        context.dispatch({
                            type: "MERGE_EVENTS",
                            eventStore: relevantEvents
                        });
                    }
                };
                context.emitter.trigger("eventResize", Object.assign(Object.assign({}, eventChangeArg), {
                    el: _this.draggingSegEl,
                    startDelta: _this.validMutation.startDelta || (0, $4a7Gb.d)(0),
                    endDelta: _this.validMutation.endDelta || (0, $4a7Gb.d)(0),
                    jsEvent: ev.origEvent,
                    view: context.viewApi
                }));
                context.emitter.trigger("eventChange", eventChangeArg);
            } else context.emitter.trigger("_noEventResize");
            // reset all internal state
            _this.draggingSeg = null;
            _this.relevantEvents = null;
            _this.validMutation = null;
        // okay to keep eventInstance around. useful to set it in handlePointerDown
        };
        var component = settings.component;
        var dragging = _this.dragging = new $1f427812e01e9d4f$var$FeaturefulElementDragging(settings.el);
        dragging.pointer.selector = ".fc-event-resizer";
        dragging.touchScrollAllowed = false;
        dragging.autoScroller.isEnabled = component.context.options.dragScroll;
        var hitDragging = _this.hitDragging = new $1f427812e01e9d4f$var$HitDragging(_this.dragging, (0, $4a7Gb.bE)(settings));
        hitDragging.emitter.on("pointerdown", _this.handlePointerDown);
        hitDragging.emitter.on("dragstart", _this.handleDragStart);
        hitDragging.emitter.on("hitupdate", _this.handleHitUpdate);
        hitDragging.emitter.on("dragend", _this.handleDragEnd);
        return _this;
    }
    (0, $fYUO3._)(EventResizing, [
        {
            key: "destroy",
            value: function destroy() {
                this.dragging.destroy();
            }
        },
        {
            key: "querySegEl",
            value: function querySegEl(ev) {
                return (0, $4a7Gb.Z)(ev.subjectEl, ".fc-event");
            }
        }
    ]);
    return EventResizing;
}((0, $4a7Gb.X));
function $1f427812e01e9d4f$var$computeMutation(hit0, hit1, isFromStart, instanceRange) {
    var dateEnv = hit0.context.dateEnv;
    var date0 = hit0.dateSpan.range.start;
    var date1 = hit1.dateSpan.range.start;
    var delta = (0, $4a7Gb.ay)(date0, date1, dateEnv, hit0.largeUnit);
    if (isFromStart) {
        if (dateEnv.add(instanceRange.start, delta) < instanceRange.end) return {
            startDelta: delta
        };
    } else if (dateEnv.add(instanceRange.end, delta) > instanceRange.start) return {
        endDelta: delta
    };
    return null;
}
var $1f427812e01e9d4f$var$UnselectAuto = /*#__PURE__*/ function() {
    "use strict";
    function UnselectAuto(context) {
        var _this = this;
        (0, $luoZD._)(this, UnselectAuto);
        this.context = context;
        this.isRecentPointerDateSelect = false; // wish we could use a selector to detect date selection, but uses hit system
        this.matchesCancel = false;
        this.matchesEvent = false;
        this.onSelect = function(selectInfo) {
            if (selectInfo.jsEvent) _this.isRecentPointerDateSelect = true;
        };
        this.onDocumentPointerDown = function(pev) {
            var unselectCancel = _this.context.options.unselectCancel;
            var downEl = (0, $4a7Gb.aP)(pev.origEvent);
            _this.matchesCancel = !!(0, $4a7Gb.Z)(downEl, unselectCancel);
            _this.matchesEvent = !!(0, $4a7Gb.Z)(downEl, $1f427812e01e9d4f$var$EventDragging.SELECTOR); // interaction started on an event?
        };
        this.onDocumentPointerUp = function(pev) {
            var _$context = _this.context;
            var documentPointer = _this.documentPointer;
            var calendarState = _$context.getCurrentData();
            // touch-scrolling should never unfocus any type of selection
            if (!documentPointer.wasTouchScroll) {
                if (calendarState.dateSelection && // an existing date selection?
                !_this.isRecentPointerDateSelect // a new pointer-initiated date selection since last onDocumentPointerUp?
                ) {
                    var unselectAuto = _$context.options.unselectAuto;
                    if (unselectAuto && (!unselectAuto || !_this.matchesCancel)) _$context.calendarApi.unselect(pev);
                }
                if (calendarState.eventSelection && // an existing event selected?
                !_this.matchesEvent // interaction DIDN'T start on an event
                ) _$context.dispatch({
                    type: "UNSELECT_EVENT"
                });
            }
            _this.isRecentPointerDateSelect = false;
        };
        var documentPointer = this.documentPointer = new $1f427812e01e9d4f$var$PointerDragging(document);
        documentPointer.shouldIgnoreMove = true;
        documentPointer.shouldWatchScroll = false;
        documentPointer.emitter.on("pointerdown", this.onDocumentPointerDown);
        documentPointer.emitter.on("pointerup", this.onDocumentPointerUp);
        /*
        TODO: better way to know about whether there was a selection with the pointer
        */ context.emitter.on("select", this.onSelect);
    }
    (0, $fYUO3._)(UnselectAuto, [
        {
            key: "destroy",
            value: function destroy() {
                this.context.emitter.off("select", this.onSelect);
                this.documentPointer.destroy();
            }
        }
    ]);
    return UnselectAuto;
}();
var $1f427812e01e9d4f$var$OPTION_REFINERS = {
    fixedMirrorParent: (0, $4a7Gb.n)
};
var $1f427812e01e9d4f$var$LISTENER_REFINERS = {
    dateClick: (0, $4a7Gb.n),
    eventDragStart: (0, $4a7Gb.n),
    eventDragStop: (0, $4a7Gb.n),
    eventDrop: (0, $4a7Gb.n),
    eventResizeStart: (0, $4a7Gb.n),
    eventResizeStop: (0, $4a7Gb.n),
    eventResize: (0, $4a7Gb.n),
    drop: (0, $4a7Gb.n),
    eventReceive: (0, $4a7Gb.n),
    eventLeave: (0, $4a7Gb.n)
};
/*
Given an already instantiated draggable object for one-or-more elements,
Interprets any dragging as an attempt to drag an events that lives outside
of a calendar onto a calendar.
*/ var $1f427812e01e9d4f$var$ExternalElementDragging = /*#__PURE__*/ function() {
    "use strict";
    function ExternalElementDragging(dragging, suppliedDragMeta) {
        var _this = this;
        (0, $luoZD._)(this, ExternalElementDragging);
        this.receivingContext = null;
        this.droppableEvent = null; // will exist for all drags, even if create:false
        this.suppliedDragMeta = null;
        this.dragMeta = null;
        this.handleDragStart = function(ev) {
            _this.dragMeta = _this.buildDragMeta(ev.subjectEl);
        };
        this.handleHitUpdate = function(hit, isFinal, ev) {
            var _$dragging = _this.hitDragging.dragging;
            var receivingContext = null;
            var droppableEvent = null;
            var isInvalid = false;
            var interaction = {
                affectedEvents: (0, $4a7Gb.H)(),
                mutatedEvents: (0, $4a7Gb.H)(),
                isEvent: _this.dragMeta.create
            };
            if (hit) {
                receivingContext = hit.context;
                if (_this.canDropElOnCalendar(ev.subjectEl, receivingContext)) {
                    droppableEvent = $1f427812e01e9d4f$var$computeEventForDateSpan(hit.dateSpan, _this.dragMeta, receivingContext);
                    interaction.mutatedEvents = (0, $4a7Gb.aU)(droppableEvent);
                    isInvalid = !(0, $4a7Gb.bX)(interaction, hit.dateProfile, receivingContext);
                    if (isInvalid) {
                        interaction.mutatedEvents = (0, $4a7Gb.H)();
                        droppableEvent = null;
                    }
                }
            }
            _this.displayDrag(receivingContext, interaction);
            // show mirror if no already-rendered mirror element OR if we are shutting down the mirror (?)
            // TODO: wish we could somehow wait for dispatch to guarantee render
            _$dragging.setMirrorIsVisible(isFinal || !droppableEvent || !document.querySelector(".fc-event-mirror"));
            if (!isInvalid) (0, $4a7Gb.au)();
            else (0, $4a7Gb.av)();
            if (!isFinal) {
                _$dragging.setMirrorNeedsRevert(!droppableEvent);
                _this.receivingContext = receivingContext;
                _this.droppableEvent = droppableEvent;
            }
        };
        this.handleDragEnd = function(pev) {
            var receivingContext = _this.receivingContext, droppableEvent = _this.droppableEvent;
            _this.clearDrag();
            if (receivingContext && droppableEvent) {
                var finalHit = _this.hitDragging.finalHit;
                var finalView = finalHit.context.viewApi;
                var dragMeta = _this.dragMeta;
                receivingContext.emitter.trigger("drop", Object.assign(Object.assign({}, $1f427812e01e9d4f$var$buildDatePointApiWithContext(finalHit.dateSpan, receivingContext)), {
                    draggedEl: pev.subjectEl,
                    jsEvent: pev.origEvent,
                    view: finalView
                }));
                if (dragMeta.create) {
                    var addingEvents = (0, $4a7Gb.aU)(droppableEvent);
                    receivingContext.dispatch({
                        type: "MERGE_EVENTS",
                        eventStore: addingEvents
                    });
                    if (pev.isTouch) receivingContext.dispatch({
                        type: "SELECT_EVENT",
                        eventInstanceId: droppableEvent.instance.instanceId
                    });
                    // signal that an external event landed
                    receivingContext.emitter.trigger("eventReceive", {
                        event: new (0, $4a7Gb._)(receivingContext, droppableEvent.def, droppableEvent.instance),
                        relatedEvents: [],
                        revert: function() {
                            receivingContext.dispatch({
                                type: "REMOVE_EVENTS",
                                eventStore: addingEvents
                            });
                        },
                        draggedEl: pev.subjectEl,
                        view: finalView
                    });
                }
            }
            _this.receivingContext = null;
            _this.droppableEvent = null;
        };
        var hitDragging = this.hitDragging = new $1f427812e01e9d4f$var$HitDragging(dragging, (0, $4a7Gb.a5));
        hitDragging.requireInitial = false; // will start outside of a component
        hitDragging.emitter.on("dragstart", this.handleDragStart);
        hitDragging.emitter.on("hitupdate", this.handleHitUpdate);
        hitDragging.emitter.on("dragend", this.handleDragEnd);
        this.suppliedDragMeta = suppliedDragMeta;
    }
    (0, $fYUO3._)(ExternalElementDragging, [
        {
            key: "buildDragMeta",
            value: function buildDragMeta(subjectEl) {
                if (typeof this.suppliedDragMeta === "object") return (0, $4a7Gb.bH)(this.suppliedDragMeta);
                if (typeof this.suppliedDragMeta === "function") return (0, $4a7Gb.bH)(this.suppliedDragMeta(subjectEl));
                return $1f427812e01e9d4f$var$getDragMetaFromEl(subjectEl);
            }
        },
        {
            key: "displayDrag",
            value: function displayDrag(nextContext, state) {
                var prevContext = this.receivingContext;
                if (prevContext && prevContext !== nextContext) prevContext.dispatch({
                    type: "UNSET_EVENT_DRAG"
                });
                if (nextContext) nextContext.dispatch({
                    type: "SET_EVENT_DRAG",
                    state: state
                });
            }
        },
        {
            key: "clearDrag",
            value: function clearDrag() {
                if (this.receivingContext) this.receivingContext.dispatch({
                    type: "UNSET_EVENT_DRAG"
                });
            }
        },
        {
            key: "canDropElOnCalendar",
            value: function canDropElOnCalendar(el, receivingContext) {
                var dropAccept = receivingContext.options.dropAccept;
                if (typeof dropAccept === "function") return dropAccept.call(receivingContext.calendarApi, el);
                if (typeof dropAccept === "string" && dropAccept) return Boolean((0, $4a7Gb.aO)(el, dropAccept));
                return true;
            }
        }
    ]);
    return ExternalElementDragging;
}();
// Utils for computing event store from the DragMeta
// ----------------------------------------------------------------------------------------------------
function $1f427812e01e9d4f$var$computeEventForDateSpan(dateSpan, dragMeta, context) {
    var defProps = Object.assign({}, dragMeta.leftoverProps);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = context.pluginHooks.externalDefTransforms[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var transform = _step.value;
            Object.assign(defProps, transform(dateSpan, dragMeta));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var _refineEventDef = (0, $4a7Gb.aj)(defProps, context), refined = _refineEventDef.refined, extra = _refineEventDef.extra;
    var def = (0, $4a7Gb.ai)(refined, extra, dragMeta.sourceId, dateSpan.allDay, context.options.forceEventDuration || Boolean(dragMeta.duration), context);
    var start = dateSpan.range.start;
    // only rely on time info if drop zone is all-day,
    // otherwise, we already know the time
    if (dateSpan.allDay && dragMeta.startTime) start = context.dateEnv.add(start, dragMeta.startTime);
    var end = dragMeta.duration ? context.dateEnv.add(start, dragMeta.duration) : (0, $4a7Gb.cs)(dateSpan.allDay, start, context);
    var instance = (0, $4a7Gb.ah)(def.defId, {
        start: start,
        end: end
    });
    return {
        def: def,
        instance: instance
    };
}
// Utils for extracting data from element
// ----------------------------------------------------------------------------------------------------
function $1f427812e01e9d4f$var$getDragMetaFromEl(el) {
    var str = $1f427812e01e9d4f$var$getEmbeddedElData(el, "event");
    var obj = str ? JSON.parse(str) : {
        create: false
    }; // if no embedded data, assume no event creation
    return (0, $4a7Gb.bH)(obj);
}
(0, $4a7Gb.bG).dataAttrPrefix = "";
function $1f427812e01e9d4f$var$getEmbeddedElData(el, name) {
    var prefix = (0, $4a7Gb.bG).dataAttrPrefix;
    var prefixedName = (prefix ? prefix + "-" : "") + name;
    return el.getAttribute("data-" + prefixedName) || "";
}
/*
Makes an element (that is *external* to any calendar) draggable.
Can pass in data that determines how an event will be created when dropped onto a calendar.
Leverages FullCalendar's internal drag-n-drop functionality WITHOUT a third-party drag system.
*/ var $1f427812e01e9d4f$export$f2a139e5d18b9882 = /*#__PURE__*/ function() {
    "use strict";
    function ExternalDraggable(el) {
        var _this = this;
        var settings = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        (0, $luoZD._)(this, ExternalDraggable);
        this.handlePointerDown = function(ev) {
            var dragging = _this.dragging;
            var _this_settings = _this.settings, minDistance = _this_settings.minDistance, longPressDelay = _this_settings.longPressDelay;
            dragging.minDistance = minDistance != null ? minDistance : ev.isTouch ? 0 : (0, $4a7Gb.e).eventDragMinDistance;
            dragging.delay = ev.isTouch ? longPressDelay != null ? longPressDelay : (0, $4a7Gb.e).longPressDelay : 0;
        };
        this.handleDragStart = function(ev) {
            if (ev.isTouch && _this.dragging.delay && ev.subjectEl.classList.contains("fc-event")) _this.dragging.mirror.getMirrorEl().classList.add("fc-event-selected");
        };
        this.settings = settings;
        var dragging = this.dragging = new $1f427812e01e9d4f$var$FeaturefulElementDragging(el);
        dragging.touchScrollAllowed = false;
        if (settings.itemSelector != null) dragging.pointer.selector = settings.itemSelector;
        if (settings.appendTo != null) dragging.mirror.parentNode = settings.appendTo; // TODO: write tests
        dragging.emitter.on("pointerdown", this.handlePointerDown);
        dragging.emitter.on("dragstart", this.handleDragStart);
        new $1f427812e01e9d4f$var$ExternalElementDragging(dragging, settings.eventData); // eslint-disable-line no-new
    }
    (0, $fYUO3._)(ExternalDraggable, [
        {
            key: "destroy",
            value: function destroy() {
                this.dragging.destroy();
            }
        }
    ]);
    return ExternalDraggable;
}();
/*
Detects when a *THIRD-PARTY* drag-n-drop system interacts with elements.
The third-party system is responsible for drawing the visuals effects of the drag.
This class simply monitors for pointer movements and fires events.
It also has the ability to hide the moving element (the "mirror") during the drag.
*/ var $1f427812e01e9d4f$var$InferredElementDragging = /*#__PURE__*/ function(ElementDragging) {
    "use strict";
    (0, $7DbRq._)(InferredElementDragging, ElementDragging);
    var _super = (0, $ju9pQ._)(InferredElementDragging);
    function InferredElementDragging(containerEl) {
        (0, $luoZD._)(this, InferredElementDragging);
        var _this;
        _this = _super.call(this, containerEl);
        _this.shouldIgnoreMove = false;
        _this.mirrorSelector = "";
        _this.currentMirrorEl = null;
        _this.handlePointerDown = function(ev) {
            _this.emitter.trigger("pointerdown", ev);
            if (!_this.shouldIgnoreMove) // fire dragstart right away. does not support delay or min-distance
            _this.emitter.trigger("dragstart", ev);
        };
        _this.handlePointerMove = function(ev) {
            if (!_this.shouldIgnoreMove) _this.emitter.trigger("dragmove", ev);
        };
        _this.handlePointerUp = function(ev) {
            _this.emitter.trigger("pointerup", ev);
            if (!_this.shouldIgnoreMove) // fire dragend right away. does not support a revert animation
            _this.emitter.trigger("dragend", ev);
        };
        var pointer = _this.pointer = new $1f427812e01e9d4f$var$PointerDragging(containerEl);
        pointer.emitter.on("pointerdown", _this.handlePointerDown);
        pointer.emitter.on("pointermove", _this.handlePointerMove);
        pointer.emitter.on("pointerup", _this.handlePointerUp);
        return _this;
    }
    (0, $fYUO3._)(InferredElementDragging, [
        {
            key: "destroy",
            value: function destroy() {
                this.pointer.destroy();
            }
        },
        {
            key: "setIgnoreMove",
            value: function setIgnoreMove(bool) {
                this.shouldIgnoreMove = bool;
            }
        },
        {
            key: "setMirrorIsVisible",
            value: function setMirrorIsVisible(bool) {
                if (bool) // restore a previously hidden element.
                // use the reference in case the selector class has already been removed.
                {
                    if (this.currentMirrorEl) {
                        this.currentMirrorEl.style.visibility = "";
                        this.currentMirrorEl = null;
                    }
                } else {
                    var mirrorEl = this.mirrorSelector ? document.querySelector(this.mirrorSelector) : null;
                    if (mirrorEl) {
                        this.currentMirrorEl = mirrorEl;
                        mirrorEl.style.visibility = "hidden";
                    }
                }
            }
        }
    ]);
    return InferredElementDragging;
}((0, $4a7Gb.bF));
/*
Bridges third-party drag-n-drop systems with FullCalendar.
Must be instantiated and destroyed by caller.
*/ var $1f427812e01e9d4f$export$51e5e9a9728fcd8f = /*#__PURE__*/ function() {
    "use strict";
    function ThirdPartyDraggable(containerOrSettings, settings) {
        (0, $luoZD._)(this, ThirdPartyDraggable);
        var containerEl = document;
        if (// wish we could just test instanceof EventTarget, but doesn't work in IE11
        containerOrSettings === document || containerOrSettings instanceof Element) {
            containerEl = containerOrSettings;
            settings = settings || {};
        } else settings = containerOrSettings || {};
        var dragging = this.dragging = new $1f427812e01e9d4f$var$InferredElementDragging(containerEl);
        if (typeof settings.itemSelector === "string") dragging.pointer.selector = settings.itemSelector;
        else if (containerEl === document) dragging.pointer.selector = "[data-event]";
        if (typeof settings.mirrorSelector === "string") dragging.mirrorSelector = settings.mirrorSelector;
        var externalDragging = new $1f427812e01e9d4f$var$ExternalElementDragging(dragging, settings.eventData);
        // The hit-detection system requires that the dnd-mirror-element be pointer-events:none,
        // but this can't be guaranteed for third-party draggables, so disable
        externalDragging.hitDragging.disablePointCheck = true;
    }
    (0, $fYUO3._)(ThirdPartyDraggable, [
        {
            key: "destroy",
            value: function destroy() {
                this.dragging.destroy();
            }
        }
    ]);
    return ThirdPartyDraggable;
}();
var $1f427812e01e9d4f$export$2e2bcd8739ae039 = (0, $782b2550ae753193$export$ae829ec7b2625219)({
    name: "@fullcalendar/interaction",
    componentInteractions: [
        $1f427812e01e9d4f$var$DateClicking,
        $1f427812e01e9d4f$var$DateSelecting,
        $1f427812e01e9d4f$var$EventDragging,
        $1f427812e01e9d4f$var$EventResizing
    ],
    calendarInteractions: [
        $1f427812e01e9d4f$var$UnselectAuto
    ],
    elementDraggingImpl: $1f427812e01e9d4f$var$FeaturefulElementDragging,
    optionRefiners: $1f427812e01e9d4f$var$OPTION_REFINERS,
    listenerRefiners: $1f427812e01e9d4f$var$LISTENER_REFINERS
});


/**!
* tippy.js v6.3.7
* (c) 2017-2021 atomiks
* MIT License
*/ function $548bef829b42ccaa$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || "").toLowerCase() : null;
}


function $d08ced4ab20d8cdc$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== "[object Window]") {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $37342f115357a5f9$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $d08ced4ab20d8cdc$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $37342f115357a5f9$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $d08ced4ab20d8cdc$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $37342f115357a5f9$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === "undefined") return false;
    var OwnElement = (0, $d08ced4ab20d8cdc$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


// and applies them to the HTMLElements such as popper and arrow
function $a0a31010a3a047b1$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $37342f115357a5f9$export$1b3bfaa9684536aa)(element) || !(0, $548bef829b42ccaa$export$2e2bcd8739ae039)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? "" : value);
        });
    });
}
function $a0a31010a3a047b1$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: "0",
            top: "0",
            margin: "0"
        },
        arrow: {
            position: "absolute"
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = "";
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $37342f115357a5f9$export$1b3bfaa9684536aa)(element) || !(0, $548bef829b42ccaa$export$2e2bcd8739ae039)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $a0a31010a3a047b1$export$2e2bcd8739ae039 = {
    name: "applyStyles",
    enabled: true,
    phase: "write",
    fn: $a0a31010a3a047b1$var$applyStyles,
    effect: $a0a31010a3a047b1$var$effect,
    requires: [
        "computeStyles"
    ]
};


var $07c5006d2e8c7141$export$8960430cfd85939f = Math.max;
var $07c5006d2e8c7141$export$96ec731ed4dcb222 = Math.min;
var $07c5006d2e8c7141$export$2077e0241d6afd3c = Math.round;



function $c771e9c72d5b5dd2$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(" ");
    return navigator.userAgent;
}


function $a8715e4396904aaf$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $c771e9c72d5b5dd2$export$2e2bcd8739ae039)());
}


function $9a52929460d1edc5$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $37342f115357a5f9$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $07c5006d2e8c7141$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $07c5006d2e8c7141$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $37342f115357a5f9$export$45a5e7f76e0caa8d)(element) ? (0, $d08ced4ab20d8cdc$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $a8715e4396904aaf$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}



function $0d021f0ecdfec985$export$2e2bcd8739ae039(node) {
    var win = (0, $d08ced4ab20d8cdc$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}




function $ed2a3d1570c3e497$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $218467b769fcc785$export$2e2bcd8739ae039(node) {
    if (node === (0, $d08ced4ab20d8cdc$export$2e2bcd8739ae039)(node) || !(0, $37342f115357a5f9$export$1b3bfaa9684536aa)(node)) return (0, $0d021f0ecdfec985$export$2e2bcd8739ae039)(node);
    else return (0, $ed2a3d1570c3e497$export$2e2bcd8739ae039)(node);
}






function $46cc2355984f7848$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $37342f115357a5f9$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $71cc84f70812b973$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $9a52929460d1edc5$export$2e2bcd8739ae039)((0, $46cc2355984f7848$export$2e2bcd8739ae039)(element)).left + (0, $0d021f0ecdfec985$export$2e2bcd8739ae039)(element).scrollLeft;
}




function $244ad8714f8d6c3b$export$2e2bcd8739ae039(element) {
    return (0, $d08ced4ab20d8cdc$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}


function $9cfa476a8e54650a$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $244ad8714f8d6c3b$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}



function $3614e9488edad135$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $07c5006d2e8c7141$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $07c5006d2e8c7141$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $3614e9488edad135$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $37342f115357a5f9$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $37342f115357a5f9$export$1b3bfaa9684536aa)(offsetParent) && $3614e9488edad135$var$isElementScaled(offsetParent);
    var documentElement = (0, $46cc2355984f7848$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $9a52929460d1edc5$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $548bef829b42ccaa$export$2e2bcd8739ae039)(offsetParent) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
        (0, $9cfa476a8e54650a$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $218467b769fcc785$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $37342f115357a5f9$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $9a52929460d1edc5$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $71cc84f70812b973$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}



function $31d574d36055a9b9$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $9a52929460d1edc5$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}





function $58c6b831f18390f0$export$2e2bcd8739ae039(element) {
    if ((0, $548bef829b42ccaa$export$2e2bcd8739ae039)(element) === "html") return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $37342f115357a5f9$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $46cc2355984f7848$export$2e2bcd8739ae039)(element) // fallback
    );
}





function $69b58b8ece1ea913$export$2e2bcd8739ae039(node) {
    if ([
        "html",
        "body",
        "#document"
    ].indexOf((0, $548bef829b42ccaa$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $37342f115357a5f9$export$1b3bfaa9684536aa)(node) && (0, $9cfa476a8e54650a$export$2e2bcd8739ae039)(node)) return node;
    return $69b58b8ece1ea913$export$2e2bcd8739ae039((0, $58c6b831f18390f0$export$2e2bcd8739ae039)(node));
}





function $66a5b8980a3365ae$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $69b58b8ece1ea913$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $d08ced4ab20d8cdc$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $9cfa476a8e54650a$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($66a5b8980a3365ae$export$2e2bcd8739ae039((0, $58c6b831f18390f0$export$2e2bcd8739ae039)(target)));
}







function $c95dd4a882bcdd72$export$2e2bcd8739ae039(element) {
    return [
        "table",
        "td",
        "th"
    ].indexOf((0, $548bef829b42ccaa$export$2e2bcd8739ae039)(element)) >= 0;
}




function $38d1a99ca0438f4b$var$getTrueOffsetParent(element) {
    if (!(0, $37342f115357a5f9$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $244ad8714f8d6c3b$export$2e2bcd8739ae039)(element).position === "fixed") return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $38d1a99ca0438f4b$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $c771e9c72d5b5dd2$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $c771e9c72d5b5dd2$export$2e2bcd8739ae039)());
    if (isIE && (0, $37342f115357a5f9$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $244ad8714f8d6c3b$export$2e2bcd8739ae039)(element);
        if (elementCss.position === "fixed") return null;
    }
    var currentNode = (0, $58c6b831f18390f0$export$2e2bcd8739ae039)(element);
    if ((0, $37342f115357a5f9$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $37342f115357a5f9$export$1b3bfaa9684536aa)(currentNode) && [
        "html",
        "body"
    ].indexOf((0, $548bef829b42ccaa$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $244ad8714f8d6c3b$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== "none" || css.perspective !== "none" || css.contain === "paint" || [
            "transform",
            "perspective"
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === "filter" || isFirefox && css.filter && css.filter !== "none") return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $38d1a99ca0438f4b$export$2e2bcd8739ae039(element) {
    var window = (0, $d08ced4ab20d8cdc$export$2e2bcd8739ae039)(element);
    var offsetParent = $38d1a99ca0438f4b$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $c95dd4a882bcdd72$export$2e2bcd8739ae039)(offsetParent) && (0, $244ad8714f8d6c3b$export$2e2bcd8739ae039)(offsetParent).position === "static")offsetParent = $38d1a99ca0438f4b$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $548bef829b42ccaa$export$2e2bcd8739ae039)(offsetParent) === "html" || (0, $548bef829b42ccaa$export$2e2bcd8739ae039)(offsetParent) === "body" && (0, $244ad8714f8d6c3b$export$2e2bcd8739ae039)(offsetParent).position === "static")) return window;
    return offsetParent || $38d1a99ca0438f4b$var$getContainingBlock(element) || window;
}


var $2b29df0662f1c8f3$export$1e95b668f3b82d = "top";
var $2b29df0662f1c8f3$export$40e543e69a8b3fbb = "bottom";
var $2b29df0662f1c8f3$export$79ffe56a765070d2 = "right";
var $2b29df0662f1c8f3$export$eabcd2c8791e7bf4 = "left";
var $2b29df0662f1c8f3$export$dfb5619354ba860 = "auto";
var $2b29df0662f1c8f3$export$aec2ce47c367b8c3 = [
    $2b29df0662f1c8f3$export$1e95b668f3b82d,
    $2b29df0662f1c8f3$export$40e543e69a8b3fbb,
    $2b29df0662f1c8f3$export$79ffe56a765070d2,
    $2b29df0662f1c8f3$export$eabcd2c8791e7bf4
];
var $2b29df0662f1c8f3$export$b3571188c770cc5a = "start";
var $2b29df0662f1c8f3$export$bd5df0f255a350f8 = "end";
var $2b29df0662f1c8f3$export$390fd549c5303b4d = "clippingParents";
var $2b29df0662f1c8f3$export$d7b7311ec04a3e8f = "viewport";
var $2b29df0662f1c8f3$export$ae5ab1c730825774 = "popper";
var $2b29df0662f1c8f3$export$ca50aac9f3ba507f = "reference";
var $2b29df0662f1c8f3$export$368f9a87e87fa4e1 = /*#__PURE__*/ $2b29df0662f1c8f3$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $2b29df0662f1c8f3$export$b3571188c770cc5a,
        placement + "-" + $2b29df0662f1c8f3$export$bd5df0f255a350f8
    ]);
}, []);
var $2b29df0662f1c8f3$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($2b29df0662f1c8f3$export$aec2ce47c367b8c3, [
    $2b29df0662f1c8f3$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $2b29df0662f1c8f3$export$b3571188c770cc5a,
        placement + "-" + $2b29df0662f1c8f3$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $2b29df0662f1c8f3$export$421679a7c3d56e = "beforeRead";
var $2b29df0662f1c8f3$export$aafa59e2e03f2942 = "read";
var $2b29df0662f1c8f3$export$6964f6c886723980 = "afterRead"; // pure-logic modifiers
var $2b29df0662f1c8f3$export$c65e99957a05207c = "beforeMain";
var $2b29df0662f1c8f3$export$f22da7240b7add18 = "main";
var $2b29df0662f1c8f3$export$bab79516f2d662fe = "afterMain"; // modifier with the purpose to write to the DOM (or write into a framework state)
var $2b29df0662f1c8f3$export$8d4d2d70e7d46032 = "beforeWrite";
var $2b29df0662f1c8f3$export$68d8715fc104d294 = "write";
var $2b29df0662f1c8f3$export$70a6e5159acce2e6 = "afterWrite";
var $2b29df0662f1c8f3$export$d087d3878fdf71d5 = [
    $2b29df0662f1c8f3$export$421679a7c3d56e,
    $2b29df0662f1c8f3$export$aafa59e2e03f2942,
    $2b29df0662f1c8f3$export$6964f6c886723980,
    $2b29df0662f1c8f3$export$c65e99957a05207c,
    $2b29df0662f1c8f3$export$f22da7240b7add18,
    $2b29df0662f1c8f3$export$bab79516f2d662fe,
    $2b29df0662f1c8f3$export$8d4d2d70e7d46032,
    $2b29df0662f1c8f3$export$68d8715fc104d294,
    $2b29df0662f1c8f3$export$70a6e5159acce2e6
];


function $54b8a507643b13d3$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $54b8a507643b13d3$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $54b8a507643b13d3$var$order(modifiers); // order based on phase
    return (0, $2b29df0662f1c8f3$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $d2df2c6d3de09dc9$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $285f2d379d0efda4$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $536e84e1b5bae7a0$var$DEFAULT_OPTIONS = {
    placement: "bottom",
    modifiers: [],
    strategy: "absolute"
};
function $536e84e1b5bae7a0$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === "function");
    });
}
function $536e84e1b5bae7a0$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $536e84e1b5bae7a0$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: "bottom",
            orderedModifiers: [],
            options: Object.assign({}, $536e84e1b5bae7a0$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var _$options = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, _$options);
                state.scrollParents = {
                    reference: (0, $37342f115357a5f9$export$45a5e7f76e0caa8d)(reference) ? (0, $66a5b8980a3365ae$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $66a5b8980a3365ae$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $66a5b8980a3365ae$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $54b8a507643b13d3$export$2e2bcd8739ae039)((0, $285f2d379d0efda4$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, _$reference = _state$elements.reference, _$popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$536e84e1b5bae7a0$var$areValidElements(_$reference, _$popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $3614e9488edad135$export$2e2bcd8739ae039)(_$reference, (0, $38d1a99ca0438f4b$export$2e2bcd8739ae039)(_$popper), state.options.strategy === "fixed"),
                    popper: (0, $31d574d36055a9b9$export$2e2bcd8739ae039)(_$popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === "function") state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $d2df2c6d3de09dc9$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$536e84e1b5bae7a0$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, _$options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === "function") {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: _$options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $536e84e1b5bae7a0$export$8f7491d57c8f97a9 = /*#__PURE__*/ $536e84e1b5bae7a0$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules



var $e1a78e59ebf959c0$var$passive = {
    passive: true
};
function $e1a78e59ebf959c0$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $d08ced4ab20d8cdc$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener("scroll", instance.update, $e1a78e59ebf959c0$var$passive);
    });
    if (resize) window.addEventListener("resize", instance.update, $e1a78e59ebf959c0$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener("scroll", instance.update, $e1a78e59ebf959c0$var$passive);
        });
        if (resize) window.removeEventListener("resize", instance.update, $e1a78e59ebf959c0$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $e1a78e59ebf959c0$export$2e2bcd8739ae039 = {
    name: "eventListeners",
    enabled: true,
    phase: "write",
    fn: function fn() {},
    effect: $e1a78e59ebf959c0$var$effect,
    data: {}
};



function $b869f8c99b914708$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[0];
}


function $161121c94a9f2845$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[1];
}


function $c64bde4fa68eb7aa$export$2e2bcd8739ae039(placement) {
    return [
        "top",
        "bottom"
    ].indexOf(placement) >= 0 ? "x" : "y";
}



function $18ab278ebe186aed$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $b869f8c99b914708$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $161121c94a9f2845$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $2b29df0662f1c8f3$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $2b29df0662f1c8f3$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $2b29df0662f1c8f3$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $2b29df0662f1c8f3$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $c64bde4fa68eb7aa$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === "y" ? "height" : "width";
        switch(variation){
            case 0, $2b29df0662f1c8f3$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $2b29df0662f1c8f3$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}


function $574dea146b1da3c1$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $18ab278ebe186aed$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: "absolute",
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $574dea146b1da3c1$export$2e2bcd8739ae039 = {
    name: "popperOffsets",
    enabled: true,
    phase: "read",
    fn: $574dea146b1da3c1$var$popperOffsets,
    data: {}
};










var $4fc0ef1d3b44c152$var$unsetSides = {
    top: "auto",
    right: "auto",
    bottom: "auto",
    left: "auto"
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $4fc0ef1d3b44c152$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $07c5006d2e8c7141$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $07c5006d2e8c7141$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $4fc0ef1d3b44c152$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === "function" ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty("x");
    var hasY = offsets.hasOwnProperty("y");
    var sideX = (0, $2b29df0662f1c8f3$export$eabcd2c8791e7bf4);
    var sideY = (0, $2b29df0662f1c8f3$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $38d1a99ca0438f4b$export$2e2bcd8739ae039)(popper);
        var heightProp = "clientHeight";
        var widthProp = "clientWidth";
        if (offsetParent === (0, $d08ced4ab20d8cdc$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $46cc2355984f7848$export$2e2bcd8739ae039)(popper);
            if ((0, $244ad8714f8d6c3b$export$2e2bcd8739ae039)(offsetParent).position !== "static" && position === "absolute") {
                heightProp = "scrollHeight";
                widthProp = "scrollWidth";
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $2b29df0662f1c8f3$export$1e95b668f3b82d) || (placement === (0, $2b29df0662f1c8f3$export$eabcd2c8791e7bf4) || placement === (0, $2b29df0662f1c8f3$export$79ffe56a765070d2)) && variation === (0, $2b29df0662f1c8f3$export$bd5df0f255a350f8)) {
            sideY = (0, $2b29df0662f1c8f3$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $2b29df0662f1c8f3$export$eabcd2c8791e7bf4) || (placement === (0, $2b29df0662f1c8f3$export$1e95b668f3b82d) || placement === (0, $2b29df0662f1c8f3$export$40e543e69a8b3fbb)) && variation === (0, $2b29df0662f1c8f3$export$bd5df0f255a350f8)) {
            sideX = (0, $2b29df0662f1c8f3$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $4fc0ef1d3b44c152$var$unsetSides);
    var _ref4 = roundOffsets === true ? $4fc0ef1d3b44c152$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $d08ced4ab20d8cdc$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : "", _Object$assign2[sideX] = hasX ? x + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function $4fc0ef1d3b44c152$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $b869f8c99b914708$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $161121c94a9f2845$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === "fixed"
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $4fc0ef1d3b44c152$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $4fc0ef1d3b44c152$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: "absolute",
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-placement": state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $4fc0ef1d3b44c152$export$2e2bcd8739ae039 = {
    name: "computeStyles",
    enabled: true,
    phase: "beforeWrite",
    fn: $4fc0ef1d3b44c152$var$computeStyles,
    data: {}
};





function $b2ee5bf5ded341ca$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $b869f8c99b914708$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $2b29df0662f1c8f3$export$eabcd2c8791e7bf4),
        (0, $2b29df0662f1c8f3$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === "function" ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $2b29df0662f1c8f3$export$eabcd2c8791e7bf4),
        (0, $2b29df0662f1c8f3$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $b2ee5bf5ded341ca$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, _$offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $2b29df0662f1c8f3$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $b2ee5bf5ded341ca$export$7fa02d8595b015ed(placement, state.rects, _$offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $b2ee5bf5ded341ca$export$2e2bcd8739ae039 = {
    name: "offset",
    enabled: true,
    phase: "main",
    requires: [
        "popperOffsets"
    ],
    fn: $b2ee5bf5ded341ca$var$offset
};


var $fc9d2b8f3f3fb67e$var$hash = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $fc9d2b8f3f3fb67e$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $fc9d2b8f3f3fb67e$var$hash[matched];
    });
}



var $037f4bf43d8d0ee9$var$hash = {
    start: "end",
    end: "start"
};
function $037f4bf43d8d0ee9$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $037f4bf43d8d0ee9$var$hash[matched];
    });
}







function $5c267d573d587844$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $d08ced4ab20d8cdc$export$2e2bcd8739ae039)(element);
    var html = (0, $46cc2355984f7848$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $a8715e4396904aaf$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $71cc84f70812b973$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $0c3e0e212b501780$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $46cc2355984f7848$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $0d021f0ecdfec985$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $07c5006d2e8c7141$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $07c5006d2e8c7141$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $71cc84f70812b973$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $244ad8714f8d6c3b$export$2e2bcd8739ae039)(body || html).direction === "rtl") x += (0, $07c5006d2e8c7141$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}










function $65fff59a4feedd17$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $37342f115357a5f9$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}



function $5c8ef01fc212eb99$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $1ecd6fe68e5461a0$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $9a52929460d1edc5$export$2e2bcd8739ae039)(element, false, strategy === "fixed");
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $1ecd6fe68e5461a0$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $2b29df0662f1c8f3$export$d7b7311ec04a3e8f) ? (0, $5c8ef01fc212eb99$export$2e2bcd8739ae039)((0, $5c267d573d587844$export$2e2bcd8739ae039)(element, strategy)) : (0, $37342f115357a5f9$export$45a5e7f76e0caa8d)(clippingParent) ? $1ecd6fe68e5461a0$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $5c8ef01fc212eb99$export$2e2bcd8739ae039)((0, $0c3e0e212b501780$export$2e2bcd8739ae039)((0, $46cc2355984f7848$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $1ecd6fe68e5461a0$var$getClippingParents(element) {
    var clippingParents = (0, $66a5b8980a3365ae$export$2e2bcd8739ae039)((0, $58c6b831f18390f0$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        "absolute",
        "fixed"
    ].indexOf((0, $244ad8714f8d6c3b$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $37342f115357a5f9$export$1b3bfaa9684536aa)(element) ? (0, $38d1a99ca0438f4b$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $37342f115357a5f9$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $37342f115357a5f9$export$45a5e7f76e0caa8d)(clippingParent) && (0, $65fff59a4feedd17$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $548bef829b42ccaa$export$2e2bcd8739ae039)(clippingParent) !== "body";
    });
} // Gets the maximum area that the element is visible in due to any number of
function $1ecd6fe68e5461a0$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === "clippingParents" ? $1ecd6fe68e5461a0$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $1ecd6fe68e5461a0$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $07c5006d2e8c7141$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $07c5006d2e8c7141$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $07c5006d2e8c7141$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $07c5006d2e8c7141$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $1ecd6fe68e5461a0$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $4c54f799bb575780$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $0108c99d6009667f$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $4c54f799bb575780$export$2e2bcd8739ae039)(), paddingObject);
}


function $ded4a29519059833$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}


function $51d9a6ab358c0b1c$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $2b29df0662f1c8f3$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $2b29df0662f1c8f3$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $2b29df0662f1c8f3$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $0108c99d6009667f$export$2e2bcd8739ae039)(typeof padding !== "number" ? padding : (0, $ded4a29519059833$export$2e2bcd8739ae039)(padding, (0, $2b29df0662f1c8f3$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $2b29df0662f1c8f3$export$ae5ab1c730825774) ? (0, $2b29df0662f1c8f3$export$ca50aac9f3ba507f) : (0, $2b29df0662f1c8f3$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $1ecd6fe68e5461a0$export$2e2bcd8739ae039)((0, $37342f115357a5f9$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $46cc2355984f7848$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $9a52929460d1edc5$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $18ab278ebe186aed$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: "absolute",
        placement: placement
    });
    var popperClientRect = (0, $5c8ef01fc212eb99$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $2b29df0662f1c8f3$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $2b29df0662f1c8f3$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $2b29df0662f1c8f3$export$79ffe56a765070d2),
                (0, $2b29df0662f1c8f3$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $2b29df0662f1c8f3$export$1e95b668f3b82d),
                (0, $2b29df0662f1c8f3$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? "y" : "x";
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $09b59ac8a017642e$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $2b29df0662f1c8f3$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $161121c94a9f2845$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $2b29df0662f1c8f3$export$368f9a87e87fa4e1) : (0, $2b29df0662f1c8f3$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $161121c94a9f2845$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $2b29df0662f1c8f3$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $51d9a6ab358c0b1c$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $b869f8c99b914708$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $d47834a88a5447f9$var$getExpandedFallbackPlacements(placement) {
    if ((0, $b869f8c99b914708$export$2e2bcd8739ae039)(placement) === (0, $2b29df0662f1c8f3$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $fc9d2b8f3f3fb67e$export$2e2bcd8739ae039)(placement);
    return [
        (0, $037f4bf43d8d0ee9$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $037f4bf43d8d0ee9$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $d47834a88a5447f9$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $b869f8c99b914708$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $fc9d2b8f3f3fb67e$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $d47834a88a5447f9$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $b869f8c99b914708$export$2e2bcd8739ae039)(placement) === (0, $2b29df0662f1c8f3$export$dfb5619354ba860) ? (0, $09b59ac8a017642e$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $b869f8c99b914708$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $161121c94a9f2845$export$2e2bcd8739ae039)(placement) === (0, $2b29df0662f1c8f3$export$b3571188c770cc5a);
        var isVertical = [
            (0, $2b29df0662f1c8f3$export$1e95b668f3b82d),
            (0, $2b29df0662f1c8f3$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? "width" : "height";
        var overflow = (0, $51d9a6ab358c0b1c$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $2b29df0662f1c8f3$export$79ffe56a765070d2) : (0, $2b29df0662f1c8f3$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $2b29df0662f1c8f3$export$40e543e69a8b3fbb) : (0, $2b29df0662f1c8f3$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $fc9d2b8f3f3fb67e$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $fc9d2b8f3f3fb67e$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $d47834a88a5447f9$export$2e2bcd8739ae039 = {
    name: "flip",
    enabled: true,
    phase: "main",
    fn: $d47834a88a5447f9$var$flip,
    requiresIfExists: [
        "offset"
    ],
    data: {
        _skip: false
    }
};





function $ff2882cade01e84b$export$2e2bcd8739ae039(axis) {
    return axis === "x" ? "y" : "x";
}



function $d33c4d388f71e5ef$export$f28d906d67a997f3(min, value, max) {
    return (0, $07c5006d2e8c7141$export$8960430cfd85939f)(min, (0, $07c5006d2e8c7141$export$96ec731ed4dcb222)(value, max));
}
function $d33c4d388f71e5ef$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $d33c4d388f71e5ef$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}








function $09ce190787cf8f95$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $51d9a6ab358c0b1c$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $b869f8c99b914708$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $161121c94a9f2845$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $c64bde4fa68eb7aa$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $ff2882cade01e84b$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === "function" ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === "number" ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === "y" ? (0, $2b29df0662f1c8f3$export$1e95b668f3b82d) : (0, $2b29df0662f1c8f3$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === "y" ? (0, $2b29df0662f1c8f3$export$40e543e69a8b3fbb) : (0, $2b29df0662f1c8f3$export$79ffe56a765070d2);
        var len = mainAxis === "y" ? "height" : "width";
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $2b29df0662f1c8f3$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $2b29df0662f1c8f3$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $31d574d36055a9b9$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData["arrow#persistent"] ? state.modifiersData["arrow#persistent"].padding : (0, $4c54f799bb575780$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $d33c4d388f71e5ef$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $38d1a99ca0438f4b$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === "y" ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $d33c4d388f71e5ef$export$f28d906d67a997f3)(tether ? (0, $07c5006d2e8c7141$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $07c5006d2e8c7141$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === "x" ? (0, $2b29df0662f1c8f3$export$1e95b668f3b82d) : (0, $2b29df0662f1c8f3$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === "x" ? (0, $2b29df0662f1c8f3$export$40e543e69a8b3fbb) : (0, $2b29df0662f1c8f3$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === "y" ? "height" : "width";
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $2b29df0662f1c8f3$export$1e95b668f3b82d),
            (0, $2b29df0662f1c8f3$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $d33c4d388f71e5ef$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $d33c4d388f71e5ef$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $09ce190787cf8f95$export$2e2bcd8739ae039 = {
    name: "preventOverflow",
    enabled: true,
    phase: "main",
    fn: $09ce190787cf8f95$var$preventOverflow,
    requiresIfExists: [
        "offset"
    ]
};











var $85c6a746641bfa46$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === "function" ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $0108c99d6009667f$export$2e2bcd8739ae039)(typeof padding !== "number" ? padding : (0, $ded4a29519059833$export$2e2bcd8739ae039)(padding, (0, $2b29df0662f1c8f3$export$aec2ce47c367b8c3)));
};
function $85c6a746641bfa46$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $b869f8c99b914708$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $c64bde4fa68eb7aa$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $2b29df0662f1c8f3$export$eabcd2c8791e7bf4),
        (0, $2b29df0662f1c8f3$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? "height" : "width";
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $85c6a746641bfa46$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $31d574d36055a9b9$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === "y" ? (0, $2b29df0662f1c8f3$export$1e95b668f3b82d) : (0, $2b29df0662f1c8f3$export$eabcd2c8791e7bf4);
    var maxProp = axis === "y" ? (0, $2b29df0662f1c8f3$export$40e543e69a8b3fbb) : (0, $2b29df0662f1c8f3$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $38d1a99ca0438f4b$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $d33c4d388f71e5ef$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $85c6a746641bfa46$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? "[data-popper-arrow]" : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === "string") {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $65fff59a4feedd17$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $85c6a746641bfa46$export$2e2bcd8739ae039 = {
    name: "arrow",
    enabled: true,
    phase: "main",
    fn: $85c6a746641bfa46$var$arrow,
    effect: $85c6a746641bfa46$var$effect,
    requires: [
        "popperOffsets"
    ],
    requiresIfExists: [
        "preventOverflow"
    ]
};




function $53f892048421f5d7$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $53f892048421f5d7$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $2b29df0662f1c8f3$export$1e95b668f3b82d),
        (0, $2b29df0662f1c8f3$export$79ffe56a765070d2),
        (0, $2b29df0662f1c8f3$export$40e543e69a8b3fbb),
        (0, $2b29df0662f1c8f3$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $53f892048421f5d7$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $51d9a6ab358c0b1c$export$2e2bcd8739ae039)(state, {
        elementContext: "reference"
    });
    var popperAltOverflow = (0, $51d9a6ab358c0b1c$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $53f892048421f5d7$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $53f892048421f5d7$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $53f892048421f5d7$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $53f892048421f5d7$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-reference-hidden": isReferenceHidden,
        "data-popper-escaped": hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $53f892048421f5d7$export$2e2bcd8739ae039 = {
    name: "hide",
    enabled: true,
    phase: "main",
    requiresIfExists: [
        "preventOverflow"
    ],
    fn: $53f892048421f5d7$var$hide
};




var $edce1af7373226a3$export$d34966752335dd47 = [
    (0, $e1a78e59ebf959c0$export$2e2bcd8739ae039),
    (0, $574dea146b1da3c1$export$2e2bcd8739ae039),
    (0, $4fc0ef1d3b44c152$export$2e2bcd8739ae039),
    (0, $a0a31010a3a047b1$export$2e2bcd8739ae039),
    (0, $b2ee5bf5ded341ca$export$2e2bcd8739ae039),
    (0, $d47834a88a5447f9$export$2e2bcd8739ae039),
    (0, $09ce190787cf8f95$export$2e2bcd8739ae039),
    (0, $85c6a746641bfa46$export$2e2bcd8739ae039),
    (0, $53f892048421f5d7$export$2e2bcd8739ae039)
];
var $edce1af7373226a3$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $536e84e1b5bae7a0$export$ed5e13716264f202)({
    defaultModifiers: $edce1af7373226a3$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules


var $359fbeb1ed9cb77a$export$c96c811c44a42da5 = '<svg width="16" height="6" xmlns="http://www.w3.org/2000/svg"><path d="M0 6s1.796-.013 4.67-3.615C5.851.9 6.93.006 8 0c1.07-.006 2.148.887 3.343 2.385C14.233 6.005 16 6 16 6H0z"></svg>';
var $359fbeb1ed9cb77a$var$BOX_CLASS = "tippy-box";
var $359fbeb1ed9cb77a$var$CONTENT_CLASS = "tippy-content";
var $359fbeb1ed9cb77a$var$BACKDROP_CLASS = "tippy-backdrop";
var $359fbeb1ed9cb77a$var$ARROW_CLASS = "tippy-arrow";
var $359fbeb1ed9cb77a$var$SVG_ARROW_CLASS = "tippy-svg-arrow";
var $359fbeb1ed9cb77a$var$TOUCH_OPTIONS = {
    passive: true,
    capture: true
};
var $359fbeb1ed9cb77a$var$TIPPY_DEFAULT_APPEND_TO = function TIPPY_DEFAULT_APPEND_TO() {
    return document.body;
};
function $359fbeb1ed9cb77a$var$hasOwnProperty(obj, key) {
    return ({}).hasOwnProperty.call(obj, key);
}
function $359fbeb1ed9cb77a$var$getValueAtIndexOrReturn(value, index, defaultValue) {
    if (Array.isArray(value)) {
        var v = value[index];
        return v == null ? Array.isArray(defaultValue) ? defaultValue[index] : defaultValue : v;
    }
    return value;
}
function $359fbeb1ed9cb77a$var$isType(value, type) {
    var str = ({}).toString.call(value);
    return str.indexOf("[object") === 0 && str.indexOf(type + "]") > -1;
}
function $359fbeb1ed9cb77a$var$invokeWithArgsOrReturn(value, args) {
    return typeof value === "function" ? value.apply(void 0, args) : value;
}
function $359fbeb1ed9cb77a$var$debounce(fn, ms) {
    // Avoid wrapping in `setTimeout` if ms is 0 anyway
    if (ms === 0) return fn;
    var timeout;
    return function(arg) {
        clearTimeout(timeout);
        timeout = setTimeout(function() {
            fn(arg);
        }, ms);
    };
}
function $359fbeb1ed9cb77a$var$removeProperties(obj, keys) {
    var clone = Object.assign({}, obj);
    keys.forEach(function(key) {
        delete clone[key];
    });
    return clone;
}
function $359fbeb1ed9cb77a$var$splitBySpaces(value) {
    return value.split(/\s+/).filter(Boolean);
}
function $359fbeb1ed9cb77a$var$normalizeToArray(value) {
    return [].concat(value);
}
function $359fbeb1ed9cb77a$var$pushIfUnique(arr, value) {
    if (arr.indexOf(value) === -1) arr.push(value);
}
function $359fbeb1ed9cb77a$var$unique(arr) {
    return arr.filter(function(item, index) {
        return arr.indexOf(item) === index;
    });
}
function $359fbeb1ed9cb77a$var$getBasePlacement(placement) {
    return placement.split("-")[0];
}
function $359fbeb1ed9cb77a$var$arrayFrom(value) {
    return [].slice.call(value);
}
function $359fbeb1ed9cb77a$var$removeUndefinedProps(obj) {
    return Object.keys(obj).reduce(function(acc, key) {
        if (obj[key] !== undefined) acc[key] = obj[key];
        return acc;
    }, {});
}
function $359fbeb1ed9cb77a$var$div() {
    return document.createElement("div");
}
function $359fbeb1ed9cb77a$var$isElement(value) {
    return [
        "Element",
        "Fragment"
    ].some(function(type) {
        return $359fbeb1ed9cb77a$var$isType(value, type);
    });
}
function $359fbeb1ed9cb77a$var$isNodeList(value) {
    return $359fbeb1ed9cb77a$var$isType(value, "NodeList");
}
function $359fbeb1ed9cb77a$var$isMouseEvent(value) {
    return $359fbeb1ed9cb77a$var$isType(value, "MouseEvent");
}
function $359fbeb1ed9cb77a$var$isReferenceElement(value) {
    return !!(value && value._tippy && value._tippy.reference === value);
}
function $359fbeb1ed9cb77a$var$getArrayOfElements(value) {
    if ($359fbeb1ed9cb77a$var$isElement(value)) return [
        value
    ];
    if ($359fbeb1ed9cb77a$var$isNodeList(value)) return $359fbeb1ed9cb77a$var$arrayFrom(value);
    if (Array.isArray(value)) return value;
    return $359fbeb1ed9cb77a$var$arrayFrom(document.querySelectorAll(value));
}
function $359fbeb1ed9cb77a$var$setTransitionDuration(els, value) {
    els.forEach(function(el) {
        if (el) el.style.transitionDuration = value + "ms";
    });
}
function $359fbeb1ed9cb77a$var$setVisibilityState(els, state) {
    els.forEach(function(el) {
        if (el) el.setAttribute("data-state", state);
    });
}
function $359fbeb1ed9cb77a$var$getOwnerDocument(elementOrElements) {
    var _element$ownerDocumen;
    var _normalizeToArray = $359fbeb1ed9cb77a$var$normalizeToArray(elementOrElements), element = _normalizeToArray[0]; // Elements created via a <template> have an ownerDocument with no reference to the body
    return element != null && (_element$ownerDocumen = element.ownerDocument) != null && _element$ownerDocumen.body ? element.ownerDocument : document;
}
function $359fbeb1ed9cb77a$var$isCursorOutsideInteractiveBorder(popperTreeData, event) {
    var clientX = event.clientX, clientY = event.clientY;
    return popperTreeData.every(function(_ref) {
        var popperRect = _ref.popperRect, popperState = _ref.popperState, props = _ref.props;
        var interactiveBorder = props.interactiveBorder;
        var basePlacement = $359fbeb1ed9cb77a$var$getBasePlacement(popperState.placement);
        var offsetData = popperState.modifiersData.offset;
        if (!offsetData) return true;
        var topDistance = basePlacement === "bottom" ? offsetData.top.y : 0;
        var bottomDistance = basePlacement === "top" ? offsetData.bottom.y : 0;
        var leftDistance = basePlacement === "right" ? offsetData.left.x : 0;
        var rightDistance = basePlacement === "left" ? offsetData.right.x : 0;
        var exceedsTop = popperRect.top - clientY + topDistance > interactiveBorder;
        var exceedsBottom = clientY - popperRect.bottom - bottomDistance > interactiveBorder;
        var exceedsLeft = popperRect.left - clientX + leftDistance > interactiveBorder;
        var exceedsRight = clientX - popperRect.right - rightDistance > interactiveBorder;
        return exceedsTop || exceedsBottom || exceedsLeft || exceedsRight;
    });
}
function $359fbeb1ed9cb77a$var$updateTransitionEndListener(box, action, listener) {
    var method = action + "EventListener"; // some browsers apparently support `transition` (unprefixed) but only fire
    // `webkitTransitionEnd`...
    [
        "transitionend",
        "webkitTransitionEnd"
    ].forEach(function(event) {
        box[method](event, listener);
    });
}
/**
 * Compared to xxx.contains, this function works for dom structures with shadow
 * dom
 */ function $359fbeb1ed9cb77a$var$actualContains(parent, child) {
    var target = child;
    while(target){
        var _target$getRootNode;
        if (parent.contains(target)) return true;
        target = target.getRootNode == null ? void 0 : (_target$getRootNode = target.getRootNode()) == null ? void 0 : _target$getRootNode.host;
    }
    return false;
}
var $359fbeb1ed9cb77a$var$currentInput = {
    isTouch: false
};
var $359fbeb1ed9cb77a$var$lastMouseMoveTime = 0;
/**
 * When a `touchstart` event is fired, it's assumed the user is using touch
 * input. We'll bind a `mousemove` event listener to listen for mouse input in
 * the future. This way, the `isTouch` property is fully dynamic and will handle
 * hybrid devices that use a mix of touch + mouse input.
 */ function $359fbeb1ed9cb77a$var$onDocumentTouchStart() {
    if ($359fbeb1ed9cb77a$var$currentInput.isTouch) return;
    $359fbeb1ed9cb77a$var$currentInput.isTouch = true;
    if (window.performance) document.addEventListener("mousemove", $359fbeb1ed9cb77a$var$onDocumentMouseMove);
}
/**
 * When two `mousemove` event are fired consecutively within 20ms, it's assumed
 * the user is using mouse input again. `mousemove` can fire on touch devices as
 * well, but very rarely that quickly.
 */ function $359fbeb1ed9cb77a$var$onDocumentMouseMove() {
    var now = performance.now();
    if (now - $359fbeb1ed9cb77a$var$lastMouseMoveTime < 20) {
        $359fbeb1ed9cb77a$var$currentInput.isTouch = false;
        document.removeEventListener("mousemove", $359fbeb1ed9cb77a$var$onDocumentMouseMove);
    }
    $359fbeb1ed9cb77a$var$lastMouseMoveTime = now;
}
/**
 * When an element is in focus and has a tippy, leaving the tab/window and
 * returning causes it to show again. For mouse users this is unexpected, but
 * for keyboard use it makes sense.
 * TODO: find a better technique to solve this problem
 */ function $359fbeb1ed9cb77a$var$onWindowBlur() {
    var activeElement = document.activeElement;
    if ($359fbeb1ed9cb77a$var$isReferenceElement(activeElement)) {
        var instance = activeElement._tippy;
        if (activeElement.blur && !instance.state.isVisible) activeElement.blur();
    }
}
function $359fbeb1ed9cb77a$var$bindGlobalEventListeners() {
    document.addEventListener("touchstart", $359fbeb1ed9cb77a$var$onDocumentTouchStart, $359fbeb1ed9cb77a$var$TOUCH_OPTIONS);
    window.addEventListener("blur", $359fbeb1ed9cb77a$var$onWindowBlur);
}
var $359fbeb1ed9cb77a$var$isBrowser = typeof window !== "undefined" && typeof document !== "undefined";
var $359fbeb1ed9cb77a$var$isIE11 = $359fbeb1ed9cb77a$var$isBrowser ? !!window.msCrypto : false;
function $359fbeb1ed9cb77a$var$createMemoryLeakWarning(method) {
    var txt = method === "destroy" ? "n already-" : " ";
    return [
        method + "() was called on a" + txt + "destroyed instance. This is a no-op but",
        "indicates a potential memory leak."
    ].join(" ");
}
function $359fbeb1ed9cb77a$var$clean(value) {
    var spacesAndTabs = /[ \t]{2,}/g;
    var lineStartWithSpaces = /^[ \t]*/gm;
    return value.replace(spacesAndTabs, " ").replace(lineStartWithSpaces, "").trim();
}
function $359fbeb1ed9cb77a$var$getDevMessage(message) {
    return $359fbeb1ed9cb77a$var$clean("\n  %ctippy.js\n\n  %c" + $359fbeb1ed9cb77a$var$clean(message) + "\n\n  %c\uD83D\uDC77\u200D This is a development-only message. It will be removed in production.\n  ");
}
function $359fbeb1ed9cb77a$var$getFormattedMessage(message) {
    return [
        $359fbeb1ed9cb77a$var$getDevMessage(message),
        "color: #00C584; font-size: 1.3em; font-weight: bold;",
        "line-height: 1.5",
        "color: #a6a095;"
    ];
} // Assume warnings and errors never have the same message
var $359fbeb1ed9cb77a$var$visitedMessages;
function $359fbeb1ed9cb77a$var$resetVisitedMessages() {
    $359fbeb1ed9cb77a$var$visitedMessages = new Set();
}
function $359fbeb1ed9cb77a$var$warnWhen(condition, message) {
    if (condition && !$359fbeb1ed9cb77a$var$visitedMessages.has(message)) {
        var _console;
        $359fbeb1ed9cb77a$var$visitedMessages.add(message);
        (_console = console).warn.apply(_console, $359fbeb1ed9cb77a$var$getFormattedMessage(message));
    }
}
function $359fbeb1ed9cb77a$var$errorWhen(condition, message) {
    if (condition && !$359fbeb1ed9cb77a$var$visitedMessages.has(message)) {
        var _console2;
        $359fbeb1ed9cb77a$var$visitedMessages.add(message);
        (_console2 = console).error.apply(_console2, $359fbeb1ed9cb77a$var$getFormattedMessage(message));
    }
}
function $359fbeb1ed9cb77a$var$validateTargets(targets) {
    var didPassFalsyValue = !targets;
    var didPassPlainObject = Object.prototype.toString.call(targets) === "[object Object]" && !targets.addEventListener;
    $359fbeb1ed9cb77a$var$errorWhen(didPassFalsyValue, [
        "tippy() was passed",
        "`" + String(targets) + "`",
        "as its targets (first) argument. Valid types are: String, Element,",
        "Element[], or NodeList."
    ].join(" "));
    $359fbeb1ed9cb77a$var$errorWhen(didPassPlainObject, [
        "tippy() was passed a plain object which is not supported as an argument",
        "for virtual positioning. Use props.getReferenceClientRect instead."
    ].join(" "));
}
var $359fbeb1ed9cb77a$var$pluginProps = {
    animateFill: false,
    followCursor: false,
    inlinePositioning: false,
    sticky: false
};
var $359fbeb1ed9cb77a$var$renderProps = {
    allowHTML: false,
    animation: "fade",
    arrow: true,
    content: "",
    inertia: false,
    maxWidth: 350,
    role: "tooltip",
    theme: "",
    zIndex: 9999
};
var $359fbeb1ed9cb77a$var$defaultProps = Object.assign({
    appendTo: $359fbeb1ed9cb77a$var$TIPPY_DEFAULT_APPEND_TO,
    aria: {
        content: "auto",
        expanded: "auto"
    },
    delay: 0,
    duration: [
        300,
        250
    ],
    getReferenceClientRect: null,
    hideOnClick: true,
    ignoreAttributes: false,
    interactive: false,
    interactiveBorder: 2,
    interactiveDebounce: 0,
    moveTransition: "",
    offset: [
        0,
        10
    ],
    onAfterUpdate: function onAfterUpdate() {},
    onBeforeUpdate: function onBeforeUpdate() {},
    onCreate: function onCreate() {},
    onDestroy: function onDestroy() {},
    onHidden: function onHidden() {},
    onHide: function onHide() {},
    onMount: function onMount() {},
    onShow: function onShow() {},
    onShown: function onShown() {},
    onTrigger: function onTrigger() {},
    onUntrigger: function onUntrigger() {},
    onClickOutside: function onClickOutside() {},
    placement: "top",
    plugins: [],
    popperOptions: {},
    render: null,
    showOnCreate: false,
    touch: true,
    trigger: "mouseenter focus",
    triggerTarget: null
}, $359fbeb1ed9cb77a$var$pluginProps, $359fbeb1ed9cb77a$var$renderProps);
var $359fbeb1ed9cb77a$var$defaultKeys = Object.keys($359fbeb1ed9cb77a$var$defaultProps);
var $359fbeb1ed9cb77a$var$setDefaultProps = function setDefaultProps(partialProps) {
    var keys = Object.keys(partialProps);
    keys.forEach(function(key) {
        $359fbeb1ed9cb77a$var$defaultProps[key] = partialProps[key];
    });
};
function $359fbeb1ed9cb77a$var$getExtendedPassedProps(passedProps) {
    var plugins = passedProps.plugins || [];
    var pluginProps = plugins.reduce(function(acc, plugin) {
        var name = plugin.name, defaultValue = plugin.defaultValue;
        if (name) {
            var _name;
            acc[name] = passedProps[name] !== undefined ? passedProps[name] : (_name = $359fbeb1ed9cb77a$var$defaultProps[name]) != null ? _name : defaultValue;
        }
        return acc;
    }, {});
    return Object.assign({}, passedProps, pluginProps);
}
function $359fbeb1ed9cb77a$var$getDataAttributeProps(reference, plugins) {
    var propKeys = plugins ? Object.keys($359fbeb1ed9cb77a$var$getExtendedPassedProps(Object.assign({}, $359fbeb1ed9cb77a$var$defaultProps, {
        plugins: plugins
    }))) : $359fbeb1ed9cb77a$var$defaultKeys;
    var props = propKeys.reduce(function(acc, key) {
        var valueAsString = (reference.getAttribute("data-tippy-" + key) || "").trim();
        if (!valueAsString) return acc;
        if (key === "content") acc[key] = valueAsString;
        else try {
            acc[key] = JSON.parse(valueAsString);
        } catch (e) {
            acc[key] = valueAsString;
        }
        return acc;
    }, {});
    return props;
}
function $359fbeb1ed9cb77a$var$evaluateProps(reference, props) {
    var out = Object.assign({}, props, {
        content: $359fbeb1ed9cb77a$var$invokeWithArgsOrReturn(props.content, [
            reference
        ])
    }, props.ignoreAttributes ? {} : $359fbeb1ed9cb77a$var$getDataAttributeProps(reference, props.plugins));
    out.aria = Object.assign({}, $359fbeb1ed9cb77a$var$defaultProps.aria, out.aria);
    out.aria = {
        expanded: out.aria.expanded === "auto" ? props.interactive : out.aria.expanded,
        content: out.aria.content === "auto" ? props.interactive ? null : "describedby" : out.aria.content
    };
    return out;
}
function $359fbeb1ed9cb77a$var$validateProps(partialProps, plugins) {
    if (partialProps === void 0) partialProps = {};
    if (plugins === void 0) plugins = [];
    var keys = Object.keys(partialProps);
    keys.forEach(function(prop) {
        var nonPluginProps = $359fbeb1ed9cb77a$var$removeProperties($359fbeb1ed9cb77a$var$defaultProps, Object.keys($359fbeb1ed9cb77a$var$pluginProps));
        var didPassUnknownProp = !$359fbeb1ed9cb77a$var$hasOwnProperty(nonPluginProps, prop); // Check if the prop exists in `plugins`
        if (didPassUnknownProp) didPassUnknownProp = plugins.filter(function(plugin) {
            return plugin.name === prop;
        }).length === 0;
        $359fbeb1ed9cb77a$var$warnWhen(didPassUnknownProp, [
            "`" + prop + "`",
            "is not a valid prop. You may have spelled it incorrectly, or if it's",
            "a plugin, forgot to pass it in an array as props.plugins.",
            "\n\n",
            "All props: https://atomiks.github.io/tippyjs/v6/all-props/\n",
            "Plugins: https://atomiks.github.io/tippyjs/v6/plugins/"
        ].join(" "));
    });
}
var $359fbeb1ed9cb77a$var$innerHTML = function innerHTML() {
    return "innerHTML";
};
function $359fbeb1ed9cb77a$var$dangerouslySetInnerHTML(element, html) {
    element[$359fbeb1ed9cb77a$var$innerHTML()] = html;
}
function $359fbeb1ed9cb77a$var$createArrowElement(value) {
    var arrow = $359fbeb1ed9cb77a$var$div();
    if (value === true) arrow.className = $359fbeb1ed9cb77a$var$ARROW_CLASS;
    else {
        arrow.className = $359fbeb1ed9cb77a$var$SVG_ARROW_CLASS;
        if ($359fbeb1ed9cb77a$var$isElement(value)) arrow.appendChild(value);
        else $359fbeb1ed9cb77a$var$dangerouslySetInnerHTML(arrow, value);
    }
    return arrow;
}
function $359fbeb1ed9cb77a$var$setContent(content, props) {
    if ($359fbeb1ed9cb77a$var$isElement(props.content)) {
        $359fbeb1ed9cb77a$var$dangerouslySetInnerHTML(content, "");
        content.appendChild(props.content);
    } else if (typeof props.content !== "function") {
        if (props.allowHTML) $359fbeb1ed9cb77a$var$dangerouslySetInnerHTML(content, props.content);
        else content.textContent = props.content;
    }
}
function $359fbeb1ed9cb77a$var$getChildren(popper) {
    var box = popper.firstElementChild;
    var boxChildren = $359fbeb1ed9cb77a$var$arrayFrom(box.children);
    return {
        box: box,
        content: boxChildren.find(function(node) {
            return node.classList.contains($359fbeb1ed9cb77a$var$CONTENT_CLASS);
        }),
        arrow: boxChildren.find(function(node) {
            return node.classList.contains($359fbeb1ed9cb77a$var$ARROW_CLASS) || node.classList.contains($359fbeb1ed9cb77a$var$SVG_ARROW_CLASS);
        }),
        backdrop: boxChildren.find(function(node) {
            return node.classList.contains($359fbeb1ed9cb77a$var$BACKDROP_CLASS);
        })
    };
}
function $359fbeb1ed9cb77a$var$render(instance) {
    var popper = $359fbeb1ed9cb77a$var$div();
    var box = $359fbeb1ed9cb77a$var$div();
    box.className = $359fbeb1ed9cb77a$var$BOX_CLASS;
    box.setAttribute("data-state", "hidden");
    box.setAttribute("tabindex", "-1");
    var content = $359fbeb1ed9cb77a$var$div();
    content.className = $359fbeb1ed9cb77a$var$CONTENT_CLASS;
    content.setAttribute("data-state", "hidden");
    $359fbeb1ed9cb77a$var$setContent(content, instance.props);
    popper.appendChild(box);
    box.appendChild(content);
    onUpdate(instance.props, instance.props);
    function onUpdate(prevProps, nextProps) {
        var _getChildren = $359fbeb1ed9cb77a$var$getChildren(popper), box = _getChildren.box, content = _getChildren.content, arrow = _getChildren.arrow;
        if (nextProps.theme) box.setAttribute("data-theme", nextProps.theme);
        else box.removeAttribute("data-theme");
        if (typeof nextProps.animation === "string") box.setAttribute("data-animation", nextProps.animation);
        else box.removeAttribute("data-animation");
        if (nextProps.inertia) box.setAttribute("data-inertia", "");
        else box.removeAttribute("data-inertia");
        box.style.maxWidth = typeof nextProps.maxWidth === "number" ? nextProps.maxWidth + "px" : nextProps.maxWidth;
        if (nextProps.role) box.setAttribute("role", nextProps.role);
        else box.removeAttribute("role");
        if (prevProps.content !== nextProps.content || prevProps.allowHTML !== nextProps.allowHTML) $359fbeb1ed9cb77a$var$setContent(content, instance.props);
        if (nextProps.arrow) {
            if (!arrow) box.appendChild($359fbeb1ed9cb77a$var$createArrowElement(nextProps.arrow));
            else if (prevProps.arrow !== nextProps.arrow) {
                box.removeChild(arrow);
                box.appendChild($359fbeb1ed9cb77a$var$createArrowElement(nextProps.arrow));
            }
        } else if (arrow) box.removeChild(arrow);
    }
    return {
        popper: popper,
        onUpdate: onUpdate
    };
} // Runtime check to identify if the render function is the default one; this
// way we can apply default CSS transitions logic and it can be tree-shaken away
$359fbeb1ed9cb77a$var$render.$$tippy = true;
var $359fbeb1ed9cb77a$var$idCounter = 1;
var $359fbeb1ed9cb77a$var$mouseMoveListeners = []; // Used by `hideAll()`
var $359fbeb1ed9cb77a$var$mountedInstances = [];
function $359fbeb1ed9cb77a$var$createTippy(reference, passedProps) {
    var props = $359fbeb1ed9cb77a$var$evaluateProps(reference, Object.assign({}, $359fbeb1ed9cb77a$var$defaultProps, $359fbeb1ed9cb77a$var$getExtendedPassedProps($359fbeb1ed9cb77a$var$removeUndefinedProps(passedProps)))); // ===========================================================================
    // 🔒 Private members
    // ===========================================================================
    var showTimeout;
    var hideTimeout;
    var scheduleHideAnimationFrame;
    var isVisibleFromClick = false;
    var didHideDueToDocumentMouseDown = false;
    var didTouchMove = false;
    var ignoreOnFirstUpdate = false;
    var lastTriggerEvent;
    var currentTransitionEndListener;
    var onFirstUpdate;
    var listeners = [];
    var debouncedOnMouseMove = $359fbeb1ed9cb77a$var$debounce(onMouseMove, props.interactiveDebounce);
    var currentTarget; // ===========================================================================
    // 🔑 Public members
    // ===========================================================================
    var id = $359fbeb1ed9cb77a$var$idCounter++;
    var popperInstance = null;
    var plugins = $359fbeb1ed9cb77a$var$unique(props.plugins);
    var state = {
        // Is the instance currently enabled?
        isEnabled: true,
        // Is the tippy currently showing and not transitioning out?
        isVisible: false,
        // Has the instance been destroyed?
        isDestroyed: false,
        // Is the tippy currently mounted to the DOM?
        isMounted: false,
        // Has the tippy finished transitioning in?
        isShown: false
    };
    var instance = {
        // properties
        id: id,
        reference: reference,
        popper: $359fbeb1ed9cb77a$var$div(),
        popperInstance: popperInstance,
        props: props,
        state: state,
        plugins: plugins,
        // methods
        clearDelayTimeouts: clearDelayTimeouts,
        setProps: setProps,
        setContent: setContent,
        show: show,
        hide: hide,
        hideWithInteractivity: hideWithInteractivity,
        enable: enable,
        disable: disable,
        unmount: unmount,
        destroy: destroy
    }; // TODO: Investigate why this early return causes a TDZ error in the tests —
    // it doesn't seem to happen in the browser
    /* istanbul ignore if */ if (!props.render) return instance;
     // ===========================================================================
    // Initial mutations
    // ===========================================================================
    var _props$render = props.render(instance), popper = _props$render.popper, onUpdate = _props$render.onUpdate;
    popper.setAttribute("data-tippy-root", "");
    popper.id = "tippy-" + instance.id;
    instance.popper = popper;
    reference._tippy = instance;
    popper._tippy = instance;
    var pluginsHooks = plugins.map(function(plugin) {
        return plugin.fn(instance);
    });
    var hasAriaExpanded = reference.hasAttribute("aria-expanded");
    addListeners();
    handleAriaExpandedAttribute();
    handleStyles();
    invokeHook("onCreate", [
        instance
    ]);
    if (props.showOnCreate) scheduleShow();
     // Prevent a tippy with a delay from hiding if the cursor left then returned
    // before it started hiding
    popper.addEventListener("mouseenter", function() {
        if (instance.props.interactive && instance.state.isVisible) instance.clearDelayTimeouts();
    });
    popper.addEventListener("mouseleave", function() {
        if (instance.props.interactive && instance.props.trigger.indexOf("mouseenter") >= 0) getDocument().addEventListener("mousemove", debouncedOnMouseMove);
    });
    return instance; // ===========================================================================
    // 🔒 Private methods
    // ===========================================================================
    function getNormalizedTouchSettings() {
        var touch = instance.props.touch;
        return Array.isArray(touch) ? touch : [
            touch,
            0
        ];
    }
    function getIsCustomTouchBehavior() {
        return getNormalizedTouchSettings()[0] === "hold";
    }
    function getIsDefaultRenderFn() {
        var _instance$props$rende;
        // @ts-ignore
        return !!((_instance$props$rende = instance.props.render) != null && _instance$props$rende.$$tippy);
    }
    function getCurrentTarget() {
        return currentTarget || reference;
    }
    function getDocument() {
        var parent = getCurrentTarget().parentNode;
        return parent ? $359fbeb1ed9cb77a$var$getOwnerDocument(parent) : document;
    }
    function getDefaultTemplateChildren() {
        return $359fbeb1ed9cb77a$var$getChildren(popper);
    }
    function getDelay(isShow) {
        // For touch or keyboard input, force `0` delay for UX reasons
        // Also if the instance is mounted but not visible (transitioning out),
        // ignore delay
        if (instance.state.isMounted && !instance.state.isVisible || $359fbeb1ed9cb77a$var$currentInput.isTouch || lastTriggerEvent && lastTriggerEvent.type === "focus") return 0;
        return $359fbeb1ed9cb77a$var$getValueAtIndexOrReturn(instance.props.delay, isShow ? 0 : 1, $359fbeb1ed9cb77a$var$defaultProps.delay);
    }
    function handleStyles(fromHide) {
        if (fromHide === void 0) fromHide = false;
        popper.style.pointerEvents = instance.props.interactive && !fromHide ? "" : "none";
        popper.style.zIndex = "" + instance.props.zIndex;
    }
    function invokeHook(hook, args, shouldInvokePropsHook) {
        if (shouldInvokePropsHook === void 0) shouldInvokePropsHook = true;
        pluginsHooks.forEach(function(pluginHooks) {
            if (pluginHooks[hook]) pluginHooks[hook].apply(pluginHooks, args);
        });
        if (shouldInvokePropsHook) {
            var _instance$props;
            (_instance$props = instance.props)[hook].apply(_instance$props, args);
        }
    }
    function handleAriaContentAttribute() {
        var aria = instance.props.aria;
        if (!aria.content) return;
        var attr = "aria-" + aria.content;
        var id = popper.id;
        var nodes = $359fbeb1ed9cb77a$var$normalizeToArray(instance.props.triggerTarget || reference);
        nodes.forEach(function(node) {
            var currentValue = node.getAttribute(attr);
            if (instance.state.isVisible) node.setAttribute(attr, currentValue ? currentValue + " " + id : id);
            else {
                var nextValue = currentValue && currentValue.replace(id, "").trim();
                if (nextValue) node.setAttribute(attr, nextValue);
                else node.removeAttribute(attr);
            }
        });
    }
    function handleAriaExpandedAttribute() {
        if (hasAriaExpanded || !instance.props.aria.expanded) return;
        var nodes = $359fbeb1ed9cb77a$var$normalizeToArray(instance.props.triggerTarget || reference);
        nodes.forEach(function(node) {
            if (instance.props.interactive) node.setAttribute("aria-expanded", instance.state.isVisible && node === getCurrentTarget() ? "true" : "false");
            else node.removeAttribute("aria-expanded");
        });
    }
    function cleanupInteractiveMouseListeners() {
        getDocument().removeEventListener("mousemove", debouncedOnMouseMove);
        $359fbeb1ed9cb77a$var$mouseMoveListeners = $359fbeb1ed9cb77a$var$mouseMoveListeners.filter(function(listener) {
            return listener !== debouncedOnMouseMove;
        });
    }
    function onDocumentPress(event) {
        // Moved finger to scroll instead of an intentional tap outside
        if ($359fbeb1ed9cb77a$var$currentInput.isTouch) {
            if (didTouchMove || event.type === "mousedown") return;
        }
        var actualTarget = event.composedPath && event.composedPath()[0] || event.target; // Clicked on interactive popper
        if (instance.props.interactive && $359fbeb1ed9cb77a$var$actualContains(popper, actualTarget)) return;
         // Clicked on the event listeners target
        if ($359fbeb1ed9cb77a$var$normalizeToArray(instance.props.triggerTarget || reference).some(function(el) {
            return $359fbeb1ed9cb77a$var$actualContains(el, actualTarget);
        })) {
            if ($359fbeb1ed9cb77a$var$currentInput.isTouch) return;
            if (instance.state.isVisible && instance.props.trigger.indexOf("click") >= 0) return;
        } else invokeHook("onClickOutside", [
            instance,
            event
        ]);
        if (instance.props.hideOnClick === true) {
            instance.clearDelayTimeouts();
            instance.hide(); // `mousedown` event is fired right before `focus` if pressing the
            // currentTarget. This lets a tippy with `focus` trigger know that it
            // should not show
            didHideDueToDocumentMouseDown = true;
            setTimeout(function() {
                didHideDueToDocumentMouseDown = false;
            }); // The listener gets added in `scheduleShow()`, but this may be hiding it
            // before it shows, and hide()'s early bail-out behavior can prevent it
            // from being cleaned up
            if (!instance.state.isMounted) removeDocumentPress();
        }
    }
    function onTouchMove() {
        didTouchMove = true;
    }
    function onTouchStart() {
        didTouchMove = false;
    }
    function addDocumentPress() {
        var doc = getDocument();
        doc.addEventListener("mousedown", onDocumentPress, true);
        doc.addEventListener("touchend", onDocumentPress, $359fbeb1ed9cb77a$var$TOUCH_OPTIONS);
        doc.addEventListener("touchstart", onTouchStart, $359fbeb1ed9cb77a$var$TOUCH_OPTIONS);
        doc.addEventListener("touchmove", onTouchMove, $359fbeb1ed9cb77a$var$TOUCH_OPTIONS);
    }
    function removeDocumentPress() {
        var doc = getDocument();
        doc.removeEventListener("mousedown", onDocumentPress, true);
        doc.removeEventListener("touchend", onDocumentPress, $359fbeb1ed9cb77a$var$TOUCH_OPTIONS);
        doc.removeEventListener("touchstart", onTouchStart, $359fbeb1ed9cb77a$var$TOUCH_OPTIONS);
        doc.removeEventListener("touchmove", onTouchMove, $359fbeb1ed9cb77a$var$TOUCH_OPTIONS);
    }
    function onTransitionedOut(duration, callback) {
        onTransitionEnd(duration, function() {
            if (!instance.state.isVisible && popper.parentNode && popper.parentNode.contains(popper)) callback();
        });
    }
    function onTransitionedIn(duration, callback) {
        onTransitionEnd(duration, callback);
    }
    function onTransitionEnd(duration, callback) {
        var box = getDefaultTemplateChildren().box;
        function listener(event) {
            if (event.target === box) {
                $359fbeb1ed9cb77a$var$updateTransitionEndListener(box, "remove", listener);
                callback();
            }
        } // Make callback synchronous if duration is 0
        // `transitionend` won't fire otherwise
        if (duration === 0) return callback();
        $359fbeb1ed9cb77a$var$updateTransitionEndListener(box, "remove", currentTransitionEndListener);
        $359fbeb1ed9cb77a$var$updateTransitionEndListener(box, "add", listener);
        currentTransitionEndListener = listener;
    }
    function on(eventType, handler, options) {
        if (options === void 0) options = false;
        var nodes = $359fbeb1ed9cb77a$var$normalizeToArray(instance.props.triggerTarget || reference);
        nodes.forEach(function(node) {
            node.addEventListener(eventType, handler, options);
            listeners.push({
                node: node,
                eventType: eventType,
                handler: handler,
                options: options
            });
        });
    }
    function addListeners() {
        if (getIsCustomTouchBehavior()) {
            on("touchstart", onTrigger, {
                passive: true
            });
            on("touchend", onMouseLeave, {
                passive: true
            });
        }
        $359fbeb1ed9cb77a$var$splitBySpaces(instance.props.trigger).forEach(function(eventType) {
            if (eventType === "manual") return;
            on(eventType, onTrigger);
            switch(eventType){
                case "mouseenter":
                    on("mouseleave", onMouseLeave);
                    break;
                case "focus":
                    on($359fbeb1ed9cb77a$var$isIE11 ? "focusout" : "blur", onBlurOrFocusOut);
                    break;
                case "focusin":
                    on("focusout", onBlurOrFocusOut);
                    break;
            }
        });
    }
    function removeListeners() {
        listeners.forEach(function(_ref) {
            var node = _ref.node, eventType = _ref.eventType, handler = _ref.handler, options = _ref.options;
            node.removeEventListener(eventType, handler, options);
        });
        listeners = [];
    }
    function onTrigger(event) {
        var _lastTriggerEvent;
        var shouldScheduleClickHide = false;
        if (!instance.state.isEnabled || isEventListenerStopped(event) || didHideDueToDocumentMouseDown) return;
        var wasFocused = ((_lastTriggerEvent = lastTriggerEvent) == null ? void 0 : _lastTriggerEvent.type) === "focus";
        lastTriggerEvent = event;
        currentTarget = event.currentTarget;
        handleAriaExpandedAttribute();
        if (!instance.state.isVisible && $359fbeb1ed9cb77a$var$isMouseEvent(event)) // If scrolling, `mouseenter` events can be fired if the cursor lands
        // over a new target, but `mousemove` events don't get fired. This
        // causes interactive tooltips to get stuck open until the cursor is
        // moved
        $359fbeb1ed9cb77a$var$mouseMoveListeners.forEach(function(listener) {
            return listener(event);
        });
         // Toggle show/hide when clicking click-triggered tooltips
        if (event.type === "click" && (instance.props.trigger.indexOf("mouseenter") < 0 || isVisibleFromClick) && instance.props.hideOnClick !== false && instance.state.isVisible) shouldScheduleClickHide = true;
        else scheduleShow(event);
        if (event.type === "click") isVisibleFromClick = !shouldScheduleClickHide;
        if (shouldScheduleClickHide && !wasFocused) scheduleHide(event);
    }
    function onMouseMove(event) {
        var target = event.target;
        var isCursorOverReferenceOrPopper = getCurrentTarget().contains(target) || popper.contains(target);
        if (event.type === "mousemove" && isCursorOverReferenceOrPopper) return;
        var popperTreeData = getNestedPopperTree().concat(popper).map(function(popper) {
            var _instance$popperInsta;
            var instance = popper._tippy;
            var state = (_instance$popperInsta = instance.popperInstance) == null ? void 0 : _instance$popperInsta.state;
            if (state) return {
                popperRect: popper.getBoundingClientRect(),
                popperState: state,
                props: props
            };
            return null;
        }).filter(Boolean);
        if ($359fbeb1ed9cb77a$var$isCursorOutsideInteractiveBorder(popperTreeData, event)) {
            cleanupInteractiveMouseListeners();
            scheduleHide(event);
        }
    }
    function onMouseLeave(event) {
        var shouldBail = isEventListenerStopped(event) || instance.props.trigger.indexOf("click") >= 0 && isVisibleFromClick;
        if (shouldBail) return;
        if (instance.props.interactive) {
            instance.hideWithInteractivity(event);
            return;
        }
        scheduleHide(event);
    }
    function onBlurOrFocusOut(event) {
        if (instance.props.trigger.indexOf("focusin") < 0 && event.target !== getCurrentTarget()) return;
         // If focus was moved to within the popper
        if (instance.props.interactive && event.relatedTarget && popper.contains(event.relatedTarget)) return;
        scheduleHide(event);
    }
    function isEventListenerStopped(event) {
        return $359fbeb1ed9cb77a$var$currentInput.isTouch ? getIsCustomTouchBehavior() !== event.type.indexOf("touch") >= 0 : false;
    }
    function createPopperInstance() {
        destroyPopperInstance();
        var _instance$props2 = instance.props, popperOptions = _instance$props2.popperOptions, placement = _instance$props2.placement, offset = _instance$props2.offset, getReferenceClientRect = _instance$props2.getReferenceClientRect, moveTransition = _instance$props2.moveTransition;
        var arrow = getIsDefaultRenderFn() ? $359fbeb1ed9cb77a$var$getChildren(popper).arrow : null;
        var computedReference = getReferenceClientRect ? {
            getBoundingClientRect: getReferenceClientRect,
            contextElement: getReferenceClientRect.contextElement || getCurrentTarget()
        } : reference;
        var tippyModifier = {
            name: "$$tippy",
            enabled: true,
            phase: "beforeWrite",
            requires: [
                "computeStyles"
            ],
            fn: function fn(_ref2) {
                var state = _ref2.state;
                if (getIsDefaultRenderFn()) {
                    var _getDefaultTemplateCh = getDefaultTemplateChildren(), box = _getDefaultTemplateCh.box;
                    [
                        "placement",
                        "reference-hidden",
                        "escaped"
                    ].forEach(function(attr) {
                        if (attr === "placement") box.setAttribute("data-placement", state.placement);
                        else if (state.attributes.popper["data-popper-" + attr]) box.setAttribute("data-" + attr, "");
                        else box.removeAttribute("data-" + attr);
                    });
                    state.attributes.popper = {};
                }
            }
        };
        var modifiers = [
            {
                name: "offset",
                options: {
                    offset: offset
                }
            },
            {
                name: "preventOverflow",
                options: {
                    padding: {
                        top: 2,
                        bottom: 2,
                        left: 5,
                        right: 5
                    }
                }
            },
            {
                name: "flip",
                options: {
                    padding: 5
                }
            },
            {
                name: "computeStyles",
                options: {
                    adaptive: !moveTransition
                }
            },
            tippyModifier
        ];
        if (getIsDefaultRenderFn() && arrow) modifiers.push({
            name: "arrow",
            options: {
                element: arrow,
                padding: 3
            }
        });
        modifiers.push.apply(modifiers, (popperOptions == null ? void 0 : popperOptions.modifiers) || []);
        instance.popperInstance = (0, $edce1af7373226a3$export$8f7491d57c8f97a9)(computedReference, popper, Object.assign({}, popperOptions, {
            placement: placement,
            onFirstUpdate: onFirstUpdate,
            modifiers: modifiers
        }));
    }
    function destroyPopperInstance() {
        if (instance.popperInstance) {
            instance.popperInstance.destroy();
            instance.popperInstance = null;
        }
    }
    function mount() {
        var appendTo = instance.props.appendTo;
        var parentNode; // By default, we'll append the popper to the triggerTargets's parentNode so
        // it's directly after the reference element so the elements inside the
        // tippy can be tabbed to
        // If there are clipping issues, the user can specify a different appendTo
        // and ensure focus management is handled correctly manually
        var node = getCurrentTarget();
        if (instance.props.interactive && appendTo === $359fbeb1ed9cb77a$var$TIPPY_DEFAULT_APPEND_TO || appendTo === "parent") parentNode = node.parentNode;
        else parentNode = $359fbeb1ed9cb77a$var$invokeWithArgsOrReturn(appendTo, [
            node
        ]);
         // The popper element needs to exist on the DOM before its position can be
        // updated as Popper needs to read its dimensions
        if (!parentNode.contains(popper)) parentNode.appendChild(popper);
        instance.state.isMounted = true;
        createPopperInstance();
    }
    function getNestedPopperTree() {
        return $359fbeb1ed9cb77a$var$arrayFrom(popper.querySelectorAll("[data-tippy-root]"));
    }
    function scheduleShow(event) {
        instance.clearDelayTimeouts();
        if (event) invokeHook("onTrigger", [
            instance,
            event
        ]);
        addDocumentPress();
        var delay = getDelay(true);
        var _getNormalizedTouchSe = getNormalizedTouchSettings(), touchValue = _getNormalizedTouchSe[0], touchDelay = _getNormalizedTouchSe[1];
        if ($359fbeb1ed9cb77a$var$currentInput.isTouch && touchValue === "hold" && touchDelay) delay = touchDelay;
        if (delay) showTimeout = setTimeout(function() {
            instance.show();
        }, delay);
        else instance.show();
    }
    function scheduleHide(event) {
        instance.clearDelayTimeouts();
        invokeHook("onUntrigger", [
            instance,
            event
        ]);
        if (!instance.state.isVisible) {
            removeDocumentPress();
            return;
        } // For interactive tippies, scheduleHide is added to a document.body handler
        // from onMouseLeave so must intercept scheduled hides from mousemove/leave
        // events when trigger contains mouseenter and click, and the tip is
        // currently shown as a result of a click.
        if (instance.props.trigger.indexOf("mouseenter") >= 0 && instance.props.trigger.indexOf("click") >= 0 && [
            "mouseleave",
            "mousemove"
        ].indexOf(event.type) >= 0 && isVisibleFromClick) return;
        var delay = getDelay(false);
        if (delay) hideTimeout = setTimeout(function() {
            if (instance.state.isVisible) instance.hide();
        }, delay);
        else // Fixes a `transitionend` problem when it fires 1 frame too
        // late sometimes, we don't want hide() to be called.
        scheduleHideAnimationFrame = requestAnimationFrame(function() {
            instance.hide();
        });
    } // ===========================================================================
    // 🔑 Public methods
    // ===========================================================================
    function enable() {
        instance.state.isEnabled = true;
    }
    function disable() {
        // Disabling the instance should also hide it
        // https://github.com/atomiks/tippy.js-react/issues/106
        instance.hide();
        instance.state.isEnabled = false;
    }
    function clearDelayTimeouts() {
        clearTimeout(showTimeout);
        clearTimeout(hideTimeout);
        cancelAnimationFrame(scheduleHideAnimationFrame);
    }
    function setProps(partialProps) {
        if (instance.state.isDestroyed) return;
        invokeHook("onBeforeUpdate", [
            instance,
            partialProps
        ]);
        removeListeners();
        var prevProps = instance.props;
        var nextProps = $359fbeb1ed9cb77a$var$evaluateProps(reference, Object.assign({}, prevProps, $359fbeb1ed9cb77a$var$removeUndefinedProps(partialProps), {
            ignoreAttributes: true
        }));
        instance.props = nextProps;
        addListeners();
        if (prevProps.interactiveDebounce !== nextProps.interactiveDebounce) {
            cleanupInteractiveMouseListeners();
            debouncedOnMouseMove = $359fbeb1ed9cb77a$var$debounce(onMouseMove, nextProps.interactiveDebounce);
        } // Ensure stale aria-expanded attributes are removed
        if (prevProps.triggerTarget && !nextProps.triggerTarget) $359fbeb1ed9cb77a$var$normalizeToArray(prevProps.triggerTarget).forEach(function(node) {
            node.removeAttribute("aria-expanded");
        });
        else if (nextProps.triggerTarget) reference.removeAttribute("aria-expanded");
        handleAriaExpandedAttribute();
        handleStyles();
        if (onUpdate) onUpdate(prevProps, nextProps);
        if (instance.popperInstance) {
            createPopperInstance(); // Fixes an issue with nested tippies if they are all getting re-rendered,
            // and the nested ones get re-rendered first.
            // https://github.com/atomiks/tippyjs-react/issues/177
            // TODO: find a cleaner / more efficient solution(!)
            getNestedPopperTree().forEach(function(nestedPopper) {
                // React (and other UI libs likely) requires a rAF wrapper as it flushes
                // its work in one
                requestAnimationFrame(nestedPopper._tippy.popperInstance.forceUpdate);
            });
        }
        invokeHook("onAfterUpdate", [
            instance,
            partialProps
        ]);
    }
    function setContent(content) {
        instance.setProps({
            content: content
        });
    }
    function show() {
        var isAlreadyVisible = instance.state.isVisible;
        var isDestroyed = instance.state.isDestroyed;
        var isDisabled = !instance.state.isEnabled;
        var isTouchAndTouchDisabled = $359fbeb1ed9cb77a$var$currentInput.isTouch && !instance.props.touch;
        var duration = $359fbeb1ed9cb77a$var$getValueAtIndexOrReturn(instance.props.duration, 0, $359fbeb1ed9cb77a$var$defaultProps.duration);
        if (isAlreadyVisible || isDestroyed || isDisabled || isTouchAndTouchDisabled) return;
         // Normalize `disabled` behavior across browsers.
        // Firefox allows events on disabled elements, but Chrome doesn't.
        // Using a wrapper element (i.e. <span>) is recommended.
        if (getCurrentTarget().hasAttribute("disabled")) return;
        invokeHook("onShow", [
            instance
        ], false);
        if (instance.props.onShow(instance) === false) return;
        instance.state.isVisible = true;
        if (getIsDefaultRenderFn()) popper.style.visibility = "visible";
        handleStyles();
        addDocumentPress();
        if (!instance.state.isMounted) popper.style.transition = "none";
         // If flipping to the opposite side after hiding at least once, the
        // animation will use the wrong placement without resetting the duration
        if (getIsDefaultRenderFn()) {
            var _getDefaultTemplateCh2 = getDefaultTemplateChildren(), box = _getDefaultTemplateCh2.box, content = _getDefaultTemplateCh2.content;
            $359fbeb1ed9cb77a$var$setTransitionDuration([
                box,
                content
            ], 0);
        }
        onFirstUpdate = function onFirstUpdate() {
            var _instance$popperInsta2;
            if (!instance.state.isVisible || ignoreOnFirstUpdate) return;
            ignoreOnFirstUpdate = true; // reflow
            popper.offsetHeight;
            popper.style.transition = instance.props.moveTransition;
            if (getIsDefaultRenderFn() && instance.props.animation) {
                var _getDefaultTemplateCh3 = getDefaultTemplateChildren(), _box = _getDefaultTemplateCh3.box, _content = _getDefaultTemplateCh3.content;
                $359fbeb1ed9cb77a$var$setTransitionDuration([
                    _box,
                    _content
                ], duration);
                $359fbeb1ed9cb77a$var$setVisibilityState([
                    _box,
                    _content
                ], "visible");
            }
            handleAriaContentAttribute();
            handleAriaExpandedAttribute();
            $359fbeb1ed9cb77a$var$pushIfUnique($359fbeb1ed9cb77a$var$mountedInstances, instance); // certain modifiers (e.g. `maxSize`) require a second update after the
            // popper has been positioned for the first time
            (_instance$popperInsta2 = instance.popperInstance) == null || _instance$popperInsta2.forceUpdate();
            invokeHook("onMount", [
                instance
            ]);
            if (instance.props.animation && getIsDefaultRenderFn()) onTransitionedIn(duration, function() {
                instance.state.isShown = true;
                invokeHook("onShown", [
                    instance
                ]);
            });
        };
        mount();
    }
    function hide() {
        var isAlreadyHidden = !instance.state.isVisible;
        var isDestroyed = instance.state.isDestroyed;
        var isDisabled = !instance.state.isEnabled;
        var duration = $359fbeb1ed9cb77a$var$getValueAtIndexOrReturn(instance.props.duration, 1, $359fbeb1ed9cb77a$var$defaultProps.duration);
        if (isAlreadyHidden || isDestroyed || isDisabled) return;
        invokeHook("onHide", [
            instance
        ], false);
        if (instance.props.onHide(instance) === false) return;
        instance.state.isVisible = false;
        instance.state.isShown = false;
        ignoreOnFirstUpdate = false;
        isVisibleFromClick = false;
        if (getIsDefaultRenderFn()) popper.style.visibility = "hidden";
        cleanupInteractiveMouseListeners();
        removeDocumentPress();
        handleStyles(true);
        if (getIsDefaultRenderFn()) {
            var _getDefaultTemplateCh4 = getDefaultTemplateChildren(), box = _getDefaultTemplateCh4.box, content = _getDefaultTemplateCh4.content;
            if (instance.props.animation) {
                $359fbeb1ed9cb77a$var$setTransitionDuration([
                    box,
                    content
                ], duration);
                $359fbeb1ed9cb77a$var$setVisibilityState([
                    box,
                    content
                ], "hidden");
            }
        }
        handleAriaContentAttribute();
        handleAriaExpandedAttribute();
        if (instance.props.animation) {
            if (getIsDefaultRenderFn()) onTransitionedOut(duration, instance.unmount);
        } else instance.unmount();
    }
    function hideWithInteractivity(event) {
        getDocument().addEventListener("mousemove", debouncedOnMouseMove);
        $359fbeb1ed9cb77a$var$pushIfUnique($359fbeb1ed9cb77a$var$mouseMoveListeners, debouncedOnMouseMove);
        debouncedOnMouseMove(event);
    }
    function unmount() {
        if (instance.state.isVisible) instance.hide();
        if (!instance.state.isMounted) return;
        destroyPopperInstance(); // If a popper is not interactive, it will be appended outside the popper
        // tree by default. This seems mainly for interactive tippies, but we should
        // find a workaround if possible
        getNestedPopperTree().forEach(function(nestedPopper) {
            nestedPopper._tippy.unmount();
        });
        if (popper.parentNode) popper.parentNode.removeChild(popper);
        $359fbeb1ed9cb77a$var$mountedInstances = $359fbeb1ed9cb77a$var$mountedInstances.filter(function(i) {
            return i !== instance;
        });
        instance.state.isMounted = false;
        invokeHook("onHidden", [
            instance
        ]);
    }
    function destroy() {
        if (instance.state.isDestroyed) return;
        instance.clearDelayTimeouts();
        instance.unmount();
        removeListeners();
        delete reference._tippy;
        instance.state.isDestroyed = true;
        invokeHook("onDestroy", [
            instance
        ]);
    }
}
function $359fbeb1ed9cb77a$var$tippy(targets, optionalProps) {
    if (optionalProps === void 0) optionalProps = {};
    var plugins = $359fbeb1ed9cb77a$var$defaultProps.plugins.concat(optionalProps.plugins || []);
    $359fbeb1ed9cb77a$var$bindGlobalEventListeners();
    var passedProps = Object.assign({}, optionalProps, {
        plugins: plugins
    });
    var elements = $359fbeb1ed9cb77a$var$getArrayOfElements(targets);
    var isSingleContentElement, isMoreThanOneReferenceElement;
    var instances = elements.reduce(function(acc, reference) {
        var instance = reference && $359fbeb1ed9cb77a$var$createTippy(reference, passedProps);
        if (instance) acc.push(instance);
        return acc;
    }, []);
    return $359fbeb1ed9cb77a$var$isElement(targets) ? instances[0] : instances;
}
$359fbeb1ed9cb77a$var$tippy.defaultProps = $359fbeb1ed9cb77a$var$defaultProps;
$359fbeb1ed9cb77a$var$tippy.setDefaultProps = $359fbeb1ed9cb77a$var$setDefaultProps;
$359fbeb1ed9cb77a$var$tippy.currentInput = $359fbeb1ed9cb77a$var$currentInput;
var $359fbeb1ed9cb77a$export$a9608aab345f7e75 = function hideAll(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, excludedReferenceOrInstance = _ref.exclude, duration = _ref.duration;
    $359fbeb1ed9cb77a$var$mountedInstances.forEach(function(instance) {
        var isExcluded = false;
        if (excludedReferenceOrInstance) isExcluded = $359fbeb1ed9cb77a$var$isReferenceElement(excludedReferenceOrInstance) ? instance.reference === excludedReferenceOrInstance : instance.popper === excludedReferenceOrInstance.popper;
        if (!isExcluded) {
            var originalDuration = instance.props.duration;
            instance.setProps({
                duration: duration
            });
            instance.hide();
            if (!instance.state.isDestroyed) instance.setProps({
                duration: originalDuration
            });
        }
    });
};
// every time the popper is destroyed (i.e. a new target), removing the styles
// and causing transitions to break for singletons when the console is open, but
// most notably for non-transform styles being used, `gpuAcceleration: false`.
var $359fbeb1ed9cb77a$var$applyStylesModifier = Object.assign({}, (0, $a0a31010a3a047b1$export$2e2bcd8739ae039), {
    effect: function effect(_ref) {
        var state = _ref.state;
        var initialStyles = {
            popper: {
                position: state.options.strategy,
                left: "0",
                top: "0",
                margin: "0"
            },
            arrow: {
                position: "absolute"
            },
            reference: {}
        };
        Object.assign(state.elements.popper.style, initialStyles.popper);
        state.styles = initialStyles;
        if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
         // intentionally return no cleanup function
    // return () => { ... }
    }
});
var $359fbeb1ed9cb77a$export$374c483667c1ea9b = function createSingleton(tippyInstances, optionalProps) {
    var _optionalProps$popper;
    if (optionalProps === void 0) optionalProps = {};
    var individualInstances = tippyInstances;
    var references = [];
    var triggerTargets = [];
    var currentTarget;
    var overrides = optionalProps.overrides;
    var interceptSetPropsCleanups = [];
    var shownOnCreate = false;
    function setTriggerTargets() {
        triggerTargets = individualInstances.map(function(instance) {
            return $359fbeb1ed9cb77a$var$normalizeToArray(instance.props.triggerTarget || instance.reference);
        }).reduce(function(acc, item) {
            return acc.concat(item);
        }, []);
    }
    function setReferences() {
        references = individualInstances.map(function(instance) {
            return instance.reference;
        });
    }
    function enableInstances(isEnabled) {
        individualInstances.forEach(function(instance) {
            if (isEnabled) instance.enable();
            else instance.disable();
        });
    }
    function interceptSetProps(singleton) {
        return individualInstances.map(function(instance) {
            var originalSetProps = instance.setProps;
            instance.setProps = function(props) {
                originalSetProps(props);
                if (instance.reference === currentTarget) singleton.setProps(props);
            };
            return function() {
                instance.setProps = originalSetProps;
            };
        });
    } // have to pass singleton, as it maybe undefined on first call
    function prepareInstance(singleton, target) {
        var index = triggerTargets.indexOf(target); // bail-out
        if (target === currentTarget) return;
        currentTarget = target;
        var overrideProps = (overrides || []).concat("content").reduce(function(acc, prop) {
            acc[prop] = individualInstances[index].props[prop];
            return acc;
        }, {});
        singleton.setProps(Object.assign({}, overrideProps, {
            getReferenceClientRect: typeof overrideProps.getReferenceClientRect === "function" ? overrideProps.getReferenceClientRect : function() {
                var _references$index;
                return (_references$index = references[index]) == null ? void 0 : _references$index.getBoundingClientRect();
            }
        }));
    }
    enableInstances(false);
    setReferences();
    setTriggerTargets();
    var plugin = {
        fn: function fn() {
            return {
                onDestroy: function onDestroy() {
                    enableInstances(true);
                },
                onHidden: function onHidden() {
                    currentTarget = null;
                },
                onClickOutside: function onClickOutside(instance) {
                    if (instance.props.showOnCreate && !shownOnCreate) {
                        shownOnCreate = true;
                        currentTarget = null;
                    }
                },
                onShow: function onShow(instance) {
                    if (instance.props.showOnCreate && !shownOnCreate) {
                        shownOnCreate = true;
                        prepareInstance(instance, references[0]);
                    }
                },
                onTrigger: function onTrigger(instance, event) {
                    prepareInstance(instance, event.currentTarget);
                }
            };
        }
    };
    var singleton = $359fbeb1ed9cb77a$var$tippy($359fbeb1ed9cb77a$var$div(), Object.assign({}, $359fbeb1ed9cb77a$var$removeProperties(optionalProps, [
        "overrides"
    ]), {
        plugins: [
            plugin
        ].concat(optionalProps.plugins || []),
        triggerTarget: triggerTargets,
        popperOptions: Object.assign({}, optionalProps.popperOptions, {
            modifiers: [].concat(((_optionalProps$popper = optionalProps.popperOptions) == null ? void 0 : _optionalProps$popper.modifiers) || [], [
                $359fbeb1ed9cb77a$var$applyStylesModifier
            ])
        })
    }));
    var originalShow = singleton.show;
    singleton.show = function(target) {
        originalShow(); // first time, showOnCreate or programmatic call with no params
        // default to showing first instance
        if (!currentTarget && target == null) return prepareInstance(singleton, references[0]);
         // triggered from event (do nothing as prepareInstance already called by onTrigger)
        // programmatic call with no params when already visible (do nothing again)
        if (currentTarget && target == null) return;
         // target is index of instance
        if (typeof target === "number") return references[target] && prepareInstance(singleton, references[target]);
         // target is a child tippy instance
        if (individualInstances.indexOf(target) >= 0) {
            var ref = target.reference;
            return prepareInstance(singleton, ref);
        } // target is a ReferenceElement
        if (references.indexOf(target) >= 0) return prepareInstance(singleton, target);
    };
    singleton.showNext = function() {
        var first = references[0];
        if (!currentTarget) return singleton.show(0);
        var index = references.indexOf(currentTarget);
        singleton.show(references[index + 1] || first);
    };
    singleton.showPrevious = function() {
        var last = references[references.length - 1];
        if (!currentTarget) return singleton.show(last);
        var index = references.indexOf(currentTarget);
        var target = references[index - 1] || last;
        singleton.show(target);
    };
    var originalSetProps = singleton.setProps;
    singleton.setProps = function(props) {
        overrides = props.overrides || overrides;
        originalSetProps(props);
    };
    singleton.setInstances = function(nextInstances) {
        enableInstances(true);
        interceptSetPropsCleanups.forEach(function(fn) {
            return fn();
        });
        individualInstances = nextInstances;
        enableInstances(false);
        setReferences();
        setTriggerTargets();
        interceptSetPropsCleanups = interceptSetProps(singleton);
        singleton.setProps({
            triggerTarget: triggerTargets
        });
    };
    interceptSetPropsCleanups = interceptSetProps(singleton);
    return singleton;
};
var $359fbeb1ed9cb77a$var$BUBBLING_EVENTS_MAP = {
    mouseover: "mouseenter",
    focusin: "focus",
    click: "click"
};
/**
 * Creates a delegate instance that controls the creation of tippy instances
 * for child elements (`target` CSS selector).
 */ function $359fbeb1ed9cb77a$export$10b1921597150314(targets, props) {
    var listeners = [];
    var childTippyInstances = [];
    var disabled = false;
    var target = props.target;
    var nativeProps = $359fbeb1ed9cb77a$var$removeProperties(props, [
        "target"
    ]);
    var parentProps = Object.assign({}, nativeProps, {
        trigger: "manual",
        touch: false
    });
    var childProps = Object.assign({
        touch: $359fbeb1ed9cb77a$var$defaultProps.touch
    }, nativeProps, {
        showOnCreate: true
    });
    var returnValue = $359fbeb1ed9cb77a$var$tippy(targets, parentProps);
    var normalizedReturnValue = $359fbeb1ed9cb77a$var$normalizeToArray(returnValue);
    function onTrigger(event) {
        if (!event.target || disabled) return;
        var targetNode = event.target.closest(target);
        if (!targetNode) return;
         // Get relevant trigger with fallbacks:
        // 1. Check `data-tippy-trigger` attribute on target node
        // 2. Fallback to `trigger` passed to `delegate()`
        // 3. Fallback to `defaultProps.trigger`
        var trigger = targetNode.getAttribute("data-tippy-trigger") || props.trigger || $359fbeb1ed9cb77a$var$defaultProps.trigger; // @ts-ignore
        if (targetNode._tippy) return;
        if (event.type === "touchstart" && typeof childProps.touch === "boolean") return;
        if (event.type !== "touchstart" && trigger.indexOf($359fbeb1ed9cb77a$var$BUBBLING_EVENTS_MAP[event.type]) < 0) return;
        var instance = $359fbeb1ed9cb77a$var$tippy(targetNode, childProps);
        if (instance) childTippyInstances = childTippyInstances.concat(instance);
    }
    function on(node, eventType, handler, options) {
        if (options === void 0) options = false;
        node.addEventListener(eventType, handler, options);
        listeners.push({
            node: node,
            eventType: eventType,
            handler: handler,
            options: options
        });
    }
    function addEventListeners(instance) {
        var reference = instance.reference;
        on(reference, "touchstart", onTrigger, $359fbeb1ed9cb77a$var$TOUCH_OPTIONS);
        on(reference, "mouseover", onTrigger);
        on(reference, "focusin", onTrigger);
        on(reference, "click", onTrigger);
    }
    function removeEventListeners() {
        listeners.forEach(function(_ref) {
            var node = _ref.node, eventType = _ref.eventType, handler = _ref.handler, options = _ref.options;
            node.removeEventListener(eventType, handler, options);
        });
        listeners = [];
    }
    function applyMutations(instance) {
        var originalDestroy = instance.destroy;
        var originalEnable = instance.enable;
        var originalDisable = instance.disable;
        instance.destroy = function(shouldDestroyChildInstances) {
            if (shouldDestroyChildInstances === void 0) shouldDestroyChildInstances = true;
            if (shouldDestroyChildInstances) childTippyInstances.forEach(function(instance) {
                instance.destroy();
            });
            childTippyInstances = [];
            removeEventListeners();
            originalDestroy();
        };
        instance.enable = function() {
            originalEnable();
            childTippyInstances.forEach(function(instance) {
                return instance.enable();
            });
            disabled = false;
        };
        instance.disable = function() {
            originalDisable();
            childTippyInstances.forEach(function(instance) {
                return instance.disable();
            });
            disabled = true;
        };
        addEventListeners(instance);
    }
    normalizedReturnValue.forEach(applyMutations);
    return returnValue;
}
var $359fbeb1ed9cb77a$export$dd8ded329c01db79 = {
    name: "animateFill",
    defaultValue: false,
    fn: function fn(instance) {
        var _instance$props$rende;
        // @ts-ignore
        if (!((_instance$props$rende = instance.props.render) != null && _instance$props$rende.$$tippy)) return {};
        var _getChildren = $359fbeb1ed9cb77a$var$getChildren(instance.popper), box = _getChildren.box, content = _getChildren.content;
        var backdrop = instance.props.animateFill ? $359fbeb1ed9cb77a$var$createBackdropElement() : null;
        return {
            onCreate: function onCreate() {
                if (backdrop) {
                    box.insertBefore(backdrop, box.firstElementChild);
                    box.setAttribute("data-animatefill", "");
                    box.style.overflow = "hidden";
                    instance.setProps({
                        arrow: false,
                        animation: "shift-away"
                    });
                }
            },
            onMount: function onMount() {
                if (backdrop) {
                    var transitionDuration = box.style.transitionDuration;
                    var duration = Number(transitionDuration.replace("ms", "")); // The content should fade in after the backdrop has mostly filled the
                    // tooltip element. `clip-path` is the other alternative but is not
                    // well-supported and is buggy on some devices.
                    content.style.transitionDelay = Math.round(duration / 10) + "ms";
                    backdrop.style.transitionDuration = transitionDuration;
                    $359fbeb1ed9cb77a$var$setVisibilityState([
                        backdrop
                    ], "visible");
                }
            },
            onShow: function onShow() {
                if (backdrop) backdrop.style.transitionDuration = "0ms";
            },
            onHide: function onHide() {
                if (backdrop) $359fbeb1ed9cb77a$var$setVisibilityState([
                    backdrop
                ], "hidden");
            }
        };
    }
};
function $359fbeb1ed9cb77a$var$createBackdropElement() {
    var backdrop = $359fbeb1ed9cb77a$var$div();
    backdrop.className = $359fbeb1ed9cb77a$var$BACKDROP_CLASS;
    $359fbeb1ed9cb77a$var$setVisibilityState([
        backdrop
    ], "hidden");
    return backdrop;
}
var $359fbeb1ed9cb77a$var$mouseCoords = {
    clientX: 0,
    clientY: 0
};
var $359fbeb1ed9cb77a$var$activeInstances = [];
function $359fbeb1ed9cb77a$var$storeMouseCoords(_ref) {
    var clientX = _ref.clientX, clientY = _ref.clientY;
    $359fbeb1ed9cb77a$var$mouseCoords = {
        clientX: clientX,
        clientY: clientY
    };
}
function $359fbeb1ed9cb77a$var$addMouseCoordsListener(doc) {
    doc.addEventListener("mousemove", $359fbeb1ed9cb77a$var$storeMouseCoords);
}
function $359fbeb1ed9cb77a$var$removeMouseCoordsListener(doc) {
    doc.removeEventListener("mousemove", $359fbeb1ed9cb77a$var$storeMouseCoords);
}
var $359fbeb1ed9cb77a$export$ac81526b64504ab6 = {
    name: "followCursor",
    defaultValue: false,
    fn: function fn(instance) {
        var reference = instance.reference;
        var doc = $359fbeb1ed9cb77a$var$getOwnerDocument(instance.props.triggerTarget || reference);
        var isInternalUpdate = false;
        var wasFocusEvent = false;
        var isUnmounted = true;
        var prevProps = instance.props;
        function getIsInitialBehavior() {
            return instance.props.followCursor === "initial" && instance.state.isVisible;
        }
        function addListener() {
            doc.addEventListener("mousemove", onMouseMove);
        }
        function removeListener() {
            doc.removeEventListener("mousemove", onMouseMove);
        }
        function unsetGetReferenceClientRect() {
            isInternalUpdate = true;
            instance.setProps({
                getReferenceClientRect: null
            });
            isInternalUpdate = false;
        }
        function onMouseMove(event) {
            // If the instance is interactive, avoid updating the position unless it's
            // over the reference element
            var isCursorOverReference = event.target ? reference.contains(event.target) : true;
            var followCursor = instance.props.followCursor;
            var clientX = event.clientX, clientY = event.clientY;
            var rect = reference.getBoundingClientRect();
            var relativeX = clientX - rect.left;
            var relativeY = clientY - rect.top;
            if (isCursorOverReference || !instance.props.interactive) instance.setProps({
                // @ts-ignore - unneeded DOMRect properties
                getReferenceClientRect: function getReferenceClientRect() {
                    var rect = reference.getBoundingClientRect();
                    var x = clientX;
                    var y = clientY;
                    if (followCursor === "initial") {
                        x = rect.left + relativeX;
                        y = rect.top + relativeY;
                    }
                    var top = followCursor === "horizontal" ? rect.top : y;
                    var right = followCursor === "vertical" ? rect.right : x;
                    var bottom = followCursor === "horizontal" ? rect.bottom : y;
                    var left = followCursor === "vertical" ? rect.left : x;
                    return {
                        width: right - left,
                        height: bottom - top,
                        top: top,
                        right: right,
                        bottom: bottom,
                        left: left
                    };
                }
            });
        }
        function create() {
            if (instance.props.followCursor) {
                $359fbeb1ed9cb77a$var$activeInstances.push({
                    instance: instance,
                    doc: doc
                });
                $359fbeb1ed9cb77a$var$addMouseCoordsListener(doc);
            }
        }
        function destroy() {
            $359fbeb1ed9cb77a$var$activeInstances = $359fbeb1ed9cb77a$var$activeInstances.filter(function(data) {
                return data.instance !== instance;
            });
            if ($359fbeb1ed9cb77a$var$activeInstances.filter(function(data) {
                return data.doc === doc;
            }).length === 0) $359fbeb1ed9cb77a$var$removeMouseCoordsListener(doc);
        }
        return {
            onCreate: create,
            onDestroy: destroy,
            onBeforeUpdate: function onBeforeUpdate() {
                prevProps = instance.props;
            },
            onAfterUpdate: function onAfterUpdate(_, _ref2) {
                var followCursor = _ref2.followCursor;
                if (isInternalUpdate) return;
                if (followCursor !== undefined && prevProps.followCursor !== followCursor) {
                    destroy();
                    if (followCursor) {
                        create();
                        if (instance.state.isMounted && !wasFocusEvent && !getIsInitialBehavior()) addListener();
                    } else {
                        removeListener();
                        unsetGetReferenceClientRect();
                    }
                }
            },
            onMount: function onMount() {
                if (instance.props.followCursor && !wasFocusEvent) {
                    if (isUnmounted) {
                        onMouseMove($359fbeb1ed9cb77a$var$mouseCoords);
                        isUnmounted = false;
                    }
                    if (!getIsInitialBehavior()) addListener();
                }
            },
            onTrigger: function onTrigger(_, event) {
                if ($359fbeb1ed9cb77a$var$isMouseEvent(event)) $359fbeb1ed9cb77a$var$mouseCoords = {
                    clientX: event.clientX,
                    clientY: event.clientY
                };
                wasFocusEvent = event.type === "focus";
            },
            onHidden: function onHidden() {
                if (instance.props.followCursor) {
                    unsetGetReferenceClientRect();
                    removeListener();
                    isUnmounted = true;
                }
            }
        };
    }
};
function $359fbeb1ed9cb77a$var$getProps(props, modifier) {
    var _props$popperOptions;
    return {
        popperOptions: Object.assign({}, props.popperOptions, {
            modifiers: [].concat((((_props$popperOptions = props.popperOptions) == null ? void 0 : _props$popperOptions.modifiers) || []).filter(function(_ref) {
                var name = _ref.name;
                return name !== modifier.name;
            }), [
                modifier
            ])
        })
    };
}
var $359fbeb1ed9cb77a$export$e2b668424a9c728 = {
    name: "inlinePositioning",
    defaultValue: false,
    fn: function fn(instance) {
        var reference = instance.reference;
        function isEnabled() {
            return !!instance.props.inlinePositioning;
        }
        var placement;
        var cursorRectIndex = -1;
        var isInternalUpdate = false;
        var triedPlacements = [];
        var modifier = {
            name: "tippyInlinePositioning",
            enabled: true,
            phase: "afterWrite",
            fn: function fn(_ref2) {
                var state = _ref2.state;
                if (isEnabled()) {
                    if (triedPlacements.indexOf(state.placement) !== -1) triedPlacements = [];
                    if (placement !== state.placement && triedPlacements.indexOf(state.placement) === -1) {
                        triedPlacements.push(state.placement);
                        instance.setProps({
                            // @ts-ignore - unneeded DOMRect properties
                            getReferenceClientRect: function getReferenceClientRect() {
                                return _getReferenceClientRect(state.placement);
                            }
                        });
                    }
                    placement = state.placement;
                }
            }
        };
        function _getReferenceClientRect(placement) {
            return $359fbeb1ed9cb77a$var$getInlineBoundingClientRect($359fbeb1ed9cb77a$var$getBasePlacement(placement), reference.getBoundingClientRect(), $359fbeb1ed9cb77a$var$arrayFrom(reference.getClientRects()), cursorRectIndex);
        }
        function setInternalProps(partialProps) {
            isInternalUpdate = true;
            instance.setProps(partialProps);
            isInternalUpdate = false;
        }
        function addModifier() {
            if (!isInternalUpdate) setInternalProps($359fbeb1ed9cb77a$var$getProps(instance.props, modifier));
        }
        return {
            onCreate: addModifier,
            onAfterUpdate: addModifier,
            onTrigger: function onTrigger(_, event) {
                if ($359fbeb1ed9cb77a$var$isMouseEvent(event)) {
                    var rects = $359fbeb1ed9cb77a$var$arrayFrom(instance.reference.getClientRects());
                    var cursorRect = rects.find(function(rect) {
                        return rect.left - 2 <= event.clientX && rect.right + 2 >= event.clientX && rect.top - 2 <= event.clientY && rect.bottom + 2 >= event.clientY;
                    });
                    var index = rects.indexOf(cursorRect);
                    cursorRectIndex = index > -1 ? index : cursorRectIndex;
                }
            },
            onHidden: function onHidden() {
                cursorRectIndex = -1;
            }
        };
    }
};
function $359fbeb1ed9cb77a$var$getInlineBoundingClientRect(currentBasePlacement, boundingRect, clientRects, cursorRectIndex) {
    // Not an inline element, or placement is not yet known
    if (clientRects.length < 2 || currentBasePlacement === null) return boundingRect;
     // There are two rects and they are disjoined
    if (clientRects.length === 2 && cursorRectIndex >= 0 && clientRects[0].left > clientRects[1].right) return clientRects[cursorRectIndex] || boundingRect;
    switch(currentBasePlacement){
        case "top":
        case "bottom":
            var firstRect = clientRects[0];
            var lastRect = clientRects[clientRects.length - 1];
            var isTop = currentBasePlacement === "top";
            var top = firstRect.top;
            var bottom = lastRect.bottom;
            var left = isTop ? firstRect.left : lastRect.left;
            var right = isTop ? firstRect.right : lastRect.right;
            var width = right - left;
            var height = bottom - top;
            return {
                top: top,
                bottom: bottom,
                left: left,
                right: right,
                width: width,
                height: height
            };
        case "left":
        case "right":
            var minLeft = Math.min.apply(Math, clientRects.map(function(rects) {
                return rects.left;
            }));
            var maxRight = Math.max.apply(Math, clientRects.map(function(rects) {
                return rects.right;
            }));
            var measureRects = clientRects.filter(function(rect) {
                return currentBasePlacement === "left" ? rect.left === minLeft : rect.right === maxRight;
            });
            var _top = measureRects[0].top;
            var _bottom = measureRects[measureRects.length - 1].bottom;
            var _left = minLeft;
            var _right = maxRight;
            var _width = _right - _left;
            var _height = _bottom - _top;
            return {
                top: _top,
                bottom: _bottom,
                left: _left,
                right: _right,
                width: _width,
                height: _height
            };
        default:
            return boundingRect;
    }
}
var $359fbeb1ed9cb77a$export$4bd4b47501432316 = {
    name: "sticky",
    defaultValue: false,
    fn: function fn(instance) {
        var reference = instance.reference, popper = instance.popper;
        function getReference() {
            return instance.popperInstance ? instance.popperInstance.state.elements.reference : reference;
        }
        function shouldCheck(value) {
            return instance.props.sticky === true || instance.props.sticky === value;
        }
        var prevRefRect = null;
        var prevPopRect = null;
        function updatePosition() {
            var currentRefRect = shouldCheck("reference") ? getReference().getBoundingClientRect() : null;
            var currentPopRect = shouldCheck("popper") ? popper.getBoundingClientRect() : null;
            if (currentRefRect && $359fbeb1ed9cb77a$var$areRectsDifferent(prevRefRect, currentRefRect) || currentPopRect && $359fbeb1ed9cb77a$var$areRectsDifferent(prevPopRect, currentPopRect)) {
                if (instance.popperInstance) instance.popperInstance.update();
            }
            prevRefRect = currentRefRect;
            prevPopRect = currentPopRect;
            if (instance.state.isMounted) requestAnimationFrame(updatePosition);
        }
        return {
            onMount: function onMount() {
                if (instance.props.sticky) updatePosition();
            }
        };
    }
};
function $359fbeb1ed9cb77a$var$areRectsDifferent(rectA, rectB) {
    if (rectA && rectB) return rectA.top !== rectB.top || rectA.right !== rectB.right || rectA.bottom !== rectB.bottom || rectA.left !== rectB.left;
    return true;
}
$359fbeb1ed9cb77a$var$tippy.setDefaultProps({
    render: $359fbeb1ed9cb77a$var$render
});
var $359fbeb1ed9cb77a$export$2e2bcd8739ae039 = $359fbeb1ed9cb77a$var$tippy;



var $f6cb959274f4cb1b$export$2e2bcd8739ae039 = {
    components: {
        FullCalendar: (0, $7336c146e4da07a9$export$2e2bcd8739ae039)
    },
    data: function() {
        return {
            baseURL: window.location.origin,
            GLOBAL: GLOBAL,
            events: [],
            columns: [
                {
                    name: "nome",
                    required: true,
                    label: "nome",
                    align: "left",
                    sortable: true
                },
                {
                    name: "valor_total",
                    align: "left",
                    label: "Valor total",
                    field: "valor_total",
                    sortable: true
                }
            ],
            rows: [
                {
                    id: 1,
                    name: "Nome",
                    valor_total: "R$ 100,00"
                }
            ],
            modalDividendo: null,
            calendarOptions: {
                plugins: [
                    (0, $d8791a4f419a01c6$export$2e2bcd8739ae039),
                    (0, $1f427812e01e9d4f$export$2e2bcd8739ae039)
                ],
                initialView: "dayGridMonth",
                weekends: false,
                timezone: "UTC",
                locales: [
                    (0, $b2e508448f8f4189$export$2e2bcd8739ae039)
                ],
                events: this.events,
                dateClick: this.onClickEvent,
                datesSet: this.getTotalByMonth,
                displayEventTime: false,
                showNonCurrentDates: false
            },
            calendarRef: null,
            eventDay: null,
            dayClicked: "",
            totalMonth: 0,
            eventsDates: new Set()
        };
    },
    methods: {
        formatToCalendar: function(arr) {
            var formato = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "yyyy-MM-dd'T'HH:mm:ss";
            var result = arr.filter(function(i) {
                return i.payment_date;
            }).map(function(i) {
                var dataFinal = (0, $a27bb432a68aee21$export$2e2bcd8739ae039)(i.payment_date);
                var entregaDataFormated = (0, $0ba290dbf11af23c$export$2e2bcd8739ae039)(dataFinal, "dd/MM/yyyy HH:mm");
                return {
                    id: i.id,
                    title: GLOBAL.fMoney(i.net_value),
                    start: i.payment_date,
                    end: entregaDataFormated,
                    color: "green",
                    extendedProps: (0, $8pZMQ._)({}, i),
                    allDay: false
                };
            });
            return result;
        },
        fMoney: function(val) {
            return Number(val).toLocaleString("pt-BR", {
                style: "currency",
                currency: "BRL",
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });
        },
        getEvents: function() {
            return (0, $a1727a7253abe12d$export$7c398597f8905a1)(function() {
                var data, error;
                return (0, $877235af7931ac6c$export$67ebef60e6f28a6)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                axios.get("".concat(this.baseURL, "/api/calendario_dividendo/"))
                            ];
                        case 1:
                            data = _state.sent().data;
                            this.events = data;
                            return [
                                3,
                                3
                            ];
                        case 2:
                            error = _state.sent();
                            console.log(error);
                            return [
                                3,
                                3
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            }).apply(this);
        },
        getEventByDate: function(date) {
            return (0, $a1727a7253abe12d$export$7c398597f8905a1)(function() {
                var data, error;
                return (0, $877235af7931ac6c$export$67ebef60e6f28a6)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                axios.get("".concat(this.baseURL, "/api/calendario_dividendo/?data_pagamento=").concat(date))
                            ];
                        case 1:
                            data = _state.sent().data;
                            this.eventDay = data;
                            return [
                                2,
                                data
                            ];
                        case 2:
                            error = _state.sent();
                            console.log(error);
                            return [
                                3,
                                3
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            }).apply(this);
        },
        getTotalByMonth: function(date) {
            return (0, $a1727a7253abe12d$export$7c398597f8905a1)(function() {
                var _this, dateFormat, data, days, error;
                return (0, $877235af7931ac6c$export$67ebef60e6f28a6)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _this = this;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            dateFormat = (0, $0ba290dbf11af23c$export$2e2bcd8739ae039)(new Date(date.startStr), "yyyy-MM");
                            return [
                                4,
                                axios.get("".concat(this.baseURL, "/api/calendario_dividendo/total_dividendos_pagos/?data=").concat(dateFormat))
                            ];
                        case 2:
                            data = _state.sent().data;
                            this.totalMonth = this.fMoney(data.total_dividendos);
                            days = document.querySelectorAll(".fc-daygrid-day");
                            days.forEach(function(day) {
                                var _$date = day.getAttribute("data-date");
                                var data = _this.events.filter(function(i) {
                                    return i.start === _$date;
                                });
                                if (data.length > 0) day.classList.add("has-event");
                                (0, $359fbeb1ed9cb77a$export$2e2bcd8739ae039)(".fc-day.has-event", {
                                    content: "Clique para ver os detalhes sobre o evento"
                                });
                            });
                            return [
                                3,
                                4
                            ];
                        case 3:
                            error = _state.sent();
                            console.log(error);
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            }).apply(this);
        },
        setModalDividendo: function() {
            this.modalDividendo = ModalX(".modal-dividendo", {
                deep: true,
                zIndex: 300000,
                zIndexDeep: 20000,
                closeOnDeep: false,
                bgModal: "rgb(30,33,36)"
            }).init();
        },
        onClickEvent: function(param) {
            var dateStr = param.dateStr;
            return (0, $a1727a7253abe12d$export$7c398597f8905a1)(function() {
                var _this_modalDividendo, response;
                return (0, $877235af7931ac6c$export$67ebef60e6f28a6)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                this.getEventByDate(dateStr)
                            ];
                        case 1:
                            response = _state.sent();
                            if (!(response === null || response === void 0 ? void 0 : response.length)) return [
                                2
                            ];
                            (_this_modalDividendo = this.modalDividendo) === null || _this_modalDividendo === void 0 ? void 0 : _this_modalDividendo.openModal(1);
                            // parseISO interpreta 'yyyy-MM-dd' como meia-noite local, sem deslocar o dia por fuso
                            this.dayClicked = (0, $0ba290dbf11af23c$export$2e2bcd8739ae039)((0, $a27bb432a68aee21$export$2e2bcd8739ae039)(dateStr), "dd/MM/yyyy");
                            return [
                                2
                            ];
                    }
                });
            }).apply(this);
        }
    },
    computed: {
        isMobile: function() {
            return window.innerWidth <= 768;
        }
    },
    watch: {
        events: {
            handler: function(newVal) {
                var _this_$refs_calendarRef, _this_$refs_calendarRef1;
                (_this_$refs_calendarRef = this.$refs.calendarRef) === null || _this_$refs_calendarRef === void 0 ? void 0 : _this_$refs_calendarRef.getApi().removeAllEvents();
                (_this_$refs_calendarRef1 = this.$refs.calendarRef) === null || _this_$refs_calendarRef1 === void 0 ? void 0 : _this_$refs_calendarRef1.getApi().addEventSource(newVal);
            }
        }
    },
    mounted: function() {
        return (0, $a1727a7253abe12d$export$7c398597f8905a1)(function() {
            var _this, days;
            return (0, $877235af7931ac6c$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _this = this;
                        this.setModalDividendo();
                        return [
                            4,
                            this.getEvents()
                        ];
                    case 1:
                        _state.sent();
                        this.events = this.formatToCalendar(this.events);
                        days = document.querySelectorAll(".fc-daygrid-day");
                        days.forEach(function(day) {
                            var date = day.getAttribute("data-date");
                            var data = _this.events.filter(function(i) {
                                return i.start === date;
                            });
                            if (data.length > 0) day.classList.add("has-event");
                            (0, $359fbeb1ed9cb77a$export$2e2bcd8739ae039)(".fc-day.has-event", {
                                content: "Clique para ver os detalhes sobre o evento"
                            });
                        });
                        return [
                            2
                        ];
                }
            });
        }).apply(this);
    },
    delimiters: [
        "{*",
        "*}"
    ]
};




function $2ebccd5bf9756300$var$_templateObject() {
    var data = (0, $f40b125b35169f4a$export$263b15b19e6ed8f)([
        '\n		<div>\n			<div class="modal-dividendo" data-position="center">\n				<section class="modal--content" data-id="1">\n					<div class="modal-header">\n						<img\n							src="{% static \'front_assets/assets/src/img/bg-modal.svg\' %}"\n							alt=""\n							class="bg-header-modal"\n						/>\n						<h3>{{dayClicked}}</h3>\n						<button\n							class="close-modal"\n							type="button"\n							data-id="1"\n							data-xclose="modal-dividendo"\n						>\n							<svg class="w-8 h-8">\n								<use xlink:href="#icon-close"></use>\n							</svg>\n						</button>\n					</div>\n					<div class="px-24 py-32">\n	\n\n						<div class="relative overflow-x-auto">\n							<table\n								class="w-full text-left "\n							>\n								<thead class="text-base font-bold px-8 " style="background: #292c2e; color:#b9b9b9;">\n									<tr>\n										<th scope="col" class="px-8 py-10">Ativo</th>\n										<th scope="col" class="px-8 py-10">Evento</th>\n										<th scope="col" class="px-8 py-10">Valor</th>\n						\n									</tr>\n								</thead>\n								<tbody>\n									<tr class="" v-for="item in eventDay" :key="item.id" style="border-bottom: 1px solid rgba(185,185,185, .2);">\n										<th\n											scope="row"\n											class="px-8 py-4  "\n										>\n											{{item.ticker_symbol}}\n										</th>\n										<td class="px-8 py-4">{{item.corporate_action_type_description}}</td>\n										<td class="px-8 py-4">{{fMoney(item.net_value)}}</td>\n					\n		\n									</tr>\n									\n								</tbody>\n							</table>\n							\n						</div>\n						<p class="text-white text-base mt-32">Total do dia: {{ totalDay }}</p>\n					</div>\n		\n				</section>\n			</div>\n		</div>\n	'
    ]);
    $2ebccd5bf9756300$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $2ebccd5bf9756300$var$modalDividendo = {
    props: [
        "eventDay",
        "dayClicked"
    ],
    data: function() {
        return {
            id: null,
            baseURL: window.location.origin,
            event: null
        };
    },
    methods: {
        fMoney: function(val) {
            return Number(val).toLocaleString("pt-BR", {
                style: "currency",
                currency: "BRL",
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });
        }
    },
    computed: {
        // Somado a partir das linhas exibidas para o total nunca divergir da tabela
        totalDay: function() {
            var total = (this.eventDay || []).reduce(function(soma, item) {
                return soma + Number(item.net_value || 0);
            }, 0);
            return this.fMoney(total);
        }
    },
    template: html($2ebccd5bf9756300$var$_templateObject())
};
var $2ebccd5bf9756300$export$2e2bcd8739ae039 = $2ebccd5bf9756300$var$modalDividendo;


// import Historico from "./pages/Historico";
var $5c62e6188689a081$var$page = function() {
    if (document.querySelector("#home_page")) return 0, $f1e4b09a23995638$export$2e2bcd8739ae039;
    if (document.querySelector("#adicionarobjetivo_page")) return 0, $95dff4962bd81e46$export$2e2bcd8739ae039;
    if (document.querySelector("#adicionarmanualmente_page")) return 0, $7805783b35864c91$export$2e2bcd8739ae039;
    if (document.querySelector("#aportarmes_page")) return 0, $2b120c6cbfc19a29$export$2e2bcd8739ae039;
    if (document.querySelector("#resumo_patrimonio-page")) return 0, $c4c9bed0678a7375$export$2e2bcd8739ae039;
    if (document.querySelector("#ondeaportar_page")) return 0, $c11af2dcb9353b30$export$2e2bcd8739ae039;
    if (document.querySelector("#objetivodetalhes_page")) return 0, $ee2bdca954332a18$export$2e2bcd8739ae039;
    if (document.querySelector("#reserva_emergencia")) return 0, $3a55e7b45fb6c209$export$2e2bcd8739ae039;
    if (document.querySelector("#calendario_page")) return 0, $f6cb959274f4cb1b$export$2e2bcd8739ae039;
    else return null;
};
var $5c62e6188689a081$var$versaoCacheSpan = document.querySelector("#versao-cache");
// versaoCacheSpan?.innerText = '10-11-2023'
// `Maska` vem de um CDN externo (base.html); se falhar, o boot do Vue não deve
// travar por causa disso, o watchdog abaixo cobre esse cenário.
var $5c62e6188689a081$var$vMaska = typeof Maska !== "undefined" ? Maska.vMaska : undefined;
var $5c62e6188689a081$var$app;
var $5c62e6188689a081$var$WATCHDOG_TIMEOUT_MS = 8000;
var $5c62e6188689a081$var$RETRY_STORAGE_KEY = "vueBootRetried";
// Mostra uma tela de fallback (sem depender de Vue) quando o boot falha
// definitivamente, evitando expor o template cru ({* ... *}) ou tela em branco.
function $5c62e6188689a081$var$showVueBootFallback() {
    var appEl = document.getElementById("app");
    if (appEl) appEl.classList.remove("vue-boot-pending");
    if (document.querySelector(".vue-boot-fallback")) return;
    // Antes de desistir, tenta recarregar a página uma única vez
    // (cobre falhas transitórias de rede/CDN).
    if (!sessionStorage.getItem($5c62e6188689a081$var$RETRY_STORAGE_KEY)) {
        sessionStorage.setItem($5c62e6188689a081$var$RETRY_STORAGE_KEY, "1");
        window.location.reload();
        return;
    }
    var fallback = document.createElement("div");
    fallback.className = "vue-boot-fallback";
    fallback.innerHTML = '\n		<p>N\xe3o foi poss\xedvel carregar esta p\xe1gina. Verifique sua conex\xe3o e tente novamente.</p>\n		<button type="button">Atualizar</button>\n	';
    fallback.querySelector("button").addEventListener("click", function() {
        return window.location.reload();
    });
    document.body.appendChild(fallback);
}
(function() {
    var pageComponent = $5c62e6188689a081$var$page();
    if (!pageComponent) return;
    var appEl = document.getElementById("app");
    if (appEl) appEl.classList.add("vue-boot-pending");
    var mounted = false;
    var watchdogTimer = setTimeout(function() {
        if (!mounted) $5c62e6188689a081$var$showVueBootFallback();
    }, $5c62e6188689a081$var$WATCHDOG_TIMEOUT_MS);
    try {
        $5c62e6188689a081$var$app = Vue.createApp(pageComponent);
        $5c62e6188689a081$var$app.config.globalProperties.$console = console.log;
        $5c62e6188689a081$var$app.config.errorHandler = function(err) {
            console.error(err);
            if (!mounted) $5c62e6188689a081$var$showVueBootFallback();
        };
        if ($5c62e6188689a081$var$vMaska) $5c62e6188689a081$var$app.directive("maska", $5c62e6188689a081$var$vMaska);
        $5c62e6188689a081$var$app.component("modal-complexo", (0, $15043aedd156b5f2$export$2e2bcd8739ae039));
        $5c62e6188689a081$var$app.component("modal-dividendo", (0, $2ebccd5bf9756300$export$2e2bcd8739ae039));
        $5c62e6188689a081$var$app.component("vue-datepicker", VueDatePicker);
        $5c62e6188689a081$var$app.component("v-select", window["vue-select"]);
        $5c62e6188689a081$var$app.mount("#app");
        mounted = true;
        clearTimeout(watchdogTimer);
        sessionStorage.removeItem($5c62e6188689a081$var$RETRY_STORAGE_KEY);
        if (appEl) appEl.classList.remove("vue-boot-pending");
    } catch (error) {
        console.error(error);
        clearTimeout(watchdogTimer);
        $5c62e6188689a081$var$showVueBootFallback();
    }
})();
window.instance = $5c62e6188689a081$var$app;

})();
//# sourceMappingURL=index.js.map
